
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4116"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4116"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.0";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.0";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    return $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1d34d5c4a288b213$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $1d34d5c4a288b213$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $1d34d5c4a288b213$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>$1d34d5c4a288b213$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $1d34d5c4a288b213$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    return $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7939e29d663dd3ed$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned$1 = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned$1[key]) $7939e29d663dd3ed$var$alreadyWarned$1[key] = true;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warnOnce(key, message) {}
const $7939e29d663dd3ed$var$logDeprecation = (flag, msg, link)=>$7939e29d663dd3ed$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $7939e29d663dd3ed$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $7939e29d663dd3ed$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $7939e29d663dd3ed$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>$7939e29d663dd3ed$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    return $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $040dbb9c344a508d$var$_extends.apply(null, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $acw62.useEffect(()=>(0, $7939e29d663dd3ed$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


// ─────────────────────────────────────────────────────────────────────────────
// @parsina/ui — the unified Parsina UI kit for all three web clients
// (doctor, clinic, patient).
//
// Canonical copy: /packages/ui (monorepo root). Each client app receives a
// synced copy at src/shared/ui via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Import everything from the barrel:
//   import { Button, TextInput, useToast } from '@parsina/ui';
// Design tokens live in the sibling package:
//   import { C, CT, statusColors } from '@parsina/tokens';
// ─────────────────────────────────────────────────────────────────────────────
// Form primitives

var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


var $85fc2fe65ff21506$exports = {};
'use strict';
Object.defineProperty($85fc2fe65ff21506$exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Concatenates two arrays faster than the array spread operator.
 */ const $85fc2fe65ff21506$var$concatArrays = (array1, array2)=>{
    // Pre-allocate for better V8 optimization
    const combinedArray = new Array(array1.length + array2.length);
    for(let i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(let i = 0; i < array2.length; i++)combinedArray[array1.length + i] = array2[i];
    return combinedArray;
};
// Factory function ensures consistent object shapes
const $85fc2fe65ff21506$var$createClassValidatorObject = (classGroupId, validator)=>({
        classGroupId: classGroupId,
        validator: validator
    });
// Factory ensures consistent ClassPartObject shape
const $85fc2fe65ff21506$var$createClassPartObject = (nextPart = new Map(), validators = null, classGroupId)=>({
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    });
const $85fc2fe65ff21506$var$CLASS_PART_SEPARATOR = '-';
const $85fc2fe65ff21506$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
const $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
const $85fc2fe65ff21506$var$createClassGroupUtils = (config)=>{
    const classMap = $85fc2fe65ff21506$var$createClassMap(config);
    const { conflictingClassGroups: conflictingClassGroups, conflictingClassGroupModifiers: conflictingClassGroupModifiers } = config;
    const getClassGroupId = (className)=>{
        if (className.startsWith('[') && className.endsWith(']')) return $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty(className);
        const classParts = className.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        const startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier)=>{
        if (hasPostfixModifier) {
            const modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            const baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $85fc2fe65ff21506$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $85fc2fe65ff21506$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
const $85fc2fe65ff21506$var$getGroupRecursive = (classParts, startIndex, classPartObject)=>{
    const classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    const currentClassPart = classParts[startIndex];
    const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        const result = $85fc2fe65ff21506$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    const validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    const classRest = startIndex === 0 ? classParts.join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const validatorsLength = validators.length;
    for(let i = 0; i < validatorsLength; i++){
        const validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ const $85fc2fe65ff21506$var$getGroupIdForArbitraryProperty = (className)=>className.slice(1, -1).indexOf(':') === -1 ? undefined : (()=>{
        const content = className.slice(1, -1);
        const colonIndex = content.indexOf(':');
        const property = content.slice(0, colonIndex);
        return property ? $85fc2fe65ff21506$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    })();
/**
 * Exported for testing only
 */ const $85fc2fe65ff21506$var$createClassMap = (config)=>{
    const { theme: theme, classGroups: classGroups } = config;
    return $85fc2fe65ff21506$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassGroups = (classGroups, theme)=>{
    const classMap = $85fc2fe65ff21506$var$createClassPartObject();
    for(const classGroupId in classGroups){
        const group = classGroups[classGroupId];
        $85fc2fe65ff21506$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
const $85fc2fe65ff21506$var$processClassesRecursively = (classGroup, classPartObject, classGroupId, theme)=>{
    const len = classGroup.length;
    for(let i = 0; i < len; i++){
        const classDefinition = classGroup[i];
        $85fc2fe65ff21506$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
const $85fc2fe65ff21506$var$processClassDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if (typeof classDefinition === 'string') {
        $85fc2fe65ff21506$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $85fc2fe65ff21506$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $85fc2fe65ff21506$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
const $85fc2fe65ff21506$var$processStringDefinition = (classDefinition, classPartObject, classGroupId)=>{
    const classPartObjectToEdit = classDefinition === '' ? classPartObject : $85fc2fe65ff21506$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
const $85fc2fe65ff21506$var$processFunctionDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    if ($85fc2fe65ff21506$var$isThemeGetter(classDefinition)) {
        $85fc2fe65ff21506$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($85fc2fe65ff21506$var$createClassValidatorObject(classGroupId, classDefinition));
};
const $85fc2fe65ff21506$var$processObjectDefinition = (classDefinition, classPartObject, classGroupId, theme)=>{
    const entries = Object.entries(classDefinition);
    const len = entries.length;
    for(let i = 0; i < len; i++){
        const [key, value] = entries[i];
        $85fc2fe65ff21506$var$processClassesRecursively(value, $85fc2fe65ff21506$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
const $85fc2fe65ff21506$var$getPart = (classPartObject, path)=>{
    let current = classPartObject;
    const parts = path.split($85fc2fe65ff21506$var$CLASS_PART_SEPARATOR);
    const len = parts.length;
    for(let i = 0; i < len; i++){
        const part = parts[i];
        let next = current.nextPart.get(part);
        if (!next) {
            next = $85fc2fe65ff21506$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
const $85fc2fe65ff21506$var$isThemeGetter = (func)=>'isThemeGetter' in func && func.isThemeGetter === true;
// LRU cache implementation using plain objects for simplicity
const $85fc2fe65ff21506$var$createLruCache = (maxCacheSize)=>{
    if (maxCacheSize < 1) return {
        get: ()=>undefined,
        set: ()=>{}
    };
    let cacheSize = 0;
    let cache = Object.create(null);
    let previousCache = Object.create(null);
    const update = (key, value)=>{
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get (key) {
            let value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set (key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
const $85fc2fe65ff21506$var$IMPORTANT_MODIFIER = '!';
const $85fc2fe65ff21506$var$MODIFIER_SEPARATOR = ':';
const $85fc2fe65ff21506$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
const $85fc2fe65ff21506$var$createResultObject = (modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal)=>({
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    });
const $85fc2fe65ff21506$var$createParseClassName = (config)=>{
    const { prefix: prefix, experimentalParseClassName: experimentalParseClassName } = config;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ let parseClassName = (className)=>{
        // Use simple array with push for better performance
        const modifiers = [];
        let bracketDepth = 0;
        let parenDepth = 0;
        let modifierStart = 0;
        let postfixModifierPosition;
        const len = className.length;
        for(let index = 0; index < len; index++){
            const currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $85fc2fe65ff21506$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        let baseClassName = baseClassNameWithImportantModifier;
        let hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($85fc2fe65ff21506$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $85fc2fe65ff21506$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        const fullPrefix = prefix + $85fc2fe65ff21506$var$MODIFIER_SEPARATOR;
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $85fc2fe65ff21506$var$createResultObject($85fc2fe65ff21506$var$EMPTY_MODIFIERS, false, className, undefined, true);
    }
    if (experimentalParseClassName) {
        const parseClassNameOriginal = parseClassName;
        parseClassName = (className)=>experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal
            });
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ const $85fc2fe65ff21506$var$createSortModifiers = (config)=>{
    // Pre-compute weights for all known modifiers for O(1) comparison
    const modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach((mod, index)=>{
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return (modifiers)=>{
        const result = [];
        let currentSegment = [];
        // Process modifiers in one pass
        for(let i = 0; i < modifiers.length; i++){
            const modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            const isArbitrary = modifier[0] === '[';
            const isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    currentSegment.sort();
                    result.push(...currentSegment);
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            currentSegment.sort();
            result.push(...currentSegment);
        }
        return result;
    };
};
const $85fc2fe65ff21506$var$createConfigUtils = (config)=>({
        cache: $85fc2fe65ff21506$var$createLruCache(config.cacheSize),
        parseClassName: $85fc2fe65ff21506$var$createParseClassName(config),
        sortModifiers: $85fc2fe65ff21506$var$createSortModifiers(config),
        postfixLookupClassGroupIds: $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds(config),
        ...$85fc2fe65ff21506$var$createClassGroupUtils(config)
    });
const $85fc2fe65ff21506$var$createPostfixLookupClassGroupIds = (config)=>{
    const lookup = Object.create(null);
    const classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(let i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
const $85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX = /\s+/;
const $85fc2fe65ff21506$var$mergeClassList = (classList, configUtils)=>{
    const { parseClassName: parseClassName, getClassGroupId: getClassGroupId, getConflictingClassGroupIds: getConflictingClassGroupIds, sortModifiers: sortModifiers, postfixLookupClassGroupIds: postfixLookupClassGroupIds } = configUtils;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ const classGroupsInConflict = [];
    const classNames = classList.trim().split($85fc2fe65ff21506$var$SPLIT_CLASSES_REGEX);
    let result = '';
    for(let index = classNames.length - 1; index >= 0; index -= 1){
        const originalClassName = classNames[index];
        const { isExternal: isExternal, modifiers: modifiers, hasImportantModifier: hasImportantModifier, baseClassName: baseClassName, maybePostfixModifierPosition: maybePostfixModifierPosition } = parseClassName(originalClassName);
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        let hasPostfixModifier = !!maybePostfixModifierPosition;
        let classGroupId;
        if (hasPostfixModifier) {
            const baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
            classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
            const classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : undefined;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        const variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        const modifierId = hasImportantModifier ? variantModifier + $85fc2fe65ff21506$var$IMPORTANT_MODIFIER : variantModifier;
        const classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(let i = 0; i < conflictGroups.length; ++i){
            const group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ const $85fc2fe65ff21506$var$twJoin = (...classLists)=>{
    let index = 0;
    let argument;
    let resolvedValue;
    let string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$toValue = (mix)=>{
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    let resolvedValue;
    let string = '';
    for(let k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $85fc2fe65ff21506$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
const $85fc2fe65ff21506$var$createTailwindMerge = (createConfigFirst, ...createConfigRest)=>{
    let configUtils;
    let cacheGet;
    let cacheSet;
    let functionToCall;
    const initTailwindMerge = (classList)=>{
        const config = createConfigRest.reduce((previousConfig, createConfigCurrent)=>createConfigCurrent(previousConfig), createConfigFirst());
        configUtils = $85fc2fe65ff21506$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    const tailwindMerge = (classList)=>{
        const cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        const result = $85fc2fe65ff21506$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return (...args)=>functionToCall($85fc2fe65ff21506$var$twJoin(...args));
};
const $85fc2fe65ff21506$var$fallbackThemeArr = [];
const $85fc2fe65ff21506$var$fromTheme = (key)=>{
    const themeGetter = (theme)=>theme[key] || $85fc2fe65ff21506$var$fallbackThemeArr;
    themeGetter.isThemeGetter = true;
    themeGetter.themeKey = key;
    return themeGetter;
};
const $85fc2fe65ff21506$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
const $85fc2fe65ff21506$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
const $85fc2fe65ff21506$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
const $85fc2fe65ff21506$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const $85fc2fe65ff21506$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const $85fc2fe65ff21506$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const $85fc2fe65ff21506$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const $85fc2fe65ff21506$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const $85fc2fe65ff21506$var$isFraction = (value)=>$85fc2fe65ff21506$var$fractionRegex.test(value);
const $85fc2fe65ff21506$var$isNumber = (value)=>!!value && !Number.isNaN(Number(value));
const $85fc2fe65ff21506$var$isInteger = (value)=>!!value && Number.isInteger(Number(value));
const $85fc2fe65ff21506$var$isPercent = (value)=>value.endsWith('%') && $85fc2fe65ff21506$var$isNumber(value.slice(0, -1));
const $85fc2fe65ff21506$var$isTshirtSize = (value)=>$85fc2fe65ff21506$var$tshirtUnitRegex.test(value);
const $85fc2fe65ff21506$var$isAny = ()=>true;
const $85fc2fe65ff21506$var$isLengthOnly = (value)=>// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $85fc2fe65ff21506$var$lengthUnitRegex.test(value) && !$85fc2fe65ff21506$var$colorFunctionRegex.test(value);
const $85fc2fe65ff21506$var$isNever = ()=>false;
const $85fc2fe65ff21506$var$isShadow = (value)=>$85fc2fe65ff21506$var$shadowRegex.test(value);
const $85fc2fe65ff21506$var$isImage = (value)=>$85fc2fe65ff21506$var$imageRegex.test(value);
const $85fc2fe65ff21506$var$isAnyNonArbitrary = (value)=>!$85fc2fe65ff21506$var$isArbitraryValue(value) && !$85fc2fe65ff21506$var$isArbitraryVariable(value);
const $85fc2fe65ff21506$var$isNamedContainerQuery = (value)=>value.startsWith('@container') && (value[10] === '/' && value[11] !== undefined || value[11] === 's' && value[16] !== undefined && value.startsWith('-size/', 10) || value[11] === 'n' && value[18] !== undefined && value.startsWith('-normal/', 10));
const $85fc2fe65ff21506$var$isArbitrarySize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelSize, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryValue = (value)=>$85fc2fe65ff21506$var$arbitraryValueRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelLength, $85fc2fe65ff21506$var$isLengthOnly);
const $85fc2fe65ff21506$var$isArbitraryNumber = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelNumber, $85fc2fe65ff21506$var$isNumber);
const $85fc2fe65ff21506$var$isArbitraryWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelWeight, $85fc2fe65ff21506$var$isAny);
const $85fc2fe65ff21506$var$isArbitraryFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelFamilyName, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryPosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelPosition, $85fc2fe65ff21506$var$isNever);
const $85fc2fe65ff21506$var$isArbitraryImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelImage, $85fc2fe65ff21506$var$isImage);
const $85fc2fe65ff21506$var$isArbitraryShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryValue(value, $85fc2fe65ff21506$var$isLabelShadow, $85fc2fe65ff21506$var$isShadow);
const $85fc2fe65ff21506$var$isArbitraryVariable = (value)=>$85fc2fe65ff21506$var$arbitraryVariableRegex.test(value);
const $85fc2fe65ff21506$var$isArbitraryVariableLength = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelLength);
const $85fc2fe65ff21506$var$isArbitraryVariableFamilyName = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelFamilyName);
const $85fc2fe65ff21506$var$isArbitraryVariablePosition = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelPosition);
const $85fc2fe65ff21506$var$isArbitraryVariableSize = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelSize);
const $85fc2fe65ff21506$var$isArbitraryVariableImage = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelImage);
const $85fc2fe65ff21506$var$isArbitraryVariableShadow = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelShadow, true);
const $85fc2fe65ff21506$var$isArbitraryVariableWeight = (value)=>$85fc2fe65ff21506$var$getIsArbitraryVariable(value, $85fc2fe65ff21506$var$isLabelWeight, true);
// Helpers
const $85fc2fe65ff21506$var$getIsArbitraryValue = (value, testLabel, testValue)=>{
    const result = $85fc2fe65ff21506$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
const $85fc2fe65ff21506$var$getIsArbitraryVariable = (value, testLabel, shouldMatchNoLabel = false)=>{
    const result = $85fc2fe65ff21506$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
const $85fc2fe65ff21506$var$isLabelPosition = (label)=>label === 'position' || label === 'percentage';
const $85fc2fe65ff21506$var$isLabelImage = (label)=>label === 'image' || label === 'url';
const $85fc2fe65ff21506$var$isLabelSize = (label)=>label === 'length' || label === 'size' || label === 'bg-size';
const $85fc2fe65ff21506$var$isLabelLength = (label)=>label === 'length';
const $85fc2fe65ff21506$var$isLabelNumber = (label)=>label === 'number';
const $85fc2fe65ff21506$var$isLabelFamilyName = (label)=>label === 'family-name';
const $85fc2fe65ff21506$var$isLabelWeight = (label)=>label === 'number' || label === 'weight';
const $85fc2fe65ff21506$var$isLabelShadow = (label)=>label === 'shadow';
const $85fc2fe65ff21506$var$validators = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $85fc2fe65ff21506$var$isAny,
    isAnyNonArbitrary: $85fc2fe65ff21506$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $85fc2fe65ff21506$var$isArbitraryFamilyName,
    isArbitraryImage: $85fc2fe65ff21506$var$isArbitraryImage,
    isArbitraryLength: $85fc2fe65ff21506$var$isArbitraryLength,
    isArbitraryNumber: $85fc2fe65ff21506$var$isArbitraryNumber,
    isArbitraryPosition: $85fc2fe65ff21506$var$isArbitraryPosition,
    isArbitraryShadow: $85fc2fe65ff21506$var$isArbitraryShadow,
    isArbitrarySize: $85fc2fe65ff21506$var$isArbitrarySize,
    isArbitraryValue: $85fc2fe65ff21506$var$isArbitraryValue,
    isArbitraryVariable: $85fc2fe65ff21506$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $85fc2fe65ff21506$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $85fc2fe65ff21506$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $85fc2fe65ff21506$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $85fc2fe65ff21506$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $85fc2fe65ff21506$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $85fc2fe65ff21506$var$isArbitraryVariableWeight,
    isArbitraryWeight: $85fc2fe65ff21506$var$isArbitraryWeight,
    isFraction: $85fc2fe65ff21506$var$isFraction,
    isInteger: $85fc2fe65ff21506$var$isInteger,
    isNamedContainerQuery: $85fc2fe65ff21506$var$isNamedContainerQuery,
    isNumber: $85fc2fe65ff21506$var$isNumber,
    isPercent: $85fc2fe65ff21506$var$isPercent,
    isTshirtSize: $85fc2fe65ff21506$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
const $85fc2fe65ff21506$var$getDefaultConfig = ()=>{
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ const themeColor = $85fc2fe65ff21506$var$fromTheme('color');
    const themeFont = $85fc2fe65ff21506$var$fromTheme('font');
    const themeText = $85fc2fe65ff21506$var$fromTheme('text');
    const themeFontWeight = $85fc2fe65ff21506$var$fromTheme('font-weight');
    const themeTracking = $85fc2fe65ff21506$var$fromTheme('tracking');
    const themeLeading = $85fc2fe65ff21506$var$fromTheme('leading');
    const themeBreakpoint = $85fc2fe65ff21506$var$fromTheme('breakpoint');
    const themeContainer = $85fc2fe65ff21506$var$fromTheme('container');
    const themeSpacing = $85fc2fe65ff21506$var$fromTheme('spacing');
    const themeRadius = $85fc2fe65ff21506$var$fromTheme('radius');
    const themeShadow = $85fc2fe65ff21506$var$fromTheme('shadow');
    const themeInsetShadow = $85fc2fe65ff21506$var$fromTheme('inset-shadow');
    const themeTextShadow = $85fc2fe65ff21506$var$fromTheme('text-shadow');
    const themeDropShadow = $85fc2fe65ff21506$var$fromTheme('drop-shadow');
    const themeBlur = $85fc2fe65ff21506$var$fromTheme('blur');
    const themePerspective = $85fc2fe65ff21506$var$fromTheme('perspective');
    const themeAspect = $85fc2fe65ff21506$var$fromTheme('aspect');
    const themeEase = $85fc2fe65ff21506$var$fromTheme('ease');
    const themeAnimate = $85fc2fe65ff21506$var$fromTheme('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ const scaleBreak = ()=>[
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    const scalePosition = ()=>[
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    const scalePositionWithArbitrary = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleOverflow = ()=>[
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    const scaleOverscroll = ()=>[
            'auto',
            'contain',
            'none'
        ];
    const scaleUnambiguousSpacing = ()=>[
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue,
            themeSpacing
        ];
    const scaleInset = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleGridTemplateColsRows = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'none',
            'subgrid',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartAndEnd = ()=>[
            'auto',
            {
                span: [
                    'full',
                    $85fc2fe65ff21506$var$isInteger,
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            },
            $85fc2fe65ff21506$var$isInteger,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridColRowStartOrEnd = ()=>[
            $85fc2fe65ff21506$var$isInteger,
            'auto',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleGridAutoColsRows = ()=>[
            'auto',
            'min',
            'max',
            'fr',
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleAlignPrimaryAxis = ()=>[
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    const scaleAlignSecondaryAxis = ()=>[
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    const scaleMargin = ()=>[
            'auto',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizing = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingInline = ()=>[
            themeContainer,
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleSizingBlock = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit',
            ...scaleUnambiguousSpacing()
        ];
    const scaleColor = ()=>[
            themeColor,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBgPosition = ()=>[
            ...scalePosition(),
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition,
            {
                position: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleBgRepeat = ()=>[
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    const scaleBgSize = ()=>[
            'auto',
            'cover',
            'contain',
            $85fc2fe65ff21506$var$isArbitraryVariableSize,
            $85fc2fe65ff21506$var$isArbitrarySize,
            {
                size: [
                    $85fc2fe65ff21506$var$isArbitraryVariable,
                    $85fc2fe65ff21506$var$isArbitraryValue
                ]
            }
        ];
    const scaleGradientStopPosition = ()=>[
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleRadius = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleBorderWidth = ()=>[
            '',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariableLength,
            $85fc2fe65ff21506$var$isArbitraryLength
        ];
    const scaleLineStyle = ()=>[
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    const scaleBlendMode = ()=>[
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    const scaleMaskImagePosition = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isPercent,
            $85fc2fe65ff21506$var$isArbitraryVariablePosition,
            $85fc2fe65ff21506$var$isArbitraryPosition
        ];
    const scaleBlur = ()=>[
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleRotate = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleScale = ()=>[
            'none',
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleSkew = ()=>[
            $85fc2fe65ff21506$var$isNumber,
            $85fc2fe65ff21506$var$isArbitraryVariable,
            $85fc2fe65ff21506$var$isArbitraryValue
        ];
    const scaleTranslate = ()=>[
            $85fc2fe65ff21506$var$isFraction,
            'full',
            ...scaleUnambiguousSpacing()
        ];
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            breakpoint: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            color: [
                $85fc2fe65ff21506$var$isAny
            ],
            container: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'drop-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $85fc2fe65ff21506$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            shadow: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            spacing: [
                'px',
                $85fc2fe65ff21506$var$isNumber
            ],
            text: [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            'text-shadow': [
                $85fc2fe65ff21506$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $85fc2fe65ff21506$var$isFraction,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */ 'container-type': [
                {
                    '@container': [
                        '',
                        'normal',
                        'size',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */ 'container-named': [
                $85fc2fe65ff21506$var$isNamedContainerQuery
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $85fc2fe65ff21506$var$isInteger,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $85fc2fe65ff21506$var$isFraction,
                        'full',
                        'auto',
                        themeContainer,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $85fc2fe65ff21506$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: [
                        ...scaleAlignPrimaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': [
                        ...scaleAlignSecondaryAxis(),
                        'normal'
                    ]
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal',
                        ...scaleAlignPrimaryAxis()
                    ]
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: [
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto',
                        ...scaleAlignSecondaryAxis(),
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ]
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': [
                        ...scaleAlignSecondaryAxis(),
                        'baseline'
                    ]
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto',
                        ...scaleAlignSecondaryAxis()
                    ]
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */ 'inline-size': [
                {
                    inline: [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none',
                        ...scaleSizingInline()
                    ]
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */ 'block-size': [
                {
                    block: [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none',
                        ...scaleSizingBlock()
                    ]
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        },
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        'none',
                        ...scaleSizing()
                    ]
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $85fc2fe65ff21506$var$isArbitraryVariableWeight,
                        $85fc2fe65ff21506$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $85fc2fe65ff21506$var$isPercent,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $85fc2fe65ff21506$var$isArbitraryVariableFamilyName,
                        $85fc2fe65ff21506$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $85fc2fe65ff21506$var$isNumber,
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading,
                        ...scaleUnambiguousSpacing()
                    ]
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: [
                        ...scaleLineStyle(),
                        'wavy'
                    ]
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'from-font',
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        'auto',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */ 'tab-size': [
                {
                    tab: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ],
                            conic: [
                                '',
                                $85fc2fe65ff21506$var$isInteger,
                                $85fc2fe65ff21506$var$isArbitraryVariable,
                                $85fc2fe65ff21506$var$isArbitraryValue
                            ]
                        },
                        $85fc2fe65ff21506$var$isArbitraryVariableImage,
                        $85fc2fe65ff21506$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: [
                        ...scaleLineStyle(),
                        'hidden',
                        'none'
                    ]
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: [
                        ...scaleLineStyle(),
                        'none',
                        'hidden'
                    ]
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        // Deprecated since Tailwind CSS v4.0.0
                        'inner',
                        'none',
                        themeShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': [
                        ...scaleBlendMode(),
                        'plus-darker',
                        'plus-lighter'
                    ]
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $85fc2fe65ff21506$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $85fc2fe65ff21506$var$isArbitraryVariableShadow,
                        $85fc2fe65ff21506$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $85fc2fe65ff21506$var$isNumber,
                        'initial',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */ zoom: [
                {
                    zoom: [
                        $85fc2fe65ff21506$var$isInteger,
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-thumb-color': [
                {
                    'scrollbar-thumb': scaleColor()
                }
            ],
            /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-track-color': [
                {
                    'scrollbar-track': scaleColor()
                }
            ],
            /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */ 'scrollbar-gutter': [
                {
                    'scrollbar-gutter': [
                        'auto',
                        'stable',
                        'both'
                    ]
                }
            ],
            /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */ 'scrollbar-w': [
                {
                    scrollbar: [
                        'auto',
                        'thin',
                        'none'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $85fc2fe65ff21506$var$isArbitraryVariable,
                        $85fc2fe65ff21506$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $85fc2fe65ff21506$var$isNumber,
                        $85fc2fe65ff21506$var$isArbitraryVariableLength,
                        $85fc2fe65ff21506$var$isArbitraryLength,
                        $85fc2fe65ff21506$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none',
                        ...scaleColor()
                    ]
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            'container-named': [
                'container-type'
            ],
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'start',
                'end',
                'right',
                'left'
            ],
            'inset-y': [
                'inset-bs',
                'inset-be',
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'ps',
                'pe',
                'pr',
                'pl'
            ],
            py: [
                'pbs',
                'pbe',
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'ms',
                'me',
                'mr',
                'ml'
            ],
            my: [
                'mbs',
                'mbe',
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-s',
                'border-w-e',
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-s',
                'border-color-e',
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-ms',
                'scroll-me',
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-ps',
                'scroll-pe',
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        postfixLookupClassGroups: [
            'container-type'
        ],
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ const $85fc2fe65ff21506$var$mergeConfigs = (baseConfig, { cacheSize: cacheSize, prefix: prefix, experimentalParseClassName: experimentalParseClassName, extend: extend = {}, override: override = {} })=>{
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'prefix', prefix);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $85fc2fe65ff21506$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'postfixLookupClassGroups', override.postfixLookupClassGroups);
    $85fc2fe65ff21506$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $85fc2fe65ff21506$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'postfixLookupClassGroups');
    $85fc2fe65ff21506$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
const $85fc2fe65ff21506$var$overrideProperty = (baseObject, overrideKey, overrideValue)=>{
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
const $85fc2fe65ff21506$var$overrideConfigProperties = (baseObject, overrideObject)=>{
    if (overrideObject) for(const key in overrideObject)$85fc2fe65ff21506$var$overrideProperty(baseObject, key, overrideObject[key]);
};
const $85fc2fe65ff21506$var$mergeConfigProperties = (baseObject, mergeObject)=>{
    if (mergeObject) for(const key in mergeObject)$85fc2fe65ff21506$var$mergeArrayProperties(baseObject, mergeObject, key);
};
const $85fc2fe65ff21506$var$mergeArrayProperties = (baseObject, mergeObject, key)=>{
    const mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
const $85fc2fe65ff21506$var$extendTailwindMerge = (configExtension, ...createConfig)=>typeof configExtension === 'function' ? $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig, configExtension, ...createConfig) : $85fc2fe65ff21506$var$createTailwindMerge(()=>$85fc2fe65ff21506$var$mergeConfigs($85fc2fe65ff21506$var$getDefaultConfig(), configExtension), ...createConfig);
const $85fc2fe65ff21506$var$twMerge = /*#__PURE__*/ $85fc2fe65ff21506$var$createTailwindMerge($85fc2fe65ff21506$var$getDefaultConfig);
$85fc2fe65ff21506$exports.createTailwindMerge = $85fc2fe65ff21506$var$createTailwindMerge;
$85fc2fe65ff21506$exports.extendTailwindMerge = $85fc2fe65ff21506$var$extendTailwindMerge;
$85fc2fe65ff21506$exports.fromTheme = $85fc2fe65ff21506$var$fromTheme;
$85fc2fe65ff21506$exports.getDefaultConfig = $85fc2fe65ff21506$var$getDefaultConfig;
$85fc2fe65ff21506$exports.mergeConfigs = $85fc2fe65ff21506$var$mergeConfigs;
$85fc2fe65ff21506$exports.twJoin = $85fc2fe65ff21506$var$twJoin;
$85fc2fe65ff21506$exports.twMerge = $85fc2fe65ff21506$var$twMerge;
$85fc2fe65ff21506$exports.validators = $85fc2fe65ff21506$var$validators;


function $42e05640dae453c1$export$1343a74baacb0543(...inputs) {
    return (0, $85fc2fe65ff21506$exports.twMerge)((0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37)(inputs));
}
const $42e05640dae453c1$export$e6aa7dbb1e28c5bd = (str)=>String(str).replace(/[۰-۹]/g, (d)=>d.charCodeAt(0) - 0x06F0).replace(/[٠-٩]/g, (d)=>d.charCodeAt(0) - 0x0660);


'use client';
// The field wrapper every kit input renders through — and therefore the one
// place that decides whether this design system produces labelled controls.
//
// It used to draw the label as a `<span>`. That looks identical and is not the
// same thing: a screen reader announcing an unlabelled text box says "edit
// text, blank", `getByLabelText` cannot find the control, and clicking the
// label does not focus the field. §12.3 says all form inputs are labelled
// through `FormField` with a real `<label for>` — this is that.
//
// The association is made here rather than at the call sites, because a rule
// that depends on every caller remembering to pass an `id` is a rule that is
// half-applied within a month. `useId` supplies one, the child's own `id` wins
// if it has one, and the error/helper line is wired as `aria-describedby` so
// the reason a field is red is announced with it.
const $221000a87dfafb8e$var$FormField = ({ label: label, required: required, error: error, helperText: helperText, children: children, className: className, style: style, htmlFor: htmlFor })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const only = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children) ? children : null;
    const controlId = htmlFor || only?.props?.id || (only ? `${generatedId}-control` : undefined);
    // Derived from the control's id, not the wrapper's, so a component that owns
    // its own wiring (the inputs that wrap their control in a positioning div)
    // can point at this message without asking for the id back.
    const messageId = (error || helperText) && controlId ? `${controlId}-message` : undefined;
    // `htmlFor` means the caller has already put the id on the real control.
    // Cloning here too would stamp the same id onto its wrapper — two elements,
    // one id, and the label resolves to whichever the browser sees first.
    const control = only && !htmlFor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(only, {
        id: controlId,
        // Never clobber a caller's own description — join, so a field that
        // already points at a hint keeps it AND gains the error line.
        'aria-describedby': [
            only.props['aria-describedby'],
            messageId
        ].filter(Boolean).join(' ') || undefined,
        'aria-invalid': only.props['aria-invalid'] ?? (error ? true : undefined)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col gap-1.5', className),
        style: style
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        htmlFor: controlId,
        className: "text-[11.5px] font-semibold text-[#5a6780] tracking-[0.01em] select-none leading-none"
    }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-destructive ms-1"
    }, "*")), control, error ? // Announced, not merely displayed: §12.3 requires validation errors to
    // reach a screen reader when they appear, and a field whose only signal
    // is a red border tells a non-sighted user nothing at all.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        role: "alert",
        className: "m-0 text-[11.5px] text-destructive font-medium leading-snug"
    }, error) : helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[11.5px] text-muted-foreground leading-snug"
    }, helperText) : null);
};
var $221000a87dfafb8e$export$2e2bcd8739ae039 = $221000a87dfafb8e$var$FormField;



var $acw62 = parcelRequire("acw62");


'use client';
const $6e2f2bccd0e2a9fb$var$TextInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, type: type = 'text', validate: validate, disabled: disabled = false, maxLength: maxLength, style: style, inputStyle: inputStyle, dir: // Unset: the field inherits the document's direction, which is what lets one
// component render a Persian and an English account. Pass dir="ltr" for a
// phone number, a code or any other Latin-digit run inside an RTL page.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: type,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        maxLength: maxLength,
        dir: dir,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 px-3.5 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }));
});
$6e2f2bccd0e2a9fb$var$TextInput.displayName = 'TextInput';
var $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039 = $6e2f2bccd0e2a9fb$var$TextInput;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// ─────────────────────────────────────────────────────────────────────────────
// @parsina/tokens — the single source of truth for the Parsina design system.
//
// Canonical copy: /packages/tokens (monorepo root). Each client app receives a
// synced copy at src/shared/tokens via `python dev/sync_shared.py` — edit HERE,
// never in the synced copies.
//
// Three historical token systems (constants/theme.js `C`, constants/unifiedTheme.js
// `CT`, and per-app CSS vars) are collapsed into this module + tokens.css +
// tailwind.preset.js. Prefer Tailwind classes; `C`/`CT` exist for the screens
// still written with inline style objects.
// ─────────────────────────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────────────────────────
// The brand — what the product is called, what its credit is called, which
// languages it offers, which calendar it reads and which market it serves — and
// how a deployment replaces it.
//
// THE PROBLEM THIS SOLVES
// One set of images runs as Parsina and as another brand (Proxia first). The
// brand is CONFIGURATION, set by the deployment (docs/rebranding/CONTRACT.md):
// the container writes `BRAND_B64` into env.js, the app decodes it at boot and
// hands it here. Everything that says the name — the catalogues' `{{brand}}`,
// the printed prescription's footer, the video call's window title — and
// everything that is Iranian by default rather than by nature — the calendar,
// the phone field's +98, the national-id rule — asks this module.
//
// WHY A REGISTRY
// The same shape as `setUiStrings` (uiStrings.js) and `configureClinical`
// (clinical/src/host.jsx): module state, set once at boot, readable from plain
// functions — a print builder, a phone parser, a locale resolver — and not only
// from components. It is not reactive: a brand does not change while a page is
// open, so it is configured BEFORE the first render and never again.
//
// THE DEFAULTS ARE THE POINT
// Every default below is the literal the framework shipped before it had a
// brand. An app that never calls `configureBrand` renders exactly what it
// rendered before, byte for byte (clinical/__tests__/brandParity.test.js holds
// the resolved catalogues to that). A deployment that configures a brand
// replaces only the fields it sets; a bad value is dropped with ONE console
// warning and its default kept — a brand must never be the reason a panel does
// not start.
//
// Brand is not market (CONTRACT §1.4). `market: 'intl'` does not rename the
// Iranian rails; it hides them (`isIranMarket()`), at the entry points.
// ─────────────────────────────────────────────────────────────────────────────
const $abf0c103b4b92127$var$deepFreeze = (value)=>{
    if (value && typeof value === 'object' && !Object.isFrozen(value)) {
        Object.values(value).forEach($abf0c103b4b92127$var$deepFreeze);
        Object.freeze(value);
    }
    return value;
};
const $abf0c103b4b92127$export$c3e10d2aebbc7f30 = $abf0c103b4b92127$var$deepFreeze({
    id: 'parsina',
    name: {
        fa: "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
        en: 'Parsina',
        ar: 'Parsina',
        fr: 'Parsina',
        de: 'Parsina'
    },
    tagline: {
        fa: "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F \u067E\u0632\u0634\u06A9\u06CC",
        en: 'Intelligent Medical Assistant',
        ar: "\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0637\u0628\u064A \u0627\u0644\u0630\u0643\u064A",
        fr: "Assistant m\xe9dical intelligent",
        de: 'Intelligenter medizinischer Assistent'
    },
    // The credit's NAME, a label only — `parseh*` identifiers never change.
    // `faEz` is the Persian ezafe form («پارسهٔ کلینیک»): heh + U+0654.
    walletUnit: {
        fa: "\u067E\u0627\u0631\u0633\u0647",
        faEz: "\u067E\u0627\u0631\u0633\u0647\u0654",
        en: 'Parseh',
        ar: "\u0628\u0627\u0631\u0633\u0647",
        fr: 'Parseh',
        de: 'Parseh'
    },
    // null = the app's own list / default / calendar / market — today's behaviour.
    locales: null,
    defaultLocale: null,
    calendar: null,
    market: null,
    assetPack: null,
    // Per-locale overlay, consulted BEFORE the catalogue: { en: { '<key>': '<text>' } }.
    strings: {}
});
const $abf0c103b4b92127$var$CALENDARS = [
    'jalali',
    'gregory'
];
const $abf0c103b4b92127$var$MARKETS = [
    'ir',
    'intl'
];
const $abf0c103b4b92127$var$SLUG = /^[a-z0-9][a-z0-9-]*$/;
const $abf0c103b4b92127$var$LOCALE_ID = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
let $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({}); // what the deployment set, after sanitising
let $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30; // the defaults with `configured` merged over them
let $abf0c103b4b92127$var$revision = 0;
// One warning per message per session — `brandLocales` runs on every render.
const $abf0c103b4b92127$var$warned = new Set();
function $abf0c103b4b92127$var$warnOnce(message) {
    if ($abf0c103b4b92127$var$warned.has(message)) return;
    $abf0c103b4b92127$var$warned.add(message);
    console.warn(`[brand] ${message}`);
}
const $abf0c103b4b92127$var$isPlainObject = (v)=>v != null && typeof v === 'object' && !Array.isArray(v);
const $abf0c103b4b92127$var$nonEmpty = (v)=>typeof v === 'string' && v.trim() !== '';
/** `{ fa: '…', en: '…' }` — keeps the entries whose value is a non-empty string. */ function $abf0c103b4b92127$var$sanitizeMap(value, field, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push(`${field} is not an object`);
        return undefined;
    }
    const out = {};
    for (const [key, text] of Object.entries(value))if ($abf0c103b4b92127$var$nonEmpty(text)) out[key] = text;
    else problems.push(`${field}.${key} is not a non-empty string`);
    return out;
}
function $abf0c103b4b92127$var$sanitizeLocales(value, problems) {
    if (!Array.isArray(value) || value.length === 0) {
        problems.push('locales is not a non-empty array');
        return undefined;
    }
    const ids = value.map((id)=>typeof id === 'string' ? id.trim().toLowerCase() : '');
    if (ids.some((id)=>!$abf0c103b4b92127$var$LOCALE_ID.test(id))) {
        problems.push(`locales has an entry that is not a language tag: ${JSON.stringify(value)}`);
        return undefined;
    }
    return [
        ...new Set(ids)
    ];
}
function $abf0c103b4b92127$var$sanitizeStrings(value, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(value)) {
        problems.push('strings is not an object');
        return undefined;
    }
    const out = {};
    for (const [locale, table] of Object.entries(value)){
        if (!$abf0c103b4b92127$var$isPlainObject(table)) {
            problems.push(`strings.${locale} is not an object`);
            continue;
        }
        const kept = {};
        for (const [key, text] of Object.entries(table)){
            const ok = typeof text === 'string' || Array.isArray(text) && text.every((item)=>typeof item === 'string');
            if (ok) kept[key] = text;
            else problems.push(`strings.${locale}.${key} is not a string`);
        }
        out[locale.toLowerCase()] = kept;
    }
    return out;
}
/**
 * Raw brand JSON → only the fields that are valid, with every problem noted.
 * Unknown fields are ignored without a word: the same object reaches every
 * runtime (CONTRACT §2) and may carry fields only a service reads.
 */ function $abf0c103b4b92127$var$sanitize(input, problems) {
    if (!$abf0c103b4b92127$var$isPlainObject(input)) {
        problems.push('the brand is not a JSON object');
        return {};
    }
    const out = {};
    const scalar = (field, test, normalise = (v)=>v)=>{
        const v = input[field];
        if (v === undefined || v === null) return;
        if (test(v)) out[field] = normalise(v);
        else problems.push(`${field} ${JSON.stringify(v)} is not valid`);
    };
    scalar('id', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('calendar', (v)=>$abf0c103b4b92127$var$CALENDARS.includes(v));
    scalar('market', (v)=>$abf0c103b4b92127$var$MARKETS.includes(v));
    scalar('assetPack', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$SLUG.test(v));
    scalar('defaultLocale', (v)=>typeof v === 'string' && $abf0c103b4b92127$var$LOCALE_ID.test(v.trim().toLowerCase()), (v)=>v.trim().toLowerCase());
    for (const field of [
        'name',
        'tagline',
        'walletUnit'
    ]){
        if (input[field] == null) continue;
        const map = $abf0c103b4b92127$var$sanitizeMap(input[field], field, problems);
        if (map && Object.keys(map).length) out[field] = map;
    }
    if (input.locales != null) {
        const locales = $abf0c103b4b92127$var$sanitizeLocales(input.locales, problems);
        if (locales) out.locales = locales;
    }
    if (input.strings != null) {
        const strings = $abf0c103b4b92127$var$sanitizeStrings(input.strings, problems);
        if (strings) out.strings = strings;
    }
    // A first-visit language the brand does not offer is a contradiction; the
    // list wins, and `brandDefaultLocale` then answers from the list.
    if (out.defaultLocale && out.locales && !out.locales.includes(out.defaultLocale)) {
        problems.push(`defaultLocale "${out.defaultLocale}" is not one of locales`);
        delete out.defaultLocale;
    }
    return out;
}
function $abf0c103b4b92127$export$d9cd1c078c0b61d(word) {
    const w = String(word ?? '');
    if (/ه$/.test(w)) return `${w}\u{654}`;
    if (/[او]$/.test(w)) return `${w}\u{6CC}`;
    return w;
}
function $abf0c103b4b92127$var$merge(clean) {
    const unit = clean.walletUnit || {};
    return $abf0c103b4b92127$var$deepFreeze({
        ...$abf0c103b4b92127$export$c3e10d2aebbc7f30,
        ...clean,
        name: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.name,
            ...clean.name
        },
        tagline: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.tagline,
            ...clean.tagline
        },
        walletUnit: {
            ...$abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit,
            ...unit,
            faEz: unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : $abf0c103b4b92127$export$c3e10d2aebbc7f30.walletUnit.faEz)
        },
        strings: clean.strings || {}
    });
}
function $abf0c103b4b92127$export$9b06eb23289fc34c(partial) {
    $abf0c103b4b92127$var$revision += 1;
    if (partial === null || partial === undefined) {
        $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze({});
        $abf0c103b4b92127$var$resolved = $abf0c103b4b92127$export$c3e10d2aebbc7f30;
        return $abf0c103b4b92127$var$resolved;
    }
    const problems = [];
    const clean = $abf0c103b4b92127$var$sanitize(partial, problems);
    if (problems.length) console.warn(`[brand] kept the default for what is not valid: ${problems.join('; ')}`);
    $abf0c103b4b92127$var$configured = $abf0c103b4b92127$var$deepFreeze(clean);
    $abf0c103b4b92127$var$resolved = Object.keys(clean).length ? $abf0c103b4b92127$var$merge(clean) : $abf0c103b4b92127$export$c3e10d2aebbc7f30;
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$3f8f5e31744c04b0(b64) {
    try {
        if (typeof atob !== 'function') return undefined;
        const binary = atob(String(b64).replace(/\s+/g, ''));
        const bytes = Uint8Array.from(binary, (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder('utf-8', {
            fatal: true
        }).decode(bytes));
    } catch  {
        return undefined;
    }
}
function $abf0c103b4b92127$export$1c31b0413ff44cf2(env = typeof window !== 'undefined' ? window.__ENV__ : undefined) {
    const b64 = env?.BRAND_B64;
    if (b64 === undefined || b64 === null || String(b64).trim() === '') return $abf0c103b4b92127$var$resolved;
    const decoded = $abf0c103b4b92127$export$3f8f5e31744c04b0(b64);
    if (decoded === undefined) {
        console.warn("[brand] BRAND_B64 is not base64 of a UTF-8 JSON object \u2014 Parsina defaults kept");
        return $abf0c103b4b92127$export$9b06eb23289fc34c(null);
    }
    return $abf0c103b4b92127$export$9b06eb23289fc34c(decoded);
}
function $abf0c103b4b92127$export$96ff94e0adb1d772() {
    return $abf0c103b4b92127$var$resolved;
}
function $abf0c103b4b92127$export$57a0b7719e4bc93b() {
    return $abf0c103b4b92127$var$revision;
}
function $abf0c103b4b92127$export$3cede7c619603eb2() {
    return $abf0c103b4b92127$var$resolved.market !== 'intl';
}
function $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) {
    const list = Array.isArray(appLocales) ? appLocales : [];
    const allowed = $abf0c103b4b92127$var$resolved.locales;
    if (!allowed) return list;
    const offered = list.filter((id)=>allowed.includes(String(id).toLowerCase()));
    if (offered.length) return offered;
    $abf0c103b4b92127$var$warnOnce(`locales ${JSON.stringify(allowed)} share nothing with this app's ${JSON.stringify(list)} \u{2014} offering the app's`);
    return list;
}
function $abf0c103b4b92127$export$879824979a5b153a(appDefault, appLocales) {
    const offered = appLocales ? $abf0c103b4b92127$export$1a326f4d00c1e158(appLocales) : $abf0c103b4b92127$var$resolved.locales;
    const wanted = $abf0c103b4b92127$var$resolved.defaultLocale;
    if (wanted && (!offered || offered.includes(wanted))) return wanted;
    if (!offered || offered.includes(appDefault)) return appDefault;
    return offered[0] ?? appDefault;
}
function $abf0c103b4b92127$export$a350347e69c4c055(appDefault = null) {
    return $abf0c103b4b92127$var$resolved.calendar || appDefault;
}
// ── Text ─────────────────────────────────────────────────────────────────────
/** A per-locale map read for `locale`: exact, then the base language, then English. */ function $abf0c103b4b92127$var$pick(map, locale) {
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    if (map[id] !== undefined) return map[id];
    const base = id.split(/[-_]/)[0];
    if (map[base] !== undefined) return map[base];
    return map.en;
}
/** What the deployment itself set for `field` in `locale`, or undefined. */ const $abf0c103b4b92127$var$configuredIn = (field, locale)=>{
    const map = $abf0c103b4b92127$var$configured[field];
    if (!map) return undefined;
    const id = String(locale || '').toLowerCase();
    return map[id] ?? map[id.split(/[-_]/)[0]];
};
function $abf0c103b4b92127$export$63a39fc1c580d092(locale) {
    return $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale);
}
function $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline) {
    const has = inline !== undefined && inline !== null;
    switch(name){
        case 'brand':
            {
                const set = $abf0c103b4b92127$var$configuredIn('name', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.name, locale));
            }
        case 'coin':
            {
                const set = $abf0c103b4b92127$var$configuredIn('walletUnit', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.walletUnit, locale));
            }
        case 'coinEz':
            {
                const unit = $abf0c103b4b92127$var$configured.walletUnit;
                const set = unit && (unit.faEz ?? (unit.fa ? $abf0c103b4b92127$export$d9cd1c078c0b61d(unit.fa) : undefined));
                return set ?? (has ? inline : $abf0c103b4b92127$var$resolved.walletUnit.faEz);
            }
        case 'tagline':
            {
                const set = $abf0c103b4b92127$var$configuredIn('tagline', locale);
                return set ?? (has ? inline : $abf0c103b4b92127$var$pick($abf0c103b4b92127$var$resolved.tagline, locale));
            }
        default:
            return undefined;
    }
}
const $abf0c103b4b92127$export$936dfa1128462f2c = Object.freeze([
    'brand',
    'coin',
    'coinEz',
    'tagline'
]);
function $abf0c103b4b92127$export$168e20da34ba5ff3(locale) {
    return {
        brand: $abf0c103b4b92127$export$6281f283246a2f65('brand', locale),
        coin: $abf0c103b4b92127$export$6281f283246a2f65('coin', locale),
        coinEz: $abf0c103b4b92127$export$6281f283246a2f65('coinEz', locale),
        tagline: $abf0c103b4b92127$export$6281f283246a2f65('tagline', locale)
    };
}
const $abf0c103b4b92127$export$55fc5ffc49a23c34 = /\{\{\s*([\w.]+)\s*(?:\|([^{}]*?))?\s*\}\}/g;
function $abf0c103b4b92127$export$1508028e88b5e6ae(text, locale) {
    if (typeof text !== 'string' || text.indexOf('{{') === -1) return text;
    return text.replace($abf0c103b4b92127$export$55fc5ffc49a23c34, (match, name, inline)=>{
        const value = $abf0c103b4b92127$export$6281f283246a2f65(name, locale, inline);
        return value === undefined ? match : value;
    });
}
function $abf0c103b4b92127$export$62fa8a9cbf8a9cc6(locale, key) {
    const table = $abf0c103b4b92127$var$resolved.strings;
    const id = String(locale || '').toLowerCase();
    const own = table[id] ?? table[id.split(/[-_]/)[0]];
    if (!own) return undefined;
    return Object.prototype.hasOwnProperty.call(own, key) ? own[key] : undefined;
}


const $e7c165fb515b04ea$export$e7094788287c5e9b = {
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    red: '#D93025',
    redLight: '#F5E8E7',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    bg: '#f5f7fa',
    card: '#ffffff',
    border: '#eef0f3',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$4b57bfb4dade55bd = {
    // Backgrounds
    bg: '#f5f7fa',
    surface: '#ffffff',
    surface2: '#f3f2f0',
    // Borders
    border: '#eef0f3',
    border2: '#ece9e4',
    // Text
    ink: '#1a2332',
    ink2: '#5a6780',
    mute: '#9aa3b0',
    mute2: '#b0aca3',
    // Accent (teal — logo top hue). Themed; see the note on `C`.
    accent: 'var(--p-teal)',
    accentInk: 'var(--p-navy-dark)',
    accentSoft: 'color-mix(in srgb, var(--p-teal) 12%, transparent)',
    // Good (green)
    good: '#1A9B6C',
    goodInk: '#166534',
    goodSoft: 'rgba(22,163,74,0.12)',
    // Warn (amber)
    warn: '#F59E0B',
    warnInk: '#92400e',
    warnSoft: 'rgba(217,119,6,0.12)',
    // Danger (red)
    danger: '#D93025',
    dangerInk: '#991b1b',
    dangerSoft: 'rgba(220,38,38,0.08)',
    // Legacy aliases (keep older code working)
    navy: 'var(--p-navy)',
    navyDark: 'var(--p-navy-dark)',
    navyLight: 'var(--p-navy-light)',
    teal: 'var(--p-teal)',
    tealLight: 'var(--p-teal-light)',
    green: '#1A9B6C',
    greenLight: '#E6F5EF',
    amber: '#F59E0B',
    amberLight: '#FEF3C7',
    red: '#D93025',
    redLight: '#F5E8E7',
    card: '#ffffff',
    textPrimary: '#1a2332',
    textSecondary: '#5a6780',
    textMuted: '#9aa3b0'
};
const $e7c165fb515b04ea$export$2d2c9be8b5b863f = {
    chip: 6,
    control: 10,
    card: 14,
    hero: 20,
    pill: 999
};
const $e7c165fb515b04ea$export$98b6069deb71e13e = {
    card: '0 1px 4px rgba(0,0,0,0.06)',
    floating: '0 8px 24px rgba(0,0,0,0.10)',
    modal: '0 25px 60px rgba(0,0,0,0.20)'
};
const $e7c165fb515b04ea$export$169e587b68892b4e = {
    base: '#e9ecf1',
    sheen: '#f6f7f9',
    // On a gradient header, the sidebar or a dark canvas: white-alpha blocks.
    onDark: 'rgba(255,255,255,0.14)',
    onDarkSheen: 'rgba(255,255,255,0.26)'
};
const $e7c165fb515b04ea$export$959fb1d648dd9e6c = 'rgba(28,27,24,0.55)';
const $e7c165fb515b04ea$export$7deb2be06092489e = 'var(--gradient-brand)';
const $e7c165fb515b04ea$export$4c2e201e0b6dbaa3 = 'var(--gradient-brand-dark)';
const $e7c165fb515b04ea$export$4a4d076b923f4e78 = 'var(--gradient-sidebar)';
const $e7c165fb515b04ea$export$18e630330c8bca65 = 50;
const $e7c165fb515b04ea$export$63b7f4b4938ce481 = 200;
function $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance) {
    if (balance == null) return null;
    if (balance < $e7c165fb515b04ea$export$18e630330c8bca65) return 'low';
    if (balance < $e7c165fb515b04ea$export$63b7f4b4938ce481) return 'mid';
    return 'ok';
}
const $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7 = {
    low: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.red,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.redLight,
        labelKey: 'credits.level.low',
        shortLabelKey: 'credits.level.lowShort'
    },
    mid: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.amber,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.amberLight,
        labelKey: 'credits.level.mid',
        shortLabelKey: 'credits.level.midShort'
    },
    ok: {
        color: $e7c165fb515b04ea$export$e7094788287c5e9b.green,
        tint: $e7c165fb515b04ea$export$e7094788287c5e9b.greenLight,
        labelKey: 'credits.level.ok',
        shortLabelKey: 'credits.level.okShort'
    }
};
function $e7c165fb515b04ea$export$3b48083d65d829ca(balance, fallback = $e7c165fb515b04ea$export$e7094788287c5e9b.textMuted) {
    const level = $e7c165fb515b04ea$export$2e1a2382662bd4ea(balance);
    return level ? $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7[level].color : fallback;
}
const $e7c165fb515b04ea$export$7bce9182245b1545 = (color, alpha = 0.12)=>{
    if (typeof color !== 'string' || !color) return 'transparent';
    const c = color.trim();
    if (c.startsWith('var(') || c.startsWith('color-mix(')) {
        const pct = Math.max(0, Math.min(100, Math.round(alpha * 100)));
        return `color-mix(in srgb, ${c} ${pct}%, transparent)`;
    }
    const h = c.replace('#', '');
    const full = h.length === 3 ? h.split('').map((x)=>x + x).join('') : h;
    const n = parseInt(full, 16);
    if (!/^[0-9a-fA-F]{6}$/.test(full) || Number.isNaN(n)) return c;
    return `rgba(${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}, ${alpha})`;
};
const $e7c165fb515b04ea$export$a1d018c6ed60ae4c = [
    {
        id: 'default',
        get label () {
            return `\u{622}\u{628}\u{6CC} ${(0, $abf0c103b4b92127$export$63a39fc1c580d092)('fa')}`;
        },
        swatch: '#0173BE',
        swatch2: '#00BEB2'
    },
    {
        id: 'teal',
        label: "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
        swatch: '#00A99E',
        swatch2: '#0173BE'
    },
    {
        id: 'ocean',
        label: "\u0644\u0627\u062C\u0648\u0631\u062F\u06CC",
        swatch: '#0A5C8A',
        swatch2: '#0E8F9E'
    },
    {
        id: 'slate',
        label: "\u062E\u0627\u06A9\u0633\u062A\u0631\u06CC \u0622\u0628\u06CC",
        swatch: '#3F5E75',
        swatch2: '#5C8A9E'
    }
];
const $e7c165fb515b04ea$export$7634868d3a6a0a2e = {
    doctor: {
        label: "\u067E\u0646\u0644 \u067E\u0632\u0634\u06A9",
        primary: '#0173BE',
        ink: '#083250'
    },
    clinic: {
        label: "\u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
        primary: '#0A4F8F',
        ink: '#062F57'
    },
    patient: {
        label: "\u067E\u0631\u0648\u0646\u062F\u0647 \u0633\u0644\u0627\u0645\u062A \u0645\u0646",
        primary: '#007C8C',
        ink: '#06363F'
    },
    dentist: {
        label: "\u067E\u0646\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
        primary: '#007D74',
        ink: '#063F3C'
    }
};
function $e7c165fb515b04ea$export$32d6efa0a3310091(panel) {
    const id = $e7c165fb515b04ea$export$7634868d3a6a0a2e[panel];
    if (!id) return $e7c165fb515b04ea$export$a1d018c6ed60ae4c;
    return $e7c165fb515b04ea$export$a1d018c6ed60ae4c.map((t)=>t.id === 'default' ? {
            ...t,
            label: "\u0631\u0646\u06AF \u067E\u0646\u0644",
            swatch: id.primary
        } : t);
}
const $e7c165fb515b04ea$export$58c32c962db85532 = [
    {
        id: 'small',
        label: "\u06A9\u0648\u0686\u06A9"
    },
    {
        id: 'medium',
        label: "\u0645\u062A\u0648\u0633\u0637"
    },
    {
        id: 'large',
        label: "\u0628\u0632\u0631\u06AF"
    }
];
const $e7c165fb515b04ea$export$2faeed762aac6741 = 'default';
const $e7c165fb515b04ea$export$b1461457ea2c1179 = 'medium';
const $e7c165fb515b04ea$export$888c18c43ead4265 = (id)=>$e7c165fb515b04ea$export$a1d018c6ed60ae4c.some((t)=>t.id === id);
const $e7c165fb515b04ea$export$5414ec5c49c0af0f = (id)=>$e7c165fb515b04ea$export$58c32c962db85532.some((f)=>f.id === id);
const $e7c165fb515b04ea$export$ff61b65939f754cc = 'parsina.appearance';
function $e7c165fb515b04ea$export$dde01dc24facb6b0(storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        const raw = store?.getItem($e7c165fb515b04ea$export$ff61b65939f754cc);
        const parsed = raw ? JSON.parse(raw) : null;
        return {
            theme: $e7c165fb515b04ea$export$888c18c43ead4265(parsed?.theme) ? parsed.theme : $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(parsed?.fontSize) ? parsed.fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    } catch  {
        // Private mode, quota, or a corrupt value — fall back rather than throw.
        return {
            theme: $e7c165fb515b04ea$export$2faeed762aac6741,
            fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
        };
    }
}
function $e7c165fb515b04ea$export$48c323151b232e54({ theme: theme, fontSize: fontSize } = {}, doc) {
    const root = (doc ?? (typeof document !== 'undefined' ? document : null))?.documentElement;
    if (!root) return {
        theme: $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    const resolved = {
        theme: $e7c165fb515b04ea$export$888c18c43ead4265(theme) ? theme : $e7c165fb515b04ea$export$2faeed762aac6741,
        fontSize: $e7c165fb515b04ea$export$5414ec5c49c0af0f(fontSize) ? fontSize : $e7c165fb515b04ea$export$b1461457ea2c1179
    };
    root.setAttribute('data-theme', resolved.theme);
    root.setAttribute('data-font-size', resolved.fontSize);
    return resolved;
}
function $e7c165fb515b04ea$export$64464588479aad90(appearance, storage) {
    const store = storage ?? (typeof localStorage !== 'undefined' ? localStorage : null);
    try {
        store?.setItem($e7c165fb515b04ea$export$ff61b65939f754cc, JSON.stringify(appearance));
    } catch  {
    // Persisting the cache is best-effort; the server copy is the real record.
    }
}
const $e7c165fb515b04ea$export$6881c75116d5bd6e = {
    // Appointment lifecycle, in the scheduling service's own vocabulary and with the
    // same Persian labels the clinic day panel uses — the desk and the doctor must not
    // call the same patient two different things.
    scheduled: {
        bg: '#F1F5F9',
        text: '#475569',
        label: "\u0646\u0648\u0628\u062A\u200C\u062F\u0627\u0631"
    },
    arrived: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u062D\u0627\u0636\u0631"
    },
    in_visit: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    },
    completed: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647"
    },
    cancelled: {
        bg: '#FEE2E2',
        text: '#991B1B',
        label: "\u0644\u063A\u0648 \u0634\u062F\u0647"
    },
    // A booked patient who never arrived. Distinct from `cancelled` — nobody
    // cancelled it — and neutral rather than red, because it is a fact about the
    // past, not a problem to act on. The patient app used to fork its own badge
    // for exactly this key (§1.1: missing keys get added here, never re-created
    // locally).
    no_show: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0639\u062F\u0645 \u062D\u0636\u0648\u0631"
    },
    // ── Patient-originated requests (docs/PATIENT_CLINIC_CARE_CONTEXT_AND_SELF_SERVICE_DESIGN.md §3) ──
    // A patient asked for this slot from the app and the clinic has not answered yet.
    // It HOLDS the slot, so it is a real appointment state and belongs here — amber
    // because it is work waiting on the desk, not a settled fact.
    requested: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9"
    },
    // The clinic declined the request, or it expired unanswered. Terminal and neutral:
    // like `no_show`, it is a fact about the past rather than a problem to act on.
    rejected: {
        bg: '#F1F5F9',
        text: '#64748B',
        label: "\u0631\u062F \u0634\u062F\u0647"
    },
    // Patient-record statuses (Patients / PatientDetail screens), a different domain.
    waiting: {
        bg: '#FEF3C7',
        text: '#92400E',
        label: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631"
    },
    visited: {
        bg: '#D1FAE5',
        text: '#065F46',
        label: "\u0648\u06CC\u0632\u06CC\u062A \u0634\u062F"
    },
    inprogress: {
        bg: '#DBEAFE',
        text: '#1E40AF',
        label: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A"
    }
};
const $e7c165fb515b04ea$export$c7989e6ff0cf1179 = [
    '#0173BE',
    '#00BEB2',
    '#F59E0B',
    '#7C4DBE'
];
const $e7c165fb515b04ea$export$6ee8bfc459aebd80 = {
    acquired: $e7c165fb515b04ea$export$c7989e6ff0cf1179[0],
    converted: $e7c165fb515b04ea$export$c7989e6ff0cf1179[1],
    lost: $e7c165fb515b04ea$export$c7989e6ff0cf1179[2],
    recovered: $e7c165fb515b04ea$export$c7989e6ff0cf1179[3]
};


var $412e1a8a99c19c1a$exports = {};

$parcel$export($412e1a8a99c19c1a$exports, "foldDigits", () => $412e1a8a99c19c1a$export$522be3011864bb18);
$parcel$export($412e1a8a99c19c1a$exports, "SEPARATORS", () => $412e1a8a99c19c1a$export$bc4e24532d262f45);
$parcel$export($412e1a8a99c19c1a$exports, "compactPhone", () => $412e1a8a99c19c1a$export$2ae1a93e018170a7);
$parcel$export($412e1a8a99c19c1a$exports, "COUNTRIES", () => $412e1a8a99c19c1a$export$4d78c43b7fa734a7);
$parcel$export($412e1a8a99c19c1a$exports, "DEFAULT_COUNTRY", () => $412e1a8a99c19c1a$export$84b76667b0a9e7b4);
$parcel$export($412e1a8a99c19c1a$exports, "countryForLocale", () => $412e1a8a99c19c1a$export$7684f8e22afec32c);
$parcel$export($412e1a8a99c19c1a$exports, "findByIso2", () => $412e1a8a99c19c1a$export$586b3eaa727579f5);
$parcel$export($412e1a8a99c19c1a$exports, "findByDialCode", () => $412e1a8a99c19c1a$export$21894a57509f6ed5);
$parcel$export($412e1a8a99c19c1a$exports, "countryName", () => $412e1a8a99c19c1a$export$3162e773cd568eb);
$parcel$export($412e1a8a99c19c1a$exports, "countryMatches", () => $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa);
$parcel$export($412e1a8a99c19c1a$exports, "parsePhone", () => $412e1a8a99c19c1a$export$48c6adddc5539199);
$parcel$export($412e1a8a99c19c1a$exports, "normalizePhone", () => $412e1a8a99c19c1a$export$e9b617754cf28d84);
$parcel$export($412e1a8a99c19c1a$exports, "isValidPhone", () => $412e1a8a99c19c1a$export$f9c4d85d720ef909);
$parcel$export($412e1a8a99c19c1a$exports, "toNational", () => $412e1a8a99c19c1a$export$317852993b4735b6);
$parcel$export($412e1a8a99c19c1a$exports, "forDisplay", () => $412e1a8a99c19c1a$export$1069b069fb83ae5b);
$parcel$export($412e1a8a99c19c1a$exports, "maskPhone", () => $412e1a8a99c19c1a$export$1f64b92865689d0d);
$parcel$export($412e1a8a99c19c1a$exports, "lookupVariants", () => $412e1a8a99c19c1a$export$493e0fb9b5aae030);
// Phone numbers, reduced to one canonical form — and read back in whatever form a
// human wants to look at.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE THREE SIBLINGS OF THIS FILE
//
//   microservices/parsina.patientmanagement.microservice/app/domain/phone.py
//       `normalize_phone` — the matching key behind `patients.phone_normalized`.
//       Iran only. Its tests are tests/test_phone.py.
//   sso/parsina.keycloakify/spi/src/main/java/ir/parsinabot/keycloak/phoneotp/PhoneNumbers.java
//       `normalize` / `toNational` / `lookupVariants` / `mask`, inside the Keycloak
//       authenticator. Iran only. Its tests are PhoneNumbersTest.java.
//   sso/parsina.keycloakify/src/login/lib/{countries.ts,phone.ts}
//       The login screen's country-aware picker and E.164 parse. 62 countries,
//       Iran first, "the list is a convenience, never a gate". Its flags are the
//       ones `flags.js` rasterises (PM-0078).
//
// This module is the fourth hand-rolled implementation of the same rules, and it is
// deliberate. Keycloak is a Java process that cannot import Python; the login theme
// cannot `npm install @parsina/framework` (its own `digits.ts` header says why); the
// alembic backfill re-implements the rules in SQL on purpose, because a migration is a
// historical record of what a database was actually given and must not change meaning
// when a source file changes. What holds them together is not a shared module — it is a
// shared CASE TABLE. `PhoneNumbersTest` carries `test_phone.py`'s cases, `test_phone.py`
// carries the migration's, and `ui/lib/phone.test.js` beside this file carries
// `test_phone.py`'s. Adding a country is one row here and one row in `countries.ts`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHY THIS EXISTS AT ALL
//
// A phone number is the only handle joining a walk-in patient record — typed at the
// clinic desk, on paper, in a hurry — to the Keycloak account that person later
// registers with themselves. The two are typed by different people, years apart, in
// whatever form each found natural: the desk's Persian-digit spelling, and
// `+98 912 345 6789` in the signup form. Compared literally they are two different
// strings and the match never happens — which is how a doctor whose realm record held
// `+989199118259` ended up with a SECOND account when a desk typed `09199118259`.
//
// So the canonical form is E.164 — `+`, country code, national significant number, ASCII
// digits and nothing else — and every comparison goes through `normalizePhone`.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE ONE PROMISE THIS FILE MAKES
//
//   With no options, `normalizePhone` is byte-identical to `phone.py#normalize_phone`
//   and `PhoneNumbers.normalize` for EVERY INPUT — not merely for the rows of
//   tests/test_phone.py — and is idempotent.
//
// "Every input" and "every row of the table" are not the same promise, and the weaker one
// was not enough: 74 real Iranian ranges written as `+9901234567` came back as
// `+9901234567` while both twins answered `+989901234567`, and 61 spellings the twins
// accept (`+0…`, `+00…`, `00<national>`, `+<national>`) were refused outright. Every one
// of those passed a green suite, because none of them was a row in the table.
//
// So the twins' algorithm is not APPROXIMATED here by a catalog that happens to contain
// Iran — it is TRANSCRIBED, in `peelIranianMobile`, and runs before the catalog is
// consulted at all. Everything else — countries, landlines, the picker — is the
// generalisation layered around it, and reaches a string only once the peel has declined
// it. `phone.test.js` executes the two implementations against each other over a
// generated corpus, so the promise is checked rather than asserted.
//
// ═══════════════════════════════════════════════════════════════════════════════
// TWO JOBS, NOT ONE
//
// `compactPhone` is LENIENT and `parsePhone` is STRICT, and the split is on purpose:
//
//   - A FIELD filters what a human may put in a box. Typing a word after a number should
//     make the letters simply not appear — the user watches them not arrive and nothing
//     is "rejected". That is `compactPhone`, and `PhoneInput` is its only real caller.
//   - A CANONICALISER judges a string that arrived from a database, an import or another
//     system, and can afford to refuse: `"09123456789abc"` is not a number with junk on
//     it, it is a string we do not understand, and guessing would be worse than
//     declining. That is `parsePhone`, and everything else calls it.
//
// Every non-field caller wants the second one.
//
// ═══════════════════════════════════════════════════════════════════════════════
// AND A THIRD JOB: READING
//
// DISPLAYING A PHONE IS NOT VALIDATING IT.
//
// `parsePhone`/`normalizePhone`/`isValidPhone`/`toNational` all JUDGE — they are the
// converters, and `''` is a verdict they are entitled to return. A READ SURFACE is not
// entitled to it. The value is already in the column; somebody stored it; a person is
// looking at the screen for it. Showing nothing, or showing `+98…` where a human expects
// `021…`, is the only way a read can fail.
//
// So every read goes through `forDisplay`, which is `toNational` with `allowLandline`
// ALWAYS on and the raw value as its fallback, and which therefore never blanks and never
// refuses. Restricting to mobiles belongs on the INPUT — `PhoneInput`, where a desk is
// still typing — and has no meaning at all on a value already written.
//
// The exports, by which job they do:
//
//   INPUT (lenient, shapes a keystroke)   compactPhone, foldDigits
//   CONVERT/VALIDATE (strict, may refuse) parsePhone, normalizePhone, isValidPhone,
//                                         toNational, lookupVariants
//   READ (never refuses)                  forDisplay, maskPhone
//   CATALOG                               COUNTRIES, DEFAULT_COUNTRY, findByIso2,
//                                         findByDialCode, countryName,
//                                         countryMatches, countryForLocale,
//                                         SEPARATORS
// The extension is NOT optional here, and the omission was a real break.
//
// The barrel resolves either spelling because a bundler is doing the resolving.
// But this module is imported DIRECTLY by DOM-free logic that runs under Node's
// own ESM resolver — the patient and student apps do exactly that, deliberately,
// so a `node` test environment does not pull raw JSX through the barrel. Node
// does not guess extensions, so `'./money'` failed there with
// ERR_MODULE_NOT_FOUND naming a file that plainly exists.
// Money — the one place the toman/rial boundary lives.
//
// Every service, every gRPC message and every GraphQL field in Parsina carries WHOLE
// RIALS. Iranian clinics quote, type and read TOMAN. Ten rials to the toman, and the
// conversion happens here, at the display edge, and nowhere else.
//
// Getting this wrong is not a cosmetic bug. A rial figure printed under a toman label
// reads as ten times the money — a 500,000 ت visit shows as 5,000,000 ت — and a toman
// figure typed into a rial field bills a tenth of what the cashier meant. Both of those
// shipped, in opposite directions, on the same screen.
//
// So: rials cross the wire, toman meets the human. Anything reaching for
// `.toLocaleString()` on a raw rial value is a bug.
//
// A clinic may keep its books in another currency: `currency.js` handles any
// allowed one, and for IRR each of its functions returns exactly what this file's
// does. New code that shows clinic money takes the document's currency and uses it.
// With its extension: phone.js imports this module under Node's own ESM resolver
// (see the note there), and Node does not guess one.

const $ca1f40e638c62a9a$export$166519e0fc2d4fb3 = 10;
const $ca1f40e638c62a9a$export$d3105a4d9be2f59 = (rial)=>rial == null || rial === '' || !Number.isFinite(Number(rial)) ? null : Number(rial) / $ca1f40e638c62a9a$export$166519e0fc2d4fb3;
const $ca1f40e638c62a9a$export$496c2c39d7e0791 = (toman)=>{
    const n = Number(String(toman ?? '').replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * $ca1f40e638c62a9a$export$166519e0fc2d4fb3) : NaN;
};
function $ca1f40e638c62a9a$export$1736ebd23f2adeaf(rial) {
    const t = $ca1f40e638c62a9a$export$d3105a4d9be2f59(rial);
    if (t == null) return "\u2014";
    // Sub-toman precision cannot exist (prices are entered in toman) but a percentage
    // discount can land on a half-toman; show it rather than silently rounding money away.
    return t.toLocaleString('fa-IR', {
        maximumFractionDigits: 1
    });
}
function $ca1f40e638c62a9a$export$cbc4bde7d9461cfb(n) {
    if (n == null || n === '' || !Number.isFinite(Number(n))) return "\u2014";
    return Number(n).toLocaleString('fa-IR');
}
function $ca1f40e638c62a9a$export$3d047decf6215cd7(input) {
    if (input == null || String(input).trim() === '') return NaN;
    return $ca1f40e638c62a9a$export$496c2c39d7e0791($ca1f40e638c62a9a$var$toAsciiDigits(input));
}
// Persian/Arabic-Indic digits → ASCII, so a pasted or typed «۵۰۰۰۰۰» parses.
function $ca1f40e638c62a9a$var$toAsciiDigits(input) {
    return String(input).replace(/[۰-۹]/g, (d)=>String("\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9".indexOf(d))).replace(/[٠-٩]/g, (d)=>String("\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669".indexOf(d)));
}
function $ca1f40e638c62a9a$export$8a2f5adb56df4f49(input, allowDecimal = false, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    let raw = String(input ?? '');
    // A locale whose decimal mark is not «.» (Persian uses «٫») would otherwise have
    // it stripped as punctuation, silently turning «۱٫۵» into «۱۵». Grouping marks
    // need no such care — they are non-digits and are meant to go.
    //
    // Under a decimal-COMMA language (French) a text that holds the comma names its
    // decimal with it, so any «.» beside it is a group mark and goes first: «1.234,5»
    // is 1234.5, as `currency.parseAmount(…, 'fr')` reads it — not «1.2345». A text
    // with no comma keeps «.» as a decimal point, which every language accepts here.
    //
    // A language that GROUPS with «.» (German «1.234,5») is different: there a dot is
    // a group mark even with no comma beside it, because that is what `groupAmount`
    // prints into a `MoneyInput` — reading it as a decimal turned a typed «12345» EUR,
    // shown «1.234» after four keys, into 1.23. Two dots are never one decimal point
    // either («1.234.567»). `NumberInput` follows the same rule: under such a
    // language it shows its value with the language's own decimal mark, so a «.» in
    // the box is never its decimal point. A text whose dots are NOT valid groups
    // («12.50», «1.5») is ambiguous there; `dotsAreGroups` lets a field refuse it.
    const dotGroups = numerals.decimal === ',' && (raw.includes(',') || numerals.group === '.');
    if (allowDecimal && dotGroups) raw = raw.split('.').join('');
    if (allowDecimal && numerals.decimal !== '.') raw = raw.split(numerals.decimal).join('.');
    let s = $ca1f40e638c62a9a$var$toAsciiDigits(raw).replace(allowDecimal ? /[^\d.]/g : /\D/g, '');
    if (allowDecimal) {
        const [intPart, ...rest] = s.split('.');
        if (rest.length) s = `${intPart}.${rest.join('')}`; // collapse extra dots
    }
    return s;
}
function $ca1f40e638c62a9a$export$bb91f232d86bf745(input, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    const raw = $ca1f40e638c62a9a$var$toAsciiDigits(String(input ?? ''));
    const intPart = raw.split(numerals.decimal)[0].replace(/[^\d.]/g, '');
    if (!intPart.includes('.')) return true;
    return /^\d{1,3}(\.\d{3})+$/.test(intPart);
}
function $ca1f40e638c62a9a$export$302430bce3371cb8(value, numerals = $ca1f40e638c62a9a$export$4b87c97d2471ab43) {
    if (value == null || value === '') return '';
    const s = String(value);
    const neg = s.startsWith('-') ? '-' : '';
    const [intPart, ...rest] = (neg ? s.slice(1) : s).split('.');
    const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, numerals.group);
    const out = neg + (rest.length ? `${grouped}${numerals.decimal}${rest.join('')}` : grouped);
    // Only the ASCII digits are remapped; the separators are already the locale's.
    return numerals === $ca1f40e638c62a9a$export$4b87c97d2471ab43 ? out : out.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
}
const $ca1f40e638c62a9a$export$4b87c97d2471ab43 = Object.freeze({
    locale: 'en',
    digits: Object.freeze([
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ]),
    group: ',',
    decimal: '.'
});
const $ca1f40e638c62a9a$var$numeralsCache = new Map([
    [
        'en',
        $ca1f40e638c62a9a$export$4b87c97d2471ab43
    ]
]);
function $ca1f40e638c62a9a$export$20975da26e036f6b(locale) {
    const key = locale || 'en';
    const hit = $ca1f40e638c62a9a$var$numeralsCache.get(key);
    if (hit) return hit;
    let resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    try {
        const plain = new Intl.NumberFormat(key, {
            useGrouping: false
        });
        const digits = Array.from({
            length: 10
        }, (_, d)=>plain.format(d));
        // 1000.1 exercises both separators in one pass; a locale missing either
        // (none in practice) falls back to the Latin one rather than to undefined.
        const parts = new Intl.NumberFormat(key, {
            useGrouping: true
        }).formatToParts(1000.1);
        const part = (type, fallback)=>parts.find((p)=>p.type === type)?.value ?? fallback;
        resolved = Object.freeze({
            locale: key,
            digits: Object.freeze(digits),
            group: part('group', ','),
            decimal: part('decimal', '.')
        });
    } catch  {
        // An unsupported or malformed tag is a caller bug, not a reason to stop
        // rendering a price. Latin digits are always readable.
        resolved = $ca1f40e638c62a9a$export$4b87c97d2471ab43;
    }
    $ca1f40e638c62a9a$var$numeralsCache.set(key, resolved);
    return resolved;
}
function $ca1f40e638c62a9a$export$594d280e896fc02b(fallback = (0, $abf0c103b4b92127$export$879824979a5b153a)('fa')) {
    if (typeof document === 'undefined') return fallback;
    return document.documentElement?.getAttribute('lang') || fallback;
}



// ─────────────────────────────────────────────────────────────────────────────
// Digits
// ─────────────────────────────────────────────────────────────────────────────
/** Persian U+06F0–U+06F9 — the default on an Iranian keyboard. */ const $412e1a8a99c19c1a$var$FA_ZERO = 0x06f0;
/** Arabic-Indic U+0660–U+0669 — Arabic-locale keyboards and some legacy imports. */ const $412e1a8a99c19c1a$var$AR_ZERO = 0x0660;
/** Fullwidth U+FF10–U+FF19 — emitted by some IME keyboards. */ const $412e1a8a99c19c1a$var$FW_ZERO = 0xff10;
function $412e1a8a99c19c1a$export$522be3011864bb18(raw) {
    if (typeof raw !== 'string') return '';
    let out = '';
    for(let i = 0; i < raw.length; i++){
        const c = raw.charCodeAt(i);
        if (c >= $412e1a8a99c19c1a$var$FA_ZERO && c <= $412e1a8a99c19c1a$var$FA_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FA_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$AR_ZERO && c <= $412e1a8a99c19c1a$var$AR_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$AR_ZERO));
        else if (c >= $412e1a8a99c19c1a$var$FW_ZERO && c <= $412e1a8a99c19c1a$var$FW_ZERO + 9) out += String.fromCharCode(48 + (c - $412e1a8a99c19c1a$var$FW_ZERO));
        else out += raw[i];
    }
    return out;
}
const $412e1a8a99c19c1a$export$bc4e24532d262f45 = " 	\r\n\f\v\xa0\u202F\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u205F\u3000\u200B\u200C\u200D\u200E\u200F\u061C\uFEFF-\u2010\u2011\u2012\u2013\u2014\u2015\u2212()[]{}<>._/\\|,;:*#'\"`"; // everything else a desk has been seen to type
const $412e1a8a99c19c1a$var$SEPARATOR_SET = new Set($412e1a8a99c19c1a$export$bc4e24532d262f45.split(''));
const $412e1a8a99c19c1a$var$stripSeparators = (s)=>{
    let out = '';
    for(let i = 0; i < s.length; i++)if (!$412e1a8a99c19c1a$var$SEPARATOR_SET.has(s[i])) out += s[i];
    return out;
};
/**
 * What must remain once decoration is gone: digits, optionally introduced by ONE leading
 * `+`. Anything else — a letter, a second `+`, an interior symbol we did not list — means
 * this string is not a phone number.
 */ const $412e1a8a99c19c1a$var$DIGITS_ONLY = /^\+?[0-9]+$/;
/**
 * The national significant number of an Iranian mobile: ten digits, the first a 9.
 * `phone.py#_IR_MOBILE` character for character (`\d` and `[0-9]` are the same set here,
 * and Iran's catalog row spells the same rule `/^9\d{9}$/`).
 *
 * It is written out separately from that row because the twins' peel below is not a
 * catalog lookup and must not become one — see `peelIranianMobile`.
 */ const $412e1a8a99c19c1a$var$IR_MOBILE = /^9[0-9]{9}$/;
/** E.164 caps the whole number — country code included — at 15 digits. The floor is a
 *  sanity bound, not a standard: no plan in this catalog is shorter. */ const $412e1a8a99c19c1a$var$E164_MIN_DIGITS = 7;
const $412e1a8a99c19c1a$var$E164_MAX_DIGITS = 15;
function $412e1a8a99c19c1a$export$2ae1a93e018170a7(raw) {
    const ascii = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    const prefix = ascii.startsWith('+') ? '+' : '';
    return prefix + ascii.replace(/\D/g, '');
}
const $412e1a8a99c19c1a$export$4d78c43b7fa734a7 = Object.freeze([
    Object.freeze({
        iso2: 'IR',
        dial: '98',
        en: 'Iran',
        fa: "\u0627\u06CC\u0631\u0627\u0646",
        ar: "\u0625\u064A\u0631\u0627\u0646",
        fr: 'Iran',
        de: 'Iran',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        nsnPattern: /^9\d{9}$/,
        example: '09121234567'
    }),
    Object.freeze({
        iso2: 'AF',
        dial: '93',
        en: 'Afghanistan',
        fa: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        fr: 'Afghanistan',
        de: 'Afghanistan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'DZ',
        dial: '213',
        en: 'Algeria',
        fa: "\u0627\u0644\u062C\u0632\u0627\u06CC\u0631",
        ar: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        fr: "Alg\xe9rie",
        de: 'Algerien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0551234567'
    }),
    Object.freeze({
        iso2: 'AM',
        dial: '374',
        en: 'Armenia',
        fa: "\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0631\u0645\u064A\u0646\u064A\u0627",
        fr: "Arm\xe9nie",
        de: 'Armenien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 8,
        example: '077123456'
    }),
    Object.freeze({
        iso2: 'AU',
        dial: '61',
        en: 'Australia',
        fa: "\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627",
        ar: "\u0623\u0633\u062A\u0631\u0627\u0644\u064A\u0627",
        fr: 'Australie',
        de: 'Australien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0412345678'
    }),
    Object.freeze({
        iso2: 'AT',
        dial: '43',
        en: 'Austria',
        fa: "\u0627\u062A\u0631\u06CC\u0634",
        ar: "\u0627\u0644\u0646\u0645\u0633\u0627",
        fr: 'Autriche',
        de: "\xd6sterreich",
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '06641234567'
    }),
    Object.freeze({
        iso2: 'AZ',
        dial: '994',
        en: 'Azerbaijan',
        fa: "\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646",
        ar: "\u0623\u0630\u0631\u0628\u064A\u062C\u0627\u0646",
        fr: "Azerba\xefdjan",
        de: 'Aserbaidschan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'BH',
        dial: '973',
        en: 'Bahrain',
        fa: "\u0628\u062D\u0631\u06CC\u0646",
        ar: "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        fr: "Bahre\xefn",
        de: 'Bahrain',
        nsnMin: 8,
        nsnMax: 8,
        example: '36001234'
    }),
    Object.freeze({
        iso2: 'BE',
        dial: '32',
        en: 'Belgium',
        fa: "\u0628\u0644\u0698\u06CC\u06A9",
        ar: "\u0628\u0644\u062C\u064A\u0643\u0627",
        fr: 'Belgique',
        de: 'Belgien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0470123456'
    }),
    Object.freeze({
        iso2: 'BR',
        dial: '55',
        en: 'Brazil',
        fa: "\u0628\u0631\u0632\u06CC\u0644",
        ar: "\u0627\u0644\u0628\u0631\u0627\u0632\u064A\u0644",
        fr: "Br\xe9sil",
        de: 'Brasilien',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 11,
        example: '11912345678'
    }),
    Object.freeze({
        iso2: 'CA',
        dial: '1',
        en: 'Canada',
        fa: "\u06A9\u0627\u0646\u0627\u062F\u0627",
        ar: "\u0643\u0646\u062F\u0627",
        fr: 'Canada',
        de: 'Kanada',
        nsnMin: 10,
        nsnMax: 10,
        example: '4165550123'
    }),
    Object.freeze({
        iso2: 'CN',
        dial: '86',
        en: 'China',
        fa: "\u0686\u06CC\u0646",
        ar: "\u0627\u0644\u0635\u064A\u0646",
        fr: 'Chine',
        de: 'China',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 12,
        example: '13123456789'
    }),
    Object.freeze({
        iso2: 'CY',
        dial: '357',
        en: 'Cyprus',
        fa: "\u0642\u0628\u0631\u0633",
        ar: "\u0642\u0628\u0631\u0635",
        fr: 'Chypre',
        de: 'Zypern',
        nsnMin: 8,
        nsnMax: 8,
        example: '96123456'
    }),
    Object.freeze({
        iso2: 'DK',
        dial: '45',
        en: 'Denmark',
        fa: "\u062F\u0627\u0646\u0645\u0627\u0631\u06A9",
        ar: "\u0627\u0644\u062F\u0646\u0645\u0627\u0631\u0643",
        fr: 'Danemark',
        de: "D\xe4nemark",
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'EG',
        dial: '20',
        en: 'Egypt',
        fa: "\u0645\u0635\u0631",
        ar: "\u0645\u0635\u0631",
        fr: "\xc9gypte",
        de: "\xc4gypten",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '01001234567'
    }),
    Object.freeze({
        iso2: 'FI',
        dial: '358',
        en: 'Finland',
        fa: "\u0641\u0646\u0644\u0627\u0646\u062F",
        ar: "\u0641\u0646\u0644\u0646\u062F\u0627",
        fr: 'Finlande',
        de: 'Finnland',
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '0401234567'
    }),
    Object.freeze({
        iso2: 'FR',
        dial: '33',
        en: 'France',
        fa: "\u0641\u0631\u0627\u0646\u0633\u0647",
        ar: "\u0641\u0631\u0646\u0633\u0627",
        fr: 'France',
        de: 'Frankreich',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'GE',
        dial: '995',
        en: 'Georgia',
        fa: "\u06AF\u0631\u062C\u0633\u062A\u0627\u0646",
        ar: "\u062C\u0648\u0631\u062C\u064A\u0627",
        fr: "G\xe9orgie",
        de: 'Georgien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '555123456'
    }),
    Object.freeze({
        iso2: 'DE',
        dial: '49',
        en: 'Germany',
        fa: "\u0622\u0644\u0645\u0627\u0646",
        ar: "\u0623\u0644\u0645\u0627\u0646\u064A\u0627",
        fr: 'Allemagne',
        de: 'Deutschland',
        trunk: '0',
        nsnMin: 6,
        nsnMax: 12,
        example: '015112345678'
    }),
    Object.freeze({
        iso2: 'GR',
        dial: '30',
        en: 'Greece',
        fa: "\u06CC\u0648\u0646\u0627\u0646",
        ar: "\u0627\u0644\u064A\u0648\u0646\u0627\u0646",
        fr: "Gr\xe8ce",
        de: 'Griechenland',
        nsnMin: 10,
        nsnMax: 10,
        example: '6912345678'
    }),
    Object.freeze({
        iso2: 'HU',
        dial: '36',
        en: 'Hungary',
        fa: "\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646",
        ar: "\u0627\u0644\u0645\u062C\u0631",
        fr: 'Hongrie',
        de: 'Ungarn',
        trunk: '06',
        nsnMin: 8,
        nsnMax: 9,
        example: '06201234567'
    }),
    Object.freeze({
        iso2: 'IN',
        dial: '91',
        en: 'India',
        fa: "\u0647\u0646\u062F",
        ar: "\u0627\u0644\u0647\u0646\u062F",
        fr: 'Inde',
        de: 'Indien',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '9812345678'
    }),
    Object.freeze({
        iso2: 'ID',
        dial: '62',
        en: 'Indonesia',
        fa: "\u0627\u0646\u062F\u0648\u0646\u0632\u06CC",
        ar: "\u0625\u0646\u062F\u0648\u0646\u064A\u0633\u064A\u0627",
        fr: "Indon\xe9sie",
        de: 'Indonesien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 12,
        example: '081234567890'
    }),
    Object.freeze({
        iso2: 'IQ',
        dial: '964',
        en: 'Iraq',
        fa: "\u0639\u0631\u0627\u0642",
        ar: "\u0627\u0644\u0639\u0631\u0627\u0642",
        fr: 'Irak',
        de: 'Irak',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '07912345678'
    }),
    Object.freeze({
        iso2: 'IT',
        dial: '39',
        en: 'Italy',
        fa: "\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627",
        ar: "\u0625\u064A\u0637\u0627\u0644\u064A\u0627",
        fr: 'Italie',
        de: 'Italien',
        nsnMin: 6,
        nsnMax: 11,
        example: '3123456789'
    }),
    Object.freeze({
        iso2: 'JP',
        dial: '81',
        en: 'Japan',
        fa: "\u0698\u0627\u067E\u0646",
        ar: "\u0627\u0644\u064A\u0627\u0628\u0627\u0646",
        fr: 'Japon',
        de: 'Japan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '09012345678'
    }),
    Object.freeze({
        iso2: 'JO',
        dial: '962',
        en: 'Jordan',
        fa: "\u0627\u0631\u062F\u0646",
        ar: "\u0627\u0644\u0623\u0631\u062F\u0646",
        fr: 'Jordanie',
        de: 'Jordanien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0791234567'
    }),
    Object.freeze({
        iso2: 'KZ',
        dial: '7',
        en: 'Kazakhstan',
        fa: "\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646",
        ar: "\u0643\u0627\u0632\u0627\u062E\u0633\u062A\u0627\u0646",
        fr: 'Kazakhstan',
        de: 'Kasachstan',
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '87011234567'
    }),
    Object.freeze({
        iso2: 'KW',
        dial: '965',
        en: 'Kuwait',
        fa: "\u06A9\u0648\u06CC\u062A",
        ar: "\u0627\u0644\u0643\u0648\u064A\u062A",
        fr: "Kowe\xeft",
        de: 'Kuwait',
        nsnMin: 8,
        nsnMax: 8,
        example: '50012345'
    }),
    Object.freeze({
        iso2: 'LB',
        dial: '961',
        en: 'Lebanon',
        fa: "\u0644\u0628\u0646\u0627\u0646",
        ar: "\u0644\u0628\u0646\u0627\u0646",
        fr: 'Liban',
        de: 'Libanon',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 8,
        example: '03123456'
    }),
    Object.freeze({
        iso2: 'LY',
        dial: '218',
        en: 'Libya',
        fa: "\u0644\u06CC\u0628\u06CC",
        ar: "\u0644\u064A\u0628\u064A\u0627",
        fr: 'Libye',
        de: 'Libyen',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'MY',
        dial: '60',
        en: 'Malaysia',
        fa: "\u0645\u0627\u0644\u0632\u06CC",
        ar: "\u0645\u0627\u0644\u064A\u0632\u064A\u0627",
        fr: 'Malaisie',
        de: 'Malaysia',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0123456789'
    }),
    Object.freeze({
        iso2: 'MR',
        dial: '222',
        en: 'Mauritania',
        fa: "\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC",
        ar: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
        fr: 'Mauritanie',
        de: 'Mauretanien',
        nsnMin: 8,
        nsnMax: 8,
        example: '22123456'
    }),
    Object.freeze({
        iso2: 'MA',
        dial: '212',
        en: 'Morocco',
        fa: "\u0645\u0631\u0627\u06A9\u0634",
        ar: "\u0627\u0644\u0645\u063A\u0631\u0628",
        fr: 'Maroc',
        de: 'Marokko',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NL',
        dial: '31',
        en: 'Netherlands',
        fa: "\u0647\u0644\u0646\u062F",
        ar: "\u0647\u0648\u0644\u0646\u062F\u0627",
        fr: 'Pays-Bas',
        de: 'Niederlande',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0612345678'
    }),
    Object.freeze({
        iso2: 'NZ',
        dial: '64',
        en: 'New Zealand',
        fa: "\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F",
        ar: "\u0646\u064A\u0648\u0632\u064A\u0644\u0646\u062F\u0627",
        fr: "Nouvelle-Z\xe9lande",
        de: 'Neuseeland',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 10,
        example: '0211234567'
    }),
    Object.freeze({
        iso2: 'NO',
        dial: '47',
        en: 'Norway',
        fa: "\u0646\u0631\u0648\u0698",
        ar: "\u0627\u0644\u0646\u0631\u0648\u064A\u062C",
        fr: "Norv\xe8ge",
        de: 'Norwegen',
        nsnMin: 8,
        nsnMax: 8,
        example: '40612345'
    }),
    Object.freeze({
        iso2: 'OM',
        dial: '968',
        en: 'Oman',
        fa: "\u0639\u0645\u0627\u0646",
        ar: "\u0639\u064F\u0645\u0627\u0646",
        fr: 'Oman',
        de: 'Oman',
        nsnMin: 8,
        nsnMax: 8,
        example: '92123456'
    }),
    Object.freeze({
        iso2: 'PK',
        dial: '92',
        en: 'Pakistan',
        fa: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0627\u0643\u0633\u062A\u0627\u0646",
        fr: 'Pakistan',
        de: 'Pakistan',
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '03012345678'
    }),
    Object.freeze({
        iso2: 'PS',
        dial: '970',
        en: 'Palestine',
        fa: "\u0641\u0644\u0633\u0637\u06CC\u0646",
        ar: "\u0641\u0644\u0633\u0637\u064A\u0646",
        fr: 'Palestine',
        de: "Pal\xe4stina",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0599123456'
    }),
    Object.freeze({
        iso2: 'PL',
        dial: '48',
        en: 'Poland',
        fa: "\u0644\u0647\u0633\u062A\u0627\u0646",
        ar: "\u0628\u0648\u0644\u0646\u062F\u0627",
        fr: 'Pologne',
        de: 'Polen',
        nsnMin: 9,
        nsnMax: 9,
        example: '512345678'
    }),
    Object.freeze({
        iso2: 'QA',
        dial: '974',
        en: 'Qatar',
        fa: "\u0642\u0637\u0631",
        ar: "\u0642\u0637\u0631",
        fr: 'Qatar',
        de: 'Katar',
        nsnMin: 8,
        nsnMax: 8,
        example: '33123456'
    }),
    Object.freeze({
        iso2: 'RU',
        dial: '7',
        en: 'Russia',
        fa: "\u0631\u0648\u0633\u06CC\u0647",
        ar: "\u0631\u0648\u0633\u064A\u0627",
        fr: 'Russie',
        de: 'Russland',
        trunk: '8',
        nsnMin: 10,
        nsnMax: 10,
        example: '89123456789'
    }),
    Object.freeze({
        iso2: 'SA',
        dial: '966',
        en: 'Saudi Arabia',
        fa: "\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC",
        ar: "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        fr: 'Arabie saoudite',
        de: 'Saudi-Arabien',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'SG',
        dial: '65',
        en: 'Singapore',
        fa: "\u0633\u0646\u06AF\u0627\u067E\u0648\u0631",
        ar: "\u0633\u0646\u063A\u0627\u0641\u0648\u0631\u0629",
        fr: 'Singapour',
        de: 'Singapur',
        nsnMin: 8,
        nsnMax: 8,
        example: '81234567'
    }),
    Object.freeze({
        iso2: 'ZA',
        dial: '27',
        en: 'South Africa',
        fa: "\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC",
        ar: "\u062C\u0646\u0648\u0628 \u0623\u0641\u0631\u064A\u0642\u064A\u0627",
        fr: 'Afrique du Sud',
        de: "S\xfcdafrika",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0821234567'
    }),
    Object.freeze({
        iso2: 'ES',
        dial: '34',
        en: 'Spain',
        fa: "\u0627\u0633\u067E\u0627\u0646\u06CC\u0627",
        ar: "\u0625\u0633\u0628\u0627\u0646\u064A\u0627",
        fr: 'Espagne',
        de: 'Spanien',
        nsnMin: 9,
        nsnMax: 9,
        example: '612345678'
    }),
    Object.freeze({
        iso2: 'SD',
        dial: '249',
        en: 'Sudan',
        fa: "\u0633\u0648\u062F\u0627\u0646",
        ar: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        fr: 'Soudan',
        de: 'Sudan',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0912345678'
    }),
    Object.freeze({
        iso2: 'SE',
        dial: '46',
        en: 'Sweden',
        fa: "\u0633\u0648\u0626\u062F",
        ar: "\u0627\u0644\u0633\u0648\u064A\u062F",
        fr: "Su\xe8de",
        de: 'Schweden',
        trunk: '0',
        nsnMin: 7,
        nsnMax: 13,
        example: '0701234567'
    }),
    Object.freeze({
        iso2: 'CH',
        dial: '41',
        en: 'Switzerland',
        fa: "\u0633\u0648\u0626\u06CC\u0633",
        ar: "\u0633\u0648\u064A\u0633\u0631\u0627",
        fr: 'Suisse',
        de: 'Schweiz',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0781234567'
    }),
    Object.freeze({
        iso2: 'SY',
        dial: '963',
        en: 'Syria',
        fa: "\u0633\u0648\u0631\u06CC\u0647",
        ar: "\u0633\u0648\u0631\u064A\u0627",
        fr: 'Syrie',
        de: 'Syrien',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0944567890'
    }),
    Object.freeze({
        iso2: 'TJ',
        dial: '992',
        en: 'Tajikistan',
        fa: "\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0637\u0627\u062C\u064A\u0643\u0633\u062A\u0627\u0646",
        fr: 'Tadjikistan',
        de: 'Tadschikistan',
        nsnMin: 9,
        nsnMax: 9,
        example: '917123456'
    }),
    Object.freeze({
        iso2: 'TH',
        dial: '66',
        en: 'Thailand',
        fa: "\u062A\u0627\u06CC\u0644\u0646\u062F",
        ar: "\u062A\u0627\u064A\u0644\u0627\u0646\u062F",
        fr: "Tha\xeflande",
        de: 'Thailand',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0812345678'
    }),
    Object.freeze({
        iso2: 'TN',
        dial: '216',
        en: 'Tunisia',
        fa: "\u062A\u0648\u0646\u0633",
        ar: "\u062A\u0648\u0646\u0633",
        fr: 'Tunisie',
        de: 'Tunesien',
        nsnMin: 8,
        nsnMax: 8,
        example: '20123456'
    }),
    Object.freeze({
        iso2: 'TM',
        dial: '993',
        en: 'Turkmenistan',
        fa: "\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646",
        ar: "\u062A\u0631\u0643\u0645\u0627\u0646\u0633\u062A\u0627\u0646",
        fr: "Turkm\xe9nistan",
        de: 'Turkmenistan',
        trunk: '8',
        nsnMin: 8,
        nsnMax: 8,
        example: '65123456'
    }),
    Object.freeze({
        iso2: 'TR',
        dial: '90',
        en: "T\xfcrkiye",
        fa: "\u062A\u0631\u06A9\u06CC\u0647",
        ar: "\u062A\u0631\u0643\u064A\u0627",
        fr: 'Turquie',
        de: "T\xfcrkei",
        trunk: '0',
        nsnMin: 10,
        nsnMax: 10,
        example: '05321234567'
    }),
    Object.freeze({
        iso2: 'UA',
        dial: '380',
        en: 'Ukraine',
        fa: "\u0627\u0648\u06A9\u0631\u0627\u06CC\u0646",
        ar: "\u0623\u0648\u0643\u0631\u0627\u0646\u064A\u0627",
        fr: 'Ukraine',
        de: 'Ukraine',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'AE',
        dial: '971',
        en: 'United Arab Emirates',
        fa: "\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647\u0654 \u0639\u0631\u0628\u06CC",
        ar: "\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: "\xc9mirats arabes unis",
        de: 'Vereinigte Arabische Emirate',
        trunk: '0',
        nsnMin: 8,
        nsnMax: 9,
        example: '0501234567'
    }),
    Object.freeze({
        iso2: 'GB',
        dial: '44',
        en: 'United Kingdom',
        fa: "\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627",
        ar: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: 'Royaume-Uni',
        de: "Vereinigtes K\xf6nigreich",
        trunk: '0',
        nsnMin: 9,
        nsnMax: 10,
        example: '07400123456'
    }),
    Object.freeze({
        iso2: 'US',
        dial: '1',
        en: 'United States',
        fa: "\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647",
        ar: "\u0627\u0644\u0648\u0644\u0627\u064A\u0627\u062A \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        fr: "\xc9tats-Unis",
        de: 'Vereinigte Staaten',
        nsnMin: 10,
        nsnMax: 10,
        example: '2025550123'
    }),
    Object.freeze({
        iso2: 'UZ',
        dial: '998',
        en: 'Uzbekistan',
        fa: "\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646",
        ar: "\u0623\u0648\u0632\u0628\u0643\u0633\u062A\u0627\u0646",
        fr: "Ouzb\xe9kistan",
        de: 'Usbekistan',
        nsnMin: 9,
        nsnMax: 9,
        example: '901234567'
    }),
    Object.freeze({
        iso2: 'YE',
        dial: '967',
        en: 'Yemen',
        fa: "\u06CC\u0645\u0646",
        ar: "\u0627\u0644\u064A\u0645\u0646",
        fr: "Y\xe9men",
        de: 'Jemen',
        trunk: '0',
        nsnMin: 9,
        nsnMax: 9,
        example: '0712345678'
    })
]);
const $412e1a8a99c19c1a$export$84b76667b0a9e7b4 = $412e1a8a99c19c1a$export$4d78c43b7fa734a7[0];
function $412e1a8a99c19c1a$export$7684f8e22afec32c(locale) {
    const tag = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).replace(/_/g, '-');
    const parts = tag.split('-');
    const region = parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p));
    const byRegion = region ? $412e1a8a99c19c1a$export$586b3eaa727579f5(region) : undefined;
    if (byRegion) return byRegion;
    const language = parts[0].toLowerCase();
    if (language === 'ar' || !(0, $abf0c103b4b92127$export$3cede7c619603eb2)()) return $412e1a8a99c19c1a$export$586b3eaa727579f5('IQ') || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
    return $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
}
function $412e1a8a99c19c1a$export$586b3eaa727579f5(iso2) {
    if (typeof iso2 !== 'string') return undefined;
    const key = iso2.toUpperCase();
    return $412e1a8a99c19c1a$export$4d78c43b7fa734a7.find((c)=>c.iso2 === key);
}
function $412e1a8a99c19c1a$export$21894a57509f6ed5(digits) {
    if (typeof digits !== 'string') return undefined;
    let best;
    for (const country of $412e1a8a99c19c1a$export$4d78c43b7fa734a7){
        if (!digits.startsWith(country.dial)) continue;
        if (best === undefined || country.dial.length > best.dial.length) best = country;
    }
    return best;
}
/**
 * The languages every row is named in — the only fields `countryName` reads and
 * `countryMatches` searches. A list rather than `country[language]`, so no locale can
 * ever read a field that is not a name (`dial`, `example`…).
 */ const $412e1a8a99c19c1a$var$NAME_LANGUAGES = Object.freeze([
    'fa',
    'en',
    'ar',
    'fr',
    'de'
]);
function $412e1a8a99c19c1a$export$3162e773cd568eb(country, locale) {
    if (!country) return '';
    const tag = locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const language = String(tag).split('-')[0];
    return $412e1a8a99c19c1a$var$NAME_LANGUAGES.includes(language) && country[language] || country.en;
}
/**
 * A name folded for SEARCH, never for display: lower case, decomposed (NFD) and stripped
 * of the combining marks U+0300–U+036F, so «etats», «Etats» and «ÉTATS» all reach
 * «États-Unis», and «turk» reaches «Türkiye» and «Türkei». «ß» has no decomposition, so
 * it is spelled out as «ss» (PM-0212): «Straße» and «strasse» fold alike.
 * Persian and Arabic letters come through unchanged — their marks sit outside that block
 * — and both sides of a comparison are folded alike, so every search that matched before
 * still matches.
 * @param {string} text
 * @returns {string}
 */ function $412e1a8a99c19c1a$var$foldForSearch(text) {
    return String(text).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
}
function $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa(country, query) {
    if (!country) return false;
    const needle = $412e1a8a99c19c1a$export$522be3011864bb18(query).trim().toLowerCase().replace(/^\+/, '');
    if (!needle) return true;
    if (country.dial.startsWith(needle) || country.iso2.toLowerCase() === needle) return true;
    const folded = $412e1a8a99c19c1a$var$foldForSearch(needle);
    return $412e1a8a99c19c1a$var$NAME_LANGUAGES.some((language)=>{
        const name = country[language];
        return typeof name === 'string' && name !== '' && $412e1a8a99c19c1a$var$foldForSearch(name).includes(folded);
    });
}
// ─────────────────────────────────────────────────────────────────────────────
// The one parse
// ─────────────────────────────────────────────────────────────────────────────
/**
 * @typedef {'required'|'tooShort'|'tooLong'|'notMobile'|'invalid'} PhoneProblem
 * Why a number was refused. Each one gets its own message: "invalid" alone tells the
 * user nothing about which digit to go looking for.
 */ /**
 * @typedef {Object} PhoneParse
 * @property {boolean} ok
 * @property {string}  e164      `'+989121234567'`, or `''` when `ok` is false.
 * @property {string}  national  `'09121234567'`, or `''` when `ok` is false — and also
 *                               `''` for an accepted number whose country is not in the
 *                               catalog, because there is no national form to render
 *                               without knowing the plan.
 * @property {Country} country   The country the MESSAGE should name: the one the number
 *                               claims where it claimed one, otherwise the selected one.
 * @property {PhoneProblem|null} problem
 */ /**
 * @typedef {Object} PhoneOptions
 * @property {Country|string} [country]        A `Country` record OR an iso2 string
 *                                             (`{ country: 'TR' }`), so no caller has to
 *                                             import the catalog to name a country.
 *                                             Default: Iran.
 * @property {boolean}        [allowLandline]  Drop the country's `nsnPattern`. Iran only,
 *                                             in practice. Default: false.
 */ const $412e1a8a99c19c1a$var$resolveCountry = (c)=>(typeof c === 'string' ? $412e1a8a99c19c1a$export$586b3eaa727579f5(c) : c) || $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
/** Does this NSN look like one of `country`'s? Length, plus — where the country declares
 *  one and the caller has not waived it — a shape. */ function $412e1a8a99c19c1a$var$fitsNsn(nsn, country, allowLandline) {
    if (nsn.length < country.nsnMin || nsn.length > country.nsnMax) return false;
    if (allowLandline || country.nsnPattern === undefined) return true;
    return country.nsnPattern.test(nsn);
}
/**
 * Drop a leading trunk prefix — the digits a number wears only when it is dialled INSIDE
 * its own country, and which are never part of the national significant number.
 *
 * **A trunk that begins with `0` comes off unconditionally.** In a plan that HAS a trunk
 * zero, no NSN begins with `0` — the zero IS the trunk, by construction — so keeping it
 * cannot produce a right answer, only one that is wrong by exactly a digit. Length bounds
 * are a check ON the NSN; they were never a way to choose whether to peel. Letting them
 * choose is what made `parsePhone('0218800000', { allowLandline: true })` — a Tehran
 * landline one digit short — answer `+980218800000`: the peeled body is nine digits and
 * misses Iran's 10/10 window, the trunk-kept string is ten and fits it, so the trunk was
 * kept and `judge`, with the mobile pattern waived, passed it on length alone. The number
 * was stored AND redisplayed («00218800000») wrong, stably and silently.
 *
 * **A trunk that is an ordinary digit stays conditional.** Russia's, Kazakhstan's and
 * Turkmenistan's trunk is `8`, and `8121234567` is St Petersburg — a real national number
 * that BEGINS with the trunk digit. There is no structural rule to appeal to, so the
 * heuristic is the best available: peel when the result is a number the country
 * recognises, or when keeping it cannot produce one.
 *
 * The `!fitsNsn(candidate)` half of that heuristic is also what makes a short Russian
 * number report "too short" rather than a shape complaint.
 *
 * ONE helper, used on BOTH branches of `parsePhone`. The live login theme peels the trunk
 * only on the national path, which is why it gets `"+98 0912 345 6789"` and
 * `"00980912 3456789"` wrong — and both of those are rows in tests/test_phone.py, i.e.
 * shapes this platform's data genuinely holds. This is the single rule here that the theme
 * does not yet have; it is filed as a follow-up against parsina.keycloakify. The theme's
 * direction is the safe one (it refuses rather than mis-reads), so the symptom there is a
 * rejected login and never a wrong number.
 *
 * What this function does NOT do is peel a SECOND zero. One trunk comes off; a string
 * wearing two (`+43 0 0664…`) is not a number this module claims to understand, and
 * `judge` refuses it rather than guessing which zero was the trunk — see the guard there.
 */ function $412e1a8a99c19c1a$var$peelTrunk(candidate, country, allowLandline) {
    const trunk = country.trunk;
    if (!trunk || !candidate.startsWith(trunk) || candidate.length <= trunk.length) return candidate;
    const without = candidate.slice(trunk.length);
    if (trunk[0] === '0') return without;
    return $412e1a8a99c19c1a$var$fitsNsn(without, country, allowLandline) || !$412e1a8a99c19c1a$var$fitsNsn(candidate, country, allowLandline) ? without : candidate;
}
/**
 * Iran's rule, exactly as the twins write it: drop a leading `+`, then peel `00`, then
 * the country code `98` when what is left would be too long to be an NSN, then the trunk
 * `0` — and require the remainder to be `9` plus nine digits.
 *
 * A LINEAR PEEL, not a catalog lookup, and the difference is the whole point of this
 * function existing. The peel never asks which country `990…` belongs to, so
 * `+9901234567` is read as the 0990 mobile it is. Asking the catalog instead is how this
 * kit used to answer `+9901234567` where both twins answer `+989901234567`: no row starts
 * with `990`, the number fell through to the generic "some foreign country" accept, and
 * `lookupVariants` then offered ONE spelling. A Keycloak probe in that spelling misses the
 * same person stored as `09901234567`, and the auto-provisioning flow mints a duplicate
 * account — the precise harm this module exists to prevent. Seventy-four live Iranian
 * ranges (0940–0949, 0950–0959, 0960–0962, 0967, 0969, 0970, 0972, 0975–0979, 0990, 0991,
 * 0996, 0997, 0999) were wrong that way.
 *
 * Line for line this is `phone.py#normalize_phone`'s body after its shared prelude, down
 * to the sequential `if`s — they are NOT mutually exclusive there and must not become so
 * here, because `+00989…` wears all three prefixes at once. `phone.test.js` executes this
 * against the real Python over a generated corpus so the two cannot drift silently.
 *
 * @param {string} s  Folded, separator-stripped, already matched against `DIGITS_ONLY`.
 * @returns {string|null}  The ten-digit NSN, or `null` when this is not an Iranian mobile.
 */ function $412e1a8a99c19c1a$var$peelIranianMobile(s) {
    let t = s;
    if (t[0] === '+') t = t.slice(1);
    if (t.startsWith('00')) t = t.slice(2);
    // The `length > 10` guard is what keeps 9812345678 — an ordinary 0981 mobile — from
    // being read as country code 98 followed by an eight-digit stub.
    if (t.startsWith('98') && t.length > 10) t = t.slice(2);
    if (t.startsWith('0')) t = t.slice(1);
    return $412e1a8a99c19c1a$var$IR_MOBILE.test(t) ? t : null;
}
/**
 * The last word on an NSN once the prefixes are off it.
 *
 * The first guard is not a length rule and deliberately runs before the length rules: in a
 * plan whose trunk prefix is a zero, an NSN that still BEGINS with one is not a number
 * this module can read. `peelTrunk` takes exactly one trunk off, so a leading zero here
 * means the string wore its trunk twice (`+43 0 0664 123 4567`, and 94 shapes like it
 * across 17 of the 52 rows). Accepting it was worse than refusing for a reason that has
 * nothing to do with the user's typing: `+430664123456` fed back through this module
 * peels the surviving zero and answers `+43664123456`, so the kit emitted an E.164 it
 * would later read as a DIFFERENT phone — the one thing a matching key may never do. A
 * number cannot be both, and guessing which zero was the trunk would be inventing data,
 * so the answer is `invalid` and the value is refused whole.
 *
 * Italy is the reason this is gated on the trunk rather than written as "no NSN begins
 * with 0": Italian landlines genuinely keep their leading zero (`+39 06 …` is Rome), which
 * is exactly why Italy's row carries no `trunk` at all.
 */ function $412e1a8a99c19c1a$var$judge(nsn, country, allowLandline) {
    const digits = country.dial + nsn;
    const fail = (problem)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (country.trunk && country.trunk[0] === '0' && nsn[0] === '0') return fail('invalid');
    if (nsn.length < country.nsnMin || digits.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
    if (nsn.length > country.nsnMax || digits.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
    if (country.nsnPattern && !allowLandline && !country.nsnPattern.test(nsn)) return fail('notMobile');
    return {
        ok: true,
        e164: `+${digits}`,
        national: (country.trunk || '') + nsn,
        country: country,
        problem: null
    };
}
function $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options = {}) {
    const selected = $412e1a8a99c19c1a$var$resolveCountry(options.country);
    const allowLandline = options.allowLandline === true;
    const fail = (problem, country = selected)=>({
            ok: false,
            e164: '',
            national: '',
            country: country,
            problem: problem
        });
    if (typeof raw !== 'string') return fail('invalid');
    let s = $412e1a8a99c19c1a$var$stripSeparators($412e1a8a99c19c1a$export$522be3011864bb18(raw));
    if (s === '') return fail('required');
    if (!$412e1a8a99c19c1a$var$DIGITS_ONLY.test(s)) return fail('invalid');
    // ── The twins ──────────────────────────────────────────────────────────────────
    // `allowLandline` does not switch this off: a landline is not an Iranian mobile, so the
    // peel declines it and the catalog below is what accepts it.
    if (selected.iso2 === 'IR') {
        const nsn = $412e1a8a99c19c1a$var$peelIranianMobile(s);
        if (nsn !== null) // Iran's trunk is `0` and its row is fixed (see COUNTRIES): `0` + NSN is the
        // national spelling, `+98` + NSN the canonical one.
        return {
            ok: true,
            e164: `+98${nsn}`,
            national: `0${nsn}`,
            country: selected,
            problem: null
        };
    }
    // ── The generalisation ─────────────────────────────────────────────────────────
    let international = false;
    if (s[0] === '+') {
        s = s.slice(1);
        international = true;
    }
    if (s.startsWith('00')) {
        s = s.slice(2);
        international = true;
    }
    if (s === '') return fail('required');
    if (international && s[0] !== '0') {
        const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(s);
        if (country === undefined) {
            if (s.length < $412e1a8a99c19c1a$var$E164_MIN_DIGITS) return fail('tooShort');
            if (s.length > $412e1a8a99c19c1a$var$E164_MAX_DIGITS) return fail('tooLong');
            // Accepted, with no national form to offer and the picker left where it was.
            return {
                ok: true,
                e164: `+${s}`,
                national: '',
                country: selected,
                problem: null
            };
        }
        return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(s.slice(country.dial.length), country, allowLandline), country, allowLandline);
    }
    const candidate = s.startsWith(selected.dial) && s.length > selected.nsnMax ? s.slice(selected.dial.length) : s;
    return $412e1a8a99c19c1a$var$judge($412e1a8a99c19c1a$var$peelTrunk(candidate, selected, allowLandline), selected, allowLandline);
}
function $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).e164;
}
function $412e1a8a99c19c1a$export$f9c4d85d720ef909(raw, options) {
    return $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options) !== '';
}
function $412e1a8a99c19c1a$export$317852993b4735b6(raw, options) {
    return $412e1a8a99c19c1a$export$48c6adddc5539199(raw, options).national;
}
function $412e1a8a99c19c1a$export$1069b069fb83ae5b(raw, options) {
    if (typeof raw !== 'string') return '';
    const parsed = $412e1a8a99c19c1a$export$48c6adddc5539199(raw, {
        ...options,
        allowLandline: true
    });
    if (!parsed.ok) return raw;
    // A number from ANOTHER country is shown internationally (PM-0078). A national
    // spelling carries no country, so `07400123456` on a desk in Tehran is dialled as an
    // Iranian number; `+447400123456` cannot be. Compared by dial code, not row, because
    // `+1` resolves to Canada whichever of the two the caller called home.
    const home = $412e1a8a99c19c1a$var$resolveCountry(options?.country);
    if (parsed.country.dial !== home.dial || !parsed.national) return parsed.e164;
    return parsed.national;
}
function $412e1a8a99c19c1a$export$1f64b92865689d0d(raw) {
    if (typeof raw !== 'string') return '';
    if (raw.length < 7) return raw;
    return `${raw.slice(0, 5)}***${raw.slice(-3)}`;
}
function $412e1a8a99c19c1a$export$493e0fb9b5aae030(raw, options) {
    const e164 = $412e1a8a99c19c1a$export$e9b617754cf28d84(raw, options);
    if (e164 === '') return [];
    const digits = e164.slice(1);
    const country = $412e1a8a99c19c1a$export$21894a57509f6ed5(digits);
    // An accepted number from outside the catalog has no known plan, so there is no trunk
    // prefix to add and no national spelling to guess at. One shape — the only one we
    // could ever have written.
    if (!country) return [
        e164
    ];
    const nsn = digits.slice(country.dial.length);
    const seen = new Set([
        e164,
        digits,
        `00${digits}`,
        ...country.trunk ? [
            country.trunk + nsn
        ] : [],
        nsn
    ]);
    return [
        ...seen
    ];
}


// GENERATED by tools/build-flags.cjs from flag-icons 7.5.0 (MIT, lipis/flag-icons) — do not
// edit by hand. 40×30 PNG (2× the drawn 20×15), base64, one per row of COUNTRIES.
// prettier-ignore
const $b7cded1008753984$var$PNG = {
    IR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////aAAAjn0BcuHLjQEDnVVVuwIHrc3P+9PTvjo72+/f74uKHy5fzqqqU0aOk16+XZwNwAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAr0lEQVR42mNQwgIYBqGgsbFxMhCCgRkQggDDmWPJf8yepZ05lvYmLe9wXlrOmbQ8Bi4uLoYFCxZwcXVvAJFgDgMMcG+fsYEBHczdXn0TXYy7nL2gHF0p51X2gtgJaIK8VzgLfC+ga58+s7ISw6bbriF7MWznuCiLUMjBwcHQ0NDAwcG9AUSCOQwhLiEuri4uYMoVzHZ1YagsDZ0eOrUUTFWWxIaGTw+NZBDEAgahIAAf7Fwe+04+vAAAAABJRU5ErkJggg==',
    AF: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEW/AAAAAAEAmQCAEQCAAADdeHfRRUXLMDDVVlbFFhbhhYTZZWTvvrzppqXDDQ2BDgJ/AJzcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeUlEQVR42mMQBAMRBjAwUgIDhqEmyJlRXoAhOG1aexm6IFvf87oXCWiCMxL2nGbrRBNMrYs5+jwMTbAnO7x02wk0wdCdMamzQ9EEdzXEHuVYjSZYkXYrKq0dTZDr6vTKmAVogpytV3dFTED30ay7d1diBsgDviEXcQB/Wk8LWL2d8wAAAABJRU5ErkJggg==',
    DZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AYjPREDQTWzP87vG5GTP2z9bldopePTN6MjP++/zslaXeTmlERzPytsGQKjOhIQw3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mMQhAMGBBgcgsI39jmgCwpPUlJSd0ATNFXSTPErQxUUDlI1ZGBgc0ARlFQKFmTgcliAImik1CjowJ6Aqv2SkqHgniI0wSZVQcE1SqcdCAti1Y7VIqxOwup4rN7EHiBYg24QRTEAq40s8eFvTBUAAAAASUVORK5CYII=',
    AM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEXZABIAM6DyqACw8tlJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZAEAsY2oJKWMCQFgQAQLMn2UPulzIAAAAASUVORK5CYII=',
    AU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAIv/AgL//Pz/bGyNi8rd3fBUVLEYGJZzc780NKO2str+iIn/JSX/yMjvoaq2g62b1p0wAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA+klEQVR42mMwimTg2CjswDDvNAMC2FxqAAly2FxCEsyW1qrYKOy+5pAakiDnG6OQjcLrhFULkAQZWGwubRS+c8kBoqQTLKcEBBuFQSSIx6YEFhSEAxCPQzUBU5AhjQGLIASgmgkCIAM4dM9uFNY97AAT4wgtYGBf9GbLRuGlyqeA1k4AOxFo11TlcyAfLXrzjKE0AqzUhYEBqBHkdxbdwwypKjAjHm6DhNJUZQYOBwYcgBObYNIELIKVMAZ7ARZZjgZMsZRZkW4YglxKSgGYupWU4PphdrMvUlLSglrFFgUVZZ8WpJoJFWRRSoDpiVoKN2oJnLWAi4GaAACk7z96Qd+VoQAAAABJRU5ErkJggg==',
    AT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX////IEC5cagsYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYhrTg8APDLo4As4YakeJ1P9cAAAAASUVORK5CYII=',
    AZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEU/mzUAueTtKTk/nDXuM0P////sKjnxV2Pza3b4qK/2lJz1iZHyanX1ho/6wsb6wcaXspUqAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFJJREFUeNpjEMQCGIa0YJISBKjvLlKCAZigytM5vU7ognoxSkolTmiCpZOUlDpXoAluPaSksjTKiQhBrNr1sVmk8nUGppOU1PciOZ7ZGBMMaUEAYGdewLA+W8AAAAAASUVORK5CYII=',
    BH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAJ1BMVEXOESb////SJTjtp6/++Pn1z9T66evmiJLXPU7gaHXPFirQGC3icH2vW5DzAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAKUlEQVR42mMQFBSM2cCABoCCgukKWAQFnRuIFMSmPXIBFotGbR95tgMA4tMe9v5fIp8AAAAASUVORK5CYII=',
    BE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXbuwr5hhoAAAH/2QzzGDDlGv6LAAAAAnRSTlPHx/co26IAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAaSURBVHjaY1ACAwVjMBBxAQOGUcFRQVoKAgBG03Gtsi/apQAAAABJRU5ErkJggg==',
    BR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX45QkinkUrSaM+WaXa2RWbubxesjQ9pz20zhyJwChmfrhVaYXGvzGgoku93cV8h2YIpy45AAAACXBIWXMAAC4jAAAuIwF4pT92AAABA0lEQVR42mMQxAIYyBBMccMUlGBgaEcXFHNgYGBJRBUUb2AAAo5CFMEEBt7N1n8YOJEFKxh4jJSUlLZAjQULSjIwXAKKKSk7MEyECQIN5FECgw0MLIVQwQkMDKyhoYuBgroMYGOBgiVAe4+Ghr4LXaSkDWS6gQQlQY65paSkFffUSAnoWoZGQQaQqxkYPoFMXPpK6QADyA9wQS2g6LpgqCBE+yVjJeXFSspxIBXtIItSgIxTRkbKQHFTmEVgJ3ErKyktUlK2Bfof5ngHoOOBZhobb4CEFLI3FxkjeRMaIEbAAHFHDroUBt7d6EGHPZDB0QExEDniJLFEHPYoFhQsJCPZAACz20xO82VhQQAAAABJRU5ErkJggg==',
    CA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXqlY/pk4zplI3////VKx7qkYrjb2fYOCz++fj1y8n87u3zwL3uqqT54N7eVUvlfnalRQo6AAAAA3RSTlPEwsLgduwSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAi0lEQVR42mNwAQIHYzgQAfEZ6C9ouhiL4PJgTMHdIbXBGIJTXFyS0QU7lri4BDejCu49Zu7isvPVXBTBFJcwF5ftLr4ogkdcwKAYWdDiC0SwEpvKVyiC1iUg2q0Z1UnTQXQwmjttgJQf0PEqKIIx2+bEN6MJGhubNWMJJbPFxApagrWrDFAUQwDYdgDA65dwevVm0gAAAABJRU5ErkJggg==',
    CN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXuHCXvJiP//wD0ahj94AX5ow/xRh7vLSL8zAjzXhr+8AL4mxD5swzvIiTwMCL1ehZhA9qiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAZklEQVR42mNgwAMYsQluRRdgZmDg3foATVBKgIGBjx1N0MgASLAGoGh2WbTEmYGhNBBFYYaSSgJQP5o9SsqYruHx9wGSbAkogqIF0kDrKxqxuJ5zAoYQbyY2b3Y8wBIemQyjgBoAAEO/DOML4QfFAAAAAElFTkSuQmCC',
    CY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////UdgD07uT7+fXaiCHLzsK9wrPpuXzuyZqvtKLe4NjeljvlrGP027ydpI2Olnz/VpYUAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAn0lEQVR42mNgoAMwwBRiLlfAFCtpwFTYsheFq6HEwKC+URxVjaGgiKOgNJpmRUEgkEURuuK+ESQogWxnraMgBFxAEt0IEfLxOYwkWAgRRLXGBCwmg+oZDqCZItvRPch74giGn1mVGSzAzlBDEuR6CqVfIQvOnACmZ2Yh69dPA4mmxS9ACUe9sEnMU+OUUa1iWvY19OUqjPA1TTNgoDsAAH0MH3woys8hAAAAAElFTkSuQmCC',
    DK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAADFBMVEXIEC7////QM0zXUWbL25x8AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJ0lEQVR42mNgAANFQSEGDDDsBZXAwFBQWAkBGASxAEoFsVo0gkMeANYLEN9rIYw3AAAAAElFTkSuQmCC',
    EG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbt4LPm05f279n7+O/q2abz6cvv473gyH/SsUfizYnSsUjUtE7UtE+FUiyCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAUUlEQVR42mNQwgIYhrQgHHAGMGAANtaABAzB5ow2CwxB6+M1mzEEq9es2o4h6Lui6wqGoL+x8RMMQfcWjxIMwWTLydMwBFknGyNcL4gFDGlBAONAN6Idm2N7AAAAAElFTkSuQmCC',
    FI: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAHlBMVEUAL2z////n6/HZ4On19/n2+PrFz933+Prf5eze5OxGbJvuAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAM0lEQVR42mMQBIECBgYGZkE4YACTAUNUUAkEGoCCbEpwwDBUANi1E9AcD/aXAza/D1FBANf4HwFP43uLAAAAAElFTkSuQmCC',
    FR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAJH////hAA/1qq+qqtocVNyOAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGklEQVR42mNgAAMWQTAwUgIDhlHBUUFaCgIANE0qMRXTPuoAAAAASUVORK5CYII=',
    GE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAIVBMVEX/////AAD/xMT/6en/KCj/ODj/uLj/aGj/t7f/Nzf/Jye3ao04AAAACXBIWXMAAC4jAAAuIwF4pT92AAAATElEQVR42mNggAJGQUEBBnRAlCBTEUJQXQEqyCGGEGxMgIgxu4o6wwStJoYYYAiaBM4ywK0du0WUOF4QC6Cf4ACFvEkg1pAPoWfIAwBUiRrZ67e50QAAAABJRU5ErkJggg==',
    DE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUAAAH/zAD/AABTrXiPAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    GR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWXudzc5/N0otAvdLlkmMzO3u6JsNdomswWZLFHhMH///8NXq9elMpdk8mvyuWUuNy9t6ayAAAACnRSTlPHx8fH7fnw4O3tua1jCQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAFxJREFUeNpj2L1796lVu1EBA+mCEwURAC54axUCYBc8c+bMr1VAwoEBCcBkXyNbRLwg8bbjFWw2RgASAsTFxSU1FEgUKSEAwyosgATB3VgACYKCWAAJtmMFlDkJADpQb8rhqOSNAAAAAElFTkSuQmCC',
    HU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEU4jQDUNRb////UNhf//f0fKhQYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHUlEQVR42mMwxgIYBLGAISPoggUwKGEBQ0Zw2AEAn7AtKfgzYVIAAAAASUVORK5CYII=',
    IN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/////mTMSiAfj4/JjY7hlZbiUlM1bW7TW1uy3t93X1+yVlc1ubrzY2O1gYLVubrvbBsOsAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAQ0lEQVR42mMQxAIYhrQgXsDsGncBQ9DcanExhqDz7EwTDMGI/NOtmIJ7vmEKPp6WaYoheB2bRcwuLgb4Ha2EBQxpQQB5PzXw6CctoQAAAABJRU5ErkJggg==',
    ID: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXnABH///9GPYQdAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mNgGAXkAkEsYFSQGEEARNwT7a82wgIAAAAASUVORK5CYII=',
    IQ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8AAAHOESbe7uZsso/n8+2z2MYAej1bqYLO5tqEv6L0+ven0bwrkV5CnG8HfkLIbu0WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNQwgIYhrQg6YCH4QADp9kGVMFlDA0MYS6oglwHMhsYUlAEOaNmrOro5nniEoAkyPa/vLzuBW/5lQvItmQaG5uGshqbGpDqPkEsYEgLAgC7sTrOTPRwzAAAAABJRU5ErkJggg==',
    IT: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEXOKzf///8Akkaq28HvuLydaqNBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGUlEQVR42mNQAgNlQTBwYICAUcFRQVoKAgAHkC93JNeyBwAAAABJRU5ErkJggg==',
    JP: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///+8AC3z09u+BTH//v7+/P3WYX3BEjz22+HegpjsuMXUXXrtusb23uTeg5nBEz3t9p09AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAa0lEQVR42mNgoDdg1VoUgC7GkS4oWNaAKsYyWRAILB1QBL0FwWALiuBEiKAkshivIURQGNlUNkEoSEASjIcJliIJKsIEhZAED8IEpbAJyhDSjtUirE7C6niYN+UIBwgk6OwcCAcy9uigOQAAuKIYLYzUZfoAAAAASUVORK5CYII=',
    JO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX/AAAAAAH///8AmQD+AAD/QED/srLEAABNAAHEIwBNawD/Dw//6Oj/qKj/KytAcwA4JMd5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAe0lEQVR42n3Puw2AMAwE0GuokJBYgRWyACNQUTJHZqFhBQZiGHBCjH/iqtNTItvIow/mHCFyhF4JnRa0WtHoi1obKmWUii/r1IJIESn1vju1ln4t+i21IUJs0fdo0N9KYnk+c08cRmGM0hoqe1FbRWMFrRE6e9BbwuEt3d6mRppivxM/AAAAAElFTkSuQmCC',
    KZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAq8L/7C19y3mKz3EWsbVNv5VvyIE6uqAjtK1lxYcMrruZ02mz2Vqm1mHM4Err5zn1kEx1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA60lEQVR42mNgwArcvbAIqu3CInj2BhbBTbewCJ7GptJsC5Th4YAQnJwAoTuVNBtgYizWqWCaNT0yXBUmyGVpAabb4gTlIwugghw2EPmpDwUFv2vBlCZPAZuiKigoKJQB9xFYmkUTKCidDhPcfAVkzRKQSuGMpTDHHwESwQrTPwoKimslByAJxv1qihcUnFnwLgFJe18S6/Rs9Wmc5wqQLGIOn1CkllRQXuOA5CSuLa1d7V1LoyxQHO/MkJyerLCoAMWbXCUMng4s09EChIHTisE4AD3oOKL3bMcMZILRgTXisEYx1sSANdlgAQBsEkHVTQYmTgAAAABJRU5ErkJggg==',
    KW: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////zGDAAAAEA2UEAgidRCBEAQRQADgUAwzoVAgWkECABAQIFBQYICAngFizfFiwsWLaJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mPIMMYEDOrOWASV1JqxCCqVYBNUysAmiGEsSBDDWLAgurEQQTRjoYKoxkIFlTYwIAPqCB6gTPACRYKaCwWRAFQwThBTcJYgpqDqQ0xBVAOhgnGCmIKzBDEFVT9iCmIYCBKMxxQTBABu501a6aV2MQAAAABJRU5ErkJggg==',
    LB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX4sLTTr6WhrpH////uFh8CqVFNw4UotmvZ8+UWsF9jypSH1q05vHej4MDA6tTt+fModX5RAAAAA3RSTlPAyNIAJ7wgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAmUlEQVR42mNwwQIYBlYQDhgRTAZjGGivgDPhgvZTQ/MwBM1mVkZ+Rhd8vm169GU0wV9hx1Zlogv2LgsNrZnWjCrYFnpsaWjZZRRB2/CdoaWhYaiCFtdjQkOrV1agCPZEhq06Gpq2G0Vw28rQ0ND0qedQBL+t/REaamyxvRnV8dahoY/RvWmx6t1xeIjAAosJGHZC8KAbfFEMAFLInkrFWlo3AAAAAElFTkSuQmCC',
    LY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAAAHnABMjnkYQSiJ7AAoNDQ5BQUJsbG2jo6MkJCW3t7eWlpZ6AAri4uLt7e3///9apKbEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAARElEQVR42mMQxAIYBlbwiAsG8GGgFqgowxTjWsoQGYAuWBvAwLYzAU2wm4Eh498EYgSxasdqEVYnkQmMsQAGJSxgYAUBQNozH9QbWmcAAAAASUVORK5CYII=',
    MY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUBAWXMAADUJib////nh4fibm7wtrbcTk5qVTwrIlX429upBBbyu7v7yQGwjCDitAxVRiJQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAApUlEQVR42mNggANBOGAgILgKDkA8zglgQWM4AHI4/nVgan8/gYFz5gRUQY4bDAwzOjoZGFzggIGB/wMDw7y7L1HN5H3AwNl79wcDQzkcAFUCBfvv/piAYibfBQaGjv8dqCo57wEtm9mA5s5eoCUg55+BA5CH+jpIDBAUM7EI7oYDJO2CWABDGhaAZBKSmUpYAHYzQ7EA7Ga6YAHYzcRqO1YzsQkCAB2DeG8b518IAAAAAElFTkSuQmCC',
    MR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAYjPNKj5mRjn/xAAcbS2goBI9eSaHlhjouwR0jxsQaDDFrgv4wQFchSCwphAscyohwGQSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAjklEQVR42mMQxAIYKBRUwgIY8AO2BCyC7AWYYu4V7SWYupst0PSDuMXmICkkwQlAvPM2kOBEEgxhYOD6wL+AgcEVSbASxpiOJHhjAYTm6kUSXPMAQvOdQhJkNYXQwQFIgizN+0HUbwsHZIfmGL91YLlnfAzNP8ZAgO4nV5BgCLrfPaO3TmGgEsAacTRIIQCjVisn0uVIegAAAABJRU5ErkJggg==',
    MA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXBJy1mQi+uLS1uQDClLy5aRjAUWzIyUjEZWjKbMi57PC+NNy83UTF1Py8NXjNWRzBcvfykAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPklEQVR42mNgGL6AxQGLIKMAFkH2AgwhztAf/aET0EVXHLbpwrTn7T1Mm5jK0hUwBJmztxlgukiBSYBhZAEA3FMKXRTvT/sAAAAASUVORK5CYII=',
    NL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEUhRouuHCj///+QNKGcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mMQxAIYhrSgEhYwtAWHHQAA8cMn2RePrhMAAAAASUVORK5CYII=',
    NZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAJH3JES/++/wCImrklaPQMEnefo+PlbYcOoFpdKWBhKzYYnVCW5e3scfyxc3n4ukbs7NpAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwElEQVR42mPY9MPYylGs2PhICAMCbH00GSRolfoISXCKiC5QsOLqfk0kQYurm747il0J029GEjQ23/rIUezpo2JjJEElIHAUA5Fg7gEwKQgHIB5nVgMWwTAsKnlmYTMTarulfpyjmF4Y3HZ2kDsvPfV1FLuvHQt05wmQ4NIbDAzn1WK7gD665OrDwLkN5KDjExgY9KOLQX4314tm4IiGmenqAwml89oMHCcZBhhMwCLWuesApiCXNBaVnMsZBhwAAPtnOCIlvtmpAAAAAElFTkSuQmCC',
    NO: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAJmTtKTn7ys4fQHf///8EKWb+8vMDntwIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAPUlEQVR42mMQBAEhZwYTRUE4YBh+gkogoAYUTFKCAwYXMAAKuiAAgzEYmDIEGyMAA/EAq3asFmF10siIDgBIBDxNHFl+NQAAAABJRU5ErkJggg==',
    OM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXvLSn///8AkCX6ubjHPSjaNSjxQT397ez2gX/4nJrzYV/709LwOTX5sa/7yMf1dXKxEGopAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAVUlEQVR42mNgAIFEQRTAwLDgNxemYOf5xZiC7LfLMAR5i8t3b0AX5LIsP9GAob23sgGLRQxrD6ALcj5g4HiAoRIEDhujAIahD1hcUABEMEgJBQxpQQDyzjeG2etjuwAAAABJRU5ErkJggg==',
    PK: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUMWQv////J2sg2djUWYBVtm2yyy7FWjFYmayXe6d79/v1+p36dvJz3+veGrYZOh01DlvGiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeklEQVR42mMQBAIFBjQwiAXZGzAFWVIZGDjQBdkmMDBwhzagChY+YGBoE0NTqVjAwPDnpgGKIMtCoCDzBlTtzIIBQMscGNAEEzDdyXJxMRbHJ0o6YApaCU4GckpQBfkEpVK/bwpA8/teIH0VPUCYTwrOacAMOofBHJsAmkIgJ8nEUEMAAAAASUVORK5CYII=',
    PS: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXtLjgAljkAAAD////IMzOWVDiXHST82tzwT1fuNT/4q68qhDlfEhZfbDgqCAr0eoGf0o+MAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAeElEQVR42o3OsQ2AMAxEURcpKKDwCqzAJKyQFdiGLViJFViAxImQ8Z0QLp90X5Y840k6CcrIUDJDDBTEQEUIGMaAYQw0DIGOw7a46yg7Q7kY+sCDPvCNdH79fIk+v6q/ZpMipoPge9wwjA3j2DCOK8K4II4L4lj1BvDTQ+3mvvDBAAAAAElFTkSuQmCC',
    PL: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEXcFDz////vuDXSAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    QA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEWNGz3////z5ummTGfhw8ytWnPChZiTKEjRpLHZs76ZM1KzZ378+fratcD69fe7dovPfIyeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAANElEQVR42mMQBAGN7QwoACwoKOOKKSg0fwGm4GUGbNqfJBMpiFU7VouwOgmr40d9NJh9BABnYibF3uZjAAAAAABJRU5ErkJggg==',
    RU: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAACVBMVEX////VKx4AOaYLRJEfAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAF0lEQVR42mNgGHZACQsY2oKCWMCQFgQAJmgn2fxJGEkAAAAASUVORK5CYII=',
    SA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUWXTHD1so6dlCUtKC6z8KevKkqa0J6o4pXi2tKgV+JrZdumn+sxbbT4dhjk3Xo7ur50TcyAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAl0lEQVR42mNgGJyAc4Ym97Tq1ZrTlBQS4IJJzme0H04vtIhqiToAF1SWjepwPeIuveqJXQBckM+1OGlXh9M148rrCEH24v/iocqXgo1nxxrABdkqgqdFyV80X5xheAxhkWCwbqPNo2XLj9SZwQVniEQvdOrRm5LTtO8AFhez0SdgmFC5hoKCgrIivi4KmCq5SxUGaeQyAABIGCoBr6ooaAAAAABJRU5ErkJggg==',
    SG: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXfAAD////mMzPhDg772NjudXXpS0vkJibrX1/1qKjwh4fznJzjHBz3wMD85OT97OwLMeD+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAYklEQVR42mNgIAEwrUzAFNzoxKCALsYtf4DHFV1QUZSdIYkdTXChzNkABpUGVMGJAhwJDKxopm4UZjAAQlTQKMa8lekSmiCLCMMK5uloguwPJ2PxkdWTBAaygSAWMCpIjCAAWLQjMqdY6EMAAAAASUVORK5CYII=',
    ZA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX9/v3+uRUUgE/brRp1pKfd6emZbw1kkTMvIQTrf3j50s8AeEcAAAHhOS0ADIr////nnyzWAAAAC3RSTlPv/eDZxsnBwd7m4E+UGYYAAAAJcEhZcwAALiMAAC4jAXilP3YAAAClSURBVHjaY9i9e1P8r7uogGH37t1b+DkxBXer/l+LKbjb4cNcFEEjkCCasQyC1bsxjGVIFNbGMJbhhKE4hrEMZ44JYhjLcOZMM4axQMEzcGNhACQIN5YBBoCCMGPhACwIMxZVEGYsYUFs2rFZhNVJ2BwP9ybLOyhACpCv7+CCiKDzQwjCDYx7hxDEMBAkiGEgSBDDQJggioFQQVQDIYJoBr579w4AID2uWajS1fMAAAAASUVORK5CYII=',
    ES: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXxvwDOag2qFRvmsgu7YhjStSK1PBfbmQnNhg7UvW23VRPTp6e9oUDAc1fSwrl3SlO5GvFDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAbUlEQVR42mNQwgIYBlZQEAtgwAMMsAkGYxETcfPA1NzSIY4uxlws6DnTHF10ckbePk40MfaLOXn7ZNEcwLE95f/u6gI0wcte/5fZogkyP/ZyW8aHpp012OvWklB0waM2Mw/EBDAQAFiDbvBFMQDs8UAnWwjUdAAAAABJRU5ErkJggg==',
    SD: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmgAAAAH/////AAAAUwAWggBdYgD0BwDS7dKZ15koqijSGwCZPgAAGwH0+/Rdv10nNCULAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdUlEQVR42o3OsQ2AMAxEURekANF4BVZgAqbJHqzEJCyESJwIGd8J4fJJ92XJK56kg6DMDCUzxEBBDFSEgGEMGMZAwxDoOO2Lu44yMpSLoQ886APfSOfXz5fo85v6azYoYjoJvscNw9gwjg3juCKMC+K4II5Vb7xWROdp9YXoAAAAAElFTkSuQmCC',
    SE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX+ywAAUpP1seVEAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAG0lEQVR42mMQBAEBBgZGQQRgGCGCAwtGcMgDAE6xGxmZ2zxDAAAAAElFTkSuQmCC',
    CH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEX/////AAD/0ND/YGD/Tk7/9vbc5piHAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAOUlEQVR42mMQxAIYaCkoYmzsiCEoxMCgOECCTkpKqgwMQUpKKkiCBgxQwEw9QawWDazfcUUHrRMDALp+J5UUpHr1AAAAAElFTkSuQmCC',
    SY: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX///8Aej0AAADOESb31tnWM0X99vfbT1/RHTHniJPzwMb76OrvsbjqmKHTKDvfYnCfYG3WAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfUlEQVR42mMQxAIYhrQgTuAAIrg3gEgWuOAXEMF7AUT6w8TYOkEkewGInJEAEeOMswh3YDgabBrDwFLa/HQCRPSEcTXQsGBToNHbjXug2jOMQcYVm4MMNm6DCi71BBrH9uYc0Dj2KVFQwWVAyMCygRuoPQsIcQElLGBICwIAQ45Aa03Ys2UAAAAASUVORK5CYII=',
    TJ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEX////MAAAAZgDibW1uqG7//vv96aH/+ur+8sb74Hv97K3844X+9tf611L722f85I0rCMw5AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAdklEQVR42mMQxAIYBqGgMRbAAAc8BxgwwCrOCaswBNNYA9LQhFjbQWRFAKrgNYb67wy5qIIMoQzV24EECgBazdGA7gDOCQxsCSASxcyAzn2vZ7Cimdn7LGtZ3g10d9ZlT3uOLsZ+e0XX3gIYzwULYFDCAgahIADpxEPh9dNYsAAAAABJRU5ErkJggg==',
    TH: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAElBMVEWlGTEtKkr09fjV1t1LSWXo09kUPIcoAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAJUlEQVR42mNgoBcIxQIYlLAASgVdsAAGQSxgyAgaYwE0CTp6AQB3hDElR27URQAAAABJRU5ErkJggg==',
    TN: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXnABP////pDyH/9/jybXj0goz1l5/qHC3+7u/uSlf3qK7wXGj71tn84uTsMkL5vMHVD65hAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkUlEQVR42mNgGLyAfWt0AYbYQkFBKXTRFxIpbo330BQ2JrG7+ssqoAhyiTFsNhQ2TEARLGziFIwQFDRCEdyYwC/oGWIoiSIY6MB8tEBHUARd8FoBD5ogSLt3Cpr2wiY+wwx0i9ikGGYIShgGoDr+4nKmLf4yqI5neCu8NMrwOJrfmZIFBU0V0IOJaYqnwiCOWQCf5x5RzATURwAAAABJRU5ErkJggg==',
    TM: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAhD2qQDNyWTaIYzXPMTBLXTuCTTe2ZTHcWS+kcTiYZVlxu5Opg3sznWRtaEfT6t5XcMERAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA3klEQVR42mNgYGAutFpYzIAGmC0frXmELsi67lXWUnRBpjN5kUYMDHsZLiBrlzo1TQhIb+BGFixxcSkGqeRGUsosrpkoBBRj4N6AEGSLfPgyCKibgR9ZMDAxMQjEuI9sZubLyCQGBt7bf1EsEiwBWsS7F8VHhYKCmN4UCg0WQhdkU5ISUsImaIShXTg0EkM70HYRTIsqOjqKMARbw0Kb0AXZg+fNC8NQWRqIqZK5oh2LmVhtl6w5g+nNmWvWHMIQPLNm5SQMQa8zk50wBFtcXDCcxNbh4oEp6NLSgqodADs3OvJyxTvoAAAAAElFTkSuQmCC',
    TR: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXjChf////lFCDmISzoND/3ubz+8/TqSFL6zc/84+XxhIv1pKnuY2vzlZvvdHvsWGBydz1BAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAhElEQVR42mNgGFqgemLGYnQxVUHJXVcPoIoxNYo9YGDwQRXkFkwHSTmgCDoKPgBRCvbIggvFFEAUs6VREUIwUBRMMRdOe4AQbJQGUx6CogyYKg+KGWCYyeRpfgDZ9gUgysAF2XZeQXFMdzI1Ci5iYKhB87u2oFjsjg/oIeLbOfXRYI5GAK4SGZ7PHOUxAAAAAElFTkSuQmCC',
    UA: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAABlBMVEX/1wAAV7hKNkFnAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAFElEQVR42mMQxAIYRgWJERwF5AIAyagT7ZPvKigAAAAASUVORK5CYII=',
    AE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAFVBMVEUAAAH/AAAAcy/////AHAzAAAD/Pz+OQQvYAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAH0lEQVR42mMQBAMRJWTAMAwExYyRwXAQFGVAAUNZEADHSDmVngXCtwAAAABJRU5ErkJggg==',
    GB: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEXIEC7///8BIWnMIj387/Ht7/UTMXTZVmz0zdSgrMfqo6/L0uHigZEwSoVTaZp3iK/3wiHXAAAACXBIWXMAAC4jAAAuIwF4pT92AAABHklEQVR42r2SsUoDQRCGf1nh4EgzxIRAAsJCBAuPA5tgFxQOIU0KO5PiwMrmhCts5aqUB2Kd4DMINkIKfQHb1HmB4AM4M7uLV6R24GD2476f3dlFSceWa9gGDrvS/RQtmCd6acL7yqyQxtT5/oPJLR4JGTQgwOciGhO2aw3wUGSa4+w9bXGAgyyPqJ/DnmqAgyrvLKzdLjngTWC/AstWoAaQwIHKCl2AwLbKDMmXwNDvh+e+UsCEHv9WV74ueUuh379PPlUypdcDhRm+9Jj81TTAg/tzHV27gWzoqIhvBHaol44+BIpsFnc65JoDPmXINU1Q7vx1TGkZLXJsWIln4eJkdTGDynmAJxJQQuXGY+AAA5Ubz0YCoHLzgdWU/QIYAVlPDjvZVgAAAABJRU5ErkJggg==',
    US: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUZL13///+9PUQmOWTtyMrlsrTLaG3DT1bcmJw1SHBLXID14eKKla3Rxs9kc5Krs8T8og+qAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA7ElEQVR42m2QTWoCQRCFH/Sqm8kMXsETFDYkjPiz8QpewSvMFWbZMAlkZNBx6Q96AG8g4gUkkK0iOYPdppMeob63e9R7Vd0Q+BN12h5EdWKGNMcGh2CKbvqQLvX7yIPfUTv4g0XLY73I9Khy8Y+xB6pQOhZdMdXL0ImkfjF92uGIt8yDuBgUAz2zuoTO2HZGqLDFNZhuOw3JbX+deCBlqVIlS1maxou+k9rtueH0mXtcvGcqej5eqCK2h07FitZ7j4vbM+cu3vgQEiShnYL5FTj/x1sMyBnQZsCEge9kzYyBXzRm4DtHDHwnZ94BDlKd9LTrU4QAAAAASUVORK5CYII=',
    UZ: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAMFBMVEUAmbX///8etTr10NRkdDJSY3wVobsKnbglqMBQucw7scaR1OC24+un3ebe8faAzNvLtHwcAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAc0lEQVR42mNgwAFWzyhgYNvQzfUBSYzzOZBgn5DJsQBJkG8CFt2NCQwMtWwXerk2IAkWNjAwcLE3ZLA1IAnyfMCine0kw/EatgO9nMjaGbimJbCxJ5SxF8BFQrEABmMsgEEQCxiMglgd74IFMChhAUNFEAB4jUr4vpG2xQAAAABJRU5ErkJggg==',
    YE: 'iVBORw0KGgoAAAANSUhEUgAAACgAAAAeBAMAAACs80HuAAAAD1BMVEUAAAHxBgD///8pKSrzLimF/Ry1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAHklEQVR42mMQxAIYhoqgCxbAoIQFDG1BYyyAYSgDAMCBL9EnDpIBAAAAAElFTkSuQmCC'
};
function $b7cded1008753984$export$a2b8715397522463(iso2) {
    const b64 = typeof iso2 === 'string' ? $b7cded1008753984$var$PNG[iso2.toUpperCase()] : undefined;
    return b64 ? `data:image/png;base64,${b64}` : undefined;
}



// ─────────────────────────────────────────────────────────────────────────────
// The words the kit's components say when the caller did not pass their own.
//
// Rule 7 used to end at "copy arrives as props, with Persian defaults", and in
// practice no app passed all of it: an English clinic desk read «قبلی / بعدی»
// under every paged table, «ذخیره شد» on every save bar and «کد ملی وارد شده
// معتبر نیست» under a field labelled "National ID" — and a few components
// (the date-range filter, the save bar's confirmation, the national-id and
// number checks) had no prop to pass at all. The date picker moved to the page
// language in v0.19.0; this table does the same for everything else.
//
// A prop still wins. When it is absent, the default comes from here, keyed by the
// base language of `<html lang>` (or the component's own `locale` prop) — the
// channel `MoneyInput`, `PhoneInput` and the date picker already read; a region
// tag reads its base language (`fr-CA` → `fr`). Persian, English, Arabic,
// French and German each carry every word, and the test holds them to one shape, so no
// language falls through to another word by word. Adding a language is adding a
// complete entry; an unknown one reads the brand's default language, else
// Persian, as `documentLocale` falls back.
//
// Digits inside a default sentence are the caller's: a count passed in is
// rendered as given, so an app that localises its numerals keeps doing so. Nor is
// there a plural lookup — a count arrives as a finished string — so each
// language words a count to read right for any number (French «rendez-vous»
// is invariable; German reads it as a label, «Termine: 3»).
// ─────────────────────────────────────────────────────────────────────────────


const $df1b34b618a72512$export$6bdac007b5b42036 = {
    fa: {
        pager: {
            prev: "\u0642\u0628\u0644\u06CC",
            next: "\u0628\u0639\u062F\u06CC",
            page: (current, pages)=>`\u{635}\u{641}\u{62D}\u{647} ${current} \u{627}\u{632} ${pages}`
        },
        saveBar: {
            save: "\u0630\u062E\u06CC\u0631\u0647 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A",
            cancel: "\u0644\u063A\u0648",
            saved: "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F"
        },
        search: {
            placeholder: "\u062C\u0633\u062A\u062C\u0648...",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062C\u0633\u062A\u062C\u0648"
        },
        select: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F..."
        },
        confirm: {
            confirm: "\u062A\u0623\u06CC\u06CC\u062F",
            cancel: "\u0627\u0646\u0635\u0631\u0627\u0641"
        },
        errorState: {
            title: "\u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC",
        close: "\u0628\u0633\u062A\u0646",
        back: "\u0628\u0627\u0632\u06AF\u0634\u062A",
        slotGrid: {
            label: "\u0633\u0627\u0639\u062A\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0632\u0645\u0627\u0646\u200C\u0647\u0627\u06CC \u0622\u0632\u0627\u062F"
        },
        phone: {
            label: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644",
            country: "\u06A9\u0634\u0648\u0631",
            countrySearch: "\u062C\u0633\u062A\u062C\u0648\u06CC \u06A9\u0634\u0648\u0631 \u06CC\u0627 \u06A9\u062F",
            countryNoMatch: "\u06A9\u0634\u0648\u0631\u06CC \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
            required: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            tooShort: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{6A9}\u{648}\u{62A}\u{627}\u{647} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${ctx.countryName} \u{628}\u{644}\u{646}\u{62F} \u{627}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{627}\u{6CC}\u{646} \u{634}\u{645}\u{627}\u{631}\u{647} \u{645}\u{648}\u{628}\u{627}\u{6CC}\u{644} \u{646}\u{6CC}\u{633}\u{62A} \u{2014} \u{646}\u{645}\u{648}\u{646}\u{647}: ${ctx.example}`,
            invalid: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        dateRange: {
            title: "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
            custom: "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
            from: "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
            to: "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
            needBoth: "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
        },
        connectivity: {
            offline: "\u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0642\u0637\u0639 \u0627\u0633\u062A \u2014 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F",
            degraded: "\u0627\u0631\u062A\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u06CC\u0633\u062A \u2014 \u062F\u0631 \u062D\u0627\u0644 \u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            restored: "\u0627\u062A\u0635\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0631\u0642\u0631\u0627\u0631 \u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            busy: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026"
        },
        nationalId: {
            label: "\u06A9\u062F \u0645\u0644\u06CC",
            // A country with no rule of its own (see lib/nationalId.js).
            genericLabel: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0634\u0646\u0627\u0633\u0627\u06CC\u06CC \u0645\u0644\u06CC",
            country: "\u06A9\u0634\u0648\u0631 \u0635\u0627\u062F\u0631\u06A9\u0646\u0646\u062F\u0647",
            // `n` arrives already in the digits of the language on screen.
            placeholder: (n)=>`${n} \u{631}\u{642}\u{645}`,
            required: "\u06A9\u062F \u0645\u0644\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
            incomplete: (n)=>`\u{6A9}\u{62F} \u{645}\u{644}\u{6CC} \u{628}\u{627}\u{6CC}\u{62F} ${n} \u{631}\u{642}\u{645} \u{628}\u{627}\u{634}\u{62F}`,
            tooShort: (n)=>`\u{62F}\u{633}\u{62A}\u{200C}\u{6A9}\u{645} ${n} \u{646}\u{648}\u{6CC}\u{633}\u{647} \u{648}\u{627}\u{631}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}`,
            invalid: "\u06A9\u062F \u0645\u0644\u06CC \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A",
            valid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            notValid: "\u06A9\u062F \u0645\u0644\u06CC \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A"
        },
        dayContext: {
            prevDay: "\u0631\u0648\u0632 \u0642\u0628\u0644",
            nextDay: "\u0631\u0648\u0632 \u0628\u0639\u062F",
            today: "\u0627\u0645\u0631\u0648\u0632",
            backToToday: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            pickDay: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632"
        },
        weekPicker: {
            title: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0631\u0648\u0632",
            thisWeek: "\u0627\u06CC\u0646 \u0647\u0641\u062A\u0647",
            nextWeek: "\u0647\u0641\u062A\u0647\u0654 \u0628\u0639\u062F",
            prevWeek: "\u0647\u0641\u062A\u0647\u0654 \u0642\u0628\u0644",
            fullCalendar: "\u062A\u0642\u0648\u06CC\u0645 \u06A9\u0627\u0645\u0644",
            backToWeek: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0647\u0641\u062A\u0647",
            today: "\u0627\u0645\u0631\u0648\u0632",
            close: "\u0628\u0633\u062A\u0646",
            range: (from, to)=>`${from} \u{62A}\u{627} ${to}`,
            countAria: (n)=>`${n} \u{646}\u{648}\u{628}\u{62A}`
        },
        walkIn: {
            suggested: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F",
            or: "\u06CC\u0627"
        },
        mobileHeader: {
            greeting: "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F\u060C",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0632 \u0646\u0634\u062F",
            body: "\u0647\u0646\u06AF\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634 \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F.",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F"
        },
        number: {
            invalid: "\u0645\u0642\u062F\u0627\u0631 \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0635\u062D\u06CC\u062D \u0646\u06CC\u0633\u062A",
            min: (n)=>`\u{62D}\u{62F}\u{627}\u{642}\u{644} ${n}`,
            max: (n)=>`\u{62D}\u{62F}\u{627}\u{6A9}\u{62B}\u{631} ${n}`
        },
        account: {
            topUp: "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631",
            menu: "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC"
        },
        bottomNav: {
            label: "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC"
        },
        files: {
            phases: {
                queued: "\u062F\u0631 \u0635\u0641",
                preparing: "\u0622\u0645\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC",
                sending: "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0631\u0633\u0627\u0644\u2026",
                done: "\u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
                failed: "\u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            replace: "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u06CC",
            drop: "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
            pick: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0641\u0627\u06CC\u0644",
            camera: "\u0639\u06A9\u0633 \u06AF\u0631\u0641\u062A\u0646",
            directory: "\u0627\u0646\u062A\u062E\u0627\u0628 \u067E\u0648\u0634\u0647",
            dragging: "\u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F"
        },
        imageStack: {
            frame: (i, n)=>`\u{62A}\u{635}\u{648}\u{6CC}\u{631} ${i} \u{627}\u{632} ${n}`,
            prev: "\u062A\u0635\u0648\u06CC\u0631 \u0642\u0628\u0644\u06CC",
            next: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0639\u062F\u06CC",
            slider: "\u062C\u0627\u0628\u0647\u200C\u062C\u0627\u06CC\u06CC \u0628\u06CC\u0646 \u062A\u0635\u0627\u0648\u06CC\u0631",
            zoomIn: "\u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC",
            zoomOut: "\u06A9\u0648\u0686\u06A9\u200C\u0646\u0645\u0627\u06CC\u06CC",
            reset: "\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC \u0646\u0645\u0627",
            series: "\u0633\u0631\u06CC\u200C\u0647\u0627",
            presets: "\u062A\u0646\u0638\u06CC\u0645 \u0646\u0645\u0627\u06CC\u0634",
            viewport: "\u0646\u0645\u0627\u06CC \u062A\u0635\u0648\u06CC\u0631",
            loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u062A\u0635\u0648\u06CC\u0631",
            error: "\u062A\u0635\u0648\u06CC\u0631 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
            retry: "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
            empty: "\u062A\u0635\u0648\u06CC\u0631\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A"
        },
        prizeWheel: {
            label: "\u06AF\u0631\u062F\u0648\u0646\u0647\u0654 \u0634\u0627\u0646\u0633"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    },
    en: {
        pager: {
            prev: 'Previous',
            next: 'Next',
            page: (current, pages)=>`Page ${current} of ${pages}`
        },
        saveBar: {
            save: 'Save changes',
            cancel: 'Cancel',
            saved: 'Saved'
        },
        search: {
            placeholder: "Search\u2026",
            clear: 'Clear search'
        },
        select: {
            placeholder: "Choose\u2026"
        },
        confirm: {
            confirm: 'Confirm',
            cancel: 'Cancel'
        },
        errorState: {
            title: 'Not available',
            retry: 'Try again'
        },
        loading: 'Loading',
        close: 'Close',
        back: 'Back',
        slotGrid: {
            label: 'Free times',
            loading: 'Loading free times'
        },
        phone: {
            label: 'Mobile number',
            country: 'Country',
            countrySearch: 'Search country or code',
            countryNoMatch: 'No country found',
            required: 'Enter a mobile number',
            tooShort: (ctx)=>`This ${ctx.countryName} number is too short \u{2014} e.g. ${ctx.example}`,
            tooLong: (ctx)=>`This ${ctx.countryName} number is too long \u{2014} e.g. ${ctx.example}`,
            notMobile: (ctx)=>`That is not a mobile number \u{2014} e.g. ${ctx.example}`,
            invalid: 'That is not a valid number'
        },
        dateRange: {
            title: 'Date range',
            custom: 'Custom range',
            from: 'From',
            to: 'To',
            needBoth: 'Pick both dates to apply'
        },
        connectivity: {
            offline: "You are offline \u2014 changes are not being saved",
            degraded: "Cannot reach the server \u2014 retrying",
            restored: 'Connection restored',
            retry: 'Try again',
            busy: "Checking\u2026"
        },
        nationalId: {
            label: 'National ID',
            genericLabel: 'National ID number',
            country: 'Issuing country',
            placeholder: (n)=>`${n} digits`,
            required: 'Enter the national ID',
            incomplete: (n)=>`A national ID has ${n} digits`,
            tooShort: (n)=>`Enter at least ${n} characters`,
            invalid: 'That national ID is not valid',
            valid: 'National ID is valid',
            notValid: 'National ID is not valid'
        },
        dayContext: {
            prevDay: 'Previous day',
            nextDay: 'Next day',
            today: 'Today',
            backToToday: 'Back to today',
            pickDay: 'Pick a day'
        },
        weekPicker: {
            title: 'Pick a day',
            thisWeek: 'This week',
            nextWeek: 'Next week',
            prevWeek: 'Last week',
            fullCalendar: 'Full calendar',
            backToWeek: 'Back to the week',
            today: 'Today',
            close: 'Close',
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} appointments`
        },
        walkIn: {
            suggested: 'Suggested',
            or: 'or'
        },
        mobileHeader: {
            greeting: 'Welcome,',
            clear: 'Clear',
            unknownInitial: '?'
        },
        errorBoundary: {
            title: 'This page did not open',
            body: 'Something went wrong while showing this page.',
            retry: 'Try again'
        },
        number: {
            invalid: 'That is not a valid number',
            min: (n)=>`At least ${n}`,
            max: (n)=>`At most ${n}`
        },
        account: {
            topUp: 'Top up credit',
            menu: 'Account'
        },
        bottomNav: {
            label: 'Main navigation'
        },
        files: {
            phases: {
                queued: 'Queued',
                preparing: 'Preparing',
                sending: "Uploading\u2026",
                done: 'Uploaded',
                failed: 'Not uploaded'
            },
            remove: 'Remove',
            retry: 'Try again',
            replace: 'Replace',
            drop: 'Drop files here or choose them',
            pick: 'Choose files',
            camera: 'Take a photo',
            directory: 'Choose a folder',
            dragging: 'Drop them'
        },
        imageStack: {
            frame: (i, n)=>`Image ${i} of ${n}`,
            prev: 'Previous image',
            next: 'Next image',
            slider: 'Move between images',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out',
            reset: 'Reset view',
            series: 'Series',
            presets: 'Display settings',
            viewport: 'Image view',
            loading: 'Loading image',
            error: 'The image did not load',
            retry: 'Try again',
            empty: 'No image to show'
        },
        prizeWheel: {
            label: 'Prize wheel'
        },
        toman: 'toman'
    },
    ar: {
        pager: {
            prev: "\u0627\u0644\u0633\u0627\u0628\u0642",
            next: "\u0627\u0644\u062A\u0627\u0644\u064A",
            page: (current, pages)=>`\u{627}\u{644}\u{635}\u{641}\u{62D}\u{629} ${current} \u{645}\u{646} ${pages}`
        },
        saveBar: {
            save: "\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            cancel: "\u0625\u0644\u063A\u0627\u0621",
            saved: "\u062A\u0645 \u0627\u0644\u062D\u0641\u0638"
        },
        search: {
            placeholder: "\u0628\u062D\u062B...",
            clear: "\u0645\u0633\u062D \u0627\u0644\u0628\u062D\u062B"
        },
        select: {
            placeholder: "\u0627\u062E\u062A\u0631..."
        },
        confirm: {
            confirm: "\u062A\u0623\u0643\u064A\u062F",
            cancel: "\u0625\u0644\u063A\u0627\u0621"
        },
        errorState: {
            title: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        loading: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644",
        close: "\u0625\u063A\u0644\u0627\u0642",
        back: "\u0631\u062C\u0648\u0639",
        slotGrid: {
            label: "\u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0623\u0648\u0642\u0627\u062A \u0627\u0644\u0645\u062A\u0627\u062D\u0629"
        },
        phone: {
            label: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            country: "\u0627\u0644\u062F\u0648\u0644\u0629",
            countrySearch: "\u0627\u0628\u062D\u062B \u0639\u0646 \u062F\u0648\u0644\u0629 \u0623\u0648 \u0631\u0645\u0632",
            countryNoMatch: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u062F\u0648\u0644\u0629",
            required: "\u0623\u062F\u062E\u0644 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644",
            tooShort: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{642}\u{635}\u{64A}\u{631} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            tooLong: (ctx)=>`\u{631}\u{642}\u{645} ${ctx.countryName} \u{637}\u{648}\u{64A}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            notMobile: (ctx)=>`\u{647}\u{630}\u{627} \u{644}\u{64A}\u{633} \u{631}\u{642}\u{645} \u{62C}\u{648}\u{627}\u{644} \u{2014} \u{645}\u{62B}\u{627}\u{644}: ${ctx.example}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        dateRange: {
            title: "\u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0632\u0645\u0646\u064A\u0629",
            custom: "\u0641\u062A\u0631\u0629 \u0645\u062E\u0635\u0635\u0629",
            from: "\u0645\u0646 \u062A\u0627\u0631\u064A\u062E",
            to: "\u0625\u0644\u0649 \u062A\u0627\u0631\u064A\u062E",
            needBoth: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u064A\u0646 \u0644\u062A\u0637\u0628\u064A\u0642 \u0627\u0644\u0641\u062A\u0631\u0629"
        },
        connectivity: {
            offline: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A \u2014 \u0644\u0627 \u062A\u064F\u062D\u0641\u0638 \u0627\u0644\u062A\u063A\u064A\u064A\u0631\u0627\u062A",
            degraded: "\u062A\u0639\u0630\u0651\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062E\u0627\u062F\u0645 \u2014 \u062C\u0627\u0631\u064D \u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            restored: "\u0639\u0627\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            busy: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0642\u0642\u2026"
        },
        nationalId: {
            label: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            genericLabel: "\u0631\u0642\u0645 \u0627\u0644\u0647\u0648\u064A\u0629 \u0627\u0644\u0648\u0637\u0646\u064A\u0629",
            country: "\u0628\u0644\u062F \u0627\u0644\u0625\u0635\u062F\u0627\u0631",
            placeholder: (n)=>`${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            required: "\u0623\u062F\u062E\u0644 \u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
            incomplete: (n)=>`\u{627}\u{644}\u{631}\u{642}\u{645} \u{627}\u{644}\u{648}\u{637}\u{646}\u{64A} \u{64A}\u{62A}\u{643}\u{648}\u{651}\u{646} \u{645}\u{646} ${n} \u{623}\u{631}\u{642}\u{627}\u{645}`,
            tooShort: (n)=>`\u{623}\u{62F}\u{62E}\u{644} ${n} \u{623}\u{62D}\u{631}\u{641} \u{639}\u{644}\u{649} \u{627}\u{644}\u{623}\u{642}\u{644}`,
            invalid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            valid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u0635\u0627\u0644\u062D",
            notValid: "\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0648\u0637\u0646\u064A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D"
        },
        dayContext: {
            prevDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0633\u0627\u0628\u0642",
            nextDay: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u062A\u0627\u0644\u064A",
            today: "\u0627\u0644\u064A\u0648\u0645",
            backToToday: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            pickDay: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645"
        },
        weekPicker: {
            title: "\u0627\u062E\u062A\u064A\u0627\u0631 \u064A\u0648\u0645",
            thisWeek: "\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            nextWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0642\u0627\u062F\u0645",
            prevWeek: "\u0627\u0644\u0623\u0633\u0628\u0648\u0639 \u0627\u0644\u0645\u0627\u0636\u064A",
            fullCalendar: "\u0627\u0644\u062A\u0642\u0648\u064A\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
            backToWeek: "\u0627\u0644\u0639\u0648\u062F\u0629 \u0625\u0644\u0649 \u0627\u0644\u0623\u0633\u0628\u0648\u0639",
            today: "\u0627\u0644\u064A\u0648\u0645",
            close: "\u0625\u063A\u0644\u0627\u0642",
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} \u{645}\u{648}\u{627}\u{639}\u{64A}\u{62F}`
        },
        walkIn: {
            suggested: "\u0645\u0642\u062A\u0631\u062D",
            or: "\u0623\u0648"
        },
        mobileHeader: {
            greeting: "\u0623\u0647\u0644\u0627\u064B\u060C",
            clear: "\u0645\u0633\u062D",
            unknownInitial: "\u061F"
        },
        errorBoundary: {
            title: "\u062A\u0639\u0630\u0651\u0631 \u0641\u062A\u062D \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629",
            body: "\u062D\u062F\u062B \u062E\u0637\u0623 \u0623\u062B\u0646\u0627\u0621 \u0639\u0631\u0636 \u0647\u0630\u0647 \u0627\u0644\u0635\u0641\u062D\u0629.",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
        },
        number: {
            invalid: "\u0627\u0644\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u064F\u062F\u062E\u064E\u0644\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
            min: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{62F}\u{646}\u{649} ${n}`,
            max: (n)=>`\u{627}\u{644}\u{62D}\u{62F} \u{627}\u{644}\u{623}\u{642}\u{635}\u{649} ${n}`
        },
        account: {
            topUp: "\u0634\u062D\u0646 \u0627\u0644\u0631\u0635\u064A\u062F",
            menu: "\u0627\u0644\u062D\u0633\u0627\u0628"
        },
        bottomNav: {
            label: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0627\u0644\u0631\u0626\u064A\u0633\u064A"
        },
        files: {
            phases: {
                queued: "\u0641\u064A \u0627\u0644\u0627\u0646\u062A\u0638\u0627\u0631",
                preparing: "\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0636\u064A\u0631",
                sending: "\u062C\u0627\u0631\u064D \u0627\u0644\u0625\u0631\u0633\u0627\u0644\u2026",
                done: "\u062A\u0645 \u0627\u0644\u0625\u0631\u0633\u0627\u0644",
                failed: "\u0644\u0645 \u064A\u064F\u0631\u0633\u0644"
            },
            remove: "\u062D\u0630\u0641",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            replace: "\u0627\u0633\u062A\u0628\u062F\u0627\u0644",
            drop: "\u0623\u0641\u0644\u062A \u0627\u0644\u0645\u0644\u0641\u0627\u062A \u0647\u0646\u0627 \u0623\u0648 \u0627\u062E\u062A\u0631\u0647\u0627",
            pick: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u0644\u0641",
            camera: "\u0627\u0644\u062A\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
            directory: "\u0627\u062E\u062A\u064A\u0627\u0631 \u0645\u062C\u0644\u062F",
            dragging: "\u0623\u0641\u0644\u062A\u0647\u0627 \u0647\u0646\u0627"
        },
        imageStack: {
            frame: (i, n)=>`\u{627}\u{644}\u{635}\u{648}\u{631}\u{629} ${i} \u{645}\u{646} ${n}`,
            prev: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
            next: "\u0627\u0644\u0635\u0648\u0631\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
            slider: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0628\u064A\u0646 \u0627\u0644\u0635\u0648\u0631",
            zoomIn: "\u062A\u0643\u0628\u064A\u0631",
            zoomOut: "\u062A\u0635\u063A\u064A\u0631",
            reset: "\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u0639\u0631\u0636",
            series: "\u0627\u0644\u0633\u0644\u0627\u0633\u0644",
            presets: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0639\u0631\u0636",
            viewport: "\u0639\u0631\u0636 \u0627\u0644\u0635\u0648\u0631\u0629",
            loading: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            error: "\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629",
            retry: "\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
            empty: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0635\u0648\u0631\u0629 \u0644\u0644\u0639\u0631\u0636"
        },
        prizeWheel: {
            label: "\u0639\u062C\u0644\u0629 \u0627\u0644\u062D\u0638"
        },
        toman: "\u062A\u0648\u0645\u0627\u0646"
    },
    // French (PM-0185): formal «vous», U+00A0 before ':', U+202F before ; ! ?,
    // the typographic apostrophe and a one-character ellipsis.
    fr: {
        pager: {
            prev: "Pr\xe9c\xe9dent",
            next: 'Suivant',
            page: (current, pages)=>`Page ${current} sur ${pages}`
        },
        saveBar: {
            save: 'Enregistrer les modifications',
            cancel: 'Annuler',
            saved: "Modifications enregistr\xe9es"
        },
        search: {
            placeholder: "Rechercher\u2026",
            clear: 'Effacer la recherche'
        },
        select: {
            placeholder: "Choisir\u2026"
        },
        confirm: {
            confirm: 'Confirmer',
            cancel: 'Annuler'
        },
        errorState: {
            title: 'Indisponible',
            retry: "R\xe9essayer"
        },
        loading: 'Chargement',
        close: 'Fermer',
        back: 'Retour',
        slotGrid: {
            label: "Cr\xe9neaux libres",
            loading: "Chargement des cr\xe9neaux libres"
        },
        phone: {
            label: "N\xb0 de portable",
            country: 'Pays',
            countrySearch: 'Rechercher un pays ou un indicatif',
            countryNoMatch: "Aucun pays trouv\xe9",
            required: "Saisissez un num\xe9ro de portable",
            // A French country name takes an article («l’Iran», «les Émirats»)
            // that a name passed in cannot carry, so it leads the message as a label.
            tooShort: (ctx)=>`${ctx.countryName}\xa0: num\xe9ro trop court \u{2014} ex.\xa0: ${ctx.example}`,
            tooLong: (ctx)=>`${ctx.countryName}\xa0: num\xe9ro trop long \u{2014} ex.\xa0: ${ctx.example}`,
            notMobile: (ctx)=>`Ce n\u{2019}est pas un num\xe9ro de portable \u{2014} ex.\xa0: ${ctx.example}`,
            invalid: "Ce num\xe9ro n\u2019est pas valide"
        },
        dateRange: {
            title: "P\xe9riode",
            custom: "P\xe9riode personnalis\xe9e",
            from: 'Du',
            to: 'Au',
            needBoth: "Choisissez les deux dates pour appliquer la p\xe9riode"
        },
        connectivity: {
            offline: "Vous \xeates hors ligne \u2014 les modifications ne sont pas enregistr\xe9es",
            degraded: "Impossible de joindre le serveur \u2014 nouvelle tentative en cours",
            restored: "Connexion r\xe9tablie",
            retry: "R\xe9essayer",
            busy: "V\xe9rification\u2026"
        },
        nationalId: {
            label: "Num\xe9ro national",
            genericLabel: "Num\xe9ro d\u2019identification national",
            country: "Pays de d\xe9livrance",
            // `n` is never below 5, so the noun after it is always plural.
            placeholder: (n)=>`${n} chiffres`,
            required: "Saisissez le num\xe9ro national",
            incomplete: (n)=>`Le num\xe9ro national doit comporter ${n} chiffres`,
            tooShort: (n)=>`Saisissez au moins ${n} caract\xe8res`,
            invalid: "Ce num\xe9ro national n\u2019est pas valide",
            valid: "Num\xe9ro national valide",
            notValid: "Num\xe9ro national non valide"
        },
        dayContext: {
            prevDay: "Jour pr\xe9c\xe9dent",
            nextDay: 'Jour suivant',
            today: "Aujourd\u2019hui",
            backToToday: "Revenir \xe0 aujourd\u2019hui",
            pickDay: 'Choisir un jour'
        },
        weekPicker: {
            title: 'Choisir un jour',
            thisWeek: 'Cette semaine',
            nextWeek: 'Semaine prochaine',
            prevWeek: "Semaine derni\xe8re",
            fullCalendar: 'Calendrier complet',
            backToWeek: "Revenir \xe0 la semaine",
            today: "Aujourd\u2019hui",
            close: 'Fermer',
            range: (from, to)=>`${from} \u{2013} ${to}`,
            countAria: (n)=>`${n} rendez-vous`
        },
        walkIn: {
            suggested: "Sugg\xe9r\xe9",
            or: 'ou'
        },
        mobileHeader: {
            greeting: 'Bienvenue,',
            clear: 'Effacer',
            unknownInitial: '?'
        },
        errorBoundary: {
            title: "Impossible d\u2019ouvrir cette page",
            body: "Une erreur s\u2019est produite lors de l\u2019affichage de cette page.",
            retry: "R\xe9essayer"
        },
        number: {
            invalid: "Ce n\u2019est pas un nombre valide",
            min: (n)=>`Minimum\xa0: ${n}`,
            max: (n)=>`Maximum\xa0: ${n}`
        },
        account: {
            topUp: "Recharger le cr\xe9dit",
            menu: 'Compte'
        },
        bottomNav: {
            label: 'Navigation principale'
        },
        files: {
            phases: {
                queued: "En file d\u2019attente",
                preparing: "Pr\xe9paration",
                sending: "Import\u2026",
                done: "Import\xe9",
                failed: "\xc9chec de l\u2019import"
            },
            remove: 'Retirer',
            retry: "R\xe9essayer",
            replace: 'Remplacer',
            drop: "D\xe9posez les fichiers ici ou choisissez-les",
            pick: 'Choisir des fichiers',
            camera: 'Prendre une photo',
            directory: 'Choisir un dossier',
            dragging: "D\xe9posez-les ici"
        },
        imageStack: {
            frame: (i, n)=>`Image ${i} sur ${n}`,
            prev: "Image pr\xe9c\xe9dente",
            next: 'Image suivante',
            slider: 'Naviguer entre les images',
            zoomIn: 'Zoom avant',
            zoomOut: "Zoom arri\xe8re",
            reset: "R\xe9initialiser la vue",
            series: "S\xe9ries",
            presets: "Param\xe8tres d\u2019affichage",
            viewport: "Vue de l\u2019image",
            loading: "Chargement de l\u2019image",
            error: "Impossible de charger l\u2019image",
            retry: "R\xe9essayer",
            empty: "Aucune image \xe0 afficher"
        },
        prizeWheel: {
            label: 'Roue de la chance'
        },
        toman: 'toman'
    },
    // German (PM-0212): formal «Sie», infinitive buttons, no space of any kind
    // before : ; ! ?, „…“ quotes, a one-character ellipsis and the en dash with a
    // space either side. Counts arrive pre-localised and German has no
    // count-neutral noun, so a count reads as a label («Termine: 3»).
    de: {
        pager: {
            prev: "Zur\xfcck",
            next: 'Weiter',
            page: (current, pages)=>`Seite ${current} von ${pages}`
        },
        saveBar: {
            save: "\xc4nderungen speichern",
            cancel: 'Abbrechen',
            saved: 'Gespeichert'
        },
        search: {
            placeholder: "Suchen\u2026",
            clear: "Suche l\xf6schen"
        },
        select: {
            placeholder: "Ausw\xe4hlen\u2026"
        },
        confirm: {
            confirm: "Best\xe4tigen",
            cancel: 'Abbrechen'
        },
        errorState: {
            title: "Nicht verf\xfcgbar",
            retry: 'Erneut versuchen'
        },
        loading: 'Wird geladen',
        close: "Schlie\xdfen",
        back: "Zur\xfcck",
        slotGrid: {
            label: 'Freie Termine',
            loading: 'Freie Termine werden geladen'
        },
        phone: {
            label: 'Mobilnummer',
            country: 'Land',
            countrySearch: 'Land oder Vorwahl suchen',
            countryNoMatch: 'Kein Land gefunden',
            required: 'Geben Sie eine Mobilnummer ein',
            // Some German country names take an article («der Iran», «die Türkei»)
            // that a name passed in cannot carry, so it leads the message as a label.
            tooShort: (ctx)=>`${ctx.countryName}: Nummer zu kurz \u{2013} z. B. ${ctx.example}`,
            tooLong: (ctx)=>`${ctx.countryName}: Nummer zu lang \u{2013} z. B. ${ctx.example}`,
            notMobile: (ctx)=>`Das ist keine Mobilnummer \u{2013} z. B. ${ctx.example}`,
            invalid: "Diese Nummer ist ung\xfcltig"
        },
        dateRange: {
            title: 'Zeitraum',
            custom: 'Benutzerdefinierter Zeitraum',
            from: 'Von',
            to: 'Bis',
            needBoth: "W\xe4hlen Sie beide Daten aus, um den Zeitraum anzuwenden"
        },
        connectivity: {
            offline: "Sie sind offline \u2013 \xc4nderungen werden nicht gespeichert",
            degraded: "Keine Verbindung zum Server \u2013 neuer Versuch l\xe4uft",
            restored: 'Verbindung wiederhergestellt',
            retry: 'Erneut versuchen',
            busy: "Wird gepr\xfcft\u2026"
        },
        nationalId: {
            label: 'Nationale ID',
            genericLabel: 'Nationale ID-Nummer',
            country: 'Ausstellungsland',
            // `n` is never below 5, so the noun after it is always plural.
            placeholder: (n)=>`${n} Ziffern`,
            required: 'Geben Sie die nationale ID ein',
            incomplete: (n)=>`Die nationale ID muss ${n} Ziffern haben`,
            tooShort: (n)=>`Geben Sie mindestens ${n} Zeichen ein`,
            invalid: "Diese nationale ID ist ung\xfcltig",
            valid: "Nationale ID ist g\xfcltig",
            notValid: "Nationale ID ist ung\xfcltig"
        },
        dayContext: {
            prevDay: 'Vorheriger Tag',
            nextDay: "N\xe4chster Tag",
            today: 'Heute',
            backToToday: "Zur\xfcck zu heute",
            pickDay: "Tag ausw\xe4hlen"
        },
        weekPicker: {
            title: "Tag ausw\xe4hlen",
            thisWeek: 'Diese Woche',
            nextWeek: "N\xe4chste Woche",
            prevWeek: 'Letzte Woche',
            fullCalendar: "Vollst\xe4ndiger Kalender",
            backToWeek: "Zur\xfcck zur Woche",
            today: 'Heute',
            close: "Schlie\xdfen",
            range: (from, to)=>`${from} bis ${to}`,
            countAria: (n)=>`Termine: ${n}`
        },
        walkIn: {
            suggested: 'Vorgeschlagen',
            or: 'oder'
        },
        mobileHeader: {
            greeting: 'Willkommen,',
            clear: "L\xf6schen",
            unknownInitial: '?'
        },
        errorBoundary: {
            title: "Diese Seite konnte nicht ge\xf6ffnet werden",
            body: 'Beim Anzeigen dieser Seite ist ein Fehler aufgetreten.',
            retry: 'Erneut versuchen'
        },
        number: {
            invalid: "Das ist keine g\xfcltige Zahl",
            min: (n)=>`Mindestens ${n}`,
            max: (n)=>`H\xf6chstens ${n}`
        },
        account: {
            topUp: 'Guthaben aufladen',
            menu: 'Konto'
        },
        bottomNav: {
            label: 'Hauptnavigation'
        },
        files: {
            phases: {
                queued: 'In Warteschlange',
                preparing: 'Wird vorbereitet',
                sending: "Wird hochgeladen\u2026",
                done: 'Hochgeladen',
                failed: 'Nicht hochgeladen'
            },
            remove: 'Entfernen',
            retry: 'Erneut versuchen',
            replace: 'Ersetzen',
            drop: "Dateien hierher ziehen oder ausw\xe4hlen",
            pick: "Dateien ausw\xe4hlen",
            camera: 'Foto aufnehmen',
            directory: "Ordner ausw\xe4hlen",
            dragging: 'Hier ablegen'
        },
        imageStack: {
            frame: (i, n)=>`Bild ${i} von ${n}`,
            prev: 'Vorheriges Bild',
            next: "N\xe4chstes Bild",
            slider: 'Zwischen Bildern wechseln',
            zoomIn: "Vergr\xf6\xdfern",
            zoomOut: 'Verkleinern',
            reset: "Ansicht zur\xfccksetzen",
            series: 'Serien',
            presets: 'Anzeigeeinstellungen',
            viewport: 'Bildansicht',
            loading: 'Bild wird geladen',
            error: 'Das Bild konnte nicht geladen werden',
            retry: 'Erneut versuchen',
            empty: 'Kein Bild zum Anzeigen'
        },
        prizeWheel: {
            label: "Gl\xfccksrad"
        },
        toman: 'Toman'
    }
};
function $df1b34b618a72512$export$cddd06f8fa3400df(locale) {
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    return $df1b34b618a72512$export$6bdac007b5b42036[base] || $df1b34b618a72512$export$6bdac007b5b42036[(0, $abf0c103b4b92127$export$879824979a5b153a)('fa')] || $df1b34b618a72512$export$6bdac007b5b42036.fa;
}


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// CountryPicker — the country half of `PhoneInput`: a button showing the flag and the
// dial code, opening a searchable, flagged list (PM-0078).
//
// PORTED from the sign-in theme (`sso/parsina.keycloakify/src/login/components/
// CountryPicker.tsx`, 6c0f939), so a doctor finds their country the same way when
// signing in and when a desk registers them. Same contract: a combobox in the WAI-ARIA
// sense — the search box owns focus and points at the active row with
// `aria-activedescendant`, so a screen reader announces each row as the arrows move.
// Search matches a name in ALL five languages, accents folded on both sides, plus the
// dial code in any digit set: a Persian reader may still type an English name, a French
// one «etats» for «États-Unis», a German one «osterreich» for «Österreich», and «+۹۷۱»
// must find the Emirates.
//
// WHY NOT THE NATIVE <select> THIS REPLACED. It could not show flags — <option> takes no
// markup — and on Chrome/Edge for Windows its open list inherited the transparent face
// and showed blank rows (the theme hit both).
//
// FLAGS ARE IMAGES, NOT EMOJI. DESIGN.md rule 10 still holds: an emoji flag is drawn by
// the OS and Windows draws none. These are the theme's flag-icons, rasterised into
// `lib/flags.js` — a named exception in DESIGN_SYSTEM.md §15.
//
// WHERE THE LIST RENDERS — the one subtle thing here.
//   - On a page: portaled to <body>, `position: fixed`, so the field's own
//     `overflow: hidden` shell and a narrow sidebar card cannot clip it.
//   - Inside a dialog or a sheet (`[role="dialog"]`): portaled INTO that dialog,
//     `position: absolute`. A modal Radix dialog sets `pointer-events: none` on <body>
//     and yanks focus back from anything outside it, so a search box portaled to <body>
//     could never be typed into (JalaliDatePicker documents the same trap, and avoids
//     typing in its popup for that reason). Inside the dialog it is in the focus scope,
//     it is not an outside click, and the kit BottomSheet's Tab trap includes it.
//   z 9999 — the `JalaliDatePicker` popup's rung of DESIGN_SYSTEM.md §9.4: a field's
//   popup must sit above the Dialog (1100) the field is in.
// ─────────────────────────────────────────────────────────────────────────────
const $7801a9372e554ab2$var$Z = 9999;
const $7801a9372e554ab2$var$GAP = 6;
const $7801a9372e554ab2$var$EDGE = 8;
const $7801a9372e554ab2$var$PANEL_WIDTH = 300;
const $7801a9372e554ab2$var$LIST_MAX = 280;
function $7801a9372e554ab2$export$48ea269755562084({ iso2: iso2, size: size = 20 }) {
    const src = (0, $b7cded1008753984$export$a2b8715397522463)(iso2);
    const box = {
        width: size,
        height: Math.round(size * 3 / 4),
        borderRadius: 2,
        flexShrink: 0 /* a flag's own corner, not a token radius */ 
    };
    if (!src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        style: {
            ...box,
            display: 'inline-block',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: "",
        "aria-hidden": "true",
        width: box.width,
        height: box.height,
        style: {
            ...box,
            display: 'block',
            objectFit: 'cover',
            boxShadow: `0 0 0 1px ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    });
}
const $7801a9372e554ab2$var$sameCountry = (a, b)=>a?.iso2 === b?.iso2;
function $7801a9372e554ab2$export$3abcf2ef1ee51ab5({ value: value, onSelect: onSelect, countries: // The offered rows; the selected one is always offered even when narrowed out.
countries = (0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7), locale: localeProp, label: label, disabled: disabled = false, // Where the panel is measured from — the whole field shell, so the list lines up
// with the box rather than with the 70px button. Defaults to the button.
anchorRef: anchorProp, showDial: // `false` shows the country's two-letter code instead of its dial code — for a
// field whose country is not a phone prefix (NationalIdInput).
showDial = true, 'data-testid': testid }) {
    const locale = localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(localeProp).phone;
    const ariaLabel = label ?? copy.country;
    const numerals = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale);
    const localize = (s)=>String(s).replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const rtl = [
        'fa',
        'ar'
    ].includes(String(locale).split('-')[0]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [active, setActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [host, setHost] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const searchRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const listId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const optionId = (iso2)=>`${listId}-${iso2}`;
    // The locale's own country first (the answer for nearly every user), the rest in the
    // reader's alphabet.
    const ordered = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rows = countries.some((c)=>$7801a9372e554ab2$var$sameCountry(c, value)) || !value ? countries : [
            value,
            ...countries
        ];
        const home = (0, $412e1a8a99c19c1a$export$7684f8e22afec32c)(locale);
        const collator = new Intl.Collator(locale);
        const first = rows.filter((c)=>$7801a9372e554ab2$var$sameCountry(c, home));
        const rest = rows.filter((c)=>!$7801a9372e554ab2$var$sameCountry(c, home)).sort((a, b)=>collator.compare((0, $412e1a8a99c19c1a$export$3162e773cd568eb)(a, locale), (0, $412e1a8a99c19c1a$export$3162e773cd568eb)(b, locale)));
        return [
            ...first,
            ...rest
        ];
    }, [
        countries,
        value,
        locale
    ]);
    // The rule — dial code, ISO code, a name in any language with accents folded on both
    // sides — is `countryMatches` in lib/phone.js, where it is tested without a DOM.
    const matches = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>ordered.filter((c)=>(0, $412e1a8a99c19c1a$export$10dfaa5ff1ea39fa)(c, query)), [
        ordered,
        query
    ]);
    const show = ()=>{
        if (disabled) return;
        setQuery('');
        setActive(Math.max(ordered.findIndex((c)=>$7801a9372e554ab2$var$sameCountry(c, value)), 0));
        setOpen(true);
    };
    const hide = (returnFocus)=>{
        setOpen(false);
        if (returnFocus) buttonRef.current?.focus();
    };
    const choose = (country)=>{
        onSelect?.(country);
        hide(true);
    };
    // Place the panel against the anchor — in <body> with fixed coordinates, or inside
    // the enclosing dialog with coordinates relative to it (see the header).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const anchor = anchorProp?.current || buttonRef.current;
        const dialog = anchor?.closest?.('[role="dialog"]') || null;
        setHost(dialog || document.body);
        const place = ()=>{
            const a = (anchorProp?.current || buttonRef.current)?.getBoundingClientRect();
            if (!a) return;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const width = Math.min(Math.max(a.width, $7801a9372e554ab2$var$PANEL_WIDTH), vw - $7801a9372e554ab2$var$EDGE * 2);
            // The button sits at the LEFT of the field in every direction (the phone run is
            // an LTR island), so the panel lines up with the field's left edge.
            const left = Math.min(Math.max($7801a9372e554ab2$var$EDGE, a.left), vw - width - $7801a9372e554ab2$var$EDGE);
            const below = vh - a.bottom - $7801a9372e554ab2$var$EDGE * 2;
            const above = a.top - $7801a9372e554ab2$var$EDGE * 2;
            const up = below < 220 && above > below;
            const listMax = Math.max(120, Math.min($7801a9372e554ab2$var$LIST_MAX, (up ? above : below) - 60));
            const top = up ? null : a.bottom + $7801a9372e554ab2$var$GAP;
            const bottom = up ? a.top - $7801a9372e554ab2$var$GAP : null;
            if (!dialog) {
                setPos({
                    position: 'fixed',
                    left: left,
                    width: width,
                    listMax: listMax,
                    top: top,
                    bottomFromTop: bottom,
                    up: up
                });
                return;
            }
            // Relative to the dialog's padding box, scrolled with its content.
            const d = dialog.getBoundingClientRect();
            const bx = dialog.clientLeft || 0;
            const by = dialog.clientTop || 0;
            setPos({
                position: 'absolute',
                left: left - d.left - bx + dialog.scrollLeft,
                width: width,
                listMax: listMax,
                top: top == null ? null : top - d.top - by + dialog.scrollTop,
                bottomFromTop: bottom == null ? null : bottom - d.top - by + dialog.scrollTop,
                up: up
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorProp
    ]);
    // Focus the search box once the panel exists.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open && pos) searchRef.current?.focus({
            preventScroll: true
        });
    }, [
        open,
        pos != null
    ]);
    // Keep the active row in view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const row = matches[active];
        if (row) document.getElementById(optionId(row.iso2))?.scrollIntoView?.({
            block: 'nearest'
        });
    }, [
        open,
        active,
        matches
    ]);
    // A press anywhere else closes it, the way a native list does.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (panelRef.current?.contains(e.target) || buttonRef.current?.contains(e.target)) return;
            hide(false);
        };
        document.addEventListener('mousedown', onDown);
        document.addEventListener('touchstart', onDown);
        return ()=>{
            document.removeEventListener('mousedown', onDown);
            document.removeEventListener('touchstart', onDown);
        };
    }, [
        open
    ]);
    const onSearchKey = (e)=>{
        const last = matches.length - 1;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                setActive((i)=>i >= last ? 0 : i + 1);
                break;
            case 'ArrowUp':
                e.preventDefault();
                setActive((i)=>i <= 0 ? last : i - 1);
                break;
            case 'Home':
                e.preventDefault();
                setActive(0);
                break;
            case 'End':
                e.preventDefault();
                setActive(last);
                break;
            case 'Enter':
                // Never submit the surrounding form from inside the picker.
                e.preventDefault();
                if (matches[active]) choose(matches[active]);
                break;
            case 'Escape':
                // Closes the list, not the dialog or sheet the field sits in.
                e.preventDefault();
                e.stopPropagation();
                e.nativeEvent?.stopImmediatePropagation?.();
                hide(true);
                break;
            case 'Tab':
                hide(false);
                break;
            default:
        }
    };
    const onButtonKey = (e)=>{
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            show();
        }
    };
    const activeRow = open ? matches[active] : undefined;
    const country = value || ordered[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ref: buttonRef,
        disabled: disabled,
        "aria-label": `${ariaLabel}: ${(0, $412e1a8a99c19c1a$export$3162e773cd568eb)(country, locale)}`,
        "aria-haspopup": "listbox",
        "aria-expanded": open,
        "aria-controls": open ? listId : undefined,
        "data-testid": testid,
        "data-country": country?.iso2,
        onClick: ()=>open ? hide(false) : show(),
        onKeyDown: onButtonKey,
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 bg-transparent border-0 font-sans text-[13.5px] text-muted-foreground cursor-pointer select-none disabled:cursor-not-allowed outline-none focus-visible:bg-muted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
        iso2: country?.iso2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, showDial ? localize(`+${country?.dial ?? ''}`) : country?.iso2 ?? ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "12",
        height: "12",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m6 9 6 6 6-6"
    }))), open && pos && host && /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        "data-jalali-popup": "",
        "data-testid": testid ? `${testid}-panel` : undefined,
        dir: rtl ? 'rtl' : 'ltr',
        style: {
            position: pos.position,
            left: pos.left,
            width: pos.width,
            ...pos.up ? {
                top: pos.bottomFromTop,
                transform: 'translateY(-100%)'
            } : {
                top: pos.top
            },
            zIndex: $7801a9372e554ab2$var$Z,
            background: 'white',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            boxShadow: (0, $e7c165fb515b04ea$export$98b6069deb71e13e).floating,
            padding: 6,
            boxSizing: 'border-box',
            pointerEvents: 'auto',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '0 10px',
            height: 40,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            marginBottom: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m20 20-3.5-3.5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: searchRef,
        type: "search",
        role: "combobox",
        "aria-expanded": "true",
        "aria-controls": listId,
        "aria-autocomplete": "list",
        "aria-activedescendant": activeRow ? optionId(activeRow.iso2) : undefined,
        "aria-label": copy.countrySearch,
        placeholder: copy.countrySearch,
        autoComplete: "off",
        spellCheck: false,
        value: query,
        "data-testid": testid ? `${testid}-search` : undefined,
        onChange: (e)=>{
            setQuery(e.target.value);
            setActive(0);
        },
        onKeyDown: onSearchKey,
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 0,
            outline: 'none',
            background: 'transparent',
            fontFamily: 'inherit',
            fontSize: 13.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        id: listId,
        role: "listbox",
        "aria-label": ariaLabel,
        style: {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            maxHeight: pos.listMax,
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        }
    }, matches.map((c, i)=>{
        const selected = $7801a9372e554ab2$var$sameCountry(c, value);
        const isActive = i === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: c.iso2,
            id: optionId(c.iso2),
            role: "option",
            "aria-selected": selected,
            "data-testid": testid ? `${testid}-option-${c.iso2}` : undefined,
            // mousedown, not click: keeps focus in the search box, so the
            // outside-press handler never sees it.
            onMouseDown: (e)=>{
                e.preventDefault();
                choose(c);
            },
            onMouseMove: ()=>setActive(i),
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                minHeight: 40,
                padding: '0 10px',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                cursor: 'pointer',
                fontSize: 13.5,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                background: isActive ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08) : 'transparent',
                fontWeight: selected ? 600 : 400
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7801a9372e554ab2$export$48ea269755562084, {
            iso2: c.iso2
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, (0, $412e1a8a99c19c1a$export$3162e773cd568eb)(c, locale)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "ltr",
            style: {
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                unicodeBidi: 'isolate'
            }
        }, localize(`+${c.dial}`)), selected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            width: "14",
            height: "14",
            "aria-hidden": "true",
            style: {
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: "M20 6 9 17l-5-5"
        })));
    }), matches.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        role: "presentation",
        style: {
            padding: '10px',
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, copy.countryNoMatch))), host));
}
var $7801a9372e554ab2$export$2e2bcd8739ae039 = $7801a9372e554ab2$export$3abcf2ef1ee51ab5;





'use client';
// The one phone field. Everywhere in Parsina a human types a phone number, it types it
// here — a patient at the desk, a staff member being added, a supplier, a clinic line.
//
// ═══════════════════════════════════════════════════════════════════════════════
// WHAT IT WRITES, AND WHAT IT SHOWS — they are not the same thing, and that is the
// whole design.
//
//   `onChange` hands back **E.164 and only E.164** — `'+989121234567'`, or `''` while
//   the number is incomplete. Never an event object. The rules live in `lib/phone.js`;
//   this component owns none of them.
//
//   The BOX still shows `09121234567`, and always will. A stored `09121234567` and a
//   stored `+989121234567` render IDENTICALLY, because the draft is seeded through
//   `toNational`. Nothing on any screen changes shape on the day this ships. That is the
//   migration cushion, and it is what lets the wire format change without a coordinated
//   three-app cutover.
//
//   `showTrunk={false}` is the one opt-out: the box shows the number AFTER the dial chip
//   — `9121234567`, `2188000000` — with the trunk `0` off, because the chip already says
//   `+98` and a desk that deletes the zero is told, by the zero coming back, that its
//   edit did nothing. It changes only the SPELLING in the box: the emitted E.164 is the
//   same, a typed `0` still parses (and comes off on blur), and a stored `0…` or `+98…`
//   seeds the same trunkless draft.
//
// Why a bare string rather than the `{ target: { value } }` shim this component used to
// emit: `MoneyInput` already broke that pattern in this kit and states the rule in its
// own header — "Value in and value out are both the BARE ASCII numeric string… onChange
// is handed that string directly, not an event" — and `JalaliDatePicker` does the same.
// Entrenching a fake event in the one component whose output is a MATCHING KEY is the
// wrong direction. The second argument carries the rest: `{ ok, problem, e164, national,
// country, draft }`, for the rare caller that needs the national form or the reason.
//
// ═══════════════════════════════════════════════════════════════════════════════
// THE VALUE/DRAFT SPLIT — the subtlest thing in this file, and the thing a later
// "simplification" will break.
//
//   - The PARENT owns the canonical value (E.164). The COMPONENT owns the visible draft.
//   - The draft is seeded from the value on mount, and RE-seeded only when the `value`
//     PROP itself changed and the two no longer normalize to the same number. So typing
//     `0912` (parent holds `''`, draft holds `'0912'`, both normalize to `''`) does not
//     wipe the half-typed number; loading a patient re-seeds; a parent reset to `''`
//     clears it; and a parent that round-trips E.164 straight back never disturbs the
//     user's own typing.
//   - It NEVER calls `onChange` on mount or on a `value` prop change. These forms drive
//     `SaveBar` and dirty-tracking, and an emit-on-mount would mark every profile dirty
//     the moment it opened.
//
// Turning this into a plain controlled input wipes half-typed numbers on every keystroke
// — a regression visible only with a parent that round-trips through async state, which
// is why `PhoneInput.test.jsx` drives it from a real Host component.
//
// ═══════════════════════════════════════════════════════════════════════════════
// COUNTRY IS DERIVED, NEVER STORED.
//
// E.164 carries the country code inside the value, so `findByDialCode` recovers the
// picker on load. There is no `country_code` column, proto field or GraphQL field
// anywhere in this platform, and this change adds none: no schema change, no migration.
//
// THE PRESELECTION FOLLOWS THE LOCALE; A STORED NUMBER DOES NOT (PM-0078).
//
// An empty field preselects `countryForLocale(locale)` — Iran under `fa`, Iraq under
// `ar`, a tag's own region where it names one — so "the default is the default locale"
// and a patient from anywhere is one tap or one `+` away. A STORED value is never read
// through that preselection: an E.164 value names its own country, and a value stored
// in NATIONAL spelling (`09121234567`) is read as Iranian, always, because this field
// has only ever written E.164 and every national spelling in the platform's columns
// predates it — and those were Iranian. Read under Iraq, `09121234567` would come back
// as `+9649121234567`, the same digits and a different person.
//
// ═══════════════════════════════════════════════════════════════════════════════
// DIGITS ON SCREEN ARE THE LOCALE'S; DIGITS ON THE WIRE ARE ASCII.
//
// DESIGN_SYSTEM.md §6.4: displayed digit strings — phone included — use the locale's
// digit set "with no per-surface exceptions". This field used to render ASCII always,
// on the argument that a phone number is a KEY; the key is what is EMITTED, and that is
// still ASCII E.164. What changed is only the paint: the draft stays an ASCII string in
// state, and `localize` maps it digit-for-digit on the way to the DOM — the dial chip,
// the box, the default placeholder and the example in an error message alike. The
// mapping is one character to one character, so the caret arithmetic below (which
// counts kept characters in the ASCII draft) is untouched; `compactPhone` already folds
// whatever numerals come back in. `locale` defaults to <html lang>, as in `MoneyInput`.
// ─────────────────────────────────────────────────────────────────────────────
// Copy. The caller's props win; otherwise the kit's own words in `<html lang>`
// (lib/kitCopy.js, DESIGN.md rule 7).
//
// Five problems, not one: "invalid" alone tells nobody which digit to go looking for.
// The example is wrapped in U+2068 FSI … U+2069 PDI so an ASCII number inside a Persian
// sentence isolates itself without any CSS — the same reasoning as rule 8's LTR island,
// applied to a string rather than a box.
// ─────────────────────────────────────────────────────────────────────────────
const $5f69d84dab43bb31$var$isolate = (s)=>`\u2068${s}\u2069`;
const $5f69d84dab43bb31$var$defaultMessages = (locale)=>{
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).phone;
    const isolated = (fn)=>(ctx)=>fn({
                ...ctx,
                example: $5f69d84dab43bb31$var$isolate(ctx.example)
            });
    return {
        required: copy.required,
        tooShort: isolated(copy.tooShort),
        tooLong: isolated(copy.tooLong),
        notMobile: isolated(copy.notMobile),
        invalid: copy.invalid
    };
};
/** A `Country`, an iso2 string, or nothing → a `Country`. */ const $5f69d84dab43bb31$var$asCountry = (value, fallback)=>(typeof value === 'string' ? (0, $412e1a8a99c19c1a$export$586b3eaa727579f5)(value) : value) || fallback;
/** The offered list: `Country` records or iso2 strings, defaulting to the whole catalog. */ function $5f69d84dab43bb31$var$resolveList(countries) {
    if (!Array.isArray(countries) || countries.length === 0) return 0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7;
    const rows = countries.map((c)=>$5f69d84dab43bb31$var$asCountry(c, undefined)).filter(Boolean);
    return rows.length ? rows : (0, $412e1a8a99c19c1a$export$4d78c43b7fa734a7);
}
/**
 * What to put in the box for a value that arrived from somewhere else.
 *
 * A number becomes its national form. Anything else is shown AS STORED — and that rule
 * is load-bearing: a phone column in this platform can hold a note («تماس با منشی»), and
 * seeding an unparseable value to `''` would make the stored content vanish from the
 * field the moment the record opened, after which any save would silently wipe it.
 * Showing what is stored, emitting nothing until the user types, and letting the filter
 * strip it on the first keystroke is the honest behaviour.
 *
 * A number whose country is outside the catalog has no national form to render, so its
 * E.164 stands in — the alternative is a blank box over a real stored number.
 */ const $5f69d84dab43bb31$var$seedDraft = (parsed, value, showTrunk = true)=>parsed.ok ? $5f69d84dab43bb31$var$spellNational(parsed, showTrunk) || parsed.e164 : typeof value === 'string' ? value : '';
/**
 * `national` with the country's trunk prefix off — `'09121234567'` → `'9121234567'`.
 * Also used on a country's `example`, which is written in national form too. A string
 * that does not begin with the trunk is returned unchanged: India's example is already
 * trunkless, and a country without a trunk has nothing to take off.
 */ const $5f69d84dab43bb31$var$withoutTrunk = (national, country)=>country?.trunk && national.startsWith(country.trunk) ? national.slice(country.trunk.length) : national;
/** The national form as this field spells it: with its trunk, or without (`showTrunk`). */ const $5f69d84dab43bb31$var$spellNational = (parsed, showTrunk)=>showTrunk ? parsed.national : $5f69d84dab43bb31$var$withoutTrunk(parsed.national, parsed.country);
/**
 * The country a value arriving from STORAGE is read in. Written internationally (`+…`,
 * `00…`) it names its own country and `fallback` only matters for a dial code outside
 * the catalog; written nationally it is Iranian — see "THE PRESELECTION FOLLOWS THE
 * LOCALE" in the header. Typing never goes through here.
 */ const $5f69d84dab43bb31$var$storedCountry = (value, fallback)=>{
    const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(value);
    if (compact === '' || compact.startsWith('+') || compact.startsWith('00')) return fallback;
    return 0, $412e1a8a99c19c1a$export$84b76667b0a9e7b4;
};
/** The characters `compactPhone` keeps. Counting these is how the caret survives a
 *  separator being filtered out from under it. */ const $5f69d84dab43bb31$var$isKept = (ch)=>ch >= '0' && ch <= '9' || ch === '+';
const $5f69d84dab43bb31$var$countKept = (s)=>(0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(s).length;
const $5f69d84dab43bb31$var$PhoneInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: // Value — E.164 preferred, ANY legacy shape accepted (09…, +98…, 0098…, 98…, 9…,
// Persian/Arabic-Indic/fullwidth digits, separators, invisible marks).
value, onChange: onChange, onBlur: onBlur, // Country — `country` is controlled (pair it with `onCountryChange`),
// `defaultCountry` is the uncontrolled seed, itself defaulting to the locale's
// country (`countryForLocale`). A DEFAULT, never a lock.
country: countryProp, defaultCountry: defaultCountry, onCountryChange: onCountryChange, countries: // Narrow the offered list. Resolving to exactly ONE renders a static dial chip
// instead of a `<select>` — see below.
countries, allowLandline: // Drop the selected country's `nsnPattern` for this field: a supplier's or a
// clinic's number is an office line. Iran only, in practice.
allowLandline = false, showTrunk: // `false` spells the box without the trunk prefix — `9121234567` beside `+98`, not
// `09121234567`. Display only; what is emitted is unchanged. See the header.
showTrunk = true, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, messages: // Copy — each entry `string | (ctx) => string`, ctx = { country, countryName, example }.
messages, label: // Chrome — the same contract as TextInput.
label, countryLabel: countryLabel, required: required, error: externalError, helperText: helperText, disabled: disabled = false, className: // `className` merges onto the bordered SHELL — the element that carries the box,
// and the one a caller sizing this field inside a 170px column means. `style` is
// the FormField's and `inputStyle` the real input's, as in `MoneyInput`.
className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
// §17.2 requires a kit component to forward them, and a past bug was exactly this.
...rest }, ref)=>{
    const kit = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(localeProp).phone;
    if (label === undefined) label = kit.label;
    if (countryLabel === undefined) countryLabel = kit.country;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const innerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const caret = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ASCII in state, the locale's numerals in the DOM. See the header.
    const numerals = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)());
    const localize = (str)=>String(str ?? '').replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    const options = $5f69d84dab43bb31$var$resolveList(countries);
    const preselected = defaultCountry !== undefined ? defaultCountry : (0, $412e1a8a99c19c1a$export$7684f8e22afec32c)(localeProp);
    const base = $5f69d84dab43bb31$var$asCountry(countryProp !== undefined ? countryProp : preselected, options[0] || (0, $412e1a8a99c19c1a$export$84b76667b0a9e7b4));
    const shellRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const opts = {
        allowLandline: allowLandline
    };
    const spell = (p)=>$5f69d84dab43bb31$var$spellNational(p, showTrunk);
    const exampleFor = (c)=>showTrunk ? c.example : $5f69d84dab43bb31$var$withoutTrunk(c.example, c);
    // Draft and country live in ONE state object so a re-seed moves both atomically —
    // a load that changes the number and the country must never render half-applied.
    const [own, setOwn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        const parsed = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, base)
        });
        return {
            draft: $5f69d84dab43bb31$var$seedDraft(parsed, value, showTrunk),
            country: parsed.ok ? parsed.country : base
        };
    });
    const country = countryProp !== undefined ? base : own.country;
    const draft = own.draft;
    // Re-seed on a `value` PROP change only. Comparing the normalized forms is what keeps
    // a parent that echoes E.164 back from rewriting what the user is still typing;
    // comparing the raw prop is what still lets a parent clear the field.
    const prevValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    if (prevValue.current !== value) {
        prevValue.current = value;
        const incoming = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(value, {
            ...opts,
            country: $5f69d84dab43bb31$var$storedCountry(value, country)
        });
        if (incoming.e164 !== (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(draft, {
            ...opts,
            country: country
        }).e164) setOwn({
            draft: $5f69d84dab43bb31$var$seedDraft(incoming, value, showTrunk),
            country: incoming.ok ? incoming.country : country
        });
    }
    const parsed = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(draft, {
        ...opts,
        country: country
    });
    // An empty field is never an error unless the caller says it is required. Every other
    // problem is reported as it stands — including for a stored note, which genuinely is
    // not a phone number and is never silently cleared.
    const problem = parsed.problem === 'required' && !required ? null : parsed.problem;
    const copy = {
        ...$5f69d84dab43bb31$var$defaultMessages(localeProp),
        ...messages
    };
    const entry = problem ? copy[problem] : null;
    const internalError = typeof entry === 'function' ? entry({
        country: parsed.country,
        countryName: (0, $412e1a8a99c19c1a$export$3162e773cd568eb)(parsed.country, localeProp),
        example: localize(exampleFor(parsed.country))
    }) : entry || '';
    // On blur only (`touched`), never while typing; an external `error` always wins; and
    // the error is ADVISORY — `onChange` still fires and the value is never cleared.
    const error = externalError || (touched ? internalError : '');
    const emit = (nextDraft, nextCountry)=>{
        const next = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(nextDraft, {
            ...opts,
            country: nextCountry
        });
        onChange?.(next.e164, {
            ...next,
            draft: nextDraft
        });
    };
    const handleChange = (event)=>{
        const el = event.target;
        const raw = el.value;
        // How many KEPT characters sat left of the caret. The filter removes characters, so
        // a separator typed or pasted mid-string shifts every index after it. Copied from
        // `MoneyInput.jsx`, which carries the same loop and the largest caret suite in the
        // kit; the counting is the part that has to be right.
        const keptLeft = $5f69d84dab43bb31$var$countKept(raw.slice(0, el.selectionStart ?? raw.length));
        const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(raw);
        const international = compact.startsWith('+') || compact.startsWith('00');
        // The picker follows an EXPLICITLY international number and nothing else. A bare
        // national number means whatever the selected country says it means, so reading a
        // country out of it would be guessing. An international number whose dial code is
        // not in the catalog leaves the picker where it was — the list is not a gate.
        let nextCountry = country;
        if (international && countryProp === undefined) {
            const claimed = (0, $412e1a8a99c19c1a$export$21894a57509f6ed5)(compact.startsWith('+') ? compact.slice(1) : compact.slice(2));
            if (claimed) nextCountry = claimed;
        }
        const next = (0, $412e1a8a99c19c1a$export$48c6adddc5539199)(compact, {
            ...opts,
            country: nextCountry
        });
        // What you typed stays on screen — no rewrite under the cursor — with ONE exception:
        // a number written internationally is re-spelled nationally once it resolves,
        // because the dial code is now showing in the chip beside it and printing `+98`
        // twice in one field is not what the user wrote either.
        const nextDraft = international && next.ok && next.national ? spell(next) : compact;
        let pos = 0;
        let seen = 0;
        while(pos < nextDraft.length && seen < keptLeft){
            if ($5f69d84dab43bb31$var$isKept(nextDraft[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        setOwn({
            draft: nextDraft,
            country: nextCountry
        });
        if (nextCountry !== country) onCountryChange?.(nextCountry);
        emit(nextDraft, nextCountry);
    };
    const handleCountry = (picked)=>{
        const next = $5f69d84dab43bb31$var$asCountry(picked, null);
        if (!next) return;
        // An explicit international prefix is rewritten in place; a bare national number is
        // left exactly as typed, because its MEANING changed the moment the country did.
        const compact = (0, $412e1a8a99c19c1a$export$2ae1a93e018170a7)(draft);
        let nextDraft = draft;
        if (compact.startsWith(`+${country.dial}`)) nextDraft = `+${next.dial}${compact.slice(1 + country.dial.length)}`;
        else if (compact.startsWith(`00${country.dial}`)) nextDraft = `00${next.dial}${compact.slice(2 + country.dial.length)}`;
        setOwn({
            draft: nextDraft,
            country: next
        });
        onCountryChange?.(next);
        emit(nextDraft, next);
    };
    const handleBlur = (event)=>{
        setTouched(true);
        // The one moment where moving the caret costs nothing: a number that parses is
        // re-spelled in its national form, which is the field's confirmation that it
        // understood you. The login theme does not do this because a login field is left
        // immediately; a form field that is filled and then revisited is a different
        // surface. No emit — the canonical value has not changed.
        const spelled = parsed.ok ? spell(parsed) : '';
        if (spelled && spelled !== draft) setOwn((s)=>({
                ...s,
                draft: spelled
            }));
        onBlur?.(event);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (caret.current != null && innerRef.current) {
            innerRef.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const setRefs = (node)=>{
        innerRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    // A list that resolves to exactly one country gets a static chip, not a picker with
    // a single row: no fake choice, no tab stop, and — the practical reason — it is what
    // keeps the whole field inside the 170px and 160px boxes `SetupViews.jsx` wraps it
    // in, and off the ~150px clipping `ProfileSection.jsx` records in its own comment.
    // Every other field gets `CountryPicker`: flag, dial code, a searchable list. The
    // flags are images, never emoji (rule 10) — see that file's header.
    const single = options.length === 1;
    const testid = rest['data-testid'];
    // The error/helper line, JOINED to whatever the caller already pointed the field at —
    // never replacing it. `FormField` is passed `htmlFor`, which tells it this component
    // owns its own aria wiring, so its own join (see FormField) does not run for this
    // field and this is the only place the two ids can meet.
    //
    // Written as one value rather than an attribute before `{...rest}`, because that order
    // means a caller's `aria-describedby` OVERWRITES the message id: the field goes red,
    // and a screen reader reads the caller's hint and never says why. `MoneyInput` already
    // does it this way, for the same reason.
    const describedBy = [
        rest['aria-describedby'],
        error || helperText ? `${controlId}-message` : null
    ].filter(Boolean).join(' ') || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center h-11 rounded-lg overflow-hidden bg-white border-[1.5px]', 'transition-[border-color,box-shadow] duration-150', error ? 'border-destructive shadow-ring-red focus-within:shadow-ring-red' : 'border-border focus-within:border-primary focus-within:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "ltr",
        className: "flex items-center w-full h-full [unicode-bidi:isolate]"
    }, single ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center gap-1.5 h-full ps-3 pe-2 shrink-0 font-sans text-[13.5px] text-muted-foreground select-none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7801a9372e554ab2$export$48ea269755562084), {
        iso2: country.iso2
    }), localize(`+${country.dial}`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7801a9372e554ab2$export$2e2bcd8739ae039), {
        value: country,
        // A number pasted from outside the offered list still selects its own
        // country — validation must be right even where the list is narrowed —
        // so the picker always offers the current row, even when not asked for.
        countries: options,
        onSelect: handleCountry,
        locale: localeProp,
        label: countryLabel,
        disabled: disabled,
        anchorRef: shellRef,
        "data-testid": testid ? `${testid}-country` : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "w-px h-5 shrink-0 bg-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-invalid": error ? true : undefined,
        ...rest,
        // A caller's placeholder is an example NUMBER like the default, and the
        // catalogues spell it in ASCII as often as not — so it gets the page's
        // numerals too, rather than being the one Latin run left in the field.
        placeholder: localize(rest.placeholder ?? exampleFor(country)),
        // After `{...rest}`: the joined value is the one that must win, and it
        // already contains the caller's own.
        "aria-describedby": describedBy,
        ref: setRefs,
        type: "tel",
        inputMode: "tel",
        autoComplete: "tel",
        value: localize(draft),
        onChange: handleChange,
        onBlur: handleBlur,
        disabled: disabled,
        // The DOM `maxLength={11}` is gone: one attribute cannot express both a
        // national and an international shape, and 11 silently truncated every
        // number written as `+98…`. 20 is a cap no real number reaches after
        // filtering.
        maxLength: 20,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex-1 min-w-0 w-full h-full ps-2.5 pe-3.5 bg-transparent border-0 outline-none', 'font-sans text-[13.5px] text-foreground tracking-[0.5px]', 'disabled:cursor-not-allowed disabled:bg-transparent'),
        style: inputStyle
    }))));
});
$5f69d84dab43bb31$var$PhoneInput.displayName = 'PhoneInput';
var $5f69d84dab43bb31$export$2e2bcd8739ae039 = $5f69d84dab43bb31$var$PhoneInput;




var $acw62 = parcelRequire("acw62");




// National id — the one place the rules of a national identity number live.
//
// «کد ملی» is Iran's: ten digits, the last a checksum of the nine before it. That
// rule was written down more than once (the input's own private copy, and a copy
// in whichever screen had to validate on submit), which is how a code one screen
// accepts is refused by the next. It is written here once, and `NationalIdInput`
// and every screen read it from here.
//
// Three things are kept apart on purpose:
//
//   - **The COUNTRY decides the rules.** How long the number is, whether it has a
//     checksum, whether letters may appear — a property of who issued it. Each
//     country is one entry in `NATIONAL_ID_RULES`; adding one is adding an entry,
//     and no component branches on a country code. Iran's entry is today's rule,
//     unchanged. A country with no entry gets `GENERIC_RULE`, which checks shape
//     only and therefore never claims a number is VALID — only that it is not
//     obviously malformed.
//   - **The LANGUAGE decides the digits on screen.** «۰۰۱۲۳۴۵۶۷۹» under `fa`,
//     «٠٠١٢٣٤٥٦٧٩» under `ar`, «0012345679» under `en` — resolved by `numeralsFor`,
//     the seam `MoneyInput` already uses. An English-speaking desk in Tehran still
//     enters Iranian codes: language never picks the rule.
//   - **The VALUE is always ASCII.** Localised digits exist only between a
//     component and the DOM. What a form stores, compares, sends and validates is
//     `normalizeNationalId`'s output.



const $2885454b73c45d9d$export$db3d38ac1c19b9cc = 'IR';
function $2885454b73c45d9d$export$d285ab09de6b6713(locale) {
    return (0, $abf0c103b4b92127$export$3cede7c619603eb2)() ? $2885454b73c45d9d$export$db3d38ac1c19b9cc : (0, $412e1a8a99c19c1a$export$7684f8e22afec32c)(locale).iso2;
}
// ── Iran — «کد ملی» ──────────────────────────────────────────────────────────
// Ten digits. With the digits d0…d9 and S = Σ d[i] × (10 − i) for i = 0…8,
// r = S mod 11; the check digit d9 is r when r < 2, else 11 − r. Ten equal digits
// satisfy the arithmetic («1111111111») and are issued to nobody, so they are
// refused by name.
const $2885454b73c45d9d$var$IR_LENGTH = 10;
function $2885454b73c45d9d$var$iranChecksumHolds(code) {
    let sum = 0;
    for(let i = 0; i < 9; i++)sum += (code.charCodeAt(i) - 48) * (10 - i);
    const rem = sum % 11;
    return code.charCodeAt(9) - 48 === (rem < 2 ? rem : 11 - rem);
}
const $2885454b73c45d9d$var$IR_RULE = Object.freeze({
    country: 'IR',
    // What may be typed — decides the on-screen keyboard and what paste keeps.
    charset: 'digits',
    minLength: $2885454b73c45d9d$var$IR_LENGTH,
    maxLength: $2885454b73c45d9d$var$IR_LENGTH,
    // A rule with a checksum can say a number is VALID; one without can only say
    // it is not malformed, and the field then shows no «معتبر است».
    verifiable: true,
    // `strip` keeps every character the rule allows; `normalize` also cuts at the
    // length. The field needs both — it refuses a keystroke into a full code
    // instead of letting it push the last digit out.
    strip: (raw)=>(0, $412e1a8a99c19c1a$export$522be3011864bb18)(String(raw ?? '')).replace(/\D/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$var$IR_RULE.strip(raw).slice(0, $2885454b73c45d9d$var$IR_LENGTH),
    check (value) {
        if (value.length < $2885454b73c45d9d$var$IR_LENGTH) return 'incomplete';
        if (/^(\d)\1{9}$/.test(value) || !$2885454b73c45d9d$var$iranChecksumHolds(value)) return 'invalid';
        return null;
    },
    // A code kept as a NUMBER somewhere upstream (a spreadsheet import, an integer
    // column) has lost its leading zeros: «0012345679» arrives as «12345679». Codes
    // begin with at most two zeros, so 8 or 9 digits can be restored — and are kept
    // only when the restored code passes the checksum.
    repair (value) {
        if (value.length !== 8 && value.length !== 9) return value;
        const padded = value.padStart($2885454b73c45d9d$var$IR_LENGTH, '0');
        return $2885454b73c45d9d$var$IR_RULE.check(padded) === null ? padded : value;
    }
});
// ── A country with no entry ──────────────────────────────────────────────────
// Latin letters and digits, a plausible length, no checksum. Deliberately loose:
// refusing a real document because its country was never written down here would
// stop a foreign patient being registered at all.
const $2885454b73c45d9d$var$GENERIC_MIN = 5;
const $2885454b73c45d9d$var$GENERIC_MAX = 20;
const $2885454b73c45d9d$export$1700237b484ebbcc = Object.freeze({
    country: null,
    charset: 'alphanumeric',
    minLength: $2885454b73c45d9d$var$GENERIC_MIN,
    maxLength: $2885454b73c45d9d$var$GENERIC_MAX,
    verifiable: false,
    strip: (raw)=>(0, $412e1a8a99c19c1a$export$522be3011864bb18)(String(raw ?? '')).toUpperCase().replace(/[^A-Z0-9]/g, ''),
    normalize: (raw)=>$2885454b73c45d9d$export$1700237b484ebbcc.strip(raw).slice(0, $2885454b73c45d9d$var$GENERIC_MAX),
    check: (value)=>value.length < $2885454b73c45d9d$var$GENERIC_MIN ? 'incomplete' : null,
    repair: (value)=>value
});
const $2885454b73c45d9d$export$92a974607f6f02fc = Object.freeze({
    IR: $2885454b73c45d9d$var$IR_RULE
});
function $2885454b73c45d9d$export$8d56917ba3265ae0(country) {
    const home = (0, $abf0c103b4b92127$export$3cede7c619603eb2)() ? $2885454b73c45d9d$var$IR_RULE : $2885454b73c45d9d$export$1700237b484ebbcc;
    const raw = String(country ?? '').trim();
    if (!raw) return home;
    const parts = raw.split(/[-_]/);
    const region = parts.length > 1 ? parts.slice(1).find((p)=>/^[A-Za-z]{2}$/.test(p)) : /^[A-Z]{2}$/.test(raw) ? raw : null;
    if (!region) return home;
    return $2885454b73c45d9d$export$92a974607f6f02fc[region.toUpperCase()] || $2885454b73c45d9d$export$1700237b484ebbcc;
}
function $2885454b73c45d9d$export$9997440a468738e3(input, country) {
    return $2885454b73c45d9d$export$8d56917ba3265ae0(country).normalize(input);
}
function $2885454b73c45d9d$export$8b1749206e586151(input, { country: country, required: required = false } = {}) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    if (!value) return required ? 'required' : null;
    return rule.check(value);
}
function $2885454b73c45d9d$export$89cadb74f28f5ec2(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    const value = rule.normalize(input);
    return !!value && rule.check(value) === null;
}
function $2885454b73c45d9d$export$f198e2644d3eb5b8(input, country) {
    const rule = $2885454b73c45d9d$export$8d56917ba3265ae0(country);
    return rule.repair(rule.normalize(input));
}
function $2885454b73c45d9d$export$6a9c909dc504d3aa(input, locale) {
    const ascii = (0, $412e1a8a99c19c1a$export$522be3011864bb18)(String(input ?? '')).trim();
    if (!ascii) return '';
    const { digits: digits } = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)());
    return ascii.replace(/\d/g, (d)=>digits[Number(d)]);
}




'use client';
// The one national-id field. Everywhere in Parsina a human types a «کد ملی», it
// types it here — and no screen keeps its own length check or checksum.
//
// What it does that a plain <input> cannot:
//
//   1. **The rules of the issuing COUNTRY.** `country` (ISO alpha-2, default
//      Iran) picks the rule from `lib/nationalId.js`: Iran's ten digits and
//      checksum today, another country's the day its entry is added, a
//      shape-only check for a country with no entry. Language never picks it.
//   2. **The numerals of the language on screen.** Persian digits under `fa`,
//      Arabic-Indic under `ar`, Latin under `en` — whatever keyboard typed them.
//      Resolved by `numeralsFor`, the seam `MoneyInput` uses; nothing here
//      branches on a locale.
//   3. **Anything typed or pasted becomes the code.** Persian, Arabic and
//      full-width digits fold to ASCII; the dashes and spaces of
//      «001-234567-9» are dropped; the caret stays where the typist left it.
//   4. **One verdict, said once.** Required / incomplete / invalid, in the page
//      language, on blur and live from then on (§6.3) — the same verdict
//      `nationalIdProblem` gives the screen on submit.
//
// Value in and value out are both the BARE ASCII code — «0012345679», never
// «۰۰۱۲۳۴۵۶۷۹». Two ways to listen, and they say the same thing:
//
//   onChange({ target: { value, name } }, info)   — event-shaped, so it drops
//                                                    into an existing handler
//   onValueChange(value, info)                    — the bare string
//
// `info` is `{ value, complete, valid, problem, country }`. `onComplete(value)`
// fires when the code becomes complete and acceptable — the moment to look a
// patient up.
//
// WHICH COUNTRY (PM-0076, owner 2026-10-05): a clinic's patients carry the
// national id of the country the CLINIC is in — `defaultCountry`, the clinic's
// stored country — but a clinic also sees patients from elsewhere. A patient form
// passes `allowOtherCountries`, and the field grows a country chip (the phone
// field's flagged, searchable picker) that starts on the clinic's country. Picking
// another country re-reads the typed value under that country's rule and reports
// it through `onCountryChange(iso2)`. `country` makes the choice CONTROLLED (a
// form that stores the issuing country); without it the field keeps its own.
const $6dabae5d3309de70$var$messageFor = (copy, problem, rule, localise)=>{
    if (problem === 'required') return copy.required;
    if (problem === 'incomplete') return rule.minLength === rule.maxLength ? copy.incomplete(localise(String(rule.maxLength))) : copy.tooShort(localise(String(rule.minLength)));
    if (problem === 'invalid') return copy.invalid;
    return '';
};
const $6dabae5d3309de70$var$NationalIdInput = ({ value: value, onChange: onChange, onValueChange: onValueChange, onBlur: onBlur, onComplete: onComplete, // Whose number it is — ISO 3166-1 alpha-2, or a locale tag with a region.
// Controlled when passed; otherwise the field starts on `defaultCountry` (the
// clinic's country; omitted is Iran — outside the Iranian market, the country
// the phone field would preselect: `defaultNationalIdCountry`) and keeps the
// person's own pick.
country: countryProp, defaultCountry: defaultCountry, allowOtherCountries: // Offer the other countries — on every form that registers or edits a PATIENT.
// Off for a field that can only hold one country's number (the doctor's own
// code for an Iranian insurer).
allowOtherCountries = false, onCountryChange: onCountryChange, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, placeholder: placeholder, disabled: disabled = false, showValid: // `false` keeps the field from announcing «معتبر است» — for a dense form where
// the green line would push the row below it.
showValid = true, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name, autoFocus…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const shellRef = (0, $acw62.useRef)(null);
    const [picked, setPicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    // Set by the first blur: from then on the verdict follows every keystroke.
    const [checked, setChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const locale = localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).nationalId;
    const numerals = (0, $acw62.useMemo)(()=>(0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale), [
        locale
    ]);
    const country = countryProp || picked || defaultCountry || (0, $2885454b73c45d9d$export$d285ab09de6b6713)(locale);
    const rule = (0, $2885454b73c45d9d$export$8d56917ba3265ae0)(country);
    const countryRow = allowOtherCountries ? (0, $412e1a8a99c19c1a$export$586b3eaa727579f5)(rule.country || country) : null;
    const localise = (ascii)=>ascii.replace(/\d/g, (d)=>numerals.digits[Number(d)]);
    // A stored value may arrive in any digits, or as a number; it is read the way
    // typing is.
    const code = rule.normalize(value);
    const problem = code ? rule.check(code) : required ? 'required' : null;
    const isComplete = code.length >= rule.minLength;
    const isValid = rule.verifiable && !!code && problem === null;
    const isInvalid = problem === 'invalid';
    const error = externalError || (checked ? $6dabae5d3309de70$var$messageFor(copy, problem, rule, localise) : '');
    const statusShown = !externalError && rule.verifiable && isComplete && (isValid || isInvalid);
    if (label === undefined) label = rule.country === 'IR' ? copy.label : copy.genericLabel;
    if (placeholder === undefined) placeholder = rule.minLength === rule.maxLength && rule.charset === 'digits' ? copy.placeholder(localise(String(rule.maxLength))) : '';
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const report = (next, nextRule, iso)=>{
        const nextProblem = next ? nextRule.check(next) : required ? 'required' : null;
        const info = {
            value: next,
            complete: next.length >= nextRule.minLength,
            valid: !!next && nextProblem === null,
            problem: nextProblem,
            country: iso
        };
        onChange?.({
            target: {
                value: next,
                name: rest.name
            }
        }, info);
        onValueChange?.(next, info);
        if (info.valid) onComplete?.(next);
    };
    const handleCountry = (row)=>{
        const iso = row?.iso2;
        if (!iso || iso === country) return;
        if (!countryProp) setPicked(iso);
        onCountryChange?.(iso);
        // The same characters, read under the new country's rule — a code typed
        // before the country was picked is kept, not cleared.
        const nextRule = (0, $2885454b73c45d9d$export$8d56917ba3265ae0)(iso);
        report(nextRule.normalize(value), nextRule, iso);
        ref.current?.focus();
    };
    const handleChange = (e)=>{
        const el = e.target;
        // Digits map one to one, so the caret belongs after as many KEPT characters
        // as sat to its left — a pasted dash or space must not push it along.
        const keptLeft = rule.strip(el.value.slice(0, el.selectionStart ?? el.value.length)).length;
        const kept = rule.strip(el.value);
        const next = kept.slice(0, rule.maxLength);
        // A keystroke into a code that is already full is refused, the way a native
        // `maxLength` refuses it — otherwise a digit typed mid-code pushes the last
        // one out and silently rewrites the number. (The DOM attribute itself is not
        // used: it truncates a pasted «001-234567-9» before the dashes are dropped.)
        const overflow = code.length === rule.maxLength && kept.length > rule.maxLength;
        if (overflow || next === code) {
            // Nothing to report, so React will not re-render — put the field back by
            // hand, or the refused character stays on screen and the caret jumps.
            const pos = Math.max(0, Math.min(code.length, keptLeft - (kept.length - code.length)));
            el.value = localise(code);
            el.setSelectionRange(pos, pos);
            return;
        }
        caret.current = Math.min(keptLeft, next.length);
        report(next, rule, country);
    };
    const messageId = `${controlId}-message`;
    const validLine = showValid && isValid && !error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: validLine ? '' : helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: shellRef,
        className: "relative [unicode-bidi:isolate]",
        dir: "ltr"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText || validLine ? messageId : undefined,
        "aria-invalid": error ? true : undefined,
        "aria-required": required || undefined,
        autoComplete: "off",
        ...rest,
        ref: ref,
        type: "text",
        inputMode: rule.charset === 'digits' ? 'numeric' : 'text',
        value: localise(code),
        onChange: handleChange,
        onBlur: (e)=>{
            setChecked(true);
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground tracking-[1.5px] tabular-nums', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', // With the country chip the chip owns the start and the ✓/✗ moves to the end.
        countryRow ? 'ps-[84px] pe-10' : 'ps-10 pe-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : statusShown && isValid ? 'border-clinic-green shadow-ring-green' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), countryRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "absolute inset-y-0 start-0 flex items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7801a9372e554ab2$export$2e2bcd8739ae039), {
        value: countryRow,
        onSelect: handleCountry,
        locale: localeProp,
        label: copy.country,
        disabled: disabled,
        anchorRef: shellRef,
        showDial: false,
        "data-testid": rest['data-testid'] ? `${rest['data-testid']}-country` : undefined
    })), statusShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": isValid ? copy.valid : copy.notValid,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('absolute top-1/2 -translate-y-1/2 flex items-center', countryRow ? 'end-3' : 'start-3', isValid ? 'text-clinic-green' : 'text-destructive')
    }, isValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })))), validLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: messageId,
        className: "m-0 text-[11.5px] font-semibold text-clinic-green leading-snug"
    }, copy.valid));
};
var $6dabae5d3309de70$export$2e2bcd8739ae039 = $6dabae5d3309de70$var$NationalIdInput;



var $acw62 = parcelRequire("acw62");




'use client';
const $4fe0519cb1ec239e$var$NumberInput = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, unit: unit, min: min, max: max, validate: validate, disabled: disabled = false, style: style, // The language whose decimal mark the field accepts; defaults to <html lang>.
locale: localeProp, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest })=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const defaultValidate = (v)=>{
        if (!v) return '';
        const n = parseFloat(v);
        const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().number;
        if (isNaN(n)) return copy.invalid;
        if (min !== undefined && n < min) return copy.min(min);
        if (max !== undefined && n > max) return copy.max(max);
        return '';
    };
    const error = externalError || (touched ? internalError : '');
    // The stored value is ASCII with «.» as the decimal point. The page language's
    // own decimal mark (French «,», Persian «٫») is folded to «.» before the strip —
    // stripping first turned «72,5» into «725». «.» is accepted in every language.
    //
    // German GROUPS with «.» (PM-0212). Echoing the stored «72.5» back made a single
    // dot the field's decimal point, so a German «1.500» was silently stored as 1.5 —
    // a factor of 1000 the box never showed. Under a language whose group mark is «.»
    // the field therefore shows its value with the language's own decimal mark
    // («72,5»), and every «.» typed into it is a group mark, as in `MoneyInput` and
    // `currency.parseAmount(…, 'de')`: «1.500» is 1500, «1.234,5» is 1234.5. A dot that
    // vanishes as it is typed («1.5» → «15») is visible; a decimal is written «1,5».
    const numerals = (0, $ca1f40e638c62a9a$export$20975da26e036f6b)(localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)());
    const localDecimal = numerals.group === '.' && numerals.decimal !== '.';
    const display = localDecimal && value != null && value !== '' ? String(value).replace('.', numerals.decimal) : value;
    const handleChange = (e)=>{
        const v = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(e.target.value, true, numerals);
        onChange({
            target: {
                value: v
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        type: "text",
        inputMode: "decimal",
        value: display,
        onChange: handleChange,
        onBlur: (e)=>{
            setTouched(true);
            setInternalError((validate || defaultValidate)(value));
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        dir: "ltr",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[14px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', unit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unit)));
};
var $4fe0519cb1ec239e$export$2e2bcd8739ae039 = $4fe0519cb1ec239e$var$NumberInput;



var $acw62 = parcelRequire("acw62");




// ─────────────────────────────────────────────────────────────────────────────
// Currency — clinic money in the currency the clinic keeps its books in.
//
// `money.js` was written for one currency: whole RIALS on the wire, TOMAN in front
// of a human. That stays true for every Iranian clinic, byte for byte. A clinic may
// now keep its books in another currency, and this module is the one place that
// knows what each allowed currency looks like:
//
//   • ON THE WIRE an amount is an integer number of MINOR UNITS of the document's
//     currency — whole rials for IRR (exponent 0, a deliberate override of ISO's 2),
//     cents for USD, fils for KWD. Field names ending in `Rial` keep their names and
//     now mean "minor units of this row's `currency`".
//   • IN FRONT OF A HUMAN an amount is divided by `displayDivisor`. That is NOT
//     10**exponent: IRR's divisor is 10, because an Iranian reads toman.
//   • An EMPTY or ABSENT currency means IRR. That is how an older server, a lagging
//     proto copy or a historical row degrades to today's behaviour.
//   • Amounts in two currencies are never added, compared or charted together.
//     There is no exchange rate anywhere in Parsina: group (`sumByCurrency`) or
//     refuse (`assertSameCurrency` → MIXED_CURRENCY).
//
// For IRR every function here returns exactly what money.js returns today:
// `formatAmount(x, 'IRR')` is `fmtToman(x)`, `toDisplay` is `rialToToman`,
// `fromDisplay` is `tomanToRial` and `parseAmount` is `parseTomanToRial` for every
// input that one accepts. The tests hold each pair against the other. Both parsers
// read money.js's notation — a «.» decimal — unless the caller names a language
// that writes a decimal COMMA (French «1 234,5», German «1.234,5»): see `parseAmount`.
//
// The table below is the closed allow-list from docs/clinic-currency/CONTRACTS.md
// §1; `currency.cases.json` beside this file is its machine-readable twin, which the
// Python services copy byte for byte. Change one, change the other.
//
// DEPENDENCY-FREE ON PURPOSE: no imports at all, not even money.js. The file must be
// droppable into an older installed framework for local testing, and into any app
// or script, without dragging a module graph along.
// ─────────────────────────────────────────────────────────────────────────────
const $fcda591c8cd139a4$export$c19ece7ea27dcd9e = 'IRR';
function $fcda591c8cd139a4$var$deepFreeze(value) {
    for (const inner of Object.values(value))if (inner && typeof inner === 'object') $fcda591c8cd139a4$var$deepFreeze(inner);
    return Object.freeze(value);
}
const $fcda591c8cd139a4$export$76e9d3e89dba5250 = $fcda591c8cd139a4$var$deepFreeze({
    IRR: {
        code: 'IRR',
        exponent: 0,
        displayDivisor: 10,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 1,
        labels: {
            fa: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            },
            en: {
                long: 'Toman',
                short: 'T'
            },
            ar: {
                long: "\u062A\u0648\u0645\u0627\u0646",
                short: "\u062A"
            },
            fr: {
                long: 'toman',
                short: 'T'
            },
            de: {
                long: 'Toman',
                short: 'T'
            }
        }
    },
    USD: {
        code: 'USD',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0644\u0627\u0631 \u0622\u0645\u0631\u06CC\u06A9\u0627",
                short: 'USD'
            },
            en: {
                long: 'US dollar',
                short: 'USD'
            },
            ar: {
                long: "\u062F\u0648\u0644\u0627\u0631 \u0623\u0645\u0631\u064A\u0643\u064A",
                short: 'USD'
            },
            fr: {
                long: "dollar am\xe9ricain",
                short: 'USD'
            },
            de: {
                long: 'US-Dollar',
                short: 'USD'
            }
        }
    },
    EUR: {
        code: 'EUR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u06CC\u0648\u0631\u0648",
                short: 'EUR'
            },
            en: {
                long: 'Euro',
                short: 'EUR'
            },
            ar: {
                long: "\u064A\u0648\u0631\u0648",
                short: 'EUR'
            },
            fr: {
                long: 'euro',
                short: 'EUR'
            },
            de: {
                long: 'Euro',
                short: 'EUR'
            }
        }
    },
    GBP: {
        code: 'GBP',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u067E\u0648\u0646\u062F \u0627\u0646\u06AF\u0644\u06CC\u0633",
                short: 'GBP'
            },
            en: {
                long: 'Pound sterling',
                short: 'GBP'
            },
            ar: {
                long: "\u062C\u0646\u064A\u0647 \u0625\u0633\u062A\u0631\u0644\u064A\u0646\u064A",
                short: 'GBP'
            },
            fr: {
                long: 'livre sterling',
                short: 'GBP'
            },
            de: {
                long: 'Pfund Sterling',
                short: 'GBP'
            }
        }
    },
    CHF: {
        code: 'CHF',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0641\u0631\u0627\u0646\u06A9 \u0633\u0648\u0626\u06CC\u0633",
                short: 'CHF'
            },
            en: {
                long: 'Swiss franc',
                short: 'CHF'
            },
            ar: {
                long: "\u0641\u0631\u0646\u0643 \u0633\u0648\u064A\u0633\u0631\u064A",
                short: 'CHF'
            },
            fr: {
                long: 'franc suisse',
                short: 'CHF'
            },
            de: {
                long: 'Schweizer Franken',
                short: 'CHF'
            }
        }
    },
    AED: {
        code: 'AED',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u062F\u0631\u0647\u0645 \u0627\u0645\u0627\u0631\u0627\u062A",
                short: 'AED'
            },
            en: {
                long: 'UAE dirham',
                short: 'AED'
            },
            ar: {
                long: "\u062F\u0631\u0647\u0645 \u0625\u0645\u0627\u0631\u0627\u062A\u064A",
                short: 'AED'
            },
            fr: {
                long: "dirham des \xc9mirats arabes unis",
                short: 'AED'
            },
            de: {
                long: 'VAE-Dirham',
                short: 'AED'
            }
        }
    },
    SAR: {
        code: 'SAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0633\u0639\u0648\u062F\u06CC",
                short: 'SAR'
            },
            en: {
                long: 'Saudi riyal',
                short: 'SAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0633\u0639\u0648\u062F\u064A",
                short: 'SAR'
            },
            fr: {
                long: 'riyal saoudien',
                short: 'SAR'
            },
            de: {
                long: 'Saudi-Riyal',
                short: 'SAR'
            }
        }
    },
    QAR: {
        code: 'QAR',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0642\u0637\u0631",
                short: 'QAR'
            },
            en: {
                long: 'Qatari riyal',
                short: 'QAR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0642\u0637\u0631\u064A",
                short: 'QAR'
            },
            fr: {
                long: 'riyal qatari',
                short: 'QAR'
            },
            de: {
                long: 'Katar-Riyal',
                short: 'QAR'
            }
        }
    },
    TRY: {
        code: 'TRY',
        exponent: 2,
        displayDivisor: 100,
        minDisplayDecimals: 2,
        maxDisplayDecimals: 2,
        labels: {
            fa: {
                long: "\u0644\u06CC\u0631 \u062A\u0631\u06A9\u06CC\u0647",
                short: 'TRY'
            },
            en: {
                long: 'Turkish lira',
                short: 'TRY'
            },
            ar: {
                long: "\u0644\u064A\u0631\u0629 \u062A\u0631\u0643\u064A\u0629",
                short: 'TRY'
            },
            fr: {
                long: 'livre turque',
                short: 'TRY'
            },
            de: {
                long: "T\xfcrkische Lira",
                short: 'TRY'
            }
        }
    },
    KWD: {
        code: 'KWD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u06A9\u0648\u06CC\u062A",
                short: 'KWD'
            },
            en: {
                long: 'Kuwaiti dinar',
                short: 'KWD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0643\u0648\u064A\u062A\u064A",
                short: 'KWD'
            },
            fr: {
                long: "dinar kowe\xeftien",
                short: 'KWD'
            },
            de: {
                long: 'Kuwait-Dinar',
                short: 'KWD'
            }
        }
    },
    BHD: {
        code: 'BHD',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0628\u062D\u0631\u06CC\u0646",
                short: 'BHD'
            },
            en: {
                long: 'Bahraini dinar',
                short: 'BHD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0628\u062D\u0631\u064A\u0646\u064A",
                short: 'BHD'
            },
            fr: {
                long: "dinar bahre\xefni",
                short: 'BHD'
            },
            de: {
                long: 'Bahrain-Dinar',
                short: 'BHD'
            }
        }
    },
    OMR: {
        code: 'OMR',
        exponent: 3,
        displayDivisor: 1000,
        minDisplayDecimals: 3,
        maxDisplayDecimals: 3,
        labels: {
            fa: {
                long: "\u0631\u06CC\u0627\u0644 \u0639\u0645\u0627\u0646",
                short: 'OMR'
            },
            en: {
                long: 'Omani rial',
                short: 'OMR'
            },
            ar: {
                long: "\u0631\u064A\u0627\u0644 \u0639\u0645\u0627\u0646\u064A",
                short: 'OMR'
            },
            fr: {
                long: 'riyal omanais',
                short: 'OMR'
            },
            de: {
                long: 'Omanischer Rial',
                short: 'OMR'
            }
        }
    },
    // Whole dinars: ISO's exponent is 3, but no fils circulate and CLDR prints IQD
    // with no decimals — the same deliberate override as IRR's.
    IQD: {
        code: 'IQD',
        exponent: 0,
        displayDivisor: 1,
        minDisplayDecimals: 0,
        maxDisplayDecimals: 0,
        labels: {
            fa: {
                long: "\u062F\u06CC\u0646\u0627\u0631 \u0639\u0631\u0627\u0642",
                short: 'IQD'
            },
            en: {
                long: 'Iraqi dinar',
                short: 'IQD'
            },
            ar: {
                long: "\u062F\u064A\u0646\u0627\u0631 \u0639\u0631\u0627\u0642\u064A",
                short: 'IQD'
            },
            fr: {
                long: 'dinar irakien',
                short: 'IQD'
            },
            de: {
                long: 'Irakischer Dinar',
                short: 'IQD'
            }
        }
    }
});
const $fcda591c8cd139a4$export$729c9ac211f2ddda = Object.freeze(Object.keys($fcda591c8cd139a4$export$76e9d3e89dba5250));
function $fcda591c8cd139a4$export$68d15a182c6bcbf0(code) {
    return typeof code === 'string' && Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$export$76e9d3e89dba5250, code);
}
function $fcda591c8cd139a4$var$invalidCurrency(code) {
    const shown = typeof code === 'string' ? JSON.stringify(code) : String(code);
    const error = new Error(`Invalid currency ${shown}: expected one of ${$fcda591c8cd139a4$export$729c9ac211f2ddda.join(', ')}`);
    error.name = 'InvalidCurrencyError';
    error.code = 'INVALID_CURRENCY';
    error.currency = code;
    return error;
}
function $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code) {
    if (code == null || code === '') return $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
    if ($fcda591c8cd139a4$export$68d15a182c6bcbf0(code)) return code;
    throw $fcda591c8cd139a4$var$invalidCurrency(code);
}
function $fcda591c8cd139a4$export$272b829bb65f9e96(code) {
    return $fcda591c8cd139a4$export$76e9d3e89dba5250[$fcda591c8cd139a4$export$b91dea8e61ccd7ef(code)];
}
function $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, currency) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (amountMinor == null || amountMinor === '' || !Number.isFinite(Number(amountMinor))) return null;
    return Number(amountMinor) / displayDivisor;
}
function $fcda591c8cd139a4$export$22f3da351f420435(displayValue, currency, locale) {
    const { displayDivisor: displayDivisor } = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const n = Number($fcda591c8cd139a4$var$dotDecimal(displayValue ?? '', locale).replace(/[,٬\s]/g, ''));
    return Number.isFinite(n) ? Math.round(n * displayDivisor) : NaN;
}
// ── Parsing what a human typed ──────────────────────────────────────────────
const $fcda591c8cd139a4$var$PERSIAN_DIGITS = "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9";
const $fcda591c8cd139a4$var$ARABIC_DIGITS = "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669";
function $fcda591c8cd139a4$var$toAsciiDigits(text) {
    return text.replace(/[۰-۹]/g, (d)=>String($fcda591c8cd139a4$var$PERSIAN_DIGITS.indexOf(d))).replace(/[٠-٩]/g, (d)=>String($fcda591c8cd139a4$var$ARABIC_DIGITS.indexOf(d)));
}
// Characters a formatted figure carries that are not part of the number: ICU puts
// an LRM before a Persian negative and an ALM before an Arabic one, and a copy out
// of an RTL page can bring RLM or an isolate along.
const $fcda591c8cd139a4$var$BIDI_MARKS = /[‎‏؜‪-‮⁦-⁩]/g;
const $fcda591c8cd139a4$var$GROUPING = /[,٬\s]/;
const $fcda591c8cd139a4$var$GROUPING_ALL = /[,٬\s]/g;
/**
 * `value` as a string in the notation both parsers read: «.» the decimal, «,» a
 * grouping mark. A language whose decimal mark is a COMMA (French «1 234,5»,
 * grouped with U+202F; German «1.234,5», grouped with «.») writes the two the
 * other way round, so its text has them traded back; «٫» and «٬» are never
 * ambiguous and stay as they are. The mark is
 * the one `formatAmount` prints for that language, so whatever it prints reads
 * back. A number is never re-read: `String(1.5)` is «1.5» on every page.
 */ function $fcda591c8cd139a4$var$dotDecimal(value, locale) {
    const text = String(value);
    if (typeof value !== 'string' || $fcda591c8cd139a4$var$decimalMarkOf($fcda591c8cd139a4$var$languageOf(locale)) !== ',') return text;
    return text.replace(/[.,]/g, (mark)=>mark === ',' ? '.' : ',');
}
function $fcda591c8cd139a4$export$b94f7550e5b92f9c(input, currency, locale) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    if (input == null) return NaN;
    const text = $fcda591c8cd139a4$var$toAsciiDigits($fcda591c8cd139a4$var$dotDecimal(input, locale)).replace($fcda591c8cd139a4$var$BIDI_MARKS, '').replace(/−/g, '-').replace(/٫/g, '.').trim();
    if (text === '') return NaN;
    if (info.code === $fcda591c8cd139a4$export$c19ece7ea27dcd9e) {
        const n = Number(text.replace($fcda591c8cd139a4$var$GROUPING_ALL, ''));
        return Number.isFinite(n) ? Math.round(n * info.displayDivisor) : NaN;
    }
    return $fcda591c8cd139a4$var$parseStrict(text, info);
}
function $fcda591c8cd139a4$var$parseStrict(text, { displayDivisor: displayDivisor, maxDisplayDecimals: maxDisplayDecimals }) {
    let body = text;
    let sign = 1;
    if (body[0] === '-' || body[0] === '+') {
        if (body[0] === '-') sign = -1;
        body = body.slice(1).trim();
    }
    const dot = body.indexOf('.');
    const whole = dot < 0 ? body : body.slice(0, dot);
    const fraction = dot < 0 ? '' : body.slice(dot + 1);
    if (!/^\d*$/.test(fraction) || fraction.length > maxDisplayDecimals) return NaN;
    const groups = whole.split($fcda591c8cd139a4$var$GROUPING);
    if (groups.length > 1 && (!/^\d{1,3}$/.test(groups[0]) || groups.slice(1).some((g)=>!/^\d{3}$/.test(g)))) return NaN;
    const digits = groups.join('');
    if (!/^\d*$/.test(digits) || digits === '' && fraction === '') return NaN;
    // Integer arithmetic: «0.29» must be 29 cents, not 28.999999999999996.
    const scale = 10 ** maxDisplayDecimals;
    const units = Number(digits || '0') * scale + Number(fraction.padEnd(maxDisplayDecimals, '0') || '0');
    const minor = Math.round(units * displayDivisor / scale);
    if (!Number.isSafeInteger(minor)) return NaN;
    return minor === 0 ? 0 : sign * minor;
}
// ── Showing an amount ───────────────────────────────────────────────────────
// The Intl tag per panel language. The numbering system is spelled out for Arabic
// because ICU's bare `ar` now prints Latin digits, while every Parsina panel renders
// Arabic with Arabic-Indic ones (`-nu-arab` in each app's i18n config). `fa-IR` is
// what `fmtToman` has always used. `fr-FR` groups with U+202F NARROW NO-BREAK SPACE
// and writes a decimal COMMA, «1 234,5» — `parseAmount` reads that back only when
// it is told the text is French. `de-DE` groups with «.» and writes a decimal
// COMMA too, «1.234,5» — read back only when the text is said to be German.
// Every language here needs `labels` on every row.
const $fcda591c8cd139a4$var$INTL_TAGS = {
    fa: 'fa-IR',
    en: 'en-US',
    ar: 'ar-u-nu-arab',
    fr: 'fr-FR',
    de: 'de-DE'
};
/** `en-GB` → `en`; unknown or unset → `fa`, as the kit's `kitCopy` falls back. */ function $fcda591c8cd139a4$var$languageOf(locale) {
    const base = String(locale || 'fa').toLowerCase().split(/[-_]/)[0];
    return Object.prototype.hasOwnProperty.call($fcda591c8cd139a4$var$INTL_TAGS, base) ? base : 'fa';
}
// The decimal mark a language prints, from the same Intl data as its formatter:
// «٫» fa and ar, «.» en, «,» fr and de. Read, not listed, so the parser can never
// disagree with the figure on screen — even on an ICU build without French data,
// where both fall back together.
const $fcda591c8cd139a4$var$decimalMarks = new Map();
function $fcda591c8cd139a4$var$decimalMarkOf(language) {
    let mark = $fcda591c8cd139a4$var$decimalMarks.get(language);
    if (mark === undefined) {
        const parts = new Intl.NumberFormat($fcda591c8cd139a4$var$INTL_TAGS[language]).formatToParts(1.5);
        mark = parts.find((p)=>p.type === 'decimal')?.value ?? '.';
        $fcda591c8cd139a4$var$decimalMarks.set(language, mark);
    }
    return mark;
}
// What joins a figure to its unit word. French and German typography never let a
// unit wrap away from its number (German: DIN 5008, «1.500 Toman»), so both take
// U+00A0 NO-BREAK SPACE; every other language keeps the plain space it has always
// had.
const $fcda591c8cd139a4$var$UNIT_JOINERS = {
    fr: '\u00a0',
    de: '\u00a0'
};
// A formatter per (language, currency). Constructing Intl.NumberFormat is not free
// and amounts render inside list rows.
const $fcda591c8cd139a4$var$numberFormats = new Map();
function $fcda591c8cd139a4$var$numberFormat(language, info) {
    const key = `${language}|${info.code}`;
    let nf = $fcda591c8cd139a4$var$numberFormats.get(key);
    if (!nf) {
        nf = new Intl.NumberFormat($fcda591c8cd139a4$var$INTL_TAGS[language], {
            minimumFractionDigits: info.minDisplayDecimals,
            maximumFractionDigits: info.maxDisplayDecimals
        });
        $fcda591c8cd139a4$var$numberFormats.set(key, nf);
    }
    return nf;
}
function $fcda591c8cd139a4$export$e251d23bea783311(amountMinor, currency, { locale: locale = 'fa', unit: unit = 'none', fallback: fallback = "\u2014" } = {}) {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    const value = $fcda591c8cd139a4$export$57a9131fd362a631(amountMinor, info.code);
    if (value == null) return fallback;
    const language = $fcda591c8cd139a4$var$languageOf(locale);
    const text = $fcda591c8cd139a4$var$numberFormat(language, info).format(value);
    if (unit !== 'short' && unit !== 'long') return text;
    return `${text}${$fcda591c8cd139a4$var$UNIT_JOINERS[language] ?? ' '}${info.labels[language][unit]}`;
}
function $fcda591c8cd139a4$export$846d8329e0c3da65(currency, locale = 'fa', style = 'long') {
    const info = $fcda591c8cd139a4$export$272b829bb65f9e96(currency);
    return info.labels[$fcda591c8cd139a4$var$languageOf(locale)][style === 'short' ? 'short' : 'long'];
}
class $fcda591c8cd139a4$export$7cfa96280ebafb15 extends Error {
    constructor(currencies = [], message){
        const list = [
            ...new Set(currencies)
        ];
        super(message || `Amounts in different currencies cannot be combined: ${list.join(', ')}`);
        this.name = 'MixedCurrencyError';
        this.code = 'MIXED_CURRENCY';
        this.currencies = list;
    }
}
function $fcda591c8cd139a4$export$73a0b246a0fd217a(...codes) {
    const seen = [];
    for (const code of codes.flat()){
        const normalized = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(code);
        if (!seen.includes(normalized)) seen.push(normalized);
    }
    if (seen.length > 1) throw new $fcda591c8cd139a4$export$7cfa96280ebafb15(seen);
    return seen[0] || $fcda591c8cd139a4$export$c19ece7ea27dcd9e;
}
const $fcda591c8cd139a4$var$picker = (pick, fallbackKey)=>{
    if (typeof pick === 'function') return pick;
    const key = pick ?? fallbackKey;
    return (row)=>row?.[key];
};
function $fcda591c8cd139a4$export$b440d7571b9fe7a6(rows, pickAmount, pickCurrency) {
    const amountOf = $fcda591c8cd139a4$var$picker(pickAmount, 'amount');
    const currencyOf = $fcda591c8cd139a4$var$picker(pickCurrency, 'currency');
    const totals = {};
    for (const row of rows || []){
        const raw = amountOf(row);
        if (raw == null || raw === '') continue;
        const amount = Number(raw);
        if (!Number.isFinite(amount)) continue;
        const code = $fcda591c8cd139a4$export$b91dea8e61ccd7ef(currencyOf(row));
        totals[code] = (totals[code] || 0) + amount;
    }
    return totals;
}


'use client';
// The one money field. Everywhere in Parsina a human types a price, it types it here.
//
// Three things it does that a plain <input> cannot:
//
//   1. **Thousands separators as you type.** «500000» reads back as «۵۰۰٬۰۰۰».
//      Native <input type="number"> can't render a separator at all (the browser
//      rejects the comma), so this is a text input that DISPLAYS the grouped string
//      and reports the bare numeric one.
//   2. **The numerals of the language on screen.** Persian digits under `fa`, Latin
//      under `en`, each with that locale's own separators — resolved from CLDR, so
//      nothing here branches on a locale id. See `numeralsFor`.
//   3. **The unit, always.** A money field with no unit is how a rial figure ends up
//      read as toman; the label defaults rather than being optional.
//
// Value in and value out are both the BARE ASCII numeric string — «500000», never
// «۵۰۰٬۰۰۰». Localised digits exist only between here and the DOM, so no form, no
// parse and no toman↔rial conversion downstream sees them. onChange is handed that
// string directly, not an event: `onChange={setAmount}`.
//
// It preserves the caret across regrouping: inserting a digit that pushes a new
// separator in would otherwise fling the cursor to the end. We remember how many
// digits sat to the left of the caret and put it back after the same digit once
// React re-renders.
// The default chip. IRR — and no currency at all, which IS IRR — reads the kit's
// localised toman, exactly as before `currency` existed. Any other clinic currency
// reads its short form from the currency table («USD», «KWD»), because a non-IRR
// clinic must never see «تومان» beside its money. Anything that is not a currency
// («پارسه», a percentage) is still the caller's `unitLabel`.
const $b90d527c31e5b4da$var$unitLabelFor = (locale, info)=>info.code === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e) ? (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).toman : (0, $fcda591c8cd139a4$export$846d8329e0c3da65)(info.code, locale, 'short');
// At most `places` digits after the decimal point. Applied only to a non-IRR
// currency: an IRR field (a toman price, a percentage discount) keeps what it
// always accepted.
function $b90d527c31e5b4da$var$limitFraction(raw, places) {
    const dot = raw.indexOf('.');
    return dot < 0 || raw.length - dot - 1 <= places ? raw : raw.slice(0, dot + 1 + places);
}
const $b90d527c31e5b4da$var$MoneyInput = ({ value: value, onChange: onChange, onBlur: onBlur, currency: // The clinic currency the figure is in. Omitted, blank or 'IRR' is today's toman
// field exactly. Another currency changes the default chip and allows up to its
// fraction digits. It never converts: value in and out stay DISPLAY units (toman,
// dollars), and the call site turns them into minor units with
// `currency.fromDisplay` — see docs/MONEY_INPUT.md §2.4 and §6.3.
currency, // Defaults to false for IRR and true for any other currency.
allowDecimal: allowDecimalProp, unit: // Unit — `unit` is a full node override, `unitLabel` just changes the text.
// `unit={null}` is the deliberate way to render none.
unit, unitLabel: unitLabel, // Locale — defaults to <html lang>, which every client sets via applyDocumentLocale.
locale: localeProp, label: // Chrome — the same contract as TextInput.
label, required: required, error: externalError, helperText: helperText, validate: validate, placeholder: placeholder, disabled: disabled = false, className: className, style: style, inputStyle: inputStyle, // Extra props (data-testid, aria-*, name…) land on the real control.
...rest })=>{
    const ref = (0, $acw62.useRef)(null);
    const caret = (0, $acw62.useRef)(null);
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // A pasted figure refused as ambiguous (see handlePaste); cleared by the next edit.
    const [pasteError, setPasteError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const locale = localeProp || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const numerals = (0, $acw62.useMemo)(()=>(0, $ca1f40e638c62a9a$export$20975da26e036f6b)(locale), [
        locale
    ]);
    // Throws INVALID_CURRENCY for a code outside the table rather than guessing.
    const info = (0, $fcda591c8cd139a4$export$272b829bb65f9e96)(currency);
    const isIrr = info.code === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
    const allowDecimal = allowDecimalProp ?? !isIrr;
    const clean = (text)=>{
        const raw = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(text, allowDecimal, numerals);
        return isIrr || !allowDecimal ? raw : $b90d527c31e5b4da$var$limitFraction(raw, info.maxDisplayDecimals);
    };
    const error = externalError || pasteError || (touched ? internalError : '');
    const display = (0, $ca1f40e638c62a9a$export$302430bce3371cb8)(value ?? '', numerals);
    // `unit === null` means "no unit, I mean it"; `undefined` means "you choose".
    const unitNode = unit !== undefined ? unit : unitLabel ?? $b90d527c31e5b4da$var$unitLabelFor(locale, info);
    const hasUnit = unitNode != null && unitNode !== '';
    // The chip is painted beside the digits, which a screen reader never connects to
    // the field — «۵۰۰٬۰۰۰» alone does not say toman. Describing the input by it is
    // what makes the unit part of the field for a non-sighted reader too. A caller's
    // own `aria-describedby` is kept, not replaced.
    const unitId = `${(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId()}-unit`;
    const describedBy = [
        rest['aria-describedby'],
        hasUnit ? unitId : null
    ].filter(Boolean).join(' ') || undefined;
    (0, $acw62.useLayoutEffect)(()=>{
        if (caret.current != null && ref.current) {
            ref.current.setSelectionRange(caret.current, caret.current);
            caret.current = null;
        }
    });
    const handleChange = (e)=>{
        const el = e.target;
        // How many MEANINGFUL characters sat left of the caret — digits, plus the
        // decimal mark when one is allowed. Counting digits alone parks the caret
        // before a just-typed decimal mark, so «1.5» lands as «1.» + «5» = «15.».
        const keptLeft = (0, $ca1f40e638c62a9a$export$8a2f5adb56df4f49)(el.value.slice(0, el.selectionStart ?? el.value.length), allowDecimal, numerals).length;
        const raw = clean(el.value);
        const grouped = (0, $ca1f40e638c62a9a$export$302430bce3371cb8)(raw, numerals);
        // Walk the regrouped string until that many are behind us; the separators it
        // inserted are skipped over. `\p{Nd}` rather than an ASCII range: «۵» is a
        // digit too, and an ASCII test flings the caret to the end in Persian.
        const isKept = (ch)=>/\p{Nd}/u.test(ch) || allowDecimal && ch === numerals.decimal;
        let pos = 0, seen = 0;
        while(pos < grouped.length && seen < keptLeft){
            if (isKept(grouped[pos])) seen++;
            pos++;
        }
        caret.current = pos;
        if (pasteError) setPasteError('');
        onChange(raw);
    };
    // Under a language that GROUPS with «.» (German) every dot is a group mark, which
    // is what the field prints as it regroups. A pasted «12.50» or «1.5» — an English
    // decimal — would silently store 1250 or 15, a hundred or ten times the amount, so
    // a paste whose dots are not groups of three is refused with the kit's «not a valid
    // number», as `currency.parseAmount(…, 'de')` refuses it. «1.234» and «1.234,5»
    // paste as before. No other language groups with «.», so none is affected.
    const handlePaste = (e)=>{
        rest.onPaste?.(e);
        if (e.defaultPrevented || numerals.group !== '.') return;
        const text = e.clipboardData?.getData('text') ?? '';
        if ((0, $ca1f40e638c62a9a$export$bb91f232d86bf745)(text, numerals)) return;
        e.preventDefault();
        setPasteError((0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).number.invalid);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ...rest,
        ref: ref,
        type: "text",
        inputMode: allowDecimal ? 'decimal' : 'numeric',
        // A number is an LTR run even inside an RTL form — the same rule that
        // keeps phone numbers and codes readable.
        dir: "ltr",
        value: display,
        onChange: handleChange,
        onPaste: handlePaste,
        "aria-describedby": describedBy,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full h-11 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none transition-[border-color,box-shadow] duration-150', hasUnit ? 'pr-3.5 pl-11' : 'px-3.5', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70', className),
        style: inputStyle
    }), hasUnit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: unitId,
        className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[11px] font-semibold text-muted-foreground pointer-events-none select-none"
    }, unitNode)));
};
var $b90d527c31e5b4da$export$2e2bcd8739ae039 = $b90d527c31e5b4da$var$MoneyInput;



var $acw62 = parcelRequire("acw62");


'use client';
const $26a45cd6e1b19edd$var$Textarea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, placeholder: placeholder, rows: rows = 3, maxLength: maxLength, showCount: showCount = false, validate: validate, disabled: disabled = false, style: style, inputStyle: // `style` dresses the FIELD (label + control + helper); `inputStyle` reaches
// the control itself — the same split `TextInput` already has. It exists for
// the mobile rule that a field's type must be ≥1rem or iOS zooms the page on
// focus (DESIGN-CONCEPT-MOBILE §6), which the 13.5px default is under.
inputStyle, dir: // Unset: inherits the document's direction (§16.3). It defaulted to 'rtl',
// which pinned every note field in the product to RTL whatever the language.
dir, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        placeholder: placeholder,
        disabled: disabled,
        rows: rows,
        maxLength: maxLength,
        dir: dir,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('w-full px-3.5 py-3 rounded-lg font-sans text-[13.5px] text-foreground', 'bg-white border-[1.5px] outline-none resize-none leading-7', 'transition-[border-color,box-shadow] duration-150', showCount && maxLength && 'pb-6', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70'),
        style: inputStyle
    }), showCount && maxLength && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute bottom-2 end-3 text-[10.5px] text-muted-foreground pointer-events-none select-none"
    }, (value || '').length, "/", maxLength)));
});
$26a45cd6e1b19edd$var$Textarea.displayName = 'Textarea';
var $26a45cd6e1b19edd$export$2e2bcd8739ae039 = $26a45cd6e1b19edd$var$Textarea;



var $acw62 = parcelRequire("acw62");



'use client';
const $2f997edd3d0e9220$var$Select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, onBlur: onBlur, options: options = [], placeholder: placeholder, validate: validate, disabled: disabled = false, style: style, // Extra props (data-testid, aria-*, inputMode…) land on the real control:
// §17.2 requires a kit component to forward them, and these did not.
...rest }, ref)=>{
    if (placeholder === undefined) placeholder = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().select.placeholder;
    const generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const controlId = rest.id || generatedId;
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        htmlFor: controlId,
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        ref: ref,
        id: controlId,
        "aria-describedby": error || helperText ? `${controlId}-message` : undefined,
        "aria-invalid": error ? true : undefined,
        ...rest,
        value: value,
        onChange: onChange,
        onBlur: (e)=>{
            setTouched(true);
            if (validate) setInternalError(validate(value) || '');
            onBlur?.(e);
        },
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// Logical padding, and no `dir` of its own: the room for the chevron
        // is on the field's END edge, whichever side that is. It used to be
        // `dir="rtl"` + `pr-3.5 pl-8`, which put a Persian-shaped control
        // inside an English page and the chevron on top of the text.
        'w-full h-11 ps-3.5 pe-8 rounded-lg font-sans text-[13.5px]', 'bg-white border-[1.5px] outline-none appearance-none cursor-pointer', 'transition-[border-color,box-shadow] duration-150', value ? 'text-foreground' : 'text-muted-foreground', error ? 'border-destructive shadow-ring-red focus:shadow-ring-red' : 'border-border focus:border-primary focus:shadow-ring-navy', disabled && 'bg-muted cursor-not-allowed opacity-70')
    }, placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), options.map((o)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: o.value,
            value: o.value
        }, o.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": "true",
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "15",
        height: "15"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    })))));
});
$2f997edd3d0e9220$var$Select.displayName = 'Select';
var $2f997edd3d0e9220$export$2e2bcd8739ae039 = $2f997edd3d0e9220$var$Select;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// src/create-context.tsx

var $acw62 = parcelRequire("acw62");

function $45e038b71f97d914$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $acw62.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $acw62.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $acw62.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $45e038b71f97d914$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $acw62.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            const { scope: scope, children: children, ...context } = props;
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const value = $acw62.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            const Context = scope?.[scopeName]?.[index] || BaseContext;
            const context = $acw62.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $acw62.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = scope?.[scopeName] || scopeContexts;
            return $acw62.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $45e038b71f97d914$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $45e038b71f97d914$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $acw62.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}


// src/primitive.tsx

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// src/slot.tsx

var $acw62 = parcelRequire("acw62");
// src/compose-refs.tsx

var $acw62 = parcelRequire("acw62");
function $fb3356a19a5676fa$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $fb3356a19a5676fa$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $fb3356a19a5676fa$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $fb3356a19a5676fa$var$setRef(refs[i], null);
            }
        };
    };
}
function $fb3356a19a5676fa$export$c7b2cbe3552a0d05(...refs) {
    return $acw62.useCallback($fb3356a19a5676fa$export$43e446d32b3d21af(...refs), refs);
}


// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $acw62.forwardRef((props, forwardedRef)=>{
        let { children: children, ...slotProps } = props;
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        if ($cf381de56a25bc52$var$isLazyComponent(children) && typeof $cf381de56a25bc52$var$use === "function") children = $cf381de56a25bc52$var$use(children._payload);
        $acw62.Children.forEach(children, (maybeSlottable)=>{
            if ($cf381de56a25bc52$var$isSlottable(maybeSlottable)) {
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                if ($cf381de56a25bc52$var$isLazyComponent(child) && typeof $cf381de56a25bc52$var$use === "function") child = $cf381de56a25bc52$var$use(child._payload);
                slottableElement = $cf381de56a25bc52$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement?.props?.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $acw62.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $acw62.Children.count(children) === 1 && $acw62.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $cf381de56a25bc52$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $cf381de56a25bc52$var$createSlottableError(ownerName) : $cf381de56a25bc52$var$createSlotError(ownerName));
            return children;
        }
        const mergedProps = $cf381de56a25bc52$var$mergeProps(slotProps, slottableElement.props ?? {});
        if (slottableElement.type !== $acw62.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $acw62.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
var $cf381de56a25bc52$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $cf381de56a25bc52$export$e88b45bda5c13eb9("Slot");
var $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $cf381de56a25bc52$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = (props)=>"child" in props ? props.children(props.child) : props.children;
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
var $cf381de56a25bc52$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $cf381de56a25bc52$export$bf68c29d8281d0f7("Slottable");
var $cf381de56a25bc52$var$getSlottableElementFromSlottable = (slottable, child)=>{
    if ("child" in slottable.props) {
        const child2 = slottable.props.child;
        if (!$acw62.isValidElement(child2)) return null;
        return $acw62.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
    }
    return $acw62.isValidElement(child) ? child : null;
};
function $cf381de56a25bc52$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $cf381de56a25bc52$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
function $cf381de56a25bc52$var$isSlottable(child) {
    return $acw62.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $cf381de56a25bc52$var$SLOTTABLE_IDENTIFIER;
}
var $cf381de56a25bc52$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $cf381de56a25bc52$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $cf381de56a25bc52$var$REACT_LAZY_TYPE && "_payload" in element && $cf381de56a25bc52$var$isPromiseLike(element._payload);
}
function $cf381de56a25bc52$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
var $cf381de56a25bc52$var$createSlotError = (ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
};
var $cf381de56a25bc52$var$createSlottableError = (ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
};
var $cf381de56a25bc52$var$use = $acw62[" use ".trim().toString()];



var $dc7d5df3de21cdcb$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $dc7d5df3de21cdcb$export$250ffa63cdc0d034 = $dc7d5df3de21cdcb$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $acw62.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $dc7d5df3de21cdcb$export$6d1a0317bde7de7f(target, event) {
    if (target) $1u0KT.flushSync(()=>target.dispatchEvent(event));
}
var $dc7d5df3de21cdcb$export$be92b6f5f03c0fe9 = $dc7d5df3de21cdcb$export$250ffa63cdc0d034;



var $acw62 = parcelRequire("acw62");
// src/primitive.tsx
var $b4e9a20689651e16$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $b4e9a20689651e16$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $b4e9a20689651e16$export$f21a1ffae260145a(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    return element?.ownerDocument?.defaultView ?? window;
}
function $b4e9a20689651e16$export$b204af158042fbac(element) {
    if (!$b4e9a20689651e16$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    return element?.ownerDocument ?? document;
}
function $b4e9a20689651e16$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $b4e9a20689651e16$export$b204af158042fbac(node);
    if (!activeElement?.nodeName) return null;
    if ($b4e9a20689651e16$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $b4e9a20689651e16$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $b4e9a20689651e16$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
function $b4e9a20689651e16$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}



var $acw62 = parcelRequire("acw62");




"use client";
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = $acw62.useRef(null);
        const itemMap = $acw62.useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        $acw62.useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = $acw62.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var $a9634733d4b9bce9$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $a9634733d4b9bce9$var$OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $a9634733d4b9bce9$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($a9634733d4b9bce9$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $a9634733d4b9bce9$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $a9634733d4b9bce9$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $a9634733d4b9bce9$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function $a9634733d4b9bce9$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function $a9634733d4b9bce9$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function $a9634733d4b9bce9$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $a9634733d4b9bce9$var$OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = $acw62.useRef(null);
        const [collectionElement, setCollectionElement] = $acw62.useState(null);
        const composeRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        $acw62.useEffect(()=>{
            if (!collectionElement) return;
            const observer = $a9634733d4b9bce9$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $acw62.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = $acw62.useRef(null);
        const [element, setElement] = $acw62.useState(null);
        const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = $acw62.useRef(itemData);
        if (!$a9634733d4b9bce9$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        $acw62.useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $a9634733d4b9bce9$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return $acw62.useState(new $a9634733d4b9bce9$var$OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function $a9634733d4b9bce9$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $a9634733d4b9bce9$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $a9634733d4b9bce9$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $a9634733d4b9bce9$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function $a9634733d4b9bce9$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}




// src/id.tsx

var $acw62 = parcelRequire("acw62");
// src/use-layout-effect.tsx

var $acw62 = parcelRequire("acw62");
var $b68d88740313b08e$export$e5c5a5f917a5871c = globalThis?.document ? $acw62.useLayoutEffect : ()=>{};


var $11885ec535b13ccc$var$useReactId = $acw62[" useId ".trim().toString()] || (()=>void 0);
var $11885ec535b13ccc$var$count = 0;
function $11885ec535b13ccc$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $acw62.useState($11885ec535b13ccc$var$useReactId());
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId ?? String($11885ec535b13ccc$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



// src/use-callback-ref.tsx

var $acw62 = parcelRequire("acw62");
function $95d2d9f03fd0d4db$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $acw62.useRef(callback);
    $acw62.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>callbackRef.current?.(...args), []);
}


// src/use-controllable-state.tsx

var $acw62 = parcelRequire("acw62");

// src/use-effect-event.tsx


var $acw62 = parcelRequire("acw62");
var $07b0b1ce13d5e29f$var$useReactEffectEvent = $acw62[" useEffectEvent ".trim().toString()];
var $07b0b1ce13d5e29f$var$useReactInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()];
function $07b0b1ce13d5e29f$export$7f54fc3180508a52(callback) {
    if (typeof $07b0b1ce13d5e29f$var$useReactEffectEvent === "function") return $07b0b1ce13d5e29f$var$useReactEffectEvent(callback);
    const ref = $acw62.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $07b0b1ce13d5e29f$var$useReactInsertionEffect === "function") $07b0b1ce13d5e29f$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $acw62.useMemo(()=>(...args)=>ref.current?.(...args), []);
}


var $aef12de5508fd46e$var$useInsertionEffect = $acw62[" useInsertionEffect ".trim().toString()] || (0, $b68d88740313b08e$export$e5c5a5f917a5871c);
function $aef12de5508fd46e$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{}, caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $aef12de5508fd46e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    {
        const isControlledRef = $acw62.useRef(prop !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $acw62.useCallback((nextValue)=>{
        if (isControlled) {
            const value2 = $aef12de5508fd46e$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) onChangeRef.current?.(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
function $aef12de5508fd46e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $acw62.useState(defaultProp);
    const prevValueRef = $acw62.useRef(value);
    const onChangeRef = $acw62.useRef(onChange);
    $aef12de5508fd46e$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== value) {
            onChangeRef.current?.(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
function $aef12de5508fd46e$var$isFunction(value) {
    return typeof value === "function";
}
var $aef12de5508fd46e$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $aef12de5508fd46e$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $07b0b1ce13d5e29f$export$7f54fc3180508a52)(onChangeProp);
    {
        const isControlledRef = $acw62.useRef(controlledState !== void 0);
        $acw62.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        {
            ...initialArg,
            state: defaultProp
        }
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $acw62.useReducer((state2, action)=>{
        if (action.type === $aef12de5508fd46e$var$SYNC_STATE) return {
            ...state2,
            state: action.state
        };
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $acw62.useRef(uncontrolledState);
    $acw62.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $acw62.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return {
            ...internalState,
            state: controlledState
        };
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $acw62.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $aef12de5508fd46e$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}



var $acw62 = parcelRequire("acw62");

"use client";
var $f9ad7d2f57cc5bec$var$DirectionContext = $acw62.createContext(void 0);
var $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($f9ad7d2f57cc5bec$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($f9ad7d2f57cc5bec$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;



"use client";
var $0483c88073bf4923$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $0483c88073bf4923$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0483c88073bf4923$var$GROUP_NAME = "RovingFocusGroup";
var [$0483c88073bf4923$var$Collection, $0483c88073bf4923$var$useCollection, $0483c88073bf4923$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($0483c88073bf4923$var$GROUP_NAME);
var [$0483c88073bf4923$var$createRovingFocusGroupContext, $0483c88073bf4923$export$c7109489551a4f4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($0483c88073bf4923$var$GROUP_NAME, [
    $0483c88073bf4923$var$createCollectionScope
]);
var [$0483c88073bf4923$var$RovingFocusProvider, $0483c88073bf4923$var$useRovingFocusContext] = $0483c88073bf4923$var$createRovingFocusGroupContext($0483c88073bf4923$var$GROUP_NAME);
var $0483c88073bf4923$export$8699f7c8af148338 = $acw62.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$0483c88073bf4923$export$8699f7c8af148338.displayName = $0483c88073bf4923$var$GROUP_NAME;
var $0483c88073bf4923$var$RovingFocusGroupImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId ?? null,
        onChange: onCurrentTabStopIdChange,
        caller: $0483c88073bf4923$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $acw62.useState(false);
    const handleEntryFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $acw62.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $acw62.useState(0);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($0483c88073bf4923$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $acw62.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $acw62.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $acw62.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($0483c88073bf4923$var$ENTRY_FOCUS, $0483c88073bf4923$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $0483c88073bf4923$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $0483c88073bf4923$var$ITEM_NAME = "RovingFocusGroupItem";
var $0483c88073bf4923$export$ab9df7c53fe8454 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children, ...itemProps } = props;
    const autoId = (0, $11885ec535b13ccc$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $0483c88073bf4923$var$useRovingFocusContext($0483c88073bf4923$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $0483c88073bf4923$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    $acw62.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $0483c88073bf4923$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $0483c88073bf4923$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$0483c88073bf4923$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        })
    });
});
$0483c88073bf4923$export$ab9df7c53fe8454.displayName = $0483c88073bf4923$var$ITEM_NAME;
var $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $0483c88073bf4923$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $0483c88073bf4923$var$getFocusIntent(event, orientation, dir) {
    const key = $0483c88073bf4923$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $0483c88073bf4923$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $0483c88073bf4923$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $0483c88073bf4923$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $0483c88073bf4923$export$be92b6f5f03c0fe9 = $0483c88073bf4923$export$8699f7c8af148338;
var $0483c88073bf4923$export$6d08773d2e66f8f2 = $0483c88073bf4923$export$ab9df7c53fe8454;



var $acw62 = parcelRequire("acw62");




"use client";
var $62b265af90252982$var$NAME = "Toggle";
var $62b265af90252982$export$bea8ebba691c5813 = $acw62.forwardRef((props, forwardedRef)=>{
    const { pressed: pressedProp, defaultPressed: defaultPressed, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed, setPressed] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed ?? false,
        caller: $62b265af90252982$var$NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
});
$62b265af90252982$export$bea8ebba691c5813.displayName = $62b265af90252982$var$NAME;
var $62b265af90252982$export$be92b6f5f03c0fe9 = $62b265af90252982$export$bea8ebba691c5813;





"use client";
var $57c1675cf83b8426$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$57c1675cf83b8426$var$createToggleGroupContext, $57c1675cf83b8426$export$d1c7c4bcd9f26dd4] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($57c1675cf83b8426$var$TOGGLE_GROUP_NAME, [
    (0, $0483c88073bf4923$export$c7109489551a4f4)
]);
var $57c1675cf83b8426$var$useRovingFocusGroupScope = (0, $0483c88073bf4923$export$c7109489551a4f4)();
var $57c1675cf83b8426$export$be92b6f5f03c0fe9 = $acw62.forwardRef((props, forwardedRef)=>{
    const { type: type, ...toggleGroupProps } = props;
    if (type === "single") {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplSingle, {
            role: "radiogroup",
            ...singleProps,
            ref: forwardedRef
        });
    }
    if (type === "multiple") {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImplMultiple, {
            role: "toolbar",
            ...multipleProps,
            ref: forwardedRef
        });
    }
    throw new Error(`Missing prop \`type\` expected on \`${$57c1675cf83b8426$var$TOGGLE_GROUP_NAME}\``);
});
$57c1675cf83b8426$export$be92b6f5f03c0fe9.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupValueProvider, $57c1675cf83b8426$var$useToggleGroupValueContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImplSingle = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? "",
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: $acw62.useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemActivate: setValue,
        onItemDeactivate: $acw62.useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupSingleProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ToggleGroupImplMultiple = $acw62.forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupMultipleProps } = props;
    const [value, setValue] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue ?? [],
        onChange: onValueChange,
        caller: $57c1675cf83b8426$var$TOGGLE_GROUP_NAME
    });
    const handleButtonActivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = $acw62.useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupImpl, {
            ...toggleGroupMultipleProps,
            ref: forwardedRef
        })
    });
});
$57c1675cf83b8426$export$be92b6f5f03c0fe9.displayName = $57c1675cf83b8426$var$TOGGLE_GROUP_NAME;
var [$57c1675cf83b8426$var$ToggleGroupContext, $57c1675cf83b8426$var$useToggleGroupContext] = $57c1675cf83b8426$var$createToggleGroupContext($57c1675cf83b8426$var$TOGGLE_GROUP_NAME);
var $57c1675cf83b8426$var$ToggleGroupImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true, ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const commonProps = {
        dir: direction,
        ...toggleGroupProps
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$be92b6f5f03c0fe9, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
                ...commonProps,
                ref: forwardedRef
            })
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            ...commonProps,
            ref: forwardedRef
        })
    });
});
var $57c1675cf83b8426$var$ITEM_NAME = "ToggleGroupItem";
var $57c1675cf83b8426$export$6d08773d2e66f8f2 = $acw62.forwardRef((props, forwardedRef)=>{
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $57c1675cf83b8426$var$useToggleGroupContext($57c1675cf83b8426$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $57c1675cf83b8426$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = $acw62.useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($0483c88073bf4923$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
            ...commonProps,
            ref: forwardedRef
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($57c1675cf83b8426$var$ToggleGroupItemImpl, {
        ...commonProps,
        ref: forwardedRef
    });
});
$57c1675cf83b8426$export$6d08773d2e66f8f2.displayName = $57c1675cf83b8426$var$ITEM_NAME;
var $57c1675cf83b8426$var$ToggleGroupItemImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, value: value, ...itemProps } = props;
    const valueContext = $57c1675cf83b8426$var$useToggleGroupValueContext($57c1675cf83b8426$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $62b265af90252982$export$bea8ebba691c5813), {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    });
});




'use client';
const $43f8655df02249d5$var$ToggleGroup = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57c1675cf83b8426$export$be92b6f5f03c0fe9, {
        type: "single",
        value: value,
        onValueChange: (v)=>{
            if (!v) return;
            onChange(v);
            setTouched(true);
            if (validate) setInternalError(validate(v) || '');
        },
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex gap-1.5 p-1 rounded-xl bg-[#f4f6f9]', error && 'ring-[1.5px] ring-destructive')
    }, options.map((opt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($57c1675cf83b8426$export$6d08773d2e66f8f2, {
            key: opt.value,
            value: opt.value,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex-1 h-[38px] rounded-[9px] font-sans text-[13px]', 'flex items-center justify-center gap-1.5', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', 'data-[state=on]:bg-white data-[state=on]:text-navy data-[state=on]:font-bold data-[state=on]:shadow-sm', 'data-[state=off]:bg-transparent data-[state=off]:text-muted-foreground data-[state=off]:font-medium', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "text-[15px]"
        }, opt.icon), opt.label))));
};
var $43f8655df02249d5$export$2e2bcd8739ae039 = $43f8655df02249d5$var$ToggleGroup;



var $acw62 = parcelRequire("acw62");


'use client';
const $fcaca06c97c91379$var$ChipSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], multi: multi = false, activeColor: activeColor = 'var(--p-navy)', activeBg: activeBg = 'hsl(var(--accent))', validate: validate, disabled: disabled = false, style: style, touch: // `touch` sizes the chips for a finger (2.75rem); `testId` names the row and,
// with each option's `testKey` (else its value), every chip in it; `children`
// follow the chips in the same row — a «more» toggle belongs there.
touch = false, testId: testId, children: children })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const isActive = (v)=>multi ? (value || []).includes(v) : value === v;
    const handleToggle = (optValue)=>{
        if (disabled) return;
        let next;
        if (multi) {
            const arr = value || [];
            next = arr.includes(optValue) ? arr.filter((v)=>v !== optValue) : [
                ...arr,
                optValue
            ];
        } else next = value === optValue ? '' : optValue;
        onChange(next);
        setTouched(true);
        if (validate) setInternalError(validate(next) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap gap-1.5",
        "data-testid": testId
    }, options.map((opt)=>{
        const active = isActive(opt.value);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleToggle(opt.value),
            disabled: disabled,
            "aria-pressed": active,
            title: opt.title,
            "data-testid": testId ? `${testId}-${opt.testKey ?? opt.value}` : undefined,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)(touch ? 'min-h-11' : 'h-[34px]', 'px-3.5 rounded-full font-sans text-xs whitespace-nowrap', 'border-[1.5px] transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', error && !active && 'border-destructive', !error && !active && 'border-border text-[#5a6780] font-medium', disabled && 'cursor-not-allowed opacity-50'),
            style: active ? {
                borderColor: activeColor,
                background: activeBg,
                color: activeColor,
                fontWeight: 700
            } : undefined
        }, opt.label);
    }), children));
};
var $fcaca06c97c91379$export$2e2bcd8739ae039 = $fcaca06c97c91379$var$ChipSelector;



var $acw62 = parcelRequire("acw62");


'use client';
const $995baf94da7c0c12$var$CardSelector = ({ label: label, required: required, error: externalError, helperText: helperText, value: value, onChange: onChange, options: options = [], columns: columns = 4, validate: validate, disabled: disabled = false, style: style })=>{
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [internalError, setInternalError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const error = externalError || (touched ? internalError : '');
    const handleSelect = (v)=>{
        if (disabled) return;
        onChange(v);
        setTouched(true);
        if (validate) setInternalError(validate(v) || '');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        error: error,
        helperText: helperText,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "grid gap-2",
        style: {
            gridTemplateColumns: `repeat(${columns}, 1fr)`
        }
    }, options.map((opt)=>{
        const active = value === opt.value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            onClick: ()=>handleSelect(opt.value),
            disabled: disabled,
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('py-3.5 px-2 rounded-xl border-[1.5px] text-center font-sans', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring', active ? 'border-navy bg-accent text-navy shadow-sm' : error ? 'border-destructive bg-white text-muted-foreground' : 'border-border bg-white text-muted-foreground', disabled && 'cursor-not-allowed opacity-50')
        }, opt.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "text-xl mb-1.5 leading-none"
        }, opt.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-[11px] leading-snug', active ? 'font-bold' : 'font-medium')
        }, opt.label));
    })));
};
var $995baf94da7c0c12$export$2e2bcd8739ae039 = $995baf94da7c0c12$var$CardSelector;



var $acw62 = parcelRequire("acw62");


'use client';
// A search box is a *labelled control*, and a filter toolbar needs to be
// selectable in tests (§15.1) — so the wrapper takes the rest props
// (`data-testid`, `id`, …) and the input takes the ones that belong to a text
// field (`aria-label`, `onKeyDown`, `name`, `autoFocus`, `disabled`).
// The clear button restores focus to the field: losing focus to <body> after
// clearing is a keyboard dead end.
const $318ef1f4a903d866$var$SearchInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ value: value, onChange: onChange, placeholder: placeholder, className: className, style: style, inputProps: inputProps, 'aria-label': ariaLabel, onKeyDown: onKeyDown, name: name, id: id, disabled: disabled = false, autoFocus: autoFocus, clearLabel: clearLabel, ...rest }, ref)=>{
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().search;
    if (placeholder === undefined) placeholder = copy.placeholder;
    if (clearLabel === undefined) clearLabel = copy.clear;
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The caller's ref wins; the internal one is what the clear button focuses.
    // A search box that a keyboard shortcut cannot focus is a search box the
    // keyboard-first flows (F3, `/`) have to reach by querySelector.
    const setRef = (node)=>{
        inputRef.current = node;
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('relative', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "absolute start-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        width: "15",
        height: "15",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: setRef,
        type: "search",
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        "aria-label": ariaLabel || placeholder,
        name: name,
        id: id,
        disabled: disabled,
        autoFocus: autoFocus,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// min-h-11 (2.75rem), not h-10: this control ships in mobile filter
        // toolbars, where DESIGN-CONCEPT-MOBILE §368 puts the floor at 44px.
        'w-full min-h-11 ps-9 pe-8 rounded-lg font-sans text-[13px] text-foreground', 'bg-white border-[1.5px] border-border outline-none', 'transition-[border-color,box-shadow] duration-150', 'focus:border-primary focus:shadow-ring-navy', 'placeholder:text-muted-foreground', disabled && 'opacity-50 cursor-not-allowed', // The native search affordance would sit on top of our clear button.
        '[&::-webkit-search-cancel-button]:appearance-none'),
        ...inputProps
    }), value && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": clearLabel,
        onClick: ()=>{
            onChange({
                target: {
                    value: ''
                }
            });
            inputRef.current?.focus();
        },
        className: "absolute end-2.5 top-1/2 -translate-y-1/2 flex p-0.5 rounded text-muted-foreground hover:text-foreground transition-colors"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "13",
        height: "13",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))));
});
$318ef1f4a903d866$var$SearchInput.displayName = 'SearchInput';
var $318ef1f4a903d866$export$2e2bcd8739ae039 = $318ef1f4a903d866$var$SearchInput;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");




// src/use-previous.tsx

var $acw62 = parcelRequire("acw62");
function $44b714300f6a50aa$export$5cae361ad82dce8b(value) {
    const ref = $acw62.useRef({
        value: value,
        previous: value
    });
    return $acw62.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}


// src/use-size.tsx

var $acw62 = parcelRequire("acw62");

function $db5ba6ddde57f255$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $acw62.useState(void 0);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



var $acw62 = parcelRequire("acw62");

"use client";
function $3207c0aa9f229d8f$var$useStateMachine(initialState, machine) {
    return $acw62.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
// src/presence.tsx
var $3207c0aa9f229d8f$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $3207c0aa9f229d8f$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $acw62.Children.only(children);
    const ref = $3207c0aa9f229d8f$var$useStableComposedRefs(presence.ref, $3207c0aa9f229d8f$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $acw62.cloneElement(child, {
        ref: ref
    }) : null;
};
$3207c0aa9f229d8f$export$99c2b779aa4e8b8b.displayName = "Presence";
function $3207c0aa9f229d8f$var$usePresence(present) {
    const [node, setNode] = $acw62.useState();
    const stylesRef = $acw62.useRef(null);
    const prevPresentRef = $acw62.useRef(present);
    const prevAnimationNameRef = $acw62.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $3207c0aa9f229d8f$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $acw62.useEffect(()=>{
        const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || styles?.display === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            const ownerWindow = node.ownerDocument.defaultView ?? window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $3207c0aa9f229d8f$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $acw62.useCallback((node2)=>{
            stylesRef.current = node2 ? getComputedStyle(node2) : null;
            setNode(node2);
        }, [])
    };
}
function $3207c0aa9f229d8f$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $3207c0aa9f229d8f$var$useStableComposedRefs(...refs) {
    const refsRef = $acw62.useRef(refs);
    refsRef.current = refs;
    return $acw62.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $3207c0aa9f229d8f$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $3207c0aa9f229d8f$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
function $3207c0aa9f229d8f$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $3207c0aa9f229d8f$var$getElementRef(element) {
    let getter = Object.getOwnPropertyDescriptor(element.props, "ref")?.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = Object.getOwnPropertyDescriptor(element, "ref")?.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $3207c0aa9f229d8f$export$be92b6f5f03c0fe9 = $3207c0aa9f229d8f$export$99c2b779aa4e8b8b;




"use client";
var $99e5d66a1fc753c6$var$CHECKBOX_NAME = "Checkbox";
var [$99e5d66a1fc753c6$var$createCheckboxContext, $99e5d66a1fc753c6$export$b566c4ff5488ea01] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($99e5d66a1fc753c6$var$CHECKBOX_NAME);
var [$99e5d66a1fc753c6$var$CheckboxProviderImpl, $99e5d66a1fc753c6$var$useCheckboxContext] = $99e5d66a1fc753c6$var$createCheckboxContext($99e5d66a1fc753c6$var$CHECKBOX_NAME);
function $99e5d66a1fc753c6$export$1335a92a9ee50a8d(props) {
    const { __scopeCheckbox: __scopeCheckbox, checked: checkedProp, children: children, defaultChecked: defaultChecked, disabled: disabled, form: form, name: name, onCheckedChange: onCheckedChange, required: required, value: value = "on", internal_do_not_use_render: // @ts-expect-error
    internal_do_not_use_render } = props;
    const [checked, setChecked] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked ?? false,
        onChange: onCheckedChange,
        caller: $99e5d66a1fc753c6$var$CHECKBOX_NAME
    });
    const [control, setControl] = $acw62.useState(null);
    const [bubbleInput, setBubbleInput] = $acw62.useState(null);
    const hasConsumerStoppedPropagationRef = $acw62.useRef(false);
    const isFormControl = control ? !!form || !!control.closest("form") : // We set this to true by default so that events bubble to forms without JS (SSR)
    true;
    const context = {
        checked: checked,
        disabled: disabled,
        setChecked: setChecked,
        control: control,
        setControl: setControl,
        name: name,
        form: form,
        value: value,
        hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef,
        required: required,
        defaultChecked: $99e5d66a1fc753c6$var$isIndeterminate(defaultChecked) ? false : defaultChecked,
        isFormControl: isFormControl,
        bubbleInput: bubbleInput,
        setBubbleInput: setBubbleInput
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$var$CheckboxProviderImpl, {
        scope: __scopeCheckbox,
        ...context,
        children: $99e5d66a1fc753c6$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    });
}
var $99e5d66a1fc753c6$var$TRIGGER_NAME = "CheckboxTrigger";
var $99e5d66a1fc753c6$export$1386466acbe59ca2 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, onKeyDown: onKeyDown, onClick: onClick, ...checkboxProps }, forwardedRef)=>{
    const { control: control, value: value, disabled: disabled, checked: checked, required: required, setControl: setControl, setChecked: setChecked, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, isFormControl: isFormControl, bubbleInput: bubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$TRIGGER_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setControl);
    const initialCheckedStateRef = $acw62.useRef(checked);
    $acw62.useEffect(()=>{
        const form = control?.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        control,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        role: "checkbox",
        "aria-checked": $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $99e5d66a1fc753c6$var$getState(checked),
        "data-disabled": disabled ? "" : void 0,
        disabled: disabled,
        value: value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onKeyDown, (event)=>{
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(onClick, (event)=>{
            setChecked((prevChecked)=>$99e5d66a1fc753c6$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (bubbleInput && isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    });
});
$99e5d66a1fc753c6$export$1386466acbe59ca2.displayName = $99e5d66a1fc753c6$var$TRIGGER_NAME;
var $99e5d66a1fc753c6$export$48513f6b9f8ce62d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value, onCheckedChange: onCheckedChange, form: form, ...checkboxProps } = props;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1335a92a9ee50a8d, {
        __scopeCheckbox: __scopeCheckbox,
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        required: required,
        onCheckedChange: onCheckedChange,
        name: name,
        form: form,
        value: value,
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$1386466acbe59ca2, {
                        ...checkboxProps,
                        ref: forwardedRef,
                        __scopeCheckbox: __scopeCheckbox
                    }),
                    isFormControl && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($99e5d66a1fc753c6$export$493083511fc9f964, {
                        __scopeCheckbox: __scopeCheckbox
                    })
                ]
            })
    });
});
$99e5d66a1fc753c6$export$48513f6b9f8ce62d.displayName = $99e5d66a1fc753c6$var$CHECKBOX_NAME;
var $99e5d66a1fc753c6$var$INDICATOR_NAME = "CheckboxIndicator";
var $99e5d66a1fc753c6$export$59aad738f51d1c05 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || $99e5d66a1fc753c6$var$isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).span, {
            "data-state": $99e5d66a1fc753c6$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$99e5d66a1fc753c6$export$59aad738f51d1c05.displayName = $99e5d66a1fc753c6$var$INDICATOR_NAME;
var $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var $99e5d66a1fc753c6$export$493083511fc9f964 = $acw62.forwardRef(({ __scopeCheckbox: __scopeCheckbox, ...props }, forwardedRef)=>{
    const { control: control, hasConsumerStoppedPropagationRef: hasConsumerStoppedPropagationRef, checked: checked, defaultChecked: defaultChecked, required: required, disabled: disabled, name: name, value: value, form: form, bubbleInput: bubbleInput, setBubbleInput: setBubbleInput } = $99e5d66a1fc753c6$var$useCheckboxContext($99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, setBubbleInput);
    const prevChecked = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $db5ba6ddde57f255$export$1ab7ae714698c4b8)(control);
    $acw62.useEffect(()=>{
        const input = bubbleInput;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        const bubbles = !hasConsumerStoppedPropagationRef.current;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $99e5d66a1fc753c6$var$isIndeterminate(checked);
            setChecked.call(input, $99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        bubbleInput,
        prevChecked,
        checked,
        hasConsumerStoppedPropagationRef
    ]);
    const defaultCheckedRef = $acw62.useRef($99e5d66a1fc753c6$var$isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).input, {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required: required,
        disabled: disabled,
        name: name,
        value: value,
        form: form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0,
            // We transform because the input is absolutely positioned but we have
            // rendered it **after** the button. This pulls it back to sit on top
            // of the button.
            transform: "translateX(-100%)"
        }
    });
});
$99e5d66a1fc753c6$export$493083511fc9f964.displayName = $99e5d66a1fc753c6$var$BUBBLE_INPUT_NAME;
function $99e5d66a1fc753c6$var$isFunction(value) {
    return typeof value === "function";
}
function $99e5d66a1fc753c6$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $99e5d66a1fc753c6$var$getState(checked) {
    return $99e5d66a1fc753c6$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}



'use client';
// `label` takes a node, not just a string: a picker row is a checkbox whose
// label IS the row (name, value, trend), and wrapping it here keeps the whole
// row inside the native <label> hit area instead of re-implementing one.
// `className`/rest land on that <label> so callers can carry the §15.1
// `data-testid` / `data-state` contract without a wrapper element.
const $7a6c6e1277da35de$var$Checkbox = ({ checked: checked, onChange: onChange, label: label, disabled: disabled = false, className: className, labelClassName: labelClassName, style: style, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center gap-2.5 select-none', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className),
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99e5d66a1fc753c6$export$48513f6b9f8ce62d, {
        checked: checked,
        onCheckedChange: onChange,
        disabled: disabled,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('h-[18px] w-[18px] shrink-0 rounded-[5px] border-[1.5px]', 'flex items-center justify-center', 'transition-all duration-150 outline-none', 'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', checked ? 'bg-navy border-navy' : 'bg-white border-border', disabled && 'opacity-50')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($99e5d66a1fc753c6$export$59aad738f51d1c05, {
        className: "flex items-center justify-center text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "11",
        height: "11"
    }, checked === 'indeterminate' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 11h14v2H5z"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })))), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-sm font-sans text-foreground', labelClassName)
    }, label));
var $7a6c6e1277da35de$export$2e2bcd8739ae039 = $7a6c6e1277da35de$var$Checkbox;



var $acw62 = parcelRequire("acw62");

'use client';
function $ddccb5e00ce1ba3b$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, label: label, description: description, disabled: disabled = false, id: id, ...rest }) {
    const reactId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const rowId = id || reactId;
    const labelId = `${rowId}-label`;
    const descId = description ? `${rowId}-desc` : undefined;
    // The kit styles inline, which cannot express :focus-visible — so the ring is
    // tracked here. Keyed on :focus-visible rather than :focus so a pointer tap
    // does not leave a ring behind, which is the behaviour the pseudo-class
    // exists to give. Setting only outlineColor (as this component did) paints
    // nothing: without an outline-style there is no outline to colour.
    const [focusRing, setFocusRing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 16,
            padding: '14px 0',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        id: labelId,
        htmlFor: rowId,
        style: {
            display: 'block',
            fontSize: 14,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            cursor: disabled ? 'not-allowed' : 'pointer'
        }
    }, label), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: descId,
        style: {
            display: 'block',
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        id: rowId,
        role: "switch",
        "aria-checked": checked,
        "aria-labelledby": labelId,
        "aria-describedby": descId,
        disabled: disabled,
        onClick: ()=>!disabled && onChange(!checked),
        onFocus: (e)=>{
            // `matches` can throw on engines without :focus-visible; a ring on
            // plain focus is a better failure than no ring at all.
            let visible = true;
            try {
                visible = e.target.matches(':focus-visible');
            } catch  {}
            setFocusRing(visible);
        },
        onBlur: ()=>setFocusRing(false),
        style: {
            width: 44,
            height: 24,
            borderRadius: 999,
            flexShrink: 0,
            padding: 0,
            border: `1px solid ${checked ? 'transparent' : '#cbd2dc'}`,
            background: checked ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : '#d1d5db',
            cursor: disabled ? 'not-allowed' : 'pointer',
            position: 'relative',
            transition: 'background 0.25s, box-shadow 0.15s',
            outline: 'none',
            boxShadow: focusRing ? `0 0 0 3px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.45)}` : 'none'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 2,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: 'white',
            transition: 'inset-inline-end 0.25s',
            insetInlineEnd: checked ? 2 : 22,
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            pointerEvents: 'none'
        }
    })));
}



var $acw62 = parcelRequire("acw62");

/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
const $7d867aa0bbfd521e$var$falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const $7d867aa0bbfd521e$export$a274e22fb40f762e = (0, $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
const $7d867aa0bbfd521e$export$87dc52566e90b739 = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants: variants, defaultVariants: defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = $7d867aa0bbfd521e$var$falsyToString(variantProp) || $7d867aa0bbfd521e$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return $7d867aa0bbfd521e$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };



'use client';
const $39b6a9e95398564b$export$dca1ee5a936bb312 = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)('inline-flex items-center justify-center gap-2 font-sans font-semibold rounded-lg transition-all duration-150 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 select-none', {
    variants: {
        variant: {
            default: 'bg-navy text-white hover:bg-navy-dark active:scale-[0.98]',
            destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90 active:scale-[0.98]',
            outline: 'border-[1.5px] border-border bg-white text-foreground hover:bg-muted active:scale-[0.98]',
            ghost: 'bg-transparent text-foreground hover:bg-muted',
            link: 'text-primary underline-offset-4 hover:underline',
            teal: 'bg-clinic-teal text-white hover:opacity-90 active:scale-[0.98]',
            // Tonal primary — a navy-tinted pill for secondary actions that still read
            // as brand (jump-to-today, filter chips) without the weight of a solid fill.
            subtle: 'bg-navy/5 text-navy border-[1.5px] border-navy/20 hover:bg-navy/10 active:scale-[0.98]',
            // A sidebar destination, on the deep-azure gradient rail. Selected state
            // arrives as `data-active="true"` (set it beside `aria-current="page"`),
            // NOT as a className the caller assembles: all four staff shells were
            // writing the same four overrides onto `variant="ghost"`, which §17.1
            // calls a fork of a kit component. The active pill is the brand
            // gradient — the single lit moment on a deliberately teal-free rail.
            nav: 'w-full justify-start font-medium text-white/60 hover:bg-white/10 hover:text-white data-[active=true]:bg-gradient-brand data-[active=true]:text-white data-[active=true]:font-bold data-[active=true]:hover:bg-gradient-brand'
        },
        size: {
            default: 'h-11 px-5 text-[13.5px]',
            sm: 'h-9  px-4 text-xs rounded-md',
            lg: 'h-12 px-7 text-[15px]',
            icon: 'h-10 w-10'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const $39b6a9e95398564b$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, variant: variant, size: size, asChild: asChild = false, ...props }, ref)=>{
    const Comp = asChild ? (0, $cf381de56a25bc52$export$be92b6f5f03c0fe9) : 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)($39b6a9e95398564b$export$dca1ee5a936bb312({
            variant: variant,
            size: size
        }), className),
        ...props
    });
});
$39b6a9e95398564b$export$353f5b6fc5456de1.displayName = 'Button';
var $39b6a9e95398564b$export$2e2bcd8739ae039 = $39b6a9e95398564b$export$353f5b6fc5456de1;



var $acw62 = parcelRequire("acw62");


'use client';
const $ddd0c49a5377bd48$export$48443d129636634d = (0, $7d867aa0bbfd521e$export$87dc52566e90b739)('inline-flex items-center rounded-full font-sans font-semibold whitespace-nowrap', {
    variants: {
        variant: {
            default: 'bg-accent text-accent-foreground text-[11px] px-2.5 py-0.5',
            // The three pale chip pairs are CSS variables (tokens.css), not
            // literals. Same pixels; the point is that a theme can reach them —
            // every raw hex left in a component is a future dark-mode bug (§11).
            destructive: 'bg-[var(--chip-danger-bg)]  text-[var(--chip-danger-ink)]  text-[11px] px-2.5 py-0.5',
            success: 'bg-[var(--chip-success-bg)] text-[var(--chip-success-ink)] text-[11px] px-2.5 py-0.5',
            warning: 'bg-[var(--chip-warning-bg)] text-[var(--chip-warning-ink)] text-[11px] px-2.5 py-0.5',
            outline: 'border border-border text-foreground text-[11px] px-2.5 py-0.5',
            // `count` — the ONE unread/tally chip. A solid navy pill, not the pale
            // tint `default` gives: every conversation row in every app was
            // overriding `default` with the same inline `background`/`color` to get
            // this, which is the hand-rolled primitive rule in slow motion.
            // `tabular-nums` keeps «۱» and «۹+» the same width so a live count does
            // not jitter the row, and `min-w-5` keeps a single digit round.
            // The swatch is navy, matching `BottomNav`'s `badgeTone: 'count'` —
            // one colour means "unread" everywhere (see DESIGN.md, Messaging).
            // `var(--p-navy)` rather than the `bg-navy` hex so the chip follows the
            // doctor's accent preset exactly as `C.navy` (which BottomNav uses) does.
            count: 'bg-[var(--p-navy)] text-white text-[11px] font-bold leading-5 min-w-5 justify-center px-1.5 tabular-nums shrink-0'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
const $ddd0c49a5377bd48$export$37acb3580601e69a = ({ className: className, variant: variant, children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)($ddd0c49a5377bd48$export$48443d129636634d({
            variant: variant
        }), className),
        ...props
    }, children);
var $ddd0c49a5377bd48$export$2e2bcd8739ae039 = $ddd0c49a5377bd48$export$37acb3580601e69a;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");




// src/use-escape-keydown.tsx

var $acw62 = parcelRequire("acw62");

function $322b9f9e9e453dd6$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis?.document) {
    const onEscapeKeyDown = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $acw62.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $30a399657994b369$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $30a399657994b369$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $30a399657994b369$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $30a399657994b369$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $30a399657994b369$var$originalBodyPointerEvents;
var $30a399657994b369$var$DismissableLayerContext = $acw62.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $30a399657994b369$export$177fb62ff3ec1f22 = $acw62.forwardRef((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    const ownerDocument = node?.ownerDocument ?? globalThis?.document;
    const [, force] = $acw62.useState({});
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $acw62.useRef(false);
    const pointerDownOutside = $30a399657994b369$var$usePointerDownOutside((event)=>{
        const target = event.target;
        if (!(target instanceof Node)) return;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces
    });
    const focusOutside = $30a399657994b369$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside?.(event);
        onInteractOutside?.(event);
        if (!event.defaultPrevented) onDismiss?.();
    }, ownerDocument);
    (0, $322b9f9e9e453dd6$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown?.(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $acw62.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $30a399657994b369$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $30a399657994b369$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $30a399657994b369$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $30a399657994b369$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $acw62.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($30a399657994b369$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$30a399657994b369$export$177fb62ff3ec1f22.displayName = $30a399657994b369$var$DISMISSABLE_LAYER_NAME;
var $30a399657994b369$var$BRANCH_NAME = "DismissableLayerBranch";
var $30a399657994b369$export$4d5eb2109db14228 = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $acw62.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$30a399657994b369$export$4d5eb2109db14228.displayName = $30a399657994b369$var$BRANCH_NAME;
function $30a399657994b369$export$210785236bdfcb27() {
    const context = $acw62.useContext($30a399657994b369$var$DismissableLayerContext);
    const [node, setNode] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
function $30a399657994b369$var$usePointerDownOutside(onPointerDownOutside, args) {
    const { ownerDocument: ownerDocument = globalThis?.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces } = args;
    const handlePointerDownOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $acw62.useRef(false);
    const isPointerDownOutsideRef = $acw62.useRef(false);
    const interceptedOutsideInteractionEventsRef = $acw62.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $acw62.useRef(()=>{});
    $acw62.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $30a399657994b369$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis?.document) {
    const handleFocusOutside = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $30a399657994b369$var$handleAndDispatchCustomEvent($30a399657994b369$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $30a399657994b369$var$dispatchUpdate() {
    const event = new CustomEvent($30a399657994b369$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $30a399657994b369$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $dc7d5df3de21cdcb$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $30a399657994b369$export$be92b6f5f03c0fe9 = $30a399657994b369$export$177fb62ff3ec1f22;
var $30a399657994b369$export$aecb2ddcb55c95be = $30a399657994b369$export$4d5eb2109db14228;



var $acw62 = parcelRequire("acw62");




"use client";
var $03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $03c48a27777929a8$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $03c48a27777929a8$var$FOCUS_SCOPE_NAME = "FocusScope";
var $03c48a27777929a8$export$20e40289641fbbb6 = $acw62.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $acw62.useState(null);
    const onMountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $95d2d9f03fd0d4db$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $acw62.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $acw62.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $03c48a27777929a8$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $03c48a27777929a8$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $acw62.useEffect(()=>{
        if (container) {
            $03c48a27777929a8$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $03c48a27777929a8$var$focusFirst($03c48a27777929a8$var$removeLinks($03c48a27777929a8$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $03c48a27777929a8$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, $03c48a27777929a8$var$EVENT_OPTIONS);
                    container.addEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $03c48a27777929a8$var$focus(previouslyFocusedElement ?? document.body, {
                        select: true
                    });
                    container.removeEventListener($03c48a27777929a8$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $03c48a27777929a8$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $03c48a27777929a8$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $03c48a27777929a8$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$03c48a27777929a8$export$20e40289641fbbb6.displayName = $03c48a27777929a8$var$FOCUS_SCOPE_NAME;
function $03c48a27777929a8$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $03c48a27777929a8$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $03c48a27777929a8$var$getTabbableEdges(container) {
    const candidates = $03c48a27777929a8$var$getTabbableCandidates(container);
    const first = $03c48a27777929a8$var$findVisible(candidates, container);
    const last = $03c48a27777929a8$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $03c48a27777929a8$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $03c48a27777929a8$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$03c48a27777929a8$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $03c48a27777929a8$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $03c48a27777929a8$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $03c48a27777929a8$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $03c48a27777929a8$var$isSelectableInput(element) && select) element.select();
    }
}
var $03c48a27777929a8$var$focusScopesStack = $03c48a27777929a8$var$createFocusScopesStack();
function $03c48a27777929a8$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope?.pause();
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            stack = $03c48a27777929a8$var$arrayRemove(stack, focusScope);
            stack[0]?.resume();
        }
    };
}
function $03c48a27777929a8$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $03c48a27777929a8$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $03c48a27777929a8$export$be92b6f5f03c0fe9 = $03c48a27777929a8$export$20e40289641fbbb6;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



"use client";
var $95d053caea9c023a$var$PORTAL_NAME = "Portal";
var $95d053caea9c023a$export$602eac185826482c = $acw62.forwardRef((props, forwardedRef)=>{
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $acw62.useState(false);
    (0, $b68d88740313b08e$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && globalThis?.document?.body;
    return container ? $1u0KT.createPortal(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$95d053caea9c023a$export$602eac185826482c.displayName = $95d053caea9c023a$var$PORTAL_NAME;
var $95d053caea9c023a$export$be92b6f5f03c0fe9 = $95d053caea9c023a$export$602eac185826482c;





var $acw62 = parcelRequire("acw62");
"use client";
var $264faec0fdf8876a$var$count = 0;
var $264faec0fdf8876a$var$guards = null;
function $264faec0fdf8876a$export$ac5b58043b79449b(props) {
    $264faec0fdf8876a$export$b7ece24a22aeda8c();
    return props.children;
}
function $264faec0fdf8876a$export$b7ece24a22aeda8c() {
    $acw62.useEffect(()=>{
        if (!$264faec0fdf8876a$var$guards) $264faec0fdf8876a$var$guards = {
            start: $264faec0fdf8876a$var$createFocusGuard(),
            end: $264faec0fdf8876a$var$createFocusGuard()
        };
        const { start: start, end: end } = $264faec0fdf8876a$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $264faec0fdf8876a$var$count++;
        return ()=>{
            if ($264faec0fdf8876a$var$count === 1) {
                $264faec0fdf8876a$var$guards?.start.remove();
                $264faec0fdf8876a$var$guards?.end.remove();
                $264faec0fdf8876a$var$guards = null;
            }
            $264faec0fdf8876a$var$count = Math.max(0, $264faec0fdf8876a$var$count - 1);
        };
    }, []);
}
function $264faec0fdf8876a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $acw62 = parcelRequire("acw62");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $05ac61ef45da8ec5$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $9ce81be4473c2c96$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $dce67a1050af61cf$export$e13ec7dd7a14088d)();


var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $1ec01e2201501f3d$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $f6d5b57f3512e73c$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e),
    zeroRight: (0, $3f8d56f1a38c65c8$export$1da7500147d4bc3)
};




var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1334c25f36aeceaf$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $be1d9ed5bb532264$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $b5f767dd03f483e5$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $9f2b7a700f678519$var$Style = (0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $3f8d56f1a38c65c8$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " .").concat((0, $3f8d56f1a38c65c8$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " .").concat((0, $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $3f8d56f1a38c65c8$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $19c77eb414ad2a19$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;


var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $eb3b6a23a33fb1ba$export$c1248ee86ba532c8))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $a7f277057d6643d0$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $a7f277057d6643d0$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $6f0aa8d921410141$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $9f2b7a700f678519$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce)((0, $f6d5b57f3512e73c$export$e27363444bedfeac), (0, $f5f147098910888d$export$a09dbff87b5da2d));


var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $cac2578984d345ac$export$22940b497e769dee), (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $0e88b28988758ab2$export$2e2bcd8739ae039)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $cac2578984d345ac$export$22940b497e769dee).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;


var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $45e038b71f97d914$export$50c7b4e9d9f19c1)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [open, setOpen] = (0, $aef12de5508fd46e$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $eeaeb48e23f662e7$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        titleId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        descriptionId: (0, $11885ec535b13ccc$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$eeaeb48e23f662e7$export$3ddf2d174ce01153.displayName = $eeaeb48e23f662e7$var$DIALOG_NAME;
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$eeaeb48e23f662e7$export$2e1e1122cf0cba88.displayName = $eeaeb48e23f662e7$var$TRIGGER_NAME;
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $95d053caea9c023a$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$eeaeb48e23f662e7$export$dad7c95542bacce0.displayName = $eeaeb48e23f662e7$var$PORTAL_NAME;
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$eeaeb48e23f662e7$export$bd1d06c79be19e17.displayName = $eeaeb48e23f662e7$var$OVERLAY_NAME;
var $eeaeb48e23f662e7$var$Slot = (0, $cf381de56a25bc52$export$e88b45bda5c13eb9)("DialogOverlay.RemoveScroll");
var $eeaeb48e23f662e7$var$DialogOverlayImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    const registerDismissableSurface = (0, $30a399657994b369$export$210785236bdfcb27)();
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, registerDismissableSurface);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039), {
        as: $eeaeb48e23f662e7$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: composedRefs,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $3207c0aa9f229d8f$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$eeaeb48e23f662e7$export$7c6e2c02157bb7d2.displayName = $eeaeb48e23f662e7$var$CONTENT_NAME;
var $eeaeb48e23f662e7$var$DialogContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $fb3356a19a5676fa$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $4a7537e072260c10$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        onCloseAutoFocus: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $eeaeb48e23f662e7$var$DialogContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $eeaeb48e23f662e7$var$DialogContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    (0, $264faec0fdf8876a$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $03c48a27777929a8$export$20e40289641fbbb6), {
            asChild: true,
            loop: true,
            trapped: trapFocus,
            onMountAutoFocus: onOpenAutoFocus,
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $30a399657994b369$export$177fb62ff3ec1f22), {
                role: "dialog",
                id: context.contentId,
                "aria-describedby": context.descriptionId,
                "aria-labelledby": context.titleId,
                "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                ...contentProps,
                ref: forwardedRef,
                deferPointerDownOutside: true,
                onDismiss: ()=>context.onOpenChange(false)
            })
        })
    });
});
var $eeaeb48e23f662e7$var$TITLE_NAME = "DialogTitle";
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$16f7638e4a34b909.displayName = $eeaeb48e23f662e7$var$TITLE_NAME;
var $eeaeb48e23f662e7$var$DESCRIPTION_NAME = "DialogDescription";
var $eeaeb48e23f662e7$export$393edc798c47379d = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$393edc798c47379d.displayName = $eeaeb48e23f662e7$var$DESCRIPTION_NAME;
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $dc7d5df3de21cdcb$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $b4e9a20689651e16$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$eeaeb48e23f662e7$export$f39c2d165cd861fe.displayName = $eeaeb48e23f662e7$var$CLOSE_NAME;
var $eeaeb48e23f662e7$export$69b62a49393917d6 = (props)=>{
    return props.children;
};
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}



'use client';
const $ace11be13f1c53cf$export$3ddf2d174ce01153 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
const $ace11be13f1c53cf$export$2e1e1122cf0cba88 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
const $ace11be13f1c53cf$export$fba2fb7cd781b7ac = $eeaeb48e23f662e7$export$f39c2d165cd861fe;
const $ace11be13f1c53cf$export$dad7c95542bacce0 = $eeaeb48e23f662e7$export$dad7c95542bacce0;
// ── Overlay z-scale (keep these in sync; see DESIGN.md "Overlay layering") ──
// Drawer 11 < BottomSheet 1000 < Dialog/ConfirmDialog 1100 < Toast / JalaliDatePicker 9999
//
// The dialog layer MUST sit above BottomSheet: a ConfirmDialog is routinely opened from
// inside a sheet (destructive confirms, unsaved-changes guards). At the old z-50 it
// rendered *behind* the sheet while Radix's modal mode set `pointer-events: none` on
// <body> — so the sheet froze with an invisible modal trapping focus, unrecoverable by
// touch. Raising the dialog (rather than lowering the sheet) is the safe direction:
// mobile chrome that must stay under a sheet — the doctor app's MobileBottomNav (z-50)
// and MobileVisitClosureFlow (z-60) — keeps working unchanged.
const $ace11be13f1c53cf$var$Z_DIALOG = 'z-[1100]';
// A dialog is a transition the user asked for, so it animates — but §12.4 of the
// design concept says every transition collapses to instant under
// `prefers-reduced-motion`. Radix drives the animation through `data-state`
// classes, so the opt-out has to be a class too; without it the dialog was the
// one overlay that kept moving for a user who asked it not to.
const $ace11be13f1c53cf$var$MOTION_SAFE = 'motion-reduce:animate-none motion-reduce:transition-none';
const $ace11be13f1c53cf$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$bd1d06c79be19e17, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('fixed inset-0 bg-black/45', $ace11be13f1c53cf$var$Z_DIALOG, 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }));
$ace11be13f1c53cf$export$bd1d06c79be19e17.displayName = 'DialogOverlay';
// Floating layers portaled to <body> (e.g. the Jalali calendar popup) live outside the
// dialog's DOM, so Radix would treat interacting with them as an outside click and close
// the dialog mid-pick. Anything inside [data-jalali-popup] is ours, not "outside".
const $ace11be13f1c53cf$var$isInFloatingLayer = (e)=>e.target instanceof Element && e.target.closest('[data-jalali-popup]');
// ── Width ────────────────────────────────────────────────────────────────────
// Four widths rather than a free `className` override, because "how wide is a
// dialog" is a design-system decision: a confirm and a full review surface must
// not each pick their own number. `md` is the historical default, so every
// existing call site keeps its exact width.
const $ace11be13f1c53cf$var$SIZE = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-3xl',
    xl: 'max-w-[52rem]'
};
// ── Layout ───────────────────────────────────────────────────────────────────
// `scroll` (default) is the classic dialog: one padded box that scrolls as a
// whole. `frame` is the surface with its own chrome — a fixed header, a
// scrolling body and a docked footer — which is what a review/receipt overlay
// needs so its primary action never scrolls out of reach. The three slot
// components read the mode from context rather than taking a prop, so a caller
// cannot half-apply it.
const $ace11be13f1c53cf$var$LayoutContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext('scroll');
const $ace11be13f1c53cf$export$b6d9565de1e068cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, children: children, showClose: showClose = true, size: size = 'md', layout: layout = 'scroll', ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$dad7c95542bacce0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$export$bd1d06c79be19e17, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$7c6e2c02157bb7d2, {
        ref: ref,
        onPointerDownOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onFocusOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if ($ace11be13f1c53cf$var$isInFloatingLayer(e)) e.preventDefault();
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2', $ace11be13f1c53cf$var$Z_DIALOG, 'w-full bg-white rounded-2xl shadow-modal', $ace11be13f1c53cf$var$SIZE[size] || $ace11be13f1c53cf$var$SIZE.md, layout === 'frame' ? [
            'grid grid-rows-[auto_minmax(0,1fr)_auto] overflow-hidden',
            'max-h-[calc(100vh-3rem)] [@supports(height:1dvh)]:max-h-[calc(100dvh-3rem)]'
        ] : 'max-h-[90vh] overflow-y-auto p-8', 'data-[state=open]:animate-in data-[state=closed]:animate-out', 'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[state=closed]:slide-out-to-left-1/2 data-[state=open]:slide-in-from-left-1/2', 'data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%]', $ace11be13f1c53cf$var$MOTION_SAFE, className),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ace11be13f1c53cf$var$LayoutContext.Provider, {
        value: layout
    }, children), showClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
        className: "absolute end-5 top-5 rounded-sm opacity-70 hover:opacity-100 outline-none focus:ring-2 focus:ring-ring transition-opacity"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))))));
$ace11be13f1c53cf$export$b6d9565de1e068cf.displayName = 'DialogContent';
const $ace11be13f1c53cf$export$742513523b177e3b = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col gap-1.5', layout === 'frame' ? 'px-5 py-4 border-b border-border' : 'mb-6', className),
        ...props
    });
};
// The scroll region of a `frame` dialog. `overscroll-contain` is what stops a
// flick at the end of the list from scrolling the page behind the dialog.
const $ace11be13f1c53cf$export$5d20f2c38fcde41f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(layout === 'frame' ? 'overflow-y-auto overscroll-contain p-5' : '', className),
        ...props
    });
});
$ace11be13f1c53cf$export$5d20f2c38fcde41f.displayName = 'DialogBody';
const $ace11be13f1c53cf$export$7bbfb2d443473050 = ({ className: className, ...props })=>{
    const layout = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ace11be13f1c53cf$var$LayoutContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex gap-2.5', layout === 'frame' ? 'px-5 py-3 border-t border-border flex-wrap' : 'mt-6', className),
        ...props
    });
};
const $ace11be13f1c53cf$export$16f7638e4a34b909 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$16f7638e4a34b909, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-[18px] font-extrabold text-foreground', className),
        ...props
    }));
$ace11be13f1c53cf$export$16f7638e4a34b909.displayName = 'DialogTitle';
const $ace11be13f1c53cf$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ className: className, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eeaeb48e23f662e7$export$393edc798c47379d, {
        ref: ref,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('text-sm text-muted-foreground leading-6', className),
        ...props
    }));
$ace11be13f1c53cf$export$94e94c2ec2c954d5.displayName = 'DialogDescription';



var $acw62 = parcelRequire("acw62");

'use client';
function $49383ac93d397699$export$2e2bcd8739ae039({ open: open, onClose: onClose, width: width = 400, children: children }) {
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open,
        onClose
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: onClose,
        style: {
            position: 'absolute',
            inset: 0,
            background: 'rgba(0,0,0,0.25)',
            zIndex: 10,
            backdropFilter: 'blur(1px)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            // Docks at the inline-END — the side away from the shell's sidebar, so
            // a drawer never covers the navigation it was opened from (§5.2). This
            // was `left: 0`, the inline-end under `rtl` and the inline-START under
            // `ltr`, i.e. straight over an English layout's sidebar.
            position: 'absolute',
            top: 0,
            insetInlineEnd: 0,
            width: width,
            height: '100%',
            background: '#fff',
            // No x-offset: a signed offset points at a physical side, and this
            // panel sits on whichever side the reading direction puts the end on.
            boxShadow: '0 0 24px rgba(0,0,0,0.12)',
            zIndex: 11,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    }, children));
}
function $49383ac93d397699$export$bb68d554ded258ea({ title: title, sub: sub, onClose: onClose, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 20px',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 16,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 2
        }
    }, sub), children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClose,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 22,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1,
            padding: '2px 6px'
        }
    }, "\xd7"));
}
function $49383ac93d397699$export$4ed8420cdfcb2b8f({ children: children, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            overflow: 'auto',
            padding: 20,
            ...style
        }
    }, children);
}
function $49383ac93d397699$export$d05a7d25ec5abf06({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '16px 20px',
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            gap: 8,
            flexShrink: 0
        }
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $acw62 = parcelRequire("acw62");
'use client';
function $0286d675359db131$export$9ff6616b10aa518d() {
    const [insets, setInsets] = (0, $acw62.useState)({
        top: 0,
        bottom: 0
    });
    (0, $acw62.useEffect)(()=>{
        const vv = typeof window === 'undefined' ? null : window.visualViewport;
        if (!vv) return undefined;
        const read = ()=>{
            const top = Math.max(0, Math.round(vv.offsetTop));
            // Everything below the visual viewport's bottom edge is covered.
            const bottom = Math.max(0, Math.round(window.innerHeight - (vv.height + vv.offsetTop)));
            setInsets((prev)=>prev.top === top && prev.bottom === bottom ? prev : {
                    top: top,
                    bottom: bottom
                });
        };
        read();
        vv.addEventListener('resize', read);
        vv.addEventListener('scroll', read);
        return ()=>{
            vv.removeEventListener('resize', read);
            vv.removeEventListener('scroll', read);
        };
    }, []);
    return insets;
}
var $0286d675359db131$export$2e2bcd8739ae039 = $0286d675359db131$export$9ff6616b10aa518d;



var $acw62 = parcelRequire("acw62");
'use client';
// ─────────────────────────────────────────────────────────────────────────────
// useOverlayHistory — put an overlay INTO the history stack.
//
// ── The problem ─────────────────────────────────────────────────────────────
// A bottom sheet, a full-screen picker and a closure overlay are all things a
// person opened and expects to be able to *back out of*. On a phone that means
// the hardware back button on Android and the browser's back gesture on iOS —
// neither of which the page can veto. Because no overlay pushed anything onto
// the history stack, pressing back with a sheet open navigated the ROUTE
// UNDERNEATH it: the sheet stayed on screen over a different screen, or the
// person left a half-finished form without ever being asked.
//
// Per-screen fixes for this do not work. Every app that tried one ended up with
// a `popstate` listener per screen, each guessing how many entries to unwind,
// and one of them (the doctor app's visit guard) hardcoded `history.go(-2)` —
// correct only while exactly one anchor exists, and wrong the moment a sheet is
// open on top of it.
//
// ── The rule this implements ────────────────────────────────────────────────
// Opening an overlay pushes ONE history entry tagged with a private token;
// closing it pops that entry. A `popstate` that removes the token is the
// platform saying "close this overlay", so `onClose` runs and nothing else
// happens — the route never changes. Overlays stack: the innermost one owns the
// newest entry, so back closes them one at a time, in order.
//
// The pushed entry deliberately CARRIES THE ROUTER'S OWN STATE FORWARD
// (`...history.state`), which keeps `idx`/`key` identical. React Router reads
// `state.idx` on `popstate` to compute a delta; leaving it untouched makes the
// delta zero, so the router sees the pop and correctly does nothing. Bumping it
// would make the router re-navigate to the same URL with a new key and reset
// screen state that the overlay was sitting on top of.
//
// ── Depth, for guarded routes ───────────────────────────────────────────────
// A route with a leave-guard (an open visit) has to unwind its own anchor PLUS
// whatever overlays are above it. `overlayHistoryDepth()` is that count, so the
// guard says `history.go(-(1 + overlayHistoryDepth()))` rather than a literal.
//
// ── Whose pop is this? (v0.11.5) ────────────────────────────────────────────
// A leave-guard is itself a `popstate` listener, and `popstate` does not say
// what was left — only what was landed on. So a guard that treats every pop
// as "the person is leaving" fires on the pops THIS hook makes: close a sheet
// with the ✕, the scrim or a submit, the cleanup below calls `back()` to drop
// the sheet's entry, and the guard asks «خروج از ویزیت؟» over a screen the
// person never tried to leave. Found on a phone in the doctor app, where every
// sheet on the visit did it.
//
// `overlayOwnsPop()` is the one question a guard needs to ask first. It is
// true in exactly the two cases where a pop is an overlay's business:
//   · an overlay still HOLDS an entry — the platform back is closing it, and
//     the overlay's own listener (registered later, so it runs after the
//     guard's) will handle it;
//   · this hook has just popped its own entry from inside the app. That is
//     announced BEFORE `back()` and consumed by the first reader within a
//     short window, so a `back()` that never produced a pop cannot swallow a
//     real one later.
//
// SSR/jsdom-safe: with no `window.history` it is inert, so a caller can add it
// unconditionally.
// ─────────────────────────────────────────────────────────────────────────────
const $6fd4a6c8c2176e20$var$MARK = 'parsinaOverlay';
let $6fd4a6c8c2176e20$var$sequence = 0;
/** Tokens of the overlays that currently own a history entry, innermost last. */ const $6fd4a6c8c2176e20$var$openTokens = [];
/** When this hook last popped its own entry (ms epoch); 0 when it has not. */ let $6fd4a6c8c2176e20$var$selfPopAt = 0;
// A history traversal completes within a frame or two; the window is only
// there so a `back()` that never produced a pop cannot claim a later one.
const $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS = 1000;
function $6fd4a6c8c2176e20$export$9452f2c4c9460e1e() {
    return $6fd4a6c8c2176e20$var$openTokens.length;
}
function $6fd4a6c8c2176e20$export$2846246580854e2f() {
    if ($6fd4a6c8c2176e20$var$openTokens.length > 0) return true;
    if ($6fd4a6c8c2176e20$var$selfPopAt && Date.now() - $6fd4a6c8c2176e20$var$selfPopAt < $6fd4a6c8c2176e20$var$SELF_POP_WINDOW_MS) {
        $6fd4a6c8c2176e20$var$selfPopAt = 0;
        return true;
    }
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
    return false;
}
function $6fd4a6c8c2176e20$export$b512be9f39899018() {
    $6fd4a6c8c2176e20$var$openTokens.length = 0;
    $6fd4a6c8c2176e20$var$sequence = 0;
    $6fd4a6c8c2176e20$var$selfPopAt = 0;
}
function $6fd4a6c8c2176e20$export$2e2bcd8739ae039(open, onClose, { enabled: enabled = true, id: id } = {}) {
    // `onClose` is almost always an inline arrow, so depending on it would tear
    // the history entry down and rebuild it on every render of the host screen.
    const onCloseRef = (0, $acw62.useRef)(onClose);
    onCloseRef.current = onClose;
    (0, $acw62.useEffect)(()=>{
        if (!enabled || !open) return undefined;
        if (typeof window === 'undefined' || !window.history?.pushState) return undefined;
        const seq = ++$6fd4a6c8c2176e20$var$sequence;
        const token = `${id || 'overlay'}#${seq}`;
        $6fd4a6c8c2176e20$var$openTokens.push(token);
        // True once the platform has already taken our entry off the stack, so the
        // cleanup below knows not to pop a second time.
        let popped = false;
        // Set by the cleanup; a reclaim scheduled before it must not fire after it.
        let disposed = false;
        let reclaimTimer = null;
        // The URL the entry was claimed on. A pop that lands on a different URL is
        // a navigation (a leave-guard's `go(-n)`), never a refused close.
        const claimedHref = window.location.href;
        const drop = ()=>{
            const at = $6fd4a6c8c2176e20$var$openTokens.indexOf(token);
            if (at !== -1) $6fd4a6c8c2176e20$var$openTokens.splice(at, 1);
        };
        const ours = ()=>window.history.state?.[$6fd4a6c8c2176e20$var$MARK] === token;
        try {
            window.history.pushState({
                ...window.history.state || {},
                [$6fd4a6c8c2176e20$var$MARK]: token
            }, '');
        } catch  {
            // iOS caps pushState calls per interval. An overlay that cannot claim an
            // entry still opens; it just does not intercept back, which is exactly
            // today's behaviour and strictly better than refusing to render.
            drop();
            return undefined;
        }
        // ── A refused close (v0.16.1) ─────────────────────────────────────────────
        // The platform back has ALREADY removed our entry by the time `onClose`
        // runs, and the page cannot veto that. A consumer may still refuse — a dirty
        // form that asks «خروج بدون ذخیره؟» and hears «بمانم», or TaskOverlay's
        // `busy` withholding `onClose` mid-write. Before this, the overlay stayed on
        // screen with no entry, so the NEXT back left the route under it.
        //
        // So one tick after `onClose`: if this effect is still alive (nothing set
        // `open` to false), claim the entry again. An honoured close has cleaned the
        // effect up by then and nothing here runs.
        const reclaim = ()=>{
            reclaimTimer = null;
            if (disposed || !popped || ours()) return;
            if (window.location.href !== claimedHref) return;
            const seqOf = (t)=>Number(t.slice(t.lastIndexOf('#') + 1));
            // Overlays opened DURING the refusal (a confirm sheet) already pushed
            // their entries above where ours belongs. With exactly one, rotate: the
            // top entry becomes ours and theirs is pushed back on top of it.
            const above = $6fd4a6c8c2176e20$var$openTokens.filter((t)=>seqOf(t) > seq);
            const state = window.history.state || {};
            try {
                if (above.length === 0) window.history.pushState({
                    ...state,
                    [$6fd4a6c8c2176e20$var$MARK]: token
                }, '');
                else if (above.length === 1 && state[$6fd4a6c8c2176e20$var$MARK] === above[0]) {
                    window.history.replaceState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: token
                    }, '');
                    window.history.pushState({
                        ...state,
                        [$6fd4a6c8c2176e20$var$MARK]: above[0]
                    }, '');
                } else // Two or more inner entries cannot be reordered without a traversal
                // the person would see; leave it as it was rather than misorder them.
                return;
            } catch  {
                return; // the iOS pushState cap — same fallback as the first claim
            }
            const at = above.length ? $6fd4a6c8c2176e20$var$openTokens.indexOf(above[0]) : -1;
            if (at === -1) $6fd4a6c8c2176e20$var$openTokens.push(token);
            else $6fd4a6c8c2176e20$var$openTokens.splice(at, 0, token);
            popped = false;
        };
        const onPop = ()=>{
            // Still ours: something DEEPER popped, and its own hook is handling it.
            if (ours()) return;
            popped = true;
            drop();
            onCloseRef.current?.();
            if (!disposed && reclaimTimer === null) reclaimTimer = setTimeout(reclaim, 0);
        };
        window.addEventListener('popstate', onPop);
        return ()=>{
            disposed = true;
            if (reclaimTimer !== null) {
                clearTimeout(reclaimTimer);
                reclaimTimer = null;
            }
            window.removeEventListener('popstate', onPop);
            drop();
            // Closed from inside the app (the ✕, a submit, Escape). Our entry is
            // still on the stack, so remove it — otherwise back would have to be
            // pressed once for the ghost entry and once for the actual route.
            //
            // `ours()` is the guard that makes this safe on unmount-by-navigation: a
            // sheet whose button routed somewhere else no longer owns the top entry,
            // and calling back() there would undo the navigation it just performed.
            if (!popped && ours()) {
                // Announced before the traversal, because the guard's listener will
                // run inside the resulting `popstate` and has no other way to know.
                $6fd4a6c8c2176e20$var$selfPopAt = Date.now();
                try {
                    window.history.back();
                } catch  {
                    $6fd4a6c8c2176e20$var$selfPopAt = 0;
                }
            }
        };
    }, [
        open,
        enabled,
        id
    ]);
}



'use client';
// ─────────────────────────────────────────────────────────────────────────────
// BottomSheet — mobile-first modal that slides up from the bottom edge.
// Replaces the duplicated ClinicModal implementations in the patient app and
// ad-hoc bottom sheets elsewhere. For desktop-centred dialogs use Dialog.
//
// It is the default overlay for a mobile task or filter set
// (DESIGN-CONCEPT-MOBILE §6); `ConfirmDialog` stays a centered dialog and sits
// ABOVE this one on the z-scale (DESIGN.md, Overlay layering).
//
// ── What makes it phone-grade (v0.10.0) ─────────────────────────────────────
// Every one of these was a defect a phone could reproduce and a desktop could
// not, and each was found in all three apps at once because they all render
// this component:
//
//   dvh, not vh        `85vh` is measured against the LARGEST viewport, so on
//                      iOS Safari with the address bar expanded the sheet was
//                      taller than the screen and its own footer sat under the
//                      toolbar. `100dvh` tracks the live viewport; the `vh`
//                      declaration stays as the fallback for browsers without
//                      it, behind an `@supports` upgrade.
//   the keyboard       `position: fixed` is blind to the software keyboard, so
//                      a focused field's submit button sat *under* the keys.
//                      The sheet sits INSIDE the visible box: the scrim pads by
//                      what the keyboard covers (bottom) and by what the browser
//                      panned past (top), and the ceiling comes down by the
//                      same amount so the sheet's top edge does not move.
//                      (v0.23.3, PM-0108) It used to only shrink its ceiling
//                      while keeping its bottom edge on the LAYOUT viewport —
//                      so on Android Chrome, which paints the keyboard over the
//                      layout viewport (`resizes-visual`), the lower part of
//                      every sheet, footer included, sat under the keys, and
//                      Chrome's attempt to reveal the field panned the visual
//                      viewport so the title bar and the field left through the
//                      top of the screen. The booking sheet on a phone was the
//                      report. Repro: the doctor client's
//                      `e2e/booking.keyboard.mobile.spec.js`.
//   back closes it     the platform back button used to navigate the route
//                      underneath an open sheet, leaving the sheet floating
//                      over a different screen. `useOverlayHistory` puts the
//                      sheet in the history stack (opt out with
//                      `historyIntegration={false}` for a desktop dialog).
//   focus stays in     a modal that leaks focus to the page behind it is not a
//                      modal. Focus moves in on open, Tab cycles inside, and
//                      the previously-focused element gets it back on close.
//   the page is still  without a scroll lock, scrolling past the sheet's end
//                      scrolls the screen behind it — on iOS the page then
//                      rubber-bands and the sheet appears to drift.
//   44px close         the ✕ was 30px, under the 2.75rem minimum (§6).
//   tokens             surfaces, scrim, radius and text now come from the token
//                      layer instead of five literal hexes.
//   rendered at body   (v0.11.4) `position: fixed` and a z-index only mean
//                      what they say inside the ROOT stacking context. A sheet
//                      mounted deep in a screen — inside the scroller of a tab,
//                      say — sat in whatever context its ancestors made: iOS
//                      WebKit composites an overflow scroller and traps fixed
//                      descendants in it, so the sheet was clipped to the
//                      scroller and the screen's own docked bar, later in the
//                      DOM, painted OVER it. Chromium does not do this, which
//                      is why a browser test could not see it. The sheet now
//                      portals to `document.body`, exactly as the kit `Dialog`
//                      does through Radix: where a sheet happens to be mounted
//                      is no longer something a screen has to get right.
//
// Props:
//   open / onClose
//   title      — optional heading
//   footer     — optional docked commit row. §6 says "submit docks bottom", and
//                the sheet's body is a scroll region, so a footer placed in
//                `children` scrolls away exactly when it is needed. This slot
//                sticks to the bottom edge, above the safe-area inset AND above
//                the software keyboard.
//   fullHeight — a tall form (a stepper, a long picker) takes the whole
//                available height instead of hugging its content, so the footer
//                sits at the bottom edge rather than halfway up the screen.
//   snap       — cap the sheet at a fraction of the viewport (0.2–1, default
//                0.85). `snap={1}` with `fullHeight` is a full-screen task.
//   dir        — writing direction. UNSET by default, so the sheet INHERITS the
//                document's. It used to hardcode `dir="rtl"`, which renders
//                backwards in an app that also ships `en`; the three RTL apps
//                set `dir="rtl"` on <html>, so inheriting is identical for them.
//   closeLabel — accessible name of the close button (default «بستن»)
//   maxWidth   — the sheet's cap on a wide viewport
//   historyIntegration — false to opt out of the back-button behaviour
//   portal     — false to render in place instead of at `document.body`. Only
//                for a consumer that deliberately scopes CSS custom properties
//                to a subtree and needs the sheet inside it; the default is the
//                one that is correct on a phone.
//   className / data-testid and any other prop are forwarded to the overlay.
//
// `dir` inherits from `<html>` after the portal, which is what it inherited
// before in every app that sets the direction where the I18N rule says to.
// ─────────────────────────────────────────────────────────────────────────────
// Everything focusable a sheet can realistically contain. `[hidden]` and
// `disabled` are excluded because Tab skips them anyway, and a trap that
// disagrees with the browser about the cycle is worse than no trap.
const $cfba7d02b5e7069f$var$FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
].join(',');
const $cfba7d02b5e7069f$var$PANEL_CLASS = 'parsina-sheet-panel';
// One stylesheet for every sheet on the page, not one per instance: the rules
// are identical and the per-sheet numbers arrive as custom properties.
const $cfba7d02b5e7069f$var$SHEET_CSS = `
  @keyframes parsina-sheet-fade{from{opacity:0}to{opacity:1}}
  @keyframes parsina-sheet-up{from{transform:translateY(24px);opacity:0}to{transform:translateY(0);opacity:1}}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-vh)}
  .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-vh)}
  /* The upgrade. Guarded because a custom property holding an unsupported unit
     is invalid at computed-value time, which would drop max-height entirely. */
  @supports (height: 100dvh){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}{max-height:var(--parsina-sheet-dvh)}
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}[data-full-height]{height:var(--parsina-sheet-dvh)}
  }
  @media (prefers-reduced-motion: reduce){
    .${$cfba7d02b5e7069f$var$PANEL_CLASS}, .parsina-sheet-scrim{animation:none!important}
  }
`;
function $cfba7d02b5e7069f$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, children: children, footer: footer, fullHeight: fullHeight = false, snap: snap = 0.85, dir: dir, closeLabel: closeLabel, maxWidth: maxWidth = 480, historyIntegration: historyIntegration = true, portal: portal = true, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().close;
    const panelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const restoreFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The box the user can see, as insets of the layout viewport (PM-0108).
    const { top: panInset, bottom: keyboardInset } = (0, $0286d675359db131$export$2e2bcd8739ae039)();
    // Back / hardware-back closes the sheet and leaves the route alone.
    (0, $6fd4a6c8c2176e20$export$2e2bcd8739ae039)(open, onClose, {
        enabled: historyIntegration,
        id: testId || 'sheet'
    });
    // Escape + the focus trap. One listener for both: they are the same contract
    // — while this is open, the keyboard belongs to it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                onClose?.();
                return;
            }
            if (e.key !== 'Tab') return;
            const panel = panelRef.current;
            if (!panel) return;
            const items = [
                ...panel.querySelectorAll($cfba7d02b5e7069f$var$FOCUSABLE)
            ].filter((el)=>el.offsetParent !== null);
            if (items.length === 0) {
                e.preventDefault();
                panel.focus();
                return;
            }
            const first = items[0];
            const last = items[items.length - 1];
            const active = document.activeElement;
            // Wrapping by hand is what keeps focus inside: the browser's own next
            // stop after `last` is the page behind the scrim.
            if (e.shiftKey && (active === first || !panel.contains(active))) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
                e.preventDefault();
                first.focus();
            }
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Move focus in on open and hand it back on close. Without the hand-back, a
    // sheet opened from a list left focus on <body>, so the next Tab started from
    // the top of the page instead of from the control that opened it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        restoreFocusRef.current = document.activeElement;
        // After paint, so the panel and its children exist to receive it.
        const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame(()=>{
            const panel = panelRef.current;
            if (!panel) return;
            const firstField = panel.querySelector($cfba7d02b5e7069f$var$FOCUSABLE);
            (firstField || panel).focus?.({
                preventScroll: true
            });
        }) : null;
        return ()=>{
            if (raf !== null) cancelAnimationFrame(raf);
            const previous = restoreFocusRef.current;
            restoreFocusRef.current = null;
            if (previous && typeof previous.focus === 'function' && document.contains(previous)) previous.focus({
                preventScroll: true
            });
        };
    }, [
        open
    ]);
    // When the visible box changes under an open sheet — the keyboard arriving,
    // the browser panning — the sheet re-lays out, and the field being typed into
    // may now sit below the body's shrunken edge. Bring it back the way a finger
    // would. `nearest` scrolls only the sheet's own scroller: the panel is inside
    // the visible box by construction, so nothing outside it has to move.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || panInset === 0 && keyboardInset === 0) return undefined;
        if (typeof requestAnimationFrame !== 'function') return undefined;
        const raf = requestAnimationFrame(()=>{
            const panel = panelRef.current;
            const active = typeof document === 'undefined' ? null : document.activeElement;
            if (!panel || !active || active === panel || !panel.contains(active)) return;
            if (typeof active.scrollIntoView !== 'function') return;
            active.scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        open,
        panInset,
        keyboardInset
    ]);
    // Body scroll lock. Restores the exact previous inline values rather than
    // clearing them, so two stacked sheets do not leave the page unlocked when
    // the inner one closes.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open || typeof document === 'undefined') return undefined;
        const body = document.body;
        const previous = {
            overflow: body.style.overflow,
            touchAction: body.style.touchAction,
            overscroll: body.style.overscrollBehavior
        };
        body.style.overflow = 'hidden';
        // iOS ignores `overflow: hidden` on <body> for touch scrolling; these two
        // are what actually stop the page behind the scrim from moving.
        body.style.touchAction = 'none';
        body.style.overscrollBehavior = 'none';
        return ()=>{
            body.style.overflow = previous.overflow;
            body.style.touchAction = previous.touchAction;
            body.style.overscrollBehavior = previous.overscroll;
        };
    }, [
        open
    ]);
    if (!open) return null;
    // `calc()` multiplies a NUMBER by a length, so the snap stays a fraction.
    const cap = Math.min(Math.max(Number(snap) || 0.85, 0.2), 1);
    const tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: dir,
        className: className ? `parsina-sheet-scrim ${className}` : 'parsina-sheet-scrim',
        "data-testid": testId,
        onClick: onClose,
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            background: (0, $e7c165fb515b04ea$export$959fb1d648dd9e6c),
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            // The scrim keeps covering the whole layout viewport (a keyboard frame
            // in flight must never show the page behind); the PANEL is confined to
            // the box the user can see — above the keys, below what was panned past.
            paddingTop: panInset ? `${panInset}px` : undefined,
            paddingBottom: keyboardInset ? `${keyboardInset}px` : undefined,
            animation: 'parsina-sheet-fade 0.2s ease-out'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $cfba7d02b5e7069f$var$SHEET_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: panelRef,
        className: $cfba7d02b5e7069f$var$PANEL_CLASS,
        "data-full-height": fullHeight ? '' : undefined,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title || closeLabel,
        tabIndex: -1,
        onClick: (e)=>e.stopPropagation(),
        style: {
            width: '100%',
            maxWidth: maxWidth,
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderRadius: `${(0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).hero}px ${(0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).hero}px 0 0`,
            boxShadow: '0 -12px 40px rgba(0,0,0,0.18)',
            // The visible box lost `keyboardInset + panInset` pixels, so the
            // ceiling comes down by exactly that: the sheet's TOP edge stays
            // where it was and the content gives up the keyboard's height, rather
            // than the whole sheet jumping. Both units are published; the
            // stylesheet picks.
            '--parsina-sheet-vh': `calc(${cap} * 100vh - ${keyboardInset + panInset}px)`,
            '--parsina-sheet-dvh': `calc(${cap} * 100dvh - ${keyboardInset + panInset}px)`,
            animation: 'parsina-sheet-up 0.25s cubic-bezier(0.4,0,0.2,1)',
            // No `fontFamily` here: the typeface is set once at the app root and
            // inherited (§2.1 — a component-level font declaration is a defect).
            outline: 'none',
            padding: '1rem 1.25rem 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.75rem',
            marginBottom: title ? '0.75rem' : 0,
            flexShrink: 0
        }
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        style: {
            fontSize: '0.9375rem',
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            margin: 0,
            minWidth: 0
        }
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClose,
        "aria-label": closeLabel,
        "data-testid": testId ? `${testId}-close` : undefined,
        style: {
            border: 'none',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            cursor: 'pointer',
            // §6: 2.75rem is the floor for anything a thumb has to hit. The
            // glyph stays small; the TARGET is what grew.
            width: '2.75rem',
            height: '2.75rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            flexShrink: 0,
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        strokeLinecap: "round",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 6 6 18M6 6l12 12"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: fullHeight ? 1 : undefined,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            // The sheet is the one scroller while it is open; a flick that
            // reaches its end must not hand the gesture to the page behind it.
            overscrollBehavior: 'contain',
            paddingBottom: footer ? 0 : 'calc(1.25rem + env(safe-area-inset-bottom, 0px))'
        }
    }, children), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            marginTop: '0.75rem',
            marginInline: '-1.25rem',
            padding: '0.625rem 1.25rem',
            paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom, 0px))',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, footer)));
    // `document` is absent during a Next.js server render; a sheet that is open
    // on the server (rare, but a valid initial state) renders in place there and
    // moves to <body> on the client.
    if (portal && typeof document !== 'undefined') return /*#__PURE__*/ (0, $1u0KT.createPortal)(tree, document.body);
    return tree;
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Menu — an anchored menu.
//
// PROMOTED from the clinic app's `src/components/common/ClinicMenu.jsx`, which
// had marked itself a promotion candidate: the kit had no menu primitive at any
// version — not a Menu, not a Popover, not a DropdownMenu — so per DESIGN.md
// rule 4 it lived in the app until a second app needed one. `AccountCard` is
// that second need, in all four panels at once.
//
// Not built from `Dialog`: a Dialog is a centred modal and this is an anchored
// menu, so the kit's overlay would be the wrong shape AND the wrong semantics
// (`role="dialog"` where a screen reader needs `role="menu"`).
//
// Portaled to `document.body` so a clipping ancestor cannot cut it off — the
// staff sidebars are fixed-width flex columns with `overflow: hidden`, and an
// anchored child of one is sliced at 260px (or at 68px when collapsed).
//
// LAYERING — z 900. Above every piece of app chrome (the doctor app's mobile
// bottom nav at z-50, its visit-closure flow at z-60) and below every kit
// overlay: BottomSheet 1000, Dialog/ConfirmDialog 1100. That order is the one
// DESIGN.md insists on — a ConfirmDialog raised from inside a menu row (sign
// out, a destructive switch) must render ABOVE the menu, and the fix for that
// ordering is never to lower the dialog. ClinicMenu sat at 11, the Drawer
// level, which was enough for the one trigger it had; 900 is what a menu opened
// from anywhere needs.
//
// Props:
//   open / onClose        — controlled
//   anchorRef             — ref to the trigger; the menu is measured against it
//   placement             — 'bottom' (default) | 'top' | 'auto'. 'auto' opens
//                           downward and flips up when the space below is too
//                           small. A menu at the FOOT of a sidebar wants 'top'.
//   width                 — px (default 300)
//   ariaLabel             — required in practice: the trigger's visible text is
//                           often a person's or a clinic's name, not the menu's
//   children              — the rows; give them role="menuitem"/"menuitemradio"
//   data-testid
// ─────────────────────────────────────────────────────────────────────────────
const $08d1958bc1315b40$var$Z = 900;
const $08d1958bc1315b40$var$GAP = 6; // breathing room between trigger and menu
const $08d1958bc1315b40$var$EDGE = 8; // never touch the viewport edge
const $08d1958bc1315b40$var$MIN_BELOW = 180; // 'auto' flips up below this much room
// Every focusable row, in DOM order. Radio rows come from ClinicSwitcher, plain
// menuitems from AccountCard; `[data-menu-focus]` lets a caller nominate
// something else entirely (ClinicSwitcher's search box).
const $08d1958bc1315b40$var$ROW_SELECTOR = '[data-menu-focus="true"], [role="menuitem"]:not([aria-disabled="true"]), [role="menuitemradio"]:not([aria-disabled="true"])';
function $08d1958bc1315b40$export$d9b273488cd8ce6f({ open: open, onClose: onClose, anchorRef: anchorRef, children: children, ariaLabel: ariaLabel, width: width = 300, placement: placement = 'bottom', 'data-testid': testId = 'menu' }) {
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [pos, setPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Position against the trigger. Measured on open and on every resize/scroll,
    // rather than once: the sidebar collapses under a CSS transition, so a
    // position captured at open time is wrong 300ms later.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!open) {
            setPos(null);
            return undefined;
        }
        const place = ()=>{
            const el = anchorRef?.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const isRtl = typeof document !== 'undefined' && document.documentElement.dir === 'rtl';
            // Anchor to the INLINE-START edge in both directions, which is the visual
            // edge the trigger shares with its container in RTL and LTR alike.
            const left = isRtl ? Math.max($08d1958bc1315b40$var$EDGE, r.right - width) : Math.min(r.left, window.innerWidth - width - $08d1958bc1315b40$var$EDGE);
            const roomBelow = window.innerHeight - r.bottom - $08d1958bc1315b40$var$EDGE * 2;
            const roomAbove = r.top - $08d1958bc1315b40$var$EDGE * 2;
            const up = placement === 'top' || placement === 'auto' && roomBelow < $08d1958bc1315b40$var$MIN_BELOW && roomAbove > roomBelow;
            const room = up ? roomAbove : roomBelow;
            const maxHeight = Math.min(Math.max(160, room), Math.round(window.innerHeight * 0.6));
            setPos(up ? {
                bottom: Math.max($08d1958bc1315b40$var$EDGE, window.innerHeight - r.top + $08d1958bc1315b40$var$GAP),
                left: left,
                maxHeight: maxHeight
            } : {
                top: r.bottom + $08d1958bc1315b40$var$GAP,
                left: left,
                maxHeight: maxHeight
            });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return ()=>{
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [
        open,
        anchorRef,
        width,
        placement
    ]);
    // Close on an outside press. `mousedown` rather than `click`, so a press that
    // starts outside and ends inside cannot re-open what it just closed.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onDown = (e)=>{
            if (menuRef.current?.contains(e.target)) return;
            if (anchorRef?.current?.contains(e.target)) return;
            onClose?.();
        };
        document.addEventListener('mousedown', onDown);
        return ()=>document.removeEventListener('mousedown', onDown);
    }, [
        open,
        onClose,
        anchorRef
    ]);
    // Escape closes, arrows walk the rows, Home/End jump. A menu you can open by
    // keyboard but only leave by mouse is a trap.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const onKey = (e)=>{
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose?.();
                return;
            }
            if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
            const rows = Array.from(menuRef.current?.querySelectorAll($08d1958bc1315b40$var$ROW_SELECTOR) || []);
            if (!rows.length) return;
            e.preventDefault();
            const at = rows.indexOf(document.activeElement);
            const next = e.key === 'Home' ? 0 : e.key === 'End' ? rows.length - 1 : e.key === 'ArrowDown' ? (at + 1) % rows.length : at <= 0 ? rows.length - 1 : at - 1;
            rows[next]?.focus?.();
        };
        document.addEventListener('keydown', onKey);
        return ()=>document.removeEventListener('keydown', onKey);
    }, [
        open,
        onClose
    ]);
    // Focus lands inside on open and returns to the trigger on close — a menu that
    // opens without focus is unreachable by keyboard, and one that drops focus on
    // close strands the caret at the top of the document.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return undefined;
        const t = window.setTimeout(()=>{
            menuRef.current?.querySelector($08d1958bc1315b40$var$ROW_SELECTOR)?.focus?.();
        }, 0);
        const anchor = anchorRef?.current;
        return ()=>{
            window.clearTimeout(t);
            if (anchor && document.contains(anchor)) anchor.focus?.();
        };
    }, [
        open,
        anchorRef
    ]);
    if (!open || !pos) return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: menuRef,
        role: "menu",
        "aria-label": ariaLabel,
        "data-testid": testId,
        style: {
            position: 'fixed',
            top: pos.top,
            bottom: pos.bottom,
            left: pos.left,
            width: width,
            maxHeight: pos.maxHeight,
            overflowY: 'auto',
            overflowX: 'hidden',
            background: 'white',
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            boxShadow: '0 18px 48px rgba(15, 34, 51, 0.18)',
            zIndex: $08d1958bc1315b40$var$Z,
            padding: 6,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, children), document.body);
}
var $08d1958bc1315b40$export$2e2bcd8739ae039 = $08d1958bc1315b40$export$d9b273488cd8ce6f;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * useResponsive — is this viewport the MOBILE surface?
 *
 * ≤ 768px is mobile across the whole product (DESIGN-CONCEPT-MOBILE preamble:
 * "everything rendered when `useResponsive()` reports ≤ 768px"). The boundary
 * is inclusive: 768 is mobile, 769 is desktop.
 *
 * It lives in the kit because it is the switch every `X.mobile.jsx` fork is
 * chosen by, and a byte-identical copy already existed in the doctor and the
 * clinic client — the second app needing it is DESIGN.md rule 4's trigger to
 * move it here. It sits beside `useKeyboardInset` and `useMeasuredWidth`: all
 * three are facts about the device's geometry that a whole class of screens
 * depends on.
 *
 * Hardened over the app-local copies in two ways:
 *   • `matchMedia` rather than a `resize` listener, so a rotation or a
 *     window drag fires once at the boundary instead of on every frame;
 *   • an SSR / no-window guard, so importing it in a Next.js server component
 *     or a node-environment test does not throw. It reports DESKTOP there —
 *     the surface with the full content, which is the safe default for a
 *     first paint that has not measured anything yet.
 *
 * @param breakpoint the inclusive mobile ceiling in px (default 768)
 * @returns { isMobile }
 */ const $e959a5a9c1f6e19d$var$query = (breakpoint)=>`(max-width: ${breakpoint}px)`;
const $e959a5a9c1f6e19d$var$read = (breakpoint)=>{
    if (typeof window === 'undefined') return false;
    if (typeof window.matchMedia === 'function') return window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint)).matches;
    return window.innerWidth <= breakpoint;
};
function $e959a5a9c1f6e19d$export$2e2bcd8739ae039(breakpoint = 768) {
    const [isMobile, setIsMobile] = (0, $acw62.useState)(()=>$e959a5a9c1f6e19d$var$read(breakpoint));
    (0, $acw62.useEffect)(()=>{
        if (typeof window === 'undefined') return undefined;
        // The state initialiser ran before mount; re-read now in case the viewport
        // is not what it was (hydration, a rotation during boot).
        setIsMobile($e959a5a9c1f6e19d$var$read(breakpoint));
        if (typeof window.matchMedia !== 'function') {
            const onResize = ()=>setIsMobile(window.innerWidth <= breakpoint);
            window.addEventListener('resize', onResize);
            return ()=>window.removeEventListener('resize', onResize);
        }
        const mq = window.matchMedia($e959a5a9c1f6e19d$var$query(breakpoint));
        const onChange = (e)=>setIsMobile(e.matches);
        // `addListener` is the pre-2019 Safari spelling; still worth keeping while
        // the product supports older iOS webviews.
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else mq.addListener(onChange);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', onChange);
            else mq.removeListener(onChange);
        };
    }, [
        breakpoint
    ]);
    return {
        isMobile: isMobile
    };
}




'use client';
// The panel surface both shells paint on. A sticky header has to repaint it, or
// the body shows through as it scrolls under.
const $382b400f7624ec9d$var$OVERLAY_SURFACE = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card;
function $382b400f7624ec9d$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, description: description, header: header, footer: footer, children: children, busy: busy = false, size: size = 'md', isMobile: isMobile, historyIntegration: historyIntegration = true, snap: snap = 1, fullHeight: fullHeight = true, closeLabel: closeLabel, className: className, 'data-testid': testId, ...rest }) {
    if (closeLabel === undefined) closeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().close;
    const auto = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    // ── Why this cannot be server-rendered blind ──────────────────────────────
    // WHICH SHELL this is depends on the viewport, and a server does not have
    // one. Rendering the desktop guess and then swapping to a sheet on the client
    // is a hydration mismatch — React discards the tree and re-renders it, and in
    // an app that streams the overlay open from a deep link (`?book=1`) that is a
    // visible flash of the wrong shape.
    //
    // So: when the caller TELLS us the tier we trust it and render on the server
    // like anything else. When it does not, we wait for the client, where the
    // question has an answer. One frame later than ideal, and never wrong.
    const told = isMobile !== undefined;
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(told);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    const mobile = told ? isMobile : auto.isMobile;
    // One guard for every way out, so "can this close right now?" has a single
    // answer rather than one per dismissal path. On the sheet tier a platform back
    // has already popped the sheet's history entry when this refuses; the sheet's
    // `useOverlayHistory` re-claims it one tick later (v0.16.1), so a busy overlay
    // keeps exactly one entry and the next back is delivered to it again.
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (busy) return;
        if (typeof onClose === 'function') onClose();
    }, [
        busy,
        onClose
    ]);
    if (!open || !mounted) return null;
    if (mobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        title: title,
        footer: footer,
        snap: snap,
        fullHeight: fullHeight,
        closeLabel: closeLabel,
        historyIntegration: historyIntegration,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        ...rest
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            background: $382b400f7624ec9d$var$OVERLAY_SURFACE,
            padding: '0 1.25rem 0.75rem'
        }
    }, header) : null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: (next)=>{
            if (!next) close();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
        size: size,
        layout: "frame",
        showClose: !busy,
        className: className,
        "data-testid": testId,
        "data-busy": busy || undefined,
        // Radix would otherwise close on Esc or an outside click mid-write.
        onEscapeKeyDown: (e)=>{
            if (busy) e.preventDefault();
        },
        onInteractOutside: (e)=>{
            if (busy) e.preventDefault();
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$742513523b177e3b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
        dir: "auto"
    }, title), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$94e94c2ec2c954d5), {
        dir: "auto"
    }, description) : null, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId ? `${testId}-header` : undefined,
        style: {
            marginTop: '0.75rem'
        }
    }, header) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), null, children), footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$7bbfb2d443473050), null, footer) : null));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $da50fe1f8f323572$export$a477a7ade7efed9c() {
    // One listener implementation for both facts: the bottom inset IS the
    // keyboard, `top` is the pan a sheet needs (PM-0108) and a composer does not.
    return (0, $0286d675359db131$export$9ff6616b10aa518d)().bottom;
}
var $da50fe1f8f323572$export$2e2bcd8739ae039 = $da50fe1f8f323572$export$a477a7ade7efed9c;


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Toast — the one notification system for every Parsina client.
//
// Replaces: native alert() calls (doctor app), the 5+ per-screen setToast/
// setTimeout implementations (clinic app), and inline-only feedback (patient app).
//
// Usage:
//   <ToastProvider>  ← once, at the app root
//   const toast = useToast();
//   toast.success('ذخیره شد');
//   toast.error('خطا در ارتباط با سرور');
//   toast.info('...'); toast.warn('...');
//
// The contract is DESIGN_SYSTEM §9.3 / DESIGN_CONCEPT §7 (PM-0022):
//   • one sentence, auto-dismissed after 4 s — an error after 6 s;
//   • at most 3 stacked on desktop, 2 on a phone (the oldest leaves);
//   • desktop: the bottom, inline-END corner (the one farthest from the sidebar);
//     phone: bottom-centre, ABOVE whatever is docked there — the bottom nav
//     (`--app-bottom-nav`), a screen's CTA footer (`--app-bottom-dock`, see
//     `usePublishedHeight`) and the software keyboard;
//   • polite to a screen reader, except an error, which interrupts.
// ─────────────────────────────────────────────────────────────────────────────
const $352ffee698fbd002$var$PALETTE = {
    success: {
        bg: '#1A9B6C',
        text: '#ffffff'
    },
    error: {
        bg: '#D93025',
        text: '#ffffff'
    },
    warn: {
        bg: '#F59E0B',
        text: '#1a2332'
    },
    info: {
        bg: '#0173BE',
        text: '#ffffff'
    }
};
const $352ffee698fbd002$var$ToastContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $352ffee698fbd002$export$beb43bca45d33d34 = 4000;
const $352ffee698fbd002$export$7a658dea7a198286 = 6000;
const $352ffee698fbd002$export$3b92a0a0bf23cbdd = {
    desktop: 3,
    mobile: 2
};
let $352ffee698fbd002$var$nextId = 1;
function $352ffee698fbd002$export$f5d03d415824e0e({ children: children, duration: duration = $352ffee698fbd002$export$beb43bca45d33d34, errorDuration: errorDuration = $352ffee698fbd002$export$7a658dea7a198286 }) {
    const [toasts, setToasts] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const timers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const keyboardInset = (0, $da50fe1f8f323572$export$2e2bcd8739ae039)();
    const max = isMobile ? $352ffee698fbd002$export$3b92a0a0bf23cbdd.mobile : $352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop;
    const dismiss = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setToasts((t)=>t.filter((x)=>x.id !== id));
        const timer = timers.current.get(id);
        if (timer) {
            clearTimeout(timer);
            timers.current.delete(id);
        }
    }, []);
    const push = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((message, type = 'info', opts = {})=>{
        const id = $352ffee698fbd002$var$nextId++;
        // The state keeps the desktop cap; the phone's smaller one is applied at
        // render, so a rotation never needs the list rewritten.
        setToasts((t)=>[
                ...t,
                {
                    id: id,
                    message: message,
                    type: type
                }
            ].slice(-$352ffee698fbd002$export$3b92a0a0bf23cbdd.desktop));
        const life = opts.duration ?? (type === 'error' ? errorDuration : duration);
        timers.current.set(id, setTimeout(()=>dismiss(id), life));
        return id;
    }, [
        dismiss,
        duration,
        errorDuration
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            timers.current.forEach(clearTimeout);
        }, []);
    const api = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            show: push,
            success: (m, o)=>push(m, 'success', o),
            error: (m, o)=>push(m, 'error', o),
            warn: (m, o)=>push(m, 'warn', o),
            info: (m, o)=>push(m, 'info', o),
            dismiss: dismiss
        }), [
        push,
        dismiss
    ]);
    const visible = toasts.slice(-max);
    // Phone: clear the nav + a docked footer, or the keyboard when that is taller
    // (a footer that pads for the keyboard already contains it — hence `max`, not
    // a sum). Desktop has neither; the corner offset is all there is.
    const bottom = isMobile ? `calc(max(var(--app-bottom-nav, 0px) + var(--app-bottom-dock, 0px), env(safe-area-inset-bottom, 0px), ${keyboardInset}px) + 0.75rem)` : '1.5rem';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($352ffee698fbd002$var$ToastContext.Provider, {
        value: api
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": "toast-stack",
        "data-placement": isMobile ? 'bottom-center' : 'bottom-end',
        style: {
            position: 'fixed',
            bottom: bottom,
            insetInline: 0,
            paddingInline: isMobile ? '1rem' : '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'center' : 'flex-end',
            gap: '0.5rem',
            zIndex: 9999,
            pointerEvents: 'none'
        }
    }, visible.map((t)=>{
        const p = $352ffee698fbd002$var$PALETTE[t.type] || $352ffee698fbd002$var$PALETTE.info;
        const isError = t.type === 'error';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: t.id,
            onClick: ()=>dismiss(t.id),
            role: isError ? 'alert' : 'status',
            "aria-live": isError ? 'assertive' : 'polite',
            "data-testid": "toast",
            "data-type": t.type,
            style: {
                pointerEvents: 'auto',
                cursor: 'pointer',
                background: p.bg,
                color: p.text,
                padding: '0.625rem 1.125rem',
                borderRadius: 'var(--radius, 10px)',
                fontSize: '0.8125rem',
                fontWeight: 600,
                boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                maxWidth: 'min(92vw, 26.25rem)',
                animation: 'parsina-toast-in 0.22s ease-out'
            }
        }, t.message);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-toast-in{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}@media (prefers-reduced-motion: reduce){[data-testid="toast"]{animation:none !important}}`)));
}
function $352ffee698fbd002$export$a407b657d3044108() {
    const ctx = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($352ffee698fbd002$var$ToastContext);
    if (!ctx) throw new Error('useToast must be used inside <ToastProvider>');
    return ctx;
}



var $acw62 = parcelRequire("acw62");


'use client';
function $31e8de2f297417a1$export$7f7cbe89f1eacd2({ size: size = 32, color: color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, thickness: thickness = 2, style: style, label: label }) {
    if (label === undefined) label = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().loading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        // The accessible name is a PROP (rule 7). It used to be a Persian string
        // literal with no way past it, so an English screen announced its loading
        // state in Persian and the app could do nothing about it.
        "aria-label": label,
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            border: `${thickness}px solid ${color}`,
            borderTopColor: 'transparent',
            animation: 'parsina-spin 0.8s linear infinite',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes parsina-spin{to{transform:rotate(360deg)}}`));
}
function $31e8de2f297417a1$export$e2b0760399e6dece({ label: label, minHeight: minHeight = '60vh' }) {
    return(// No `dir` of its own — it inherits the document's, like every other
    // component in the kit. It is a centred column either way.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minHeight: minHeight,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31e8de2f297417a1$export$7f7cbe89f1eacd2, {
        label: label
    }), label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 13,
            color: '#9aa3b0',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, label) : null));
}
var $31e8de2f297417a1$export$2e2bcd8739ae039 = $31e8de2f297417a1$export$7f7cbe89f1eacd2;



var $acw62 = parcelRequire("acw62");

'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SessionCheck / SessionError / SessionPage — what EVERY Parsina panel shows
// between opening the tab and knowing who is signed in.
//
// The Keycloak round trip, the token check and whatever read a panel needs
// before its first screen (onboarding status, memberships, appearance) all sit
// behind this one card. It was the doctor panel's (its App.jsx `AuthPage`),
// copied into the clinic panel in 2026-09 and drawn differently again in the
// dentist, student and admin panels — five front doors to one product. It is
// the kit's now, so a person who opens two panels in one morning meets one
// door, and a change to it is one release rather than five edits.
//
//   SessionPage   the canvas (145° navy gradient, two drifting discs) and the
//                 420px white card that rises in
//   SessionCheck  the loading state: brand hero, three bouncing dots, the
//                 progress track, and the manual sign-in link after 4s
//   SessionError  a boot that could not finish: logo, tone disc, message,
//                 one gradient action, and the SSO host it tried
//
// ── Continuing across a remount ─────────────────────────────────────────────
//
// A panel's boot often has two owners — the auth check, then a provider that
// reads what the panel needs — and each renders its own SessionCheck. Left
// alone the second mount would restart every animation: the card rising again,
// the track snapping back to 5%. So every animation is offset by the time since
// this MODULE loaded (≈ the page's start) with a negative `animation-delay`,
// and the manual link counts from the same moment. The second mount continues
// the first.
//
// Every word is a PROP (rule 7) and so is the logo: the kit ships no image, and
// a panel with its own mark (ParsinaDent) passes its own.
// ─────────────────────────────────────────────────────────────────────────────
const $3c4ca280922aa4ea$var$now = ()=>typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
const $3c4ca280922aa4ea$var$SESSION_T0 = $3c4ca280922aa4ea$var$now();
/** Milliseconds since the kit loaded — the one clock every session screen shares. */ const $3c4ca280922aa4ea$var$sinceBoot = ()=>$3c4ca280922aa4ea$var$now() - $3c4ca280922aa4ea$var$SESSION_T0;
const $3c4ca280922aa4ea$var$continued = (elapsedMs, ownDelayS = 0)=>({
        animationDelay: `${ownDelayS - elapsedMs / 1000}s`
    });
const $3c4ca280922aa4ea$export$6b89370abb8fc4ae = `linear-gradient(145deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark} 0%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy} 55%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight} 100%)`;
const $3c4ca280922aa4ea$export$e3b7f640fe979c0e = `linear-gradient(160deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark} 0%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy} 60%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight} 100%)`;
const $3c4ca280922aa4ea$var$SESSION_ACTION = `linear-gradient(135deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark}, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy})`;
// Reduced motion: the card simply appears, the dots rest, the track sits part
// filled. Those resting values are the base rules, so they hold wherever the
// animation does not.
const $3c4ca280922aa4ea$var$SESSION_CSS = `
  @keyframes parsina-session-rise { from { opacity: 0; transform: translateY(24px) } to { opacity: 1; transform: translateY(0) } }
  @keyframes parsina-session-dot { 0%, 65%, 100% { transform: translateY(0); opacity: 0.3 } 30% { transform: translateY(-9px); opacity: 1 } }
  @keyframes parsina-session-progress { 0% { width: 5% } 50% { width: 65% } 85% { width: 88% } 100% { width: 93% } }
  @keyframes parsina-session-float { 0%, 100% { transform: scale(1) } 50% { transform: scale(1.06) } }
  @keyframes parsina-session-appear { from { opacity: 0 } to { opacity: 1 } }
  [data-session-dot] { opacity: 0.6; }
  [data-session-progress] { width: 65%; }
  @media (prefers-reduced-motion: no-preference) {
    [data-session-card] { animation: parsina-session-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1) both; }
    [data-session-dot] { animation: parsina-session-dot 1.5s ease-in-out infinite; }
    [data-session-progress] { animation: parsina-session-progress 3s ease-out both; }
    [data-session-float] { animation-name: parsina-session-float; animation-timing-function: ease-in-out; animation-iteration-count: infinite; }
    [data-session-appear] { animation: parsina-session-appear 0.4s ease both; }
  }
`;
function $3c4ca280922aa4ea$export$15364261a1aca489({ children: children, testId: testId }) {
    // Read once per mount: the offset must not move under a running animation.
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            height: '100vh',
            background: $3c4ca280922aa4ea$export$6b89370abb8fc4ae,
            fontFamily: 'Meshkat, sans-serif',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, $3c4ca280922aa4ea$var$SESSION_CSS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            top: -120,
            insetInlineEnd: -80,
            width: 380,
            height: 380,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)',
            animationDuration: '9s',
            pointerEvents: 'none'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        "data-session-float": "",
        style: {
            position: 'absolute',
            bottom: -160,
            insetInlineStart: -100,
            width: 500,
            height: 500,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
            animationDuration: '12s',
            pointerEvents: 'none',
            ...$3c4ca280922aa4ea$var$continued(elapsed, 3)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        "data-session-card": "",
        style: {
            background: 'white',
            borderRadius: 16,
            width: 420,
            maxWidth: 'calc(100vw - 48px)',
            boxShadow: '0 32px 80px rgba(0,0,0,0.3), 0 8px 32px rgba(0,0,0,0.18)',
            textAlign: 'center',
            overflow: 'hidden',
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    }, children));
}
function $3c4ca280922aa4ea$export$cd72095868f03c30({ logo: logo, brandName: brandName, panelName: panelName, title: title, subtitle: subtitle, stuckLabel: stuckLabel, manualLabel: manualLabel, onManualSignIn: onManualSignIn, manualAfterMs: manualAfterMs = 4000, testId: testId = 'session-check' }) {
    const [elapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3c4ca280922aa4ea$var$sinceBoot);
    const [showManual, setShowManual] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>elapsed >= manualAfterMs);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (showManual || !onManualSignIn) return undefined;
        const timer = setTimeout(()=>setShowManual(true), Math.max(0, manualAfterMs - $3c4ca280922aa4ea$var$sinceBoot()));
        return ()=>clearTimeout(timer);
    }, [
        showManual,
        onManualSignIn,
        manualAfterMs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: $3c4ca280922aa4ea$export$e3b7f640fe979c0e,
            padding: '36px 44px 32px',
            position: 'relative',
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            top: -24,
            insetInlineEnd: -24,
            width: 100,
            height: 100,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            position: 'absolute',
            bottom: -30,
            insetInlineStart: -20,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 14,
            position: 'relative'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 72,
            height: 72,
            borderRadius: 18,
            background: 'rgba(255,255,255,0.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain'
        }
    }))) : null, brandName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 26,
            fontWeight: 800,
            color: 'white',
            marginBottom: 4,
            letterSpacing: -0.5
        }
    }, brandName) : null, panelName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: 'rgba(255,255,255,0.55)'
        }
    }, panelName) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '32px 44px 40px'
        },
        role: "status",
        "aria-live": "polite",
        "aria-busy": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            justifyContent: 'center',
            gap: 10,
            marginBottom: 18
        }
    }, [
        0,
        0.18,
        0.36
    ].map((delay)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: delay,
            "data-session-dot": "",
            style: {
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                ...$3c4ca280922aa4ea$var$continued(elapsed, delay)
            }
        }))), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 15,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: 6,
            fontWeight: 500
        }
    }, title) : null, subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 28
        }
    }, subtitle) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": "true",
        style: {
            width: '100%',
            height: 4,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            borderRadius: 4,
            overflow: 'hidden',
            marginBottom: 28
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-progress": "",
        style: {
            height: '100%',
            background: `linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark}, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight})`,
            borderRadius: 4,
            ...$3c4ca280922aa4ea$var$continued(elapsed)
        }
    })), showManual && onManualSignIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-session-appear": "",
        style: {
            marginTop: 18,
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, stuckLabel, stuckLabel ? ' ' : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onManualSignIn,
        "data-testid": `${testId}-manual`,
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            font: 'inherit',
            fontSize: 13,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            textDecoration: 'underline',
            textUnderlineOffset: 3
        }
    }, manualLabel)) : null));
}
// Filled glyphs (Material `error`, `cloud_off`) — the doctor card's family.
const $3c4ca280922aa4ea$var$ErrorGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    }));
const $3c4ca280922aa4ea$var$OfflineGlyph = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: "30",
        height: "30",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
    }));
const $3c4ca280922aa4ea$var$TONES = {
    /** The sign-in service failed, or the redirect looped. */ danger: {
        bg: '#FEF2F2',
        ring: '#FECACA',
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
        Glyph: $3c4ca280922aa4ea$var$ErrorGlyph
    },
    /** Signed in, but the panel's backend did not answer. */ warning: {
        bg: '#FFFBEB',
        ring: '#FDE68A',
        ink: '#B45309',
        Glyph: $3c4ca280922aa4ea$var$OfflineGlyph
    }
};
function $3c4ca280922aa4ea$export$d422f67d76bf24e4({ tone: tone = 'danger', logo: logo, brandName: brandName, title: title, body: body, detail: detail, actionLabel: actionLabel, onAction: onAction, secondary: secondary, host: host, testId: testId = 'session-error', stateTestId: stateTestId }) {
    const look = $3c4ca280922aa4ea$var$TONES[tone] || $3c4ca280922aa4ea$var$TONES.danger;
    const { Glyph: Glyph } = look;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3c4ca280922aa4ea$export$15364261a1aca489, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '40px 44px 44px'
        },
        role: "alert",
        "data-testid": stateTestId
    }, logo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: brandName || '',
        style: {
            width: 52,
            height: 52,
            objectFit: 'contain',
            marginBottom: 20,
            opacity: 0.55
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: look.bg,
            border: `2px solid ${look.ring}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        color: look.ink
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0 0 10px',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 18,
            fontWeight: 800,
            letterSpacing: -0.3
        }
    }, title), body ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontSize: 14,
            marginBottom: detail ? 12 : 32,
            lineHeight: 1.8
        }
    }, body) : null, detail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontSize: 12,
            marginBottom: 32,
            lineHeight: 1.7,
            wordBreak: 'break-word'
        }
    }, detail) : null, onAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onAction,
        style: {
            width: '100%',
            height: 50,
            background: $3c4ca280922aa4ea$var$SESSION_ACTION,
            color: 'white',
            border: 'none',
            borderRadius: 12,
            fontSize: 15,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            boxShadow: `0 4px 16px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.3)}`,
            marginBottom: secondary ? 10 : 20
        }
    }, actionLabel) : null, secondary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: secondary.onClick,
        style: {
            width: '100%',
            height: 44,
            background: 'white',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            border: `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            marginBottom: 20
        }
    }, secondary.label) : null, host ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            padding: '10px 14px',
            background: '#f8fafc',
            borderRadius: 10,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        width: "13",
        height: "13",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "ltr",
        style: {
            fontSize: 11,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontFamily: 'monospace',
            letterSpacing: 0.2
        }
    }, host)) : null));
}
var $3c4ca280922aa4ea$export$2e2bcd8739ae039 = $3c4ca280922aa4ea$export$cd72095868f03c30;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Skeleton family — the loading state of every Parsina screen.
//
// A screen that is fetching draws ITS OWN SHAPE in placeholder blocks: the
// header, tabs, filters, table or cards it is about to show, at the sizes they
// will have. Not a centred spinner, not «در حال بارگذاری…», not a blank page —
// see DESIGN.md §"Loading & skeleton". The primitives here are the vocabulary;
// each screen composes its own skeleton from them (`PatientDetailSkeleton`,
// `ReceptionSkeleton`, …) so the skeleton matches THAT screen, desktop and
// mobile alike, and nothing jumps when the data lands.
//
// Sizes mirror the real components on purpose: `SkeletonInput` is 44px like a
// `TextInput`, `SkeletonButton` 44px like a `Button`, `SkeletonTable` rows are
// 52px (44 dense) like `Table`, `SkeletonCard` has the `Card` surface. If a real
// component's geometry changes, change its skeleton in the same commit.
//
// Every block is `aria-hidden`; a composite root carries `role="status"`,
// `aria-busy` and an accessible `label` (a prop, rule 7) so assistive tech hears
// ONE "loading" instead of forty empty boxes. Motion respects
// `prefers-reduced-motion`: the sheen stops, the blocks stay.
// ─────────────────────────────────────────────────────────────────────────────
const $c90190398471f24a$var$SHIMMER_CSS = `
  @keyframes parsina-shimmer {
    0%   { background-position: 200% 0 }
    100% { background-position: -200% 0 }
  }
  [data-skeleton] {
    background: linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base} 25%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).sheen} 50%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base} 75%);
    background-size: 200% 100%;
    animation: parsina-shimmer 1.4s ease-in-out infinite;
  }
  [data-skeleton][data-tone="onDark"] {
    background: linear-gradient(90deg, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark} 25%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDarkSheen} 50%, ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark} 75%);
    background-size: 200% 100%;
  }
  @media (prefers-reduced-motion: reduce) {
    [data-skeleton] { animation: none; background: ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).base}; }
    [data-skeleton][data-tone="onDark"] { background: ${(0, $e7c165fb515b04ea$export$169e587b68892b4e).onDark}; }
  }
`;
// One stylesheet for the whole family. React 19 hoists a <style> with `href` +
// `precedence` into <head> once, however many skeletons are on screen.
const $c90190398471f24a$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-skeleton",
        precedence: "default"
    }, $c90190398471f24a$var$SHIMMER_CSS);
function $c90190398471f24a$export$8f31e4c4a37b8e9c({ width: width = '100%', height: height = 14, radius: radius = (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip, circle: circle = false, tone: tone, style: style, className: className, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-skeleton": "",
        // `tone="onDark"` — white-alpha blocks for a gradient header, a sidebar
        // or a dark image canvas, where the neutral grey would read as a hole.
        "data-tone": tone === 'onDark' ? 'onDark' : undefined,
        className: className,
        style: {
            width: width,
            height: circle ? width : height,
            borderRadius: circle ? '50%' : radius,
            flexShrink: 0,
            ...style
        },
        ...rest
    }));
}
// Whether we are already inside an announced skeleton region. A page skeleton
// composed of a SkeletonStats, a SkeletonTable and two SkeletonCards used to
// announce "loading" four times; only the OUTERMOST region speaks now, the
// nested ones are plain hidden boxes.
const $c90190398471f24a$var$Nested = /*#__PURE__*/ (0, $acw62.createContext)(false);
function $c90190398471f24a$export$8b3e24dbbac64362({ as: Tag = 'div', label: label, style: style, children: children, ...rest }) {
    const nested = (0, $acw62.useContext)($c90190398471f24a$var$Nested);
    if (nested) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "aria-hidden": true,
        "data-state": "loading",
        style: style,
        ...rest
    }, children);
    // An announced region is named in whatever language the page is showing: the
    // caller's `label`, or the kit's own word for "loading" in `<html lang>`.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Nested.Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        role: "status",
        "aria-busy": "true",
        "aria-label": label ?? (0, $df1b34b618a72512$export$cddd06f8fa3400df)().loading,
        "data-state": "loading",
        style: style,
        ...rest
    }, children));
}
const $c90190398471f24a$var$Root = $c90190398471f24a$export$8b3e24dbbac64362;
// Line widths for a paragraph — the last line is shorter, like real text.
const $c90190398471f24a$var$LINE_WIDTHS = [
    '100%',
    '92%',
    '96%',
    '85%',
    '70%'
];
function $c90190398471f24a$export$cb6ddd830302c2a8({ width: width = '60%', height: height = 14, lines: lines = 1, lastWidth: lastWidth = '60%', gap: gap = 8, style: style, ...rest }) {
    if (lines <= 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: width,
        height: height,
        style: style,
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            width: '100%',
            ...style
        },
        ...rest
    }, Array.from({
        length: lines
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: height,
            width: i === lines - 1 ? lastWidth : $c90190398471f24a$var$LINE_WIDTHS[i % $c90190398471f24a$var$LINE_WIDTHS.length]
        })));
}
function $c90190398471f24a$export$53c2c5a35a7e31a2({ size: size = 40, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size,
        circle: true,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$7387c3f2666b9f16({ width: width = 112, size: size = 'default', style: style, ...rest }) {
    const height = size === 'sm' ? 36 : size === 'icon' ? 40 : 44;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: size === 'icon' ? height : width,
        height: height,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
        style: style,
        ...rest
    });
}
function $c90190398471f24a$export$5ce4f4d8e50e2948({ label: label = true, labelWidth: labelWidth = 88, multiline: multiline = false, width: width = '100%', style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            width: width,
            ...style
        },
        ...rest
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: labelWidth,
        height: 12
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: multiline ? 96 : 44,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }));
}
function $c90190398471f24a$export$5956eb8f2ff4afde({ avatar: avatar = true, lines: lines = 0, chips: chips = 2, actions: actions = 2, padding: padding = 20, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: padding,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
        size: 48
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "60%",
        height: 14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "40%",
        height: 11
    }))), lines > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$cb6ddd830302c2a8, {
        lines: lines,
        height: 12
    }) : null, chips > 0 || actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }) : null, chips > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 6
        }
    }, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: 60 + i % 2 * 12,
            height: 22,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }))) : null, actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: 36,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            style: {
                flex: 1
            }
        }))) : null);
}
const $c90190398471f24a$var$ROW_WIDTHS = [
    48,
    120,
    100,
    70,
    80,
    70,
    100
];
function $c90190398471f24a$export$8bbcb87f63697989({ cols: cols = 7, widths: widths = $c90190398471f24a$var$ROW_WIDTHS, dense: dense = false, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        "aria-hidden": true,
        style: {
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            height: dense ? 44 : 52
        },
        ...rest
    }, Array.from({
        length: cols
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
            key: i,
            style: {
                padding: '0 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: widths[i % widths.length] || 80,
            height: i === 0 ? 18 : 13
        }))));
}
function $c90190398471f24a$export$6a15d3f7c248c5bb({ rows: rows = 6, columns: columns = 5, dense: dense = false, header: header = true, style: style, label: label, ...rest }) {
    const cols = Array.isArray(columns) ? columns : Array.from({
        length: columns
    }, (_, i)=>$c90190398471f24a$var$ROW_WIDTHS[(i + 1) % $c90190398471f24a$var$ROW_WIDTHS.length]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            overflow: 'hidden',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'fixed'
        }
    }, header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
        style: {
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
            height: 40
        }
    }, cols.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: i,
            style: {
                padding: '0 16px',
                textAlign: 'start'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: Math.min(typeof w === 'number' ? w * 0.7 : 72, 96),
            height: 11
        }))))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: rows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8bbcb87f63697989, {
            key: i,
            cols: cols.length,
            widths: cols,
            dense: dense
        })))));
}
function $c90190398471f24a$export$9e2e66b17fdb9730({ count: count = 5, avatar: avatar = true, trailing: trailing = 56, divided: divided = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                minHeight: avatar ? 64 : 52,
                padding: '0 4px',
                borderTop: divided && i > 0 ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
            }
        }, avatar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$53c2c5a35a7e31a2, {
            size: 40
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${55 + i * 17 % 30}%`,
            height: 14
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: `${30 + i * 11 % 25}%`,
            height: 11
        })), trailing > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: trailing,
            height: 22,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }) : null)));
}
function $c90190398471f24a$export$452537ec11d5437e({ count: count = 4, widths: widths, gap: gap = 4, padding: padding = '12px 14px', style: style, ...rest }) {
    const ws = widths || Array.from({
        length: count
    }, (_, i)=>[
            72,
            60,
            96,
            84,
            68
        ][i % 5]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            gap: gap,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            overflowX: 'hidden',
            ...style
        },
        ...rest
    }, ws.map((w, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                padding: padding
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: w,
            height: 13
        }))));
}
const $c90190398471f24a$var$BAR_HEIGHTS = [
    0.55,
    0.8,
    0.4,
    0.95,
    0.65,
    0.75,
    0.5,
    0.85,
    0.6,
    0.7,
    0.45,
    0.9
];
function $c90190398471f24a$export$9e5a4339fadac171({ height: height = 200, bars: bars = 8, line: line = false, legend: legend = 2, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            ...style
        }
    }, legend > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 14
        }
    }, Array.from({
        length: legend
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 6
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 10,
            circle: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 56,
            height: 11
        })))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: height,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: '0 8px'
        }
    }, line ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: "100%",
        height: Math.round(height * 0.35),
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        style: {
            marginBottom: Math.round(height * 0.25)
        }
    }) : Array.from({
        length: bars
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            height: Math.round(height * $c90190398471f24a$var$BAR_HEIGHTS[i % $c90190398471f24a$var$BAR_HEIGHTS.length]),
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            style: {
                flex: 1,
                width: 'auto'
            }
        }))));
}
function $c90190398471f24a$export$68fb050a45c52f04({ fields: fields = 4, columns: columns = 1, actions: actions = 1, multiline: multiline = [], gap: gap = 16, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: gap
        }
    }, Array.from({
        length: fields
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$5ce4f4d8e50e2948, {
            key: i,
            multiline: multiline.includes(i),
            style: multiline.includes(i) && columns > 1 ? {
                gridColumn: '1 / -1'
            } : undefined
        }))), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8,
            justifyContent: 'flex-end'
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 120 : 96
        }))) : null);
}
function $c90190398471f24a$export$171a4533b2ae49b5({ subtitle: subtitle = true, actions: actions = 1, back: back = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            minHeight: 44,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            minWidth: 0
        }
    }, back ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 36,
        height: 36,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 160,
        height: 20
    }), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 110,
        height: 12
    }) : null)), actions > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: 8
        }
    }, Array.from({
        length: actions
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$7387c3f2666b9f16, {
            key: i,
            width: i === 0 ? 112 : 44
        }))) : null);
}
function $c90190398471f24a$export$f70e1ea07462d9df({ search: search = true, chips: chips = 3, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap',
            ...style
        },
        ...rest
    }, search ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
        width: 240,
        height: 44,
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
        style: {
            maxWidth: '100%'
        }
    }) : null, Array.from({
        length: chips
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            key: i,
            width: [
                84,
                72,
                96,
                64
            ][i % 4],
            height: 36,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        })));
}
function $c90190398471f24a$export$3122f708803a735a({ count: count = 4, icon: icon = true, style: style, label: label, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$var$Root, {
        label: label,
        ...rest,
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`,
            gap: 12,
            ...style
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderRadius: 12,
                padding: '16px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: 44,
            height: 44,
            radius: 12
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                flex: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "55%",
            height: 22
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c90190398471f24a$export$8f31e4c4a37b8e9c, {
            width: "70%",
            height: 11
        })))));
}
var $c90190398471f24a$export$2e2bcd8739ae039 = $c90190398471f24a$export$8f31e4c4a37b8e9c;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $ebab042c7bf4d462$export$73bda83cddbc7187 = (string)=>string?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();


function $9849370148eea58e$export$cffcae2df5126ae4(iconName, iconNode, aliases = []) {
    if (iconNode == null) throw new Error("[lucide]: iconNode is required when icon name is used");
    return {
        name: (0, $ebab042c7bf4d462$export$73bda83cddbc7187)(iconName),
        size: 24,
        node: iconNode,
        ...aliases.length > 0 ? {
            aliases: aliases
        } : {}
    };
}


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $679cfb4006de9dc2$export$86f54f62aa7a7514 = (string)=>{
    let out = "";
    let upperNext = false;
    for (const ch of string){
        if (ch === "-" || ch === "_" || ch <= " ") {
            upperNext = out.length > 0;
            continue;
        }
        if (out.length === 0) out += ch.toLowerCase();
        else out += upperNext ? ch.toUpperCase() : ch;
        upperNext = false;
    }
    return out;
};


const $05938c6aab1a7024$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $679cfb4006de9dc2$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5921600fb4e81be8$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $c6be556545857de8$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};



function $4ca0126f0d25626c$var$isDefined(value) {
    return value !== null && value !== void 0;
}
function $4ca0126f0d25626c$export$2e2bcd8739ae039(icon, params = {}) {
    const attributeNames = params.attributeNames ?? {};
    const getAttributeName = (attributeName)=>attributeNames[attributeName] ?? attributeName;
    const viewBoxWidth = icon.size ?? icon.width ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["width"];
    const viewBoxHeight = icon.size ?? icon.height ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["height"];
    const aliasClassNames = icon.aliases?.filter((alias)=>typeof alias === "string" && alias.trim() !== "").map((alias)=>`lucide-${alias}`) ?? [];
    const iconClassNames = [
        ...icon.name ? [
            `lucide-${icon.name}`
        ] : [],
        ...aliasClassNames
    ];
    const classNamesFromClassName = params.className?.split(" ").filter(Boolean) ?? [];
    const className = params.includeDefaultClasses === false ? (0, $5921600fb4e81be8$export$3d46f4579dba46e5)(...classNamesFromClassName) : (0, $5921600fb4e81be8$export$3d46f4579dba46e5)("lucide", ...iconClassNames, ...classNamesFromClassName);
    const calculatedStrokeWidth = params.absoluteStrokeWidth ? Number(params.strokeWidth ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["stroke-width"]) * Number(icon.size ?? icon.width ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["width"]) / Number(params.size ?? params.width ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["width"]) : params.strokeWidth ?? (0, $c6be556545857de8$export$2e2bcd8739ae039)["stroke-width"];
    const attributes = {
        ...Object.entries((0, $c6be556545857de8$export$2e2bcd8739ae039)).reduce((attrs, [attrName, value])=>{
            attrs[getAttributeName(attrName)] = value;
            return attrs;
        }, {}),
        ..."color" in params && params.color && {
            [getAttributeName("stroke")]: params.color
        },
        ..."size" in params && $4ca0126f0d25626c$var$isDefined(params.size) && {
            [getAttributeName("width")]: params.size,
            [getAttributeName("height")]: params.size
        },
        ..."width" in params && $4ca0126f0d25626c$var$isDefined(params.width) && {
            [getAttributeName("width")]: params.width
        },
        ..."height" in params && $4ca0126f0d25626c$var$isDefined(params.height) && {
            [getAttributeName("height")]: params.height
        },
        [getAttributeName("stroke-width")]: calculatedStrokeWidth,
        ...className && {
            [getAttributeName("class")]: className
        },
        [getAttributeName("viewBox")]: `0 0 ${viewBoxWidth} ${viewBoxHeight}`,
        ...params.hasA11yProp === false ? {
            [getAttributeName("aria-hidden")]: "true"
        } : {},
        ..."attributes" in params && params.attributes
    };
    return [
        "svg",
        attributes,
        icon.node.map((child)=>{
            const [name, attrs, children] = child;
            const nextAttrs = params.nonScalingStroke ? {
                [getAttributeName("vector-effect")]: "non-scaling-stroke",
                ...attrs
            } : attrs;
            return children ? [
                name,
                nextAttrs,
                children
            ] : [
                name,
                nextAttrs
            ];
        })
    ];
}


function $f9986151c9447952$export$2e2bcd8739ae039(icon, params = {}) {
    return (0, $4ca0126f0d25626c$export$2e2bcd8739ae039)(icon, {
        ...params,
        attributeNames: {
            ...params.attributeNames,
            class: "className",
            "stroke-width": "strokeWidth",
            "stroke-linecap": "strokeLinecap",
            "stroke-linejoin": "strokeLinejoin",
            "vector-effect": "vectorEffect"
        }
    });
}


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $08ed9cd30f364255$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};



var $acw62 = parcelRequire("acw62");
"use strict";
"use client";
const $fdd26cba762f63b6$var$LucideContext = (0, $acw62.createContext)({});
function $fdd26cba762f63b6$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className }) {
    const value = (0, $acw62.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            nonScalingStroke: nonScalingStroke,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        nonScalingStroke,
        className
    ]);
    return (0, $acw62.createElement)($fdd26cba762f63b6$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $fdd26cba762f63b6$export$52ee7576b6cde767 = ()=>(0, $acw62.useContext)($fdd26cba762f63b6$var$LucideContext);


"use strict";
"use client";
const $8c69f6577678916e$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color, size: size, width: width, height: height, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, nonScalingStroke: nonScalingStroke, className: className = "", children: children, iconNode: iconNode = [], icon: icon = {
    node: iconNode,
    aliases: [],
    size: 24
}, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, nonScalingStroke: contextNonScalingStroke = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $fdd26cba762f63b6$export$52ee7576b6cde767)() ?? {};
    const hasAccessibleProp = Boolean(children) || (0, $08ed9cd30f364255$export$ab365959aa6deed0)(rest);
    const [name, svgAttributes, builtIconNode = []] = (0, $f9986151c9447952$export$2e2bcd8739ae039)(icon, {
        color: color ?? contextColor,
        width: width ?? size ?? contextSize,
        height: height ?? size ?? contextSize,
        strokeWidth: strokeWidth ?? contextStrokeWidth,
        absoluteStrokeWidth: absoluteStrokeWidth ?? contextAbsoluteStrokeWidth,
        nonScalingStroke: nonScalingStroke ?? contextNonScalingStroke,
        className: (0, $5921600fb4e81be8$export$3d46f4579dba46e5)(contextClass, className),
        hasA11yProp: hasAccessibleProp,
        attributes: rest
    });
    return (0, $acw62.createElement)(name, {
        ref: ref,
        ...svgAttributes
    }, [
        ...builtIconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


function $cb908d1b06653674$export$2e2bcd8739ae039(iconDataOrName, iconNode = [], aliases = []) {
    const iconData = typeof iconDataOrName === "string" ? (0, $9849370148eea58e$export$cffcae2df5126ae4)(iconDataOrName, iconNode, aliases) : iconDataOrName;
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $8c69f6577678916e$export$2e2bcd8739ae039), {
            ref: ref,
            icon: iconData,
            className: className,
            ...props
        }));
    if (iconData.name) Component.displayName = (0, $05938c6aab1a7024$export$6fb43ff9addf7357)(iconData.name);
    return Component;
}


const $5c08c9e83bb1a976$export$a2387ed3b5d536eb = {
    name: "inbox",
    size: 24,
    node: [
        [
            "polyline",
            {
                points: "22 12 16 12 14 15 10 15 8 12 2 12",
                key: "o97t9d"
            }
        ],
        [
            "path",
            {
                d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
                key: "oot6mr"
            }
        ]
    ]
};
$5c08c9e83bb1a976$export$a2387ed3b5d536eb.node;
const $5c08c9e83bb1a976$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5c08c9e83bb1a976$export$a2387ed3b5d536eb);



'use client';
function $838915ee2bfb8ab1$export$2e2bcd8739ae039({ icon: icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c08c9e83bb1a976$export$2e2bcd8739ae039), {
    size: 44,
    strokeWidth: 1.5,
    "aria-hidden": true
}), title: title, description: description, action: action, fill: fill = false, style: style, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            animation: 'fadeUp .3s ease',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 56,
            marginBottom: 16,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }, icon), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, description), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 16
        }
    }, action));
}



var $acw62 = parcelRequire("acw62");
'use client';
// Inlined so the component carries no bundler-specific asset import (Parcel's
// `url:` scheme does not exist in Next.js) — same default-avatar silhouette.
const $a53b6ea678d7efe0$var$defaultAvatarSrc = 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><rect width="40" height="40" fill="#e2e8f0"/><circle cx="20" cy="15" r="7" fill="#94a3b8"/><path d="M6 38c1.8-8 7.5-12 14-12s12.2 4 14 12z" fill="#94a3b8"/></svg>');
const $a53b6ea678d7efe0$var$AVATAR_COLORS = [
    '#1d4ed8',
    '#0891b2',
    '#0d9488',
    '#7c3aed',
    '#db2777',
    '#ea580c',
    '#16a34a'
];
function $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name) {
    const s = name || '';
    let h = 0;
    for(let i = 0; i < s.length; i++)h = s.charCodeAt(i) + ((h << 5) - h);
    return $a53b6ea678d7efe0$var$AVATAR_COLORS[Math.abs(h) % $a53b6ea678d7efe0$var$AVATAR_COLORS.length];
}
const $a53b6ea678d7efe0$var$Avatar = ({ name: name, size: size = 40, bg: bg, color: color = 'white', src: src })=>{
    const resolvedBg = bg ?? $a53b6ea678d7efe0$export$75ef3c97b2be2f20(name);
    const [status, setStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(src ? 'loading' : 'idle');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setStatus(src ? 'loading' : 'idle');
    }, [
        src
    ]);
    const initials = (name || '').split(' ').filter(Boolean).map((w)=>w[0]).join('').slice(0, 2) || '?';
    const isSkeleton = status === 'loading';
    const isError = status === 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: size,
            height: size,
            borderRadius: '50%',
            background: isSkeleton ? '#e2e8f0' : src && !isError ? 'transparent' : resolvedBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size * 0.35,
            fontWeight: '700',
            color: color,
            flexShrink: 0,
            overflow: 'hidden',
            position: 'relative',
            animation: isSkeleton ? 'avatar-pulse 1.4s ease-in-out infinite' : 'none'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, `@keyframes avatar-pulse{0%,100%{opacity:1}50%{opacity:.4}}`), src && !isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: src,
        alt: name,
        onLoad: ()=>setStatus('loaded'),
        onError: ()=>setStatus('error'),
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: isSkeleton ? 0 : 1,
            transition: 'opacity 0.25s',
            position: 'absolute',
            inset: 0
        }
    }), (!src || isError) && (isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: $a53b6ea678d7efe0$var$defaultAvatarSrc,
        alt: "",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, initials)));
};
var $a53b6ea678d7efe0$export$2e2bcd8739ae039 = $a53b6ea678d7efe0$var$Avatar;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PersonRow — a person, offered for choosing or simply stated.
//
// ── Why this is kit ─────────────────────────────────────────────────────────
// RECEPTION_PRACTITIONER_BOOKING §6.2 specifies a row anatomy for the clinic's
// practitioner picker — avatar, name, a meta line of «حرفه · تخصص · مدت», a
// trailing availability phrase, an ordinal for the first nine, and a disabled
// state that still says WHY. The patient app's practitioner step is the same
// row with different words in it. Two apps, one anatomy, and a *document*
// specifying it app-agnostically: §17.1 answers yes twice over.
//
// The rule it encodes is DESIGN.md rule 12 — an avatar means a person. This is
// not for anything that is not somebody.
//
// ── One component, two sizes — deliberately not two components ──────────────
// `size="sm"` is the CHIP: the pill in the clinic `BookingModal`'s header and
// the identity line of the patient's booking overlay. It is the same person
// with the same avatar and the same two lines, smaller and not tappable —
// shipping it as a second export would be the many-components failure §17.1
// warns about, and would let the two drift.
//
// Interactivity follows `onClick`: with one it is a real `<button>` and grows a
// chevron; without one it is a `<div>` that states rather than offers. A caller
// never has to ask for both.
//
// ── Unbookable is shown, never hidden (§2.6, §8.5) ──────────────────────────
// `disabled` mutes the row and shows `disabledReason` instead of dropping it
// from the list. Omitting is what makes a list lie: a patient looking for a
// specific doctor concludes they have left the clinic. `action` is the way out
// of the reason — the «تعریف ↗» link the clinic offers somebody who may fix it
// — and is simply not passed to a caller who may not.
//
// ── No copy, no numbers of its own ──────────────────────────────────────────
// §16.2 / §16.1: `name`, `meta`, `trailing`, `disabledReason` and `ordinal` are
// rendered VERBATIM, so their digits are whatever the app's own seam already
// made them. This component must never call a formatter and carries no
// catalogue. The patient app's `formatNumber` and the clinic's `formatDigits`
// are different seams, and both stay on their side of this line.
// ─────────────────────────────────────────────────────────────────────────────
// The chevron points the way the reader travels, which flips with the document.
// `--dir-flip` is the kit's one mirror (§11) — there is no `dir` prop, because a
// component that took one could be told to disagree with <html>.
const $cff717c1fa706fb8$var$Chevron = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "16",
        height: "16",
        fill: "currentColor",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $cff717c1fa706fb8$var$SIZES = {
    md: {
        avatar: 34,
        pad: '0.6875rem 0.875rem',
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        name: '0.84375rem',
        meta: '0.75rem',
        gap: '0.625rem'
    },
    sm: {
        avatar: 28,
        pad: '0.3125rem 0.75rem',
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
        name: '0.8125rem',
        meta: '0.6875rem',
        gap: '0.5rem'
    }
};
function $cff717c1fa706fb8$export$2e2bcd8739ae039({ name: name, meta: meta, trailing: trailing, ordinal: ordinal, avatar: avatar, size: size = 'md', selected: selected = false, disabled: disabled = false, disabledReason: disabledReason, action: action, chevron: chevron, onClick: onClick, as: as, className: className, 'data-testid': testId, ...rest }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    const interactive = typeof onClick === 'function' && !disabled;
    const showChevron = chevron === undefined ? interactive : chevron && !disabled;
    const tail = disabled && disabledReason ? disabledReason : trailing;
    const Tag = as || (interactive ? 'button' : 'div');
    const isButton = Tag === 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        type: isButton ? 'button' : undefined,
        onClick: interactive ? onClick : undefined,
        disabled: isButton ? disabled : undefined,
        "aria-disabled": !isButton && disabled ? true : undefined,
        "aria-selected": rest.role === 'option' ? selected : undefined,
        "data-testid": testId,
        "data-state": disabled ? 'disabled' : selected ? 'selected' : 'default',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(interactive || size === 'md' ? 'w-full text-start' : 'text-start', className),
        style: {
            // A chip HUGS its contents; a row fills the list it is in. A
            // block-level chip stretched to the panel width reads as an empty field
            // rather than as a named person.
            display: size === 'sm' ? 'inline-flex' : 'flex',
            width: size === 'sm' ? 'fit-content' : undefined,
            maxWidth: '100%',
            alignItems: 'center',
            gap: S.gap,
            padding: S.pad,
            borderRadius: S.radius,
            border: size === 'sm' ? 'none' : `1px solid ${selected ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: size === 'sm' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.08) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            cursor: disabled ? 'not-allowed' : interactive ? 'pointer' : 'default',
            opacity: disabled ? 0.6 : 1,
            // ≥ 2.75rem is the phone hit target (MOBILE_WEB_PWA §5); a chip is not a
            // target at all, so it is exempt.
            minHeight: size === 'sm' ? undefined : '2.75rem',
            minWidth: 0,
            transition: 'background 0.15s, border-color 0.15s'
        },
        ...rest
    }, ordinal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            width: '1.25rem',
            textAlign: 'center',
            fontSize: '0.6875rem',
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, ordinal) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: avatar?.name ?? (typeof name === 'string' ? name : ''),
        bg: avatar?.color,
        src: avatar?.src,
        size: S.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.name,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            fontSize: S.meta,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, meta) : null), tail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            flexShrink: 0,
            fontSize: '0.6875rem',
            fontWeight: 700,
            lineHeight: 1.5,
            color: disabled ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
            textAlign: 'end'
        }
    }, tail) : null, action, showChevron ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($cff717c1fa706fb8$var$Chevron, null) : null);
}
function $cff717c1fa706fb8$export$fb8511da6566433c({ count: count = 4, size: size = 'md', label: label, 'data-testid': testId }) {
    const S = $cff717c1fa706fb8$var$SIZES[size] || $cff717c1fa706fb8$var$SIZES.md;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: label,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }
    }, Array.from({
        length: count
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: S.gap,
                padding: S.pad,
                borderRadius: S.radius,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: S.avatar,
            height: S.avatar,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: "45%",
            height: 11,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: "30%",
            height: 9,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip
        })))));
}



var $acw62 = parcelRequire("acw62");




'use client';
function $7718f00aead6941c$export$2e2bcd8739ae039({ state: state = 'content', slots: slots = [], value: value, onSelect: onSelect, notice: notice = null, label: label, loadingLabel: loadingLabel, min: min = '5rem', columns: columns, loadingCount: loadingCount = 12, className: className, 'data-testid': testId, ...rest }) {
    if (label === undefined) label = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().slotGrid.label;
    if (loadingLabel === undefined) loadingLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().slotGrid.loading;
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: columns ? `repeat(${columns}, minmax(0, 1fr))` : `repeat(auto-fill, minmax(${min}, 1fr))`,
        gap: '0.5rem'
    };
    if (state === 'loading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: loadingLabel,
        "data-testid": testId,
        "data-state": "loading",
        style: gridStyle
    }, Array.from({
        length: loadingCount
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            key: i,
            height: 44,
            radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
        })));
    if (state === 'error' || state === 'empty') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: className,
        ...rest
    }, notice);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": label,
        "data-testid": testId,
        "data-state": "content",
        className: className,
        style: gridStyle,
        ...rest
    }, slots.map((slot)=>{
        const selected = value != null && slot.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: slot.value,
            type: "button",
            onClick: slot.disabled ? undefined : ()=>onSelect?.(slot),
            disabled: slot.disabled,
            "aria-pressed": selected,
            "data-testid": `${testId || 'slot'}-${slot.value}`,
            "data-state": slot.disabled ? 'disabled' : selected ? 'selected' : 'default',
            "data-held": slot.held || undefined,
            className: "tabular-nums",
            style: {
                // ≥ 2.75rem: a time is among the smallest things a thumb has to
                // hit on this screen, and there are dozens of them.
                minHeight: '2.75rem',
                padding: '0.5rem 0.625rem',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                fontSize: '0.8125rem',
                fontWeight: 600,
                cursor: slot.disabled ? 'not-allowed' : 'pointer',
                border: selected ? `2px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent}` : slot.held ? `1.5px dashed ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn}` : `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.14) : slot.held ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn, 0.1) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                color: selected ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                opacity: slot.disabled ? 0.45 : 1,
                transition: 'background 0.14s, border-color 0.14s'
            }
        }, slot.label);
    }));
}



var $acw62 = parcelRequire("acw62");


'use client';
// Card — the system's surface unit.
//
// With `onClick` it becomes a REAL button (never a `<div onClick>`): callers used
// to wrap it in a `role="button"` div to get keyboard operation and a focus ring
// back, which nested two interactive elements and handed screen readers a control
// inside a control. Those semantics belong here. Pass `role="link"` when the tap
// navigates rather than acts.
const $9169df7fa2fdff01$var$Card = ({ children: children, style: style, onClick: onClick, role: role, disabled: disabled, className: className, ...rest })=>{
    const surface = {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        borderRadius: 16,
        padding: '16px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
        ...style
    };
    if (!onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        style: surface,
        ...rest
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: role,
        disabled: disabled,
        onClick: onClick,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('outline-none focus-visible:ring-2 focus-visible:ring-ring', className),
        style: {
            ...surface,
            display: 'block',
            width: '100%',
            textAlign: 'inherit',
            font: 'inherit',
            color: 'inherit',
            cursor: disabled ? 'default' : 'pointer',
            transition: 'transform 0.15s, box-shadow 0.15s'
        },
        onMouseDown: (e)=>{
            if (!disabled) e.currentTarget.style.transform = 'scale(0.98)';
        },
        onMouseUp: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.transform = 'scale(1)';
        },
        ...rest
    }, children);
};
var $9169df7fa2fdff01$export$2e2bcd8739ae039 = $9169df7fa2fdff01$var$Card;



var $acw62 = parcelRequire("acw62");

'use client';
function $4f942082497afe1e$export$2e2bcd8739ae039({ status: status, style: style }) {
    const cfg = (0, $e7c165fb515b04ea$export$6881c75116d5bd6e)[status] || {
        label: status || "\u2014",
        bg: '#f1f5f9',
        text: '#64748b'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            background: cfg.bg,
            color: cfg.text,
            ...style
        }
    }, cfg.label);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $178f36e6e586ad89$export$2e2bcd8739ae039({ label: label, value: value, unit: unit, icon: icon, bg: bg, accent: accent, loading: loading, minWidth: minWidth = 140, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderRadius: 12,
            padding: '16px 20px',
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            flex: 1,
            minWidth: minWidth,
            ...rest.style
        }
    }, icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 44,
            height: 44,
            borderRadius: 12,
            background: bg || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 22,
            fontWeight: 800,
            color: accent || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.15
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            whiteSpace: 'nowrap'
        }
    }, loading ? "\u2014" : value), unit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("wbr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 500,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginInlineStart: 4,
            whiteSpace: 'nowrap'
        }
    }, unit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginTop: 4
        }
    }, label)));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $64626580dc6749e0$export$2e2bcd8739ae039({ stats: stats, loading: loading, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: '12px 32px',
            display: 'flex',
            gap: 12,
            flexShrink: 0,
            overflowX: 'auto',
            ...style
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                background: s.bg,
                borderRadius: 10,
                padding: '8px 16px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 20,
                fontWeight: 800,
                color: s.color
            }
        }, loading ? "\u2014" : s.value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: 11,
                fontWeight: 600,
                color: s.color,
                opacity: 0.75
            }
        }, s.label))));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $ed420e5a4f8c639f$export$2e2bcd8739ae039({ title: title, sub: sub, breadcrumb: breadcrumb, children: children, autoFocus: autoFocus = false, ...rest }) {
    const hasMeta = sub || breadcrumb;
    const titleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!autoFocus) return;
        // `preventScroll`: the heading is already at the top of the page, and
        // scrolling on focus would fight the route change's own scroll reset.
        titleRef.current?.focus({
            preventScroll: true
        });
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            background: '#fff',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            padding: hasMeta ? '14px 32px' : '0 32px',
            display: 'flex',
            alignItems: 'center',
            gap: 20,
            minHeight: 64,
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1
        }
    }, breadcrumb && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 3
        }
    }, breadcrumb), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: titleRef,
        // -1: reachable by script, never a stop in the tab order. A heading
        // that took a Tab of its own would be a new obstacle on every page.
        tabIndex: autoFocus ? -1 : undefined,
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: 18,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.2,
            outline: 'none'
        }
    }, title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, sub)), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexShrink: 0
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2a140ead2dcbdb51$export$a2387ed3b5d536eb = {
    name: "arrow-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ],
        [
            "path",
            {
                d: "m12 5 7 7-7 7",
                key: "xquz4c"
            }
        ]
    ]
};
$2a140ead2dcbdb51$export$a2387ed3b5d536eb.node;
const $2a140ead2dcbdb51$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($2a140ead2dcbdb51$export$a2387ed3b5d536eb);





'use client';
function $3c79ee8367a72d83$export$2e2bcd8739ae039({ onBack: onBack, backLabel: backLabel, title: title, sub: sub, avatar: avatar, status: status, badges: badges, meta: meta, stats: stats, children: children, className: className, 'data-testid': testId, ...rest }) {
    if (backLabel === undefined) backLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().back;
    const metaItems = (meta || []).filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            paddingInline: '1.75rem',
            paddingBlock: '0.75rem',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            minHeight: '4rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        },
        ...rest
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": testId ? `${testId}-back` : undefined,
        className: "shrink-0 gap-1.5 ps-2 pe-3 text-muted-foreground hover:text-foreground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flex: 1,
            minWidth: 0
        }
    }, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, avatar), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            flex: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5625rem',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        dir: "auto",
        style: {
            margin: 0,
            fontWeight: 800,
            fontSize: '1.125rem',
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, title), status, badges), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: '0.8125rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: '0.1875rem'
        }
    }, sub), metaItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap',
            marginTop: '0.1875rem',
            fontSize: '0.78125rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, metaItems.map((m, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: i
        }, i > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: 3,
                height: 3,
                borderRadius: '50%',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                opacity: 0.6,
                flexShrink: 0
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, m)))))), (stats?.length || children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            flexShrink: 0,
            flexWrap: 'wrap'
        }
    }, stats?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.5625rem'
        }
    }, stats.map((s, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                minWidth: '4.5rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.375rem',
                borderRadius: 'var(--radius, 0.625rem)',
                textAlign: 'center',
                background: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                border: `1px solid ${s.accent ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.65625rem',
                fontWeight: 600,
                marginBottom: '0.0625rem',
                color: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, s.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1rem',
                fontWeight: 800,
                letterSpacing: '-0.01em',
                color: s.accent ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                fontVariantNumeric: 'tabular-nums'
            }
        }, s.value)))), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
        }
    }, children)));
}



var $acw62 = parcelRequire("acw62");

'use client';
const $ca91b548719491bb$var$TopBar = ({ title: title, subtitle: subtitle, onBack: onBack, action: action })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            padding: '16px 20px 20px',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onBack,
        style: {
            background: 'rgba(255,255,255,0.15)',
            border: 'none',
            borderRadius: 10,
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            color: 'white',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.5",
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "9 18 15 12 9 6"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'white',
            fontSize: 18,
            fontWeight: 700
        }
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: 12,
            marginTop: 2
        }
    }, subtitle))), action));
var $ca91b548719491bb$export$2e2bcd8739ae039 = $ca91b548719491bb$var$TopBar;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2b40836209aae972$export$a2387ed3b5d536eb = {
    name: "chevron-left",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m15 18-6-6 6-6",
                key: "1wnfg3"
            }
        ]
    ]
};
$2b40836209aae972$export$a2387ed3b5d536eb.node;
const $2b40836209aae972$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($2b40836209aae972$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30b4d9519dd12f8d$export$a2387ed3b5d536eb = {
    name: "search",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21 21-4.34-4.34",
                key: "14j7rj"
            }
        ],
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ]
    ]
};
$30b4d9519dd12f8d$export$a2387ed3b5d536eb.node;
const $30b4d9519dd12f8d$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($30b4d9519dd12f8d$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b6a18bc128c0629$export$a2387ed3b5d536eb = {
    name: "x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M18 6 6 18",
                key: "1bl5f8"
            }
        ],
        [
            "path",
            {
                d: "m6 6 12 12",
                key: "d8bk6v"
            }
        ]
    ]
};
$4b6a18bc128c0629$export$a2387ed3b5d536eb.node;
const $4b6a18bc128c0629$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($4b6a18bc128c0629$export$a2387ed3b5d536eb);







var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayStatStrip — a day's figures as ONE row: the mobile KPI zone of a
// LIST-DOMINANT cockpit (MOBILE_WEB_PWA §4, `StatStrip`), where the list is the
// screen's purpose and the counts only frame it. It replaces 4-up tiles, which
// cost ~100px above the first row.
//
//   «۱۲ نوبت · ۳ منتظر · ۵ انجام · ۱ لغو»                       [end]
//
// Each number carries its semantic ink. A count that has not loaded is «–»,
// never 0 — a zero is a claim. Below 360px the words go and the coloured
// numbers stay; the row keeps a sentence for assistive tech either way.
//
// With `onSelect` each figure is also the FILTER it counts (aria-pressed): the
// clinic desk's status chips and its counts were two rows saying the same
// numbers, and are one here. Without it the row only reads.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.3), PM-0052.
//
// Props:
//   items      — [{ key, value (number|null), label, color? }]
//   loading    — every value reads «–»
//   format     — (n) => string; the caller's digits (default: String)
//   ariaLabel  — the row read as one sentence
//   activeKey / onSelect(key) — makes the figures toggle filters
//   end        — optional trailing node (a money figure, a link)
//   testIdPrefix — default 'reception' → `reception-stats`, `reception-stat-<key>`
//   onDark     — the strip on brand chrome (MobileHeader `figures`, PM-0120): white
//                ink, no surface, no rule — the gradient is the background
// ─────────────────────────────────────────────────────────────────────────────
const $93cce909f7881164$var$useNarrow = ()=>{
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== 'undefined' && window.innerWidth < 360);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const onResize = ()=>setNarrow(window.innerWidth < 360);
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    return narrow;
};
function $93cce909f7881164$export$2e2bcd8739ae039({ items: items, loading: loading = false, format: format = (n)=>String(n), ariaLabel: ariaLabel, activeKey: activeKey, onSelect: onSelect, end: end, testIdPrefix: testIdPrefix = 'reception', onDark: onDark = false, style: style }) {
    const narrow = $93cce909f7881164$var$useNarrow();
    const p = testIdPrefix;
    const n = (v)=>loading || v == null ? "\u2013" : format(v);
    const interactive = typeof onSelect === 'function';
    const figure = (it)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 800,
                color: onDark ? 'rgba(255,255,255,0.95)' : it.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
            }
        }, n(it.value)), !narrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontWeight: 500,
                color: onDark ? 'rgba(255,255,255,0.72)' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                marginInlineStart: '0.1875rem'
            }
        }, it.label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-stats`,
        style: {
            flexShrink: 0,
            minHeight: interactive ? '2.75rem' : '2.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: onDark ? 0 : '0 0.875rem',
            background: onDark ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            borderBottom: onDark ? 'none' : `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": ariaLabel,
        className: "mobile-strip",
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: interactive ? 'center' : 'baseline',
            gap: interactive ? 0 : '0.375rem',
            overflowX: interactive ? 'auto' : 'hidden',
            whiteSpace: 'nowrap',
            scrollbarWidth: 'none'
        }
    }, items.map((it, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: it.key
        }, i > 0 && !interactive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                color: onDark ? 'rgba(255,255,255,0.4)' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                fontSize: '0.75rem'
            }
        }, "\xb7"), interactive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "ghost",
            size: "sm",
            "data-testid": `${p}-stat-${it.key}`,
            "aria-pressed": activeKey === it.key,
            "aria-label": `${it.label} ${n(it.value)}`,
            onClick: ()=>onSelect(it.key),
            className: "h-auto min-h-9 shrink-0 rounded-full px-1.5 py-0 font-normal",
            style: {
                fontSize: '0.78125rem',
                background: activeKey === it.key ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)(it.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.14) : 'transparent',
                boxShadow: activeKey === it.key ? `inset 0 0 0 1px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)(it.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.45)}` : 'none'
            }
        }, figure(it)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${p}-stat-${it.key}`,
            "aria-hidden": true,
            style: {
                fontSize: '0.78125rem'
            }
        }, figure(it))))), end ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, end) : null);
}


'use client';
/**
 * MobileHeader — the gradient screen header that is the mobile brand signature
 * (DESIGN-CONCEPT-MOBILE §3.2). Every top-level mobile screen opens with it.
 *
 * Two modes, chosen by the props you pass — never a mode flag:
 *
 *   • **Cockpit** (`user`) — the person's name as a *greeting*, not chrome:
 *     avatar + «خوش آمدید،» + name on the inline-start edge. What a top-level
 *     bottom-nav destination uses.
 *   • **Content screen** (`onBack` + `title`) — a drilled-into full-screen
 *     surface has no bottom nav, so the header itself carries the way back:
 *     back affordance above the screen title, on the same brand chrome rather
 *     than in a separate bar above it (§3.1).
 *   • **Compact** (`compact`) — one 3.75rem row for a WORKSPACE screen, where
 *     the chrome competes with the work (the visit room): icon-only back,
 *     the title and `subtitle` as two short lines beside an optional `avatar`,
 *     then `action`, then `actions`. The title shrinks a step at a time
 *     (0.9375 → 0.75rem) before it ellipsises, so a long name is read rather
 *     than cut. `onTitleClick` makes the identity block a button — the name IS
 *     the way into the record — and `titleActionLabel` says so under it.
 *
 * Both modes render `title` as the page's single `<h1>` (§12.1) and accept
 * `actions` — white-alpha square quick actions ≥2.75rem, the sanctioned way to
 * tint on-gradient chrome (§2.2). A control that navigates nowhere is a defect,
 * so a caller passes an action only when its destination exists.
 *
 * `children` is the optional context-widget row (a date navigator, a filter
 * strip) rendered inside the gradient below the identity row.
 *
 * Props:
 *   title      — screen title; rendered as the page's <h1>
 *   subtitle   — optional line under the title
 *   greeting   — cockpit lead-in above the name (default «خوش آمدید،»)
 *   user       — { name, avatar } → cockpit greeting mode
 *   onBack     — back handler → content mode; renders the «بازگشت» affordance
 *   backLabel  — label for the back affordance (default «بازگشت»)
 *   actions    — [{ key, icon, label, onClick, badge? }] end-side quick actions;
 *                `badge` = { color } renders a small status dot
 *   action     — a single trailing node (shorthand; rendered after `actions`;
 *                in compact mode BEFORE them, so a live control such as the
 *                visit's listen pill sits next to the identity, and «⋯» last)
 *   compact    — the one-row workspace layout (see above)
 *   figures    — compact only (PM-0120): [{ key, value, label, color? }] rendered
 *                as ONE inline row of figures under the identity row, on the
 *                gradient (`DayStatStrip onDark`) — the place a content screen
 *                used to spend four stat tiles and ~200 px on. Hidden when every
 *                value is null and nothing is loading: a row of «–» is not a
 *                glance. `figuresLoading`, `figuresFormat`, `figuresLabel` and
 *                `figuresTestIdPrefix` (→ `<prefix>-stats`) are the strip's own.
 *   avatar     — compact only: `{ name, src }` → a 2rem avatar before the title
 *   leading    — compact only: one node right after the back affordance, in
 *                the header's top inline-START corner (the visit's event bell).
 *                It renders nothing when it has nothing to say, so the slot
 *                costs the title no width until then.
 *   onTitleClick / titleActionLabel — compact only: make the identity block a
 *                button and name its destination under the title
 *   backTestId — override for the back control's `data-testid`. Defaults to
 *                `${testId}-back`; a screen whose selector contract already
 *                names its own back control passes it here rather than
 *                renaming the whole header (which is what an app fork did).
 *   sticky     — pin the header to the top of its scroller. A list destination
 *                whose filter bar lives in `children` needs the bar to stay
 *                reachable while the list scrolls under it (§3.2).
 *   search     — `{ value, onChange, placeholder, clearLabel, onClear, onSubmit,
 *                autoFocus, testId }`. Renders the on-gradient search field that a lookup
 *                screen opens into: a real `<input>` at ≥2.75rem with an inline
 *                clear control, sitting above `children`. Passing it is what
 *                turns a 🔍 quick action into a search surface, so no screen
 *                hand-rolls a white field on the brand chrome again.
 *   children   — optional context-widget row
 *   className / data-testid — forwarded to the root (§15.1)
 */ function $62f4a9fc87ba90f8$var$QuickActions({ actions: actions, testId: testId }) {
    if (!actions?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, actions.map(({ key: key, icon: icon, label: label, onClick: onClick, badge: badge })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key,
            style: {
                position: 'relative'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            variant: "ghost",
            size: "icon",
            onClick: onClick,
            "aria-label": label,
            title: label,
            "data-testid": testId ? `${testId}-action-${key}` : undefined,
            className: "min-w-11 min-h-11 text-white hover:bg-white/25",
            style: {
                background: 'rgba(255,255,255,0.14)',
                borderRadius: 'var(--radius, 0.625rem)'
            }
        }, icon), badge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                position: 'absolute',
                top: '0.25rem',
                insetInlineEnd: '0.25rem',
                width: '0.5rem',
                height: '0.5rem',
                borderRadius: '50%',
                background: badge.color,
                border: '1.5px solid rgba(1,94,156,0.9)'
            }
        }))));
}
// The compact title: tries each size in turn and keeps the largest at which
// the text still fits its box, then ellipsises. A patient's full name is the
// one thing on a visit header that must be READ, and a phone gives it ~9rem.
const $62f4a9fc87ba90f8$var$TITLE_SIZES = [
    '0.9375rem',
    '0.875rem',
    '0.8125rem',
    '0.75rem'
];
function $62f4a9fc87ba90f8$var$FitTitle({ children: children, testId: testId }) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [step, setStep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        const el = ref.current;
        if (!el) return undefined;
        const fit = ()=>{
            let k = 0;
            el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[0];
            while(k < $62f4a9fc87ba90f8$var$TITLE_SIZES.length - 1 && el.scrollWidth > el.clientWidth + 1){
                k += 1;
                el.style.fontSize = $62f4a9fc87ba90f8$var$TITLE_SIZES[k];
            }
            setStep(k);
        };
        fit();
        const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
        ro?.observe(el.parentElement || el);
        return ()=>ro?.disconnect();
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        ref: ref,
        dir: "auto",
        "data-testid": testId,
        style: {
            margin: 0,
            minWidth: 0,
            color: '#fff',
            fontWeight: 700,
            lineHeight: 1.25,
            fontSize: $62f4a9fc87ba90f8$var$TITLE_SIZES[step],
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, children);
}
function $62f4a9fc87ba90f8$var$CompactIdentity({ title: title, subtitle: subtitle, avatar: avatar, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, testId: testId }) {
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: avatar.name || title || (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.unknownInitial,
        size: 32,
        bg: "rgba(255,255,255,0.2)",
        src: avatar.src || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            gap: '0.0625rem',
            textAlign: 'start'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$FitTitle, {
        testId: `${testId}-title`
    }, title), (subtitle || onTitleClick && titleActionLabel) && /* One run of inline text, so a narrow slot ellipsises the whole line
             instead of clipping the hint. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0,
            fontSize: '0.6875rem',
            lineHeight: 1.3,
            color: 'rgba(255,255,255,0.72)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, subtitle, subtitle && onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true
    }, " \xb7 "), onTitleClick && titleActionLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 600
        }
    }, titleActionLabel, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2b40836209aae972$export$2e2bcd8739ae039), {
        size: 11,
        "aria-hidden": true,
        style: {
            display: 'inline-block',
            verticalAlign: '-0.125em',
            marginInlineStart: '0.125rem',
            transform: 'scaleX(var(--dir-flip, 1))'
        }
    })))));
    const layout = {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        minWidth: 0,
        flex: 1,
        minHeight: '2.75rem'
    };
    if (!onTitleClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: layout
    }, body);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onTitleClick,
        "aria-label": titleActionLabel ? `${titleActionLabel} \u{2014} ${title}` : title,
        "data-testid": `${testId}-identity`,
        className: "rounded-lg hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60",
        style: {
            ...layout,
            background: 'transparent',
            border: 0,
            padding: '0 0.25rem',
            color: '#fff',
            cursor: 'pointer',
            font: 'inherit'
        }
    }, body);
}
function $62f4a9fc87ba90f8$export$2e2bcd8739ae039({ title: title, subtitle: subtitle, greeting: greeting, user: user, onBack: onBack, backLabel: backLabel, actions: actions = [], action: action, compact: compact = false, figures: figures, figuresLoading: figuresLoading = false, figuresFormat: figuresFormat, figuresLabel: figuresLabel, figuresTestIdPrefix: figuresTestIdPrefix = 'header', avatar: avatar, leading: leading, onTitleClick: onTitleClick, titleActionLabel: titleActionLabel, backTestId: backTestId, sticky: sticky = false, search: search, children: children, className: className, style: style, 'data-testid': testId = 'mobile-header', ...rest }) {
    if (greeting === undefined) greeting = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.greeting;
    if (backLabel === undefined) backLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().back;
    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        "data-compact": "",
        style: {
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            padding: 'calc(0.5rem + env(safe-area-inset-top, 0px)) 0.75rem 0.5rem',
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-2.5rem',
            insetInlineEnd: '-1.875rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            minHeight: '2.75rem'
        }
    }, onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        onClick: onBack,
        "aria-label": backLabel,
        title: backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "min-w-11 min-h-11 shrink-0 text-white/90 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
        size: 20,
        "aria-hidden": true
    })), leading, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$CompactIdentity, {
        title: title,
        subtitle: subtitle,
        avatar: avatar,
        onTitleClick: onTitleClick,
        titleActionLabel: titleActionLabel,
        testId: testId
    }), action, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    })), figures && (figuresLoading || figures.some((f)=>f.value != null)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93cce909f7881164$export$2e2bcd8739ae039), {
        onDark: true,
        items: figures,
        loading: figuresLoading,
        format: figuresFormat,
        ariaLabel: figuresLabel,
        testIdPrefix: figuresTestIdPrefix,
        style: {
            marginTop: '0.125rem',
            minHeight: '2rem'
        }
    }), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.5rem'
        }
    }, children));
    const hasTrailing = actions.length > 0 || Boolean(action);
    const trailing = hasTrailing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$QuickActions, {
        actions: actions,
        testId: testId
    }), action);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        className: className,
        "data-testid": testId,
        style: {
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            padding: 'calc(1rem + env(safe-area-inset-top, 0px)) 1rem 1.5rem',
            // `sticky` keeps the filter bar in `children` reachable while a long
            // list scrolls under it; `relative` is the default so the decorative
            // circles below still clip to the header.
            position: sticky ? 'sticky' : 'relative',
            ...sticky ? {
                top: 0,
                zIndex: 30
            } : null,
            overflow: 'hidden',
            flexShrink: 0,
            // A caller's `style` is MERGED OVER the computed layout, the convention
            // the rest of the kit follows (`Card`, the chat family). It used to fall
            // into `...rest` and — because the spread sits after this attribute —
            // REPLACE the whole object: passing `style` for so much as a
            // `position: sticky` silently deleted the brand gradient, the padding
            // and the safe-area inset, and left white text on a white page.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            top: '-1.875rem',
            insetInlineEnd: '-1.875rem',
            width: '8.75rem',
            height: '8.75rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.04)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            position: 'absolute',
            bottom: '-1.25rem',
            insetInlineStart: '-0.625rem',
            width: '6.25rem',
            height: '6.25rem',
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.06)'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative'
        }
    }, onBack ? /* Content mode — the way back lives on the brand chrome (§3.1). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onBack,
        "aria-label": backLabel,
        "data-testid": backTestId || `${testId}-back`,
        className: "h-auto min-h-11 gap-1.5 ps-0 pe-2 text-white/85 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, backLabel)), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: '0.25rem 0 0',
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)) : /* Cockpit mode — greeting (or a bare title) + quick actions (§3.2). */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (user || hasTrailing) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '0.75rem'
        }
    }, user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: user.name || (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.unknownInitial,
        size: 40,
        bg: "rgba(255,255,255,0.2)",
        src: user.avatar || undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.65)',
            fontSize: '0.6875rem'
        }
    }, greeting), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            color: '#fff',
            fontSize: '0.9375rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, user.name || "\u2026"))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null), trailing), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            margin: user || hasTrailing ? '0.75rem 0 0' : 0,
            color: '#fff',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.25
        }
    }, title)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: 'rgba(255,255,255,0.7)',
            fontSize: '0.75rem',
            marginTop: '0.25rem'
        }
    }, subtitle), search && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($62f4a9fc87ba90f8$var$SearchField, {
        ...search,
        headerTestId: testId
    }), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: '0.875rem'
        }
    }, children)));
}
/**
 * The on-gradient search field (§3.2). A real `<input>` — not a kit `TextInput`
 * — because the kit field is painted for a white surface and this one sits on
 * the brand chrome; the shared contract it does keep is the 2.75rem height, the
 * ≥1rem font (anything smaller triggers iOS focus-zoom) and a clear control.
 */ function $62f4a9fc87ba90f8$var$SearchField({ value: value = '', onChange: onChange, onClear: onClear, onSubmit: onSubmit, placeholder: placeholder, clearLabel: clearLabel, autoFocus: autoFocus = false, testId: testId, headerTestId: headerTestId }) {
    if (clearLabel === undefined) clearLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().mobileHeader.clear;
    const id = testId || `${headerTestId}-search`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        role: "search",
        onSubmit: (e)=>{
            e.preventDefault();
            onSubmit?.(value);
        },
        style: {
            marginTop: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'rgba(255,255,255,0.16)',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            paddingInline: '0.75rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30b4d9519dd12f8d$export$2e2bcd8739ae039), {
        size: 17,
        color: "rgba(255,255,255,0.75)",
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "search",
        inputMode: "search",
        enterKeyHint: "search",
        autoFocus: autoFocus,
        value: value,
        onChange: (e)=>onChange?.(e.target.value),
        placeholder: placeholder,
        "data-testid": id,
        style: {
            flex: 1,
            minWidth: 0,
            height: '2.75rem',
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: '#fff',
            // ≥1rem or iOS zooms the whole page on focus and never zooms back.
            fontSize: '1rem',
            fontFamily: 'inherit'
        }
    }), value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "ghost",
        size: "icon",
        onClick: ()=>onClear?.(),
        "aria-label": clearLabel,
        "data-testid": `${id}-clear`,
        className: "min-w-11 min-h-11 text-white/80 hover:bg-white/15 hover:text-white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    })) : null);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5b56343e65588121$export$a2387ed3b5d536eb = {
    name: "calendar-days",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M8 13h.01",
                key: "1sbv64"
            }
        ],
        [
            "path",
            {
                d: "M12 13h.01",
                key: "y0uutt"
            }
        ],
        [
            "path",
            {
                d: "M16 13h.01",
                key: "wip0gl"
            }
        ],
        [
            "path",
            {
                d: "M8 17h.01",
                key: "p3bg7i"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ],
        [
            "path",
            {
                d: "M16 17h.01",
                key: "ql8jdd"
            }
        ]
    ]
};
$5b56343e65588121$export$a2387ed3b5d536eb.node;
const $5b56343e65588121$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5b56343e65588121$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dc4be5d9d5a360aa$export$a2387ed3b5d536eb = {
    name: "chevron-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 9 6 6 6-6",
                key: "qrunsl"
            }
        ]
    ]
};
$dc4be5d9d5a360aa$export$a2387ed3b5d536eb.node;
const $dc4be5d9d5a360aa$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($dc4be5d9d5a360aa$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9c8dd034124f4eb9$export$a2387ed3b5d536eb = {
    name: "chevron-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m9 18 6-6-6-6",
                key: "mthhwq"
            }
        ]
    ]
};
$9c8dd034124f4eb9$export$a2387ed3b5d536eb.node;
const $9c8dd034124f4eb9$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($9c8dd034124f4eb9$export$a2387ed3b5d536eb);





'use client';
// ─────────────────────────────────────────────────────────────────────────────
// DayContextCard — the context row of a LIST-DOMINANT cockpit's gradient
// header (MOBILE_WEB_PWA §3.2): one white-alpha inset card answering "what am
// I looking at", in two rows.
//
//   line     — the lens: WHERE / WHOSE list this is. The doctor's پذیرش says
//              where the presence schedule puts them («اکنون در کلینیک مهر ·
//              تا ۱۴:۰۰»); the clinic's says whose queue the desk is working
//              («دکتر رضایی · تزریق»). With a choice to make it is the trigger
//              for the caller's picker (`onOpen`); without one it only informs
//              — absent, never disabled.
//   date bar — ‹ day › with the label opening the week sheet. It replaces a
//              navigator + week strip stack that cost ~130px of a phone.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.2) when
// the clinic's phone reception was rebuilt on the same anatomy (PM-0052). The
// card renders; it decides nothing: the sentence, the icon and the picker are
// the caller's.
//
// Props:
//   line        — null | {
//                   icon      lucide component
//                   text      the sentence (already formatted)
//                   hint      optional second, smaller line
//                   pill      optional trailing chip (the lens as it stands)
//                   tone      'warn' | 'muted' | undefined
//                   state     forwarded as data-place-state (tests, styling)
//                   onOpen    makes the row a button that opens a picker
//                   openLabel the button's accessible name
//                   ariaLabel the live region's label (live lines only)
//                   live      announce changes politely (a schedule boundary
//                             flips the sentence once, so it is said once)
//                 }
//   action      — optional node at the END of the lens row, outside its button
//                 (the clinic desk's registry search). On-gradient, ≥2.75rem.
//   dateLabel / isToday / onPrev / onNext / onToday / onOpenWeek
//   labels      — { prevDay, nextDay, today, backToToday, pickDay } (kitCopy defaults)
//   testIdPrefix — default 'reception' → `reception-context`, `-place`,
//                  `-place-open`, `-place-lens`, `-place-hint`, `-datenav`,
//                  `-datenav-prev|pick|today|next`
// ─────────────────────────────────────────────────────────────────────────────
const $9dd7f5e3d401ab69$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $9dd7f5e3d401ab69$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $9dd7f5e3d401ab69$var$rowBase = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
    flex: 1,
    minWidth: 0,
    minHeight: '2.75rem',
    padding: '0 0.625rem',
    color: '#fff',
    textAlign: 'start'
};
function $9dd7f5e3d401ab69$export$2e2bcd8739ae039({ line: line, action: action, dateLabel: dateLabel, isToday: isToday, onPrev: onPrev, onNext: onNext, onToday: onToday, onOpenWeek: onOpenWeek, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception', style: style }) {
    const copy = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).dayContext,
        ...labels
    };
    const p = testIdPrefix;
    const Icon = line?.icon;
    const warn = line?.tone === 'warn';
    const muted = line?.tone === 'muted';
    const lineBody = line && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 15,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: warn ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight : '#fff',
            opacity: muted ? 0.7 : 1
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: '0.78125rem',
            fontWeight: 700,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            opacity: muted ? 0.8 : 1
        }
    }, line.text), line.hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-hint`,
        style: {
            display: 'block',
            fontSize: '0.65625rem',
            fontWeight: 500,
            color: 'rgba(255,255,255,0.7)'
        }
    }, line.hint)), line.pill && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${p}-place-lens`,
        style: {
            flexShrink: 0,
            maxWidth: '40%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.2)'
        }
    }, line.pill), line.onOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
        size: 14,
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.75
        }
    }));
    const liveProps = line?.live ? {
        role: 'status',
        'aria-live': 'polite',
        'aria-label': line.ariaLabel ? `${line.ariaLabel}: ${line.text}` : undefined
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-context`,
        style: {
            background: 'rgba(255,255,255,0.12)',
            borderRadius: '0.75rem',
            overflow: 'hidden',
            ...style
        }
    }, line && line.text != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...liveProps,
        "data-testid": `${p}-place`,
        "data-place-state": line.state,
        style: {
            borderBottom: '1px solid rgba(255,255,255,0.14)',
            ...action ? {
                display: 'flex',
                alignItems: 'center'
            } : null
        }
    }, line.onOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        "data-testid": `${p}-place-open`,
        "aria-haspopup": "dialog",
        "aria-label": line.openLabel,
        className: "h-auto justify-start rounded-none font-normal hover:bg-white/10",
        style: $9dd7f5e3d401ab69$var$rowBase,
        onClick: line.onOpen
    }, lineBody) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$9dd7f5e3d401ab69$var$rowBase,
            minHeight: action ? '2.75rem' : '2.25rem',
            paddingBlock: '0.375rem'
        }
    }, lineBody), action ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0,
            paddingInlineEnd: '0.25rem'
        }
    }, action) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-datenav`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem',
            padding: '0.125rem 0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-prev`,
        "aria-label": copy.prevDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.375rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-pick`,
        "aria-label": onOpenWeek ? `${dateLabel} \u{2014} ${copy.pickDay}` : undefined,
        "aria-haspopup": onOpenWeek ? 'dialog' : undefined,
        className: "h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15",
        onClick: onOpenWeek
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5b56343e65588121$export$2e2bcd8739ae039), {
        size: 14,
        style: {
            opacity: 0.75
        },
        "aria-hidden": true
    }), dateLabel), isToday ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '1rem',
            padding: '0.125rem 0.5rem',
            background: 'rgba(255,255,255,0.24)',
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, copy.today) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${p}-datenav-today`,
        className: "h-auto min-h-8 px-2 py-0.5 text-[0.65625rem] font-bold text-white whitespace-nowrap rounded-full hover:bg-white/25",
        style: {
            background: 'rgba(255,255,255,0.18)'
        },
        onClick: onToday
    }, copy.backToToday)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-datenav-next`,
        "aria-label": copy.nextDay,
        className: "min-w-11 min-h-11 text-white hover:bg-white/15",
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $9dd7f5e3d401ab69$var$NEXT_GLYPH
    }))));
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


// ─────────────────────────────────────────────────────────────────────────────
// What the date picker draws in each UI language.
//
// The picker used to be Persian whatever the page was: an English reception
// desk read «۴ مهر ۱۴۰۵» in a field whose own heading said «Saturday,
// September 26, 2026», and a mistyped date answered «قالب تاریخ: ۱۴۰۴/۰۵/۱۲».
// Everything the picker shows now comes from this table, keyed by the base
// language of `<html lang>` — the channel `MoneyInput` and `PhoneInput` already
// read (see `documentLocale` in money.js). The kit cannot import an app's i18n.
//
// `calendar` is the one entry that is not wording. It matches the calendar each
// app's locale descriptor hands Intl (`intl` in i18n/config.js): Persian and
// Arabic are Jalali (`-u-ca-persian`), English, French and German are Gregorian. The
// picker and the app's own `formatDate` have to agree, or the desk picks one day
// and reads back another. CLDR cannot supply it — it gives `ar` the Gregorian
// calendar, which both apps deliberately override — so it is data here, not
// `resolvedOptions().calendar`.
//
// `months` carries BOTH calendars' names for every language, because a caller
// can pin the calendar (`calendar="jalali"`) on a surface that is Jalali in
// every language — an accounting period is bounded by Jalali months whatever
// the UI language is.
//
// `date` is wording AND word order: DateRangeFilter reads the order of a range
// label off it (day first unless `{month}` leads), never off `calendar` — French
// and German are Gregorian like English and still put the day first; German's
// «{d}.» also gives every day of a range its ordinal dot. `weekStart` is the
// first column of a GREGORIAN grid only; a Jalali grid opens on Saturday in
// every language (JalaliDatePicker.jsx `JALALI.weekStart`).
//
// Adding a language is adding an entry. An unknown one gets Persian, the product
// default, exactly as `documentLocale` falls back — or the brand's default
// language when the brand names one.
//
// A BRAND that names a calendar (`calendar: 'gregory' | 'jalali'`,
// ui/lib/brand.js) moves every language's `calendar` to it, the same switch the
// apps' locale descriptors make, so picker and `formatDate` still agree. A caller
// that pins `calendar` on the picker still wins.
// ─────────────────────────────────────────────────────────────────────────────


// The brand's calendar ids → this table's.
const $0873d4f32691c14e$var$PICKER_CALENDAR = {
    gregory: 'gregorian',
    jalali: 'jalali'
};
const $0873d4f32691c14e$export$4b8e9f545c94f612 = {
    fa: {
        calendar: 'jalali',
        dir: 'rtl',
        digits: "\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9",
        // First column of a Gregorian grid; a Jalali grid always opens on شنبه.
        weekStart: 6,
        // Indexed by `Date#getDay()` — 0 is Sunday.
        weekdays: [
            "\u06CC",
            "\u062F",
            "\u0633",
            "\u0686",
            "\u067E",
            "\u062C",
            "\u0634"
        ],
        months: {
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
                "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u06CC\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u06CC\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u06CC",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u0698\u0627\u0646\u0648\u06CC\u0647",
                "\u0641\u0648\u0631\u06CC\u0647",
                "\u0645\u0627\u0631\u0633",
                "\u0622\u0648\u0631\u06CC\u0644",
                "\u0645\u0647",
                "\u0698\u0648\u0626\u0646",
                "\u0698\u0648\u0626\u06CC\u0647",
                "\u0627\u0648\u062A",
                "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
                "\u0627\u06A9\u062A\u0628\u0631",
                "\u0646\u0648\u0627\u0645\u0628\u0631",
                "\u062F\u0633\u0627\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0633\u0627\u0639\u062A {time}",
        strings: {
            placeholder: "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
            selectYear: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0627\u0644",
            goToToday: "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
            openCalendar: "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
            time: "\u0633\u0627\u0639\u062A",
            hour: "\u0633\u0627\u0639\u062A",
            minute: "\u062F\u0642\u06CC\u0642\u0647",
            stepUp: "{label} \u0628\u06CC\u0634\u062A\u0631",
            stepDown: "{label} \u06A9\u0645\u062A\u0631",
            now: "\u0627\u06A9\u0646\u0648\u0646",
            confirm: "\u062A\u0627\u06CC\u06CC\u062F"
        },
        errors: {
            format: "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: {example}",
            range: "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            time: "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
            noTime: "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
            future: "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A"
        }
    },
    en: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        weekStart: 0,
        weekdays: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        months: {
            // The Latin spellings ICU gives `en-US-u-ca-persian`, so a pinned-Jalali
            // picker and the app's `clinicCalendarIntl` labels name a month the same way.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            gregorian: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ]
        },
        date: '{month} {d}, {y}',
        dateTime: '{date}, {time}',
        strings: {
            placeholder: 'Select date',
            selectYear: 'Select year',
            goToToday: 'Go to today',
            clear: 'Clear date',
            openCalendar: 'Show calendar',
            time: 'Time',
            hour: 'Hour',
            minute: 'Minute',
            stepUp: '{label} up',
            stepDown: '{label} down',
            now: 'Now',
            confirm: 'Done'
        },
        errors: {
            format: 'Date format: {example}',
            range: 'Invalid date',
            time: 'Invalid time',
            noTime: 'This field does not take a time',
            future: 'Future dates are not allowed'
        }
    },
    ar: {
        calendar: 'jalali',
        dir: 'rtl',
        // Arabic-Indic, the set the apps' `-u-nu-arab` renders — NOT Persian's.
        digits: "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669",
        weekStart: 6,
        weekdays: [
            "\u062D",
            "\u0646",
            "\u062B",
            "\u0631",
            "\u062E",
            "\u062C",
            "\u0633"
        ],
        months: {
            // The apps' corrected list (`monthNames` on their `ar` descriptor): CLDR's
            // Arabic names for the Persian calendar are not words in any language.
            jalali: [
                "\u0641\u0631\u0648\u0631\u062F\u064A\u0646",
                "\u0627\u0631\u062F\u064A\u0628\u0647\u0634\u062A",
                "\u062E\u0631\u062F\u0627\u062F",
                "\u062A\u064A\u0631",
                "\u0645\u0631\u062F\u0627\u062F",
                "\u0634\u0647\u0631\u064A\u0648\u0631",
                "\u0645\u0647\u0631",
                "\u0622\u0628\u0627\u0646",
                "\u0622\u0630\u0631",
                "\u062F\u064A",
                "\u0628\u0647\u0645\u0646",
                "\u0627\u0633\u0641\u0646\u062F"
            ],
            gregorian: [
                "\u064A\u0646\u0627\u064A\u0631",
                "\u0641\u0628\u0631\u0627\u064A\u0631",
                "\u0645\u0627\u0631\u0633",
                "\u0623\u0628\u0631\u064A\u0644",
                "\u0645\u0627\u064A\u0648",
                "\u064A\u0648\u0646\u064A\u0648",
                "\u064A\u0648\u0644\u064A\u0648",
                "\u0623\u063A\u0633\u0637\u0633",
                "\u0633\u0628\u062A\u0645\u0628\u0631",
                "\u0623\u0643\u062A\u0648\u0628\u0631",
                "\u0646\u0648\u0641\u0645\u0628\u0631",
                "\u062F\u064A\u0633\u0645\u0628\u0631"
            ]
        },
        date: '{d} {month} {y}',
        dateTime: "{date} \u0627\u0644\u0633\u0627\u0639\u0629 {time}",
        strings: {
            placeholder: "\u0627\u062E\u062A\u0631 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            selectYear: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0633\u0646\u0629",
            goToToday: "\u0627\u0644\u0630\u0647\u0627\u0628 \u0625\u0644\u0649 \u0627\u0644\u064A\u0648\u0645",
            clear: "\u0645\u0633\u062D \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
            openCalendar: "\u0639\u0631\u0636 \u0627\u0644\u062A\u0642\u0648\u064A\u0645",
            time: "\u0627\u0644\u0648\u0642\u062A",
            hour: "\u0627\u0644\u0633\u0627\u0639\u0629",
            minute: "\u0627\u0644\u062F\u0642\u064A\u0642\u0629",
            stepUp: "\u0632\u064A\u0627\u062F\u0629 {label}",
            stepDown: "\u0625\u0646\u0642\u0627\u0635 {label}",
            now: "\u0627\u0644\u0622\u0646",
            confirm: "\u062A\u0623\u0643\u064A\u062F"
        },
        errors: {
            format: "\u0635\u064A\u063A\u0629 \u0627\u0644\u062A\u0627\u0631\u064A\u062E: {example}",
            range: "\u062A\u0627\u0631\u064A\u062E \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            time: "\u0648\u0642\u062A \u063A\u064A\u0631 \u0635\u0627\u0644\u062D",
            noTime: "\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0644\u0627 \u064A\u0642\u0628\u0644 \u0648\u0642\u062A\u064B\u0627",
            future: "\u0644\u0627 \u064A\u064F\u0633\u0645\u062D \u0628\u062A\u0627\u0631\u064A\u062E \u0645\u0633\u062A\u0642\u0628\u0644\u064A"
        }
    },
    // PM-0185 (D3/D8/D9 = the workspace's docs/locale/FRENCH.md §9): Gregorian like
    // `en`, but day first and Monday first.
    fr: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        // Monday, as French calendars draw a week (CLDR fr firstDay 1, D9). Only the
        // Gregorian grid reads it; the panels' own week strips stay Saturday-first.
        weekStart: 1,
        // Indexed by `Date#getDay()` — 0 is Sunday. Two letters: CLDR's narrow
        // «D L M M J V S» names Tuesday and Wednesday alike.
        weekdays: [
            'Di',
            'Lu',
            'Ma',
            'Me',
            'Je',
            'Ve',
            'Sa'
        ],
        months: {
            // D8: the English UI's spellings, one fixed list — the `monthNames` the apps'
            // French descriptors pass (with `stripEra`) and server text's month names —
            // so picker, formatter and server name a month alike. Not ICU's
            // `fr-u-ca-persian` names (ordibehešt, khordâd …), which differ between ICU builds.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            // Lower case, as French writes them, the calendar's heading included.
            gregorian: [
                'janvier',
                "f\xe9vrier",
                'mars',
                'avril',
                'mai',
                'juin',
                'juillet',
                "ao\xfbt",
                'septembre',
                'octobre',
                'novembre',
                "d\xe9cembre"
            ]
        },
        // What Intl prints for `fr-FR`: «26 septembre 2026», «26 septembre 2026 à 14:30».
        date: '{d} {month} {y}',
        dateTime: "{date} \xe0 {time}",
        strings: {
            placeholder: 'Choisir une date',
            selectYear: "Choisir l\u2019ann\xe9e",
            goToToday: "Aller \xe0 aujourd\u2019hui",
            clear: 'Effacer la date',
            openCalendar: 'Afficher le calendrier',
            time: 'Heure',
            hour: 'Heure',
            minute: 'Minute',
            // `{label}` is `hour` or `minute` above, capitalised — so it leads.
            stepUp: "{label}\xa0: augmenter",
            stepDown: "{label}\xa0: diminuer",
            now: 'Maintenant',
            confirm: 'OK'
        },
        errors: {
            format: "Format de date\xa0: {example}",
            range: 'Date non valide',
            time: 'Heure non valide',
            noTime: "Ce champ n\u2019accepte pas d\u2019heure",
            future: "Les dates futures ne sont pas autoris\xe9es"
        }
    },
    // PM-0212: German follows the French plan — Gregorian like `en`, day first and
    // Monday first, and the day is an ordinal («26. September 2026»).
    de: {
        calendar: 'gregorian',
        dir: 'ltr',
        digits: '0123456789',
        // Monday, as German calendars draw a week (CLDR de firstDay 1, DIN 1355). Only
        // the Gregorian grid reads it; the panels' own week strips stay Saturday-first.
        weekStart: 1,
        // Indexed by `Date#getDay()` — 0 is Sunday. The two-letter forms German
        // calendars print (CLDR `de` short: «So Mo Di Mi Do Fr Sa»).
        weekdays: [
            'So',
            'Mo',
            'Di',
            'Mi',
            'Do',
            'Fr',
            'Sa'
        ],
        months: {
            // The English UI's spellings, one fixed list — the `monthNames` the apps'
            // German descriptors pass (with `stripEra`) and server text's month names —
            // as for French (D8), not ICU's `de-u-ca-persian` names.
            jalali: [
                'Farvardin',
                'Ordibehesht',
                'Khordad',
                'Tir',
                'Mordad',
                'Shahrivar',
                'Mehr',
                'Aban',
                'Azar',
                'Dey',
                'Bahman',
                'Esfand'
            ],
            gregorian: [
                'Januar',
                'Februar',
                "M\xe4rz",
                'April',
                'Mai',
                'Juni',
                'Juli',
                'August',
                'September',
                'Oktober',
                'November',
                'Dezember'
            ]
        },
        // What Intl prints for `de-DE`: «26. September 2026», «26. September 2026 um 14:30».
        // The «.» after `{d}` is the ordinal; DateRangeFilter keeps it on every day.
        date: '{d}. {month} {y}',
        dateTime: '{date} um {time}',
        strings: {
            placeholder: "Datum w\xe4hlen",
            selectYear: "Jahr w\xe4hlen",
            goToToday: 'Zu heute springen',
            clear: "Datum l\xf6schen",
            openCalendar: 'Kalender anzeigen',
            time: 'Uhrzeit',
            hour: 'Stunde',
            minute: 'Minute',
            // `{label}` is `hour` or `minute` above, a capitalised noun — so it leads.
            stepUp: "{label} erh\xf6hen",
            stepDown: '{label} verringern',
            now: 'Jetzt',
            confirm: 'Fertig'
        },
        errors: {
            format: 'Datumsformat: {example}',
            range: "Ung\xfcltiges Datum",
            time: "Ung\xfcltige Uhrzeit",
            noTime: 'Dieses Feld nimmt keine Uhrzeit an',
            future: "Ein Datum in der Zukunft ist nicht zul\xe4ssig"
        }
    }
};
function $0873d4f32691c14e$export$90e478cf5247906b(locale) {
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    const L = $0873d4f32691c14e$export$4b8e9f545c94f612[base] || $0873d4f32691c14e$export$4b8e9f545c94f612[(0, $abf0c103b4b92127$export$879824979a5b153a)('fa')] || $0873d4f32691c14e$export$4b8e9f545c94f612.fa;
    const calendar = $0873d4f32691c14e$var$PICKER_CALENDAR[(0, $abf0c103b4b92127$export$a350347e69c4c055)(null)];
    return !calendar || calendar === L.calendar ? L : {
        ...L,
        calendar: calendar
    };
}
const $0873d4f32691c14e$export$9a328bbde6508c84 = (template, vars)=>String(template).replace(/\{(\w+)\}/g, (m, k)=>k in vars ? String(vars[k]) : m);
const $0873d4f32691c14e$export$545c62727d3740ae = (s, digits)=>String(s).replace(/\d/g, (d)=>digits[d]);


'use client';
// Everything the picker SHOWS — calendar, digits, month and weekday names, its own
// labels and its error messages — follows the page language (`<html lang>`, or the
// `locale` prop), from the table in lib/datePickerLocale.js. Under `en` that means a
// Gregorian, left-to-right calendar; under `fa` and `ar`, the Jalali one. `value` is
// Gregorian 'YYYY-MM-DD' in every language, so no caller changes with the language.
const $d9dd19094c9f758e$var$FA_DIGITS = (0, $0873d4f32691c14e$export$4b8e9f545c94f612).fa.digits;
const $d9dd19094c9f758e$var$pad2 = (n)=>String(n).padStart(2, '0');
// ── Jalali math (works for years 1300–1500) ───────────────────────────────────
function $d9dd19094c9f758e$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $d9dd19094c9f758e$var$jMonthDays(y, m) {
    if (m <= 6) return 31;
    if (m <= 11) return 30;
    return $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29;
}
// Anchor: 1400/01/01 = 2021-03-21 UTC. Works backward too.
function $d9dd19094c9f758e$var$jalaliToMs(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21);
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(jy) ? 30 : 29
    ];
    let doy = jd - 1;
    for(let i = 0; i < jm - 1; i++)doy += md[i];
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    return anchor + (days + doy) * 86400000;
}
function $d9dd19094c9f758e$var$msToJalali(ms) {
    const anchor = Date.UTC(2021, 2, 21);
    let days = Math.floor((ms - anchor) / 86400000);
    let y = 1400;
    if (days >= 0) while(true){
        const diy = $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    else while(days < 0){
        y--;
        days += $d9dd19094c9f758e$var$jIsLeap(y) ? 366 : 365;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $d9dd19094c9f758e$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(m < 11 && days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
// ── The two calendars ─────────────────────────────────────────────────────────
// One shape, so the grids, the parser and the disableFuture rules below exist once
// and never ask which calendar they are drawing. Dates are `{ y, m, d }` with a
// 1-based month; `toMs`/`fromMs` read the day at UTC midnight.
const $d9dd19094c9f758e$var$JALALI = {
    id: 'jalali',
    firstYear: 1300,
    lastYear: 1500,
    weekStart: 6,
    monthDays: $d9dd19094c9f758e$var$jMonthDays,
    toMs: $d9dd19094c9f758e$var$jalaliToMs,
    fromMs: $d9dd19094c9f758e$var$msToJalali
};
const $d9dd19094c9f758e$var$GREGORIAN = {
    id: 'gregorian',
    firstYear: 1921,
    lastYear: 2121,
    weekStart: null,
    monthDays: (y, m)=>new Date(Date.UTC(y, m, 0)).getUTCDate(),
    toMs: (y, m, d)=>Date.UTC(y, m - 1, d),
    fromMs: (ms)=>{
        const t = new Date(ms);
        return {
            y: t.getUTCFullYear(),
            m: t.getUTCMonth() + 1,
            d: t.getUTCDate()
        };
    }
};
const $d9dd19094c9f758e$var$CALENDARS = {
    jalali: $d9dd19094c9f758e$var$JALALI,
    gregorian: $d9dd19094c9f758e$var$GREGORIAN
};
const $d9dd19094c9f758e$var$calendarOf = (id)=>$d9dd19094c9f758e$var$CALENDARS[id] || $d9dd19094c9f758e$var$JALALI;
const $d9dd19094c9f758e$var$todayIn = (cal)=>cal.fromMs(Date.now());
// 'YYYY-MM-DD' → the same day in `cal`.
function $d9dd19094c9f758e$var$valueToDate(cal, str) {
    if (!str || str.length < 10) return null;
    const [y, m, d] = str.split('-').map(Number);
    if (!y || !m || !d) return null;
    return cal.fromMs(Date.UTC(y, m - 1, d));
}
// A day in `cal` → 'YYYY-MM-DD'.
function $d9dd19094c9f758e$var$dateToValue(cal, y, m, d) {
    const dt = new Date(cal.toMs(y, m, d));
    return [
        dt.getUTCFullYear(),
        String(dt.getUTCMonth() + 1).padStart(2, '0'),
        String(dt.getUTCDate()).padStart(2, '0')
    ].join('-');
}
// The locale's data plus the calendar it resolves to — `calendar` pins one.
function $d9dd19094c9f758e$var$resolvePicker(locale, calendar) {
    const L = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale);
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar || L.calendar);
    return {
        L: L,
        cal: cal,
        months: L.months[cal.id],
        weekStart: cal.weekStart ?? L.weekStart,
        num: (n)=>(0, $0873d4f32691c14e$export$545c62727d3740ae)(n, L.digits)
    };
}
function $d9dd19094c9f758e$export$565a3e0423f3fda3(value) {
    const s = String(value || '').trim();
    if (!s) return {
        date: '',
        time: ''
    };
    const [date, rest = ''] = s.split(/[T\s]+/);
    const t = rest.match(/^(\d{1,2}):(\d{1,2})/);
    return {
        date: date,
        time: t ? `${$d9dd19094c9f758e$var$pad2(+t[1])}:${$d9dd19094c9f758e$var$pad2(+t[2])}` : ''
    };
}
function $d9dd19094c9f758e$export$26bc4d93216d514d(raw, { withTime: withTime = false, disableFuture: disableFuture = false, calendar: calendar = 'jalali' } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const s = (0, $42e05640dae453c1$export$e6aa7dbb1e28c5bd)(raw ?? '').replace(/[،,]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!s) return {
        empty: true
    };
    const m = s.match(/^(\d{4})\s*[/\-.]\s*(\d{1,2})\s*[/\-.]\s*(\d{1,2})(?:[ T]+(\d{1,2})\s*[:.]\s*(\d{1,2}))?$/);
    if (!m) return {
        error: 'format'
    };
    const y = +m[1], mo = +m[2], d = +m[3];
    if (y < cal.firstYear || y > cal.lastYear) return {
        error: 'range'
    };
    if (mo < 1 || mo > 12) return {
        error: 'range'
    };
    if (d < 1 || d > cal.monthDays(y, mo)) return {
        error: 'range'
    };
    const hasTime = m[4] !== undefined;
    let hh = 0, mi = 0;
    if (hasTime) {
        if (!withTime) return {
            error: 'noTime'
        };
        hh = +m[4];
        mi = +m[5];
        if (hh > 23 || mi > 59) return {
            error: 'time'
        };
    }
    if (disableFuture) {
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        if (cal.toMs(y, mo, d) > cal.toMs(t.y, t.m, t.d)) return {
            error: 'future'
        };
    }
    const date = $d9dd19094c9f758e$var$dateToValue(cal, y, mo, d);
    return {
        j: {
            y: y,
            m: mo,
            d: d
        },
        hh: hh,
        mi: mi,
        hasTime: hasTime,
        value: withTime ? `${date} ${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}` : date
    };
}
function $d9dd19094c9f758e$export$c715042cb80ca422(value, { withTime: withTime = false, calendar: calendar = 'jalali', digits: digits = $d9dd19094c9f758e$var$FA_DIGITS } = {}) {
    const cal = $d9dd19094c9f758e$var$calendarOf(calendar);
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const c = $d9dd19094c9f758e$var$valueToDate(cal, date);
    if (!c) return '';
    const base = `${c.y}/${$d9dd19094c9f758e$var$pad2(c.m)}/${$d9dd19094c9f758e$var$pad2(c.d)}`;
    return (0, $0873d4f32691c14e$export$545c62727d3740ae)(withTime ? `${base} ${time || '00:00'}` : base, digits);
}
const $d9dd19094c9f758e$export$5a5aa410a9e7d978 = (raw, opts = {})=>$d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
        ...opts,
        calendar: 'jalali'
    });
const $d9dd19094c9f758e$export$544b31198dd3053c = (value, { withTime: withTime = false } = {})=>$d9dd19094c9f758e$export$c715042cb80ca422(value, {
        withTime: withTime,
        calendar: 'jalali',
        digits: $d9dd19094c9f758e$var$FA_DIGITS
    });
function $d9dd19094c9f758e$var$buildGrid(cal, y, m, weekStart) {
    const days = cal.monthDays(y, m);
    const offset = (new Date(cal.toMs(y, m, 1)).getUTCDay() - weekStart + 7) % 7;
    const cells = [
        ...Array(offset).fill(null),
        ...Array.from({
            length: days
        }, (_, i)=>i + 1)
    ];
    while(cells.length % 7)cells.push(null);
    const grid = [];
    for(let i = 0; i < cells.length; i += 7)grid.push(cells.slice(i, i + 7));
    return grid;
}
// ── Sub-components ────────────────────────────────────────────────────────────
const $d9dd19094c9f758e$var$NavBtn = ({ onClick: onClick, children: children, disabled: disabled })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov && !disabled ? '#e2e8f0' : '#f0f4f8',
            border: 'none',
            borderRadius: 6,
            width: 28,
            height: 28,
            cursor: disabled ? 'default' : 'pointer',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: disabled ? '#c8c8c8' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            flexShrink: 0,
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevR = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }));
const $d9dd19094c9f758e$var$ChevL = ({ size: size = 14 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: size,
        height: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }));
const $d9dd19094c9f758e$var$GridCell = ({ label: label, selected: selected, current: current, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    let bg = hov && !disabled ? '#e2e8f0' : '#f8fafc';
    let color = disabled ? '#c8c8c8' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    let fw = 400;
    if (selected && !disabled) {
        bg = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        color = 'white';
        fw = 700;
    } else if (current && !disabled) {
        bg = '#EAF4FC';
        color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        fw = 600;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 36,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            fontWeight: fw,
            background: bg,
            color: color,
            transition: 'background 0.12s'
        }
    }, label);
};
const $d9dd19094c9f758e$var$DayCell = ({ day: day, label: label, isToday: isToday, isSel: isSel, disabled: disabled, onClick: onClick })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    if (!day) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null);
    let bg = hov && !disabled ? '#f0f4f8' : 'transparent';
    let color = disabled ? '#d0d0d0' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    let fw = 400;
    if (isSel && !disabled) {
        bg = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        color = 'white';
        fw = 700;
    } else if (isToday) {
        bg = '#EAF4FC';
        color = (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy;
        fw = 700;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: disabled ? undefined : onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            height: 34,
            borderRadius: 8,
            border: 'none',
            cursor: disabled ? 'default' : 'pointer',
            background: bg,
            color: color,
            fontWeight: fw,
            fontSize: 12,
            fontFamily: 'Meshkat, sans-serif',
            transition: 'background 0.12s'
        }
    }, label);
};
// ‹ label › — earlier on the LEFT and later on the RIGHT in every language. That is
// the reading order under `ltr`, and it is what the RTL picker has always drawn, so
// the row pins its own direction instead of mirroring with the card.
const $d9dd19094c9f758e$var$NavRow = ({ onPrev: onPrev, onNext: onNext, nextDisabled: nextDisabled, marginBottom: marginBottom, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: marginBottom,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevL, null)), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavBtn, {
        onClick: onNext,
        disabled: nextDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevR, null)));
const $d9dd19094c9f758e$export$9c97d98ce20c6c7a = ({ locale: locale, calendar: calendar, ...rest })=>{
    const picker = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    // Keyed on the calendar: the view state is a year and month IN that calendar, so a
    // language switch that changes calendars starts over rather than reading 1405 as a
    // Gregorian year.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$CalendarBody, {
        key: picker.cal.id,
        picker: picker,
        ...rest
    });
};
const $d9dd19094c9f758e$var$CalendarBody = ({ value: value, onChange: onChange, disableFuture: disableFuture = false, picker: picker })=>{
    const { L: L, cal: cal, months: months, weekStart: weekStart, num: num } = picker;
    const today = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$d9dd19094c9f758e$var$todayIn(cal), [
        cal
    ]);
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('day'); // 'day' | 'month' | 'year'
    const [viewY, setViewY] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.y);
    const [viewM, setViewM] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(today.m);
    const [sel, setSel] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const yrRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // scrollable year container
    const yrSelRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // selected/current year cell
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (value) {
            const c = $d9dd19094c9f758e$var$valueToDate(cal, value);
            if (c) {
                setSel(c);
                setViewY(c.y);
                setViewM(c.m);
                return;
            }
        }
        setSel(null);
    }, [
        value,
        cal
    ]);
    const changeMonth = (delta)=>{
        let m = viewM + delta, y = viewY;
        if (m > 12) {
            m = 1;
            y++;
        }
        if (m < 1) {
            m = 12;
            y--;
        }
        setViewM(m);
        setViewY(y);
    };
    const enterYearMode = ()=>setMode('year');
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (mode !== 'year') return;
        const t = setTimeout(()=>{
            if (yrSelRef.current && yrRef.current) {
                const el = yrSelRef.current;
                const container = yrRef.current;
                container.scrollTop = el.offsetTop - container.clientHeight / 2 + el.clientHeight / 2;
            }
        }, 30);
        return ()=>clearTimeout(t);
    }, [
        mode
    ]);
    const selectDay = (d)=>{
        if (!d) return;
        setSel({
            y: viewY,
            m: viewM,
            d: d
        });
        onChange($d9dd19094c9f758e$var$dateToValue(cal, viewY, viewM, d));
        setMode('day');
    };
    // disableFuture checks
    const yearDisabled = (y)=>disableFuture && y > today.y;
    const monthDisabled = (y, m)=>disableFuture && (y > today.y || y === today.y && m > today.m);
    const dayDisabled = (d)=>{
        if (!disableFuture || !d) return false;
        if (viewY > today.y) return true;
        if (viewY === today.y && viewM > today.m) return true;
        if (viewY === today.y && viewM === today.m && d > today.d) return true;
        return false;
    };
    const grid = $d9dd19094c9f758e$var$buildGrid(cal, viewY, viewM, weekStart);
    const weekdays = Array.from({
        length: 7
    }, (_, i)=>L.weekdays[(weekStart + i) % 7]);
    // Shared header label button style
    const labelBtn = (extra)=>({
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif',
            borderRadius: 6,
            padding: '4px 10px',
            ...extra
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, mode === 'year' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: 10,
            letterSpacing: 1
        }
    }, L.strings.selectYear), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: yrRef,
        style: {
            maxHeight: 240,
            overflowY: 'auto',
            paddingLeft: 2,
            paddingRight: 2
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 4
        }
    }, Array.from({
        length: today.y - cal.firstYear + 1 + (disableFuture ? 0 : 6)
    }, (_, i)=>cal.firstYear + i).map((yr)=>{
        const isFocused = yr === (sel?.y ?? today.y);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: yr,
            ref: isFocused ? yrSelRef : null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            label: num(yr),
            selected: sel ? yr === sel.y : false,
            current: yr === today.y,
            disabled: yearDisabled(yr),
            onClick: ()=>{
                setViewY(yr);
                setMode('month');
            }
        }));
    })))), mode === 'month' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 6
        }
    }, months.map((name, idx)=>{
        const mn = idx + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$GridCell, {
            key: idx,
            label: name,
            selected: !!(sel && sel.y === viewY && sel.m === mn),
            current: viewY === today.y && mn === today.m,
            disabled: monthDisabled(viewY, mn),
            onClick: ()=>{
                setViewM(mn);
                setMode('day');
            }
        });
    }))), mode === 'day' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 4,
        onPrev: ()=>setViewY((y)=>y - 1),
        onNext: ()=>setViewY((y)=>y + 1),
        nextDisabled: yearDisabled(viewY + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: enterYearMode,
        style: labelBtn({
            fontSize: 13,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        })
    }, num(viewY))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$NavRow, {
        marginBottom: 12,
        onPrev: ()=>changeMonth(-1),
        onNext: ()=>changeMonth(1),
        nextDisabled: monthDisabled(viewM === 12 ? viewY + 1 : viewY, viewM === 12 ? 1 : viewM + 1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setMode('month'),
        style: labelBtn({
            fontSize: 15,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        })
    }, months[viewM - 1])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            marginBottom: 10
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            marginBottom: 4
        }
    }, weekdays.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            style: {
                textAlign: 'center',
                fontSize: 11,
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                padding: '2px 0'
            }
        }, d))), grid.map((week, wi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: wi,
            style: {
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                gap: 2
            }
        }, week.map((day, di)=>{
            const isToday = day && viewY === today.y && viewM === today.m && day === today.d;
            const isSel = day && sel && viewY === sel.y && viewM === sel.m && day === sel.d;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$DayCell, {
                key: di,
                day: day,
                label: day ? num(day) : '',
                isToday: isToday,
                isSel: isSel,
                disabled: dayDisabled(day),
                onClick: ()=>selectDay(day)
            });
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>{
            setViewY(today.y);
            setViewM(today.m);
        },
        style: {
            marginTop: 12,
            width: '100%',
            height: 32,
            background: '#f8fafc',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.goToToday)));
};
// ── Popup shell ───────────────────────────────────────────────────────────────
// The floating card the calendar sits in, positioned under `anchorRef` (flipping above
// it when the viewport has no room below) and closed by a click anywhere outside both.
// Portaled to <body>: an ancestor with a CSS transform (e.g. a centered DialogContent)
// would otherwise become the containing block of this fixed card and misplace it, and
// an ancestor overflow would clip it. Dialog.jsx whitelists [data-jalali-popup] so the
// portaled card doesn't count as an outside click that dismisses the dialog.
//
// Placement is measured from the card's REAL height, never a guessed constant: the
// calendar is ~380px tall in day mode, so the old `spaceBelow > 320` test opened it
// downward with 60px too little room and the last week of the month fell off the
// bottom of the screen — the exact failure seen with the field low in a tall modal.
// The measured box is then clamped into the viewport on both axes, and re-placed on
// scroll/resize because a field inside a scrollable DialogContent moves under it.
const $d9dd19094c9f758e$var$POPUP_WIDTH = 300;
const $d9dd19094c9f758e$var$POPUP_GAP = 6; // breathing room between the trigger and the card
const $d9dd19094c9f758e$var$POPUP_MARGIN = 8; // never touch the viewport edge
const $d9dd19094c9f758e$export$bb703e6cd16789d6 = ({ anchorRef: anchorRef, onClose: onClose, children: children, width: width = $d9dd19094c9f758e$var$POPUP_WIDTH, locale: locale })=>{
    const cardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The card reads in the language its calendar is drawn in — pass the same `locale`
    // to both, or neither and let both read `<html lang>`.
    const rtl = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale).dir === 'rtl';
    // Positions the card by writing to the DOM node rather than through state: this runs
    // from a ResizeObserver (mode switches change the card's height) and from scroll, and
    // a setState there would re-render → re-measure → re-render without ever settling.
    const place = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const card = cardRef.current;
        const anchor = anchorRef.current;
        if (!card || !anchor) return;
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        const maxH = vh - $d9dd19094c9f758e$var$POPUP_MARGIN * 2;
        // Cap first, measure second — otherwise a card taller than the viewport reports a
        // height no placement can satisfy.
        card.style.maxHeight = `${maxH}px`;
        const h = Math.min(card.offsetHeight || 0, maxH);
        const rect = anchor.getBoundingClientRect();
        const roomBelow = vh - rect.bottom - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        const roomAbove = rect.top - $d9dd19094c9f758e$var$POPUP_GAP - $d9dd19094c9f758e$var$POPUP_MARGIN;
        // Below by default; flip above only when that side genuinely has more room.
        let top = h <= roomBelow || roomBelow >= roomAbove ? rect.bottom + $d9dd19094c9f758e$var$POPUP_GAP : rect.top - $d9dd19094c9f758e$var$POPUP_GAP - h;
        top = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(top, vh - $d9dd19094c9f758e$var$POPUP_MARGIN - h));
        // The trigger's START edge: right edges align under RTL, left edges under LTR. Then
        // clamp so a trigger near either viewport edge can't push the card off-screen.
        let left = rtl ? rect.right - width : rect.left;
        left = Math.max($d9dd19094c9f758e$var$POPUP_MARGIN, Math.min(left, vw - $d9dd19094c9f758e$var$POPUP_MARGIN - width));
        card.style.top = `${top}px`;
        card.style.left = `${left}px`;
        card.style.visibility = 'visible';
    }, [
        anchorRef,
        width,
        rtl
    ]);
    // Layout effect, before paint: a card positioned after the fact is a card the user
    // sees jump from the corner of the screen to where it belongs.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        place();
        const onScroll = ()=>place();
        // capture:true — the scroll that matters is usually an ancestor's (the modal body),
        // and scroll events from those don't bubble to window.
        window.addEventListener('scroll', onScroll, true);
        window.addEventListener('resize', place);
        let ro;
        if (typeof ResizeObserver !== 'undefined' && cardRef.current) {
            ro = new ResizeObserver(()=>place());
            ro.observe(cardRef.current);
        }
        return ()=>{
            window.removeEventListener('scroll', onScroll, true);
            window.removeEventListener('resize', place);
            ro?.disconnect();
        };
    }, [
        place
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const h = (e)=>{
            if (cardRef.current?.contains(e.target)) return;
            if (anchorRef.current?.contains(e.target)) return; // the trigger toggles itself
            onClose();
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        anchorRef,
        onClose
    ]);
    // A modal Radix dialog locks scrolling with react-remove-scroll, which cancels every
    // `wheel` and `touchmove` that reaches `document` from OUTSIDE the dialog — and this
    // card is portaled out of it. So in «ویرایش بیمار» and every other dialog with a date
    // field the year list (and a card taller than the screen) could not be scrolled by
    // wheel, trackpad or finger, only by dragging a scrollbar (PM-0121). Stopped here they
    // never reach that listener; the card's own scrolling is the browser's and needs
    // nothing more. Passive: nothing here cancels a scroll. The page behind stays locked.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const card = cardRef.current;
        if (!card) return undefined;
        const keep = (e)=>e.stopPropagation();
        card.addEventListener('wheel', keep, {
            passive: true
        });
        card.addEventListener('touchmove', keep, {
            passive: true
        });
        return ()=>{
            card.removeEventListener('wheel', keep);
            card.removeEventListener('touchmove', keep);
        };
    }, []);
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: cardRef,
        "data-jalali-popup": "",
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            visibility: 'hidden',
            overflowY: 'auto',
            overscrollBehavior: 'contain',
            zIndex: 9999,
            width: width,
            background: 'white',
            borderRadius: 16,
            padding: '16px 14px',
            boxShadow: '0 16px 48px rgba(0,0,0,0.18)',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            direction: rtl ? 'rtl' : 'ltr',
            boxSizing: 'border-box',
            pointerEvents: 'auto'
        }
    }, children), document.body);
};
// ── Time row ──────────────────────────────────────────────────────────────────
// Two spinnable segments under the calendar, shown only when `withTime`. Rendered LTR:
// an "HH:MM" pair inside an RTL paragraph gets its two numeric runs reordered by the
// bidi algorithm, so the minutes would appear where the hours belong.
//
// Steppers, not text boxes, on purpose. The popup is portaled to <body>, so inside a
// modal Radix dialog it sits outside the focus scope and anything focusable in it gets
// focus yanked straight back into the dialog — a text field there could never be typed
// into. Buttons don't need focus to be clicked, and an exact time can always be typed
// into the field itself, which does live inside the dialog.
const $d9dd19094c9f758e$var$StepBtn = ({ onClick: onClick, label: label, children: children })=>{
    const [hov, setHov] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": label,
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            background: hov ? '#e2e8f0' : 'transparent',
            border: 'none',
            borderRadius: 4,
            width: 26,
            height: 18,
            padding: 0,
            cursor: 'pointer',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.12s'
        }
    }, children);
};
const $d9dd19094c9f758e$var$ChevUp = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }));
const $d9dd19094c9f758e$var$ChevDn = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "12",
        height: "12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 16l6-6-1.41-1.41L12 13.17 7.41 8.59 6 10z"
    }));
const $d9dd19094c9f758e$var$TimeSegment = ({ value: value, onChange: onChange, max: max, step: step, label: label, L: L })=>{
    const wrap = (n)=>(n % (max + 1) + max + 1) % (max + 1);
    const shown = (0, $0873d4f32691c14e$export$545c62727d3740ae)($d9dd19094c9f758e$var$pad2(value), L.digits);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "spinbutton",
        "aria-label": label,
        "aria-valuenow": value,
        "aria-valuemin": 0,
        "aria-valuemax": max,
        "aria-valuetext": shown,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.strings.stepUp, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value + step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevUp, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: 42,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            background: '#f8fafc',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 14,
            fontWeight: 700,
            fontFamily: 'Meshkat, sans-serif',
            boxSizing: 'border-box',
            userSelect: 'none'
        }
    }, shown), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$StepBtn, {
        label: (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.strings.stepDown, {
            label: label
        }),
        onClick: ()=>onChange(wrap(value - step))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$ChevDn, null)));
};
const $d9dd19094c9f758e$var$TimeRow = ({ hh: hh, mi: mi, onChange: onChange, minuteStep: minuteStep = 5, L: L })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 12,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.time), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            direction: 'ltr'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.hour,
        value: hh,
        max: 23,
        step: 1,
        onChange: (h)=>onChange(h, mi)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 14,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeSegment, {
        L: L,
        label: L.strings.minute,
        value: mi,
        max: 59,
        step: minuteStep,
        onChange: (m)=>onChange(hh, m)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>{
            const n = new Date();
            onChange(n.getHours(), Math.floor(n.getMinutes() / minuteStep) * minuteStep);
        },
        style: {
            background: '#f8fafc',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 8,
            height: 28,
            padding: '0 10px',
            fontSize: 12,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.now));
// ── Main Component ────────────────────────────────────────────────────────────
// Editable input + the shared calendar. The selected moment lives entirely in `value` —
// the only local copy is `draft`, the half-typed text, which exists exactly while the
// field has focus and is discarded (never committed) if it never parses.
//
// Idle, the field reads «۱۲ مرداد ۱۴۰۴» (English: «August 3, 2025»); focused, it
// becomes the numeric «۱۴۰۴/۰۵/۱۲» («2025/08/03») the parser round-trips. The input is
// dir="ltr" while typed so date and time segments keep their order — bidi reorders two
// numeric runs inside an RTL field.
//
// `locale` (default `<html lang>`) and `calendar` behave as on `JalaliCalendar`.
const $d9dd19094c9f758e$var$JalaliDatePicker = ({ value: value, onChange: onChange, placeholder: placeholder, locale: locale, calendar: calendar, height: height = 44, fontSize: fontSize = 14, disabled: disabled = false, disableFuture: disableFuture = false, withTime: withTime = false, minuteStep: minuteStep = 5, readOnlyInput: readOnlyInput = false, id: // Forwarded to the typeable <input> (v0.16.1), so a FormField label can name it
// (DESIGN_CONCEPT §12.3) and a caller can validate on blur.
id, name: name, onBlur: onBlur, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-describedby': ariaDescribedBy, 'aria-invalid': ariaInvalid, 'data-testid': testId })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // null ⇒ not typing
    // The error CODE, not its wording — so a language switch re-words a standing error.
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const { L: L, cal: cal, months: months, num: num } = $d9dd19094c9f758e$var$resolvePicker(locale, calendar);
    const rtl = L.dir === 'rtl';
    const { date: date, time: time } = $d9dd19094c9f758e$export$565a3e0423f3fda3(value);
    const sel = date ? $d9dd19094c9f758e$var$valueToDate(cal, date) : null;
    const [hh, mi] = time ? time.split(':').map(Number) : [
        0,
        0
    ];
    const prettyDate = sel ? (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.date, {
        d: num(sel.d),
        month: months[sel.m - 1],
        y: num(sel.y)
    }) : '';
    const prettyVal = sel && withTime && time ? (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.dateTime, {
        date: prettyDate,
        time: num(`${$d9dd19094c9f758e$var$pad2(hh)}:${$d9dd19094c9f758e$var$pad2(mi)}`)
    }) : prettyDate;
    // «Date format: 2026/09/26» — the example is today, in the calendar and digits shown.
    const errorText = (()=>{
        if (!error) return '';
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        return (0, $0873d4f32691c14e$export$9a328bbde6508c84)(L.errors[error] || L.errors.format, {
            example: num(`${t.y}/${$d9dd19094c9f758e$var$pad2(t.m)}/${$d9dd19094c9f758e$var$pad2(t.d)}`)
        });
    })();
    const editable = !disabled && !readOnlyInput;
    const shownText = draft !== null ? draft : prettyVal;
    // The time a with-time field falls back to when a date arrives without one — by
    // picking or by typing, the same either way. Now, rounded down to the step: 00:00 is
    // almost never the moment someone meant, and the result is visible in the field.
    const fallbackTime = ()=>{
        const now = new Date();
        return `${$d9dd19094c9f758e$var$pad2(now.getHours())}:${$d9dd19094c9f758e$var$pad2(Math.floor(now.getMinutes() / minuteStep) * minuteStep)}`;
    };
    const emitDate = (gregorian)=>{
        if (!gregorian) {
            onChange('');
            return;
        }
        if (!withTime) {
            onChange(gregorian);
            setOpen(false);
            return;
        }
        onChange(`${gregorian} ${time || fallbackTime()}`); // popup stays open for the time
    };
    // Setting a time before a day picks today, so the field can never hold a bare time.
    // The draft is dropped: a modal's focus trap can bounce focus back into the field
    // while the popup is used, and a stale half-typed draft would then hide the new time.
    const emitTime = (h, m)=>{
        const t = $d9dd19094c9f758e$var$todayIn(cal);
        const d = date || $d9dd19094c9f758e$var$dateToValue(cal, t.y, t.m, t.d);
        setDraft(null);
        setError('');
        onChange(`${d} ${$d9dd19094c9f758e$var$pad2(h)}:${$d9dd19094c9f758e$var$pad2(m)}`);
    };
    const handleType = (raw)=>{
        setDraft(raw);
        if (!raw.trim()) {
            setError('');
            if (value) onChange('');
            return;
        }
        const r = $d9dd19094c9f758e$export$26bc4d93216d514d(raw, {
            withTime: withTime,
            disableFuture: disableFuture,
            calendar: cal.id
        });
        if (r.error) {
            setError(r.error);
            return;
        }
        setError('');
        // A date typed with no time keeps the time the field already holds.
        if (withTime && !r.hasTime) onChange(`${r.value.slice(0, 10)} ${time || fallbackTime()}`);
        else onChange(r.value);
    };
    const startEditing = ()=>{
        if (!editable || draft !== null) return;
        setDraft($d9dd19094c9f758e$export$c715042cb80ca422(value, {
            withTime: withTime,
            calendar: cal.id,
            digits: L.digits
        }));
    };
    const commit = ()=>{
        if (draft === null) return;
        setDraft(null); // whatever survived is already in `value`; anything else reverts
        setError('');
    };
    const clearDate = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setDraft(null);
        setError('');
        onChange('');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'relative',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: triggerRef,
        onMouseDown: (e)=>{
            // Only the box's own padding — the input and the icons handle their own clicks.
            if (disabled || e.target !== e.currentTarget) return;
            if (editable) {
                e.preventDefault();
                inputRef.current?.focus();
                setOpen(true);
            } else setOpen((o)=>!o);
        },
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 12px',
            gap: 6,
            border: `1.5px solid ${error ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : open || draft !== null ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            cursor: disabled ? 'default' : editable ? 'text' : 'pointer',
            background: disabled ? '#f8fafc' : 'white',
            transition: 'border-color 0.18s',
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: inputRef,
        type: "text",
        id: id,
        name: name,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": ariaInvalid ?? (error ? true : undefined),
        "data-testid": testId,
        // Displayed in the reader's direction, edited LTR. «۱۷ مهر ۱۳۶۹» is
        // number/word/number: under an LTR base the day lands on the far left and the
        // whole thing reads backwards. The typed «۱۳۶۹/۰۷/۱۷ ۱۴:۳۰» is the opposite
        // case — two numeric runs that bidi would swap in an RTL field, putting the
        // minutes where the year belongs.
        dir: draft !== null ? 'ltr' : L.dir,
        value: shownText,
        placeholder: placeholder ?? L.strings.placeholder,
        disabled: disabled,
        readOnly: !editable,
        onFocus: startEditing,
        onClick: ()=>{
            if (disabled) return;
            if (editable) setOpen(true);
            else setOpen((o)=>!o);
        },
        onChange: (e)=>handleType(e.target.value),
        onBlur: (e)=>{
            commit();
            onBlur?.(e);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                e.preventDefault();
                commit();
                setOpen(false);
                inputRef.current?.blur();
            } else if (e.key === 'Escape') {
                setDraft(null);
                setError('');
                setOpen(false);
            } else if (e.key === 'ArrowDown' && !open) setOpen(true);
        },
        style: {
            flex: 1,
            minWidth: 0,
            height: '100%',
            border: 'none',
            outline: 'none',
            // Pinned to the reader's side, so starting to type does not jump the text.
            background: 'transparent',
            padding: 0,
            textAlign: rtl ? 'right' : 'left',
            fontSize: fontSize,
            fontFamily: 'Meshkat, sans-serif',
            color: shownText ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            cursor: editable ? 'text' : disabled ? 'default' : 'pointer'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            flexShrink: 0
        }
    }, (sel || draft) && !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.clear,
        onMouseDown: clearDate,
        style: {
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 2,
            borderRadius: 4,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "14",
        height: "14"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "aria-label": L.strings.openCalendar,
        onMouseDown: (e)=>{
            e.preventDefault();
            if (!disabled) setOpen((o)=>!o);
        },
        style: {
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: disabled ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: open ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        width: "18",
        height: "18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 5 2 5.9 2 7v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }))))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            marginTop: 4,
            fontSize: 11,
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            fontFamily: 'Meshkat, sans-serif'
        }
    }, errorText), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$bb703e6cd16789d6, {
        anchorRef: triggerRef,
        onClose: ()=>setOpen(false),
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$export$9c97d98ce20c6c7a, {
        locale: locale,
        calendar: calendar,
        value: date,
        onChange: (v)=>{
            setDraft(null);
            setError('');
            emitDate(v);
        },
        disableFuture: disableFuture
    }), withTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9dd19094c9f758e$var$TimeRow, {
        L: L,
        hh: hh,
        mi: mi,
        minuteStep: minuteStep,
        onChange: emitTime
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: ()=>setOpen(false),
        style: {
            marginTop: 10,
            width: '100%',
            height: 34,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            border: 'none',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 700,
            color: 'white',
            cursor: 'pointer',
            fontFamily: 'Meshkat, sans-serif'
        }
    }, L.strings.confirm))));
};
var $d9dd19094c9f758e$export$2e2bcd8739ae039 = $d9dd19094c9f758e$var$JalaliDatePicker;




// ─────────────────────────────────────────────────────────────────────────────
// Jalali weeks over Iran-local ISO dates ('YYYY-MM-DD').
//
// The reception surfaces of the doctor and clinic panels both browse a day at
// a time and a week at a time (`WeekPickerSheet`), and both speak an absolute
// ISO date in the URL or state. The arithmetic is done at UTC noon so neither
// DST nor the browser's own zone can move a day across midnight.
//
// A Jalali week opens on Saturday: شنبه = 0 … جمعه = 6.
// ─────────────────────────────────────────────────────────────────────────────
const $1d28c7ea24194f0d$var$DAY_MS = 86400000;
const $1d28c7ea24194f0d$var$noonMs = (iso)=>Date.parse(`${iso}T12:00:00Z`);
const $1d28c7ea24194f0d$export$c13cab26eb520a22 = (iso, days)=>new Date($1d28c7ea24194f0d$var$noonMs(iso) + days * $1d28c7ea24194f0d$var$DAY_MS).toISOString().split('T')[0];
const $1d28c7ea24194f0d$export$f9f83315c2979a2f = (iso)=>(new Date($1d28c7ea24194f0d$var$noonMs(iso)).getUTCDay() + 1) % 7;
const $1d28c7ea24194f0d$export$4905be222d58a860 = (iso)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(iso, -$1d28c7ea24194f0d$export$f9f83315c2979a2f(iso));
const $1d28c7ea24194f0d$export$6b21eb5279a580dd = (startISO)=>Array.from({
        length: 7
    }, (_, i)=>$1d28c7ea24194f0d$export$c13cab26eb520a22(startISO, i));
const $1d28c7ea24194f0d$export$fa5589c3fde4793c = $1d28c7ea24194f0d$var$noonMs;


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// WeekPickerSheet — week browsing in a bottom sheet, opened from a day bar's
// label (`DayContextCard`). A seven-chip week strip answers a question asked a
// few times a day and costs ~64px on every screen load; the sheet costs none.
//
// Weeks are Jalali, Saturday → Friday, over Iran-local ISO dates, and the sheet
// opens on the week holding the selected day. Each row says what the day holds:
// the caller's `describeDay` line (the doctor: where the schedule puts them)
// and the count of appointments — `·` not counted yet, `—` counted and empty.
// A row described as `off` is muted but still tappable. Picking a day only
// calls `onPick(iso)` — the sheet never navigates.
//
// «تقویم کامل» swaps the body for the month grid (one sheet, two views — no
// stacked sheets) for far jumps.
//
// Promoted from the doctor app (DOCTOR_MOBILE_RECEPTION_REDESIGN §4.4), PM-0052.
//
// Props:
//   open / onClose / selISO / todayISO / onPick(iso)
//   useWeekCounts — a HOOK `(weekStartISO, { enabled }) => [{ iso, count|null }]`
//                   called on every render (pass a stable function); omit it
//                   and the count column stays blank
//   describeDay   — optional `(iso) => null | { text, aria?, off? }`
//   fmt           — { weekday(ms), dayMonth(ms), weekdayDayMonth(ms), number(n) };
//                   defaults use Intl with the Persian calendar
//   labels        — overrides for kitCopy().weekPicker
//   testIdPrefix  — default 'reception' → `reception-week-sheet`, `-week-<iso>`, …
// ─────────────────────────────────────────────────────────────────────────────
const $b3d011a6fde34c03$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $b3d011a6fde34c03$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $b3d011a6fde34c03$var$noCounts = ()=>null;
function $b3d011a6fde34c03$var$defaultFmt(locale) {
    const tag = `${locale || 'fa'}-IR-u-ca-persian`;
    const make = (opts)=>{
        try {
            const f = new Intl.DateTimeFormat(tag, {
                timeZone: 'UTC',
                ...opts
            });
            return (ms)=>f.format(ms);
        } catch  {
            return (ms)=>new Date(ms).toISOString().split('T')[0];
        }
    };
    const nf = (()=>{
        try {
            return new Intl.NumberFormat(tag);
        } catch  {
            return null;
        }
    })();
    return {
        weekday: make({
            weekday: 'long'
        }),
        dayMonth: make({
            day: 'numeric',
            month: 'long'
        }),
        weekdayDayMonth: make({
            weekday: 'long',
            day: 'numeric',
            month: 'long'
        }),
        number: (n)=>nf ? nf.format(n) : String(n)
    };
}
function $b3d011a6fde34c03$export$2e2bcd8739ae039({ open: open, onClose: onClose, selISO: selISO, todayISO: todayISO, onPick: onPick, useWeekCounts: useWeekCounts = $b3d011a6fde34c03$var$noCounts, describeDay: describeDay, fmt: fmtProp, labels: labels, locale: locale, testIdPrefix: testIdPrefix = 'reception' }) {
    const loc = locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)();
    const copy = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)(loc).weekPicker,
        ...labels
    };
    const fmt = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            ...$b3d011a6fde34c03$var$defaultFmt(loc),
            ...fmtProp
        }), [
        loc,
        fmtProp
    ]);
    const p = testIdPrefix;
    const [weekStart, setWeekStart] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $1d28c7ea24194f0d$export$4905be222d58a860)(selISO));
    const [view, setView] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('week');
    // Every opening starts on the selected day's week, in the week view.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setWeekStart((0, $1d28c7ea24194f0d$export$4905be222d58a860)(selISO));
            setView('week');
        }
    }, [
        open,
        selISO
    ]);
    const days = useWeekCounts(weekStart, {
        enabled: open
    }) || [];
    const countOf = new Map(days.map((d)=>[
            d.iso,
            d.count
        ]));
    const thisWeek = (0, $1d28c7ea24194f0d$export$4905be222d58a860)(todayISO);
    const isoDays = (0, $1d28c7ea24194f0d$export$6b21eb5279a580dd)(weekStart);
    const range = copy.range(fmt.dayMonth((0, $1d28c7ea24194f0d$export$fa5589c3fde4793c)(isoDays[0])), fmt.dayMonth((0, $1d28c7ea24194f0d$export$fa5589c3fde4793c)(isoDays[6])));
    const pick = (iso)=>{
        onClose();
        if (iso) onPick(iso);
    };
    const quick = [
        {
            key: 'this',
            label: copy.thisWeek,
            start: thisWeek
        },
        {
            key: 'next',
            label: copy.nextWeek,
            start: (0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(thisWeek, 7)
        },
        {
            key: 'prev',
            label: copy.prevWeek,
            start: (0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(thisWeek, -7)
        }
    ];
    const footer = view === 'week' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        "data-testid": `${p}-week-calendar`,
        className: "w-full min-h-11 gap-2",
        onClick: ()=>setView('month')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5b56343e65588121$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), copy.fullCalendar) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        "data-testid": `${p}-week-back`,
        className: "w-full min-h-11",
        onClick: ()=>setView('week')
    }, copy.backToWeek);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: copy.title,
        closeLabel: copy.close,
        footer: footer,
        "data-testid": `${p}-week-sheet`
    }, view === 'month' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$9c97d98ce20c6c7a), {
        value: selISO,
        onChange: (v)=>pick(v)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.625rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        style: {
            display: 'flex',
            gap: '0.375rem',
            flexWrap: 'wrap'
        }
    }, quick.map((q)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: q.key,
            variant: weekStart === q.start ? 'default' : 'outline',
            size: "sm",
            "aria-pressed": weekStart === q.start,
            "data-testid": `${p}-week-quick-${q.key}`,
            className: "min-h-9 rounded-full",
            onClick: ()=>setWeekStart(q.start)
        }, q.label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-prev`,
        "aria-label": copy.prevWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(s, -7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${p}-week-range`,
        style: {
            flex: 1,
            textAlign: 'center',
            fontSize: '0.875rem',
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, range), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${p}-week-next`,
        "aria-label": copy.nextWeek,
        className: "min-w-11 min-h-11",
        onClick: ()=>setWeekStart((s)=>(0, $1d28c7ea24194f0d$export$c13cab26eb520a22)(s, 7))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $b3d011a6fde34c03$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, isoDays.map((iso)=>{
        const ms = (0, $1d28c7ea24194f0d$export$fa5589c3fde4793c)(iso);
        const desc = describeDay ? describeDay(iso) : null;
        const count = countOf.get(iso);
        const selected = iso === selISO;
        const today = iso === todayISO;
        const off = Boolean(desc?.off);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: iso,
            variant: "ghost",
            "data-testid": `${p}-week-${iso}`,
            "aria-current": selected ? 'date' : undefined,
            "aria-label": [
                fmt.weekdayDayMonth(ms),
                desc?.aria || (desc?.text && desc.text !== "\u2014" ? desc.text : null),
                count != null ? copy.countAria(fmt.number(count)) : null
            ].filter(Boolean).join(" \xb7 "),
            className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-none px-2 py-1.5 font-normal",
            style: {
                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: selected ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08) : 'transparent',
                textAlign: 'start'
            },
            onClick: ()=>pick(iso)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                width: '4.5rem',
                flexShrink: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.8125rem',
                fontWeight: selected ? 800 : 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
            }
        }, fmt.weekday(ms)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                display: 'block',
                fontSize: '0.6875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
            }
        }, fmt.dayMonth(ms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flex: 1,
                minWidth: 0,
                fontSize: '0.75rem',
                color: off ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, desc?.text || ''), today && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                flexShrink: 0,
                fontSize: '0.625rem',
                fontWeight: 700,
                borderRadius: '1rem',
                padding: '0.0625rem 0.4375rem',
                background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.12),
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
            }
        }, copy.today), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                width: '1.75rem',
                flexShrink: 0,
                textAlign: 'center',
                fontSize: '0.875rem',
                fontWeight: 800,
                color: count ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, count == null ? useWeekCounts === $b3d011a6fde34c03$var$noCounts ? '' : "\xb7" : count === 0 ? "\u2014" : fmt.number(count)));
    }))));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3fbaf9031554177f$export$a2387ed3b5d536eb = {
    name: "check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 6 9 17l-5-5",
                key: "1gmf2c"
            }
        ]
    ]
};
$3fbaf9031554177f$export$a2387ed3b5d536eb.node;
const $3fbaf9031554177f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3fbaf9031554177f$export$a2387ed3b5d536eb);






'use client';
function $336d0c00b1b6b543$export$2e2bcd8739ae039({ open: open, onClose: onClose, title: title, closeLabel: closeLabel, groups: groups = [], locale: locale, testIdPrefix: testIdPrefix = 'choice' }) {
    const close = closeLabel || (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).close;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: title,
        closeLabel: close,
        "data-testid": `${testIdPrefix}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem'
        }
    }, groups.filter((g)=>g.options?.length).map((g)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.key,
            "data-testid": `${testIdPrefix}-group-${g.key}`
        }, g.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
            style: {
                margin: '0 0 0.25rem',
                padding: '0 0.25rem',
                fontSize: '0.75rem',
                fontWeight: 800,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
            }
        }, g.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "radiogroup",
            "aria-label": g.label || g.title,
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.25rem'
            }
        }, g.options.map((row)=>{
            const Icon = row.icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                key: row.id,
                variant: "ghost",
                role: "radio",
                "aria-checked": Boolean(row.checked),
                "data-testid": `${testIdPrefix}-option-${row.id}`,
                className: "h-auto min-h-[3.25rem] w-full justify-start gap-3 rounded-xl px-2.5 py-2 font-normal",
                style: {
                    background: row.checked ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08) : 'transparent',
                    textAlign: 'start'
                },
                onClick: ()=>{
                    g.onPick?.(row.id);
                    if (!row.keepOpen) onClose?.();
                }
            }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                "aria-hidden": true,
                style: {
                    width: '2rem',
                    height: '2rem',
                    borderRadius: '0.5rem',
                    flexShrink: 0,
                    display: 'grid',
                    placeItems: 'center',
                    background: row.quiet ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.12),
                    color: row.quiet ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
                size: 16
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                dir: "auto",
                style: {
                    display: 'block',
                    fontSize: '0.84375rem',
                    fontWeight: 700,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            }, row.name), row.meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                style: {
                    display: 'block',
                    fontSize: '0.71875rem',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    whiteSpace: 'normal'
                }
            }, row.meta)), row.checked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true,
                style: {
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                    flexShrink: 0
                }
            }));
        }))))));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $28cc8471170fac89$export$2e2bcd8739ae039({ checked: checked = false, onChange: onChange, disabled: disabled = false, suggested: suggested = false, separated: separated = false, compact: compact = false, title: title, hint: hint = null, labels: labels, locale: locale, testId: testId = 'walkin-toggle', style: style }) {
    const copy = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).walkIn,
        ...labels
    };
    const lead = suggested && !checked && !disabled;
    const ink = checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : lead ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    const border = checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : lead ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border;
    const bg = checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft : lead ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.07) : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface;
    const track = {
        w: compact ? 34 : 40,
        h: compact ? 20 : 22
    };
    const knob = track.h - 6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            ...style
        }
    }, separated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        "data-testid": `${testId}-or`,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 11.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }), copy.or, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        role: "switch",
        "aria-checked": checked,
        disabled: disabled,
        onClick: ()=>onChange?.(!checked),
        "data-testid": testId,
        "data-suggested": lead ? 'true' : undefined,
        style: {
            position: 'relative',
            width: '100%',
            minHeight: compact ? 44 : 56,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: compact ? 10 : 12,
            padding: compact ? '6px 12px' : '10px 14px',
            borderRadius: 10,
            border: `1.5px solid ${border}`,
            background: bg,
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            transition: 'background .14s, border-color .14s'
        }
    }, lead && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-badge`,
        style: {
            position: 'absolute',
            top: -9,
            insetInlineEnd: 10,
            padding: '0 8px',
            borderRadius: 999,
            fontSize: 10.5,
            fontWeight: 800,
            lineHeight: '17px',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy}`
        }
    }, copy.suggested), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            minWidth: 0,
            opacity: disabled ? 0.55 : 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: compact ? 13 : 13.5,
            fontWeight: 700,
            color: ink
        }
    }, title), hint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": `${testId}-hint`,
        style: {
            fontSize: compact ? 11 : 11.5,
            lineHeight: 1.55,
            fontWeight: 500,
            color: checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, hint)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            position: 'relative',
            flexShrink: 0,
            width: track.w,
            height: track.h,
            borderRadius: 999,
            background: checked ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .14s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            top: 3,
            width: knob,
            height: knob,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.25)',
            insetInlineStart: checked ? track.w - knob - 3 : 3,
            transition: 'inset-inline-start .14s'
        }
    }))));
}




var $acw62 = parcelRequire("acw62");



'use client';
function $5943a0a75dff01a1$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, heightVar: heightVar = '--app-bottom-nav', className: className, 'data-testid': testId = 'bottom-nav', ...rest }) {
    const barRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Publish the real height while this bar is mounted, and clear it when it is
    // not — the bar is absent on full-screen flows, and a stale value there would
    // push floating chrome up over nothing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = barRef.current;
        if (!el || !heightVar || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(heightVar, `${Math.round(el.offsetHeight)}px`);
        publish();
        // ResizeObserver is absent in jsdom and in older webviews; the one-shot
        // measurement above is already right for them, since what it would catch
        // (a rotation changing the inset, a text-size change) is rare and
        // self-correcting on the next navigation.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(heightVar);
        };
    }, [
        heightVar,
        items.length
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("nav", {
        ref: barRef,
        className: className,
        "data-testid": testId,
        "aria-label": (0, $df1b34b618a72512$export$cddd06f8fa3400df)().bottomNav.label,
        style: {
            flexShrink: 0,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'space-around',
            paddingInline: '0.5rem',
            paddingTop: 0,
            // `max(…)`, not the bare inset: in a browser tab the inset is 0 because
            // the browser's own toolbar occupies that strip, which left the labels
            // sitting on the very edge of the window. The floor gives them the same
            // breathing room the home indicator provides in standalone mode.
            paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 0.25rem)',
            position: 'relative',
            zIndex: 50
        },
        ...rest
    }, items.map((item)=>{
        const isActive = item.key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: item.key,
            variant: "ghost",
            onClick: ()=>onSelect?.(item.key, item),
            "aria-current": isActive ? 'page' : undefined,
            "data-testid": `${testId}-${item.key}`,
            className: "h-auto min-h-11 flex-1 flex-col gap-1 rounded-none py-2 font-medium",
            style: {
                color: isActive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                position: 'relative',
                display: 'inline-flex'
            }
        }, item.icon, item.badge != null && item.badge !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": `${testId}-${item.key}-badge`,
            // The count is decoration to the eye and information to a
            // screen reader; without a label it is read as a bare digit
            // beside the destination's name. The caller supplies the
            // sentence because only it knows what is being counted.
            "aria-label": item.badgeLabel,
            style: {
                position: 'absolute',
                top: '-0.25rem',
                insetInlineEnd: '-0.375rem',
                minWidth: '1rem',
                height: '1rem',
                paddingInline: '0.25rem',
                borderRadius: '0.5rem',
                // Tone is the caller's to choose, and the default is NOT the
                // safe one. Red carries "something is wrong"; an unread count
                // is not wrong, it is waiting — the colour budget reserves red
                // for destructive meaning, so a count uses `badgeTone="count"`.
                // ('accent' is the original spelling and still resolves here;
                // it drew navy from the start, and navy is the swatch the
                // whole unread family now agrees on.)
                // The default stays red only because it is what shipped, and
                // changing it silently would restyle callers that meant alarm.
                background: item.badgeTone === 'count' || item.badgeTone === 'accent' ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                color: '#fff',
                fontSize: '0.625rem',
                fontWeight: 700,
                lineHeight: '1rem',
                textAlign: 'center'
            }
        }, item.badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: isActive ? 700 : 500
            }
        }, item.label));
    }));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $ea4bc4a14affb445$export$2e2bcd8739ae039({ tiles: tiles = [], loading: loading = false, columns: columns = 4, className: className, 'data-testid': testId = 'stat-tiles', ...rest }) {
    if (!tiles.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": loading ? 'loading' : 'content',
        style: {
            display: 'grid',
            // minmax(0, 1fr) rather than 1fr: a grid track's default `min-width:auto`
            // is its content's minimum, so one long value would push the row past
            // 320px and take the whole page into horizontal scroll (§9).
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: '0.5rem'
        },
        ...rest
    }, tiles.map(({ key: key, label: label, value: value, icon: icon, color: color, solid: solid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: key ?? label,
            "data-testid": `${testId}-${key ?? label}`,
            style: {
                background: solid ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderRadius: '0.875rem',
                padding: '0.625rem 0.25rem',
                textAlign: 'center',
                boxShadow: solid ? `0 4px 16px ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.35)}` : '0 1px 4px rgba(0,0,0,0.06)',
                border: `1px solid ${solid ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                minWidth: 0
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '0.1875rem',
                color: solid ? '#fff' : color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '1.0625rem',
                fontWeight: 800,
                color: solid ? '#fff' : color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, loading || value == null || value === '' ? "\u2014" : value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                fontSize: '0.59375rem',
                color: solid ? 'rgba(255,255,255,0.7)' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                marginTop: '0.125rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }
        }, label))));
}



var $acw62 = parcelRequire("acw62");





'use client';
// ─────────────────────────────────────────────────────────────────────────────
// AccountCard — the block at the foot of the sidebar.
//
// ONE component for the doctor, clinic, dentist and patient panels, each of
// which had hand-rolled its own version: three copies of the پارسه balance card
// that already disagreed about their hex values, and four different answers to
// «چطور از حسابم خارج شوم؟».
//
// ── TWO ZONES, ONE COMPONENT ────────────────────────────────────────────────
// The balance on top, the identity below it, separated by the hairline that was
// already there. Not one merged row: the balance is a number read at a glance
// many times an hour, the identity is a control pressed rarely. The doctor and
// clinic panels independently arrived at this same stacking; this makes it the
// rule rather than a coincidence.
//
// ── THE IDENTITY ROW IS THE MENU TRIGGER ────────────────────────────────────
// The two loose 16px glyphs are gone. A sign-out icon sat one pixel from an
// external-link icon, both unlabelled, and the only thing distinguishing «رفتن
// به حساب» from «خروج» was the shape of a 16px arrow. Now the whole row opens a
// menu whose every destination is named in words.
//
// ── ONE BALANCE: THE SIGNED-IN PERSON'S OWN ─────────────────────────────────
// In the clinic panel there are two pots of money — the clinic's shared pool
// that reception AI spends, and the person's own wallet. This card shows ONLY
// the person's. They are never summed and never offset, and a block labelled
// «حساب من» must not be able to show money that belongs to the clinic. Omit
// `credit` entirely (a receptionist owns no wallet; patients hold no پارسه at
// all) and the zone is not rendered — there is then no number here to be wrong
// about.
//
// ── THE APP FORMATS THE DIGITS ──────────────────────────────────────────────
// `credit.amount` is a STRING the app already localised — Persian digits in fa,
// Latin in en. Same seam as `BottomNav`'s badge: the digit boundary belongs to
// the app, which knows its locale; the kit does not. `credit.level` likewise
// comes from `creditLevel()` in @parsina/framework/tokens, so all four panels
// agree on what «کم» means.
//
// ── SURVIVING THE 68px RAIL ─────────────────────────────────────────────────
// Coin tile and avatar sit in fixed-width cells FIRST in DOM order, so under RTL
// they are rightmost and the collapse — which clips from the inline-end — takes
// only the fading text. Both zones stay operable collapsed, and the menu still
// opens (it is portaled, so the sidebar's `overflow: hidden` cannot slice it).
// Nothing focusable is left painted at zero opacity: the top-up button is not
// rendered at all when collapsed, rather than faded into an invisible tab stop.
//
// Props:
//   user       {name, subtitle?, avatarUrl?}                       — required
//   credit     {amount, level, unit, label, levelLabel, onClick?}  — omit to hide the zone
//   onTopUp    ()=>void  — shows «شارژ اعتبار», expanded + level 'low' only
//   topUpLabel string
//   items      MenuItem[] — {key, label, description?, icon?, href?, external?,
//                            onClick?, tone?, separatorBefore?, 'data-testid'?}
//   collapsed  boolean    — the 68px rail
//   overlay    'auto' | 'menu' | 'sheet'  — auto switches at 768px (DESIGN.md §6:
//              a BottomSheet is the default overlay for a task on mobile; a 236px
//              popover anchored to the bottom edge of a phone is not)
//   menuLabel  string     — accessible name; required, because the trigger's own
//                           visible text is a person's name
// ─────────────────────────────────────────────────────────────────────────────
const $a13c7c62f369d090$var$MINI = 68; // the collapsed rail, and so the width of every icon cell
const $a13c7c62f369d090$var$INSET = 10; // the card's inset from the sidebar edges
const $a13c7c62f369d090$var$NARROW_QUERY = '(max-width: 768px)';
function $a13c7c62f369d090$var$useNarrow(enabled) {
    const [narrow, setNarrow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || typeof window === 'undefined' || !window.matchMedia) return undefined;
        const mq = window.matchMedia($a13c7c62f369d090$var$NARROW_QUERY);
        const sync = ()=>setNarrow(mq.matches);
        sync();
        // `addListener` is the Safari < 14 spelling; both are cheap to support and
        // the patient app is the one that actually meets phones.
        if (mq.addEventListener) mq.addEventListener('change', sync);
        else mq.addListener(sync);
        return ()=>{
            if (mq.removeEventListener) mq.removeEventListener('change', sync);
            else mq.removeListener(sync);
        };
    }, [
        enabled
    ]);
    return narrow;
}
const $a13c7c62f369d090$var$CoinGlyph = ({ size: size = 16 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        width: size,
        height: size,
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8.5",
        stroke: "currentColor",
        strokeWidth: "1.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 7.5v9M9.5 10h5M9.5 14h5",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round"
    }));
// Says the press LEAVES this panel. Without it a row that navigates to حساب
// پارسینا reads as a tab that never opens.
const $a13c7c62f369d090$var$ExternalGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "13",
        height: "13",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            opacity: 0.55
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "15 3 21 3 21 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        x1: "10",
        y1: "14",
        x2: "21",
        y2: "3"
    }));
// ── one menu row, in either presentation ────────────────────────────────────
function $a13c7c62f369d090$var$AccountMenuRow({ item: item, onDone: onDone, compact: compact, testIdBase: testIdBase }) {
    const destructive = item.tone === 'destructive';
    const ink = destructive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary;
    const hover = destructive ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, 0.10) : (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.08);
    const style = {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: compact ? '10px' : '13px 12px',
        minHeight: compact ? 40 : 48,
        border: 'none',
        borderRadius: 9,
        background: 'transparent',
        color: ink,
        textAlign: 'start',
        textDecoration: 'none',
        fontFamily: 'inherit',
        fontSize: 13.5,
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'background 0.14s'
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            display: 'flex',
            color: destructive ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        },
        "aria-hidden": true
    }, item.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.label), item.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            fontSize: 11,
            fontWeight: 500,
            marginTop: 1,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, item.description)), item.external && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$ExternalGlyph, null));
    const shared = {
        role: 'menuitem',
        'data-testid': item['data-testid'] || `${testIdBase}-item-${item.key}`,
        style: style,
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = hover;
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = 'transparent';
        }
    };
    // A real <a> when the destination is a URL: it must be focusable, openable in
    // a new tab with the usual modifiers, and readable in the status bar.
    return item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...shared,
        href: item.href,
        target: item.target,
        rel: item.target === '_blank' ? 'noopener noreferrer' : undefined,
        onClick: ()=>onDone?.()
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...shared,
        type: "button",
        onClick: ()=>{
            onDone?.();
            item.onClick?.();
        }
    }, body);
}
// ── the balance, in either presentation ─────────────────────────────────────
// A real <a> when `credit.href` is given — the clinic panel's balance points at
// حساب پارسینا, and a link there must be middle-clickable and readable in the
// status bar rather than a button that happens to navigate. A <button> when the
// destination is inside this SPA, so it does not reload the app.
function $a13c7c62f369d090$var$CreditZone({ credit: credit, levelColor: levelColor, isLow: isLow, collapsed: collapsed, fade: fade, testId: testId }) {
    const bg = (hovered)=>isLow ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, hovered ? 0.24 : 0.16) : `rgba(255,255,255,${hovered ? 0.12 : 0.06})`;
    const props = {
        'data-testid': `${testId}-credit`,
        onClick: credit.onClick,
        title: collapsed ? `${credit.label} \u{2014} ${credit.amount} ${credit.unit}` : undefined,
        'aria-label': `${credit.label} \u{2014} ${credit.amount} ${credit.unit}`,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `0 ${$a13c7c62f369d090$var$INSET}px`,
            display: 'flex',
            alignItems: 'center',
            borderRadius: 12,
            padding: 0,
            background: bg(false),
            border: `1px solid ${isLow ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, 0.4) : 'rgba(255,255,255,0.08)'}`,
            cursor: credit.href || credit.onClick ? 'pointer' : 'default',
            fontFamily: 'inherit',
            textAlign: 'start',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'background 0.18s'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.background = bg(true);
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.background = bg(false);
        }
    };
    const body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI - $a13c7c62f369d090$var$INSET * 2,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            padding: '9px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 30,
            height: 30,
            borderRadius: 9,
            flexShrink: 0,
            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)(levelColor, 0.22),
            color: levelColor,
            display: 'grid',
            placeItems: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 16
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: $a13c7c62f369d090$var$INSET
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'block',
            fontSize: 10.5,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.5)',
            whiteSpace: 'nowrap'
        }
    }, credit.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            marginTop: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 15,
            fontWeight: 800,
            color: '#fff',
            whiteSpace: 'nowrap'
        }
    }, credit.amount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 11,
            color: 'rgba(255,255,255,0.5)'
        }
    }, credit.unit), credit.levelLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            marginInlineStart: 'auto',
            whiteSpace: 'nowrap'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: levelColor
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: 10.5,
            fontWeight: 700,
            color: 'rgba(255,255,255,0.6)'
        }
    }, credit.levelLabel)))));
    return credit.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        ...props,
        href: credit.href,
        target: credit.target,
        rel: credit.target === '_blank' ? 'noopener noreferrer' : undefined
    }, body) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ...props,
        type: "button"
    }, body);
}
function $a13c7c62f369d090$export$2e2bcd8739ae039({ user: user, credit: credit = null, onTopUp: onTopUp, topUpLabel: topUpLabel, items: items = [], collapsed: collapsed = false, overlay: overlay = 'auto', menuLabel: menuLabel, 'data-testid': testId = 'account-card' }) {
    if (topUpLabel === undefined) topUpLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().account.topUp;
    if (menuLabel === undefined) menuLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().account.menu;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const narrow = $a13c7c62f369d090$var$useNarrow(overlay === 'auto');
    const asSheet = overlay === 'sheet' || overlay === 'auto' && narrow;
    // Collapsing must not leave the menu floating beside a rail that just changed
    // width — the anchor moves 192px under a CSS transition.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setOpen(false);
    }, [
        collapsed
    ]);
    const rows = items.filter(Boolean);
    const close = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setOpen(false), []);
    const fade = {
        opacity: collapsed ? 0 : 1,
        pointerEvents: collapsed ? 'none' : 'auto',
        transition: 'opacity 0.16s ease'
    };
    const level = credit?.level || 'ok';
    const levelColor = (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level]?.color || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal;
    const isLow = level === 'low';
    const rendered = rows.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: item.key
        }, item.separatorBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            role: "separator",
            style: {
                height: 1,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
                margin: '5px 8px'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$AccountMenuRow, {
            item: item,
            onDone: close,
            compact: !asSheet,
            testIdBase: testId
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        style: {
            flexShrink: 0,
            position: 'relative'
        }
    }, credit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '6px 0 2px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CreditZone, {
        credit: credit,
        levelColor: levelColor,
        isLow: isLow,
        collapsed: collapsed,
        fade: fade,
        testId: testId
    }), onTopUp && isLow && !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        "data-testid": `${testId}-topup`,
        onClick: onTopUp,
        style: {
            width: `calc(100% - ${$a13c7c62f369d090$var$INSET * 2}px)`,
            margin: `6px ${$a13c7c62f369d090$var$INSET}px 0`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 5,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            border: 'none',
            borderRadius: 10,
            padding: '7px 0',
            color: '#fff',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 800
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($a13c7c62f369d090$var$CoinGlyph, {
        size: 13
    }), " ", topUpLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: triggerRef,
        type: "button",
        "data-testid": `${testId}-trigger`,
        onClick: ()=>setOpen((v)=>!v),
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-label": `${menuLabel} \u{2014} ${user?.name || ''}`,
        title: collapsed ? `${menuLabel} \u{2014} ${user?.name || ''}` : undefined,
        style: {
            width: '100%',
            marginTop: credit ? 10 : 0,
            display: 'flex',
            alignItems: 'center',
            padding: '12px 0',
            border: 'none',
            borderTop: '1px solid rgba(255,255,255,0.07)',
            background: open ? 'rgba(255,255,255,0.09)' : 'transparent',
            cursor: 'pointer',
            fontFamily: 'inherit',
            textAlign: 'start',
            overflow: 'hidden',
            transition: 'background 0.16s'
        },
        onMouseEnter: (e)=>{
            if (!open) e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        },
        onMouseLeave: (e)=>{
            if (!open) e.currentTarget.style.background = 'transparent';
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            width: $a13c7c62f369d090$var$MINI,
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: user?.name || '',
        size: 36,
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        src: user?.avatarUrl || undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            ...fade,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flex: 1,
            minWidth: 0,
            paddingInlineEnd: 12
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: '#fff',
            fontSize: 13,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user?.name || "\u2014"), user?.subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        style: {
            display: 'block',
            color: 'rgba(255,255,255,0.42)',
            fontSize: 11,
            marginTop: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }, user.subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: "15",
        height: "15",
        "aria-hidden": true,
        style: {
            flexShrink: 0,
            color: open ? '#fff' : 'rgba(255,255,255,0.45)',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.18s, color 0.18s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: "18 15 12 9 6 15"
    })))), asSheet ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        title: menuLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "menu",
        "aria-label": menuLabel,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, rendered)) : // 'top': this card is the LAST thing in the sidebar, so a menu opening
    // downward would render off the bottom of the viewport.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $08d1958bc1315b40$export$2e2bcd8739ae039), {
        open: open,
        onClose: close,
        anchorRef: triggerRef,
        ariaLabel: menuLabel,
        placement: "top",
        width: 236,
        "data-testid": `${testId}-menu`
    }, rendered));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $dd795e2724b3b1d0$export$2e2bcd8739ae039({ items: items = [], active: active, onSelect: onSelect, ariaLabel: ariaLabel, className: className, 'data-testid': testId = 'section-nav', ...rest }) {
    const activeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Keep the selected section in view: a strip long enough to scroll can put
    // the active item off-screen (or half-clipped at an edge) after a tap, a
    // route restore, or a rotation.
    //
    // Feature-detected, not assumed: `scrollIntoView` does not exist in jsdom and
    // is missing from some old webviews, and an unguarded call there throws from
    // inside an effect — which unmounts the whole record rather than merely
    // failing to centre a tab. Centring is a convenience; rendering is not.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = activeRef.current;
        if (typeof el?.scrollIntoView !== 'function') return;
        el.scrollIntoView({
            inline: 'center',
            block: 'nearest',
            behavior: 'smooth'
        });
    }, [
        active
    ]);
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "tablist",
        "aria-label": ariaLabel,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            flexShrink: 0,
            display: 'flex',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            padding: '0 0.25rem'
        },
        ...rest
    }, items.map(({ key: key, label: label, icon: icon })=>{
        const on = key === active;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            key: key,
            ref: on ? activeRef : undefined,
            variant: "ghost",
            role: "tab",
            "aria-selected": on,
            "data-testid": `${testId}-${key}`,
            onClick: ()=>onSelect?.(key, {
                    key: key,
                    label: label,
                    icon: icon
                }),
            className: "h-auto min-h-11 shrink-0 flex-col gap-0.5 rounded-none px-3.5 py-2 hover:bg-transparent",
            style: {
                color: on ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                fontWeight: on ? 700 : 500,
                borderBottom: on ? `2.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy}` : '2.5px solid transparent'
            }
        }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true,
            style: {
                display: 'inline-flex'
            }
        }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem'
            }
        }, label));
    }));
}



var $acw62 = parcelRequire("acw62");




'use client';
/**
 * DateNavigator — the mobile day stepper (DESIGN-CONCEPT-MOBILE §4): prev/next
 * arrows around a TAPPABLE day label that opens the kit `JalaliCalendar` in a
 * `BottomSheet`. It is the mobile counterpart of the desktop header's
 * `JalaliDatePicker`, and it exists because §4 says arrow-stepping must never
 * be the ONLY path to a date — a doctor looking at next Tuesday should not
 * press an arrow five times.
 *
 * `variant="onGradient"` is the §3.2 "white-alpha inset card": the context
 * widget that lives INSIDE `MobileHeader`'s gradient.
 *
 * Every label is a prop and none is defaulted to Persian. The kit has no
 * translator, the calendar formatting stays with the app (the same rule
 * `TimeRuler.formatTick` and `ChatDayDivider.label` follow), and this component
 * is used by an app that ships in two languages.
 *
 * Props:
 *   value / onChange  — Gregorian 'YYYY-MM-DD', like every kit date component
 *   dateLabel         — the day, formatted by the caller (Jalaali under fa)
 *   subLabel          — optional second line, shown only when `isToday`
 *   isToday           — drives the «back to today» affordance
 *   onPrev / onNext / onToday
 *   prevLabel / nextLabel / pickLabel / todayLabel / sheetTitle — all required
 *                       in practice; they are this component's whole copy
 *   variant           — 'onGradient' (default) | 'plain'
 *   className / data-testid — forwarded to the root
 */ const $e0ac3bcac665682a$var$PREV_GLYPH = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $e0ac3bcac665682a$var$NEXT_GLYPH = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
function $e0ac3bcac665682a$export$2e2bcd8739ae039({ value: value, onChange: onChange, dateLabel: dateLabel, subLabel: subLabel, isToday: isToday = true, onPrev: onPrev, onNext: onNext, onToday: onToday, prevLabel: prevLabel, nextLabel: nextLabel, pickLabel: pickLabel, todayLabel: todayLabel, sheetTitle: sheetTitle, closeLabel: closeLabel, variant: variant = 'onGradient', className: className, 'data-testid': testId = 'date-navigator', ...rest }) {
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const onGradient = variant === 'onGradient';
    const arrowClass = onGradient ? 'min-w-11 min-h-11 text-white hover:bg-white/25' : 'min-w-11 min-h-11';
    const arrowStyle = onGradient ? {
        background: 'rgba(255,255,255,0.12)',
        borderRadius: '0.5rem'
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            background: onGradient ? 'rgba(255,255,255,0.12)' : 'transparent',
            borderRadius: '0.75rem',
            padding: '0.375rem 0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '0.375rem'
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-prev`,
        "aria-label": prevLabel,
        title: prevLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onPrev
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$PREV_GLYPH
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            textAlign: 'center',
            flex: 1,
            minWidth: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-pick`,
        "aria-label": pickLabel,
        className: onGradient ? 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold text-white hover:bg-white/15' : 'h-auto min-h-11 gap-1.5 px-2 py-0 text-[0.84375rem] font-bold',
        onClick: ()=>setPickerOpen(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5b56343e65588121$export$2e2bcd8739ae039), {
        size: 14,
        style: {
            opacity: 0.7
        },
        "aria-hidden": true
    }), dateLabel), isToday ? subLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            color: onGradient ? 'rgba(255,255,255,0.6)' : undefined,
            fontSize: '0.6875rem'
        }
    }, subLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        "data-testid": `${testId}-today`,
        className: onGradient ? 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold text-white/85 hover:bg-transparent hover:text-white' : 'mx-auto block h-auto min-h-0 p-0 text-[0.65625rem] font-semibold',
        onClick: onToday
    }, todayLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "icon",
        "data-testid": `${testId}-next`,
        "aria-label": nextLabel,
        title: nextLabel,
        className: arrowClass,
        style: arrowStyle,
        onClick: onNext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
        size: 18,
        "aria-hidden": true,
        style: $e0ac3bcac665682a$var$NEXT_GLYPH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: pickerOpen,
        onClose: ()=>setPickerOpen(false),
        title: sheetTitle || pickLabel,
        closeLabel: closeLabel,
        "data-testid": `${testId}-sheet`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$9c97d98ce20c6c7a), {
        value: value,
        onChange: (v)=>{
            setPickerOpen(false);
            if (v) onChange?.(v);
        }
    }), !isToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        className: "mt-3 w-full min-h-11",
        "data-testid": `${testId}-sheet-today`,
        onClick: ()=>{
            setPickerOpen(false);
            onToday?.();
        }
    }, todayLabel)));
}



var $acw62 = parcelRequire("acw62");





'use client';
function $a1c3a031457b1019$export$2e2bcd8739ae039({ onSave: onSave, onCancel: onCancel, saving: saving = false, saved: saved = false, disabled: disabled = false, sticky: sticky = false, saveLabel: saveLabel, cancelLabel: cancelLabel, savedLabel: savedLabel, className: className, style: // Merged OVER the computed layout, the `Card`/messaging-family precedent
// (DESIGN.md). It used to arrive through `...rest`, which is spread after
// `style` — so a caller adding one padding value silently deleted `display`,
// `position` and the safe-area inset and took the whole bar's layout with it.
style, 'data-testid': testId = 'savebar', ...rest }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().saveBar;
    if (saveLabel === undefined) saveLabel = copy.save;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    if (savedLabel === undefined) savedLabel = copy.saved;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        "data-state": saving ? 'saving' : saved ? 'saved' : 'idle',
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            marginTop: '1.75rem',
            ...sticky && {
                position: 'sticky',
                bottom: 0,
                marginTop: '1rem',
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                padding: '0.75rem 0 calc(0.75rem + env(safe-area-inset-bottom, 0px))',
                zIndex: 5
            },
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        onClick: onSave,
        disabled: saving || disabled,
        "data-testid": `${testId}-submit`
    }, saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 16,
        thickness: 2,
        color: "currentColor"
    }), saved && !saving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
        size: 16,
        "aria-hidden": true
    }), saved && !saving ? savedLabel : saveLabel), onCancel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onCancel,
        disabled: saving,
        "data-testid": `${testId}-cancel`
    }, cancelLabel));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $5f9cbffc25828c55$export$2e2bcd8739ae039({ n: n, title: title, sub: sub, icon: Icon, children: children, ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ...rest,
        style: {
            background: '#fff',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 18,
            boxShadow: '0 1px 2px rgba(22,39,61,.04), 0 8px 24px rgba(22,39,61,.05)'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        style: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: 13,
            padding: '18px 22px 0'
        }
    }, n != null && n !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            flexShrink: 0,
            width: 30,
            height: 30,
            borderRadius: '50%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            color: '#fff',
            fontWeight: 800,
            fontSize: 14,
            display: 'grid',
            placeItems: 'center'
        }
    }, n), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 16,
            fontWeight: 800,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
        }
    }, Icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        size: 17,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
    }), title), sub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 12.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 3
        }
    }, sub))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            padding: '18px 22px 22px',
            display: 'flex',
            flexDirection: 'column',
            gap: 16
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7f8899ae39ae38a1$export$a2387ed3b5d536eb = {
    name: "chevron-up",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m18 15-6-6-6 6",
                key: "153udz"
            }
        ]
    ]
};
$7f8899ae39ae38a1$export$a2387ed3b5d536eb.node;
const $7f8899ae39ae38a1$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($7f8899ae39ae38a1$export$a2387ed3b5d536eb);




'use client';
function $82e7212e133be19c$export$2e2bcd8739ae039({ columns: columns = [], rows: rows = [], rowKey: rowKey, onRowClick: onRowClick, onRowActivate: onRowActivate, rowProps: rowProps, empty: empty, loading: loading = false, skeletonRows: skeletonRows = 6, dense: dense = false, ariaLabel: ariaLabel, caption: caption, sort: sort, onSort: onSort, ...rest }) {
    const rowH = dense ? 44 : 52;
    // Logical, not physical. `'end'` used to resolve to `left`, which is the end
    // of an RTL row and the START of an LTR one — so a numeric column aligned to
    // the wrong edge the moment a table rendered in English.
    const alignOf = (a)=>a === 'center' ? 'center' : a === 'end' ? 'end' : 'start';
    const isEmpty = !loading && rows.length === 0;
    // Placeholder block widths for the loading body, derived from the REAL
    // column widths so a cell's block sits where that column's content will.
    // Without this the blocks cycled a generic width list, and a 70px status
    // column drew a 120px block that the <th> then clipped — the one thing a
    // skeleton exists to avoid. A column with no declared width (the flexible
    // ones, usually the name) keeps the generic rhythm; a percentage width is
    // relative to a table whose pixel size we do not know here, so it falls
    // back too. 60% of the column, because a cell is content plus padding.
    const skeletonWidths = columns.map((col, i)=>{
        const w = col.width;
        const px = typeof w === 'number' ? w : typeof w === 'string' && /^\d+(\.\d+)?px$/.test(w) ? parseFloat(w) : null;
        if (px == null) return [
            120,
            96,
            110,
            84
        ][i % 4];
        return Math.max(32, Math.round(px * 0.6));
    });
    const activate = onRowActivate || null;
    const interactive = !!(activate || onRowClick);
    const headerCell = (col)=>{
        if (!col.sortable || !onSort) return col.header;
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: ()=>onSort(key),
            className: "inline-flex items-center gap-1 bg-transparent border-0 p-0 cursor-pointer text-inherit hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded",
            style: {
                fontSize: 'inherit',
                fontWeight: 'inherit',
                fontFamily: 'inherit'
            },
            "data-active": active ? 'true' : undefined
        }, col.header, active ? sort.dir === 'asc' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f8899ae39ae38a1$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
            size: 13,
            "aria-hidden": true
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": loading ? 'loading' : isEmpty ? 'empty' : 'content',
        "aria-busy": loading ? 'true' : undefined,
        style: {
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("table", {
        "aria-label": caption ? undefined : ariaLabel,
        style: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 13.5
        }
    }, caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("caption", {
        style: {
            captionSide: 'top',
            textAlign: 'start',
            padding: '0 14px 8px',
            fontSize: 12.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, caption), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", null, columns.map((col)=>{
        const key = col.sortKey || col.key;
        const active = sort?.key === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("th", {
            key: col.key,
            scope: "col",
            "aria-sort": !col.sortable || !onSort ? undefined : active ? sort.dir === 'asc' ? 'ascending' : 'descending' : 'none',
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 1,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                fontWeight: 700,
                fontSize: 12.5,
                textAlign: alignOf(col.align),
                padding: '10px 14px',
                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                width: col.width,
                whiteSpace: 'nowrap'
            }
        }, headerCell(col));
    }))), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, Array.from({
        length: skeletonRows
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8bbcb87f63697989), {
            key: i,
            cols: columns.length,
            widths: skeletonWidths,
            dense: dense
        }))), !loading && !isEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows.map((row, i)=>{
        const extra = rowProps ? rowProps(row, i) || {} : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowKey ? rowKey(row, i) : row.id ?? i,
            onClick: interactive ? ()=>(activate || onRowClick)(row) : undefined,
            // Hover and focus are CSS states. The onMouseEnter/onMouseLeave
            // pair this replaces mutated inline styles — which §1.3 forbids,
            // and which left a row stuck highlighted whenever the pointer
            // left during a re-render.
            className: interactive ? 'transition-colors hover:bg-muted focus-visible:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring' : undefined,
            ...activate ? {
                tabIndex: 0,
                role: 'link',
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                        e.preventDefault();
                        activate(row);
                    }
                }
            } : null,
            ...extra,
            style: {
                height: rowH,
                cursor: interactive ? 'pointer' : 'default',
                ...extra.style
            }
        }, columns.map((col)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: col.key,
                style: {
                    textAlign: alignOf(col.align),
                    padding: '8px 14px',
                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    verticalAlign: 'middle'
                }
            }, col.render ? col.render(row, i) : row[col.key])));
    })))), isEmpty && empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, empty) : null);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $24dfcaee8d76ee07$export$2e2bcd8739ae039({ options: options = [], value: value, onChange: onChange, size: size = 'md', semantics: semantics = 'tabs', ariaLabel: ariaLabel, ...rest }) {
    const h = size === 'lg' ? 44 : size === 'sm' ? 32 : 36;
    const isFilter = semantics === 'filter';
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const move = (delta)=>{
        const enabled = options.filter((o)=>!o.disabled);
        if (!enabled.length) return;
        const at = enabled.findIndex((o)=>o.value === value);
        const next = enabled[(at + delta + enabled.length) % enabled.length];
        if (next) onChange?.(next.value);
    };
    const onKeyDown = (e)=>{
        if (![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ].includes(e.key)) return;
        e.preventDefault();
        if (e.key === 'Home' || e.key === 'End') {
            const enabled = options.filter((o)=>!o.disabled);
            const target = e.key === 'Home' ? enabled[0] : enabled[enabled.length - 1];
            if (target) onChange?.(target.value);
            return;
        }
        // Direction from the DOM, not an assumption: the visual "next" option is on
        // the left in an RTL group and on the right in an LTR one.
        const rtl = ref.current ? getComputedStyle(ref.current).direction === 'rtl' : true;
        const forward = rtl ? e.key === 'ArrowLeft' : e.key === 'ArrowRight';
        move(forward ? 1 : -1);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        ref: ref,
        role: isFilter ? 'radiogroup' : 'tablist',
        "aria-label": ariaLabel,
        onKeyDown: onKeyDown,
        style: {
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        }
    }, options.map((opt)=>{
        const active = opt.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: opt.value,
            type: "button",
            role: isFilter ? 'radio' : 'tab',
            ...isFilter ? {
                'aria-checked': active
            } : {
                'aria-selected': active
            },
            // Roving tabindex: the group is ONE tab stop and the arrows move
            // inside it. Without this every option is its own stop, so tabbing
            // past a six-option filter takes six presses.
            tabIndex: active ? 0 : -1,
            disabled: opt.disabled,
            "data-state": active ? 'active' : 'inactive',
            onClick: ()=>!opt.disabled && onChange?.(opt.value),
            className: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
            style: {
                height: h,
                padding: size === 'sm' ? '0 12px' : '0 16px',
                border: 'none',
                cursor: opt.disabled ? 'not-allowed' : 'pointer',
                borderRadius: 9,
                fontSize: size === 'sm' ? 12.5 : 13.5,
                fontWeight: 700,
                fontFamily: 'inherit',
                background: active ? '#fff' : 'transparent',
                color: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                boxShadow: active ? '0 1px 3px rgba(22,39,61,.12)' : 'none',
                opacity: opt.disabled ? 0.5 : 1,
                transition: 'all .15s',
                whiteSpace: 'nowrap'
            }
        }, opt.label);
    }));
}



var $acw62 = parcelRequire("acw62");



'use client';
// The page's own numerals — the digit set the date picker draws for `<html lang>`.
const $7bca3244df749c49$var$pageNum = (n)=>(0, $0873d4f32691c14e$export$545c62727d3740ae)(String(Math.trunc(Number(n))), (0, $0873d4f32691c14e$export$90e478cf5247906b)().digits);
function $7bca3244df749c49$export$2e2bcd8739ae039({ page: page = 1, pageCount: pageCount, total: total, pageSize: pageSize = 20, onChange: onChange, prevLabel: prevLabel, nextLabel: nextLabel, pageLabel: pageLabel, formatNumber: formatNumber = $7bca3244df749c49$var$pageNum }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().pager;
    if (prevLabel === undefined) prevLabel = copy.prev;
    if (nextLabel === undefined) nextLabel = copy.next;
    if (pageLabel === undefined) pageLabel = copy.page;
    const pages = pageCount ?? Math.max(1, Math.ceil((total || 0) / pageSize));
    if (pages <= 1) return null;
    const go = (p)=>{
        if (p >= 1 && p <= pages && p !== page) onChange?.(p);
    };
    const btn = (label, target, disabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            onClick: ()=>go(target),
            disabled: disabled,
            style: {
                minWidth: 34,
                height: 34,
                padding: '0 10px',
                borderRadius: 9,
                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: '#fff',
                cursor: disabled ? 'default' : 'pointer',
                color: disabled ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                fontFamily: 'inherit',
                fontSize: 13,
                opacity: disabled ? 0.5 : 1
            }
        }, label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            padding: '12px 0'
        }
    }, btn(prevLabel, page - 1, page <= 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontWeight: 600,
            padding: '0 6px'
        }
    }, pageLabel(formatNumber(page), formatNumber(pages))), btn(nextLabel, page + 1, page >= pages));
}



var $acw62 = parcelRequire("acw62");



'use client';
function $ab3d370aebf1b917$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, title: title, description: description, confirmLabel: confirmLabel, cancelLabel: cancelLabel, destructive: destructive = false, loading: loading = false, confirmDisabled: confirmDisabled = false, onConfirm: onConfirm, children: children, confirmTestId: confirmTestId, cancelTestId: cancelTestId, ...rest }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().confirm;
    if (confirmLabel === undefined) confirmLabel = copy.confirm;
    if (cancelLabel === undefined) cancelLabel = copy.cancel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
        size: "sm",
        showClose: false,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$742513523b177e3b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$16f7638e4a34b909), null, title)), typeof description === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "text-sm text-muted-foreground leading-6"
    }, description) : description || null, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "mt-4"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
        className: "mt-6 flex gap-2 justify-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: destructive ? 'destructive' : 'default',
        disabled: loading || confirmDisabled,
        onClick: onConfirm,
        "data-testid": confirmTestId
    }, confirmLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        disabled: loading,
        autoFocus: true,
        onClick: ()=>onOpenChange?.(false),
        "data-testid": cancelTestId
    }, cancelLabel))));
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Inline alert / callout banner (zone ②). Tokened bg/ink per variant — never raw hex.
 *
 * Props:
 *   variant  — 'info' | 'success' | 'warning' | 'error' | 'neutral'
 *   title    — optional bold lead line
 *   icon     — optional leading lucide node
 *   action   — optional trailing node (e.g. a Button)
 *   children — body content
 */ const $35331361c3270146$var$VARIANT = {
    info: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    },
    success: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    warning: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    error: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
    },
    neutral: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2
    }
};
function $35331361c3270146$export$2e2bcd8739ae039({ variant: variant = 'info', title: title, icon: icon, action: action, children: children, style: style, ...rest }) {
    const v = $35331361c3270146$var$VARIANT[variant] || $35331361c3270146$var$VARIANT.info;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            background: v.bg,
            color: v.ink,
            padding: '11px 16px',
            borderRadius: 12,
            fontSize: 13,
            ...style
        }
    }, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            display: 'inline-flex',
            flexShrink: 0
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flex: 1,
            minWidth: 0
        }
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontWeight: 700,
            marginBottom: children ? 4 : 0
        }
    }, title), children), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            flexShrink: 0
        }
    }, action));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f66de94054a4f331$export$a2387ed3b5d536eb = {
    name: "triangle-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
                key: "wmoenq"
            }
        ],
        [
            "path",
            {
                d: "M12 9v4",
                key: "juzpu7"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ]
    ],
    aliases: [
        "alert-triangle"
    ]
};
$f66de94054a4f331$export$a2387ed3b5d536eb.node;
const $f66de94054a4f331$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($f66de94054a4f331$export$a2387ed3b5d536eb);





'use client';
function $3cbee9b1abdcb86a$export$2e2bcd8739ae039({ icon: icon, title: title, description: description, onRetry: onRetry, retryLabel: retryLabel, fill: fill = false, style: style, ...rest }) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorState;
    if (title === undefined) title = copy.title;
    if (retryLabel === undefined) retryLabel = copy.retry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ...rest,
        "data-state": "error",
        style: {
            textAlign: 'center',
            padding: '60px 20px',
            ...fill && {
                flex: 1,
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'inline-flex',
            marginBottom: 16,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
        size: 44
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 18,
            fontWeight: 700,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: 8
        }
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 13,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginBottom: 16
        }
    }, description), onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onRetry
    }, retryLabel));
}



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one shell every whole-page system state renders through: 404, 403, the
// crash recovery page, maintenance, the cold offline boot, session expiry.
//
// Why one component rather than six designs: these screens are, by definition,
// the moments a user is already unsure whether the app is working. Six
// different layouts for six different faults reads as six different kinds of
// broken. One recognisable shape — icon, one-line verdict, one-line advice, a
// primary action — makes an unexpected page legible as "the app is telling me
// something", which is exactly the reassurance the situation needs.
//
// The shape is deliberately NOT the framework's `EmptyState`. An empty state
// says «there is nothing here yet» inside a working screen and must stay quiet;
// a system state says «something is wrong» and owns the viewport. Collapsing
// them is how a failed load ends up looking like a successful load of nothing.
//
// DESIGN COMPLIANCE — this page is not a special case:
//   • sizes and weights are the documented type roles (hero / metric / body /
//     caption). The kit cannot import an app's `type` module, so the values are
//     inlined with the role named beside them — never a size chosen for this
//     component alone,
//   • radius and elevation from RADIUS/SHADOW, so the card matches every other
//     card rather than being 2px rounder,
//   • actions are the kit `Button` — the app has seven button variants and a
//     hand-rolled one here would be an eighth,
//   • colours from `C`, never literal hex, so an accent preset reaches this
//     page too.
// ─────────────────────────────────────────────────────────────────────────────
/**
 * Tone drives the icon disc only, never the page. A red wash behind a 404 would
 * make a mistyped URL look like a clinical incident.
 */ const $46e1ac2ff7a7c6a8$var$TONES = {
    neutral: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted, 0.1)
        }),
    info: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1)
        }),
    warning: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight
        }),
    danger: ()=>({
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).redLight
        })
};
// The disc matches ErrorState's, so the inline and full-page failures read as
// one family seen at two sizes.
const $46e1ac2ff7a7c6a8$var$DISC = 56;
// The documented type roles, at their default-setting values. The kit cannot
// import an app's `constants/typography`, so the scale is restated here rather
// than sizes being invented per component — spread it exactly as an app spreads
// `type.*`, and the two surfaces stay identical.
const $46e1ac2ff7a7c6a8$var$TYPE = {
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    body: {
        fontSize: '0.8125rem',
        fontWeight: 500,
        lineHeight: 1.85
    },
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    }
};
function $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039({ tone: tone = 'neutral', icon: icon, code: code, title: title, body: body, detail: detail, actions: actions = [], children: children, footer: footer, fullscreen: fullscreen = false, testId: testId = 'system-page' }) {
    const palette = ($46e1ac2ff7a7c6a8$var$TONES[tone] || $46e1ac2ff7a7c6a8$var$TONES.neutral)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-system-state": tone,
        role: "alert",
        // `polite`, not `assertive`: the page has already replaced everything the
        // user was looking at, so the screen reader does not also need to
        // interrupt itself mid-sentence to say so.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullscreen ? undefined : 1,
            width: fullscreen ? '100vw' : '100%',
            height: fullscreen ? '100vh' : '100%',
            minHeight: fullscreen ? undefined : '20rem',
            padding: '2rem 1.25rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
            padding: '2.5rem 2rem 2rem',
            maxWidth: '28.75rem',
            width: '100%',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: (0, $e7c165fb515b04ea$export$98b6069deb71e13e).card
        }
    }, code && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-hidden": true,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.hero,
            position: 'absolute',
            top: '-0.5rem',
            insetInlineStart: '0.875rem',
            color: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted, 0.09),
            userSelect: 'none',
            direction: 'ltr',
            pointerEvents: 'none'
        }
    }, code), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: $46e1ac2ff7a7c6a8$var$DISC,
            height: $46e1ac2ff7a7c6a8$var$DISC,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            position: 'relative'
        }
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.metric,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            marginBottom: '0.5rem'
        }
    }, title), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.body,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            marginBottom: '1.25rem'
        }
    }, body), children, detail && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": `${testId}-detail`,
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            direction: 'ltr',
            textAlign: 'left',
            fontFamily: 'monospace',
            wordBreak: 'break-word',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            padding: '0.5rem 0.625rem',
            margin: '0 0 1.25rem',
            maxHeight: '7.5rem',
            overflow: 'auto'
        }
    }, detail), actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            flexDirection: actions.length > 2 ? 'column' : 'row',
            gap: '0.625rem',
            justifyContent: 'center'
        }
    }, actions.map((action, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46e1ac2ff7a7c6a8$var$SystemAction, {
            key: action.key || action.label || i,
            ...action,
            // The first action is the recommended one unless a caller says
            // otherwise — a system page with two equally-weighted buttons
            // makes the user decide something they have no basis to decide.
            variant: action.variant || (i === 0 ? 'primary' : 'secondary')
        }))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...$46e1ac2ff7a7c6a8$var$TYPE.caption,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: '1.25rem',
            lineHeight: 1.8
        }
    }, footer)));
}
// The two roles a system page offers map onto kit variants: `default` (the
// navy fill) for the recommended action, `outline` for the alternative. The
// prop names stay primary/secondary because that is what the CALLER is
// choosing — an intent, not a paint job — and it keeps the call sites readable.
const $46e1ac2ff7a7c6a8$var$VARIANT_MAP = {
    primary: 'default',
    secondary: 'outline',
    ghost: 'ghost'
};
function $46e1ac2ff7a7c6a8$var$SystemAction({ label: label, onClick: onClick, href: href, variant: variant, testId: testId }) {
    const kitVariant = $46e1ac2ff7a7c6a8$var$VARIANT_MAP[variant] || 'outline';
    // `asChild` renders the anchor with the button's styling, so a link action is
    // visually identical to a button one instead of being a hand-styled <a>.
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        asChild: true,
        variant: kitVariant,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: href
    }, label));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: kitVariant,
        onClick: onClick,
        "data-testid": testId
    }, label);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b5539f6bdf6973c1$export$a2387ed3b5d536eb = {
    name: "octagon-alert",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 16h.01",
                key: "1drbdi"
            }
        ],
        [
            "path",
            {
                d: "M12 8v4",
                key: "1got3b"
            }
        ],
        [
            "path",
            {
                d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
                key: "1fd625"
            }
        ]
    ],
    aliases: [
        "alert-octagon"
    ]
};
$b5539f6bdf6973c1$export$a2387ed3b5d536eb.node;
const $b5539f6bdf6973c1$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($b5539f6bdf6973c1$export$a2387ed3b5d536eb);




'use client';
class $10231e94a06472aa$export$7583e06808a373a5 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, info) {
        // Keep the component stack. `error.stack` points at the component that
        // threw, not the tree that rendered it — and for a shared primitive
        // (Button, Card) the latter is the only part identifying WHICH screen is
        // broken.
        // eslint-disable-next-line no-console
        console.error('[ErrorBoundary]', error, info?.componentStack);
        this.props.onError?.(error, info);
    }
    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) this.setState({
            error: null
        });
    }
    reset = ()=>this.setState({
            error: null
        });
    render() {
        if (!this.state.error) return this.props.children;
        return this.props.renderFallback(this.state.error, this.reset);
    }
}
function $10231e94a06472aa$export$2e2bcd8739ae039({ children: children, resetKey: resetKey, title: title, body: body, retryLabel: retryLabel, showRetry: showRetry = true, actions: actions = [], footer: footer, fullscreen: fullscreen = false, onError: onError, testId: testId = 'error-boundary' }) {
    if (title === undefined) title = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorBoundary.title;
    if (body === undefined) body = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorBoundary.body;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().errorBoundary.retry;
    const renderFallback = (error, reset)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $46e1ac2ff7a7c6a8$export$2e2bcd8739ae039), {
            testId: testId,
            tone: "danger",
            fullscreen: fullscreen,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b5539f6bdf6973c1$export$2e2bcd8739ae039), {
                size: 30,
                strokeWidth: 2,
                "aria-hidden": true
            }),
            title: title,
            body: body,
            // The message, not the stack: a user cannot read a stack, and the message
            // is the part that lets support reproduce it. The stack is in the console
            // for whoever goes looking.
            detail: error?.message || String(error),
            actions: [
                ...showRetry ? [
                    {
                        key: 'retry',
                        label: retryLabel,
                        onClick: reset,
                        variant: 'primary',
                        testId: `${testId}-retry`
                    }
                ] : [],
                ...actions
            ],
            footer: footer
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($10231e94a06472aa$export$7583e06808a373a5, {
        resetKey: resetKey,
        renderFallback: renderFallback,
        onError: onError
    }, children);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $07c0fad7e9511576$export$a2387ed3b5d536eb = {
    name: "cloud-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.94 5.274A7 7 0 0 1 15.71 10h1.79a4.5 4.5 0 0 1 4.222 6.057",
                key: "1uxyv8"
            }
        ],
        [
            "path",
            {
                d: "M18.796 18.81A4.5 4.5 0 0 1 17.5 19H9A7 7 0 0 1 5.79 5.78",
                key: "99tcn7"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ]
    ]
};
$07c0fad7e9511576$export$a2387ed3b5d536eb.node;
const $07c0fad7e9511576$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($07c0fad7e9511576$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $96b330d9ae0cfa5e$export$a2387ed3b5d536eb = {
    name: "refresh-cw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
                key: "v9h5vc"
            }
        ],
        [
            "path",
            {
                d: "M21 3v5h-5",
                key: "1q7to0"
            }
        ],
        [
            "path",
            {
                d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
                key: "3uifl3"
            }
        ],
        [
            "path",
            {
                d: "M8 16H3v5",
                key: "1cv678"
            }
        ]
    ]
};
$96b330d9ae0cfa5e$export$a2387ed3b5d536eb.node;
const $96b330d9ae0cfa5e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($96b330d9ae0cfa5e$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f44aa7a4ced52702$export$a2387ed3b5d536eb = {
    name: "wifi",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 20h.01",
                key: "zekei9"
            }
        ],
        [
            "path",
            {
                d: "M2 8.82a15 15 0 0 1 20 0",
                key: "dnpr2z"
            }
        ],
        [
            "path",
            {
                d: "M5 12.859a10 10 0 0 1 14 0",
                key: "1x1e6c"
            }
        ],
        [
            "path",
            {
                d: "M8.5 16.429a5 5 0 0 1 7 0",
                key: "1bycff"
            }
        ]
    ]
};
$f44aa7a4ced52702$export$a2387ed3b5d536eb.node;
const $f44aa7a4ced52702$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($f44aa7a4ced52702$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34b17daf5c0ea500$export$a2387ed3b5d536eb = {
    name: "wifi-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 20h.01",
                key: "zekei9"
            }
        ],
        [
            "path",
            {
                d: "M8.5 16.429a5 5 0 0 1 7 0",
                key: "1bycff"
            }
        ],
        [
            "path",
            {
                d: "M5 12.859a10 10 0 0 1 5.17-2.69",
                key: "1dl1wf"
            }
        ],
        [
            "path",
            {
                d: "M19 12.859a10 10 0 0 0-2.007-1.523",
                key: "4k23kn"
            }
        ],
        [
            "path",
            {
                d: "M2 8.82a15 15 0 0 1 4.177-2.643",
                key: "1grhjp"
            }
        ],
        [
            "path",
            {
                d: "M22 8.82a15 15 0 0 0-11.288-3.764",
                key: "z3jwby"
            }
        ],
        [
            "path",
            {
                d: "m2 2 20 20",
                key: "1ooewy"
            }
        ]
    ]
};
$34b17daf5c0ea500$export$a2387ed3b5d536eb.node;
const $34b17daf5c0ea500$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($34b17daf5c0ea500$export$a2387ed3b5d536eb);





var $acw62 = parcelRequire("acw62");
// ─────────────────────────────────────────────────────────────────────────────
// The one-way channel from "a request just failed for transport reasons" to
// "the connectivity detector should go and check".
//
// It exists because the two halves cannot import each other. `bffClient` is a
// leaf module with no React in it — deliberately, so it can be used from
// anywhere, including outside a component — while `useOnlineStatus` is a hook.
// Without this the detector would only ever learn about an outage from
// `navigator.onLine`, which is exactly the signal that lies: it reports online
// for a captive portal, a dead VPN, and a firewall that black-holes the BFF.
// Those are the cases the doctor most needs named, because in every one of them
// the laptop insists everything is fine.
//
// Kept as a plain subscriber list rather than an event emitter or a context: it
// carries no payload, has at most one listener (the shell's hook), and must be
// safe to call from a `catch` block during module teardown. There is nothing
// here to configure and nothing to get wrong.
// ─────────────────────────────────────────────────────────────────────────────
const $1ca1f567c505cbd8$var$listeners = new Set();
function $1ca1f567c505cbd8$export$288ba6b4215d30f3(listener) {
    $1ca1f567c505cbd8$var$listeners.add(listener);
    return ()=>$1ca1f567c505cbd8$var$listeners.delete(listener);
}
function $1ca1f567c505cbd8$export$87a8bdb1d0a966cf() {
    for (const listener of $1ca1f567c505cbd8$var$listeners)try {
        listener();
    } catch  {}
}
function $1ca1f567c505cbd8$export$d433e139d37a5376() {
    $1ca1f567c505cbd8$var$listeners.clear();
}


// ─────────────────────────────────────────────────────────────────────────────
// Is the app actually able to reach its backend?
//
// The app had no answer to this at all. A doctor whose Wi-Fi dropped mid-clinic
// saw each screen fail on its own schedule, each with its own error card, none
// of them saying the one thing that explained all of them — and nothing told
// them when it came back, so the habit became "refresh and hope".
//
// `navigator.onLine` alone is not the answer, and the direction of its error
// matters. It is RELIABLE when false (the OS says there is no route to
// anywhere) and near-worthless when true (it means "an interface is up", which
// a captive portal, an expired hotel Wi-Fi login, a VPN drop and a firewall all
// satisfy while dropping every packet to the BFF). So:
//
//   offline  — the browser says so. Trusted immediately, no probe needed.
//   degraded — the browser says we are online but the BFF is not answering.
//              Only entered from real evidence: a request that actually failed,
//              confirmed by a probe. This is the state that catches the captive
//              portal, and it is why a bare `navigator.onLine` hook was not
//              enough.
//   online   — reachable.
//
// The probe is deliberately cheap and deliberately rare: it only runs while
// something is known to be wrong, or once when the browser says the network
// came back. It never polls a healthy connection — a heartbeat that fires all
// day to detect a condition that lasts seconds is a battery cost paid by every
// doctor to benefit none of them.
// ─────────────────────────────────────────────────────────────────────────────
/** The browser's own verdict. Reliable when true, worthless when false — see above. */ const $2a96b0bae45a4311$var$isBrowserOffline = ()=>typeof navigator !== 'undefined' && navigator.onLine === false;
const $2a96b0bae45a4311$export$cd9c3c6bf535afc9 = {
    ONLINE: 'online',
    DEGRADED: 'degraded',
    OFFLINE: 'offline'
};
// Backoff for the recovery probe while disconnected. Starts brisk — most
// outages are a few seconds of a lift or a dead spot, and the doctor should not
// wait a minute to be told they are back — then eases off so a genuinely long
// outage is not a request every two seconds for twenty minutes.
const $2a96b0bae45a4311$var$PROBE_MIN_MS = 3000;
const $2a96b0bae45a4311$var$PROBE_MAX_MS = 30000;
// The probe budget. Much shorter than a real query's: this asks one question
// ("is anything there?") and a slow answer is a no for our purposes.
const $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS = 5000;
/**
 * Ask the BFF whether it is reachable.
 *
 * Sends the smallest legal GraphQL request rather than hitting a health path:
 * the BFF has no unauthenticated health endpoint, and this way the probe
 * traverses exactly the path real queries do — same origin, same proxy, same
 * TLS. Any HTTP response at all counts as reachable, INCLUDING 400 and 401: the
 * question is whether packets arrive, not whether we are welcome. Treating a
 * 401 as "offline" would put a network banner in front of a user whose session
 * simply expired, which is a different problem with different copy.
 */ async function $2a96b0bae45a4311$var$probeBff(url, signal) {
    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: '{__typename}'
            }),
            signal: signal,
            cache: 'no-store'
        });
        return Boolean(res);
    } catch  {
        return false;
    }
}
function $2a96b0bae45a4311$export$a32c5b7f472865fb({ url: url } = {}) {
    const [state, setState] = (0, $acw62.useState)(()=>$2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE);
    // Was the connection ever lost in this session? Drives the transient «اتصال
    // برقرار شد» confirmation — without it, the banner would announce a recovery
    // to every doctor who simply opened the app.
    const [recovered, setRecovered] = (0, $acw62.useState)(false);
    const timerRef = (0, $acw62.useRef)(null);
    const backoffRef = (0, $acw62.useRef)($2a96b0bae45a4311$var$PROBE_MIN_MS);
    const abortRef = (0, $acw62.useRef)(null);
    const stateRef = (0, $acw62.useRef)(state);
    stateRef.current = state;
    const clearTimer = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const goOnline = (0, $acw62.useCallback)(()=>{
        backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
        clearTimer();
        setState((prev)=>{
            if (prev !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) setRecovered(true);
            return $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE;
        });
    }, []);
    /**
   * Run one probe now and schedule the next if it fails.
   *
   * Exposed as `check` so a failed real request can hand its evidence over
   * rather than making the hook discover the same outage independently.
   */ const check = (0, $acw62.useCallback)(async ()=>{
        if ($2a96b0bae45a4311$var$isBrowserOffline()) {
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
            return false;
        }
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const timeout = setTimeout(()=>controller.abort(), $2a96b0bae45a4311$var$PROBE_TIMEOUT_MS);
        const reachable = url ? await $2a96b0bae45a4311$var$probeBff(url, controller.signal) : true;
        clearTimeout(timeout);
        if (reachable) {
            goOnline();
            return true;
        }
        // Re-read the authoritative signal at the moment of the verdict rather than
        // trusting the state we entered with: a probe can outlive the condition that
        // started it, and an in-flight request that resolves after the interface
        // genuinely dropped must not downgrade a true OFFLINE to DEGRADED.
        //
        // The reverse matters more, and is the case the test pins: once the browser
        // reports online again, a failing probe means DEGRADED — there IS a network,
        // the BFF is just not on the other end of it. Keeping OFFLINE sticky here
        // would have described a captive portal as "no internet", which sends the
        // doctor to look at a router that is working perfectly.
        setState($2a96b0bae45a4311$var$isBrowserOffline() ? $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE : $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED);
        clearTimer();
        timerRef.current = setTimeout(check, backoffRef.current);
        backoffRef.current = Math.min(backoffRef.current * 2, $2a96b0bae45a4311$var$PROBE_MAX_MS);
        return false;
    }, [
        goOnline,
        url
    ]);
    /**
   * Report a request that just failed for transport reasons.
   *
   * The distinction that makes this hook trustworthy: we do NOT go straight to
   * `degraded` on one failed request. A single 502 from one flaky upstream is
   * not a connectivity problem, and telling the doctor their connection is down
   * when one panel failed would train them to ignore the banner — which is the
   * whole asset here. The probe is what turns a suspicion into a claim.
   */ const reportFailure = (0, $acw62.useCallback)(()=>{
        if (stateRef.current === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
    }, [
        check
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleOffline = ()=>{
            // No probe: the browser is authoritative in this direction, and firing a
            // request at a machine with no route just burns a timeout.
            clearTimer();
            abortRef.current?.abort();
            setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        };
        // …and NOT authoritative in the other. 'online' means an interface came up,
        // which a captive portal satisfies. Confirm before claiming recovery.
        const handleOnline = ()=>{
            backoffRef.current = $2a96b0bae45a4311$var$PROBE_MIN_MS;
            check();
        };
        // Coming back to a backgrounded tab is the other moment worth checking: a
        // laptop that slept through a network change reports nothing, and the first
        // thing the doctor does is read a screen full of stale data.
        const handleVisibility = ()=>{
            if (document.visibilityState === 'visible' && stateRef.current !== $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE) check();
        };
        window.addEventListener('offline', handleOffline);
        window.addEventListener('online', handleOnline);
        document.addEventListener('visibilitychange', handleVisibility);
        // The evidence `navigator.onLine` cannot give us: a real request that just
        // failed at the transport layer.
        const unsubscribe = (0, $1ca1f567c505cbd8$export$288ba6b4215d30f3)(reportFailure);
        // A tab that BOOTS offline never fires an event — it was already in that
        // state — so the initial value has to stand on its own, and it does.
        if ($2a96b0bae45a4311$var$isBrowserOffline()) setState($2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE);
        return ()=>{
            window.removeEventListener('offline', handleOffline);
            window.removeEventListener('online', handleOnline);
            document.removeEventListener('visibilitychange', handleVisibility);
            unsubscribe();
            clearTimer();
            abortRef.current?.abort();
        };
    }, [
        check,
        reportFailure
    ]);
    return {
        state: state,
        isOnline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.ONLINE,
        isOffline: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.OFFLINE,
        isDegraded: state === $2a96b0bae45a4311$export$cd9c3c6bf535afc9.DEGRADED,
        recovered: recovered,
        acknowledgeRecovery: (0, $acw62.useCallback)(()=>setRecovered(false), []),
        check: check,
        reportFailure: reportFailure
    };
}
var $2a96b0bae45a4311$export$2e2bcd8739ae039 = $2a96b0bae45a4311$export$a32c5b7f472865fb;



'use client';
// ─────────────────────────────────────────────────────────────────────────────
// The one place the app says «you are not connected».
//
// Without one, a dropped connection produces N independent error cards, one per
// panel, each blaming itself, none of them explaining the others — and no signal
// at all when it comes back, so the user's only strategy is to refresh and see.
//
// Deliberate choices:
//
//   It is a BAR, not a modal or a toast. A modal would block a doctor from
//   reading the notes already on screen, which are still perfectly good and are
//   the most valuable thing in the room during an outage. A toast would vanish
//   while the condition persisted. A bar states an ongoing fact and lets work
//   continue around it.
//
//   It sits at the top and pushes content down rather than floating over it.
//   Overlaying would cover the page header on every screen — which in a
//   clinical app is often the patient's name, not something to hide.
//
//   Recovery is announced ONCE and then disappears on its own. A permanent
//   «متصل» is chrome nobody reads; the useful signal is the transition, and
//   specifically the moment a user can stop wondering whether their last save
//   went through.
// ─────────────────────────────────────────────────────────────────────────────
const $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS = 4000;
const $0790d8ae08647dfa$var$VARIANTS = {
    [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).OFFLINE]: {
        Icon: (0, $34b17daf5c0ea500$export$2e2bcd8739ae039),
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
        fg: '#fff',
        testId: 'connectivity-offline'
    },
    [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).DEGRADED]: {
        Icon: (0, $07c0fad7e9511576$export$2e2bcd8739ae039),
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
        // Amber is a light hue; white on it fails contrast. `CT.warnInk` is the
        // ink the kit already pairs with a warning surface — a hand-mixed brown
        // here is how a second, slightly-off warning colour enters a design system.
        fg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk,
        testId: 'connectivity-degraded'
    }
};
function $0790d8ae08647dfa$export$2e2bcd8739ae039({ state: state, recovered: recovered, onAcknowledgeRecovery: onAcknowledgeRecovery, onRetry: onRetry, busy: busy, offlineLabel: offlineLabel, degradedLabel: degradedLabel, restoredLabel: restoredLabel, retryLabel: retryLabel, busyLabel: busyLabel }) {
    if (offlineLabel === undefined) offlineLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.offline;
    if (degradedLabel === undefined) degradedLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.degraded;
    if (restoredLabel === undefined) restoredLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.restored;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.retry;
    if (busyLabel === undefined) busyLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().connectivity.busy;
    const disconnected = state !== (0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).ONLINE;
    const LABELS = {
        [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).OFFLINE]: offlineLabel,
        [(0, $2a96b0bae45a4311$export$cd9c3c6bf535afc9).DEGRADED]: degradedLabel
    };
    // The recovery bar retires itself. The timer is keyed on the flag so a second
    // outage inside the window restarts it rather than inheriting a stale
    // countdown that would hide the confirmation early.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!recovered || disconnected) return undefined;
        const timer = setTimeout(()=>onAcknowledgeRecovery?.(), $0790d8ae08647dfa$var$RECOVERY_VISIBLE_MS);
        return ()=>clearTimeout(timer);
    }, [
        recovered,
        disconnected,
        onAcknowledgeRecovery
    ]);
    if (disconnected) {
        const variant = $0790d8ae08647dfa$var$VARIANTS[state];
        if (!variant) return null;
        const { Icon: Icon, bg: bg, fg: fg, testId: testId } = variant;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
            bg: bg,
            fg: fg,
            testId: testId,
            state: state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
            size: 15,
            strokeWidth: 2.2,
            "aria-hidden": true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, LABELS[state]), onRetry && // The kit Button at `sm`, not a hand-rolled pill. It sits on a
        // coloured bar rather than the page, so `currentColor` carries the
        // bar's ink through — the only thing the variants cannot know — and
        // height, radius, type, focus ring and disabled state all come from
        // the kit like every other button.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            type: "button",
            size: "sm",
            variant: "ghost",
            onClick: onRetry,
            disabled: busy,
            "data-testid": "connectivity-retry",
            style: {
                marginInlineStart: 'auto',
                color: fg,
                border: '1px solid currentColor',
                background: 'transparent',
                gap: '0.3125rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $96b330d9ae0cfa5e$export$2e2bcd8739ae039), {
            size: 12,
            "aria-hidden": true,
            style: busy ? {
                animation: 'connectivity-spin 0.9s linear infinite'
            } : undefined
        }), busy ? busyLabel : retryLabel));
    }
    if (recovered) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0790d8ae08647dfa$var$Bar, {
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
        fg: "#fff",
        testId: "connectivity-restored",
        state: "restored"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f44aa7a4ced52702$export$2e2bcd8739ae039), {
        size: 15,
        strokeWidth: 2.2,
        "aria-hidden": true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, restoredLabel));
    return null;
}
function $0790d8ae08647dfa$var$Bar({ bg: bg, fg: fg, testId: testId, state: state, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-connection-state": state,
        role: "status",
        // `polite`, not `assertive`. A user mid-sentence must not have their
        // screen reader interrupted by an infrastructure notice — the connection
        // dropping is not more urgent than what they are writing.
        "aria-live": "polite",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            padding: '0.4375rem 1rem',
            background: bg,
            color: fg,
            fontSize: '0.75rem',
            fontWeight: 600,
            flexShrink: 0,
            zIndex: 40
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", null, '@keyframes connectivity-spin { to { transform: rotate(360deg) } }'), children);
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Square icon-only button with a ≥44px touch target (mobile-safe) and a required
 * accessible label. `onGradient` variant is the white-alpha control for gradient
 * headers (§3.2). Encapsulates the affordance so screens never hand-roll a raw <button>.
 *
 * Props:
 *   icon     — lucide node (required)
 *   label    — accessible label / tooltip (required)
 *   variant  — 'default' | 'ghost' | 'outline' | 'onGradient'
 *   size     — px (default 44 — the mobile minimum)
 *   onClick, disabled
 */ const $26386601b5f40a7d$var$VARIANT = {
    default: {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        color: '#fff',
        border: 'none'
    },
    ghost: {
        background: 'transparent',
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
        border: 'none'
    },
    outline: {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
    },
    onGradient: {
        background: 'rgba(255,255,255,0.15)',
        color: '#fff',
        border: 'none'
    }
};
function $26386601b5f40a7d$export$2e2bcd8739ae039({ icon: icon, label: label, onClick: onClick, variant: variant = 'default', size: size = 44, disabled: disabled = false, style: style, ...rest }) {
    const v = $26386601b5f40a7d$var$VARIANT[variant] || $26386601b5f40a7d$var$VARIANT.default;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        ...rest,
        onClick: onClick,
        disabled: disabled,
        "aria-label": label,
        title: label,
        style: {
            width: size,
            height: size,
            minWidth: size,
            padding: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            flexShrink: 0,
            fontFamily: 'inherit',
            ...v,
            ...style
        }
    }, icon);
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $83905746e46531b9$export$a2387ed3b5d536eb = {
    name: "plus",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M5 12h14",
                key: "1ays0h"
            }
        ],
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le"
            }
        ]
    ]
};
$83905746e46531b9$export$a2387ed3b5d536eb.node;
const $83905746e46531b9$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($83905746e46531b9$export$a2387ed3b5d536eb);



'use client';
function $9b6fb81a56105b0d$export$2e2bcd8739ae039({ label: label, icon: icon, onClick: onClick, minHeight: minHeight = 118, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: onClick,
        style: {
            width: '100%',
            minHeight: minHeight,
            padding: 16,
            background: 'transparent',
            border: `1.5px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 16,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 6,
            cursor: 'pointer',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            fontFamily: 'inherit',
            fontWeight: 700,
            fontSize: 14,
            ...style
        }
    }, icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $83905746e46531b9$export$2e2bcd8739ae039), {
        size: 22
    }), label);
}



var $acw62 = parcelRequire("acw62");

'use client';
function $0d47a2201c3cd6a9$export$2e2bcd8739ae039({ checked: checked, onChange: onChange, disabled: disabled = false, label: label, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "switch",
        "aria-checked": checked,
        "aria-disabled": disabled,
        "aria-label": label,
        onClick: ()=>{
            if (!disabled) onChange?.(!checked);
        },
        style: {
            width: 44,
            height: 24,
            borderRadius: 4,
            flexShrink: 0,
            position: 'relative',
            cursor: disabled ? 'not-allowed' : 'pointer',
            background: checked ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : '#d1d5db',
            opacity: disabled ? 0.5 : 1,
            transition: 'background .25s',
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 3,
            width: 18,
            height: 18,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
            right: checked ? 3 : 23,
            transition: 'right .25s'
        }
    }));
}



var $acw62 = parcelRequire("acw62");


'use client';
function $2358e3acbc4a7e55$export$2e2bcd8739ae039({ title: title, badge: badge, defaultOpen: defaultOpen = false, open: controlledOpen, onOpenChange: onOpenChange, children: children, style: style }) {
    const [uncontrolled, setUncontrolled] = (0, $acw62.useState)(defaultOpen);
    const open = controlledOpen !== undefined ? controlledOpen : uncontrolled;
    const toggle = ()=>{
        const next = !open;
        if (onOpenChange) onOpenChange(next);
        if (controlledOpen === undefined) setUncontrolled(next);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        onClick: toggle,
        "aria-expanded": open,
        style: {
            width: '100%',
            minHeight: 44,
            padding: '14px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontWeight: 700,
            fontSize: 14.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6
        }
    }, title, badge != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            fontSize: 12
        }
    }, badge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
        size: 18,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        style: {
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform .15s'
        }
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            paddingBottom: 8
        }
    }, children));
}



var $acw62 = parcelRequire("acw62");



'use client';
// ─────────────────────────────────────────────────────────────────────────────
// PrizeWheel — a wheel of fortune: N equal slices that spin and stop on one.
//
// Domain-free on purpose. The kit draws a circle and turns it; it knows nothing
// about prizes, wallets, campaigns or Parseh. The caller hands it the slices it
// should print and the slice it should land on, and is told when the wheel has
// stopped.
//
//   segments     [{ index, label }] in index order — position i IS slice i.
//                Labels arrive FORMATTED: Persian digits go through the app's
//                own digit seam (rule 7), never through the kit.
//   targetIndex  the winning slice, or null while nobody knows it yet. The
//                SERVER picks it; the wheel only animates to it.
//   spinning     whether the wheel should be turning. With a target but no
//                spin the wheel sits AT the result — that is how an already
//                spun draw is re-shown without replaying the animation.
//   onSettled    fired once, when the spin has stopped.
//   size         pixel diameter (it still shrinks to its container).
//
// ── Geometry ────────────────────────────────────────────────────────────────
// One 400×400 viewBox, so every number below is a user unit and the whole wheel
// scales with `size` — including the label type, which is why the labels do not
// need a second size prop. Slice i runs from `i·step − 90°` (SVG angles start
// at 3 o'clock and grow clockwise, so −90° is 12 o'clock) clockwise by one
// step. A label is rotated onto its slice's mid-angle and flipped 180° through
// the bottom half of the wheel, because a label that is merely rotated is
// upside down for half the circle.
//
// ── Motion ──────────────────────────────────────────────────────────────────
// ONE CSS transition on the slice group: θ = 5 full turns + (360 − the centre
// angle of the winning slice), so the slice's middle finishes under the pointer
// at 12 o'clock. The turns accumulate, so a wheel that is spun twice keeps
// turning the same way instead of unwinding.
//
// **Clockwise whatever the document's direction is.** Rule 8 is about layout
// and about content that carries direction; a wheel has neither. What the eye
// tracks is the pointer, and an RTL page that spun the other way would read as
// a different mechanism, not as a mirrored one.
//
// `prefers-reduced-motion: reduce` removes the transition (the BottomSheet /
// Dialog / Skeleton pattern: a media query in the kit's own stylesheet), so the
// wheel JUMPS to its result. `transitionend` then never fires — hence the
// timer, which is the real settle signal and the transition's is the early one.
// Whichever arrives first wins; `onSettled` is called exactly once per spin.
//
// ── Colour ──────────────────────────────────────────────────────────────────
// Four brand tones, cycled, with the label ink flipped against them so both
// pass contrast. The inks are `C.card` on the two filled tones and
// `var(--panel-ink)` on the two tints — the panel's deep ink rather than
// `CT.accentInk`, because an accent preset may NOT re-tint `--panel-ink`
// (tokens.css) while it does re-tint `--p-navy-dark`: under the فیروزه‌ای preset
// `accentInk` on a tint falls to ~3.9:1, and `--panel-ink` holds above 11:1
// under every preset and every panel.
// ─────────────────────────────────────────────────────────────────────────────
const $c173fca63c358943$var$CX = 200;
const $c173fca63c358943$var$CY = 200;
const $c173fca63c358943$var$R_SLICE = 190; // the coloured slices
const $c173fca63c358943$var$R_RIM = 196; // the white rim they sit on
const $c173fca63c358943$var$R_LABEL = 128; // where a slice prints its label
const $c173fca63c358943$var$R_HUB = 34; // the white hub cap
const $c173fca63c358943$var$R_HUB_INNER = 22;
const $c173fca63c358943$var$R_PIP = 9;
const $c173fca63c358943$var$TURNS = 5;
const $c173fca63c358943$var$SPIN_MS = 4000;
const $c173fca63c358943$var$SPIN_EASE = 'cubic-bezier(0.17, 0.67, 0.12, 1)';
// The transition's own `transitionend` is the early signal; this is the one
// that is always sent. The grace covers the frame between committing the
// rotation and the browser starting to paint it.
const $c173fca63c358943$var$SETTLE_GRACE_MS = 200;
const $c173fca63c358943$var$REDUCED_SETTLE_MS = 50;
const $c173fca63c358943$var$FILLS = [
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight,
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark,
    (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1)
];
const $c173fca63c358943$var$INKS = [
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
    'var(--panel-ink)',
    (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
    'var(--panel-ink)'
];
const $c173fca63c358943$var$DISC_CSS = `
  [data-prize-disc] { transform-origin: ${$c173fca63c358943$var$CX}px ${$c173fca63c358943$var$CY}px; }
  [data-prize-disc][data-spinning="true"] { transition: transform ${$c173fca63c358943$var$SPIN_MS}ms ${$c173fca63c358943$var$SPIN_EASE}; }
  @media (prefers-reduced-motion: reduce) {
    [data-prize-disc][data-spinning="true"] { transition: none !important; }
  }
`;
// One stylesheet for every wheel on the page: React 19 hoists a <style> with
// `href` + `precedence` into <head> once (the Skeleton family does the same).
const $c173fca63c358943$var$Styles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
        href: "parsina-prize-wheel",
        precedence: "default"
    }, $c173fca63c358943$var$DISC_CSS);
// Reduced motion, read in JS — only to choose how long to wait for a spin that
// the media query above has already cancelled. Defensive like the clinical
// module's `prefersInstant()`: with no window and no `matchMedia` there is no
// animation to wait for either, so "reduced" is the safe answer.
function $c173fca63c358943$var$prefersReducedMotion() {
    if (typeof window === 'undefined') return true;
    if (typeof window.matchMedia !== 'function') return true;
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch  {
        return true;
    }
}
const $c173fca63c358943$var$pol = (deg, r)=>{
    const t = deg * Math.PI / 180;
    return [
        $c173fca63c358943$var$CX + r * Math.cos(t),
        $c173fca63c358943$var$CY + r * Math.sin(t)
    ];
};
// The angle the disc must come to rest at, from zero, for slice `index` of
// `count` to face the pointer: whole turns for the show, then back to the
// slice's own middle.
function $c173fca63c358943$var$angleFor(index, count) {
    const step = 360 / count;
    return $c173fca63c358943$var$TURNS * 360 + (360 - (index * step + step / 2));
}
function $c173fca63c358943$export$2e2bcd8739ae039({ segments: segments = [], targetIndex: targetIndex = null, spinning: spinning = false, onSettled: onSettled, size: size = 320, label: // Rule 7: the app passes its own; unset, the kit's word in `<html lang>`.
label, className: className, style: style, ...rest }) {
    if (label === undefined) label = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().prizeWheel.label;
    const slices = Array.isArray(segments) ? segments : [];
    const count = slices.length;
    const step = count > 0 ? 360 / count : 0;
    const target = Number.isInteger(targetIndex) && targetIndex >= 0 && targetIndex < count ? targetIndex : null;
    const spin = Boolean(spinning) && target != null;
    const [rotation, setRotation] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // The live callback, so a caller that passes a fresh closure every render
    // does not re-arm the timer mid-spin.
    const onSettledRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onSettled);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onSettledRef.current = onSettled;
    });
    // The armed settle, shared with `transitionend`; null when no spin is running.
    const settleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (target == null) {
            setRotation(0);
            return;
        }
        // Drop the fraction of a turn the disc is already at, then add whole turns:
        // the rotation only ever grows, so the wheel never runs backwards.
        setRotation((prev)=>prev - prev % 360 + $c173fca63c358943$var$angleFor(target, count));
    }, [
        target,
        count
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!spin) return undefined;
        let fired = false;
        const fire = ()=>{
            if (fired) return;
            fired = true;
            onSettledRef.current?.();
        };
        settleRef.current = fire;
        const timer = setTimeout(fire, $c173fca63c358943$var$prefersReducedMotion() ? $c173fca63c358943$var$REDUCED_SETTLE_MS : $c173fca63c358943$var$SPIN_MS + $c173fca63c358943$var$SETTLE_GRACE_MS);
        return ()=>{
            clearTimeout(timer);
            settleRef.current = null;
        };
    }, [
        spin,
        target
    ]);
    // Under two slices there is no wheel to draw — the arc flag below describes a
    // minor arc, and a single slice has no arc at all. Nothing is drawn rather
    // than something misleading, as `Sparkline` does with a single point.
    if (count < 2) return null;
    const paths = [];
    const labels = [];
    for(let i = 0; i < count; i += 1){
        const from = i * step - 90;
        const to = from + step;
        const mid = from + step / 2;
        const [x0, y0] = $c173fca63c358943$var$pol(from, $c173fca63c358943$var$R_SLICE);
        const [x1, y1] = $c173fca63c358943$var$pol(to, $c173fca63c358943$var$R_SLICE);
        const [lx, ly] = $c173fca63c358943$var$pol(mid, $c173fca63c358943$var$R_LABEL);
        // Through the bottom half of the wheel a label rotated onto its slice reads
        // upside down; turning it over keeps every label the right way up.
        const upright = mid > 90 && mid < 270 ? mid + 180 : mid;
        paths.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            key: `slice-${i}`,
            d: `M${$c173fca63c358943$var$CX},${$c173fca63c358943$var$CY} L${x0.toFixed(2)},${y0.toFixed(2)} A${$c173fca63c358943$var$R_SLICE},${$c173fca63c358943$var$R_SLICE} 0 0 1 ${x1.toFixed(2)},${y1.toFixed(2)} Z`,
            fill: $c173fca63c358943$var$FILLS[i % $c173fca63c358943$var$FILLS.length],
            stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            strokeWidth: 3
        }));
        labels.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: `label-${i}`,
            transform: `translate(${lx.toFixed(2)} ${ly.toFixed(2)}) rotate(${upright.toFixed(2)})`,
            fill: $c173fca63c358943$var$INKS[i % $c173fca63c358943$var$INKS.length],
            fontSize: 17,
            fontWeight: 700,
            textAnchor: "middle",
            dominantBaseline: "middle"
        }, slices[i]?.label));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c173fca63c358943$var$Styles, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 400 400",
        // The pointer sits above the disc, outside the box.
        style: {
            display: 'block',
            overflow: 'visible',
            maxWidth: '100%',
            height: 'auto',
            ...style
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        role: "img",
        "aria-label": label,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_RIM,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "data-prize-disc": "",
        "data-spinning": spin ? 'true' : 'false',
        style: {
            transform: `rotate(${rotation}deg)`
        },
        onTransitionEnd: (e)=>{
            if (e.propertyName === 'transform') settleRef.current?.();
        }
    }, paths, labels), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_HUB_INNER,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: $c173fca63c358943$var$CX,
        cy: $c173fca63c358943$var$CY,
        r: $c173fca63c358943$var$R_PIP,
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M182,-2 L218,-2 L200,34 Z",
        fill: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        stroke: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        strokeWidth: 3,
        strokeLinejoin: "round"
    })));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5401c97ba566f60e$export$a2387ed3b5d536eb = {
    name: "camera",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
                key: "18u6gg"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "13",
                r: "3",
                key: "1vg3eu"
            }
        ]
    ]
};
$5401c97ba566f60e$export$a2387ed3b5d536eb.node;
const $5401c97ba566f60e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5401c97ba566f60e$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $df9771111904a5d5$export$a2387ed3b5d536eb = {
    name: "file-text",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
                key: "1oefj6"
            }
        ],
        [
            "path",
            {
                d: "M14 2v5a1 1 0 0 0 1 1h5",
                key: "wfsgrz"
            }
        ],
        [
            "path",
            {
                d: "M10 9H8",
                key: "b1mrlr"
            }
        ],
        [
            "path",
            {
                d: "M16 13H8",
                key: "t4e002"
            }
        ],
        [
            "path",
            {
                d: "M16 17H8",
                key: "z1uh3a"
            }
        ]
    ]
};
$df9771111904a5d5$export$a2387ed3b5d536eb.node;
const $df9771111904a5d5$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($df9771111904a5d5$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8745eaf007923a88$export$a2387ed3b5d536eb = {
    name: "folder-open",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
                key: "usdka0"
            }
        ]
    ]
};
$8745eaf007923a88$export$a2387ed3b5d536eb.node;
const $8745eaf007923a88$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($8745eaf007923a88$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $557120626e51c22d$export$a2387ed3b5d536eb = {
    name: "upload",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 3v12",
                key: "1x0j5s"
            }
        ],
        [
            "path",
            {
                d: "m17 8-5-5-5 5",
                key: "7q97r8"
            }
        ],
        [
            "path",
            {
                d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                key: "ih7n3h"
            }
        ]
    ]
};
$557120626e51c22d$export$a2387ed3b5d536eb.node;
const $557120626e51c22d$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($557120626e51c22d$export$a2387ed3b5d536eb);









'use client';
const $ad7c85561d054b68$export$d8640b1e4d69af25 = [
    'queued',
    'preparing',
    'sending',
    'done',
    'failed'
];
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5); a mouse keeps `sm`.
const $ad7c85561d054b68$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $ad7c85561d054b68$var$SIZES = {
    regular: {
        padBlock: '1.75rem',
        icon: 28
    },
    compact: {
        padBlock: '1rem',
        icon: 20
    }
};
// ── accept matching ─────────────────────────────────────────────────────────
function $ad7c85561d054b68$var$acceptTokens(accept) {
    if (!accept) return [];
    const list = Array.isArray(accept) ? accept : String(accept).split(',');
    return list.map((t)=>String(t).trim().toLowerCase()).filter(Boolean);
}
function $ad7c85561d054b68$export$b4699969e89702eb(file, accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    if (tokens.length === 0) return true;
    const name = String(file?.name || '').toLowerCase();
    const type = String(file?.type || '').toLowerCase();
    return tokens.some((token)=>{
        if (token.startsWith('.')) return name.endsWith(token);
        if (token.endsWith('/*')) return type.startsWith(token.slice(0, -1));
        return type === token;
    });
}
// `null`, '' and [] mean "no filter" — and no `accept` attribute on the input.
function $ad7c85561d054b68$var$acceptAttr(accept) {
    const tokens = $ad7c85561d054b68$var$acceptTokens(accept);
    return tokens.length ? tokens.join(',') : undefined;
}
function $ad7c85561d054b68$var$isImage(file) {
    return !!file && typeof file.type === 'string' && file.type.toLowerCase().startsWith('image/');
}
function $ad7c85561d054b68$export$8c95ef2c56e9a241({ name: name, meta: meta, phase: phase = 'queued', progress: progress, progressLabel: progressLabel, error: error, file: file, previewUrl: previewUrl, badge: badge, removable: removable, replaceable: replaceable = false, trailing: trailing, busy: busy = false, disabled: disabled = false, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, phaseLabels: phaseLabels, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, as: Tag = 'li', className: className, 'data-testid': testId, ...rest }) {
    if (removeLabel === undefined) removeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.replace;
    const labels = {
        ...(0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.phases,
        ...phaseLabels
    };
    const phaseLabel = labels[phase] ?? phase;
    // A thumbnail for an image File, created here and revoked when the row
    // leaves or the file changes — a leaked object URL holds the whole blob.
    const [objectUrl, setObjectUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wantsObjectUrl = !previewUrl && !badge && $ad7c85561d054b68$var$isImage(file);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!wantsObjectUrl || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
            setObjectUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setObjectUrl(url);
        return ()=>{
            if (typeof URL.revokeObjectURL === 'function') URL.revokeObjectURL(url);
        };
    }, [
        file,
        wantsObjectUrl
    ]);
    const thumbSrc = previewUrl || (wantsObjectUrl ? objectUrl : null);
    const canRemove = (removable ?? phase !== 'done') && !busy && typeof onRemove === 'function';
    const canRetry = phase === 'failed' && !!file && !busy && typeof onRetry === 'function';
    const canReplace = replaceable && !busy && typeof onReplace === 'function';
    const hasBar = typeof progress === 'number' && Number.isFinite(progress);
    const pct = hasBar ? Math.max(0, Math.min(100, progress)) : 0;
    const phaseColor = phase === 'failed' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk : phase === 'done' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        "data-testid": testId,
        "data-state": phase,
        "aria-live": "polite",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex items-center', className),
        style: {
            gap: '0.625rem',
            paddingBlock: '0.5rem',
            paddingInline: '0.625rem',
            minHeight: '2.75rem',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            minWidth: 0,
            opacity: disabled ? 0.6 : 1
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "flex items-center justify-center overflow-hidden",
        style: {
            flexShrink: 0,
            width: '2.25rem',
            height: '2.25rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            fontSize: '0.625rem',
            fontWeight: 800
        }
    }, badge ? badge : thumbSrc ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: thumbSrc,
        alt: "",
        "data-testid": testId ? `${testId}-thumb` : undefined,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df9771111904a5d5$export$2e2bcd8739ae039), {
        size: 18,
        strokeWidth: 1.5
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex flex-col",
        style: {
            flex: 1,
            minWidth: 0,
            gap: '0.125rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        dir: "auto",
        className: "text-start",
        style: {
            unicodeBidi: 'isolate',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            lineHeight: 1.4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }, name), error ? // Keyed on the text: a CHANGED error remounts and is announced once;
    // an unchanged one re-rendering stays quiet.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        key: String(error),
        role: "alert",
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
            lineHeight: 1.5
        }
    }, error) : meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, meta) : null, hasBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": pct,
        "aria-label": progressLabel || phaseLabel,
        className: "flex",
        style: {
            flex: 1,
            height: '0.25rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "transition-[width] duration-200 motion-reduce:transition-none",
        style: {
            width: `${pct}%`,
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).pill
        }
    })), progressLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "tabular-nums",
        style: {
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, progressLabel) : null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            flexShrink: 0,
            gap: '0.375rem'
        }
    }, trailing, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "flex items-center",
        style: {
            gap: '0.25rem',
            fontSize: '0.6875rem',
            fontWeight: 600,
            color: phaseColor
        }
    }, phase === 'sending' || phase === 'preparing' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        className: "inline-flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 14,
        thickness: 2,
        label: ""
    })) : null, phase === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14,
        strokeWidth: 2,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, phaseLabel)), canReplace ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "ghost",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onReplace,
        disabled: disabled,
        "data-testid": testId ? `${testId}-replace` : undefined
    }, replaceLabel) : null, canRetry ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        type: "button",
        variant: "outline",
        size: "sm",
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        onClick: onRetry,
        disabled: disabled,
        "data-testid": testId ? `${testId}-retry` : undefined
    }, retryLabel) : null, canRemove ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: 40,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true
        }),
        label: removeLabel,
        onClick: onRemove,
        disabled: disabled,
        "data-testid": testId ? `${testId}-remove` : undefined
    }) : null));
}
const $ad7c85561d054b68$export$731398005976572f = $ad7c85561d054b68$export$8c95ef2c56e9a241;
// ─────────────────────────────────────────────────────────────────────────────
// FileDropzone
// ─────────────────────────────────────────────────────────────────────────────
// Every row the zone counts: the flat `files`, or the rows of every group.
function $ad7c85561d054b68$var$rowsOf(groups, files) {
    if (Array.isArray(groups)) return groups.flatMap((g)=>Array.isArray(g?.files) ? g.files : []);
    return Array.isArray(files) ? files : [];
}
function $ad7c85561d054b68$export$2e2bcd8739ae039({ files: filesProp, groups: groups, onFiles: onFiles, onRemove: onRemove, onRetry: onRetry, onReplace: onReplace, accept: accept, multiple: multiple = true, maxFiles: maxFiles, maxBytes: maxBytes, capture: capture, directory: directory = false, extraActions: extraActions, disabled: disabled = false, busy: busy = false, error: error, size: size = 'regular', label: label, required: required, helperText: helperText, dropLabel: dropLabel, pickLabel: pickLabel, cameraLabel: cameraLabel, directoryLabel: directoryLabel, removeLabel: removeLabel, retryLabel: retryLabel, replaceLabel: replaceLabel, phaseLabels: phaseLabels, draggingLabel: draggingLabel, emptyHint: emptyHint, listLabel: listLabel, className: className, style: style, 'data-testid': testId, ...rest }) {
    if (dropLabel === undefined) dropLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.drop;
    if (pickLabel === undefined) pickLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.pick;
    if (cameraLabel === undefined) cameraLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.camera;
    if (directoryLabel === undefined) directoryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.directory;
    if (removeLabel === undefined) removeLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.remove;
    if (retryLabel === undefined) retryLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.retry;
    if (replaceLabel === undefined) replaceLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.replace;
    if (draggingLabel === undefined) draggingLabel = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().files.dragging;
    const S = $ad7c85561d054b68$var$SIZES[size] || $ad7c85561d054b68$var$SIZES.regular;
    const baseId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const zoneId = `${baseId}-zone`;
    const helperId = helperText ? `${baseId}-helper` : undefined;
    const errorId = error ? `${baseId}-error` : undefined;
    const mainRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const cameraRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const directoryRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const replaceTarget = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dragDepth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const [dragging, setDragging] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const files = $ad7c85561d054b68$var$rowsOf(groups, filesProp);
    const warnedBoth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const inert = disabled || busy;
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    // `webkitdirectory` is not a React prop; it has to be an attribute.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = directoryRef.current;
        if (!el) return;
        el.setAttribute('webkitdirectory', '');
        el.setAttribute('directory', '');
    }, [
        directory
    ]);
    // Never lingers in `dragging` if the zone is disabled mid-drag.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (inert) {
            dragDepth.current = 0;
            setDragging(false);
        }
    }, [
        inert
    ]);
    const report = (picked, source)=>{
        const list = Array.from(picked || []);
        // Nothing picked (a cancelled dialog, a drop of text) is not a batch.
        if (list.length === 0) return;
        let room = Infinity;
        if (typeof maxFiles === 'number') room = Math.max(0, maxFiles - files.length);
        if (!multiple) room = Math.min(room, 1);
        const accepted = [];
        const rejected = [];
        for (const f of list){
            if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) rejected.push({
                file: f,
                reason: 'type'
            });
            else if (typeof maxBytes === 'number' && typeof f.size === 'number' && f.size > maxBytes) rejected.push({
                file: f,
                reason: 'size'
            });
            else if (accepted.length >= room) rejected.push({
                file: f,
                reason: 'count'
            });
            else accepted.push(f);
        }
        onFiles?.(accepted, rejected, source);
    };
    const onInputChange = (source)=>(e)=>{
            const picked = e.target.files;
            try {
                report(picked, source);
            } finally{
                // Reset, so picking the same file twice still fires `change`.
                e.target.value = '';
            }
        };
    const onReplaceChange = (e)=>{
        const f = e.target.files?.[0];
        const id = replaceTarget.current;
        e.target.value = '';
        replaceTarget.current = null;
        if (!f || id == null) return;
        // A refused replacement is reported like any refused pick, so the caller
        // has one place that writes the sentence.
        if (!$ad7c85561d054b68$export$b4699969e89702eb(f, accept)) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'type'
                }
            ], 'picker');
            return;
        }
        if (typeof maxBytes === 'number' && f.size > maxBytes) {
            onFiles?.([], [
                {
                    file: f,
                    reason: 'size'
                }
            ], 'picker');
            return;
        }
        onReplace?.(id, f);
    };
    const open = (ref)=>()=>{
            if (inert) return;
            ref.current?.click();
        };
    const hasDragFiles = (e)=>{
        const types = e.dataTransfer?.types;
        if (!types) return true;
        return Array.from(types).includes('Files');
    };
    const onDragEnter = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (inert) return;
        dragDepth.current += 1;
        setDragging(true);
    };
    const onDragOver = (e)=>{
        if (!hasDragFiles(e)) return;
        e.preventDefault();
        if (e.dataTransfer) e.dataTransfer.dropEffect = inert ? 'none' : 'copy';
    };
    const onDragLeave = ()=>{
        if (inert) return;
        // `dragleave` fires on every child boundary; only the last one leaves.
        dragDepth.current = Math.max(0, dragDepth.current - 1);
        if (dragDepth.current === 0) setDragging(false);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        dragDepth.current = 0;
        setDragging(false);
        if (inert) return;
        report(e.dataTransfer?.files, 'drop');
    };
    const state = disabled ? 'disabled' : dragging ? 'dragging' : files.length ? 'has-files' : 'idle';
    const accentOn = dragging && !inert;
    const describedBy = [
        helperId,
        errorId
    ].filter(Boolean).join(' ') || undefined;
    const pickerProps = {
        type: 'button',
        variant: 'outline',
        size: 'sm',
        className: $ad7c85561d054b68$var$TOUCH_TARGET,
        disabled: disabled,
        'aria-disabled': busy || undefined
    };
    const renderRow = (f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ad7c85561d054b68$export$8c95ef2c56e9a241, {
            key: f.id,
            name: f.name,
            meta: f.meta,
            phase: f.phase,
            progress: f.progress,
            progressLabel: f.progressLabel,
            error: f.error,
            file: f.file,
            previewUrl: f.previewUrl,
            badge: f.badge,
            removable: f.removable,
            replaceable: f.replaceable,
            trailing: f.trailing,
            busy: busy,
            disabled: disabled,
            phaseLabels: phaseLabels,
            removeLabel: removeLabel,
            retryLabel: retryLabel,
            replaceLabel: replaceLabel,
            onRemove: onRemove ? ()=>onRemove(f.id) : undefined,
            onRetry: onRetry ? ()=>onRetry(f.id) : undefined,
            onReplace: onReplace ? ()=>{
                if (inert) return;
                replaceTarget.current = f.id;
                replaceRef.current?.click();
            } : undefined,
            "data-testid": testId ? `${testId}-row-${f.id}` : undefined
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        "data-busy": busy || undefined,
        className: className,
        style: style,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $221000a87dfafb8e$export$2e2bcd8739ae039), {
        label: label,
        required: required,
        htmlFor: zoneId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('frame'),
        onDragEnter: onDragEnter,
        onDragOver: onDragOver,
        onDragLeave: onDragLeave,
        onDrop: onDrop,
        className: "flex flex-col items-center",
        style: {
            gap: '0.625rem',
            paddingBlock: S.padBlock,
            paddingInline: '1rem',
            borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
            border: `1.5px dashed ${accentOn ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: accentOn ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.06) : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
            opacity: disabled ? 0.55 : 1,
            cursor: disabled ? 'not-allowed' : undefined,
            transition: 'border-color 0.15s, background 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        id: zoneId,
        type: "button",
        "data-testid": tid('zone'),
        onClick: open(mainRef),
        disabled: disabled,
        "aria-disabled": busy || undefined,
        "aria-describedby": describedBy,
        className: "flex w-full flex-col items-center text-center outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md",
        style: {
            gap: '0.375rem',
            background: 'transparent',
            border: 'none',
            padding: '0.25rem',
            cursor: inert ? disabled ? 'not-allowed' : 'default' : 'pointer',
            font: 'inherit',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $557120626e51c22d$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: S.icon,
        strokeWidth: 1.5,
        color: accentOn ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.8125rem',
            fontWeight: 600
        }
    }, accentOn ? draggingLabel : dropLabel), emptyHint && files.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        }
    }, emptyHint) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "flex flex-wrap items-center justify-center",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(mainRef),
        "data-testid": tid('pick')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $557120626e51c22d$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), pickLabel), capture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(cameraRef),
        "data-testid": tid('camera-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5401c97ba566f60e$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), cameraLabel) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ...pickerProps,
        onClick: open(directoryRef),
        "data-testid": tid('directory-button')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8745eaf007923a88$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        size: 14
    }), directoryLabel) : null, typeof extraActions === 'function' ? extraActions({
        openPicker: open(mainRef),
        openCamera: capture ? open(cameraRef) : undefined,
        openDirectory: directory ? open(directoryRef) : undefined,
        labels: {
            pick: pickLabel,
            camera: cameraLabel,
            directory: directoryLabel
        },
        disabled: inert
    }) : extraActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: mainRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": pickLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        multiple: multiple,
        disabled: disabled,
        onChange: onInputChange('picker'),
        "data-testid": tid('input')
    }), capture ? // A SEPARATE input: `capture` on the main one makes iOS skip the
    // gallery entirely.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: cameraRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": cameraLabel,
        accept: "image/*",
        capture: capture,
        disabled: disabled,
        onChange: onInputChange('camera'),
        "data-testid": tid('camera')
    }) : null, directory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: directoryRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": directoryLabel,
        multiple: true,
        disabled: disabled,
        onChange: onInputChange('directory'),
        "data-testid": tid('directory')
    }) : null, typeof onReplace === 'function' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        ref: replaceRef,
        type: "file",
        className: "sr-only",
        tabIndex: -1,
        "aria-label": replaceLabel,
        accept: $ad7c85561d054b68$var$acceptAttr(accept),
        disabled: disabled,
        onChange: onReplaceChange,
        "data-testid": tid('replace-input')
    }) : null), helperText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: helperId,
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, helperText) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: errorId,
        key: String(error),
        role: "alert",
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
            fontWeight: 500,
            lineHeight: 1.5
        }
    }, error) : null, Array.isArray(groups) ? groups.map((g)=>{
        const rows = Array.isArray(g.files) ? g.files : [];
        const headingId = `${baseId}-group-${g.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
            key: g.id,
            "aria-labelledby": headingId,
            "data-testid": tid(`group-${g.id}`),
            "data-state": rows.length ? 'has-files' : 'empty',
            className: "flex flex-col",
            style: {
                gap: '0.375rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex items-baseline",
            style: {
                gap: '0.5rem',
                minWidth: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            id: headingId,
            style: {
                fontSize: '0.75rem',
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                lineHeight: 1.5
            }
        }, g.title), g.meta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.6875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                lineHeight: 1.5
            }
        }, g.meta) : null), rows.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            "aria-labelledby": headingId,
            className: "m-0 flex list-none flex-col p-0",
            style: {
                gap: '0.375rem'
            }
        }, rows.map(renderRow)) : g.emptyText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
            className: "m-0",
            style: {
                fontSize: '0.71875rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                lineHeight: 1.5
            }
        }, g.emptyText) : null);
    }) : files.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        "aria-label": listLabel || (typeof label === 'string' ? label : undefined),
        className: "m-0 flex list-none flex-col p-0",
        style: {
            gap: '0.375rem'
        }
    }, files.map(renderRow)) : null)));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c96e72789512f0bb$export$a2387ed3b5d536eb = {
    name: "maximize",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 3H5a2 2 0 0 0-2 2v3",
                key: "1dcmit"
            }
        ],
        [
            "path",
            {
                d: "M21 8V5a2 2 0 0 0-2-2h-3",
                key: "1e4gt3"
            }
        ],
        [
            "path",
            {
                d: "M3 16v3a2 2 0 0 0 2 2h3",
                key: "wsl5sc"
            }
        ],
        [
            "path",
            {
                d: "M16 21h3a2 2 0 0 0 2-2v-3",
                key: "18trek"
            }
        ]
    ]
};
$c96e72789512f0bb$export$a2387ed3b5d536eb.node;
const $c96e72789512f0bb$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($c96e72789512f0bb$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $191016e022d4d457$export$a2387ed3b5d536eb = {
    name: "zoom-in",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "line",
            {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65",
                key: "13gj7c"
            }
        ],
        [
            "line",
            {
                x1: "11",
                x2: "11",
                y1: "8",
                y2: "14",
                key: "1vmskp"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11",
                key: "durymu"
            }
        ]
    ]
};
$191016e022d4d457$export$a2387ed3b5d536eb.node;
const $191016e022d4d457$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($191016e022d4d457$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a481aded68921702$export$a2387ed3b5d536eb = {
    name: "zoom-out",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "11",
                cy: "11",
                r: "8",
                key: "4ej97u"
            }
        ],
        [
            "line",
            {
                x1: "21",
                x2: "16.65",
                y1: "21",
                y2: "16.65",
                key: "13gj7c"
            }
        ],
        [
            "line",
            {
                x1: "8",
                x2: "14",
                y1: "11",
                y2: "11",
                key: "durymu"
            }
        ]
    ]
};
$a481aded68921702$export$a2387ed3b5d536eb.node;
const $a481aded68921702$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($a481aded68921702$export$a2387ed3b5d536eb);













'use client';
function $cb5da664f84994ea$export$bb0048c9149cbdb(locale) {
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).imageStack;
    const { digits: digits } = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale);
    return {
        ...copy,
        frame: (i, n)=>copy.frame((0, $0873d4f32691c14e$export$545c62727d3740ae)(i, digits), (0, $0873d4f32691c14e$export$545c62727d3740ae)(n, digits))
    };
}
const $cb5da664f84994ea$export$eb119caddc05b7a2 = $cb5da664f84994ea$export$bb0048c9149cbdb('fa');
const $cb5da664f84994ea$var$MIN_ZOOM = 1;
const $cb5da664f84994ea$var$MAX_ZOOM = 8;
const $cb5da664f84994ea$var$ZOOM_STEP = 1.25;
// Pixels of wheel delta / finger travel per frame. Interaction thresholds,
// not layout — they never reach a style.
const $cb5da664f84994ea$var$WHEEL_PER_FRAME = 60;
const $cb5da664f84994ea$var$SWIPE_PER_FRAME = 24;
const $cb5da664f84994ea$var$DOUBLE_TAP_MS = 300;
// ≥ 2.75rem on a coarse pointer (MOBILE_WEB_PWA §5).
const $cb5da664f84994ea$var$TOUCH_TARGET = '[@media(pointer:coarse)]:min-h-[2.75rem]';
const $cb5da664f84994ea$var$clamp = (v, lo, hi)=>Math.max(lo, Math.min(hi, v));
function $cb5da664f84994ea$export$2e2bcd8739ae039({ frameCount: frameCount = 0, index: indexProp, defaultIndex: defaultIndex = 0, onIndexChange: onIndexChange, loadFrame: loadFrame, revokeFrame: revokeFrame, preloadRadius: preloadRadius = 5, sourceKey: sourceKey, series: series, activeSeriesId: activeSeriesId, onSeriesChange: onSeriesChange, presets: presets, activePresetId: activePresetId, onPresetChange: onPresetChange, caption: caption, banner: banner, loading: loading = false, error: error, onRetry: onRetry, labels: labelsProp, className: className, style: style, 'data-testid': testId, ...rest }) {
    const labels = {
        ...$cb5da664f84994ea$export$bb0048c9149cbdb(),
        ...labelsProp
    };
    const tid = (suffix)=>testId ? `${testId}-${suffix}` : undefined;
    const n = Math.max(0, Math.floor(Number(frameCount) || 0));
    // ── index: controlled when `index` is given, otherwise internal ───────────
    const [innerIndex, setInnerIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultIndex);
    const controlled = indexProp !== undefined && indexProp !== null;
    const index = n ? $cb5da664f84994ea$var$clamp(Math.floor(controlled ? indexProp : innerIndex) || 0, 0, n - 1) : 0;
    const indexRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(index);
    indexRef.current = index;
    const go = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (!n) return;
        const target = $cb5da664f84994ea$var$clamp(Math.round(next), 0, n - 1);
        if (target === indexRef.current) return;
        if (!controlled) setInnerIndex(target);
        onIndexChange?.(target);
    }, [
        n,
        controlled,
        onIndexChange
    ]);
    // ── frame cache ───────────────────────────────────────────────────────────
    const loadRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(loadFrame);
    loadRef.current = loadFrame;
    const revokeRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(revokeFrame);
    revokeRef.current = revokeFrame;
    const cache = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → url
    const pending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map()); // i → AbortController
    const failed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Set()); // i
    const shownRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null); // url on screen
    const [, bump] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer((x)=>x + 1, 0);
    const [shownUrl, setShownUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [, setRetryTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const release = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((url)=>{
        if (!url || url === shownRef.current) return;
        revokeRef.current?.(url);
    }, []);
    const source = `${activeSeriesId ?? ''}|${activePresetId ?? ''}|${n}|${sourceKey ?? ''}`;
    const sourceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(source);
    // A new source: cancel everything in flight and forget every frame. The
    // shown image stays up (under a spinner) until its replacement arrives.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (sourceRef.current === source) return;
        sourceRef.current = source;
        for (const ctrl of pending.current.values())ctrl.abort();
        pending.current.clear();
        for (const url of cache.current.values())release(url);
        cache.current.clear();
        failed.current.clear();
        bump();
    }, [
        source,
        release
    ]);
    // Load the current frame and its neighbours; evict what fell out.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!n || typeof loadRef.current !== 'function' || loading || error) return;
        const lo = Math.max(0, index - preloadRadius);
        const hi = Math.min(n - 1, index + preloadRadius);
        for (const [i, ctrl] of pending.current)if (i < lo || i > hi) {
            ctrl.abort();
            pending.current.delete(i);
        }
        for (const [i, url] of cache.current)if (i < lo || i > hi) {
            cache.current.delete(i);
            release(url);
        }
        for (const i of failed.current)if (i < lo || i > hi) failed.current.delete(i);
        // Current frame first, then outward: ±1, ±2, …
        const order = [
            index
        ];
        for(let d = 1; d <= preloadRadius; d += 1){
            if (index + d <= hi) order.push(index + d);
            if (index - d >= lo) order.push(index - d);
        }
        const mySource = sourceRef.current;
        for (const i of order){
            if (cache.current.has(i) || pending.current.has(i) || failed.current.has(i)) continue;
            const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : {
                abort () {},
                signal: undefined
            };
            pending.current.set(i, ctrl);
            let p;
            try {
                p = Promise.resolve(loadRef.current(i, {
                    signal: ctrl.signal
                }));
            } catch (e) {
                p = Promise.reject(e);
            }
            p.then((url)=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) {
                    if (url) revokeRef.current?.(url);
                    return;
                }
                pending.current.delete(i);
                cache.current.set(i, url);
                bump();
            }, ()=>{
                const stale = ctrl.signal?.aborted || sourceRef.current !== mySource || pending.current.get(i) !== ctrl;
                if (stale) return;
                pending.current.delete(i);
                failed.current.add(i);
                bump();
            });
        }
    });
    // Show the current frame as soon as it is cached; revoke what it replaced.
    const currentUrl = cache.current.get(index) ?? null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!currentUrl || currentUrl === shownRef.current) return;
        const previous = shownRef.current;
        shownRef.current = currentUrl;
        setShownUrl(currentUrl);
        if (previous && ![
            ...cache.current.values()
        ].includes(previous)) revokeRef.current?.(previous);
    }, [
        currentUrl
    ]);
    // Unmount: cancel, and hand back every URL still held.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>()=>{
            for (const ctrl of pending.current.values())ctrl.abort();
            pending.current.clear();
            const urls = new Set([
                ...cache.current.values(),
                shownRef.current
            ].filter(Boolean));
            cache.current.clear();
            shownRef.current = null;
            for (const url of urls)revokeRef.current?.(url);
        }, []);
    const retryFrame = ()=>{
        failed.current.delete(index);
        setRetryTick((t)=>t + 1);
    };
    const frameState = failed.current.has(index) ? 'error' : currentUrl ? 'ready' : 'loading';
    // ── zoom & pan ────────────────────────────────────────────────────────────
    const [zoom, setZoom] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(1);
    const [pan, setPan] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const stageRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const clampPan = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((p, z)=>{
        const rect = stageRef.current?.getBoundingClientRect?.();
        if (!rect || !rect.width || !rect.height) return z <= 1 ? {
            x: 0,
            y: 0
        } : p;
        const mx = (z - 1) * rect.width / 2;
        const my = (z - 1) * rect.height / 2;
        return {
            x: $cb5da664f84994ea$var$clamp(p.x, -mx, mx),
            y: $cb5da664f84994ea$var$clamp(p.y, -my, my)
        };
    }, []);
    const zoomTo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((z)=>{
        const next = $cb5da664f84994ea$var$clamp(z, $cb5da664f84994ea$var$MIN_ZOOM, $cb5da664f84994ea$var$MAX_ZOOM);
        setZoom(next);
        setPan((p)=>next <= 1 ? {
                x: 0,
                y: 0
            } : clampPan(p, next));
    }, [
        clampPan
    ]);
    const resetView = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setZoom(1);
        setPan({
            x: 0,
            y: 0
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        resetView();
    }, [
        activeSeriesId,
        resetView
    ]);
    // Latest values for the native listeners below.
    const live = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    live.current = {
        zoom: zoom,
        go: go,
        index: index,
        zoomTo: zoomTo
    };
    // Wheel needs a non-passive listener to keep the page from scrolling.
    const wheelAcc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = stageRef.current;
        if (!el) return undefined;
        const onWheel = (e)=>{
            e.preventDefault();
            const L = live.current;
            if (e.ctrlKey || e.metaKey) {
                L.zoomTo(L.zoom * (e.deltaY < 0 ? $cb5da664f84994ea$var$ZOOM_STEP : 1 / $cb5da664f84994ea$var$ZOOM_STEP));
                return;
            }
            // Line/page deltas (a notched mouse on some platforms) step one frame
            // per event; pixel deltas (trackpads) accumulate.
            if (e.deltaMode !== 0) {
                wheelAcc.current = 0;
                if (e.deltaY) L.go(L.index + Math.sign(e.deltaY));
                return;
            }
            wheelAcc.current += e.deltaY;
            const steps = Math.trunc(wheelAcc.current / $cb5da664f84994ea$var$WHEEL_PER_FRAME);
            if (steps) {
                wheelAcc.current -= steps * $cb5da664f84994ea$var$WHEEL_PER_FRAME;
                L.go(L.index + steps);
            }
        };
        el.addEventListener('wheel', onWheel, {
            passive: false
        });
        return ()=>el.removeEventListener('wheel', onWheel);
    });
    // Pointers: one finger pans (zoomed) or swipes frames (not zoomed); two pinch.
    const pointers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(new Map());
    const gesture = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const lastTap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const onPointerDown = (e)=>{
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        try {
            e.currentTarget.setPointerCapture?.(e.pointerId);
        } catch  {}
        const pts = [
            ...pointers.current.values()
        ];
        if (pts.length === 2) gesture.current = {
            kind: 'pinch',
            dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) || 1,
            zoom: zoom
        };
        else if (pts.length === 1) gesture.current = zoom > 1 ? {
            kind: 'pan',
            x: e.clientX,
            y: e.clientY,
            pan: pan
        } : {
            kind: 'swipe',
            y: e.clientY,
            index: index
        };
    };
    const onPointerMove = (e)=>{
        if (!pointers.current.has(e.pointerId)) return;
        pointers.current.set(e.pointerId, {
            x: e.clientX,
            y: e.clientY
        });
        const g = gesture.current;
        if (!g) return;
        if (g.kind === 'pinch') {
            const pts = [
                ...pointers.current.values()
            ];
            if (pts.length < 2) return;
            const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
            zoomTo(g.zoom * (dist / g.dist));
        } else if (g.kind === 'pan') setPan(clampPan({
            x: g.pan.x + (e.clientX - g.x),
            y: g.pan.y + (e.clientY - g.y)
        }, zoom));
        else if (g.kind === 'swipe') {
            // Finger up = next frame, like scrolling a page of film.
            const steps = Math.trunc((g.y - e.clientY) / $cb5da664f84994ea$var$SWIPE_PER_FRAME);
            go(g.index + steps);
        }
    };
    const onPointerUp = (e)=>{
        pointers.current.delete(e.pointerId);
        if (pointers.current.size === 0) {
            if (e.pointerType === 'touch') {
                const now = Date.now();
                if (now - lastTap.current < $cb5da664f84994ea$var$DOUBLE_TAP_MS) {
                    resetView();
                    lastTap.current = 0;
                } else lastTap.current = now;
            }
            gesture.current = null;
        } else if (pointers.current.size === 1) {
            const [pt] = [
                ...pointers.current.values()
            ];
            gesture.current = zoom > 1 ? {
                kind: 'pan',
                x: pt.x,
                y: pt.y,
                pan: pan
            } : null;
        }
    };
    const onKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowUp':
            case 'PageUp':
                go(index - 1);
                break;
            case 'ArrowDown':
            case 'PageDown':
                go(index + 1);
                break;
            case 'Home':
                go(0);
                break;
            case 'End':
                go(n - 1);
                break;
            case '+':
            case '=':
                zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '-':
            case '_':
                zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP);
                break;
            case '0':
                resetView();
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    // ── states ────────────────────────────────────────────────────────────────
    const state = loading ? 'loading' : error ? 'error' : n === 0 ? 'empty' : 'content';
    const frameText = n ? labels.frame(index + 1, n) : '';
    const canvasStyle = {
        position: 'relative',
        width: '100%',
        aspectRatio: '1 / 1',
        maxHeight: '70dvh',
        maxWidth: '100%',
        borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink,
        overflow: 'hidden'
    };
    const seriesStrip = Array.isArray(series) && series.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "group",
        "aria-label": labels.series,
        "data-testid": tid('series'),
        className: "flex",
        style: {
            gap: '0.5rem',
            overflowX: 'auto',
            paddingBlock: '0.125rem',
            scrollbarWidth: 'thin'
        }
    }, series.map((s)=>{
        const active = s.id === activeSeriesId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: s.id,
            type: "button",
            "aria-pressed": active,
            "data-state": active ? 'active' : 'inactive',
            "data-testid": tid(`series-${s.id}`),
            onClick: ()=>{
                if (!active) onSeriesChange?.(s.id);
            },
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('inline-flex items-center outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flexShrink: 0,
                gap: '0.375rem',
                minHeight: '2.25rem',
                paddingInline: '0.75rem',
                paddingBlock: '0.25rem',
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control,
                border: `1px solid ${active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                background: active ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.1) : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                color: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                font: 'inherit',
                fontSize: '0.75rem',
                fontWeight: 600,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            dir: "auto",
            style: {
                unicodeBidi: 'isolate'
            }
        }, s.label), s.badge != null && s.badge !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                fontSize: '0.625rem',
                fontWeight: 700,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                borderRadius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).chip,
                paddingInline: '0.3125rem'
            }
        }, s.badge) : null);
    })) : null;
    const presetControl = Array.isArray(presets) && presets.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": tid('presets'),
        style: {
            maxWidth: '100%',
            overflowX: 'auto'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
        semantics: "filter",
        size: "lg",
        ariaLabel: labels.presets,
        options: presets.map((p)=>({
                value: p.id,
                label: p.label
            })),
        value: activePresetId,
        onChange: (id)=>{
            if (id !== activePresetId) onPresetChange?.(id);
        }
    })) : null;
    let body;
    if (state === 'loading') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: labels.loading,
        "data-testid": tid('loading'),
        className: "flex flex-col",
        style: {
            gap: '0.5rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
        height: "auto",
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).card,
        style: {
            ...canvasStyle,
            background: undefined
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
        height: "2.75rem",
        radius: (0, $e7c165fb515b04ea$export$2d2c9be8b5b863f).control
    }));
    else if (state === 'error') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        "data-testid": tid('error'),
        title: typeof error === 'string' ? error : labels.error,
        onRetry: onRetry,
        retryLabel: labels.retry
    });
    else if (state === 'empty') body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
        "data-testid": tid('empty'),
        title: labels.empty
    });
    else {
        const transform = `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`;
        body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: stageRef,
            role: "img",
            "aria-roledescription": labels.viewport,
            "aria-label": frameText,
            tabIndex: 0,
            "data-testid": tid('stage'),
            "data-frame-state": frameState,
            "data-zoom": String(Math.round(zoom * 100) / 100),
            onKeyDown: onKeyDown,
            onPointerDown: onPointerDown,
            onPointerMove: onPointerMove,
            onPointerUp: onPointerUp,
            onPointerCancel: onPointerUp,
            onDoubleClick: resetView,
            className: "outline-none focus-visible:ring-2 focus-visible:ring-ring",
            style: {
                ...canvasStyle,
                touchAction: 'none',
                userSelect: 'none',
                cursor: zoom > 1 ? 'grab' : 'ns-resize'
            }
        }, shownUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: shownUrl,
            alt: "",
            draggable: false,
            "data-testid": tid('image'),
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                transform: transform,
                transformOrigin: 'center',
                opacity: frameState === 'ready' ? 1 : 0.6,
                pointerEvents: 'none'
            }
        }) : frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c90190398471f24a$export$8f31e4c4a37b8e9c), {
            tone: "onDark",
            width: "100%",
            height: "100%",
            radius: 0,
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0
            }
        }) : null, frameState === 'loading' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "data-testid": tid('frame-loading'),
            className: "flex items-center justify-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
            size: 28,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            label: labels.loading
        })) : null, frameState === 'error' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            "data-testid": tid('frame-error'),
            className: "flex flex-col items-center justify-center text-center",
            style: {
                position: 'absolute',
                insetBlock: 0,
                insetInline: 0,
                gap: '0.75rem',
                paddingInline: '1rem',
                background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink, 0.7),
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            role: "alert",
            style: {
                fontSize: '0.8125rem',
                fontWeight: 600
            }
        }, labels.error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            type: "button",
            variant: "outline",
            size: "sm",
            className: $cb5da664f84994ea$var$TOUCH_TARGET,
            onClick: retryFrame,
            "data-testid": tid('frame-retry')
        }, labels.retry)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "flex flex-wrap items-center",
            style: {
                gap: '0.5rem'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7f8899ae39ae38a1$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.prev,
            onClick: ()=>go(index - 1),
            disabled: index <= 0,
            "data-testid": tid('prev')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "range",
            min: 0,
            max: Math.max(0, n - 1),
            step: 1,
            value: index,
            "aria-label": labels.slider,
            "aria-valuetext": frameText,
            onChange: (e)=>go(Number(e.target.value)),
            disabled: n <= 1,
            "data-testid": tid('slider'),
            className: (0, $42e05640dae453c1$export$1343a74baacb0543)('outline-none focus-visible:ring-2 focus-visible:ring-ring', $cb5da664f84994ea$var$TOUCH_TARGET),
            style: {
                flex: '1 1 8rem',
                minWidth: 0,
                minHeight: '2.25rem',
                accentColor: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "outline",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.next,
            onClick: ()=>go(index + 1),
            disabled: index >= n - 1,
            "data-testid": tid('next')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-live": "polite",
            "aria-atomic": "true",
            "data-testid": tid('counter'),
            className: "tabular-nums",
            style: {
                fontSize: '0.75rem',
                fontWeight: 600,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                whiteSpace: 'nowrap'
            }
        }, frameText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "flex items-center",
            style: {
                gap: '0.25rem',
                marginInlineStart: 'auto'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a481aded68921702$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomOut,
            onClick: ()=>zoomTo(zoom / $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom <= $cb5da664f84994ea$var$MIN_ZOOM,
            "data-testid": tid('zoom-out')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $191016e022d4d457$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.zoomIn,
            onClick: ()=>zoomTo(zoom * $cb5da664f84994ea$var$ZOOM_STEP),
            disabled: zoom >= $cb5da664f84994ea$var$MAX_ZOOM,
            "data-testid": tid('zoom-in')
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
            variant: "ghost",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c96e72789512f0bb$export$2e2bcd8739ae039), {
                size: 18,
                "aria-hidden": true
            }),
            label: labels.reset,
            onClick: resetView,
            disabled: zoom === 1 && pan.x === 0 && pan.y === 0,
            "data-testid": tid('reset')
        }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "data-testid": testId,
        "data-state": state,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('flex flex-col', className),
        style: {
            gap: '0.625rem',
            minWidth: 0,
            ...style
        },
        ...rest
    }, banner, state !== 'loading' ? seriesStrip : null, state !== 'loading' ? presetControl : null, body, caption ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "m-0",
        style: {
            fontSize: '0.71875rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            lineHeight: 1.5
        }
    }, caption) : null);
}



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// FilterChip — one toggleable filter in a chip row (category, type, status).
//
// Distinct from `ChipSelector`, which is a *form field* (label, validation,
// helper text, a value the user submits). This is a **view filter**: it narrows
// what a list shows, lives in a toolbar rather than a form, and reports its
// state through `aria-pressed` — the correct semantics for a toggle button, and
// the reason the two are not one component.
//
// Sized for touch by default (`min-h-11` = 2.75rem), because the phone is where
// chip rows are used most and a sub-44px target is a defect there. `count` is a
// node, not a number, so the caller formats digits in its own locale.
// ─────────────────────────────────────────────────────────────────────────────
const $4f5f0e3d96e18162$var$FilterChip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ label: label, count: count, active: active = false, onClick: onClick, disabled: disabled, className: className, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        ref: ref,
        type: "button",
        variant: active ? 'subtle' : 'outline',
        size: "sm",
        "aria-pressed": active,
        disabled: disabled,
        onClick: onClick,
        "data-state": active ? 'active' : 'inactive',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)('min-h-11 shrink-0 rounded-full gap-1', className),
        ...rest
    }, label ?? children, count != null && count !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "text-[0.625rem] opacity-70"
    }, "(", count, ")")));
$4f5f0e3d96e18162$var$FilterChip.displayName = 'FilterChip';
var $4f5f0e3d96e18162$export$2e2bcd8739ae039 = $4f5f0e3d96e18162$var$FilterChip;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// Sparkline — an inline, axis-less trend glyph for a short numeric series.
//
// The smallest data-viz unit in the system: it rides inside a row or a tile to
// answer «is this going up or down?» without spending a chart's worth of space.
// It is deliberately unlabelled — the row already carries the name, the value
// and the unit, and the glyph only has to show shape.
//
// Tones resolve from the token set, so a sparkline never invents a colour:
// `accent` for an in-range series, `danger`/`warn` when the caller has already
// judged the latest reading out of range.
//
// Empty appearance (by design): fewer than two numeric points cannot describe a
// trend, so the glyph renders nothing at all rather than a misleading flat line.
// ─────────────────────────────────────────────────────────────────────────────
const $91c948f90369c6a3$var$TONES = {
    accent: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
    danger: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger,
    warn: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    good: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good,
    mute: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
};
const $91c948f90369c6a3$var$Sparkline = ({ points: points = [], width: width = 72, height: height = 26, tone: tone = 'accent', strokeWidth: strokeWidth = 1.5, showLast: showLast = true, className: className, style: style, ...rest })=>{
    const vals = (points || []).map((p)=>typeof p === 'number' ? p : parseFloat(p)).filter((v)=>!Number.isNaN(v));
    if (vals.length < 2) return null;
    const min = Math.min(...vals);
    const max = Math.max(...vals);
    // A flat series would divide by zero; pad it so the line sits mid-height.
    const pad = (max - min) * 0.15 || 1;
    const lo = min - pad;
    const hi = max + pad;
    const xOf = (i)=>i / (vals.length - 1) * width;
    const yOf = (v)=>height - (v - lo) / (hi - lo) * height;
    const path = vals.map((v, i)=>`${xOf(i).toFixed(1)},${yOf(v).toFixed(1)}`).join(' ');
    const stroke = $91c948f90369c6a3$var$TONES[tone] || $91c948f90369c6a3$var$TONES.accent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        // Time always reads left→right, including on an RTL page.
        style: {
            direction: 'ltr',
            overflow: 'visible',
            display: 'block',
            flexShrink: 0,
            ...style
        },
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "aria-hidden": true,
        focusable: "false",
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), showLast && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: xOf(vals.length - 1),
        cy: yOf(vals[vals.length - 1]),
        r: "2.5",
        fill: stroke
    }));
};
var $91c948f90369c6a3$export$2e2bcd8739ae039 = $91c948f90369c6a3$var$Sparkline;



var $acw62 = parcelRequire("acw62");


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TrendChart — the full-size counterpart to `Sparkline`: one numeric series over
// time, with an optional reference band and per-point status.
//
// It is the system's answer to «show me this measurement's history» — a lab
// analyte, a vital sign, a wallet balance, a clinic's daily revenue. It stays
// presentational: the caller normalises its data to `readings` and decides what
// «abnormal» means; the chart only draws.
//
//   readings   [{ value, date?, status? }]  — chronological, oldest first
//   refLow/refHigh                          — optional reference band + guides
//   formatX(reading, index)                 — axis label; the caller owns the
//                                             locale (Jalali dates, digits…)
//   formatValue(v)                          — value-axis label; same reason —
//                                             digits follow the UI locale, and
//                                             only the app knows what that is
//   emptyLabel                              — copy for the not-enough-data state;
//                                             omitted ⇒ silent blank of the same
//                                             height, so layout never jumps
//
// Status → colour uses the semantic tokens and accepts either casing, because
// clinical back-ends disagree about it (`ABNORMAL` vs `abnormal`).
// ─────────────────────────────────────────────────────────────────────────────
const $b7b57ad44712e2b0$var$STATUS_TONE = {
    abnormal: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    ABNORMAL: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
    critical: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger,
    CRITICAL: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger
};
const $b7b57ad44712e2b0$var$VIEWBOX_W = 520;
const $b7b57ad44712e2b0$var$PAD = {
    t: 12,
    r: 16,
    b: 36,
    l: 46
};
const $b7b57ad44712e2b0$var$TrendChart = ({ readings: readings = [], color: color = (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, refLow: refLow, refHigh: refHigh, height: height = 160, gridLines: gridLines = 4, formatX: formatX, formatValue: formatValue = (v)=>v.toFixed(1), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const numeric = (readings || []).map((r)=>({
            ...r,
            num: typeof r?.value === 'number' ? r.value : parseFloat(r?.value)
        }));
    const plottable = numeric.filter((r)=>!Number.isNaN(r.num));
    if (plottable.length < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    const nums = plottable.map((r)=>r.num);
    const dataMin = Math.min(...nums);
    const dataMax = Math.max(...nums);
    const span = dataMax - dataMin;
    // Include the reference band in the visible window, then breathe by 15% (or a
    // flat ±2 when every reading is identical and the span is 0).
    const lo = Math.min(dataMin, refLow ?? dataMin) - (span * 0.15 || 2);
    const hi = Math.max(dataMax, refHigh ?? dataMax) + (span * 0.15 || 2);
    const range = hi - lo || 1;
    const H = height;
    const cw = $b7b57ad44712e2b0$var$VIEWBOX_W - $b7b57ad44712e2b0$var$PAD.l - $b7b57ad44712e2b0$var$PAD.r;
    const ch = H - $b7b57ad44712e2b0$var$PAD.t - $b7b57ad44712e2b0$var$PAD.b;
    const xOf = (i)=>$b7b57ad44712e2b0$var$PAD.l + i / (plottable.length - 1) * cw;
    const yOf = (v)=>$b7b57ad44712e2b0$var$PAD.t + ch - (v - lo) / range * ch;
    const path = plottable.map((r, i)=>`${xOf(i).toFixed(1)},${yOf(r.num).toFixed(1)}`).join(' ');
    const xStep = Math.max(1, Math.floor(plottable.length / 5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${$b7b57ad44712e2b0$var$VIEWBOX_W} ${H}`,
        // Decorative by contract: every screen that plots a series also lists the
        // readings, and the list is the accessible equivalent (§12).
        "aria-hidden": true,
        focusable: "false",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "content",
        // A time axis reads left→right regardless of the page's direction.
        style: {
            width: '100%',
            height: H,
            display: 'block',
            overflow: 'visible',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: $b7b57ad44712e2b0$var$PAD.l,
        y: yOf(refHigh),
        width: cw,
        height: Math.abs(yOf(refLow) - yOf(refHigh)),
        fill: (0, $e7c165fb515b04ea$export$7bce9182245b1545)(color, 0.08),
        rx: "2"
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = yOf(v);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: $b7b57ad44712e2b0$var$PAD.l,
            x2: $b7b57ad44712e2b0$var$PAD.l + cw,
            y1: y,
            y2: y,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: $b7b57ad44712e2b0$var$PAD.l - 5,
            y: y + 4,
            textAnchor: "end",
            fontSize: "10",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
        points: path,
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }), plottable.map((r, i)=>{
        const cx = xOf(i);
        const cy = yOf(r.num);
        const dot = $b7b57ad44712e2b0$var$STATUS_TONE[r.status] || color;
        const label = i % xStep === 0 && formatX ? formatX(r, i) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: r.id ?? i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: cx,
            cy: cy,
            r: "4",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            stroke: dot,
            strokeWidth: "2"
        }), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: cx,
            y: H - 6,
            textAnchor: "middle",
            fontSize: "9",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        }, label));
    }), refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refHigh) + 4,
        fontSize: "9",
        fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
    }, formatValue(refHigh)), refLow != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
        x: $b7b57ad44712e2b0$var$PAD.l + cw + 4,
        y: yOf(refLow) + 4,
        fontSize: "9",
        fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
    }, formatValue(refLow)));
};
var $b7b57ad44712e2b0$export$2e2bcd8739ae039 = $b7b57ad44712e2b0$var$TrendChart;



var $acw62 = parcelRequire("acw62");


// ─────────────────────────────────────────────────────────────────────────────
// timeScale — the shared time→pixel mapping behind the kit's timeline charts.
//
// A timeline is only useful when every lane agrees on the clock: the whole
// point of stacking a measurement strip over an interval bar is that a vertical
// line means «the same moment». So the scale is computed ONCE by the caller and
// handed to every lane, instead of each chart deriving its own domain from its
// own data (which would silently misalign lanes with different date coverage).
//
// Domain-free by contract: milliseconds in, viewBox units out. The kit never
// decides what a date *means* — locale, calendar and label text stay with the
// app (the same division `TrendChart.formatX` already draws).
// ─────────────────────────────────────────────────────────────────────────────
// A linear scale over [min,max] → [padStart, width-padEnd].
//
//   scale.x(t)        → viewBox x for a timestamp (ms)
//   scale.invert(px)  → timestamp for a viewBox x
//   scale.clampX(t)   → x, clamped into the plot area (bars that start before
//                       the window still render, flush to the edge)
//   scale.inWindow(t) → is this timestamp inside the visible domain
function $95e851aef96b9382$export$27d74465d4d4bf01({ min: min, max: max, width: width, padStart: padStart = 0, padEnd: padEnd = 0 }) {
    const span = max - min || 1;
    const x0 = padStart;
    const x1 = Math.max(padStart + 1, width - padEnd);
    const w = x1 - x0;
    const x = (t)=>x0 + (t - min) / span * w;
    return {
        min: min,
        max: max,
        x0: x0,
        x1: x1,
        width: w,
        x: x,
        clampX: (t)=>Math.min(x1, Math.max(x0, x(t))),
        invert: (px)=>min + (px - x0) / w * span,
        inWindow: (t)=>t >= min && t <= max
    };
}
function $95e851aef96b9382$export$b9a1c56e49c8e590(min, max, count = 6) {
    const step = (max - min) / Math.max(1, count);
    return Array.from({
        length: count + 1
    }, (_, i)=>min + step * i);
}
function $95e851aef96b9382$export$849b7cb2b6ea39a7(points, scale, minGapPx = 8, isSignificant) {
    if (!points || points.length < 3) return points || [];
    const out = [];
    let lastX = -Infinity;
    points.forEach((p, i)=>{
        const px = scale.x(p.x);
        const keep = i === 0 || i === points.length - 1 || (isSignificant ? isSignificant(p) : false) || px - lastX >= minGapPx;
        if (keep) {
            out.push(p);
            lastX = px;
        }
    });
    return out;
}



var $acw62 = parcelRequire("acw62");

'use client';
const $33096ab4a7258714$export$52ff61eca6e84e5a = ({ scale: scale, ticks: ticks, top: top = 0, bottom: bottom })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        "aria-hidden": true
    }, (ticks || []).map((t, i)=>{
        if (!scale.inWindow(t)) return null;
        const x = Math.round(scale.x(t)) + 0.5; // crisp hairline
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            key: i,
            "data-chrome": "grid",
            x1: x,
            x2: x,
            y1: top,
            y2: bottom,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        });
    }));
const $33096ab4a7258714$export$cb94255ec4be9f06 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "now",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
        strokeWidth: "1",
        opacity: "0.9",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$5c09e766dd7f9830 = ({ scale: scale, at: at, top: top = 0, bottom: bottom })=>{
    if (at == null || !scale.inWindow(at)) return null;
    const x = Math.round(scale.x(at)) + 0.5;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
        "data-chrome": "cursor",
        x1: x,
        x2: x,
        y1: top,
        y2: bottom,
        stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
        strokeWidth: "1",
        opacity: "0.75",
        "aria-hidden": true
    });
};
const $33096ab4a7258714$export$348dc3495f07d294 = (status, fallback)=>{
    const s = String(status || '').toLowerCase();
    if (s === 'critical') return (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger;
    if (s === 'abnormal' || s === 'high' || s === 'low' || s === 'h' || s === 'l') return (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn;
    return fallback;
};
const $33096ab4a7258714$export$3b8c55d8340f8b88 = {
    start: 44,
    end: 12
};


'use client';
// ─────────────────────────────────────────────────────────────────────────────
// TimeRuler — the clock a stack of timeline lanes shares.
//
// It draws the tick labels once, at the top of the stack, so the lanes beneath
// stay pure plot. The caller owns the calendar: it supplies the tick
// timestamps and `formatTick`, exactly as `TrendChart.formatX` already does —
// the kit never decides that a boundary is a Jalali month rather than a week.
//
// Time reads left→right even on an RTL page (`direction: ltr`), the convention
// `Sparkline` and `TrendChart` already set; the surrounding labels stay RTL.
//
//   scale     — from createTimeScale, or pass xMin/xMax/width and let it build
//   ticks     — timestamps (ms) to label
//   formatTick(t, i) → node
//   nowAt     — timestamp of «now», drawn as the accent boundary
//   cursorAt  — synced crosshair position
//   markers   — optional [{ t, tone, shape, label }] event dots riding the axis
// ─────────────────────────────────────────────────────────────────────────────
const $88ed18dfb45d0422$var$TimeRuler = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, ticks: ticks = [], formatTick: formatTick, nowAt: nowAt, cursorAt: cursorAt, markers: markers, height: height = 52, labelGap: labelGap = 56, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const axisY = height - 18;
    // Labels thin out rather than collide: a tick keeps its gridline always, but
    // only prints its label when it clears the previous printed one. The newest
    // boundary is the anchor a reader looks for, so labelling walks from the end.
    const labelled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const keep = new Set();
        let lastX = Infinity;
        for(let i = ticks.length - 1; i >= 0; i -= 1){
            const t = ticks[i];
            if (!scale.inWindow(t)) continue;
            const x = scale.x(t);
            if (lastX - x >= labelGap) {
                keep.add(i);
                lastX = x;
            }
        }
        return keep;
    }, [
        ticks,
        scale,
        labelGap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        // Decorative by contract (DESIGN.md data-viz rule): the readout and the
        // table view carry the same information for assistive tech.
        "aria-hidden": true,
        focusable: "false",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: axisY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: axisY
    }), (markers || []).map((m, i)=>{
        if (!scale.inWindow(m.t)) return null;
        const cx = scale.x(m.t);
        const cy = axisY - 20;
        if (m.shape === 'cross') {
            const r = 4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: m.id ?? i,
                stroke: m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
                strokeWidth: "1.6",
                strokeLinecap: "round"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy - r,
                x2: cx + r,
                y2: cy + r
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
                x1: cx - r,
                y1: cy + r,
                x2: cx + r,
                y2: cy - r
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            key: m.id ?? i,
            cx: cx,
            cy: cy,
            r: "4.5",
            fill: m.filled ? m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            stroke: m.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            strokeWidth: "2"
        });
    }), formatTick && ticks.map((t, i)=>{
        if (!labelled.has(i)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            key: i,
            x: scale.x(t),
            y: height - 5,
            textAnchor: "middle",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            style: {
                fontSize: '0.625rem'
            }
        }, formatTick(t, i));
    }));
};
var $88ed18dfb45d0422$export$2e2bcd8739ae039 = $88ed18dfb45d0422$var$TimeRuler;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// SeriesLane — one measurement plotted against a SHARED time axis.
//
// The time-domain sibling of `TrendChart`. The two are deliberately different
// components rather than one with a mode, because they answer different
// questions and their x-axes are not the same kind of thing:
//
//   TrendChart  — one series, standalone, points spaced by INDEX. «How has this
//                 analyte moved?» Even spacing is a feature there: it spends
//                 every pixel on shape, and a lone chart has nothing to align to.
//   SeriesLane  — points sit at their real TIMESTAMPS on a domain the caller
//                 owns, so several lanes stack into one timeline and a vertical
//                 line means «the same moment» in all of them.
//
// Multiple series per lane are for the components of ONE measurement (systolic
// and diastolic), never for unrelated metrics: those get their own lane with
// their own value scale. Two unrelated measures sharing one y-axis is the
// dual-axis mistake, and it invents correlations that are not in the data.
//
//   series      — [{ points:[{x,y,status?,id?}], color?, label? }] (x = ms, sorted)
//   refLow/High — reference band + the window it must stay inside
//   ticks       — the shared gridline timestamps
//   formatValue — value-axis labels; the caller owns the locale/digits
// ─────────────────────────────────────────────────────────────────────────────
const $db32618d5eb876e6$var$PAD_TOP = 10;
const $db32618d5eb876e6$var$PAD_BOTTOM = 8;
const $db32618d5eb876e6$var$SeriesLane = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, series: series = [], refLow: refLow, refHigh: refHigh, height: height = 88, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, gridLines: gridLines = 2, formatValue: formatValue = (v)=>String(Math.round(v * 10) / 10), emptyLabel: emptyLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const lanes = (series || []).map((s)=>({
            ...s,
            points: (s.points || []).filter((p)=>p && Number.isFinite(p.y))
        })).filter((s)=>s.points.length);
    const all = lanes.flatMap((s)=>s.points.map((p)=>p.y));
    if (!all.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        "data-state": "empty",
        style: {
            height: height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.6875rem',
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            ...style
        },
        ...rest
    }, emptyLabel || null);
    // The value window always contains the reference band: a result is read
    // against its range, so a band pushed off-canvas would hide the very thing
    // that makes the number mean something.
    const dataMin = Math.min(...all, refLow ?? Infinity);
    const dataMax = Math.max(...all, refHigh ?? -Infinity);
    const span = dataMax - dataMin;
    const lo = dataMin - (span * 0.18 || Math.abs(dataMin * 0.1) || 1);
    const hi = dataMax + (span * 0.18 || Math.abs(dataMax * 0.1) || 1);
    const range = hi - lo || 1;
    const plotTop = $db32618d5eb876e6$var$PAD_TOP;
    const plotBottom = height - $db32618d5eb876e6$var$PAD_BOTTOM;
    const yOf = (v)=>plotTop + (plotBottom - plotTop) - (v - lo) / range * (plotBottom - plotTop);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${height}`,
        width: width,
        height: height,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": "content",
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, refLow != null && refHigh != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: scale.x0,
        y: yOf(refHigh),
        width: scale.x1 - scale.x0,
        height: Math.max(1, Math.abs(yOf(refLow) - yOf(refHigh))),
        fill: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent, 0.09)
    }), Array.from({
        length: gridLines + 1
    }, (_, i)=>{
        const v = lo + range / gridLines * i;
        const y = Math.round(yOf(v)) + 0.5;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: `g${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("line", {
            x1: scale.x0,
            x2: scale.x1,
            y1: y,
            y2: y,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).border,
            strokeWidth: "1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: scale.x0 - 6,
            y: y + 3,
            textAnchor: "end",
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute,
            style: {
                fontSize: '0.5625rem'
            }
        }, formatValue(v)));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: plotTop,
        bottom: plotBottom
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: plotTop,
        bottom: plotBottom
    }), lanes.map((s, si)=>{
        const color = s.color || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent;
        const inWin = s.points.filter((p)=>p.x >= scale.min && p.x <= scale.max);
        if (!inWin.length) return null;
        const path = inWin.map((p)=>`${scale.x(p.x).toFixed(1)},${yOf(p.y).toFixed(1)}`).join(' ');
        // Dots thin when dense, but an out-of-range reading is never thinned
        // away — the abnormal point is the one the doctor came for.
        const dots = (0, $95e851aef96b9382$export$849b7cb2b6ea39a7)(inWin, scale, 9, (p)=>!!p.status && p.status !== 'normal');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: s.id ?? si
        }, inWin.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("polyline", {
            points: path,
            fill: "none",
            stroke: color,
            strokeWidth: "2",
            strokeLinejoin: "round",
            strokeLinecap: "round"
        }), dots.map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
                key: p.id ?? i,
                cx: scale.x(p.x),
                cy: yOf(p.y),
                r: "3.5",
                fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                stroke: (0, $33096ab4a7258714$export$348dc3495f07d294)(p.status, color),
                strokeWidth: "2"
            })));
    }));
};
var $db32618d5eb876e6$export$2e2bcd8739ae039 = $db32618d5eb876e6$var$SeriesLane;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// IntervalBars — spans of time as bars on a shared axis (a Gantt lane).
//
// Some facts are not points: a prescription is an exposure window, a shift is a
// span of coverage. Plotted as intervals against the same clock as the
// measurement lanes, they answer the question a dot never can — «was this
// running while that changed?».
//
//   rows  — [{ id, label, segments: [{ from, to, label?, tone?, open? }] }]
//           `to == null` (or open) ⇒ still running: the bar reaches `nowAt`
//           and takes an arrow cap instead of a flat end.
//
// Adjacent segments of one row are separated by a 2px gap in the surface
// colour — never a stroke around the bar: the gap is the separator, a border
// would add ink that is not data. That gap is also how a dosage change reads
// as a change rather than one long uninterrupted bar.
// ─────────────────────────────────────────────────────────────────────────────
const $c413dd52a563653b$var$SEG_GAP = 2;
// SVG has no text-overflow, and slicing a string is the wrong tool for a label
// that may be RTL: cutting Persian text and appending «…» puts the ellipsis on
// the visually *leading* edge, so the label reads as though its beginning were
// missing. So a label is drawn only when it fits whole (measure-free estimate at
// the label's font size, ~6.2px/char for the mixed fa/Latin names this carries);
// otherwise it is dropped and the value lives in the row header and the table.
// «A label that won't fit doesn't get clipped.»
const $c413dd52a563653b$var$CHAR_W = 6.2;
const $c413dd52a563653b$var$labelFits = (label, room)=>String(label).length * $c413dd52a563653b$var$CHAR_W <= room;
const $c413dd52a563653b$var$IntervalBars = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, rows: rows = [], rowHeight: rowHeight = 26, barThickness: barThickness = 15, height: height, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, formatLabel: formatLabel, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const h = height || Math.max(rowHeight, rows.length * rowHeight + 8);
    const r = barThickness / 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": rows.length ? 'content' : 'empty',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), rows.map((row, ri)=>{
        const cy = 4 + ri * rowHeight + rowHeight / 2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: row.id ?? ri
        }, (row.segments || []).map((seg, si)=>{
            const open = seg.open || seg.to == null;
            const rawTo = open ? nowAt ?? scale.max : seg.to;
            if (seg.from > scale.max || rawTo < scale.min) return null;
            const x1 = scale.clampX(seg.from);
            // The gap belongs to every segment but the row's last one.
            const isLast = si === row.segments.length - 1;
            const x2 = Math.max(x1 + 2, scale.clampX(rawTo) - (isLast ? 0 : $c413dd52a563653b$var$SEG_GAP));
            const w = Math.max(2, x2 - x1);
            const tone = seg.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).navy;
            const label = formatLabel ? formatLabel(seg, row) : seg.label;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
                key: seg.id ?? si
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
                x: x1,
                y: cy - r,
                width: w,
                height: barThickness,
                rx: Math.min(4, r),
                fill: tone
            }), open && scale.inWindow(rawTo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
                d: `M${x2 - 1},${cy - r} L${x2 + 6},${cy} L${x2 - 1},${cy + r} Z`,
                fill: tone
            }), label && w > 52 && $c413dd52a563653b$var$labelFits(label, w - 14) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
                x: x1 + w / 2,
                y: cy + 3.5,
                textAnchor: "middle",
                fill: "#ffffff",
                style: {
                    fontSize: '0.625rem',
                    fontWeight: 700,
                    direction: 'rtl'
                }
            }, label));
        }));
    }));
};
var $c413dd52a563653b$export$2e2bcd8739ae039 = $c413dd52a563653b$var$IntervalBars;



var $acw62 = parcelRequire("acw62");




'use client';
// ─────────────────────────────────────────────────────────────────────────────
// EventMarkers — discrete moments on a shared time axis.
//
// The lane for things that happen rather than things that are measured: a
// diagnosis recorded, an order placed, a document filed. Each mark carries its
// identity in its SHAPE and its row as well as its tone, so the lane still
// reads under colour-blindness, in monochrome print, and — the case that
// actually bites — under an accent preset where two brand hues sit close
// together. Colour reinforces identity here; it never carries it alone.
//
//   events — [{ id, t, row, label, tone, shape }]
//            shape: 'triangle' | 'diamond' | 'circle' | 'square'
//            row:   0-based lane row (events of a kind share a row)
//
// Labels are placed left→right and only when they clear the previous label on
// the same row; the rest stay reachable through the crosshair readout and the
// table view. A dense month is normal for a sick patient, and overlapping
// labels would make exactly those months unreadable.
// ─────────────────────────────────────────────────────────────────────────────
const $b578d6619b9c2e00$var$SHAPES = {
    triangle: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy + s * 0.8} L${cx - s},${cy + s * 0.8} Z`,
    diamond: (cx, cy, s)=>`M${cx},${cy - s} L${cx + s},${cy} L${cx},${cy + s} L${cx - s},${cy} Z`,
    square: (cx, cy, s)=>`M${cx - s},${cy - s} L${cx + s},${cy - s} L${cx + s},${cy + s} L${cx - s},${cy + s} Z`
};
const $b578d6619b9c2e00$var$CHAR_W = 5.6;
const $b578d6619b9c2e00$var$EventMarkers = ({ xMin: xMin, xMax: xMax, width: width = 640, scale: scaleProp, events: events = [], rows: rows = 1, rowHeight: rowHeight = 22, height: height, size: size = 5, ticks: ticks = [], nowAt: nowAt, cursorAt: cursorAt, showLabels: showLabels = true, className: className, style: style, ...rest })=>{
    const scale = scaleProp || (0, $95e851aef96b9382$export$27d74465d4d4bf01)({
        min: xMin,
        max: xMax,
        width: width,
        padStart: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).start,
        padEnd: (0, $33096ab4a7258714$export$3b8c55d8340f8b88).end
    });
    const h = height || rows * rowHeight + 10;
    // Declutter per row, walking forward; `labelEnd` tracks where the last
    // printed label finished so the next one only prints if it clears it.
    const placed = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const rowEnd = {};
        return [
            ...events
        ].filter((e)=>scale.inWindow(e.t)).sort((a, b)=>a.t - b.t).map((e)=>{
            const x = scale.x(e.t);
            const row = e.row || 0;
            const textW = String(e.label || '').length * $b578d6619b9c2e00$var$CHAR_W;
            const start = x + 9;
            const show = showLabels && !!e.label && start >= (rowEnd[row] ?? -Infinity) + 8;
            if (show) rowEnd[row] = start + textW;
            return {
                ...e,
                x: x,
                row: row,
                showLabel: show
            };
        });
    }, [
        events,
        scale,
        showLabels
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: `0 0 ${Math.max(1, width)} ${h}`,
        width: width,
        height: h,
        preserveAspectRatio: "xMinYMid meet",
        "aria-hidden": true,
        focusable: "false",
        "data-state": events.length ? 'content' : 'empty',
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(className),
        style: {
            display: 'block',
            direction: 'ltr',
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$52ff61eca6e84e5a), {
        scale: scale,
        ticks: ticks,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$cb94255ec4be9f06), {
        scale: scale,
        at: nowAt,
        top: 0,
        bottom: h
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33096ab4a7258714$export$5c09e766dd7f9830), {
        scale: scale,
        at: cursorAt,
        top: 0,
        bottom: h
    }), placed.map((e, i)=>{
        const cy = 6 + e.row * rowHeight + rowHeight / 2;
        const tone = e.tone || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent;
        const path = $b578d6619b9c2e00$var$SHAPES[e.shape];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
            key: e.id ?? i
        }, path ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
            d: path(e.x, cy, size + 1),
            fill: tone,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            strokeWidth: "1.5"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
            cx: e.x,
            cy: cy,
            r: size,
            fill: tone,
            stroke: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            strokeWidth: "1.5"
        }), e.showLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("text", {
            x: e.x + 9,
            y: cy + 3.5,
            fill: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).ink2,
            style: {
                fontSize: '0.625rem'
            }
        }, e.label));
    }));
};
var $b578d6619b9c2e00$export$2e2bcd8739ae039 = $b578d6619b9c2e00$var$EventMarkers;




var $acw62 = parcelRequire("acw62");
'use client';
function $28afc58f3cd2c6a9$export$7266b1e659c4866f(initial = 640) {
    const [width, setWidth] = (0, $acw62.useState)(initial);
    const observerRef = (0, $acw62.useRef)(null);
    const ref = (0, $acw62.useCallback)((node)=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        // Expose the node on the callback ref itself.
        ref.current = node;
        if (!node) return;
        const read = ()=>{
            const w = node.clientWidth || node.getBoundingClientRect?.().width || 0;
            // Sub-pixel jitter would re-render every lane on every scroll.
            if (w > 0) setWidth((prev)=>Math.abs(prev - w) >= 0.5 ? w : prev);
        };
        read();
        if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(read);
            ro.observe(node);
            observerRef.current = ro;
        }
    }, []);
    return [
        ref,
        width
    ];
}
var $28afc58f3cd2c6a9$export$2e2bcd8739ae039 = $28afc58f3cd2c6a9$export$7266b1e659c4866f;





var $acw62 = parcelRequire("acw62");
'use client';
function $f1d9659251ef0350$export$2e2bcd8739ae039(ref, varName = '--app-bottom-dock', enabled = true) {
    (0, $acw62.useEffect)(()=>{
        const el = ref?.current;
        if (!enabled || !el || !varName || typeof document === 'undefined') return undefined;
        const root = document.documentElement;
        const publish = ()=>root.style.setProperty(varName, `${Math.round(el.offsetHeight)}px`);
        publish();
        // Absent in jsdom and older webviews; the one-shot measurement stands in.
        const ro = typeof ResizeObserver === 'function' ? new ResizeObserver(publish) : null;
        if (ro) ro.observe(el);
        return ()=>{
            if (ro) ro.disconnect();
            root.style.removeProperty(varName);
        };
    }, [
        ref,
        varName,
        enabled
    ]);
}







var $acw62 = parcelRequire("acw62");
function $1cf0083ab82acba7$export$8f772b88f40431ca({ pairingUrl: pairingUrl, getToken: getToken, headers: headers, loadSession: loadSession, unlinkSession: unlinkSession, pollWhileDisconnected: pollWhileDisconnected = false } = {}) {
    const [session, setSession] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    // The live pairing attempt: { kind, code, expiresAt, message } or null.
    const [pairing, setPairing] = (0, $acw62.useState)(null);
    const controller = (0, $acw62.useRef)(null);
    // The callers are re-created on every render by most call sites, and a
    // dependency on them would restart the effects below forever. The ref is read
    // at call time, so the newest one is always the one used.
    const io = (0, $acw62.useRef)({
        getToken: getToken,
        headers: headers,
        loadSession: loadSession,
        unlinkSession: unlinkSession
    });
    (0, $acw62.useEffect)(()=>{
        io.current = {
            getToken: getToken,
            headers: headers,
            loadSession: loadSession,
            unlinkSession: unlinkSession
        };
    });
    const refetch = (0, $acw62.useCallback)(async ()=>{
        try {
            const next = await io.current.loadSession?.() || null;
            setSession(next);
            setError(null);
            return next;
        } catch (err) {
            setError(err);
            return null;
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $acw62.useEffect)(()=>{
        refetch();
    }, [
        refetch
    ]);
    const stopPairing = (0, $acw62.useCallback)(()=>{
        // Aborting closes the HTTP response, which the BFF turns into a gRPC cancel.
        // Without it the gateway holds a fresh, half-linked device open for the full
        // three-minute window and the phone accumulates abandoned entries in its
        // «linked devices» list.
        controller.current?.abort();
        controller.current = null;
        setPairing(null);
    }, []);
    // Whatever happens — a tab closed, a route change, a component unmounted — the
    // stream must not outlive the screen that opened it.
    (0, $acw62.useEffect)(()=>()=>{
            controller.current?.abort();
        }, []);
    // DISCONNECTED is transient and recovers on its own, which is why a screen that
    // gates an action on the link may ask to watch it: somebody who fixes the link
    // in another tab must see the action become available without reopening
    // anything. Opt-in, because a settings page has no such need and a poll nobody
    // is watching is a request nobody wanted. PAIRING is NOT polled — the stream
    // delivers it.
    (0, $acw62.useEffect)(()=>{
        if (!pollWhileDisconnected || session?.state !== 'DISCONNECTED') return undefined;
        const timer = setInterval(refetch, 2500);
        return ()=>clearInterval(timer);
    }, [
        pollWhileDisconnected,
        session?.state,
        refetch
    ]);
    const startLink = (0, $acw62.useCallback)(async (method, phone)=>{
        stopPairing();
        // A new attempt clears the last one's failure. Without this the screen keeps
        // reporting a gateway that was down two minutes ago while a code is on the way.
        setError(null);
        const token = await io.current.getToken?.();
        if (!token) throw new Error('Not authenticated');
        const url = new URL(pairingUrl, typeof window === 'undefined' ? undefined : window.location.origin);
        url.searchParams.set('method', method === 'PAIRING_CODE' ? 'PAIRING_CODE' : 'QR');
        if (phone) url.searchParams.set('phone', phone);
        const ctrl = new AbortController();
        controller.current = ctrl;
        const extra = typeof io.current.headers === 'function' ? io.current.headers() || {} : io.current.headers || {};
        let res;
        try {
            res = await fetch(url.toString(), {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'text/event-stream',
                    ...extra
                },
                signal: ctrl.signal
            });
        } catch (err) {
            // AN ABORT IS NOT A FAILURE, and reporting it as one is a bug users meet
            // constantly: while a code is slow to arrive the screen looks dead, so
            // people press the button again — or switch from QR to the typed code —
            // and THAT aborts this request. Rethrowing put the browser's own
            // «signal is aborted without reason» on a Persian screen, as the reason
            // the attempt they had just started had failed.
            //
            // `readStream` has always swallowed its own aborts for this reason; this
            // is the same rule on the half of the request that happens before the
            // stream exists.
            if (err?.name === 'AbortError') return false;
            throw err;
        }
        if (!res.ok || !res.body) {
            const body = await res.json().catch(()=>null);
            controller.current = null;
            // The BFF's own sentence when it has one — it knows whether this was a
            // missing permission, a missing account or an unreachable gateway, and the
            // screen does not. It travels as `serverMessage` rather than as the
            // Error's own message, so a caller that renders it cannot accidentally
            // render a DOMException's English text the same way. Absent on purpose
            // when the BFF said nothing: copy belongs in the caller's catalogue.
            const refusal = new Error(body?.error || 'pairing refused');
            refusal.serverMessage = body?.error || '';
            throw refusal;
        }
        setPairing({
            kind: 'CONNECTING',
            code: '',
            expiresAt: null,
            message: ''
        });
        // Deliberately not awaited: the stream lives for as long as the pairing does,
        // and the caller needs its button back the moment the first code can arrive.
        $1cf0083ab82acba7$var$readStream(res.body, ctrl, controller, {
            setPairing: setPairing,
            refetch: refetch,
            setError: setError
        });
        return true;
    }, [
        pairingUrl,
        refetch,
        stopPairing
    ]);
    const unlink = (0, $acw62.useCallback)(async ()=>{
        stopPairing();
        await io.current.unlinkSession?.();
        await refetch();
    }, [
        refetch,
        stopPairing
    ]);
    return {
        session: session,
        loading: loading,
        error: error,
        pairing: pairing,
        refetch: refetch,
        startLink: startLink,
        stopPairing: stopPairing,
        unlink: unlink,
        /** The one state where a message can actually leave the building. */ canSend: session?.state === 'CONNECTED'
    };
}
/**
 * Reads SSE frames off the response body.
 *
 * Frames are separated by a blank line and a frame's `data:` is one JSON object.
 * Lines beginning `:` are the server's keep-alive comments and carry nothing —
 * they exist so an intermediary does not close a connection that is idle between
 * two QR codes.
 */ async function $1cf0083ab82acba7$var$readStream(body, ctrl, controller, { setPairing: setPairing, refetch: refetch, setError: setError }) {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    try {
        for(;;){
            const { value: value, done: done } = await reader.read();
            if (done) break;
            buffer += decoder.decode(value, {
                stream: true
            });
            let split;
            while((split = buffer.indexOf('\n\n')) >= 0){
                const frame = buffer.slice(0, split);
                buffer = buffer.slice(split + 2);
                const parsed = $1cf0083ab82acba7$export$9616b51a1be2e082(frame);
                if (!parsed) continue;
                if (parsed.event === 'error') {
                    // Server copy, or nothing — see the comment on the failed-response branch.
                    setError(new Error(parsed.data?.message || ''));
                    setPairing(null);
                    continue;
                }
                const { kind: kind, code: code, expiresInSeconds: expiresInSeconds, message: message } = parsed.data || {};
                if (kind === 'SUCCESS') {
                    setPairing(null);
                    await refetch();
                    continue;
                }
                if (kind === 'TIMEOUT' || kind === 'ERROR') {
                    setPairing({
                        kind: kind,
                        code: '',
                        expiresAt: null,
                        message: message || ''
                    });
                    continue;
                }
                setPairing({
                    kind: kind || 'QR',
                    code: code || '',
                    // An absolute instant, not a countdown: a component that re-renders for
                    // its own reasons must not restart the clock.
                    expiresAt: expiresInSeconds > 0 ? new Date(Date.now() + expiresInSeconds * 1000).toISOString() : null,
                    message: message || ''
                });
            }
        }
    } catch (err) {
        // An abort is this hook's own doing — the operator navigated away — and is
        // not a failure to report.
        if (err?.name !== 'AbortError') setError(err);
    } finally{
        // The stream that just finished may not be the one now in flight: pressing
        // «اتصال» twice aborts the first, and its cleanup must not wipe the second
        // one's code off the screen.
        if (controller.current === ctrl) {
            controller.current = null;
            setPairing(null);
        }
    }
}
function $1cf0083ab82acba7$export$9616b51a1be2e082(frame) {
    let event = 'message';
    const data = [];
    for (const line of String(frame).split('\n')){
        if (!line || line.startsWith(':')) continue;
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).trim());
    }
    if (!data.length) return null;
    try {
        return {
            event: event,
            data: JSON.parse(data.join('\n'))
        };
    } catch  {
        return null;
    }
}
var $1cf0083ab82acba7$export$2e2bcd8739ae039 = $1cf0083ab82acba7$export$8f772b88f40431ca;



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2b71f7c0d2454a8e$export$a2387ed3b5d536eb = {
    name: "clock",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 6v6l4 2",
                key: "mmk7yg"
            }
        ]
    ]
};
$2b71f7c0d2454a8e$export$a2387ed3b5d536eb.node;
const $2b71f7c0d2454a8e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($2b71f7c0d2454a8e$export$a2387ed3b5d536eb);




'use client';
/**
 * ChatBubble — one message in a conversation (kit-grade per DESIGN-CONCEPT
 * §17.2: tokens only, logical properties only, language-free, presentational).
 *
 * The chat-spec decisions this component encodes so no app re-derives them:
 *
 *  - **Alignment is `alignSelf`, never a margin hack.** `flex-end` for my
 *    messages, `flex-start` for the other party — logical values, so the whole
 *    conversation mirrors correctly under `dir="ltr"` with no direction prop.
 *  - **Radius 14px card scale (`0.875rem`) with a 10px "tail" corner**
 *    (`var(--radius, 0.625rem)`): the reduced corner sits on the block-end,
 *    *inline-start-or-end* edge nearest the sender — `borderEndEndRadius` on
 *    mine, `borderEndStartRadius` on theirs. Logical corners: the tail flips
 *    with the document direction by itself.
 *  - **No `•` separator ever** — the meta row (time + status) is a space-gap
 *    flex layout.
 *  - **A failed write must look failed**: `failed` restyles the surface from
 *    the `CT.danger*` family and renders a retry affordance; the caller decides
 *    when to actually re-send (`onRetry`).
 *  - **Delivery state is never colour-only.** Pass `status` and the bubble
 *    draws the glyph itself — `Clock` / `Check` / `TriangleAlert` — so the
 *    difference between "sending", "sent" and "failed" survives a colour-blind
 *    reader and a greyscale screen (DESIGN-CONCEPT §12 "colour is never the
 *    only carrier of meaning"). Apps do not ship their own dot.
 *
 * States (always stamped on the root as `data-state`): `sent` | `pending`
 * (60% opacity — visibly in flight) | `failed`.
 *
 * The root stays a plain div forwarding `...rest`; `role="listitem"` and any
 * grouping semantics are the caller's business.
 *
 * Props:
 *   body        — message text (rendered `dir="auto"`, pre-wrap, wraps anywhere)
 *   timeLabel   — pre-formatted time string; the calendar/locale stays with the app
 *   mine        — true for the authenticated user's own messages
 *   pending     — in-flight local echo (awaiting the server)
 *   failed      — the send failed; renders the retry affordance when `onRetry` given
 *   status      — 'pending' | 'sent' | 'failed': draws the delivery glyph. This
 *                 is the supported way to show delivery state; `statusLabel`
 *                 names it for screen readers.
 *   statusIcon  — escape hatch: a caller-supplied status node, used INSTEAD of
 *                 the built-in glyph
 *   statusLabel — screen-reader text for the status glyph (an icon alone says
 *                 nothing). NOTE: `statusLabel` on its own draws nothing
 *                 visible — it is the accessible name of a glyph, so it needs
 *                 `status` (or `statusIcon`) beside it. Dev builds warn.
 *   onRetry     — re-send handler; button rendered only when `failed`
 *   retryLabel  — label for the retry affordance
 *   style       — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // The delivery vocabulary the kit draws. Three states, three shapes — the
// glyph, not the hue, is what distinguishes them.
const $a6342f4e7688b45e$var$STATUS_GLYPH = {
    pending: (0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039),
    sent: (0, $3fbaf9031554177f$export$2e2bcd8739ae039),
    failed: (0, $f66de94054a4f331$export$2e2bcd8739ae039)
};
function $a6342f4e7688b45e$export$2e2bcd8739ae039({ body: body, timeLabel: timeLabel, mine: mine = false, pending: pending = false, failed: failed = false, status: status, statusIcon: statusIcon, statusLabel: statusLabel, onRetry: onRetry, retryLabel: retryLabel, className: className, style: style, 'data-testid': testId = 'chat-bubble', ...rest }) {
    const state = failed ? 'failed' : pending ? 'pending' : 'sent';
    // Surface per party; `failed` overrides both — an undelivered message is a
    // problem to act on, not a normal bubble at lower opacity.
    const surface = failed ? {
        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger, 0.4)}`
    } : mine ? {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        color: '#ffffff',
        border: 'none'
    } : {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
    };
    // Meta ink follows the surface. On navy the safe soft ink is literal white at
    // reduced opacity (colour arithmetic on a var() token is banned — soft() would
    // work, but #fff is the one sanctioned literal on navy).
    const metaStyle = failed ? {
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
        opacity: 0.8
    } : mine ? {
        color: '#ffffff',
        opacity: 0.75
    } : {
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
    };
    const Glyph = status ? $a6342f4e7688b45e$var$STATUS_GLYPH[status] : null;
    // Tint: the muted ink for the two quiet states, the danger ink for a failed
    // write. The one exception is the navy `mine` surface, where a fixed grey is
    // simply unreadable — there the glyph inherits the meta row's ink, which is
    // already the muted value FOR that surface. Same intent, legible result.
    const glyphColor = mine && !failed ? 'currentColor' : status === 'failed' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute;
    const glyph = statusIcon || (Glyph ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Glyph, {
        size: 13,
        strokeWidth: 2.25,
        "aria-hidden": true,
        style: {
            color: glyphColor
        }
    }) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: mine ? 'flex-end' : 'flex-start',
            // Alignment via alignSelf ONLY — never marginInline hacks, never textAlign.
            alignSelf: mine ? 'flex-end' : 'flex-start',
            maxWidth: 'min(85%, 42rem)',
            gap: '0.25rem',
            // Caller style MERGES over the computed layout (the `Card` precedent) —
            // spreading it after `...rest` used to silently drop `alignSelf` and
            // take mine/theirs alignment with it.
            ...style
        },
        ...rest,
        // AFTER ...rest: the delivery state is derived, not caller-supplied.
        "data-state": state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            ...surface,
            borderRadius: '0.875rem',
            // The "tail": the corner nearest the sender drops to the base radius.
            ...mine ? {
                borderEndEndRadius: 'var(--radius, 0.625rem)'
            } : {
                borderEndStartRadius: 'var(--radius, 0.625rem)'
            },
            padding: '0.5rem 0.875rem',
            ...pending && {
                opacity: 0.6
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        dir: "auto",
        style: {
            fontSize: '0.875rem',
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            overflowWrap: 'anywhere'
        }
    }, body), (timeLabel || glyph || statusLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '0.375rem',
            marginTop: '0.125rem',
            fontSize: '0.75rem',
            ...metaStyle
        }
    }, timeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, timeLabel), glyph && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "img",
        "aria-label": statusLabel,
        style: {
            display: 'inline-flex',
            alignItems: 'center'
        }
    }, glyph), !glyph && statusLabel && // Misuse (warned above), but the fact is not thrown away: assistive
    // tech still gets the delivery state.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: 'absolute',
            width: 1,
            height: 1,
            margin: -1,
            padding: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            border: 0
        }
    }, statusLabel))), failed && onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: onRetry,
        "data-testid": `${testId}-retry`,
        // size="sm" is 2.25rem; this renders on both apps' phone threads,
        // where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger
        }
    }, retryLabel));
}



var $acw62 = parcelRequire("acw62");

'use client';
function $01fd1e3fa9bffaa8$export$2e2bcd8739ae039({ label: label, className: className, style: style, 'data-testid': testId = 'chat-day-divider', ...rest }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            paddingBlock: '0.5rem',
            // Caller style MERGES over the computed layout (the `Card` precedent):
            // arriving inside `...rest` it used to replace `display: flex` outright
            // and collapse the two hairlines.
            ...style
        },
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            fontSize: '0.75rem',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            paddingInline: '0.625rem',
            borderRadius: 'var(--radius, 0.625rem)',
            whiteSpace: 'nowrap'
        }
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-hidden": true,
        style: {
            flex: 1,
            height: '1px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
        }
    }));
}



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c49d7be4abd1b80$export$a2387ed3b5d536eb = {
    name: "send",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
                key: "1ffxy3"
            }
        ],
        [
            "path",
            {
                d: "m21.854 2.147-10.94 10.939",
                key: "12cjpa"
            }
        ]
    ]
};
$6c49d7be4abd1b80$export$a2387ed3b5d536eb.node;
const $6c49d7be4abd1b80$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6c49d7be4abd1b80$export$a2387ed3b5d536eb);






'use client';
function $27c9e9585cb6c9b4$export$2e2bcd8739ae039({ value: value, onChange: onChange, onSend: onSend, disabled: disabled = false, sending: sending = false, placeholder: placeholder, sendLabel: sendLabel, sendIcon: sendIcon, readOnlyNotice: readOnlyNotice, maxLength: maxLength = 4000, autoGrowMaxRem: autoGrowMaxRem = 7.5, className: className, style: style, 'data-testid': testId = 'chat-composer', inputProps: inputProps, ...rest }) {
    const fieldRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Auto-grow: collapse, then take the content's scrollHeight. The rem clamp
    // lives in CSS (`maxHeight`), so the px assignment here never exceeds it and
    // the field starts scrolling instead of growing.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = fieldRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [
        value,
        readOnlyNotice
    ]);
    if (readOnlyNotice) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            padding: '0.5rem 1rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            ...style
        },
        ...rest,
        "data-state": "readonly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "info",
        "data-testid": `${testId}-notice`
    }, readOnlyNotice));
    const canSend = !disabled && !sending && Boolean(value && value.trim());
    const handleKeyDown = (e)=>{
        if (e.key !== 'Enter' || e.shiftKey) return;
        // Committing IME composition ends with Enter too — that one is not a send.
        if (e.nativeEvent && e.nativeEvent.isComposing) return;
        e.preventDefault();
        if (canSend) onSend();
    };
    const { className: fieldClassName, style: fieldStyle, ...fieldRest } = inputProps || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        style: {
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem',
            padding: '0.5rem 1rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            // Caller style MERGES over the computed layout (the `Card` precedent).
            ...style
        },
        ...rest,
        // AFTER ...rest: the send lifecycle is the composer's own state.
        "data-state": sending ? 'sending' : 'ready'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        ref: fieldRef,
        value: value,
        onChange: onChange,
        onKeyDown: handleKeyDown,
        placeholder: placeholder,
        "aria-label": placeholder,
        disabled: disabled || sending,
        rows: 1,
        maxLength: maxLength,
        dir: "auto",
        "data-testid": `${testId}-field`,
        className: (0, $42e05640dae453c1$export$1343a74baacb0543)(// The replacement for the outline we suppress — keyboard focus on the
        // feature's primary input has to be visible (§12.2).
        'outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1', 'transition-shadow duration-150', fieldClassName),
        style: {
            flex: 1,
            minWidth: 0,
            // ≥1rem or iOS zooms the page on focus — the composer's iron rule.
            fontSize: '1rem',
            lineHeight: 1.6,
            fontFamily: 'inherit',
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 'var(--radius, 0.625rem)',
            padding: '0.625rem 0.875rem',
            resize: 'none',
            maxHeight: `${autoGrowMaxRem}rem`,
            overflowY: 'auto',
            ...disabled || sending ? {
                opacity: 0.6
            } : null,
            ...fieldStyle
        },
        ...fieldRest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
        icon: sendIcon || // RTL-first flip — see the header note; LTR apps override via sendIcon.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6c49d7be4abd1b80$export$2e2bcd8739ae039), {
            size: 18,
            "aria-hidden": true,
            style: {
                transform: 'scaleX(-1)'
            }
        }),
        label: sendLabel,
        onClick: ()=>{
            if (canSend) onSend();
        },
        disabled: !canSend,
        "data-testid": `${testId}-send`
    }));
}



var $acw62 = parcelRequire("acw62");



'use client';
/**
 * ChatThread — the message column of a conversation (kit-grade per
 * DESIGN-CONCEPT §17.2). A flex column of `ChatBubble`/`ChatDayDivider`
 * children with the two behaviours every thread needs and no app should
 * re-derive:
 *
 *  - **Backwards pagination is a button, never a scroll trigger** (the
 *    pagination-not-infinite-scroll rule): when `hasOlder`, a ghost expander
 *    sits at the top of the thread; `loadingOlder` disables it and shows the
 *    kit spinner.
 *  - **Containment-safe autoscroll**: when the children count grows and the
 *    user was at/near the bottom (within ~4rem), the thread follows — by
 *    assigning `scrollTop` on the **resolved scroll container**, NEVER
 *    `scrollIntoView`, which walks every ancestor scroller and yanks the whole
 *    page in an embedded pane. A reader scrolled up into history is never
 *    yanked down, and a prepended older page never triggers it.
 *
 * Two containment modes via `fill`:
 *   true  — the thread IS the scroll container (`flex: 1; minHeight: 0;
 *           overflowY: auto`) for a desktop pane (the doctor app's P4 column);
 *   false — the thread sits in page flow and something ABOVE it scrolls.
 *
 * **Resolving the scroller (why this is not `document.scrollingElement`).**
 * In `fill={false}` mode the scroller is whatever ancestor actually scrolls,
 * and on a phone that is almost never the document: both mobile shells are
 * `inset: 0; overflow: hidden` with a single inner `overflow-y: auto` region.
 * Writing `document.scrollingElement.scrollTop` there lands on an element that
 * cannot scroll, and listening on `window` never fires, so the sampled gap
 * stays at its seed and autoscroll is silently dead. So the component walks
 * `containerRef.current.parentElement` upward for a computed `overflowY` of
 * `auto`/`scroll` and uses the first hit — falling back to
 * `document.scrollingElement` for a genuinely page-scrolled surface. The result
 * is cached per mount and re-resolved if the container node itself changes.
 * Callers may name the scroller explicitly with `scrollParentRef` instead.
 *
 * `role="log"` + `aria-live="polite"`: new messages are announced without
 * interrupting, and assistive tech knows earliest-first ordering applies.
 *
 * Exposes `scrollToBottom()` via ref for the caller's "jump to latest"
 * affordances.
 *
 * Props:
 *   children       — the message column (bubbles, day dividers)
 *   fill           — scroll-container mode (see above; default false)
 *   padBlockRem    — block padding in rem. Pass this instead of
 *                    `style={{ paddingBlock }}`: `style` is merged now, but a
 *                    named prop keeps the caller out of the layout entirely.
 *   hasOlder       — render the load-older expander
 *   onLoadOlder    — expander handler
 *   loadingOlder   — expander busy state (disabled + spinner)
 *   loadOlderLabel — expander label
 *   autoScroll     — follow new messages when near the bottom (default true)
 *   scrollParentRef— optional ref to the scroll container, skipping resolution
 *   style          — MERGED over the component's own layout, never replacing it
 *   className / data-testid — forwarded to the root (§15.1)
 */ // "Near the bottom" — ~4rem at the default type scale. Close enough that the
// reader is clearly following the conversation, not studying history.
const $af5a908f2b99a71b$var$NEAR_BOTTOM_PX = 64;
const $af5a908f2b99a71b$var$SCROLLY = new Set([
    'auto',
    'scroll',
    'overlay'
]);
const $af5a908f2b99a71b$var$ChatThread = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ChatThread({ children: children, fill: fill = false, padBlockRem: padBlockRem, hasOlder: hasOlder = false, onLoadOlder: onLoadOlder, loadingOlder: loadingOlder = false, loadOlderLabel: loadOlderLabel, autoScroll: autoScroll = true, scrollParentRef: scrollParentRef, className: className, style: style, 'data-testid': testId = 'chat-thread', ...rest }, ref) {
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Distance from the bottom edge, sampled on every scroll — read (not
    // recomputed) when children arrive, so the decision reflects where the user
    // WAS before the DOM grew. Starts at 0: opening a thread lands on the latest
    // message.
    const bottomGapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    const prevCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    // The resolved scroller, cached per mount, plus the container node it was
    // resolved FROM — a `key` swap gives us a new node and must re-resolve.
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const scrollerForRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Set while a backwards page is being prepended, so the growth it causes is
    // not mistaken for a new message. Without it a short thread — one that never
    // scrolled, so the sampled gap is still its 0 seed — passes the near-bottom
    // guard and yanks the reader away from the «older» button they just pressed.
    const prependingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children);
    const resolveScroller = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = containerRef.current;
        if (!el) return null;
        // `fill` — the thread IS the scroller; nothing to walk.
        if (fill) return el;
        if (scrollParentRef && scrollParentRef.current) return scrollParentRef.current;
        if (scrollerForRef.current === el && scrollerRef.current) return scrollerRef.current;
        let found = null;
        if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') for(let node = el.parentElement; node; node = node.parentElement){
            const overflowY = window.getComputedStyle(node).overflowY;
            if ($af5a908f2b99a71b$var$SCROLLY.has(overflowY)) {
                found = node;
                break;
            }
        }
        // Nothing between here and the root scrolls → the page really does.
        if (!found && typeof document !== 'undefined') found = document.scrollingElement;
        scrollerRef.current = found;
        scrollerForRef.current = el;
        return found;
    }, [
        fill,
        scrollParentRef
    ]);
    const sampleGap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) bottomGapRef.current = el.scrollHeight - el.scrollTop - el.clientHeight;
    }, [
        resolveScroller
    ]);
    const scrollToBottom = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const el = resolveScroller();
        if (el) el.scrollTop = el.scrollHeight; // the scroller itself — containment-safe
        bottomGapRef.current = 0;
    }, [
        resolveScroller
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            scrollToBottom: scrollToBottom
        }), [
        scrollToBottom
    ]);
    // Sample the gap from whatever actually scrolls.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (typeof window === 'undefined') return undefined;
        const el = resolveScroller();
        if (!el) return undefined;
        // The viewport's scroll event is dispatched at the Document, not at <html>,
        // so a document-level scroller has to be listened to on `window`.
        const isDocScroller = typeof document !== 'undefined' && (el === document.scrollingElement || el === document.documentElement || el === document.body);
        const target = isDocScroller ? window : el;
        const onScroll = ()=>sampleGap();
        target.addEventListener('scroll', onScroll, {
            passive: true
        });
        return ()=>target.removeEventListener('scroll', onScroll);
    }, [
        resolveScroller,
        sampleGap
    ]);
    // Follow growth only when the reader was already at the bottom.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const prev = prevCountRef.current;
        prevCountRef.current = childCount;
        if (!autoScroll || childCount <= prev) return;
        // Backwards page: the growth is above the reader, never below.
        if (prependingRef.current) {
            prependingRef.current = false;
            return;
        }
        if (bottomGapRef.current <= $af5a908f2b99a71b$var$NEAR_BOTTOM_PX) scrollToBottom();
    }, [
        childCount,
        autoScroll,
        scrollToBottom
    ]);
    // Declared AFTER the growth effect on purpose: when a load-older resolves,
    // both run in the same commit and the growth effect must still see the flag.
    // This one only clears a flag the fetch never spent — an empty or failed page
    // produces no growth, and a stale flag would swallow the next real message.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!loadingOlder) prependingRef.current = false;
    }, [
        loadingOlder
    ]);
    const handleLoadOlder = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        prependingRef.current = true;
        onLoadOlder?.(e);
    }, [
        onLoadOlder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className,
        "data-testid": testId,
        role: "log",
        "aria-live": "polite",
        ref: containerRef,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            paddingInline: '1rem',
            ...padBlockRem != null && {
                paddingBlock: `${padBlockRem}rem`
            },
            ...fill && {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto'
            },
            // Caller style MERGES over the computed layout — it never replaces it.
            // (Same precedent as `Card`.) Anything a caller genuinely needs to own,
            // like block padding, has a named prop.
            ...style
        },
        ...rest,
        // AFTER ...rest: the thread's own busy state is not the caller's to
        // overwrite — a caller-side data-state would hide `loading` forever.
        "data-state": loadingOlder ? 'loading' : 'ready'
    }, hasOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            paddingBlock: '0.25rem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "ghost",
        size: "sm",
        onClick: handleLoadOlder,
        disabled: loadingOlder,
        "data-testid": `${testId}-load-older`,
        // size="sm" is 2.25rem; this control renders on both apps' phone
        // threads, where the floor is 2.75rem (DESIGN-CONCEPT-MOBILE §368).
        className: "min-h-11",
        style: {
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    }, loadingOlder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
        size: 14,
        thickness: 2
    }), loadOlderLabel)), children);
});
var $af5a908f2b99a71b$export$2e2bcd8739ae039 = $af5a908f2b99a71b$var$ChatThread;






var $acw62 = parcelRequire("acw62");

const $393fa4133562fea6$export$6c2d0d964670e2e3 = [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
];
const $393fa4133562fea6$export$fb4a539c21dc93d2 = [
    "\u0634",
    "\u06CC",
    "\u062F",
    "\u0633",
    "\u0686",
    "\u067E",
    "\u062C"
];
const $393fa4133562fea6$export$961e0c326b64dc98 = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[+d]);
const $393fa4133562fea6$export$c7153f4b19854938 = 12600000;
const $393fa4133562fea6$export$710ba58c9cc5d7e7 = ()=>new Date(Date.now() + $393fa4133562fea6$export$c7153f4b19854938);
function $393fa4133562fea6$var$jIsLeap(y) {
    return (y * 8 + 29) % 33 < 8;
}
function $393fa4133562fea6$export$129955be4a159fb3(ms) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = Math.floor((ms - anchor) / 86400000);
    if (!Number.isFinite(days)) return null;
    // Nothing in a medical record predates the Jalali era, so a timestamp that
    // far back is corrupt input. Reject it rather than walk ~270,000 iterations
    // and hand the caller a confident negative year.
    if (days < -520000) return null; // ≈ year 1
    let y = 1400;
    // Before the anchor: step back a year at a time until the day index lands
    // inside one, mirroring the forward walk below.
    while(days < 0){
        y--;
        days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    }
    while(true){
        const diy = $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
        if (days < diy) break;
        days -= diy;
        y++;
    }
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(y) ? 30 : 29
    ];
    let m = 0;
    while(days >= md[m]){
        days -= md[m];
        m++;
    }
    return {
        y: y,
        m: m + 1,
        d: days + 1
    };
}
function $393fa4133562fea6$export$998538909dbe3791(jy, jm, jd) {
    const anchor = Date.UTC(2021, 2, 21); // 1400/01/01
    let days = 0;
    if (jy >= 1400) for(let y = 1400; y < jy; y++)days += $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    else for(let y = jy; y < 1400; y++)days -= $393fa4133562fea6$var$jIsLeap(y) ? 366 : 365;
    const md = [
        31,
        31,
        31,
        31,
        31,
        31,
        30,
        30,
        30,
        30,
        30,
        $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29
    ];
    for(let m = 0; m < jm - 1; m++)days += md[m];
    days += jd - 1;
    return anchor + days * 86400000;
}
function $393fa4133562fea6$export$33c90dd38a62167e(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    return $393fa4133562fea6$var$jIsLeap(jy) ? 30 : 29;
}
function $393fa4133562fea6$export$748262491e74cb62() {
    const now = $393fa4133562fea6$export$710ba58c9cc5d7e7();
    // Day-of-week in Iran time: getUTCDay() because we manually shifted the clock
    const jsDay = now.getUTCDay(); // 0=Sun … 6=Sat
    const irWeekday = (jsDay + 1) % 7; // 0=ش … 6=ج
    const nowMs = now.getTime(); // already shifted UTC+3:30
    return Array.from({
        length: 7
    }, (_, i)=>{
        const dayMs = nowMs + (i - irWeekday) * 86400000;
        return {
            ...$393fa4133562fea6$export$129955be4a159fb3(dayMs),
            shortName: $393fa4133562fea6$export$fb4a539c21dc93d2[i],
            isToday: i === irWeekday
        };
    });
}






'use client';
/**
 * Date-range filter as a single dropdown.
 *
 * The trigger always reads out the *applied* range ("امروز", "۱۲–۱۸ تیر", "Sep 12–18"), so the
 * active filter is never ambiguous — the older layout left the two date inputs
 * visible next to the preset chips, and a custom range highlighted no chip at all.
 *
 * Props:
 *   presets   — [{ id, label }]; the ids are opaque, the parent maps them to a window
 *   preset    — active preset id, or 'custom'
 *   custom    — { from, to } applied custom range, Gregorian 'YYYY-MM-DD' (picker format)
 *   onPreset  — (id) => void
 *   onCustom  — (from, to) => void; only fired once BOTH ends are picked
 */ // Gregorian 'YYYY-MM-DD' (what JalaliDatePicker emits) → { y, m, d } in the
// calendar the page reads: Jalali for Persian and Arabic, Gregorian for English,
// French and German — the same choice the picker itself makes (lib/datePickerLocale.js).
const $751677fd0a80fd7a$var$partsOf = (s, calendar)=>{
    if (!s || s.length < 10) return null;
    const [y, m, d] = s.split('-').map(Number);
    if (!y || !m || !d) return null;
    return calendar === 'jalali' ? (0, $393fa4133562fea6$export$129955be4a159fb3)(Date.UTC(y, m - 1, d)) : {
        y: y,
        m: m,
        d: d
    };
};
const $751677fd0a80fd7a$var$dayKey = (p)=>p.y * 10000 + p.m * 100 + p.d;
// Month first or day first. Persian, English and Arabic keep the order this label
// has always had, the CALENDAR's: month first on a Gregorian page ("September
// 12–18", «سبتمبر ١٢–١٨» under a Gregorian brand), day first on a Jalali one —
// a live Gregorian brand (Proxia, en + ar) must read exactly as before (PM-0185
// D15). A language added since (French, German) reads its own date template
// instead: «12–18 septembre», «12.–18. September», «12–18 Tir», day first
// whichever calendar the page reads.
const $751677fd0a80fd7a$var$CALENDAR_ORDER = new Set([
    'fa',
    'en',
    'ar'
]);
const $751677fd0a80fd7a$var$monthFirst = (L, locale)=>{
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    if ($751677fd0a80fd7a$var$CALENDAR_ORDER.has(base) || !(0, $0873d4f32691c14e$export$4b8e9f545c94f612)[base]) return L.calendar === 'gregorian';
    return L.date.indexOf('{month}') < L.date.indexOf('{d}');
};
// What a day-first language writes right after the day number, read off the same
// template: German's ordinal dot («{d}. {month} {y}» → «12.–18. September»,
// «30. August – 2. September»); nothing for French. fa/en/ar keep their old label.
const $751677fd0a80fd7a$var$dayMark = (L, locale)=>{
    const base = String(locale || (0, $ca1f40e638c62a9a$export$594d280e896fc02b)()).toLowerCase().split(/[-_]/)[0];
    if ($751677fd0a80fd7a$var$CALENDAR_ORDER.has(base) || !(0, $0873d4f32691c14e$export$4b8e9f545c94f612)[base]) return '';
    const m = /\{d\}(\S*)\s+\{month\}/.exec(L.date);
    return m ? m[1] : '';
};
function $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale) {
    const L = (0, $0873d4f32691c14e$export$90e478cf5247906b)(locale);
    let a = $751677fd0a80fd7a$var$partsOf(fromStr, L.calendar);
    let b = $751677fd0a80fd7a$var$partsOf(toStr, L.calendar);
    if (!a || !b) return (0, $df1b34b618a72512$export$cddd06f8fa3400df)(locale).dateRange.custom;
    if ($751677fd0a80fd7a$var$dayKey(a) > $751677fd0a80fd7a$var$dayKey(b)) [a, b] = [
        b,
        a
    ];
    const num = (x)=>(0, $0873d4f32691c14e$export$545c62727d3740ae)(x, L.digits);
    const month = (p)=>L.months[L.calendar][p.m - 1];
    if ($751677fd0a80fd7a$var$monthFirst(L, locale)) {
        const md = (p)=>`${month(p)} ${num(p.d)}`;
        if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${md(a)}, ${num(a.y)}`;
        if (a.y === b.y && a.m === b.m) return `${month(a)} ${num(a.d)}\u{2013}${num(b.d)}`;
        if (a.y === b.y) return `${md(a)} \u{2013} ${md(b)}`;
        return `${md(a)}, ${num(a.y)} \u{2013} ${md(b)}, ${num(b.y)}`;
    }
    const mark = $751677fd0a80fd7a$var$dayMark(L, locale);
    const day = (p)=>`${num(p.d)}${mark}`;
    const dm = (p)=>`${day(p)} ${month(p)}`;
    if ($751677fd0a80fd7a$var$dayKey(a) === $751677fd0a80fd7a$var$dayKey(b)) return `${dm(a)} ${num(a.y)}`;
    if (a.y === b.y && a.m === b.m) return `${day(a)}\u{2013}${day(b)} ${month(a)}`;
    if (a.y === b.y) return `${dm(a)} \u{2013} ${dm(b)}`;
    return `${dm(a)} ${num(a.y)} \u{2013} ${dm(b)} ${num(b.y)}`;
}
function $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, fromStr, toStr, presets, locale) {
    if (preset === 'custom') return $751677fd0a80fd7a$export$a0d62bcaf969e834(fromStr, toStr, locale);
    return (presets.find((p)=>p.id === preset) || {}).label || '';
}
const $751677fd0a80fd7a$var$CalendarIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M20 3h-1V1h-2v2H7V1H5v2H4C2.9 3 2 3.9 2 5v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13zM7 10h5v5H7z"
    }));
const $751677fd0a80fd7a$var$ChevronIcon = ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "14",
        height: "14",
        fill: "currentColor",
        style: {
            flexShrink: 0,
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7 10l5 5 5-5z"
    }));
const $751677fd0a80fd7a$var$CheckIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "15",
        height: "15",
        fill: "currentColor",
        style: {
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }));
const $751677fd0a80fd7a$var$PresetRow = ({ label: label, active: active, onClick: onClick })=>{
    const [hov, setHov] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: onClick,
        onMouseEnter: ()=>setHov(true),
        onMouseLeave: ()=>setHov(false),
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '8px 10px',
            borderRadius: 8,
            border: 'none',
            background: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight : hov ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg : 'transparent',
            color: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            fontSize: 13,
            fontWeight: active ? 700 : 500,
            fontFamily: 'inherit',
            cursor: 'pointer',
            textAlign: 'start',
            transition: 'background 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), active && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CheckIcon, null));
};
function $751677fd0a80fd7a$export$2e2bcd8739ae039({ presets: presets, preset: preset, custom: custom, onPreset: onPreset, onCustom: onCustom }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    // Draft dates live here, not in the parent: a range is only *applied* once both
    // ends exist, so a half-picked range can never desync the trigger label from the
    // window the list is actually showing.
    const [dFrom, setDFrom] = (0, $acw62.useState)(custom.from);
    const [dTo, setDTo] = (0, $acw62.useState)(custom.to);
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setDFrom(custom.from);
            setDTo(custom.to);
        }
    }, [
        open,
        custom.from,
        custom.to
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (!ref.current) return;
            if (ref.current.contains(e.target)) return;
            // The two custom-range fields are `JalaliDatePicker`s, and their calendar
            // is PORTALED to <body> so a clipping ancestor cannot slice it. That puts
            // it outside `ref`, so picking a day counted as an outside click and shut
            // the dropdown before the date could register — which made the custom
            // range unreachable by calendar in every screen that uses this filter.
            if (e.target.closest?.('[data-jalali-popup]')) return;
            setOpen(false);
        };
        document.addEventListener('mousedown', h);
        return ()=>document.removeEventListener('mousedown', h);
    }, [
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        const h = (e)=>{
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('keydown', h);
        return ()=>document.removeEventListener('keydown', h);
    }, [
        open
    ]);
    const copy = (0, $df1b34b618a72512$export$cddd06f8fa3400df)().dateRange;
    const isCustom = preset === 'custom';
    const label = $751677fd0a80fd7a$export$94bb145bb1ee00a2(preset, custom.from, custom.to, presets);
    const halfDone = !!dFrom !== !!dTo;
    const pickPreset = (id)=>{
        onPreset(id);
        setOpen(false);
    };
    const pickFrom = (v)=>{
        setDFrom(v);
        if (v && dTo) {
            onCustom(v, dTo);
            setOpen(false);
        }
    };
    const pickTo = (v)=>{
        setDTo(v);
        if (v && dFrom) {
            onCustom(dFrom, v);
            setOpen(false);
        }
    };
    const highlighted = open || isCustom;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: ref,
        style: {
            position: 'relative',
            flexShrink: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        onClick: ()=>setOpen((o)=>!o),
        title: copy.title,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            height: 36,
            padding: '0 12px',
            borderRadius: 8,
            border: `1px solid ${highlighted ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: highlighted ? '#fff' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            color: highlighted ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            fontSize: 13,
            fontWeight: 700,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            transition: 'all 0.12s'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$CalendarIcon, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$ChevronIcon, {
        open: open
    })), open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: 'absolute',
            top: 'calc(100% + 6px)',
            insetInlineStart: 0,
            zIndex: 60,
            width: 260,
            background: '#fff',
            borderRadius: 12,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            boxShadow: '0 12px 36px rgba(0,0,0,0.14)',
            padding: 8
        }
    }, presets.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($751677fd0a80fd7a$var$PresetRow, {
            key: p.id,
            label: p.label,
            active: preset === p.id,
            onClick: ()=>pickPreset(p.id)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            height: 1,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
            margin: '8px 4px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            color: isCustom ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            padding: '2px 10px 8px'
        }
    }, copy.custom), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            display: 'grid',
            gap: 8,
            padding: '0 4px 4px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
        value: dFrom,
        onChange: pickFrom,
        placeholder: copy.from,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
        value: dTo,
        onChange: pickTo,
        placeholder: copy.to,
        height: 38,
        fontSize: 13,
        disableFuture: true
    }), halfDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            fontSize: 11,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            fontWeight: 600,
            padding: '0 2px'
        }
    }, copy.needBoth))));
}



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Applies the doctor's accent preset and type scale to <html>.
 *
 * Where the value comes from, in order:
 *   1. localStorage, read synchronously during the first render, so a reload
 *      paints the chosen accent immediately instead of flashing the default
 *      while the `me` query is still in flight.
 *   2. The server copy, pushed in via `appearance` once settings load. That is
 *      the real record and wins whenever it differs — it is how the preference
 *      follows the doctor to another device.
 *
 * Themed values are CSS custom properties (see tokens.css), so switching the
 * preset re-themes every screen without re-rendering anything: this provider
 * only sets two attributes on the root element.
 */ const $54fc473ae52026aa$var$ThemeContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
function $54fc473ae52026aa$export$d8964aec282183a3({ appearance: appearance, children: children }) {
    // Lazy initialiser — runs before first paint, not in an effect.
    const [local, setLocal] = (0, $acw62.useState)(()=>{
        const stored = (0, $e7c165fb515b04ea$export$dde01dc24facb6b0)();
        (0, $e7c165fb515b04ea$export$48c323151b232e54)(stored);
        return stored;
    });
    const serverTheme = appearance?.theme;
    const serverFontSize = appearance?.fontSize;
    // Adopt the server's copy when it arrives or changes (e.g. the doctor changed
    // the accent on another device). Nulls mean "not loaded yet" — not "reset".
    (0, $acw62.useEffect)(()=>{
        if (!serverTheme && !serverFontSize) return;
        setLocal((prev)=>{
            const next = {
                theme: serverTheme || prev.theme,
                fontSize: serverFontSize || prev.fontSize
            };
            if (next.theme === prev.theme && next.fontSize === prev.fontSize) return prev;
            const resolved = (0, $e7c165fb515b04ea$export$48c323151b232e54)(next);
            (0, $e7c165fb515b04ea$export$64464588479aad90)(resolved);
            return resolved;
        });
    }, [
        serverTheme,
        serverFontSize
    ]);
    const value = (0, $acw62.useMemo)(()=>({
            theme: local.theme,
            fontSize: local.fontSize,
            // Apply a choice locally and cache it. Two callers:
            //   - the settings picker, so the accent switches under the doctor's cursor
            //     instead of after a server round trip;
            //   - app boot, to adopt the server's copy once `me` resolves.
            // Persisting to the BFF is the caller's job — this only paints and caches.
            setAppearance: (patch)=>{
                setLocal((prev)=>{
                    const resolved = (0, $e7c165fb515b04ea$export$48c323151b232e54)({
                        ...prev,
                        ...patch
                    });
                    (0, $e7c165fb515b04ea$export$64464588479aad90)(resolved);
                    return resolved;
                });
            }
        }), [
        local
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($54fc473ae52026aa$var$ThemeContext.Provider, {
        value: value
    }, children);
}
function $54fc473ae52026aa$export$93d4e7f90805808f() {
    return (0, $acw62.useContext)($54fc473ae52026aa$var$ThemeContext) ?? {
        theme: (0, $e7c165fb515b04ea$export$2faeed762aac6741),
        fontSize: (0, $e7c165fb515b04ea$export$b1461457ea2c1179),
        setAppearance: ()=>{}
    };
}
var $54fc473ae52026aa$export$2e2bcd8739ae039 = $54fc473ae52026aa$export$d8964aec282183a3;




var $acw62 = parcelRequire("acw62");
'use client';
const $02b96a2843192315$export$df49a36517896dd5 = {
    // ── The Jalali date picker ────────────────────────────────────────────────
    'common.datePicker.placeholder': "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.clear': "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u062A\u0627\u0631\u06CC\u062E",
    'common.datePicker.openCalendar': "\u0646\u0645\u0627\u06CC\u0634 \u062A\u0642\u0648\u06CC\u0645",
    'common.datePicker.today': "\u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.goToToday': "\u0628\u0631\u0648 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
    'common.datePicker.now': "\u0627\u06A9\u0646\u0648\u0646",
    'common.datePicker.hour': "\u0633\u0627\u0639\u062A",
    'common.datePicker.minute': "\u062F\u0642\u06CC\u0642\u0647",
    // `{{unit}}` is one of the two above — a stepper's two arrows are named
    // "hour more" / "hour less" for a screen reader.
    'common.datePicker.increase': "{{unit}} \u0628\u06CC\u0634\u062A\u0631",
    'common.datePicker.decrease': "{{unit}} \u06A9\u0645\u062A\u0631",
    'common.datePicker.previousMonth': "\u0645\u0627\u0647 \u0642\u0628\u0644",
    'common.datePicker.nextMonth': "\u0645\u0627\u0647 \u0628\u0639\u062F",
    'common.datePicker.errors.format': "\u0642\u0627\u0644\u0628 \u062A\u0627\u0631\u06CC\u062E: \u06F1\u06F4\u06F0\u06F4/\u06F0\u06F5/\u06F1\u06F2",
    'common.datePicker.errors.range': "\u062A\u0627\u0631\u06CC\u062E \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.time': "\u0633\u0627\u0639\u062A \u0646\u0627\u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A",
    'common.datePicker.errors.noTime': "\u0627\u06CC\u0646 \u0641\u06CC\u0644\u062F \u0633\u0627\u0639\u062A \u0646\u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F",
    'common.datePicker.errors.future': "\u062A\u0627\u0631\u06CC\u062E \u0622\u06CC\u0646\u062F\u0647 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A",
    // ── The mobile shell ──────────────────────────────────────────────────────
    // Not visible copy — the bottom bar's accessible name. It is here for the
    // same reason the rest is: a screen reader in an English panel should not
    // announce the navigation in Persian.
    'common.a11y.primaryNav': "\u0646\u0627\u0648\u0628\u0631\u06CC \u0627\u0635\u0644\u06CC",
    // ── The date-range filter ─────────────────────────────────────────────────
    'common.dateRange.label': "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
    'common.dateRange.custom': "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
    'common.dateRange.from': "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.to': "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
    'common.dateRange.pickBoth': "\u0628\u0631\u0627\u06CC \u0627\u0639\u0645\u0627\u0644\u060C \u0647\u0631 \u062F\u0648 \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F"
};
const $02b96a2843192315$export$cdafc612aa9b582a = {
    'common.calendar.months': [
        "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
        "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
        "\u062E\u0631\u062F\u0627\u062F",
        "\u062A\u06CC\u0631",
        "\u0645\u0631\u062F\u0627\u062F",
        "\u0634\u0647\u0631\u06CC\u0648\u0631",
        "\u0645\u0647\u0631",
        "\u0622\u0628\u0627\u0646",
        "\u0622\u0630\u0631",
        "\u062F\u06CC",
        "\u0628\u0647\u0645\u0646",
        "\u0627\u0633\u0641\u0646\u062F"
    ],
    // Saturday-first, one glyph each — the calendar header.
    'common.calendar.weekdaysNarrow': [
        "\u0634",
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C"
    ]
};
/** Persian digits — what the kit has always rendered. */ const $02b96a2843192315$var$toPersianDigits = (n)=>String(n).replace(/\d/g, (d)=>"\u06F0\u06F1\u06F2\u06F3\u06F4\u06F5\u06F6\u06F7\u06F8\u06F9"[d]);
// ── The registry ────────────────────────────────────────────────────────────
//
// Module state rather than context, because it has to be readable from plain
// functions (the date parser's error messages) and not only from components.
// `version` is what makes it REACTIVE: a panel that switches language at
// runtime bumps it, and every mounted kit component re-reads.
let $02b96a2843192315$var$table = null;
let $02b96a2843192315$var$version = 0;
const $02b96a2843192315$var$listeners = new Set();
function $02b96a2843192315$export$bf11b40754c929ae(next) {
    $02b96a2843192315$var$table = next || null;
    $02b96a2843192315$var$version += 1;
    $02b96a2843192315$var$listeners.forEach((notify)=>notify());
}
function $02b96a2843192315$var$subscribe(notify) {
    $02b96a2843192315$var$listeners.add(notify);
    return ()=>$02b96a2843192315$var$listeners.delete(notify);
}
const $02b96a2843192315$var$snapshot = ()=>$02b96a2843192315$var$version;
/** `{{unit}}` → vars.unit. The kit needs no more interpolation than this. */ function $02b96a2843192315$var$interpolate(text, vars) {
    if (!vars) return text;
    return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name)=>vars[name] === undefined ? match : String(vars[name]));
}
function $02b96a2843192315$export$44bc4c060d9b3ece(key, vars) {
    const override = $02b96a2843192315$var$table?.string?.(key);
    const text = override === undefined || override === null ? $02b96a2843192315$export$df49a36517896dd5[key] : override;
    // A key with no default is a bug in the kit, not in the app — surfacing the
    // key beats rendering `undefined` into the DOM.
    return $02b96a2843192315$var$interpolate(text === undefined ? key : text, vars);
}
function $02b96a2843192315$export$d041a4afca2888c(key) {
    const override = $02b96a2843192315$var$table?.list?.(key);
    return Array.isArray(override) ? override : $02b96a2843192315$export$cdafc612aa9b582a[key] || [];
}
function $02b96a2843192315$export$aa5144520a3863d7(value) {
    const override = $02b96a2843192315$var$table?.number?.(value);
    return override === undefined || override === null ? $02b96a2843192315$var$toPersianDigits(value) : String(override);
}
function $02b96a2843192315$export$ee19af4091ffbbfc() {
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore($02b96a2843192315$var$subscribe, $02b96a2843192315$var$snapshot, $02b96a2843192315$var$snapshot);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            t: $02b96a2843192315$export$44bc4c060d9b3ece,
            list: $02b96a2843192315$export$d041a4afca2888c,
            num: $02b96a2843192315$export$aa5144520a3863d7
        }), // `version` is read through the store above; naming it here is what ties
    // the memo to a catalogue swap.
    [
        $02b96a2843192315$var$version
    ]);
}










// Runtime configuration, resolved once at module load.
//
// window.__ENV__ is written by docker-entrypoint.sh at container start from the
// k8s deployment env, so the same image serves every environment. process.env is
// the Parcel build-time fallback (baked in via the Dockerfile ARG) for local dev.
const $d87bd335296b449f$var$runtime = typeof window !== 'undefined' && window.__ENV__ || {};
const $d87bd335296b449f$export$bb117bdb9f34de64 = $d87bd335296b449f$var$runtime.BFF_URL || undefined || 'https://dapi.parsinabot.ir/graphql';
const $d87bd335296b449f$export$d8ff6422767fc83a = $d87bd335296b449f$var$runtime.BFF_WS_URL || undefined || $d87bd335296b449f$export$bb117bdb9f34de64.replace(/^https/, 'wss').replace(/^http/, 'ws').replace('/graphql', '');
const $d87bd335296b449f$export$348460d0a768e5a6 = String($d87bd335296b449f$var$runtime.USE_BROWSER_STT ?? undefined ?? 'false') === 'true';
const $d87bd335296b449f$export$91dbb4a8660769db = $d87bd335296b449f$var$runtime.PARSINA_KC_BASE_URL || undefined || 'https://sso.itechtrade.ir';
const $d87bd335296b449f$export$5aec0b605bf1c5bb = ($d87bd335296b449f$var$runtime.ACCOUNT_APP_URL || undefined || 'https://account.parsinabot.ir').replace(/\/+$/, '');
function $d87bd335296b449f$export$cce6d3603c0b63d(section = '/') {
    const back = typeof window !== 'undefined' ? window.location.origin : '';
    const path = section.startsWith('/') ? section : `/${section}`;
    return `${$d87bd335296b449f$export$5aec0b605bf1c5bb}${path}${back ? `?return_url=${encodeURIComponent(back)}` : ''}`;
}
const $d87bd335296b449f$export$ce4d22a853fad121 = ($d87bd335296b449f$var$runtime.CLINIC_APP_URL || undefined || 'https://clinic.parsinabot.ir').replace(/\/+$/, '');
function $d87bd335296b449f$export$656ea0803b1a2433(clinic) {
    const ref = typeof clinic === 'string' ? clinic : clinic?.slug || clinic?.clinicId || clinic?.id || '';
    return ref ? `${$d87bd335296b449f$export$ce4d22a853fad121}/c/${encodeURIComponent(ref)}/` : `${$d87bd335296b449f$export$ce4d22a853fad121}/`;
}
function $d87bd335296b449f$export$35411b84b35a3ed4(clinic) {
    window.location.assign($d87bd335296b449f$export$656ea0803b1a2433(clinic));
}


var $23a4fb8df39836e9$exports = {};
$23a4fb8df39836e9$exports = import.meta.resolve("90mMd");


var $f0b50123bb07e4c7$exports = {};
$f0b50123bb07e4c7$exports = import.meta.resolve("8C9I7");


// i18n provider — resolves the locale (config.js), serves t() and the
// formatters (format.js), persists the choice, and keeps <html lang/dir> in
// sync. The inline script in index.html owns only the pre-paint frame; from
// mount onward this owns it, and nothing else in the app sets `direction`.


var $acw62 = parcelRequire("acw62");
// Locale resolution — the SAME contract as the inline pre-paint script in
// index.html and as the doctor client's src/i18n/config.js: stored choice
// ('parsina.locale') → device language → English. Keep the three in step.
//
// A deliberately small implementation of that contract: resolution is the only
// part of i18n this app needs that the doctor client's src/i18n/ also has, and
// the rest of that module (namespace-per-file, a lazy loader) buys nothing for
// six screens and one bundle — see catalogs.js. It is a candidate for promotion
// to @parsina/framework once a third client wants the same three lines; until
// then, do not fork the doctor client's version, and keep this contract
// identical to it and to the pre-paint script in index.html.
// `fr` and `de` need the kit at v0.24.0 or later (README «French release
// order», which holds for German too): on an older pin every kit-owned surface
// — pager, date picker, currency names, parseAmount — falls back to PERSIAN
// under lang=fr / lang=de. Do not ship this list with the v0.21.0 pin.
const $94f36eaf2deb686d$export$4c4b683c586ca56e = {
    fa: 'rtl',
    en: 'ltr',
    fr: 'ltr',
    de: 'ltr'
};
const $94f36eaf2deb686d$export$86880b4b2e1a2384 = 'parsina.locale';
const $94f36eaf2deb686d$export$9e8d0820828f4de3 = 'en';
function $94f36eaf2deb686d$export$ec67f55c222e1546(tag) {
    if (!tag) return null;
    if ($94f36eaf2deb686d$export$4c4b683c586ca56e[tag]) return tag;
    const base = String(tag).toLowerCase().split(/[-_]/)[0];
    return $94f36eaf2deb686d$export$4c4b683c586ca56e[base] ? base : null;
}
function $94f36eaf2deb686d$export$df9bcabe7f932e01(storage, languages) {
    let stored = null;
    try {
        stored = $94f36eaf2deb686d$export$ec67f55c222e1546(storage?.getItem($94f36eaf2deb686d$export$86880b4b2e1a2384));
    } catch  {
    /* storage off */ }
    if (stored) return stored;
    for (const tag of languages || []){
        const hit = $94f36eaf2deb686d$export$ec67f55c222e1546(tag);
        if (hit) return hit;
    }
    return $94f36eaf2deb686d$export$9e8d0820828f4de3;
}


// The catalogue barrel.
//
// EN is the SOURCE catalogue (the doctor-app rule, docs/I18N.md there): every
// key is declared in en.js, and fa.js, fr.js and de.js translate it. A key in
// only one translation is a defect, and tests/i18n.test.js asserts parity with
// en in both directions for every catalogue here. A locale enters SUPPORTED
// (config.js) only together with its complete catalogue.
//
// All of them live in ./translations/ so a screen's copy can be reviewed
// without scrolling past the mechanism.
//
// One flat map per locale, with fully qualified dotted keys, rather than the
// doctor app's namespace-per-file + lazy loader. This app has six screens and
// one bundle; the loader's job — not shipping fifteen JSON files to render one
// screen — does not exist here yet. The KEY SHAPE is identical, so promoting to
// the namespaced loader later is a mechanical move that touches no screen.
// EN — the SOURCE catalogue.
//
// Every key the app renders is declared HERE first, and fa.js, fr.js and de.js
// translate it. A key missing from en.js is a defect and tests/i18n.test.js
// fails on it.
//
// Keys are fully qualified and the first segment is the namespace, so a key you
// read in a screen is a key you can grep for. There is deliberately no scoped
// `useTranslation('today')` form — one rule, one lookup.
//
// Persian is the PRODUCT language; English is the source of record for the
// catalogue. All four catalogues (en, fa, fr, de) are complete and shipped; a
// key missing from fr.js or de.js would fall back to English, never to Persian.
const $6ecdd4f2fd8400bc$export$84584c2a98eb6753 = {
    // ── app ──────────────────────────────────────────────────────────────────
    'app.title': "Parsina \u2014 Dental Module",
    // ── nav / chrome ─────────────────────────────────────────────────────────
    'nav.brand.name': 'Parsina',
    'nav.brand.panel': 'Dentistry',
    'nav.items.today': 'Today',
    'nav.items.patients': 'Patients',
    'nav.items.credits': 'Credit',
    'nav.items.profile': 'Profile',
    'nav.sidebar.collapse': 'Collapse menu',
    'nav.sidebar.expand': 'Expand menu',
    'nav.sidebar.logout': 'Sign out',
    'nav.sidebar.editProfile': 'Profile',
    'nav.clinic.label': 'Clinic',
    // The AccountCard at the foot of the rail — the balance, and the menu that
    // holds every account-level destination. The unit is "Parseh" in BOTH locales.
    'nav.account.menuLabel': 'Account',
    'nav.account.parsina': 'Parsina account',
    'nav.account.parsinaHint': 'Name, password, language',
    'nav.credits.label': 'Your Parseh credit',
    'nav.credits.topUp': 'Top up Parseh',
    'nav.clinicSwitch.label': 'Go to clinic panel',
    // Landmark names. Two <nav>-less/<main>-less pages are indistinguishable to a
    // screen reader's landmark list; the rail and the page body are named so
    // "skip to content" works without a skip link.
    'nav.landmark.primary': 'Main menu',
    'nav.landmark.content': 'Content',
    // ── common ───────────────────────────────────────────────────────────────
    'common.actions.cancel': 'Cancel',
    'common.actions.retry': 'Try again',
    // The accessible name of every skeleton composite (DESIGN.md §"Loading & skeleton").
    'common.loading': 'Loading',
    'common.actions.save': 'Save',
    'common.actions.saving': "Saving\u2026",
    'common.actions.back': 'Back',
    // Distinct from «انصراف»: a read-only drawer is dismissed, not cancelled —
    // there is nothing pending to abandon.
    'common.actions.close': 'Close',
    'common.actions.clearFilters': 'Clear filters',
    'common.actions.join': 'Join',
    // A button mid-flight. Not «Saving…»: the session dialog's primary
    // action is a token refresh, and nothing is being saved.
    'common.state.pleaseWait': "Please wait\u2026",
    'common.labels.phone': 'Phone',
    'common.labels.country': 'Country',
    'common.labels.nationalId': 'National ID',
    'common.labels.fileNumber': 'File no.',
    'common.labels.none': "\u2014",
    'common.gender.male': 'Male',
    'common.gender.female': 'Female',
    'common.marital.single': 'Single',
    'common.marital.married': 'Married',
    'common.marital.divorced': 'Divorced',
    'common.marital.widowed': 'Widowed',
    'common.units.years': '{{count}} yrs',
    // The plural `one` form (Intl.PluralRules of the panel language), picked by
    // the translator when `count` is a NUMBER: «1 yr» here, «0 an» / «1 an» in
    // French, where 0 is `one` too.
    'common.units.years_one': '{{count}} yr',
    'common.units.minute': 'min',
    // Spelled out, not 'sec': it sits beside a countdown that a dentist has
    // two minutes to act on, and an abbreviation reads as a table cell.
    'common.units.second': 'seconds',
    // The unit word of CLINIC money in an Iranian clinic (IRR, shown as toman).
    // Not the credits screens' own `credits.toman`: that is platform money and
    // never follows a clinic's currency.
    'common.units.toman': 'toman',
    // The same word AFTER an amount of 2 toman or more (src/lib/money.js
    // moneyUnit). English keeps «toman» invariable, as it always read; French
    // says «tomans».
    'common.units.tomans': 'toman',
    // The colon a screen puts between a label and its value («File no.: 12»).
    // A catalogue entry, not a literal, because French writes a no-break space
    // before it («N° de dossier : 12»).
    'common.punct.colon': ':',
    // Voice dictation (browser SpeechRecognition — see useSpeechToText.js).
    'common.voice.start': 'Dictate',
    'common.voice.stop': 'Stop recording',
    // No ellipsis: the elapsed clock follows it immediately, and «Listening… 00:12»
    // reads as a pause where there is none.
    'common.voice.listening': 'Listening',
    'common.voice.priceTitle': '5 Parseh per minute of recording, rounded up.',
    'common.voice.inlineTranscribing': "Writing it out\u2026",
    'common.voice.error.denied': 'Microphone access was denied',
    'common.voice.error.no-mic': 'No microphone was found',
    'common.voice.error.unsupported': 'This browser cannot record audio',
    // getUserMedia only exists over HTTPS — what you hit opening the app on an
    // iPad by its LAN IP address.
    'common.voice.error.insecure': 'Recording only works over a secure (HTTPS) connection',
    'common.voice.error.credits': 'Your Parsina credit has run out',
    'common.voice.error.auth': 'Your session is no longer valid. Please sign in again',
    'common.voice.error.onboarding': 'Finish your registration first',
    'common.voice.error.unavailable': 'The speech-to-text service is unavailable',
    'common.voice.error.timeout': 'Writing the text out took too long',
    'common.voice.error.generic': 'Could not record audio',
    // ── mobile shell ─────────────────────────────────────────────────────────
    // Copy that belongs to the ≤768px surface only. The kit's own defaults for
    // these slots (MobileHeader.greeting, BottomSheet.closeLabel) are Persian
    // literals, so every one of them has to be passed explicitly or it leaks
    // Persian into the English UI.
    'mobile.greeting': 'Welcome,',
    // The expander that grows a list. Never infinite scroll: position and
    // citability matter, and a phone list is where losing your place hurts most.
    'mobile.showMore': 'Show more',
    'mobile.close': 'Close',
    // ── auth / boot ──────────────────────────────────────────────────────────
    'auth.checking': "Signing you in\u2026",
    'auth.loading': "Loading your workspace\u2026",
    'auth.loopError': 'Sign-in keeps redirecting. Clear your session and try again, or contact support.',
    'auth.loopTitle': 'Sign-in failed',
    'auth.checkingHint': 'This takes a moment',
    'auth.stuck': 'Not redirected?',
    'auth.manualSignIn': 'Click here',
    'auth.retry': 'Try again',
    'auth.signOut': 'Sign out',
    'auth.bootFailed.title': 'Could not start',
    'auth.bootFailed.body': 'Your workspace could not be loaded. This is usually temporary.',
    // The session ending — see src/lib/session.js. Deliberately word-for-word the
    // doctor panel's copy (src/i18n/translations/en/auth.json there): a dentist
    // who also works in the doctor panel meets this dialog in both, and two
    // wordings for one event would read as two different products.
    'auth.session.expiringTitle': 'Your session is about to end',
    'auth.session.expiringBody': 'Extend it to keep working without interruption.',
    'auth.session.staySignedIn': 'Keep working',
    'auth.session.expiredTitle': 'Your session has ended',
    'auth.session.expiredBody': "Sign in again to continue. This page has not been closed \u2014 you will come back to it.",
    'auth.session.signInAgain': 'Sign in again',
    'auth.session.returnNotice': 'Anything you already saved is safe. Note down anything unsaved on screen before signing in again.',
    // ── errors ───────────────────────────────────────────────────────────────
    'errors.generic': 'Something went wrong.',
    'errors.load.today': 'The day could not be loaded.',
    'errors.load.patients': 'The patient list could not be loaded.',
    'errors.load.patient': 'This record could not be loaded.',
    'errors.load.profile': 'Your profile could not be loaded.',
    'errors.load.drugs': 'The formulary could not be searched.',
    'errors.credits.title': 'Not enough Parsina credits',
    'errors.credits.body': "The interaction check needs credits. Top up from \u0627\u0639\u062A\u0628\u0627\u0631 \u2014 prescribing itself is not blocked.",
    // ── today (امروز) ─────────────────────────────────────────────────────────
    'today.title': 'Today',
    'today.date.today': 'Today',
    'today.date.prev': 'Previous day',
    'today.date.next': 'Next day',
    // Mobile: tapping the day label opens the calendar in a sheet, so any date is
    // one tap away instead of N arrow presses.
    'today.date.pick': 'Pick a date',
    'today.counts.total': 'Appointments',
    'today.counts.here': 'In the clinic',
    'today.counts.scheduled': 'Booked',
    'today.counts.completed': 'Seen',
    'today.counts.cancelled': 'Cancelled',
    // Mobile keeps the stat row at exactly four tiles (the design's signature), so
    // the desktop's conditional fifth KPI becomes this muted line beneath it.
    'today.counts.cancelledLine': '{{count}} cancelled',
    // The waiting room is a fact about NOW, so it exists only for today. Said out
    // loud rather than showing an empty queue block on another day.
    'today.notice.liveQueue': 'The live waiting room is only shown for today. Other days show the booked list.',
    // The appointment lifecycle, in the SCHEDULING service's own vocabulary.
    // The kit's StatusBadge derives its label from `statusColors[status].label`,
    // which is Persian-only — so the day sheet read «نوبت‌دار» inside an otherwise
    // English UI. The colours still come from the kit; only the word is here.
    // An unrecognised status renders verbatim (AppointmentRow), never relabelled.
    'today.status.scheduled': 'Booked',
    'today.status.arrived': 'Arrived',
    'today.status.in_visit': 'In the chair',
    'today.status.completed': 'Seen',
    'today.status.cancelled': 'Cancelled',
    'today.status.no_show': 'No-show',
    'today.blocks.queue': 'Waiting room',
    'today.blocks.upcoming': 'Ahead',
    'today.blocks.done': 'Finished',
    'today.next.title': 'Next patient',
    'today.next.at': 'at {{time}}',
    'today.next.service': 'Service: {{name}}',
    'today.next.serviceVisit': 'Visit',
    'today.next.serviceMore': '+{{count}} more',
    'today.empty.title': 'Nothing booked for this day',
    'today.empty.description': 'Appointments are booked by the clinic front desk and appear here automatically.',
    'today.error.title': 'The day sheet is unavailable',
    'today.queue.positionNext': 'Next',
    'today.queue.position': 'No. {{position}}',
    'today.queue.waited': 'waited {{count}} min',
    'today.queue.waitedHours': 'waited {{hours}} h',
    'today.queue.waitedHoursMinutes': 'waited {{hours}} h {{minutes}} min',
    'today.queue.elapsed': '{{count}} min in the chair',
    'today.queue.elapsedHours': '{{hours}} h in the chair',
    'today.queue.elapsedHoursMinutes': '{{hours}} h {{minutes}} min in the chair',
    'today.row.visit': 'Visit',
    'today.row.visitFor': 'Open the visit for {{name}}',
    'today.row.open': 'Open record',
    // Every row's button reads «Open record»; the accessible name says WHOSE, so
    // a screen reader running the day sheet is not a list of identical buttons.
    'today.row.openFor': 'Open the record of {{name}}',
    'today.row.walkIn': 'Walk-in',
    'today.row.unknownPatient': 'Unnamed patient',
    'today.readOnlyNote': 'Booking, cancelling and queue order belong to the clinic front desk. This panel reads the same appointments.',
    // ── patients (بیماران) ────────────────────────────────────────────────────
    'patients.title': 'Patients',
    'patients.subtitle': "The clinic register \u2014 the same patients the front desk enrols",
    'patients.search.placeholder': 'Name, phone, national ID or file number',
    'patients.search.hint': 'Type at least two characters to search.',
    'patients.count': '{{count}} patients',
    'patients.columns.name': 'Patient',
    'patients.columns.phone': 'Phone',
    'patients.columns.fileNumber': 'File no.',
    'patients.columns.nationalId': 'National ID',
    'patients.empty.title': 'No patients yet',
    'patients.empty.description': 'Patients registered at the clinic front desk appear here.',
    'patients.emptyFiltered.title': 'No match',
    'patients.emptyFiltered.description': 'No patient matches this search.',
    'patients.noClinic.title': 'You are not a member of a clinic yet',
    'patients.noClinic.description': 'The patient register belongs to a clinic. Join one with its invitation code from your profile.',
    'patients.noClinic.action': 'Go to profile',
    'patients.pendingClinic.title': 'Your membership has not been accepted yet',
    'patients.pendingClinic.description': 'You have asked to join, and the clinic has to accept you before its patient register opens. The status is on your profile.',
    'patients.error.title': 'The patient list is unavailable',
    // ── patient workspace ────────────────────────────────────────────────────
    'patient.tabs.summary': 'Summary',
    'patient.tabs.history': 'History',
    // The mobile record's sticky section strip is a landmark; the kit takes its
    // name as a prop rather than hardcoding a Persian one.
    'patient.tabs.sectionsLabel': 'Record sections',
    'patient.actions.prescribe': 'Prescribe',
    'patient.notFound.title': 'Record not found',
    'patient.notFound.description': 'This patient does not exist, or is not visible to you.',
    'patient.error.title': 'This record is unavailable',
    'patient.stats.age': 'Age',
    'patient.stats.allergies': 'Allergies',
    'patient.stats.medications': 'Medications',
    'patient.summary.demographics': 'Details',
    'patient.summary.allergies': 'Allergies',
    'patient.summary.noAllergies': 'No allergy recorded.',
    // Recorded VALUES, recognised and labelled. An unrecognised value renders
    // verbatim (lib/patients.js) — a clinical field is never relabelled.
    'patient.severity.mild': 'Mild',
    'patient.severity.moderate': 'Moderate',
    'patient.severity.severe': 'Severe',
    'patient.conditionStatus.active': 'Active',
    'patient.conditionStatus.inactive': 'Inactive',
    'patient.conditionStatus.resolved': 'Resolved',
    'patient.conditionStatus.remission': 'In remission',
    'patient.photo.open': 'View a larger photo of {{name}}',
    'patient.photo.alt': 'Profile photo of {{name}}',
    'patient.summary.allergyWarning': "Recorded allergies \u2014 check them before prescribing.",
    'patient.fields.birthDate': 'Date of birth',
    'patient.fields.gender': 'Gender',
    'patient.fields.maritalStatus': 'Marital status',
    'patient.fields.bloodType': 'Blood type',
    'patient.fields.job': 'Occupation',
    'patient.fields.insurance': 'Insurance',
    'patient.fields.height': 'Height',
    'patient.fields.createdAt': 'Registered',
    'patient.history.conditions': 'Conditions',
    'patient.history.medications': 'Medications',
    'patient.history.noConditions': 'No condition recorded.',
    'patient.history.noMedications': 'No medication recorded.',
    'patient.history.prescribedOn': 'Prescribed {{date}}',
    // ── prescription (نسخه) ──────────────────────────────────────────────────
    'prescription.title': 'Prescription',
    'prescription.subtitle': 'For {{name}}',
    'prescription.search.label': 'Add a medicine',
    'prescription.search.placeholder': "Search the formulary\u2026",
    'prescription.search.searching': "Searching\u2026",
    'prescription.search.empty': 'No medicine matches.',
    'prescription.search.hint': 'Type at least two characters.',
    // Announced, not drawn: the formulary popup's result count reaches a screen
    // reader through the combobox's live region.
    'prescription.search.results': '{{count}} medicines found.',
    'prescription.item.dose': 'Dose',
    'prescription.item.frequency': 'Frequency',
    'prescription.item.duration': 'Duration',
    'prescription.item.note': 'Note',
    'prescription.item.remove': 'Remove {{name}}',
    'prescription.empty.title': 'Nothing prescribed yet',
    'prescription.empty.description': 'Search the formulary above to add the first medicine.',
    'prescription.save': 'Save prescription',
    'prescription.saveConfirm': 'Confirm and save',
    'prescription.saving': "Saving\u2026",
    'prescription.saved': 'Prescription saved.',
    'prescription.saveFailed': 'The prescription could not be saved.',
    'prescription.savePartial': '{{saved}} of {{total}} medicines were saved.',
    'prescription.allergies.title': 'Recorded allergies',
    'prescription.interactions.title': 'Interaction check',
    'prescription.interactions.checking': "Checking\u2026",
    'prescription.interactions.none': 'No interaction found for these medicines.',
    'prescription.interactions.needsTwo': 'Add a second medicine to run the interaction check.',
    'prescription.interactions.unavailable': 'The interaction check is unavailable right now. Prescribing is not blocked.',
    'prescription.interactions.severity.high': 'High',
    'prescription.interactions.severity.moderate': 'Moderate',
    'prescription.interactions.severity.low': 'Low',
    'prescription.interactions.type.interaction': 'Interaction',
    'prescription.interactions.type.contraindication': 'Contraindication',
    'prescription.interactions.type.allergy': 'Allergy',
    'prescription.interactions.type.black_box': 'Black box',
    'prescription.history.title': 'Previously prescribed',
    'prescription.history.empty': 'Nothing prescribed before.',
    // ── profile ──────────────────────────────────────────────────────────────
    'profile.title': 'Profile',
    'profile.subtitle': 'Your identity, your clinics and your shifts',
    'profile.sections.label': 'Profile sections',
    'profile.sections.identity': 'Identity',
    'profile.sections.clinics': 'Clinics',
    'profile.sections.presence': 'Shifts',
    'profile.sections.appearance': 'Appearance & language',
    'profile.fields.fullName': 'Full name',
    'profile.fields.medicalCode': 'Medical council number',
    'profile.fields.specialty': 'Specialty',
    'profile.fields.bio': 'About you',
    // The READABLE label for the dental specialty. The value actually stored and
    // sent is the Persian string in constants/specialties.js — never this. They
    // are separate on purpose: the stored value is a server identifier the
    // normalized predicate matches on, this is copy.
    'profile.specialtyValue': 'Dentistry',
    'profile.medicalCodeLocked': 'The council number was recorded at sign-up and cannot be edited. Contact Parsina support to have it corrected.',
    'profile.specialtyLocked': 'This panel serves dentists, so the specialty is fixed. Changing it elsewhere closes this panel to your account.',
    'profile.saved': 'Profile saved.',
    'profile.noChanges': 'Nothing changed.',
    'profile.saveFailed': 'The profile could not be saved.',
    'profile.duplicateCode': 'That medical council number already belongs to another account.',
    'profile.clinics.empty': 'You are not a member of any clinic yet.',
    'profile.clinics.status.pending': 'Awaiting the clinic',
    'profile.clinics.status.active': 'Active',
    'profile.clinics.visitDuration': 'Slot {{count}} min',
    // The clinic scope switcher lives in the desktop SIDEBAR, which does not
    // exist below 768px — so on mobile it lives here, or a multi-clinic dentist is
    // locked to one scope forever with no way to say which.
    'profile.clinics.activeScope': 'Active clinic',
    'profile.clinics.activeScopeHint': 'Today and Patients show this clinic.',
    'profile.clinics.joinTitle': 'Join a clinic',
    'profile.clinics.joinHint': 'Ask the clinic manager for the invitation code.',
    'profile.clinics.joinPlaceholder': 'Invitation code',
    'profile.clinics.joined': 'You joined {{name}}.',
    'profile.clinics.notFound': 'No clinic has that invitation code.',
    'profile.clinics.joinFailed': 'Joining the clinic failed.',
    'profile.presence.empty': 'The clinic has not set shifts for you.',
    'profile.presence.oneOff': 'One-off',
    // A disabled shift was drawn at 55% opacity and nothing else — a state
    // carried by appearance alone, invisible to a screen reader and easy to miss.
    'profile.presence.inactive': 'Off',
    'profile.presence.readOnly': 'Shifts are set by the clinic; this panel reads them.',
    'profile.presence.days.0': 'Monday',
    'profile.presence.days.1': 'Tuesday',
    'profile.presence.days.2': 'Wednesday',
    'profile.presence.days.3': 'Thursday',
    'profile.presence.days.4': 'Friday',
    'profile.presence.days.5': 'Saturday',
    'profile.presence.days.6': 'Sunday',
    'profile.appearance.theme': 'Accent',
    'profile.appearance.fontSize': 'Text size',
    'profile.appearance.language': 'Language',
    'profile.appearance.saved': 'Preference saved.',
    'profile.appearance.failed': 'The preference was not saved on the server.',
    'profile.theme.default': 'Parsina blue',
    'profile.theme.teal': 'Turquoise',
    'profile.theme.ocean': 'Deep blue',
    'profile.theme.slate': 'Blue grey',
    'profile.fontSize.small': 'Small',
    'profile.fontSize.medium': 'Medium',
    'profile.fontSize.large': 'Large',
    'profile.language.fa': "\u0641\u0627\u0631\u0633\u06CC",
    'profile.language.en': 'English',
    'profile.language.fr': "Fran\xe7ais",
    'profile.language.de': 'Deutsch',
    // ── onboarding ───────────────────────────────────────────────────────────
    'onboarding.title': 'Parsina dental module',
    'onboarding.subtitle.step1': 'Register once so your account can be identified',
    'onboarding.subtitle.clinic': 'Connect to the clinic you work at',
    'onboarding.subtitle.done': 'You are ready',
    'onboarding.progress.step1': 'Registration',
    'onboarding.progress.clinic': 'Clinic',
    'onboarding.progress.done': 'Done',
    'onboarding.step1.fullName': 'Full name',
    'onboarding.step1.fullNamePlaceholder': 'Dr Maryam Ahmadi',
    'onboarding.step1.medicalCode': 'Medical council number',
    'onboarding.step1.medicalCodePlaceholder': 'e.g. 123456',
    'onboarding.step1.specialty': 'Specialty',
    'onboarding.step1.bio': 'About you (optional)',
    'onboarding.step1.submit': 'Continue',
    'onboarding.step1.specialtyNote': 'This panel is the dental module, so the specialty is set for you.',
    'onboarding.clinic.choiceTitle': 'Your practice or clinic',
    'onboarding.clinic.choiceDescription': 'If you have your own practice, register it here. If you work at another clinic, join it with an invitation code.',
    'onboarding.clinic.ownTitle': 'Register my own practice',
    'onboarding.clinic.ownBody': 'For a personal practice. You will be its owner.',
    'onboarding.clinic.joinTitle': 'Join an existing clinic',
    'onboarding.clinic.joinBody': 'With the invitation code the clinic gave you.',
    'onboarding.clinic.back': 'Back',
    'onboarding.clinic.ownName': 'Practice name',
    'onboarding.clinic.ownNamePlaceholder': 'Dr Ahmadi Dental Practice',
    'onboarding.clinic.ownCity': 'City (optional)',
    'onboarding.clinic.ownAddress': 'Address (optional)',
    'onboarding.clinic.ownPhone': 'Practice phone (optional)',
    'onboarding.clinic.create': 'Register practice',
    'validation.clinicName': 'Enter the practice name.',
    'onboarding.clinic.alreadyExists': 'A practice is already registered for this account.',
    // The currency the practice keeps its books in. `{{currency}}` is a name
    // with its ISO code, e.g. "UAE dirham (AED)".
    'onboarding.clinic.currency': 'Practice currency',
    'onboarding.clinic.currencyHint': 'Tariffs and treatment plans are recorded in this currency. It can be changed in the clinic panel only until the first amount is recorded.',
    'onboarding.clinic.currencyIrr': 'Toman (IRR)',
    'onboarding.clinic.currencyMismatch': 'A practice is already registered for this account, in {{currency}}. Choose that currency, or change it in the clinic panel.',
    'onboarding.clinic.setupIncomplete': "The practice was created, but its currency could not be set in accounting. Do not register it again \u2014 contact Parsina support to finish the setup.",
    'onboarding.clinic.title': 'Join your clinic',
    'onboarding.clinic.description': 'With the clinic invitation code your appointments and the clinic register open up. You can do this later from your profile.',
    'onboarding.clinic.placeholder': 'Invitation code',
    'onboarding.clinic.join': 'Join',
    'onboarding.clinic.skip': 'Later',
    'onboarding.done.title': 'Welcome',
    'onboarding.done.body': 'Your dental workspace is ready. Today shows the appointments the clinic books for you.',
    'onboarding.done.enter': 'Enter the panel',
    // ── validation ───────────────────────────────────────────────────────────
    'validation.medicalCode': 'Enter your medical council number.',
    'validation.fullName': 'Enter your full name.',
    'validation.invitationCode': 'Enter the invitation code.',
    'validation.officePhone': 'The practice phone is not a complete number. Correct it, or clear the field.',
    // The kit's PhoneInput copy, in this app's two languages. `{{example}}`
    // arrives already wrapped in FSI/PDI, so it reads LTR inside a Persian line.
    'validation.phone.tooShort': "This {{country}} number is short \u2014 example: {{example}}",
    'validation.phone.tooLong': "This {{country}} number is long \u2014 example: {{example}}",
    'validation.phone.invalid': 'That is not a valid number.',
    // ── چارت دندان / odontogram ──────────────────────────────────────────────
    'patient.tabs.plan': 'Treatment plan',
    'patient.plan.empty.title': 'No treatment plan has been recorded for this patient',
    'patient.plan.empty.description': 'A treatment plan is written during a visit.',
    'patient.plan.noLines': 'This course has no lines yet.',
    'patient.plan.doneTitle': 'Treatments performed',
    'patient.plan.outstanding': '{{count}} treatments outstanding \u2014 {{amount}} in total',
    'patient.tabs.chart': 'Dental chart',
    'chart.tooth': 'Tooth',
    'chart.universalShort': 'US #',
    'chart.annotation.planned': 'planned',
    'chart.annotation.treated': 'treated',
    'chart.legend.planned': 'Planned',
    'chart.legend.treated': 'Treated',
    'chart.tooltip.treated': 'Treatments performed',
    'chart.tooltip.andMore': 'and {{count}} more',
    'chart.tooltip.planned': 'Planned',
    'chart.wholeMouth.title': 'Whole mouth',
    'chart.history.title': 'History of tooth {{fdi}}',
    'chart.history.treatment': 'Treatment',
    'chart.history.event': 'Chart',
    'chart.history.causedBy': 'from the treatment above',
    'chart.history.empty': 'Nothing has been recorded for this tooth yet.',
    'chart.history.unavailable': 'This tooth\u2019s history could not be read.',
    'chart.history.session': 'Session {{n}}',
    'chart.history.voided': "Voided \u2014 {{reason}}",
    'chart.notCharted': 'Not charted',
    'chart.patientRight': "PATIENT'S RIGHT",
    'chart.patientLeft': "PATIENT'S LEFT",
    'chart.aria.odontogram': "Dental chart \u2014 click a tooth or a surface to record",
    'chart.hint': 'Click a surface to record it, or the tooth for its whole state.',
    // ── chart, mobile ────────────────────────────────────────────────────────
    // `chart.hint` names a MOUSE action. On a touch screen a crown is ~10px and a
    // surface far less, which is under the 44px floor and cannot be fixed inside
    // the arch without breaking the anatomical frame — so the phone gets its own
    // wording and its own ≥44px tooth picker beneath the chart.
    'chart.mobile.settings': 'Chart settings',
    'chart.mobile.pickTooth': 'Pick a tooth',
    'chart.mobile.tapHint': "Tap a tooth on the chart, or pick one below \u2014 surfaces are recorded in the sheet that opens.",
    'chart.mobile.legend': 'Key',
    'chart.legend.bridge': 'Bridge',
    'chart.legend.wholeToothCaries': 'Whole-tooth caries',
    'chart.export.button': 'Export image',
    'chart.export.error': "Could not export the image \u2014 this browser does not support it.",
    'chart.material': 'Material',
    'chart.isHistorical': 'Existing work (not done today)',
    'chart.showPrimary': 'Show primary teeth',
    'chart.hidePrimary': 'Hide primary teeth',
    'chart.showUniversal': 'Show US numbers',
    'chart.hideUniversal': 'Hide US numbers',
    'chart.error.title': 'Could not load the chart',
    'chart.error.body': 'The dental chart could not be fetched. Please try again.',
    'chart.summary.charted': 'Charted',
    'chart.summary.decayed': 'Decayed',
    'chart.summary.restored': 'Restored',
    'chart.summary.missing': 'Missing',
    'chart.summary.dmft': 'DMFT',
    'chart.presence.title': 'Presence',
    'chart.presence.present': 'Present',
    'chart.presence.extracted': 'Extracted',
    'chart.presence.exfoliated': 'Exfoliated',
    'chart.presence.congenitally_absent': 'Congenitally absent',
    'chart.presence.unerupted': 'Unerupted',
    'chart.presence.impacted': 'Impacted',
    'chart.surfaces.title': 'Surfaces',
    'chart.surfaces.hint': 'Pick a surface, then its state',
    'chart.surfaces.setFor': 'State for',
    'chart.surface.M': 'Mesial',
    'chart.surface.D': 'Distal',
    'chart.surface.F': 'Facial',
    'chart.surface.L': 'Lingual',
    'chart.surface.O': 'Occlusal',
    'chart.surface.I': 'Incisal',
    'chart.surfaceState.sound': 'Sound',
    'chart.surfaceState.caries': 'Caries',
    'chart.surfaceState.restoration': 'Restoration',
    'chart.surfaceState.recurrent_caries': 'Recurrent caries',
    'chart.surfaceState.temporary': 'Temporary',
    'chart.surfaceState.sealant': 'Sealant',
    'chart.surfaceState.fractured': 'Fractured',
    'chart.condition.title': 'Whole tooth',
    'chart.condition.hint': 'Independent of the surfaces above',
    'chart.conditionName.sound': 'Sound',
    'chart.conditionName.caries': 'Caries',
    'chart.conditionName.root_canal': 'Root canal',
    'chart.conditionName.post_core': 'Post & core',
    'chart.conditionName.crown': 'Crown',
    'chart.conditionName.veneer': 'Veneer',
    'chart.conditionName.implant': 'Implant',
    'chart.conditionName.bridge_abutment': 'Bridge abutment',
    'chart.conditionName.bridge_pontic': 'Pontic',
    'chart.conditionName.fracture': 'Fracture',
    'chart.conditionName.attrition': 'Attrition',
    'chart.conditionName.mobility': 'Mobility',
    'chart.conditionName.periapical_lesion': 'Periapical lesion',
    'chart.conditionName.sealant': 'Sealant',
    'chart.conditionName.temporary': 'Temporary',
    'chart.conditionName.watch': 'Watch',
    'chart.note.title': 'Note',
    'chart.note.placeholder': 'Anything worth recording about this tooth',
    'chart.materialName.composite': 'Composite',
    'chart.materialName.amalgam': 'Amalgam',
    'chart.materialName.glass_ionomer': 'Glass ionomer',
    'chart.materialName.zirconia': 'Zirconia',
    'chart.materialName.pfm': 'PFM',
    'chart.materialName.full_metal': 'Full metal',
    'chart.materialName.emax': 'E.max',
    'chart.materialName.temporary': 'Temporary',
    'chart.materialName.gold': 'Gold',
    // ── hover card ──────────────────────────────────────────────────────────
    'chart.primary': 'primary',
    'chart.tooltip.notCharted': 'Nothing recorded for this tooth yet.',
    'chart.tooltip.sound': "Examined \u2014 no findings",
    'chart.tooltip.lastRecorded': 'Last recorded',
    'chart.quadrant.upperRight': "Upper right (patient's)",
    'chart.quadrant.upperLeft': "Upper left (patient's)",
    'chart.quadrant.lowerRight': "Lower right (patient's)",
    'chart.quadrant.lowerLeft': "Lower left (patient's)",
    'chart.toothName.centralIncisor': 'Central incisor',
    'chart.toothName.lateralIncisor': 'Lateral incisor',
    'chart.toothName.canine': 'Canine',
    'chart.toothName.firstPremolar': 'First premolar',
    'chart.toothName.secondPremolar': 'Second premolar',
    'chart.toothName.firstMolar': 'First molar',
    'chart.toothName.secondMolar': 'Second molar',
    'chart.toothName.thirdMolar': 'Third molar (wisdom)',
    // ── جلسهٔ درمان — the visit workspace (docs/dent-visit.md) ────────────────
    //
    // Two columns: a persistent clinical view (odontogram · subjective · طرح
    // درمان) and a tabbed workspace (دارو · دستورات · تشخیص · پرسش · فایل‌ها).
    'visit.error.title': 'The visit could not be opened',
    'visit.error.body': 'We could not read this appointment. Please try again.',
    'visit.notFound.title': 'Visit not found',
    'visit.notFound.description': 'This appointment does not exist, is not yours, or has no patient record attached.',
    'visit.unknownPatient': 'Unnamed patient',
    'visit.openRecord': 'Patient record',
    'visit.finish.action': 'Finish visit',
    'visit.finish.working': "Closing\u2026",
    'visit.finish.confirm.title': 'Close this visit?',
    'visit.finish.confirm.body': 'Anything unsaved is written and the visit is closed. After that it is read-only and this app cannot reopen it.',
    // «نوبت بعدی» — asked only when the visit leaves work planned and not done.
    'visit.finish.followUp.title': '{{count}} treatment(s) left in the plan',
    'visit.finish.followUp.andMore': 'and {{count}} more',
    'visit.finish.followUp.today': 'Today',
    'visit.finish.followUp.tomorrow': 'Tomorrow',
    'visit.finish.followUp.withinWeek': 'Within a week',
    'visit.finish.followUp.within2Weeks': 'Within two weeks',
    'visit.finish.followUp.withinMonth': 'Within a month',
    'visit.finish.followUp.within3Months': 'Within three months',
    'visit.finish.followUp.when': 'By when should the next appointment be?',
    'visit.finish.followUp.none': 'Not needed',
    'visit.finish.followUp.deskNote': 'Reception will be told, so they can book it with you.',
    'visit.finish.followUp.noneNote': 'Reception will not be told anything.',
    'visit.finish.done.plain': 'The visit is closed.',
    'visit.finish.done.followUpRaised': 'The visit is closed. Reception has been asked to book the next one.',
    'visit.finish.done.alreadyBooked': 'The visit is closed. This patient already has a next appointment.',
    'visit.finish.done.followUpFailed': 'The visit is closed, but reception was not told about the next appointment.',
    'visit.finish.error.subjective': 'The note was not saved, so the visit was not closed. Try again.',
    'visit.finish.error.complete': 'The note was saved, but the visit could not be closed. Try again.',
    // A finished visit is READ-ONLY: this app cannot reopen an appointment, so a
    // late write would file a record under a day that is over.
    // ── The video visit ──────────────────────────────────────────────────────
    'visit.call.start': 'Video call',
    'visit.call.title': 'Video call',
    'visit.call.panelLabel': 'Video call panel',
    'visit.call.connecting': "Connecting\u2026",
    // "End call", never "End visit" — closing the visit is one-way and closes the
    // record; hanging up does neither, and the two must never read alike.
    'visit.call.hangUp': 'End call',
    'visit.call.notRecorded': 'This call is not recorded and nothing from it is stored.',
    'visit.call.error.connection': 'The call could not connect. Check the connection and try again.',
    'visit.call.error.unavailable': 'Video visits are not enabled in this environment.',
    'visit.call.error.visitOver': 'This visit is closed, so a video call cannot be placed on it.',
    'visit.readOnly.badge': 'Read-only',
    'visit.readOnly.note': 'This visit is closed, so nothing further can be recorded against it. Everything already on record is still shown.',
    // Every AI action is a button, never automatic — each one bills a credit.
    'visit.ai.costsCredits': 'Uses AI credit.',
    'visit.tabs.meds': 'Medication',
    'visit.tabs.orders': 'Orders',
    'visit.tabs.diagnosis': 'Diagnosis',
    'visit.tabs.questions': 'Questions',
    'visit.tabs.files': 'Files',
    'visit.tabs.sectionsLabel': 'Visit sections',
    // ── §3.1.1 odontogram ───────────────────────────────────────────────────
    'visit.chart.title': 'Dental chart',
    'visit.chart.hint': 'Select a tooth to see its findings and what is planned on it.',
    'visit.chart.tooth': 'Tooth {{fdi}}',
    'visit.chart.openTooth': 'Findings',
    'visit.chart.planForTooth': 'Add to plan',
    'visit.chart.noPlanForTooth': 'Nothing planned on this tooth.',
    'visit.chart.history': 'History',
    'visit.chart.noHistory': 'Nothing has been recorded for this tooth.',
    'visit.chart.historyUnavailable': 'The history could not be loaded.',
    'visit.chart.historical': 'pre-existing',
    // ── §3.1.2 subjective ───────────────────────────────────────────────────
    'visit.subjective.title': 'Patient subjective',
    'visit.subjective.error.title': 'The note could not be loaded',
    'visit.subjective.error.body': "We could not read this visit\u2019s note. Please try again.",
    'visit.subjective.saved': 'Saved',
    'visit.subjective.saveFailed': 'The note could not be saved. Please try again.',
    'visit.subjective.history': 'Patient history',
    'visit.subjective.noAllergies': 'No allergies on record',
    'visit.subjective.conditions': 'Conditions',
    'visit.subjective.medications': 'Medication',
    'visit.subjective.chiefComplaint': 'Chief complaint',
    'visit.subjective.dictateComplaint': 'Dictate the chief complaint',
    'visit.subjective.dictateNotes': 'Dictate the note',
    'visit.subjective.teeth': 'Teeth involved',
    'visit.subjective.noTeeth': 'Tap the teeth on the chart above',
    'visit.subjective.addTooth': 'Add tooth {{fdi}}',
    'visit.subjective.selectToothFirst': 'Select a tooth on the chart',
    'visit.subjective.painScore': "Pain (0\u201310)",
    'visit.subjective.painCharacter': 'Pain character',
    'visit.subjective.pain.sharp': 'Sharp',
    'visit.subjective.pain.dull': 'Dull',
    'visit.subjective.pain.throbbing': 'Throbbing',
    'visit.subjective.pain.sensitivity': 'Sensitivity',
    'visit.subjective.pain.none': 'No pain',
    'visit.subjective.onset': 'Onset',
    'visit.subjective.duration': 'Duration',
    'visit.subjective.aggravating': 'Made worse by',
    'visit.subjective.relieving': 'Relieved by',
    'visit.subjective.dentalHistory': 'Dental history',
    'visit.subjective.notes': 'Notes',
    'visit.subjective.priorVisits': 'Previous visits',
    'visit.subjective.noPriorVisits': 'No previous visits on record.',
    'visit.subjective.priorNoSummary': 'No complaint recorded',
    'visit.subjective.priorDiagnoses': '{{count}} diagnoses',
    // ── §3.1.3 treatment plan ───────────────────────────────────────────────
    'visit.plan.title': 'Treatment plan',
    'visit.plan.error.title': 'The plan could not be loaded',
    'visit.plan.error.body': "We could not read this patient\u2019s treatment plan. Please try again.",
    // Clinic-currency refusals, by extensions.code (CLINIC_CURRENCY_UNAVAILABLE,
    // CURRENCY_MISMATCH). Never an exchange rate: two currencies are not combined.
    'visit.plan.error.currencyUnavailable': "The practice\u2019s currency could not be read, and without it the plan\u2019s amounts cannot be shown. Please try again.",
    'visit.plan.error.currencyMismatch': "These amounts are not in the practice\u2019s currency, and amounts in different currencies are never added together. Ask the practice manager to check the practice\u2019s currency.",
    'visit.plan.saveFailed': 'The plan could not be saved.',
    'visit.plan.empty.title': 'No plan yet',
    'visit.plan.empty.description': 'Add the treatments you intend to carry out, tooth by tooth.',
    'visit.plan.add': 'Add treatment',
    'visit.plan.added': "\u201C{{what}}\u201D was added to the treatment plan.",
    'visit.plan.addedForTooth': "\u201C{{what}}\u201D was added to the treatment plan for tooth {{fdi}}.",
    'visit.chart.planFormOpened': "Add form opened for tooth {{fdi}} \u2014 choose the treatment.",
    'visit.plan.addItem': 'Add to plan',
    'visit.plan.service': 'Treatment',
    'visit.plan.choose': "Choose a treatment\u2026",
    'visit.plan.tooth': 'Tooth',
    'visit.plan.wholeMouth': 'Whole mouth',
    'visit.plan.wholeMouthShort': 'Mouth',
    'visit.plan.phase': 'Phase',
    'visit.plan.description': 'Description',
    'visit.plan.untitledItem': 'Untitled treatment',
    'visit.plan.changeStatus': 'Change status of {{item}}',
    'visit.plan.remove': 'Remove {{item}}',
    'visit.plan.showOnChart': 'Show on the chart',
    // Approval is the one irreversible call: amounts become whole rials once, the
    // totals are computed and the signed document is frozen.
    'visit.plan.surfaces': 'Surfaces',
    'visit.plan.sessions': 'Sessions',
    'visit.plan.sessionsOf': 'Session {{done}} of {{total}}',
    // Key kept from when every amount was toman. `{{unit}}` is "toman" for IRR
    // (common.units.toman), and the ISO code — "AED" — for any other currency.
    'visit.plan.toman': '{{amount}} {{unit}}',
    'visit.plan.noTariff': 'No tariff set',
    'visit.plan.outstanding': 'Outstanding: {{amount}}',
    // A service the clinic prices in another currency than the plan's. It is
    // never converted, so it is never priced into this plan. `{{currency}}` and
    // `{{planCurrency}}` are ISO codes ("IRR", "AED"): a name would put "toman"
    // on a plan counted in dirhams.
    'visit.plan.otherCurrency': 'Tariff in another currency ({{currency}})',
    'visit.plan.otherCurrencyRefused': "The tariff of \u201C{{name}}\u201D is in {{currency}}, so it cannot be added to a plan in {{planCurrency}}.",
    // «ثبت انجام» — what was actually DONE, as against what was quoted.
    'visit.record.openVisit': 'Open visit',
    'visit.record.open': 'Record as done',
    'visit.record.openSession': 'Record session',
    'visit.record.title': "Record as done \u2014 {{treatment}}",
    'visit.record.subtitle': 'Records what was done in this visit. This is the clinical record.',
    'visit.record.service': 'Treatment performed',
    'visit.record.tooth': 'Tooth',
    'visit.record.surfaces': 'Surfaces',
    'visit.record.material': 'Material',
    'visit.record.noMaterial': 'No material',
    'visit.record.note': 'What was done',
    'visit.record.notePlaceholder': 'Briefly, what was done',
    'visit.record.outcome': 'Outcome',
    'visit.record.outcome.completed': 'Completed',
    'visit.record.outcome.inProgress': 'Continues next session',
    'visit.record.chartEffect': 'Tooth state after treatment',
    'visit.record.chartEffect.none': 'Leave the chart unchanged',
    'visit.record.chartEffect.noneDetail': 'Nothing will be written to the dental chart.',
    'visit.record.chartEffect.detail': "Tooth {{tooth}} will be charted as \u201C{{state}}\u201D.",
    'visit.record.chartEffect.detailSurfaces': "Surfaces {{surfaces}} of tooth {{tooth}} will be charted as \u201C{{state}}\u201D.",
    'visit.record.chartEffect.needsSurfaces': 'Pick the surfaces that were treated, or nothing will be written to the chart.',
    'visit.record.chartEffect.surfaceOption': "Surfaces \u2014 {{state}}",
    'visit.record.chartEffect.inProgress': 'This session does not finish the treatment, so by default nothing is charted.',
    'visit.record.billingNote': 'Billing and stock are separate writes made after this one; this form records no amount.',
    'visit.record.save': 'Record',
    'visit.record.saved': "\u201C{{what}}\u201D recorded.",
    'visit.record.failed': 'The treatment could not be recorded.',
    'visit.record.doneHere': 'Done in this visit ({{count}})',
    'visit.record.void': 'Void',
    'visit.record.voidReason': 'Reason for voiding',
    'visit.record.voidedFor': "Voided \u2014 {{reason}}",
    'visit.record.voidConfirm.title': "Void \u201C{{what}}\u201D?",
    'visit.record.voidConfirm.body': 'The row is not deleted: it stays in the record, struck through, with the reason you give. A reason is required.',
    'visit.record.notBilled': 'Not on the bill',
    'visit.record.voidConfirm.alsoChart': 'Also void what this wrote to tooth {{tooth}} on the chart',
    'visit.record.voidConfirm.stillBilled': 'This treatment is already charged on the patient\u2019s invoice. Voiding it takes the charge back automatically \u2014 as a negative correction line if the invoice has been issued.',
    'visit.record.voidCharge.notReversed': 'The treatment was voided, but its charge could not be taken off the invoice. Ask the cash desk to correct it.',
    'visit.record.billed': 'Added to this visit\u2019s invoice.',
    'visit.plan.noServices.title': 'This clinic has not defined any services yet',
    'visit.plan.noServices.body': 'Treatment plan lines come from the clinic\u2019s services. Define and price the dental services in the clinic panel.',
    'visit.plan.noServices.action': 'Define services in the clinic panel',
    'visit.plan.catalogUnavailable': 'The clinic\u2019s service list could not be read. This does not mean there are none \u2014 try again.',
    'visit.plan.applicability.unset': 'Not specified',
    'visit.plan.applicability.tooth': 'One tooth',
    'visit.plan.applicability.surfaces': 'Surfaces of one tooth',
    'visit.plan.applicability.quadrant': 'One quadrant',
    'visit.plan.applicability.arch': 'One arch',
    'visit.plan.applicability.mouth': 'Whole mouth',
    'visit.plan.newService.title': 'New service',
    'visit.plan.newService.subtitle': 'Added to the clinic\u2019s services, and offered to every colleague from then on.',
    'visit.plan.newService.name': 'Service name',
    'visit.plan.newService.category': 'Group',
    'visit.plan.newService.chartEffect': 'Effect on the chart',
    'visit.plan.newService.applicability': 'Applies to',
    'visit.plan.newService.tariff': 'Tariff per session ({{unit}})',
    'visit.plan.newService.duration': 'Minutes per session',
    'visit.plan.newService.tariffHint': 'The tariff may be left empty; the service is saved with no tariff and is not billed until one is set.',
    'visit.plan.newService.clinicOnly.title': 'Completed in the clinic panel',
    'visit.plan.newService.clinicOnly.body': 'Consumables, other costs, commission and insurance.',
    'visit.plan.newService.save': 'Save and select',
    'visit.plan.newService.created': '\u201c{{name}}\u201d was added to the clinic\u2019s services.',
    'visit.plan.newService.nameRequired': 'A service name is required.',
    'visit.plan.newService.failed': 'The service could not be saved.',
    'visit.plan.newService.badTariff': 'The tariff must be a number, in {{unit}}.',
    'visit.plan.newService.currencyUnknown': "This practice\u2019s currency could not be read, so the tariff cannot be entered here. The service is saved with no tariff; set it in the clinic panel.",
    'visit.plan.noClinic': 'This visit is not attached to a clinic; without one, services and tariffs cannot be read.',
    'common.form.optional': '(optional)',
    'visit.plan.locked': 'Signed',
    'visit.plan.startNew': 'Start a new course',
    'visit.plan.lockedNextStep': 'Adding a treatment starts a new course.',
    'visit.plan.lockedNote': 'This plan has been approved and signed, so its lines can no longer be changed. Treatments can still be marked as done.',
    'visit.plan.phases.emergency': 'Emergency',
    'visit.plan.phases.phase1': 'Phase 1',
    'visit.plan.phases.phase2': 'Phase 2',
    'visit.plan.phases.maintenance': 'Maintenance',
    // The service's five item states. The document names three (Pending,
    // Scheduled, Completed); these are the ones that actually get stored.
    'visit.plan.status.proposed': 'Proposed',
    'visit.plan.status.accepted': 'Accepted',
    'visit.plan.status.done': 'Done',
    'visit.plan.status.rejected': 'Declined',
    'visit.plan.status.deferred': 'Deferred',
    'visit.plan.planStatus.draft': 'Draft',
    'visit.plan.planStatus.proposed': 'Proposed',
    'visit.plan.planStatus.approved': 'Approved',
    'visit.plan.planStatus.in_progress': 'In progress',
    'visit.plan.planStatus.completed': 'Completed',
    'visit.plan.planStatus.abandoned': 'Abandoned',
    // ── §3.2.1 medication ───────────────────────────────────────────────────
    'visit.meds.empty.title': 'Nothing prescribed yet',
    'visit.meds.empty.description': 'Search the formulary above to add a medication to this visit.',
    'visit.meds.thisVisit': 'Prescribed in this visit',
    'visit.meds.current': 'Current medication',
    'visit.meds.suggest': 'AI suggestions',
    'visit.meds.suggesting': "Analysing\u2026",
    'visit.meds.suggestions': 'Suggested medication',
    'visit.meds.suggestClose': 'Dismiss suggestions',
    'visit.meds.suggestAdd': 'Add to prescription',
    'visit.meds.suggestAdded': 'Added',
    'visit.meds.noSuggestions': 'Nothing to suggest. Record this visit\u2019s diagnosis or assessment first \u2014 the analysis reads what has been written for this visit.',
    'visit.meds.suggestUnavailable': 'AI suggestions are unavailable.',
    'visit.meds.followUp': 'Follow-up:',
    // ── §3.2.2 orders — dental lab and imaging only ─────────────────────────
    'visit.orders.error.title': 'Orders could not be loaded',
    'visit.orders.error.body': "We could not read this visit\u2019s orders. Please try again.",
    'visit.orders.saveFailed': 'The order could not be saved.',
    'visit.orders.empty.title': 'No orders in this visit',
    'visit.orders.empty.description': 'Request a radiograph or send a case to the lab.',
    'visit.orders.type': 'Order type',
    'visit.orders.types.imaging': 'Imaging',
    'visit.orders.types.lab': 'Laboratory',
    'visit.orders.types.dental_lab': 'Dental laboratory',
    'visit.orders.service': 'Service',
    'visit.orders.serviceScope': "\u201C{{type}}\u201D services only",
    'visit.orders.choose': "Choose a service\u2026",
    'visit.orders.description': 'Description',
    'visit.orders.descriptionHint': 'Leave blank to use the service name',
    'visit.orders.notes': 'Notes for the lab / radiology',
    'visit.orders.urgency': 'Urgency',
    'visit.orders.urgencies.routine': 'Routine',
    'visit.orders.urgencies.urgent': 'Urgent',
    'visit.orders.urgencies.stat': 'Immediate',
    'visit.orders.sessions': 'Sessions',
    'visit.orders.sessionCount': '{{count}} sessions',
    'visit.orders.add': 'Place order',
    'visit.orders.statuses.pending': 'Pending',
    'visit.orders.statuses.in_progress': 'In progress',
    'visit.orders.statuses.completed': 'Completed',
    'visit.orders.statuses.cancelled': 'Cancelled',
    'visit.orders.transitions.start': 'Start',
    'visit.orders.transitions.complete': 'Mark done',
    'visit.orders.transitions.cancel': 'Cancel',
    'visit.orders.suggest': 'AI suggestions',
    'visit.orders.suggesting': "Analysing\u2026",
    'visit.orders.suggestions': 'Suggested orders',
    'visit.orders.suggestClose': 'Dismiss suggestions',
    'visit.orders.suggestAdd': 'Place order',
    'visit.orders.suggestAdded': 'Placed',
    'visit.orders.noSuggestions': 'Nothing to suggest. Record this visit\u2019s diagnosis or assessment first \u2014 the analysis reads what has been written for this visit.',
    'visit.orders.suggestUnavailable': 'AI suggestions are unavailable.',
    'visit.orders.suggestDropped': '{{count}} suggestion(s) fell outside the dental catalogue and were not shown.',
    // ── §3.2.3 diagnosis, with click-to-reveal traceability ─────────────────
    'visit.diagnosis.error.title': 'Diagnoses could not be loaded',
    'visit.diagnosis.error.body': "We could not read this visit\u2019s diagnoses. Please try again.",
    'visit.diagnosis.saveFailed': 'The diagnosis could not be saved.',
    'visit.diagnosis.empty.title': 'No diagnosis recorded',
    'visit.diagnosis.empty.description': 'Record what you have concluded, and the findings it rests on are stored with it.',
    'visit.diagnosis.name': 'Diagnosis',
    'visit.diagnosis.code': 'ICD code',
    'visit.diagnosis.certainty': 'Certainty',
    'visit.diagnosis.verification.provisional': 'Provisional',
    'visit.diagnosis.verification.confirmed': 'Confirmed',
    'visit.diagnosis.add': 'Record diagnosis',
    'visit.diagnosis.remove': 'Remove {{name}}',
    'visit.diagnosis.willAttach': '{{count}} supporting findings will be stored with this diagnosis.',
    // The disclosure §3.2.3 requires: every entry reveals what it was derived from.
    'visit.diagnosis.evidence': 'Evidence ({{count}})',
    'visit.diagnosis.noEvidence': 'No supporting findings were recorded with this diagnosis.',
    'visit.diagnosis.evidenceKind.subjective': 'Subjective',
    'visit.diagnosis.evidenceKind.history': 'History',
    'visit.diagnosis.evidenceKind.chart': 'Chart',
    'visit.diagnosis.evidenceKind.file': 'Document',
    'visit.diagnosis.evidenceKind.order': 'Order',
    'visit.diagnosis.evidenceKind.ai': 'AI analysis',
    'visit.diagnosis.showTooth': 'Show tooth',
    'visit.diagnosis.toothEvidence': 'Findings on tooth {{fdi}}',
    'visit.diagnosis.aiAssisted': 'AI-assisted',
    'visit.diagnosis.suggest': 'AI suggestions',
    'visit.diagnosis.suggesting': "Analysing\u2026",
    'visit.diagnosis.suggestions': 'Suggested diagnoses',
    'visit.diagnosis.noSuggestions': "No suggestions. Record the subjective first \u2014 the analysis reads what has been written for this visit.",
    'visit.diagnosis.suggestUnavailable': 'AI suggestions are unavailable right now.',
    'visit.diagnosis.accept': 'Record',
    'visit.diagnosis.alreadyRecorded': 'Recorded',
    'visit.diagnosis.confidence.high': 'High confidence',
    'visit.diagnosis.confidence.medium': 'Medium confidence',
    'visit.diagnosis.confidence.low': 'Low confidence',
    // ── SOAP assistant — the diagnosis tab ──────────────────────────────────
    'visit.soap.title': 'Note assistant',
    // "When you stop", not "then press the button": there is no separate button
    // any more — stopping the recording sends the analysis, and the stop
    // button's own label says so.
    'visit.soap.description': 'Say what happened in the session; when you stop, the assistant completes the note sections and advises on the problem. Nothing is recorded until you approve it.',
    // Not 'Dictate the note' — visit.subjective.dictateNotes already owns that
    // accessible name, and two controls answering to it breaks anyone querying
    // by role.
    'visit.soap.speak': 'Dictate the session',
    'visit.soap.speakStop': 'Finish and get advice',
    'visit.soap.analyzing': "Analyzing\u2026",
    'visit.soap.heard': 'What was heard:',
    'visit.soap.retry': 'Send again',
    'visit.soap.voiceUnavailable': 'Dictation needs a microphone and a secure (HTTPS) connection, and is not available in this browser.',
    'visit.soap.draftTitle': 'Proposed note draft',
    'visit.soap.sections.s': "Subjective (S) \u2014 appended to notes",
    'visit.soap.sections.o': 'Examination & findings (O)',
    'visit.soap.sections.a': 'Assessment (A)',
    'visit.soap.sections.p': 'Treatment plan (P)',
    'visit.soap.apply': 'Apply to the patient note',
    'visit.soap.applied': 'Written into the patient note.',
    'visit.soap.applyFailed': 'Applying the draft failed.',
    'visit.soap.dismiss': 'Dismiss',
    'visit.soap.noNews': 'Nothing new to add to the note.',
    'visit.soap.refineUnavailable': 'Note completion is unavailable.',
    'visit.soap.adviceTitle': 'Assistant advice',
    'visit.soap.adviceUnavailable': 'AI advice is unavailable.',
    'visit.soap.suggestedDiagnosis': 'Suggested diagnosis',
    'visit.soap.recordDiagnosis': 'Record as diagnosis',
    'visit.soap.accepted': "Accepted \u2014 recorded in this visit\u2019s diagnoses.",
    'visit.soap.actions': 'Suggested actions',
    'visit.soap.medications': 'Suggested medications',
    'visit.soap.aiEvidence': 'Derived from the session narrative analysis',
    // ── Per-tooth findings from the narrative → the dental chart ──────────────
    'visit.soap.teeth.title': 'Tooth findings',
    'visit.soap.teeth.description': 'These were read out of the session narrative as being about specific teeth. Whichever you confirm is recorded on the dental chart; the rest are not recorded.',
    'visit.soap.teeth.lowConfidenceHint': "Low-confidence rows are left unticked \u2014 check the tooth number before recording.",
    'visit.soap.teeth.tooth': 'Tooth {{fdi}}',
    'visit.soap.teeth.surface': 'Surface {{surface}}',
    'visit.soap.teeth.historical': 'History',
    'visit.soap.teeth.record': 'Record on chart ({{count}})',
    'visit.soap.teeth.recording': "Recording\u2026",
    'visit.soap.teeth.recorded': 'Recorded on the dental chart.',
    'visit.soap.teeth.recordFailed': 'Could not record on the dental chart.',
    'visit.soap.teeth.none': 'No specific tooth finding was found in the narrative.',
    'visit.soap.teeth.unavailable': 'Reading tooth findings is unavailable.',
    'visit.soap.teeth.confidence.high': 'High confidence',
    'visit.soap.teeth.confidence.medium': 'Medium confidence',
    'visit.soap.teeth.confidence.low': 'Low confidence',
    'tooth.aspect.presence': 'Tooth presence',
    'tooth.aspect.condition': 'Tooth condition',
    'tooth.aspect.surface': 'Surface state',
    'tooth.value.sound': 'Sound',
    'tooth.value.caries': 'Caries',
    'tooth.value.root_canal': 'Root canal',
    'tooth.value.post_core': 'Post and core',
    'tooth.value.crown': 'Crown',
    'tooth.value.veneer': 'Veneer',
    'tooth.value.implant': 'Implant',
    'tooth.value.bridge_abutment': 'Bridge abutment',
    'tooth.value.bridge_pontic': 'Pontic',
    'tooth.value.fracture': 'Fracture',
    'tooth.value.attrition': 'Attrition',
    'tooth.value.mobility': 'Mobility',
    'tooth.value.periapical_lesion': 'Periapical lesion',
    'tooth.value.sealant': 'Sealant',
    'tooth.value.temporary': 'Temporary',
    'tooth.value.watch': 'Watch',
    'tooth.value.restoration': 'Restoration',
    'tooth.value.recurrent_caries': 'Recurrent caries',
    'tooth.value.fractured': 'Fractured',
    'tooth.value.present': 'Present',
    'tooth.value.extracted': 'Extracted',
    'tooth.value.exfoliated': 'Exfoliated',
    'tooth.value.congenitally_absent': 'Congenitally absent',
    'tooth.value.unerupted': 'Unerupted',
    'tooth.value.impacted': 'Impacted',
    'tooth.material.composite': 'Composite',
    'tooth.material.amalgam': 'Amalgam',
    'tooth.material.glass_ionomer': 'Glass ionomer',
    'tooth.material.zirconia': 'Zirconia',
    'tooth.material.pfm': 'PFM',
    'tooth.material.full_metal': 'Full metal',
    'tooth.material.emax': 'E.max',
    'tooth.material.temporary': 'Temporary',
    'tooth.material.gold': 'Gold',
    // ── §3.2.4 questions — the clinical assistant ───────────────────────────
    'visit.questions.title': 'Clinical assistant',
    'visit.questions.forDiagnoses': 'Questions that would confirm or exclude: {{list}}',
    'visit.questions.noDiagnosesYet': "No diagnosis recorded yet \u2014 the assistant will ask about the complaint you have written.",
    'visit.questions.generate': 'Find the gaps',
    'visit.questions.generating': "Thinking\u2026",
    'visit.questions.unavailable': 'The clinical assistant is unavailable right now.',
    'visit.questions.fallbackNote': 'These are general questions rather than ones written for this patient.',
    'visit.questions.empty.title': 'No open questions',
    'visit.questions.empty.description': 'Nothing further is needed to support the current diagnoses.',
    'visit.questions.count': '{{count}} questions',
    'visit.questions.yes': 'Yes',
    'visit.questions.no': 'No',
    // Answering RECORDS a finding into the note — that is what makes this a
    // workflow rather than a list of prompts.
    'visit.questions.recorded': 'Recorded: {{statement}}',
    'visit.questions.recordFailed': 'The answer could not be recorded in the note.',
    'visit.questions.askTitle': 'Ask the assistant',
    'visit.questions.askPlaceholder': "Ask about this patient\u2026",
    'visit.questions.ask': 'Ask',
    'visit.questions.asking': "Asking\u2026",
    'visit.questions.followUps': 'Follow-up',
    // ── §3.2.5 files, and the report each one produced ──────────────────────
    // ── فایل‌ها: what kind of thing is being uploaded ────────────────────────
    'visit.files.kind': 'What is this?',
    'visit.files.kinds.image': 'Dental image',
    'visit.files.kinds.document': 'Document',
    'visit.files.viewType': 'View',
    'visit.files.viewTypes.periapical': 'Periapical (PA)',
    'visit.files.viewTypes.bitewing': 'Bitewing (BW)',
    'visit.files.viewTypes.panoramic': 'Panoramic (OPG)',
    'visit.files.viewTypes.ceph': 'Cephalometric',
    'visit.files.viewTypes.photo': 'Photograph',
    'visit.files.plainUploadNote': 'Uploading only stores the file. Text extraction and image reading are separate actions.',
    'visit.files.unsupportedImage': 'This image format cannot be displayed. Use JPEG or PNG.',
    'visit.files.openImage': 'Open image',
    'visit.files.extract': 'Extract text',
    'visit.files.extracting': "Extracting\u2026",
    // ── The image workspace ─────────────────────────────────────────────────
    'visit.image.back': 'Back to files',
    'visit.image.tools': 'Drawing tools',
    'visit.image.tool.cursor': 'Select',
    'visit.image.tool.pin': 'Pin',
    'visit.image.tool.box': 'Box',
    'visit.image.tool.ellipse': 'Circle',
    'visit.image.tool.arrow': 'Arrow',
    'visit.image.tool.freehand': 'Freehand',
    'visit.image.color': 'Pen colour',
    'visit.image.colorName.E11D48': 'Red',
    'visit.image.colorName.F59E0B': 'Amber',
    'visit.image.colorName.0EA5A0': 'Teal',
    'visit.image.colorName.2563EB': 'Blue',
    'visit.image.zoomIn': 'Zoom in',
    'visit.image.zoomOut': 'Zoom out',
    'visit.image.fit': 'Reset view',
    'visit.image.brightness': 'Brightness',
    'visit.image.contrast': 'Contrast',
    'visit.image.read': 'Read image',
    'visit.image.reading': "Reading\u2026",
    'visit.image.readStatus.no_findings': 'The assistant found nothing reportable in this image. You were not charged.',
    'visit.image.readStatus.no_image': 'The image could not be read.',
    'visit.image.comment': 'Note on this mark',
    'visit.image.commentPlaceholder': 'What did you see here?',
    'visit.image.removeMark': 'Delete this mark',
    'visit.image.tooManyMarks': 'An image can hold at most {{max}} marks.',
    'visit.image.saveFailed': 'The marks could not be saved.',
    'visit.image.unsaved': "Unsaved marks \u2014 press Save.",
    'visit.image.findings': 'What the assistant read',
    'visit.image.findingsNote': 'Suggestions. Nothing is charted until you confirm it.',
    'visit.image.confidence.high': 'Clear',
    'visit.image.confidence.medium': 'Probable',
    'visit.image.confidence.low': 'Uncertain',
    'visit.image.notLocalized': 'location not identified',
    'visit.image.unlocalizedNote': '{{count}} finding(s) could not be placed on the image and are listed only.',
    'visit.image.confirm': 'Confirm',
    'visit.files.openFile': 'Open file',
    'visit.image.register': 'Register',
    'visit.image.registering': "Registering\u2026",
    'visit.image.notRegistered.title': 'Not registered as a dental image',
    'visit.image.notRegistered.body': "You can view it. Marking it up and having the assistant read it need a view type \u2014 a bitewing and a photograph do not show the same things.",
    'visit.image.changeView': 'Change view',
    'visit.image.viewType.title': 'View type',
    'visit.image.viewType.body': "This decides what the assistant may report \u2014 a bitewing does not show a periapical lesion, and a photograph shows no bone. Correct it if it is wrong.",
    'visit.image.discard.title': 'Discard the marks you drew?',
    'visit.image.discard.body': 'They have not been saved and there is no other copy of them.',
    'visit.image.discard.confirm': 'Discard',
    'visit.files.error.title': 'Files could not be loaded',
    'visit.files.error.body': "We could not read this patient\u2019s documents. Please try again.",
    'visit.files.empty.title': 'No documents',
    'visit.files.empty.description': 'Upload a radiograph, a lab result or a referral letter.',
    'visit.files.upload': 'Upload document',
    'visit.files.uploading': "Uploading\u2026",
    'visit.files.uploadFailed': 'The document could not be uploaded.',
    'visit.files.readFailed': 'The file could not be read.',
    'visit.files.tooLarge': 'The file is larger than 15 MB.',
    'visit.files.docType': 'Document type',
    'visit.files.docTypes.lab_report': 'Lab report',
    'visit.files.docTypes.prescription': 'Prescription',
    'visit.files.docTypes.general': 'Other',
    'visit.files.attachTooth': 'Attach to tooth {{fdi}}',
    'visit.files.thisVisit': 'This visit',
    // The pairing §3.2.5 asks for: the report lives inside its own file's card.
    'visit.files.hasReport': 'Report',
    'visit.files.noReport': 'No report was extracted from this document.',
    'visit.files.previewFailed': 'The file could not be opened.',
    'visit.files.bytesGone': 'The original file is no longer stored; only its report remains.',
    'visit.files.remove': 'Delete {{name}}',
    'visit.files.units.b': 'B',
    'visit.files.units.kb': 'KB',
    'visit.files.units.mb': 'MB',
    // ── credits (اعتبار) ──────────────────────────────────────────────────────
    // The unit is «پارسه» / "Parseh" in BOTH locales — never «سکه», never "coin",
    // never the Latin "PC". Toman appears only where the number is a price.
    'credits.title': 'Parsina credit',
    'credits.subtitle': 'Your Parseh balance, what it was spent on, and how to add more.',
    'credits.unit': 'Parseh',
    'credits.toman': 'toman',
    'credits.tomanShort': 'T',
    'credits.currentBalance': 'Current balance',
    'credits.buy': 'Buy Parseh',
    'credits.topUp': 'Top up',
    'credits.percent': '{{value}}%',
    'credits.timesUsed': "{{count}}\xd7",
    'credits.itemCount': '{{count}} entries',
    'credits.minutesUsed': '{{count}} min',
    'credits.byService': 'Where it went',
    'credits.transactions': 'Transactions',
    // Balance levels. `*Short` is the level on its own, for a chip too narrow for
    // the full phrase — the phone header uses it.
    'credits.level.low': 'Low balance',
    'credits.level.lowShort': 'Low',
    'credits.level.mid': 'Getting low',
    'credits.level.midShort': 'Fair',
    'credits.level.ok': 'Healthy balance',
    'credits.level.okShort': 'Good',
    'credits.banner.low': 'Only {{coins}} Parseh left. The assistant stops when it runs out.',
    'credits.banner.mid': "{{coins}} Parseh left \u2014 enough for a few more sessions.",
    // Service families, as the wallet knows them. The finer name of an action
    // comes from the transaction itself; these are the family it belongs to.
    'credits.service.assistant': 'Clinical assistant',
    'credits.service.interaction': 'Interaction check',
    'credits.service.transcription': 'Transcription',
    'credits.service.topUp': 'Top-up',
    'credits.service.gift': 'Gift code',
    'credits.service.sms': 'SMS',
    'credits.service.ai': 'AI service',
    'credits.filter.label': 'Filter transactions',
    'credits.filter.all': 'All',
    'credits.filter.spend': 'Spent',
    'credits.filter.topUp': 'Added',
    'credits.group.label': 'Group by',
    'credits.group.day': 'Day',
    'credits.group.type': 'Service',
    'credits.range.label': 'Date range',
    'credits.range.all': 'All time',
    'credits.range.days7': 'Last 7 days',
    'credits.range.days30': 'Last 30 days',
    'credits.range.thisMonth': 'This month',
    'credits.time.today': 'Today',
    'credits.time.yesterday': 'Yesterday',
    'credits.kpi.month': 'Spent this month',
    'credits.kpi.perVisit': 'Per session',
    'credits.kpi.topService': 'Biggest consumer',
    'credits.showingRange': "Showing {{from}}\u2013{{to}} of {{total}}",
    'credits.pager.page': 'Page {{page}} of {{total}}',
    'credits.pager.previous': 'Previous',
    'credits.pager.next': 'Next',
    'credits.empty.title': 'No transactions yet',
    'credits.empty.hint': 'Every assistant action in a session appears here.',
    'credits.empty.filtered': 'Nothing in this range',
    'credits.empty.filteredHint': 'Try a wider date range or a different filter.',
    'credits.error.title': 'Transactions unavailable',
    'credits.error.body': 'Your balance could not be read. Nothing has been charged.',
    // The price list. One row per action a dentist can actually take in this app —
    // there is no transcription row, because this app does not transcribe.
    'credits.priceList.title': 'What each action costs',
    'credits.priceList.hint': "Charged only when you press the button \u2014 nothing runs on its own.",
    'credits.priceList.viewAll': 'Show all',
    // The list's only metered row. The service rounds up, so even the shortest
    // dictation is charged as a full minute.
    'credits.price.transcription': 'Voice dictation (speech to text)',
    'credits.price.differential': 'AI diagnosis suggestion',
    'credits.price.advice': 'Assistant advice',
    'credits.price.soap': 'Complete the note',
    'credits.price.teeth': 'Tooth findings from the narrative',
    'credits.price.confirmq': 'Confirmation questions',
    'credits.price.ask': 'Ask the assistant',
    'credits.price.ocr': 'Read an uploaded document',
    'credits.price.interaction': 'Drug interaction check',
    // Top-up
    'credits.topUp.chooseAmount': 'Choose an amount',
    'credits.topUp.recommended': 'Recommended',
    'credits.topUp.approxVisits': 'About {{count}} sessions with the assistant',
    'credits.topUp.custom': 'Another amount',
    'credits.topUp.customAria': 'Amount',
    'credits.topUp.payVia': 'Pay {{amount}} toman via {{gateway}}',
    'credits.topUp.enterAmount': 'Enter an amount',
    'credits.topUp.redirecting': "Going to the gateway\u2026",
    'credits.topUp.redirectNote': 'You will be taken to the bank gateway and returned here afterwards.',
    'credits.topUp.minimum': 'The smallest purchase is {{amount}} toman.',
    'credits.topUp.failed': 'The payment could not be started. Please try again.',
    'credits.topUp.failedWithReason': 'The payment could not be started: {{reason}}',
    'credits.gateway.saderat': 'Saderat Bank',
    'credits.gateway.zarinpal': 'Zarinpal',
    'credits.payment.done': "Payment successful \u2014 your balance has been topped up.",
    'credits.payment.failed': 'The payment did not go through. Nothing was charged.',
    // Gift codes
    'credits.gift.title': 'Gift code',
    'credits.gift.hint': 'Have a code from a Parsina campaign? Enter it here and the Parseh lands in your balance.',
    'credits.gift.placeholder': 'PARSINA-1404-XXXX',
    'credits.gift.submit': 'Redeem',
    'credits.gift.submitting': "Redeeming\u2026",
    'credits.gift.empty': 'Enter the code first.',
    'credits.gift.notFound': 'This code is not valid. Enter it exactly as you received it.',
    'credits.gift.oneUse': 'Each code can be used once.',
    'credits.gift.success': '{{parseh}} Parseh added',
    'credits.gift.successSub': 'About {{visits}} sessions with the assistant.',
    'credits.gift.newBalance': 'New balance',
    'credits.gift.myCodes': 'Your codes',
    'credits.gift.worth': "{{parseh}} Parseh \u2014 about {{visits}} sessions",
    'credits.gift.status.issued': 'Unused',
    'credits.gift.status.redeemed': 'Used',
    'credits.gift.status.revoked': 'Revoked',
    'credits.gift.status.expired': 'Expired',
    // Low-balance alert. NOT the red floor this screen paints below 50 Parseh —
    // that is a colour rule; this is what the wallet sends a message about.
    'credits.lowBalance.title': 'Low-balance alert',
    'credits.lowBalance.hint': 'We will let you know when your balance falls below this.',
    'credits.lowBalance.toggleAria': 'Enable low-balance alerts',
    'credits.lowBalance.thresholdAria': 'Alert threshold, in Parseh',
    'credits.lowBalance.active': 'You will be warned below {{coins}} Parseh.',
    'credits.lowBalance.off': 'Alerts are off.',
    'credits.lowBalance.invalid': 'Enter a valid threshold.',
    'credits.lowBalance.saved': 'Alert settings saved.',
    'credits.lowBalance.failed': 'The alert settings could not be saved.'
};


// FA — the product language. Translates en.js key for key.
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here. tests/i18n.test.js asserts both directions.
const $04d49d2d0d0e0cec$export$48a262eaf0aadda2 = {
    // ── app ──────────────────────────────────────────────────────────────────
    'app.title': "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u2014 \u0645\u0627\u0698\u0648\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
    // ── nav / chrome ─────────────────────────────────────────────────────────
    'nav.brand.name': "\u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
    'nav.brand.panel': "\u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
    'nav.items.today': "\u0627\u0645\u0631\u0648\u0632",
    'nav.items.patients': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646",
    'nav.items.credits': "\u0627\u0639\u062A\u0628\u0627\u0631",
    'nav.items.profile': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'nav.sidebar.collapse': "\u0628\u0633\u062A\u0646 \u0645\u0646\u0648",
    'nav.sidebar.expand': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u0645\u0646\u0648",
    'nav.sidebar.logout': "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628",
    'nav.sidebar.editProfile': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'nav.clinic.label': "\u06A9\u0644\u06CC\u0646\u06CC\u06A9",
    // The AccountCard at the foot of the rail — the balance, and the menu that
    // holds every account-level destination. The unit is «پارسه» in BOTH locales.
    'nav.account.menuLabel': "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC",
    'nav.account.parsina': "\u062D\u0633\u0627\u0628 \u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
    'nav.account.parsinaHint': "\u0646\u0627\u0645\u060C \u0631\u0645\u0632 \u0639\u0628\u0648\u0631\u060C \u0632\u0628\u0627\u0646",
    'nav.credits.label': "\u0627\u0639\u062A\u0628\u0627\u0631 \u067E\u0627\u0631\u0633\u0647\u0654 \u0634\u0645\u0627",
    'nav.credits.topUp': "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631 \u067E\u0627\u0631\u0633\u0647",
    'nav.clinicSwitch.label': "\u0631\u0641\u062A\u0646 \u0628\u0647 \u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
    // See the note on these keys in en.js.
    'nav.landmark.primary': "\u0645\u0646\u0648\u06CC \u0627\u0635\u0644\u06CC",
    'nav.landmark.content': "\u0645\u062D\u062A\u0648\u0627",
    // ── common ───────────────────────────────────────────────────────────────
    'common.actions.cancel': "\u0627\u0646\u0635\u0631\u0627\u0641",
    'common.actions.retry': "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F",
    // The accessible name of every skeleton composite (DESIGN.md §"Loading & skeleton").
    'common.loading': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC",
    'common.actions.save': "\u0630\u062E\u06CC\u0631\u0647",
    'common.actions.saving': "\u062F\u0631 \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647\u2026",
    'common.actions.back': "\u0628\u0627\u0632\u06AF\u0634\u062A",
    'common.actions.close': "\u0628\u0633\u062A\u0646",
    'common.actions.clearFilters': "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
    'common.actions.join': "\u067E\u06CC\u0648\u0633\u062A\u0646",
    // دکمه‌ای که در حال انجام کار است. «در حال ذخیره…» نیست: کنش اصلیِ
    // گفت‌وگوی نشست، تمدید توکن است و چیزی ذخیره نمی‌شود.
    'common.state.pleaseWait': "\u0644\u0637\u0641\u0627\u064B \u0635\u0628\u0631 \u06A9\u0646\u06CC\u062F\u2026",
    'common.labels.phone': "\u062A\u0644\u0641\u0646",
    'common.labels.country': "\u06A9\u0634\u0648\u0631",
    'common.labels.nationalId': "\u06A9\u062F \u0645\u0644\u06CC",
    'common.labels.fileNumber': "\u0634\u0645\u0627\u0631\u0647\u0654 \u067E\u0631\u0648\u0646\u062F\u0647",
    'common.labels.none': "\u2014",
    'common.gender.male': "\u0645\u0631\u062F",
    'common.gender.female': "\u0632\u0646",
    'common.marital.single': "\u0645\u062C\u0631\u062F",
    'common.marital.married': "\u0645\u062A\u0623\u0647\u0644",
    'common.marital.divorced': "\u0645\u0637\u0644\u0642\u0647",
    'common.marital.widowed': "\u0628\u06CC\u0648\u0647",
    'common.units.years': "{{count}} \u0633\u0627\u0644",
    'common.units.years_one': "{{count}} \u0633\u0627\u0644",
    'common.units.minute': "\u062F\u0642\u06CC\u0642\u0647",
    'common.units.second': "\u062B\u0627\u0646\u06CC\u0647",
    // The unit word of CLINIC money in an Iranian clinic (IRR, shown as toman).
    // Not «پارسه» and not the credits screens' own `credits.toman`: those are
    // platform money and never follow a clinic's currency.
    'common.units.toman': "\u062A\u0648\u0645\u0627\u0646",
    'common.units.tomans': "\u062A\u0648\u0645\u0627\u0646",
    'common.punct.colon': ':',
    // Voice dictation (browser SpeechRecognition — see useSpeechToText.js).
    'common.voice.start': "\u06AF\u0641\u062A\u0646 \u0628\u0627 \u0635\u062F\u0627",
    'common.voice.stop': "\u067E\u0627\u06CC\u0627\u0646 \u0636\u0628\u0637",
    // بدون سه‌نقطه: بلافاصله بعدش زمان‌سنج می‌آید و «…۰۰:۱۲» بد خوانده می‌شود.
    'common.voice.listening': "\u062F\u0631 \u062D\u0627\u0644 \u0634\u0646\u06CC\u062F\u0646",
    'common.voice.priceTitle': "\u06F5 \u067E\u0627\u0631\u0633\u0647 \u0628\u0631\u0627\u06CC \u0647\u0631 \u062F\u0642\u06CC\u0642\u0647 \u0636\u0628\u0637\u061B \u0628\u0647\u200C\u0633\u0645\u062A \u0628\u0627\u0644\u0627 \u06AF\u0631\u062F \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'common.voice.inlineTranscribing': "\u062F\u0631 \u062D\u0627\u0644 \u062A\u0628\u062F\u06CC\u0644\u2026",
    'common.voice.error.denied': "\u062F\u0633\u062A\u0631\u0633\u06CC \u0628\u0647 \u0645\u06CC\u06A9\u0631\u0648\u0641\u0648\u0646 \u062F\u0627\u062F\u0647 \u0646\u0634\u062F",
    'common.voice.error.no-mic': "\u0645\u06CC\u06A9\u0631\u0648\u0641\u0648\u0646\u06CC \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
    'common.voice.error.unsupported': "\u0627\u06CC\u0646 \u0645\u0631\u0648\u0631\u06AF\u0631 \u0636\u0628\u0637 \u0635\u062F\u0627 \u0631\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0646\u0645\u06CC\u200C\u06A9\u0646\u062F",
    // getUserMedia فقط روی HTTPS وجود دارد. این همان چیزی است که موقع باز کردن
    // برنامه روی آی‌پد با آدرس IP شبکهٔ محلی دیده می‌شود.
    'common.voice.error.insecure': "\u0636\u0628\u0637 \u0635\u062F\u0627 \u0641\u0642\u0637 \u0631\u0648\u06CC \u0627\u062A\u0635\u0627\u0644 \u0627\u0645\u0646 (HTTPS) \u06A9\u0627\u0631 \u0645\u06CC\u200C\u06A9\u0646\u062F",
    'common.voice.error.credits': "\u0627\u0639\u062A\u0628\u0627\u0631 \u067E\u0627\u0631\u0633\u0647\u0654 \u0634\u0645\u0627 \u06A9\u0627\u0641\u06CC \u0646\u06CC\u0633\u062A",
    'common.voice.error.auth': "\u0646\u0634\u0633\u062A \u0634\u0645\u0627 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A. \u062F\u0648\u0628\u0627\u0631\u0647 \u0648\u0627\u0631\u062F \u0634\u0648\u06CC\u062F",
    'common.voice.error.onboarding': "\u0627\u0628\u062A\u062F\u0627 \u062B\u0628\u062A\u200C\u0646\u0627\u0645 \u062E\u0648\u062F \u0631\u0627 \u06A9\u0627\u0645\u0644 \u06A9\u0646\u06CC\u062F",
    'common.voice.error.unavailable': "\u0633\u0631\u0648\u06CC\u0633 \u062A\u0628\u062F\u06CC\u0644 \u06AF\u0641\u062A\u0627\u0631 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
    'common.voice.error.timeout': "\u062A\u0628\u062F\u06CC\u0644 \u06AF\u0641\u062A\u0627\u0631 \u0628\u0647 \u0645\u062A\u0646 \u0628\u06CC\u0634 \u0627\u0632 \u062D\u062F \u0637\u0648\u0644 \u06A9\u0634\u06CC\u062F",
    'common.voice.error.generic': "\u0636\u0628\u0637 \u0635\u062F\u0627 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F",
    // ── پوستهٔ موبایل ─────────────────────────────────────────────────────────
    // متنی که فقط به سطح ≤۷۶۸ پیکسل تعلق دارد. پیش‌فرض خودِ کیت برای این جاها
    // (MobileHeader.greeting و BottomSheet.closeLabel) رشتهٔ فارسی است، پس همه
    // باید صریح پاس داده شوند وگرنه در رابط انگلیسی فارسی نشت می‌کند.
    'mobile.greeting': "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F\u060C",
    // بزرگ‌کنندهٔ فهرست. هرگز اسکرول بی‌نهایت: جای آدم در فهرست مهم است و روی
    // موبایل گم‌کردن آن بیشترین هزینه را دارد.
    'mobile.showMore': "\u0646\u0645\u0627\u06CC\u0634 \u0628\u06CC\u0634\u062A\u0631",
    'mobile.close': "\u0628\u0633\u062A\u0646",
    // ── auth / boot ──────────────────────────────────────────────────────────
    'auth.checking': "\u062F\u0631 \u062D\u0627\u0644 \u0648\u0631\u0648\u062F\u2026",
    'auth.loading': "\u062F\u0631 \u062D\u0627\u0644 \u0622\u0645\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC \u0641\u0636\u0627\u06CC \u06A9\u0627\u0631\u06CC\u2026",
    'auth.loopError': "\u0648\u0631\u0648\u062F \u0645\u062F\u0627\u0645 \u062A\u06A9\u0631\u0627\u0631 \u0645\u06CC\u200C\u0634\u0648\u062F. \u0646\u0634\u0633\u062A \u0631\u0627 \u067E\u0627\u06A9 \u06A9\u0646\u06CC\u062F \u0648 \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F\u060C \u06CC\u0627 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    'auth.loopTitle': "\u0648\u0631\u0648\u062F \u0646\u0627\u0645\u0648\u0641\u0642 \u0628\u0648\u062F",
    'auth.checkingHint': "\u0686\u0646\u062F \u0644\u062D\u0638\u0647 \u0635\u0628\u0631 \u06A9\u0646\u06CC\u062F",
    'auth.stuck': "\u0647\u062F\u0627\u06CC\u062A \u0646\u0634\u062F\u06CC\u062F\u061F",
    'auth.manualSignIn': "\u0627\u06CC\u0646\u062C\u0627 \u06A9\u0644\u06CC\u06A9 \u06A9\u0646\u06CC\u062F",
    'auth.retry': "\u062A\u0644\u0627\u0634 \u062F\u0648\u0628\u0627\u0631\u0647",
    'auth.signOut': "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628",
    'auth.bootFailed.title': "\u0634\u0631\u0648\u0639 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F",
    'auth.bootFailed.body': "\u0641\u0636\u0627\u06CC \u06A9\u0627\u0631\u06CC \u0634\u0645\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F. \u0627\u06CC\u0646 \u062E\u0637\u0627 \u0645\u0639\u0645\u0648\u0644\u0627\u064B \u0645\u0648\u0642\u062A\u06CC \u0627\u0633\u062A.",
    // پایان نشست — نگاه کنید به src/lib/session.js. عیناً همان متن پنل پزشک
    // (آنجا src/i18n/translations/fa/auth.json): دندان‌پزشکی که در هر دو پنل
    // کار می‌کند این گفت‌وگو را در هر دو می‌بیند، و دو نگارش برای یک رویداد
    // یعنی دو محصول متفاوت.
    'auth.session.expiringTitle': "\u0646\u0634\u0633\u062A \u0634\u0645\u0627 \u0631\u0648 \u0628\u0647 \u067E\u0627\u06CC\u0627\u0646 \u0627\u0633\u062A",
    'auth.session.expiringBody': "\u0628\u0631\u0627\u06CC \u0627\u062F\u0627\u0645\u0647\u0654 \u06A9\u0627\u0631 \u0628\u062F\u0648\u0646 \u0642\u0637\u0639 \u0634\u062F\u0646\u060C \u0646\u0634\u0633\u062A \u0631\u0627 \u062A\u0645\u062F\u06CC\u062F \u06A9\u0646\u06CC\u062F.",
    'auth.session.staySignedIn': "\u0627\u062F\u0627\u0645\u0647\u0654 \u06A9\u0627\u0631",
    'auth.session.expiredTitle': "\u0646\u0634\u0633\u062A \u0634\u0645\u0627 \u067E\u0627\u06CC\u0627\u0646 \u06CC\u0627\u0641\u062A\u0647 \u0627\u0633\u062A",
    'auth.session.expiredBody': "\u0628\u0631\u0627\u06CC \u0627\u062F\u0627\u0645\u0647 \u0628\u0627\u06CC\u062F \u062F\u0648\u0628\u0627\u0631\u0647 \u0648\u0627\u0631\u062F \u0634\u0648\u06CC\u062F. \u0635\u0641\u062D\u0647\u0654 \u0641\u0639\u0644\u06CC \u0628\u0633\u062A\u0647 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u067E\u0633 \u0627\u0632 \u0648\u0631\u0648\u062F \u0628\u0647 \u0647\u0645\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0632\u0645\u06CC\u200C\u06AF\u0631\u062F\u06CC\u062F.",
    'auth.session.signInAgain': "\u0648\u0631\u0648\u062F \u0645\u062C\u062F\u062F",
    'auth.session.returnNotice': "\u0647\u0631 \u0686\u06CC\u0632\u06CC \u06A9\u0647 \u067E\u06CC\u0634 \u0627\u0632 \u0627\u06CC\u0646 \u0630\u062E\u06CC\u0631\u0647 \u06A9\u0631\u062F\u0647\u200C\u0627\u06CC\u062F \u0645\u062D\u0641\u0648\u0638 \u0627\u0633\u062A. \u0645\u0648\u0627\u0631\u062F \u0630\u062E\u06CC\u0631\u0647\u200C\u0646\u0634\u062F\u0647\u0654 \u0631\u0648\u06CC \u0635\u0641\u062D\u0647 \u0631\u0627 \u067E\u06CC\u0634 \u0627\u0632 \u0648\u0631\u0648\u062F \u0645\u062C\u062F\u062F \u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u06A9\u0646\u06CC\u062F.",
    // ── errors ───────────────────────────────────────────────────────────────
    'errors.generic': "\u062E\u0637\u0627\u06CC\u06CC \u0631\u062E \u062F\u0627\u062F.",
    'errors.load.today': "\u0631\u0648\u0632 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F.",
    'errors.load.patients': "\u0641\u0647\u0631\u0633\u062A \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F.",
    'errors.load.patient': "\u0627\u06CC\u0646 \u067E\u0631\u0648\u0646\u062F\u0647 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F.",
    'errors.load.profile': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0634\u0645\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F.",
    'errors.load.drugs': "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u062F\u0627\u0631\u0648 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F.",
    'errors.credits.title': "\u0627\u0639\u062A\u0628\u0627\u0631 \u0647\u0648\u0634\u0645\u0646\u062F \u06A9\u0627\u0641\u06CC \u0646\u06CC\u0633\u062A",
    'errors.credits.body': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644 \u062F\u0627\u0631\u0648\u06CC\u06CC \u0646\u06CC\u0627\u0632\u0645\u0646\u062F \u0627\u0639\u062A\u0628\u0627\u0631 \u0627\u0633\u062A. \u0627\u0632 \u0628\u062E\u0634 \xab\u0627\u0639\u062A\u0628\u0627\u0631\xbb \u0634\u0627\u0631\u0698 \u06A9\u0646\u06CC\u062F \u2014 \u062A\u062C\u0648\u06CC\u0632 \u0646\u0633\u062E\u0647 \u0645\u062A\u0648\u0642\u0641 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    // ── today (امروز) ─────────────────────────────────────────────────────────
    'today.title': "\u0627\u0645\u0631\u0648\u0632",
    'today.date.today': "\u0627\u0645\u0631\u0648\u0632",
    'today.date.prev': "\u0631\u0648\u0632 \u0642\u0628\u0644",
    'today.date.next': "\u0631\u0648\u0632 \u0628\u0639\u062F",
    // موبایل: با لمس برچسبِ روز، تقویم در یک شیت باز می‌شود تا هر تاریخی یک لمس
    // فاصله داشته باشد، نه چند بار زدنِ فلش.
    'today.date.pick': "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
    'today.counts.total': "\u0646\u0648\u0628\u062A\u200C\u0647\u0627",
    'today.counts.here': "\u062D\u0627\u0636\u0631 \u062F\u0631 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
    'today.counts.scheduled': "\u0646\u0648\u0628\u062A\u200C\u062F\u0627\u0631",
    'today.counts.completed': "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647",
    'today.counts.cancelled': "\u0644\u063A\u0648 \u0634\u062F\u0647",
    // در موبایل ردیف آمار دقیقاً چهار کاشی است (امضای بصری طراحی)، پس KPI پنجمِ
    // شرطیِ دسکتاپ به این خط کم‌رنگ زیر ردیف تبدیل می‌شود.
    'today.counts.cancelledLine': "{{count}} \u0644\u063A\u0648 \u0634\u062F\u0647",
    // صف زنده واقعیتی دربارهٔ «همین حالا» است، پس فقط برای امروز وجود دارد. به‌جای
    // نمایش یک بلوک صفِ خالی در روزهای دیگر، صریح گفته می‌شود.
    'today.notice.liveQueue': "\u0635\u0641 \u0632\u0646\u062F\u0647\u0654 \u0627\u062A\u0627\u0642 \u0627\u0646\u062A\u0638\u0627\u0631 \u0641\u0642\u0637 \u0628\u0631\u0627\u06CC \u0627\u0645\u0631\u0648\u0632 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F. \u0631\u0648\u0632\u0647\u0627\u06CC \u062F\u06CC\u06AF\u0631 \u0641\u0647\u0631\u0633\u062A \u0646\u0648\u0628\u062A\u200C\u0647\u0627 \u0631\u0627 \u0646\u0634\u0627\u0646 \u0645\u06CC\u200C\u062F\u0647\u0646\u062F.",
    // See the note on these keys in en.js. The Persian wording is the kit's own
    // `statusColors` labels verbatim — the desk and the dentist must not call the
    // same patient two different things.
    'today.status.scheduled': "\u0646\u0648\u0628\u062A\u200C\u062F\u0627\u0631",
    'today.status.arrived': "\u062D\u0627\u0636\u0631",
    'today.status.in_visit': "\u062F\u0631 \u062D\u0627\u0644 \u0648\u06CC\u0632\u06CC\u062A",
    'today.status.completed': "\u0648\u06CC\u0632\u06CC\u062A\u200C\u0634\u062F\u0647",
    'today.status.cancelled': "\u0644\u063A\u0648 \u0634\u062F\u0647",
    'today.status.no_show': "\u0639\u062F\u0645 \u062D\u0636\u0648\u0631",
    'today.blocks.queue': "\u0627\u062A\u0627\u0642 \u0627\u0646\u062A\u0638\u0627\u0631",
    'today.blocks.upcoming': "\u067E\u06CC\u0634\u200C\u0631\u0648",
    'today.blocks.done': "\u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
    'today.next.title': "\u0628\u06CC\u0645\u0627\u0631 \u0628\u0639\u062F\u06CC",
    'today.next.at': "\u0633\u0627\u0639\u062A {{time}}",
    'today.next.service': "\u062E\u062F\u0645\u062A: {{name}}",
    'today.next.serviceVisit': "\u0648\u06CC\u0632\u06CC\u062A",
    'today.next.serviceMore': "+{{count}} \u0645\u0648\u0631\u062F \u062F\u06CC\u06AF\u0631",
    'today.empty.title': "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0631\u0648\u0632 \u0646\u0648\u0628\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
    'today.empty.description': "\u0646\u0648\u0628\u062A\u200C\u0647\u0627 \u0631\u0627 \u067E\u0630\u06CC\u0631\u0634 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062B\u0628\u062A \u0645\u06CC\u200C\u06A9\u0646\u062F \u0648 \u0628\u0647\u200C\u0635\u0648\u0631\u062A \u062E\u0648\u062F\u06A9\u0627\u0631 \u0627\u06CC\u0646\u062C\u0627 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'today.error.title': "\u0628\u0631\u0646\u0627\u0645\u0647\u0654 \u0631\u0648\u0632 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
    'today.queue.positionNext': "\u0646\u0641\u0631 \u0628\u0639\u062F",
    'today.queue.position': "\u0646\u0641\u0631 {{position}}",
    'today.queue.waited': "{{count}} \u062F\u0642\u06CC\u0642\u0647 \u0627\u0646\u062A\u0638\u0627\u0631",
    'today.queue.waitedHours': "{{hours}} \u0633\u0627\u0639\u062A \u0627\u0646\u062A\u0638\u0627\u0631",
    'today.queue.waitedHoursMinutes': "{{hours}} \u0633\u0627\u0639\u062A \u0648 {{minutes}} \u062F\u0642\u06CC\u0642\u0647 \u0627\u0646\u062A\u0638\u0627\u0631",
    'today.queue.elapsed': "{{count}} \u062F\u0642\u06CC\u0642\u0647 \u0631\u0648\u06CC \u06CC\u0648\u0646\u06CC\u062A",
    'today.queue.elapsedHours': "{{hours}} \u0633\u0627\u0639\u062A \u0631\u0648\u06CC \u06CC\u0648\u0646\u06CC\u062A",
    'today.queue.elapsedHoursMinutes': "{{hours}} \u0633\u0627\u0639\u062A \u0648 {{minutes}} \u062F\u0642\u06CC\u0642\u0647 \u0631\u0648\u06CC \u06CC\u0648\u0646\u06CC\u062A",
    'today.row.visit': "\u062C\u0644\u0633\u0647",
    'today.row.visitFor': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u062C\u0644\u0633\u0647\u0654 \u062F\u0631\u0645\u0627\u0646 {{name}}",
    'today.row.open': "\u067E\u0631\u0648\u0646\u062F\u0647",
    // See the note on this key in en.js.
    'today.row.openFor': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u067E\u0631\u0648\u0646\u062F\u0647\u0654 {{name}}",
    'today.row.walkIn': "\u062B\u0628\u062A \u0633\u0631\u06CC\u0639",
    'today.row.unknownPatient': "\u0628\u06CC\u0645\u0627\u0631 \u0628\u062F\u0648\u0646 \u0646\u0627\u0645",
    'today.readOnlyNote': "\u062B\u0628\u062A\u060C \u0644\u063A\u0648 \u0648 \u062A\u0631\u062A\u06CC\u0628 \u0635\u0641 \u0628\u0631 \u0639\u0647\u062F\u0647\u0654 \u067E\u0630\u06CC\u0631\u0634 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0627\u0633\u062A. \u0627\u06CC\u0646 \u067E\u0646\u0644 \u0647\u0645\u0627\u0646 \u0646\u0648\u0628\u062A\u200C\u0647\u0627 \u0631\u0627 \u0645\u06CC\u200C\u062E\u0648\u0627\u0646\u062F.",
    // ── patients (بیماران) ────────────────────────────────────────────────────
    'patients.title': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646",
    'patients.subtitle': "\u062F\u0641\u062A\u0631 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u2014 \u0647\u0645\u0627\u0646 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646\u06CC \u06A9\u0647 \u067E\u0630\u06CC\u0631\u0634 \u062B\u0628\u062A \u0645\u06CC\u200C\u06A9\u0646\u062F",
    'patients.search.placeholder': "\u0646\u0627\u0645\u060C \u062A\u0644\u0641\u0646\u060C \u06A9\u062F \u0645\u0644\u06CC \u06CC\u0627 \u0634\u0645\u0627\u0631\u0647\u0654 \u067E\u0631\u0648\u0646\u062F\u0647",
    'patients.search.hint': "\u0628\u0631\u0627\u06CC \u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u062F\u0633\u062A\u200C\u06A9\u0645 \u062F\u0648 \u062D\u0631\u0641 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F.",
    'patients.count': "{{count}} \u0628\u06CC\u0645\u0627\u0631",
    'patients.columns.name': "\u0628\u06CC\u0645\u0627\u0631",
    'patients.columns.phone': "\u062A\u0644\u0641\u0646",
    'patients.columns.fileNumber': "\u0634\u0645\u0627\u0631\u0647\u0654 \u067E\u0631\u0648\u0646\u062F\u0647",
    'patients.columns.nationalId': "\u06A9\u062F \u0645\u0644\u06CC",
    'patients.empty.title': "\u0647\u0646\u0648\u0632 \u0628\u06CC\u0645\u0627\u0631\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
    'patients.empty.description': "\u0628\u06CC\u0645\u0627\u0631\u0627\u0646\u06CC \u06A9\u0647 \u062F\u0631 \u067E\u0630\u06CC\u0631\u0634 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u0646\u062F \u0627\u06CC\u0646\u062C\u0627 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'patients.emptyFiltered.title': "\u0646\u062A\u06CC\u062C\u0647\u200C\u0627\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F",
    'patients.emptyFiltered.description': "\u0647\u06CC\u0686 \u0628\u06CC\u0645\u0627\u0631\u06CC \u0628\u0627 \u0627\u06CC\u0646 \u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u0645\u0637\u0627\u0628\u0642\u062A \u0646\u062F\u0627\u0631\u062F.",
    'patients.noClinic.title': "\u0647\u0646\u0648\u0632 \u0639\u0636\u0648 \u0647\u06CC\u0686 \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u06CC \u0646\u06CC\u0633\u062A\u06CC\u062F",
    'patients.noClinic.description': "\u062F\u0641\u062A\u0631 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0645\u062A\u0639\u0644\u0642 \u0628\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0627\u0633\u062A. \u0628\u0627 \u06A9\u062F \u062F\u0639\u0648\u062A \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u060C \u0627\u0632 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u062E\u0648\u062F \u0628\u0647 \u0622\u0646 \u0628\u067E\u06CC\u0648\u0646\u062F\u06CC\u062F.",
    'patients.noClinic.action': "\u0631\u0641\u062A\u0646 \u0628\u0647 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'patients.pendingClinic.title': "\u0639\u0636\u0648\u06CC\u062A \u0634\u0645\u0627 \u0647\u0646\u0648\u0632 \u062A\u0623\u06CC\u06CC\u062F \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
    'patients.pendingClinic.description': "\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0639\u0636\u0648\u06CC\u062A \u062B\u0628\u062A \u0634\u062F\u0647 \u0648 \u062A\u0627 \u0632\u0645\u0627\u0646\u06CC \u06A9\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0622\u0646 \u0631\u0627 \u062A\u0623\u06CC\u06CC\u062F \u0646\u06A9\u0646\u062F\u060C \u062F\u0641\u062A\u0631 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0628\u0627\u0632 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F. \u0648\u0636\u0639\u06CC\u062A \u0631\u0627 \u062F\u0631 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0628\u0628\u06CC\u0646\u06CC\u062F.",
    'patients.error.title': "\u0641\u0647\u0631\u0633\u062A \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
    // ── patient workspace ────────────────────────────────────────────────────
    'patient.tabs.summary': "\u062E\u0644\u0627\u0635\u0647",
    'patient.tabs.history': "\u0633\u0648\u0627\u0628\u0642",
    // نوار بخش‌های چسبانِ پروندهٔ موبایل یک لندمارک است؛ نام آن را کیت به‌صورت
    // prop می‌گیرد و رشتهٔ فارسی را در خودش hardcode نمی‌کند.
    'patient.tabs.sectionsLabel': "\u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u067E\u0631\u0648\u0646\u062F\u0647",
    'patient.actions.prescribe': "\u0646\u0633\u062E\u0647",
    'patient.notFound.title': "\u067E\u0631\u0648\u0646\u062F\u0647 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F",
    'patient.notFound.description': "\u0686\u0646\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631\u06CC \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F\u060C \u06CC\u0627 \u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u0642\u0627\u0628\u0644 \u0645\u0634\u0627\u0647\u062F\u0647 \u0646\u06CC\u0633\u062A.",
    'patient.error.title': "\u0627\u06CC\u0646 \u067E\u0631\u0648\u0646\u062F\u0647 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
    'patient.stats.age': "\u0633\u0646",
    'patient.stats.allergies': "\u062D\u0633\u0627\u0633\u06CC\u062A",
    'patient.stats.medications': "\u062F\u0627\u0631\u0648",
    'patient.summary.demographics': "\u0645\u0634\u062E\u0635\u0627\u062A",
    'patient.summary.allergies': "\u062D\u0633\u0627\u0633\u06CC\u062A\u200C\u0647\u0627",
    'patient.summary.noAllergies': "\u062D\u0633\u0627\u0633\u06CC\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    // See the note on these keys in en.js.
    'patient.severity.mild': "\u062E\u0641\u06CC\u0641",
    'patient.severity.moderate': "\u0645\u062A\u0648\u0633\u0637",
    'patient.severity.severe': "\u0634\u062F\u06CC\u062F",
    'patient.conditionStatus.active': "\u0641\u0639\u0627\u0644",
    'patient.conditionStatus.inactive': "\u063A\u06CC\u0631\u0641\u0639\u0627\u0644",
    'patient.conditionStatus.resolved': "\u0628\u0631\u0637\u0631\u0641\u200C\u0634\u062F\u0647",
    'patient.conditionStatus.remission': "\u062F\u0631 \u062F\u0648\u0631\u0647\u0654 \u0628\u0647\u0628\u0648\u062F",
    'patient.photo.open': "\u062F\u06CC\u062F\u0646 \u0639\u06A9\u0633 {{name}} \u062F\u0631 \u0627\u0646\u062F\u0627\u0632\u0647 \u0628\u0632\u0631\u06AF",
    'patient.photo.alt': "\u0639\u06A9\u0633 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 {{name}}",
    'patient.summary.allergyWarning': "\u062D\u0633\u0627\u0633\u06CC\u062A\u200C\u0647\u0627\u06CC \u062B\u0628\u062A\u200C\u0634\u062F\u0647 \u2014 \u067E\u06CC\u0634 \u0627\u0632 \u062A\u062C\u0648\u06CC\u0632 \u0628\u0631\u0631\u0633\u06CC \u06A9\u0646\u06CC\u062F.",
    'patient.fields.birthDate': "\u062A\u0627\u0631\u06CC\u062E \u062A\u0648\u0644\u062F",
    'patient.fields.gender': "\u062C\u0646\u0633\u06CC\u062A",
    'patient.fields.maritalStatus': "\u0648\u0636\u0639\u06CC\u062A \u062A\u0623\u0647\u0644",
    'patient.fields.bloodType': "\u06AF\u0631\u0648\u0647 \u062E\u0648\u0646\u06CC",
    'patient.fields.job': "\u0634\u063A\u0644",
    'patient.fields.insurance': "\u0628\u06CC\u0645\u0647",
    'patient.fields.height': "\u0642\u062F",
    'patient.fields.createdAt': "\u062A\u0627\u0631\u06CC\u062E \u062B\u0628\u062A",
    'patient.history.conditions': "\u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627",
    'patient.history.medications': "\u062F\u0627\u0631\u0648\u0647\u0627",
    'patient.history.noConditions': "\u062A\u0634\u062E\u06CC\u0635\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'patient.history.noMedications': "\u062F\u0627\u0631\u0648\u06CC\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'patient.history.prescribedOn': "\u062A\u062C\u0648\u06CC\u0632 {{date}}",
    // ── prescription (نسخه) ──────────────────────────────────────────────────
    'prescription.title': "\u0646\u0633\u062E\u0647",
    'prescription.subtitle': "\u0628\u0631\u0627\u06CC {{name}}",
    'prescription.search.label': "\u0627\u0641\u0632\u0648\u062F\u0646 \u062F\u0627\u0631\u0648",
    'prescription.search.placeholder': "\u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u062F\u0627\u0631\u0648\u0647\u0627\u2026",
    'prescription.search.searching': "\u062F\u0631 \u062D\u0627\u0644 \u062C\u0633\u062A\u200C\u0648\u062C\u0648\u2026",
    'prescription.search.empty': "\u062F\u0627\u0631\u0648\u06CC\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.",
    'prescription.search.hint': "\u062F\u0633\u062A\u200C\u06A9\u0645 \u062F\u0648 \u062D\u0631\u0641 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F.",
    // See the note on this key in en.js.
    'prescription.search.results': "{{count}} \u062F\u0627\u0631\u0648 \u06CC\u0627\u0641\u062A \u0634\u062F.",
    'prescription.item.dose': "\u062F\u0648\u0632",
    'prescription.item.frequency': "\u062A\u0648\u0627\u062A\u0631",
    'prescription.item.duration': "\u0645\u062F\u062A",
    'prescription.item.note': "\u062A\u0648\u0636\u06CC\u062D",
    'prescription.item.remove': "\u062D\u0630\u0641 {{name}}",
    'prescription.empty.title': "\u0647\u0646\u0648\u0632 \u062F\u0627\u0631\u0648\u06CC\u06CC \u0627\u0641\u0632\u0648\u062F\u0647 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
    'prescription.empty.description': "\u0627\u0632 \u06A9\u0627\u062F\u0631 \u0628\u0627\u0644\u0627 \u0627\u0648\u0644\u06CC\u0646 \u062F\u0627\u0631\u0648 \u0631\u0627 \u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u0648 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F.",
    'prescription.save': "\u062B\u0628\u062A \u0646\u0633\u062E\u0647",
    'prescription.saveConfirm': "\u062A\u0623\u06CC\u06CC\u062F \u0648 \u062B\u0628\u062A",
    'prescription.saving': "\u062F\u0631 \u062D\u0627\u0644 \u062B\u0628\u062A\u2026",
    'prescription.saved': "\u0646\u0633\u062E\u0647 \u062B\u0628\u062A \u0634\u062F.",
    'prescription.saveFailed': "\u062B\u0628\u062A \u0646\u0633\u062E\u0647 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F.",
    'prescription.savePartial': "{{saved}} \u062F\u0627\u0631\u0648 \u0627\u0632 {{total}} \u062F\u0627\u0631\u0648 \u062B\u0628\u062A \u0634\u062F.",
    'prescription.allergies.title': "\u062D\u0633\u0627\u0633\u06CC\u062A\u200C\u0647\u0627\u06CC \u062B\u0628\u062A\u200C\u0634\u062F\u0647",
    'prescription.interactions.title': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644",
    'prescription.interactions.checking': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026",
    'prescription.interactions.none': "\u062A\u062F\u0627\u062E\u0644\u06CC \u0645\u06CC\u0627\u0646 \u0627\u06CC\u0646 \u062F\u0627\u0631\u0648\u0647\u0627 \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.",
    'prescription.interactions.needsTwo': "\u0628\u0631\u0627\u06CC \u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644\u060C \u062F\u0627\u0631\u0648\u06CC \u062F\u0648\u0645 \u0631\u0627 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F.",
    'prescription.interactions.unavailable': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644 \u062F\u0631 \u062D\u0627\u0644 \u062D\u0627\u0636\u0631 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A. \u062A\u062C\u0648\u06CC\u0632 \u0646\u0633\u062E\u0647 \u0645\u062A\u0648\u0642\u0641 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'prescription.interactions.severity.high': "\u0632\u06CC\u0627\u062F",
    'prescription.interactions.severity.moderate': "\u0645\u062A\u0648\u0633\u0637",
    'prescription.interactions.severity.low': "\u06A9\u0645",
    'prescription.interactions.type.interaction': "\u062A\u062F\u0627\u062E\u0644",
    'prescription.interactions.type.contraindication': "\u0645\u0646\u0639 \u0645\u0635\u0631\u0641",
    'prescription.interactions.type.allergy': "\u062D\u0633\u0627\u0633\u06CC\u062A",
    'prescription.interactions.type.black_box': "\u0647\u0634\u062F\u0627\u0631 \u062C\u062F\u06CC",
    'prescription.history.title': "\u062A\u062C\u0648\u06CC\u0632\u0647\u0627\u06CC \u067E\u06CC\u0634\u06CC\u0646",
    'prescription.history.empty': "\u062A\u062C\u0648\u06CC\u0632 \u067E\u06CC\u0634\u06CC\u0646\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    // ── profile ──────────────────────────────────────────────────────────────
    'profile.title': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'profile.subtitle': "\u0647\u0648\u06CC\u062A\u060C \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u200C\u0647\u0627 \u0648 \u0634\u06CC\u0641\u062A\u200C\u0647\u0627\u06CC \u0634\u0645\u0627",
    'profile.sections.label': "\u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u067E\u0631\u0648\u0641\u0627\u06CC\u0644",
    'profile.sections.identity': "\u0647\u0648\u06CC\u062A",
    'profile.sections.clinics': "\u06A9\u0644\u06CC\u0646\u06CC\u06A9\u200C\u0647\u0627",
    'profile.sections.presence': "\u0634\u06CC\u0641\u062A\u200C\u0647\u0627",
    'profile.sections.appearance': "\u0638\u0627\u0647\u0631 \u0648 \u0632\u0628\u0627\u0646",
    'profile.fields.fullName': "\u0646\u0627\u0645 \u0648 \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC",
    'profile.fields.medicalCode': "\u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC",
    'profile.fields.specialty': "\u062A\u062E\u0635\u0635",
    'profile.fields.bio': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0634\u0645\u0627",
    // Copy, not the stored value — see the note on this key in en.js.
    'profile.specialtyValue': "\u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC",
    'profile.medicalCodeLocked': "\u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0647\u0646\u06AF\u0627\u0645 \u062B\u0628\u062A\u200C\u0646\u0627\u0645 \u062B\u0628\u062A \u0634\u062F\u0647 \u0648 \u0642\u0627\u0628\u0644 \u0648\u06CC\u0631\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A. \u0628\u0631\u0627\u06CC \u0627\u0635\u0644\u0627\u062D \u0622\u0646 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    'profile.specialtyLocked': "\u0627\u06CC\u0646 \u067E\u0646\u0644 \u0628\u0631\u0627\u06CC \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u0627\u0646 \u0627\u0633\u062A\u060C \u0628\u0646\u0627\u0628\u0631\u0627\u06CC\u0646 \u062A\u062E\u0635\u0635 \u062B\u0627\u0628\u062A \u0627\u0633\u062A. \u062A\u063A\u06CC\u06CC\u0631 \u0622\u0646 \u0627\u0632 \u062C\u0627\u06CC \u062F\u06CC\u06AF\u0631\u060C \u062F\u0633\u062A\u0631\u0633\u06CC \u062D\u0633\u0627\u0628 \u0634\u0645\u0627 \u0628\u0647 \u0627\u06CC\u0646 \u067E\u0646\u0644 \u0631\u0627 \u0645\u06CC\u200C\u0628\u0646\u062F\u062F.",
    'profile.saved': "\u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0630\u062E\u06CC\u0631\u0647 \u0634\u062F.",
    'profile.noChanges': "\u062A\u063A\u06CC\u06CC\u0631\u06CC \u0627\u0639\u0645\u0627\u0644 \u0646\u0634\u062F.",
    'profile.saveFailed': "\u0630\u062E\u06CC\u0631\u0647\u0654 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F.",
    'profile.duplicateCode': "\u0627\u06CC\u0646 \u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0642\u0628\u0644\u0627\u064B \u0628\u0631\u0627\u06CC \u062D\u0633\u0627\u0628 \u062F\u06CC\u06AF\u0631\u06CC \u062B\u0628\u062A \u0634\u062F\u0647 \u0627\u0633\u062A.",
    'profile.clinics.empty': "\u0647\u0646\u0648\u0632 \u0639\u0636\u0648 \u0647\u06CC\u0686 \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u06CC \u0646\u06CC\u0633\u062A\u06CC\u062F.",
    'profile.clinics.status.pending': "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
    'profile.clinics.status.active': "\u0641\u0639\u0627\u0644",
    'profile.clinics.visitDuration': "\u0646\u0648\u0628\u062A {{count}} \u062F\u0642\u06CC\u0642\u0647",
    // انتخابگر کلینیک فعال در سایدبارِ دسکتاپ است و زیر ۷۶۸ پیکسل سایدباری وجود
    // ندارد — پس روی موبایل اینجاست، وگرنه دندان‌پزشکِ چندکلینیکی برای همیشه در یک
    // اسکوپ حبس می‌شود بدون آنکه بتواند بگوید کدام.
    'profile.clinics.activeScope': "\u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0641\u0639\u0627\u0644",
    'profile.clinics.activeScopeHint': "\u0627\u0645\u0631\u0648\u0632 \u0648 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0647\u0645\u06CC\u0646 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0631\u0627 \u0646\u0634\u0627\u0646 \u0645\u06CC\u200C\u062F\u0647\u0646\u062F.",
    'profile.clinics.joinTitle': "\u067E\u06CC\u0648\u0633\u062A\u0646 \u0628\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
    'profile.clinics.joinHint': "\u06A9\u062F \u062F\u0639\u0648\u062A \u0631\u0627 \u0627\u0632 \u0645\u062F\u06CC\u0631 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    'profile.clinics.joinPlaceholder': "\u06A9\u062F \u062F\u0639\u0648\u062A",
    'profile.clinics.joined': "\u0628\u0647 {{name}} \u067E\u06CC\u0648\u0633\u062A\u06CC\u062F.",
    'profile.clinics.notFound': "\u06A9\u0644\u06CC\u0646\u06CC\u06A9\u06CC \u0628\u0627 \u0627\u06CC\u0646 \u06A9\u062F \u062F\u0639\u0648\u062A \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F.",
    'profile.clinics.joinFailed': "\u067E\u06CC\u0648\u0633\u062A\u0646 \u0628\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F.",
    'profile.presence.empty': "\u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0647\u0646\u0648\u0632 \u0634\u06CC\u0641\u062A\u06CC \u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u062A\u0639\u0631\u06CC\u0641 \u0646\u06A9\u0631\u062F\u0647 \u0627\u0633\u062A.",
    'profile.presence.oneOff': "\u062A\u06A9\u200C\u0631\u0648\u0632",
    // See the note on this key in en.js.
    'profile.presence.inactive': "\u063A\u06CC\u0631\u0641\u0639\u0627\u0644",
    'profile.presence.readOnly': "\u0634\u06CC\u0641\u062A\u200C\u0647\u0627 \u0631\u0627 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062A\u0639\u06CC\u06CC\u0646 \u0645\u06CC\u200C\u06A9\u0646\u062F\u061B \u0627\u06CC\u0646 \u067E\u0646\u0644 \u0641\u0642\u0637 \u0622\u0646\u200C\u0647\u0627 \u0631\u0627 \u0645\u06CC\u200C\u062E\u0648\u0627\u0646\u062F.",
    'profile.presence.days.0': "\u062F\u0648\u0634\u0646\u0628\u0647",
    'profile.presence.days.1': "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
    'profile.presence.days.2': "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
    'profile.presence.days.3': "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
    'profile.presence.days.4': "\u062C\u0645\u0639\u0647",
    'profile.presence.days.5': "\u0634\u0646\u0628\u0647",
    'profile.presence.days.6': "\u06CC\u06A9\u0634\u0646\u0628\u0647",
    'profile.appearance.theme': "\u0631\u0646\u06AF \u062A\u0623\u06A9\u06CC\u062F\u06CC",
    'profile.appearance.fontSize': "\u0627\u0646\u062F\u0627\u0632\u0647\u0654 \u0645\u062A\u0646",
    'profile.appearance.language': "\u0632\u0628\u0627\u0646",
    'profile.appearance.saved': "\u062A\u0646\u0638\u06CC\u0645 \u0630\u062E\u06CC\u0631\u0647 \u0634\u062F.",
    'profile.appearance.failed': "\u062A\u0646\u0638\u06CC\u0645 \u0631\u0648\u06CC \u0633\u0631\u0648\u0631 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F.",
    'profile.theme.default': "\u0622\u0628\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
    'profile.theme.teal': "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
    'profile.theme.ocean': "\u0644\u0627\u062C\u0648\u0631\u062F\u06CC",
    'profile.theme.slate': "\u062E\u0627\u06A9\u0633\u062A\u0631\u06CC \u0622\u0628\u06CC",
    'profile.fontSize.small': "\u06A9\u0648\u0686\u06A9",
    'profile.fontSize.medium': "\u0645\u062A\u0648\u0633\u0637",
    'profile.fontSize.large': "\u0628\u0632\u0631\u06AF",
    'profile.language.fa': "\u0641\u0627\u0631\u0633\u06CC",
    'profile.language.en': 'English',
    'profile.language.fr': "Fran\xe7ais",
    'profile.language.de': 'Deutsch',
    // ── onboarding ───────────────────────────────────────────────────────────
    'onboarding.title': "\u0645\u0627\u0698\u0648\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
    'onboarding.subtitle.step1': "\u06CC\u06A9\u200C\u0628\u0627\u0631 \u062B\u0628\u062A\u200C\u0646\u0627\u0645 \u06A9\u0646\u06CC\u062F \u062A\u0627 \u062D\u0633\u0627\u0628 \u0634\u0645\u0627 \u0634\u0646\u0627\u0633\u0627\u06CC\u06CC \u0634\u0648\u062F",
    'onboarding.subtitle.clinic': "\u0628\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u06CC \u06A9\u0647 \u062F\u0631 \u0622\u0646 \u06A9\u0627\u0631 \u0645\u06CC\u200C\u06A9\u0646\u06CC\u062F \u0645\u062A\u0635\u0644 \u0634\u0648\u06CC\u062F",
    'onboarding.subtitle.done': "\u0622\u0645\u0627\u062F\u0647\u200C\u0627\u06CC\u062F",
    'onboarding.progress.step1': "\u062B\u0628\u062A\u200C\u0646\u0627\u0645",
    'onboarding.progress.clinic': "\u06A9\u0644\u06CC\u0646\u06CC\u06A9",
    'onboarding.progress.done': "\u067E\u0627\u06CC\u0627\u0646",
    'onboarding.step1.fullName': "\u0646\u0627\u0645 \u0648 \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC",
    'onboarding.step1.fullNamePlaceholder': "\u062F\u06A9\u062A\u0631 \u0645\u0631\u06CC\u0645 \u0627\u062D\u0645\u062F\u06CC",
    'onboarding.step1.medicalCode': "\u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC",
    'onboarding.step1.medicalCodePlaceholder': "\u0645\u062B\u0644\u0627\u064B \u06F1\u06F2\u06F3\u06F4\u06F5\u06F6",
    'onboarding.step1.specialty': "\u062A\u062E\u0635\u0635",
    'onboarding.step1.bio': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0634\u0645\u0627 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)",
    'onboarding.step1.submit': "\u0627\u062F\u0627\u0645\u0647",
    'onboarding.step1.specialtyNote': "\u0627\u06CC\u0646 \u067E\u0646\u0644 \u0645\u0627\u0698\u0648\u0644 \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC \u0627\u0633\u062A\u060C \u0628\u0646\u0627\u0628\u0631\u0627\u06CC\u0646 \u062A\u062E\u0635\u0635 \u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u062A\u0639\u06CC\u06CC\u0646 \u0634\u062F\u0647 \u0627\u0633\u062A.",
    'onboarding.clinic.choiceTitle': "\u0645\u0637\u0628 \u06CC\u0627 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0634\u0645\u0627",
    'onboarding.clinic.choiceDescription': "\u0627\u06AF\u0631 \u0645\u0637\u0628 \u062E\u0648\u062F\u062A\u0627\u0646 \u0631\u0627 \u062F\u0627\u0631\u06CC\u062F\u060C \u0647\u0645\u06CC\u0646\u200C\u062C\u0627 \u062B\u0628\u062A\u0634 \u06A9\u0646\u06CC\u062F. \u0627\u06AF\u0631 \u062F\u0631 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062F\u06CC\u06AF\u0631\u06CC \u06A9\u0627\u0631 \u0645\u06CC\u200C\u06A9\u0646\u06CC\u062F\u060C \u0628\u0627 \u06A9\u062F \u062F\u0639\u0648\u062A \u0628\u0647 \u0622\u0646 \u0628\u067E\u06CC\u0648\u0646\u062F\u06CC\u062F.",
    'onboarding.clinic.ownTitle': "\u0645\u0637\u0628 \u062E\u0648\u062F\u0645 \u0631\u0627 \u062B\u0628\u062A \u0645\u06CC\u200C\u06A9\u0646\u0645",
    'onboarding.clinic.ownBody': "\u0628\u0631\u0627\u06CC \u0645\u0637\u0628 \u0634\u062E\u0635\u06CC. \u0634\u0645\u0627 \u0645\u0627\u0644\u06A9 \u0622\u0646 \u062E\u0648\u0627\u0647\u06CC\u062F \u0628\u0648\u062F.",
    'onboarding.clinic.joinTitle': "\u0628\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0645\u0648\u062C\u0648\u062F \u0645\u06CC\u200C\u067E\u06CC\u0648\u0646\u062F\u0645",
    'onboarding.clinic.joinBody': "\u0628\u0627 \u06A9\u062F \u062F\u0639\u0648\u062A\u06CC \u06A9\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0628\u0647 \u0634\u0645\u0627 \u062F\u0627\u062F\u0647 \u0627\u0633\u062A.",
    'onboarding.clinic.back': "\u0628\u0627\u0632\u06AF\u0634\u062A",
    'onboarding.clinic.ownName': "\u0646\u0627\u0645 \u0645\u0637\u0628",
    'onboarding.clinic.ownNamePlaceholder': "\u0645\u0637\u0628 \u062F\u06A9\u062A\u0631 \u0627\u062D\u0645\u062F\u06CC",
    'onboarding.clinic.ownCity': "\u0634\u0647\u0631 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)",
    'onboarding.clinic.ownAddress': "\u0646\u0634\u0627\u0646\u06CC (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)",
    'onboarding.clinic.ownPhone': "\u062A\u0644\u0641\u0646 \u0645\u0637\u0628 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)",
    'onboarding.clinic.create': "\u062B\u0628\u062A \u0645\u0637\u0628",
    'validation.clinicName': "\u0646\u0627\u0645 \u0645\u0637\u0628 \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'onboarding.clinic.alreadyExists': "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062D\u0633\u0627\u0628 \u0627\u0632 \u0642\u0628\u0644 \u0645\u0637\u0628\u06CC \u062B\u0628\u062A \u0634\u062F\u0647 \u0627\u0633\u062A.",
    // The currency the practice keeps its books in. `{{currency}}` is a name
    // with its ISO code, e.g. «درهم امارات (AED)».
    'onboarding.clinic.currency': "\u0648\u0627\u062D\u062F \u067E\u0648\u0644 \u0645\u0637\u0628",
    'onboarding.clinic.currencyHint': "\u062A\u0639\u0631\u0641\u0647\u200C\u0647\u0627 \u0648 \u0637\u0631\u062D\u200C\u0647\u0627\u06CC \u062F\u0631\u0645\u0627\u0646 \u0628\u0627 \u0647\u0645\u06CC\u0646 \u0648\u0627\u062D\u062F \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \u062A\u0627 \u067E\u06CC\u0634 \u0627\u0632 \u062B\u0628\u062A \u0646\u062E\u0633\u062A\u06CC\u0646 \u0645\u0628\u0644\u063A\u060C \u0627\u0632 \u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0642\u0627\u0628\u0644 \u062A\u063A\u06CC\u06CC\u0631 \u0627\u0633\u062A.",
    'onboarding.clinic.currencyIrr': "\u062A\u0648\u0645\u0627\u0646 (IRR)",
    'onboarding.clinic.currencyMismatch': "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062D\u0633\u0627\u0628 \u0627\u0632 \u0642\u0628\u0644 \u0645\u0637\u0628\u06CC \u0628\u0627 \u0648\u0627\u062D\u062F \u067E\u0648\u0644 {{currency}} \u062B\u0628\u062A \u0634\u062F\u0647 \u0627\u0633\u062A. \u0647\u0645\u0627\u0646 \u0648\u0627\u062D\u062F \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F\u060C \u06CC\u0627 \u0622\u0646 \u0631\u0627 \u062F\u0631 \u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062A\u063A\u06CC\u06CC\u0631 \u062F\u0647\u06CC\u062F.",
    'onboarding.clinic.setupIncomplete': "\u0645\u0637\u0628 \u062B\u0628\u062A \u0634\u062F\u060C \u0627\u0645\u0627 \u0648\u0627\u062D\u062F \u067E\u0648\u0644 \u0622\u0646 \u062F\u0631 \u062D\u0633\u0627\u0628\u062F\u0627\u0631\u06CC \u062A\u0646\u0638\u06CC\u0645 \u0646\u0634\u062F. \u0645\u0637\u0628 \u0631\u0627 \u062F\u0648\u0628\u0627\u0631\u0647 \u062B\u0628\u062A \u0646\u06A9\u0646\u06CC\u062F\u061B \u0628\u0631\u0627\u06CC \u062A\u06A9\u0645\u06CC\u0644 \u0622\u0646 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
    'onboarding.clinic.title': "\u0628\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062E\u0648\u062F \u0628\u067E\u06CC\u0648\u0646\u062F\u06CC\u062F",
    'onboarding.clinic.description': "\u0628\u0627 \u06A9\u062F \u062F\u0639\u0648\u062A \u06A9\u0644\u06CC\u0646\u06CC\u06A9\u060C \u0646\u0648\u0628\u062A\u200C\u0647\u0627 \u0648 \u062F\u0641\u062A\u0631 \u0628\u06CC\u0645\u0627\u0631\u0627\u0646 \u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u0628\u0627\u0632 \u0645\u06CC\u200C\u0634\u0648\u062F. \u0627\u06CC\u0646 \u06A9\u0627\u0631 \u0631\u0627 \u0628\u0639\u062F\u0627\u064B \u0647\u0645 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u0627\u0632 \u067E\u0631\u0648\u0641\u0627\u06CC\u0644 \u0627\u0646\u062C\u0627\u0645 \u062F\u0647\u06CC\u062F.",
    'onboarding.clinic.placeholder': "\u06A9\u062F \u062F\u0639\u0648\u062A",
    'onboarding.clinic.join': "\u067E\u06CC\u0648\u0633\u062A\u0646",
    'onboarding.clinic.skip': "\u0628\u0639\u062F\u0627\u064B",
    'onboarding.done.title': "\u062E\u0648\u0634 \u0622\u0645\u062F\u06CC\u062F",
    'onboarding.done.body': "\u0641\u0636\u0627\u06CC \u06A9\u0627\u0631\u06CC \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC \u0634\u0645\u0627 \u0622\u0645\u0627\u062F\u0647 \u0627\u0633\u062A. \u062F\u0631 \xab\u0627\u0645\u0631\u0648\u0632\xbb \u0646\u0648\u0628\u062A\u200C\u0647\u0627\u06CC\u06CC \u0631\u0627 \u0645\u06CC\u200C\u0628\u06CC\u0646\u06CC\u062F \u06A9\u0647 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u0628\u0631\u0627\u06CC\u062A\u0627\u0646 \u062B\u0628\u062A \u0645\u06CC\u200C\u06A9\u0646\u062F.",
    'onboarding.done.enter': "\u0648\u0631\u0648\u062F \u0628\u0647 \u067E\u0646\u0644",
    // ── validation ───────────────────────────────────────────────────────────
    'validation.medicalCode': "\u06A9\u062F \u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'validation.fullName': "\u0646\u0627\u0645 \u0648 \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'validation.invitationCode': "\u06A9\u062F \u062F\u0639\u0648\u062A \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'validation.officePhone': "\u062A\u0644\u0641\u0646 \u0645\u0637\u0628 \u06A9\u0627\u0645\u0644 \u0646\u06CC\u0633\u062A. \u0622\u0646 \u0631\u0627 \u0627\u0635\u0644\u0627\u062D \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u062E\u0627\u0644\u06CC \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F.",
    'validation.phone.tooShort': "\u0634\u0645\u0627\u0631\u0647\u0654 {{country}} \u06A9\u0648\u062A\u0627\u0647 \u0627\u0633\u062A \u2014 \u0646\u0645\u0648\u0646\u0647: {{example}}",
    'validation.phone.tooLong': "\u0634\u0645\u0627\u0631\u0647\u0654 {{country}} \u0628\u0644\u0646\u062F \u0627\u0633\u062A \u2014 \u0646\u0645\u0648\u0646\u0647: {{example}}",
    'validation.phone.invalid': "\u0634\u0645\u0627\u0631\u0647\u0654 \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A.",
    // ── چارت دندان / odontogram ──────────────────────────────────────────────
    'patient.tabs.plan': "\u067E\u0644\u0646 \u062F\u0631\u0645\u0627\u0646",
    'patient.plan.empty.title': "\u0647\u0646\u0648\u0632 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646\u06CC \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'patient.plan.empty.description': "\u067E\u0644\u0646 \u062F\u0631\u0645\u0627\u0646 \u062F\u0631 \u062C\u0631\u06CC\u0627\u0646 \u0648\u06CC\u0632\u06CC\u062A \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'patient.plan.noLines': "\u0627\u06CC\u0646 \u062F\u0648\u0631\u0647 \u0647\u0646\u0648\u0632 \u0631\u062F\u06CC\u0641\u06CC \u0646\u062F\u0627\u0631\u062F.",
    'patient.plan.doneTitle': "\u062F\u0631\u0645\u0627\u0646\u200C\u0647\u0627\u06CC \u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
    'patient.plan.outstanding': "{{count}} \u0627\u0642\u062F\u0627\u0645 \u0627\u0646\u062C\u0627\u0645\u200C\u0646\u0634\u062F\u0647 \u2014 \u0645\u062C\u0645\u0648\u0639 {{amount}}",
    'patient.tabs.chart': "\u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646",
    'chart.tooth': "\u062F\u0646\u062F\u0627\u0646",
    'chart.universalShort': "\u0634\u0645\u0627\u0631\u0647\u0654 \u0622\u0645\u0631\u06CC\u06A9\u0627\u06CC\u06CC",
    'chart.annotation.planned': "\u062F\u0631 \u0628\u0631\u0646\u0627\u0645\u0647",
    'chart.annotation.treated': "\u062F\u0631\u0645\u0627\u0646\u200C\u0634\u062F\u0647",
    'chart.legend.planned': "\u062F\u0631 \u0628\u0631\u0646\u0627\u0645\u0647",
    'chart.legend.treated': "\u062F\u0631\u0645\u0627\u0646\u200C\u0634\u062F\u0647",
    'chart.tooltip.treated': "\u062F\u0631\u0645\u0627\u0646\u200C\u0647\u0627\u06CC \u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
    'chart.tooltip.andMore': "\u0648 {{count}} \u0645\u0648\u0631\u062F \u062F\u06CC\u06AF\u0631",
    'chart.tooltip.planned': "\u062F\u0631 \u0628\u0631\u0646\u0627\u0645\u0647",
    'chart.wholeMouth.title': "\u06A9\u0644 \u062F\u0647\u0627\u0646",
    'chart.history.title': "\u062A\u0627\u0631\u06CC\u062E\u0686\u0647\u0654 \u062F\u0646\u062F\u0627\u0646 {{fdi}}",
    'chart.history.treatment': "\u062F\u0631\u0645\u0627\u0646",
    'chart.history.event': "\u0686\u0627\u0631\u062A",
    'chart.history.causedBy': "\u0627\u0632 \u062F\u0631\u0645\u0627\u0646 \u0628\u0627\u0644\u0627",
    'chart.history.empty': "\u0647\u0646\u0648\u0632 \u0686\u06CC\u0632\u06CC \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062F\u0646\u062F\u0627\u0646 \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'chart.history.unavailable': "\u062A\u0627\u0631\u06CC\u062E\u0686\u0647\u0654 \u0627\u06CC\u0646 \u062F\u0646\u062F\u0627\u0646 \u062E\u0648\u0627\u0646\u062F\u0647 \u0646\u0634\u062F.",
    'chart.history.session': "\u062C\u0644\u0633\u0647\u0654 {{n}}",
    'chart.history.voided': "\u0627\u0628\u0637\u0627\u0644\u200C\u0634\u062F\u0647 \u2014 {{reason}}",
    'chart.notCharted': "\u062B\u0628\u062A\u200C\u0646\u0634\u062F\u0647",
    'chart.patientRight': "\u0631\u0627\u0633\u062A \u0628\u06CC\u0645\u0627\u0631",
    'chart.patientLeft': "\u0686\u067E \u0628\u06CC\u0645\u0627\u0631",
    'chart.aria.odontogram': "\u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 \u2014 \u0628\u0631\u0627\u06CC \u062B\u0628\u062A\u060C \u0631\u0648\u06CC \u062F\u0646\u062F\u0627\u0646 \u06CC\u0627 \u0633\u0637\u062D \u0622\u0646 \u06A9\u0644\u06CC\u06A9 \u06A9\u0646\u06CC\u062F",
    'chart.hint': "\u0628\u0631\u0627\u06CC \u062B\u0628\u062A \u0631\u0648\u06CC \u06CC\u06A9 \u0633\u0637\u062D \u06A9\u0644\u06CC\u06A9 \u06A9\u0646\u06CC\u062F\u060C \u06CC\u0627 \u0631\u0648\u06CC \u062E\u0648\u062F \u062F\u0646\u062F\u0627\u0646 \u0628\u0631\u0627\u06CC \u0648\u0636\u0639\u06CC\u062A \u06A9\u0644\u06CC.",
    // ── چارت، موبایل ─────────────────────────────────────────────────────────
    // chart.hint از کنشِ ماوس حرف می‌زند. روی صفحهٔ لمسی هر تاج حدود ۱۰ پیکسل و هر
    // سطح بسیار کمتر است — زیر کفِ ۴۴ پیکسل، و بدون شکستن قاب آناتومیک قابل
    // بزرگ‌کردن نیست. پس موبایل متن خودش و انتخابگر دندانِ ≥۴۴ پیکسلی خودش را دارد.
    'chart.mobile.settings': "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u0646\u0645\u0648\u062F\u0627\u0631",
    'chart.mobile.pickTooth': "\u0627\u0646\u062A\u062E\u0627\u0628 \u062F\u0646\u062F\u0627\u0646",
    'chart.mobile.tapHint': "\u0631\u0648\u06CC \u062F\u0646\u062F\u0627\u0646 \u062F\u0631 \u0646\u0645\u0648\u062F\u0627\u0631 \u0628\u0632\u0646\u06CC\u062F\u060C \u06CC\u0627 \u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u067E\u0627\u06CC\u06CC\u0646 \u06CC\u06A9\u06CC \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F \u2014 \u0633\u0637\u0648\u062D \u062F\u0631 \u0634\u06CC\u062A\u06CC \u06A9\u0647 \u0628\u0627\u0632 \u0645\u06CC\u200C\u0634\u0648\u062F \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'chart.mobile.legend': "\u0631\u0627\u0647\u0646\u0645\u0627",
    'chart.legend.bridge': "\u0628\u0631\u06CC\u062C",
    'chart.legend.wholeToothCaries': "\u067E\u0648\u0633\u06CC\u062F\u06AF\u06CC \u06A9\u0644 \u062F\u0646\u062F\u0627\u0646",
    'chart.export.button': "\u062E\u0631\u0648\u062C\u06CC \u062A\u0635\u0648\u06CC\u0631",
    'chart.export.error': "\u062E\u0631\u0648\u062C\u06CC \u062A\u0635\u0648\u06CC\u0631 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F \u2014 \u0645\u0631\u0648\u0631\u06AF\u0631 \u0627\u0632 \u0622\u0646 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0646\u0645\u06CC\u200C\u06A9\u0646\u062F.",
    'chart.material': "\u062C\u0646\u0633",
    'chart.isHistorical': "\u06A9\u0627\u0631 \u0642\u0628\u0644\u06CC (\u0627\u0645\u0631\u0648\u0632 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F\u0647)",
    'chart.showPrimary': "\u0646\u0645\u0627\u06CC\u0634 \u062F\u0646\u062F\u0627\u0646\u200C\u0647\u0627\u06CC \u0634\u06CC\u0631\u06CC",
    'chart.hidePrimary': "\u067E\u0646\u0647\u0627\u0646\u200C\u06A9\u0631\u062F\u0646 \u062F\u0646\u062F\u0627\u0646\u200C\u0647\u0627\u06CC \u0634\u06CC\u0631\u06CC",
    'chart.showUniversal': "\u0646\u0645\u0627\u06CC\u0634 \u0634\u0645\u0627\u0631\u0647\u0654 \u0622\u0645\u0631\u06CC\u06A9\u0627\u06CC\u06CC",
    'chart.hideUniversal': "\u067E\u0646\u0647\u0627\u0646\u200C\u06A9\u0631\u062F\u0646 \u0634\u0645\u0627\u0631\u0647\u0654 \u0622\u0645\u0631\u06CC\u06A9\u0627\u06CC\u06CC",
    'chart.error.title': "\u0686\u0627\u0631\u062A \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'chart.error.body': "\u062F\u0631\u06CC\u0627\u0641\u062A \u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'chart.summary.charted': "\u062B\u0628\u062A\u200C\u0634\u062F\u0647",
    'chart.summary.decayed': "\u067E\u0648\u0633\u06CC\u062F\u0647",
    'chart.summary.restored': "\u062A\u0631\u0645\u06CC\u0645\u200C\u0634\u062F\u0647",
    'chart.summary.missing': "\u06A9\u0634\u06CC\u062F\u0647\u200C\u0634\u062F\u0647",
    'chart.summary.dmft': "\u0634\u0627\u062E\u0635 DMFT",
    'chart.presence.title': "\u0648\u0636\u0639\u06CC\u062A \u062F\u0646\u062F\u0627\u0646",
    'chart.presence.present': "\u0645\u0648\u062C\u0648\u062F",
    'chart.presence.extracted': "\u06A9\u0634\u06CC\u062F\u0647\u200C\u0634\u062F\u0647",
    'chart.presence.exfoliated': "\u0627\u0641\u062A\u0627\u062F\u0647 (\u0634\u06CC\u0631\u06CC)",
    'chart.presence.congenitally_absent': "\u0641\u0642\u062F\u0627\u0646 \u0645\u0627\u062F\u0631\u0632\u0627\u062F\u06CC",
    'chart.presence.unerupted': "\u0646\u0631\u0648\u06CC\u06CC\u062F\u0647",
    'chart.presence.impacted': "\u0646\u0647\u0641\u062A\u0647",
    'chart.surfaces.title': "\u0633\u0637\u0648\u062D",
    'chart.surfaces.hint': "\u06CC\u06A9 \u0633\u0637\u062D \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F\u060C \u0633\u067E\u0633 \u0648\u0636\u0639\u06CC\u062A \u0622\u0646 \u0631\u0627",
    'chart.surfaces.setFor': "\u0648\u0636\u0639\u06CC\u062A \u0628\u0631\u0627\u06CC",
    'chart.surface.M': "\u0645\u0632\u06CC\u0627\u0644",
    'chart.surface.D': "\u062F\u06CC\u0633\u062A\u0627\u0644",
    'chart.surface.F': "\u0628\u0627\u06A9\u0627\u0644/\u0644\u0628\u06CC\u0627\u0644",
    'chart.surface.L': "\u0644\u06CC\u0646\u06AF\u0648\u0627\u0644/\u067E\u0627\u0644\u0627\u062A\u0627\u0644",
    'chart.surface.O': "\u0627\u06A9\u0644\u0648\u0632\u0627\u0644",
    'chart.surface.I': "\u0627\u06CC\u0646\u0633\u0627\u06CC\u0632\u0627\u0644",
    'chart.surfaceState.sound': "\u0633\u0627\u0644\u0645",
    'chart.surfaceState.caries': "\u067E\u0648\u0633\u06CC\u062F\u06AF\u06CC",
    'chart.surfaceState.restoration': "\u062A\u0631\u0645\u06CC\u0645",
    'chart.surfaceState.recurrent_caries': "\u067E\u0648\u0633\u06CC\u062F\u06AF\u06CC \u062B\u0627\u0646\u0648\u06CC\u0647",
    'chart.surfaceState.temporary': "\u062A\u0631\u0645\u06CC\u0645 \u0645\u0648\u0642\u062A",
    'chart.surfaceState.sealant': "\u0641\u06CC\u0634\u0648\u0631\u0633\u06CC\u0644\u0627\u0646\u062A",
    'chart.surfaceState.fractured': "\u0634\u06A9\u0633\u062A\u06AF\u06CC",
    'chart.condition.title': "\u06A9\u0644 \u062F\u0646\u062F\u0627\u0646",
    'chart.condition.hint': "\u0645\u0633\u062A\u0642\u0644 \u0627\u0632 \u0633\u0637\u0648\u062D \u0628\u0627\u0644\u0627",
    'chart.conditionName.sound': "\u0633\u0627\u0644\u0645",
    'chart.conditionName.caries': "\u067E\u0648\u0633\u06CC\u062F\u06AF\u06CC",
    'chart.conditionName.root_canal': "\u0639\u0635\u0628\u200C\u06A9\u0634\u06CC",
    'chart.conditionName.post_core': "\u067E\u0633\u062A \u0648 \u06A9\u0648\u0631",
    'chart.conditionName.crown': "\u0631\u0648\u06A9\u0634",
    'chart.conditionName.veneer': "\u0648\u0646\u06CC\u0631 / \u0644\u0645\u06CC\u0646\u062A",
    'chart.conditionName.implant': "\u0627\u06CC\u0645\u067E\u0644\u0646\u062A",
    'chart.conditionName.bridge_abutment': "\u067E\u0627\u06CC\u0647\u0654 \u0628\u0631\u06CC\u062C",
    'chart.conditionName.bridge_pontic': "\u067E\u0648\u0646\u062A\u06CC\u06A9",
    'chart.conditionName.fracture': "\u0634\u06A9\u0633\u062A\u06AF\u06CC",
    'chart.conditionName.attrition': "\u0633\u0627\u06CC\u0634",
    'chart.conditionName.mobility': "\u0644\u0642\u06CC",
    'chart.conditionName.periapical_lesion': "\u0636\u0627\u06CC\u0639\u0647\u0654 \u0627\u067E\u06CC\u06A9\u0627\u0644",
    'chart.conditionName.sealant': "\u0641\u06CC\u0634\u0648\u0631\u0633\u06CC\u0644\u0627\u0646\u062A",
    'chart.conditionName.temporary': "\u0645\u0648\u0642\u062A",
    'chart.conditionName.watch': "\u062A\u062D\u062A \u0646\u0638\u0631",
    'chart.note.title': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'chart.note.placeholder': "\u0647\u0631 \u0646\u06A9\u062A\u0647\u0654 \u0642\u0627\u0628\u0644 \u062B\u0628\u062A \u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0627\u06CC\u0646 \u062F\u0646\u062F\u0627\u0646",
    'chart.materialName.composite': "\u06A9\u0627\u0645\u067E\u0648\u0632\u06CC\u062A",
    'chart.materialName.amalgam': "\u0622\u0645\u0627\u0644\u06AF\u0627\u0645",
    'chart.materialName.glass_ionomer': "\u06AF\u0644\u0627\u0633\u200C\u0622\u06CC\u0646\u0648\u0645\u0631",
    'chart.materialName.zirconia': "\u0632\u06CC\u0631\u06A9\u0648\u0646\u06CC\u0627",
    'chart.materialName.pfm': "\u0641\u0644\u0632-\u0633\u0631\u0627\u0645\u06CC\u06A9 (PFM)",
    'chart.materialName.full_metal': "\u0641\u0648\u0644\u200C\u0645\u062A\u0627\u0644",
    'chart.materialName.emax': "\u0627\u06CC\u200C\u0645\u06A9\u0633",
    'chart.materialName.temporary': "\u0645\u0648\u0642\u062A",
    'chart.materialName.gold': "\u0637\u0644\u0627",
    // ── hover card ──────────────────────────────────────────────────────────
    'chart.primary': "\u0634\u06CC\u0631\u06CC",
    'chart.tooltip.notCharted': "\u0647\u0646\u0648\u0632 \u0686\u06CC\u0632\u06CC \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062F\u0646\u062F\u0627\u0646 \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'chart.tooltip.sound': "\u0645\u0639\u0627\u06CC\u0646\u0647 \u0634\u062F\u0647 \u2014 \u0628\u062F\u0648\u0646 \u06CC\u0627\u0641\u062A\u0647",
    'chart.tooltip.lastRecorded': "\u0622\u062E\u0631\u06CC\u0646 \u062B\u0628\u062A",
    'chart.quadrant.upperRight': "\u0628\u0627\u0644\u0627 \u0631\u0627\u0633\u062A (\u0628\u06CC\u0645\u0627\u0631)",
    'chart.quadrant.upperLeft': "\u0628\u0627\u0644\u0627 \u0686\u067E (\u0628\u06CC\u0645\u0627\u0631)",
    'chart.quadrant.lowerRight': "\u067E\u0627\u06CC\u06CC\u0646 \u0631\u0627\u0633\u062A (\u0628\u06CC\u0645\u0627\u0631)",
    'chart.quadrant.lowerLeft': "\u067E\u0627\u06CC\u06CC\u0646 \u0686\u067E (\u0628\u06CC\u0645\u0627\u0631)",
    'chart.toothName.centralIncisor': "\u062B\u0646\u0627\u06CC\u0627\u06CC \u0645\u06CC\u0627\u0646\u06CC (\u0633\u0627\u0646\u062A\u0631\u0627\u0644)",
    'chart.toothName.lateralIncisor': "\u062B\u0646\u0627\u06CC\u0627\u06CC \u06A9\u0646\u0627\u0631\u06CC (\u0644\u062A\u0631\u0627\u0644)",
    'chart.toothName.canine': "\u0646\u06CC\u0634 (\u06A9\u0627\u0646\u06CC\u0646)",
    'chart.toothName.firstPremolar': "\u067E\u0631\u0645\u0648\u0644\u0631 \u0627\u0648\u0644",
    'chart.toothName.secondPremolar': "\u067E\u0631\u0645\u0648\u0644\u0631 \u062F\u0648\u0645",
    'chart.toothName.firstMolar': "\u0645\u0648\u0644\u0631 \u0627\u0648\u0644",
    'chart.toothName.secondMolar': "\u0645\u0648\u0644\u0631 \u062F\u0648\u0645",
    'chart.toothName.thirdMolar': "\u0645\u0648\u0644\u0631 \u0633\u0648\u0645 (\u0639\u0642\u0644)",
    // ── جلسهٔ درمان — میز کار ویزیت (docs/dent-visit.md) ─────────────────────
    'visit.error.title': "\u062C\u0644\u0633\u0647\u0654 \u062F\u0631\u0645\u0627\u0646 \u0628\u0627\u0632 \u0646\u0634\u062F",
    'visit.error.body': "\u062E\u0648\u0627\u0646\u062F\u0646 \u0627\u06CC\u0646 \u0646\u0648\u0628\u062A \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.notFound.title': "\u062C\u0644\u0633\u0647 \u06CC\u0627\u0641\u062A \u0646\u0634\u062F",
    'visit.notFound.description': "\u0627\u06CC\u0646 \u0646\u0648\u0628\u062A \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F\u060C \u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u0646\u06CC\u0633\u062A\u060C \u06CC\u0627 \u067E\u0631\u0648\u0646\u062F\u0647\u0654 \u0628\u06CC\u0645\u0627\u0631\u06CC \u0628\u0647 \u0622\u0646 \u0645\u062A\u0635\u0644 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.unknownPatient': "\u0628\u06CC\u0645\u0627\u0631 \u0628\u062F\u0648\u0646 \u0646\u0627\u0645",
    'visit.openRecord': "\u067E\u0631\u0648\u0646\u062F\u0647\u0654 \u0628\u06CC\u0645\u0627\u0631",
    'visit.finish.action': "\u067E\u0627\u06CC\u0627\u0646 \u062C\u0644\u0633\u0647",
    'visit.finish.working': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0633\u062A\u0646\u2026",
    'visit.finish.confirm.title': "\u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0634\u0648\u062F\u061F",
    'visit.finish.confirm.body': "\u0647\u0631\u0686\u0647 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u0647 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F. \u067E\u0633 \u0627\u0632 \u0622\u0646 \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0641\u0642\u0637 \u062E\u0648\u0627\u0646\u062F\u0646\u06CC \u0627\u0633\u062A \u0648 \u0627\u0632 \u0627\u06CC\u0646 \u0628\u0631\u0646\u0627\u0645\u0647 \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u0627\u0632 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    // «نوبت بعدی» — asked only when the visit leaves work planned and not done.
    'visit.finish.followUp.title': "{{count}} \u0627\u0642\u062F\u0627\u0645 \u0627\u0632 \u067E\u0644\u0646 \u062F\u0631\u0645\u0627\u0646 \u0628\u0627\u0642\u06CC \u0645\u0627\u0646\u062F\u0647",
    'visit.finish.followUp.andMore': "\u0648 {{count}} \u0645\u0648\u0631\u062F \u062F\u06CC\u06AF\u0631",
    'visit.finish.followUp.today': "\u0647\u0645\u06CC\u0646 \u0627\u0645\u0631\u0648\u0632",
    'visit.finish.followUp.tomorrow': "\u0641\u0631\u062F\u0627",
    'visit.finish.followUp.withinWeek': "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u0647\u0641\u062A\u0647",
    'visit.finish.followUp.within2Weeks': "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u062F\u0648 \u0647\u0641\u062A\u0647",
    'visit.finish.followUp.withinMonth': "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u0645\u0627\u0647",
    'visit.finish.followUp.within3Months': "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u0633\u0647 \u0645\u0627\u0647",
    'visit.finish.followUp.when': "\u0646\u0648\u0628\u062A \u0628\u0639\u062F\u06CC \u062A\u0627 \u0686\u0647 \u0632\u0645\u0627\u0646\u06CC \u0628\u0627\u0634\u062F\u061F",
    'visit.finish.followUp.none': "\u0644\u0627\u0632\u0645 \u0646\u06CC\u0633\u062A",
    'visit.finish.followUp.deskNote': "\u0628\u0647 \u067E\u0630\u06CC\u0631\u0634 \u0627\u0639\u0644\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F \u062A\u0627 \u0646\u0648\u0628\u062A \u0628\u0639\u062F\u06CC \u0631\u0627 \u0628\u0627 \u0634\u0645\u0627 \u0647\u0645\u0627\u0647\u0646\u06AF \u06A9\u0646\u062F.",
    'visit.finish.followUp.noneNote': "\u0686\u06CC\u0632\u06CC \u0628\u0647 \u067E\u0630\u06CC\u0631\u0634 \u0627\u0639\u0644\u0627\u0645 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.finish.done.plain': "\u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0634\u062F.",
    'visit.finish.done.followUpRaised': "\u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0634\u062F. \u0646\u0648\u0628\u062A \u0628\u0639\u062F\u06CC \u0628\u0647 \u067E\u0630\u06CC\u0631\u0634 \u0627\u0639\u0644\u0627\u0645 \u0634\u062F.",
    'visit.finish.done.alreadyBooked': "\u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0634\u062F. \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0627\u0632 \u0642\u0628\u0644 \u0646\u0648\u0628\u062A \u0628\u0639\u062F\u06CC \u062F\u0627\u0631\u062F.",
    'visit.finish.done.followUpFailed': "\u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0634\u062F\u060C \u0627\u0645\u0627 \u0646\u0648\u0628\u062A \u0628\u0639\u062F\u06CC \u0628\u0647 \u067E\u0630\u06CC\u0631\u0634 \u0627\u0639\u0644\u0627\u0645 \u0646\u0634\u062F.",
    'visit.finish.error.subjective': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u060C \u0628\u0646\u0627\u0628\u0631\u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0646\u0634\u062F. \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.finish.error.complete': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647 \u0634\u062F\u060C \u0627\u0645\u0627 \u0628\u0633\u062A\u0646 \u062C\u0644\u0633\u0647 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    // ── ویزیت تصویری ─────────────────────────────────────────────────────────
    'visit.call.start': "\u062A\u0645\u0627\u0633 \u062A\u0635\u0648\u06CC\u0631\u06CC",
    'visit.call.title': "\u062A\u0645\u0627\u0633 \u062A\u0635\u0648\u06CC\u0631\u06CC",
    'visit.call.panelLabel': "\u067E\u0646\u062C\u0631\u0647\u0654 \u062A\u0645\u0627\u0633 \u062A\u0635\u0648\u06CC\u0631\u06CC",
    'visit.call.connecting': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u062A\u0635\u0627\u0644\u2026",
    // «پایان تماس», never «پایان جلسه» — closing the visit is one-way and closes
    // the record; hanging up does neither, and the two must never read alike.
    'visit.call.hangUp': "\u067E\u0627\u06CC\u0627\u0646 \u062A\u0645\u0627\u0633",
    'visit.call.notRecorded': "\u0627\u06CC\u0646 \u062A\u0645\u0627\u0633 \u0636\u0628\u0637 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0686\u06CC\u0632\u06CC \u0627\u0632 \u0622\u0646 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0645\u06CC\u200C\u06AF\u0631\u062F\u062F.",
    'visit.call.error.connection': "\u062A\u0645\u0627\u0633 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u0634\u062F. \u0627\u062A\u0635\u0627\u0644 \u0627\u06CC\u0646\u062A\u0631\u0646\u062A \u0631\u0627 \u0628\u0631\u0631\u0633\u06CC \u06A9\u0646\u06CC\u062F \u0648 \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.call.error.unavailable': "\u062A\u0645\u0627\u0633 \u062A\u0635\u0648\u06CC\u0631\u06CC \u062F\u0631 \u0627\u06CC\u0646 \u0645\u062D\u06CC\u0637 \u0641\u0639\u0627\u0644 \u0646\u06CC\u0633\u062A.",
    'visit.call.error.visitOver': "\u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0634\u062F\u0647 \u0627\u0633\u062A \u0648 \u062A\u0645\u0627\u0633 \u062A\u0635\u0648\u06CC\u0631\u06CC \u0631\u0648\u06CC \u0622\u0646 \u0628\u0631\u0642\u0631\u0627\u0631 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.readOnly.badge': "\u0641\u0642\u0637 \u062E\u0648\u0627\u0646\u062F\u0646\u06CC",
    'visit.readOnly.note': "\u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0628\u0633\u062A\u0647 \u0634\u062F\u0647 \u0627\u0633\u062A \u0648 \u0686\u06CC\u0632 \u062A\u0627\u0632\u0647\u200C\u0627\u06CC \u0631\u0648\u06CC \u0622\u0646 \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F. \u0622\u0646\u0686\u0647 \u067E\u06CC\u0634\u200C\u062A\u0631 \u062B\u0628\u062A \u0634\u062F\u0647 \u0647\u0645\u0686\u0646\u0627\u0646 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.ai.costsCredits': "\u0627\u06CC\u0646 \u06A9\u0627\u0631 \u0627\u0632 \u0627\u0639\u062A\u0628\u0627\u0631 \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC \u06A9\u0645 \u0645\u06CC\u200C\u06A9\u0646\u062F.",
    'visit.tabs.meds': "\u062F\u0627\u0631\u0648",
    'visit.tabs.orders': "\u062F\u0633\u062A\u0648\u0631\u0627\u062A",
    'visit.tabs.diagnosis': "\u062A\u0634\u062E\u06CC\u0635",
    'visit.tabs.questions': "\u067E\u0631\u0633\u0634\u200C\u0647\u0627",
    'visit.tabs.files': "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627",
    'visit.tabs.sectionsLabel': "\u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u062C\u0644\u0633\u0647",
    // ── §3.1.1 اودنتوگرام ────────────────────────────────────────────────────
    'visit.chart.title': "\u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646",
    'visit.chart.hint': "\u0628\u0631\u0627\u06CC \u062F\u06CC\u062F\u0646 \u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627 \u0648 \u0627\u0642\u062F\u0627\u0645\u200C\u0647\u0627\u06CC \u0628\u0631\u0646\u0627\u0645\u0647\u200C\u0631\u06CC\u0632\u06CC\u200C\u0634\u062F\u0647\u060C \u062F\u0646\u062F\u0627\u0646 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.",
    'visit.chart.tooth': "\u062F\u0646\u062F\u0627\u0646 {{fdi}}",
    'visit.chart.openTooth': "\u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627",
    'visit.chart.planForTooth': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0647 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646",
    'visit.chart.noPlanForTooth': "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062F\u0646\u062F\u0627\u0646 \u0627\u0642\u062F\u0627\u0645\u06CC \u0628\u0631\u0646\u0627\u0645\u0647\u200C\u0631\u06CC\u0632\u06CC \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.chart.history': "\u0633\u0627\u0628\u0642\u0647",
    'visit.chart.noHistory': "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062F\u0646\u062F\u0627\u0646 \u0686\u06CC\u0632\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.chart.historyUnavailable': "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0633\u0627\u0628\u0642\u0647 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.chart.historical': "\u0633\u0627\u0628\u0642",
    // ── §3.1.2 شرح حال ───────────────────────────────────────────────────────
    'visit.subjective.title': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0628\u06CC\u0645\u0627\u0631",
    'visit.subjective.error.title': "\u0634\u0631\u062D \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'visit.subjective.error.body': "\u062E\u0648\u0627\u0646\u062F\u0646 \u0634\u0631\u062D \u062D\u0627\u0644 \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.subjective.saved': "\u062B\u0628\u062A \u0634\u062F",
    'visit.subjective.saveFailed': "\u062B\u0628\u062A \u0634\u0631\u062D \u062D\u0627\u0644 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.subjective.history': "\u0633\u0648\u0627\u0628\u0642 \u0628\u06CC\u0645\u0627\u0631",
    'visit.subjective.noAllergies': "\u062D\u0633\u0627\u0633\u06CC\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
    'visit.subjective.conditions': "\u0628\u06CC\u0645\u0627\u0631\u06CC\u200C\u0647\u0627",
    'visit.subjective.medications': "\u062F\u0627\u0631\u0648\u0647\u0627",
    'visit.subjective.chiefComplaint': "\u0634\u06A9\u0627\u06CC\u062A \u0627\u0635\u0644\u06CC",
    'visit.subjective.dictateComplaint': "\u06AF\u0641\u062A\u0646 \u0634\u06A9\u0627\u06CC\u062A \u0627\u0635\u0644\u06CC \u0628\u0627 \u0635\u062F\u0627",
    'visit.subjective.dictateNotes': "\u06AF\u0641\u062A\u0646 \u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0628\u0627 \u0635\u062F\u0627",
    'visit.subjective.teeth': "\u062F\u0646\u062F\u0627\u0646\u200C\u0647\u0627\u06CC \u062F\u0631\u06AF\u06CC\u0631",
    'visit.subjective.noTeeth': "\u0631\u0648\u06CC \u062F\u0646\u062F\u0627\u0646\u200C\u0647\u0627\u06CC \u0645\u0648\u0631\u062F \u0646\u0638\u0631 \u062F\u0631 \u0686\u0627\u0631\u062A \u0628\u0632\u0646\u06CC\u062F",
    'visit.subjective.addTooth': "\u0627\u0641\u0632\u0648\u062F\u0646 \u062F\u0646\u062F\u0627\u0646 {{fdi}}",
    'visit.subjective.selectToothFirst': "\u0627\u0628\u062A\u062F\u0627 \u0627\u0632 \u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
    'visit.subjective.painScore': "\u0634\u062F\u062A \u062F\u0631\u062F (\u06F0 \u062A\u0627 \u06F1\u06F0)",
    'visit.subjective.painCharacter': "\u0646\u0648\u0639 \u062F\u0631\u062F",
    'visit.subjective.pain.sharp': "\u062A\u06CC\u0632",
    'visit.subjective.pain.dull': "\u0645\u0628\u0647\u0645",
    'visit.subjective.pain.throbbing': "\u0636\u0631\u0628\u0627\u0646\u200C\u062F\u0627\u0631",
    'visit.subjective.pain.sensitivity': "\u062D\u0633\u0627\u0633\u06CC\u062A",
    'visit.subjective.pain.none': "\u0628\u062F\u0648\u0646 \u062F\u0631\u062F",
    'visit.subjective.onset': "\u0632\u0645\u0627\u0646 \u0634\u0631\u0648\u0639",
    'visit.subjective.duration': "\u0645\u062F\u062A",
    'visit.subjective.aggravating': "\u062A\u0634\u062F\u06CC\u062F\u06A9\u0646\u0646\u062F\u0647",
    'visit.subjective.relieving': "\u062A\u0633\u06A9\u06CC\u0646\u200C\u062F\u0647\u0646\u062F\u0647",
    'visit.subjective.dentalHistory': "\u0633\u0627\u0628\u0642\u0647\u0654 \u062F\u0646\u062F\u0627\u0646\u06CC",
    'visit.subjective.notes': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'visit.subjective.priorVisits': "\u0645\u0631\u0627\u062C\u0639\u0627\u062A \u0642\u0628\u0644\u06CC",
    'visit.subjective.noPriorVisits': "\u0645\u0631\u0627\u062C\u0639\u0647\u0654 \u0642\u0628\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.subjective.priorNoSummary': "\u0634\u06A9\u0627\u06CC\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.subjective.priorDiagnoses': "{{count}} \u062A\u0634\u062E\u06CC\u0635",
    // ── §3.1.3 اقدام درمانی و پلن درمان دندانی ───────────────────────────────
    'visit.plan.title': "\u067E\u0644\u0646 \u062F\u0631\u0645\u0627\u0646",
    'visit.plan.error.title': "\u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'visit.plan.error.body': "\u062E\u0648\u0627\u0646\u062F\u0646 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646 \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    // Clinic-currency refusals, by extensions.code (CLINIC_CURRENCY_UNAVAILABLE,
    // CURRENCY_MISMATCH). Never an exchange rate: two currencies are not combined.
    'visit.plan.error.currencyUnavailable': "\u0648\u0627\u062D\u062F \u067E\u0648\u0644 \u0645\u0637\u0628 \u062E\u0648\u0627\u0646\u062F\u0647 \u0646\u0634\u062F \u0648 \u0628\u062F\u0648\u0646 \u0622\u0646 \u0645\u0628\u0627\u0644\u063A \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.plan.error.currencyMismatch': "\u0627\u06CC\u0646 \u0645\u0628\u0627\u0644\u063A \u0628\u0647 \u0648\u0627\u062D\u062F \u067E\u0648\u0644 \u0645\u0637\u0628 \u0646\u06CC\u0633\u062A\u0646\u062F \u0648 \u0645\u0628\u0627\u0644\u063A \u0628\u0627 \u0648\u0627\u062D\u062F\u0647\u0627\u06CC \u067E\u0648\u0644 \u0645\u062A\u0641\u0627\u0648\u062A \u0647\u0631\u06AF\u0632 \u0628\u0627 \u0647\u0645 \u062C\u0645\u0639 \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \u0627\u0632 \u0645\u062F\u06CC\u0631 \u0645\u0637\u0628 \u0628\u062E\u0648\u0627\u0647\u06CC\u062F \u0648\u0627\u062D\u062F \u067E\u0648\u0644 \u0645\u0637\u0628 \u0631\u0627 \u0628\u0631\u0631\u0633\u06CC \u06A9\u0646\u062F.",
    'visit.plan.saveFailed': "\u062B\u0628\u062A \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.plan.empty.title': "\u0647\u0646\u0648\u0632 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.plan.empty.description': "\u0627\u0642\u062F\u0627\u0645\u200C\u0647\u0627\u06CC\u06CC \u0631\u0627 \u06A9\u0647 \u0642\u0635\u062F \u0627\u0646\u062C\u0627\u0645\u0634\u0627\u0646 \u0631\u0627 \u062F\u0627\u0631\u06CC\u062F\u060C \u062F\u0646\u062F\u0627\u0646\u200C\u0628\u0647\u200C\u062F\u0646\u062F\u0627\u0646 \u0627\u0636\u0627\u0641\u0647 \u06A9\u0646\u06CC\u062F.",
    'visit.plan.add': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0627\u0642\u062F\u0627\u0645",
    // Confirmation after a line actually lands in the plan — «افزودن به طرح
    // درمان» on the chart only OPENS the form, so the dentist needs to be told
    // when the add itself happened, not when the form opened.
    'visit.plan.added': "\xab{{what}}\xbb \u0628\u0647 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646 \u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F.",
    'visit.plan.addedForTooth': "\xab{{what}}\xbb \u0628\u0631\u0627\u06CC \u062F\u0646\u062F\u0627\u0646 {{fdi}} \u0628\u0647 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646 \u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F.",
    // Shown on the chart the moment the button is pressed — it names what the
    // press did, which is open a form, not add a treatment.
    'visit.chart.planFormOpened': "\u0641\u0631\u0645 \u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0631\u0627\u06CC \u062F\u0646\u062F\u0627\u0646 {{fdi}} \u0628\u0627\u0632 \u0634\u062F \u2014 \u0627\u0642\u062F\u0627\u0645 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.",
    'visit.plan.addItem': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0647 \u0637\u0631\u062D",
    'visit.plan.service': "\u0627\u0642\u062F\u0627\u0645 \u062F\u0631\u0645\u0627\u0646\u06CC",
    'visit.plan.choose': "\u06CC\u06A9 \u0627\u0642\u062F\u0627\u0645 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F\u2026",
    'visit.plan.tooth': "\u062F\u0646\u062F\u0627\u0646",
    'visit.plan.wholeMouth': "\u06A9\u0644 \u062F\u0647\u0627\u0646",
    'visit.plan.wholeMouthShort': "\u062F\u0647\u0627\u0646",
    'visit.plan.phase': "\u0641\u0627\u0632",
    'visit.plan.description': "\u0634\u0631\u062D",
    'visit.plan.untitledItem': "\u0627\u0642\u062F\u0627\u0645 \u0628\u062F\u0648\u0646 \u0639\u0646\u0648\u0627\u0646",
    'visit.plan.changeStatus': "\u062A\u063A\u06CC\u06CC\u0631 \u0648\u0636\u0639\u06CC\u062A {{item}}",
    'visit.plan.remove': "\u062D\u0630\u0641 {{item}}",
    'visit.plan.showOnChart': "\u0646\u0645\u0627\u06CC\u0634 \u0631\u0648\u06CC \u0686\u0627\u0631\u062A",
    'visit.plan.surfaces': "\u0633\u0637\u0648\u062D",
    'visit.plan.sessions': "\u062A\u0639\u062F\u0627\u062F \u062C\u0644\u0633\u0627\u062A",
    'visit.plan.sessionsOf': "\u062C\u0644\u0633\u0647\u0654 {{done}} \u0627\u0632 {{total}}",
    // Key kept from when every amount was toman. `{{unit}}` is «تومان» for IRR
    // (common.units.toman), and the ISO code — «AED» — for any other currency.
    'visit.plan.toman': '{{amount}} {{unit}}',
    'visit.plan.noTariff': "\u0628\u062F\u0648\u0646 \u062A\u0639\u0631\u0641\u0647",
    'visit.plan.outstanding': "\u0645\u0627\u0646\u062F\u0647 \u0627\u0632 \u067E\u0644\u0646: {{amount}}",
    // A service the clinic prices in another currency than the plan's. It is
    // never converted, so it is never priced into this plan. `{{currency}}` and
    // `{{planCurrency}}` are ISO codes («IRR», «AED»): a name would put «تومان»
    // on a plan counted in dirhams.
    'visit.plan.otherCurrency': "\u062A\u0639\u0631\u0641\u0647 \u0628\u0647 \u0648\u0627\u062D\u062F \u067E\u0648\u0644 \u062F\u06CC\u06AF\u0631 ({{currency}})",
    'visit.plan.otherCurrencyRefused': "\u062A\u0639\u0631\u0641\u0647\u0654 \xab{{name}}\xbb \u0628\u0647 {{currency}} \u0627\u0633\u062A \u0648 \u0628\u0647 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646\u06CC \u0628\u0647 {{planCurrency}} \u0627\u0641\u0632\u0648\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    // «ثبت انجام» — what was actually DONE, as against what was quoted.
    'visit.record.openVisit': "\u0645\u0634\u0627\u0647\u062F\u0647\u0654 \u0648\u06CC\u0632\u06CC\u062A",
    'visit.record.open': "\u062B\u0628\u062A \u0627\u0646\u062C\u0627\u0645",
    'visit.record.openSession': "\u062B\u0628\u062A \u062C\u0644\u0633\u0647",
    'visit.record.title': "\u062B\u0628\u062A \u0627\u0646\u062C\u0627\u0645 \u2014 {{treatment}}",
    'visit.record.subtitle': "\u0622\u0646\u0686\u0647 \u062F\u0631 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0627\u0646\u062C\u0627\u0645 \u0634\u062F \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0627\u06CC\u0646 \u062B\u0628\u062A\u060C \u067E\u0631\u0648\u0646\u062F\u0647\u0654 \u0628\u0627\u0644\u06CC\u0646\u06CC \u0627\u0633\u062A.",
    'visit.record.service': "\u062E\u062F\u0645\u062A \u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
    'visit.record.tooth': "\u062F\u0646\u062F\u0627\u0646",
    'visit.record.surfaces': "\u0633\u0637\u0648\u062D",
    'visit.record.material': "\u0645\u0627\u062F\u0647",
    'visit.record.noMaterial': "\u0628\u062F\u0648\u0646 \u0645\u0627\u062F\u0647",
    'visit.record.note': "\u0634\u0631\u062D \u06A9\u0627\u0631",
    'visit.record.notePlaceholder': "\u0622\u0646\u0686\u0647 \u0627\u0646\u062C\u0627\u0645 \u0634\u062F\u060C \u0628\u0647\u200C\u0627\u062E\u062A\u0635\u0627\u0631",
    'visit.record.outcome': "\u0646\u062A\u06CC\u062C\u0647",
    'visit.record.outcome.completed': "\u062A\u06A9\u0645\u06CC\u0644 \u0634\u062F",
    'visit.record.outcome.inProgress': "\u0627\u062F\u0627\u0645\u0647 \u062F\u0631 \u062C\u0644\u0633\u0647\u0654 \u0628\u0639\u062F",
    'visit.record.chartEffect': "\u0648\u0636\u0639\u06CC\u062A \u062F\u0646\u062F\u0627\u0646 \u067E\u0633 \u0627\u0632 \u062F\u0631\u0645\u0627\u0646",
    'visit.record.chartEffect.none': "\u062A\u063A\u06CC\u06CC\u0631\u06CC \u062F\u0631 \u0686\u0627\u0631\u062A \u0646\u062F\u0647\u062F",
    'visit.record.chartEffect.noneDetail': "\u0686\u06CC\u0632\u06CC \u062F\u0631 \u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.record.chartEffect.detail': "\u062F\u0646\u062F\u0627\u0646 {{tooth}} \u062F\u0631 \u0686\u0627\u0631\u062A \xab{{state}}\xbb \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.record.chartEffect.detailSurfaces': "\u0633\u0637\u0648\u062D {{surfaces}} \u062F\u0646\u062F\u0627\u0646 {{tooth}} \u062F\u0631 \u0686\u0627\u0631\u062A \xab{{state}}\xbb \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.record.chartEffect.needsSurfaces': "\u0628\u0631\u0627\u06CC \u062B\u0628\u062A \u0648\u0636\u0639\u06CC\u062A \u0633\u0637\u062D\u060C \u0627\u0628\u062A\u062F\u0627 \u0633\u0637\u062D \u062F\u0631\u0645\u0627\u0646\u200C\u0634\u062F\u0647 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F\u061B \u062F\u0631 \u063A\u06CC\u0631 \u0627\u06CC\u0646 \u0635\u0648\u0631\u062A \u0686\u06CC\u0632\u06CC \u062F\u0631 \u0686\u0627\u0631\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.record.chartEffect.surfaceOption': "\u0633\u0637\u0648\u062D \u2014 {{state}}",
    'visit.record.chartEffect.inProgress': "\u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u062F\u0631\u0645\u0627\u0646 \u0631\u0627 \u062A\u0645\u0627\u0645 \u0646\u0645\u06CC\u200C\u06A9\u0646\u062F\u060C \u067E\u0633 \u0628\u0647\u200C\u0635\u0648\u0631\u062A \u067E\u06CC\u0634\u200C\u0641\u0631\u0636 \u0686\u06CC\u0632\u06CC \u062F\u0631 \u0686\u0627\u0631\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.record.billingNote': "\u0635\u0648\u0631\u062A\u200C\u062D\u0633\u0627\u0628 \u0648 \u06A9\u0633\u0631 \u0627\u0632 \u0627\u0646\u0628\u0627\u0631 \u067E\u0633 \u0627\u0632 \u0627\u06CC\u0646 \u062B\u0628\u062A \u0648 \u062C\u062F\u0627 \u0627\u0632 \u0622\u0646 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F\u061B \u0627\u06CC\u0646 \u0641\u0631\u0645 \u0645\u0628\u0644\u063A\u06CC \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u06A9\u0646\u062F.",
    'visit.record.save': "\u062B\u0628\u062A",
    'visit.record.saved': "\xab{{what}}\xbb \u062B\u0628\u062A \u0634\u062F.",
    'visit.record.failed': "\u062B\u0628\u062A \u062F\u0631\u0645\u0627\u0646 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.record.doneHere': "\u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647 \u062F\u0631 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A ({{count}})",
    'visit.record.void': "\u0627\u0628\u0637\u0627\u0644",
    'visit.record.voidReason': "\u062F\u0644\u06CC\u0644 \u0627\u0628\u0637\u0627\u0644",
    'visit.record.voidedFor': "\u0627\u0628\u0637\u0627\u0644\u200C\u0634\u062F\u0647 \u2014 {{reason}}",
    'visit.record.voidConfirm.title': "\u0627\u0628\u0637\u0627\u0644 \xab{{what}}\xbb\u061F",
    'visit.record.voidConfirm.body': "\u0631\u062F\u06CC\u0641 \u062D\u0630\u0641 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0628\u0627 \u062E\u0637\u200C\u062E\u0648\u0631\u062F\u06AF\u06CC \u0648 \u062F\u0644\u06CC\u0644\u06CC \u06A9\u0647 \u0645\u06CC\u200C\u0646\u0648\u06CC\u0633\u06CC\u062F \u062F\u0631 \u067E\u0631\u0648\u0646\u062F\u0647 \u0645\u06CC\u200C\u0645\u0627\u0646\u062F. \u062F\u0644\u06CC\u0644 \u0627\u0644\u0632\u0627\u0645\u06CC \u0627\u0633\u062A.",
    'visit.record.notBilled': "\u0628\u0647 \u0635\u0648\u0631\u062A\u200C\u062D\u0633\u0627\u0628 \u0627\u0636\u0627\u0641\u0647 \u0646\u0634\u062F",
    'visit.record.voidConfirm.alsoChart': "\u0648\u0636\u0639\u06CC\u062A \u062F\u0646\u062F\u0627\u0646 {{tooth}} \u062F\u0631 \u0686\u0627\u0631\u062A \u0647\u0645 \u0628\u0627\u0637\u0644 \u0634\u0648\u062F",
    'visit.record.voidConfirm.stillBilled': "\u0647\u0632\u06CC\u0646\u0647\u0654 \u0627\u06CC\u0646 \u062F\u0631\u0645\u0627\u0646 \u0631\u0648\u06CC \u0635\u0648\u0631\u062A\u200C\u062D\u0633\u0627\u0628 \u0628\u06CC\u0645\u0627\u0631 \u062B\u0628\u062A \u0634\u062F\u0647 \u0627\u0633\u062A. \u0628\u0627 \u0627\u0628\u0637\u0627\u0644\u060C \u0647\u0632\u06CC\u0646\u0647 \u062E\u0648\u062F\u06A9\u0627\u0631 \u0627\u0632 \u0635\u0648\u0631\u062A\u200C\u062D\u0633\u0627\u0628 \u0628\u0631\u0645\u06CC\u200C\u06AF\u0631\u062F\u062F\u061B \u0627\u06AF\u0631 \u0641\u0627\u06A9\u062A\u0648\u0631 \u0635\u0627\u062F\u0631 \u0634\u062F\u0647 \u0628\u0627\u0634\u062F \u06CC\u06A9 \u0642\u0644\u0645 \u0627\u0635\u0644\u0627\u062D\u06CC \u0645\u0646\u0641\u06CC \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.record.voidCharge.notReversed': "\u062F\u0631\u0645\u0627\u0646 \u0627\u0628\u0637\u0627\u0644 \u0634\u062F\u060C \u0627\u0645\u0627 \u0647\u0632\u06CC\u0646\u0647\u0654 \u0622\u0646 \u0627\u0632 \u0635\u0648\u0631\u062A\u200C\u062D\u0633\u0627\u0628 \u0628\u0631\u0646\u06AF\u0634\u062A. \u0628\u0631\u0627\u06CC \u0627\u0635\u0644\u0627\u062D \u0622\u0646 \u0628\u0627 \u0635\u0646\u062F\u0648\u0642 \u0647\u0645\u0627\u0647\u0646\u06AF \u06A9\u0646\u06CC\u062F.",
    'visit.record.billed': "\u0631\u0648\u06CC \u0635\u0648\u0631\u062A\u200C\u062D\u0633\u0627\u0628 \u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u062B\u0628\u062A \u0634\u062F.",
    'visit.plan.noServices.title': "\u0627\u06CC\u0646 \u0645\u0637\u0628 \u0647\u0646\u0648\u0632 \u062E\u062F\u0645\u062A\u06CC \u062A\u0639\u0631\u06CC\u0641 \u0646\u06A9\u0631\u062F\u0647 \u0627\u0633\u062A",
    'visit.plan.noServices.body': "\u0631\u062F\u06CC\u0641\u200C\u0647\u0627\u06CC \u067E\u0644\u0646 \u062F\u0631\u0645\u0627\u0646 \u0627\u0632 \u062E\u062F\u0645\u0627\u062A \u0645\u0637\u0628 \u0645\u06CC\u200C\u0622\u06CC\u0646\u062F. \u062E\u062F\u0645\u0627\u062A \u062F\u0646\u062F\u0627\u0646\u200C\u067E\u0632\u0634\u06A9\u06CC \u0631\u0627 \u062F\u0631 \u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062A\u0639\u0631\u06CC\u0641 \u0648 \u062A\u0639\u0631\u0641\u0647\u200C\u06AF\u0630\u0627\u0631\u06CC \u06A9\u0646\u06CC\u062F.",
    'visit.plan.noServices.action': "\u062A\u0639\u0631\u06CC\u0641 \u062E\u062F\u0645\u0627\u062A \u062F\u0631 \u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9",
    'visit.plan.catalogUnavailable': "\u0641\u0647\u0631\u0633\u062A \u062E\u062F\u0645\u0627\u062A \u0645\u0637\u0628 \u062E\u0648\u0627\u0646\u062F\u0647 \u0646\u0634\u062F. \u0627\u06CC\u0646 \u0628\u0647 \u0645\u0639\u0646\u0627\u06CC \u0646\u0628\u0648\u062F \u062E\u062F\u0645\u062A \u0646\u06CC\u0633\u062A \u2014 \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.plan.applicability.unset': "\u0645\u0634\u062E\u0635 \u0646\u0634\u062F\u0647",
    'visit.plan.applicability.tooth': "\u06CC\u06A9 \u062F\u0646\u062F\u0627\u0646",
    'visit.plan.applicability.surfaces': "\u0633\u0637\u0648\u062D \u06CC\u06A9 \u062F\u0646\u062F\u0627\u0646",
    'visit.plan.applicability.quadrant': "\u06CC\u06A9 \u0646\u0627\u062D\u06CC\u0647 (\u06A9\u0648\u0627\u062F\u0631\u0627\u0646\u062A)",
    'visit.plan.applicability.arch': "\u06CC\u06A9 \u0641\u06A9",
    'visit.plan.applicability.mouth': "\u06A9\u0644 \u062F\u0647\u0627\u0646",
    'visit.plan.newService.title': "\u062E\u062F\u0645\u062A \u062C\u062F\u06CC\u062F",
    'visit.plan.newService.subtitle': "\u0628\u0647 \u062E\u062F\u0645\u0627\u062A \u0645\u0637\u0628 \u0627\u0641\u0632\u0648\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0628\u0631\u0627\u06CC \u0647\u0645\u0647\u0654 \u0647\u0645\u06A9\u0627\u0631\u0627\u0646 \u0646\u06CC\u0632 \u0642\u0627\u0628\u0644 \u0627\u0646\u062A\u062E\u0627\u0628 \u062E\u0648\u0627\u0647\u062F \u0628\u0648\u062F.",
    'visit.plan.newService.name': "\u0646\u0627\u0645 \u062E\u062F\u0645\u062A",
    'visit.plan.newService.category': "\u06AF\u0631\u0648\u0647",
    'visit.plan.newService.chartEffect': "\u0627\u062B\u0631 \u0631\u0648\u06CC \u0686\u0627\u0631\u062A",
    'visit.plan.newService.applicability': "\u06A9\u0627\u0631\u0628\u0631\u062F",
    'visit.plan.newService.tariff': "\u062A\u0639\u0631\u0641\u0647\u0654 \u0647\u0631 \u062C\u0644\u0633\u0647 ({{unit}})",
    'visit.plan.newService.duration': "\u0645\u062F\u062A \u0647\u0631 \u062C\u0644\u0633\u0647 (\u062F\u0642\u06CC\u0642\u0647)",
    'visit.plan.newService.tariffHint': "\u062A\u0639\u0631\u0641\u0647 \u0631\u0627 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646 \u062E\u0627\u0644\u06CC \u06AF\u0630\u0627\u0634\u062A\u061B \u062E\u062F\u0645\u062A \xab\u0628\u062F\u0648\u0646 \u062A\u0639\u0631\u0641\u0647\xbb \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u062A\u0627 \u062A\u0639\u06CC\u06CC\u0646 \u062A\u0639\u0631\u0641\u0647 \u062F\u0631 \u0635\u0648\u0631\u062A\u200C\u062D\u0633\u0627\u0628 \u0646\u0645\u06CC\u200C\u0622\u06CC\u062F.",
    'visit.plan.newService.clinicOnly.title': "\u062F\u0631 \u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062A\u06A9\u0645\u06CC\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F",
    'visit.plan.newService.clinicOnly.body': "\u0645\u0648\u0627\u062F \u0645\u0635\u0631\u0641\u06CC\u060C \u0633\u0627\u06CC\u0631 \u0647\u0632\u06CC\u0646\u0647\u200C\u0647\u0627\u060C \u067E\u0648\u0631\u0633\u0627\u0646\u062A \u0648 \u0628\u06CC\u0645\u0647.",
    'visit.plan.newService.save': "\u0630\u062E\u06CC\u0631\u0647 \u0648 \u0627\u0646\u062A\u062E\u0627\u0628",
    'visit.plan.newService.created': "\xab{{name}}\xbb \u0628\u0647 \u062E\u062F\u0645\u0627\u062A \u0645\u0637\u0628 \u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F.",
    'visit.plan.newService.nameRequired': "\u0646\u0627\u0645 \u062E\u062F\u0645\u062A \u0644\u0627\u0632\u0645 \u0627\u0633\u062A.",
    'visit.plan.newService.failed': "\u062B\u0628\u062A \u062E\u062F\u0645\u062A \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.plan.newService.badTariff': "\u062A\u0639\u0631\u0641\u0647 \u0628\u0627\u06CC\u062F \u06CC\u06A9 \u0639\u062F\u062F \u0628\u0647 {{unit}} \u0628\u0627\u0634\u062F.",
    'visit.plan.newService.currencyUnknown': "\u0648\u0627\u062D\u062F \u067E\u0648\u0644 \u0627\u06CC\u0646 \u0645\u0637\u0628 \u062E\u0648\u0627\u0646\u062F\u0647 \u0646\u0634\u062F\u060C \u067E\u0633 \u062A\u0639\u0631\u0641\u0647 \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0646\u0645\u06CC\u200C\u062A\u0648\u0627\u0646 \u0648\u0627\u0631\u062F \u06A9\u0631\u062F. \u062E\u062F\u0645\u062A \xab\u0628\u062F\u0648\u0646 \u062A\u0639\u0631\u0641\u0647\xbb \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u062A\u0639\u0631\u0641\u0647 \u0631\u0627 \u062F\u0631 \u067E\u0646\u0644 \u06A9\u0644\u06CC\u0646\u06CC\u06A9 \u062A\u0639\u06CC\u06CC\u0646 \u06A9\u0646\u06CC\u062F.",
    'visit.plan.noClinic': "\u0627\u06CC\u0646 \u0648\u06CC\u0632\u06CC\u062A \u0628\u0647 \u0645\u0637\u0628\u06CC \u0646\u0633\u0628\u062A \u062F\u0627\u062F\u0647 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u0628\u062F\u0648\u0646 \u0645\u0637\u0628\u060C \u062E\u062F\u0645\u0627\u062A \u0648 \u062A\u0639\u0631\u0641\u0647\u200C\u0647\u0627 \u062E\u0648\u0627\u0646\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'common.form.optional': "(\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)",
    'visit.plan.locked': "\u0627\u0645\u0636\u0627 \u0634\u062F\u0647",
    'visit.plan.startNew': "\u0634\u0631\u0648\u0639 \u062F\u0648\u0631\u0647\u0654 \u062C\u062F\u06CC\u062F",
    'visit.plan.lockedNextStep': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0627\u0642\u062F\u0627\u0645 \u062A\u0627\u0632\u0647\u060C \u06CC\u06A9 \u062F\u0648\u0631\u0647\u0654 \u062F\u0631\u0645\u0627\u0646 \u062C\u062F\u06CC\u062F \u0622\u063A\u0627\u0632 \u0645\u06CC\u200C\u06A9\u0646\u062F.",
    'visit.plan.lockedNote': "\u0627\u06CC\u0646 \u0637\u0631\u062D \u062F\u0631\u0645\u0627\u0646 \u062A\u0623\u06CC\u06CC\u062F \u0648 \u0627\u0645\u0636\u0627 \u0634\u062F\u0647 \u0627\u0633\u062A\u060C \u067E\u0633 \u0631\u062F\u06CC\u0641\u200C\u0647\u0627\u06CC \u0622\u0646 \u062F\u06CC\u06AF\u0631 \u062A\u063A\u06CC\u06CC\u0631 \u0646\u0645\u06CC\u200C\u06A9\u0646\u062F. \u0648\u0636\u0639\u06CC\u062A \u0627\u0646\u062C\u0627\u0645 \u0627\u0642\u062F\u0627\u0645\u200C\u0647\u0627 \u0647\u0645\u0686\u0646\u0627\u0646 \u0642\u0627\u0628\u0644 \u062B\u0628\u062A \u0627\u0633\u062A.",
    'visit.plan.phases.emergency': "\u0627\u0648\u0631\u0698\u0627\u0646\u0633\u06CC",
    'visit.plan.phases.phase1': "\u0641\u0627\u0632 \u06F1",
    'visit.plan.phases.phase2': "\u0641\u0627\u0632 \u06F2",
    'visit.plan.phases.maintenance': "\u0646\u06AF\u0647\u062F\u0627\u0631\u0646\u062F\u0647",
    'visit.plan.status.proposed': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0634\u062F\u0647",
    'visit.plan.status.accepted': "\u067E\u0630\u06CC\u0631\u0641\u062A\u0647\u200C\u0634\u062F\u0647",
    'visit.plan.status.done': "\u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
    'visit.plan.status.rejected': "\u0631\u062F \u0634\u062F\u0647",
    'visit.plan.status.deferred': "\u0628\u0647 \u062A\u0639\u0648\u06CC\u0642 \u0627\u0641\u062A\u0627\u062F\u0647",
    'visit.plan.planStatus.draft': "\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633",
    'visit.plan.planStatus.proposed': "\u0627\u0631\u0627\u0626\u0647\u200C\u0634\u062F\u0647",
    'visit.plan.planStatus.approved': "\u062A\u0623\u06CC\u06CC\u062F\u0634\u062F\u0647",
    'visit.plan.planStatus.in_progress': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0646\u062C\u0627\u0645",
    'visit.plan.planStatus.completed': "\u062A\u06A9\u0645\u06CC\u0644\u200C\u0634\u062F\u0647",
    'visit.plan.planStatus.abandoned': "\u0631\u0647\u0627\u0634\u062F\u0647",
    // ── §3.2.1 دارو ──────────────────────────────────────────────────────────
    'visit.meds.empty.title': "\u0647\u0646\u0648\u0632 \u062F\u0627\u0631\u0648\u06CC\u06CC \u062A\u062C\u0648\u06CC\u0632 \u0646\u0634\u062F\u0647",
    'visit.meds.empty.description': "\u0628\u0631\u0627\u06CC \u0627\u0641\u0632\u0648\u062F\u0646 \u062F\u0627\u0631\u0648 \u0628\u0647 \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647\u060C \u0627\u0632 \u062C\u0633\u062A\u062C\u0648\u06CC \u0628\u0627\u0644\u0627 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F.",
    'visit.meds.thisVisit': "\u062A\u062C\u0648\u06CC\u0632\u0634\u062F\u0647 \u062F\u0631 \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647",
    'visit.meds.current': "\u062F\u0627\u0631\u0648\u0647\u0627\u06CC \u0641\u0639\u0644\u06CC \u0628\u06CC\u0645\u0627\u0631",
    'visit.meds.suggest': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC",
    'visit.meds.suggesting': "\u062F\u0631 \u062D\u0627\u0644 \u062A\u062D\u0644\u06CC\u0644\u2026",
    'visit.meds.suggestions': "\u062F\u0627\u0631\u0648\u0647\u0627\u06CC \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.meds.suggestClose': "\u0628\u0633\u062A\u0646 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0647\u0627",
    'visit.meds.suggestAdd': "\u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0647 \u0646\u0633\u062E\u0647",
    'visit.meds.suggestAdded': "\u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F",
    'visit.meds.noSuggestions': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC \u0646\u06CC\u0633\u062A. \u0627\u0628\u062A\u062F\u0627 \u062A\u0634\u062E\u06CC\u0635 \u06CC\u0627 \u0627\u0631\u0632\u06CC\u0627\u0628\u06CC \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0631\u0627 \u062B\u0628\u062A \u06A9\u0646\u06CC\u062F \u2014 \u062A\u062D\u0644\u06CC\u0644 \u0628\u0631 \u067E\u0627\u06CC\u0647\u0654 \u0622\u0646\u0686\u0647 \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0646\u0648\u0634\u062A\u0647 \u0634\u062F\u0647 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.meds.suggestUnavailable': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.meds.followUp': "\u067E\u06CC\u06AF\u06CC\u0631\u06CC:",
    // ── §3.2.2 دستورات — فقط لابراتوار و تصویربرداری دندانی ──────────────────
    'visit.orders.error.title': "\u062F\u0633\u062A\u0648\u0631\u0627\u062A \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'visit.orders.error.body': "\u062E\u0648\u0627\u0646\u062F\u0646 \u062F\u0633\u062A\u0648\u0631\u0627\u062A \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.orders.saveFailed': "\u062B\u0628\u062A \u062F\u0633\u062A\u0648\u0631 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.orders.empty.title': "\u062F\u0633\u062A\u0648\u0631\u06CC \u062F\u0631 \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.orders.empty.description': "\u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0631\u0627\u062F\u06CC\u0648\u06AF\u0631\u0627\u0641\u06CC \u0628\u062F\u0647\u06CC\u062F \u06CC\u0627 \u06A9\u06CC\u0633 \u0631\u0627 \u0628\u0647 \u0644\u0627\u0628\u0631\u0627\u062A\u0648\u0627\u0631 \u0628\u0641\u0631\u0633\u062A\u06CC\u062F.",
    'visit.orders.type': "\u0646\u0648\u0639 \u062F\u0633\u062A\u0648\u0631",
    'visit.orders.types.imaging': "\u062A\u0635\u0648\u06CC\u0631\u0628\u0631\u062F\u0627\u0631\u06CC",
    'visit.orders.types.lab': "\u0644\u0627\u0628\u0631\u0627\u062A\u0648\u0627\u0631",
    'visit.orders.types.dental_lab': "\u0644\u0627\u0628\u0631\u0627\u062A\u0648\u0627\u0631 \u062F\u0646\u062F\u0627\u0646\u06CC",
    'visit.orders.service': "\u062E\u062F\u0645\u062A",
    'visit.orders.serviceScope': "\u0641\u0642\u0637 \u062E\u062F\u0645\u0627\u062A \xab{{type}}\xbb",
    'visit.orders.choose': "\u06CC\u06A9 \u062E\u062F\u0645\u062A \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F\u2026",
    'visit.orders.description': "\u0634\u0631\u062D",
    'visit.orders.descriptionHint': "\u062E\u0627\u0644\u06CC \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F \u062A\u0627 \u0646\u0627\u0645 \u062E\u062F\u0645\u062A \u062B\u0628\u062A \u0634\u0648\u062F",
    'visit.orders.notes': "\u062A\u0648\u0636\u06CC\u062D \u0628\u0631\u0627\u06CC \u0644\u0627\u0628\u0631\u0627\u062A\u0648\u0627\u0631 / \u0631\u0627\u062F\u06CC\u0648\u0644\u0648\u0698\u06CC",
    'visit.orders.urgency': "\u0641\u0648\u0631\u06CC\u062A",
    'visit.orders.urgencies.routine': "\u0639\u0627\u062F\u06CC",
    'visit.orders.urgencies.urgent': "\u0641\u0648\u0631\u06CC",
    'visit.orders.urgencies.stat': "\u0622\u0646\u06CC",
    'visit.orders.sessions': "\u062A\u0639\u062F\u0627\u062F \u062C\u0644\u0633\u0627\u062A",
    'visit.orders.sessionCount': "{{count}} \u062C\u0644\u0633\u0647",
    'visit.orders.add': "\u062B\u0628\u062A \u062F\u0633\u062A\u0648\u0631",
    'visit.orders.statuses.pending': "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631",
    'visit.orders.statuses.in_progress': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0646\u062C\u0627\u0645",
    'visit.orders.statuses.completed': "\u0627\u0646\u062C\u0627\u0645 \u0634\u062F\u0647",
    'visit.orders.statuses.cancelled': "\u0644\u063A\u0648 \u0634\u062F\u0647",
    'visit.orders.transitions.start': "\u0634\u0631\u0648\u0639",
    'visit.orders.transitions.complete': "\u062B\u0628\u062A \u0627\u0646\u062C\u0627\u0645",
    'visit.orders.transitions.cancel': "\u0644\u063A\u0648",
    'visit.orders.suggest': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC",
    'visit.orders.suggesting': "\u062F\u0631 \u062D\u0627\u0644 \u062A\u062D\u0644\u06CC\u0644\u2026",
    'visit.orders.suggestions': "\u062F\u0633\u062A\u0648\u0631\u0647\u0627\u06CC \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.orders.suggestClose': "\u0628\u0633\u062A\u0646 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0647\u0627",
    'visit.orders.suggestAdd': "\u062B\u0628\u062A \u062F\u0633\u062A\u0648\u0631",
    'visit.orders.suggestAdded': "\u062B\u0628\u062A \u0634\u062F\u0647",
    'visit.orders.noSuggestions': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC \u0646\u06CC\u0633\u062A. \u0627\u0628\u062A\u062F\u0627 \u062A\u0634\u062E\u06CC\u0635 \u06CC\u0627 \u0627\u0631\u0632\u06CC\u0627\u0628\u06CC \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0631\u0627 \u062B\u0628\u062A \u06A9\u0646\u06CC\u062F \u2014 \u062A\u062D\u0644\u06CC\u0644 \u0628\u0631 \u067E\u0627\u06CC\u0647\u0654 \u0622\u0646\u0686\u0647 \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0646\u0648\u0634\u062A\u0647 \u0634\u062F\u0647 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.orders.suggestUnavailable': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.orders.suggestDropped': "{{count}} \u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062E\u0627\u0631\u062C \u0627\u0632 \u0641\u0647\u0631\u0633\u062A \u062F\u0646\u062F\u0627\u0646\u06CC \u0628\u0648\u062F \u0648 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0646\u0634\u062F.",
    // ── §3.2.3 تشخیص، با نمایش مستندات پشتیبان ───────────────────────────────
    'visit.diagnosis.error.title': "\u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'visit.diagnosis.error.body': "\u062E\u0648\u0627\u0646\u062F\u0646 \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u06CC \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.diagnosis.saveFailed': "\u062B\u0628\u062A \u062A\u0634\u062E\u06CC\u0635 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.diagnosis.empty.title': "\u062A\u0634\u062E\u06CC\u0635\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.diagnosis.empty.description': "\u0646\u062A\u06CC\u062C\u0647\u200C\u06AF\u06CC\u0631\u06CC \u062E\u0648\u062F \u0631\u0627 \u062B\u0628\u062A \u06A9\u0646\u06CC\u062F\u061B \u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0628\u0631 \u067E\u0627\u06CC\u0647\u0654 \u0622\u0646 \u0627\u0633\u062A \u0647\u0645\u0631\u0627\u0647 \u062A\u0634\u062E\u06CC\u0635 \u0630\u062E\u06CC\u0631\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.diagnosis.name': "\u062A\u0634\u062E\u06CC\u0635",
    'visit.diagnosis.code': "\u06A9\u062F ICD",
    'visit.diagnosis.certainty': "\u0642\u0637\u0639\u06CC\u062A",
    'visit.diagnosis.verification.provisional': "\u0645\u0648\u0642\u062A",
    'visit.diagnosis.verification.confirmed': "\u0642\u0637\u0639\u06CC",
    'visit.diagnosis.add': "\u062B\u0628\u062A \u062A\u0634\u062E\u06CC\u0635",
    'visit.diagnosis.remove': "\u062D\u0630\u0641 {{name}}",
    'visit.diagnosis.willAttach': "{{count}} \u0645\u0633\u062A\u0646\u062F \u067E\u0634\u062A\u06CC\u0628\u0627\u0646 \u0647\u0645\u0631\u0627\u0647 \u0627\u06CC\u0646 \u062A\u0634\u062E\u06CC\u0635 \u0630\u062E\u06CC\u0631\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.diagnosis.evidence': "\u0645\u0633\u062A\u0646\u062F\u0627\u062A ({{count}})",
    'visit.diagnosis.noEvidence': "\u0645\u0633\u062A\u0646\u062F\u06CC \u0647\u0645\u0631\u0627\u0647 \u0627\u06CC\u0646 \u062A\u0634\u062E\u06CC\u0635 \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.diagnosis.evidenceKind.subjective': "\u0634\u0631\u062D \u062D\u0627\u0644",
    'visit.diagnosis.evidenceKind.history': "\u0633\u0648\u0627\u0628\u0642",
    'visit.diagnosis.evidenceKind.chart': "\u0686\u0627\u0631\u062A",
    'visit.diagnosis.evidenceKind.file': "\u0633\u0646\u062F",
    'visit.diagnosis.evidenceKind.order': "\u062F\u0633\u062A\u0648\u0631",
    'visit.diagnosis.evidenceKind.ai': "\u062A\u062D\u0644\u06CC\u0644 \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC",
    'visit.diagnosis.showTooth': "\u0646\u0645\u0627\u06CC\u0634 \u062F\u0646\u062F\u0627\u0646",
    'visit.diagnosis.toothEvidence': "\u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627\u06CC \u062F\u0646\u062F\u0627\u0646 {{fdi}}",
    'visit.diagnosis.aiAssisted': "\u0628\u0647 \u06A9\u0645\u06A9 \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC",
    'visit.diagnosis.suggest': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC",
    'visit.diagnosis.suggesting': "\u062F\u0631 \u062D\u0627\u0644 \u062A\u062D\u0644\u06CC\u0644\u2026",
    'visit.diagnosis.suggestions': "\u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u06CC \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.diagnosis.noSuggestions': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC \u0646\u06CC\u0633\u062A. \u0627\u0628\u062A\u062F\u0627 \u0634\u0631\u062D \u062D\u0627\u0644 \u0631\u0627 \u062B\u0628\u062A \u06A9\u0646\u06CC\u062F \u2014 \u062A\u062D\u0644\u06CC\u0644 \u0628\u0631 \u067E\u0627\u06CC\u0647\u0654 \u0622\u0646\u0686\u0647 \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u0646\u0648\u0634\u062A\u0647 \u0634\u062F\u0647 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.diagnosis.suggestUnavailable': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.diagnosis.accept': "\u062B\u0628\u062A",
    'visit.diagnosis.alreadyRecorded': "\u062B\u0628\u062A \u0634\u062F\u0647",
    'visit.diagnosis.confidence.high': "\u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u0628\u0627\u0644\u0627",
    'visit.diagnosis.confidence.medium': "\u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u0645\u062A\u0648\u0633\u0637",
    'visit.diagnosis.confidence.low': "\u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u067E\u0627\u06CC\u06CC\u0646",
    // ── دستیار شرح حال (SOAP) — تب تشخیص ─────────────────────────────────────
    'visit.soap.title': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0634\u0631\u062D \u062D\u0627\u0644",
    // «با پایان ضبط» و نه «سپس دکمه را بزنید»: دیگر دکمهٔ جداگانه‌ای نیست —
    // خودِ توقف ضبط، تحلیل را می‌فرستد و برچسب دکمهٔ توقف همین را می‌گوید.
    'visit.soap.description': "\u0622\u0646\u0686\u0647 \u062F\u0631 \u062C\u0644\u0633\u0647 \u06AF\u0630\u0634\u062A \u0631\u0627 \u0628\u06AF\u0648\u06CC\u06CC\u062F\u061B \u0628\u0627 \u067E\u0627\u06CC\u0627\u0646 \u0636\u0628\u0637\u060C \u062F\u0633\u062A\u06CC\u0627\u0631 \u0628\u062E\u0634\u200C\u0647\u0627\u06CC \u0634\u0631\u062D \u062D\u0627\u0644 \u0631\u0627 \u062A\u06A9\u0645\u06CC\u0644 \u0645\u06CC\u200C\u06A9\u0646\u062F \u0648 \u0628\u0631 \u0627\u0633\u0627\u0633 \u0645\u0634\u06A9\u0644\u060C \u062A\u0648\u0635\u06CC\u0647 \u0645\u06CC\u200C\u062F\u0647\u062F. \u062A\u0627 \u0634\u0645\u0627 \u062A\u0623\u06CC\u06CC\u062F \u0646\u06A9\u0646\u06CC\u062F \u0686\u06CC\u0632\u06CC \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.soap.speak': "\u0627\u0639\u0644\u0627\u0645 \u0634\u0631\u062D \u062D\u0627\u0644",
    'visit.soap.speakStop': "\u067E\u0627\u06CC\u0627\u0646 \u0648 \u062F\u0631\u06CC\u0627\u0641\u062A \u062A\u0648\u0635\u06CC\u0647",
    'visit.soap.analyzing': "\u062F\u0631 \u062D\u0627\u0644 \u062A\u062D\u0644\u06CC\u0644\u2026",
    'visit.soap.heard': "\u0645\u062A\u0646 \u0634\u0646\u06CC\u062F\u0647\u200C\u0634\u062F\u0647:",
    'visit.soap.retry': "\u0627\u0631\u0633\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647",
    'visit.soap.voiceUnavailable': "\u0627\u0639\u0644\u0627\u0645 \u0634\u0631\u062D \u062D\u0627\u0644 \u0628\u0647 \u0645\u06CC\u06A9\u0631\u0648\u0641\u0648\u0646 \u0648 \u0627\u062A\u0635\u0627\u0644 \u0627\u0645\u0646 (HTTPS) \u0646\u06CC\u0627\u0632 \u062F\u0627\u0631\u062F \u0648 \u062F\u0631 \u0627\u06CC\u0646 \u0645\u0631\u0648\u0631\u06AF\u0631 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.soap.draftTitle': "\u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC \u0634\u0631\u062D \u062D\u0627\u0644",
    'visit.soap.sections.s': "\u0634\u0631\u062D \u062D\u0627\u0644 (S) \u2014 \u0627\u0641\u0632\u0648\u062F\u0647 \u0628\u0647 \u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'visit.soap.sections.o': "\u0645\u0639\u0627\u06CC\u0646\u0647 \u0648 \u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627 (O)",
    'visit.soap.sections.a': "\u0627\u0631\u0632\u06CC\u0627\u0628\u06CC (A)",
    'visit.soap.sections.p': "\u0628\u0631\u0646\u0627\u0645\u0647 \u062F\u0631\u0645\u0627\u0646 (P)",
    'visit.soap.apply': "\u0627\u0639\u0645\u0627\u0644 \u062F\u0631 \u0634\u0631\u062D \u062D\u0627\u0644 \u0628\u06CC\u0645\u0627\u0631",
    'visit.soap.applied': "\u062F\u0631 \u0634\u0631\u062D \u062D\u0627\u0644 \u0628\u06CC\u0645\u0627\u0631 \u062B\u0628\u062A \u0634\u062F.",
    'visit.soap.applyFailed': "\u0627\u0639\u0645\u0627\u0644 \u067E\u06CC\u0634\u200C\u0646\u0648\u06CC\u0633 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.soap.dismiss': "\u0631\u062F \u06A9\u0631\u062F\u0646",
    'visit.soap.noNews': "\u0646\u06A9\u062A\u0647\u0654 \u062A\u0627\u0632\u0647\u200C\u0627\u06CC \u0628\u0631\u0627\u06CC \u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0647 \u0634\u0631\u062D \u062D\u0627\u0644 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F.",
    'visit.soap.refineUnavailable': "\u062A\u06A9\u0645\u06CC\u0644 \u0634\u0631\u062D \u062D\u0627\u0644 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.soap.adviceTitle': "\u062A\u0648\u0635\u06CC\u0647\u0654 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.soap.adviceUnavailable': "\u062A\u0648\u0635\u06CC\u0647\u0654 \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.soap.suggestedDiagnosis': "\u062A\u0634\u062E\u06CC\u0635 \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.soap.recordDiagnosis': "\u062B\u0628\u062A \u0628\u0647 \u0639\u0646\u0648\u0627\u0646 \u062A\u0634\u062E\u06CC\u0635",
    'visit.soap.accepted': "\u0627\u06CC\u0646 \u062A\u0634\u062E\u06CC\u0635 \u067E\u0630\u06CC\u0631\u0641\u062A\u0647 \u0648 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u06CC \u0627\u06CC\u0646 \u062C\u0644\u0633\u0647 \u062B\u0628\u062A \u0634\u062F.",
    'visit.soap.actions': "\u0627\u0642\u062F\u0627\u0645\u0627\u062A \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.soap.medications': "\u062F\u0627\u0631\u0648\u0647\u0627\u06CC \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'visit.soap.aiEvidence': "\u0628\u0631\u0622\u0645\u062F\u0647 \u0627\u0632 \u062A\u062D\u0644\u06CC\u0644 \u0645\u062A\u0646 \u062C\u0644\u0633\u0647",
    // ── یافته‌های دندانی متن جلسه → چارت دندان ────────────────────────────────
    'visit.soap.teeth.title': "\u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627\u06CC \u062F\u0646\u062F\u0627\u0646\u200C\u0647\u0627",
    'visit.soap.teeth.description': "\u0627\u06CC\u0646 \u0645\u0648\u0627\u0631\u062F \u0627\u0632 \u0645\u062A\u0646 \u062C\u0644\u0633\u0647 \u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u062F\u0646\u062F\u0627\u0646\u200C\u0647\u0627\u06CC \u0645\u0634\u062E\u0635 \u062E\u0648\u0627\u0646\u062F\u0647 \u0634\u062F\u0647 \u0627\u0633\u062A. \u0647\u0631 \u06A9\u062F\u0627\u0645 \u0631\u0627 \u06A9\u0647 \u062A\u0623\u06CC\u06CC\u062F \u06A9\u0646\u06CC\u062F \u062F\u0631 \u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0628\u0642\u06CC\u0647 \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'visit.soap.teeth.lowConfidenceHint': "\u0645\u0648\u0627\u0631\u062F \u06A9\u0645\u200C\u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u0627\u0632 \u067E\u06CC\u0634 \u062A\u06CC\u06A9 \u0646\u062E\u0648\u0631\u062F\u0647\u200C\u0627\u0646\u062F \u2014 \u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u0646\u062F\u0627\u0646 \u0631\u0627 \u067E\u06CC\u0634 \u0627\u0632 \u062B\u0628\u062A \u0628\u0631\u0631\u0633\u06CC \u06A9\u0646\u06CC\u062F.",
    'visit.soap.teeth.tooth': "\u062F\u0646\u062F\u0627\u0646 {{fdi}}",
    'visit.soap.teeth.surface': "\u0633\u0637\u062D {{surface}}",
    'visit.soap.teeth.historical': "\u0633\u0627\u0628\u0642\u0647",
    'visit.soap.teeth.record': "\u062B\u0628\u062A \u062F\u0631 \u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 ({{count}})",
    'visit.soap.teeth.recording': "\u062F\u0631 \u062D\u0627\u0644 \u062B\u0628\u062A\u2026",
    'visit.soap.teeth.recorded': "\u062F\u0631 \u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 \u062B\u0628\u062A \u0634\u062F.",
    'visit.soap.teeth.recordFailed': "\u062B\u0628\u062A \u062F\u0631 \u0686\u0627\u0631\u062A \u062F\u0646\u062F\u0627\u0646 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.soap.teeth.none': "\u06CC\u0627\u0641\u062A\u0647\u0654 \u062F\u0646\u062F\u0627\u0646\u06CC \u0645\u0634\u062E\u0635\u06CC \u062F\u0631 \u0645\u062A\u0646 \u062C\u0644\u0633\u0647 \u067E\u06CC\u062F\u0627 \u0646\u0634\u062F.",
    'visit.soap.teeth.unavailable': "\u062E\u0648\u0627\u0646\u062F\u0646 \u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627\u06CC \u062F\u0646\u062F\u0627\u0646 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.soap.teeth.confidence.high': "\u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u0628\u0627\u0644\u0627",
    'visit.soap.teeth.confidence.medium': "\u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u0645\u062A\u0648\u0633\u0637",
    'visit.soap.teeth.confidence.low': "\u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u067E\u0627\u06CC\u06CC\u0646",
    // The chart's own vocabulary, in the dentist's language. Keys are the values
    // the dental service defines; an unknown one falls back to the raw value
    // rather than showing an empty row.
    'tooth.aspect.presence': "\u0648\u062C\u0648\u062F \u062F\u0646\u062F\u0627\u0646",
    'tooth.aspect.condition': "\u0648\u0636\u0639\u06CC\u062A \u062F\u0646\u062F\u0627\u0646",
    'tooth.aspect.surface': "\u0648\u0636\u0639\u06CC\u062A \u0633\u0637\u062D",
    'tooth.value.sound': "\u0633\u0627\u0644\u0645",
    'tooth.value.caries': "\u067E\u0648\u0633\u06CC\u062F\u06AF\u06CC",
    'tooth.value.root_canal': "\u0639\u0635\u0628\u200C\u06A9\u0634\u06CC",
    'tooth.value.post_core': "\u067E\u0633\u062A \u0648 \u06A9\u0648\u0631",
    'tooth.value.crown': "\u0631\u0648\u06A9\u0634",
    'tooth.value.veneer': "\u0648\u0646\u06CC\u0631",
    'tooth.value.implant': "\u0627\u06CC\u0645\u067E\u0644\u0646\u062A",
    'tooth.value.bridge_abutment': "\u067E\u0627\u06CC\u0647\u0654 \u0628\u0631\u06CC\u062C",
    'tooth.value.bridge_pontic': "\u067E\u0648\u0646\u062A\u06CC\u06A9",
    'tooth.value.fracture': "\u0634\u06A9\u0633\u062A\u06AF\u06CC",
    'tooth.value.attrition': "\u0633\u0627\u06CC\u0634",
    'tooth.value.mobility': "\u0644\u0642\u06CC",
    'tooth.value.periapical_lesion': "\u0636\u0627\u06CC\u0639\u0647\u0654 \u0627\u067E\u06CC\u06A9\u0627\u0644",
    'tooth.value.sealant': "\u0641\u06CC\u0634\u0648\u0631\u0633\u06CC\u0644\u0627\u0646\u062A",
    'tooth.value.temporary': "\u0645\u0648\u0642\u062A",
    'tooth.value.watch': "\u062A\u062D\u062A \u0646\u0638\u0631",
    'tooth.value.restoration': "\u062A\u0631\u0645\u06CC\u0645",
    'tooth.value.recurrent_caries': "\u067E\u0648\u0633\u06CC\u062F\u06AF\u06CC \u062B\u0627\u0646\u0648\u06CC\u0647",
    'tooth.value.fractured': "\u0634\u06A9\u0633\u062A\u0647",
    'tooth.value.present': "\u0645\u0648\u062C\u0648\u062F",
    'tooth.value.extracted': "\u06A9\u0634\u06CC\u062F\u0647\u200C\u0634\u062F\u0647",
    'tooth.value.exfoliated': "\u0627\u0641\u062A\u0627\u062F\u0647 (\u0634\u06CC\u0631\u06CC)",
    'tooth.value.congenitally_absent': "\u0645\u0627\u062F\u0631\u0632\u0627\u062F\u06CC \u063A\u0627\u06CC\u0628",
    'tooth.value.unerupted': "\u0646\u0631\u0648\u06CC\u06CC\u062F\u0647",
    'tooth.value.impacted': "\u0646\u0647\u0641\u062A\u0647",
    'tooth.material.composite': "\u06A9\u0627\u0645\u067E\u0648\u0632\u06CC\u062A",
    'tooth.material.amalgam': "\u0622\u0645\u0627\u0644\u06AF\u0627\u0645",
    'tooth.material.glass_ionomer': "\u06AF\u0644\u0627\u0633\u200C\u0622\u06CC\u0646\u0648\u0645\u0631",
    'tooth.material.zirconia': "\u0632\u06CC\u0631\u06A9\u0648\u0646\u06CC\u0627",
    'tooth.material.pfm': "\u0641\u0644\u0632-\u0633\u0631\u0627\u0645\u06CC\u06A9",
    'tooth.material.full_metal': "\u0641\u0648\u0644 \u0645\u062A\u0627\u0644",
    'tooth.material.emax': "\u0627\u06CC\u200C\u0645\u06A9\u0633",
    'tooth.material.temporary': "\u0645\u0648\u0642\u062A",
    'tooth.material.gold': "\u0637\u0644\u0627",
    // ── §3.2.4 پرسش‌ها — دستیار بالینی ───────────────────────────────────────
    'visit.questions.title': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0628\u0627\u0644\u06CC\u0646\u06CC",
    'visit.questions.forDiagnoses': "\u067E\u0631\u0633\u0634\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0627\u06CC\u0646 \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627 \u0631\u0627 \u062A\u0623\u06CC\u06CC\u062F \u06CC\u0627 \u0631\u062F \u0645\u06CC\u200C\u06A9\u0646\u062F: {{list}}",
    'visit.questions.noDiagnosesYet': "\u0647\u0646\u0648\u0632 \u062A\u0634\u062E\u06CC\u0635\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u2014 \u062F\u0633\u062A\u06CC\u0627\u0631 \u0628\u0631 \u067E\u0627\u06CC\u0647\u0654 \u0634\u06A9\u0627\u06CC\u062A\u06CC \u06A9\u0647 \u0646\u0648\u0634\u062A\u0647\u200C\u0627\u06CC\u062F \u067E\u0631\u0633\u0634 \u0645\u06CC\u200C\u0633\u0627\u0632\u062F.",
    'visit.questions.generate': "\u06CC\u0627\u0641\u062A\u0646 \u0646\u06A9\u0627\u062A \u0645\u0628\u0647\u0645",
    'visit.questions.generating': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026",
    'visit.questions.unavailable': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0628\u0627\u0644\u06CC\u0646\u06CC \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A.",
    'visit.questions.fallbackNote': "\u0627\u06CC\u0646 \u067E\u0631\u0633\u0634\u200C\u0647\u0627 \u0639\u0645\u0648\u0645\u06CC \u0647\u0633\u062A\u0646\u062F \u0648 \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0646\u0648\u0634\u062A\u0647 \u0646\u0634\u062F\u0647\u200C\u0627\u0646\u062F.",
    'visit.questions.empty.title': "\u067E\u0631\u0633\u0634 \u0628\u0627\u0632\u06CC \u0646\u06CC\u0633\u062A",
    'visit.questions.empty.description': "\u0628\u0631\u0627\u06CC \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC \u0627\u0632 \u062A\u0634\u062E\u06CC\u0635\u200C\u0647\u0627\u06CC \u0641\u0639\u0644\u06CC\u060C \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0628\u06CC\u0634\u062A\u0631\u06CC \u0644\u0627\u0632\u0645 \u0646\u06CC\u0633\u062A.",
    'visit.questions.count': "{{count}} \u067E\u0631\u0633\u0634",
    'visit.questions.yes': "\u0628\u0644\u0647",
    'visit.questions.no': "\u062E\u06CC\u0631",
    'visit.questions.recorded': "\u062B\u0628\u062A \u0634\u062F: {{statement}}",
    'visit.questions.recordFailed': "\u062B\u0628\u062A \u067E\u0627\u0633\u062E \u062F\u0631 \u0634\u0631\u062D \u062D\u0627\u0644 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.questions.askTitle': "\u067E\u0631\u0633\u0634 \u0627\u0632 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'visit.questions.askPlaceholder': "\u062F\u0631\u0628\u0627\u0631\u0647\u0654 \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0628\u067E\u0631\u0633\u06CC\u062F\u2026",
    'visit.questions.ask': "\u0628\u067E\u0631\u0633",
    'visit.questions.asking': "\u062F\u0631 \u062D\u0627\u0644 \u067E\u0631\u0633\u06CC\u062F\u0646\u2026",
    'visit.questions.followUps': "\u067E\u06CC\u06AF\u06CC\u0631\u06CC",
    // ── §3.2.5 فایل‌ها و گزارش استخراج‌شدهٔ هرکدام ────────────────────────────
    // ── فایل‌ها: what kind of thing is being uploaded ────────────────────────
    'visit.files.kind': "\u0627\u06CC\u0646 \u0641\u0627\u06CC\u0644 \u0686\u06CC\u0633\u062A\u061F",
    'visit.files.kinds.image': "\u062A\u0635\u0648\u06CC\u0631 \u062F\u0646\u062F\u0627\u0646\u06CC",
    'visit.files.kinds.document': "\u0633\u0646\u062F",
    'visit.files.viewType': "\u0646\u0648\u0639 \u062A\u0635\u0648\u06CC\u0631",
    'visit.files.viewTypes.periapical': "\u067E\u0631\u06CC\u200C\u0627\u067E\u06CC\u06A9\u0627\u0644 (PA)",
    'visit.files.viewTypes.bitewing': "\u0628\u0627\u06CC\u062A\u200C\u0648\u06CC\u0646\u06AF (BW)",
    'visit.files.viewTypes.panoramic': "\u067E\u0627\u0646\u0648\u0631\u0627\u0645\u06CC\u06A9 (OPG)",
    'visit.files.viewTypes.ceph': "\u0633\u0641\u0627\u0644\u0648\u0645\u062A\u0631\u06CC",
    'visit.files.viewTypes.photo': "\u0639\u06A9\u0633",
    'visit.files.plainUploadNote': "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0641\u0642\u0637 \u0641\u0627\u06CC\u0644 \u0631\u0627 \u0630\u062E\u06CC\u0631\u0647 \u0645\u06CC\u200C\u06A9\u0646\u062F. \u0627\u0633\u062A\u062E\u0631\u0627\u062C \u0645\u062A\u0646 \u0648 \u062E\u0648\u0627\u0646\u062F\u0646 \u062A\u0635\u0648\u06CC\u0631 \u062C\u062F\u0627\u06AF\u0627\u0646\u0647 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
    'visit.files.unsupportedImage': "\u0627\u06CC\u0646 \u0642\u0627\u0644\u0628 \u062A\u0635\u0648\u06CC\u0631 \u0642\u0627\u0628\u0644 \u0646\u0645\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A. \u0627\u0632 JPEG \u06CC\u0627 PNG \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F.",
    'visit.files.openImage': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u062A\u0635\u0648\u06CC\u0631",
    'visit.files.extract': "\u0627\u0633\u062A\u062E\u0631\u0627\u062C \u0645\u062A\u0646",
    'visit.files.extracting': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0633\u062A\u062E\u0631\u0627\u062C\u2026",
    // ── The image workspace ─────────────────────────────────────────────────
    'visit.image.back': "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0641\u0627\u06CC\u0644\u200C\u0647\u0627",
    'visit.image.tools': "\u0627\u0628\u0632\u0627\u0631 \u062A\u0631\u0633\u06CC\u0645",
    'visit.image.tool.cursor': "\u0627\u0646\u062A\u062E\u0627\u0628",
    'visit.image.tool.pin': "\u0646\u0634\u0627\u0646\u0647",
    'visit.image.tool.box': "\u06A9\u0627\u062F\u0631",
    'visit.image.tool.ellipse': "\u062F\u0627\u06CC\u0631\u0647",
    'visit.image.tool.arrow': "\u0641\u0644\u0634",
    'visit.image.tool.freehand': "\u0642\u0644\u0645 \u0622\u0632\u0627\u062F",
    'visit.image.color': "\u0631\u0646\u06AF \u0642\u0644\u0645",
    'visit.image.colorName.E11D48': "\u0642\u0631\u0645\u0632",
    'visit.image.colorName.F59E0B': "\u06A9\u0647\u0631\u0628\u0627\u06CC\u06CC",
    'visit.image.colorName.0EA5A0': "\u0641\u06CC\u0631\u0648\u0632\u0647\u200C\u0627\u06CC",
    'visit.image.colorName.2563EB': "\u0622\u0628\u06CC",
    'visit.image.zoomIn': "\u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC",
    'visit.image.zoomOut': "\u06A9\u0648\u0686\u06A9\u200C\u0646\u0645\u0627\u06CC\u06CC",
    'visit.image.fit': "\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC \u0646\u0645\u0627",
    'visit.image.brightness': "\u0631\u0648\u0634\u0646\u0627\u06CC\u06CC",
    'visit.image.contrast': "\u06A9\u0646\u062A\u0631\u0627\u0633\u062A",
    'visit.image.read': "\u062E\u0648\u0627\u0646\u062F\u0646 \u062A\u0635\u0648\u06CC\u0631",
    'visit.image.reading': "\u062F\u0631 \u062D\u0627\u0644 \u062E\u0648\u0627\u0646\u062F\u0646\u2026",
    'visit.image.readStatus.no_findings': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u062F\u0631 \u0627\u06CC\u0646 \u062A\u0635\u0648\u06CC\u0631 \u06CC\u0627\u0641\u062A\u0647\u0654 \u0642\u0627\u0628\u0644 \u06AF\u0632\u0627\u0631\u0634\u06CC \u067E\u06CC\u062F\u0627 \u0646\u06A9\u0631\u062F. \u0627\u0639\u062A\u0628\u0627\u0631\u06CC \u06A9\u0645 \u0646\u0634\u062F.",
    'visit.image.readStatus.no_image': "\u062E\u0648\u0627\u0646\u062F\u0646 \u062A\u0635\u0648\u06CC\u0631 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.image.comment': "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0627\u06CC\u0646 \u0646\u0634\u0627\u0646\u0647",
    'visit.image.commentPlaceholder': "\u0627\u06CC\u0646\u062C\u0627 \u0686\u0647 \u062F\u06CC\u062F\u06CC\u062F\u061F",
    'visit.image.removeMark': "\u062D\u0630\u0641 \u0627\u06CC\u0646 \u0646\u0634\u0627\u0646\u0647",
    'visit.image.tooManyMarks': "\u0647\u0631 \u062A\u0635\u0648\u06CC\u0631 \u062D\u062F\u0627\u06A9\u062B\u0631 {{max}} \u0646\u0634\u0627\u0646\u0647 \u0645\u06CC\u200C\u067E\u0630\u06CC\u0631\u062F.",
    'visit.image.saveFailed': "\u0630\u062E\u06CC\u0631\u0647\u0654 \u0646\u0634\u0627\u0646\u0647\u200C\u0647\u0627 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.image.unsaved': "\u0646\u0634\u0627\u0646\u0647\u200C\u0647\u0627\u06CC \u0630\u062E\u06CC\u0631\u0647\u200C\u0646\u0634\u062F\u0647 \u2014 \xab\u0630\u062E\u06CC\u0631\u0647\xbb \u0631\u0627 \u0628\u0632\u0646\u06CC\u062F.",
    'visit.image.findings': "\u0622\u0646\u0686\u0647 \u062F\u0633\u062A\u06CC\u0627\u0631 \u062E\u0648\u0627\u0646\u062F",
    'visit.image.findingsNote': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u0627\u0633\u062A\u061B \u062A\u0627 \u062A\u0623\u06CC\u06CC\u062F \u0646\u06A9\u0646\u06CC\u062F \u062F\u0631 \u0686\u0627\u0631\u062A \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'visit.image.confidence.high': "\u0648\u0627\u0636\u062D",
    'visit.image.confidence.medium': "\u0645\u062D\u062A\u0645\u0644",
    'visit.image.confidence.low': "\u0646\u0627\u0645\u0637\u0645\u0626\u0646",
    'visit.image.notLocalized': "\u0645\u062D\u0644 \u0645\u0634\u062E\u0635 \u0646\u0634\u062F",
    'visit.image.unlocalizedNote': "\u0645\u062D\u0644 {{count}} \u06CC\u0627\u0641\u062A\u0647 \u0631\u0648\u06CC \u062A\u0635\u0648\u06CC\u0631 \u0645\u0634\u062E\u0635 \u0646\u0634\u062F \u0648 \u0641\u0642\u0637 \u0641\u0647\u0631\u0633\u062A \u0634\u062F\u0647\u200C\u0627\u0646\u062F.",
    'visit.image.confirm': "\u062A\u0623\u06CC\u06CC\u062F",
    'visit.files.openFile': "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646 \u0641\u0627\u06CC\u0644",
    'visit.image.register': "\u062B\u0628\u062A",
    'visit.image.registering': "\u062F\u0631 \u062D\u0627\u0644 \u062B\u0628\u062A\u2026",
    'visit.image.notRegistered.title': "\u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u062A\u0635\u0648\u06CC\u0631 \u062F\u0646\u062F\u0627\u0646\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.image.notRegistered.body': "\u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u0628\u0628\u06CC\u0646\u06CC\u062F\u0634. \u0628\u0631\u0627\u06CC \u0639\u0644\u0627\u0645\u062A\u200C\u06AF\u0630\u0627\u0631\u06CC \u0648 \u062E\u0648\u0627\u0646\u062F\u0646 \u0628\u0627 \u062F\u0633\u062A\u06CC\u0627\u0631\u060C \u0646\u0648\u0639 \u062A\u0635\u0648\u06CC\u0631 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A \u2014 \u0628\u0627\u06CC\u062A\u200C\u0648\u06CC\u0646\u06AF \u0648 \u0639\u06A9\u0633 \u06CC\u06A9 \u0686\u06CC\u0632 \u0631\u0627 \u0646\u0634\u0627\u0646 \u0646\u0645\u06CC\u200C\u062F\u0647\u0646\u062F.",
    'visit.image.changeView': "\u062A\u063A\u06CC\u06CC\u0631 \u0646\u0648\u0639",
    'visit.image.viewType.title': "\u0646\u0648\u0639 \u062A\u0635\u0648\u06CC\u0631",
    'visit.image.viewType.body': "\u0627\u06CC\u0646 \u062A\u0639\u06CC\u06CC\u0646 \u0645\u06CC\u200C\u06A9\u0646\u062F \u062F\u0633\u062A\u06CC\u0627\u0631 \u0686\u0647 \u0686\u06CC\u0632\u06CC \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u06AF\u0632\u0627\u0631\u0634 \u06A9\u0646\u062F \u2014 \u0628\u0627\u06CC\u062A\u200C\u0648\u06CC\u0646\u06AF \u0636\u0627\u06CC\u0639\u0647\u0654 \u067E\u0631\u06CC\u200C\u0627\u067E\u06CC\u06A9\u0627\u0644 \u0631\u0627 \u0646\u0634\u0627\u0646 \u0646\u0645\u06CC\u200C\u062F\u0647\u062F \u0648 \u0639\u06A9\u0633\u060C \u0627\u0633\u062A\u062E\u0648\u0627\u0646 \u0631\u0627. \u0627\u06AF\u0631 \u0627\u0634\u062A\u0628\u0627\u0647 \u0627\u0633\u062A \u0627\u0635\u0644\u0627\u062D\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.image.discard.title': "\u0646\u0634\u0627\u0646\u0647\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u06A9\u0634\u06CC\u062F\u0647\u200C\u0627\u06CC\u062F \u062D\u0630\u0641 \u0634\u0648\u062F\u061F",
    'visit.image.discard.body': "\u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u0647\u200C\u0627\u0646\u062F \u0648 \u0646\u0633\u062E\u0647\u0654 \u062F\u06CC\u06AF\u0631\u06CC \u0627\u0632 \u0622\u0646\u200C\u0647\u0627 \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F.",
    'visit.image.discard.confirm': "\u062D\u0630\u0641",
    'visit.files.error.title': "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F",
    'visit.files.error.body': "\u062E\u0648\u0627\u0646\u062F\u0646 \u0627\u0633\u0646\u0627\u062F \u0627\u06CC\u0646 \u0628\u06CC\u0645\u0627\u0631 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'visit.files.empty.title': "\u0633\u0646\u062F\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'visit.files.empty.description': "\u0631\u0627\u062F\u06CC\u0648\u06AF\u0631\u0627\u0641\u06CC\u060C \u062C\u0648\u0627\u0628 \u0622\u0632\u0645\u0627\u06CC\u0634 \u06CC\u0627 \u0646\u0627\u0645\u0647\u0654 \u0627\u0631\u062C\u0627\u0639 \u0631\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u06A9\u0646\u06CC\u062F.",
    'visit.files.upload': "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0633\u0646\u062F",
    'visit.files.uploading': "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026",
    'visit.files.uploadFailed': "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0633\u0646\u062F \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.files.readFailed': "\u062E\u0648\u0627\u0646\u062F\u0646 \u0641\u0627\u06CC\u0644 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.files.tooLarge': "\u062D\u062C\u0645 \u0641\u0627\u06CC\u0644 \u0628\u06CC\u0634 \u0627\u0632 \u06F1\u06F5 \u0645\u06AF\u0627\u0628\u0627\u06CC\u062A \u0627\u0633\u062A.",
    'visit.files.docType': "\u0646\u0648\u0639 \u0633\u0646\u062F",
    'visit.files.docTypes.lab_report': "\u062C\u0648\u0627\u0628 \u0622\u0632\u0645\u0627\u06CC\u0634",
    'visit.files.docTypes.prescription': "\u0646\u0633\u062E\u0647",
    'visit.files.docTypes.general': "\u0633\u0627\u06CC\u0631",
    'visit.files.attachTooth': "\u0627\u062A\u0635\u0627\u0644 \u0628\u0647 \u062F\u0646\u062F\u0627\u0646 {{fdi}}",
    'visit.files.thisVisit': "\u0627\u06CC\u0646 \u062C\u0644\u0633\u0647",
    'visit.files.hasReport': "\u06AF\u0632\u0627\u0631\u0634",
    'visit.files.noReport': "\u06AF\u0632\u0627\u0631\u0634\u06CC \u0627\u0632 \u0627\u06CC\u0646 \u0633\u0646\u062F \u0627\u0633\u062A\u062E\u0631\u0627\u062C \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'visit.files.previewFailed': "\u0628\u0627\u0632\u06A9\u0631\u062F\u0646 \u0641\u0627\u06CC\u0644 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F.",
    'visit.files.bytesGone': "\u0641\u0627\u06CC\u0644 \u0627\u0635\u0644\u06CC \u062F\u06CC\u06AF\u0631 \u0630\u062E\u06CC\u0631\u0647 \u0646\u06CC\u0633\u062A\u061B \u0641\u0642\u0637 \u06AF\u0632\u0627\u0631\u0634 \u0622\u0646 \u0628\u0627\u0642\u06CC \u0645\u0627\u0646\u062F\u0647 \u0627\u0633\u062A.",
    'visit.files.remove': "\u062D\u0630\u0641 {{name}}",
    'visit.files.units.b': "\u0628\u0627\u06CC\u062A",
    'visit.files.units.kb': "\u06A9\u06CC\u0644\u0648\u0628\u0627\u06CC\u062A",
    'visit.files.units.mb': "\u0645\u06AF\u0627\u0628\u0627\u06CC\u062A",
    // ── credits (اعتبار) ──────────────────────────────────────────────────────
    'credits.title': "\u0627\u0639\u062A\u0628\u0627\u0631 \u067E\u0627\u0631\u0633\u06CC\u0646\u0627",
    'credits.subtitle': "\u0645\u0648\u062C\u0648\u062F\u06CC \u067E\u0627\u0631\u0633\u0647\u060C \u0627\u06CC\u0646\u06A9\u0647 \u06A9\u062C\u0627 \u062E\u0631\u062C \u0634\u062F\u0647 \u0648 \u0686\u0637\u0648\u0631 \u0634\u0627\u0631\u0698 \u06A9\u0646\u06CC\u062F.",
    'credits.unit': "\u067E\u0627\u0631\u0633\u0647",
    'credits.toman': "\u062A\u0648\u0645\u0627\u0646",
    'credits.tomanShort': "\u062A",
    'credits.currentBalance': "\u0645\u0648\u062C\u0648\u062F\u06CC \u0641\u0639\u0644\u06CC",
    'credits.buy': "\u062E\u0631\u06CC\u062F \u067E\u0627\u0631\u0633\u0647",
    'credits.topUp': "\u0634\u0627\u0631\u0698",
    'credits.percent': "\u066A{{value}}",
    'credits.timesUsed': "{{count}} \u0628\u0627\u0631",
    'credits.itemCount': "{{count}} \u0645\u0648\u0631\u062F",
    'credits.minutesUsed': "{{count}} \u062F\u0642\u06CC\u0642\u0647",
    'credits.byService': "\u06A9\u062C\u0627 \u062E\u0631\u062C \u0634\u062F",
    'credits.transactions': "\u062A\u0631\u0627\u06A9\u0646\u0634\u200C\u0647\u0627",
    'credits.level.low': "\u0627\u0639\u062A\u0628\u0627\u0631 \u06A9\u0645",
    'credits.level.lowShort': "\u06A9\u0645",
    'credits.level.mid': "\u0631\u0648 \u0628\u0647 \u0627\u062A\u0645\u0627\u0645",
    'credits.level.midShort': "\u0645\u062A\u0648\u0633\u0637",
    'credits.level.ok': "\u0627\u0639\u062A\u0628\u0627\u0631 \u0645\u0646\u0627\u0633\u0628",
    'credits.level.okShort': "\u062E\u0648\u0628",
    'credits.banner.low': "\u0641\u0642\u0637 {{coins}} \u067E\u0627\u0631\u0633\u0647 \u0645\u0627\u0646\u062F\u0647 \u0627\u0633\u062A. \u0628\u0627 \u062A\u0645\u0627\u0645\u200C\u0634\u062F\u0646 \u0627\u0639\u062A\u0628\u0627\u0631\u060C \u062F\u0633\u062A\u06CC\u0627\u0631 \u0645\u062A\u0648\u0642\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'credits.banner.mid': "{{coins}} \u067E\u0627\u0631\u0633\u0647 \u0645\u0627\u0646\u062F\u0647 \u2014 \u06A9\u0627\u0641\u06CC \u0628\u0631\u0627\u06CC \u0686\u0646\u062F \u062C\u0644\u0633\u0647\u0654 \u062F\u06CC\u06AF\u0631.",
    'credits.service.assistant': "\u062F\u0633\u062A\u06CC\u0627\u0631 \u0628\u0627\u0644\u06CC\u0646\u06CC",
    'credits.service.interaction': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644",
    'credits.service.transcription': "\u067E\u06CC\u0627\u062F\u0647\u200C\u0633\u0627\u0632\u06CC \u0635\u0648\u062A",
    'credits.service.topUp': "\u0634\u0627\u0631\u0698 \u0627\u0639\u062A\u0628\u0627\u0631",
    'credits.service.gift': "\u06A9\u062F \u0647\u062F\u06CC\u0647",
    'credits.service.sms': "\u067E\u06CC\u0627\u0645\u06A9",
    'credits.service.ai': "\u0633\u0631\u0648\u06CC\u0633 \u0647\u0648\u0634\u0645\u0646\u062F",
    'credits.filter.label': "\u0641\u06CC\u0644\u062A\u0631 \u062A\u0631\u0627\u06A9\u0646\u0634\u200C\u0647\u0627",
    'credits.filter.all': "\u0647\u0645\u0647",
    'credits.filter.spend': "\u0645\u0635\u0631\u0641",
    'credits.filter.topUp': "\u0627\u0641\u0632\u0627\u06CC\u0634",
    'credits.group.label': "\u06AF\u0631\u0648\u0647\u200C\u0628\u0646\u062F\u06CC",
    'credits.group.day': "\u0631\u0648\u0632",
    'credits.group.type': "\u0633\u0631\u0648\u06CC\u0633",
    'credits.range.label': "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
    'credits.range.all': "\u0647\u0645\u0647\u0654 \u0632\u0645\u0627\u0646\u200C\u0647\u0627",
    'credits.range.days7': "\u06F7 \u0631\u0648\u0632 \u0627\u062E\u06CC\u0631",
    'credits.range.days30': "\u06F3\u06F0 \u0631\u0648\u0632 \u0627\u062E\u06CC\u0631",
    'credits.range.thisMonth': "\u0627\u06CC\u0646 \u0645\u0627\u0647",
    'credits.time.today': "\u0627\u0645\u0631\u0648\u0632",
    'credits.time.yesterday': "\u062F\u06CC\u0631\u0648\u0632",
    'credits.kpi.month': "\u0645\u0635\u0631\u0641 \u0627\u06CC\u0646 \u0645\u0627\u0647",
    'credits.kpi.perVisit': "\u0647\u0631 \u062C\u0644\u0633\u0647",
    'credits.kpi.topService': "\u0628\u06CC\u0634\u062A\u0631\u06CC\u0646 \u0645\u0635\u0631\u0641",
    'credits.showingRange': "\u0646\u0645\u0627\u06CC\u0634 {{from}}\u2013{{to}} \u0627\u0632 {{total}}",
    'credits.pager.page': "\u0635\u0641\u062D\u0647\u0654 {{page}} \u0627\u0632 {{total}}",
    'credits.pager.previous': "\u0642\u0628\u0644\u06CC",
    'credits.pager.next': "\u0628\u0639\u062F\u06CC",
    'credits.empty.title': "\u0647\u0646\u0648\u0632 \u062A\u0631\u0627\u06A9\u0646\u0634\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
    'credits.empty.hint': "\u0647\u0631 \u0639\u0645\u0644\u06CC\u0627\u062A \u062F\u0633\u062A\u06CC\u0627\u0631 \u062F\u0631 \u062C\u0644\u0633\u0647\u0654 \u062F\u0631\u0645\u0627\u0646 \u0627\u06CC\u0646\u062C\u0627 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'credits.empty.filtered': "\u062F\u0631 \u0627\u06CC\u0646 \u0628\u0627\u0632\u0647 \u0686\u06CC\u0632\u06CC \u0646\u06CC\u0633\u062A",
    'credits.empty.filteredHint': "\u0628\u0627\u0632\u0647\u0654 \u0628\u0627\u0632\u062A\u0631\u06CC \u06CC\u0627 \u0641\u06CC\u0644\u062A\u0631 \u062F\u06CC\u06AF\u0631\u06CC \u0631\u0627 \u0627\u0645\u062A\u062D\u0627\u0646 \u06A9\u0646\u06CC\u062F.",
    'credits.error.title': "\u062A\u0631\u0627\u06A9\u0646\u0634\u200C\u0647\u0627 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
    'credits.error.body': "\u062E\u0648\u0627\u0646\u062F\u0646 \u0627\u0639\u062A\u0628\u0627\u0631 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0645\u0628\u0644\u063A\u06CC \u06A9\u0633\u0631 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'credits.priceList.title': "\u0647\u0631 \u0639\u0645\u0644\u06CC\u0627\u062A \u0686\u0646\u062F \u067E\u0627\u0631\u0633\u0647\u061F",
    'credits.priceList.hint': "\u0641\u0642\u0637 \u0628\u0627 \u0641\u0634\u0631\u062F\u0646 \u062F\u06A9\u0645\u0647 \u06A9\u0633\u0631 \u0645\u06CC\u200C\u0634\u0648\u062F \u2014 \u0647\u06CC\u0686 \u0686\u06CC\u0632 \u062E\u0648\u062F\u06A9\u0627\u0631 \u0627\u062C\u0631\u0627 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
    'credits.priceList.viewAll': "\u0646\u0645\u0627\u06CC\u0634 \u0647\u0645\u0647",
    // تنها ردیف دقیقه‌ای فهرست. سرویس به‌سمت بالا گرد می‌کند، پس کوتاه‌ترین
    // گفتن هم یک دقیقهٔ کامل حساب می‌شود.
    'credits.price.transcription': "\u06AF\u0641\u062A\u0646 \u0628\u0627 \u0635\u062F\u0627 (\u062A\u0628\u062F\u06CC\u0644 \u06AF\u0641\u062A\u0627\u0631 \u0628\u0647 \u0645\u062A\u0646)",
    'credits.price.differential': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F \u062A\u0634\u062E\u06CC\u0635 \u0647\u0648\u0634 \u0645\u0635\u0646\u0648\u0639\u06CC",
    'credits.price.advice': "\u0646\u06A9\u0627\u062A \u062F\u0633\u062A\u06CC\u0627\u0631 \u0628\u0627\u0644\u06CC\u0646\u06CC",
    'credits.price.soap': "\u062A\u06A9\u0645\u06CC\u0644 \u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
    'credits.price.teeth': "\u06CC\u0627\u0641\u062A\u0647\u200C\u0647\u0627\u06CC \u062F\u0646\u062F\u0627\u0646 \u0627\u0632 \u0634\u0631\u062D \u062C\u0644\u0633\u0647",
    'credits.price.confirmq': "\u067E\u0631\u0633\u0634\u200C\u0647\u0627\u06CC \u062A\u06A9\u0645\u06CC\u0644\u06CC",
    'credits.price.ask': "\u067E\u0631\u0633\u0634 \u0627\u0632 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'credits.price.ocr': "\u062E\u0648\u0627\u0646\u062F\u0646 \u0633\u0646\u062F \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u200C\u0634\u062F\u0647",
    'credits.price.interaction': "\u0628\u0631\u0631\u0633\u06CC \u062A\u062F\u0627\u062E\u0644 \u062F\u0627\u0631\u0648\u06CC\u06CC",
    'credits.topUp.chooseAmount': "\u0627\u0646\u062A\u062E\u0627\u0628 \u0645\u0628\u0644\u063A",
    'credits.topUp.recommended': "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u06CC",
    'credits.topUp.approxVisits': "\u062D\u062F\u0648\u062F {{count}} \u062C\u0644\u0633\u0647 \u0628\u0627 \u062F\u0633\u062A\u06CC\u0627\u0631",
    'credits.topUp.custom': "\u0645\u0628\u0644\u063A \u062F\u0644\u062E\u0648\u0627\u0647",
    'credits.topUp.customAria': "\u0645\u0628\u0644\u063A",
    'credits.topUp.payVia': "\u067E\u0631\u062F\u0627\u062E\u062A {{amount}} \u062A\u0648\u0645\u0627\u0646 \u0628\u0627 {{gateway}}",
    'credits.topUp.enterAmount': "\u0645\u0628\u0644\u063A \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F",
    'credits.topUp.redirecting': "\u062F\u0631 \u062D\u0627\u0644 \u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u062F\u0631\u06AF\u0627\u0647\u2026",
    'credits.topUp.redirectNote': "\u0628\u0647 \u062F\u0631\u06AF\u0627\u0647 \u0628\u0627\u0646\u06A9\u06CC \u0645\u0646\u062A\u0642\u0644 \u0645\u06CC\u200C\u0634\u0648\u06CC\u062F \u0648 \u067E\u0633 \u0627\u0632 \u067E\u0631\u062F\u0627\u062E\u062A \u0628\u0647 \u0647\u0645\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0627\u0632\u0645\u06CC\u200C\u06AF\u0631\u062F\u06CC\u062F.",
    'credits.topUp.minimum': "\u06A9\u0645\u062A\u0631\u06CC\u0646 \u0645\u0628\u0644\u063A \u062E\u0631\u06CC\u062F {{amount}} \u062A\u0648\u0645\u0627\u0646 \u0627\u0633\u062A.",
    'credits.topUp.failed': "\u0634\u0631\u0648\u0639 \u067E\u0631\u062F\u0627\u062E\u062A \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F. \u0644\u0637\u0641\u0627\u064B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.",
    'credits.topUp.failedWithReason': "\u0634\u0631\u0648\u0639 \u067E\u0631\u062F\u0627\u062E\u062A \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F: {{reason}}",
    'credits.gateway.saderat': "\u0628\u0627\u0646\u06A9 \u0635\u0627\u062F\u0631\u0627\u062A",
    'credits.gateway.zarinpal': "\u0632\u0631\u06CC\u0646\u200C\u067E\u0627\u0644",
    'credits.payment.done': "\u067E\u0631\u062F\u0627\u062E\u062A \u0645\u0648\u0641\u0642 \u2014 \u0627\u0639\u062A\u0628\u0627\u0631 \u0634\u0645\u0627 \u0634\u0627\u0631\u0698 \u0634\u062F.",
    'credits.payment.failed': "\u067E\u0631\u062F\u0627\u062E\u062A \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F. \u0645\u0628\u0644\u063A\u06CC \u06A9\u0633\u0631 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
    'credits.gift.title': "\u06A9\u062F \u0647\u062F\u06CC\u0647",
    'credits.gift.hint': "\u06A9\u062F\u06CC \u0627\u0632 \u06A9\u0645\u067E\u06CC\u0646\u200C\u0647\u0627\u06CC \u067E\u0627\u0631\u0633\u06CC\u0646\u0627 \u062F\u0627\u0631\u06CC\u062F\u061F \u0627\u06CC\u0646\u062C\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F \u062A\u0627 \u067E\u0627\u0631\u0633\u0647\u0654 \u0622\u0646 \u0628\u0647 \u0627\u0639\u062A\u0628\u0627\u0631\u062A\u0627\u0646 \u0627\u0636\u0627\u0641\u0647 \u0634\u0648\u062F.",
    'credits.gift.placeholder': 'PARSINA-1404-XXXX',
    'credits.gift.submit': "\u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC",
    'credits.gift.submitting': "\u062F\u0631 \u062D\u0627\u0644 \u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC\u2026",
    'credits.gift.empty': "\u0627\u0628\u062A\u062F\u0627 \u06A9\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'credits.gift.notFound': "\u0627\u06CC\u0646 \u06A9\u062F \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A. \u0644\u0637\u0641\u0627\u064B \u0622\u0646 \u0631\u0627 \u062F\u0642\u06CC\u0642\u0627\u064B \u0647\u0645\u0627\u0646\u200C\u0637\u0648\u0631 \u06A9\u0647 \u062F\u0631\u06CC\u0627\u0641\u062A \u06A9\u0631\u062F\u0647\u200C\u0627\u06CC\u062F \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'credits.gift.oneUse': "\u0647\u0631 \u06A9\u062F \u0641\u0642\u0637 \u06CC\u06A9\u200C\u0628\u0627\u0631 \u0642\u0627\u0628\u0644 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0627\u0633\u062A.",
    'credits.gift.success': "{{parseh}} \u067E\u0627\u0631\u0633\u0647 \u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F",
    'credits.gift.successSub': "\u062D\u062F\u0648\u062F {{visits}} \u062C\u0644\u0633\u0647 \u0628\u0627 \u062F\u0633\u062A\u06CC\u0627\u0631.",
    'credits.gift.newBalance': "\u0645\u0648\u062C\u0648\u062F\u06CC \u062C\u062F\u06CC\u062F",
    'credits.gift.myCodes': "\u06A9\u062F\u0647\u0627\u06CC \u0634\u0645\u0627",
    'credits.gift.worth': "{{parseh}} \u067E\u0627\u0631\u0633\u0647 \u2014 \u062D\u062F\u0648\u062F {{visits}} \u062C\u0644\u0633\u0647",
    'credits.gift.status.issued': "\u0627\u0633\u062A\u0641\u0627\u062F\u0647\u200C\u0646\u0634\u062F\u0647",
    'credits.gift.status.redeemed': "\u0627\u0633\u062A\u0641\u0627\u062F\u0647\u200C\u0634\u062F\u0647",
    'credits.gift.status.revoked': "\u0628\u0627\u0637\u0644\u200C\u0634\u062F\u0647",
    'credits.gift.status.expired': "\u0645\u0646\u0642\u0636\u06CC\u200C\u0634\u062F\u0647",
    'credits.lowBalance.title': "\u0647\u0634\u062F\u0627\u0631 \u0627\u0639\u062A\u0628\u0627\u0631 \u06A9\u0645",
    'credits.lowBalance.hint': "\u0648\u0642\u062A\u06CC \u0645\u0648\u062C\u0648\u062F\u06CC \u0627\u0632 \u0627\u06CC\u0646 \u0645\u0642\u062F\u0627\u0631 \u06A9\u0645\u062A\u0631 \u0634\u0648\u062F \u0628\u0647 \u0634\u0645\u0627 \u0627\u0637\u0644\u0627\u0639 \u0645\u06CC\u200C\u062F\u0647\u06CC\u0645.",
    'credits.lowBalance.toggleAria': "\u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC \u0647\u0634\u062F\u0627\u0631 \u0627\u0639\u062A\u0628\u0627\u0631 \u06A9\u0645",
    'credits.lowBalance.thresholdAria': "\u062D\u062F \u0647\u0634\u062F\u0627\u0631\u060C \u0628\u0647 \u067E\u0627\u0631\u0633\u0647",
    'credits.lowBalance.active': "\u0632\u06CC\u0631 {{coins}} \u067E\u0627\u0631\u0633\u0647 \u0628\u0647 \u0634\u0645\u0627 \u0647\u0634\u062F\u0627\u0631 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
    'credits.lowBalance.off': "\u0647\u0634\u062F\u0627\u0631\u0647\u0627 \u062E\u0627\u0645\u0648\u0634 \u0627\u0633\u062A.",
    'credits.lowBalance.invalid': "\u062D\u062F \u0647\u0634\u062F\u0627\u0631 \u0645\u0639\u062A\u0628\u0631 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.",
    'credits.lowBalance.saved': "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u0647\u0634\u062F\u0627\u0631 \u0630\u062E\u06CC\u0631\u0647 \u0634\u062F.",
    'credits.lowBalance.failed': "\u0630\u062E\u06CC\u0631\u0647\u0654 \u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u0647\u0634\u062F\u0627\u0631 \u0645\u0645\u06A9\u0646 \u0646\u0634\u062F."
};


// FR — French. Translates en.js key for key (PM-0185).
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here; tests/i18n.test.js asserts both directions. A
// key that ever goes missing falls back to English (translator.js), never to
// Persian.
//
// French typography is in the values themselves: « » with a no-break space
// inside, U+00A0 before ':' and '%', U+202F before ; ! ?, the typographic
// apostrophe ’. Count-neutral wording throughout — this translator has no
// plural lookup, so a {{count}} string must read correctly for 0, 1 and many.
// Brand and code values are kept as they are: 'Parsina', 'Parseh',
// 'PARSINA-1404-XXXX', the language endonyms.
const $63d59e529dc08206$export$acb2a88f7d552ebf = {
    // ── app ──────────────────────────────────────────────────────────────────
    'app.title': "Parsina \u2014 Module dentaire",
    // ── nav / chrome ─────────────────────────────────────────────────────────
    'nav.brand.name': 'Parsina',
    'nav.brand.panel': 'Chirurgie dentaire',
    'nav.items.today': "Aujourd\u2019hui",
    'nav.items.patients': 'Patients',
    'nav.items.credits': "Cr\xe9dit",
    'nav.items.profile': 'Profil',
    'nav.sidebar.collapse': "R\xe9duire le menu",
    'nav.sidebar.expand': "D\xe9velopper le menu",
    'nav.sidebar.logout': "Se d\xe9connecter",
    'nav.sidebar.editProfile': 'Profil',
    'nav.clinic.label': 'Clinique',
    'nav.account.menuLabel': 'Compte',
    'nav.account.parsina': 'Compte Parsina',
    'nav.account.parsinaHint': 'Nom, mot de passe, langue',
    'nav.credits.label': "Votre cr\xe9dit Parseh",
    'nav.credits.topUp': 'Recharger en Parseh',
    'nav.clinicSwitch.label': "Acc\xe9der \xe0 l\u2019espace clinique",
    'nav.landmark.primary': 'Menu principal',
    'nav.landmark.content': 'Contenu',
    // ── common ───────────────────────────────────────────────────────────────
    'common.actions.cancel': 'Annuler',
    'common.actions.retry': "R\xe9essayer",
    'common.loading': 'Chargement',
    'common.actions.save': 'Enregistrer',
    'common.actions.saving': "Enregistrement\u2026",
    'common.actions.back': 'Retour',
    'common.actions.close': 'Fermer',
    'common.actions.clearFilters': 'Effacer les filtres',
    'common.actions.join': 'Rejoindre',
    'common.state.pleaseWait': "Veuillez patienter\u2026",
    'common.labels.phone': "T\xe9l\xe9phone",
    'common.labels.country': 'Pays',
    'common.labels.nationalId': "N\xb0 national",
    'common.labels.fileNumber': "N\xb0 de dossier",
    'common.labels.none': "\u2014",
    'common.gender.male': 'Homme',
    'common.gender.female': 'Femme',
    'common.marital.single': "C\xe9libataire",
    'common.marital.married': "Mari\xe9(e)",
    'common.marital.divorced': "Divorc\xe9(e)",
    'common.marital.widowed': 'Veuf / veuve',
    'common.units.years': '{{count}} ans',
    'common.units.years_one': '{{count}} an',
    'common.units.minute': 'min',
    'common.units.second': 'secondes',
    'common.units.toman': 'toman',
    'common.units.tomans': 'tomans',
    'common.punct.colon': "\xa0:",
    'common.voice.start': 'Dicter',
    'common.voice.stop': "Arr\xeater l\u2019enregistrement",
    'common.voice.listening': "En \xe9coute",
    'common.voice.priceTitle': "5 Parseh par minute d\u2019enregistrement, arrondi \xe0 la minute sup\xe9rieure.",
    'common.voice.inlineTranscribing': "Transcription\u2026",
    'common.voice.error.denied': "L\u2019acc\xe8s au micro a \xe9t\xe9 refus\xe9",
    'common.voice.error.no-mic': "Aucun micro n\u2019a \xe9t\xe9 d\xe9tect\xe9",
    'common.voice.error.unsupported': 'Ce navigateur ne peut pas enregistrer de son',
    'common.voice.error.insecure': "L\u2019enregistrement ne fonctionne que sur une connexion s\xe9curis\xe9e (HTTPS)",
    'common.voice.error.credits': "Cr\xe9dit Parseh insuffisant",
    'common.voice.error.auth': "Votre session n\u2019est plus valide. Veuillez vous reconnecter",
    'common.voice.error.onboarding': "Terminez d\u2019abord votre inscription",
    'common.voice.error.unavailable': 'Le service de reconnaissance vocale est indisponible',
    'common.voice.error.timeout': 'La transcription a pris trop de temps',
    'common.voice.error.generic': "Impossible d\u2019enregistrer le son",
    // ── mobile shell ─────────────────────────────────────────────────────────
    'mobile.greeting': 'Bienvenue,',
    'mobile.showMore': 'Afficher plus',
    'mobile.close': 'Fermer',
    // ── auth / boot ──────────────────────────────────────────────────────────
    'auth.checking': "Connexion\u2026",
    'auth.loading': "Chargement de votre espace\u2026",
    'auth.loopError': "La connexion redirige en boucle. Effacez votre session et r\xe9essayez, ou contactez l\u2019assistance.",
    'auth.loopTitle': "\xc9chec de la connexion",
    'auth.checkingHint': "Cela ne prend qu\u2019un instant",
    'auth.stuck': "Pas de redirection\u202F?",
    'auth.manualSignIn': 'Cliquez ici',
    'auth.retry': "R\xe9essayer",
    'auth.signOut': "Se d\xe9connecter",
    'auth.bootFailed.title': "D\xe9marrage impossible",
    'auth.bootFailed.body': "Votre espace n\u2019a pas pu \xeatre charg\xe9. C\u2019est g\xe9n\xe9ralement temporaire.",
    'auth.session.expiringTitle': "Votre session va bient\xf4t expirer",
    'auth.session.expiringBody': "Prolongez-la pour continuer \xe0 travailler sans interruption.",
    'auth.session.staySignedIn': "Continuer \xe0 travailler",
    'auth.session.expiredTitle': "Votre session a expir\xe9",
    'auth.session.expiredBody': "Reconnectez-vous pour continuer. Cette page n\u2019a pas \xe9t\xe9 ferm\xe9e \u2014 vous y reviendrez ensuite.",
    'auth.session.signInAgain': 'Se reconnecter',
    'auth.session.returnNotice': "Tout ce que vous avez d\xe9j\xe0 enregistr\xe9 est conserv\xe9. Avant de vous reconnecter, notez ce qui n\u2019est pas encore enregistr\xe9 \xe0 l\u2019\xe9cran.",
    // ── errors ───────────────────────────────────────────────────────────────
    'errors.generic': "Une erreur s\u2019est produite.",
    'errors.load.today': "La journ\xe9e n\u2019a pas pu \xeatre charg\xe9e.",
    'errors.load.patients': "La liste des patients n\u2019a pas pu \xeatre charg\xe9e.",
    'errors.load.patient': "Ce dossier n\u2019a pas pu \xeatre charg\xe9.",
    'errors.load.profile': "Votre profil n\u2019a pas pu \xeatre charg\xe9.",
    'errors.load.drugs': "La recherche dans le r\xe9f\xe9rentiel des m\xe9dicaments a \xe9chou\xe9.",
    'errors.credits.title': "Cr\xe9dit IA insuffisant",
    'errors.credits.body': "La v\xe9rification des interactions n\xe9cessite du cr\xe9dit. Rechargez-le depuis la page \xab\xa0Cr\xe9dit\xa0\xbb \u2014 la prescription elle-m\xeame n\u2019est pas bloqu\xe9e.",
    // ── today (امروز) ─────────────────────────────────────────────────────────
    'today.title': "Aujourd\u2019hui",
    'today.date.today': "Aujourd\u2019hui",
    'today.date.prev': "Jour pr\xe9c\xe9dent",
    'today.date.next': 'Jour suivant',
    'today.date.pick': 'Choisir une date',
    'today.counts.total': 'Rendez-vous',
    'today.counts.here': "\xc0 la clinique",
    'today.counts.scheduled': "Planifi\xe9s",
    'today.counts.completed': 'Vus',
    'today.counts.cancelled': "Annul\xe9s",
    'today.counts.cancelledLine': "Annul\xe9s\xa0: {{count}}",
    'today.notice.liveQueue': "La salle d\u2019attente en direct ne s\u2019affiche que pour aujourd\u2019hui. Les autres jours affichent la liste des rendez-vous planifi\xe9s.",
    'today.status.scheduled': "Planifi\xe9",
    'today.status.arrived': "Arriv\xe9",
    'today.status.in_visit': 'Au fauteuil',
    'today.status.completed': 'Vu',
    'today.status.cancelled': "Annul\xe9",
    'today.status.no_show': "Non honor\xe9",
    'today.blocks.queue': "Salle d\u2019attente",
    'today.blocks.upcoming': "\xc0 venir",
    'today.blocks.done': "Termin\xe9s",
    'today.next.title': 'Patient suivant',
    'today.next.at': "\xe0 {{time}}",
    'today.next.service': "Prestation\xa0: {{name}}",
    'today.next.serviceVisit': "S\xe9ance",
    'today.next.serviceMore': '+{{count}} en plus',
    'today.empty.title': "Aucun rendez-vous planifi\xe9 ce jour-l\xe0",
    'today.empty.description': "Les rendez-vous sont planifi\xe9s par l\u2019accueil de la clinique et s\u2019affichent ici automatiquement.",
    'today.error.title': 'Le planning du jour est indisponible',
    'today.queue.positionNext': 'Suivant',
    'today.queue.position': "N\xb0\xa0{{position}}",
    'today.queue.waited': "{{count}}\xa0min d\u2019attente",
    'today.queue.waitedHours': "{{hours}}\xa0h d\u2019attente",
    'today.queue.waitedHoursMinutes': "{{hours}}\xa0h {{minutes}}\xa0min d\u2019attente",
    'today.queue.elapsed': "{{count}}\xa0min au fauteuil",
    'today.queue.elapsedHours': "{{hours}}\xa0h au fauteuil",
    'today.queue.elapsedHoursMinutes': "{{hours}}\xa0h {{minutes}}\xa0min au fauteuil",
    'today.row.visit': "S\xe9ance",
    'today.row.visitFor': "Ouvrir la s\xe9ance de {{name}}",
    'today.row.open': 'Ouvrir le dossier',
    'today.row.openFor': 'Ouvrir le dossier de {{name}}',
    'today.row.walkIn': "R\xe9servation rapide",
    'today.row.unknownPatient': 'Patient sans nom',
    'today.readOnlyNote': "La planification, l\u2019annulation et l\u2019ordre de passage rel\xe8vent de l\u2019accueil de la clinique. Cet espace affiche les m\xeames rendez-vous.",
    // ── patients (بیماران) ────────────────────────────────────────────────────
    'patients.title': 'Patients',
    'patients.subtitle': "Le registre des patients de la clinique \u2014 les m\xeames patients que ceux enregistr\xe9s \xe0 l\u2019accueil",
    'patients.search.placeholder': "Nom, t\xe9l\xe9phone, n\xb0 national ou n\xb0 de dossier",
    'patients.search.hint': "Saisissez au moins deux caract\xe8res pour rechercher.",
    'patients.count': "Patients\xa0: {{count}}",
    'patients.columns.name': 'Patient',
    'patients.columns.phone': "T\xe9l\xe9phone",
    'patients.columns.fileNumber': "N\xb0 de dossier",
    'patients.columns.nationalId': "N\xb0 national",
    'patients.empty.title': "Aucun patient pour l\u2019instant",
    'patients.empty.description': "Les patients enregistr\xe9s \xe0 l\u2019accueil de la clinique apparaissent ici.",
    'patients.emptyFiltered.title': "Aucun r\xe9sultat",
    'patients.emptyFiltered.description': "Aucun patient ne correspond \xe0 cette recherche.",
    'patients.noClinic.title': "Vous n\u2019avez encore rejoint aucune clinique",
    'patients.noClinic.description': "Le registre des patients appartient \xe0 une clinique. Rejoignez-en une depuis votre profil, avec son code d\u2019invitation.",
    'patients.noClinic.action': "Acc\xe9der au profil",
    'patients.pendingClinic.title': "Votre rattachement n\u2019a pas encore \xe9t\xe9 approuv\xe9",
    'patients.pendingClinic.description': "Vous avez demand\xe9 \xe0 rejoindre la clinique, qui doit approuver votre demande avant d\u2019ouvrir son registre des patients. Le statut figure sur votre profil.",
    'patients.error.title': 'La liste des patients est indisponible',
    // ── patient workspace ────────────────────────────────────────────────────
    'patient.tabs.summary': "R\xe9sum\xe9",
    'patient.tabs.history': "Ant\xe9c\xe9dents",
    'patient.tabs.sectionsLabel': 'Sections du dossier',
    'patient.actions.prescribe': 'Prescrire',
    'patient.notFound.title': 'Dossier introuvable',
    'patient.notFound.description': "Ce patient n\u2019existe pas ou ne vous est pas accessible.",
    'patient.error.title': 'Ce dossier est indisponible',
    'patient.stats.age': "\xc2ge",
    'patient.stats.allergies': 'Allergies',
    'patient.stats.medications': "M\xe9dicaments",
    'patient.summary.demographics': 'Informations',
    'patient.summary.allergies': 'Allergies',
    'patient.summary.noAllergies': "Aucune allergie enregistr\xe9e.",
    'patient.severity.mild': "L\xe9g\xe8re",
    'patient.severity.moderate': "Mod\xe9r\xe9e",
    'patient.severity.severe': "S\xe9v\xe8re",
    'patient.conditionStatus.active': 'Actif',
    'patient.conditionStatus.inactive': 'Inactif',
    'patient.conditionStatus.resolved': "R\xe9solu",
    'patient.conditionStatus.remission': "En r\xe9mission",
    'patient.photo.open': 'Afficher en grand la photo de {{name}}',
    'patient.photo.alt': 'Photo de profil de {{name}}',
    'patient.summary.allergyWarning': "Allergies enregistr\xe9es \u2014 v\xe9rifiez-les avant de prescrire.",
    'patient.fields.birthDate': 'Date de naissance',
    'patient.fields.gender': 'Sexe',
    'patient.fields.maritalStatus': 'Situation familiale',
    'patient.fields.bloodType': 'Groupe sanguin',
    'patient.fields.job': 'Profession',
    'patient.fields.insurance': 'Assurance',
    'patient.fields.height': 'Taille',
    'patient.fields.createdAt': "Date d\u2019enregistrement",
    'patient.history.conditions': 'Diagnostics',
    'patient.history.medications': "M\xe9dicaments",
    'patient.history.noConditions': "Aucun diagnostic enregistr\xe9.",
    'patient.history.noMedications': "Aucun m\xe9dicament enregistr\xe9.",
    'patient.history.prescribedOn': 'Prescrit le {{date}}',
    // ── prescription (نسخه) ──────────────────────────────────────────────────
    'prescription.title': 'Ordonnance',
    'prescription.subtitle': 'Pour {{name}}',
    'prescription.search.label': "Ajouter un m\xe9dicament",
    'prescription.search.placeholder': "Rechercher un m\xe9dicament\u2026",
    'prescription.search.searching': "Recherche\u2026",
    'prescription.search.empty': "Aucun m\xe9dicament ne correspond.",
    'prescription.search.hint': "Saisissez au moins deux caract\xe8res.",
    'prescription.search.results': "M\xe9dicaments trouv\xe9s\xa0: {{count}}.",
    'prescription.item.dose': 'Dose',
    'prescription.item.frequency': "Fr\xe9quence",
    'prescription.item.duration': "Dur\xe9e",
    'prescription.item.note': 'Note',
    'prescription.item.remove': 'Retirer {{name}}',
    'prescription.empty.title': "Aucun m\xe9dicament prescrit pour l\u2019instant",
    'prescription.empty.description': "Recherchez un m\xe9dicament ci-dessus pour ajouter le premier.",
    'prescription.save': "Enregistrer l\u2019ordonnance",
    'prescription.saveConfirm': 'Confirmer et enregistrer',
    'prescription.saving': "Enregistrement\u2026",
    'prescription.saved': "Ordonnance enregistr\xe9e.",
    'prescription.saveFailed': "L\u2019ordonnance n\u2019a pas pu \xeatre enregistr\xe9e.",
    'prescription.savePartial': "M\xe9dicaments enregistr\xe9s\xa0: {{saved}} sur {{total}}.",
    'prescription.allergies.title': "Allergies enregistr\xe9es",
    'prescription.interactions.title': "V\xe9rification des interactions",
    'prescription.interactions.checking': "V\xe9rification\u2026",
    'prescription.interactions.none': "Aucune interaction d\xe9tect\xe9e entre ces m\xe9dicaments.",
    'prescription.interactions.needsTwo': "Ajoutez un deuxi\xe8me m\xe9dicament pour lancer la v\xe9rification des interactions.",
    'prescription.interactions.unavailable': "La v\xe9rification des interactions est indisponible pour le moment. La prescription n\u2019est pas bloqu\xe9e.",
    'prescription.interactions.severity.high': "\xc9lev\xe9e",
    'prescription.interactions.severity.moderate': "Mod\xe9r\xe9e",
    'prescription.interactions.severity.low': 'Faible',
    'prescription.interactions.type.interaction': 'Interaction',
    'prescription.interactions.type.contraindication': 'Contre-indication',
    'prescription.interactions.type.allergy': 'Allergie',
    'prescription.interactions.type.black_box': 'Mise en garde majeure',
    'prescription.history.title': "Prescriptions ant\xe9rieures",
    'prescription.history.empty': "Aucune prescription ant\xe9rieure.",
    // ── profile ──────────────────────────────────────────────────────────────
    'profile.title': 'Profil',
    'profile.subtitle': "Votre identit\xe9, vos cliniques et vos plages horaires",
    'profile.sections.label': 'Sections du profil',
    'profile.sections.identity': "Identit\xe9",
    'profile.sections.clinics': 'Cliniques',
    'profile.sections.presence': 'Plages horaires',
    'profile.sections.appearance': 'Apparence et langue',
    'profile.fields.fullName': 'Nom complet',
    'profile.fields.medicalCode': "N\xb0 d\u2019inscription \xe0 l\u2019Ordre",
    'profile.fields.specialty': "Sp\xe9cialit\xe9",
    'profile.fields.bio': "\xc0 propos de vous",
    'profile.specialtyValue': 'Chirurgie dentaire',
    'profile.medicalCodeLocked': "Le n\xb0 d\u2019inscription \xe0 l\u2019Ordre a \xe9t\xe9 saisi lors de la cr\xe9ation du compte et ne peut pas \xeatre modifi\xe9. Contactez l\u2019assistance Parsina pour le faire corriger.",
    'profile.specialtyLocked': "Cet espace est destin\xe9 aux dentistes\xa0: la sp\xe9cialit\xe9 y est donc fixe. La modifier ailleurs fermera l\u2019acc\xe8s de votre compte \xe0 cet espace.",
    'profile.saved': "Profil enregistr\xe9.",
    'profile.noChanges': 'Aucune modification.',
    'profile.saveFailed': "Le profil n\u2019a pas pu \xeatre enregistr\xe9.",
    'profile.duplicateCode': "Ce n\xb0 d\u2019inscription \xe0 l\u2019Ordre est d\xe9j\xe0 associ\xe9 \xe0 un autre compte.",
    'profile.clinics.empty': "Vous n\u2019avez encore rejoint aucune clinique.",
    'profile.clinics.status.pending': "En attente d\u2019approbation",
    'profile.clinics.status.active': 'Actif',
    'profile.clinics.visitDuration': "Cr\xe9neau de {{count}}\xa0min",
    'profile.clinics.activeScope': 'Clinique active',
    'profile.clinics.activeScopeHint': "Les pages \xab\xa0Aujourd\u2019hui\xa0\xbb et \xab\xa0Patients\xa0\xbb affichent cette clinique.",
    'profile.clinics.joinTitle': 'Rejoindre une clinique',
    'profile.clinics.joinHint': "Demandez le code d\u2019invitation au responsable de la clinique.",
    'profile.clinics.joinPlaceholder': "Code d\u2019invitation",
    'profile.clinics.joined': 'Vous avez rejoint {{name}}.',
    'profile.clinics.notFound': "Aucune clinique ne correspond \xe0 ce code d\u2019invitation.",
    'profile.clinics.joinFailed': 'Impossible de rejoindre la clinique.',
    'profile.presence.empty': "La clinique n\u2019a pas encore d\xe9fini de plages horaires pour vous.",
    'profile.presence.oneOff': 'Ponctuelle',
    'profile.presence.inactive': "D\xe9sactiv\xe9e",
    'profile.presence.readOnly': "Les plages horaires sont d\xe9finies par la clinique\u202F; cet espace se contente de les afficher.",
    'profile.presence.days.0': 'Lundi',
    'profile.presence.days.1': 'Mardi',
    'profile.presence.days.2': 'Mercredi',
    'profile.presence.days.3': 'Jeudi',
    'profile.presence.days.4': 'Vendredi',
    'profile.presence.days.5': 'Samedi',
    'profile.presence.days.6': 'Dimanche',
    'profile.appearance.theme': "Couleur d\u2019accent",
    'profile.appearance.fontSize': 'Taille du texte',
    'profile.appearance.language': 'Langue',
    'profile.appearance.saved': "Pr\xe9f\xe9rence enregistr\xe9e.",
    'profile.appearance.failed': "La pr\xe9f\xe9rence n\u2019a pas \xe9t\xe9 enregistr\xe9e sur le serveur.",
    'profile.theme.default': 'Bleu Parsina',
    'profile.theme.teal': 'Turquoise',
    'profile.theme.ocean': 'Bleu profond',
    'profile.theme.slate': 'Gris bleu',
    'profile.fontSize.small': 'Petite',
    'profile.fontSize.medium': 'Moyenne',
    'profile.fontSize.large': 'Grande',
    'profile.language.fa': "\u0641\u0627\u0631\u0633\u06CC",
    'profile.language.en': 'English',
    'profile.language.fr': "Fran\xe7ais",
    'profile.language.de': 'Deutsch',
    // ── onboarding ───────────────────────────────────────────────────────────
    'onboarding.title': 'Module dentaire Parsina',
    'onboarding.subtitle.step1': "Inscrivez-vous une seule fois pour que votre compte puisse \xeatre identifi\xe9",
    'onboarding.subtitle.clinic': "Rattachez-vous \xe0 la clinique o\xf9 vous exercez",
    'onboarding.subtitle.done': "Tout est pr\xeat",
    'onboarding.progress.step1': 'Inscription',
    'onboarding.progress.clinic': 'Clinique',
    'onboarding.progress.done': "Termin\xe9",
    'onboarding.step1.fullName': 'Nom complet',
    'onboarding.step1.fullNamePlaceholder': 'Dr Maryam Ahmadi',
    'onboarding.step1.medicalCode': "N\xb0 d\u2019inscription \xe0 l\u2019Ordre",
    'onboarding.step1.medicalCodePlaceholder': "ex.\xa0: 123456",
    'onboarding.step1.specialty': "Sp\xe9cialit\xe9",
    'onboarding.step1.bio': "\xc0 propos de vous (facultatif)",
    'onboarding.step1.submit': 'Continuer',
    'onboarding.step1.specialtyNote': "Cet espace est le module dentaire\xa0: la sp\xe9cialit\xe9 est donc d\xe9finie pour vous.",
    'onboarding.clinic.choiceTitle': 'Votre cabinet ou votre clinique',
    'onboarding.clinic.choiceDescription': "Si vous avez votre propre cabinet, enregistrez-le ici. Si vous exercez dans une autre clinique, rejoignez-la avec un code d\u2019invitation.",
    'onboarding.clinic.ownTitle': 'Enregistrer mon propre cabinet',
    'onboarding.clinic.ownBody': "Pour un cabinet personnel. Vous en serez propri\xe9taire.",
    'onboarding.clinic.joinTitle': 'Rejoindre une clinique existante',
    'onboarding.clinic.joinBody': "Avec le code d\u2019invitation que la clinique vous a remis.",
    'onboarding.clinic.back': 'Retour',
    'onboarding.clinic.ownName': 'Nom du cabinet',
    'onboarding.clinic.ownNamePlaceholder': 'Cabinet dentaire du Dr Ahmadi',
    'onboarding.clinic.ownCity': 'Ville (facultatif)',
    'onboarding.clinic.ownAddress': 'Adresse (facultatif)',
    'onboarding.clinic.ownPhone': "T\xe9l\xe9phone du cabinet (facultatif)",
    'onboarding.clinic.create': 'Enregistrer le cabinet',
    'validation.clinicName': 'Saisissez le nom du cabinet.',
    'onboarding.clinic.alreadyExists': "Un cabinet est d\xe9j\xe0 enregistr\xe9 pour ce compte.",
    'onboarding.clinic.currency': 'Devise du cabinet',
    'onboarding.clinic.currencyHint': "Les tarifs et les plans de traitement sont enregistr\xe9s dans cette devise. Elle ne peut \xeatre modifi\xe9e dans l\u2019espace clinique que jusqu\u2019\xe0 l\u2019enregistrement du premier montant.",
    'onboarding.clinic.currencyIrr': 'Toman (IRR)',
    'onboarding.clinic.currencyMismatch': "Un cabinet est d\xe9j\xe0 enregistr\xe9 pour ce compte, en {{currency}}. Choisissez cette devise, ou modifiez-la dans l\u2019espace clinique.",
    'onboarding.clinic.setupIncomplete': "Le cabinet a \xe9t\xe9 cr\xe9\xe9, mais sa devise n\u2019a pas pu \xeatre d\xe9finie dans la comptabilit\xe9. Ne l\u2019enregistrez pas une deuxi\xe8me fois \u2014 contactez l\u2019assistance Parsina pour terminer la configuration.",
    'onboarding.clinic.title': 'Rejoindre votre clinique',
    'onboarding.clinic.description': "Avec le code d\u2019invitation de la clinique, vous acc\xe9dez \xe0 vos rendez-vous et au registre des patients de la clinique. Vous pourrez aussi le faire plus tard depuis votre profil.",
    'onboarding.clinic.placeholder': "Code d\u2019invitation",
    'onboarding.clinic.join': 'Rejoindre',
    'onboarding.clinic.skip': 'Plus tard',
    'onboarding.done.title': 'Bienvenue',
    'onboarding.done.body': "Votre espace dentaire est pr\xeat. La page \xab\xa0Aujourd\u2019hui\xa0\xbb affiche les rendez-vous que la clinique planifie pour vous.",
    'onboarding.done.enter': "Acc\xe9der \xe0 l\u2019espace",
    // ── validation ───────────────────────────────────────────────────────────
    'validation.medicalCode': "Saisissez votre n\xb0 d\u2019inscription \xe0 l\u2019Ordre.",
    'validation.fullName': 'Saisissez votre nom complet.',
    'validation.invitationCode': "Saisissez le code d\u2019invitation.",
    'validation.officePhone': "Le num\xe9ro de t\xe9l\xe9phone du cabinet est incomplet. Corrigez-le ou videz le champ.",
    'validation.phone.tooShort': "Ce num\xe9ro ({{country}}) est trop court \u2014 exemple\xa0: {{example}}",
    'validation.phone.tooLong': "Ce num\xe9ro ({{country}}) est trop long \u2014 exemple\xa0: {{example}}",
    'validation.phone.invalid': "Ce num\xe9ro n\u2019est pas valide.",
    // ── چارت دندان / odontogram ──────────────────────────────────────────────
    'patient.tabs.plan': 'Plan de traitement',
    'patient.plan.empty.title': "Aucun plan de traitement n\u2019a \xe9t\xe9 enregistr\xe9 pour ce patient",
    'patient.plan.empty.description': "Le plan de traitement est r\xe9dig\xe9 pendant une s\xe9ance.",
    'patient.plan.noLines': 'Ce cycle de soins ne comporte encore aucune ligne.',
    'patient.plan.doneTitle': "Soins r\xe9alis\xe9s",
    'patient.plan.outstanding': "Soins restant \xe0 r\xe9aliser\xa0: {{count}} \u2014 {{amount}} au total",
    'patient.tabs.chart': "Sch\xe9ma dentaire",
    'chart.tooth': 'Dent',
    'chart.universalShort': "N\xb0 US",
    'chart.annotation.planned': "soin pr\xe9vu",
    'chart.annotation.treated': "trait\xe9e",
    'chart.legend.planned': "Pr\xe9vu",
    'chart.legend.treated': "Trait\xe9",
    'chart.tooltip.treated': "Soins r\xe9alis\xe9s",
    'chart.tooltip.andMore': 'et {{count}} de plus',
    'chart.tooltip.planned': "Pr\xe9vu",
    'chart.wholeMouth.title': "Bouche enti\xe8re",
    'chart.history.title': 'Historique de la dent {{fdi}}',
    'chart.history.treatment': 'Soin',
    'chart.history.event': "Sch\xe9ma",
    'chart.history.causedBy': 'issu du soin ci-dessus',
    'chart.history.empty': "Rien n\u2019a encore \xe9t\xe9 enregistr\xe9 pour cette dent.",
    'chart.history.unavailable': "L\u2019historique de cette dent n\u2019a pas pu \xeatre lu.",
    'chart.history.session': "S\xe9ance {{n}}",
    'chart.history.voided': "Invalid\xe9 \u2014 {{reason}}",
    'chart.notCharted': "Non renseign\xe9e",
    'chart.patientRight': 'DROITE DU PATIENT',
    'chart.patientLeft': 'GAUCHE DU PATIENT',
    'chart.aria.odontogram': "Sch\xe9ma dentaire \u2014 cliquez sur une dent ou une face pour l\u2019enregistrer",
    'chart.hint': "Cliquez sur une face pour l\u2019enregistrer, ou sur la dent pour son \xe9tat global.",
    // ── chart, mobile ────────────────────────────────────────────────────────
    'chart.mobile.settings': "Param\xe8tres du sch\xe9ma",
    'chart.mobile.pickTooth': 'Choisir une dent',
    'chart.mobile.tapHint': "Touchez une dent sur le sch\xe9ma, ou choisissez-en une ci-dessous \u2014 les faces s\u2019enregistrent dans le panneau qui s\u2019ouvre.",
    'chart.mobile.legend': "L\xe9gende",
    'chart.legend.bridge': 'Bridge',
    'chart.legend.wholeToothCaries': 'Carie de toute la dent',
    'chart.export.button': "Exporter l\u2019image",
    'chart.export.error': "Impossible d\u2019exporter l\u2019image \u2014 ce navigateur ne le permet pas.",
    'chart.material': "Mat\xe9riau",
    'chart.isHistorical': "Soin ant\xe9rieur (non r\xe9alis\xe9 aujourd\u2019hui)",
    'chart.showPrimary': 'Afficher les dents temporaires',
    'chart.hidePrimary': 'Masquer les dents temporaires',
    'chart.showUniversal': "Afficher la num\xe9rotation am\xe9ricaine",
    'chart.hideUniversal': "Masquer la num\xe9rotation am\xe9ricaine",
    'chart.error.title': "Impossible de charger le sch\xe9ma",
    'chart.error.body': "Le sch\xe9ma dentaire n\u2019a pas pu \xeatre r\xe9cup\xe9r\xe9. Veuillez r\xe9essayer.",
    'chart.summary.charted': "Renseign\xe9es",
    'chart.summary.decayed': "Cari\xe9es",
    'chart.summary.restored': "Obtur\xe9es",
    'chart.summary.missing': 'Absentes',
    'chart.summary.dmft': 'Indice CAO',
    'chart.presence.title': "Pr\xe9sence",
    'chart.presence.present': "Pr\xe9sente",
    'chart.presence.extracted': 'Extraite',
    'chart.presence.exfoliated': "Exfoli\xe9e",
    'chart.presence.congenitally_absent': "Ag\xe9n\xe9sie",
    'chart.presence.unerupted': "Non \xe9rup\xe9e",
    'chart.presence.impacted': 'Incluse',
    'chart.surfaces.title': 'Faces',
    'chart.surfaces.hint': "Choisissez une face, puis son \xe9tat",
    'chart.surfaces.setFor': "\xc9tat pour",
    'chart.surface.M': "M\xe9siale",
    'chart.surface.D': 'Distale',
    'chart.surface.F': 'Vestibulaire',
    'chart.surface.L': 'Linguale / palatine',
    'chart.surface.O': 'Occlusale',
    'chart.surface.I': 'Bord incisif',
    'chart.surfaceState.sound': 'Saine',
    'chart.surfaceState.caries': "Cari\xe9e",
    'chart.surfaceState.restoration': "Obtur\xe9e",
    'chart.surfaceState.recurrent_caries': 'Carie secondaire',
    'chart.surfaceState.temporary': 'Obturation provisoire',
    'chart.surfaceState.sealant': 'Scellement de sillons',
    'chart.surfaceState.fractured': "Fractur\xe9e",
    'chart.condition.title': "Dent enti\xe8re",
    'chart.condition.hint': "Ind\xe9pendamment des faces ci-dessus",
    'chart.conditionName.sound': 'Saine',
    'chart.conditionName.caries': 'Carie',
    'chart.conditionName.root_canal': 'Traitement endodontique',
    'chart.conditionName.post_core': 'Reconstitution corono-radiculaire',
    'chart.conditionName.crown': 'Couronne',
    'chart.conditionName.veneer': 'Facette',
    'chart.conditionName.implant': 'Implant',
    'chart.conditionName.bridge_abutment': 'Pilier de bridge',
    'chart.conditionName.bridge_pontic': "Interm\xe9diaire de bridge",
    'chart.conditionName.fracture': 'Fracture',
    'chart.conditionName.attrition': 'Attrition',
    'chart.conditionName.mobility': "Mobilit\xe9",
    'chart.conditionName.periapical_lesion': "L\xe9sion p\xe9riapicale",
    'chart.conditionName.sealant': 'Scellement de sillons',
    'chart.conditionName.temporary': 'Provisoire',
    'chart.conditionName.watch': "\xc0 surveiller",
    'chart.note.title': 'Note',
    'chart.note.placeholder': "Tout ce qui m\xe9rite d\u2019\xeatre not\xe9 sur cette dent",
    'chart.materialName.composite': 'Composite',
    'chart.materialName.amalgam': 'Amalgame',
    'chart.materialName.glass_ionomer': "Verre ionom\xe8re (CVI)",
    'chart.materialName.zirconia': 'Zircone',
    'chart.materialName.pfm': "C\xe9ramo-m\xe9tallique (CCM)",
    'chart.materialName.full_metal': "Tout m\xe9tal",
    'chart.materialName.emax': 'E.max',
    'chart.materialName.temporary': 'Provisoire',
    'chart.materialName.gold': 'Or',
    // ── hover card ──────────────────────────────────────────────────────────
    'chart.primary': 'temporaire',
    'chart.tooltip.notCharted': "Rien n\u2019a encore \xe9t\xe9 enregistr\xe9 pour cette dent.",
    'chart.tooltip.sound': "Examin\xe9e \u2014 aucune anomalie",
    'chart.tooltip.lastRecorded': 'Dernier enregistrement',
    'chart.quadrant.upperRight': "Sup\xe9rieur droit (c\xf4t\xe9 patient)",
    'chart.quadrant.upperLeft': "Sup\xe9rieur gauche (c\xf4t\xe9 patient)",
    'chart.quadrant.lowerRight': "Inf\xe9rieur droit (c\xf4t\xe9 patient)",
    'chart.quadrant.lowerLeft': "Inf\xe9rieur gauche (c\xf4t\xe9 patient)",
    'chart.toothName.centralIncisor': 'Incisive centrale',
    'chart.toothName.lateralIncisor': "Incisive lat\xe9rale",
    'chart.toothName.canine': 'Canine',
    'chart.toothName.firstPremolar': "Premi\xe8re pr\xe9molaire",
    'chart.toothName.secondPremolar': "Deuxi\xe8me pr\xe9molaire",
    'chart.toothName.firstMolar': "Premi\xe8re molaire",
    'chart.toothName.secondMolar': "Deuxi\xe8me molaire",
    'chart.toothName.thirdMolar': "Troisi\xe8me molaire (dent de sagesse)",
    // ── جلسهٔ درمان — the visit workspace (docs/dent-visit.md) ────────────────
    'visit.error.title': "La s\xe9ance n\u2019a pas pu \xeatre ouverte",
    'visit.error.body': "Ce rendez-vous n\u2019a pas pu \xeatre lu. Veuillez r\xe9essayer.",
    'visit.notFound.title': "S\xe9ance introuvable",
    'visit.notFound.description': "Ce rendez-vous n\u2019existe pas, ne vous concerne pas ou n\u2019est rattach\xe9 \xe0 aucun dossier patient.",
    'visit.unknownPatient': 'Patient sans nom',
    'visit.openRecord': 'Dossier patient',
    'visit.finish.action': "Terminer la s\xe9ance",
    'visit.finish.working': "Cl\xf4ture\u2026",
    'visit.finish.confirm.title': "Cl\xf4turer cette s\xe9ance\u202F?",
    'visit.finish.confirm.body': "Les modifications non enregistr\xe9es sont enregistr\xe9es, puis la s\xe9ance est cl\xf4tur\xe9e. Elle passe ensuite en lecture seule et cette application ne peut pas la rouvrir.",
    'visit.finish.followUp.title': "Soins restant dans le plan de traitement\xa0: {{count}}",
    'visit.finish.followUp.andMore': 'et {{count}} de plus',
    'visit.finish.followUp.today': "Aujourd\u2019hui",
    'visit.finish.followUp.tomorrow': 'Demain',
    'visit.finish.followUp.withinWeek': 'Sous une semaine',
    'visit.finish.followUp.within2Weeks': 'Sous deux semaines',
    'visit.finish.followUp.withinMonth': 'Sous un mois',
    'visit.finish.followUp.within3Months': 'Sous trois mois',
    'visit.finish.followUp.when': "Dans quel d\xe9lai le prochain rendez-vous doit-il avoir lieu\u202F?",
    'visit.finish.followUp.none': "Pas n\xe9cessaire",
    'visit.finish.followUp.deskNote': "L\u2019accueil sera pr\xe9venu afin de planifier ce rendez-vous avec vous.",
    'visit.finish.followUp.noneNote': "L\u2019accueil ne sera pr\xe9venu de rien.",
    'visit.finish.done.plain': "La s\xe9ance est cl\xf4tur\xe9e.",
    'visit.finish.done.followUpRaised': "La s\xe9ance est cl\xf4tur\xe9e. L\u2019accueil a \xe9t\xe9 invit\xe9 \xe0 planifier la suivante.",
    'visit.finish.done.alreadyBooked': "La s\xe9ance est cl\xf4tur\xe9e. Ce patient a d\xe9j\xe0 un prochain rendez-vous.",
    'visit.finish.done.followUpFailed': "La s\xe9ance est cl\xf4tur\xe9e, mais l\u2019accueil n\u2019a pas \xe9t\xe9 pr\xe9venu du prochain rendez-vous.",
    'visit.finish.error.subjective': "La note de s\xe9ance n\u2019a pas \xe9t\xe9 enregistr\xe9e, la s\xe9ance n\u2019a donc pas \xe9t\xe9 cl\xf4tur\xe9e. R\xe9essayez.",
    'visit.finish.error.complete': "La note de s\xe9ance a \xe9t\xe9 enregistr\xe9e, mais la s\xe9ance n\u2019a pas pu \xeatre cl\xf4tur\xe9e. R\xe9essayez.",
    // ── The video visit ──────────────────────────────────────────────────────
    'visit.call.start': "Appel vid\xe9o",
    'visit.call.title': "Appel vid\xe9o",
    'visit.call.panelLabel': "Panneau d\u2019appel vid\xe9o",
    'visit.call.connecting': "Connexion\u2026",
    'visit.call.hangUp': 'Raccrocher',
    'visit.call.notRecorded': "Cet appel n\u2019est pas enregistr\xe9 et rien n\u2019en est conserv\xe9.",
    'visit.call.error.connection': "L\u2019appel n\u2019a pas pu \xeatre \xe9tabli. V\xe9rifiez la connexion et r\xe9essayez.",
    'visit.call.error.unavailable': "Les t\xe9l\xe9consultations ne sont pas activ\xe9es dans cet environnement.",
    'visit.call.error.visitOver': "Cette s\xe9ance est cl\xf4tur\xe9e\xa0: aucun appel vid\xe9o ne peut y \xeatre pass\xe9.",
    'visit.readOnly.badge': 'Lecture seule',
    'visit.readOnly.note': "Cette s\xe9ance est cl\xf4tur\xe9e\xa0: plus rien ne peut y \xeatre enregistr\xe9. Tout ce qui est d\xe9j\xe0 enregistr\xe9 reste affich\xe9.",
    'visit.ai.costsCredits': "Utilise du cr\xe9dit IA.",
    'visit.tabs.meds': "M\xe9dicaments",
    'visit.tabs.orders': 'Demandes',
    'visit.tabs.diagnosis': 'Diagnostic',
    'visit.tabs.questions': 'Questions',
    'visit.tabs.files': 'Fichiers',
    'visit.tabs.sectionsLabel': "Sections de la s\xe9ance",
    // ── §3.1.1 odontogram ───────────────────────────────────────────────────
    'visit.chart.title': "Sch\xe9ma dentaire",
    'visit.chart.hint': "S\xe9lectionnez une dent pour voir ses constatations et ce qui y est pr\xe9vu.",
    'visit.chart.tooth': 'Dent {{fdi}}',
    'visit.chart.openTooth': 'Constatations',
    'visit.chart.planForTooth': 'Ajouter au plan',
    'visit.chart.noPlanForTooth': "Rien n\u2019est pr\xe9vu sur cette dent.",
    'visit.chart.history': 'Historique',
    'visit.chart.noHistory': "Rien n\u2019a \xe9t\xe9 enregistr\xe9 pour cette dent.",
    'visit.chart.historyUnavailable': "L\u2019historique n\u2019a pas pu \xeatre charg\xe9.",
    'visit.chart.historical': "ant\xe9rieur",
    // ── §3.1.2 subjective ───────────────────────────────────────────────────
    'visit.subjective.title': "Anamn\xe8se",
    'visit.subjective.error.title': "Impossible de charger la note de s\xe9ance",
    'visit.subjective.error.body': "La note de cette s\xe9ance n\u2019a pas pu \xeatre lue. Veuillez r\xe9essayer.",
    'visit.subjective.saved': "Enregistr\xe9",
    'visit.subjective.saveFailed': "La note de s\xe9ance n\u2019a pas pu \xeatre enregistr\xe9e. Veuillez r\xe9essayer.",
    'visit.subjective.history': "Ant\xe9c\xe9dents du patient",
    'visit.subjective.noAllergies': "Aucune allergie enregistr\xe9e",
    'visit.subjective.conditions': 'Pathologies',
    'visit.subjective.medications': "M\xe9dicaments",
    'visit.subjective.chiefComplaint': 'Motif de consultation',
    'visit.subjective.dictateComplaint': 'Dicter le motif de consultation',
    'visit.subjective.dictateNotes': 'Dicter la note',
    'visit.subjective.teeth': "Dents concern\xe9es",
    'visit.subjective.noTeeth': "Touchez les dents sur le sch\xe9ma ci-dessus",
    'visit.subjective.addTooth': 'Ajouter la dent {{fdi}}',
    'visit.subjective.selectToothFirst': "S\xe9lectionnez une dent sur le sch\xe9ma",
    'visit.subjective.painScore': "Douleur (0\u201310)",
    'visit.subjective.painCharacter': 'Type de douleur',
    'visit.subjective.pain.sharp': 'Vive',
    'visit.subjective.pain.dull': 'Sourde',
    'visit.subjective.pain.throbbing': 'Pulsatile',
    'visit.subjective.pain.sensitivity': "Sensibilit\xe9",
    'visit.subjective.pain.none': 'Aucune douleur',
    'visit.subjective.onset': "D\xe9but",
    'visit.subjective.duration': "Dur\xe9e",
    'visit.subjective.aggravating': "Aggrav\xe9e par",
    'visit.subjective.relieving': "Soulag\xe9e par",
    'visit.subjective.dentalHistory': "Ant\xe9c\xe9dents dentaires",
    'visit.subjective.notes': 'Notes',
    'visit.subjective.priorVisits': "S\xe9ances pr\xe9c\xe9dentes",
    'visit.subjective.noPriorVisits': "Aucune s\xe9ance pr\xe9c\xe9dente enregistr\xe9e.",
    'visit.subjective.priorNoSummary': "Aucun motif enregistr\xe9",
    'visit.subjective.priorDiagnoses': "Diagnostics\xa0: {{count}}",
    // ── §3.1.3 treatment plan ───────────────────────────────────────────────
    'visit.plan.title': 'Plan de traitement',
    'visit.plan.error.title': 'Impossible de charger le plan',
    'visit.plan.error.body': "Le plan de traitement de ce patient n\u2019a pas pu \xeatre lu. Veuillez r\xe9essayer.",
    'visit.plan.error.currencyUnavailable': "La devise du cabinet n\u2019a pas pu \xeatre lue\u202F; sans elle, les montants du plan ne peuvent pas \xeatre affich\xe9s. Veuillez r\xe9essayer.",
    'visit.plan.error.currencyMismatch': "Ces montants ne sont pas dans la devise du cabinet, et des montants en devises diff\xe9rentes ne sont jamais additionn\xe9s. Demandez au responsable du cabinet de v\xe9rifier la devise du cabinet.",
    'visit.plan.saveFailed': "Le plan n\u2019a pas pu \xeatre enregistr\xe9.",
    'visit.plan.empty.title': "Aucun plan pour l\u2019instant",
    'visit.plan.empty.description': "Ajoutez les soins que vous pr\xe9voyez de r\xe9aliser, dent par dent.",
    'visit.plan.add': 'Ajouter un soin',
    'visit.plan.added': "Soin \xab\xa0{{what}}\xa0\xbb ajout\xe9 au plan de traitement.",
    'visit.plan.addedForTooth': "Soin \xab\xa0{{what}}\xa0\xbb ajout\xe9 au plan de traitement pour la dent {{fdi}}.",
    'visit.chart.planFormOpened': "Formulaire d\u2019ajout ouvert pour la dent {{fdi}} \u2014 choisissez le soin.",
    'visit.plan.addItem': 'Ajouter au plan',
    'visit.plan.service': 'Soin',
    'visit.plan.choose': "Choisir un soin\u2026",
    'visit.plan.tooth': 'Dent',
    'visit.plan.wholeMouth': "Bouche enti\xe8re",
    'visit.plan.wholeMouthShort': 'Bouche',
    'visit.plan.phase': 'Phase',
    'visit.plan.description': 'Description',
    'visit.plan.untitledItem': 'Soin sans titre',
    'visit.plan.changeStatus': 'Modifier le statut de {{item}}',
    'visit.plan.remove': 'Retirer {{item}}',
    'visit.plan.showOnChart': "Afficher sur le sch\xe9ma",
    'visit.plan.surfaces': 'Faces',
    'visit.plan.sessions': "S\xe9ances",
    'visit.plan.sessionsOf': "S\xe9ance {{done}} sur {{total}}",
    'visit.plan.toman': '{{amount}} {{unit}}',
    'visit.plan.noTariff': "Aucun tarif d\xe9fini",
    'visit.plan.outstanding': "Reste \xe0 r\xe9aliser\xa0: {{amount}}",
    'visit.plan.otherCurrency': 'Tarif dans une autre devise ({{currency}})',
    'visit.plan.otherCurrencyRefused': "Le tarif de \xab\xa0{{name}}\xa0\xbb est en {{currency}}\xa0: il ne peut pas \xeatre ajout\xe9 \xe0 un plan en {{planCurrency}}.",
    'visit.record.openVisit': "Ouvrir la s\xe9ance",
    'visit.record.open': "Enregistrer comme r\xe9alis\xe9",
    'visit.record.openSession': "Enregistrer la s\xe9ance",
    'visit.record.title': "Enregistrer comme r\xe9alis\xe9 \u2014 {{treatment}}",
    'visit.record.subtitle': "Enregistre ce qui a \xe9t\xe9 fait pendant cette s\xe9ance. C\u2019est le dossier clinique.",
    'visit.record.service': "Soin r\xe9alis\xe9",
    'visit.record.tooth': 'Dent',
    'visit.record.surfaces': 'Faces',
    'visit.record.material': "Mat\xe9riau",
    'visit.record.noMaterial': "Aucun mat\xe9riau",
    'visit.record.note': "Ce qui a \xe9t\xe9 fait",
    'visit.record.notePlaceholder': "En bref, ce qui a \xe9t\xe9 fait",
    'visit.record.outcome': "R\xe9sultat",
    'visit.record.outcome.completed': "Termin\xe9",
    'visit.record.outcome.inProgress': "Se poursuit \xe0 la prochaine s\xe9ance",
    'visit.record.chartEffect': "\xc9tat de la dent apr\xe8s le soin",
    'visit.record.chartEffect.none': "Ne pas modifier le sch\xe9ma",
    'visit.record.chartEffect.noneDetail': "Rien ne sera inscrit sur le sch\xe9ma dentaire.",
    'visit.record.chartEffect.detail': "La dent {{tooth}} sera enregistr\xe9e sur le sch\xe9ma comme \xab\xa0{{state}}\xa0\xbb.",
    'visit.record.chartEffect.detailSurfaces': "Les faces {{surfaces}} de la dent {{tooth}} seront enregistr\xe9es sur le sch\xe9ma comme \xab\xa0{{state}}\xa0\xbb.",
    'visit.record.chartEffect.needsSurfaces': "Choisissez les faces trait\xe9es, sinon rien ne sera inscrit sur le sch\xe9ma.",
    'visit.record.chartEffect.surfaceOption': "Faces \u2014 {{state}}",
    'visit.record.chartEffect.inProgress': "Cette s\xe9ance ne termine pas le soin\xa0: par d\xe9faut, rien n\u2019est inscrit sur le sch\xe9ma.",
    'visit.record.billingNote': "La facturation et le stock sont enregistr\xe9s s\xe9par\xe9ment, apr\xe8s cet enregistrement\u202F; ce formulaire n\u2019enregistre aucun montant.",
    'visit.record.save': 'Enregistrer',
    'visit.record.saved': "Soin \xab\xa0{{what}}\xa0\xbb enregistr\xe9.",
    'visit.record.failed': "Le soin n\u2019a pas pu \xeatre enregistr\xe9.",
    'visit.record.doneHere': "R\xe9alis\xe9s pendant cette s\xe9ance ({{count}})",
    'visit.record.void': 'Invalider',
    'visit.record.voidReason': "Motif d\u2019invalidation",
    'visit.record.voidedFor': "Invalid\xe9 \u2014 {{reason}}",
    'visit.record.voidConfirm.title': "Invalider \xab\xa0{{what}}\xa0\xbb\u202F?",
    'visit.record.voidConfirm.body': "La ligne n\u2019est pas supprim\xe9e\xa0: elle reste dans le dossier, barr\xe9e, avec le motif que vous indiquez. Le motif est obligatoire.",
    'visit.record.notBilled': "Non factur\xe9",
    'visit.record.voidConfirm.alsoChart': "Invalider aussi ce qui a \xe9t\xe9 inscrit pour la dent {{tooth}} sur le sch\xe9ma",
    'visit.record.voidConfirm.stillBilled': "Ce soin figure d\xe9j\xe0 sur la facture du patient. L\u2019invalider retire automatiquement le montant \u2014 sous forme de ligne d\u2019avoir si la facture a \xe9t\xe9 \xe9mise.",
    'visit.record.voidCharge.notReversed': "Le soin a \xe9t\xe9 invalid\xe9, mais son montant n\u2019a pas pu \xeatre retir\xe9 de la facture. Demandez \xe0 la caisse de la corriger.",
    'visit.record.billed': "Ajout\xe9 \xe0 la facture de cette s\xe9ance.",
    'visit.plan.noServices.title': "Cette clinique n\u2019a encore d\xe9fini aucune prestation",
    'visit.plan.noServices.body': "Les lignes du plan de traitement proviennent des prestations de la clinique. D\xe9finissez les prestations dentaires et leurs tarifs dans l\u2019espace clinique.",
    'visit.plan.noServices.action': "D\xe9finir les prestations dans l\u2019espace clinique",
    'visit.plan.catalogUnavailable': "La liste des prestations de la clinique n\u2019a pas pu \xeatre lue. Cela ne veut pas dire qu\u2019il n\u2019y en a aucune \u2014 r\xe9essayez.",
    'visit.plan.applicability.unset': "Non pr\xe9cis\xe9",
    'visit.plan.applicability.tooth': 'Une dent',
    'visit.plan.applicability.surfaces': "Faces d\u2019une dent",
    'visit.plan.applicability.quadrant': 'Un quadrant',
    'visit.plan.applicability.arch': 'Une arcade',
    'visit.plan.applicability.mouth': "Bouche enti\xe8re",
    'visit.plan.newService.title': 'Nouvelle prestation',
    'visit.plan.newService.subtitle': "Ajout\xe9e aux prestations de la clinique et propos\xe9e d\xe8s lors \xe0 tous vos coll\xe8gues.",
    'visit.plan.newService.name': 'Nom de la prestation',
    'visit.plan.newService.category': 'Groupe',
    'visit.plan.newService.chartEffect': "Effet sur le sch\xe9ma",
    'visit.plan.newService.applicability': "S\u2019applique \xe0",
    'visit.plan.newService.tariff': "Tarif par s\xe9ance ({{unit}})",
    'visit.plan.newService.duration': "Minutes par s\xe9ance",
    'visit.plan.newService.tariffHint': "Le tarif peut rester vide\xa0: la prestation est enregistr\xe9e sans tarif et n\u2019est pas factur\xe9e tant qu\u2019aucun tarif n\u2019est d\xe9fini.",
    'visit.plan.newService.clinicOnly.title': "\xc0 compl\xe9ter dans l\u2019espace clinique",
    'visit.plan.newService.clinicOnly.body': "Consommables, autres co\xfbts, commission et assurance.",
    'visit.plan.newService.save': "Enregistrer et s\xe9lectionner",
    'visit.plan.newService.created': "La prestation \xab\xa0{{name}}\xa0\xbb a \xe9t\xe9 ajout\xe9e aux prestations de la clinique.",
    'visit.plan.newService.nameRequired': 'Le nom de la prestation est obligatoire.',
    'visit.plan.newService.failed': "La prestation n\u2019a pas pu \xeatre enregistr\xe9e.",
    'visit.plan.newService.badTariff': "Le tarif doit \xeatre un nombre, en {{unit}}.",
    'visit.plan.newService.currencyUnknown': "La devise de ce cabinet n\u2019a pas pu \xeatre lue\xa0: le tarif ne peut donc pas \xeatre saisi ici. La prestation est enregistr\xe9e sans tarif\u202F; d\xe9finissez-le dans l\u2019espace clinique.",
    'visit.plan.noClinic': "Cette s\xe9ance n\u2019est rattach\xe9e \xe0 aucune clinique\u202F; sans clinique, les prestations et les tarifs ne peuvent pas \xeatre lus.",
    'common.form.optional': '(facultatif)',
    'visit.plan.locked': "Sign\xe9",
    'visit.plan.startNew': 'Commencer un nouveau cycle',
    'visit.plan.lockedNextStep': 'Ajouter un soin ouvre un nouveau cycle de traitement.',
    'visit.plan.lockedNote': "Ce plan a \xe9t\xe9 approuv\xe9 et sign\xe9\xa0: ses lignes ne peuvent plus \xeatre modifi\xe9es. Les soins peuvent toujours \xeatre marqu\xe9s comme r\xe9alis\xe9s.",
    'visit.plan.phases.emergency': 'Urgence',
    'visit.plan.phases.phase1': 'Phase 1',
    'visit.plan.phases.phase2': 'Phase 2',
    'visit.plan.phases.maintenance': 'Maintenance',
    'visit.plan.status.proposed': "Propos\xe9",
    'visit.plan.status.accepted': "Accept\xe9",
    'visit.plan.status.done': "R\xe9alis\xe9",
    'visit.plan.status.rejected': "Refus\xe9",
    'visit.plan.status.deferred': "Report\xe9",
    'visit.plan.planStatus.draft': 'Brouillon',
    'visit.plan.planStatus.proposed': "Propos\xe9",
    'visit.plan.planStatus.approved': "Approuv\xe9",
    'visit.plan.planStatus.in_progress': 'En cours',
    'visit.plan.planStatus.completed': "Termin\xe9",
    'visit.plan.planStatus.abandoned': "Abandonn\xe9",
    // ── §3.2.1 medication ───────────────────────────────────────────────────
    'visit.meds.empty.title': "Aucune prescription pour l\u2019instant",
    'visit.meds.empty.description': "Recherchez dans le r\xe9f\xe9rentiel ci-dessus pour ajouter un m\xe9dicament \xe0 cette s\xe9ance.",
    'visit.meds.thisVisit': "Prescrit pendant cette s\xe9ance",
    'visit.meds.current': 'Traitement en cours',
    'visit.meds.suggest': "Suggestions de l\u2019IA",
    'visit.meds.suggesting': "Analyse en cours\u2026",
    'visit.meds.suggestions': "M\xe9dicaments sugg\xe9r\xe9s",
    'visit.meds.suggestClose': 'Ignorer les suggestions',
    'visit.meds.suggestAdd': "Ajouter \xe0 l\u2019ordonnance",
    'visit.meds.suggestAdded': "Ajout\xe9",
    'visit.meds.noSuggestions': "Aucune suggestion. Enregistrez d\u2019abord le diagnostic ou l\u2019\xe9valuation de cette s\xe9ance \u2014 l\u2019analyse s\u2019appuie sur ce qui a \xe9t\xe9 r\xe9dig\xe9 pour cette s\xe9ance.",
    'visit.meds.suggestUnavailable': "Les suggestions de l\u2019IA sont indisponibles.",
    'visit.meds.followUp': "Suivi\xa0:",
    // ── §3.2.2 orders — dental lab and imaging only ─────────────────────────
    'visit.orders.error.title': 'Impossible de charger les demandes',
    'visit.orders.error.body': "Les demandes de cette s\xe9ance n\u2019ont pas pu \xeatre lues. Veuillez r\xe9essayer.",
    'visit.orders.saveFailed': "La demande n\u2019a pas pu \xeatre enregistr\xe9e.",
    'visit.orders.empty.title': "Aucune demande pendant cette s\xe9ance",
    'visit.orders.empty.description': "Demandez une radiographie ou envoyez un cas au laboratoire de proth\xe8se.",
    'visit.orders.type': 'Type de demande',
    'visit.orders.types.imaging': 'Imagerie',
    'visit.orders.types.lab': 'Biologie',
    'visit.orders.types.dental_lab': "Laboratoire de proth\xe8se",
    'visit.orders.service': 'Prestation',
    'visit.orders.serviceScope': "Prestations \xab\xa0{{type}}\xa0\xbb uniquement",
    'visit.orders.choose': "Choisir une prestation\u2026",
    'visit.orders.description': 'Description',
    'visit.orders.descriptionHint': 'Laisser vide pour utiliser le nom de la prestation',
    'visit.orders.notes': "Notes pour le laboratoire de proth\xe8se / la radiologie",
    'visit.orders.urgency': "Priorit\xe9",
    'visit.orders.urgencies.routine': 'Normal',
    'visit.orders.urgencies.urgent': 'Urgent',
    'visit.orders.urgencies.stat': "Tr\xe8s urgent",
    'visit.orders.sessions': "S\xe9ances",
    'visit.orders.sessionCount': "S\xe9ances\xa0: {{count}}",
    'visit.orders.add': 'Envoyer la demande',
    'visit.orders.statuses.pending': 'En attente',
    'visit.orders.statuses.in_progress': 'En cours',
    'visit.orders.statuses.completed': "Termin\xe9e",
    'visit.orders.statuses.cancelled': "Annul\xe9e",
    'visit.orders.transitions.start': "D\xe9marrer",
    'visit.orders.transitions.complete': "Marquer comme termin\xe9e",
    'visit.orders.transitions.cancel': 'Annuler',
    'visit.orders.suggest': "Suggestions de l\u2019IA",
    'visit.orders.suggesting': "Analyse en cours\u2026",
    'visit.orders.suggestions': "Demandes sugg\xe9r\xe9es",
    'visit.orders.suggestClose': 'Ignorer les suggestions',
    'visit.orders.suggestAdd': 'Envoyer la demande',
    'visit.orders.suggestAdded': "Envoy\xe9e",
    'visit.orders.noSuggestions': "Aucune suggestion. Enregistrez d\u2019abord le diagnostic ou l\u2019\xe9valuation de cette s\xe9ance \u2014 l\u2019analyse s\u2019appuie sur ce qui a \xe9t\xe9 r\xe9dig\xe9 pour cette s\xe9ance.",
    'visit.orders.suggestUnavailable': "Les suggestions de l\u2019IA sont indisponibles.",
    'visit.orders.suggestDropped': "Suggestions hors du catalogue dentaire, non affich\xe9es\xa0: {{count}}",
    // ── §3.2.3 diagnosis, with click-to-reveal traceability ─────────────────
    'visit.diagnosis.error.title': 'Impossible de charger les diagnostics',
    'visit.diagnosis.error.body': "Les diagnostics de cette s\xe9ance n\u2019ont pas pu \xeatre lus. Veuillez r\xe9essayer.",
    'visit.diagnosis.saveFailed': "Le diagnostic n\u2019a pas pu \xeatre enregistr\xe9.",
    'visit.diagnosis.empty.title': "Aucun diagnostic enregistr\xe9",
    'visit.diagnosis.empty.description': "Enregistrez votre conclusion\xa0: les constatations sur lesquelles elle repose sont conserv\xe9es avec elle.",
    'visit.diagnosis.name': 'Diagnostic',
    'visit.diagnosis.code': 'Code CIM',
    'visit.diagnosis.certainty': 'Certitude',
    'visit.diagnosis.verification.provisional': 'Provisoire',
    'visit.diagnosis.verification.confirmed': "Confirm\xe9",
    'visit.diagnosis.add': 'Enregistrer le diagnostic',
    'visit.diagnosis.remove': 'Retirer {{name}}',
    'visit.diagnosis.willAttach': "\xc9l\xe9ments \xe0 l\u2019appui qui seront enregistr\xe9s avec ce diagnostic\xa0: {{count}}.",
    'visit.diagnosis.evidence': "\xc9l\xe9ments ({{count}})",
    'visit.diagnosis.noEvidence': "Aucun \xe9l\xe9ment \xe0 l\u2019appui n\u2019a \xe9t\xe9 enregistr\xe9 avec ce diagnostic.",
    'visit.diagnosis.evidenceKind.subjective': "Anamn\xe8se",
    'visit.diagnosis.evidenceKind.history': "Ant\xe9c\xe9dents",
    'visit.diagnosis.evidenceKind.chart': "Sch\xe9ma",
    'visit.diagnosis.evidenceKind.file': 'Document',
    'visit.diagnosis.evidenceKind.order': 'Demande',
    'visit.diagnosis.evidenceKind.ai': "Analyse de l\u2019IA",
    'visit.diagnosis.showTooth': 'Afficher la dent',
    'visit.diagnosis.toothEvidence': 'Constatations sur la dent {{fdi}}',
    'visit.diagnosis.aiAssisted': "Avec l\u2019aide de l\u2019IA",
    'visit.diagnosis.suggest': "Suggestions de l\u2019IA",
    'visit.diagnosis.suggesting': "Analyse en cours\u2026",
    'visit.diagnosis.suggestions': "Diagnostics sugg\xe9r\xe9s",
    'visit.diagnosis.noSuggestions': "Aucune suggestion. Enregistrez d\u2019abord l\u2019anamn\xe8se \u2014 l\u2019analyse s\u2019appuie sur ce qui a \xe9t\xe9 r\xe9dig\xe9 pour cette s\xe9ance.",
    'visit.diagnosis.suggestUnavailable': "Les suggestions de l\u2019IA sont indisponibles pour le moment.",
    'visit.diagnosis.accept': 'Enregistrer',
    'visit.diagnosis.alreadyRecorded': "Enregistr\xe9",
    'visit.diagnosis.confidence.high': "Confiance \xe9lev\xe9e",
    'visit.diagnosis.confidence.medium': 'Confiance moyenne',
    'visit.diagnosis.confidence.low': 'Confiance faible',
    // ── SOAP assistant — the diagnosis tab ──────────────────────────────────
    'visit.soap.title': "Assistant de r\xe9daction",
    'visit.soap.description': "Dites ce qui s\u2019est pass\xe9 pendant la s\xe9ance\u202F; quand vous arr\xeatez, l\u2019assistant compl\xe8te les sections de la note de s\xe9ance et donne des conseils sur le probl\xe8me. Rien n\u2019est enregistr\xe9 sans votre approbation.",
    'visit.soap.speak': "Dicter la s\xe9ance",
    'visit.soap.speakStop': 'Terminer et obtenir des conseils',
    'visit.soap.analyzing': "Analyse en cours\u2026",
    'visit.soap.heard': "Ce qui a \xe9t\xe9 entendu\xa0:",
    'visit.soap.retry': 'Renvoyer',
    'visit.soap.voiceUnavailable': "La dict\xe9e n\xe9cessite un micro et une connexion s\xe9curis\xe9e (HTTPS), et n\u2019est pas disponible dans ce navigateur.",
    'visit.soap.draftTitle': "Proposition de note de s\xe9ance",
    'visit.soap.sections.s': "Anamn\xe8se (S) \u2014 ajout\xe9e aux notes",
    'visit.soap.sections.o': 'Examen clinique et constatations (O)',
    'visit.soap.sections.a': "\xc9valuation (A)",
    'visit.soap.sections.p': 'Plan de traitement (P)',
    'visit.soap.apply': "Appliquer \xe0 la note de s\xe9ance",
    'visit.soap.applied': "Inscrit dans la note de s\xe9ance.",
    'visit.soap.applyFailed': "La proposition n\u2019a pas pu \xeatre appliqu\xe9e.",
    'visit.soap.dismiss': 'Ignorer',
    'visit.soap.noNews': "Rien de nouveau \xe0 ajouter \xe0 la note de s\xe9ance.",
    'visit.soap.refineUnavailable': "La compl\xe9tion de la note de s\xe9ance est indisponible.",
    'visit.soap.adviceTitle': "Conseils de l\u2019assistant",
    'visit.soap.adviceUnavailable': "Les conseils de l\u2019IA sont indisponibles.",
    'visit.soap.suggestedDiagnosis': "Diagnostic sugg\xe9r\xe9",
    'visit.soap.recordDiagnosis': 'Enregistrer comme diagnostic',
    'visit.soap.accepted': "Accept\xe9 \u2014 enregistr\xe9 dans les diagnostics de cette s\xe9ance.",
    'visit.soap.actions': "Actions sugg\xe9r\xe9es",
    'visit.soap.medications': "M\xe9dicaments sugg\xe9r\xe9s",
    'visit.soap.aiEvidence': "Issu de l\u2019analyse du r\xe9cit de la s\xe9ance",
    // ── Per-tooth findings from the narrative → the dental chart ──────────────
    'visit.soap.teeth.title': 'Constatations dentaires',
    'visit.soap.teeth.description': "Ces \xe9l\xe9ments ont \xe9t\xe9 rep\xe9r\xe9s dans le r\xe9cit de la s\xe9ance comme concernant des dents pr\xe9cises. Ceux que vous confirmez sont enregistr\xe9s sur le sch\xe9ma dentaire\u202F; les autres ne le sont pas.",
    'visit.soap.teeth.lowConfidenceHint': "Les lignes \xe0 faible confiance ne sont pas coch\xe9es \u2014 v\xe9rifiez le num\xe9ro de la dent avant de l\u2019enregistrer.",
    'visit.soap.teeth.tooth': 'Dent {{fdi}}',
    'visit.soap.teeth.surface': 'Face {{surface}}',
    'visit.soap.teeth.historical': "Ant\xe9c\xe9dent",
    'visit.soap.teeth.record': "Enregistrer sur le sch\xe9ma ({{count}})",
    'visit.soap.teeth.recording': "Enregistrement\u2026",
    'visit.soap.teeth.recorded': "Enregistr\xe9 sur le sch\xe9ma dentaire.",
    'visit.soap.teeth.recordFailed': "Impossible d\u2019enregistrer sur le sch\xe9ma dentaire.",
    'visit.soap.teeth.none': "Aucune constatation dentaire pr\xe9cise n\u2019a \xe9t\xe9 trouv\xe9e dans le r\xe9cit.",
    'visit.soap.teeth.unavailable': 'La lecture des constatations dentaires est indisponible.',
    'visit.soap.teeth.confidence.high': "Confiance \xe9lev\xe9e",
    'visit.soap.teeth.confidence.medium': 'Confiance moyenne',
    'visit.soap.teeth.confidence.low': 'Confiance faible',
    'tooth.aspect.presence': "Pr\xe9sence de la dent",
    'tooth.aspect.condition': "\xc9tat de la dent",
    'tooth.aspect.surface': "\xc9tat de la face",
    'tooth.value.sound': 'Saine',
    'tooth.value.caries': 'Carie',
    'tooth.value.root_canal': 'Traitement endodontique',
    'tooth.value.post_core': 'Reconstitution corono-radiculaire',
    'tooth.value.crown': 'Couronne',
    'tooth.value.veneer': 'Facette',
    'tooth.value.implant': 'Implant',
    'tooth.value.bridge_abutment': 'Pilier de bridge',
    'tooth.value.bridge_pontic': "Interm\xe9diaire de bridge",
    'tooth.value.fracture': 'Fracture',
    'tooth.value.attrition': 'Attrition',
    'tooth.value.mobility': "Mobilit\xe9",
    'tooth.value.periapical_lesion': "L\xe9sion p\xe9riapicale",
    'tooth.value.sealant': 'Scellement de sillons',
    'tooth.value.temporary': 'Provisoire',
    'tooth.value.watch': "\xc0 surveiller",
    'tooth.value.restoration': 'Obturation',
    'tooth.value.recurrent_caries': 'Carie secondaire',
    'tooth.value.fractured': "Fractur\xe9e",
    'tooth.value.present': "Pr\xe9sente",
    'tooth.value.extracted': 'Extraite',
    'tooth.value.exfoliated': "Exfoli\xe9e",
    'tooth.value.congenitally_absent': "Ag\xe9n\xe9sie",
    'tooth.value.unerupted': "Non \xe9rup\xe9e",
    'tooth.value.impacted': 'Incluse',
    'tooth.material.composite': 'Composite',
    'tooth.material.amalgam': 'Amalgame',
    'tooth.material.glass_ionomer': "Verre ionom\xe8re (CVI)",
    'tooth.material.zirconia': 'Zircone',
    'tooth.material.pfm': 'CCM',
    'tooth.material.full_metal': "Tout m\xe9tal",
    'tooth.material.emax': 'E.max',
    'tooth.material.temporary': 'Provisoire',
    'tooth.material.gold': 'Or',
    // ── §3.2.4 questions — the clinical assistant ───────────────────────────
    'visit.questions.title': 'Assistant clinique',
    'visit.questions.forDiagnoses': "Questions qui permettraient de confirmer ou d\u2019\xe9carter\xa0: {{list}}",
    'visit.questions.noDiagnosesYet': "Aucun diagnostic enregistr\xe9 pour l\u2019instant \u2014 l\u2019assistant posera des questions sur le motif que vous avez r\xe9dig\xe9.",
    'visit.questions.generate': "Rep\xe9rer les points \xe0 \xe9claircir",
    'visit.questions.generating': "R\xe9flexion\u2026",
    'visit.questions.unavailable': "L\u2019assistant clinique est indisponible pour le moment.",
    'visit.questions.fallbackNote': "Ce sont des questions g\xe9n\xe9rales, et non des questions r\xe9dig\xe9es pour ce patient.",
    'visit.questions.empty.title': 'Aucune question en suspens',
    'visit.questions.empty.description': "Rien de plus n\u2019est n\xe9cessaire pour \xe9tayer les diagnostics actuels.",
    'visit.questions.count': "Questions\xa0: {{count}}",
    'visit.questions.yes': 'Oui',
    'visit.questions.no': 'Non',
    'visit.questions.recorded': "Enregistr\xe9\xa0: {{statement}}",
    'visit.questions.recordFailed': "La r\xe9ponse n\u2019a pas pu \xeatre enregistr\xe9e dans la note de s\xe9ance.",
    'visit.questions.askTitle': "Demander \xe0 l\u2019assistant",
    'visit.questions.askPlaceholder': "Posez une question sur ce patient\u2026",
    'visit.questions.ask': 'Demander',
    'visit.questions.asking': "Envoi de la question\u2026",
    'visit.questions.followUps': 'Suivi',
    // ── §3.2.5 files, and the report each one produced ──────────────────────
    // ── فایل‌ها: what kind of thing is being uploaded ────────────────────────
    'visit.files.kind': "De quoi s\u2019agit-il\u202F?",
    'visit.files.kinds.image': 'Image dentaire',
    'visit.files.kinds.document': 'Document',
    'visit.files.viewType': 'Incidence',
    'visit.files.viewTypes.periapical': "R\xe9tro-alv\xe9olaire",
    'visit.files.viewTypes.bitewing': "R\xe9tro-coronaire (bite-wing)",
    'visit.files.viewTypes.panoramic': 'Panoramique dentaire',
    'visit.files.viewTypes.ceph': "T\xe9l\xe9radiographie de profil",
    'visit.files.viewTypes.photo': 'Photographie',
    'visit.files.plainUploadNote': "L\u2019import se contente de stocker le fichier. L\u2019extraction du texte et la lecture de l\u2019image sont des actions distinctes.",
    'visit.files.unsupportedImage': "Ce format d\u2019image ne peut pas \xeatre affich\xe9. Utilisez JPEG ou PNG.",
    'visit.files.openImage': "Ouvrir l\u2019image",
    'visit.files.extract': 'Extraire le texte',
    'visit.files.extracting': "Extraction\u2026",
    // ── The image workspace ─────────────────────────────────────────────────
    'visit.image.back': 'Retour aux fichiers',
    'visit.image.tools': 'Outils de dessin',
    'visit.image.tool.cursor': "S\xe9lectionner",
    'visit.image.tool.pin': "Rep\xe8re",
    'visit.image.tool.box': 'Rectangle',
    'visit.image.tool.ellipse': 'Cercle',
    'visit.image.tool.arrow': "Fl\xe8che",
    'visit.image.tool.freehand': "Main lev\xe9e",
    'visit.image.color': 'Couleur du crayon',
    'visit.image.colorName.E11D48': 'Rouge',
    'visit.image.colorName.F59E0B': 'Ambre',
    'visit.image.colorName.0EA5A0': 'Turquoise',
    'visit.image.colorName.2563EB': 'Bleu',
    'visit.image.zoomIn': 'Zoom avant',
    'visit.image.zoomOut': "Zoom arri\xe8re",
    'visit.image.fit': "R\xe9initialiser la vue",
    'visit.image.brightness': "Luminosit\xe9",
    'visit.image.contrast': 'Contraste',
    'visit.image.read': "Lire l\u2019image",
    'visit.image.reading': "Lecture\u2026",
    'visit.image.readStatus.no_findings': "L\u2019assistant n\u2019a rien trouv\xe9 de notable sur cette image. Aucun cr\xe9dit n\u2019a \xe9t\xe9 d\xe9bit\xe9.",
    'visit.image.readStatus.no_image': "L\u2019image n\u2019a pas pu \xeatre lue.",
    'visit.image.comment': "Note sur ce rep\xe8re",
    'visit.image.commentPlaceholder': "Qu\u2019avez-vous observ\xe9 ici\u202F?",
    'visit.image.removeMark': "Supprimer ce rep\xe8re",
    'visit.image.tooManyMarks': "Une image peut contenir au maximum {{max}} rep\xe8res.",
    'visit.image.saveFailed': "Les rep\xe8res n\u2019ont pas pu \xeatre enregistr\xe9s.",
    'visit.image.unsaved': "Rep\xe8res non enregistr\xe9s \u2014 appuyez sur \xab\xa0Enregistrer\xa0\xbb.",
    'visit.image.findings': "Ce que l\u2019assistant a lu",
    'visit.image.findingsNote': "Ce sont des suggestions. Rien n\u2019est inscrit sur le sch\xe9ma sans votre confirmation.",
    'visit.image.confidence.high': 'Nette',
    'visit.image.confidence.medium': 'Probable',
    'visit.image.confidence.low': 'Incertaine',
    'visit.image.notLocalized': "emplacement non identifi\xe9",
    'visit.image.unlocalizedNote': "Constatations non localisables sur l\u2019image, simplement list\xe9es\xa0: {{count}}",
    'visit.image.confirm': 'Confirmer',
    'visit.files.openFile': 'Ouvrir le fichier',
    'visit.image.register': 'Enregistrer',
    'visit.image.registering': "Enregistrement\u2026",
    'visit.image.notRegistered.title': "Non enregistr\xe9e comme image dentaire",
    'visit.image.notRegistered.body': "Vous pouvez la consulter. Pour l\u2019annoter et la faire lire par l\u2019assistant, il faut pr\xe9ciser l\u2019incidence \u2014 une r\xe9tro-coronaire et une photographie ne montrent pas les m\xeames choses.",
    'visit.image.changeView': "Changer l\u2019incidence",
    'visit.image.viewType.title': 'Incidence',
    'visit.image.viewType.body': "Ce choix d\xe9termine ce que l\u2019assistant peut signaler \u2014 une r\xe9tro-coronaire ne montre pas une l\xe9sion p\xe9riapicale, et une photographie ne montre pas l\u2019os. Corrigez-le s\u2019il est erron\xe9.",
    'visit.image.discard.title': "Abandonner les rep\xe8res dessin\xe9s\u202F?",
    'visit.image.discard.body': "Ils n\u2019ont pas \xe9t\xe9 enregistr\xe9s et il n\u2019en existe aucune autre copie.",
    'visit.image.discard.confirm': 'Abandonner',
    'visit.files.error.title': 'Impossible de charger les fichiers',
    'visit.files.error.body': "Les documents de ce patient n\u2019ont pas pu \xeatre lus. Veuillez r\xe9essayer.",
    'visit.files.empty.title': 'Aucun document',
    'visit.files.empty.description': "Importez une radiographie, un r\xe9sultat d\u2019analyse ou une lettre d\u2019orientation.",
    'visit.files.upload': 'Importer un document',
    'visit.files.uploading': "Import\u2026",
    'visit.files.uploadFailed': "Le document n\u2019a pas pu \xeatre import\xe9.",
    'visit.files.readFailed': "Le fichier n\u2019a pas pu \xeatre lu.",
    'visit.files.tooLarge': "Le fichier d\xe9passe 15\xa0Mo.",
    'visit.files.docType': 'Type de document',
    'visit.files.docTypes.lab_report': "R\xe9sultat d\u2019analyse",
    'visit.files.docTypes.prescription': 'Ordonnance',
    'visit.files.docTypes.general': 'Autre',
    'visit.files.attachTooth': "Rattacher \xe0 la dent {{fdi}}",
    'visit.files.thisVisit': "Cette s\xe9ance",
    'visit.files.hasReport': 'Compte rendu',
    'visit.files.noReport': "Aucun compte rendu n\u2019a \xe9t\xe9 extrait de ce document.",
    'visit.files.previewFailed': "Le fichier n\u2019a pas pu \xeatre ouvert.",
    'visit.files.bytesGone': "Le fichier d\u2019origine n\u2019est plus conserv\xe9\u202F; seul son compte rendu subsiste.",
    'visit.files.remove': 'Supprimer {{name}}',
    'visit.files.units.b': 'o',
    'visit.files.units.kb': 'Ko',
    'visit.files.units.mb': 'Mo',
    // ── credits (اعتبار) ──────────────────────────────────────────────────────
    'credits.title': "Cr\xe9dit Parsina",
    'credits.subtitle': 'Votre solde Parseh, son utilisation et les moyens de le recharger.',
    'credits.unit': 'Parseh',
    'credits.toman': 'tomans',
    'credits.tomanShort': 'T',
    'credits.currentBalance': 'Solde actuel',
    'credits.buy': 'Acheter des Parseh',
    'credits.topUp': 'Recharger',
    'credits.percent': "{{value}}\xa0%",
    'credits.timesUsed': '{{count}} fois',
    'credits.itemCount': "op\xe9rations\xa0: {{count}}",
    'credits.minutesUsed': "{{count}}\xa0min",
    'credits.byService': "R\xe9partition par service",
    'credits.transactions': "Op\xe9rations",
    'credits.level.low': 'Solde faible',
    'credits.level.lowShort': 'Faible',
    'credits.level.mid': 'Solde en baisse',
    'credits.level.midShort': 'Moyen',
    'credits.level.ok': 'Solde suffisant',
    'credits.level.okShort': 'Bon',
    'credits.banner.low': "Il ne reste que {{coins}} Parseh. L\u2019assistant s\u2019arr\xeatera une fois le cr\xe9dit \xe9puis\xe9.",
    'credits.banner.mid': "Il reste {{coins}} Parseh \u2014 de quoi tenir encore quelques s\xe9ances.",
    'credits.service.assistant': 'Assistant clinique',
    'credits.service.interaction': "V\xe9rification des interactions",
    'credits.service.transcription': 'Transcription',
    'credits.service.topUp': 'Recharge',
    'credits.service.gift': 'Code cadeau',
    'credits.service.sms': 'SMS',
    'credits.service.ai': 'Service IA',
    'credits.filter.label': "Filtrer les op\xe9rations",
    'credits.filter.all': 'Toutes',
    'credits.filter.spend': 'Consommation',
    'credits.filter.topUp': 'Ajouts',
    'credits.group.label': 'Regrouper par',
    'credits.group.day': 'Jour',
    'credits.group.type': 'Service',
    'credits.range.label': "P\xe9riode",
    'credits.range.all': "Toute la p\xe9riode",
    'credits.range.days7': '7 derniers jours',
    'credits.range.days30': '30 derniers jours',
    'credits.range.thisMonth': 'Ce mois-ci',
    'credits.time.today': "Aujourd\u2019hui",
    'credits.time.yesterday': 'Hier',
    'credits.kpi.month': "Consomm\xe9 ce mois-ci",
    'credits.kpi.perVisit': "Par s\xe9ance",
    'credits.kpi.topService': 'Premier poste de consommation',
    'credits.showingRange': "Affichage\xa0: {{from}}\u2013{{to}} sur {{total}}",
    'credits.pager.page': 'Page {{page}} sur {{total}}',
    'credits.pager.previous': "Pr\xe9c\xe9dent",
    'credits.pager.next': 'Suivant',
    'credits.empty.title': "Aucune op\xe9ration pour l\u2019instant",
    'credits.empty.hint': "Chaque action de l\u2019assistant pendant une s\xe9ance appara\xeet ici.",
    'credits.empty.filtered': "Aucune op\xe9ration sur cette p\xe9riode",
    'credits.empty.filteredHint': "Essayez une p\xe9riode plus large ou un autre filtre.",
    'credits.error.title': "Op\xe9rations indisponibles",
    'credits.error.body': "Votre solde n\u2019a pas pu \xeatre lu. Aucun cr\xe9dit n\u2019a \xe9t\xe9 d\xe9bit\xe9.",
    'credits.priceList.title': "Co\xfbt de chaque action",
    'credits.priceList.hint': "D\xe9bit\xe9 uniquement lorsque vous appuyez sur le bouton \u2014 rien ne se lance tout seul.",
    'credits.priceList.viewAll': 'Tout afficher',
    'credits.price.transcription': "Dict\xe9e vocale (reconnaissance vocale)",
    'credits.price.differential': "Suggestion de diagnostic par l\u2019IA",
    'credits.price.advice': "Conseils de l\u2019assistant",
    'credits.price.soap': "Compl\xe9ter la note",
    'credits.price.teeth': "Constatations par dent \xe0 partir du compte rendu de s\xe9ance",
    'credits.price.confirmq': 'Questions de confirmation',
    'credits.price.ask': "Demander \xe0 l\u2019assistant",
    'credits.price.ocr': "Lecture d\u2019un document import\xe9",
    'credits.price.interaction': "V\xe9rification des interactions m\xe9dicamenteuses",
    'credits.topUp.chooseAmount': 'Choisir un montant',
    'credits.topUp.recommended': "Recommand\xe9",
    'credits.topUp.approxVisits': "S\xe9ances avec l\u2019assistant\xa0: environ {{count}}",
    'credits.topUp.custom': 'Autre montant',
    'credits.topUp.customAria': 'Montant',
    'credits.topUp.payVia': 'Payer {{amount}} tomans via {{gateway}}',
    'credits.topUp.enterAmount': 'Saisissez un montant',
    'credits.topUp.redirecting': "Redirection vers la passerelle\u2026",
    'credits.topUp.redirectNote': "La passerelle de paiement bancaire va s\u2019ouvrir, puis vous reviendrez sur cette page.",
    'credits.topUp.minimum': "L\u2019achat minimum est de {{amount}} tomans.",
    'credits.topUp.failed': "Le paiement n\u2019a pas pu \xeatre lanc\xe9. Veuillez r\xe9essayer.",
    'credits.topUp.failedWithReason': "Le paiement n\u2019a pas pu \xeatre lanc\xe9\xa0: {{reason}}",
    'credits.gateway.saderat': 'Bank Saderat',
    'credits.gateway.zarinpal': 'Zarinpal',
    'credits.payment.done': "Paiement r\xe9ussi \u2014 votre solde a \xe9t\xe9 recharg\xe9.",
    'credits.payment.failed': "Le paiement n\u2019a pas abouti. Aucun montant n\u2019a \xe9t\xe9 d\xe9bit\xe9.",
    'credits.gift.title': 'Code cadeau',
    'credits.gift.hint': "Vous avez un code re\xe7u lors d\u2019une campagne Parsina\u202F? Saisissez-le ici\xa0: le cr\xe9dit Parseh correspondant sera ajout\xe9 \xe0 votre solde.",
    'credits.gift.placeholder': 'PARSINA-1404-XXXX',
    'credits.gift.submit': 'Activer',
    'credits.gift.submitting': "Activation\u2026",
    'credits.gift.empty': "Saisissez d\u2019abord le code.",
    'credits.gift.notFound': "Ce code n\u2019est pas valide. Saisissez-le exactement tel que vous l\u2019avez re\xe7u.",
    'credits.gift.oneUse': "Chaque code ne peut \xeatre utilis\xe9 qu\u2019une seule fois.",
    'credits.gift.success': "Cr\xe9dit ajout\xe9\xa0: {{parseh}} Parseh",
    'credits.gift.successSub': "S\xe9ances avec l\u2019assistant\xa0: environ {{visits}}.",
    'credits.gift.newBalance': 'Nouveau solde',
    'credits.gift.myCodes': 'Vos codes',
    'credits.gift.worth': "{{parseh}} Parseh \u2014 s\xe9ances\xa0: environ {{visits}}",
    'credits.gift.status.issued': "Non utilis\xe9",
    'credits.gift.status.redeemed': "Utilis\xe9",
    'credits.gift.status.revoked': "R\xe9voqu\xe9",
    'credits.gift.status.expired': "Expir\xe9",
    'credits.lowBalance.title': 'Alerte de solde faible',
    'credits.lowBalance.hint': "Nous vous pr\xe9viendrons lorsque votre solde passera sous ce seuil.",
    'credits.lowBalance.toggleAria': 'Activer les alertes de solde faible',
    'credits.lowBalance.thresholdAria': "Seuil d\u2019alerte, en Parseh",
    'credits.lowBalance.active': "Une alerte vous sera envoy\xe9e sous {{coins}} Parseh.",
    'credits.lowBalance.off': "Les alertes sont d\xe9sactiv\xe9es.",
    'credits.lowBalance.invalid': 'Saisissez un seuil valide.',
    'credits.lowBalance.saved': "Param\xe8tres d\u2019alerte enregistr\xe9s.",
    'credits.lowBalance.failed': "Les param\xe8tres d\u2019alerte n\u2019ont pas pu \xeatre enregistr\xe9s."
};


// DE — German. Translates en.js key for key (PM-0212).
//
// Every key here must exist in en.js (EN is the source catalogue) and every EN
// key must be translated here; tests/i18n.test.js asserts both directions. A
// key that ever goes missing falls back to English (translator.js), never to
// Persian.
//
// German typography is in the values themselves: formal Sie, „…“ quotes,
// no space before : ; ! ?, U+00A0 only between a figure and its unit or %.
// The one plural form is `<key>_one` (translator.js, Intl.PluralRules de:
// only 1 is `one`, so „0 Jahre“, „1 Jahr“). Brand and code values are kept as
// they are: 'Parsina', 'Parseh', 'PARSINA-1404-XXXX', the language endonyms.
const $89c0b7497ce84fc9$export$2fa162a495d26869 = {
    // ── app ──────────────────────────────────────────────────────────────────
    'app.title': "Parsina \u2013 Modul Zahnmedizin",
    // ── nav / chrome ─────────────────────────────────────────────────────────
    'nav.brand.name': 'Parsina',
    'nav.brand.panel': 'Zahnmedizin',
    'nav.items.today': 'Heute',
    'nav.items.patients': 'Patienten',
    'nav.items.credits': 'Guthaben',
    'nav.items.profile': 'Profil',
    'nav.sidebar.collapse': "Men\xfc einklappen",
    'nav.sidebar.expand': "Men\xfc ausklappen",
    'nav.sidebar.logout': 'Abmelden',
    'nav.sidebar.editProfile': 'Profil',
    'nav.clinic.label': 'Praxis',
    'nav.account.menuLabel': 'Konto',
    'nav.account.parsina': 'Parsina-Konto',
    'nav.account.parsinaHint': 'Name, Passwort, Sprache',
    'nav.credits.label': 'Ihr Parseh-Guthaben',
    'nav.credits.topUp': 'Parseh aufladen',
    'nav.clinicSwitch.label': 'Zum Praxisbereich wechseln',
    'nav.landmark.primary': "Hauptmen\xfc",
    'nav.landmark.content': 'Inhalt',
    // ── common ───────────────────────────────────────────────────────────────
    'common.actions.cancel': 'Abbrechen',
    'common.actions.retry': 'Erneut versuchen',
    'common.loading': 'Wird geladen',
    'common.actions.save': 'Speichern',
    'common.actions.saving': "Wird gespeichert\u2026",
    'common.actions.back': "Zur\xfcck",
    'common.actions.close': "Schlie\xdfen",
    'common.actions.clearFilters': "Filter zur\xfccksetzen",
    'common.actions.join': 'Beitreten',
    'common.state.pleaseWait': "Bitte warten\u2026",
    'common.labels.phone': 'Telefon',
    'common.labels.country': 'Land',
    'common.labels.nationalId': 'Nationale ID',
    'common.labels.fileNumber': 'Akten-Nr.',
    'common.labels.none': "\u2014",
    'common.gender.male': "M\xe4nnlich",
    'common.gender.female': 'Weiblich',
    'common.marital.single': 'Ledig',
    'common.marital.married': 'Verheiratet',
    'common.marital.divorced': 'Geschieden',
    'common.marital.widowed': 'Verwitwet',
    'common.units.years': '{{count}} Jahre',
    'common.units.years_one': '{{count}} Jahr',
    'common.units.minute': 'Min.',
    'common.units.second': 'Sekunden',
    'common.units.toman': 'Toman',
    'common.units.tomans': 'Toman',
    'common.punct.colon': ':',
    'common.voice.start': 'Diktieren',
    'common.voice.stop': 'Aufnahme beenden',
    'common.voice.listening': "Aufnahme l\xe4uft",
    'common.voice.priceTitle': '5 Parseh pro Aufnahmeminute, aufgerundet.',
    'common.voice.inlineTranscribing': "Wird transkribiert\u2026",
    'common.voice.error.denied': 'Der Mikrofonzugriff wurde verweigert',
    'common.voice.error.no-mic': 'Es wurde kein Mikrofon gefunden',
    'common.voice.error.unsupported': 'Dieser Browser kann keine Audioaufnahmen erstellen',
    'common.voice.error.insecure': "Die Aufnahme funktioniert nur \xfcber eine sichere Verbindung (HTTPS)",
    'common.voice.error.credits': 'Ihr Parseh-Guthaben ist aufgebraucht',
    'common.voice.error.auth': "Ihre Anmeldesitzung ist nicht mehr g\xfcltig. Bitte melden Sie sich erneut an",
    'common.voice.error.onboarding': "Schlie\xdfen Sie zuerst Ihre Registrierung ab",
    'common.voice.error.unavailable': "Der Spracherkennungsdienst ist nicht verf\xfcgbar",
    'common.voice.error.timeout': 'Die Transkription hat zu lange gedauert',
    'common.voice.error.generic': 'Die Audioaufnahme ist fehlgeschlagen',
    // ── mobile shell ─────────────────────────────────────────────────────────
    'mobile.greeting': 'Willkommen,',
    'mobile.showMore': 'Mehr anzeigen',
    'mobile.close': "Schlie\xdfen",
    // ── auth / boot ──────────────────────────────────────────────────────────
    'auth.checking': "Sie werden angemeldet\u2026",
    'auth.loading': "Ihr Arbeitsbereich wird geladen\u2026",
    'auth.loopError': "Die Anmeldung leitet immer wieder weiter. L\xf6schen Sie Ihre Anmeldesitzung und versuchen Sie es erneut, oder kontaktieren Sie den Support.",
    'auth.loopTitle': 'Anmeldung fehlgeschlagen',
    'auth.checkingHint': 'Einen Moment bitte',
    'auth.stuck': 'Nicht weitergeleitet?',
    'auth.manualSignIn': 'Hier klicken',
    'auth.retry': 'Erneut versuchen',
    'auth.signOut': 'Abmelden',
    'auth.bootFailed.title': 'Start fehlgeschlagen',
    'auth.bootFailed.body': "Ihr Arbeitsbereich konnte nicht geladen werden. Das ist meist nur vor\xfcbergehend.",
    'auth.session.expiringTitle': "Ihre Anmeldesitzung l\xe4uft bald ab",
    'auth.session.expiringBody': "Verl\xe4ngern Sie sie, um ohne Unterbrechung weiterzuarbeiten.",
    'auth.session.staySignedIn': 'Weiterarbeiten',
    'auth.session.expiredTitle': 'Ihre Anmeldesitzung ist abgelaufen',
    'auth.session.expiredBody': "Melden Sie sich erneut an, um fortzufahren. Diese Seite wurde nicht geschlossen \u2013 Sie kehren danach hierher zur\xfcck.",
    'auth.session.signInAgain': 'Erneut anmelden',
    'auth.session.returnNotice': 'Alles, was Sie bereits gespeichert haben, bleibt erhalten. Notieren Sie nicht gespeicherte Angaben auf dem Bildschirm, bevor Sie sich erneut anmelden.',
    // ── errors ───────────────────────────────────────────────────────────────
    'errors.generic': 'Es ist ein Fehler aufgetreten.',
    'errors.load.today': 'Der Tag konnte nicht geladen werden.',
    'errors.load.patients': 'Die Patientenliste konnte nicht geladen werden.',
    'errors.load.patient': 'Diese Akte konnte nicht geladen werden.',
    'errors.load.profile': 'Ihr Profil konnte nicht geladen werden.',
    'errors.load.drugs': 'Das Arzneimittelverzeichnis konnte nicht durchsucht werden.',
    'errors.credits.title': 'Nicht genug Parseh-Guthaben',
    'errors.credits.body': "Die Wechselwirkungspr\xfcfung ben\xf6tigt Guthaben. Laden Sie es unter \u201EGuthaben\u201C auf \u2013 das Verordnen selbst wird nicht blockiert.",
    // ── today (امروز) ─────────────────────────────────────────────────────────
    'today.title': 'Heute',
    'today.date.today': 'Heute',
    'today.date.prev': 'Vorheriger Tag',
    'today.date.next': "N\xe4chster Tag",
    'today.date.pick': "Datum w\xe4hlen",
    'today.counts.total': 'Termine',
    'today.counts.here': 'In der Praxis',
    'today.counts.scheduled': 'Geplant',
    'today.counts.completed': 'Behandelt',
    'today.counts.cancelled': 'Abgesagt',
    'today.counts.cancelledLine': 'Abgesagt: {{count}}',
    'today.notice.liveQueue': "Das Live-Wartezimmer wird nur f\xfcr heute angezeigt. F\xfcr andere Tage wird die Liste der geplanten Termine angezeigt.",
    'today.status.scheduled': 'Geplant',
    'today.status.arrived': 'Anwesend',
    'today.status.in_visit': 'In Behandlung',
    'today.status.completed': 'Behandelt',
    'today.status.cancelled': 'Abgesagt',
    'today.status.no_show': 'Nicht erschienen',
    'today.blocks.queue': 'Wartezimmer',
    'today.blocks.upcoming': 'Bevorstehend',
    'today.blocks.done': 'Abgeschlossen',
    'today.next.title': "N\xe4chster Patient",
    'today.next.at': 'um {{time}}',
    'today.next.service': 'Leistung: {{name}}',
    'today.next.serviceVisit': 'Sitzung',
    'today.next.serviceMore': '+{{count}} weitere',
    'today.empty.title': "F\xfcr diesen Tag sind keine Termine geplant",
    'today.empty.description': 'Termine werden vom Empfang der Praxis vergeben und erscheinen hier automatisch.',
    'today.error.title': "Der Tagesplan ist nicht verf\xfcgbar",
    'today.queue.positionNext': "Als N\xe4chstes",
    'today.queue.position': 'Nr. {{position}}',
    'today.queue.waited': "{{count}}\xa0Min. Wartezeit",
    'today.queue.waitedHours': "{{hours}}\xa0Std. Wartezeit",
    'today.queue.waitedHoursMinutes': "{{hours}}\xa0Std. {{minutes}}\xa0Min. Wartezeit",
    'today.queue.elapsed': "{{count}}\xa0Min. in Behandlung",
    'today.queue.elapsedHours': "{{hours}}\xa0Std. in Behandlung",
    'today.queue.elapsedHoursMinutes': "{{hours}}\xa0Std. {{minutes}}\xa0Min. in Behandlung",
    'today.row.visit': 'Sitzung',
    'today.row.visitFor': "Sitzung von {{name}} \xf6ffnen",
    'today.row.open': "Akte \xf6ffnen",
    'today.row.openFor': "Akte von {{name}} \xf6ffnen",
    'today.row.walkIn': 'Schnelltermin',
    'today.row.unknownPatient': 'Patient ohne Namen',
    'today.readOnlyNote': 'Terminvergabe, Absagen und die Aufrufreihenfolge liegen beim Empfang der Praxis. Dieser Bereich zeigt dieselben Termine.',
    // ── patients (بیماران) ────────────────────────────────────────────────────
    'patients.title': 'Patienten',
    'patients.subtitle': "Das Patientenregister der Praxis \u2013 dieselben Patienten, die der Empfang aufnimmt",
    'patients.search.placeholder': 'Name, Telefon, nationale ID oder Aktennummer',
    'patients.search.hint': 'Geben Sie mindestens zwei Zeichen ein, um zu suchen.',
    'patients.count': 'Patienten: {{count}}',
    'patients.columns.name': 'Patient',
    'patients.columns.phone': 'Telefon',
    'patients.columns.fileNumber': 'Akten-Nr.',
    'patients.columns.nationalId': 'Nationale ID',
    'patients.empty.title': 'Noch keine Patienten',
    'patients.empty.description': 'Patienten, die am Empfang der Praxis registriert werden, erscheinen hier.',
    'patients.emptyFiltered.title': 'Keine Treffer',
    'patients.emptyFiltered.description': 'Kein Patient entspricht dieser Suche.',
    'patients.noClinic.title': "Sie geh\xf6ren noch keiner Praxis an",
    'patients.noClinic.description': "Das Patientenregister geh\xf6rt zu einer Praxis. Treten Sie einer Praxis in Ihrem Profil mit deren Einladungscode bei.",
    'patients.noClinic.action': 'Zum Profil',
    'patients.pendingClinic.title': "Ihre Zugeh\xf6rigkeit wurde noch nicht best\xe4tigt",
    'patients.pendingClinic.description': "Sie haben den Beitritt beantragt. Die Praxis muss ihn best\xe4tigen, bevor ihr Patientenregister f\xfcr Sie freigegeben wird. Den Status finden Sie in Ihrem Profil.",
    'patients.error.title': "Die Patientenliste ist nicht verf\xfcgbar",
    // ── patient workspace ────────────────────────────────────────────────────
    'patient.tabs.summary': "\xdcbersicht",
    'patient.tabs.history': 'Vorgeschichte',
    'patient.tabs.sectionsLabel': 'Abschnitte der Akte',
    'patient.actions.prescribe': 'Verordnen',
    'patient.notFound.title': 'Akte nicht gefunden',
    'patient.notFound.description': "Dieser Patient existiert nicht oder ist f\xfcr Sie nicht sichtbar.",
    'patient.error.title': "Diese Akte ist nicht verf\xfcgbar",
    'patient.stats.age': 'Alter',
    'patient.stats.allergies': 'Allergien',
    'patient.stats.medications': 'Medikamente',
    'patient.summary.demographics': 'Angaben',
    'patient.summary.allergies': 'Allergien',
    'patient.summary.noAllergies': 'Keine Allergie erfasst.',
    'patient.severity.mild': 'Leicht',
    'patient.severity.moderate': 'Mittelgradig',
    'patient.severity.severe': 'Schwer',
    'patient.conditionStatus.active': 'Aktiv',
    'patient.conditionStatus.inactive': 'Inaktiv',
    'patient.conditionStatus.resolved': 'Abgeheilt',
    'patient.conditionStatus.remission': 'In Remission',
    'patient.photo.open': "Foto von {{name}} vergr\xf6\xdfert anzeigen",
    'patient.photo.alt': 'Profilfoto von {{name}}',
    'patient.summary.allergyWarning': "Erfasste Allergien \u2013 vor dem Verordnen pr\xfcfen.",
    'patient.fields.birthDate': 'Geburtsdatum',
    'patient.fields.gender': 'Geschlecht',
    'patient.fields.maritalStatus': 'Familienstand',
    'patient.fields.bloodType': 'Blutgruppe',
    'patient.fields.job': 'Beruf',
    'patient.fields.insurance': 'Versicherung',
    'patient.fields.height': "Gr\xf6\xdfe",
    'patient.fields.createdAt': 'Registriert am',
    'patient.history.conditions': 'Diagnosen',
    'patient.history.medications': 'Medikamente',
    'patient.history.noConditions': 'Keine Diagnose erfasst.',
    'patient.history.noMedications': 'Kein Medikament erfasst.',
    'patient.history.prescribedOn': 'Verordnet am {{date}}',
    // ── prescription (نسخه) ──────────────────────────────────────────────────
    'prescription.title': 'Rezept',
    'prescription.subtitle': "F\xfcr {{name}}",
    'prescription.search.label': "Medikament hinzuf\xfcgen",
    'prescription.search.placeholder': "Medikament suchen\u2026",
    'prescription.search.searching': "Wird gesucht\u2026",
    'prescription.search.empty': 'Kein passendes Medikament gefunden.',
    'prescription.search.hint': 'Geben Sie mindestens zwei Zeichen ein.',
    'prescription.search.results': 'Gefundene Medikamente: {{count}}.',
    'prescription.item.dose': 'Dosis',
    'prescription.item.frequency': "H\xe4ufigkeit",
    'prescription.item.duration': 'Dauer',
    'prescription.item.note': 'Bemerkung',
    'prescription.item.remove': '{{name}} entfernen',
    'prescription.empty.title': 'Noch nichts verordnet',
    'prescription.empty.description': "Suchen Sie oben ein Medikament, um das erste hinzuzuf\xfcgen.",
    'prescription.save': 'Rezept speichern',
    'prescription.saveConfirm': "Best\xe4tigen und speichern",
    'prescription.saving': "Wird gespeichert\u2026",
    'prescription.saved': 'Rezept gespeichert.',
    'prescription.saveFailed': 'Das Rezept konnte nicht gespeichert werden.',
    'prescription.savePartial': 'Gespeicherte Medikamente: {{saved}} von {{total}}.',
    'prescription.allergies.title': 'Erfasste Allergien',
    'prescription.interactions.title': "Wechselwirkungspr\xfcfung",
    'prescription.interactions.checking': "Wird gepr\xfcft\u2026",
    'prescription.interactions.none': 'Keine Wechselwirkung zwischen diesen Medikamenten gefunden.',
    'prescription.interactions.needsTwo': "F\xfcgen Sie ein zweites Medikament hinzu, um die Wechselwirkungspr\xfcfung zu starten.",
    'prescription.interactions.unavailable': "Die Wechselwirkungspr\xfcfung ist derzeit nicht verf\xfcgbar. Das Verordnen wird nicht blockiert.",
    'prescription.interactions.severity.high': 'Schwerwiegend',
    'prescription.interactions.severity.moderate': 'Mittelschwer',
    'prescription.interactions.severity.low': "Geringf\xfcgig",
    'prescription.interactions.type.interaction': 'Wechselwirkung',
    'prescription.interactions.type.contraindication': 'Kontraindikation',
    'prescription.interactions.type.allergy': 'Allergie',
    'prescription.interactions.type.black_box': 'Schwerwiegender Warnhinweis',
    'prescription.history.title': 'Bisherige Medikation',
    'prescription.history.empty': 'Bisher nichts verordnet.',
    // ── profile ──────────────────────────────────────────────────────────────
    'profile.title': 'Profil',
    'profile.subtitle': "Ihre Identit\xe4t, Ihre Praxen und Ihre Anwesenheitszeiten",
    'profile.sections.label': 'Profilabschnitte',
    'profile.sections.identity': "Identit\xe4t",
    'profile.sections.clinics': 'Praxen',
    'profile.sections.presence': 'Anwesenheitszeiten',
    'profile.sections.appearance': 'Darstellung und Sprache',
    'profile.fields.fullName': "Vollst\xe4ndiger Name",
    'profile.fields.medicalCode': "\xc4rztekammernummer",
    'profile.fields.specialty': 'Fachrichtung',
    'profile.fields.bio': "\xdcber Sie",
    'profile.specialtyValue': 'Zahnmedizin',
    'profile.medicalCodeLocked': "Die \xc4rztekammernummer wurde bei der Registrierung erfasst und kann nicht bearbeitet werden. Wenden Sie sich an den Parsina-Support, um sie korrigieren zu lassen.",
    'profile.specialtyLocked': "Dieser Bereich ist f\xfcr Zahn\xe4rzte bestimmt, daher ist die Fachrichtung festgelegt. Wird sie an anderer Stelle ge\xe4ndert, verliert Ihr Konto den Zugang zu diesem Bereich.",
    'profile.saved': 'Profil gespeichert.',
    'profile.noChanges': "Keine \xc4nderungen.",
    'profile.saveFailed': 'Das Profil konnte nicht gespeichert werden.',
    'profile.duplicateCode': "Diese \xc4rztekammernummer geh\xf6rt bereits zu einem anderen Konto.",
    'profile.clinics.empty': "Sie geh\xf6ren noch keiner Praxis an.",
    'profile.clinics.status.pending': "Best\xe4tigung der Praxis ausstehend",
    'profile.clinics.status.active': 'Aktiv',
    'profile.clinics.visitDuration': "Zeitfenster {{count}}\xa0Min.",
    'profile.clinics.activeScope': 'Aktive Praxis',
    'profile.clinics.activeScopeHint': "\u201EHeute\u201C und \u201EPatienten\u201C zeigen diese Praxis.",
    'profile.clinics.joinTitle': 'Einer Praxis beitreten',
    'profile.clinics.joinHint': 'Fragen Sie die Praxisleitung nach dem Einladungscode.',
    'profile.clinics.joinPlaceholder': 'Einladungscode',
    'profile.clinics.joined': 'Sie sind {{name}} beigetreten.',
    'profile.clinics.notFound': 'Keine Praxis hat diesen Einladungscode.',
    'profile.clinics.joinFailed': 'Der Beitritt zur Praxis ist fehlgeschlagen.',
    'profile.presence.empty': "Die Praxis hat f\xfcr Sie noch keine Anwesenheitszeiten festgelegt.",
    'profile.presence.oneOff': 'Einmalig',
    'profile.presence.inactive': 'Inaktiv',
    'profile.presence.readOnly': 'Die Anwesenheitszeiten legt die Praxis fest; dieser Bereich zeigt sie nur an.',
    'profile.presence.days.0': 'Montag',
    'profile.presence.days.1': 'Dienstag',
    'profile.presence.days.2': 'Mittwoch',
    'profile.presence.days.3': 'Donnerstag',
    'profile.presence.days.4': 'Freitag',
    'profile.presence.days.5': 'Samstag',
    'profile.presence.days.6': 'Sonntag',
    'profile.appearance.theme': 'Akzentfarbe',
    'profile.appearance.fontSize': "Textgr\xf6\xdfe",
    'profile.appearance.language': 'Sprache',
    'profile.appearance.saved': 'Einstellung gespeichert.',
    'profile.appearance.failed': 'Die Einstellung wurde nicht auf dem Server gespeichert.',
    'profile.theme.default': 'Parsina-Blau',
    'profile.theme.teal': "T\xfcrkis",
    'profile.theme.ocean': 'Tiefblau',
    'profile.theme.slate': 'Blaugrau',
    'profile.fontSize.small': 'Klein',
    'profile.fontSize.medium': 'Mittel',
    'profile.fontSize.large': "Gro\xdf",
    'profile.language.fa': "\u0641\u0627\u0631\u0633\u06CC",
    'profile.language.en': 'English',
    'profile.language.fr': "Fran\xe7ais",
    'profile.language.de': 'Deutsch',
    // ── onboarding ───────────────────────────────────────────────────────────
    'onboarding.title': 'Parsina-Modul Zahnmedizin',
    'onboarding.subtitle.step1': 'Registrieren Sie sich einmalig, damit Ihr Konto identifiziert werden kann',
    'onboarding.subtitle.clinic': 'Verbinden Sie sich mit der Praxis, in der Sie arbeiten',
    'onboarding.subtitle.done': 'Alles bereit',
    'onboarding.progress.step1': 'Registrierung',
    'onboarding.progress.clinic': 'Praxis',
    'onboarding.progress.done': 'Fertig',
    'onboarding.step1.fullName': "Vollst\xe4ndiger Name",
    'onboarding.step1.fullNamePlaceholder': 'Dr. Maryam Ahmadi',
    'onboarding.step1.medicalCode': "\xc4rztekammernummer",
    'onboarding.step1.medicalCodePlaceholder': 'z. B. 123456',
    'onboarding.step1.specialty': 'Fachrichtung',
    'onboarding.step1.bio': "\xdcber Sie (optional)",
    'onboarding.step1.submit': 'Weiter',
    'onboarding.step1.specialtyNote': "Dieser Bereich ist das Modul Zahnmedizin, daher ist die Fachrichtung f\xfcr Sie festgelegt.",
    'onboarding.clinic.choiceTitle': 'Ihre Einzelpraxis oder Praxis',
    'onboarding.clinic.choiceDescription': 'Wenn Sie eine eigene Einzelpraxis haben, registrieren Sie sie hier. Wenn Sie in einer anderen Praxis arbeiten, treten Sie ihr mit einem Einladungscode bei.',
    'onboarding.clinic.ownTitle': 'Eigene Einzelpraxis registrieren',
    'onboarding.clinic.ownBody': "F\xfcr eine eigene Praxis. Sie werden ihr Inhaber.",
    'onboarding.clinic.joinTitle': 'Einer bestehenden Praxis beitreten',
    'onboarding.clinic.joinBody': 'Mit dem Einladungscode, den Sie von der Praxis erhalten haben.',
    'onboarding.clinic.back': "Zur\xfcck",
    'onboarding.clinic.ownName': 'Name der Praxis',
    'onboarding.clinic.ownNamePlaceholder': 'Zahnarztpraxis Dr. Ahmadi',
    'onboarding.clinic.ownCity': 'Stadt (optional)',
    'onboarding.clinic.ownAddress': 'Adresse (optional)',
    'onboarding.clinic.ownPhone': 'Telefon der Praxis (optional)',
    'onboarding.clinic.create': 'Praxis registrieren',
    'validation.clinicName': 'Geben Sie den Namen der Praxis ein.',
    'onboarding.clinic.alreadyExists': "F\xfcr dieses Konto ist bereits eine Praxis registriert.",
    'onboarding.clinic.currency': "W\xe4hrung der Praxis",
    'onboarding.clinic.currencyHint': "Geb\xfchren und Behandlungspl\xe4ne werden in dieser W\xe4hrung erfasst. Im Praxisbereich l\xe4sst sie sich nur \xe4ndern, bis der erste Betrag erfasst ist.",
    'onboarding.clinic.currencyIrr': 'Toman (IRR)',
    'onboarding.clinic.currencyMismatch': "F\xfcr dieses Konto ist bereits eine Praxis mit der W\xe4hrung {{currency}} registriert. W\xe4hlen Sie diese W\xe4hrung oder \xe4ndern Sie sie im Praxisbereich.",
    'onboarding.clinic.setupIncomplete': "Die Praxis wurde angelegt, aber ihre W\xe4hrung konnte in der Buchhaltung nicht festgelegt werden. Registrieren Sie sie nicht erneut \u2013 wenden Sie sich an den Parsina-Support, um die Einrichtung abzuschlie\xdfen.",
    'onboarding.clinic.title': 'Ihrer Praxis beitreten',
    'onboarding.clinic.description': "Mit dem Einladungscode der Praxis werden Ihre Termine und das Patientenregister der Praxis freigegeben. Sie k\xf6nnen dies auch sp\xe4ter in Ihrem Profil erledigen.",
    'onboarding.clinic.placeholder': 'Einladungscode',
    'onboarding.clinic.join': 'Beitreten',
    'onboarding.clinic.skip': "Sp\xe4ter",
    'onboarding.done.title': 'Willkommen',
    'onboarding.done.body': "Ihr zahnmedizinischer Arbeitsbereich ist bereit. \u201EHeute\u201C zeigt die Termine, die die Praxis f\xfcr Sie vergibt.",
    'onboarding.done.enter': "Bereich \xf6ffnen",
    // ── validation ───────────────────────────────────────────────────────────
    'validation.medicalCode': "Geben Sie Ihre \xc4rztekammernummer ein.",
    'validation.fullName': "Geben Sie Ihren vollst\xe4ndigen Namen ein.",
    'validation.invitationCode': 'Geben Sie den Einladungscode ein.',
    'validation.officePhone': "Die Telefonnummer der Praxis ist unvollst\xe4ndig. Korrigieren Sie sie oder leeren Sie das Feld.",
    'validation.phone.tooShort': "Diese Nummer ({{country}}) ist zu kurz \u2013 Beispiel: {{example}}",
    'validation.phone.tooLong': "Diese Nummer ({{country}}) ist zu lang \u2013 Beispiel: {{example}}",
    'validation.phone.invalid': "Diese Nummer ist ung\xfcltig.",
    // ── چارت دندان / odontogram ──────────────────────────────────────────────
    'patient.tabs.plan': 'Behandlungsplan',
    'patient.plan.empty.title': "F\xfcr diesen Patienten wurde noch kein Behandlungsplan erfasst",
    'patient.plan.empty.description': "Ein Behandlungsplan wird w\xe4hrend einer Sitzung erstellt.",
    'patient.plan.noLines': "Dieser Behandlungszyklus enth\xe4lt noch keine Positionen.",
    'patient.plan.doneTitle': "Durchgef\xfchrte Behandlungen",
    'patient.plan.outstanding': "Offene Ma\xdfnahmen: {{count}} \u2013 insgesamt {{amount}}",
    'patient.tabs.chart': 'Zahnschema',
    'chart.tooth': 'Zahn',
    'chart.universalShort': 'US-Nr.',
    'chart.annotation.planned': 'geplant',
    'chart.annotation.treated': 'behandelt',
    'chart.legend.planned': 'Geplant',
    'chart.legend.treated': 'Behandelt',
    'chart.tooltip.treated': "Durchgef\xfchrte Behandlungen",
    'chart.tooltip.andMore': 'und weitere ({{count}})',
    'chart.tooltip.planned': 'Geplant',
    'chart.wholeMouth.title': 'Gesamtgebiss',
    'chart.history.title': 'Verlauf von Zahn {{fdi}}',
    'chart.history.treatment': 'Behandlung',
    'chart.history.event': 'Zahnschema',
    'chart.history.causedBy': 'aus der Behandlung oben',
    'chart.history.empty': "F\xfcr diesen Zahn wurde noch nichts erfasst.",
    'chart.history.unavailable': 'Der Verlauf dieses Zahns konnte nicht gelesen werden.',
    'chart.history.session': 'Sitzung {{n}}',
    'chart.history.voided': "Storniert \u2013 {{reason}}",
    'chart.notCharted': 'Nicht erfasst',
    'chart.patientRight': 'RECHTS (PATIENT)',
    'chart.patientLeft': 'LINKS (PATIENT)',
    'chart.aria.odontogram': "Zahnschema \u2013 klicken Sie auf einen Zahn oder eine Fl\xe4che, um einen Befund zu erfassen",
    'chart.hint': "Klicken Sie auf eine Fl\xe4che, um sie zu erfassen, oder auf den Zahn f\xfcr seinen Gesamtstatus.",
    // ── chart, mobile ────────────────────────────────────────────────────────
    'chart.mobile.settings': 'Einstellungen des Zahnschemas',
    'chart.mobile.pickTooth': "Zahn ausw\xe4hlen",
    'chart.mobile.tapHint': "Tippen Sie im Zahnschema auf einen Zahn oder w\xe4hlen Sie unten einen aus \u2013 die Fl\xe4chen werden im sich \xf6ffnenden Fenster erfasst.",
    'chart.mobile.legend': 'Legende',
    'chart.legend.bridge': "Br\xfccke",
    'chart.legend.wholeToothCaries': 'Karies des gesamten Zahns',
    'chart.export.button': 'Bild exportieren',
    'chart.export.error': "Das Bild konnte nicht exportiert werden \u2013 dieser Browser unterst\xfctzt das nicht.",
    'chart.material': 'Material',
    'chart.isHistorical': "Vorhandene Versorgung (nicht heute durchgef\xfchrt)",
    'chart.showPrimary': "Milchz\xe4hne anzeigen",
    'chart.hidePrimary': "Milchz\xe4hne ausblenden",
    'chart.showUniversal': 'US-Nummern anzeigen',
    'chart.hideUniversal': 'US-Nummern ausblenden',
    'chart.error.title': 'Das Zahnschema konnte nicht geladen werden',
    'chart.error.body': 'Das Zahnschema konnte nicht abgerufen werden. Bitte versuchen Sie es erneut.',
    'chart.summary.charted': 'Erfasst',
    'chart.summary.decayed': "Kari\xf6s",
    'chart.summary.restored': "Gef\xfcllt",
    'chart.summary.missing': 'Fehlend',
    'chart.summary.dmft': 'DMF-T',
    'chart.presence.title': 'Vorhandensein',
    'chart.presence.present': 'Vorhanden',
    'chart.presence.extracted': 'Extrahiert',
    'chart.presence.exfoliated': 'Ausgefallen',
    'chart.presence.congenitally_absent': 'Nicht angelegt',
    'chart.presence.unerupted': 'Nicht durchgebrochen',
    'chart.presence.impacted': 'Retiniert',
    'chart.surfaces.title': "Fl\xe4chen",
    'chart.surfaces.hint': "Fl\xe4che w\xe4hlen, dann ihren Status",
    'chart.surfaces.setFor': "Status f\xfcr",
    'chart.surface.M': 'Mesial',
    'chart.surface.D': 'Distal',
    'chart.surface.F': "Vestibul\xe4r",
    'chart.surface.L': 'Oral',
    'chart.surface.O': 'Okklusal',
    'chart.surface.I': 'Inzisal',
    'chart.surfaceState.sound': 'Gesund',
    'chart.surfaceState.caries': 'Karies',
    'chart.surfaceState.restoration': "F\xfcllung",
    'chart.surfaceState.recurrent_caries': "Sekund\xe4rkaries",
    'chart.surfaceState.temporary': 'Provisorium',
    'chart.surfaceState.sealant': 'Fissurenversiegelung',
    'chart.surfaceState.fractured': 'Frakturiert',
    'chart.condition.title': 'Gesamter Zahn',
    'chart.condition.hint': "Unabh\xe4ngig von den Fl\xe4chen oben",
    'chart.conditionName.sound': 'Gesund',
    'chart.conditionName.caries': 'Karies',
    'chart.conditionName.root_canal': "Wurzelgef\xfcllt",
    'chart.conditionName.post_core': 'Stiftaufbau',
    'chart.conditionName.crown': 'Krone',
    'chart.conditionName.veneer': 'Veneer',
    'chart.conditionName.implant': 'Implantat',
    'chart.conditionName.bridge_abutment': "Br\xfcckenpfeiler",
    'chart.conditionName.bridge_pontic': "Br\xfcckenglied",
    'chart.conditionName.fracture': 'Fraktur',
    'chart.conditionName.attrition': 'Attrition',
    'chart.conditionName.mobility': 'Zahnlockerung',
    'chart.conditionName.periapical_lesion': "Apikale L\xe4sion",
    'chart.conditionName.sealant': 'Fissurenversiegelung',
    'chart.conditionName.temporary': 'Provisorium',
    'chart.conditionName.watch': 'Zu beobachten',
    'chart.note.title': 'Notiz',
    'chart.note.placeholder': 'Alles, was zu diesem Zahn festgehalten werden sollte',
    'chart.materialName.composite': 'Komposit',
    'chart.materialName.amalgam': 'Amalgam',
    'chart.materialName.glass_ionomer': 'Glasionomerzement',
    'chart.materialName.zirconia': 'Zirkonoxid',
    'chart.materialName.pfm': 'VMK',
    'chart.materialName.full_metal': 'Vollguss (NEM)',
    'chart.materialName.emax': 'E.max',
    'chart.materialName.temporary': 'Provisorisch',
    'chart.materialName.gold': 'Gold',
    // ── hover card ──────────────────────────────────────────────────────────
    'chart.primary': 'Milchzahn',
    'chart.tooltip.notCharted': "F\xfcr diesen Zahn wurde noch nichts erfasst.",
    'chart.tooltip.sound': "Untersucht \u2013 ohne Befund",
    'chart.tooltip.lastRecorded': 'Zuletzt erfasst',
    'chart.quadrant.upperRight': 'Oberkiefer rechts (Patient)',
    'chart.quadrant.upperLeft': 'Oberkiefer links (Patient)',
    'chart.quadrant.lowerRight': 'Unterkiefer rechts (Patient)',
    'chart.quadrant.lowerLeft': 'Unterkiefer links (Patient)',
    'chart.toothName.centralIncisor': 'Mittlerer Schneidezahn',
    'chart.toothName.lateralIncisor': 'Seitlicher Schneidezahn',
    'chart.toothName.canine': 'Eckzahn',
    'chart.toothName.firstPremolar': "Erster Pr\xe4molar",
    'chart.toothName.secondPremolar': "Zweiter Pr\xe4molar",
    'chart.toothName.firstMolar': 'Erster Molar',
    'chart.toothName.secondMolar': 'Zweiter Molar',
    'chart.toothName.thirdMolar': 'Dritter Molar (Weisheitszahn)',
    // ── جلسهٔ درمان — the visit workspace (docs/dent-visit.md) ────────────────
    'visit.error.title': "Die Sitzung konnte nicht ge\xf6ffnet werden",
    'visit.error.body': 'Dieser Termin konnte nicht gelesen werden. Bitte versuchen Sie es erneut.',
    'visit.notFound.title': 'Sitzung nicht gefunden',
    'visit.notFound.description': "Dieser Termin existiert nicht, geh\xf6rt nicht zu Ihnen oder ist mit keiner Patientenakte verkn\xfcpft.",
    'visit.unknownPatient': 'Patient ohne Namen',
    'visit.openRecord': 'Patientenakte',
    'visit.finish.action': 'Sitzung beenden',
    'visit.finish.working': "Wird beendet\u2026",
    'visit.finish.confirm.title': 'Diese Sitzung beenden?',
    'visit.finish.confirm.body': "Alles noch nicht Gespeicherte wird gespeichert und die Sitzung beendet. Danach ist sie schreibgesch\xfctzt und kann in dieser App nicht wieder ge\xf6ffnet werden.",
    'visit.finish.followUp.title': "Verbleibende Ma\xdfnahmen im Plan: {{count}}",
    'visit.finish.followUp.andMore': 'und weitere ({{count}})',
    'visit.finish.followUp.today': 'Heute',
    'visit.finish.followUp.tomorrow': 'Morgen',
    'visit.finish.followUp.withinWeek': 'Innerhalb einer Woche',
    'visit.finish.followUp.within2Weeks': 'Innerhalb von zwei Wochen',
    'visit.finish.followUp.withinMonth': 'Innerhalb eines Monats',
    'visit.finish.followUp.within3Months': 'Innerhalb von drei Monaten',
    'visit.finish.followUp.when': "Bis wann sollte der n\xe4chste Termin stattfinden?",
    'visit.finish.followUp.none': 'Nicht erforderlich',
    'visit.finish.followUp.deskNote': 'Der Empfang wird informiert, damit er den Termin bei Ihnen vergeben kann.',
    'visit.finish.followUp.noneNote': 'Der Empfang wird nicht informiert.',
    'visit.finish.done.plain': 'Die Sitzung ist beendet.',
    'visit.finish.done.followUpRaised': "Die Sitzung ist beendet. Der Empfang wurde gebeten, den n\xe4chsten Termin zu vergeben.",
    'visit.finish.done.alreadyBooked': "Die Sitzung ist beendet. Dieser Patient hat bereits einen n\xe4chsten Termin.",
    'visit.finish.done.followUpFailed': "Die Sitzung ist beendet, aber der Empfang wurde nicht \xfcber den n\xe4chsten Termin informiert.",
    'visit.finish.error.subjective': 'Die Anamnese wurde nicht gespeichert, daher wurde die Sitzung nicht beendet. Versuchen Sie es erneut.',
    'visit.finish.error.complete': 'Die Anamnese wurde gespeichert, aber die Sitzung konnte nicht beendet werden. Versuchen Sie es erneut.',
    // ── The video visit ──────────────────────────────────────────────────────
    'visit.call.start': 'Videoanruf',
    'visit.call.title': 'Videoanruf',
    'visit.call.panelLabel': 'Videoanruf-Fenster',
    'visit.call.connecting': "Verbindung wird hergestellt\u2026",
    'visit.call.hangUp': 'Anruf beenden',
    'visit.call.notRecorded': 'Dieser Anruf wird nicht aufgezeichnet, und nichts davon wird gespeichert.',
    'visit.call.error.connection': "Der Anruf konnte nicht verbunden werden. Pr\xfcfen Sie die Verbindung und versuchen Sie es erneut.",
    'visit.call.error.unavailable': 'Videosprechstunden sind in dieser Umgebung nicht aktiviert.',
    'visit.call.error.visitOver': 'Diese Sitzung ist beendet, daher kann kein Videoanruf dazu gestartet werden.',
    'visit.readOnly.badge': 'Nur Lesen',
    'visit.readOnly.note': 'Diese Sitzung ist beendet, daher kann nichts mehr dazu erfasst werden. Alles bereits Erfasste wird weiterhin angezeigt.',
    'visit.ai.costsCredits': 'Verbraucht Parseh-Guthaben.',
    'visit.tabs.meds': 'Medikation',
    'visit.tabs.orders': 'Anordnungen',
    'visit.tabs.diagnosis': 'Diagnose',
    'visit.tabs.questions': 'Fragen',
    'visit.tabs.files': 'Dateien',
    'visit.tabs.sectionsLabel': 'Abschnitte der Sitzung',
    // ── §3.1.1 odontogram ───────────────────────────────────────────────────
    'visit.chart.title': 'Zahnschema',
    'visit.chart.hint': "W\xe4hlen Sie einen Zahn, um seine Befunde und die geplanten Ma\xdfnahmen zu sehen.",
    'visit.chart.tooth': 'Zahn {{fdi}}',
    'visit.chart.openTooth': 'Befunde',
    'visit.chart.planForTooth': "Zum Plan hinzuf\xfcgen",
    'visit.chart.noPlanForTooth': "F\xfcr diesen Zahn ist nichts geplant.",
    'visit.chart.history': 'Verlauf',
    'visit.chart.noHistory': "F\xfcr diesen Zahn wurde nichts erfasst.",
    'visit.chart.historyUnavailable': 'Der Verlauf konnte nicht geladen werden.',
    'visit.chart.historical': 'vorbestehend',
    // ── §3.1.2 subjective ───────────────────────────────────────────────────
    'visit.subjective.title': 'Anamnese',
    'visit.subjective.error.title': 'Die Anamnese konnte nicht geladen werden',
    'visit.subjective.error.body': 'Die Anamnese dieser Sitzung konnte nicht gelesen werden. Bitte versuchen Sie es erneut.',
    'visit.subjective.saved': 'Gespeichert',
    'visit.subjective.saveFailed': 'Die Anamnese konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    'visit.subjective.history': 'Vorgeschichte des Patienten',
    'visit.subjective.noAllergies': 'Keine Allergien erfasst',
    'visit.subjective.conditions': 'Erkrankungen',
    'visit.subjective.medications': 'Medikation',
    'visit.subjective.chiefComplaint': 'Vorstellungsgrund',
    'visit.subjective.dictateComplaint': 'Vorstellungsgrund diktieren',
    'visit.subjective.dictateNotes': 'Notiz diktieren',
    'visit.subjective.teeth': "Betroffene Z\xe4hne",
    'visit.subjective.noTeeth': "Tippen Sie oben im Zahnschema auf die betroffenen Z\xe4hne",
    'visit.subjective.addTooth': "Zahn {{fdi}} hinzuf\xfcgen",
    'visit.subjective.selectToothFirst': "W\xe4hlen Sie im Zahnschema einen Zahn aus",
    'visit.subjective.painScore': "Schmerzst\xe4rke (0\u201310)",
    'visit.subjective.painCharacter': 'Schmerzcharakter',
    'visit.subjective.pain.sharp': 'Stechend',
    'visit.subjective.pain.dull': 'Dumpf',
    'visit.subjective.pain.throbbing': 'Pochend',
    'visit.subjective.pain.sensitivity': 'Empfindlichkeit',
    'visit.subjective.pain.none': 'Keine Schmerzen',
    'visit.subjective.onset': 'Beschwerdebeginn',
    'visit.subjective.duration': 'Dauer',
    'visit.subjective.aggravating': "Verst\xe4rkt durch",
    'visit.subjective.relieving': 'Gelindert durch',
    'visit.subjective.dentalHistory': "Zahn\xe4rztliche Vorgeschichte",
    'visit.subjective.notes': 'Notizen',
    'visit.subjective.priorVisits': "Fr\xfchere Sitzungen",
    'visit.subjective.noPriorVisits': "Keine fr\xfcheren Sitzungen erfasst.",
    'visit.subjective.priorNoSummary': 'Kein Vorstellungsgrund erfasst',
    'visit.subjective.priorDiagnoses': 'Diagnosen: {{count}}',
    // ── §3.1.3 treatment plan ───────────────────────────────────────────────
    'visit.plan.title': 'Behandlungsplan',
    'visit.plan.error.title': 'Der Plan konnte nicht geladen werden',
    'visit.plan.error.body': 'Der Behandlungsplan dieses Patienten konnte nicht gelesen werden. Bitte versuchen Sie es erneut.',
    'visit.plan.error.currencyUnavailable': "Die W\xe4hrung der Praxis konnte nicht gelesen werden; ohne sie k\xf6nnen die Betr\xe4ge des Plans nicht angezeigt werden. Bitte versuchen Sie es erneut.",
    'visit.plan.error.currencyMismatch': "Diese Betr\xe4ge sind nicht in der W\xe4hrung der Praxis, und Betr\xe4ge in unterschiedlichen W\xe4hrungen werden nie zusammengerechnet. Bitten Sie die Praxisleitung, die W\xe4hrung der Praxis zu pr\xfcfen.",
    'visit.plan.saveFailed': 'Der Plan konnte nicht gespeichert werden.',
    'visit.plan.empty.title': 'Noch kein Plan',
    'visit.plan.empty.description': "F\xfcgen Sie die geplanten Ma\xdfnahmen Zahn f\xfcr Zahn hinzu.",
    'visit.plan.add': "Ma\xdfnahme hinzuf\xfcgen",
    'visit.plan.added': "\u201E{{what}}\u201C wurde zum Behandlungsplan hinzugef\xfcgt.",
    'visit.plan.addedForTooth': "\u201E{{what}}\u201C wurde f\xfcr Zahn {{fdi}} zum Behandlungsplan hinzugef\xfcgt.",
    'visit.chart.planFormOpened': "Formular f\xfcr Zahn {{fdi}} ge\xf6ffnet \u2013 w\xe4hlen Sie die Ma\xdfnahme.",
    'visit.plan.addItem': "Zum Plan hinzuf\xfcgen",
    'visit.plan.service': "Ma\xdfnahme",
    'visit.plan.choose': "Ma\xdfnahme ausw\xe4hlen\u2026",
    'visit.plan.tooth': 'Zahn',
    'visit.plan.wholeMouth': 'Gesamtgebiss',
    'visit.plan.wholeMouthShort': 'Gebiss',
    'visit.plan.phase': 'Phase',
    'visit.plan.description': 'Beschreibung',
    'visit.plan.untitledItem': "Ma\xdfnahme ohne Titel",
    'visit.plan.changeStatus': "Status \xe4ndern: {{item}}",
    'visit.plan.remove': '{{item}} entfernen',
    'visit.plan.showOnChart': 'Im Zahnschema anzeigen',
    'visit.plan.surfaces': "Fl\xe4chen",
    'visit.plan.sessions': 'Sitzungen',
    'visit.plan.sessionsOf': 'Sitzung {{done}} von {{total}}',
    'visit.plan.toman': '{{amount}} {{unit}}',
    'visit.plan.noTariff': "Keine Geb\xfchr festgelegt",
    'visit.plan.outstanding': 'Offen: {{amount}}',
    'visit.plan.otherCurrency': "Geb\xfchr in anderer W\xe4hrung ({{currency}})",
    'visit.plan.otherCurrencyRefused': "Die Geb\xfchr f\xfcr \u201E{{name}}\u201C ist in {{currency}} angegeben und kann daher keinem Plan in {{planCurrency}} hinzugef\xfcgt werden.",
    'visit.record.openVisit': "Sitzung \xf6ffnen",
    'visit.record.open': "Als durchgef\xfchrt erfassen",
    'visit.record.openSession': 'Sitzung erfassen',
    'visit.record.title': "Als durchgef\xfchrt erfassen \u2013 {{treatment}}",
    'visit.record.subtitle': "Erfasst, was in dieser Sitzung durchgef\xfchrt wurde. Dies ist die klinische Dokumentation.",
    'visit.record.service': "Durchgef\xfchrte Behandlung",
    'visit.record.tooth': 'Zahn',
    'visit.record.surfaces': "Fl\xe4chen",
    'visit.record.material': 'Material',
    'visit.record.noMaterial': 'Kein Material',
    'visit.record.note': "Durchgef\xfchrte Ma\xdfnahme",
    'visit.record.notePlaceholder': "Kurz beschreiben, was durchgef\xfchrt wurde",
    'visit.record.outcome': 'Ergebnis',
    'visit.record.outcome.completed': 'Abgeschlossen',
    'visit.record.outcome.inProgress': "Fortsetzung in der n\xe4chsten Sitzung",
    'visit.record.chartEffect': 'Zahnstatus nach der Behandlung',
    'visit.record.chartEffect.none': "Zahnschema unver\xe4ndert lassen",
    'visit.record.chartEffect.noneDetail': 'Im Zahnschema wird nichts eingetragen.',
    'visit.record.chartEffect.detail': "Zahn {{tooth}} wird im Zahnschema als \u201E{{state}}\u201C eingetragen.",
    'visit.record.chartEffect.detailSurfaces': "Die Fl\xe4chen {{surfaces}} von Zahn {{tooth}} werden im Zahnschema als \u201E{{state}}\u201C eingetragen.",
    'visit.record.chartEffect.needsSurfaces': "W\xe4hlen Sie die behandelten Fl\xe4chen aus, sonst wird nichts im Zahnschema eingetragen.",
    'visit.record.chartEffect.surfaceOption': "Fl\xe4chen \u2013 {{state}}",
    'visit.record.chartEffect.inProgress': "Diese Sitzung schlie\xdft die Behandlung nicht ab, daher wird standardm\xe4\xdfig nichts im Zahnschema eingetragen.",
    'visit.record.billingNote': 'Abrechnung und Lagerentnahme werden nach diesem Eintrag getrennt erfasst; dieses Formular erfasst keinen Betrag.',
    'visit.record.save': 'Erfassen',
    'visit.record.saved': "\u201E{{what}}\u201C wurde erfasst.",
    'visit.record.failed': 'Die Behandlung konnte nicht erfasst werden.',
    'visit.record.doneHere': "In dieser Sitzung durchgef\xfchrt ({{count}})",
    'visit.record.void': 'Stornieren',
    'visit.record.voidReason': 'Stornogrund',
    'visit.record.voidedFor': "Storniert \u2013 {{reason}}",
    'visit.record.voidConfirm.title': "\u201E{{what}}\u201C stornieren?",
    'visit.record.voidConfirm.body': "Der Eintrag wird nicht gel\xf6scht: Er bleibt durchgestrichen und mit dem von Ihnen angegebenen Grund in der Akte. Ein Grund ist erforderlich.",
    'visit.record.notBilled': 'Nicht abgerechnet',
    'visit.record.voidConfirm.alsoChart': "Auch den Eintrag f\xfcr Zahn {{tooth}} im Zahnschema stornieren",
    'visit.record.voidConfirm.stillBilled': "Diese Behandlung ist bereits auf der Rechnung des Patienten berechnet. Beim Stornieren wird der Betrag automatisch zur\xfcckgenommen \u2013 als negative Korrekturposition, falls die Rechnung bereits ausgestellt wurde.",
    'visit.record.voidCharge.notReversed': 'Die Behandlung wurde storniert, der Betrag konnte jedoch nicht von der Rechnung genommen werden. Bitten Sie die Kasse, dies zu korrigieren.',
    'visit.record.billed': "Zur Rechnung dieser Sitzung hinzugef\xfcgt.",
    'visit.plan.noServices.title': 'Diese Praxis hat noch keine Leistungen definiert',
    'visit.plan.noServices.body': "Die Positionen des Behandlungsplans stammen aus den Leistungen der Praxis. Definieren Sie die zahn\xe4rztlichen Leistungen im Praxisbereich und legen Sie ihre Geb\xfchren fest.",
    'visit.plan.noServices.action': 'Leistungen im Praxisbereich definieren',
    'visit.plan.catalogUnavailable': "Die Leistungsliste der Praxis konnte nicht gelesen werden. Das bedeutet nicht, dass keine vorhanden sind \u2013 versuchen Sie es erneut.",
    'visit.plan.applicability.unset': 'Nicht angegeben',
    'visit.plan.applicability.tooth': 'Ein Zahn',
    'visit.plan.applicability.surfaces': "Fl\xe4chen eines Zahns",
    'visit.plan.applicability.quadrant': 'Ein Quadrant',
    'visit.plan.applicability.arch': 'Ein Kiefer',
    'visit.plan.applicability.mouth': 'Gesamtgebiss',
    'visit.plan.newService.title': 'Neue Leistung',
    'visit.plan.newService.subtitle': "Wird zu den Leistungen der Praxis hinzugef\xfcgt und steht ab dann dem gesamten Team zur Auswahl.",
    'visit.plan.newService.name': 'Name der Leistung',
    'visit.plan.newService.category': 'Gruppe',
    'visit.plan.newService.chartEffect': 'Auswirkung auf das Zahnschema',
    'visit.plan.newService.applicability': "Gilt f\xfcr",
    'visit.plan.newService.tariff': "Geb\xfchr pro Sitzung ({{unit}})",
    'visit.plan.newService.duration': 'Minuten pro Sitzung',
    'visit.plan.newService.tariffHint': "Die Geb\xfchr kann leer bleiben; die Leistung wird ohne Geb\xfchr gespeichert und erst abgerechnet, wenn eine festgelegt ist.",
    'visit.plan.newService.clinicOnly.title': "Wird im Praxisbereich vervollst\xe4ndigt",
    'visit.plan.newService.clinicOnly.body': 'Verbrauchsmaterial, sonstige Kosten, Anteil und Versicherung.',
    'visit.plan.newService.save': "Speichern und ausw\xe4hlen",
    'visit.plan.newService.created': "\u201E{{name}}\u201C wurde zu den Leistungen der Praxis hinzugef\xfcgt.",
    'visit.plan.newService.nameRequired': 'Der Name der Leistung ist erforderlich.',
    'visit.plan.newService.failed': 'Die Leistung konnte nicht gespeichert werden.',
    'visit.plan.newService.badTariff': "Die Geb\xfchr muss eine Zahl in {{unit}} sein.",
    'visit.plan.newService.currencyUnknown': "Die W\xe4hrung dieser Praxis konnte nicht gelesen werden, daher kann die Geb\xfchr hier nicht eingegeben werden. Die Leistung wird ohne Geb\xfchr gespeichert; legen Sie die Geb\xfchr im Praxisbereich fest.",
    'visit.plan.noClinic': "Diese Sitzung ist keiner Praxis zugeordnet; ohne Praxis k\xf6nnen Leistungen und Geb\xfchren nicht gelesen werden.",
    'common.form.optional': '(optional)',
    'visit.plan.locked': 'Unterschrieben',
    'visit.plan.startNew': 'Neuen Behandlungszyklus beginnen',
    'visit.plan.lockedNextStep': "Wenn Sie eine Ma\xdfnahme hinzuf\xfcgen, beginnt ein neuer Behandlungszyklus.",
    'visit.plan.lockedNote': "Dieser Plan wurde genehmigt und unterschrieben, daher k\xf6nnen seine Positionen nicht mehr ge\xe4ndert werden. Ma\xdfnahmen k\xf6nnen weiterhin als durchgef\xfchrt markiert werden.",
    'visit.plan.phases.emergency': 'Akutbehandlung',
    'visit.plan.phases.phase1': 'Phase 1',
    'visit.plan.phases.phase2': 'Phase 2',
    'visit.plan.phases.maintenance': 'Erhaltungsphase',
    'visit.plan.status.proposed': 'Vorgeschlagen',
    'visit.plan.status.accepted': 'Angenommen',
    'visit.plan.status.done': "Durchgef\xfchrt",
    'visit.plan.status.rejected': 'Abgelehnt',
    'visit.plan.status.deferred': "Zur\xfcckgestellt",
    'visit.plan.planStatus.draft': 'Entwurf',
    'visit.plan.planStatus.proposed': 'Vorgeschlagen',
    'visit.plan.planStatus.approved': 'Genehmigt',
    'visit.plan.planStatus.in_progress': 'In Bearbeitung',
    'visit.plan.planStatus.completed': 'Abgeschlossen',
    'visit.plan.planStatus.abandoned': 'Abgebrochen',
    // ── §3.2.1 medication ───────────────────────────────────────────────────
    'visit.meds.empty.title': 'Noch nichts verordnet',
    'visit.meds.empty.description': "Suchen Sie oben im Arzneimittelverzeichnis, um dieser Sitzung ein Medikament hinzuzuf\xfcgen.",
    'visit.meds.thisVisit': 'In dieser Sitzung verordnet',
    'visit.meds.current': 'Aktuelle Medikation',
    'visit.meds.suggest': "KI-Vorschl\xe4ge",
    'visit.meds.suggesting': "Wird analysiert\u2026",
    'visit.meds.suggestions': 'Vorgeschlagene Medikamente',
    'visit.meds.suggestClose': "Vorschl\xe4ge ausblenden",
    'visit.meds.suggestAdd': "Zum Rezept hinzuf\xfcgen",
    'visit.meds.suggestAdded': "Hinzugef\xfcgt",
    'visit.meds.noSuggestions': "Keine Vorschl\xe4ge. Erfassen Sie zuerst die Diagnose oder Beurteilung dieser Sitzung \u2013 die Analyse st\xfctzt sich auf das, was f\xfcr diese Sitzung dokumentiert wurde.",
    'visit.meds.suggestUnavailable': "KI-Vorschl\xe4ge sind nicht verf\xfcgbar.",
    'visit.meds.followUp': 'Wiedervorstellung:',
    // ── §3.2.2 orders — dental lab and imaging only ─────────────────────────
    'visit.orders.error.title': 'Anordnungen konnten nicht geladen werden',
    'visit.orders.error.body': 'Die Anordnungen dieser Sitzung konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',
    'visit.orders.saveFailed': 'Die Anordnung konnte nicht gespeichert werden.',
    'visit.orders.empty.title': 'Keine Anordnungen in dieser Sitzung',
    'visit.orders.empty.description': "Fordern Sie eine R\xf6ntgenaufnahme an oder senden Sie einen Fall an das Dentallabor.",
    'visit.orders.type': 'Art der Anordnung',
    'visit.orders.types.imaging': 'Bildgebung',
    'visit.orders.types.lab': 'Labor',
    'visit.orders.types.dental_lab': 'Dentallabor',
    'visit.orders.service': 'Leistung',
    'visit.orders.serviceScope': "Nur Leistungen der Art \u201E{{type}}\u201C",
    'visit.orders.choose': "Leistung ausw\xe4hlen\u2026",
    'visit.orders.description': 'Beschreibung',
    'visit.orders.descriptionHint': 'Leer lassen, um den Namen der Leistung zu verwenden',
    'visit.orders.notes': "Hinweise f\xfcr Labor / Radiologie",
    'visit.orders.urgency': 'Dringlichkeit',
    'visit.orders.urgencies.routine': 'Routine',
    'visit.orders.urgencies.urgent': 'Dringend',
    'visit.orders.urgencies.stat': 'Notfall',
    'visit.orders.sessions': 'Anzahl der Sitzungen',
    'visit.orders.sessionCount': 'Sitzungen: {{count}}',
    'visit.orders.add': 'Anordnung erfassen',
    'visit.orders.statuses.pending': 'Ausstehend',
    'visit.orders.statuses.in_progress': 'In Bearbeitung',
    'visit.orders.statuses.completed': 'Abgeschlossen',
    'visit.orders.statuses.cancelled': 'Annulliert',
    'visit.orders.transitions.start': 'Beginnen',
    'visit.orders.transitions.complete': 'Als erledigt markieren',
    'visit.orders.transitions.cancel': 'Annullieren',
    'visit.orders.suggest': "KI-Vorschl\xe4ge",
    'visit.orders.suggesting': "Wird analysiert\u2026",
    'visit.orders.suggestions': 'Vorgeschlagene Anordnungen',
    'visit.orders.suggestClose': "Vorschl\xe4ge ausblenden",
    'visit.orders.suggestAdd': 'Anordnung erfassen',
    'visit.orders.suggestAdded': 'Erfasst',
    'visit.orders.noSuggestions': "Keine Vorschl\xe4ge. Erfassen Sie zuerst die Diagnose oder Beurteilung dieser Sitzung \u2013 die Analyse st\xfctzt sich auf das, was f\xfcr diese Sitzung dokumentiert wurde.",
    'visit.orders.suggestUnavailable': "KI-Vorschl\xe4ge sind nicht verf\xfcgbar.",
    'visit.orders.suggestDropped': "Vorschl\xe4ge au\xdferhalb des zahn\xe4rztlichen Leistungskatalogs, nicht angezeigt: {{count}}",
    // ── §3.2.3 diagnosis, with click-to-reveal traceability ─────────────────
    'visit.diagnosis.error.title': 'Diagnosen konnten nicht geladen werden',
    'visit.diagnosis.error.body': 'Die Diagnosen dieser Sitzung konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',
    'visit.diagnosis.saveFailed': 'Die Diagnose konnte nicht gespeichert werden.',
    'visit.diagnosis.empty.title': 'Keine Diagnose erfasst',
    'visit.diagnosis.empty.description': 'Erfassen Sie Ihre Schlussfolgerung; die Befunde, auf denen sie beruht, werden mit ihr gespeichert.',
    'visit.diagnosis.name': 'Diagnose',
    'visit.diagnosis.code': 'ICD-Code',
    'visit.diagnosis.certainty': 'Diagnosesicherheit',
    'visit.diagnosis.verification.provisional': 'Verdacht',
    'visit.diagnosis.verification.confirmed': 'Gesichert',
    'visit.diagnosis.add': 'Diagnose erfassen',
    'visit.diagnosis.remove': '{{name}} entfernen',
    'visit.diagnosis.willAttach': "St\xfctzende Befunde, die mit dieser Diagnose gespeichert werden: {{count}}",
    'visit.diagnosis.evidence': 'Belege ({{count}})',
    'visit.diagnosis.noEvidence': "Zu dieser Diagnose wurden keine st\xfctzenden Befunde erfasst.",
    'visit.diagnosis.evidenceKind.subjective': 'Anamnese',
    'visit.diagnosis.evidenceKind.history': 'Vorgeschichte',
    'visit.diagnosis.evidenceKind.chart': 'Zahnschema',
    'visit.diagnosis.evidenceKind.file': 'Dokument',
    'visit.diagnosis.evidenceKind.order': 'Anordnung',
    'visit.diagnosis.evidenceKind.ai': 'KI-Analyse',
    'visit.diagnosis.showTooth': 'Zahn anzeigen',
    'visit.diagnosis.toothEvidence': 'Befunde an Zahn {{fdi}}',
    'visit.diagnosis.aiAssisted': "KI-gest\xfctzt",
    'visit.diagnosis.suggest': "KI-Vorschl\xe4ge",
    'visit.diagnosis.suggesting': "Wird analysiert\u2026",
    'visit.diagnosis.suggestions': 'Vorgeschlagene Diagnosen',
    'visit.diagnosis.noSuggestions': "Keine Vorschl\xe4ge. Erfassen Sie zuerst die Anamnese \u2013 die Analyse st\xfctzt sich auf das, was f\xfcr diese Sitzung dokumentiert wurde.",
    'visit.diagnosis.suggestUnavailable': "KI-Vorschl\xe4ge sind derzeit nicht verf\xfcgbar.",
    'visit.diagnosis.accept': 'Erfassen',
    'visit.diagnosis.alreadyRecorded': 'Erfasst',
    'visit.diagnosis.confidence.high': 'Hohe Konfidenz',
    'visit.diagnosis.confidence.medium': 'Mittlere Konfidenz',
    'visit.diagnosis.confidence.low': 'Geringe Konfidenz',
    // ── SOAP assistant — the diagnosis tab ──────────────────────────────────
    'visit.soap.title': 'Dokumentationsassistent',
    'visit.soap.description': "Schildern Sie, was in der Sitzung geschehen ist; wenn Sie stoppen, erg\xe4nzt der Assistent die Abschnitte der Dokumentation und gibt Empfehlungen zum Problem. Nichts wird erfasst, bevor Sie es best\xe4tigen.",
    'visit.soap.speak': 'Sitzung diktieren',
    'visit.soap.speakStop': 'Beenden und Empfehlungen erhalten',
    'visit.soap.analyzing': "Wird analysiert\u2026",
    'visit.soap.heard': 'Erkannter Text:',
    'visit.soap.retry': 'Erneut senden',
    'visit.soap.voiceUnavailable': "Das Diktat erfordert ein Mikrofon und eine sichere Verbindung (HTTPS) und ist in diesem Browser nicht verf\xfcgbar.",
    'visit.soap.draftTitle': 'Vorgeschlagener Entwurf der Dokumentation',
    'visit.soap.sections.s': "Anamnese (S) \u2013 wird den Notizen angef\xfcgt",
    'visit.soap.sections.o': 'Untersuchung und Befund (O)',
    'visit.soap.sections.a': 'Beurteilung (A)',
    'visit.soap.sections.p': 'Plan (P)',
    'visit.soap.apply': "In die Dokumentation \xfcbernehmen",
    'visit.soap.applied': "In die Dokumentation \xfcbernommen.",
    'visit.soap.applyFailed': "Der Entwurf konnte nicht \xfcbernommen werden.",
    'visit.soap.dismiss': 'Verwerfen',
    'visit.soap.noNews': "Nichts Neues f\xfcr die Dokumentation.",
    'visit.soap.refineUnavailable': "Die Vervollst\xe4ndigung der Dokumentation ist nicht verf\xfcgbar.",
    'visit.soap.adviceTitle': 'Empfehlungen des Assistenten',
    'visit.soap.adviceUnavailable': "KI-Empfehlungen sind nicht verf\xfcgbar.",
    'visit.soap.suggestedDiagnosis': 'Vorgeschlagene Diagnose',
    'visit.soap.recordDiagnosis': 'Als Diagnose erfassen',
    'visit.soap.accepted': "\xdcbernommen \u2013 in den Diagnosen dieser Sitzung erfasst.",
    'visit.soap.actions': "Vorgeschlagene Ma\xdfnahmen",
    'visit.soap.medications': 'Vorgeschlagene Medikamente',
    'visit.soap.aiEvidence': 'Abgeleitet aus der Analyse der Sitzungsschilderung',
    // ── Per-tooth findings from the narrative → the dental chart ──────────────
    'visit.soap.teeth.title': 'Zahnbefunde',
    'visit.soap.teeth.description': "Diese Angaben wurden aus der Sitzungsschilderung bestimmten Z\xe4hnen zugeordnet. Was Sie best\xe4tigen, wird im Zahnschema erfasst; der Rest wird nicht erfasst.",
    'visit.soap.teeth.lowConfidenceHint': "Zeilen mit geringer Konfidenz sind nicht vorausgew\xe4hlt \u2013 pr\xfcfen Sie die Zahnnummer vor dem Erfassen.",
    'visit.soap.teeth.tooth': 'Zahn {{fdi}}',
    'visit.soap.teeth.surface': "Fl\xe4che {{surface}}",
    'visit.soap.teeth.historical': 'Vorbestehend',
    'visit.soap.teeth.record': 'Im Zahnschema erfassen ({{count}})',
    'visit.soap.teeth.recording': "Wird erfasst\u2026",
    'visit.soap.teeth.recorded': 'Im Zahnschema erfasst.',
    'visit.soap.teeth.recordFailed': 'Die Befunde konnten nicht im Zahnschema erfasst werden.',
    'visit.soap.teeth.none': 'In der Schilderung wurde kein Befund zu einem bestimmten Zahn gefunden.',
    'visit.soap.teeth.unavailable': "Das Auslesen von Zahnbefunden ist nicht verf\xfcgbar.",
    'visit.soap.teeth.confidence.high': 'Hohe Konfidenz',
    'visit.soap.teeth.confidence.medium': 'Mittlere Konfidenz',
    'visit.soap.teeth.confidence.low': 'Geringe Konfidenz',
    'tooth.aspect.presence': 'Vorhandensein des Zahns',
    'tooth.aspect.condition': 'Zahnzustand',
    'tooth.aspect.surface': "Zustand der Fl\xe4che",
    'tooth.value.sound': 'Gesund',
    'tooth.value.caries': 'Karies',
    'tooth.value.root_canal': "Wurzelgef\xfcllt",
    'tooth.value.post_core': 'Stiftaufbau',
    'tooth.value.crown': 'Krone',
    'tooth.value.veneer': 'Veneer',
    'tooth.value.implant': 'Implantat',
    'tooth.value.bridge_abutment': "Br\xfcckenpfeiler",
    'tooth.value.bridge_pontic': "Br\xfcckenglied",
    'tooth.value.fracture': 'Fraktur',
    'tooth.value.attrition': 'Attrition',
    'tooth.value.mobility': 'Zahnlockerung',
    'tooth.value.periapical_lesion': "Apikale L\xe4sion",
    'tooth.value.sealant': 'Fissurenversiegelung',
    'tooth.value.temporary': 'Provisorisch',
    'tooth.value.watch': 'Zu beobachten',
    'tooth.value.restoration': "F\xfcllung",
    'tooth.value.recurrent_caries': "Sekund\xe4rkaries",
    'tooth.value.fractured': 'Frakturiert',
    'tooth.value.present': 'Vorhanden',
    'tooth.value.extracted': 'Extrahiert',
    'tooth.value.exfoliated': 'Ausgefallen',
    'tooth.value.congenitally_absent': 'Nicht angelegt',
    'tooth.value.unerupted': 'Nicht durchgebrochen',
    'tooth.value.impacted': 'Retiniert',
    'tooth.material.composite': 'Komposit',
    'tooth.material.amalgam': 'Amalgam',
    'tooth.material.glass_ionomer': 'Glasionomerzement',
    'tooth.material.zirconia': 'Zirkonoxid',
    'tooth.material.pfm': 'VMK',
    'tooth.material.full_metal': 'Vollguss (NEM)',
    'tooth.material.emax': 'E.max',
    'tooth.material.temporary': 'Provisorisch',
    'tooth.material.gold': 'Gold',
    // ── §3.2.4 questions — the clinical assistant ───────────────────────────
    'visit.questions.title': 'Klinischer Assistent',
    'visit.questions.forDiagnoses': "Fragen zur Best\xe4tigung oder zum Ausschluss: {{list}}",
    'visit.questions.noDiagnosesYet': "Noch keine Diagnose erfasst \u2013 der Assistent stellt Fragen zum dokumentierten Vorstellungsgrund.",
    'visit.questions.generate': "L\xfccken finden",
    'visit.questions.generating': "Wird gepr\xfcft\u2026",
    'visit.questions.unavailable': "Der klinische Assistent ist derzeit nicht verf\xfcgbar.",
    'visit.questions.fallbackNote': "Dies sind allgemeine Fragen, nicht speziell f\xfcr diesen Patienten formuliert.",
    'visit.questions.empty.title': 'Keine offenen Fragen',
    'visit.questions.empty.description': "F\xfcr die aktuellen Diagnosen ist nichts weiter erforderlich.",
    'visit.questions.count': 'Fragen: {{count}}',
    'visit.questions.yes': 'Ja',
    'visit.questions.no': 'Nein',
    'visit.questions.recorded': 'Erfasst: {{statement}}',
    'visit.questions.recordFailed': 'Die Antwort konnte nicht in der Anamnese erfasst werden.',
    'visit.questions.askTitle': 'Assistent fragen',
    'visit.questions.askPlaceholder': "Frage zu diesem Patienten\u2026",
    'visit.questions.ask': 'Fragen',
    'visit.questions.asking': "Frage wird gesendet\u2026",
    'visit.questions.followUps': "M\xf6gliche Anschlussfragen",
    // ── §3.2.5 files, and the report each one produced ──────────────────────
    // ── فایل‌ها: what kind of thing is being uploaded ────────────────────────
    'visit.files.kind': 'Was ist das?',
    'visit.files.kinds.image': "Zahn\xe4rztliche Aufnahme",
    'visit.files.kinds.document': 'Dokument',
    'visit.files.viewType': 'Aufnahmeart',
    'visit.files.viewTypes.periapical': 'Zahnfilm',
    'visit.files.viewTypes.bitewing': "Bissfl\xfcgelaufnahme",
    'visit.files.viewTypes.panoramic': 'Panoramaaufnahme (OPG)',
    'visit.files.viewTypes.ceph': "Fernr\xf6ntgenseitenbild (FRS)",
    'visit.files.viewTypes.photo': 'Foto',
    'visit.files.plainUploadNote': 'Beim Hochladen wird die Datei nur gespeichert. Texterkennung und Bildauswertung sind separate Aktionen.',
    'visit.files.unsupportedImage': 'Dieses Bildformat kann nicht angezeigt werden. Verwenden Sie JPEG oder PNG.',
    'visit.files.openImage': "Bild \xf6ffnen",
    'visit.files.extract': 'Text extrahieren',
    'visit.files.extracting': "Wird extrahiert\u2026",
    // ── The image workspace ─────────────────────────────────────────────────
    'visit.image.back': "Zur\xfcck zu den Dateien",
    'visit.image.tools': 'Zeichenwerkzeuge',
    'visit.image.tool.cursor': "Ausw\xe4hlen",
    'visit.image.tool.pin': 'Markierung',
    'visit.image.tool.box': 'Rechteck',
    'visit.image.tool.ellipse': 'Kreis',
    'visit.image.tool.arrow': 'Pfeil',
    'visit.image.tool.freehand': 'Freihand',
    'visit.image.color': 'Stiftfarbe',
    'visit.image.colorName.E11D48': 'Rot',
    'visit.image.colorName.F59E0B': 'Bernstein',
    'visit.image.colorName.0EA5A0': 'Petrol',
    'visit.image.colorName.2563EB': 'Blau',
    'visit.image.zoomIn': "Vergr\xf6\xdfern",
    'visit.image.zoomOut': 'Verkleinern',
    'visit.image.fit': "Ansicht zur\xfccksetzen",
    'visit.image.brightness': 'Helligkeit',
    'visit.image.contrast': 'Kontrast',
    'visit.image.read': 'Bild auswerten',
    'visit.image.reading': "Wird ausgewertet\u2026",
    'visit.image.readStatus.no_findings': 'Der Assistent hat in diesem Bild nichts Berichtenswertes gefunden. Es wurde nichts abgebucht.',
    'visit.image.readStatus.no_image': 'Das Bild konnte nicht gelesen werden.',
    'visit.image.comment': 'Notiz zu dieser Markierung',
    'visit.image.commentPlaceholder': 'Was haben Sie hier gesehen?',
    'visit.image.removeMark': "Diese Markierung l\xf6schen",
    'visit.image.tooManyMarks': "Ein Bild kann h\xf6chstens {{max}} Markierungen enthalten.",
    'visit.image.saveFailed': 'Die Markierungen konnten nicht gespeichert werden.',
    'visit.image.unsaved': "Nicht gespeicherte Markierungen \u2013 klicken Sie auf \u201ESpeichern\u201C.",
    'visit.image.findings': 'Vom Assistenten erkannt',
    'visit.image.findingsNote': "Vorschl\xe4ge. Nichts wird im Zahnschema erfasst, bevor Sie es best\xe4tigen.",
    'visit.image.confidence.high': 'Eindeutig',
    'visit.image.confidence.medium': 'Wahrscheinlich',
    'visit.image.confidence.low': 'Unsicher',
    'visit.image.notLocalized': 'Lage nicht ermittelt',
    'visit.image.unlocalizedNote': 'Befunde, die nicht im Bild verortet werden konnten und nur aufgelistet sind: {{count}}',
    'visit.image.confirm': "Best\xe4tigen",
    'visit.files.openFile': "Datei \xf6ffnen",
    'visit.image.register': 'Erfassen',
    'visit.image.registering': "Wird erfasst\u2026",
    'visit.image.notRegistered.title': "Nicht als zahn\xe4rztliche Aufnahme erfasst",
    'visit.image.notRegistered.body': "Sie k\xf6nnen die Datei ansehen. Zum Markieren und zur Auswertung durch den Assistenten ist eine Aufnahmeart erforderlich \u2013 eine Bissfl\xfcgelaufnahme und ein Foto zeigen nicht dasselbe.",
    'visit.image.changeView': "Aufnahmeart \xe4ndern",
    'visit.image.viewType.title': 'Aufnahmeart',
    'visit.image.viewType.body': "Davon h\xe4ngt ab, was der Assistent melden darf \u2013 eine Bissfl\xfcgelaufnahme zeigt keine apikale L\xe4sion, und ein Foto zeigt keinen Knochen. Korrigieren Sie die Angabe, falls sie falsch ist.",
    'visit.image.discard.title': 'Gezeichnete Markierungen verwerfen?',
    'visit.image.discard.body': 'Sie wurden nicht gespeichert, und es gibt keine weitere Kopie davon.',
    'visit.image.discard.confirm': 'Verwerfen',
    'visit.files.error.title': 'Dateien konnten nicht geladen werden',
    'visit.files.error.body': 'Die Dokumente dieses Patienten konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',
    'visit.files.empty.title': 'Keine Dokumente',
    'visit.files.empty.description': "Laden Sie eine R\xf6ntgenaufnahme, einen Laborbefund oder ein \xdcberweisungsschreiben hoch.",
    'visit.files.upload': 'Dokument hochladen',
    'visit.files.uploading': "Wird hochgeladen\u2026",
    'visit.files.uploadFailed': 'Das Dokument konnte nicht hochgeladen werden.',
    'visit.files.readFailed': 'Die Datei konnte nicht gelesen werden.',
    'visit.files.tooLarge': "Die Datei ist gr\xf6\xdfer als 15\xa0MB.",
    'visit.files.docType': 'Dokumenttyp',
    'visit.files.docTypes.lab_report': 'Laborbefund',
    'visit.files.docTypes.prescription': 'Rezept',
    'visit.files.docTypes.general': 'Sonstiges',
    'visit.files.attachTooth': 'Zahn {{fdi}} zuordnen',
    'visit.files.thisVisit': 'Diese Sitzung',
    'visit.files.hasReport': 'Bericht',
    'visit.files.noReport': 'Aus diesem Dokument wurde kein Bericht extrahiert.',
    'visit.files.previewFailed': "Die Datei konnte nicht ge\xf6ffnet werden.",
    'visit.files.bytesGone': 'Die Originaldatei ist nicht mehr gespeichert; nur ihr Bericht ist noch vorhanden.',
    'visit.files.remove': "{{name}} l\xf6schen",
    'visit.files.units.b': 'B',
    'visit.files.units.kb': 'KB',
    'visit.files.units.mb': 'MB',
    // ── credits (اعتبار) ──────────────────────────────────────────────────────
    'credits.title': 'Parseh-Guthaben',
    'credits.subtitle': "Ihr Parseh-Guthaben, wof\xfcr es verwendet wurde und wie Sie es aufladen.",
    'credits.unit': 'Parseh',
    'credits.toman': 'Toman',
    'credits.tomanShort': 'T',
    'credits.currentBalance': 'Aktuelles Guthaben',
    'credits.buy': 'Parseh kaufen',
    'credits.topUp': 'Aufladen',
    'credits.percent': "{{value}}\xa0%",
    'credits.timesUsed': "{{count}}\xd7",
    'credits.itemCount': "Eintr\xe4ge: {{count}}",
    'credits.minutesUsed': "{{count}}\xa0Min.",
    'credits.byService': "Wof\xfcr verwendet",
    'credits.transactions': "Ums\xe4tze",
    'credits.level.low': 'Niedriges Guthaben',
    'credits.level.lowShort': 'Niedrig',
    'credits.level.mid': 'Guthaben wird knapp',
    'credits.level.midShort': "M\xe4\xdfig",
    'credits.level.ok': 'Ausreichendes Guthaben',
    'credits.level.okShort': 'Gut',
    'credits.banner.low': 'Nur noch {{coins}} Parseh. Der Assistent stoppt, sobald das Guthaben aufgebraucht ist.',
    'credits.banner.mid': "Noch {{coins}} Parseh \u2013 genug f\xfcr einige weitere Sitzungen.",
    'credits.service.assistant': 'Klinischer Assistent',
    'credits.service.interaction': "Wechselwirkungspr\xfcfung",
    'credits.service.transcription': 'Transkription',
    'credits.service.topUp': 'Aufladung',
    'credits.service.gift': 'Geschenkcode',
    'credits.service.sms': 'SMS',
    'credits.service.ai': 'KI-Dienst',
    'credits.filter.label': "Ums\xe4tze filtern",
    'credits.filter.all': 'Alle',
    'credits.filter.spend': 'Abgebucht',
    'credits.filter.topUp': 'Aufgeladen',
    'credits.group.label': 'Gruppieren nach',
    'credits.group.day': 'Tag',
    'credits.group.type': 'Dienst',
    'credits.range.label': 'Zeitraum',
    'credits.range.all': 'Gesamter Zeitraum',
    'credits.range.days7': 'Letzte 7 Tage',
    'credits.range.days30': 'Letzte 30 Tage',
    'credits.range.thisMonth': 'Dieser Monat',
    'credits.time.today': 'Heute',
    'credits.time.yesterday': 'Gestern',
    'credits.kpi.month': 'Verbrauch diesen Monat',
    'credits.kpi.perVisit': 'Pro Sitzung',
    'credits.kpi.topService': "Gr\xf6\xdfter Posten",
    'credits.showingRange': "Angezeigt: {{from}}\u2013{{to}} von {{total}}",
    'credits.pager.page': 'Seite {{page}} von {{total}}',
    'credits.pager.previous': "Zur\xfcck",
    'credits.pager.next': 'Weiter',
    'credits.empty.title': "Noch keine Ums\xe4tze",
    'credits.empty.hint': 'Jede Aktion des Assistenten in einer Sitzung erscheint hier.',
    'credits.empty.filtered': "Keine Ums\xe4tze in diesem Zeitraum",
    'credits.empty.filteredHint': "W\xe4hlen Sie einen gr\xf6\xdferen Zeitraum oder einen anderen Filter.",
    'credits.error.title': "Ums\xe4tze nicht verf\xfcgbar",
    'credits.error.body': 'Ihr Guthaben konnte nicht gelesen werden. Es wurde nichts abgebucht.',
    'credits.priceList.title': 'Was jede Aktion kostet',
    'credits.priceList.hint': "Abgebucht wird nur, wenn Sie die Schaltfl\xe4che dr\xfccken \u2013 nichts startet von selbst.",
    'credits.priceList.viewAll': 'Alle anzeigen',
    'credits.price.transcription': 'Diktat (Spracherkennung)',
    'credits.price.differential': 'KI-Diagnosevorschlag',
    'credits.price.advice': 'Empfehlungen des Assistenten',
    'credits.price.soap': "Dokumentation vervollst\xe4ndigen",
    'credits.price.teeth': 'Zahnbefunde aus der Sitzungsbeschreibung',
    'credits.price.confirmq': "R\xfcckfragen zur Best\xe4tigung",
    'credits.price.ask': 'Assistent fragen',
    'credits.price.ocr': 'Hochgeladenes Dokument auslesen',
    'credits.price.interaction': "Wechselwirkungspr\xfcfung",
    'credits.topUp.chooseAmount': "Betrag w\xe4hlen",
    'credits.topUp.recommended': 'Empfohlen',
    'credits.topUp.approxVisits': 'Sitzungen mit dem Assistenten: ca. {{count}}',
    'credits.topUp.custom': 'Anderer Betrag',
    'credits.topUp.customAria': 'Betrag',
    'credits.topUp.payVia': "{{amount}} Toman \xfcber {{gateway}} bezahlen",
    'credits.topUp.enterAmount': 'Betrag eingeben',
    'credits.topUp.redirecting': "Weiterleitung zum Zahlungsanbieter\u2026",
    'credits.topUp.redirectNote': "Sie werden zum Zahlungsportal der Bank weitergeleitet und anschlie\xdfend hierher zur\xfcckgef\xfchrt.",
    'credits.topUp.minimum': "Der Mindestbetrag betr\xe4gt {{amount}} Toman.",
    'credits.topUp.failed': 'Die Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
    'credits.topUp.failedWithReason': 'Die Zahlung konnte nicht gestartet werden: {{reason}}',
    'credits.gateway.saderat': 'Bank Saderat',
    'credits.gateway.zarinpal': 'Zarinpal',
    'credits.payment.done': "Zahlung erfolgreich \u2013 Ihr Guthaben wurde aufgeladen.",
    'credits.payment.failed': 'Die Zahlung ist nicht zustande gekommen. Es wurde nichts abgebucht.',
    'credits.gift.title': 'Geschenkcode',
    'credits.gift.hint': "Haben Sie einen Code aus einer Parsina-Aktion? Geben Sie ihn hier ein \u2013 der Parseh-Betrag wird Ihrem Guthaben hinzugef\xfcgt.",
    'credits.gift.placeholder': 'PARSINA-1404-XXXX',
    'credits.gift.submit': "Einl\xf6sen",
    'credits.gift.submitting': "Wird eingel\xf6st\u2026",
    'credits.gift.empty': 'Geben Sie zuerst den Code ein.',
    'credits.gift.notFound': "Dieser Code ist ung\xfcltig. Geben Sie ihn genau so ein, wie Sie ihn erhalten haben.",
    'credits.gift.oneUse': 'Jeder Code kann nur einmal verwendet werden.',
    'credits.gift.success': "{{parseh}} Parseh hinzugef\xfcgt",
    'credits.gift.successSub': 'Sitzungen mit dem Assistenten: ca. {{visits}}.',
    'credits.gift.newBalance': 'Neues Guthaben',
    'credits.gift.myCodes': 'Ihre Codes',
    'credits.gift.worth': "{{parseh}} Parseh \u2013 Sitzungen: ca. {{visits}}",
    'credits.gift.status.issued': 'Unbenutzt',
    'credits.gift.status.redeemed': "Eingel\xf6st",
    'credits.gift.status.revoked': 'Widerrufen',
    'credits.gift.status.expired': 'Abgelaufen',
    'credits.lowBalance.title': 'Warnung bei niedrigem Guthaben',
    'credits.lowBalance.hint': "Wir benachrichtigen Sie, wenn Ihr Guthaben unter diesen Wert f\xe4llt.",
    'credits.lowBalance.toggleAria': 'Warnungen bei niedrigem Guthaben aktivieren',
    'credits.lowBalance.thresholdAria': 'Warnschwelle in Parseh',
    'credits.lowBalance.active': "Sie werden gewarnt, wenn Ihr Guthaben unter {{coins}} Parseh f\xe4llt.",
    'credits.lowBalance.off': 'Warnungen sind deaktiviert.',
    'credits.lowBalance.invalid': "Geben Sie einen g\xfcltigen Schwellenwert ein.",
    'credits.lowBalance.saved': 'Warneinstellungen gespeichert.',
    'credits.lowBalance.failed': 'Die Warneinstellungen konnten nicht gespeichert werden.'
};


const $2edfa6dc91a2e944$export$19b86c51217a817c = {
    en: $6ecdd4f2fd8400bc$export$84584c2a98eb6753,
    fa: $04d49d2d0d0e0cec$export$48a262eaf0aadda2,
    fr: $63d59e529dc08206$export$acb2a88f7d552ebf,
    de: $89c0b7497ce84fc9$export$2fa162a495d26869
};


// Locale-aware formatting.
//
// Every number, date and clock the dentist reads goes through here. Two rules
// this file exists to enforce:
//
//   1. NOTHING hardcodes Persian digits. The doctor client's `toFa()` habit
//      renders «۱۲» inside an otherwise English UI; `formatNumber` follows the
//      active locale instead.
//   2. Every date formatter pins `timeZone: 'Asia/Tehran'`. The instants on the
//      wire are UTC epochs and the clinic's day is an Iran day; formatting one
//      in the browser's zone puts a 23:30 appointment on the wrong date for a
//      dentist travelling, and on the right one at home — the worst kind of bug.
//
// Jalali comes from the locale tag (`-u-ca-persian`), never from an `if`: one
// code path renders both calendars, so they cannot drift.
// The ISO-day shape is imported rather than re-declared: lib/iranTime.js owns
// what "a calendar day on the wire" looks like, and this module has to agree
// with it about which strings get the noon-UTC anchor below.
// Iran local time — the ONE place this client turns an epoch into a calendar day
// or a wall clock.
//
// The platform rule: EPOCH MILLISECONDS on the wire, everywhere, always
// (GraphQL carries them as strings because GraphQL Int is 32-bit). Iran local
// time exists only where a *day boundary* or a *wall clock* is needed. The
// scheduling service and parsina.bff.dentist compute the same boundary with the
// same offset; if this file drifts from them, the day sheet and the day it asks
// for stop being the same day.
//
// Pure and React-free on purpose — tests/iranTime.test.js calls it directly.
// UTC+3:30. Iran abolished DST in 2022, so this is a constant, not a lookup.
// Taken from the framework rather than re-declared: two copies of an offset is
// how a day sheet ends up half an hour wide.

const $6e94fc1378f3a785$export$33df4d54a0f76001 = /^\d{4}-\d{2}-\d{2}$/;
function $6e94fc1378f3a785$export$ceda478235320bf2(nowMs = Date.now()) {
    return new Date(nowMs + (0, $393fa4133562fea6$export$c7153f4b19854938)).toISOString().slice(0, 10);
}
function $6e94fc1378f3a785$export$29d3212020cf53a5(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return '';
    return new Date(n + (0, $393fa4133562fea6$export$c7153f4b19854938)).toISOString().slice(0, 10);
}
function $6e94fc1378f3a785$export$938a2af94a6be3bb(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return '';
    return new Date(n + (0, $393fa4133562fea6$export$c7153f4b19854938)).toISOString().slice(11, 16);
}
function $6e94fc1378f3a785$export$beb979c4570c8eb7(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return null;
    const d = new Date(n + (0, $393fa4133562fea6$export$c7153f4b19854938));
    return d.getUTCHours() * 60 + d.getUTCMinutes();
}
const $6e94fc1378f3a785$export$9bf6380b18b1be8 = (nowMs = Date.now())=>$6e94fc1378f3a785$export$beb979c4570c8eb7(nowMs);
function $6e94fc1378f3a785$export$c13cab26eb520a22(iso, days) {
    if (!$6e94fc1378f3a785$export$33df4d54a0f76001.test(iso || '')) return '';
    const ms = Date.parse(`${iso}T12:00:00Z`) + days * 86400000;
    if (Number.isNaN(ms)) return '';
    return new Date(ms).toISOString().slice(0, 10);
}
function $6e94fc1378f3a785$export$3537fc298e9336da(iso) {
    if (!$6e94fc1378f3a785$export$33df4d54a0f76001.test(iso || '')) return null;
    const ms = Date.parse(`${iso}T12:00:00Z`);
    return Number.isNaN(ms) ? null : ms;
}
function $6e94fc1378f3a785$export$4a79f0068700788b(hhmm) {
    const [h, m] = String(hhmm || '').split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
}


const $c53f9539af19d960$var$INTL_TAG = {
    // arabext = ۰۱۲۳۴۵۶۷۸۹, the digits Persian users read.
    fa: 'fa-IR-u-ca-persian-nu-arabext',
    // en-GB rather than en-US: the day-month order and the 24-hour clock match
    // what the Persian side shows, so switching language changes the words and
    // not the shape.
    en: 'en-GB',
    // French mirrors English in this panel: Gregorian, Latin digits, 24-hour.
    // Without it fr would silently take en-GB, and English month and weekday
    // names would sit inside a French UI. Groups with U+202F, decimal comma.
    fr: 'fr-FR',
    // German likewise mirrors English: Gregorian, Latin digits, 24-hour. Groups
    // thousands with '.', decimal comma.
    de: 'de-DE'
};
const $c53f9539af19d960$var$TZ = 'Asia/Tehran';
const $c53f9539af19d960$var$DATE_STYLES = {
    // «شنبه، ۲۶ تیر» / «Sat, 17 Jul»
    weekdayDayMonth: {
        weekday: 'short',
        day: 'numeric',
        month: 'long'
    },
    // «شنبه، ۲۶ تیر ۱۴۰۴» / «Saturday, 17 July 2025»
    full: {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    },
    // «۲۶ تیر» / «17 July»
    dayMonth: {
        day: 'numeric',
        month: 'long'
    },
    // «۱۴۰۴/۰۴/۲۶» / «17/07/2025»
    numeric: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }
};
/**
 * Accepts an epoch (number or the numeric strings the wire carries) or a plain
 * `YYYY-MM-DD`. A bare date is anchored at noon UTC so no timezone shift can
 * move it onto the neighbouring day.
 */ function $c53f9539af19d960$var$toDate(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'string' && (0, $6e94fc1378f3a785$export$33df4d54a0f76001).test(value)) {
        const ms = Date.parse(`${value}T12:00:00Z`);
        return Number.isNaN(ms) ? null : new Date(ms);
    }
    const n = Number(value);
    if (Number.isFinite(n) && n > 0) return new Date(n);
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? null : new Date(parsed);
}
function $c53f9539af19d960$export$c3f4cd5551df13fd(locale) {
    const tag = $c53f9539af19d960$var$INTL_TAG[locale] || $c53f9539af19d960$var$INTL_TAG.en;
    const number = new Intl.NumberFormat(tag);
    const time = new Intl.DateTimeFormat(tag, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: $c53f9539af19d960$var$TZ
    });
    const dates = Object.fromEntries(Object.entries($c53f9539af19d960$var$DATE_STYLES).map(([name, opts])=>[
            name,
            new Intl.DateTimeFormat(tag, {
                ...opts,
                timeZone: $c53f9539af19d960$var$TZ
            })
        ]));
    /** A number in the active locale's digits and grouping. */ const formatNumber = (n)=>Number.isFinite(Number(n)) ? number.format(Number(n)) : '';
    /**
   * Localise the digits inside a string that is NOT a number — a clock («۰۹:۳۰»),
   * a file number, a national id. Grouping separators would corrupt those, which
   * is why this is a different function from formatNumber.
   */ const formatDigits = (s)=>{
        if (s == null) return '';
        const zero = locale === 'fa' ? 0x06F0 : 0x0030;
        return String(s).replace(/\d/g, (d)=>String.fromCharCode(zero + Number(d)));
    };
    const formatDate = (value, style = 'weekdayDayMonth')=>{
        const d = $c53f9539af19d960$var$toDate(value);
        if (!d) return '';
        return (dates[style] || dates.weekdayDayMonth).format(d);
    };
    /** 24-hour, in Iran time, in both languages. A clinic runs on one clock. */ const formatTime = (value)=>{
        const d = $c53f9539af19d960$var$toDate(value);
        return d ? time.format(d) : '';
    };
    return {
        formatNumber: formatNumber,
        formatDigits: formatDigits,
        formatDate: formatDate,
        formatTime: formatTime
    };
}
function $c53f9539af19d960$export$3004b7ed4244ef95() {
    return typeof document !== 'undefined' && document.documentElement.getAttribute('dir') === 'ltr' ? ', ' : "\u060C ";
}
function $c53f9539af19d960$export$69b8321e9fbf06df() {
    return typeof document !== 'undefined' && document.documentElement.getAttribute('dir') === 'ltr' ? '?' : "\u061F";
}


// The translator. Pure — tests call it directly.
//
// Resolution order: active locale → the EN source catalogue → the key itself.
// A visible key in the UI is a louder defect signal than silent empty text, and
// the catalogue-parity test (tests/i18n.test.js) is what stops it reaching a
// dentist.
//
// Interpolation is `{{name}}` and nothing else. A NUMBER value is routed through
// the active locale's number formatter, so «۳ مورد» in Persian and «3 items» in
// English come from the same call and no screen has to remember to localise a
// count. Pass a STRING to opt out — a year, a national id, an ICD code.
//
// Markup interpolation is deliberately impossible: a catalogue that can inject
// elements is a catalogue that can inject an unreviewed layout.
const $56c2db411f2e97f5$var$TOKEN = /\{\{(\w+)\}\}/g;
function $56c2db411f2e97f5$export$89e29e4ab65e70a9(template, vars, formatNumber) {
    if (!vars) return template;
    return String(template).replace($56c2db411f2e97f5$var$TOKEN, (match, name)=>{
        if (!(name in vars)) return match;
        const value = vars[name];
        if (typeof value === 'number') return formatNumber ? formatNumber(value) : String(value);
        return value == null ? '' : String(value);
    });
}
function $56c2db411f2e97f5$export$6f3122ee6dbd9f46({ catalogs: catalogs, fallback: fallback, locale: locale, formatNumber: formatNumber }) {
    const active = catalogs[locale] || {};
    let plurals = null;
    try {
        plurals = new Intl.PluralRules(locale || 'en');
    } catch  {
        plurals = null;
    }
    // One plural form only, and only where a catalogue asks for it: a key with a
    // `<key>_one` sibling uses it when `count` is a NUMBER in the language's
    // `one` category («1 yr»; French «0 an», «1 an» — 0 is `one` there). Every
    // other key, and a count passed as a pre-formatted STRING, reads the bare key
    // exactly as before.
    const pick = (key, vars)=>{
        if (!plurals || typeof vars?.count !== 'number') return key;
        const one = `${key}_one`;
        if (!(one in active) && !(one in fallback)) return key;
        return plurals.select(vars.count) === 'one' ? one : key;
    };
    const t = (key, vars)=>{
        const k = pick(key, vars);
        const template = active[k] ?? fallback[k] ?? key;
        return $56c2db411f2e97f5$export$89e29e4ab65e70a9(template, vars, formatNumber);
    };
    /** For copy that is genuinely optional — render the element only if it exists. */ t.has = (key)=>key in active || key in fallback;
    return t;
}


const $a278322405d51c25$var$I18nContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $a278322405d51c25$export$ddb338179359cccc = {
    transform: 'scaleX(var(--dir-flip, 1))'
};
const $a278322405d51c25$export$3433559efc22d110 = {
    dir: 'ltr',
    style: {
        unicodeBidi: 'isolate'
    }
};
const $a278322405d51c25$export$7fc2fdc74bdf206 = (value)=>value ? 'auto' : undefined;
function $a278322405d51c25$export$a54013f0d02a8f82({ children: children }) {
    const [locale, setLocaleState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $94f36eaf2deb686d$export$df9bcabe7f932e01)(typeof localStorage !== 'undefined' ? localStorage : null, typeof navigator !== 'undefined' ? navigator.languages?.length ? navigator.languages : [
            navigator.language
        ] : []));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        document.documentElement.setAttribute('lang', locale);
        document.documentElement.setAttribute('dir', (0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[locale]);
    }, [
        locale
    ]);
    const setLocale = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        if (!(0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[next]) return;
        try {
            localStorage.setItem((0, $94f36eaf2deb686d$export$86880b4b2e1a2384), next);
        } catch  {
        /* storage off */ }
        setLocaleState(next);
    }, []);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const formatters = (0, $c53f9539af19d960$export$c3f4cd5551df13fd)(locale);
        return {
            locale: locale,
            dir: (0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[locale],
            isRTL: (0, $94f36eaf2deb686d$export$4c4b683c586ca56e)[locale] === 'rtl',
            setLocale: setLocale,
            t: (0, $56c2db411f2e97f5$export$6f3122ee6dbd9f46)({
                catalogs: $2edfa6dc91a2e944$export$19b86c51217a817c,
                fallback: (0, $6ecdd4f2fd8400bc$export$84584c2a98eb6753),
                locale: locale,
                formatNumber: formatters.formatNumber
            }),
            ...formatters
        };
    }, [
        locale,
        setLocale
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a278322405d51c25$var$I18nContext.Provider, {
        value: value,
        children: children
    });
}
// A fallback value for anything rendered outside the provider (a test, an error
// boundary that mounted above it). It reports English and formats with English
// rules rather than throwing: "no translations" must never be the reason a
// clinical screen fails to render.
let $a278322405d51c25$var$orphan = null;
function $a278322405d51c25$var$orphanValue() {
    if (!$a278322405d51c25$var$orphan) {
        const formatters = (0, $c53f9539af19d960$export$c3f4cd5551df13fd)('en');
        $a278322405d51c25$var$orphan = {
            locale: 'en',
            dir: 'ltr',
            isRTL: false,
            setLocale: ()=>{},
            t: (0, $56c2db411f2e97f5$export$6f3122ee6dbd9f46)({
                catalogs: $2edfa6dc91a2e944$export$19b86c51217a817c,
                fallback: (0, $6ecdd4f2fd8400bc$export$84584c2a98eb6753),
                locale: 'en',
                formatNumber: formatters.formatNumber
            }),
            ...formatters
        };
    }
    return $a278322405d51c25$var$orphan;
}
function $a278322405d51c25$export$9fc83ad70ead8663() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($a278322405d51c25$var$I18nContext) ?? $a278322405d51c25$var$orphanValue();
}



// OIDC Authorization Code + PKCE flow for Keycloak

const $3bdb28763df76ec7$var$KC_BASE = `${(0, $d87bd335296b449f$export$91dbb4a8660769db)}/realms/parsina`;
const $3bdb28763df76ec7$var$CLIENT_ID = "parsina-web";
// Always derived at call time so redirect_uri is consistent across
// the auth request and token exchange even if the page reloads.
function $3bdb28763df76ec7$var$getRedirectUri() {
    return `${window.location.origin}/`;
}
// ── PKCE helpers ─────────────────────────────────────────────────────────────
function $3bdb28763df76ec7$var$randomBytes(len) {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    return arr;
}
function $3bdb28763df76ec7$var$base64url(buf) {
    return btoa(String.fromCharCode(...buf)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
async function $3bdb28763df76ec7$var$sha256(str) {
    const enc = new TextEncoder().encode(str);
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return new Uint8Array(buf);
}
async function $3bdb28763df76ec7$var$generateChallenge(verifier) {
    return $3bdb28763df76ec7$var$base64url(await $3bdb28763df76ec7$var$sha256(verifier));
}
// ── Token storage ─────────────────────────────────────────────────────────────
// A sign-in lasts as long as Keycloak's refresh token — 30 days on beta1 — not
// as long as one tab (PM-0158). The REFRESH token and the id token (the logout
// hint) live in localStorage, so a new tab, a reopened browser or a Chrome that
// Android killed in the background signs in silently from them. The 5-minute
// ACCESS token stays per tab. Before this, all three lived in sessionStorage and
// every new tab or browser restart threw a valid 30-day token away and sent the
// user to the login form. A copy left in sessionStorage by an older build is
// still read, so a tab open across the deploy keeps working.
const $3bdb28763df76ec7$var$PERSISTED = [
    'kc_refresh',
    'kc_id_token'
];
function $3bdb28763df76ec7$var$durable() {
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$var$readPersisted(key) {
    try {
        const v = $3bdb28763df76ec7$var$durable()?.getItem(key);
        if (v) return v;
    } catch  {}
    return sessionStorage.getItem(key);
}
function $3bdb28763df76ec7$export$257b2d10b709d8ef() {
    return sessionStorage.getItem('kc_token');
}
function $3bdb28763df76ec7$export$c8736e6c4fef498e() {
    return $3bdb28763df76ec7$var$readPersisted('kc_refresh');
}
function $3bdb28763df76ec7$export$393ade1005606e67() {
    return $3bdb28763df76ec7$var$readPersisted('kc_id_token');
}
function $3bdb28763df76ec7$var$saveTokens(token, refresh, idToken) {
    sessionStorage.setItem('kc_token', token);
    const pairs = [
        [
            'kc_refresh',
            refresh
        ],
        [
            'kc_id_token',
            idToken
        ]
    ].filter(([, v])=>v);
    try {
        const store = $3bdb28763df76ec7$var$durable();
        if (!store) throw new Error('no localStorage');
        pairs.forEach(([k, v])=>store.setItem(k, v));
        pairs.forEach(([k])=>sessionStorage.removeItem(k));
    } catch  {
        // Private mode or blocked storage: the tab still works, as it always did.
        pairs.forEach(([k, v])=>sessionStorage.setItem(k, v));
    }
}
function $3bdb28763df76ec7$export$67488bf92fa15f1e() {
    [
        'kc_token',
        'kc_refresh',
        'kc_id_token',
        'kc_verifier',
        'kc_state'
    ].forEach((k)=>sessionStorage.removeItem(k));
    try {
        $3bdb28763df76ec7$var$PERSISTED.forEach((k)=>$3bdb28763df76ec7$var$durable()?.removeItem(k));
    } catch  {}
}
// Keycloak ROTATES the refresh token. With it shared across tabs, two tabs
// refreshing at the same moment would present the same token twice and the
// second would be refused — and a refused refresh signs the user out. The
// browser's Web Locks serialise refreshes across every tab of this origin; each
// refresh reads the stored token inside the lock, so it uses the one the
// previous tab just received. Where Web Locks are missing, the per-tab
// single-flight below still holds.
async function $3bdb28763df76ec7$var$withRefreshLock(fn) {
    const locks = typeof navigator !== 'undefined' ? navigator.locks : null;
    if (!locks || typeof locks.request !== 'function') return fn();
    return locks.request('parsina-kc-refresh', ()=>fn());
}
// ── Redirect-loop guard ───────────────────────────────────────────────────────
// Records each redirect timestamp. If 3+ happen within 30 s, stops redirecting
// and lets the app render an error screen instead.
const $3bdb28763df76ec7$var$LOOP_KEY = 'kc_redirect_ts';
const $3bdb28763df76ec7$var$LOOP_LIMIT = 3;
const $3bdb28763df76ec7$var$LOOP_WIN = 30000; // ms
function $3bdb28763df76ec7$var$redirectAllowed() {
    const raw = sessionStorage.getItem($3bdb28763df76ec7$var$LOOP_KEY);
    const hist = raw ? JSON.parse(raw) : [];
    const now = Date.now();
    const recent = hist.filter((ts)=>now - ts < $3bdb28763df76ec7$var$LOOP_WIN);
    if (recent.length >= $3bdb28763df76ec7$var$LOOP_LIMIT) return false;
    sessionStorage.setItem($3bdb28763df76ec7$var$LOOP_KEY, JSON.stringify([
        ...recent,
        now
    ]));
    return true;
}
function $3bdb28763df76ec7$export$639ddbdf19445d0c() {
    sessionStorage.removeItem($3bdb28763df76ec7$var$LOOP_KEY);
}
async function $3bdb28763df76ec7$export$2fb87bbf5418dbe1() {
    if (!$3bdb28763df76ec7$var$redirectAllowed()) {
        // Too many consecutive redirects — surface the error to the user instead.
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/?auth_error=loop');
        window.location.reload();
        return;
    }
    const verifier = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(32));
    const challenge = await $3bdb28763df76ec7$var$generateChallenge(verifier);
    const state = $3bdb28763df76ec7$var$base64url($3bdb28763df76ec7$var$randomBytes(16));
    sessionStorage.setItem('kc_verifier', verifier);
    sessionStorage.setItem('kc_state', state);
    const params = new URLSearchParams({
        response_type: 'code',
        client_id: $3bdb28763df76ec7$var$CLIENT_ID,
        redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
        scope: 'openid profile email',
        state: state,
        code_challenge: challenge,
        code_challenge_method: 'S256'
    });
    window.location.href = `${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/auth?${params}`;
}
async function $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7() {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const code = params.get('code');
    const state = params.get('state');
    const verifier = sessionStorage.getItem('kc_verifier');
    const saved = sessionStorage.getItem('kc_state');
    console.log('[handleCallback] error:', error, '| hasCode:', !!code, '| stateMatch:', state === saved, '| hasVerifier:', !!verifier);
    // Keycloak returned an explicit error (access_denied, login_required, etc.)
    if (error) {
        console.warn('[handleCallback] KC returned error:', error, params.get('error_description'));
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        window.history.replaceState({}, '', '/');
        return false;
    }
    // Missing or mismatched PKCE / state — don't retry immediately
    if (!code || !verifier || state !== saved) {
        console.warn("[handleCallback] missing code/verifier or state mismatch \u2014 aborting");
        window.history.replaceState({}, '', '/');
        return false;
    }
    const res = await fetch(`${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: $3bdb28763df76ec7$var$CLIENT_ID,
            redirect_uri: $3bdb28763df76ec7$var$getRedirectUri(),
            code: code,
            code_verifier: verifier
        })
    });
    window.history.replaceState({}, '', '/');
    if (!res.ok) {
        console.error('[handleCallback] token exchange failed:', res.status, await res.text());
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        // The FIELDS, never the payload: a token-endpoint response is the one body
        // in this app that can carry a bearer credential, and the browser console
        // is readable by any script on the page and by every support screenshot.
        console.error('[handleCallback] no access_token in response. keys:', Object.keys(data || {}).join(','), '| error:', data?.error, data?.error_description);
        return false;
    }
    // Log roles from new token
    try {
        const claims = JSON.parse(atob(data.access_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        const roles = claims?.resource_access?.['parsina-bff']?.roles || [];
        console.log('[handleCallback] new token roles:', roles, '| sub:', claims?.sub, '| clinic_id:', claims?.clinic_id);
    } catch  {}
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    console.log('[handleCallback] tokens saved successfully');
    return true;
}
// Concurrent refresh, deduplicated.
//
// Reads fire in parallel on every screen — useToday alone issues two
// (`Promise.allSettled`), and the layout adds `me` + `myClinics` on top. When
// the access token has expired they ALL reach getValidToken() at the same
// moment and each calls this with the SAME refresh token.
//
// That is a race with a session-ending outcome: Keycloak rotates refresh
// tokens, and with «Revoke Refresh Token» enabled the second presentation of
// one is `invalid_grant` — so the loser's `clearTokens()` below wipes the
// tokens the winner had just saved, and the next request finds no token and
// bounces to login. Even without revocation the two `saveTokens()` calls race
// and the older pair can land last.
//
// One in-flight promise shared by every caller removes the race in every realm
// configuration and costs one round trip instead of N. The exported signature
// is unchanged: still a Promise<boolean>.
let $3bdb28763df76ec7$var$refreshInFlight = null;
function $3bdb28763df76ec7$var$refreshAccessTokenInTab() {
    if ($3bdb28763df76ec7$var$refreshInFlight) return $3bdb28763df76ec7$var$refreshInFlight;
    // `.finally` passes the resolution value through, so callers still receive
    // the boolean; the slot is cleared either way so a later expiry can retry.
    $3bdb28763df76ec7$var$refreshInFlight = $3bdb28763df76ec7$var$performRefresh().finally(()=>{
        $3bdb28763df76ec7$var$refreshInFlight = null;
    });
    return $3bdb28763df76ec7$var$refreshInFlight;
}
async function $3bdb28763df76ec7$var$performRefresh() {
    const refresh = $3bdb28763df76ec7$export$c8736e6c4fef498e();
    if (!refresh) return false;
    const res = await fetch(`${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: $3bdb28763df76ec7$var$CLIENT_ID,
            refresh_token: refresh
        })
    });
    if (!res.ok) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    const data = await res.json();
    if (!data.access_token) {
        $3bdb28763df76ec7$export$67488bf92fa15f1e();
        return false;
    }
    $3bdb28763df76ec7$var$saveTokens(data.access_token, data.refresh_token, data.id_token);
    return true;
}
function $3bdb28763df76ec7$export$a0973bcfe11b05c9() {
    const idToken = $3bdb28763df76ec7$export$393ade1005606e67();
    $3bdb28763df76ec7$export$67488bf92fa15f1e();
    $3bdb28763df76ec7$export$639ddbdf19445d0c();
    const params = new URLSearchParams({
        client_id: $3bdb28763df76ec7$var$CLIENT_ID,
        post_logout_redirect_uri: $3bdb28763df76ec7$var$getRedirectUri()
    });
    if (idToken) params.set('id_token_hint', idToken);
    window.location.href = `${$3bdb28763df76ec7$var$KC_BASE}/protocol/openid-connect/logout?${params}`;
}
function $3bdb28763df76ec7$export$83cd1f1503eb19c0(token) {
    try {
        const b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(b64), (c)=>c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch  {
        return null;
    }
}
function $3bdb28763df76ec7$export$b007d77a962aa175(token) {
    const p = $3bdb28763df76ec7$export$83cd1f1503eb19c0(token);
    if (!p) return true;
    return Date.now() >= p.exp * 1000 - 30000; // 30 s buffer
}
function $3bdb28763df76ec7$export$f8f36faf9a051362() {
    return $3bdb28763df76ec7$var$withRefreshLock(()=>$3bdb28763df76ec7$var$refreshAccessTokenInTab());
}



const $d4d7a25942cf3f48$export$3b6ed64b5b4e542d = {
    EXPIRING: 'expiring',
    EXPIRED: 'expired'
};
const $d4d7a25942cf3f48$export$9a8e643ece3bd90e = 120000;
// setTimeout is clamped to a 32-bit signed millisecond count, and a longer
// delay wraps to a negative value and fires IMMEDIATELY. A Keycloak SSO session
// can legitimately be days long, so a naive `setTimeout(warnAt)` would show the
// expiry warning the instant a dentist signed in.
const $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS = 2147483647;
const $d4d7a25942cf3f48$var$listeners = new Set();
function $d4d7a25942cf3f48$export$a883a9af61079ac7(listener) {
    $d4d7a25942cf3f48$var$listeners.add(listener);
    return ()=>$d4d7a25942cf3f48$var$listeners.delete(listener);
}
function $d4d7a25942cf3f48$export$c21f8c101d467dce(event) {
    for (const listener of $d4d7a25942cf3f48$var$listeners)try {
        listener(event);
    } catch  {}
}
function $d4d7a25942cf3f48$export$4a79209357ec4bed() {
    $d4d7a25942cf3f48$var$listeners.clear();
}
// ── Returning the dentist to where they were ─────────────────────────────────
// Keycloak's redirect_uri is the origin, so a re-login has always landed on
// امروز. That is a small loss on a list screen and a real one on
// /visit/:appointmentId or /patients/:id/chart — the dentist has to find the
// patient again and re-open the session they were just interrupted in.
//
// sessionStorage, not localStorage: this is a fact about THIS tab's interrupted
// journey. Two tabs re-authenticating would otherwise overwrite each other's
// destination and send one of them somewhere it never was.
const $d4d7a25942cf3f48$var$RETURN_KEY = 'parsina_return_to';
function $d4d7a25942cf3f48$export$4986ea797be155b1(path = `${window.location.pathname}${window.location.search}`) {
    try {
        // Only in-app paths. Storing an absolute URL would make this a redirect
        // parameter an attacker could aim off-site.
        if (typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')) sessionStorage.setItem($d4d7a25942cf3f48$var$RETURN_KEY, path);
    } catch  {}
}
function $d4d7a25942cf3f48$export$e5c839e26770d4ca() {
    try {
        const path = sessionStorage.getItem($d4d7a25942cf3f48$var$RETURN_KEY);
        sessionStorage.removeItem($d4d7a25942cf3f48$var$RETURN_KEY);
        return path && path.startsWith('/') && !path.startsWith('//') ? path : null;
    } catch  {
        return null;
    }
}
function $d4d7a25942cf3f48$export$2d1c01c0322daf36() {
    const refresh = (0, $3bdb28763df76ec7$export$c8736e6c4fef498e)();
    if (!refresh) return null;
    const payload = (0, $3bdb28763df76ec7$export$83cd1f1503eb19c0)(refresh);
    // Keycloak offline tokens carry exp: 0, meaning "does not expire". Treating
    // that as "expired in 1970" would raise the dialog immediately on login.
    if (!payload?.exp) return null;
    return payload.exp * 1000;
}
function $d4d7a25942cf3f48$export$73946e6b8a04196b({ emit: emit = $d4d7a25942cf3f48$export$c21f8c101d467dce, now: now = ()=>Date.now() } = {}) {
    let warnTimer = null;
    let endTimer = null;
    let cancelled = false;
    const clear = ()=>{
        clearTimeout(warnTimer);
        clearTimeout(endTimer);
        warnTimer = null;
        endTimer = null;
    };
    const arm = ()=>{
        clear();
        if (cancelled) return;
        const expiry = $d4d7a25942cf3f48$export$2d1c01c0322daf36();
        // No refresh token, or one that never expires: nothing to schedule. An
        // actual rejection still arrives through `emitSession` from bffClient, so
        // this is not the only path to the dialog.
        if (!expiry) return;
        const remaining = expiry - now();
        if (remaining <= 0) {
            emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRED);
            return;
        }
        const untilWarning = remaining - $d4d7a25942cf3f48$export$9a8e643ece3bd90e;
        if (untilWarning > 0) warnTimer = setTimeout(()=>emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRING), Math.min(untilWarning, $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS));
        else emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRING);
        endTimer = setTimeout(()=>emit($d4d7a25942cf3f48$export$3b6ed64b5b4e542d.EXPIRED), Math.min(remaining, $d4d7a25942cf3f48$var$MAX_TIMEOUT_MS));
    };
    arm();
    return {
        /** Re-read the token and re-arm. Call after any successful refresh. */ rearm: arm,
        cancel: ()=>{
            cancelled = true;
            clear();
        }
    };
}
async function $d4d7a25942cf3f48$export$d0caa90bfa1dd141() {
    const ok = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)().catch(()=>false);
    return Boolean(ok);
}


// The one way this client talks to parsina.bff.dentist.
//
// Mirrors the doctor client's src/lib/bffClient.js: attach the Keycloak access
// token, refresh once on a 401 and retry, and surface GraphQL errors WITH their
// `extensions` intact. There is no Apollo Client — a single fetch wrapper is the
// whole data layer, and both exported names are the same function.
//
// Why `extensions` must survive: this BFF's whole authorization story is carried
// in error codes (UNAUTHENTICATED, NOT_ONBOARDED, GATE_UNAVAILABLE,
// CLINIC_REQUIRED, INSUFFICIENT_CREDITS). Throwing on `res.status` alone would
// drop them, and the boot check would then read "your token expired" as "this
// dentist has not onboarded" — the exact regression the doctor client's comment
// records.



async function $206625c7d33bd390$var$getValidToken() {
    let token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
    if (!token) return null;
    if ((0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) {
        const ok = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)();
        if (!ok) return null;
        token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
    }
    return token;
}
// The panel's language, so the BFF answers in it (its src/i18n/serverText.js):
// the services' errors and the labels they compose. `<html lang>` is set by the
// I18nProvider on every switch, so it is read per request.
function $206625c7d33bd390$var$panelLanguage() {
    return typeof document !== 'undefined' && document.documentElement.getAttribute('lang') || 'fa';
}
async function $206625c7d33bd390$var$executeRequest(token, query, variables) {
    return fetch((0, $d87bd335296b449f$export$bb117bdb9f34de64), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-parsina-locale': $206625c7d33bd390$var$panelLanguage()
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
}
/**
 * Build the Error a caller sees. Keeps `status`, `extensions` and the full
 * `graphQLErrors` list so a screen can branch on a code rather than on a string.
 */ function $206625c7d33bd390$var$buildError(body, status) {
    const gqlError = body?.errors?.[0];
    const err = new Error(gqlError?.message || `BFF error: ${status}`);
    if (status) err.status = status;
    if (gqlError?.extensions) err.extensions = gqlError.extensions;
    if (body?.errors) err.graphQLErrors = body.errors;
    return err;
}
/**
 * The error a dead session throws.
 *
 * Carries the SAME shape a rejected request would (`status` + `extensions.code`)
 * so one branch handles both. App.jsx's boot runs before the shell — and so
 * before anything is listening for session events — and reads exactly these two
 * fields to decide "log in again" rather than "this dentist has not onboarded".
 */ function $206625c7d33bd390$var$sessionEndedError(message) {
    const err = new Error(message);
    err.status = 401;
    err.extensions = {
        code: 'UNAUTHENTICATED'
    };
    return err;
}
async function $206625c7d33bd390$var$bffRequest(query, variables = {}) {
    const token = await $206625c7d33bd390$var$getValidToken();
    if (!token) {
        // Raise, do not navigate. `redirectToLogin()` here was a full-document
        // navigation, which unmounts React and destroys everything unsaved — a
        // طرح درمان mid-price, a tooth editor holding AI findings, a نسخه being
        // assembled — without warning and without returning the dentist to the
        // screen they were on. The shell listens for this and raises a dialog over
        // the still-intact screen instead (src/lib/session.js).
        (0, $d4d7a25942cf3f48$export$c21f8c101d467dce)((0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRED);
        throw $206625c7d33bd390$var$sessionEndedError('Not authenticated');
    }
    let res = await $206625c7d33bd390$var$executeRequest(token, query, variables);
    // A 401 can also mean server-side expiry or clock skew, not just a stale
    // local token — refresh once and retry before giving up on the session.
    if (res.status === 401) {
        const refreshed = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)();
        if (!refreshed) {
            (0, $d4d7a25942cf3f48$export$c21f8c101d467dce)((0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRED);
            throw $206625c7d33bd390$var$sessionEndedError('Session expired');
        }
        res = await $206625c7d33bd390$var$executeRequest((0, $3bdb28763df76ec7$export$257b2d10b709d8ef)(), query, variables);
    }
    if (!res.ok) {
        // Read the body anyway: Apollo sends a perfectly normal GraphQL error
        // payload alongside a non-2xx status (401 UNAUTHENTICATED, 503
        // GATE_UNAVAILABLE), and the code is the only thing that tells them apart.
        const body = await res.json().catch(()=>null);
        throw $206625c7d33bd390$var$buildError(body, res.status);
    }
    const { data: data, errors: errors } = await res.json();
    // A 200 with an `errors` entry is the field-level half of the specialty gate
    // (parsina.bff.dentist/src/graphql/guard.js) — deliberately not an HTTP error,
    // so a query that also asked for a permitted field still returns it.
    if (errors?.length) throw $206625c7d33bd390$var$buildError({
        errors: errors
    });
    return data;
}
const $206625c7d33bd390$export$dbfe74f291058e97 = (err)=>err?.extensions?.code || null;
const $206625c7d33bd390$export$7fb4864174f056c = $206625c7d33bd390$var$bffRequest;
const $206625c7d33bd390$export$8395d0fc0d822a81 = $206625c7d33bd390$var$bffRequest;


// Which clinic this dentist is currently working in.
//
// This is app-wide state, not screen state, for a reason the BFF forces:
// patientmanagement's ListPatients accepts a doctor_id and IGNORES it — only
// clinic_id and search actually filter — so an unscoped patient list is the
// whole platform's registry. The BFF therefore refuses an ambiguous request
// with CLINIC_REQUIRED, and this context is what supplies the answer.
//
// The membership list is read ONCE per session (it changes when a clinic
// manager accepts a join, not while the dentist works) and shared, rather than
// each screen firing its own myClinics.
//
// The choice is persisted locally only. There is no server-side "active clinic"
// — the doctor BFF's `x-active-clinic-id` header exists and NOTHING in the
// platform sends it, so its value there is the doctor's own sub: a clinic id
// that does not exist. This app does not repeat that.


var $acw62 = parcelRequire("acw62");

// Small pure facts about a patient record, shared by the list and the workspace.
//
// Everything here is defensive about free-text service columns: gender and
// birth_date have no validator server-side (CORE.md §11 G11), so the client
// renders what it recognises and passes the rest through UNCHANGED rather than
// normalising a value it does not understand into a wrong one.
/**
 * The catalogue key for a gender value, or null when the stored string is not
 * one this app has copy for — in which case the RAW value is rendered. A
 * patient whose record says «آقا» must not be re-labelled.
 *
 * i18n-exempt: the strings below are STORED VALUES being recognised, not copy
 * being shown. The label the dentist reads is t('common.gender.male').
 */ function $2e1381078ec7f76f$export$c58a664d6aae39f0(raw) {
    const s = String(raw || '').toLowerCase().trim();
    if ([
        'male',
        'm',
        "\u0645\u0631\u062F",
        "\u0622\u0642\u0627"
    ].includes(s)) return 'common.gender.male';
    if ([
        'female',
        'f',
        "\u0632\u0646",
        "\u062E\u0627\u0646\u0645"
    ].includes(s)) return 'common.gender.female';
    return null;
}
function $2e1381078ec7f76f$export$c50166745a33f7cd(raw) {
    const s = String(raw || '').toLowerCase().trim();
    if ([
        'single',
        'unmarried',
        "\u0645\u062C\u0631\u062F"
    ].includes(s)) return 'common.marital.single';
    if ([
        'married',
        "\u0645\u062A\u0627\u0647\u0644",
        "\u0645\u062A\u0623\u0647\u0644"
    ].includes(s)) return 'common.marital.married';
    if ([
        'divorced',
        "\u0645\u0637\u0644\u0642\u0647"
    ].includes(s)) return 'common.marital.divorced';
    if ([
        'widowed',
        'widow',
        "\u0628\u06CC\u0648\u0647"
    ].includes(s)) return 'common.marital.widowed';
    return null;
}
function $2e1381078ec7f76f$export$43b5c849fabfd025(raw) {
    const s = String(raw || '').toLowerCase().trim();
    if ([
        'severe',
        'high',
        'critical'
    ].includes(s)) return 'patient.severity.severe';
    if ([
        'moderate',
        'medium'
    ].includes(s)) return 'patient.severity.moderate';
    if ([
        'mild',
        'low'
    ].includes(s)) return 'patient.severity.mild';
    return null;
}
function $2e1381078ec7f76f$export$d96129a410768e32(raw) {
    const s = String(raw || '').toLowerCase().trim();
    if (s === 'active') return 'patient.conditionStatus.active';
    if (s === 'inactive') return 'patient.conditionStatus.inactive';
    if (s === 'resolved') return 'patient.conditionStatus.resolved';
    if (s === 'remission') return 'patient.conditionStatus.remission';
    return null;
}
const $2e1381078ec7f76f$export$f56c1bb712b9ef86 = 2;
function $2e1381078ec7f76f$export$68339b3094913cd4(term) {
    return String(term || '').trim().length >= $2e1381078ec7f76f$export$f56c1bb712b9ef86;
}
function $2e1381078ec7f76f$export$83ab5e31da45bcb4(term) {
    const s = String(term || '').trim();
    return s.length >= $2e1381078ec7f76f$export$f56c1bb712b9ef86 ? s : null;
}
function $2e1381078ec7f76f$export$618753ab4f635d6c(link) {
    return link?.active !== false && link?.status !== 'pending';
}
function $2e1381078ec7f76f$export$52cbda071c24c9b8({ clinics: clinics, activeId: activeId }) {
    const list = clinics || [];
    const usable = list.filter($2e1381078ec7f76f$export$618753ab4f635d6c);
    if (usable.length === 0) return {
        state: list.length > 0 ? 'pending' : 'none',
        clinicId: null
    };
    if (activeId && usable.some((c)=>c.clinicId === activeId)) return {
        state: 'ready',
        clinicId: activeId
    };
    return {
        state: 'ready',
        clinicId: usable[0].clinicId
    };
}


const $862d9bf17e1d4526$var$STORAGE_KEY = 'parsina.dentist.clinic';
const $862d9bf17e1d4526$export$b45f75e40554fb1 = `
  query MyClinics {
    myClinics {
      id
      clinicId
      status
      active
      visitDurationMinutes
      clinic { id name city province officePhone invitationCode currency }
    }
  }
`;
const $862d9bf17e1d4526$var$ClinicScopeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
const $862d9bf17e1d4526$var$readStored = ()=>{
    try {
        return localStorage.getItem($862d9bf17e1d4526$var$STORAGE_KEY) || null;
    } catch  {
        return null;
    }
};
function $862d9bf17e1d4526$export$ac4d1181bb6a7e7d({ children: children }) {
    const [clinics, setClinics] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [activeId, setActiveIdState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($862d9bf17e1d4526$var$readStored);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($862d9bf17e1d4526$export$b45f75e40554fb1).then((data)=>{
            if (!alive) return;
            setClinics(data?.myClinics || []);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            // A membership read that fails leaves the list empty, and every screen
            // that needs a clinic says so. It must NOT fall back to "no clinic
            // scope" and fetch the platform's whole registry.
            console.error('[clinicScope] myClinics failed:', err?.message);
            setError(err);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        nonce
    ]);
    const setActiveId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id)=>{
        setActiveIdState(id || null);
        try {
            if (id) localStorage.setItem($862d9bf17e1d4526$var$STORAGE_KEY, id);
            else localStorage.removeItem($862d9bf17e1d4526$var$STORAGE_KEY);
        } catch  {
        /* storage off — the choice simply does not survive a reload */ }
    }, []);
    // A stored clinic the dentist was removed from — or one that has not accepted
    // them yet — must not keep scoping queries. The rule itself lives in
    // lib/patients.js: it is pure, it is tested there, and it was previously
    // written out a second time here, so a change to one copy would have left the
    // hook and its own test disagreeing.
    const { state: scopeState, clinicId: resolvedActive } = (0, $2e1381078ec7f76f$export$52cbda071c24c9b8)({
        clinics: clinics,
        activeId: activeId
    });
    // The memberships that may actually scope a query — `clinics` still carries
    // every row, including pending ones, because پروفایل shows their status.
    // Anything that PICKS a scope (the sidebar switcher) has to offer this list:
    // an option that cannot scope is an option that produces CLINIC_FORBIDDEN.
    const scopeClinics = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>clinics.filter((0, $2e1381078ec7f76f$export$618753ab4f635d6c)), [
        clinics
    ]);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            clinics: clinics,
            scopeClinics: scopeClinics,
            scopeState: scopeState,
            loading: loading,
            error: error,
            activeId: resolvedActive,
            activeClinic: clinics.find((c)=>c.clinicId === resolvedActive) || null,
            setActiveId: setActiveId,
            reload: ()=>setNonce((n)=>n + 1)
        }), [
        clinics,
        scopeClinics,
        scopeState,
        loading,
        error,
        resolvedActive,
        setActiveId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($862d9bf17e1d4526$var$ClinicScopeContext.Provider, {
        value: value,
        children: children
    });
}
function $862d9bf17e1d4526$export$26433d199b47941f() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($862d9bf17e1d4526$var$ClinicScopeContext) ?? {
        clinics: [],
        scopeClinics: [],
        scopeState: 'none',
        loading: true,
        error: null,
        activeId: null,
        activeClinic: null,
        setActiveId: ()=>{},
        reload: ()=>{}
    };
}



var $acw62 = parcelRequire("acw62");


const $be7f94ce6db606a5$export$5749bf3f1d0fd21b = {
    ACTIVE: 'active',
    EXPIRING: 'expiring',
    EXPIRED: 'expired'
};
function $be7f94ce6db606a5$export$86b827a672ae590c() {
    const [status, setStatus] = (0, $acw62.useState)($be7f94ce6db606a5$export$5749bf3f1d0fd21b.ACTIVE);
    const [secondsLeft, setSecondsLeft] = (0, $acw62.useState)(Math.round((0, $d4d7a25942cf3f48$export$9a8e643ece3bd90e) / 1000));
    const [busy, setBusy] = (0, $acw62.useState)(false);
    const watcherRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const watcher = (0, $d4d7a25942cf3f48$export$73946e6b8a04196b)();
        watcherRef.current = watcher;
        const unsubscribe = (0, $d4d7a25942cf3f48$export$a883a9af61079ac7)((event)=>{
            setStatus((prev)=>{
                // Terminal. A late-firing `expiring` timer must not downgrade an expiry
                // that a rejected request has already proven — that would put a
                // countdown in front of a dentist whose session is definitively over
                // and offer them an extension that cannot work.
                if (prev === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED) return prev;
                if (event === (0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRED) return $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED;
                if (event === (0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRING) return $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING;
                return prev;
            });
        });
        return ()=>{
            unsubscribe();
            watcher.cancel();
        };
    }, []);
    // The countdown ticks only while it is on screen. A once-per-second timer
    // running for a dentist's whole day to service a dialog that is almost never
    // open is pure waste.
    (0, $acw62.useEffect)(()=>{
        if (status !== $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING) return undefined;
        const tick = ()=>{
            const expiry = (0, $d4d7a25942cf3f48$export$2d1c01c0322daf36)();
            const remaining = expiry ? Math.round((expiry - Date.now()) / 1000) : 0;
            setSecondsLeft(Math.max(0, remaining));
        };
        tick();
        const id = setInterval(tick, 1000);
        return ()=>clearInterval(id);
    }, [
        status
    ]);
    /** «ادامهٔ کار» — renew silently and put the dialog away. */ const extend = (0, $acw62.useCallback)(async ()=>{
        setBusy(true);
        const ok = await (0, $d4d7a25942cf3f48$export$d0caa90bfa1dd141)();
        setBusy(false);
        if (!ok) {
            // The refresh token is dead. Retrying would fail identically, and a
            // spinner that never resolves is a worse answer than an honest one.
            setStatus($be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED);
            return false;
        }
        setStatus($be7f94ce6db606a5$export$5749bf3f1d0fd21b.ACTIVE);
        // Re-arm against the NEW token: a renewal mints a new expiry, and the old
        // timers would otherwise fire against a token that no longer exists.
        watcherRef.current?.rearm();
        return true;
    }, []);
    /**
   * Hide the warning without extending.
   *
   * Does not cancel anything — the schedule still runs and the expired dialog
   * still arrives. A dentist mid-sentence is allowed to wave this away; they
   * are not allowed to switch off the fact that the session is ending.
   */ const dismissWarning = (0, $acw62.useCallback)(()=>{
        setStatus((prev)=>prev === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING ? $be7f94ce6db606a5$export$5749bf3f1d0fd21b.ACTIVE : prev);
    }, []);
    /** Sign in again, returning to the screen the dentist was interrupted on. */ const signInAgain = (0, $acw62.useCallback)(async ()=>{
        setBusy(true);
        (0, $d4d7a25942cf3f48$export$4986ea797be155b1)();
        await (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
    }, []);
    return {
        status: status,
        secondsLeft: secondsLeft,
        busy: busy,
        isExpiring: status === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRING,
        isExpired: status === $be7f94ce6db606a5$export$5749bf3f1d0fd21b.EXPIRED,
        extend: extend,
        dismissWarning: dismissWarning,
        signInAgain: signInAgain
    };
}
var $be7f94ce6db606a5$export$2e2bcd8739ae039 = $be7f94ce6db606a5$export$86b827a672ae590c;



parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $59813a4678999ce6$export$a2387ed3b5d536eb = {
    name: "log-in",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m10 17 5-5-5-5",
                key: "1bsop3"
            }
        ],
        [
            "path",
            {
                d: "M15 12H3",
                key: "6jk70r"
            }
        ],
        [
            "path",
            {
                d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
                key: "u53s6r"
            }
        ]
    ]
};
$59813a4678999ce6$export$a2387ed3b5d536eb.node;
const $59813a4678999ce6$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($59813a4678999ce6$export$a2387ed3b5d536eb);



// Design tokens. Re-exported from @parsina/framework so a screen imports one
// short path and never a local palette — `soft()` in particular must come from
// here: the accent tokens are CSS `var()` references now, so hand-rolled hex
// arithmetic on them produces `rgba(NaN, …)`.



// The type ramp اعتبار is drawn with.
//
// These are not new sizes. They are the values this app already spells out
// inline on every screen ('0.8125rem' body, '0.6875rem' caption, '0.75rem'
// label) — and they are byte-identical to the doctor client's
// src/constants/typography.js, which is what makes the two panels' credit
// surfaces the same design rather than two things that resemble each other.
// اعتبار needs ~60 of them on one screen, and sixty inline literals is where a
// ramp starts to drift.
//
// FONT FAMILY IS ABSENT ON PURPOSE. styles.css declares one «Meshkat»
// (Vazirmatn) face on html/body and everything inherits it; a component-level
// `fontFamily` is a defect (DESIGN-CONCEPT-MOBILE §2.1, and
// tests/mobileComposition.test.js fails on one).
//
// SIZES ARE rem, never px, so they follow the dentist's font-size preference —
// tokens.css drives the root size off `data-font-size`, which is what the
// appearance picker on پروفایل writes.
//
// Usage: spread a role, then layer only colour and margins on top.
//   <div style={{ ...type.title, color: C.textPrimary }}>عنوان</div>
const $9ab4d64d86b95e22$export$bf9fb029d174d554 = {
    // Headline number — the balance on the desktop hero.
    hero: {
        fontSize: '2.25rem',
        fontWeight: 800,
        lineHeight: 1.05
    },
    // The same number on a phone, where 36px would push the tiles off-screen.
    display: {
        fontSize: '1.625rem',
        fontWeight: 800,
        lineHeight: 1.1
    },
    // KPI / stat value.
    metric: {
        fontSize: '1.1875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    // Card / section headings.
    title: {
        fontSize: '0.9375rem',
        fontWeight: 800,
        lineHeight: 1.3
    },
    // Numeric amounts (ledger rows, group totals).
    amount: {
        fontSize: '0.875rem',
        fontWeight: 800,
        lineHeight: 1.2
    },
    // Primary body / row text.
    body: {
        fontSize: '0.8125rem',
        fontWeight: 700,
        lineHeight: 1.4
    },
    // Field / stat labels.
    label: {
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    // Secondary meta.
    caption: {
        fontSize: '0.6875rem',
        fontWeight: 600,
        lineHeight: 1.4
    },
    // Tiny meta / dot labels.
    micro: {
        fontSize: '0.625rem',
        fontWeight: 700,
        lineHeight: 1.4
    },
    // Unit suffix («پارسه»), beside a value in a lighter weight.
    unit: {
        fontSize: '0.75rem',
        fontWeight: 700
    }
};
var $9ab4d64d86b95e22$export$2e2bcd8739ae039 = $9ab4d64d86b95e22$export$bf9fb029d174d554;



// ─────────────────────────────────────────────────────────────────────────────
// The two faces of a session ending.
//
// Both are modal — genuinely modal, unlike almost anything else in this app —
// because unlike a connection drop there is nothing useful the dentist can do
// underneath. Every write will fail, and letting them keep charting into a
// tooth editor that cannot be saved is worse than interrupting them.
//
// What the modal deliberately does NOT do is unmount anything. The screen
// behind it is intact and readable, which is the entire point: the previous
// behaviour navigated away, so the طرح درمان was simply gone. Here it is still
// on screen, still selectable, and after «ورود مجدد» the dentist comes back to
// the same URL.
//
//   Warning  raised while the session can still be extended silently. It has a
//            live countdown, because "soon" is not something anyone can plan
//            around, and its primary action costs one silent token refresh.
//            Dismissible — a dentist mid-sentence may reasonably want it gone,
//            and the expired dialog will follow if they do nothing.
//
//   Expired  not dismissible. There is no state to return to underneath in
//            which anything works.
//
// Built on the kit `Dialog` (Radix) rather than a hand-rolled fixed overlay.
// That is not tidiness: it is what buys the focus trap, the `aria-modal`
// semantics, the escape/outside-click handling, the scroll lock and the scrim
// that every other modal in the app already has. A bespoke overlay here would
// be the one dialog in the product that a keyboard user could tab out of, and
// «ورود مجدد» is a bad button to lose focus of.
// ─────────────────────────────────────────────────────────────────────────────
/** The tone disc. One shape, two tones — the family has to read as one thing. */ function $e88acdb961d2fa90$var$Disc({ tone: tone, children: children }) {
    const palette = tone === 'warning' ? {
        fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight
    } : {
        fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            width: '3.5rem',
            height: '3.5rem',
            borderRadius: '999px',
            background: palette.bg,
            color: palette.fg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem'
        },
        children: children
    });
}
function $e88acdb961d2fa90$export$c05fa71599f06855({ secondsLeft: secondsLeft, onExtend: onExtend, onDismiss: onDismiss, busy: busy }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: true,
        onOpenChange: (next)=>{
            if (!next) onDismiss?.();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            role: "alertdialog",
            "data-testid": "session-expiring",
            showClose: false,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e88acdb961d2fa90$var$Disc, {
                            tone: "warning",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039), {
                                size: 26,
                                strokeWidth: 1.9,
                                "aria-hidden": true
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                            style: {
                                textAlign: 'center'
                            },
                            children: t('auth.session.expiringTitle')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                                fontWeight: 500,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                lineHeight: 1.85
                            },
                            children: t('auth.session.expiringBody')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            "data-testid": "session-countdown",
                            "aria-live": "off",
                            style: {
                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).display,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
                                margin: '0.5rem 0 0',
                                fontVariantNumeric: 'tabular-nums'
                            },
                            children: [
                                formatNumber(Math.max(0, secondsLeft)),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).unit,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        marginInlineStart: '0.375rem'
                                    },
                                    children: t('common.units.second')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    style: {
                        flexDirection: 'column',
                        gap: '0.5rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: onExtend,
                            disabled: busy,
                            "data-testid": "session-extend",
                            style: {
                                width: '100%'
                            },
                            children: t(busy ? 'common.state.pleaseWait' : 'auth.session.staySignedIn')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "ghost",
                            onClick: onDismiss,
                            "data-testid": "session-dismiss",
                            style: {
                                width: '100%'
                            },
                            children: t('common.actions.close')
                        })
                    ]
                })
            ]
        })
    });
}
function $e88acdb961d2fa90$export$88240b05a63eec38({ onSignIn: onSignIn, busy: busy }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return(// Not dismissible, and it takes three separate refusals to mean it: no
    // close affordance, no escape, no outside click. Any one of them left open
    // would drop the dentist back onto a screen where every button silently
    // fails — which looks exactly like the app having frozen.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: true,
        onOpenChange: ()=>{},
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            role: "alertdialog",
            "data-testid": "session-expired",
            showClose: false,
            onEscapeKeyDown: (e)=>e.preventDefault(),
            onPointerDownOutside: (e)=>e.preventDefault(),
            onInteractOutside: (e)=>e.preventDefault(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e88acdb961d2fa90$var$Disc, {
                            tone: "info",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59813a4678999ce6$export$2e2bcd8739ae039), {
                                size: 26,
                                strokeWidth: 1.9,
                                "aria-hidden": true
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                            style: {
                                textAlign: 'center'
                            },
                            children: t('auth.session.expiredTitle')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                        fontWeight: 500,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                        lineHeight: 1.85,
                        textAlign: 'center'
                    },
                    children: t('auth.session.expiredBody')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    style: {
                        flexDirection: 'column',
                        gap: '0.5rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: onSignIn,
                        disabled: busy,
                        "data-testid": "session-signin",
                        style: {
                            width: '100%'
                        },
                        children: t('auth.session.signInAgain')
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                        marginTop: '1rem',
                        lineHeight: 1.8,
                        textAlign: 'center'
                    },
                    children: t('auth.session.returnNotice')
                })
            ]
        })
    }));
}




var $acw62 = parcelRequire("acw62");







// Screen-name navigation.
//
// Screens navigate by NAME ('patients'), never by URL literal. One map owns the
// name → path translation, so a route can be renamed in one place and so a nav
// entry for a screen that does not exist fails loudly here instead of rendering
// a dead link.
//
// tests/routing.test.js pins the three-way agreement: every key below has a
// matching <Route> in App.jsx, and every <Route> path is reachable through a key
// here. Adding a ROUTES entry without its <Route> fails the suite.


var $acw62 = parcelRequire("acw62");
const $53b14620f65a31c3$export$cd891b82501bb412 = {
    // امروز — the landing route and the clinic connection.
    today: ()=>'/',
    patients: ()=>'/patients',
    // `tab` is a URL SEGMENT, not local state: a refresh, a back button and a
    // shared link all have to restore the section the dentist was reading.
    // 'summary' is the default and is left out of the URL.
    patient: (d = {})=>`/patients/${d.id}${d.tab && d.tab !== 'summary' ? `/${d.tab}` : ''}`,
    prescription: (d = {})=>`/prescription/${d.patientId}${d.appointmentId ? `?appointmentId=${encodeURIComponent(d.appointmentId)}` : ''}`,
    // جلسهٔ درمان — the visit workspace, keyed on the APPOINTMENT.
    //
    // The appointment is the visit (there is no encounters table), and it is the
    // only id in the path: the patient comes from the server's answer about this
    // appointment, so the URL cannot be edited to pair one patient's record with
    // another's visit.
    //
    // The left column's tab is a QUERY parameter rather than a path segment,
    // unlike the patient workspace's. The two are different kinds of thing: a
    // patient section is a place, and this is a pane of one workspace that stays
    // open around it. 'diagnosis' is the default and is left out.
    visit: (d = {})=>`/visit/${d.appointmentId}${d.tab && d.tab !== 'diagnosis' ? `?tab=${encodeURIComponent(d.tab)}` : ''}`,
    profile: ()=>'/profile',
    // اعتبار — the Parsina Credit balance, ledger and top-up. A destination and
    // not a profile tab: it is where a dentist goes when the assistant answered
    // «اعتبار کافی نیست», and that has to be one tap away from anywhere.
    credits: ()=>'/credits'
};
function $53b14620f65a31c3$export$5b61ff3425c1c197() {
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((screen, data)=>{
        const build = $53b14620f65a31c3$export$cd891b82501bb412[screen];
        if (!build) {
            // Loud rather than silent: a typo'd screen name is a dead button, and a
            // dead button is indistinguishable from a slow one.
            console.warn(`[useAppNavigate] no route for "${screen}"`);
            return;
        }
        navigate(build(data || {}), {
            state: data
        });
        window.scrollTo(0, 0);
    }, [
        navigate
    ]);
}
var $53b14620f65a31c3$export$2e2bcd8739ae039 = $53b14620f65a31c3$export$5b61ff3425c1c197;


// The signed-in dentist's own identity.
//
// `me` is served from the profile the gate already read for this request, so it
// costs no extra downstream round trip — cheap enough for the sidebar to ask
// for on its own rather than being threaded down from App.

var $acw62 = parcelRequire("acw62");

const $5bc9ff20f6a2b818$export$4fdec73565eec05f = `
  query Me {
    me { id fullName medicalCode specialty bio isDentist isOnboarded }
  }
`;
function $5bc9ff20f6a2b818$export$f637e1cf42d15a62() {
    const [me, setMe] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        (0, $206625c7d33bd390$export$7fb4864174f056c)($5bc9ff20f6a2b818$export$4fdec73565eec05f).then((data)=>{
            if (!alive) return;
            setMe(data?.me || null);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useMe] failed:', err?.message);
            setError(err);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        nonce
    ]);
    return {
        me: me,
        loading: loading,
        error: error,
        reload: ()=>setNonce((n)=>n + 1)
    };
}
var $5bc9ff20f6a2b818$export$2e2bcd8739ae039 = $5bc9ff20f6a2b818$export$f637e1cf42d15a62;



// اعتبار — the credit screen's data layer.
//
// FOUR hooks in one file rather than four files, because they are one subject
// and three of them are two dozen lines. They are separate hooks and not one
// combined query on purpose: the balance is polled from several places and
// refetched on events, while the ledger is paged and filtered — a single
// `useCredits()` would refetch a 30-row ledger every time a visit ended.
//
// No `ownerId` is sent anywhere below. The BFF scopes every one of these to the
// caller's own token (parsina.bff.dentist/src/graphql/typeDefs/credits.js), so
// there is nothing here for a client to get wrong or to tamper with.

var $acw62 = parcelRequire("acw62");

// The پارسه price list, resolved — ONE server-side list instead of the
// hardcoded constants (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md
// §9.2, phase 3).
//
// Every price this app prints goes through `costOf(actionId)` below. The
// action ids are the ones the app already used (`COIN_COSTS.TOOTH_FINDINGS`,
// …); `SERVICE_KEY_BY_ACTION` is the ONE table that maps them onto the AI RPC
// names the service prices — change a mapping here, nowhere else.
//
// ── The constants are the fallback and the first paint ──────────────────────
// `constants/creditPricing.js` is what renders before the list has arrived and
// what renders when it never does (offline, BFF down, the AI service down and
// the BFF serving its own frozen copy). A price chip therefore NEVER spins and
// never goes blank: it shows the shipped number, then the policy's number the
// moment it is known. `source` says which one is on screen.
//
// ── Fetched once per page load, remembered for the session ──────────────────
// The list is read through the app's own GraphQL client the first time any
// surface asks for it and shared by every component after that (a module-level
// store read through `useSyncExternalStore`). The last answer is also kept in
// sessionStorage so a reload paints the policy price first, not the constant.
// A FAILED read is not remembered: the next surface to mount tries again.

var $acw62 = parcelRequire("acw62");

// The «پارسه» price list — the OFFLINE FALLBACK and the first-paint value.
//
// Since 2026-09-12 the price of every AI action comes from ONE server-side
// list: the AI service's active pricing policy, served by the BFF as
// `creditPrices` and read here through `src/lib/useCreditPrices.js`
// (docs/AI_COST_AND_PARSEH_PRICING_MANAGEMENT_DESIGN.md §9.2, phase 3). Every
// price chip and the Credits price list go through `costOf(actionId)` /
// `useCreditPrices()` there, so what is advertised follows the policy the
// service actually debits from.
//
// THIS FILE is what renders before that list has arrived and what renders when
// it never does (offline, BFF down). It mirrors the schedule the AI service
// shipped with (aiassitant/app/domain/services/usage_context.py +
// credits_policy.md):
//   LLM actions 10 پارسه · interaction check 3 پارسه · transcription 5/minute.
// It is NOT where a price is changed — the design doc is the reference, and the
// admin panel's pricing policy is the instrument.
//
// ── WHY THIS LIST DIFFERS FROM THE DOCTOR APP'S ────────────────────────────
// Same prices, different ROWS, because this app performs different actions.
// Every row below is a button a dentist actually presses — nothing here fires
// on load, on a keystroke or on a debounce, which is why «user-triggered» is a
// correctness rule in this app and not a UI preference.
//
// ── 2026-08-25: THE TRANSCRIPTION ROW ARRIVED, AND THIS FILE SAID IT NEVER
//    WOULD ──────────────────────────────────────────────────────────────────
// The removed paragraph gave three reasons for having no transcription row:
// DESIGN.md §7 put voice out of scope, TranscribeAudio was not wrapped in the
// BFF, and advertising a price for something the app cannot do is worse than
// not listing it. The second is simply no longer true — voice dictation goes
// through parsina.bff.dentist's /ws/transcribe now — and the third has
// inverted with it: the dentist IS being charged, so the price has to be on
// the list. §7's actual subject, a continuous visit transcript, is still out
// of scope; what is priced here is FIELD DICTATION.
//
// IT IS THE ONLY METERED ROW. Every other action is a flat charge per press.
// Transcription is per MINUTE and the service rounds UP
// (usage_context.py:36-38, `ceil(elapsed_minutes) * 5`), so the shortest
// possible dictation — two words into شکایت اصلی — still costs a whole 5
// پارسه. That is the service's rule, not this app's, and the UI says so rather
// than letting a dentist infer a per-second price from «۵ / دقیقه».
//
// UNIT LANGUAGE: the unit is «پارسه» / "Parseh" everywhere in the UI, in both
// locales — never «سکه», never "coin", never the Latin "PC". Toman appears only
// at purchase and in the hero's equivalence line. The COIN_* identifiers below
// keep their names on purpose: they are internal, and the wallet's own contract
// still spells the unit "coin".
/** Retail value of one پارسه, in Toman — FALLBACK. The policy's `parsehToman`
 *  wins when known; read it through `coinPriceToman()` in lib/useCreditPrices.js. */ const $75f061374f24c25d$export$603323bf3f7bd8d9 = 1000;
const $75f061374f24c25d$export$e6d8c7e3d913b530 = {
    // The ONLY metered cost here: charged per elapsed minute of recording,
    // rounded up. Same number and same rule as the doctor app's
    // TRANSCRIPTION_PER_MIN — one dentist, one wallet, one price.
    TRANSCRIPTION_PER_MIN: 5,
    //                           یادداشت and the visit narrative in تشخیص
    DIFFERENTIAL: 10,
    CONFIRM_QUESTIONS: 10,
    ASK_QUESTION: 10,
    SOAP_REFINE: 10,
    //                  merge produced new content; the server's `charged` flag is
    //                  the signal, never the click.
    TOOTH_FINDINGS: 10,
    //                     separately from the two reads above so a chart the
    //                     assistant could not read does not cost the note draft.
    VISIT_ADVICE: 10,
    OCR: 10,
    INTERACTION_CHECK: 3
};
const $75f061374f24c25d$export$52690e1136e04e64 = [
    {
        id: 'transcription',
        action: 'TRANSCRIPTION_PER_MIN',
        labelKey: 'credits.price.transcription',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.TRANSCRIPTION_PER_MIN,
        perKey: 'common.units.minute'
    },
    {
        id: 'differential',
        action: 'DIFFERENTIAL',
        labelKey: 'credits.price.differential',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.DIFFERENTIAL
    },
    {
        id: 'advice',
        action: 'VISIT_ADVICE',
        labelKey: 'credits.price.advice',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.VISIT_ADVICE
    },
    {
        id: 'soap',
        action: 'SOAP_REFINE',
        labelKey: 'credits.price.soap',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.SOAP_REFINE
    },
    {
        id: 'teeth',
        action: 'TOOTH_FINDINGS',
        labelKey: 'credits.price.teeth',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.TOOTH_FINDINGS
    },
    {
        id: 'confirmq',
        action: 'CONFIRM_QUESTIONS',
        labelKey: 'credits.price.confirmq',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.CONFIRM_QUESTIONS
    },
    {
        id: 'ask',
        action: 'ASK_QUESTION',
        labelKey: 'credits.price.ask',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.ASK_QUESTION
    },
    {
        id: 'ocr',
        action: 'OCR',
        labelKey: 'credits.price.ocr',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.OCR
    },
    {
        id: 'interaction',
        action: 'INTERACTION_CHECK',
        labelKey: 'credits.price.interaction',
        cost: $75f061374f24c25d$export$e6d8c7e3d913b530.INTERACTION_CHECK
    }
];
function $75f061374f24c25d$export$b634cc5d06849b0a(n, formatNumber) {
    if (n == null || !Number.isFinite(Number(n))) return "\u2014";
    const rounded = Math.round(Number(n));
    return formatNumber ? formatNumber(rounded) : String(rounded);
}
function $75f061374f24c25d$export$3c73313758e13369(coins, { formatNumber: formatNumber, tomanLabel: tomanLabel, tomanPerCoin: tomanPerCoin = $75f061374f24c25d$export$603323bf3f7bd8d9 } = {}) {
    if (coins == null || !Number.isFinite(Number(coins))) return '';
    const toman = Math.round(Number(coins)) * tomanPerCoin;
    const text = formatNumber ? formatNumber(toman) : String(toman);
    return `\u{2248} ${text} ${tomanLabel || ''}`.trim();
}


const $9449204a10cf7050$export$c3ecc18ec062bc34 = Object.freeze({
    TRANSCRIPTION_PER_MIN: 'TranscribeAudio',
    DIFFERENTIAL: 'GetDifferentialDiagnosis',
    CONFIRM_QUESTIONS: 'GenerateConfirmationQuestions',
    ASK_QUESTION: 'AskDoctorQuestion',
    SOAP_REFINE: 'RefineSoapNote',
    TOOTH_FINDINGS: 'ExtractToothFindings',
    // `generateVisitAdvice` in parsina.bff.dentist is served by GenerateVisitSummary.
    VISIT_ADVICE: 'GenerateVisitSummary',
    OCR: 'ProcessDocumentOCR',
    INTERACTION_CHECK: 'CheckDrugInteraction'
});
const $9449204a10cf7050$export$f5e24740e23fe4a0 = `
  query CreditPrices {
    creditPrices {
      source
      policyId
      parsehToman
      generatedAt
      items { serviceKey unit parseh priceSource }
    }
  }
`;
const $9449204a10cf7050$var$STORAGE_KEY = 'parsina:creditPrices:v1';
const $9449204a10cf7050$var$FALLBACK_STATE = Object.freeze({
    byService: null,
    parsehToman: null,
    policyId: null,
    source: 'fallback',
    loaded: false
});
let $9449204a10cf7050$var$state = $9449204a10cf7050$var$FALLBACK_STATE;
const $9449204a10cf7050$var$listeners = new Set();
let $9449204a10cf7050$var$inflight = null;
let $9449204a10cf7050$var$answered = false; // a SERVICE answer landed this page load — read once
function $9449204a10cf7050$var$emit(next) {
    $9449204a10cf7050$var$state = next;
    for (const fn of $9449204a10cf7050$var$listeners)fn();
}
function $9449204a10cf7050$export$34ef7267354f580f(list) {
    if (!list || list.source !== 'service' || !Array.isArray(list.items)) // The BFF's own fallback is still the constants — say so, and keep them.
    return {
        ...$9449204a10cf7050$var$FALLBACK_STATE,
        loaded: true
    };
    const byService = new Map();
    for (const item of list.items){
        // An unpriced row (null) leaves the constant in place: a chip must never
        // go blank for a service the AI still charges under its code default.
        // Checked for null BEFORE Number(): Number(null) is 0, and 0 is a price.
        if (!item?.serviceKey || item.parseh === null || item.parseh === undefined) continue;
        const n = Number(item.parseh);
        if (Number.isFinite(n) && n >= 0) byService.set(item.serviceKey, n);
    }
    const toman = Number(list.parsehToman);
    return {
        byService: byService,
        parsehToman: Number.isFinite(toman) && toman > 0 ? Math.round(toman) : null,
        policyId: list.policyId || null,
        source: 'service',
        loaded: true
    };
}
function $9449204a10cf7050$export$477e957045ea2243(list) {
    const next = $9449204a10cf7050$export$34ef7267354f580f(list);
    if (next.source === 'service') {
        $9449204a10cf7050$var$answered = true;
        try {
            sessionStorage.setItem($9449204a10cf7050$var$STORAGE_KEY, JSON.stringify(list));
        } catch  {}
    }
    $9449204a10cf7050$var$emit(next);
}
function $9449204a10cf7050$export$230b85c65d633100() {
    $9449204a10cf7050$var$state = $9449204a10cf7050$var$FALLBACK_STATE;
    $9449204a10cf7050$var$inflight = null;
    $9449204a10cf7050$var$answered = false;
    try {
        sessionStorage.removeItem($9449204a10cf7050$var$STORAGE_KEY);
    } catch  {}
    for (const fn of $9449204a10cf7050$var$listeners)fn();
}
// A reload paints the last policy price first, not the constant.
try {
    const cached = sessionStorage.getItem($9449204a10cf7050$var$STORAGE_KEY);
    if (cached) {
        const restored = $9449204a10cf7050$export$34ef7267354f580f(JSON.parse(cached));
        if (restored.source === 'service') $9449204a10cf7050$var$state = {
            ...restored,
            loaded: false
        };
    }
} catch  {}
function $9449204a10cf7050$export$84016827a72d6537() {
    if ($9449204a10cf7050$var$answered) return Promise.resolve($9449204a10cf7050$var$state);
    if ($9449204a10cf7050$var$inflight) return $9449204a10cf7050$var$inflight;
    $9449204a10cf7050$var$inflight = Promise.resolve().then(()=>(0, $206625c7d33bd390$export$7fb4864174f056c)($9449204a10cf7050$export$f5e24740e23fe4a0)).then((data)=>{
        const list = data?.creditPrices;
        if (list && list.source === 'service') $9449204a10cf7050$export$477e957045ea2243(list);
        else $9449204a10cf7050$var$emit({
            ...$9449204a10cf7050$var$state,
            loaded: true
        });
    }).catch(()=>{
        // Offline, signed out, the BFF down: the constants stay on screen.
        $9449204a10cf7050$var$emit({
            ...$9449204a10cf7050$var$state,
            loaded: true
        });
    }).finally(()=>{
        $9449204a10cf7050$var$inflight = null;
    }).then(()=>$9449204a10cf7050$var$state);
    return $9449204a10cf7050$var$inflight;
}
function $9449204a10cf7050$export$c932aceb7c67d0f4(actionId) {
    const key = $9449204a10cf7050$export$c3ecc18ec062bc34[actionId];
    if (key && $9449204a10cf7050$var$state.byService && $9449204a10cf7050$var$state.byService.has(key)) return $9449204a10cf7050$var$state.byService.get(key);
    return (0, $75f061374f24c25d$export$e6d8c7e3d913b530)[actionId] ?? null;
}
function $9449204a10cf7050$export$ca9b35f04336e4e5() {
    return $9449204a10cf7050$var$state.parsehToman ?? (0, $75f061374f24c25d$export$603323bf3f7bd8d9);
}
function $9449204a10cf7050$export$685f009c83717b79() {
    return (0, $75f061374f24c25d$export$52690e1136e04e64).map((row)=>({
            ...row,
            cost: $9449204a10cf7050$export$c932aceb7c67d0f4(row.action)
        }));
}
const $9449204a10cf7050$var$subscribe = (fn)=>{
    $9449204a10cf7050$var$listeners.add(fn);
    return ()=>$9449204a10cf7050$var$listeners.delete(fn);
};
const $9449204a10cf7050$var$getSnapshot = ()=>$9449204a10cf7050$var$state;
function $9449204a10cf7050$export$204bd72286fdb787() {
    const snapshot = (0, $acw62.useSyncExternalStore)($9449204a10cf7050$var$subscribe, $9449204a10cf7050$var$getSnapshot, $9449204a10cf7050$var$getSnapshot);
    (0, $acw62.useEffect)(()=>{
        $9449204a10cf7050$export$84016827a72d6537();
    }, []);
    return {
        costOf: $9449204a10cf7050$export$c932aceb7c67d0f4,
        coinPriceToman: snapshot.parsehToman ?? (0, $75f061374f24c25d$export$603323bf3f7bd8d9),
        priceList: $9449204a10cf7050$export$685f009c83717b79(),
        source: snapshot.source,
        policyId: snapshot.policyId,
        loaded: snapshot.loaded
    };
}


// Which payment gateway a top-up uses, and how a Toman price becomes the
// number that gateway expects.
//
// THE WHOLE UI PRICES IN TOMAN. The gateways disagree about the unit they
// settle in — Sepehr (بانک صادرات / شاپرک) takes RIALS, Zarinpal takes Toman —
// so the conversion happens exactly once, here, at the moment an amount is
// handed to the BFF. The BFF passes the figure through untouched, precisely so
// there is only one place that can multiply by ten.
// The table is DATA — `rialsPerToman` decides what a payment is worth, and
// `toGatewayAmount` must not need a translator to compute it. Only the bank's
// display name is copy, so only that is a key.
const $84433f335a456b60$export$839b863c97f80b96 = {
    sepehr: {
        labelKey: 'credits.gateway.saderat',
        unit: 'IRR',
        rialsPerToman: 10
    },
    zarinpal: {
        labelKey: 'credits.gateway.zarinpal',
        unit: 'IRT',
        rialsPerToman: 1
    }
};
const $84433f335a456b60$export$bd634cd508c418bb = 'sepehr';
const $84433f335a456b60$export$18053a58f12c6137 = (t, gateway = $84433f335a456b60$export$bd634cd508c418bb)=>{
    const key = $84433f335a456b60$export$839b863c97f80b96[gateway]?.labelKey;
    return key ? t(key) : '';
};
function $84433f335a456b60$export$5fca33782a4a7d9f(amountToman, gateway = $84433f335a456b60$export$bd634cd508c418bb) {
    const factor = $84433f335a456b60$export$839b863c97f80b96[gateway]?.rialsPerToman ?? 1;
    return Math.round(amountToman * factor);
}


// ── Balance ─────────────────────────────────────────────────────────────────
const $3c762e0fe7df1045$var$BALANCE_QUERY = `
  query MyCreditBalance {
    myCreditBalance { balance currency }
  }
`;
const $3c762e0fe7df1045$export$4a4252ca3b3282d3 = 'parsina:credits-changed';
function $3c762e0fe7df1045$export$9cce968afbb01012() {
    if (typeof window !== 'undefined') window.dispatchEvent(new Event($3c762e0fe7df1045$export$4a4252ca3b3282d3));
}
function $3c762e0fe7df1045$export$6f7596e662cfa902() {
    const [balance, setBalance] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        (0, $206625c7d33bd390$export$7fb4864174f056c)($3c762e0fe7df1045$var$BALANCE_QUERY).then((data)=>{
            setBalance(data?.myCreditBalance?.balance ?? null);
            setError(null);
        })// A failed balance read leaves the previous number on screen rather than
        // blanking it. `null` here does not mean zero — it means unknown — and
        // painting «۰ پارسه» over a working wallet is the one wrong answer.
        .catch((err)=>setError(err));
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    // Something in this tab moved it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        window.addEventListener($3c762e0fe7df1045$export$4a4252ca3b3282d3, load);
        return ()=>window.removeEventListener($3c762e0fe7df1045$export$4a4252ca3b3282d3, load);
    }, [
        load
    ]);
    // The dentist came back to the tab — most likely from the payment gateway, or
    // from the doctor panel, where the SAME wallet may have moved.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onVisible = ()=>{
            if (document.visibilityState === 'visible') load();
        };
        document.addEventListener('visibilitychange', onVisible);
        return ()=>document.removeEventListener('visibilitychange', onVisible);
    }, [
        load
    ]);
    return {
        balance: balance,
        error: error,
        reload: load
    };
}
// ── Ledger ──────────────────────────────────────────────────────────────────
const $3c762e0fe7df1045$var$TRANSACTIONS_QUERY = `
  query MyCreditTransactions(
    $limit: Int, $offset: Int, $startDate: String, $endDate: String, $type: String
  ) {
    myCreditTransactions(
      limit: $limit, offset: $offset, startDate: $startDate, endDate: $endDate, type: $type
    ) {
      totalCount
      transactions { id type amount serviceType description createdAt referenceId }
    }
  }
`;
function $3c762e0fe7df1045$export$5735140d6962cb0e({ limit: limit = 30, offset: offset = 0, startDate: startDate = '', endDate: endDate = '', type: type = '' } = {}) {
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        transactions: [],
        totalCount: 0
    });
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($3c762e0fe7df1045$var$TRANSACTIONS_QUERY, {
            limit: limit,
            offset: offset,
            startDate: startDate,
            endDate: endDate,
            type: type
        }).then((res)=>{
            setData(res?.myCreditTransactions ?? {
                transactions: [],
                totalCount: 0
            });
            setError(null);
        }).catch((err)=>setError(err)).finally(()=>setLoading(false));
    }, [
        limit,
        offset,
        startDate,
        endDate,
        type
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    return {
        ...data,
        loading: loading,
        error: error,
        reload: load
    };
}
// ── Top-up ──────────────────────────────────────────────────────────────────
const $3c762e0fe7df1045$var$TOPUP_MUTATION = `
  mutation StartCreditTopUp($gateway: String!, $amount: Int!, $description: String, $returnUrl: String) {
    startCreditTopUp(gateway: $gateway, amount: $amount, description: $description, returnUrl: $returnUrl) {
      gateway paymentUrl
    }
  }
`;
function $3c762e0fe7df1045$export$64e212e524010641(gateway = (0, $84433f335a456b60$export$bd634cd508c418bb)) {
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const startTopUp = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (coins, toman, { description: description, returnUrl: returnUrl } = {})=>{
        setBusy(true);
        setError(null);
        try {
            const amountToman = Math.round(toman ?? coins * (0, $9449204a10cf7050$export$ca9b35f04336e4e5)());
            const res = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($3c762e0fe7df1045$var$TOPUP_MUTATION, {
                gateway: gateway,
                // The one conversion. Sepehr settles in rials, Zarinpal in toman.
                amount: (0, $84433f335a456b60$export$5fca33782a4a7d9f)(amountToman, gateway),
                description: description || '',
                returnUrl: returnUrl || `${window.location.origin}/credits`
            });
            const url = res?.startCreditTopUp?.paymentUrl;
            if (url) {
                window.location.href = url;
                // Deliberately not clearing `busy`: the page is navigating away, and
                // re-enabling the button for the last frames invites a second charge.
                return true;
            }
            setError(new Error('NO_URL'));
            return false;
        } catch (err) {
            // The server's own message is shown when there is one. A gateway that
            // refused the amount, a wallet that is down and a network blip are three
            // different instructions to the dentist, and «به‌زودی» over all of them
            // says a working feature does not exist.
            setError(err);
            return false;
        } finally{
            setBusy(false);
        }
    }, [
        gateway
    ]);
    return {
        startTopUp: startTopUp,
        busy: busy,
        error: error
    };
}
// ── Low-balance alert ───────────────────────────────────────────────────────
const $3c762e0fe7df1045$var$LOW_BALANCE_QUERY = `
  query MyLowBalanceConfig {
    myLowBalanceConfig { threshold enableAlerts }
  }
`;
const $3c762e0fe7df1045$var$LOW_BALANCE_MUTATION = `
  mutation UpdateMyLowBalanceThreshold($threshold: Float!, $enableAlerts: Boolean!) {
    updateMyLowBalanceThreshold(threshold: $threshold, enableAlerts: $enableAlerts) {
      threshold enableAlerts
    }
  }
`;
function $3c762e0fe7df1045$export$2177e3f0da1cd259() {
    const [config, setConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($3c762e0fe7df1045$var$LOW_BALANCE_QUERY).then((res)=>{
            const c = res?.myLowBalanceConfig;
            setConfig(c ? {
                threshold: c.threshold,
                enableAlerts: c.enableAlerts
            } : null);
            setError(null);
        }).catch((err)=>setError(err)).finally(()=>setLoading(false));
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load();
    }, [
        load
    ]);
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (next)=>{
        setSaving(true);
        try {
            const res = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($3c762e0fe7df1045$var$LOW_BALANCE_MUTATION, {
                threshold: Number(next.threshold),
                enableAlerts: !!next.enableAlerts
            });
            const c = res?.updateMyLowBalanceThreshold;
            setConfig({
                threshold: c.threshold,
                enableAlerts: c.enableAlerts
            });
            return true;
        } catch (err) {
            setError(err);
            return false;
        } finally{
            setSaving(false);
        }
    }, []);
    return {
        config: config,
        loading: loading,
        saving: saving,
        error: error,
        reload: load,
        save: save
    };
}
// ── Gift codes ──────────────────────────────────────────────────────────────
const $3c762e0fe7df1045$var$MY_GIFT_CODES = `
  query MyGiftCodes {
    myGiftCodes { id code parseh smartVisits status expiresAtMs redeemedAtMs }
  }
`;
const $3c762e0fe7df1045$var$REDEEM_GIFT_CODE = `
  mutation RedeemGiftCode($code: String!) {
    redeemGiftCode(code: $code) {
      granted
      giftCode { id code parseh smartVisits status redeemedAtMs }
      balance { balance currency }
    }
  }
`;
function $3c762e0fe7df1045$export$67e83c350c566786() {
    const [codes, setCodes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const refresh = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($3c762e0fe7df1045$var$MY_GIFT_CODES).then((data)=>setCodes(data?.myGiftCodes || []))// The BFF already answers `[]` for an unreachable CRM; this catch is for
        // a failed request, and the answer is the same — the rest of the page
        // works, and the dentist is not shown an error about a card they may
        // never use.
        .catch(()=>setCodes([])).finally(()=>setLoading(false));
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        refresh();
    }, [
        refresh
    ]);
    const redeem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (code)=>{
        const trimmed = (code || '').trim();
        if (!trimmed) return {
            ok: false,
            code: 'EMPTY'
        };
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($3c762e0fe7df1045$var$REDEEM_GIFT_CODE, {
                code: trimmed
            });
            const result = data?.redeemGiftCode;
            if (!result) return {
                ok: false,
                code: 'UNKNOWN'
            };
            refresh();
            return {
                ok: true,
                granted: result.granted,
                smartVisits: result.giftCode?.smartVisits ?? 0,
                balance: result.balance?.balance ?? null
            };
        } catch (err) {
            // The BFF's message is written FOR the dentist — «قبلاً استفاده شده»,
            // «منقضی شده» — and each is a different instruction, so it is shown rather
            // than replaced with one generic line.
            const gqlError = err?.graphQLErrors?.[0];
            return {
                ok: false,
                code: gqlError?.extensions?.code || err?.extensions?.code || 'UNKNOWN',
                message: gqlError?.message || err?.message || ''
            };
        }
    }, [
        refresh
    ]);
    return {
        codes: codes,
        loading: loading,
        redeem: redeem,
        refresh: refresh
    };
}


// Balance thresholds — «چقدر اعتبار کم است؟» answered once.
//
// THE DEFINITION MOVED. It lives in `@parsina/framework/tokens` as of framework
// v0.10.0 and this file is now a re-export, so the call sites that know it by
// this path keep working while there is exactly ONE copy in the monorepo.
//
// The old comment here said these numbers were "deliberately identical" to the
// doctor client's — and the doctor client's said the same about this one, and the
// clinic client carried a third copy. Three files kept in sync by comment is not
// a mechanism. One person has ONE wallet, and there is deliberately no `dentist`
// owner_type: a top-up made in this panel pays for an AI call made in the doctor
// panel, so «اعتبار کم» must mean the same thing in both.
//
// Still true, and still worth saying: this is a CLIENT rule about how a balance
// is PAINTED. It is not the wallet's alert threshold — that one is configurable
// per account and lives on the server (`myLowBalanceConfig`); this is the red
// floor below which the page puts a top-up button in front of the dentist
// regardless.
//
// Add nothing to this file. A new rule belongs in the framework.




/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $86bc9f94aec05e0c$export$a2387ed3b5d536eb = {
    name: "user-round",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "8",
                r: "5",
                key: "1hypcn"
            }
        ],
        [
            "path",
            {
                d: "M20 21a8 8 0 0 0-16 0",
                key: "rfgkzh"
            }
        ]
    ],
    aliases: [
        "user-2"
    ]
};
$86bc9f94aec05e0c$export$a2387ed3b5d536eb.node;
const $86bc9f94aec05e0c$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($86bc9f94aec05e0c$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $df82e729d4b50e19$export$a2387ed3b5d536eb = {
    name: "users",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "path",
            {
                d: "M16 3.128a4 4 0 0 1 0 7.744",
                key: "16gr8j"
            }
        ],
        [
            "path",
            {
                d: "M22 21v-2a4 4 0 0 0-3-3.87",
                key: "kshegd"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ]
    ]
};
$df82e729d4b50e19$export$a2387ed3b5d536eb.node;
const $df82e729d4b50e19$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($df82e729d4b50e19$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7dfd9db3a50f7eb1$export$a2387ed3b5d536eb = {
    name: "wallet",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
                key: "18etb6"
            }
        ],
        [
            "path",
            {
                d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
                key: "xoc0q4"
            }
        ]
    ]
};
$7dfd9db3a50f7eb1$export$a2387ed3b5d536eb.node;
const $7dfd9db3a50f7eb1$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($7dfd9db3a50f7eb1$export$a2387ed3b5d536eb);


const $58df888399335ec9$export$d42503afcc3a9b06 = [
    {
        id: 'today',
        labelKey: 'nav.items.today',
        Icon: (0, $5b56343e65588121$export$2e2bcd8739ae039)
    },
    {
        id: 'patients',
        labelKey: 'nav.items.patients',
        Icon: (0, $df82e729d4b50e19$export$2e2bcd8739ae039)
    },
    {
        id: 'credits',
        labelKey: 'nav.items.credits',
        Icon: (0, $7dfd9db3a50f7eb1$export$2e2bcd8739ae039)
    },
    {
        id: 'profile',
        labelKey: 'nav.items.profile',
        Icon: (0, $86bc9f94aec05e0c$export$2e2bcd8739ae039)
    }
];
function $58df888399335ec9$export$798863679d04a4c9(pathname) {
    if (pathname === '/' || pathname.startsWith('/today')) return 'today';
    if (pathname.startsWith('/patients') || pathname.startsWith('/prescription')) return 'patients';
    if (pathname.startsWith('/credits')) return 'credits';
    if (pathname.startsWith('/profile')) return 'profile';
    return null;
}
const $58df888399335ec9$export$c8efa7b3e004c1a3 = [
    '/',
    '/patients',
    '/credits',
    '/profile'
];
const $58df888399335ec9$export$3ee288e5161ec231 = (pathname)=>{
    const normalized = String(pathname || '/').replace(/\/+$/, '') || '/';
    return $58df888399335ec9$export$c8efa7b3e004c1a3.includes(normalized);
};
var $58df888399335ec9$export$2e2bcd8739ae039 = $58df888399335ec9$export$d42503afcc3a9b06;


/*
 * RTL layout: the sidebar is on the RIGHT of the screen.
 * When it collapses, `overflow: hidden` clips from the LEFT — so anything that
 * must stay visible (the toggle, the icons, the avatar) has to be anchored to
 * the RIGHT, i.e. come FIRST in RTL flex order. Every rule below follows from
 * that one sentence.
 */ const $64212f0be7bb84ee$var$MINI = 68; // collapsed width
const $64212f0be7bb84ee$var$FULL = 260; // expanded width
// Glyphs for the AccountCard menu. App-local, like the destination icons: the
// kit owns the menu's shape, not its destinations, so it owns none of their
// icons either. Identical set to the doctor panel's, so a dentist who uses both
// is not relearning the same four rows.
const $64212f0be7bb84ee$var$ICON = {
    account: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
        })
    }),
    clinic: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
        })
    }),
    // Not mirrored: the arrow points out of a door, not along the reading direction.
    logout: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "currentColor",
        width: "17",
        height: "17",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
        })
    })
};
const $64212f0be7bb84ee$var$DentistLayout = ({ children: children })=>{
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const { me: me } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    const { scopeClinics: scopeClinics, activeId: activeId, setActiveId: setActiveId } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    // The dentist's own پارسه, for the AccountCard below. The SAME wallet the
    // doctor panel spends — one person, one balance.
    const { balance: balance } = (0, $3c762e0fe7df1045$export$6f7596e662cfa902)();
    // The level comes from the framework's one credit scale, so this panel and the
    // doctor's cannot disagree about what «کم» means.
    const balanceLevel = (0, $e7c165fb515b04ea$export$2e1a2382662bd4ea)(balance);
    // Which clinic «رفتن به پنل کلینیک» lands on: the one currently scoping this
    // panel, so the dentist arrives where they were already working. Falls back to
    // the first membership when the scope has not resolved yet, and is null — so
    // the row is not rendered — when there is no clinic to enter at all.
    const clinicTarget = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>scopeClinics.find((m)=>m.clinicId === activeId) || scopeClinics[0] || null, [
        scopeClinics,
        activeId
    ]);
    // This layout is now the DESKTOP surface only — App.jsx swaps it for
    // MobileShell at ≤768px, so the collapse below is about a narrow LAPTOP (a
    // chairside window between 768 and 1100px), not about a phone. A phone gets
    // the bottom bar, not a 68px rail eating 19% of a 360px viewport.
    const [collapsed, setCollapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== 'undefined' && window.innerWidth < 1100);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const mq = window.matchMedia('(max-width: 1100px)');
        const onChange = (e)=>setCollapsed(e.matches);
        mq.addEventListener('change', onChange);
        return ()=>mq.removeEventListener('change', onChange);
    }, []);
    const current = (0, $58df888399335ec9$export$798863679d04a4c9)(location.pathname);
    // Labels live in the DOM always and fade, so the width transition stays smooth.
    const fade = {
        opacity: collapsed ? 0 : 1,
        transition: 'opacity 0.22s ease',
        pointerEvents: collapsed ? 'none' : 'auto',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            width: '100vw',
            height: '100vh',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    width: collapsed ? $64212f0be7bb84ee$var$MINI : $64212f0be7bb84ee$var$FULL,
                    flexShrink: 0,
                    background: (0, $e7c165fb515b04ea$export$4a4d076b923f4e78),
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    transition: 'width 0.3s cubic-bezier(.4,0,.2,1)',
                    zIndex: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            height: 68,
                            display: 'flex',
                            alignItems: 'center',
                            flexShrink: 0,
                            borderBottom: '1px solid rgba(255,255,255,0.07)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    width: $64212f0be7bb84ee$var$MINI,
                                    flexShrink: 0,
                                    display: 'flex',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setCollapsed((c)=>!c),
                                    title: collapsed ? t('nav.sidebar.expand') : t('nav.sidebar.collapse'),
                                    "aria-label": collapsed ? t('nav.sidebar.expand') : t('nav.sidebar.collapse'),
                                    style: {
                                        width: 36,
                                        height: 36,
                                        background: 'rgba(255,255,255,0.08)',
                                        border: 'none',
                                        borderRadius: 10,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        color: 'rgba(255,255,255,0.6)'
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                        viewBox: "0 0 24 24",
                                        fill: "currentColor",
                                        width: "18",
                                        height: "18",
                                        style: {
                                            transition: 'transform 0.3s cubic-bezier(.4,0,.2,1)',
                                            // The glyph points at the sidebar's own edge, so it mirrors
                                            // with the layout as well as rotating with the toggle.
                                            transform: `scaleX(var(--dir-flip, 1)) rotate(${collapsed ? 0 : 180}deg)`
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                            d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    paddingInlineStart: 4,
                                    paddingInlineEnd: 8,
                                    ...fade
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))),
                                        alt: "",
                                        style: {
                                            height: '2.2rem',
                                            width: 'auto',
                                            objectFit: 'contain',
                                            flexShrink: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    color: 'white',
                                                    fontSize: 16,
                                                    fontWeight: 800,
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: t('nav.brand.name')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    color: 'rgba(255,255,255,0.45)',
                                                    fontSize: 11,
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: t('nav.brand.panel')
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                        "aria-label": t('nav.landmark.primary'),
                        style: {
                            flex: 1,
                            paddingTop: 10,
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        },
                        children: (0, $58df888399335ec9$export$d42503afcc3a9b06).map((item)=>{
                            const active = current === item.id;
                            const { Icon: Icon } = item;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>navigate(item.id),
                                title: collapsed ? t(item.labelKey) : undefined,
                                "aria-current": active ? 'page' : undefined,
                                style: {
                                    width: 'calc(100% - 20px)',
                                    margin: '2px 10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: 0,
                                    border: 'none',
                                    borderRadius: 10,
                                    background: active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : 'transparent',
                                    boxShadow: active ? '0 2px 8px rgba(0,0,0,0.22)' : 'none',
                                    cursor: 'pointer',
                                    transition: 'background 0.18s, box-shadow 0.18s',
                                    fontFamily: 'inherit'
                                },
                                onMouseEnter: (e)=>{
                                    if (!active) e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                                },
                                onMouseLeave: (e)=>{
                                    if (!active) e.currentTarget.style.background = 'transparent';
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: $64212f0be7bb84ee$var$MINI - 20,
                                            flexShrink: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '11px 0',
                                            color: active ? 'white' : 'rgba(255,255,255,0.55)'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 20,
                                            "aria-hidden": true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...fade,
                                            color: active ? 'white' : 'rgba(255,255,255,0.55)',
                                            fontSize: 14,
                                            fontWeight: active ? 700 : 500
                                        },
                                        children: t(item.labelKey)
                                    })
                                ]
                            }, item.id);
                        })
                    }),
                    scopeClinics.length > 1 && !collapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            padding: '0 14px 10px',
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: "clinic-scope",
                                style: {
                                    display: 'block',
                                    fontSize: 10.5,
                                    fontWeight: 600,
                                    color: 'rgba(255,255,255,0.45)',
                                    marginBottom: 5
                                },
                                children: t('nav.clinic.label')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                                id: "clinic-scope",
                                value: activeId || '',
                                onChange: (e)=>setActiveId(e.target.value),
                                style: {
                                    width: '100%',
                                    height: 34,
                                    borderRadius: 9,
                                    border: '1px solid rgba(255,255,255,0.14)',
                                    background: 'rgba(255,255,255,0.08)',
                                    color: '#fff',
                                    fontFamily: 'inherit',
                                    fontSize: 12.5,
                                    padding: '0 8px'
                                },
                                children: scopeClinics.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: m.clinicId,
                                        style: {
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        children: m.clinic?.name || m.clinicId
                                    }, m.clinicId))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a13c7c62f369d090$export$2e2bcd8739ae039), {
                        "data-testid": "account-card",
                        collapsed: collapsed,
                        menuLabel: t('nav.account.menuLabel'),
                        user: {
                            name: me?.fullName || "\u2014",
                            subtitle: me?.specialty || ''
                        },
                        credit: balance === null ? null : {
                            // Already localised by the app — the kit renders digits verbatim.
                            amount: (0, $75f061374f24c25d$export$b634cc5d06849b0a)(balance, formatNumber),
                            level: balanceLevel,
                            unit: t('credits.unit'),
                            label: t('nav.credits.label'),
                            levelLabel: balanceLevel ? t((0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[balanceLevel].shortLabelKey) : '',
                            onClick: ()=>navigate('credits')
                        },
                        onTopUp: ()=>navigate('credits'),
                        topUpLabel: t('nav.credits.topUp'),
                        items: [
                            {
                                key: 'account',
                                // Name, password and language belong to حساب پارسینا — one account
                                // backs every panel, so an editor here would be a second writer
                                // against the same person.
                                label: t('nav.account.parsina'),
                                description: t('nav.account.parsinaHint'),
                                icon: $64212f0be7bb84ee$var$ICON.account,
                                href: (0, $d87bd335296b449f$export$cce6d3603c0b63d)('/'),
                                external: true,
                                'data-testid': 'sidebar-account'
                            },
                            // Neither «پروفایل» nor «اعتبار» gets a row: both are visible nav
                            // destinations, and a menu copy of a row one press away in the rail
                            // is noise. The balance card above is the entry to اعتبار; this menu
                            // carries only what the rail cannot.
                            clinicTarget && {
                                key: 'clinic',
                                label: t('nav.clinicSwitch.label'),
                                description: clinicTarget.clinic?.name || '',
                                icon: $64212f0be7bb84ee$var$ICON.clinic,
                                onClick: ()=>(0, $d87bd335296b449f$export$35411b84b35a3ed4)(clinicTarget.clinicId),
                                'data-testid': 'switch-to-clinic'
                            },
                            {
                                key: 'logout',
                                label: t('nav.sidebar.logout'),
                                icon: $64212f0be7bb84ee$var$ICON.logout,
                                tone: 'destructive',
                                separatorBefore: true,
                                onClick: ()=>(0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)()
                            }
                        ].filter(Boolean)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                "aria-label": t('nav.landmark.content'),
                style: {
                    flex: 1,
                    minWidth: 0,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                },
                children: children
            })
        ]
    });
};
var $64212f0be7bb84ee$export$2e2bcd8739ae039 = $64212f0be7bb84ee$var$DentistLayout;




var $acw62 = parcelRequire("acw62");






// The mobile shell — what replaces DentistLayout below 768px.
//
// DESIGN-CONCEPT-MOBILE §3: "The shell is bottom navigation + per-screen
// headers. There is no sidebar, no drawer, no shared TopBar." The rail is not
// collapsed here, it is GONE: a 68px mini-rail on a 360px viewport is a
// shrunken workstation, which is the thing the concept exists to reject, and it
// spends 19% of the width on chrome that a thumb cannot comfortably reach
// anyway.
//
// Each screen supplies its own gradient MobileHeader (§3.2). This file owns
// only two things: the single page scroll, and the bar.
/*
 * `position: fixed; inset: 0` is LOAD-BEARING, not a style choice.
 *
 * styles.css sets `#root { display:flex; align-items:center; justify-content:
 * center; min-height:100vh }` over `body { background:#0f1923 }` — the frame the
 * pre-app auth screens are centred in. A flow-positioned mobile shell inherits
 * that and renders as a centred box floating on a dark page. Taking the shell
 * out of flow is what makes the app fill the phone.
 *
 * It is also the shape §6's "one page-level scroll" needs: an
 * `inset:0; overflow:hidden` root with exactly ONE inner scroll region. (It is
 * the same shape the kit's ChatThread documents when it resolves its scroller —
 * a mobile shell is not the document.)
 */ const $3dffe7472d2e8d91$var$ROOT = {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
    // §8: "The mobile root owns env(safe-area-inset-*)". The TOP inset belongs to
    // MobileHeader (it already pads `calc(1rem + env(safe-area-inset-top))`) and
    // the BOTTOM to BottomNav, so what is left for the root is the notch's left
    // and right — the landscape case, where content would otherwise run under the
    // rounded corners.
    paddingInlineStart: 'env(safe-area-inset-left, 0px)',
    paddingInlineEnd: 'env(safe-area-inset-right, 0px)'
};
/*
 * The body does NOT scroll — each screen owns exactly ONE scroll region inside
 * it, and that is the deliberate choice §6 forces ("one page-level scroll;
 * nested vertical scroll regions are a defect").
 *
 * A scrolling body here would make two: the screen's own scroller nested in the
 * shell's. It would also make the two rules the concept states about the header
 * impossible to express — §3.2 wants the cockpit's header PINNED (امروز, where
 * the day's numbers must never leave the screen) and a content screen's header
 * to SCROLL AWAY (the record, where content wins the viewport). Which of the two
 * happens is decided by whether a screen puts its MobileHeader inside its
 * scroller, and that decision only exists if the shell is not scrolling for it.
 */ const $3dffe7472d2e8d91$var$BODY = {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
};
const $3dffe7472d2e8d91$var$MobileShell = ({ children: children })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const active = (0, $58df888399335ec9$export$798863679d04a4c9)(location.pathname);
    // §3.1: the bar renders only on top-level destinations. A patient record and
    // نسخه are full-screen surfaces whose MobileHeader carries the way back —
    // a bottom bar there would offer «بیماران» as an escape from a record the
    // dentist is halfway through charting.
    const showNav = (0, $58df888399335ec9$export$3ee288e5161ec231)(location.pathname);
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $58df888399335ec9$export$d42503afcc3a9b06).map(({ id: id, labelKey: labelKey, Icon: Icon })=>({
                key: id,
                label: t(labelKey),
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 22,
                    "aria-hidden": true
                })
            })), [
        t
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: $3dffe7472d2e8d91$var$ROOT,
        "data-testid": "mobile-shell",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                "aria-label": t('nav.landmark.content'),
                style: $3dffe7472d2e8d91$var$BODY,
                "data-testid": "mobile-scroll",
                children: children
            }),
            showNav && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5943a0a75dff01a1$export$2e2bcd8739ae039), {
                items: items,
                active: active,
                onSelect: (key)=>navigate(key),
                "data-testid": "dentist-bottom-nav",
                // The kit hardcodes a Persian `aria-label`, and its `...rest` spreads
                // AFTER it, so a caller-supplied one wins. This app ships `en` too.
                "aria-label": t('nav.landmark.primary')
            })
        ]
    });
};
var $3dffe7472d2e8d91$export$2e2bcd8739ae039 = $3dffe7472d2e8d91$var$MobileShell;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ba16dd414953e5a4$export$a2387ed3b5d536eb = {
    name: "info",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 16v-4",
                key: "1dtifu"
            }
        ],
        [
            "path",
            {
                d: "M12 8h.01",
                key: "e9boi3"
            }
        ]
    ]
};
$ba16dd414953e5a4$export$a2387ed3b5d536eb.node;
const $ba16dd414953e5a4$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($ba16dd414953e5a4$export$a2387ed3b5d536eb);






// امروز — the day sheet and the waiting room.
//
// THIS IS THE CLINIC CONNECTION. Every row is the same `appointments` row the
// منشی created in the clinic app: one table in scheduling, `doctor_id` = this
// dentist. Nothing here writes — booking, cancelling, marking arrived and queue
// order belong to the clinic desk, and the BFF exposes no scheduling mutation
// at all rather than shipping buttons that lead nowhere.
//
// Two queries, always fired together:
//   today(date, clinicId)  the selected calendar day, ascending
//   queue                  arrived + in_visit right now, in the SERVICE's order
//
// The queue is deliberately a separate read: it is "who is in the building",
// which is a fact about NOW and not about the selected day, and its order is
// the scheduling service's own (in_visit first, then the desk's manual
// position, then time). Re-deriving that order client-side is how the dentist
// and the desk end up disagreeing about who walks in next.

var $acw62 = parcelRequire("acw62");


const $02315dbdc761d1d1$var$APPOINTMENT_FIELDS = `
  id
  patientId
  placeholderLabel
  clinicId
  dateTime
  type
  status
  urgency
  queuePosition
  durationMinutes
  arrivedAt
  visitStartedAt
  patient { id name phone avatarUrl }
`;
const $02315dbdc761d1d1$export$1383b78d6e520d08 = `
  query DaySheet($date: String, $clinicId: ID) {
    today(date: $date, clinicId: $clinicId) {
      date
      total
      appointments { ${$02315dbdc761d1d1$var$APPOINTMENT_FIELDS} }
    }
  }
`;
const $02315dbdc761d1d1$export$34a55dd15989950c = `
  query Queue($clinicId: ID) {
    queue(clinicId: $clinicId) { ${$02315dbdc761d1d1$var$APPOINTMENT_FIELDS} }
  }
`;
// A day sheet goes stale by itself: the desk marks patients arrived while the
// dentist is looking at it. There is no /ws/events on this BFF — the doctor
// app's socket has no counterpart here — so this polls, and says so rather than
// opening a socket that would never connect.
const $02315dbdc761d1d1$var$POLL_MS = 30000;
function $02315dbdc761d1d1$export$6d84255ad587f3b5({ date: date, clinicId: clinicId }) {
    const iso = date || (0, $6e94fc1378f3a785$export$ceda478235320bf2)();
    const [appointments, setAppointments] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [queue, setQueue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // The day the newest request was fired for. A slow response for a day the
    // dentist has already navigated away from must not overwrite the one on
    // screen.
    const wantedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(iso);
    wantedRef.current = iso;
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        if (initial) setLoading(true);
        const asked = iso;
        const [day, room] = await Promise.allSettled([
            (0, $206625c7d33bd390$export$7fb4864174f056c)($02315dbdc761d1d1$export$1383b78d6e520d08, {
                date: asked,
                clinicId: clinicId || null
            }),
            (0, $206625c7d33bd390$export$7fb4864174f056c)($02315dbdc761d1d1$export$34a55dd15989950c, {
                clinicId: clinicId || null
            })
        ]);
        if (wantedRef.current !== asked) return;
        if (day.status === 'fulfilled') setAppointments(day.value?.today?.appointments || []);
        if (room.status === 'fulfilled') setQueue(room.value?.queue || []);
        // The DAY read IS the screen, so a failed first paint of it is an error
        // screen even when the queue arrived.
        //
        // Requiring BOTH to fail looked conservative and was not: Today.web.jsx
        // gates the waiting-room block on the day list being non-empty, so a
        // queue that arrived alone paints nothing at all — the dentist is shown
        // «هیچ نوبتی برای این روز ثبت نشده» for a day that was never read, while
        // patients sit in the waiting room. "No appointments" and "we could not
        // ask" are different facts and only one of them is silence.
        //
        // A failed queue read on its own is NOT an error: it is supplementary,
        // and the day still renders. And `initial` still guards the other rule —
        // a failed background refresh never replaces a day the dentist is
        // reading with an error card.
        if (initial && day.status === 'rejected') {
            console.error('[useToday] day read failed:', day.reason?.message);
            setError(day.reason);
        } else if (day.status === 'fulfilled') setError(null);
        if (initial) setLoading(false);
    }, [
        iso,
        clinicId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        setError(null);
        load({
            initial: true
        });
        const timer = setInterval(()=>{
            if (alive && document.visibilityState === 'visible') load();
        }, $02315dbdc761d1d1$var$POLL_MS);
        return ()=>{
            alive = false;
            clearInterval(timer);
        };
    }, [
        load
    ]);
    return {
        appointments: appointments,
        queue: queue,
        loading: loading,
        error: error,
        reload: ()=>load({
                initial: true
            })
    };
}
var $02315dbdc761d1d1$export$2e2bcd8739ae039 = $02315dbdc761d1d1$export$6d84255ad587f3b5;


// «خدمت» on the «بیمار بعدی» hero — what the next patient is coming FOR.
//
// The appointment row cannot answer this. `Appointment.type` is online |
// in_person and scheduling's own visit_type is a dead column the service never
// populates: the clinic desk books an hour with a dentist, not a treatment. The
// answer lives in the patient's طرح درمان — whatever a previous visit agreed
// and did not carry out is what the next sitting is for, and a patient with no
// outstanding line is coming for a ویزیت.
//
// ── One patient, not the day sheet ─────────────────────────────────────────
// This reads the plan of exactly ONE patient: the one `buildDayModel()` called
// next. Hanging the same read off every row would be a plan read and a record
// read per appointment on every paint of a twenty-row day, for a fact the
// screen shows in one place.
//
// ── And it does not ride the day poll ──────────────────────────────────────
// useToday re-reads every 30s so the desk's «پذیرش شد» lands. A plan does not
// change on that clock — it changes when this dentist edits it, inside the
// visit, on another screen — so this fires on the PATIENT changing and not on
// the tick. The cost of being a minute stale here is a name; the cost of
// polling two more reads forever is every dentist's battery.

var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3f35c50d66e81764$export$a2387ed3b5d536eb = {
    name: "clipboard-list",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1",
                key: "tgr4d6"
            }
        ],
        [
            "path",
            {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                key: "116196"
            }
        ],
        [
            "path",
            {
                d: "M12 11h4",
                key: "1jrz19"
            }
        ],
        [
            "path",
            {
                d: "M12 16h4",
                key: "n85exb"
            }
        ],
        [
            "path",
            {
                d: "M8 11h.01",
                key: "1dfujw"
            }
        ],
        [
            "path",
            {
                d: "M8 16h.01",
                key: "18s6g9"
            }
        ]
    ]
};
$3f35c50d66e81764$export$a2387ed3b5d536eb.node;
const $3f35c50d66e81764$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3f35c50d66e81764$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3703118ab2b2b83a$export$a2387ed3b5d536eb = {
    name: "message-circle-question-mark",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
                key: "1sd12s"
            }
        ],
        [
            "path",
            {
                d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3",
                key: "1u773s"
            }
        ],
        [
            "path",
            {
                d: "M12 17h.01",
                key: "p32p05"
            }
        ]
    ],
    aliases: [
        "message-circle-question"
    ]
};
$3703118ab2b2b83a$export$a2387ed3b5d536eb.node;
const $3703118ab2b2b83a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3703118ab2b2b83a$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5ffe798f65d504e7$export$a2387ed3b5d536eb = {
    name: "pill",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
                key: "wa1lgi"
            }
        ],
        [
            "path",
            {
                d: "m8.5 8.5 7 7",
                key: "rvfmvr"
            }
        ]
    ]
};
$5ffe798f65d504e7$export$a2387ed3b5d536eb.node;
const $5ffe798f65d504e7$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5ffe798f65d504e7$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $02839c5704f38745$export$a2387ed3b5d536eb = {
    name: "stethoscope",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11 2v2",
                key: "1539x4"
            }
        ],
        [
            "path",
            {
                d: "M5 2v2",
                key: "1yf1q8"
            }
        ],
        [
            "path",
            {
                d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1",
                key: "rb5t3r"
            }
        ],
        [
            "path",
            {
                d: "M8 15a6 6 0 0 0 12 0v-3",
                key: "x18d4x"
            }
        ],
        [
            "circle",
            {
                cx: "20",
                cy: "10",
                r: "2",
                key: "ts1r5v"
            }
        ]
    ]
};
$02839c5704f38745$export$a2387ed3b5d536eb.node;
const $02839c5704f38745$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($02839c5704f38745$export$a2387ed3b5d536eb);


// The tooth grammar, client side.
//
// The SERVER owns validation (the dental microservice's app/domain/teeth.py).
// This module is for LAYOUT and LABELLING — what to draw, where, and what to
// call it. It deliberately does not re-implement the rules: the chart read
// already tells us `surfacesAvailable` per tooth, and this file only needs the
// same list to render a tooth the server has never heard of yet (an unchartd
// one) before the first read lands.
//
// FDI / ISO 3950 — decided 2026-08-02, CORE.md §6.
//
//   1 upper-right   2 upper-left        5 upper-right   6 upper-left   (primary)
//   4 lower-right   3 lower-left        8 lower-right   7 lower-left
//
// THE ANATOMICAL FRAME — CORE.md §9, a patient-safety invariant, not styling:
//
//   The chart is drawn in the PATIENT's frame, as the dentist looks into the
//   mouth. Quadrants 1 and 4 (the patient's RIGHT) sit on the SCREEN's LEFT,
//   in BOTH locales. The app is RTL-first, so a well-meaning RTL pass is
//   exactly what would mirror this and put the dentist on the wrong side of
//   the mouth. The SVG is therefore rendered with an explicit `direction: ltr`
//   and absolute coordinates — never logical properties, never `--dir-flip`.
// ── The teeth, in DRAWING order (screen left → right) ───────────────────────
// Upper right runs 18→11 so the arch reads outward-to-midline on the left half,
// then 21→28 outward again on the right. That is the order a printed chart uses
// and the order arrow keys should traverse.
const $789c06d5db9cfc3f$export$5a612d534771cd4d = [
    '18',
    '17',
    '16',
    '15',
    '14',
    '13',
    '12',
    '11'
];
const $789c06d5db9cfc3f$export$6c4603ff5929fc45 = [
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28'
];
const $789c06d5db9cfc3f$export$c424c982f84c895e = [
    '48',
    '47',
    '46',
    '45',
    '44',
    '43',
    '42',
    '41'
];
const $789c06d5db9cfc3f$export$160c5beaa48911ca = [
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38'
];
const $789c06d5db9cfc3f$export$d710d07514285490 = [
    '55',
    '54',
    '53',
    '52',
    '51'
];
const $789c06d5db9cfc3f$export$3cc89f30d94feb2a = [
    '61',
    '62',
    '63',
    '64',
    '65'
];
const $789c06d5db9cfc3f$export$1f51469cfe7942b5 = [
    '85',
    '84',
    '83',
    '82',
    '81'
];
const $789c06d5db9cfc3f$export$9227d6333792fc43 = [
    '71',
    '72',
    '73',
    '74',
    '75'
];
const $789c06d5db9cfc3f$export$7841f2f53987dfb9 = {
    upper: [
        ...$789c06d5db9cfc3f$export$5a612d534771cd4d,
        ...$789c06d5db9cfc3f$export$6c4603ff5929fc45
    ],
    lower: [
        ...$789c06d5db9cfc3f$export$c424c982f84c895e,
        ...$789c06d5db9cfc3f$export$160c5beaa48911ca
    ]
};
const $789c06d5db9cfc3f$export$fc5732f3d203b9d = {
    upper: [
        ...$789c06d5db9cfc3f$export$d710d07514285490,
        ...$789c06d5db9cfc3f$export$3cc89f30d94feb2a
    ],
    lower: [
        ...$789c06d5db9cfc3f$export$1f51469cfe7942b5,
        ...$789c06d5db9cfc3f$export$9227d6333792fc43
    ]
};
const $789c06d5db9cfc3f$export$caea9277658ec1cf = [
    ...$789c06d5db9cfc3f$export$7841f2f53987dfb9.upper,
    ...$789c06d5db9cfc3f$export$7841f2f53987dfb9.lower
];
const $789c06d5db9cfc3f$export$591efb51beeb9bfa = [
    ...$789c06d5db9cfc3f$export$fc5732f3d203b9d.upper,
    ...$789c06d5db9cfc3f$export$fc5732f3d203b9d.lower
];
const $789c06d5db9cfc3f$export$89717d998154e6e4 = [
    {
        id: '1',
        key: 'chart.quadrant.upperRight',
        teeth: $789c06d5db9cfc3f$export$5a612d534771cd4d,
        primary: $789c06d5db9cfc3f$export$d710d07514285490
    },
    {
        id: '2',
        key: 'chart.quadrant.upperLeft',
        teeth: $789c06d5db9cfc3f$export$6c4603ff5929fc45,
        primary: $789c06d5db9cfc3f$export$3cc89f30d94feb2a
    },
    {
        id: '4',
        key: 'chart.quadrant.lowerRight',
        teeth: $789c06d5db9cfc3f$export$c424c982f84c895e,
        primary: $789c06d5db9cfc3f$export$1f51469cfe7942b5
    },
    {
        id: '3',
        key: 'chart.quadrant.lowerLeft',
        teeth: $789c06d5db9cfc3f$export$160c5beaa48911ca,
        primary: $789c06d5db9cfc3f$export$9227d6333792fc43
    }
];
const $789c06d5db9cfc3f$export$4d89b90a838e8cb1 = (teeth)=>(teeth || []).some((s)=>!s.isPermanent && s.isCharted);
const $789c06d5db9cfc3f$export$7995d2693cfacea3 = (showPrimary, teeth)=>showPrimary === true || showPrimary === 'auto' && $789c06d5db9cfc3f$export$4d89b90a838e8cb1(teeth);
const $789c06d5db9cfc3f$export$8a45705b1b8eb2ec = (fdi)=>[
        '1',
        '2',
        '3',
        '4'
    ].includes(String(fdi)[0]);
const $789c06d5db9cfc3f$export$ae50dec7acbeb690 = (fdi)=>[
        '1',
        '2',
        '5',
        '6'
    ].includes(String(fdi)[0]);
const $789c06d5db9cfc3f$export$5880b8b5730aff45 = (fdi)=>Number(String(fdi)[1]);
const $789c06d5db9cfc3f$export$91c5a5d0ecc2fdd = (fdi)=>$789c06d5db9cfc3f$export$5880b8b5730aff45(fdi) <= 3;
const $789c06d5db9cfc3f$export$449bdafc1e1c1cf7 = {
    M: 'M',
    D: 'D',
    F: 'F',
    L: 'L',
    O: 'O',
    I: 'I'
};
const $789c06d5db9cfc3f$export$e8e69ffa6db2b2c2 = (fdi)=>[
        'M',
        'D',
        'F',
        'L',
        $789c06d5db9cfc3f$export$91c5a5d0ecc2fdd(fdi) ? 'I' : 'O'
    ];
const $789c06d5db9cfc3f$export$c772952b4b390da9 = (fdi)=>[
        '1',
        '4',
        '5',
        '8'
    ].includes(String(fdi)[0]);
const $789c06d5db9cfc3f$export$52e39c9e8fc17728 = {
    PRESENT: 'present',
    EXTRACTED: 'extracted',
    EXFOLIATED: 'exfoliated',
    CONGENITALLY_ABSENT: 'congenitally_absent',
    UNERUPTED: 'unerupted',
    IMPACTED: 'impacted'
};
const $789c06d5db9cfc3f$export$5c3943b5a89fa884 = (presence)=>[
        $789c06d5db9cfc3f$export$52e39c9e8fc17728.EXTRACTED,
        $789c06d5db9cfc3f$export$52e39c9e8fc17728.EXFOLIATED,
        $789c06d5db9cfc3f$export$52e39c9e8fc17728.CONGENITALLY_ABSENT
    ].includes(presence);
const $789c06d5db9cfc3f$export$82384a94f00cdd46 = [
    $789c06d5db9cfc3f$export$52e39c9e8fc17728.PRESENT,
    $789c06d5db9cfc3f$export$52e39c9e8fc17728.EXTRACTED,
    $789c06d5db9cfc3f$export$52e39c9e8fc17728.EXFOLIATED,
    $789c06d5db9cfc3f$export$52e39c9e8fc17728.CONGENITALLY_ABSENT,
    $789c06d5db9cfc3f$export$52e39c9e8fc17728.UNERUPTED,
    $789c06d5db9cfc3f$export$52e39c9e8fc17728.IMPACTED
];
const $789c06d5db9cfc3f$export$1cfe08df32bc8f76 = {
    SOUND: 'sound',
    CARIES: 'caries',
    ROOT_CANAL: 'root_canal',
    POST_CORE: 'post_core',
    CROWN: 'crown',
    VENEER: 'veneer',
    IMPLANT: 'implant',
    BRIDGE_ABUTMENT: 'bridge_abutment',
    BRIDGE_PONTIC: 'bridge_pontic',
    FRACTURE: 'fracture',
    ATTRITION: 'attrition',
    MOBILITY: 'mobility',
    PERIAPICAL_LESION: 'periapical_lesion',
    SEALANT: 'sealant',
    TEMPORARY: 'temporary',
    WATCH: 'watch'
};
const $789c06d5db9cfc3f$export$58954b0b7e983b1b = [
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.CARIES,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.ROOT_CANAL,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.CROWN,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.IMPLANT,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.VENEER,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.POST_CORE,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_ABUTMENT,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_PONTIC,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.SEALANT,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.TEMPORARY,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.FRACTURE,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.ATTRITION,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.MOBILITY,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.PERIAPICAL_LESION,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.WATCH,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.SOUND
];
const $789c06d5db9cfc3f$export$72f070c4454b9c95 = {
    SOUND: 'sound',
    CARIES: 'caries',
    RESTORATION: 'restoration',
    RECURRENT_CARIES: 'recurrent_caries',
    TEMPORARY: 'temporary',
    SEALANT: 'sealant',
    FRACTURED: 'fractured'
};
const $789c06d5db9cfc3f$export$1d0d1c0dec314fe8 = [
    $789c06d5db9cfc3f$export$72f070c4454b9c95.CARIES,
    $789c06d5db9cfc3f$export$72f070c4454b9c95.RESTORATION,
    $789c06d5db9cfc3f$export$72f070c4454b9c95.RECURRENT_CARIES,
    $789c06d5db9cfc3f$export$72f070c4454b9c95.TEMPORARY,
    $789c06d5db9cfc3f$export$72f070c4454b9c95.SEALANT,
    $789c06d5db9cfc3f$export$72f070c4454b9c95.FRACTURED,
    $789c06d5db9cfc3f$export$72f070c4454b9c95.SOUND
];
const $789c06d5db9cfc3f$export$b7815f33793b967 = [
    'composite',
    'amalgam',
    'glass_ionomer',
    'zirconia',
    'pfm',
    'full_metal',
    'emax',
    'temporary',
    'gold'
];
function $789c06d5db9cfc3f$export$13f248a297f9c8b4(aspect, value) {
    if (aspect === 'presence') return [];
    if (value === $789c06d5db9cfc3f$export$1cfe08df32bc8f76.CROWN || value === $789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_ABUTMENT || value === $789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_PONTIC) return [
        'zirconia',
        'pfm',
        'full_metal',
        'emax',
        'gold',
        'temporary'
    ];
    if (value === $789c06d5db9cfc3f$export$1cfe08df32bc8f76.VENEER) return [
        'emax',
        'composite',
        'zirconia'
    ];
    if (value === $789c06d5db9cfc3f$export$72f070c4454b9c95.RESTORATION) return [
        'composite',
        'amalgam',
        'glass_ionomer',
        'gold',
        'temporary'
    ];
    return [];
}
const $789c06d5db9cfc3f$export$c080d5661a747fd2 = {
    sound: {
        fill: '#ffffff',
        stroke: '#94a3b8'
    },
    caries: {
        fill: '#ef4444',
        stroke: '#b91c1c'
    },
    recurrent_caries: {
        fill: '#f97316',
        stroke: '#c2410c'
    },
    restoration: {
        fill: '#3b82f6',
        stroke: '#1d4ed8'
    },
    temporary: {
        fill: '#f59e0b',
        stroke: '#b45309'
    },
    sealant: {
        fill: '#22c55e',
        stroke: '#15803d'
    },
    fractured: {
        fill: '#a855f7',
        stroke: '#7e22ce'
    },
    missing: {
        fill: '#e2e8f0',
        stroke: '#cbd5e1'
    },
    untouched: {
        fill: '#f8fafc',
        stroke: '#cbd5e1'
    },
    // Whole-tooth condition colours — the glyph layer and `toothOutline` share
    // these, so the outline tint and the glyph can never disagree. Their fills are
    // PALE on purpose: they wash a whole crown (and back a whole picker chip),
    // where the saturated surface colours above would drown everything drawn over
    // them and leave dark label text unreadable.
    //
    // `caries_tooth` is decay recorded against the WHOLE tooth rather than a
    // surface. It needs its own entry precisely because it must not be the
    // surface red: the saturated red goes on painting ONE facet, and this pale
    // field says the whole crown — two readings the chart has to keep apart.
    caries_tooth: {
        fill: '#fecdd3',
        stroke: '#b91c1c'
    },
    implant: {
        fill: '#e0e7ff',
        stroke: '#4f46e5'
    },
    root_canal: {
        fill: '#fce7f3',
        stroke: '#be185d'
    },
    post_core: {
        fill: '#dbeafe',
        stroke: '#1d4ed8'
    },
    bridge: {
        fill: '#bfdbfe',
        stroke: '#3b82f6'
    }
};
const $789c06d5db9cfc3f$export$46572491bf07a861 = {
    crownCentre: '#ffffff',
    crownRim: '#e8edf3',
    archShadow: '#94a3b8',
    surfaceHover: '#0EA5A0',
    // "Something is recorded here that this chart has no mark for" — see
    // `hasUndrawnCondition`. Deliberately neutral: it says a finding EXISTS and
    // refuses to say what, because inventing a symbol for لقی or سایش is a
    // clinical convention to settle with a dentist, not in a renderer.
    noteMark: '#475569',
    // The PNG export (exportChart.js): an opaque page behind the chart —
    // referrals get printed, and a transparent PNG on a dark viewer is
    // unreadable — and the patient-context header line above it.
    exportBackground: '#ffffff',
    exportHeader: '#334155'
};
const $789c06d5db9cfc3f$export$49e77edbb85c0c46 = {
    stroke: $789c06d5db9cfc3f$export$c080d5661a747fd2.bridge.stroke,
    strokeWidth: 7,
    strokeOpacity: 0.35,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
};
const $789c06d5db9cfc3f$export$5acff4402443fc33 = {
    // Teal — Parsina's own accent, and the one colour on this chart that belongs
    // to the APP rather than to the mouth. Nothing clinical is teal, so the badge
    // cannot be mistaken for a finding.
    fill: '#0d9488',
    ink: '#ffffff',
    r: 3.1
};
const $789c06d5db9cfc3f$export$268f349e84521056 = {
    // Amber — the palette's "provisional or watch" (§ the colour language
    // above): planned work is exactly that, a thing intended and not yet true.
    stroke: '#f59e0b',
    strokeWidth: 2.5,
    // Dashed, and that is the load-bearing part: every SOLID outline on this
    // chart is a fact about the tooth. A dashed one cannot be misread as one.
    strokeDasharray: '4 3',
    strokeOpacity: 0.9
};
const $789c06d5db9cfc3f$export$63b4f8828903890e = {
    gold: '#b45309',
    zirconia: '#64748b',
    emax: '#64748b',
    full_metal: '#64748b',
    pfm: '#475569'
};
const $789c06d5db9cfc3f$export$e5b4b6e3feb01a67 = (material)=>$789c06d5db9cfc3f$export$63b4f8828903890e[material] || $789c06d5db9cfc3f$export$c080d5661a747fd2.restoration.stroke;
const $789c06d5db9cfc3f$export$332b24b8d2f6799 = (value)=>$789c06d5db9cfc3f$export$c080d5661a747fd2[value] || $789c06d5db9cfc3f$export$c080d5661a747fd2.sound;
const $789c06d5db9cfc3f$export$59c2133a38d8f663 = [
    [
        $789c06d5db9cfc3f$export$1cfe08df32bc8f76.CARIES,
        'caries_tooth'
    ],
    [
        $789c06d5db9cfc3f$export$1cfe08df32bc8f76.IMPLANT,
        'implant'
    ],
    [
        $789c06d5db9cfc3f$export$1cfe08df32bc8f76.CROWN,
        'restoration'
    ],
    [
        $789c06d5db9cfc3f$export$1cfe08df32bc8f76.ROOT_CANAL,
        'root_canal'
    ]
];
function $789c06d5db9cfc3f$export$c500e7ba307fe4bd(state) {
    if (!state || $789c06d5db9cfc3f$export$5c3943b5a89fa884(state.presence)) return null;
    const values = (state.conditions || []).map((c)=>c.value);
    const hit = $789c06d5db9cfc3f$export$59c2133a38d8f663.find(([value])=>values.includes(value));
    return hit ? hit[0] : null;
}
function $789c06d5db9cfc3f$export$47f15c26a9378317(state) {
    if (!state) return $789c06d5db9cfc3f$export$c080d5661a747fd2.untouched;
    if ($789c06d5db9cfc3f$export$5c3943b5a89fa884(state.presence)) return $789c06d5db9cfc3f$export$c080d5661a747fd2.missing;
    const tinting = $789c06d5db9cfc3f$export$c500e7ba307fe4bd(state);
    if (tinting) return $789c06d5db9cfc3f$export$c080d5661a747fd2[$789c06d5db9cfc3f$export$59c2133a38d8f663.find(([value])=>value === tinting)[1]];
    if (!state.isCharted) return $789c06d5db9cfc3f$export$c080d5661a747fd2.untouched;
    return $789c06d5db9cfc3f$export$c080d5661a747fd2.sound;
}
const $789c06d5db9cfc3f$export$1eb77b461d84506c = [
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.CARIES,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.IMPLANT,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.CROWN,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.ROOT_CANAL,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.POST_CORE,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.VENEER,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.FRACTURE,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_ABUTMENT,
    $789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_PONTIC
];
const $789c06d5db9cfc3f$export$f57b14f0f1731a73 = (state)=>(state?.conditions || []).some((c)=>c.value !== $789c06d5db9cfc3f$export$1cfe08df32bc8f76.SOUND && !$789c06d5db9cfc3f$export$1eb77b461d84506c.includes(c.value));
function $789c06d5db9cfc3f$export$ed28de37b06d1e98(teethStates, rowOrder) {
    const spans = [];
    let run = null;
    const flush = ()=>{
        if (run && run.hasAbutment) spans.push({
            teeth: run.teeth,
            row: rowOrder
        });
        run = null;
    };
    for (const fdi of rowOrder){
        const values = ((teethStates[fdi] || {}).conditions || []).map((c)=>c.value);
        const onBridge = values.includes($789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_ABUTMENT) || values.includes($789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_PONTIC);
        if (!onBridge) {
            flush();
            continue;
        }
        if (!run) run = {
            teeth: [],
            hasAbutment: false
        };
        run.teeth.push(fdi);
        if (values.includes($789c06d5db9cfc3f$export$1cfe08df32bc8f76.BRIDGE_ABUTMENT)) run.hasAbutment = true;
    }
    flush();
    return spans;
}
function $789c06d5db9cfc3f$export$1b175748dc696419(withPrimary) {
    return withPrimary ? [
        $789c06d5db9cfc3f$export$7841f2f53987dfb9.upper,
        $789c06d5db9cfc3f$export$fc5732f3d203b9d.upper,
        $789c06d5db9cfc3f$export$fc5732f3d203b9d.lower,
        $789c06d5db9cfc3f$export$7841f2f53987dfb9.lower
    ] : [
        $789c06d5db9cfc3f$export$7841f2f53987dfb9.upper,
        $789c06d5db9cfc3f$export$7841f2f53987dfb9.lower
    ];
}
function $789c06d5db9cfc3f$export$185d1f0722e636b2(rows, fdi, key) {
    let r = -1;
    let i = -1;
    rows.forEach((row, ri)=>{
        const ii = row.indexOf(fdi);
        if (ii !== -1) {
            r = ri;
            i = ii;
        }
    });
    // No cursor yet — or the cursor's row was just hidden (primary toggled off).
    if (r === -1) return rows[0][0];
    if (key === 'ArrowRight') return rows[r][Math.min(i + 1, rows[r].length - 1)];
    if (key === 'ArrowLeft') return rows[r][Math.max(i - 1, 0)];
    if (key === 'ArrowUp' || key === 'ArrowDown') {
        const nr = r + (key === 'ArrowDown' ? 1 : -1);
        if (nr < 0 || nr >= rows.length) return fdi; // clamp at the jaws' edge
        const row = rows[nr];
        // "Nearest index", generalized proportionally to rows of different
        // lengths (16 permanent vs 10 primary), which tracks screen position
        // closely enough; for the equal-length permanent rows it is the SAME
        // index — 16 lands on 46, the tooth it bites against.
        const ni = Math.round(i * (row.length - 1) / Math.max(rows[r].length - 1, 1));
        return row[ni];
    }
    return fdi;
}
const $789c06d5db9cfc3f$export$a03cd68eb350afd7 = 800;
const $789c06d5db9cfc3f$export$7f2a9e5a373efa49 = {
    buffer: '',
    at: 0,
    jump: null
};
function $789c06d5db9cfc3f$export$ca8b5b1a6c320e6e(key) {
    if (typeof key !== 'string' || key.length !== 1) return null;
    if (key >= '0' && key <= '9') return key;
    const cp = key.codePointAt(0);
    if (cp >= 0x06f0 && cp <= 0x06f9) return String(cp - 0x06f0); // ۰-۹
    if (cp >= 0x0660 && cp <= 0x0669) return String(cp - 0x0660); // ٠-٩
    return null;
}
function $789c06d5db9cfc3f$export$79a01b9b47bc6931(state, action) {
    const s = state || $789c06d5db9cfc3f$export$7f2a9e5a373efa49;
    if (action.type === 'clear') return $789c06d5db9cfc3f$export$7f2a9e5a373efa49;
    if (action.type !== 'digit') return s.jump ? {
        ...s,
        jump: null
    } : s;
    const digit = $789c06d5db9cfc3f$export$ca8b5b1a6c320e6e(action.digit);
    if (digit == null) return s.jump ? {
        ...s,
        jump: null
    } : s;
    const stale = action.now - s.at > $789c06d5db9cfc3f$export$a03cd68eb350afd7;
    const buffer = (stale ? '' : s.buffer) + digit;
    if (buffer.length < 2) return {
        buffer: buffer,
        at: action.now,
        jump: null
    };
    return {
        buffer: '',
        at: action.now,
        jump: (action.teeth || []).includes(buffer) ? buffer : null
    };
}
// ── Anatomical names ───────────────────────────────────────────────────────
//
// The name a dentist would say out loud. Position (the second FDI digit) alone
// determines it — with ONE trap:
//
//   PERMANENT positions 4 and 5 are PREMOLARS.
//   PRIMARY   positions 4 and 5 are MOLARS — a child has no premolars at all;
//             the permanent premolars erupt into those positions later.
//
// So `54` is "second primary molar", never "first premolar". Getting this
// wrong would put the wrong tooth name on a child's chart.
const $789c06d5db9cfc3f$var$PERMANENT_NAME_BY_POSITION = {
    1: 'centralIncisor',
    2: 'lateralIncisor',
    3: 'canine',
    4: 'firstPremolar',
    5: 'secondPremolar',
    6: 'firstMolar',
    7: 'secondMolar',
    8: 'thirdMolar'
};
const $789c06d5db9cfc3f$var$PRIMARY_NAME_BY_POSITION = {
    1: 'centralIncisor',
    2: 'lateralIncisor',
    3: 'canine',
    4: 'firstMolar',
    5: 'secondMolar'
};
function $789c06d5db9cfc3f$export$569cf66ddb61c0fe(fdi) {
    const table = $789c06d5db9cfc3f$export$8a45705b1b8eb2ec(fdi) ? $789c06d5db9cfc3f$var$PERMANENT_NAME_BY_POSITION : $789c06d5db9cfc3f$var$PRIMARY_NAME_BY_POSITION;
    const name = table[$789c06d5db9cfc3f$export$5880b8b5730aff45(fdi)];
    return name ? `chart.toothName.${name}` : '';
}
function $789c06d5db9cfc3f$export$a0a562654de3fbbe(fdi) {
    const q = String(fdi)[0];
    const upper = $789c06d5db9cfc3f$export$ae50dec7acbeb690(fdi);
    const right = [
        '1',
        '4',
        '5',
        '8'
    ].includes(q);
    return `chart.quadrant.${upper ? 'upper' : 'lower'}${right ? 'Right' : 'Left'}`;
}
function $789c06d5db9cfc3f$export$cc997a7b5611bfee(fdi, state) {
    const surfaces = (state?.surfaces || []).filter((s)=>s.value && s.value !== 'sound');
    return {
        fdi: fdi,
        universal: state?.universal || '',
        nameKey: $789c06d5db9cfc3f$export$569cf66ddb61c0fe(fdi),
        quadrantKey: $789c06d5db9cfc3f$export$a0a562654de3fbbe(fdi),
        isPrimary: !$789c06d5db9cfc3f$export$8a45705b1b8eb2ec(fdi),
        presence: state?.presence || $789c06d5db9cfc3f$export$52e39c9e8fc17728.PRESENT,
        isMissingTooth: $789c06d5db9cfc3f$export$5c3943b5a89fa884(state?.presence),
        surfaces: // A surface recorded as SOUND is a finding, but it is noise in a hover
        // card — the card answers "what is wrong with this tooth".
        surfaces,
        conditions: (state?.conditions || []).filter((c)=>c.value && c.value !== 'sound'),
        notes: state?.notes || [],
        isCharted: !!state?.isCharted,
        lastRecordedAtMs: state?.lastRecordedAtMs || null
    };
}


// Money, from the kit — the ONE place this app turns an amount into text.
//
// This app had no money in it at all until طرح درمان began quoting the clinic's
// own tariffs. Every Parsina service carries an integer number of MINOR UNITS of
// the document's currency (docs/clinic-currency/CONTRACTS.md): whole RIALS for an
// Iranian clinic, which quotes, types and reads TOMAN — ten rials to the toman —
// and fils, cents or baisa for a clinic that keeps its books in AED, USD or OMR.
// Writing either conversion a second time here is exactly how a 500,000 ت
// treatment ends up printed as 5,000,000 ت on a document a patient signs — which
// has shipped before, in both directions, on one screen.
//
// So the conversions are the kit's (`money.js` for toman, `currency.js` for every
// allowed currency) and this file only COMPOSES them: which figure, which unit
// word, which catalogue sentence. Nothing here divides by anything.
//
// ── The rules it keeps ──────────────────────────────────────────────────────
//   • IRR — and a blank currency, which IS IRR — renders in Persian and
//     English exactly as it always has: `fmtToman` (Persian digits) + this
//     app's own «تومان» / "toman" catalogue word. Byte for byte. French and
//     German are the exceptions (PM-0185, PM-0212): the kit keeps `fmtToman`
//     Persian by design and off their pages, so a French or German page gets
//     the kit's locale formatter («4 500 000» with U+202F / «4.500.000», Latin
//     digits) and the `common.units.tomans` word from 2 up («tomans» in
//     French, the invariable «Toman» in German).
//   • Any other currency renders in its own fraction digits, in the page's
//     digits, beside its ISO code («۱۲٫۵۰ AED»), and never beside «تومان».
//   • Two currencies are never added. There is no exchange rate in Parsina;
//     callers group by currency (`sumByCurrency`) or refuse.


const $ee13d5f9dccabef6$var$isIrr = (currency)=>(0, $fcda591c8cd139a4$export$b91dea8e61ccd7ef)(currency) === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
const $ee13d5f9dccabef6$var$languageOf = (locale)=>String(locale || '').toLowerCase().split(/[-_]/)[0];
// Panel languages whose toman figures use the kit's locale formatter instead of
// `fmtToman`'s Persian digits. Persian and English are deliberately not here:
// their toman figures stay byte for byte what they always were.
const $ee13d5f9dccabef6$var$LOCALE_TOMAN = new Set([
    'fr',
    'de'
]);
// Panel languages whose DECIMAL mark is a comma — where «500,000» typed as a
// toman tariff is ambiguous (a grouped half million, or 500 point zero). German
// groups with '.', so «500.000» is just as ambiguous there.
const $ee13d5f9dccabef6$var$COMMA_DECIMAL = new Set([
    'fr',
    'de'
]);
// Ten rials to the toman: «tomans» begins at 2 toman = 20 rials.
const $ee13d5f9dccabef6$var$TWO_TOMAN_IN_RIAL = 20;
function $ee13d5f9dccabef6$export$f76b597c9baf5209(currency, { t: t, locale: locale, amountMinor: amountMinor } = {}) {
    if ($ee13d5f9dccabef6$var$isIrr(currency)) // After an amount of 2 toman or more, the plural form («tomans» in French;
    // «toman» / «تومان» / «Toman» unchanged in English, Persian and German).
    return typeof amountMinor === 'number' && Math.abs(amountMinor) >= $ee13d5f9dccabef6$var$TWO_TOMAN_IN_RIAL ? t('common.units.tomans') : t('common.units.toman');
    return (0, $fcda591c8cd139a4$export$846d8329e0c3da65)(currency, locale, 'short');
}
function $ee13d5f9dccabef6$export$dc766bb5b31bee30(currency, { t: t, locale: locale } = {}) {
    if ($ee13d5f9dccabef6$var$isIrr(currency)) return t('common.units.toman');
    return (0, $fcda591c8cd139a4$export$846d8329e0c3da65)(currency, locale, 'long');
}
function $ee13d5f9dccabef6$export$728728cdd469760f(amountMinor, currency, { locale: locale } = {}) {
    if ($ee13d5f9dccabef6$var$isIrr(currency) && !$ee13d5f9dccabef6$var$LOCALE_TOMAN.has($ee13d5f9dccabef6$var$languageOf(locale))) return (0, $ca1f40e638c62a9a$export$1736ebd23f2adeaf)(amountMinor);
    return (0, $fcda591c8cd139a4$export$e251d23bea783311)(amountMinor, currency, {
        locale: locale
    });
}
function $ee13d5f9dccabef6$export$a17b3c2052469c69(amountMinor, currency, { t: t, locale: locale } = {}) {
    return t('visit.plan.toman', {
        amount: $ee13d5f9dccabef6$export$728728cdd469760f(amountMinor, currency, {
            locale: locale
        }),
        unit: $ee13d5f9dccabef6$export$f76b597c9baf5209(currency, {
            t: t,
            locale: locale,
            amountMinor: amountMinor
        })
    });
}
function $ee13d5f9dccabef6$export$164219e1848ce85d(typed, currency, locale) {
    if (!$ee13d5f9dccabef6$var$isIrr(currency) || !$ee13d5f9dccabef6$var$COMMA_DECIMAL.has($ee13d5f9dccabef6$var$languageOf(locale))) return (0, $fcda591c8cd139a4$export$b94f7550e5b92f9c)(typed, currency, locale);
    const text = String(typed ?? '').trim();
    const marks = text.match(/[.,]/g);
    if (marks) {
        if (new Set(marks).size > 1) return NaN;
        const groups = text.split(/[.,]/);
        if (groups.slice(1).some((g)=>!/^[0-9۰-۹٠-٩]{3}$/.test(g))) return NaN;
    }
    // The marks are grouping by now; the kit reads what is left (spaces, «٬»,
    // Persian digits) exactly as it always has.
    return (0, $fcda591c8cd139a4$export$b94f7550e5b92f9c)(text.replace(/[.,]/g, ''), currency);
}


// What can be drawn on a dental image, and the arithmetic for drawing it.
//
// ────────────────────────────────────────────────────────────────────────────
// EVERY COORDINATE IN THIS FILE IS NORMALIZED TO [0,1]
// ────────────────────────────────────────────────────────────────────────────
// Not pixels. Never pixels. The same radiograph is drawn at 900px on a
// reception monitor, at 380px on a phone, and at whatever the current zoom
// makes it — and it is re-drawn on every one of those changes. A mark stored in
// pixels is a mark that lands on a different tooth the moment the window is
// resized, and the dentist who drew it is the last person who would ever see it
// in the right place.
//
// The server enforces the same range (dental_image_links, validate_annotations)
// so a client that forgets cannot store one either. The conversion happens in
// exactly two functions below — `toUnit` on the way in from a pointer event,
// and `toPercent` on the way out to CSS — and nowhere else.
//
// It lives in lib/ rather than inside the workspace component because the
// annotation layer, the findings layer and the hit-test all need the same
// arithmetic, and three copies of "is this point inside that box" is how two of
// them end up disagreeing about the edge.

const $2c51377d39509d2c$export$68d935f6a7eab51c = 'pin';
const $2c51377d39509d2c$export$17a0078031eb7d1d = 'box';
const $2c51377d39509d2c$export$d82ee3d579db8f16 = 'ellipse';
const $2c51377d39509d2c$export$8a0b11bdd5ff0385 = 'arrow';
const $2c51377d39509d2c$export$c785f1ba800069c4 = 'freehand';
const $2c51377d39509d2c$export$65870a12014ac356 = [
    $2c51377d39509d2c$export$68d935f6a7eab51c,
    $2c51377d39509d2c$export$17a0078031eb7d1d,
    $2c51377d39509d2c$export$d82ee3d579db8f16,
    $2c51377d39509d2c$export$8a0b11bdd5ff0385,
    $2c51377d39509d2c$export$c785f1ba800069c4
];
const $2c51377d39509d2c$export$b360132b6204666 = new Set([
    $2c51377d39509d2c$export$17a0078031eb7d1d,
    $2c51377d39509d2c$export$d82ee3d579db8f16,
    $2c51377d39509d2c$export$8a0b11bdd5ff0385,
    $2c51377d39509d2c$export$c785f1ba800069c4
]);
const $2c51377d39509d2c$export$d9cb664db3721cc7 = new Set([
    $2c51377d39509d2c$export$17a0078031eb7d1d,
    $2c51377d39509d2c$export$d82ee3d579db8f16
]);
const $2c51377d39509d2c$export$96cdd4336b8baa5d = [
    '#E11D48',
    '#F59E0B',
    '#0EA5A0',
    '#2563EB'
];
const $2c51377d39509d2c$export$a868e3b957eaade4 = $2c51377d39509d2c$export$96cdd4336b8baa5d[0];
const $2c51377d39509d2c$export$e4cedbb8a08ffd7a = 200;
const $2c51377d39509d2c$export$217e8b917497ff48 = 2000;
const $2c51377d39509d2c$export$9d6fea047341202 = 2000;
const $2c51377d39509d2c$export$4ed55f6519d0435b = [
    'periapical',
    'bitewing',
    'panoramic',
    'ceph',
    'photo'
];
const $2c51377d39509d2c$export$125b59614f576538 = (t)=>/^image\//i.test(String(t || ''));
const $2c51377d39509d2c$export$3a8b165dd96278af = /^image\/(jpeg|png|gif|bmp|webp|tiff)$/i;
const $2c51377d39509d2c$export$7dc169c276dbe757 = (t)=>$2c51377d39509d2c$export$3a8b165dd96278af.test(String(t || ''));
const $2c51377d39509d2c$export$5c5ee632c52bc4a2 = (n)=>n < 0 ? 0 : n > 1 ? 1 : n;
function $2c51377d39509d2c$export$d48be2db27a3a8d3(event, element) {
    if (!element) return {
        x: 0,
        y: 0
    };
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return {
        x: 0,
        y: 0
    };
    return {
        x: $2c51377d39509d2c$export$5c5ee632c52bc4a2((event.clientX - rect.left) / rect.width),
        y: $2c51377d39509d2c$export$5c5ee632c52bc4a2((event.clientY - rect.top) / rect.height)
    };
}
const $2c51377d39509d2c$export$56afe66a453bd445 = (n)=>`${($2c51377d39509d2c$export$5c5ee632c52bc4a2(n) * 100).toFixed(4)}%`;
function $2c51377d39509d2c$export$19efb8ccf6e13914(kind, from, to) {
    if (kind === $2c51377d39509d2c$export$8a0b11bdd5ff0385) return {
        x: from.x,
        y: from.y,
        x2: to.x,
        y2: to.y
    };
    if ($2c51377d39509d2c$export$d9cb664db3721cc7.has(kind)) return {
        x: Math.min(from.x, to.x),
        y: Math.min(from.y, to.y),
        w: Math.abs(to.x - from.x),
        h: Math.abs(to.y - from.y)
    };
    return {
        x: to.x,
        y: to.y
    };
}
const $2c51377d39509d2c$export$1df1459115d12091 = 0.01;
function $2c51377d39509d2c$export$275dc60b90a08333(kind, from, to) {
    if (!$2c51377d39509d2c$export$b360132b6204666.has(kind)) return true;
    return Math.abs(to.x - from.x) > $2c51377d39509d2c$export$1df1459115d12091 || Math.abs(to.y - from.y) > $2c51377d39509d2c$export$1df1459115d12091;
}
function $2c51377d39509d2c$export$d39c435a0adaeeff({ kind: kind, geometry: geometry, color: color, toothFdi: toothFdi }) {
    return {
        // A client-side id, so a mark can be selected, edited and erased before it
        // has ever been saved. The server keeps whatever id it is given.
        id: `m-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`,
        kind: kind,
        x: 0,
        y: 0,
        ...geometry,
        points: geometry.points || [],
        toothFdi: toothFdi || null,
        comment: '',
        color: color || $2c51377d39509d2c$export$a868e3b957eaade4
    };
}
function $2c51377d39509d2c$export$822ebe4c89939c31(points) {
    const out = [];
    for(let i = 0; i + 1 < (points || []).length; i += 2)out.push(`${$2c51377d39509d2c$export$5c5ee632c52bc4a2(points[i]) * 100},${$2c51377d39509d2c$export$5c5ee632c52bc4a2(points[i + 1]) * 100}`);
    return out.join(' ');
}
function $2c51377d39509d2c$export$48e1e0c65905441(mark) {
    if (!mark) return {
        x: 0,
        y: 0
    };
    if (mark.kind === $2c51377d39509d2c$export$8a0b11bdd5ff0385) return {
        x: mark.x2 ?? mark.x,
        y: mark.y2 ?? mark.y
    };
    return {
        x: mark.x,
        y: mark.y
    };
}
const $2c51377d39509d2c$export$7849a1990b6ddf9f = (f)=>!!f && (f.w || 0) > 0 && (f.h || 0) > 0;
function $2c51377d39509d2c$export$aae4999338ff8157(confidence) {
    if (confidence === 'high') return {
        line: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accent,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    };
    if (confidence === 'medium') return {
        line: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warn,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    };
    return {
        line: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    };
}
const $2c51377d39509d2c$export$824fa60a66980aaf = (f)=>!!(f?.toothFdi && f?.aspect && f?.value);


const $0cd549c1a257ae26$export$bc2c85ac4003b25 = (t)=>[
        {
            value: 'diagnosis',
            label: t('visit.tabs.diagnosis'),
            Icon: (0, $02839c5704f38745$export$2e2bcd8739ae039)
        },
        {
            value: 'meds',
            label: t('visit.tabs.meds'),
            Icon: (0, $5ffe798f65d504e7$export$2e2bcd8739ae039)
        },
        {
            value: 'orders',
            label: t('visit.tabs.orders'),
            Icon: (0, $3f35c50d66e81764$export$2e2bcd8739ae039)
        },
        {
            value: 'questions',
            label: t('visit.tabs.questions'),
            Icon: (0, $3703118ab2b2b83a$export$2e2bcd8739ae039)
        },
        {
            value: 'files',
            label: t('visit.tabs.files'),
            Icon: (0, $8745eaf007923a88$export$2e2bcd8739ae039)
        }
    ];
const $0cd549c1a257ae26$export$a6d374bb1b39867a = [
    'diagnosis',
    'meds',
    'orders',
    'questions',
    'files'
];
const $0cd549c1a257ae26$export$a988734073442de8 = 'diagnosis';
const $0cd549c1a257ae26$export$a415b6f5d9b3134c = `
  mutation CompleteVisit($patientId: ID!, $appointmentId: ID!, $followUp: VisitFollowUpInput) {
    completeVisit(patientId: $patientId, appointmentId: $appointmentId, followUp: $followUp) {
      appointmentId
      status
      editable
      followUpOutcome
    }
  }
`;
const $0cd549c1a257ae26$export$512faac54c275f2e = `
  query Visit($appointmentId: ID!) {
    visit(appointmentId: $appointmentId) {
      appointmentId
      patientId
      clinicId
      dateTime
      status
      urgency
      durationMinutes
      editable
      patient {
        id name phone nationalId birthDate age gender bloodType fileNumber avatarUrl
        allergies { id allergen reaction severity }
        conditions { id code display clinicalStatus onsetDate }
        medications { id code display status authoredOn dosageInstruction }
      }
    }
  }
`;
const $0cd549c1a257ae26$export$8f8b87906e9e5f4e = `
  query VideoVisitSession($patientId: ID!, $appointmentId: ID!) {
    videoVisitSession(patientId: $patientId, appointmentId: $appointmentId) {
      domain
      roomName
      token
      expiresAt
      displayName
      moderator
    }
  }
`;
// ── Right column: the subjective ────────────────────────────────────────────
const $0cd549c1a257ae26$var$NOTE_FIELDS = `
  id
  appointmentId
  createdAt
  subjective
  objective
  assessment
  plan
  dental {
    chiefComplaint painScore painCharacter teethFdi
    onset duration aggravatingFactors relievingFactors dentalHistory notes
  }
`;
const $0cd549c1a257ae26$export$4cf273fa9ac8cacd = `
  query VisitNote($patientId: ID!, $appointmentId: ID!) {
    visitNote(patientId: $patientId, appointmentId: $appointmentId) { ${$0cd549c1a257ae26$var$NOTE_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$6ae6c77977d8a05b = `
  mutation SaveVisitNote(
    $patientId: ID!, $appointmentId: ID!,
    $subjective: DentalSubjectiveInput, $objective: String, $assessment: String, $plan: String
  ) {
    saveVisitNote(
      patientId: $patientId, appointmentId: $appointmentId,
      subjective: $subjective, objective: $objective, assessment: $assessment, plan: $plan
    ) { ${$0cd549c1a257ae26$var$NOTE_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$6aafaa5b4bb80bb4 = `
  query PriorVisits($patientId: ID!, $appointmentId: ID!, $limit: Int) {
    priorVisits(patientId: $patientId, appointmentId: $appointmentId, limit: $limit) {
      appointmentId dateTime summary diagnosisCount hasNote
    }
  }
`;
// ── Right column: طرح درمان ─────────────────────────────────────────────────
//
// The dental service's plan, not a second model of one. Item status is the
// service's vocabulary; PLAN_ITEM_STATUS below maps it to the words §3.1.3 uses.
//
// Every `…Rial` amount is an integer number of MINOR UNITS of the plan's
// `currency` (whole rials for IRR — the names are historical and kept). Items
// carry no currency of their own: a plan is ONE currency, so the plan's is read.
const $0cd549c1a257ae26$var$PLAN_FIELDS = `
  id
  clinicId
  title
  status
  approvedAtMs
  note
  totalAmountRial
  patientTotalRial
  insuranceTotalRial
  items {
    id phase catalogId toothFdi surfaces description status sortOrder quantity
    lineAmountRial linePatientRial
  }
`;
// What the plan READ asks for: the fields above plus what every amount is
// counted in. SIGNED, that is the currency stamped at approval; UNSIGNED, the
// plan clinic's current one — which the BFF reads from clinicmanagement.
//
// Only the read asks for it. The mutations below discard their response (the
// hook refetches after every write), and a write that SUCCEEDED must not come
// back as a failure because a display-only field could not be resolved: a
// createTreatmentPlan reported as failed is one the dentist presses again, and
// that makes a second plan.
const $0cd549c1a257ae26$var$PLAN_READ_FIELDS = `
  ${$0cd549c1a257ae26$var$PLAN_FIELDS}
  currency
`;
const $0cd549c1a257ae26$export$225549b931c14bb0 = `
  query DentalTreatmentCatalog($clinicId: ID) {
    dentalTreatmentCatalog(clinicId: $clinicId) {
      id name category tariffRial currency durationMinutes applicability chartEffect archived source
    }
  }
`;
const $0cd549c1a257ae26$export$17160a4cc503e72e = `
  query TreatmentPlans($patientId: ID!, $clinicId: ID) {
    treatmentPlans(patientId: $patientId, clinicId: $clinicId) { ${$0cd549c1a257ae26$var$PLAN_READ_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$849b53aa3ba97fa1 = `
  mutation CreatePlan($patientId: ID!, $clinicId: ID, $title: String, $items: [TreatmentPlanItemInput!]) {
    createTreatmentPlan(patientId: $patientId, clinicId: $clinicId, title: $title, items: $items) {
      ${$0cd549c1a257ae26$var$PLAN_FIELDS}
    }
  }
`;
const $0cd549c1a257ae26$export$653ed1769de23b83 = `
  mutation UpdatePlan($planId: ID!, $items: [TreatmentPlanItemInput!]) {
    updateTreatmentPlan(planId: $planId, items: $items) { ${$0cd549c1a257ae26$var$PLAN_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$66c7a31c01734817 = `
  mutation SetPlanItemStatus($planId: ID!, $itemId: ID!, $status: String!) {
    setPlanItemStatus(planId: $planId, itemId: $itemId, status: $status) { ${$0cd549c1a257ae26$var$PLAN_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$9dc71384dbf426d1 = `
  mutation CreateClinicService($clinicId: ID, $input: NewClinicServiceInput!) {
    createClinicService(clinicId: $clinicId, input: $input) {
      id name category tariffRial currency durationMinutes applicability chartEffect archived source
    }
  }
`;
const $0cd549c1a257ae26$export$62e5bc55ca1f47a0 = `
  mutation ApprovePlan($planId: ID!, $approvedByPatient: Boolean) {
    approveTreatmentPlan(planId: $planId, approvedByPatient: $approvedByPatient) {
      ${$0cd549c1a257ae26$var$PLAN_FIELDS}
    }
  }
`;
// ── What was actually DONE ──────────────────────────────────────────────────
//
// A plan is a quote; a record is the work. They are different rows for the
// reason «انجام‌شده» was never trustworthy as a status: a status says the work
// happened and nothing else — no who, no when, no visit, no surfaces, no
// material, no note — and it can be taken back without a trace.
//
// NO AMOUNTS here, and the absence is the design (typeDefs/plan.js): the
// billable act is an order in clinicalencounter and `orderId` is the only
// thread to it, so nothing on this screen can invent what a treatment cost.
const $0cd549c1a257ae26$var$RECORD_FIELDS = `
  id appointmentId planId planItemId catalogId
  serviceName applicability toothFdi surfaces material note
  outcome sessionNo performerId performerType actorId
  performedAtMs recordedAtMs
  orderId billingState stockState
  voidedAtMs voidedBy voidReason
`;
const $0cd549c1a257ae26$export$80e65e29894beb41 = `
  query TreatmentRecords($patientId: ID!, $clinicId: ID) {
    treatmentRecords(patientId: $patientId, clinicId: $clinicId) { ${$0cd549c1a257ae26$var$RECORD_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$5b85ae2a03d3fc5a = `
  mutation RecordTreatment($patientId: ID!, $clinicId: ID, $input: RecordTreatmentInput!) {
    recordTreatment(patientId: $patientId, clinicId: $clinicId, input: $input) { ${$0cd549c1a257ae26$var$RECORD_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$3c9c0cef7c22edda = `
  mutation VoidTreatmentRecord(
    $patientId: ID!, $recordId: ID!, $reason: String!, $voidChartEvents: Boolean
  ) {
    voidTreatmentRecord(
      patientId: $patientId, recordId: $recordId, reason: $reason,
      voidChartEvents: $voidChartEvents
    ) {
      ${$0cd549c1a257ae26$var$RECORD_FIELDS}
      chargeReversed
    }
  }
`;
const $0cd549c1a257ae26$export$aac7d3d2f39b3cb = `
  query VisitMedications($patientId: ID!, $appointmentId: ID) {
    listMedications(patientId: $patientId, appointmentId: $appointmentId) {
      id code display status authoredOn dosageInstruction
    }
  }
`;
const $0cd549c1a257ae26$export$69475176a670f48d = `
  query MedicationSuggestions($patientId: ID!, $appointmentId: ID!) {
    medicationSuggestions(patientId: $patientId, appointmentId: $appointmentId) {
      followUpTimeline
      items { name dosage frequency duration notes }
    }
  }
`;
function $0cd549c1a257ae26$export$a446afe38fa74cae(med) {
    const d = med?.dosageInstruction;
    if (!d) return '';
    if (typeof d === 'string') return d;
    if (d.text) return String(d.text);
    return [
        d.dose,
        d.frequency,
        d.duration,
        d.note
    ].map((p)=>String(p || '').trim()).filter(Boolean).join(" \xb7 ");
}
// ── Left column: دستورات ────────────────────────────────────────────────────
const $0cd549c1a257ae26$var$ORDER_FIELDS = `
  id orderType description urgency status notes code catalogId sessionCount createdAt
`;
const $0cd549c1a257ae26$export$e8f901dd17836000 = `
  query DentalOrderCatalog($orderType: String, $clinicId: ID) {
    dentalOrderCatalog(orderType: $orderType, clinicId: $clinicId) {
      id orderType name category code modality bodyPart source
    }
  }
`;
const $0cd549c1a257ae26$export$b96ec224ac32a5ad = `
  query VisitOrderSuggestions($patientId: ID!, $appointmentId: ID!) {
    visitOrderSuggestions(patientId: $patientId, appointmentId: $appointmentId) {
      rationale
      droppedCount
      items { key orderType name catalogId reason urgency category code }
    }
  }
`;
const $0cd549c1a257ae26$export$9df8d3fcfc0d6821 = `
  query VisitOrders($appointmentId: ID!) {
    visitOrders(appointmentId: $appointmentId) { ${$0cd549c1a257ae26$var$ORDER_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$11d6279dbbc74916 = `
  mutation CreateVisitOrder(
    $patientId: ID!, $appointmentId: ID!, $orderType: String!, $description: String!,
    $catalogId: String, $urgency: String, $notes: String, $code: String, $sessionCount: Int
  ) {
    createVisitOrder(
      patientId: $patientId, appointmentId: $appointmentId, orderType: $orderType,
      description: $description, catalogId: $catalogId, urgency: $urgency,
      notes: $notes, code: $code, sessionCount: $sessionCount
    ) { ${$0cd549c1a257ae26$var$ORDER_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$5318d282c9f591fb = `
  mutation SetVisitOrderStatus($appointmentId: ID!, $orderId: ID!, $transition: String!) {
    setVisitOrderStatus(appointmentId: $appointmentId, orderId: $orderId, transition: $transition) {
      ${$0cd549c1a257ae26$var$ORDER_FIELDS}
    }
  }
`;
// ── Left column: تشخیص ─────────────────────────────────────────────────────
const $0cd549c1a257ae26$var$DIAGNOSIS_FIELDS = `
  id code display clinicalStatus verificationStatus onsetDate createdAt aiAssisted
  evidence { kind detail ref }
`;
const $0cd549c1a257ae26$export$11ffaf5d5da7263c = `
  query VisitDiagnoses($patientId: ID!, $appointmentId: ID!) {
    visitDiagnoses(patientId: $patientId, appointmentId: $appointmentId) { ${$0cd549c1a257ae26$var$DIAGNOSIS_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$28f15e67f10e46f2 = `
  query VisitDifferential($patientId: ID!, $appointmentId: ID!) {
    visitDifferential(patientId: $patientId, appointmentId: $appointmentId) {
      diagnosisCode diagnosisName supportingEvidence contradictingEvidence confidence
    }
  }
`;
const $0cd549c1a257ae26$export$e4dfe19fcbbce380 = `
  mutation RecordVisitDiagnosis(
    $patientId: ID!, $appointmentId: ID!, $code: String!, $display: String!,
    $verificationStatus: String, $evidence: [DiagnosisEvidenceInput!], $aiAssisted: Boolean
  ) {
    recordVisitDiagnosis(
      patientId: $patientId, appointmentId: $appointmentId, code: $code, display: $display,
      verificationStatus: $verificationStatus, evidence: $evidence, aiAssisted: $aiAssisted
    ) { ${$0cd549c1a257ae26$var$DIAGNOSIS_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$c31d57401ee1a145 = `
  mutation DeleteVisitDiagnosis($patientId: ID!, $diagnosisId: ID!) {
    deleteVisitDiagnosis(patientId: $patientId, diagnosisId: $diagnosisId)
  }
`;
const $0cd549c1a257ae26$export$28edc0ee0a4c0a1 = `
  query VisitQuestions(
    $patientId: ID!, $appointmentId: ID!, $diagnosisCodes: [String!], $diagnosisNames: [String!]
  ) {
    visitQuestions(
      patientId: $patientId, appointmentId: $appointmentId,
      diagnosisCodes: $diagnosisCodes, diagnosisNames: $diagnosisNames
    ) {
      fallback
      items {
        diagnosisCode diagnosisName
        questions { id question hint positiveStatement negativeStatement }
      }
    }
  }
`;
const $0cd549c1a257ae26$export$39fc140801b04626 = `
  mutation AskVisitQuestion($patientId: ID!, $appointmentId: ID!, $question: String!) {
    askVisitQuestion(patientId: $patientId, appointmentId: $appointmentId, question: $question) {
      answer confidence references followUps
    }
  }
`;
const $0cd549c1a257ae26$export$ab0c29477139cdb6 = `
  mutation RefineVisitNote($patientId: ID!, $appointmentId: ID!, $transcript: String!) {
    refineVisitNote(patientId: $patientId, appointmentId: $appointmentId, transcript: $transcript) {
      sections { section text changed additions }
      changed charged status
    }
  }
`;
const $0cd549c1a257ae26$export$1893e1ce8127ba54 = `
  mutation ExtractToothFindings($patientId: ID!, $appointmentId: ID!, $transcript: String!) {
    extractToothFindings(patientId: $patientId, appointmentId: $appointmentId, transcript: $transcript) {
      status charged
      findings { toothFdi aspect surface value material evidence confidence isHistorical }
    }
  }
`;
const $0cd549c1a257ae26$export$2e29d4a4d81f7aa1 = `
  mutation GenerateVisitAdvice($patientId: ID!, $appointmentId: ID!, $transcript: String!) {
    generateVisitAdvice(patientId: $patientId, appointmentId: $appointmentId, transcript: $transcript) {
      summary suggestedDiagnosis icdCodes { code description }
      suggestedActions suggestedMedications
    }
  }
`;
function $0cd549c1a257ae26$export$5eaa45fb4b6fc44b(draft, currentNotes = '') {
    const patch = {};
    for (const s of draft?.sections || []){
        if (!s?.changed) continue;
        if (s.section === 'o') patch.objective = s.text;
        else if (s.section === 'a') patch.assessment = s.text;
        else if (s.section === 'p') patch.plan = s.text;
        else if (s.section === 's' && s.additions?.length) {
            const added = s.additions.join('\n');
            patch.subjective = {
                notes: currentNotes ? `${currentNotes}\n${added}` : added
            };
        }
    }
    return patch;
}
function $0cd549c1a257ae26$export$20ae66bdf902993(finding) {
    if (!finding?.toothFdi || !finding?.aspect || !finding?.value) return null;
    return {
        toothFdi: finding.toothFdi,
        aspect: finding.aspect,
        surface: finding.aspect === 'surface' ? finding.surface || null : null,
        value: finding.value,
        material: finding.material || null,
        note: finding.evidence || null,
        isHistorical: !!finding.isHistorical
    };
}
// ── Left column: فایل‌ها ────────────────────────────────────────────────────
const $0cd549c1a257ae26$var$ANNOTATION_FIELDS = `
  id kind x y w h x2 y2 points toothFdi comment color authorId createdAtMs
`;
const $0cd549c1a257ae26$var$FINDING_FIELDS = `
  id toothFdi aspect surface value label evidence confidence isHistorical x y w h
`;
const $0cd549c1a257ae26$var$FILE_FIELDS = `
  id fileName fileType fileSize createdAt documentType reportText
  abnormalFlags storageFileId teethFdi fromThisVisit
  imageLinkId viewType aiReadAtMs
  annotations { ${$0cd549c1a257ae26$var$ANNOTATION_FIELDS} }
  aiFindings { ${$0cd549c1a257ae26$var$FINDING_FIELDS} }
`;
const $0cd549c1a257ae26$export$175f5ece51a71be1 = `
  query VisitFiles($patientId: ID!, $appointmentId: ID!) {
    visitFiles(patientId: $patientId, appointmentId: $appointmentId) { ${$0cd549c1a257ae26$var$FILE_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$d141e074b4d84050 = `
  query VisitFileUrl($patientId: ID!, $fileId: ID!) {
    visitFileUrl(patientId: $patientId, fileId: $fileId)
  }
`;
const $0cd549c1a257ae26$export$d4c482abf80efea8 = `
  mutation UploadVisitFile(
    $patientId: ID!, $appointmentId: ID!, $fileName: String!, $contentType: String!,
    $fileData: String!, $documentType: String, $viewType: String, $teethFdi: [String!]
  ) {
    uploadVisitFile(
      patientId: $patientId, appointmentId: $appointmentId, fileName: $fileName,
      contentType: $contentType, fileData: $fileData, documentType: $documentType,
      viewType: $viewType, teethFdi: $teethFdi
    ) { ${$0cd549c1a257ae26$var$FILE_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$f12482f856b497dd = `
  mutation RunFileOcr(
    $patientId: ID!, $appointmentId: ID!, $fileId: ID!, $documentType: String
  ) {
    runFileOcr(
      patientId: $patientId, appointmentId: $appointmentId,
      fileId: $fileId, documentType: $documentType
    ) { ${$0cd549c1a257ae26$var$FILE_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$cbdf065b0d2b950b = `
  mutation RegisterVisitImage(
    $patientId: ID!, $appointmentId: ID!, $fileId: ID!,
    $viewType: String!, $teethFdi: [String!]
  ) {
    registerVisitImage(
      patientId: $patientId, appointmentId: $appointmentId,
      fileId: $fileId, viewType: $viewType, teethFdi: $teethFdi
    ) { ${$0cd549c1a257ae26$var$FILE_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$84a314bc9e339af4 = `
  mutation AnalyzeVisitImage($patientId: ID!, $appointmentId: ID!, $fileId: ID!) {
    analyzeVisitImage(
      patientId: $patientId, appointmentId: $appointmentId, fileId: $fileId
    ) {
      charged status aiReadAtMs
      findings { ${$0cd549c1a257ae26$var$FINDING_FIELDS} }
    }
  }
`;
const $0cd549c1a257ae26$export$5bae2d275c2f44e2 = `
  mutation SaveImageAnnotations(
    $patientId: ID!, $appointmentId: ID!, $fileId: ID!,
    $annotations: [ImageAnnotationInput!]!
  ) {
    saveImageAnnotations(
      patientId: $patientId, appointmentId: $appointmentId,
      fileId: $fileId, annotations: $annotations
    ) { ${$0cd549c1a257ae26$var$ANNOTATION_FIELDS} }
  }
`;
const $0cd549c1a257ae26$export$7d2c6204ee78cd8c = `
  mutation DeleteVisitFile($patientId: ID!, $fileId: ID!) {
    deleteVisitFile(patientId: $patientId, fileId: $fileId)
  }
`;
const $0cd549c1a257ae26$export$7fe249ad93dcc233 = [
    'imaging',
    'dental_lab'
];
const $0cd549c1a257ae26$export$c9b31a4acc93d37d = [
    'routine',
    'urgent',
    'stat'
];
const $0cd549c1a257ae26$export$5086c7e51ccaa482 = [
    'proposed',
    'accepted',
    'done',
    'rejected',
    'deferred'
];
/**
 * What a line may become NEXT — a process, not a set of interchangeable labels.
 *
 * The dropdown used to offer every status but the current one, in both
 * directions, which read as «this control does nothing»: a dentist could put a
 * line back to پیشنهادشده after agreeing it, or mark it رد شده and un-reject it,
 * forever, with no consequence anywhere. A quote is a conversation with a
 * patient and it moves one way.
 *
 *   پیشنهادشده  we suggested it        → پذیرفته‌شده · رد شده · به تعویق
 *   پذیرفته‌شده  the patient agreed     → به تعویق · رد شده
 *   به تعویق     agreed, not now        → پذیرفته‌شده · رد شده
 *   رد شده       the patient declined   → (nothing — reopen by re-quoting)
 *   انجام‌شده    it happened            → (nothing — void the record instead)
 *
 * ── «انجام‌شده» is never in this list ──────────────────────────────────────
 * A line becomes done by RECORDING the treatment that finished it. Setting it
 * from a dropdown is the bare status overwrite this whole feature exists to
 * replace: no who, no when, no visit, no surfaces, no material, no note, and
 * reversible without a trace.
 *
 * Nor is رد شده reversible here. Undoing a refusal by picking a word from a
 * menu loses the only thing that mattered about it — that the patient was asked
 * and said no. Re-quoting is how a declined treatment comes back, and it leaves
 * the refusal in the record where it belongs.
 */ const $0cd549c1a257ae26$var$PLAN_ITEM_TRANSITIONS = {
    proposed: [
        'accepted',
        'deferred',
        'rejected'
    ],
    accepted: [
        'deferred',
        'rejected'
    ],
    deferred: [
        'accepted',
        'rejected'
    ],
    rejected: [],
    done: []
};
function $0cd549c1a257ae26$export$8d9172732906836e(current) {
    return $0cd549c1a257ae26$var$PLAN_ITEM_TRANSITIONS[current] || [];
}
const $0cd549c1a257ae26$export$41d850810a86099c = (status)=>!$0cd549c1a257ae26$export$8d9172732906836e(status).length;
const $0cd549c1a257ae26$export$d8fa188a7f68dae7 = (visit)=>visit?.editable !== false;
function $0cd549c1a257ae26$export$c825b1cc6eb6552a(plans = []) {
    const byTooth = new Map();
    for (const plan of plans){
        // An abandoned course is not a plan for this tooth any more.
        if (plan?.status === 'abandoned') continue;
        for (const item of plan?.items || []){
            if (!item?.toothFdi) continue;
            if (!byTooth.has(item.toothFdi)) byTooth.set(item.toothFdi, []);
            byTooth.get(item.toothFdi).push({
                planId: plan.id,
                itemId: item.id,
                status: item.status,
                description: item.description || ''
            });
        }
    }
    return byTooth;
}
function $0cd549c1a257ae26$export$774cea0d439b4aad(records = [], catalog = []) {
    const byTooth = new Map();
    // Oldest first, so `names` reads in the order the work happened and
    // `lastAtMs` ends up on the newest.
    const ordered = [
        ...records
    ].sort((a, b)=>(Number(a?.recordedAtMs) || 0) - (Number(b?.recordedAtMs) || 0));
    for (const r of ordered){
        if (!r || r.voidedAtMs || !r.toothFdi) continue;
        const at = Number(r.recordedAtMs) || 0;
        const entry = byTooth.get(r.toothFdi) || {
            count: 0,
            lastAtMs: 0,
            names: []
        };
        entry.count += 1;
        if (at > entry.lastAtMs) entry.lastAtMs = at;
        entry.names.push($0cd549c1a257ae26$export$279093cb86d9c700(r, catalog));
        byTooth.set(r.toothFdi, entry);
    }
    return byTooth;
}
function $0cd549c1a257ae26$export$cc03fdd5f9432e88(records = []) {
    return records.filter((r)=>r && !r.voidedAtMs && !r.toothFdi).sort((a, b)=>(Number(b?.recordedAtMs) || 0) - (Number(a?.recordedAtMs) || 0));
}
const $0cd549c1a257ae26$export$cfb0120eb78d7586 = (status)=>![
        'done',
        'rejected'
    ].includes(String(status || ''));
function $0cd549c1a257ae26$export$49c0abb5f6c435a2(planTeeth) {
    const out = new Set();
    for (const [fdi, items] of planTeeth)if (items.some((i)=>$0cd549c1a257ae26$export$cfb0120eb78d7586(i.status))) out.add(fdi);
    return out;
}
function $0cd549c1a257ae26$export$9e890aca5c4be77f(plans = []) {
    return plans.find((p)=>![
            'completed',
            'abandoned'
        ].includes(p?.status)) || null;
}
const $0cd549c1a257ae26$export$2fc3923f5055ac01 = (plan)=>!!plan?.approvedAtMs;
const $0cd549c1a257ae26$export$5c9d23f753d827d0 = (t)=>[
        {
            value: '',
            label: t('visit.plan.applicability.unset')
        },
        {
            value: 'tooth',
            label: t('visit.plan.applicability.tooth')
        },
        {
            value: 'surfaces',
            label: t('visit.plan.applicability.surfaces')
        },
        {
            value: 'quadrant',
            label: t('visit.plan.applicability.quadrant')
        },
        {
            value: 'arch',
            label: t('visit.plan.applicability.arch')
        },
        {
            value: 'mouth',
            label: t('visit.plan.applicability.mouth')
        }
    ];
const $0cd549c1a257ae26$export$a5a2a58e8e5d8a26 = (t)=>[
        {
            value: '',
            label: t('visit.plan.applicability.unset')
        },
        ...$0cd549c1a257ae26$export$7e825e47d2291c85('11').map((o)=>({
                value: o.value,
                label: o.layer === 'none' ? t('visit.record.chartEffect.none') : o.layer === 'surface' ? t('visit.record.chartEffect.surfaceOption', {
                    state: t(`tooth.value.${o.word}`)
                }) : t(`tooth.value.${o.word}`)
            }))
    ];
function $0cd549c1a257ae26$export$9cba27725f1ac46d(entry) {
    const applicability = entry?.applicability || null;
    return {
        // «کل دهان» is offered wherever a tooth is, because a per-tooth service
        // genuinely can be planned for the whole mouth (a full-mouth extraction
        // plan is one line, not thirty-two).
        tooth: applicability !== 'mouth',
        surfaces: applicability === 'surfaces',
        // An arch or a quadrant is neither one tooth nor the whole mouth, and this
        // app has no field for either yet. Asking for a tooth would be wrong and
        // asking for nothing loses the site, so the dentist writes it in «شرح» —
        // which is what they do today for everything.
        hint: applicability === 'arch' || applicability === 'quadrant' ? applicability : null
    };
}
function $0cd549c1a257ae26$export$5d9a996a03bb93f5(item, records = []) {
    const quoted = Math.max(1, Number(item?.quantity) || 1);
    const recorded = records.filter((r)=>r?.planItemId === item?.id && !r.voidedAtMs).length;
    const done = recorded || (item?.status === 'done' ? quoted : 0);
    return {
        done: Math.min(done, quoted),
        quoted: quoted,
        multi: quoted > 1
    };
}
function $0cd549c1a257ae26$export$236c7cfabf06d283(item, records = [], { editable: editable = true } = {}) {
    if (!editable || !item?.id) return false;
    if (item.status === 'rejected') return false;
    const { done: done, quoted: quoted } = $0cd549c1a257ae26$export$5d9a996a03bb93f5(item, records);
    return done < quoted;
}
// ── «نوبت بعدی» — what the «پایان جلسه» dialog offers ──────────────────────
//
// A dentist does not think in «۲ هفتهٔ دیگر». They think «همین امروز», «فردا»,
// «تا یک هفته». So the options are the sentences they would say, and every one
// but the first two is a DEADLINE — «کمتر از یک هفته» means book within a week,
// NOT wait a week.
//
// That distinction is the whole reason a choice carries two instants:
//
//   floor  `after`  the earliest the appointment may be — the named day for
//                   «امروز»/«فردا», and NOW for every «کمتر از…»
//   ceil   `by`     the deadline, which is what the desk is actually being told
//
// Collapsing them into one would have «کمتر از یک هفته» mean «not before a
// week»: the opposite instruction, so the more urgent the dentist was the later
// the patient would be seen.
//
// `by: null` is «لازم نیست» — a real answer that raises nothing AND withdraws a
// prompt an earlier visit left, because the clinical judgement just changed.
const $0cd549c1a257ae26$var$DAY_MS = 86400000;
const $0cd549c1a257ae26$export$4b6ff696946acc8d = Object.freeze([
    // A point in time: today, and today.
    {
        key: 'today',
        afterDays: 0,
        byDays: 0
    },
    {
        key: 'tomorrow',
        afterDays: 1,
        byDays: 1
    },
    // A window: bookable now, due by then.
    {
        key: 'withinWeek',
        afterDays: null,
        byDays: 7
    },
    {
        key: 'within2Weeks',
        afterDays: null,
        byDays: 14
    },
    {
        key: 'withinMonth',
        afterDays: null,
        byDays: 30
    },
    {
        key: 'within3Months',
        afterDays: null,
        byDays: 90
    },
    {
        key: 'none',
        afterDays: null,
        byDays: null
    }
]);
const $0cd549c1a257ae26$export$f61ae47d7ba2b859 = 'withinWeek';
function $0cd549c1a257ae26$export$c9843a8a10355e58(key, now = Date.now(), durationMinutes = 0) {
    const choice = $0cd549c1a257ae26$export$4b6ff696946acc8d.find((i)=>i.key === key);
    if (!choice) return null;
    if (choice.byDays === null) return {
        declined: true
    };
    return {
        // Epoch ms as STRINGS: GraphQL Int is 32-bit and would overflow.
        ...choice.afterDays === null ? {} : {
            suggestedAfterMs: String(now + choice.afterDays * $0cd549c1a257ae26$var$DAY_MS)
        },
        suggestedByMs: String(now + choice.byDays * $0cd549c1a257ae26$var$DAY_MS),
        ...durationMinutes > 0 ? {
            durationMinutes: durationMinutes
        } : {}
    };
}
function $0cd549c1a257ae26$export$c4397ce7b585cc7c(items = [], catalog = []) {
    const byId = new Map((catalog || []).filter((c)=>c?.id).map((c)=>[
            c.id,
            c
        ]));
    let best = 0;
    for (const item of items){
        const minutes = Number(byId.get(item?.catalogId)?.durationMinutes) || 0;
        if (minutes > best) best = minutes;
    }
    return best;
}
/**
 * A line that should make the dialog ask «when should they come back?».
 *
 * NOT `isOutstandingPlanItem`, and the difference is the whole point. That one
 * answers «is this tooth still waiting for something», which a PROPOSED or a
 * DEFERRED line is — both keep the odontogram's planned ring, correctly. This
 * one answers «should the desk chase an appointment», which neither is:
 *
 *   پیشنهادشده  quoted, and the patient has not answered. Chasing it turns
 *               every diagnosis a dentist types into a booking task. Removed
 *               on the product owner's instruction, 2026-09-21.
 *   به تعویق    the patient saying NOT NOW; prompting the desk anyway
 *               contradicts the thing the dentist just recorded.
 *
 * A line is chased once the dentist moves it to «پذیرفته‌شده» — the patient
 * agreed, so the desk has something to book.
 *
 * Mirrors the service's OUTSTANDING_ITEM_STATUSES exactly (its
 * app/domain/dentistry/follow_up.py); reusing the ring's rule here made the
 * dialog ask about deferred lines the service would then refuse to raise.
 */ const $0cd549c1a257ae26$var$PROMPTS_FOR_FOLLOW_UP = [
    'accepted'
];
function $0cd549c1a257ae26$export$f5a44d3156f7523c(plans = [], records = []) {
    const out = [];
    for (const plan of plans){
        if (plan?.status === 'abandoned' || plan?.status === 'completed') continue;
        for (const item of plan.items || []){
            if (!$0cd549c1a257ae26$var$PROMPTS_FOR_FOLLOW_UP.includes(String(item?.status || ''))) continue;
            const { done: done, quoted: quoted } = $0cd549c1a257ae26$export$5d9a996a03bb93f5(item, records);
            if (done >= quoted) continue;
            out.push(item);
        }
    }
    return out;
}
/** Clinical order, not alphabetical: an emergency line is done first whenever
 *  it was quoted. Mirrors VisitTreatmentPlan's own PHASES. */ const $0cd549c1a257ae26$var$PHASES_IN_ORDER = [
    'emergency',
    'phase1',
    'phase2',
    'maintenance'
];
function $0cd549c1a257ae26$export$162d55e8fec86548(plans = [], records = []) {
    const items = $0cd549c1a257ae26$export$f5a44d3156f7523c(plans, records);
    if (items.length === 0) return null;
    const rank = (phase)=>{
        const i = $0cd549c1a257ae26$var$PHASES_IN_ORDER.indexOf(String(phase || ''));
        return i < 0 ? $0cd549c1a257ae26$var$PHASES_IN_ORDER.length : i;
    };
    const first = items.slice().sort((a, b)=>rank(a.phase) - rank(b.phase) || (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0))[0];
    return {
        label: first.description || '',
        toothFdi: first.toothFdi || null,
        more: items.length - 1
    };
}
function $0cd549c1a257ae26$export$37d161d3e5b5ff8b(records = [], appointmentId) {
    if (!appointmentId) return [];
    return records.filter((r)=>r?.appointmentId === appointmentId).slice().sort((a, b)=>(Number(b?.recordedAtMs) || 0) - (Number(a?.recordedAtMs) || 0));
}
function $0cd549c1a257ae26$export$279093cb86d9c700(record, catalog = []) {
    const snapshot = String(record?.serviceName || '').trim();
    if (snapshot) return snapshot;
    const id = record?.catalogId;
    const entry = id ? (catalog || []).find((c)=>c?.id === id) : null;
    return entry?.name || null;
}
const $0cd549c1a257ae26$export$8604b736a60e0cc5 = 'none';
function $0cd549c1a257ae26$export$5bdb384b22eb31f0(effect) {
    const key = String(effect || '').trim().toLowerCase();
    if (!key || key === $0cd549c1a257ae26$export$8604b736a60e0cc5) return null;
    const [layer, ...rest] = key.split(':');
    const value = rest.join(':');
    if (!value || ![
        'surface',
        'condition',
        'presence'
    ].includes(layer)) return null;
    return {
        layer: layer,
        value: value
    };
}
function $0cd549c1a257ae26$export$26076c91f3335ba5(entry, outcome) {
    if (outcome === 'in_progress') return $0cd549c1a257ae26$export$8604b736a60e0cc5;
    const declared = String(entry?.chartEffect || '').trim().toLowerCase();
    if (declared) return declared;
    return `surface:${(0, $789c06d5db9cfc3f$export$72f070c4454b9c95).RESTORATION}`;
}
function $0cd549c1a257ae26$export$7e825e47d2291c85(toothFdi) {
    const out = [
        {
            value: $0cd549c1a257ae26$export$8604b736a60e0cc5,
            layer: 'none'
        }
    ];
    if (!toothFdi) return out;
    if ((0, $789c06d5db9cfc3f$export$e8e69ffa6db2b2c2)(toothFdi).length) for (const state of (0, $789c06d5db9cfc3f$export$1d0d1c0dec314fe8))out.push({
        value: `surface:${state}`,
        layer: 'surface',
        word: state
    });
    for (const condition of (0, $789c06d5db9cfc3f$export$58954b0b7e983b1b))out.push({
        value: `condition:${condition}`,
        layer: 'condition',
        word: condition
    });
    // Only extraction. The other absences — exfoliated, congenitally absent —
    // are not things a treatment DOES.
    out.push({
        value: `presence:${(0, $789c06d5db9cfc3f$export$52e39c9e8fc17728).EXTRACTED}`,
        layer: 'presence',
        word: (0, $789c06d5db9cfc3f$export$52e39c9e8fc17728).EXTRACTED
    });
    return out;
}
function $0cd549c1a257ae26$export$eb8ea8a7dc42e176({ toothFdi: toothFdi, surfaces: surfaces, material: material, effect: effect = `surface:${(0, $789c06d5db9cfc3f$export$72f070c4454b9c95).RESTORATION}` } = {}) {
    if (!toothFdi) return [];
    const parsed = $0cd549c1a257ae26$export$5bdb384b22eb31f0(effect);
    if (!parsed) return [];
    if (parsed.layer === 'surface') {
        // The surfaces THIS tooth has, not merely the six letters that exist: an
        // incisor has no O. The service refuses an event naming a surface the tooth
        // cannot carry — and it refuses the WHOLE act, record included — so a stale
        // «O» carried over from a molar's plan line would lose the treatment, not
        // just the chart change.
        const available = (0, $789c06d5db9cfc3f$export$e8e69ffa6db2b2c2)(toothFdi);
        const codes = String(surfaces || '').toUpperCase().split('').filter((c)=>Object.prototype.hasOwnProperty.call((0, $789c06d5db9cfc3f$export$449bdafc1e1c1cf7), c)).filter((c)=>available.includes(c));
        return [
            ...new Set(codes)
        ].map((surface)=>({
                toothFdi: toothFdi,
                aspect: 'surface',
                surface: surface,
                value: parsed.value,
                material: material || null
            }));
    }
    return [
        {
            toothFdi: toothFdi,
            aspect: parsed.layer,
            surface: null,
            value: parsed.value,
            // A presence event carries no material: a tooth that has left the mouth is
            // not made of anything.
            material: parsed.layer === 'condition' ? material || null : null
        }
    ];
}
function $0cd549c1a257ae26$export$2971a96bcdab4d0f(plan) {
    return (0, $fcda591c8cd139a4$export$b91dea8e61ccd7ef)(plan?.currency);
}
function $0cd549c1a257ae26$export$11c05300a3da9053(entry, currency) {
    const own = (0, $fcda591c8cd139a4$export$b91dea8e61ccd7ef)(entry?.currency);
    const unit = Number(entry?.tariffRial) || 0;
    if (currency != null && own !== (0, $fcda591c8cd139a4$export$b91dea8e61ccd7ef)(currency)) return {
        amount: null,
        currency: own,
        mismatch: !!entry
    };
    return {
        amount: unit || null,
        currency: own,
        mismatch: false
    };
}
function $0cd549c1a257ae26$export$56006d7957c8727b(item, catalog = [], { locked: locked, currency: currency } = {}) {
    const planCurrency = (0, $fcda591c8cd139a4$export$b91dea8e61ccd7ef)(currency);
    if (locked) {
        const amount = Number(item?.lineAmountRial) || 0;
        return {
            amount: amount > 0 ? amount : null,
            currency: planCurrency,
            mismatch: false,
            entryCurrency: null
        };
    }
    const entry = catalog.find((c)=>c.id === item?.catalogId);
    const price = $0cd549c1a257ae26$export$11c05300a3da9053(entry, planCurrency);
    if (price.mismatch) return {
        amount: null,
        currency: planCurrency,
        mismatch: true,
        entryCurrency: price.currency
    };
    return {
        amount: price.amount ? price.amount * Math.max(1, Number(item?.quantity) || 1) : null,
        currency: planCurrency,
        mismatch: false,
        entryCurrency: price.currency
    };
}
function $0cd549c1a257ae26$export$f1f59bae25b41163(item, catalog = [], { locked: locked, currency: currency } = {}) {
    return $0cd549c1a257ae26$export$56006d7957c8727b(item, catalog, {
        locked: locked,
        currency: currency
    }).amount;
}
function $0cd549c1a257ae26$export$2078a79d5d359959(plan, catalog = []) {
    const locked = $0cd549c1a257ae26$export$2fc3923f5055ac01(plan);
    const currency = $0cd549c1a257ae26$export$2971a96bcdab4d0f(plan);
    const amount = (plan?.items || []).filter((i)=>$0cd549c1a257ae26$export$cfb0120eb78d7586(i.status)).reduce((sum, i)=>sum + ($0cd549c1a257ae26$export$56006d7957c8727b(i, catalog, {
            locked: locked,
            currency: currency
        }).amount || 0), 0);
    return {
        amount: amount,
        currency: currency
    };
}
function $0cd549c1a257ae26$export$a781244b2298f1c8(plan, catalog = []) {
    return $0cd549c1a257ae26$export$2078a79d5d359959(plan, catalog).amount;
}
/** IRR first, then the allow-list's order — a stable order for per-currency rows. */ function $0cd549c1a257ae26$var$byCurrencyOrder(a, b) {
    return (0, $fcda591c8cd139a4$export$729c9ac211f2ddda).indexOf(a.currency) - (0, $fcda591c8cd139a4$export$729c9ac211f2ddda).indexOf(b.currency);
}
function $0cd549c1a257ae26$export$4e15388b46f420b8(plans = [], catalog = []) {
    let count = 0;
    const totals = new Map();
    for (const plan of plans || []){
        if (!plan || plan.status === 'abandoned') continue;
        const locked = $0cd549c1a257ae26$export$2fc3923f5055ac01(plan);
        const currency = $0cd549c1a257ae26$export$2971a96bcdab4d0f(plan);
        for (const item of plan.items || []){
            if (!$0cd549c1a257ae26$export$cfb0120eb78d7586(item.status)) continue;
            count += 1;
            const { amount: amount } = $0cd549c1a257ae26$export$56006d7957c8727b(item, catalog, {
                locked: locked,
                currency: currency
            });
            totals.set(currency, (totals.get(currency) || 0) + (amount || 0));
        }
    }
    return {
        count: count,
        totals: [
            ...totals
        ].map(([currency, amount])=>({
                currency: currency,
                amount: amount
            })).sort($0cd549c1a257ae26$var$byCurrencyOrder)
    };
}
function $0cd549c1a257ae26$export$2442dd73c45c103c(plan, catalog = []) {
    if (!plan || $0cd549c1a257ae26$export$2fc3923f5055ac01(plan)) return false;
    const items = plan.items || [];
    if (!items.length) return false;
    const currency = $0cd549c1a257ae26$export$2971a96bcdab4d0f(plan);
    const prices = items.map((i)=>$0cd549c1a257ae26$export$56006d7957c8727b(i, catalog, {
            locked: false,
            currency: currency
        }));
    if (prices.some((p)=>p.mismatch)) return false;
    return prices.some((p)=>p.amount !== null);
}
function $0cd549c1a257ae26$export$1ebde7358daead69(t, err) {
    switch(err?.extensions?.code){
        case 'CLINIC_CURRENCY_UNAVAILABLE':
            return t('visit.plan.error.currencyUnavailable');
        case 'CURRENCY_MISMATCH':
            return t('visit.plan.error.currencyMismatch');
        default:
            return null;
    }
}
function $0cd549c1a257ae26$export$a2f1b1864a88d0bc({ clinicId: clinicId, plan: plan, clinics: clinics = [], catalog: catalog = [] } = {}) {
    if (plan && !$0cd549c1a257ae26$export$2fc3923f5055ac01(plan) && (!clinicId || plan.clinicId === clinicId)) return $0cd549c1a257ae26$export$2971a96bcdab4d0f(plan);
    const membership = clinicId ? (clinics || []).find((m)=>m?.clinicId === clinicId) : null;
    if (membership?.clinic) return (0, $fcda591c8cd139a4$export$b91dea8e61ccd7ef)(membership.clinic.currency);
    const codes = new Set((catalog || []).map((c)=>(0, $fcda591c8cd139a4$export$b91dea8e61ccd7ef)(c?.currency)));
    return codes.size === 1 ? [
        ...codes
    ][0] : null;
}
function $0cd549c1a257ae26$export$25df2e315be8e003(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const result = String(reader.result || '');
            const comma = result.indexOf(',');
            resolve(comma >= 0 ? result.slice(comma + 1) : '');
        };
        reader.onerror = ()=>reject(reader.error || new Error('read failed'));
        reader.readAsDataURL(file);
    });
}
const $0cd549c1a257ae26$export$ad100638cfc43086 = 15728640;
const $0cd549c1a257ae26$export$ca410b253ced059c = [
    'lab_report',
    'prescription',
    'general'
];
const $0cd549c1a257ae26$export$cf0d6a5afe211dd5 = (contentType, viewType)=>{
    if (viewType && viewType !== 'photo') return false;
    return /^(application\/pdf|image\/(jpeg|png|tiff|bmp|webp))$/i.test(String(contentType || ''));
};
function $0cd549c1a257ae26$export$7cc0b9b3fa44a60f(t, prefix, value) {
    const raw = String(value ?? '').trim();
    if (!raw) return '';
    const key = `${prefix}.${raw}`;
    return t.has?.(key) ? t(key) : raw;
}
function $0cd549c1a257ae26$export$671351640b9eccaf(bytes) {
    const n = Number(bytes) || 0;
    if (n <= 0) return null;
    if (n < 1024) return {
        value: n,
        unit: 'b'
    };
    if (n < 1048576) return {
        value: Math.round(n / 1024),
        unit: 'kb'
    };
    return {
        value: Math.round(n / 1048576 * 10) / 10,
        unit: 'mb'
    };
}


function $caa1f9ee90604e7f$export$4599bdc3f357e9d6({ patientId: patientId, clinicId: clinicId }) {
    const [service, setService] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        // A «ثبت سریع» walk-in has no patient record, so there is no plan to read.
        if (!patientId) {
            setService(null);
            return undefined;
        }
        let alive = true;
        // Cleared while the next patient's plan is read: leaving the previous
        // patient's treatment under a new patient's name is the one wrong answer
        // this hook can give.
        setService(null);
        (async ()=>{
            const vars = {
                patientId: patientId,
                clinicId: clinicId || null
            };
            const [plans, records] = await Promise.allSettled([
                (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$17160a4cc503e72e), vars),
                (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$80e65e29894beb41), vars)
            ]);
            if (!alive) return;
            if (plans.status !== 'fulfilled') {
                console.error('[useNextService] plan read failed:', plans.reason?.message);
                return;
            }
            // A failed RECORD read is not a failure of the whole answer: `sessionsOf`
            // falls back to the line's own «انجام‌شده» status, which is what every
            // plan written before records existed carries anyway.
            if (records.status !== 'fulfilled') console.error('[useNextService] record read failed:', records.reason?.message);
            setService((0, $0cd549c1a257ae26$export$162d55e8fec86548)(plans.value?.treatmentPlans || [], records.status === 'fulfilled' ? records.value?.treatmentRecords || [] : []));
        })();
        return ()=>{
            alive = false;
        };
    }, [
        patientId,
        clinicId
    ]);
    return service;
}
var $caa1f9ee90604e7f$export$2e2bcd8739ae039 = $caa1f9ee90604e7f$export$4599bdc3f357e9d6;


// The day model behind امروز — pure, React-free, text-free.
//
// It is separate from the screen for the reason the doctor app's
// Reception.shared.js gives: who is next, what the queue order is and what the
// day's counts are must be ONE computation, or two surfaces (and the tests) end
// up disagreeing about which patient walks in next.
//
// The status vocabulary here is the SCHEDULING service's, verbatim —
// scheduled | arrived | in_visit | completed | cancelled — because that is what
// parsina.bff.dentist exposes and it deliberately carries no second vocabulary.

const $13f800aa071fd2d2$export$2c639164686afa11 = [
    'scheduled',
    'arrived',
    'in_visit',
    'completed',
    'cancelled'
];
const $13f800aa071fd2d2$export$7caf56b642c4b5aa = (s)=>s === 'completed' || s === 'cancelled';
const $13f800aa071fd2d2$export$c681edc7fb7265b4 = (s)=>s === 'arrived' || s === 'in_visit';
const $13f800aa071fd2d2$export$ee8d39e3e546e43 = 20;
const $13f800aa071fd2d2$export$ecc34e94feb73a99 = 720;
function $13f800aa071fd2d2$export$c80826d3392ea781(appt) {
    return {
        ...appt,
        time: (0, $6e94fc1378f3a785$export$938a2af94a6be3bb)(appt?.dateTime),
        minutes: (0, $6e94fc1378f3a785$export$beb979c4570c8eb7)(appt?.dateTime)
    };
}
function $13f800aa071fd2d2$export$c1de35a83862cf9(appt) {
    return appt?.patient?.name || appt?.placeholderLabel || '';
}
function $13f800aa071fd2d2$export$8820bfcc7ef6bb39(appt, nowMs) {
    const arrived = Number(appt?.arrivedAt);
    if (!Number.isFinite(arrived) || arrived <= 0) return null;
    const min = Math.max(0, Math.floor((nowMs - arrived) / 60000));
    return min > $13f800aa071fd2d2$export$ecc34e94feb73a99 ? null : min;
}
function $13f800aa071fd2d2$export$e38f5492dd7c5c53(appt, nowMs) {
    const started = Number(appt?.visitStartedAt);
    if (!Number.isFinite(started) || started <= 0) return {
        elapsedMin: null,
        level: 'normal'
    };
    const elapsedMin = Math.max(0, Math.floor((nowMs - started) / 60000));
    if (elapsedMin > $13f800aa071fd2d2$export$ecc34e94feb73a99) return {
        elapsedMin: null,
        level: 'normal'
    };
    const dur = appt.durationMinutes || 30;
    const level = elapsedMin > 2 * dur ? 'critical' : elapsedMin > dur ? 'over' : 'normal';
    return {
        elapsedMin: elapsedMin,
        level: level
    };
}
function $13f800aa071fd2d2$export$ad1ae77322e9b4e5({ appointments: appointments = [], queue: queue = [], isToday: isToday, nowMin: nowMin }) {
    const dayApts = [
        ...appointments
    ].map($13f800aa071fd2d2$export$c80826d3392ea781).sort((a, b)=>Number(a.dateTime || 0) - Number(b.dateTime || 0));
    const roomQueue = isToday ? queue.map($13f800aa071fd2d2$export$c80826d3392ea781) : [];
    const queueIds = new Set(roomQueue.map((a)=>a.id));
    const upcoming = dayApts.filter((a)=>!queueIds.has(a.id) && !$13f800aa071fd2d2$export$7caf56b642c4b5aa(a.status));
    const done = dayApts.filter((a)=>$13f800aa071fd2d2$export$7caf56b642c4b5aa(a.status));
    // Rows that are in the ROOM but not on the day sheet. This is not a corner
    // case invented here — two live sources produce it:
    //
    //   * `appointments.clinic_id` is NULLABLE (scheduling/app/infrastructure/db/
    //     models.py:22). `today` filters `clinic_id == clinicId` server-side, so
    //     an unattributed row is dropped from the sheet, while `queue` KEEPS it
    //     on purpose — a patient physically in the room must not vanish.
    //   * `get_queue_status` filters on status alone, with no date bound, so a
    //     patient marked arrived yesterday and never completed is still in the
    //     room list today.
    //
    // They are the reason the screen must not gate the waiting room on the day
    // sheet being non-empty, and the reason the KPI strip counts `counted` and
    // not `dayApts`: «حاضر ۰» above a queue block listing a patient is the
    // screen contradicting itself.
    const dayIds = new Set(dayApts.map((a)=>a.id));
    const roomOnly = roomQueue.filter((a)=>!dayIds.has(a.id));
    const counted = roomOnly.length > 0 ? [
        ...dayApts,
        ...roomOnly
    ] : dayApts;
    // Waiting-line position counts only the patients still waiting; the one
    // already in the chair is not "number 1 in line", they are in the chair.
    const queuePosOf = new Map(roomQueue.filter((a)=>a.status === 'arrived').map((a, i)=>[
            a.id,
            i + 1
        ]));
    const nextApt = isToday ? roomQueue[0] || upcoming.find((a)=>a.minutes != null && a.minutes >= nowMin) || null : null;
    return {
        dayApts: dayApts,
        roomQueue: roomQueue,
        roomOnly: roomOnly,
        counted: counted,
        queueIds: queueIds,
        upcoming: upcoming,
        done: done,
        queuePosOf: queuePosOf,
        nextApt: nextApt
    };
}
function $13f800aa071fd2d2$export$c8c7db9d09049583(dayApts) {
    return {
        total: dayApts.length,
        here: dayApts.filter((a)=>$13f800aa071fd2d2$export$c681edc7fb7265b4(a.status)).length,
        scheduled: dayApts.filter((a)=>a.status === 'scheduled').length,
        completed: dayApts.filter((a)=>a.status === 'completed').length,
        cancelled: dayApts.filter((a)=>a.status === 'cancelled').length
    };
}





var $acw62 = parcelRequire("acw62");





// One rule for rendering a minutes-count on the day sheet: under an hour it
// stays minutes, from an hour up it reads in hours (+ leftover minutes).
//
// It lives here — not inline in AppointmentRow — because the mobile card
// renders the identical chips, and two copies of "when does انتظار switch to
// ساعت" is how the two surfaces would come to disagree. appointments.js itself
// stays text-free, so the key-choosing lives one file over.
//
// The three variants per base key ('', 'Hours', 'HoursMinutes') must exist in
// every catalogue; the parity test in tests/i18n.test.js is what enforces it.
function $e7459ce5155aabe1$export$6983ec1528bb4f57(t, baseKey, min) {
    if (min < 60) return t(baseKey, {
        count: min
    });
    const hours = Math.floor(min / 60);
    const minutes = min % 60;
    if (minutes === 0) return t(`${baseKey}Hours`, {
        hours: hours
    });
    return t(`${baseKey}HoursMinutes`, {
        hours: hours,
        minutes: minutes
    });
}



parcelRequire("acw62");


// The appointment status pill — one component, both surfaces.
//
// NOT the kit's <StatusBadge/>: that derives its LABEL from
// `statusColors[status].label`, which is Persian-only — so the day sheet read
// «نوبت‌دار» beside English copy for a dentist working in `en`. Everything
// visual still comes from the kit's tokens; only the word is the catalogue's,
// and a status this app has no copy for renders VERBATIM rather than being
// relabelled — the same fallback the kit uses.
//
// It lives here rather than inside AppointmentRow because the mobile card
// renders the identical pill (§1.1: fork the markup, share the vocabulary). The
// two surfaces disagreeing about what «arrived» is called would be a defect;
// this is the smallest thing they can share to make that impossible.
const $fe44ad2ad7f0db99$var$NEUTRAL_BG = (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2;
const $fe44ad2ad7f0db99$var$StatusPill = ({ status: status, style: style })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const cfg = (0, $e7c165fb515b04ea$export$6881c75116d5bd6e)[status] || {
        bg: $fe44ad2ad7f0db99$var$NEUTRAL_BG,
        text: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    };
    const key = `today.status.${status}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            fontSize: 11,
            fontWeight: 700,
            padding: '3px 10px',
            borderRadius: 20,
            background: cfg.bg,
            color: cfg.text,
            flexShrink: 0,
            whiteSpace: 'nowrap',
            ...style
        },
        children: t.has(key) ? t(key) : status || t('common.labels.none')
    });
};
var $fe44ad2ad7f0db99$export$2e2bcd8739ae039 = $fe44ad2ad7f0db99$var$StatusPill;




var $acw62 = parcelRequire("acw62");


/**
 * A patient's avatar that opens the photo full-size when there is one to open.
 *
 * CLICKABLE ONLY WHEN A PHOTO EXISTS. Initials are generated from the name, so
 * there is nothing behind them to enlarge — wrapping them in a button would put
 * a focus stop on every row of the day sheet and the register that does nothing
 * when activated. `src` is what decides, not the patient.
 *
 * The stored image is 512×512 (the storage service downscales on upload), so the
 * dialog caps at that: scaling past the source only produces a blurrier picture
 * than the one already on screen.
 */ const $e4d30a9c02b68374$var$PatientAvatar = ({ name: name, src: src, size: size = 40, bg: bg, alt: alt })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const avatar = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a53b6ea678d7efe0$export$2e2bcd8739ae039), {
        name: name,
        src: src || undefined,
        size: size,
        bg: bg
    });
    if (!src) return avatar;
    const label = alt || name || '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: (e)=>{
                    // Every one of these avatars sits inside something else that is
                    // clickable — a day-sheet row, a register row, a page header with a
                    // back affordance. Without this, opening the photo also navigates,
                    // and the dialog appears over a screen the dentist did not ask for.
                    e.stopPropagation();
                    setOpen(true);
                },
                "aria-label": t('patient.photo.open', {
                    name: label
                }),
                style: {
                    padding: 0,
                    border: 'none',
                    background: 'none',
                    cursor: 'zoom-in',
                    borderRadius: '50%',
                    display: 'block',
                    flexShrink: 0,
                    lineHeight: 0
                },
                children: avatar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
                open: open,
                onOpenChange: setOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
                    className: "max-w-[560px]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                                children: label
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: src,
                            alt: t('patient.photo.alt', {
                                name: label
                            }),
                            style: {
                                display: 'block',
                                width: '100%',
                                maxWidth: 512,
                                height: 'auto',
                                margin: '0 auto',
                                borderRadius: 12
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var $e4d30a9c02b68374$export$2e2bcd8739ae039 = $e4d30a9c02b68374$var$PatientAvatar;


// One day-sheet row.
//
// TWO actions, and the distinction between them is the point:
//
//   «پرونده»   opens the patient's RECORD — everything ever recorded.
//   «جلسه»     opens THIS APPOINTMENT's workspace (docs/dent-visit.md).
//
// Neither writes to scheduling, which is still the rule this app is built on:
// «حاضر شد» belongs to the clinic desk and there is no server behind it here.
// Opening a visit is a READ — the workspace itself refuses to write to a
// completed or cancelled appointment — so it is not the «شروع ویزیت» this
// comment used to rule out. That one changes an appointment's status; this one
// changes which screen the dentist is on.
//
// A finished row keeps both: yesterday's visit is read-only, not hidden.
// An open visit escalates on ONE vocabulary: normal (in-visit blue) → over
// (past its booked slot, amber) → critical (past twice its slot, red). All from
// tokens; there is no local palette anywhere in this file.
const $db3b4f054b2a0cba$var$OVERRUN_CHIP = {
    normal: {
        bg: (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).in_visit.bg,
        color: (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).in_visit.text
    },
    over: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    critical: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
    }
};
const $db3b4f054b2a0cba$var$NEUTRAL_BG = (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2;
// The status pill moved to `src/components/StatusPill.jsx`: the mobile card
// renders the identical pill, and two copies of "what is «arrived» called" is
// how the two surfaces would come to disagree.
const $db3b4f054b2a0cba$var$ClockGlyph = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039), {
        size: 11,
        strokeWidth: 2.4,
        style: {
            display: 'inline-block',
            verticalAlign: '-1.5px',
            marginInlineEnd: 3
        }
    });
const $db3b4f054b2a0cba$var$QueuePos = ({ pos: pos })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const first = pos === 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            fontSize: 10,
            fontWeight: 800,
            borderRadius: 6,
            padding: '2px 7px',
            whiteSpace: 'nowrap',
            color: first ? (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).arrived.text : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            background: first ? (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).arrived.bg : $db3b4f054b2a0cba$var$NEUTRAL_BG,
            border: `1px solid ${first ? 'transparent' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            flexShrink: 0
        },
        children: first ? t('today.queue.positionNext') : t('today.queue.position', {
            position: pos
        })
    });
};
const $db3b4f054b2a0cba$var$AppointmentRow = ({ apt: apt, queuePos: queuePos, nowMs: nowMs, onOpen: onOpen, onOpenVisit: onOpenVisit })=>{
    const { t: t, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [hovered, setHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const waited = apt.status === 'arrived' ? (0, $13f800aa071fd2d2$export$8820bfcc7ef6bb39)(apt, nowMs) : null;
    const { elapsedMin: elapsedMin, level: level } = apt.status === 'in_visit' ? (0, $13f800aa071fd2d2$export$e38f5492dd7c5c53)(apt, nowMs) : {
        elapsedMin: null,
        level: 'normal'
    };
    const overChip = $db3b4f054b2a0cba$var$OVERRUN_CHIP[level];
    const dotColor = ((0, $e7c165fb515b04ea$export$6881c75116d5bd6e)[apt.status] || {}).text || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted;
    const name = (0, $13f800aa071fd2d2$export$c1de35a83862cf9)(apt);
    // A «ثبت سریع» row has no patient record to open — placeholderLabel carries
    // the name INSTEAD of patientId, and exactly one of the two is ever set.
    const walkIn = !apt.patientId;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        onMouseEnter: ()=>setHovered(true),
        onMouseLeave: ()=>setHovered(false),
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 16px',
            borderRadius: 12,
            marginBottom: 8,
            background: hovered ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2 : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            border: `1.5px solid ${hovered ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border : $db3b4f054b2a0cba$var$NEUTRAL_BG}`,
            transition: 'all 0.15s'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    background: dotColor,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 13,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    minWidth: 44,
                    textAlign: 'center',
                    flexShrink: 0
                },
                children: apt.time ? formatDigits(apt.time) : t('common.labels.none')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: 1,
                    height: 28,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                name: name,
                src: apt.patient?.avatarUrl,
                size: 32,
                bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 13,
                            fontWeight: 700,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: name || t('today.row.unknownPatient')
                    }),
                    apt.patient?.phone && // A phone number is a Latin-digit run: it must read left-to-right
                    // inside an RTL line, and `isolate` stops the punctuation around it
                    // being dragged to the wrong end.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        dir: "ltr",
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            unicodeBidi: 'isolate',
                            whiteSpace: 'nowrap'
                        },
                        children: formatDigits((0, $412e1a8a99c19c1a$exports).forDisplay(apt.patient.phone))
                    }),
                    walkIn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 9.5,
                            fontWeight: 800,
                            borderRadius: 5,
                            padding: '1px 6px',
                            flexShrink: 0,
                            background: $db3b4f054b2a0cba$var$NEUTRAL_BG,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: t('today.row.walkIn')
                    })
                ]
            }),
            waited != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    borderRadius: 20,
                    padding: '2px 9px',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    background: waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft : $db3b4f054b2a0cba$var$NEUTRAL_BG,
                    color: waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db3b4f054b2a0cba$var$ClockGlyph, {}),
                    (0, $e7459ce5155aabe1$export$6983ec1528bb4f57)(t, 'today.queue.waited', waited)
                ]
            }),
            elapsedMin != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    fontSize: 10.5,
                    fontWeight: 700,
                    borderRadius: 20,
                    padding: '2px 9px',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                    background: overChip.bg,
                    color: overChip.color
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db3b4f054b2a0cba$var$ClockGlyph, {}),
                    (0, $e7459ce5155aabe1$export$6983ec1528bb4f57)(t, 'today.queue.elapsed', elapsedMin)
                ]
            }),
            queuePos != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db3b4f054b2a0cba$var$QueuePos, {
                pos: queuePos
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe44ad2ad7f0db99$export$2e2bcd8739ae039), {
                status: apt.status
            }),
            !walkIn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 6,
                    flexShrink: 0
                },
                children: [
                    onOpenVisit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: (0, $13f800aa071fd2d2$export$7caf56b642c4b5aa)(apt.status) ? 'subtle' : 'default',
                        onClick: ()=>onOpenVisit(apt),
                        "aria-label": t('today.row.visitFor', {
                            name: name || t('today.row.unknownPatient')
                        }),
                        className: "shrink-0",
                        children: t('today.row.visit')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        size: "sm",
                        variant: onOpenVisit ? 'outline' : (0, $13f800aa071fd2d2$export$7caf56b642c4b5aa)(apt.status) ? 'subtle' : 'default',
                        onClick: ()=>onOpen?.(apt),
                        "aria-label": t('today.row.openFor', {
                            name: name || t('today.row.unknownPatient')
                        }),
                        className: "shrink-0",
                        children: t('today.row.open')
                    })
                ]
            })
        ]
    });
};
var $db3b4f054b2a0cba$export$2e2bcd8739ae039 = $db3b4f054b2a0cba$var$AppointmentRow;



parcelRequire("acw62");







parcelRequire("acw62");
/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6fb6c94f3b917ca1$export$a2387ed3b5d536eb = {
    name: "list-checks",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 5h8",
                key: "a7qcls"
            }
        ],
        [
            "path",
            {
                d: "M13 12h8",
                key: "h98zly"
            }
        ],
        [
            "path",
            {
                d: "M13 19h8",
                key: "c3s6r1"
            }
        ],
        [
            "path",
            {
                d: "m3 17 2 2 4-4",
                key: "1jhpwq"
            }
        ],
        [
            "path",
            {
                d: "m3 7 2 2 4-4",
                key: "1obspn"
            }
        ]
    ]
};
$6fb6c94f3b917ca1$export$a2387ed3b5d536eb.node;
const $6fb6c94f3b917ca1$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6fb6c94f3b917ca1$export$a2387ed3b5d536eb);



// «خدمت» — what the next patient is coming FOR, on the day sheet's hero.
//
// One component for both heroes, because the SENTENCE is the same on a phone
// and on a reception monitor and only the type size differs. The two files
// already share StatusPill, PatientAvatar and the today.next.* vocabulary; a
// second copy of this composition is how the phone ends up saying something
// the desktop does not.
//
// `service` is `nextPlannedService()` — the first outstanding طرح درمان line —
// or null. Null is a real answer and is said in words: «ویزیت». It is NOT
// silence, because a blank where the treatment goes reads as "we do not know"
// on a screen whose whole job is a glance.
//
// The tooth rides along («ترمیم کامپوزیت · دندان ۱۶») because a dentist reads
// site and service as one fact, and «+۲» says the sitting has more waiting
// without promising a day's work in one appointment.
const $239ffdcb18e03bab$var$NextServiceChip = ({ service: service, compact: compact = false })=>{
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const planned = !!service;
    // An untitled line is still a planned line — «ویزیت» here would claim the
    // patient has nothing outstanding, which is the opposite of the truth.
    const name = planned ? service.label || t('visit.plan.untitledItem') : t('today.next.serviceVisit');
    const Icon = planned ? (0, $6fb6c94f3b917ca1$export$2e2bcd8739ae039) : (0, $02839c5704f38745$export$2e2bcd8739ae039);
    const size = compact ? 12 : 14;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "today-next-service",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: compact ? 5 : 6,
            marginTop: 4,
            minWidth: 0,
            fontSize: compact ? '0.6875rem' : 13,
            fontWeight: 600,
            color: 'rgba(255,255,255,0.85)'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                size: size,
                strokeWidth: 2.4,
                "aria-hidden": true,
                style: {
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                dir: "auto",
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: [
                    t('today.next.service', {
                        name: name
                    }),
                    planned && service.toothFdi ? ` \xb7 ${t('visit.chart.tooth', {
                        fdi: formatNumber(service.toothFdi)
                    })}` : ''
                ]
            }),
            planned && service.more > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    flexShrink: 0,
                    fontSize: compact ? '0.625rem' : 11,
                    fontWeight: 700,
                    borderRadius: 20,
                    padding: '1px 7px',
                    background: 'rgba(255,255,255,0.22)'
                },
                children: t('today.next.serviceMore', {
                    count: service.more
                })
            })
        ]
    });
};
var $239ffdcb18e03bab$export$2e2bcd8739ae039 = $239ffdcb18e03bab$var$NextServiceChip;



// The «بیمار بعدی» hero — desktop.
//
// The single most important fact of the day sheet is who walks in next, and an
// info Alert gave it the visual weight of a footnote. This is the desktop
// counterpart of `mobile/MobileNextPatient.jsx`: same brand gradient, same
// vocabulary (StatusPill, displayName, today.next.*), laid out as one wide row
// because the reception monitor has the width the phone lacks.
//
// `apt` is `buildDayModel().nextApt` — null off today, null with nobody
// waiting. This component never decides who is next. Nor does it decide what
// they are coming FOR: `service` is read beside it (hooks/useNextService.js)
// and null renders as «ویزیت».
const $81f917ab05ccb6fc$var$NextPatientHero = ({ apt: apt, service: service, onOpen: onOpen, onOpenVisit: onOpenVisit })=>{
    const { t: t, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (!apt) return null;
    const name = (0, $13f800aa071fd2d2$export$c1de35a83862cf9)(apt) || t('today.row.unknownPatient');
    // A «ثبت سریع» walk-in has no patient record, so there is nothing to open:
    // both actions disappear rather than navigate nowhere (§3.2).
    const hasRecord = Boolean(apt.patientId);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-testid": "today-next",
        "aria-label": t('today.next.title'),
        style: {
            position: 'relative',
            overflow: 'hidden',
            background: (0, $e7c165fb515b04ea$export$7deb2be06092489e),
            borderRadius: 16,
            padding: '20px 24px',
            marginBottom: 18,
            color: '#fff',
            boxShadow: '0 8px 24px color-mix(in srgb, var(--p-navy) 28%, transparent)'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "aria-hidden": true,
                style: {
                    position: 'absolute',
                    insetInlineEnd: -70,
                    top: -70,
                    width: 220,
                    height: 220,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.08)'
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "aria-hidden": true,
                style: {
                    position: 'absolute',
                    insetInlineEnd: 90,
                    bottom: -90,
                    width: 160,
                    height: 160,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.05)'
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 18
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                        name: name,
                        src: apt.patient?.avatarUrl,
                        size: 56,
                        bg: "rgba(255,255,255,0.22)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                style: {
                                    margin: '0 0 4px',
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: 'rgba(255,255,255,0.78)'
                                },
                                children: t('today.next.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                    minWidth: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        dir: "auto",
                                        style: {
                                            fontSize: 22,
                                            fontWeight: 800,
                                            lineHeight: 1.3,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        },
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe44ad2ad7f0db99$export$2e2bcd8739ae039), {
                                        status: apt.status
                                    })
                                ]
                            }),
                            apt.time && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    marginTop: 4,
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: 'rgba(255,255,255,0.85)'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039), {
                                        size: 14,
                                        strokeWidth: 2.4,
                                        "aria-hidden": true,
                                        style: {
                                            flexShrink: 0
                                        }
                                    }),
                                    t('today.next.at', {
                                        time: formatDigits(apt.time)
                                    })
                                ]
                            }),
                            hasRecord && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $239ffdcb18e03bab$export$2e2bcd8739ae039), {
                                service: service
                            })
                        ]
                    }),
                    hasRecord && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            flexShrink: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: ()=>onOpenVisit?.(apt),
                                "data-testid": "today-next-visit",
                                "aria-label": t('today.row.visitFor', {
                                    name: name
                                }),
                                className: "hover:bg-white/90",
                                style: {
                                    background: '#fff',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                                    fontWeight: 800
                                },
                                children: t('today.row.visit')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                onClick: ()=>onOpen?.(apt),
                                "data-testid": "today-next-open",
                                "aria-label": t('today.row.openFor', {
                                    name: name
                                }),
                                className: "text-white hover:bg-white/25",
                                style: {
                                    background: 'rgba(255,255,255,0.16)',
                                    color: '#fff'
                                },
                                children: t('today.row.open')
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $81f917ab05ccb6fc$export$2e2bcd8739ae039 = $81f917ab05ccb6fc$var$NextPatientHero;



parcelRequire("acw62");



parcelRequire("acw62");



const $e0ce57f089cb4321$export$45686ee14bc4c7f3 = ({ label: label, ...rest })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8b3e24dbbac64362), {
        label: label ?? t('common.loading'),
        ...rest
    });
};
const $e0ce57f089cb4321$export$a5bf34efdb86126b = ({ avatar: avatar = true, meta: meta = true, stats: stats = 0, actions: actions = 1 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            minHeight: '4rem',
            paddingInline: '1.75rem',
            paddingBlock: '0.75rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 72,
                height: 36,
                radius: 8
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    avatar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$53c2c5a35a7e31a2), {
                        size: 44
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 180,
                                height: 18
                            }),
                            meta && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 240,
                                height: 12
                            })
                        ]
                    })
                ]
            }),
            stats > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: '0.5625rem'
                },
                children: Array.from({
                    length: stats
                }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 64,
                        height: 38,
                        radius: 10
                    }, i))
            }),
            actions > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: '0.5rem'
                },
                children: Array.from({
                    length: actions
                }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        width: i === 0 ? 112 : 96
                    }, i))
            })
        ]
    });
const $e0ce57f089cb4321$export$4c127c4db7b36f7f = ({ back: back = false, greeting: greeting = false, subtitle: subtitle = true, children: children, ...rest })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 160,
                height: 20,
                tone: "onDark"
            }),
            subtitle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 110,
                height: 12,
                tone: "onDark"
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        title: title,
        onBack: back ? ()=>{} : undefined,
        backLabel: t('common.actions.back'),
        user: greeting ? {
            name: ' '
        } : undefined,
        greeting: greeting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: 72,
            height: 10,
            tone: "onDark"
        }) : undefined,
        ...rest,
        children: children
    });
};
const $e0ce57f089cb4321$export$6237acc7cd007357 = ({ count: count = 4, columns: columns = count })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: '0.5rem'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: '0.75rem',
                    padding: '0.625rem 0.25rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: "45%",
                        height: 17
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: "60%",
                        height: 9
                    })
                ]
            }, i))
    });
const $e0ce57f089cb4321$export$52fa1d077274aab0 = ({ count: count = 3 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            padding: '0 0.25rem',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 44,
                    padding: '0.5rem 0.875rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 4
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 16,
                        height: 16,
                        radius: 4
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 48,
                        height: 10
                    })
                ]
            }, i))
    });
const $e0ce57f089cb4321$export$f51fccaec5c96c2a = ({ count: count = 3, height: height = 40 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'inline-flex',
            gap: 4,
            padding: 4,
            borderRadius: 12,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: [
                    88,
                    104,
                    76,
                    96,
                    84
                ][i % 5],
                height: height - 8,
                radius: 8
            }, i))
    });
const $e0ce57f089cb4321$export$67864df0c74efa69 = ({ radius: radius = 12 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: radius,
            padding: '8px 4px 4px'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: "100%",
            height: "auto",
            radius: 10,
            style: {
                aspectRatio: '620 / 396',
                maxWidth: 760,
                margin: '0 auto'
            }
        })
    });
const $e0ce57f089cb4321$export$1d36da46ad5622dc = ({ count: count = 6 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            flexDirection: 'column'
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 12,
                    minHeight: 44,
                    borderTop: i > 0 ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${28 + i * 7 % 18}%`,
                        height: 11
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${30 + i * 13 % 26}%`,
                        height: 13
                    })
                ]
            }, i))
    });
const $e0ce57f089cb4321$export$f102dad4aafe4ad4 = ({ valueWidth: valueWidth = '70%' })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: "45%",
                height: 11
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: valueWidth,
                height: 14
            })
        ]
    });
const $e0ce57f089cb4321$export$543533cea58d4261 = ({ count: count = 3, gap: gap = 12 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: gap
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${34 + i * 11 % 22}%`,
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 56,
                        height: 22,
                        radius: 999
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 70,
                        height: 12,
                        style: {
                            marginInlineStart: 'auto'
                        }
                    })
                ]
            }, i))
    });


// امروز — the loading shape of the day sheet, desktop and mobile.
//
// The page chrome (header, date navigator, KPI tiles) is REAL while the day
// loads — `KpiCard`/`StatTiles` carry their own `loading` dash — so what
// skeletons here is only the part the query fills: the next-patient hero and
// the first block of appointment rows. Geometry follows NextPatientHero,
// AppointmentRow (desktop) and MobileNextPatient, MobileAppointmentCard
// (mobile) exactly, so the rows the dentist is about to click do not move when
// the data lands.
// ── desktop ─────────────────────────────────────────────────────────────────
/** NextPatientHero: gradient band, 56px avatar, kicker + 22px name, two buttons. */ const $2fa3e7ee1d1f83aa$var$HeroSkeleton = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $e7c165fb515b04ea$export$7deb2be06092489e),
            borderRadius: 16,
            padding: '20px 24px',
            marginBottom: 18,
            display: 'flex',
            alignItems: 'center',
            gap: 18
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$53c2c5a35a7e31a2), {
                size: 56,
                tone: "onDark"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 12,
                        tone: "onDark"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: "40%",
                        height: 22,
                        tone: "onDark"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 120,
                        height: 12,
                        tone: "onDark"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        width: 88,
                        tone: "onDark"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        width: 88,
                        tone: "onDark"
                    })
                ]
            })
        ]
    });
/** AppointmentRow: dot · time · divider · 32px avatar · name/phone · pill · two sm buttons. */ const $2fa3e7ee1d1f83aa$var$RowSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 16px',
            borderRadius: 12,
            marginBottom: 8,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            border: `1.5px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 8,
                circle: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 44,
                height: 14
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: 1,
                    height: 28,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
                    flexShrink: 0
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$53c2c5a35a7e31a2), {
                size: 32
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${22 + i * 9 % 16}%`,
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 78,
                        height: 11
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 64,
                height: 22,
                radius: 999
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        size: "sm",
                        width: 64
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        size: "sm",
                        width: 64
                    })
                ]
            })
        ]
    });
/** A day-sheet Block: titled strip + count pill over its rows. */ const $2fa3e7ee1d1f83aa$var$BlockSkeleton = ({ rows: rows })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: 0,
            marginBottom: 14,
            overflow: 'hidden'
        },
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '14px 20px',
                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 14
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 28,
                        height: 20,
                        radius: 999
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: 12
                },
                children: Array.from({
                    length: rows
                }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2fa3e7ee1d1f83aa$var$RowSkeleton, {
                        i: i
                    }, i))
            })
        ]
    });
const $2fa3e7ee1d1f83aa$export$4698d892fd98ece6 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "today-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2fa3e7ee1d1f83aa$var$HeroSkeleton, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2fa3e7ee1d1f83aa$var$BlockSkeleton, {
                rows: 3
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2fa3e7ee1d1f83aa$var$BlockSkeleton, {
                rows: 2
            })
        ]
    });
// ── mobile ──────────────────────────────────────────────────────────────────
/** MobileNextPatient: 40px avatar, kicker/name/time, full-width ghost button. */ const $2fa3e7ee1d1f83aa$var$MobileHeroSkeleton = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            background: (0, $e7c165fb515b04ea$export$7deb2be06092489e),
            borderRadius: '1rem',
            padding: '0.875rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$53c2c5a35a7e31a2), {
                        size: 40,
                        tone: "onDark"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 72,
                                height: 10,
                                tone: "onDark"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: "55%",
                                height: 15,
                                tone: "onDark"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 90,
                                height: 10,
                                tone: "onDark"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 56,
                        height: 22,
                        radius: 999,
                        tone: "onDark"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: "100%",
                height: 44,
                radius: 10,
                tone: "onDark",
                style: {
                    marginTop: '0.75rem'
                }
            })
        ]
    });
/** MobileAppointmentCard: time · 32px avatar · name/phone · status pill. */ const $2fa3e7ee1d1f83aa$var$MobileCardSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        style: {
            padding: '0.75rem',
            marginBottom: '0.5rem',
            borderRadius: '0.875rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.625rem'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 44,
                    height: 13
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$53c2c5a35a7e31a2), {
                    size: 32
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 5
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                            width: `${45 + i * 13 % 30}%`,
                            height: 13
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                            width: "35%",
                            height: 11
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 56,
                    height: 22,
                    radius: 999
                })
            ]
        })
    });
const $2fa3e7ee1d1f83aa$export$f5df4f64a00ea7c5 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "today-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2fa3e7ee1d1f83aa$var$MobileHeroSkeleton, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: '0.875rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            marginBottom: '0.5rem',
                            minHeight: 28
                        },
                        "aria-hidden": true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 96,
                                height: 13
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 24,
                                height: 18,
                                radius: 999
                            })
                        ]
                    }),
                    [
                        0,
                        1,
                        2,
                        3
                    ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2fa3e7ee1d1f83aa$var$MobileCardSkeleton, {
                            i: i
                        }, i))
                ]
            })
        ]
    });


// امروز — the screen that makes this app real.
//
// Every row here is an `appointments` row the clinic's منشی created. Nothing on
// this screen writes: the day is read, and the read is the whole point
// (DESIGN.md §6 — "the phase where the dentist app stops being a shell and
// starts showing the clinic's appointments").
// A titled section of the day with a count pill. Collapsible for «انجام‌شده»,
// which is history rather than work.
const $12c6ee8e8eac267c$var$Block = ({ title: title, count: count, tint: tint, tintText: tintText, collapsible: collapsible, defaultOpen: defaultOpen = true, children: children })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultOpen);
    // The disclosure has to NAME the region it controls, or a screen reader
    // announces "expanded" with nothing attached to it.
    const bodyId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: 0,
            marginBottom: 14,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: collapsible ? ()=>setOpen((o)=>!o) : undefined,
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '14px 20px',
                    borderBottom: open ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none',
                    cursor: collapsible ? 'pointer' : 'default'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            margin: 0,
                            fontSize: 14,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: collapsible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            "aria-expanded": open,
                            "aria-controls": bodyId,
                            onClick: (e)=>{
                                // The strip's own handler would otherwise toggle a second time
                                // and cancel this one out.
                                e.stopPropagation();
                                setOpen((o)=>!o);
                            },
                            style: {
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                margin: 0,
                                font: 'inherit',
                                color: 'inherit',
                                cursor: 'pointer'
                            },
                            children: title
                        }) : title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 11,
                            fontWeight: 800,
                            borderRadius: 20,
                            padding: '2px 9px',
                            background: tint || (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                            color: tintText || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: count
                    }),
                    collapsible && // A lucide glyph, not a «▲»/«▼» text character: the arrow glyphs are
                    // font-dependent and sit on the text baseline, so they drift out of
                    // line with the row in Vazirmatn.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                        size: 16,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                        "aria-hidden": true,
                        style: {
                            marginInlineStart: 'auto',
                            flexShrink: 0,
                            transform: open ? 'rotate(180deg)' : 'none',
                            transition: 'transform .15s'
                        }
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: bodyId,
                style: {
                    padding: '12px 16px 4px'
                },
                children: children
            })
        ]
    });
};
// Previous/next day.
//
// The kit's IconButton owns the affordance — label, tooltip, hit target — so
// this is not a hand-rolled button. What is app-specific is the chevron's
// MEANING: «روز قبل» points back the way the reader came from, which is RIGHT
// in Persian and LEFT in English. `MIRROR_ICON` (scaleX(--dir-flip); +1 in RTL,
// -1 in LTR) turns lucide's right-pointing glyph into exactly that, and `next`
// is its negation. Rendering the SAME glyph for both — which a fixed
// left-chevron does in RTL — leaves the two day buttons indistinguishable in
// the product language.
const $12c6ee8e8eac267c$var$NEXT_ICON = {
    transform: 'scaleX(calc(var(--dir-flip, 1) * -1))'
};
const $12c6ee8e8eac267c$var$NavBtn = ({ label: label, onClick: onClick, next: next })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
        variant: "outline",
        size: 40,
        label: label,
        onClick: onClick,
        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd034124f4eb9$export$2e2bcd8739ae039), {
            size: 16,
            "aria-hidden": true,
            style: next ? $12c6ee8e8eac267c$var$NEXT_ICON : (0, $a278322405d51c25$export$ddb338179359cccc)
        }),
        style: {
            borderRadius: 10
        }
    });
const $12c6ee8e8eac267c$var$TodayScreen = ()=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { activeId: activeId } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    // The selected day lives in the URL, so a refresh, a back button and a shared
    // link all restore the day being read. Today is the default and is omitted.
    const rawDate = searchParams.get('date');
    const today = (0, $6e94fc1378f3a785$export$ceda478235320bf2)();
    const selected = (0, $6e94fc1378f3a785$export$33df4d54a0f76001).test(rawDate || '') ? rawDate : today;
    const isToday = selected === today;
    const setDay = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((iso)=>{
        const next = new URLSearchParams(searchParams);
        if (!iso || iso === (0, $6e94fc1378f3a785$export$ceda478235320bf2)()) next.delete('date');
        else next.set('date', iso);
        setSearchParams(next, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    const { appointments: appointments, queue: queue, loading: loading, error: error, reload: reload } = (0, $02315dbdc761d1d1$export$6d84255ad587f3b5)({
        date: selected,
        clinicId: activeId
    });
    // Wait and chair clocks are minute-grained, so the screen re-renders on a
    // slow tick rather than making every row own a timer.
    const [tick, setTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>Date.now());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const timer = setInterval(()=>setTick(Date.now()), 30000);
        return ()=>clearInterval(timer);
    }, []);
    const model = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $13f800aa071fd2d2$export$ad1ae77322e9b4e5)({
            appointments: appointments,
            queue: queue,
            isToday: isToday,
            nowMin: (0, $6e94fc1378f3a785$export$9bf6380b18b1be8)(tick) ?? 0
        }), [
        appointments,
        queue,
        isToday,
        tick
    ]);
    // `counted`, not `dayApts`: it is the day sheet PLUS anyone in the room who
    // is not on it (a row with no clinic_id, or one marked arrived on an earlier
    // day and never completed). dayCounts' own contract is that the numbers are
    // derived from the same rows that render underneath them, and the waiting
    // room renders.
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $13f800aa071fd2d2$export$c8c7db9d09049583)(model.counted), [
        model.counted
    ]);
    // What the next patient is coming FOR. Read beside the day, on the PATIENT
    // changing rather than on the day poll — see hooks/useNextService.js.
    const nextService = (0, $caa1f9ee90604e7f$export$4599bdc3f357e9d6)({
        patientId: model.nextApt?.patientId || null,
        clinicId: activeId
    });
    // What the screen actually has to show. The day sheet is not the whole of it:
    // gating on `dayApts` alone painted «هیچ نوبتی برای این روز ثبت نشده» over a
    // waiting room with patients in it — the day read succeeded and said nothing,
    // which is the one failure this screen cannot afford.
    const hasRows = model.counted.length > 0;
    const openPatient = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((apt)=>{
        if (apt?.patientId) navigate('patient', {
            id: apt.patientId
        });
    }, [
        navigate
    ]);
    // جلسهٔ درمان — THIS appointment's workspace (docs/dent-visit.md). Keyed on
    // the appointment rather than the patient, because the appointment is the
    // visit. A «ثبت سریع» walk-in has no patient record, and the workspace cannot
    // open on one, so its row offers no visit button at all.
    const openVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((apt)=>{
        if (apt?.id && apt?.patientId) navigate('visit', {
            appointmentId: apt.id
        });
    }, [
        navigate
    ]);
    const kpis = [
        {
            key: 'total',
            label: t('today.counts.total'),
            value: counts.total
        },
        {
            key: 'here',
            label: t('today.counts.here'),
            value: counts.here,
            accent: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
        },
        {
            key: 'scheduled',
            label: t('today.counts.scheduled'),
            value: counts.scheduled
        },
        {
            key: 'completed',
            label: t('today.counts.completed'),
            value: counts.completed
        },
        // Only when there are any: a permanent «۰ لغو شده» tile is a number that
        // never says anything.
        ...counts.cancelled > 0 ? [
            {
                key: 'cancelled',
                label: t('today.counts.cancelled'),
                value: counts.cancelled
            }
        ] : []
    ];
    const dateNav = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12c6ee8e8eac267c$var$NavBtn, {
                label: t('today.date.prev'),
                onClick: ()=>setDay((0, $6e94fc1378f3a785$export$c13cab26eb520a22)(selected, -1))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: 210
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9dd19094c9f758e$export$2e2bcd8739ae039), {
                    value: selected,
                    onChange: (v)=>setDay(v || today),
                    height: 40
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12c6ee8e8eac267c$var$NavBtn, {
                label: t('today.date.next'),
                onClick: ()=>setDay((0, $6e94fc1378f3a785$export$c13cab26eb520a22)(selected, 1)),
                next: true
            }),
            !isToday && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                variant: "subtle",
                onClick: ()=>setDay(today),
                children: t('today.date.today')
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('today.title'),
                sub: formatDate((0, $6e94fc1378f3a785$export$3537fc298e9336da)(selected), 'full'),
                children: dateNav
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '24px 32px 40px'
                },
                children: error ? // role="alert" so a failed day is ANNOUNCED, not just drawn: the read
                // is asynchronous and the dentist's focus is on the date navigator
                // above, which stays operable through the failure.
                //
                // On the WRAPPER, not on <Card>: the kit destructures `role` and only
                // applies it to its onClick (button) form, so a role passed to a plain
                // Card is silently dropped.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "alert",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                            title: t('today.error.title'),
                            description: t('errors.load.today'),
                            onRetry: reload,
                            retryLabel: t('common.actions.retry')
                        })
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    "data-testid": "today-content",
                    "data-state": loading ? 'loading' : hasRows ? 'content' : 'empty',
                    "aria-busy": loading || undefined,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                display: 'flex',
                                gap: 12,
                                marginBottom: 18,
                                flexWrap: 'wrap'
                            },
                            children: kpis.map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $178f36e6e586ad89$export$2e2bcd8739ae039), {
                                    label: k.label,
                                    value: formatNumber(k.value),
                                    accent: k.accent,
                                    loading: loading
                                }, k.key))
                        }),
                        loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa3e7ee1d1f83aa$export$4698d892fd98ece6), {
                            label: t('common.loading')
                        }),
                        !loading && !hasRows && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b56343e65588121$export$2e2bcd8739ae039), {
                                    size: 48,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                }),
                                title: t('today.empty.title'),
                                description: t('today.empty.description')
                            })
                        }),
                        !loading && hasRows && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81f917ab05ccb6fc$export$2e2bcd8739ae039), {
                                    apt: model.nextApt,
                                    service: nextService,
                                    onOpen: openPatient,
                                    onOpenVisit: openVisit
                                }),
                                model.roomQueue.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12c6ee8e8eac267c$var$Block, {
                                    title: t('today.blocks.queue'),
                                    count: formatNumber(model.roomQueue.length),
                                    tint: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
                                    tintText: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
                                    children: model.roomQueue.map((apt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db3b4f054b2a0cba$export$2e2bcd8739ae039), {
                                            apt: apt,
                                            queuePos: model.queuePosOf.get(apt.id) ?? null,
                                            nowMs: tick,
                                            onOpen: openPatient,
                                            onOpenVisit: openVisit
                                        }, apt.id))
                                }),
                                model.upcoming.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12c6ee8e8eac267c$var$Block, {
                                    title: t('today.blocks.upcoming'),
                                    count: formatNumber(model.upcoming.length),
                                    children: model.upcoming.map((apt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db3b4f054b2a0cba$export$2e2bcd8739ae039), {
                                            apt: apt,
                                            nowMs: tick,
                                            onOpen: openPatient,
                                            onOpenVisit: openVisit
                                        }, apt.id))
                                }),
                                model.done.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($12c6ee8e8eac267c$var$Block, {
                                    title: t('today.blocks.done'),
                                    count: formatNumber(model.done.length),
                                    collapsible: true,
                                    defaultOpen: model.roomQueue.length === 0 && model.upcoming.length === 0,
                                    children: model.done.map((apt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db3b4f054b2a0cba$export$2e2bcd8739ae039), {
                                            apt: apt,
                                            nowMs: tick,
                                            onOpen: openPatient,
                                            onOpenVisit: openVisit
                                        }, apt.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                marginTop: 18,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                fontSize: 12
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba16dd414953e5a4$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t('today.readOnlyNote')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $12c6ee8e8eac267c$export$2e2bcd8739ae039 = $12c6ee8e8eac267c$var$TodayScreen;




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $87513a585d30c268$export$a2387ed3b5d536eb = {
    name: "calendar-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 14v2.2l1.6 1",
                key: "fo4ql5"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "path",
            {
                d: "M21 7.338V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h2.338",
                key: "7hb8p4"
            }
        ],
        [
            "path",
            {
                d: "M3 9h5.859",
                key: "numkqi"
            }
        ],
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "circle",
            {
                cx: "16",
                cy: "16",
                r: "6",
                key: "qoo3c4"
            }
        ]
    ]
};
$87513a585d30c268$export$a2387ed3b5d536eb.node;
const $87513a585d30c268$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($87513a585d30c268$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8cb58a0e56c12463$export$a2387ed3b5d536eb = {
    name: "circle-check",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "m16 9-5.5 5.5L8 12",
                key: "xofnsj"
            }
        ]
    ],
    aliases: [
        "check-circle-2"
    ]
};
$8cb58a0e56c12463$export$a2387ed3b5d536eb.node;
const $8cb58a0e56c12463$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($8cb58a0e56c12463$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6fe01e99f8f7285e$export$a2387ed3b5d536eb = {
    name: "user-check",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 11 2 2 4-4",
                key: "9rsbq5"
            }
        ],
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ]
    ]
};
$6fe01e99f8f7285e$export$a2387ed3b5d536eb.node;
const $6fe01e99f8f7285e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6fe01e99f8f7285e$export$a2387ed3b5d536eb);












parcelRequire("acw62");








// One appointment as a mobile CARD.
//
// This is the phone twin of the desktop `AppointmentRow`, and deliberately a
// separate component (§1.1: "same row, two surfaces, no shared component"). The
// desktop row is one flex line with nine children and a hover-repainted
// background — a hover affordance has no touch equivalent (§6), and nine
// children do not fit 320px. This is two lines inside a tappable card.
//
// The WHOLE card is the tap target (§4: "whole card taps into the record"), via
// the kit `Card`'s onClick form — a real <button>, with `role="link"` because
// the tap navigates. Never a `<div onClick>`.
//
// The escalation vocabulary is the desktop's, verbatim, from the SAME
// derivations: waited → amber past WAIT_WARN_MIN; an open visit normal → over →
// critical. Two surfaces disagreeing about whether a visit is running late
// would be worse than either alone.
const $539f61ab7b8a32ef$var$OVERRUN_CHIP = {
    normal: {
        bg: (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).in_visit.bg,
        color: (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).in_visit.text
    },
    over: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    critical: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
    }
};
const $539f61ab7b8a32ef$var$Chip = ({ bg: bg, color: color, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            fontSize: '0.65625rem',
            fontWeight: 700,
            borderRadius: '999px',
            padding: '0.125rem 0.5rem',
            whiteSpace: 'nowrap',
            flexShrink: 0,
            background: bg,
            color: color,
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.1875rem'
        },
        children: children
    });
const $539f61ab7b8a32ef$var$MobileAppointmentCard = ({ apt: apt, queuePos: queuePos, nowMs: nowMs, onOpen: onOpen, testId: testId })=>{
    const { t: t, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const waited = apt.status === 'arrived' ? (0, $13f800aa071fd2d2$export$8820bfcc7ef6bb39)(apt, nowMs) : null;
    const { elapsedMin: elapsedMin, level: level } = apt.status === 'in_visit' ? (0, $13f800aa071fd2d2$export$e38f5492dd7c5c53)(apt, nowMs) : {
        elapsedMin: null,
        level: 'normal'
    };
    const overChip = $539f61ab7b8a32ef$var$OVERRUN_CHIP[level];
    const name = (0, $13f800aa071fd2d2$export$c1de35a83862cf9)(apt) || t('today.row.unknownPatient');
    // A «ثبت سریع» row has no patient record to open — placeholderLabel carries
    // the name INSTEAD of patientId, and exactly one of the two is ever set. So
    // this card is not tappable: a link to nothing is worse than no link.
    const walkIn = !apt.patientId;
    const body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem',
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: '0.8125rem',
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            flexShrink: 0,
                            minWidth: '2.75rem'
                        },
                        dir: "ltr",
                        children: apt.time ? formatDigits(apt.time) : t('common.labels.none')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                        name: name,
                        src: apt.patient?.avatarUrl,
                        size: 32,
                        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: name
                            }),
                            apt.patient?.phone && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "ltr",
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    unicodeBidi: 'isolate',
                                    whiteSpace: 'nowrap'
                                },
                                children: formatDigits((0, $412e1a8a99c19c1a$exports).forDisplay(apt.patient.phone))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe44ad2ad7f0db99$export$2e2bcd8739ae039), {
                        status: apt.status
                    })
                ]
            }),
            (waited != null || elapsedMin != null || queuePos != null || walkIn) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.375rem',
                    marginTop: '0.5rem'
                },
                children: [
                    queuePos != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($539f61ab7b8a32ef$var$Chip, {
                        bg: queuePos === 1 ? (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).arrived.bg : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                        color: queuePos === 1 ? (0, $e7c165fb515b04ea$export$6881c75116d5bd6e).arrived.text : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                        children: queuePos === 1 ? t('today.queue.positionNext') : t('today.queue.position', {
                            position: queuePos
                        })
                    }),
                    waited != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($539f61ab7b8a32ef$var$Chip, {
                        bg: waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                        color: waited > (0, $13f800aa071fd2d2$export$ee8d39e3e546e43) ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039), {
                                size: 11,
                                strokeWidth: 2.4,
                                "aria-hidden": true
                            }),
                            (0, $e7459ce5155aabe1$export$6983ec1528bb4f57)(t, 'today.queue.waited', waited)
                        ]
                    }),
                    elapsedMin != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($539f61ab7b8a32ef$var$Chip, {
                        bg: overChip.bg,
                        color: overChip.color,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039), {
                                size: 11,
                                strokeWidth: 2.4,
                                "aria-hidden": true
                            }),
                            (0, $e7459ce5155aabe1$export$6983ec1528bb4f57)(t, 'today.queue.elapsed', elapsedMin)
                        ]
                    }),
                    walkIn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($539f61ab7b8a32ef$var$Chip, {
                        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                        children: t('today.row.walkIn')
                    })
                ]
            })
        ]
    });
    const style = {
        padding: '0.75rem',
        marginBottom: '0.5rem',
        borderRadius: '0.875rem'
    };
    if (walkIn) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: style,
        "data-testid": testId,
        children: body
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        onClick: ()=>onOpen?.(apt),
        role: "link",
        // The tap opens جلسهٔ درمان, so the accessible name has to say so — it
        // announced «باز کردن پرونده» while navigating to the visit workspace.
        "aria-label": t('today.row.visitFor', {
            name: name
        }),
        style: style,
        "data-testid": testId,
        children: body
    });
};
var $539f61ab7b8a32ef$export$2e2bcd8739ae039 = $539f61ab7b8a32ef$var$MobileAppointmentCard;



parcelRequire("acw62");







// The «نفر بعدی» hero (§4 ④).
//
// On the desktop this is an `Alert variant="info"` in the page flow. On a phone
// the single most important fact of the screen — who walks in next — gets the
// brand gradient and the top of the fold, because a glance is the whole
// interaction: §1's mobile job list opens with "glance at the day".
//
// `apt` comes from `buildDayModel().nextApt`, which is null off today and null
// with nobody waiting. This component never decides who is next — nor what they
// are coming FOR: `service` is read beside it (hooks/useNextService.js), and
// null renders as «ویزیت».
const $f8309d1f577904bb$var$MobileNextPatient = ({ apt: apt, service: service, onOpen: onOpen, onOpenVisit: onOpenVisit })=>{
    const { t: t, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (!apt) return null;
    const name = (0, $13f800aa071fd2d2$export$c1de35a83862cf9)(apt) || t('today.row.unknownPatient');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-testid": "today-next",
        style: {
            background: (0, $e7c165fb515b04ea$export$7deb2be06092489e),
            borderRadius: '1rem',
            padding: '0.875rem',
            color: '#fff',
            boxShadow: '0 6px 20px rgba(0,0,0,0.14)'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                        name: name,
                        src: apt.patient?.avatarUrl,
                        size: 40,
                        bg: "rgba(255,255,255,0.22)"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: '0.6875rem',
                                    color: 'rgba(255,255,255,0.75)'
                                },
                                children: t('today.next.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.9375rem',
                                    fontWeight: 800,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: name
                            }),
                            apt.time && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: '0.6875rem',
                                    color: 'rgba(255,255,255,0.8)'
                                },
                                children: t('today.next.at', {
                                    time: formatDigits(apt.time)
                                })
                            }),
                            apt.patientId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $239ffdcb18e03bab$export$2e2bcd8739ae039), {
                                service: service,
                                compact: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe44ad2ad7f0db99$export$2e2bcd8739ae039), {
                        status: apt.status
                    })
                ]
            }),
            apt.patientId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'grid',
                    gap: '0.5rem',
                    marginTop: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: ()=>onOpenVisit?.(apt),
                        "data-testid": "today-next-visit",
                        "aria-label": t('today.row.visitFor', {
                            name: name
                        }),
                        className: "w-full min-h-11 hover:bg-white/90",
                        style: {
                            background: '#fff',
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                            fontWeight: 800
                        },
                        children: t('today.row.visit')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        onClick: ()=>onOpen?.(apt),
                        "data-testid": "today-next-open",
                        "aria-label": t('today.row.openFor', {
                            name: name
                        }),
                        className: "w-full min-h-11 text-white hover:bg-white/25",
                        style: {
                            background: 'rgba(255,255,255,0.18)',
                            color: '#fff'
                        },
                        children: t('today.row.open')
                    })
                ]
            })
        ]
    });
};
var $f8309d1f577904bb$export$2e2bcd8739ae039 = $f8309d1f577904bb$var$MobileNextPatient;



parcelRequire("acw62");



const $45e53d65b3e0238c$export$156186cd9d0794 = ({ children: children, count: count, action: action, style: style })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            margin: '0 0 0.5rem',
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                style: {
                    margin: 0,
                    fontSize: '0.8125rem',
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: children
            }),
            count != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 700,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: count
            }),
            action && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    marginInlineStart: 'auto'
                },
                children: action
            })
        ]
    });
const $45e53d65b3e0238c$export$ca7697601dcd7803 = ({ onClick: onClick, testId: testId })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
        variant: "outline",
        onClick: onClick,
        "data-testid": testId,
        className: "w-full min-h-11",
        style: {
            marginTop: '0.5rem'
        },
        children: t('mobile.showMore')
    });
};
const $45e53d65b3e0238c$export$4f0e1e0c5eb41359 = ({ label: label, value: value, ltr: ltr })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const empty = value == null || value === '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'baseline',
            gap: '0.75rem',
            padding: '0.625rem 0',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: '0.75rem',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    flexShrink: 0
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                ...ltr && !empty ? {
                    dir: 'ltr'
                } : {},
                style: {
                    fontSize: '0.8125rem',
                    color: empty ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    marginInlineStart: 'auto',
                    textAlign: 'end',
                    minWidth: 0,
                    overflowWrap: 'anywhere',
                    ...ltr && !empty ? {
                        unicodeBidi: 'isolate'
                    } : {}
                },
                children: empty ? t('common.labels.none') : value
            })
        ]
    });
};
var $45e53d65b3e0238c$export$2e2bcd8739ae039 = $45e53d65b3e0238c$export$156186cd9d0794;



// امروز — THE MOBILE COCKPIT (DESIGN-CONCEPT-MOBILE §4).
//
// ┌──────────────────────────────────────┐
// │ ① MobileHeader (gradient) — PINNED    │  avatar · greeting · name
// │    └ DateNavigator (white-alpha card) │  ‹ | 🗓 شنبه، ۲۶ تیر | ›
// │ ② StatTiles — 4-up, riding the edge   │  امروز · اینجا · نوبت‌دار · انجام‌شده
// ├──────────────────────────────────────┤  ── the scroll starts here ──
// │ ③ Alert — only off today              │
// │ ④ MobileNextPatient (hero)            │
// │ ⑤ three sections of cards             │
// │ ⑥ the read-only note                  │
// │ [ BottomNav ]                          │
// └──────────────────────────────────────┘
//
// The header, the date navigator and the tiles are PINNED and the card list is
// what scrolls — §3.2's rule for a glanceable screen: "the day's numbers and
// the date navigator never leave the screen".
//
// NO quick actions in the header and NO sticky CTA. §3.2 and §10 are explicit
// that "a control that navigates nowhere is a defect, not a placeholder" — this
// screen writes nothing at all (booking, cancelling and queue order belong to
// the clinic desk), so a gradient CTA here would be a button with no server
// behind it. اعتبار now exists and IS a destination, but it belongs in the
// bottom bar with the other three, not as a shortcut on top of the day sheet:
// nothing about a day's appointments is a reason to go and buy پارسه.
// How many cards a section shows before «نمایش بیشتر».
const $52fd2e1a6fb3f591$var$PAGE = 5;
const $52fd2e1a6fb3f591$var$Section = ({ id: id, title: title, count: count, children: children, defaultOpen: defaultOpen = true, collapsible: collapsible })=>{
    const body = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            paddingTop: '0.25rem'
        },
        children: children
    });
    if (!collapsible) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        "data-testid": `today-section-${id}`,
        style: {
            marginBottom: '0.875rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                count: count,
                children: title
            }),
            body
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        "data-testid": `today-section-${id}`,
        style: {
            marginBottom: '0.875rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2358e3acbc4a7e55$export$2e2bcd8739ae039), {
            title: title,
            badge: count,
            defaultOpen: defaultOpen,
            children: body
        })
    });
};
/** One section's cards, capped and grown by an explicit expander (§4). */ const $52fd2e1a6fb3f591$var$CardList = ({ id: id, rows: rows, model: model, tick: tick, onOpen: onOpen })=>{
    const [shown, setShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($52fd2e1a6fb3f591$var$PAGE);
    // A new day (or a poll that shortened the list) must not leave a stale
    // "expanded to 20" behind.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>setShown($52fd2e1a6fb3f591$var$PAGE), [
        id,
        rows.length === 0
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            rows.slice(0, shown).map((apt)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $539f61ab7b8a32ef$export$2e2bcd8739ae039), {
                    apt: apt,
                    queuePos: model.queuePosOf.get(apt.id) ?? null,
                    nowMs: tick,
                    onOpen: onOpen,
                    testId: `today-row-${apt.id}`
                }, apt.id)),
            rows.length > shown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$ca7697601dcd7803), {
                onClick: ()=>setShown((n)=>n + $52fd2e1a6fb3f591$var$PAGE),
                testId: `today-more-${id}`
            })
        ]
    });
};
const $52fd2e1a6fb3f591$var$TodayMobile = ()=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { activeId: activeId } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const { me: me } = (0, $5bc9ff20f6a2b818$export$f637e1cf42d15a62)();
    // The `?date=` contract is the desktop's, verbatim — a link shared from a
    // phone opens the same day on a workstation.
    const rawDate = searchParams.get('date');
    const today = (0, $6e94fc1378f3a785$export$ceda478235320bf2)();
    const selected = (0, $6e94fc1378f3a785$export$33df4d54a0f76001).test(rawDate || '') ? rawDate : today;
    const isToday = selected === today;
    const setDay = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((iso)=>{
        const next = new URLSearchParams(searchParams);
        if (!iso || iso === (0, $6e94fc1378f3a785$export$ceda478235320bf2)()) next.delete('date');
        else next.set('date', iso);
        setSearchParams(next, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    const { appointments: appointments, queue: queue, loading: loading, error: error, reload: reload } = (0, $02315dbdc761d1d1$export$6d84255ad587f3b5)({
        date: selected,
        clinicId: activeId
    });
    const [tick, setTick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>Date.now());
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const timer = setInterval(()=>setTick(Date.now()), 30000);
        return ()=>clearInterval(timer);
    }, []);
    const model = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $13f800aa071fd2d2$export$ad1ae77322e9b4e5)({
            appointments: appointments,
            queue: queue,
            isToday: isToday,
            nowMin: (0, $6e94fc1378f3a785$export$9bf6380b18b1be8)(tick) ?? 0
        }), [
        appointments,
        queue,
        isToday,
        tick
    ]);
    // `counted`, not `dayApts` — the day sheet PLUS anyone in the room who is not
    // on it. lib/appointments.js:98-114 explains why the two differ; a tile
    // reading «اینجا ۰» above a populated waiting room is the screen
    // contradicting itself.
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $13f800aa071fd2d2$export$c8c7db9d09049583)(model.counted), [
        model.counted
    ]);
    const hasRows = model.counted.length > 0;
    // What the next patient is coming FOR. Read beside the day, on the PATIENT
    // changing rather than on the day poll — see hooks/useNextService.js.
    const nextService = (0, $caa1f9ee90604e7f$export$4599bdc3f357e9d6)({
        patientId: model.nextApt?.patientId || null,
        clinicId: activeId
    });
    // A day-sheet card has ONE tap target on this surface, so it opens the thing
    // the dentist came for: جلسهٔ درمان for THIS appointment. The patient's whole
    // record is one tap further in, from the visit header's own action — the
    // reverse of the desktop rail, which has room for both buttons on the row.
    //
    // A «ثبت سریع» walk-in has no patient record and the workspace cannot open on
    // one, so its card falls back to doing nothing rather than navigating to a
    // screen that would immediately render «جلسه یافت نشد».
    const openVisit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((apt)=>{
        if (apt?.id && apt?.patientId) navigate('visit', {
            appointmentId: apt.id
        });
    }, [
        navigate
    ]);
    // The hero is the exception to "one tap target": it has the room for the
    // second one, so «پرونده» there means the patient's record, as it does on the
    // desktop hero — not a second door onto the visit.
    const openRecord = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((apt)=>{
        if (apt?.patientId) navigate('patient', {
            id: apt.patientId
        });
    }, [
        navigate
    ]);
    // EXACTLY FOUR TILES, always (§4). The desktop's conditional fifth KPI
    // («لغو شده», rendered only when there are any) becomes a muted line under
    // the row — the 4-up rhythm is the design's signature and a row that is
    // sometimes five wide is a different component.
    const tiles = [
        {
            key: 'total',
            label: t('today.counts.total'),
            value: formatNumber(counts.total),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b56343e65588121$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true
            }),
            solid: true
        },
        {
            key: 'here',
            label: t('today.counts.here'),
            value: formatNumber(counts.here),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fe01e99f8f7285e$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true
            }),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
        },
        {
            key: 'scheduled',
            label: t('today.counts.scheduled'),
            value: formatNumber(counts.scheduled),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87513a585d30c268$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true
            }),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        },
        {
            key: 'completed',
            label: t('today.counts.completed'),
            value: formatNumber(counts.completed),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                size: 16,
                "aria-hidden": true
            }),
            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                        user: {
                            name: me?.fullName || ''
                        },
                        // The kit defaults `greeting` to a Persian literal; this app ships en.
                        greeting: t('mobile.greeting'),
                        "data-testid": "today-header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ac3bcac665682a$export$2e2bcd8739ae039), {
                            value: selected,
                            onChange: (v)=>setDay(v || today),
                            dateLabel: formatDate((0, $6e94fc1378f3a785$export$3537fc298e9336da)(selected), 'full'),
                            isToday: isToday,
                            onPrev: ()=>setDay((0, $6e94fc1378f3a785$export$c13cab26eb520a22)(selected, -1)),
                            onNext: ()=>setDay((0, $6e94fc1378f3a785$export$c13cab26eb520a22)(selected, 1)),
                            onToday: ()=>setDay(today),
                            prevLabel: t('today.date.prev'),
                            nextLabel: t('today.date.next'),
                            pickLabel: t('today.date.pick'),
                            todayLabel: t('today.date.today'),
                            sheetTitle: t('today.date.pick'),
                            closeLabel: t('mobile.close'),
                            "data-testid": "today-datenav"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            padding: '0 0.75rem',
                            marginTop: '-1rem',
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea4bc4a14affb445$export$2e2bcd8739ae039), {
                                tiles: tiles,
                                loading: loading,
                                "data-testid": "today-stats"
                            }),
                            counts.cancelled > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": "today-cancelled-line",
                                style: {
                                    marginTop: '0.375rem',
                                    fontSize: '0.6875rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    textAlign: 'center'
                                },
                                children: t('today.counts.cancelledLine', {
                                    count: counts.cancelled
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "today-content",
                "data-state": error ? 'error' : loading ? 'loading' : hasRows ? 'content' : 'empty',
                "aria-busy": loading || undefined,
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    // Clear of the bottom bar so the last card is never covered (§4).
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: error ? // The header and the date navigator stay MOUNTED and operable through
                // the failure (§7) — a failed day is one tap from a good one.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "alert",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                        title: t('today.error.title'),
                        description: t('errors.load.today'),
                        onRetry: reload,
                        retryLabel: t('common.actions.retry')
                    })
                }) : loading ? // The cockpit's OWN shape: the next-patient hero and the first
                // section of cards at their real size (§7 — never a spinner, never a
                // generic card stack). The pinned header and tiles above are real.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fa3e7ee1d1f83aa$export$f5df4f64a00ea7c5), {
                    label: t('common.loading')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        !isToday && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "info",
                            style: {
                                marginBottom: '0.875rem'
                            },
                            children: t('today.notice.liveQueue')
                        }),
                        !hasRows ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b56343e65588121$export$2e2bcd8739ae039), {
                                    size: 44,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                }),
                                title: t('today.empty.title'),
                                description: t('today.empty.description')
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8309d1f577904bb$export$2e2bcd8739ae039), {
                                    apt: model.nextApt,
                                    service: nextService,
                                    onOpen: openRecord,
                                    onOpenVisit: openVisit
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        marginTop: '0.875rem'
                                    },
                                    children: [
                                        model.roomQueue.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($52fd2e1a6fb3f591$var$Section, {
                                            id: "queue",
                                            title: t('today.blocks.queue'),
                                            count: formatNumber(model.roomQueue.length),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($52fd2e1a6fb3f591$var$CardList, {
                                                id: "queue",
                                                rows: model.roomQueue,
                                                model: model,
                                                tick: tick,
                                                onOpen: openVisit
                                            })
                                        }),
                                        model.upcoming.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($52fd2e1a6fb3f591$var$Section, {
                                            id: "upcoming",
                                            title: t('today.blocks.upcoming'),
                                            count: formatNumber(model.upcoming.length),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($52fd2e1a6fb3f591$var$CardList, {
                                                id: "upcoming",
                                                rows: model.upcoming,
                                                model: model,
                                                tick: tick,
                                                onOpen: openVisit
                                            })
                                        }),
                                        model.done.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($52fd2e1a6fb3f591$var$Section, {
                                            id: "done",
                                            title: t('today.blocks.done'),
                                            count: formatNumber(model.done.length),
                                            collapsible: true,
                                            defaultOpen: model.roomQueue.length === 0 && model.upcoming.length === 0,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($52fd2e1a6fb3f591$var$CardList, {
                                                id: "done",
                                                rows: model.done,
                                                model: model,
                                                tick: tick,
                                                onOpen: openVisit
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '0.5rem',
                                marginTop: '1rem',
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                fontSize: '0.6875rem',
                                lineHeight: 1.8
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba16dd414953e5a4$export$2e2bcd8739ae039), {
                                    size: 14,
                                    style: {
                                        flexShrink: 0,
                                        marginTop: '0.125rem'
                                    },
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t('today.readOnlyNote')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $52fd2e1a6fb3f591$export$2e2bcd8739ae039 = $52fd2e1a6fb3f591$var$TodayMobile;


// امروز — two surfaces, one behaviour.
//
// ≤768px gets the mobile COCKPIT (DESIGN-CONCEPT-MOBILE §4) and NOT the desktop
// page reflowed: the gradient header with the date navigator inside it, the 4-up
// stat row riding its edge, and tappable cards instead of a nine-child flex row
// with a hover-repainted background.
//
// Both surfaces read the same `useToday` + `buildDayModel` + `dayCounts`, so
// they can look nothing alike and still can never disagree about who is next
// (§1.1: "the two surfaces may look nothing alike but must never disagree").
const $2d82b9c575211bc6$var$TodayScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52fd2e1a6fb3f591$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $12c6ee8e8eac267c$export$2e2bcd8739ae039), {});
};
var $2d82b9c575211bc6$export$2e2bcd8739ae039 = $2d82b9c575211bc6$var$TodayScreen;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");







// بیماران — the clinic's patient register, paged and searched server-side.
//
// Real paging from day one: the BFF returns { patients, total, limit, offset }
// and caps limit at 100. The doctor app hardcodes limit:100/offset:0 and throws
// `total_count` away, so its list silently stops at a hundred patients — a
// clinic of any size never sees the rest.
//
// Search is DB-side (name / phone / national id / file number) and, when the
// query is clinic-scoped, file-number matching is scoped too — so clinic A's
// «۱۲» can never surface clinic B's patient.

var $acw62 = parcelRequire("acw62");

// Offset paging arithmetic, in one place.
//
// The BFF's `patients` query returns { total, limit, offset } and caps limit at
// 100. The screen thinks in 1-based pages (that is what the pager renders) and
// the wire thinks in offsets, so the conversion happens here rather than being
// re-derived at three call sites with three different off-by-ones.
const $76567e4e635dac59$export$5716e8bcb003888d = 25;
function $76567e4e635dac59$export$7804ac8eb5cfa918(total, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const size = Number(limit) > 0 ? Number(limit) : $76567e4e635dac59$export$5716e8bcb003888d;
    return Math.max(1, Math.ceil((Number(total) || 0) / size));
}
function $76567e4e635dac59$export$37065cd88a320a11(page, total, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const n = Math.floor(Number(page));
    if (!Number.isFinite(n) || n < 1) return 1;
    return Math.min(n, $76567e4e635dac59$export$7804ac8eb5cfa918(total, limit));
}
function $76567e4e635dac59$export$bfb063dcf959468d(page, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const n = Math.floor(Number(page));
    const size = Number(limit) > 0 ? Number(limit) : $76567e4e635dac59$export$5716e8bcb003888d;
    return Math.max(0, (Number.isFinite(n) && n > 0 ? n - 1 : 0) * size);
}
function $76567e4e635dac59$export$b6fa4c60b3a546ad(offset, limit = $76567e4e635dac59$export$5716e8bcb003888d) {
    const size = Number(limit) > 0 ? Number(limit) : $76567e4e635dac59$export$5716e8bcb003888d;
    const off = Number(offset);
    if (!Number.isFinite(off) || off <= 0) return 1;
    return Math.floor(off / size) + 1;
}


const $f46579689a7664d0$export$9df4c4caac87ccb3 = `
  query Patients($clinicId: ID, $search: String, $limit: Int, $offset: Int) {
    patients(clinicId: $clinicId, search: $search, limit: $limit, offset: $offset) {
      total
      limit
      offset
      patients {
        id
        name
        phone
        nationalId
        fileNumber
        gender
        age
        createdAt
        avatarUrl
      }
    }
  }
`;
function $f46579689a7664d0$export$560b468408f8295e({ clinicId: clinicId, search: search, page: page = 1, pageSize: pageSize = (0, $76567e4e635dac59$export$5716e8bcb003888d) }) {
    const [patients, setPatients] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [total, setTotal] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        if (!clinicId) {
            setPatients([]);
            setTotal(0);
            setLoading(false);
            setError(null);
            return ()=>{
                alive = false;
            };
        }
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($f46579689a7664d0$export$9df4c4caac87ccb3, {
            clinicId: clinicId,
            search: search || null,
            limit: pageSize,
            offset: (0, $76567e4e635dac59$export$bfb063dcf959468d)(page, pageSize)
        }).then((data)=>{
            if (!alive) return;
            setPatients(data?.patients?.patients || []);
            setTotal(data?.patients?.total || 0);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[usePatients] failed:', (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) || err?.message);
            setError(err);
            // A failed read must replace the list with an error state, never fall
            // through to an empty one: "no patients" and "we could not ask" are
            // different facts and only one of them means "register someone".
            setPatients([]);
            setTotal(0);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        clinicId,
        search,
        page,
        pageSize,
        nonce
    ]);
    return {
        patients: patients,
        total: total,
        loading: loading,
        error: error,
        reload: ()=>setNonce((n)=>n + 1)
    };
}
var $f46579689a7664d0$export$2e2bcd8739ae039 = $f46579689a7664d0$export$560b468408f8295e;





// بیماران — the clinic's register, not a dental register. A patient is not
// "dental" or "medical" (DESIGN.md §2): this is the same list the منشی enrols
// into at پذیرش, read through the same service.
//
// The list is CLINIC-SCOPED OR EMPTY, never unscoped. patientmanagement ignores
// the doctor_id filter entirely — only clinic_id and search narrow anything —
// so a call without a clinic returns the platform's whole registry. A dentist
// with no membership gets the "join a clinic" state instead of a request.
const $f41bc4c36c7784ab$var$PatientsScreen = ()=>{
    const { t: t, formatNumber: formatNumber, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { loading: clinicsLoading, activeId: activeId, scopeState: scopeState } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const urlQuery = searchParams.get('q') || '';
    const urlPage = Number(searchParams.get('page')) || 1;
    // Keystrokes echo locally at once and reach the URL after a pause, so typing
    // neither stalls the field nor stacks a history entry per character.
    const [typed, setTyped] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(urlQuery);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>setTyped(urlQuery), [
        urlQuery
    ]);
    const commit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value)=>{
        const next = new URLSearchParams(searchParams);
        if (value) next.set('q', value);
        else next.delete('q');
        next.delete('page'); // a new search starts at page one
        setSearchParams(next, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const trimmed = typed.trim();
        if (trimmed === urlQuery) return undefined;
        // Clearing commits immediately: waiting 300 ms to show the full list again
        // reads as a broken clear button.
        if (!trimmed) {
            commit('');
            return undefined;
        }
        if (trimmed.length < (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86)) return undefined;
        const timer = setTimeout(()=>commit(trimmed), 300);
        return ()=>clearTimeout(timer);
    }, [
        typed,
        urlQuery,
        commit
    ]);
    const { patients: patients, total: total, loading: loading, error: error, reload: reload } = (0, $f46579689a7664d0$export$560b468408f8295e)({
        clinicId: activeId,
        search: (0, $2e1381078ec7f76f$export$83ab5e31da45bcb4)(urlQuery),
        page: urlPage,
        pageSize: (0, $76567e4e635dac59$export$5716e8bcb003888d)
    });
    // Membership resolves BEFORE the register can be asked for, and until it does
    // there is no honest answer to «how many patients». Without this the screen
    // rendered «هنوز بیماری ثبت نشده است» for the first frames of every visit:
    // clinicsLoading leaves `noClinic` false, and usePatients with a null clinicId
    // returns loading:false + an empty page by design — so a dentist with a full
    // register was told they had none, and then the list appeared underneath it.
    const busy = clinicsLoading || loading;
    const page = (0, $76567e4e635dac59$export$37065cd88a320a11)(urlPage, total, (0, $76567e4e635dac59$export$5716e8bcb003888d));
    const goPage = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        const params = new URLSearchParams(searchParams);
        if (next <= 1) params.delete('page');
        else params.set('page', String(next));
        setSearchParams(params);
    }, [
        searchParams,
        setSearchParams
    ]);
    // The URL is what the hook actually pages on, so a hand-edited `?page=999`
    // would otherwise fetch offset 24950 — an empty table — while the pager below
    // rendered the clamped page and quietly disagreed with it. Once `total` is
    // known, put the URL back inside range and let the refetch follow.
    //
    // `busy`, not `loading`: while membership is still resolving `total` is 0, so
    // pageCount is 1 and a deep link to `?page=3` would be rewritten to page one
    // before the register had been asked for even once.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (busy || error) return;
        if (page !== urlPage) goPage(page);
    }, [
        busy,
        error,
        page,
        urlPage,
        goPage
    ]);
    const columns = [
        {
            key: 'name',
            header: t('patients.columns.name'),
            render: (row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                            name: row.name,
                            src: row.avatarUrl,
                            size: 30,
                            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    onClick: (e)=>{
                                        // The <tr> handler would fire too and push a second identical
                                        // history entry.
                                        e.stopPropagation();
                                        navigate('patient', {
                                            id: row.id
                                        });
                                    },
                                    style: {
                                        display: 'block',
                                        maxWidth: '100%',
                                        background: 'none',
                                        border: 'none',
                                        padding: 0,
                                        margin: 0,
                                        font: 'inherit',
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                        textAlign: 'start',
                                        cursor: 'pointer',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: row.name
                                }),
                                (row.gender || row.age != null) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: [
                                        (0, $2e1381078ec7f76f$export$c58a664d6aae39f0)(row.gender) ? t((0, $2e1381078ec7f76f$export$c58a664d6aae39f0)(row.gender)) : row.gender || '',
                                        row.age != null ? t('common.units.years', {
                                            count: row.age
                                        }) : ''
                                    ].filter(Boolean).join(" \xb7 ")
                                })
                            ]
                        })
                    ]
                })
        },
        {
            key: 'phone',
            header: t('patients.columns.phone'),
            width: 150,
            render: (row)=>row.phone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "ltr",
                    style: {
                        unicodeBidi: 'isolate'
                    },
                    children: formatDigits((0, $412e1a8a99c19c1a$exports).forDisplay(row.phone))
                }) : t('common.labels.none')
        },
        {
            key: 'fileNumber',
            header: t('patients.columns.fileNumber'),
            width: 120,
            render: (row)=>row.fileNumber ? formatDigits(row.fileNumber) : t('common.labels.none')
        },
        {
            key: 'nationalId',
            header: t('patients.columns.nationalId'),
            width: 140,
            render: (row)=>row.nationalId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    dir: "ltr",
                    style: {
                        unicodeBidi: 'isolate'
                    },
                    children: formatDigits(row.nationalId)
                }) : t('common.labels.none')
        }
    ];
    // ── No USABLE clinic → no register. Said plainly, with the way out. ───────
    //
    // Two different facts, and they need two different sentences. `scopeState`
    // is the shared rule (lib/patients.js), the same one the BFF's patientScope
    // applies server-side:
    //
    //   'none'     no membership at all — join one with an invitation code.
    //   'pending'  joined, not yet accepted. Counting a pending membership as a
    //              clinic was the bug: `activeId` became its id, every query was
    //              scoped to a clinic the BFF refuses (CLINIC_FORBIDDEN), and the
    //              dentist got a retry button for something no retry can fix.
    const noClinic = !clinicsLoading && scopeState === 'none';
    const pendingClinic = !clinicsLoading && scopeState === 'pending';
    const blocked = noClinic || pendingClinic;
    const trimmedTyped = typed.trim();
    const tooShort = trimmedTyped.length > 0 && trimmedTyped.length < (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('patients.title'),
                sub: t('patients.subtitle'),
                children: !blocked && !busy && !error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: 12.5,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    },
                    children: t('patients.count', {
                        count: total
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '24px 32px 40px'
                },
                children: blocked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df82e729d4b50e19$export$2e2bcd8739ae039), {
                            size: 48,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        }),
                        title: t(pendingClinic ? 'patients.pendingClinic.title' : 'patients.noClinic.title'),
                        description: t(pendingClinic ? 'patients.pendingClinic.description' : 'patients.noClinic.description'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: ()=>navigate('profile'),
                            children: t('patients.noClinic.action')
                        })
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                            style: {
                                marginBottom: 14,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                                    value: typed,
                                    onChange: (e)=>setTyped(e.target.value),
                                    placeholder: t('patients.search.placeholder'),
                                    "aria-label": t('patients.search.placeholder'),
                                    clearLabel: t('common.actions.clearFilters'),
                                    // The kit hardcodes dir="rtl" on its <input>. This field accepts
                                    // «علی», "Ali", a phone number and a file number, and a Latin or
                                    // digit run typed into a forced-RTL box has its caret and its
                                    // punctuation reordered. `dir="auto"` follows the first strong
                                    // character the dentist actually types, which is the one rule
                                    // that is right for all four. `inputProps` is the escape hatch
                                    // the kit provides — it spreads last, so it wins.
                                    inputProps: {
                                        dir: 'auto'
                                    },
                                    style: {
                                        flex: 1,
                                        minWidth: 220,
                                        maxWidth: 420
                                    }
                                }),
                                tooShort && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: t('patients.search.hint')
                                }),
                                urlQuery && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "subtle",
                                    onClick: ()=>setTyped(''),
                                    children: t('common.actions.clearFilters')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-testid": "patients-content",
                            "data-state": error ? 'error' : busy ? 'loading' : patients.length ? 'content' : 'empty',
                            "aria-busy": busy || undefined,
                            children: error ? // role="alert" on the wrapper: the kit's Card drops a `role`
                            // unless it is the onClick (button) form.
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "alert",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                        title: t('patients.error.title'),
                                        description: t('errors.load.patients'),
                                        onRetry: reload,
                                        retryLabel: t('common.actions.retry')
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                style: {
                                    padding: 0,
                                    overflow: 'hidden'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $82e7212e133be19c$export$2e2bcd8739ae039), {
                                        loading: busy,
                                        skeletonRows: 8,
                                        columns: columns,
                                        rows: patients,
                                        rowKey: (row)=>row.id,
                                        onRowClick: (row)=>navigate('patient', {
                                                id: row.id
                                            }),
                                        empty: // A filtered empty list and a genuinely empty register are
                                        // different facts, and only one of them means "register
                                        // someone".
                                        urlQuery ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df82e729d4b50e19$export$2e2bcd8739ae039), {
                                                size: 44,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            }),
                                            title: t('patients.emptyFiltered.title'),
                                            description: t('patients.emptyFiltered.description'),
                                            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                onClick: ()=>setTyped(''),
                                                children: t('common.actions.clearFilters')
                                            })
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df82e729d4b50e19$export$2e2bcd8739ae039), {
                                                size: 44,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            }),
                                            title: t('patients.empty.title'),
                                            description: t('patients.empty.description')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7bca3244df749c49$export$2e2bcd8739ae039), {
                                        page: page,
                                        total: total,
                                        pageSize: (0, $76567e4e635dac59$export$5716e8bcb003888d),
                                        onChange: goPage
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $f41bc4c36c7784ab$export$2e2bcd8739ae039 = $f41bc4c36c7784ab$var$PatientsScreen;




var $acw62 = parcelRequire("acw62");











parcelRequire("acw62");





// One register row as a mobile card.
//
// The desktop surface is the kit `Table` — four columns, a sticky header and a
// per-row name button, because a workstation reads a register by column. A
// phone cannot show four columns at 320px without either truncating every one
// of them or scrolling sideways, so the same four facts stack: identity on the
// first line, the two identifiers on the second.
//
// The WHOLE card is the tap target — the kit `Card`'s onClick form, a real
// <button> with `role="link"` because the tap navigates. The desktop's
// mouse-only `<tr onClick>` (the bug patientsRegister.test.jsx pins) cannot
// recur here: there is no row, only a button.
const $639579a43dea71c2$var$MobilePatientCard = ({ patient: patient, onOpen: onOpen, testId: testId })=>{
    const { t: t, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const gKey = (0, $2e1381078ec7f76f$export$c58a664d6aae39f0)(patient.gender);
    const sub = [
        gKey ? t(gKey) : patient.gender || '',
        patient.age != null ? t('common.units.years', {
            count: patient.age
        }) : ''
    ].filter(Boolean).join(" \xb7 ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        onClick: ()=>onOpen?.(patient),
        role: "link",
        "aria-label": t('today.row.openFor', {
            name: patient.name
        }),
        "data-testid": testId,
        style: {
            padding: '0.75rem',
            marginBottom: '0.5rem',
            borderRadius: '0.875rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem',
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                        name: patient.name,
                        src: patient.avatarUrl,
                        size: 36,
                        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            minWidth: 0,
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.875rem',
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: patient.name
                            }),
                            sub && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: sub
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '0.75rem',
                    marginTop: '0.5rem',
                    fontSize: '0.6875rem',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            t('common.labels.phone'),
                            ': ',
                            patient.phone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                dir: "ltr",
                                style: {
                                    unicodeBidi: 'isolate'
                                },
                                children: formatDigits((0, $412e1a8a99c19c1a$exports).forDisplay(patient.phone))
                            }) : t('common.labels.none')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            marginInlineStart: 'auto'
                        },
                        children: [
                            t('common.labels.fileNumber'),
                            `${t('common.punct.colon')} `,
                            patient.fileNumber ? formatDigits(patient.fileNumber) : t('common.labels.none')
                        ]
                    })
                ]
            })
        ]
    });
};
var $639579a43dea71c2$export$2e2bcd8739ae039 = $639579a43dea71c2$var$MobilePatientCard;




parcelRequire("acw62");


// بیماران — the loading shape of the register.
//
// Only the MOBILE list skeletons: the page header and the search card are real
// chrome that stays operable while the first page loads (DESIGN.md §"Loading &
// skeleton", "Region load"). A later page never comes through here at all —
// the rows stay on screen and dim (§7, stale-while-refetch).
//
// The desktop has no skeleton of its own any more: it renders the REAL `Table`
// with `loading`, so the header, the four column widths and the sort chrome are
// the real ones and only the body is placeholder. See Patients.web.jsx.
/** MobilePatientCard: 36px avatar · name/sub · a phone/file-number meta row. */ const $473d92b5d5894c98$var$MobileRowSkeleton = ({ i: i })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        "aria-hidden": true,
        style: {
            padding: '0.75rem',
            marginBottom: '0.5rem',
            borderRadius: '0.875rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.625rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$53c2c5a35a7e31a2), {
                        size: 36
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: `${40 + i * 17 % 35}%`,
                                height: 14
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: "30%",
                                height: 11
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 110,
                        height: 11
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 72,
                        height: 11
                    })
                ]
            })
        ]
    });
const $473d92b5d5894c98$export$4948d30d9050f5d9 = ({ label: label, rows: rows = 6 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "patients-skeleton",
        children: Array.from({
            length: rows
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($473d92b5d5894c98$var$MobileRowSkeleton, {
                i: i
            }, i))
    });


// بیماران — the mobile register (a top-level bottom-nav destination).
//
// ┌──────────────────────────────────────┐
// │ ① MobileHeader — title + count        │  scrolls away (§3.2, content screen)
// │ ② SearchInput — STICKY under it       │  the one inline control (§4B)
// │ ③ one card per patient                │  whole card taps into the record
// │ ④ «نمایش بیشتر»                        │  accumulates; never a desktop Pager
// │ [ BottomNav ]                          │
// └──────────────────────────────────────┘
//
// The desktop `Pager` is a row of 34px buttons — below the 2.75rem floor (§6) —
// and §4 rules out infinite scroll, so the list grows through an explicit
// expander. The `?page=` param still advances as it grows, so a refresh
// restores how far the dentist got, and `clampPage` still guards a hand-edited
// value.
//
// Everything about SCOPE is the desktop's, unchanged and load-bearing: no
// membership and pending membership are two different sentences, and `busy`
// (membership + list) is what stops «هنوز بیماری ثبت نشده» painting over a
// register that simply has not been asked for yet.
const $34ccae04bdd17fac$var$PatientsMobile = ()=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { loading: clinicsLoading, activeId: activeId, scopeState: scopeState } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const urlQuery = searchParams.get('q') || '';
    const urlPage = Number(searchParams.get('page')) || 1;
    const [typed, setTyped] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(urlQuery);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>setTyped(urlQuery), [
        urlQuery
    ]);
    const commit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value)=>{
        const next = new URLSearchParams(searchParams);
        if (value) next.set('q', value);
        else next.delete('q');
        next.delete('page');
        setSearchParams(next, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    // The desktop's debounce, verbatim: 300 ms, and a CLEAR commits immediately
    // because waiting to show the full list again reads as a broken clear button.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const trimmed = typed.trim();
        if (trimmed === urlQuery) return undefined;
        if (!trimmed) {
            commit('');
            return undefined;
        }
        if (trimmed.length < (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86)) return undefined;
        const timer = setTimeout(()=>commit(trimmed), 300);
        return ()=>clearTimeout(timer);
    }, [
        typed,
        urlQuery,
        commit
    ]);
    const { patients: patients, total: total, loading: loading, error: error, reload: reload } = (0, $f46579689a7664d0$export$560b468408f8295e)({
        clinicId: activeId,
        search: (0, $2e1381078ec7f76f$export$83ab5e31da45bcb4)(urlQuery),
        page: urlPage,
        pageSize: (0, $76567e4e635dac59$export$5716e8bcb003888d)
    });
    const busy = clinicsLoading || loading;
    const page = (0, $76567e4e635dac59$export$37065cd88a320a11)(urlPage, total, (0, $76567e4e635dac59$export$5716e8bcb003888d));
    // The accumulated list. A phone reads a register by scrolling, so page 2 is
    // APPENDED rather than replacing page 1 — but the pages themselves are the
    // desktop's, server-side, 25 at a time.
    //
    // Keyed on (clinic, query): changing either is a different register and the
    // accumulation has to start over, or the dentist sees clinic A's page 2 under
    // clinic B's page 1.
    const listKey = `${activeId || ''}|${urlQuery}`;
    const [acc, setAcc] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        key: listKey,
        rows: []
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setAcc((prev)=>{
            if (prev.key !== listKey) return {
                key: listKey,
                rows: []
            };
            return prev;
        });
    }, [
        listKey
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (busy || error) return;
        setAcc((prev)=>{
            const base = prev.key === listKey ? prev.rows : [];
            const seen = new Set(base.map((p)=>p.id));
            const merged = [
                ...base,
                ...patients.filter((p)=>!seen.has(p.id))
            ];
            // Identical content must not produce a new array, or this effect loops.
            if (merged.length === base.length && prev.key === listKey) return prev;
            return {
                key: listKey,
                rows: merged
            };
        });
    }, [
        patients,
        busy,
        error,
        listKey
    ]);
    const rows = acc.key === listKey ? acc.rows : [];
    const hasMore = page < (0, $76567e4e635dac59$export$7804ac8eb5cfa918)(total, (0, $76567e4e635dac59$export$5716e8bcb003888d));
    const loadMore = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const params = new URLSearchParams(searchParams);
        params.set('page', String(page + 1));
        // NOT `replace`: «نمایش بیشتر» is a step the back button should undo, the
        // same way the desktop pager's next-page is.
        setSearchParams(params);
    }, [
        page,
        searchParams,
        setSearchParams
    ]);
    const noClinic = !clinicsLoading && scopeState === 'none';
    const pendingClinic = !clinicsLoading && scopeState === 'pending';
    const blocked = noClinic || pendingClinic;
    const trimmedTyped = typed.trim();
    const tooShort = trimmedTyped.length > 0 && trimmedTyped.length < (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86);
    // The first page is a skeleton; a LATER page keeps the rows on screen and
    // dims (§7: "stale-while-refetch dims, never blanks").
    const firstLoad = busy && rows.length === 0;
    return(// ONE scroll region, and the header is INSIDE it: §3.2 lets a content
    // screen's header scroll away — content wins the viewport, chrome does not.
    // What stays is the search field, which is sticky at the top of this same
    // scroller.
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "patients-content",
        "data-state": error ? 'error' : firstLoad ? 'loading' : rows.length ? 'content' : 'empty',
        "aria-busy": busy || undefined,
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                title: t('patients.title'),
                subtitle: !blocked && !busy && !error ? t('patients.count', {
                    count: total
                }) : undefined,
                "data-testid": "patients-header"
            }),
            blocked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df82e729d4b50e19$export$2e2bcd8739ae039), {
                            size: 44,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        }),
                        title: t(pendingClinic ? 'patients.pendingClinic.title' : 'patients.noClinic.title'),
                        description: t(pendingClinic ? 'patients.pendingClinic.description' : 'patients.noClinic.description'),
                        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            className: "min-h-11",
                            onClick: ()=>navigate('profile'),
                            children: t('patients.noClinic.action')
                        })
                    })
                })
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                            padding: '0.75rem',
                            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                                value: typed,
                                onChange: (e)=>setTyped(e.target.value),
                                placeholder: t('patients.search.placeholder'),
                                "aria-label": t('patients.search.placeholder'),
                                clearLabel: t('common.actions.clearFilters'),
                                // The kit hardcodes dir="rtl" on its <input>. This field accepts
                                // «علی», "Ali", a phone number and a file number, and a Latin or
                                // digit run typed into a forced-RTL box has its caret and its
                                // punctuation reordered. `inputProps` spreads last, so it wins.
                                // `fontSize: 1rem` is the iOS focus-zoom floor (§6).
                                inputProps: {
                                    dir: 'auto',
                                    style: {
                                        fontSize: '1rem'
                                    }
                                },
                                "data-testid": "patients-search",
                                style: {
                                    width: '100%'
                                }
                            }),
                            tooShort && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: '0.375rem',
                                    fontSize: '0.6875rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('patients.search.hint')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            flex: 1,
                            padding: '0.75rem 0.75rem 1.5rem'
                        },
                        children: error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            role: "alert",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                title: t('patients.error.title'),
                                description: t('errors.load.patients'),
                                onRetry: reload,
                                retryLabel: t('common.actions.retry')
                            })
                        }) : firstLoad ? // Patient-card-shaped rows, not a generic card stack: the
                        // register's own shape, so nothing shifts when the page lands.
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473d92b5d5894c98$export$4948d30d9050f5d9), {
                            label: t('common.loading')
                        }) : rows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                            children: urlQuery ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df82e729d4b50e19$export$2e2bcd8739ae039), {
                                    size: 44,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                }),
                                title: t('patients.emptyFiltered.title'),
                                description: t('patients.emptyFiltered.description'),
                                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    className: "min-h-11",
                                    onClick: ()=>setTyped(''),
                                    children: t('common.actions.clearFilters')
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df82e729d4b50e19$export$2e2bcd8739ae039), {
                                    size: 44,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                }),
                                title: t('patients.empty.title'),
                                description: t('patients.empty.description')
                            })
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                opacity: busy ? 0.6 : 1,
                                transition: 'opacity .15s'
                            },
                            children: [
                                rows.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $639579a43dea71c2$export$2e2bcd8739ae039), {
                                        patient: p,
                                        onOpen: ()=>navigate('patient', {
                                                id: p.id
                                            }),
                                        testId: `patients-row-${p.id}`
                                    }, p.id)),
                                hasMore && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$ca7697601dcd7803), {
                                    onClick: loadMore,
                                    testId: "patients-more"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        marginTop: '0.75rem',
                                        textAlign: 'center',
                                        fontSize: '0.6875rem',
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: t('patients.count', {
                                        count: total
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
var $34ccae04bdd17fac$export$2e2bcd8739ae039 = $34ccae04bdd17fac$var$PatientsMobile;


// بیماران — two surfaces, one register.
//
// The desktop is a four-column kit `Table` with a `Pager`; the phone is a list
// of tappable cards that grows through «نمایش بیشتر» (§4 — never infinite
// scroll, and never a row of 34px pager buttons on a touch screen).
//
// Both read the same `usePatients` at the same `DEFAULT_PAGE_SIZE`, apply the
// same `searchTerm`/`MIN_SEARCH_LENGTH` and honour the same `?q=`/`?page=` URL
// contract — so a link opened on either device shows the same patients.
const $87056e061dab16ec$var$PatientsScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34ccae04bdd17fac$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f41bc4c36c7784ab$export$2e2bcd8739ae039), {});
};
var $87056e061dab16ec$export$2e2bcd8739ae039 = $87056e061dab16ec$var$PatientsScreen;




var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ed00022cb253e04b$export$a2387ed3b5d536eb = {
    name: "user-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                key: "1yyitq"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "7",
                r: "4",
                key: "nufk8"
            }
        ],
        [
            "line",
            {
                x1: "17",
                x2: "22",
                y1: "8",
                y2: "13",
                key: "3nzzx3"
            }
        ],
        [
            "line",
            {
                x1: "22",
                x2: "17",
                y1: "8",
                y2: "13",
                key: "1swrse"
            }
        ]
    ]
};
$ed00022cb253e04b$export$a2387ed3b5d536eb.node;
const $ed00022cb253e04b$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($ed00022cb253e04b$export$a2387ed3b5d536eb);






// One patient record.
//
// ONE query, not four. `allergies`, `conditions` and `medications` are
// selected-only sub-reads on the BFF's Patient type: each costs an extra RPC,
// but they are issued inside a single GraphQL request and every one of them
// degrades to [] on failure — so a formulary hiccup cannot blank the record's
// demographics.
//
// clinicId is passed so شمارهٔ پرونده is filled in: a file number belongs to a
// (clinic, patient) pair, and GetPatient on its own has no way to know which
// clinic is asking.

var $acw62 = parcelRequire("acw62");

const $781cda2ad75d5a69$export$ea6696695dab3a10 = `
  query PatientRecord($id: ID!, $clinicId: ID) {
    patient(id: $id, clinicId: $clinicId) {
      id
      name
      phone
      nationalId
      birthDate
      age
      gender
      maritalStatus
      bloodType
      job
      insurance
      height
      createdAt
      fileNumber
      avatarUrl
      allergies { id allergen reaction severity status createdAt }
      conditions { id code display clinicalStatus verificationStatus onsetDate createdAt }
      medications { id code display status authoredOn dosageInstruction endDate appointmentId }
    }
  }
`;
function $781cda2ad75d5a69$export$9b570c45914f833c(id, clinicId) {
    const [patient, setPatient] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!id) {
            setLoading(false);
            return undefined;
        }
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($781cda2ad75d5a69$export$ea6696695dab3a10, {
            id: id,
            clinicId: clinicId || null
        }).then((data)=>{
            if (!alive) return;
            // `null` here is NOT_FOUND, which the screen renders as its own state —
            // it is not an error and must not offer a retry button.
            setPatient(data?.patient || null);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[usePatient] failed:', err?.message);
            setError(err);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        id,
        clinicId,
        nonce
    ]);
    return {
        patient: patient,
        loading: loading,
        error: error,
        reload: ()=>setNonce((n)=>n + 1)
    };
}
var $781cda2ad75d5a69$export$2e2bcd8739ae039 = $781cda2ad75d5a69$export$9b570c45914f833c;




parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");



// A titled panel: the kit's `Card` plus a heading row.
//
// This is COMPOSITION, not a re-implementation — `SectionCard` in the kit is a
// numbered step in a multi-step form, and `CollapsibleSection` is a disclosure.
// Neither is "a card with a title", which is what a read-only record section is.
// Everything visual still comes from the kit's Card and from tokens.
const $ca14abae17ea5b4d$var$Panel = ({ title: title, action: action, children: children, style: style, collapsible: /**
   * Turn the heading into a disclosure.
   *
   * The visit workspace needs this on the phone: its three persistent sections
   * are stacked in one scroll there, and three expanded ones show none of them.
   * It belongs HERE rather than in a wrapper because a `CollapsibleSection`
   * around a Panel renders the title TWICE — the wrapper's and the Panel's own.
   *
   * `collapsible` is opt-in and the default is unchanged, so every existing
   * Panel keeps its plain heading.
   */ collapsible = false, defaultOpen: defaultOpen = true, ...rest })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(defaultOpen);
    const bodyId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const shown = collapsible ? open : true;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: 0,
            overflow: 'hidden',
            ...style
        },
        ...rest,
        children: [
            (title || action) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '14px 20px',
                    borderBottom: shown ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
                },
                children: [
                    title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        style: {
                            margin: 0,
                            fontSize: 14,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: collapsible ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            "aria-expanded": open,
                            "aria-controls": bodyId,
                            onClick: ()=>setOpen((o)=>!o),
                            style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 6,
                                minHeight: 44,
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                margin: 0,
                                font: 'inherit',
                                color: 'inherit',
                                cursor: 'pointer'
                            },
                            children: [
                                title,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true,
                                    style: {
                                        transform: open ? 'rotate(180deg)' : 'none',
                                        transition: 'transform .15s'
                                    }
                                })
                            ]
                        }) : title
                    }),
                    action && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            marginInlineStart: 'auto'
                        },
                        children: action
                    })
                ]
            }),
            shown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: bodyId,
                style: {
                    padding: '16px 20px'
                },
                children: children
            })
        ]
    });
};
var $ca14abae17ea5b4d$export$2e2bcd8739ae039 = $ca14abae17ea5b4d$var$Panel;



// خلاصه — who this patient is, and what they are allergic to.
//
// Allergies are given their own panel and their own banner rather than being a
// row in the details grid: they are the one fact on this screen that changes
// what may be prescribed on the next one.
const $353d784267d31267$var$Field = ({ label: label, value: value })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    fontWeight: 600,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    marginBottom: 3
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 13.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    overflowWrap: 'anywhere'
                },
                children: value || t('common.labels.none')
            })
        ]
    });
};
const $353d784267d31267$var$Ltr = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        dir: "ltr",
        style: {
            unicodeBidi: 'isolate'
        },
        children: children
    });
const $353d784267d31267$var$SummaryTab = ({ patient: patient })=>{
    const { t: t, formatNumber: formatNumber, formatDigits: formatDigits, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const allergies = patient.allergies || [];
    const gKey = (0, $2e1381078ec7f76f$export$c58a664d6aae39f0)(patient.gender);
    const mKey = (0, $2e1381078ec7f76f$export$c50166745a33f7cd)(patient.maritalStatus);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            allergies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                    size: 16
                }),
                title: t('patient.summary.allergyWarning'),
                children: allergies.map((a)=>a.allergen).filter(Boolean).join(" \xb7 ")
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: t('patient.summary.demographics'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                        gap: 18
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('common.labels.phone'),
                            value: patient.phone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Ltr, {
                                children: formatDigits((0, $412e1a8a99c19c1a$exports).forDisplay(patient.phone))
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('common.labels.nationalId'),
                            value: patient.nationalId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Ltr, {
                                children: formatDigits(patient.nationalId)
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('common.labels.fileNumber'),
                            value: patient.fileNumber ? formatDigits(patient.fileNumber) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.birthDate'),
                            value: patient.birthDate ? formatDigits(patient.birthDate) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.stats.age'),
                            value: patient.age != null ? t('common.units.years', {
                                count: patient.age
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.gender'),
                            value: gKey ? t(gKey) : patient.gender
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.maritalStatus'),
                            value: mKey ? t(mKey) : patient.maritalStatus
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.bloodType'),
                            value: patient.bloodType ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Ltr, {
                                children: patient.bloodType
                            }) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.job'),
                            value: patient.job
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.insurance'),
                            value: patient.insurance
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.height'),
                            value: patient.height ? formatNumber(patient.height) : null
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($353d784267d31267$var$Field, {
                            label: t('patient.fields.createdAt'),
                            value: patient.createdAt ? formatDate(patient.createdAt, 'numeric') : null
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: t('patient.summary.allergies'),
                children: allergies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: 13,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    },
                    children: t('patient.summary.noAllergies')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 10
                    },
                    children: allergies.map((a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 13.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: a.allergen
                                }),
                                a.severity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: (0, $2e1381078ec7f76f$export$43b5c849fabfd025)(a.severity) ? t((0, $2e1381078ec7f76f$export$43b5c849fabfd025)(a.severity)) : a.severity
                                }),
                                a.reaction && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                    },
                                    children: a.reaction
                                })
                            ]
                        }, a.id))
                })
            })
        ]
    });
};
var $353d784267d31267$export$2e2bcd8739ae039 = $353d784267d31267$var$SummaryTab;



parcelRequire("acw62");





// سوابق — what has been recorded about this patient, read-only.
//
// Conditions and medications come from clinicalencounter and are keyed on
// `appointment_id`: there is no encounters table on this platform, encounters
// ARE appointments. Nothing here groups by "visit" for that reason — inventing
// a visit grouping the data does not carry would be inventing a fact.
const $a55d7d850b9289c2$var$dosageLine = (medication)=>{
    const d = medication?.dosageInstruction;
    if (!d) return '';
    if (typeof d === 'string') return d;
    if (d.text) return d.text;
    return [
        d.dose,
        d.frequency,
        d.duration
    ].filter(Boolean).join(" \xb7 ");
};
const $a55d7d850b9289c2$var$HistoryTab = ({ patient: patient })=>{
    const { t: t, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const conditions = patient.conditions || [];
    const medications = patient.medications || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: t('patient.history.conditions'),
                children: conditions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: 13,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    },
                    children: t('patient.history.noConditions')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 12
                    },
                    children: conditions.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 13.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: c.display
                                }),
                                c.code && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    dir: "ltr",
                                    style: {
                                        unicodeBidi: 'isolate',
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: c.code
                                }),
                                c.clinicalStatus && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: (0, $2e1381078ec7f76f$export$d96129a410768e32)(c.clinicalStatus) ? t((0, $2e1381078ec7f76f$export$d96129a410768e32)(c.clinicalStatus)) : c.clinicalStatus
                                }),
                                c.onsetDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        marginInlineStart: 'auto'
                                    },
                                    children: formatDate(c.onsetDate, 'numeric')
                                })
                            ]
                        }, c.id))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: t('patient.history.medications'),
                children: medications.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: 13,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    },
                    children: t('patient.history.noMedications')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 12
                    },
                    children: medications.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'baseline',
                                gap: 10,
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 13.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: m.display
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                    },
                                    children: $a55d7d850b9289c2$var$dosageLine(m)
                                }),
                                m.authoredOn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        marginInlineStart: 'auto'
                                    },
                                    children: t('patient.history.prescribedOn', {
                                        date: formatDate(m.authoredOn, 'numeric')
                                    })
                                })
                            ]
                        }, m.id))
                })
            })
        ]
    });
};
var $a55d7d850b9289c2$export$2e2bcd8739ae039 = $a55d7d850b9289c2$var$HistoryTab;




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");

function $849f2169098c9170$export$2e2bcd8739ae039({ count: count = 1 }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                r: (0, $789c06d5db9cfc3f$export$5acff4402443fc33).r,
                fill: (0, $789c06d5db9cfc3f$export$5acff4402443fc33).fill,
                stroke: (0, $789c06d5db9cfc3f$export$5acff4402443fc33).ink,
                strokeWidth: 0.9
            }),
            count > 1 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: 0,
                y: 0,
                textAnchor: "middle",
                dominantBaseline: "central",
                fill: (0, $789c06d5db9cfc3f$export$5acff4402443fc33).ink,
                fontSize: 3.6,
                fontWeight: 700,
                children: count > 9 ? '9+' : count
            }) : /* A tick, drawn as a path rather than a glyph so it cannot be
           swapped by a font that lacks it. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M -1.5 0.1 L -0.45 1.2 L 1.6 -1.1",
                fill: "none",
                stroke: (0, $789c06d5db9cfc3f$export$5acff4402443fc33).ink,
                strokeWidth: 0.9,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}



// Odontogram geometry — tooth silhouettes and the dental arch.
//
// Pure maths, no React, so it is testable without a DOM.
//
// ── THE VIEW ───────────────────────────────────────────────────────────────
// Every tooth is drawn from the OCCLUSAL view (looking down onto the chewing
// surface), which is what a paper odontogram shows, in a LOCAL frame:
//
//        facial (buccal/labial — cheek or lip)      -y
//                     ▲
//        mesial ◄──── ● ────► distal        (before quadrant mirroring)
//                     ▼
//        lingual (tongue / palate)                  +y
//
// The tooth is drawn once in that frame and then ROTATED onto the arch. That
// is why the surfaces stay anatomically right all the way round the curve:
// mesial keeps pointing along the arch toward the midline, buccal keeps
// pointing out of the mouth, at every position. Laying flat boxes in a row and
// hand-flipping their labels per quadrant is what produces charts where half
// the surfaces are mislabelled.
//
// ── CROWN DIMENSIONS ───────────────────────────────────────────────────────
// Proportional to real mesiodistal × buccolingual crown widths (mm), so a
// molar reads as a molar at a glance. Scaled, not literal.
const $1e2d81a721530153$var$MM = 3.1; // px per mm — the whole chart scales from this one number
/** [mesiodistal, buccolingual] crown width in mm, by tooth type. */ const $1e2d81a721530153$var$CROWN_MM = {
    centralIncisorUpper: [
        8.5,
        7.0
    ],
    lateralIncisorUpper: [
        6.5,
        6.0
    ],
    centralIncisorLower: [
        5.3,
        6.0
    ],
    lateralIncisorLower: [
        5.7,
        6.5
    ],
    canine: [
        7.6,
        8.0
    ],
    firstPremolar: [
        7.1,
        9.2
    ],
    secondPremolar: [
        6.6,
        9.0
    ],
    firstMolar: [
        10.3,
        11.0
    ],
    secondMolar: [
        9.8,
        10.7
    ],
    thirdMolar: [
        8.9,
        10.0
    ],
    // Primary crowns are markedly smaller — a child's chart must not look like
    // an adult's with different numbers.
    // Split, because one 'primary incisor' size collided with the permanent
    // lateral it succeeds — and a primary tooth is never wider than the
    // anterior that replaces it.
    primaryCentralIncisor: [
        6.5,
        5.0
    ],
    primaryLateralIncisor: [
        5.1,
        4.1
    ],
    primaryCanine: [
        6.0,
        6.5
    ],
    primaryFirstMolar: [
        7.3,
        8.5
    ],
    primarySecondMolar: [
        8.7,
        9.5
    ]
};
function $1e2d81a721530153$export$9a1c6150672f0d2b(fdi) {
    const q = Number(String(fdi)[0]);
    const p = Number(String(fdi)[1]);
    const primary = q >= 5;
    const upper = [
        1,
        2,
        5,
        6
    ].includes(q);
    if (primary) {
        if (p === 1) return 'primaryCentralIncisor';
        if (p === 2) return 'primaryLateralIncisor';
        if (p === 3) return 'primaryCanine';
        return p === 4 ? 'primaryFirstMolar' : 'primarySecondMolar';
    }
    if (p === 1) return upper ? 'centralIncisorUpper' : 'centralIncisorLower';
    if (p === 2) return upper ? 'lateralIncisorUpper' : 'lateralIncisorLower';
    if (p === 3) return 'canine';
    if (p === 4) return 'firstPremolar';
    if (p === 5) return 'secondPremolar';
    if (p === 6) return 'firstMolar';
    if (p === 7) return 'secondMolar';
    return 'thirdMolar';
}
function $1e2d81a721530153$export$45a85319a6792eac(fdi) {
    const [md, bl] = $1e2d81a721530153$var$CROWN_MM[$1e2d81a721530153$export$9a1c6150672f0d2b(fdi)] || $1e2d81a721530153$var$CROWN_MM.firstMolar;
    return {
        w: md * $1e2d81a721530153$var$MM,
        h: bl * $1e2d81a721530153$var$MM
    };
}
const $1e2d81a721530153$export$56a2711836dcc7fb = (t)=>t.includes('ncisor');
const $1e2d81a721530153$export$91a6fac4425c1e2c = (t)=>t.includes('anine');
const $1e2d81a721530153$export$9025823d5fcafea3 = (t)=>t.includes('olar') && !t.includes('remolar');
const $1e2d81a721530153$export$32420ce44e213687 = (t)=>t.includes('remolar');
function $1e2d81a721530153$export$fdbe61f566b424c8(fdi) {
    return $1e2d81a721530153$var$crownOutline(fdi, 1);
}
/**
 * The same silhouette at a scale — shared by `crownPath` (scale 1) and
 * `crownRingPath` (the روکش ring, drawn just inside it). One builder, so the
 * ring can never drift out of step with the outline it hugs.
 */ function $1e2d81a721530153$var$crownOutline(fdi, scale) {
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const x = w / 2 * scale;
    const y = h / 2 * scale;
    const type = $1e2d81a721530153$export$9a1c6150672f0d2b(fdi);
    if ($1e2d81a721530153$export$56a2711836dcc7fb(type)) // Flat facial edge (the incisal ridge seen from above), rounded lingually.
    return [
        `M ${-x} ${-y}`,
        `L ${x} ${-y}`,
        `Q ${x * 1.05} ${0} ${x * 0.72} ${y * 0.9}`,
        `Q ${0} ${y * 1.15} ${-x * 0.72} ${y * 0.9}`,
        `Q ${-x * 1.05} ${0} ${-x} ${-y}`,
        'Z'
    ].join(' ');
    if ($1e2d81a721530153$export$91a6fac4425c1e2c(type)) // The cusp tip points facially — the canine's defining feature.
    return [
        `M ${0} ${-y * 1.18}`,
        `Q ${x * 0.9} ${-y * 0.75} ${x * 0.95} ${0}`,
        `Q ${x * 0.85} ${y * 0.95} ${0} ${y}`,
        `Q ${-x * 0.85} ${y * 0.95} ${-x * 0.95} ${0}`,
        `Q ${-x * 0.9} ${-y * 0.75} ${0} ${-y * 1.18}`,
        'Z'
    ].join(' ');
    if ($1e2d81a721530153$export$32420ce44e213687(type)) // Oval, slightly waisted at the mid — two cusps, buccal and lingual.
    return [
        `M ${0} ${-y}`,
        `Q ${x} ${-y * 0.8} ${x * 0.92} ${0}`,
        `Q ${x} ${y * 0.8} ${0} ${y}`,
        `Q ${-x} ${y * 0.8} ${-x * 0.92} ${0}`,
        `Q ${-x} ${-y * 0.8} ${0} ${-y}`,
        'Z'
    ].join(' ');
    // Molar: broad, rounded rectangle.
    const r = Math.min(w, h) * 0.22 * scale;
    return [
        `M ${-x + r} ${-y}`,
        `L ${x - r} ${-y}`,
        `Q ${x} ${-y} ${x} ${-y + r}`,
        `L ${x} ${y - r}`,
        `Q ${x} ${y} ${x - r} ${y}`,
        `L ${-x + r} ${y}`,
        `Q ${-x} ${y} ${-x} ${y - r}`,
        `L ${-x} ${-y + r}`,
        `Q ${-x} ${-y} ${-x + r} ${-y}`,
        'Z'
    ].join(' ');
}
function $1e2d81a721530153$export$4ff80055e6ee2fdf(fdi) {
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const x = w / 2;
    const y = h / 2;
    // The central region is proportionally LARGER on molars: the occlusal table
    // really is most of a molar's crown, and it is the most-clicked surface.
    const inset = $1e2d81a721530153$export$9025823d5fcafea3($1e2d81a721530153$export$9a1c6150672f0d2b(fdi)) ? 0.34 : 0.30;
    const ix = x * (1 - inset * 2) + x * inset * 0.55;
    const iy = y * (1 - inset * 2) + y * inset * 0.55;
    return {
        // facial (buccal/labial) — always toward -y in the local frame
        facial: `${-x},${-y} ${x},${-y} ${ix},${-iy} ${-ix},${-iy}`,
        lingual: `${-x},${y} ${x},${y} ${ix},${iy} ${-ix},${iy}`,
        // left/right in the local frame; the caller maps them to mesial/distal,
        // because WHICH side is mesial depends on the quadrant.
        left: `${-x},${-y} ${-ix},${-iy} ${-ix},${iy} ${-x},${y}`,
        right: `${x},${-y} ${ix},${-iy} ${ix},${iy} ${x},${y}`,
        centre: {
            x: -ix,
            y: -iy,
            w: ix * 2,
            h: iy * 2
        }
    };
}
function $1e2d81a721530153$export$f20aa94a419a9b0f(fdi) {
    const type = $1e2d81a721530153$export$9a1c6150672f0d2b(fdi);
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const x = w * 0.19;
    const y = h * 0.19;
    const r = Math.min(w, h) * 0.055;
    if ($1e2d81a721530153$export$9025823d5fcafea3(type)) {
        const pts = [
            [
                -x,
                -y
            ],
            [
                x,
                -y
            ],
            [
                -x,
                y
            ],
            [
                x,
                y
            ]
        ];
        // First molars carry a fifth cusp (the distolingual/Carabelli region) —
        // the classic way a chart distinguishes a 6 from a 7 at a glance.
        if (type === 'firstMolar' || type === 'primarySecondMolar') pts.push([
            x * 1.35,
            y * 0.25
        ]);
        return pts.map(([cx, cy])=>({
                cx: cx,
                cy: cy,
                r: r
            }));
    }
    if ($1e2d81a721530153$export$32420ce44e213687(type)) return [
        {
            cx: 0,
            cy: -y,
            r: r
        },
        {
            cx: 0,
            cy: y,
            r: r
        }
    ];
    if ($1e2d81a721530153$export$91a6fac4425c1e2c(type)) return [
        {
            cx: 0,
            cy: -h * 0.14,
            r: r * 1.1
        }
    ];
    return []; // incisors have an edge, not cusps
}
function $1e2d81a721530153$export$8b7b648247419b02(fdi) {
    const type = $1e2d81a721530153$export$9a1c6150672f0d2b(fdi);
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const x = w * 0.19; // the cusp grid — fissures run between cusps
    const y = h * 0.19;
    if ($1e2d81a721530153$export$9025823d5fcafea3(type)) return [
        `M ${-x} ${-y * 1.3} L ${-x} ${y * 1.3}`,
        `M ${x} ${-y * 1.3} L ${x} ${y * 1.3}`,
        `M ${-x * 1.5} 0 L ${x * 1.5} 0`
    ].join(' ');
    if ($1e2d81a721530153$export$32420ce44e213687(type)) return `M ${-w * 0.27} 0 L ${w * 0.27} 0`;
    // Anteriors (incisors and canines): the incisal edge line.
    return `M ${-w * 0.3} ${-h * 0.34} L ${w * 0.3} ${-h * 0.34}`;
}
function $1e2d81a721530153$export$ecea09364f6d7e85(fdi) {
    return $1e2d81a721530153$var$crownOutline(fdi, 0.76);
}
function $1e2d81a721530153$export$93f6716ad9cd507a(fdi) {
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const s = Math.min(w, h) * 0.13;
    return `0,${s} ${-s * 0.9},${-s * 0.75} ${s * 0.9},${-s * 0.75}`;
}
function $1e2d81a721530153$export$de80878fd40fdd08(fdi) {
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const m = Math.min(w, h);
    const gap = m * 0.13;
    return [
        {
            x1: -m * 0.17,
            y1: -gap,
            x2: m * 0.17,
            y2: -gap
        },
        {
            x1: -m * 0.14,
            y1: 0,
            x2: m * 0.14,
            y2: 0
        },
        {
            x1: -m * 0.11,
            y1: gap,
            x2: m * 0.11,
            y2: gap
        }
    ];
}
function $1e2d81a721530153$export$28ba678519100449(fdi) {
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const m = Math.min(w, h);
    return {
        bar: {
            x1: 0,
            y1: -m * 0.2,
            x2: 0,
            y2: m * 0.16
        },
        dot: {
            cx: 0,
            cy: -m * 0.2,
            r: m * 0.075
        }
    };
}
function $1e2d81a721530153$export$8dd5375953039c36(fdi) {
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const x = w / 2;
    const y = h / 2;
    return `M ${-x * 0.62} ${-y * 0.55} Q 0 ${-y * 1.02} ${x * 0.62} ${-y * 0.55}`;
}
function $1e2d81a721530153$export$43af588fb1be7790(fdi) {
    const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
    const x = w / 2;
    const y = h / 2;
    const SEGMENTS = 5;
    const pts = [];
    for(let i = 0; i <= SEGMENTS; i += 1){
        const t = i / SEGMENTS;
        const jag = i === 0 || i === SEGMENTS ? 0 : i % 2 ? 1 : -1;
        pts.push(`${-x * 0.6 + x * 1.2 * t},${-y * 0.45 + y * 0.9 * t + jag * y * 0.2}`);
    }
    return pts.join(' ');
}
function $1e2d81a721530153$export$4f8fa4869e489935(i, n, { cx: cx, cy: cy, rx: rx, ry: ry, upper: upper }) {
    // Spread across the arc, insetting the ends so the last tooth is not exactly
    // on the horizontal axis (where the rotation would be a full 90°).
    const t = n === 1 ? 0.5 : i / (n - 1);
    return $1e2d81a721530153$var$placeAtTheta(Math.PI * (0.06 + t * 0.88), {
        cx: cx,
        cy: cy,
        rx: rx,
        ry: ry,
        upper: upper
    });
}
/** Position + rotation at a given ellipse parameter. */ function $1e2d81a721530153$var$placeAtTheta(theta, { cx: cx, cy: cy, rx: rx, ry: ry, upper: upper }) {
    const x = cx - rx * Math.cos(theta);
    const y = upper ? cy - ry * Math.sin(theta) : cy + ry * Math.sin(theta);
    // Outward normal — away from the arch centre, i.e. out of the mouth.
    const nx = -rx * Math.cos(theta);
    const ny = upper ? -ry * Math.sin(theta) : ry * Math.sin(theta);
    // The local frame draws facial toward -y, so rotate that onto the normal.
    const rotation = Math.atan2(ny, nx) * 180 / Math.PI + 90;
    return {
        x: x,
        y: y,
        rotation: rotation
    };
}
// ── Arc-length spacing ─────────────────────────────────────────────────────
//
// WHY THE ANGLE PARAMETER IS NOT ENOUGH — the bug this replaces.
//
// Stepping θ evenly does NOT step evenly along an ellipse. The speed is
//     |d/dθ| = sqrt(rx²sin²θ + ry²cos²θ)
// which for the chart's arch (rx≈232, ry≈96) is ~96 at the ends and ~232 at
// the apex: the ends advance 2.4× slower, so teeth bunch there. And the ends
// are exactly where the MOLARS are — the widest teeth got the least room, and
// 15/16/17/18 visibly overlapped each other on screen.
//
// The fix is to walk ARC LENGTH and give each tooth room proportional to its
// own mesiodistal crown width, which is also what a real arch does: teeth sit
// contiguously, a molar occupying more of the curve than an incisor.
const $1e2d81a721530153$var$ARC_STEPS = 720;
/** Cumulative arc length along the arch, sampled once per arch. */ function $1e2d81a721530153$var$arcTable({ rx: rx, ry: ry }, theta0, theta1) {
    const table = [
        {
            theta: theta0,
            s: 0
        }
    ];
    let s = 0;
    const dt = (theta1 - theta0) / $1e2d81a721530153$var$ARC_STEPS;
    for(let k = 1; k <= $1e2d81a721530153$var$ARC_STEPS; k += 1){
        const a = theta0 + dt * (k - 1);
        const b = theta0 + dt * k;
        // Trapezoid on the speed function — plenty at 720 samples, and it runs
        // once per arch per render rather than per tooth.
        const sa = Math.hypot(rx * Math.sin(a), ry * Math.cos(a));
        const sb = Math.hypot(rx * Math.sin(b), ry * Math.cos(b));
        s += (sa + sb) / 2 * dt;
        table.push({
            theta: b,
            s: s
        });
    }
    return table;
}
/** Invert the table: the θ at a given arc length. */ function $1e2d81a721530153$var$thetaAt(table, s) {
    const last = table[table.length - 1];
    if (s <= 0) return table[0].theta;
    if (s >= last.s) return last.theta;
    let lo = 0;
    let hi = table.length - 1;
    while(hi - lo > 1){
        const mid = lo + hi >> 1;
        if (table[mid].s <= s) lo = mid;
        else hi = mid;
    }
    const span = table[hi].s - table[lo].s;
    const f = span > 0 ? (s - table[lo].s) / span : 0;
    return table[lo].theta + f * (table[hi].theta - table[lo].theta);
}
function $1e2d81a721530153$export$9b81fb6547ada184(fdis, opts) {
    const theta0 = Math.PI * 0.04;
    const theta1 = Math.PI * 0.96;
    const table = $1e2d81a721530153$var$arcTable(opts, theta0, theta1);
    const total = table[table.length - 1].s;
    const box = fdis.map((fdi)=>{
        const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdi);
        return {
            halfW: w / 2,
            halfH: h / 2
        };
    });
    // First pass at natural spacing, then GROW any gap whose teeth actually
    // collide (see needSeparation). Two passes: the separation test needs
    // positions, positions need the spacing.
    // The arch midpoint IS the dental midline: the arc is symmetric about it, so
    // growing outward from there puts the central incisors either side of the
    // chart's dashed axis by construction.
    const centre = total / 2;
    let scale = 1;
    let placed = $1e2d81a721530153$var$layout(fdis, box, table, total, opts, scale, centre);
    const overflow = placed.usedArc / total;
    if (overflow > 1) {
        // Too long even after separation — shrink everything, CROWNS INCLUDED
        // (the renderer applies `scale`), and lay out once more at the smaller
        // size. Shrinking only the spacing would reintroduce the overlap.
        scale = 1 / overflow;
        placed = $1e2d81a721530153$var$layout(fdis, box, table, total, opts, scale, centre);
    }
    return placed.teeth;
}
/**
 * One layout pass, run OUTWARD FROM THE MIDLINE.
 *
 * Not left-to-right: the separation pass pushes each tooth away from its
 * neighbour, so a single sweep accumulates all of that slack at one end and the
 * two central incisors stop straddling the midline (measured 6px off). The
 * midline is the anatomical reference — it is where the chart's dashed axis is
 * drawn and where symmetry is judged — so the layout starts there and grows
 * both ways, which makes symmetry automatic instead of approximate.
 */ function $1e2d81a721530153$var$layout(fdis, box, table, total, opts, scale, centreArc) {
    const MIN_GAP = 2.5;
    const n = fdis.length;
    const mid = Math.floor(n / 2); // first tooth LEFT of the midline
    const teeth = new Array(n);
    const make = (i, arc)=>({
            fdi: fdis[i],
            arc: arc,
            scale: scale,
            halfW: box[i].halfW * scale,
            halfH: box[i].halfH * scale,
            ...$1e2d81a721530153$var$placeAtTheta($1e2d81a721530153$var$thetaAt(table, arc), opts)
        });
    // The two teeth either side of the midline. They are the ONLY pair not
    // produced by the outward growth loop, so they need the same corner test
    // applied explicitly — seeding them from half-widths alone left the central
    // incisors 0.03px apart while every other pair had 2.7px, because a rotated
    // crown reaches to its CORNER, not its mesiodistal edge.
    //
    // Both are pushed out by the same amount, so the midline stays exact.
    let half = MIN_GAP / 2;
    for(let guard = 0; guard < 60; guard += 1){
        if (mid > 0) teeth[mid - 1] = make(mid - 1, centreArc - half - box[mid - 1].halfW * scale);
        if (mid < n) teeth[mid] = make(mid, centreArc + half + box[mid].halfW * scale);
        if (mid === 0 || mid >= n) break;
        if ($1e2d81a721530153$var$clears(teeth[mid - 1], teeth[mid], MIN_GAP)) break;
        half += 0.75;
    }
    // Grow outward, pushing each tooth until its corners clear its inward
    // neighbour's (see clears() — reach is the ROTATED extent, not the width).
    const grow = (from, step)=>{
        for(let i = from; i >= 0 && i < n; i += step){
            const prev = teeth[i - step];
            let advance = prev.halfW + box[i].halfW * scale + MIN_GAP;
            let candidate = make(i, prev.arc + step * advance);
            for(let guard = 0; guard < 60 && !$1e2d81a721530153$var$clears(prev, candidate, MIN_GAP); guard += 1){
                advance += 1.5;
                candidate = make(i, prev.arc + step * advance);
            }
            teeth[i] = candidate;
        }
    };
    grow(mid + 1, 1);
    grow(mid - 2, -1);
    // How much arc the finished run needs, measured tip to tip.
    const first = teeth[0];
    const last = teeth[n - 1];
    const usedArc = last.arc + last.halfW - (first.arc - first.halfW);
    return {
        teeth: teeth,
        usedArc: usedArc
    };
}
/**
 * Do two placed crowns clear each other?
 *
 * The separating-axis test along the line joining their centres. A rotated
 * rectangle's reach along a direction is
 *     halfW·|x̂·u| + halfH·|ŷ·u|
 * where x̂/ŷ are the tooth's own axes — which is why sizing by mesiodistal
 * width alone was wrong: a rotated molar presents its CORNER (reach ≈ the
 * half-diagonal, ~23px, not ~16px), and at the arch ends neighbouring teeth
 * differ sharply in rotation, so their corners swing into one another. That is
 * the overlap that survived the first arc-length fix.
 */ function $1e2d81a721530153$var$clears(a, b, margin) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    const len = Math.hypot(dx, dy);
    if (len === 0) return false;
    const ux = dx / len;
    const uy = dy / len;
    return len >= $1e2d81a721530153$var$reachAlong(a, ux, uy) + $1e2d81a721530153$var$reachAlong(b, ux, uy) + margin;
}
function $1e2d81a721530153$var$reachAlong(tooth, ux, uy) {
    const r = tooth.rotation * Math.PI / 180;
    const cos = Math.cos(r);
    const sin = Math.sin(r);
    // Tooth axes in world space: local +x → (cos, sin), local +y → (-sin, cos).
    return tooth.halfW * Math.abs(cos * ux + sin * uy) + tooth.halfH * Math.abs(-sin * ux + cos * uy);
}
function $1e2d81a721530153$export$7901f9f7e9e2d853(n, opts, fdis) {
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for(let i = 0; i < n; i += 1){
        const { x: x, y: y } = $1e2d81a721530153$export$4f8fa4869e489935(i, n, opts);
        const { w: w, h: h } = $1e2d81a721530153$export$45a85319a6792eac(fdis[i]);
        const reach = Math.max(w, h) * 0.75; // rotation-safe half-diagonal
        minX = Math.min(minX, x - reach);
        maxX = Math.max(maxX, x + reach);
        minY = Math.min(minY, y - reach);
        maxY = Math.max(maxY, y + reach);
    }
    return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}



function $f3bdeb9cef364344$export$2e2bcd8739ae039({ fdi: fdi, state: state, selected: selected = false, hovered: hovered = false, highlighted: // A tooth this SCREEN has something to say about — the visit workspace marks
// the teeth a طرح درمان touches (dent-visit.md §3.1.3). It is deliberately
// not a `state` value: nothing about it is recorded on the tooth, it is a
// caller's annotation, and folding it into the chart's clinical vocabulary
// would put "planned" beside "carious" as if the two were the same kind of
// fact.
highlighted = false, treatedCount: // How many treatments have been RECORDED on this tooth — «درمان‌شده».
//
// A second annotation beside `highlighted`, and the same kind of thing: a
// caller's statement about the tooth, never a fact stored on it. The two
// answer different questions and routinely both apply:
//
//   highlighted  something is PLANNED here           (dashed ring)
//   treatedCount something was DONE here             (check badge)
//
// It is a COUNT rather than a boolean because a course is several sessions
// on one tooth and «۳» is the more useful thing to read at a glance.
treatedCount = 0, onSelect: onSelect, onSurfaceSelect: onSurfaceSelect, onHover: onHover, onHoverEnd: onHoverEnd, t: t, idPrefix: // Per-chart-instance id namespace (Odontogram threads its own). Ids must be
// unique per DOCUMENT, not per chart: with two charts on one page a bare
// `crown-11` clip or `crownShine` gradient resolves to whichever chart
// rendered first, silently cross-wiring their defs.
idPrefix = '' }) {
    const clipId = `${idPrefix}crown-${fdi}`;
    const { w: w, h: h } = (0, $1e2d81a721530153$export$45a85319a6792eac)(fdi);
    const path = (0, $1e2d81a721530153$export$fdbe61f566b424c8)(fdi);
    const regions = (0, $1e2d81a721530153$export$4ff80055e6ee2fdf)(fdi);
    const marks = (0, $1e2d81a721530153$export$f20aa94a419a9b0f)(fdi);
    // Which surface the cursor is on, for the stroke highlight. Local state on
    // purpose: hover feedback is this tooth's business, not the chart's.
    const [hoverSurface, setHoverSurface] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const available = state?.surfacesAvailable?.length ? state.surfacesAvailable : (0, $789c06d5db9cfc3f$export$e8e69ffa6db2b2c2)(fdi);
    const centre = available.includes('O') ? 'O' : 'I';
    const missing = (0, $789c06d5db9cfc3f$export$5c3943b5a89fa884)(state?.presence);
    const outline = (0, $789c06d5db9cfc3f$export$47f15c26a9378317)(state);
    // A whole-tooth condition is carrying the outline colour, so the silhouette
    // is saying something clinical and gets the weight to be seen saying it.
    const tinted = (0, $789c06d5db9cfc3f$export$c500e7ba307fe4bd)(state);
    // local left/right → mesial/distal
    const mesialRight = (0, $789c06d5db9cfc3f$export$c772952b4b390da9)(fdi);
    const byRegion = {
        facial: 'F',
        lingual: 'L',
        right: mesialRight ? 'M' : 'D',
        left: mesialRight ? 'D' : 'M'
    };
    const valueOf = (code)=>(state?.surfaces || []).find((s)=>s.surface === code)?.value || null;
    // Untinted surfaces are TRANSPARENT so the shared crown gradient (one def in
    // Odontogram.jsx) shows through; a recorded state paints opaquely ABOVE it,
    // which is what keeps caries-red fully readable over the shading.
    const fillFor = (code)=>{
        const v = valueOf(code);
        return v ? (0, $789c06d5db9cfc3f$export$332b24b8d2f6799)(v).fill : 'transparent';
    };
    const condValues = (state?.conditions || []).map((c)=>c.value);
    const has = (v)=>condValues.includes(v);
    const crownMaterial = (state?.conditions || []).find((c)=>c.value === (0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).CROWN)?.material || null;
    const anyGlyph = has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).CROWN) || has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).ROOT_CANAL) || has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).IMPLANT) || has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).POST_CORE) || has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).VENEER) || has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).FRACTURE);
    const handleSurface = (code)=>(e)=>{
            e.stopPropagation(); // a surface click is not also a tooth click
            onSurfaceSelect?.(fdi, code);
        };
    const hoverProps = {
        onMouseMove: (e)=>onHover?.(fdi, {
                clientX: e.clientX,
                clientY: e.clientY
            }),
        onMouseLeave: ()=>onHoverEnd?.(fdi)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        style: {
            cursor: missing ? 'default' : 'pointer'
        },
        onClick: ()=>onSelect?.(fdi),
        // Deliberately NOT a tab stop: 52 focusable teeth was a keyboard trap
        // in practice. The chart <svg> is ONE tab stop and arrow keys move the
        // cursor inside it (Odontogram.jsx). The aria-label stays so the group
        // still names itself to assistive tech.
        role: "button",
        "aria-label": [
            `${t('chart.tooth')} ${fdi}`,
            highlighted ? t('chart.annotation.planned') : null,
            treatedCount > 0 ? t('chart.annotation.treated') : null
        ].filter(Boolean).join((0, $c53f9539af19d960$export$3004b7ed4244ef95)()),
        ...hoverProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: clipId,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: path
                    })
                })
            }),
            (selected || hovered) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: path,
                fill: "none",
                stroke: selected ? '#0EA5A0' : '#94a3b8',
                strokeWidth: selected ? 6 : 4,
                strokeOpacity: selected ? 0.35 : 0.25,
                pointerEvents: "none"
            }),
            highlighted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: path,
                fill: "none",
                ...(0, $789c06d5db9cfc3f$export$268f349e84521056),
                pointerEvents: "none"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: path,
                fill: missing ? outline.fill : `url(#${idPrefix}crownShine)`
            }),
            !missing && tinted === (0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).CARIES && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: path,
                fill: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).caries_tooth.fill,
                opacity: 0.88,
                pointerEvents: "none"
            }),
            missing ? // Struck through, not hidden: the POSITION still matters — it is where
            // a bridge or an implant goes — so removing it would lose the gap.
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: `url(#${clipId})`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                        x1: -w / 2,
                        y1: -h / 2,
                        x2: w / 2,
                        y2: h / 2,
                        stroke: outline.stroke,
                        strokeWidth: 1.8
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                        x1: w / 2,
                        y1: -h / 2,
                        x2: -w / 2,
                        y2: h / 2,
                        stroke: outline.stroke,
                        strokeWidth: 1.8
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: `url(#${clipId})`,
                children: [
                    Object.entries(byRegion).map(([region, code])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                            points: regions[region],
                            fill: fillFor(code),
                            stroke: hoverSurface === code ? (0, $789c06d5db9cfc3f$export$46572491bf07a861).surfaceHover : outline.stroke,
                            strokeWidth: hoverSurface === code ? 1.1 : 0.4,
                            onClick: handleSurface(code),
                            onMouseEnter: ()=>setHoverSurface(code),
                            onMouseLeave: ()=>setHoverSurface((s)=>s === code ? null : s),
                            role: "button",
                            tabIndex: -1,
                            "aria-label": `${fdi} \u{2014} ${t(`chart.surface.${code}`)}`
                        }, region)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: regions.centre.x,
                        y: regions.centre.y,
                        width: regions.centre.w,
                        height: regions.centre.h,
                        rx: 2,
                        fill: fillFor(centre),
                        stroke: hoverSurface === centre ? (0, $789c06d5db9cfc3f$export$46572491bf07a861).surfaceHover : outline.stroke,
                        strokeWidth: hoverSurface === centre ? 1.1 : 0.4,
                        onClick: handleSurface(centre),
                        onMouseEnter: ()=>setHoverSurface(centre),
                        onMouseLeave: ()=>setHoverSurface((s)=>s === centre ? null : s),
                        role: "button",
                        tabIndex: -1,
                        "aria-label": `${fdi} \u{2014} ${t(`chart.surface.${centre}`)}`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        pointerEvents: "none",
                        opacity: valueOf(centre) ? 0.35 : 0.5,
                        children: [
                            marks.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: c.cx,
                                    cy: c.cy,
                                    r: c.r,
                                    fill: "none",
                                    stroke: outline.stroke,
                                    strokeWidth: 0.7
                                }, i)),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: (0, $1e2d81a721530153$export$8b7b648247419b02)(fdi),
                                fill: "none",
                                stroke: outline.stroke,
                                strokeWidth: 0.8,
                                strokeLinecap: "round"
                            })
                        ]
                    })
                ]
            }),
            anyGlyph && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                pointerEvents: "none",
                children: [
                    has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).CROWN) && // The universal chart convention: a second ring just inside the
                    // silhouette. Material tints it (teeth.js CROWN_MATERIAL_TINTS).
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: (0, $1e2d81a721530153$export$ecea09364f6d7e85)(fdi),
                        fill: "none",
                        stroke: (0, $789c06d5db9cfc3f$export$e5b4b6e3feb01a67)(crownMaterial),
                        strokeWidth: 1.5
                    }),
                    has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).VENEER) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: (0, $1e2d81a721530153$export$8dd5375953039c36)(fdi),
                        fill: "none",
                        stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).restoration.stroke,
                        strokeWidth: 2.4,
                        strokeLinecap: "round"
                    }),
                    has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).FRACTURE) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                        points: (0, $1e2d81a721530153$export$43af588fb1be7790)(fdi),
                        fill: "none",
                        stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).fractured.stroke,
                        strokeWidth: 1.4
                    }),
                    has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).IMPLANT) && (0, $1e2d81a721530153$export$de80878fd40fdd08)(fdi).map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                            x1: s.x1,
                            y1: s.y1,
                            x2: s.x2,
                            y2: s.y2,
                            stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).implant.stroke,
                            strokeWidth: 1.8,
                            strokeLinecap: "round"
                        }, i)),
                    has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).POST_CORE) && (()=>{
                        const g = (0, $1e2d81a721530153$export$28ba678519100449)(fdi);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                    x1: g.bar.x1,
                                    y1: g.bar.y1,
                                    x2: g.bar.x2,
                                    y2: g.bar.y2,
                                    stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).post_core.stroke,
                                    strokeWidth: 1.8,
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: g.dot.cx,
                                    cy: g.dot.cy,
                                    r: g.dot.r,
                                    fill: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).post_core.stroke
                                })
                            ]
                        });
                    })(),
                    has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).ROOT_CANAL) && // Nudged below the post when both are recorded — RCT → post&core →
                    // crown is the classic sequence, and both marks live at the pulp
                    // position, so unmoved they would hide each other.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        points: (0, $1e2d81a721530153$export$93f6716ad9cd507a)(fdi),
                        fill: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).root_canal.stroke,
                        transform: has((0, $789c06d5db9cfc3f$export$1cfe08df32bc8f76).POST_CORE) ? `translate(0 ${Math.min(w, h) * 0.3})` : undefined
                    })
                ]
            }),
            !missing && (0, $789c06d5db9cfc3f$export$f57b14f0f1731a73)(state) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 0,
                cy: h * 0.3,
                r: 1.5,
                fill: (0, $789c06d5db9cfc3f$export$46572491bf07a861).noteMark,
                pointerEvents: "none"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: path,
                fill: "none",
                stroke: outline.stroke,
                strokeWidth: tinted ? 2.2 : 1.3,
                pointerEvents: "none"
            }),
            !state?.isCharted && !missing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 0,
                cy: 0,
                r: 1.5,
                fill: "#cbd5e1",
                pointerEvents: "none"
            }),
            treatedCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                pointerEvents: "none",
                transform: `translate(${w * 0.42}, ${-h * 0.42})`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $849f2169098c9170$export$2e2bcd8739ae039), {
                    count: treatedCount
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




// The hover card.
//
// It answers the question a dentist asks while scanning an arch: "what is this
// tooth, and what is wrong with it?" — WITHOUT clicking, because clicking opens
// an editor and scanning should not risk an edit.
//
// It is an HTML overlay, not SVG <text>: it needs wrapping Persian, mixed
// LTR/RTL runs (an FDI number inside a Persian sentence), and a shadow. And it
// deliberately REPLACES the native <title> tooltips the surfaces used to carry
// — two tooltips for one element is worse than either alone, and the native one
// takes ~1s to appear and cannot be styled or read by a dentist at a glance.
//
// pointerEvents: 'none' is load-bearing: the card follows the cursor and would
// otherwise sit under it, stealing the hover from the tooth and flickering.
const $88fa21a6af013ee1$var$Row = ({ label: label, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            gap: 8,
            alignItems: 'baseline',
            marginTop: 3
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 10.5,
                    color: '#94a3b8',
                    minWidth: 52
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 11.5,
                    color: '#e2e8f0'
                },
                children: children
            })
        ]
    });
const $88fa21a6af013ee1$var$Swatch = ({ value: value })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: 2,
            background: (0, $789c06d5db9cfc3f$export$332b24b8d2f6799)(value).fill,
            border: `1px solid ${(0, $789c06d5db9cfc3f$export$332b24b8d2f6799)(value).stroke}`,
            marginInlineEnd: 5
        }
    });
function $88fa21a6af013ee1$export$2e2bcd8739ae039({ fdi: fdi, state: state, x: x, y: y, containerWidth: containerWidth, t: t, formatDate: formatDate, treated: // What has been DONE to this tooth, and what is still intended — the two
// chart annotations, as words.
//
// Handed in from the maps the chart already holds rather than fetched here:
// the card follows the cursor across 52 teeth, and a read per hover would be
// 52 possible round trips for something nobody asked to load.
treated = null, planned: planned = null }) {
    if (!fdi) return null;
    const s = (0, $789c06d5db9cfc3f$export$cc997a7b5611bfee)(fdi, state);
    // Newest first, capped at two: this is a glance, and the drawer's history
    // holds the whole list.
    const allTreated = (treated?.names || []).filter(Boolean).slice().reverse();
    const treatedLines = allTreated.slice(0, 2);
    const hiddenTreated = Math.max(0, allTreated.length - treatedLines.length);
    // Only what is still WAITING. A finished line is already one of the ✓ rows
    // above, and listing it twice would read as two separate things.
    const plannedLines = (planned || []).filter((p)=>p && p.status !== 'done' && p.status !== 'rejected').map((p)=>p.description).filter(Boolean).slice(0, 2);
    const WIDTH = 210;
    const OFFSET = 16;
    // Flip to the other side of the cursor near the right edge, so the card is
    // never clipped by the panel. Vertical placement is fixed below the cursor:
    // the arch is short enough that the card always has room under it.
    const flip = x + OFFSET + WIDTH > (containerWidth || Infinity);
    const left = flip ? Math.max(4, x - OFFSET - WIDTH) : x + OFFSET;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "tooltip",
        style: {
            position: 'absolute',
            left: left,
            top: y + OFFSET,
            width: WIDTH,
            background: '#0f172a',
            color: '#e2e8f0',
            borderRadius: 8,
            padding: '9px 11px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
            pointerEvents: 'none',
            zIndex: 20,
            // The card is prose, so it follows the READING direction — unlike the
            // arch itself, which is anatomical and pinned to LTR.
            textAlign: 'start'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 6
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 15,
                            fontWeight: 800,
                            color: '#fff'
                        },
                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                        children: s.fdi
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12,
                            fontWeight: 600
                        },
                        children: t(s.nameKey)
                    }),
                    s.isPrimary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 9.5,
                            background: '#334155',
                            color: '#cbd5e1',
                            borderRadius: 4,
                            padding: '1px 5px'
                        },
                        children: t('chart.primary')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    fontSize: 10.5,
                    color: '#94a3b8',
                    marginTop: 1
                },
                children: [
                    t(s.quadrantKey),
                    s.universal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            " \xb7 ",
                            t('chart.universalShort'),
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                ...(0, $a278322405d51c25$export$3433559efc22d110),
                                children: s.universal
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    height: 1,
                    background: '#1e293b',
                    margin: '7px 0'
                }
            }),
            !s.isCharted ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    color: '#94a3b8'
                },
                children: t('chart.tooltip.notCharted')
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    s.presence !== 'present' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88fa21a6af013ee1$var$Row, {
                        label: t('chart.presence.title'),
                        children: t(`chart.presence.${s.presence}`)
                    }),
                    s.conditions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88fa21a6af013ee1$var$Row, {
                        label: t('chart.condition.title'),
                        children: s.conditions.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: [
                                    i > 0 && (0, $c53f9539af19d960$export$3004b7ed4244ef95)(),
                                    t(`chart.conditionName.${c.value}`),
                                    c.material && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        style: {
                                            color: '#94a3b8'
                                        },
                                        children: [
                                            " (",
                                            t(`chart.materialName.${c.material}`),
                                            ")"
                                        ]
                                    })
                                ]
                            }, c.eventId || i))
                    }),
                    s.surfaces.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88fa21a6af013ee1$var$Row, {
                        label: t('chart.surfaces.title'),
                        children: s.surfaces.map((sf, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    marginInlineEnd: 7,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88fa21a6af013ee1$var$Swatch, {
                                        value: sf.value
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                                        children: sf.surface
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            color: '#cbd5e1'
                                        },
                                        children: t(`chart.surfaceState.${sf.value}`)
                                    })
                                ]
                            }, sf.eventId || i))
                    }),
                    s.presence === 'present' && !s.conditions.length && !s.surfaces.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11.5,
                            color: '#4ade80'
                        },
                        children: t('chart.tooltip.sound')
                    }),
                    s.notes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($88fa21a6af013ee1$var$Row, {
                        label: t('chart.note.title'),
                        children: [
                            s.notes[0].text,
                            s.notes.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    color: '#94a3b8'
                                },
                                children: [
                                    " +",
                                    s.notes.length - 1
                                ]
                            })
                        ]
                    }),
                    s.lastRecordedAtMs && formatDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: 10,
                            color: '#64748b',
                            marginTop: 6
                        },
                        children: [
                            t('chart.tooltip.lastRecorded'),
                            " ",
                            formatDate(s.lastRecordedAtMs)
                        ]
                    })
                ]
            }),
            treatedLines.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 8,
                    borderTop: '1px solid #334155',
                    paddingTop: 6
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 10.5,
                            color: '#94a3b8',
                            marginBottom: 3
                        },
                        children: t('chart.tooltip.treated')
                    }),
                    treatedLines.map((line, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                fontSize: 11.5,
                                color: '#5eead4'
                            },
                            children: [
                                "\u2713 ",
                                line
                            ]
                        }, i)),
                    hiddenTreated > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 10.5,
                            color: '#64748b'
                        },
                        children: t('chart.tooltip.andMore', {
                            count: hiddenTreated
                        })
                    })
                ]
            }),
            plannedLines.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: treatedLines.length ? 4 : 8
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        fontSize: 11.5,
                        color: '#fbbf24'
                    },
                    children: [
                        t('chart.tooltip.planned'),
                        t('common.punct.colon'),
                        " ",
                        plannedLines.join(" \xb7 ")
                    ]
                })
            })
        ]
    });
}




// The odontogram — the whole mouth, on two arches.
//
// ── THE ANATOMICAL FRAME (CORE.md §9) — a patient-safety invariant ──────────
//
// Drawn as the DENTIST LOOKS INTO THE MOUTH: the patient's RIGHT (quadrants 1
// and 4) is on the SCREEN's LEFT, in BOTH locales.
//
// The app is RTL-first and `--dir-flip` is +1 under RTL, so a well-meaning
// "make it RTL-correct" pass is exactly what would mirror the arch and put the
// dentist on the wrong side of the mouth. Three defences: an explicit
// direction:ltr on the <svg>, absolute coordinates only, and permanent
// «راست بیمار»/«چپ بیمار» markers drawn INTO the chart so a mirrored render is
// visible rather than merely wrong. tests/odontogram.test.js pins the order.
//
// ── WHY AN ARCH AND NOT A ROW ──────────────────────────────────────────────
// The curve is not decoration. Each tooth is drawn in a local frame with its
// facial surface toward -y and then ROTATED onto the arch, so buccal keeps
// facing out of the mouth and mesial keeps pointing toward the midline at
// every position — including the third molars, where a flat row would have
// them 90° wrong. Anatomical honesty and legibility come from the same choice.
const $45122e9f240c7236$var$PAD = 30;
const $45122e9f240c7236$var$LABEL_GAP = 15;
// Per-instance SVG id namespace. SVG ids resolve per DOCUMENT, not per svg:
// with two charts on one page a bare `crownShine` (or `crown-11` clip) would
// resolve to whichever chart rendered first, cross-wiring their defs. NOT
// React.useId — its value is derived from tree POSITION, so two charts at the
// same position in two roots (a portal, a print preview) get the SAME id, and
// its delimiters (`:`/`«»`) are not safe inside a `url(#…)` reference. A
// module counter is unique across roots by construction. No SSR here (Parcel
// SPA), so nothing needs to match a server render.
let $45122e9f240c7236$var$chartSeq = 0;
// Visually hidden but still announced — the standard clip pattern. display:none
// (or aria-hidden) would silence the live region entirely.
const $45122e9f240c7236$var$SR_ONLY = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
};
// Upper arch bows up, lower bows down; the two are drawn as facing "∩" / "∪"
// with a gap between, exactly as a printed chart does.
const $45122e9f240c7236$var$ARCH = {
    permanent: {
        rx: 232,
        ry: 96
    },
    primary: {
        rx: 150,
        ry: 62
    }
};
function $45122e9f240c7236$var$Arch({ teeth: teeth, states: states, selected: selected, highlight: highlight, treated: treated, hovered: hovered, onSelect: onSelect, onSurfaceSelect: onSurfaceSelect, onHover: onHover, onHoverEnd: onHoverEnd, labelMode: labelMode, cx: cx, cy: cy, rx: rx, ry: ry, upper: upper, t: t, idPrefix: idPrefix }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: (0, $1e2d81a721530153$export$9b81fb6547ada184)(teeth, {
            cx: cx,
            cy: cy,
            rx: rx,
            ry: ry,
            upper: upper
        }).map(({ fdi: fdi, x: x, y: y, rotation: rotation, scale: scale })=>{
            const state = states[fdi];
            const { w: w, h: h } = (0, $1e2d81a721530153$export$45a85319a6792eac)(fdi);
            // The number sits OUTSIDE the arch, along the same outward normal the
            // tooth is rotated onto, so it never lands on a clickable surface.
            //
            // Offset by the crown's HALF-DIAGONAL, not half its height: the tooth
            // is rotated, so its corner — not its facial edge — is the nearest
            // point to the label. Using h/2 let a molar's corner slide under its
            // own number, and under the smaller Universal number below it.
            const labelR = Math.hypot(w, h) / 2 + $45122e9f240c7236$var$LABEL_GAP;
            const rad = (rotation - 90) * Math.PI / 180;
            const lx = x + Math.cos(rad) * labelR;
            const ly = y + Math.sin(rad) * labelR;
            const isSel = selected === fdi;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                        transform: `translate(${x}, ${y}) rotate(${rotation})${scale < 1 ? ` scale(${scale})` : ''}`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f3bdeb9cef364344$export$2e2bcd8739ae039), {
                            fdi: fdi,
                            state: state,
                            selected: isSel,
                            highlighted: !!highlight?.has(fdi),
                            treatedCount: treated?.get(fdi)?.count || 0,
                            hovered: hovered === fdi,
                            onSelect: onSelect,
                            onSurfaceSelect: onSurfaceSelect,
                            onHover: onHover,
                            onHoverEnd: onHoverEnd,
                            t: t,
                            idPrefix: idPrefix
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        x: lx,
                        y: ly,
                        textAnchor: "middle",
                        dominantBaseline: "middle",
                        fontSize: 9.5,
                        fontWeight: isSel ? 800 : 600,
                        fill: isSel ? '#0EA5A0' : '#64748b',
                        style: {
                            userSelect: 'none',
                            pointerEvents: 'none'
                        },
                        children: fdi
                    }),
                    labelMode === 'both' && state?.universal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        x: lx,
                        y: ly + 10,
                        textAnchor: "middle",
                        dominantBaseline: "middle",
                        fontSize: 7.5,
                        fill: "#a8b3c2",
                        style: {
                            userSelect: 'none',
                            pointerEvents: 'none'
                        },
                        children: state.universal
                    })
                ]
            }, fdi);
        })
    });
}
function $45122e9f240c7236$export$2e2bcd8739ae039({ teeth: teeth = [], selected: selected = null, highlight: /**
   * FDI numbers this screen wants marked, as a Set.
   *
   * The visit workspace passes the teeth a طرح درمان touches (dent-visit.md
   * §3.1.3, "link treatments directly to specific teeth on the Odontogram").
   * It is an ANNOTATION and not clinical state: nothing about it is stored on
   * the tooth, and the chart draws it as a dashed ring precisely so it cannot
   * be mistaken for a recorded finding.
   *
   * A Set rather than an array because this is a per-tooth membership test
   * inside the render of 52 teeth.
   */ highlight = null, treated: /**
   * FDI numbers work has been RECORDED on — «درمان‌شده».
   *
   * `Map<fdi, { count, lastAtMs, names[] }>`, built by `treatedByFdi` in
   * Visit.shared.js from the patient's treatment records. The chart draws a
   * check badge, and the tooltip reads the same map rather than fetching per
   * hover — 52 teeth and a hover read would be 52 possible round trips.
   *
   * An ANNOTATION, like `highlight`: nothing about it is stored on the tooth.
   * The two are independent and routinely both apply — a tooth can have a
   * finished restoration and another treatment still planned.
   */ treated = null, planned: /**
   * What is PLANNED per tooth — `Map<fdi, [{ status, description, … }]>` from
   * `planTeethIndex`. Only the tooltip reads it: the arch already says
   * "planned" with the dashed ring, and the card is where the dentist finds
   * out WHAT is planned without opening anything.
   */ planned = null, onSelect: onSelect, onSurfaceSelect: onSurfaceSelect, showPrimary: showPrimary = 'auto', labelMode: labelMode = 'fdi', t: t, formatDate: formatDate }) {
    const wrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const svgRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Every id this chart defines — the gradient, the blur filter, the
    // per-tooth clips — is namespaced by this per-instance prefix (see chartSeq
    // above). Lazy state, not a bare expression: it must be minted once per
    // MOUNT, not once per render.
    const [idPrefix] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>`odo${$45122e9f240c7236$var$chartSeq += 1}-`);
    const [hover, setHover] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null); // { fdi, x, y }
    // The keyboard cursor — the FDI the arrow keys sit on. Kept across blur so
    // tabbing away and back resumes where the dentist left off.
    const [cursor, setCursor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // The FDI digit buffer. A ref, not state: a half-typed pair renders nothing.
    const fdiBufRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef((0, $789c06d5db9cfc3f$export$7f2a9e5a373efa49));
    const handleHover = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi, { clientX: clientX, clientY: clientY })=>{
        const box = wrapRef.current?.getBoundingClientRect();
        if (!box) return;
        setHover({
            fdi: fdi,
            x: clientX - box.left,
            y: clientY - box.top
        });
    }, []);
    // Only clear when leaving the tooth the card is FOR: moving between adjacent
    // teeth fires the new tooth's enter before the old one's leave, and an
    // unconditional clear would blank the card that just opened.
    const handleHoverEnd = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi)=>{
        setHover((h)=>h && h.fdi !== fdi ? h : null);
    }, []);
    const states = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = {};
        for (const s of teeth)map[s.toothFdi] = s;
        return map;
    }, [
        teeth
    ]);
    // The rule lives in lib/teeth.js because the MOBILE tooth picker offers the
    // same set of teeth: a picker listing 55-51 over a chart not drawing them
    // would be two controls describing different mouths.
    const withPrimary = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $789c06d5db9cfc3f$export$7995d2693cfacea3)(showPrimary, teeth), [
        showPrimary,
        teeth
    ]);
    const W = 620;
    const cx = W / 2;
    const { rx: rx, ry: ry } = $45122e9f240c7236$var$ARCH.permanent;
    const P = $45122e9f240c7236$var$ARCH.primary;
    // Upper arch apex near the top, lower arch apex near the bottom, mirrored
    // about a midline gap — the layout of every printed odontogram.
    const upperBase = $45122e9f240c7236$var$PAD + ry + 26;
    const lowerBase = upperBase + 96;
    const H = lowerBase + ry + $45122e9f240c7236$var$PAD + 22;
    const common = {
        states: states,
        selected: selected,
        highlight: highlight,
        treated: treated,
        hovered: hover?.fdi,
        onSelect: onSelect,
        onSurfaceSelect: onSurfaceSelect,
        onHover: handleHover,
        onHoverEnd: handleHoverEnd,
        labelMode: labelMode,
        t: t,
        idPrefix: idPrefix
    };
    // The visible rows with their arch options, in VERTICAL screen order —
    // primary arches nest between the permanent ones. ONE definition feeds the
    // bridge bars, the keyboard rows and the world-position lookup, so they can
    // never disagree about what is on screen or where.
    const rowDefs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>[
            {
                row: (0, $789c06d5db9cfc3f$export$7841f2f53987dfb9).upper,
                opts: {
                    cx: cx,
                    cy: upperBase,
                    rx: rx,
                    ry: ry,
                    upper: true
                }
            },
            ...withPrimary ? [
                {
                    row: (0, $789c06d5db9cfc3f$export$fc5732f3d203b9d).upper,
                    opts: {
                        cx: cx,
                        cy: upperBase + 14,
                        rx: P.rx,
                        ry: P.ry,
                        upper: true
                    }
                },
                {
                    row: (0, $789c06d5db9cfc3f$export$fc5732f3d203b9d).lower,
                    opts: {
                        cx: cx,
                        cy: lowerBase - 14,
                        rx: P.rx,
                        ry: P.ry,
                        upper: false
                    }
                }
            ] : [],
            {
                row: (0, $789c06d5db9cfc3f$export$7841f2f53987dfb9).lower,
                opts: {
                    cx: cx,
                    cy: lowerBase,
                    rx: rx,
                    ry: ry,
                    upper: false
                }
            }
        ], [
        withPrimary,
        cx,
        upperBase,
        lowerBase,
        rx,
        ry,
        P.rx,
        P.ry
    ]);
    // fdi → its world (viewBox) position.
    //
    // Computed ONCE from the same archPlacements() the teeth are drawn with, and
    // shared by the keyboard cursor's hover card and the bridge bars. Spacing is
    // arc-length based and depends on the WHOLE row (each tooth takes room
    // proportional to its crown), so a per-index re-derivation would not even be
    // reproducible — it would put the cursor and the bridge bars on coordinates
    // no tooth occupies.
    const worldPos = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = {};
        for (const { row: row, opts: opts } of rowDefs)for (const p of (0, $1e2d81a721530153$export$9b81fb6547ada184)(row, opts))map[p.fdi] = p;
        return map;
    }, [
        rowDefs
    ]);
    // بریج bars — one per span, computed per ROW because upper and lower are
    // separate rowOrders (bridgeSpans can then never leak a span across the
    // midline gap between the arches).
    const bridgeBars = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return rowDefs.flatMap(({ row: row, opts: opts })=>(0, $789c06d5db9cfc3f$export$ed28de37b06d1e98)(states, row)// A one-tooth span (a lone abutment, a bridge half-charted) is real
            // data, but a bar over a single tooth connects nothing — skip drawing.
            .filter((span)=>span.teeth.length > 1).map((span)=>({
                    key: span.teeth.join('-'),
                    // The chord through the teeth's world positions follows the arch
                    // closely enough at bridge lengths; pontic (usually missing) teeth
                    // are on the polyline like any other, so the bar crosses the gap.
                    points: span.teeth.map((fdi)=>worldPos[fdi]).filter(Boolean).map((p)=>`${p.x},${p.y}`).join(' ')
                })));
    }, [
        states,
        rowDefs,
        worldPos
    ]);
    // Move the keyboard cursor to a tooth: the halo and the hover card are the
    // SAME mechanism the mouse uses — the tooth's world position is mapped back
    // to client coordinates and fed through handleHover, so the two paths
    // cannot drift apart visually.
    const focusTooth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi)=>{
        setCursor(fdi);
        const p = worldPos[fdi];
        const rect = svgRef.current?.getBoundingClientRect();
        if (!p || !rect) return;
        // The svg scales uniformly from its viewBox (width:100%), so world →
        // client is one factor. jsdom reports a zero rect; the fallback keeps the
        // card maths finite there.
        const scale = rect.width ? rect.width / W : 1;
        handleHover(fdi, {
            clientX: rect.left + p.x * scale,
            clientY: rect.top + p.y * scale
        });
    }, [
        worldPos,
        handleHover
    ]);
    // Keyboard charting. The svg is ONE tab stop (Tab passes straight through —
    // no focus trap); arrows move the cursor, digits jump to an FDI, Enter or
    // Space opens the tooth. Arrow traversal follows DRAWING order and
    // deliberately IGNORES RTL (CORE.md §9): ArrowRight is always toward the
    // SCREEN's right, in both locales — the arch is anatomical, not textual.
    const handleKeyDown = (e)=>{
        const rows = rowDefs.map((d)=>d.row);
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault(); // the page must not scroll under the chart
            focusTooth((0, $789c06d5db9cfc3f$export$185d1f0722e636b2)(rows, cursor, e.key));
            return;
        }
        if ((e.key === 'Enter' || e.key === ' ') && cursor) {
            e.preventDefault();
            onSelect?.(cursor); // the same path a click takes
            return;
        }
        if (e.key === 'Escape') {
            fdiBufRef.current = (0, $789c06d5db9cfc3f$export$79a01b9b47bc6931)(fdiBufRef.current, {
                type: 'clear'
            });
            return;
        }
        if ((0, $789c06d5db9cfc3f$export$ca8b5b1a6c320e6e)(e.key) != null) {
            e.preventDefault();
            fdiBufRef.current = (0, $789c06d5db9cfc3f$export$79a01b9b47bc6931)(fdiBufRef.current, {
                type: 'digit',
                digit: e.key,
                now: Date.now(),
                teeth: rows.flat()
            });
            if (fdiBufRef.current.jump) focusTooth(fdiBufRef.current.jump);
        }
    };
    const handleChartBlur = ()=>{
        fdiBufRef.current = (0, $789c06d5db9cfc3f$export$79a01b9b47bc6931)(fdiBufRef.current, {
            type: 'clear'
        });
        // Close the card only if it is the CURSOR's — a mouse hovering elsewhere
        // keeps its own card (same rule handleHoverEnd applies between teeth).
        if (cursor) handleHoverEnd(cursor);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: wrapRef,
        style: {
            position: 'relative'
        },
        onMouseLeave: ()=>setHover(null),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                ref: svgRef,
                viewBox: `0 0 ${W} ${H}`,
                width: "100%",
                role: "group",
                "aria-label": t('chart.aria.odontogram'),
                // ONE tab stop for the whole chart — arrow keys navigate inside, Tab
                // leaves normally. The teeth themselves are deliberately not focusable
                // (52 tab stops was a keyboard trap in practice, see Tooth.jsx).
                tabIndex: 0,
                onKeyDown: handleKeyDown,
                onBlur: handleChartBlur,
                // direction:ltr is LOAD-BEARING — see the header. Do not remove it to
                // "fix RTL": the arch is anatomical, not textual.
                style: {
                    direction: 'ltr',
                    maxWidth: 760,
                    display: 'block',
                    margin: '0 auto'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                                id: `${idPrefix}crownShine`,
                                cx: "50%",
                                cy: "42%",
                                r: "68%",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        offset: "0%",
                                        stopColor: (0, $789c06d5db9cfc3f$export$46572491bf07a861).crownCentre
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        offset: "55%",
                                        stopColor: (0, $789c06d5db9cfc3f$export$46572491bf07a861).crownCentre
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                                        offset: "100%",
                                        stopColor: (0, $789c06d5db9cfc3f$export$46572491bf07a861).crownRim
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("filter", {
                                id: `${idPrefix}archShadowBlur`,
                                x: "-20%",
                                y: "-40%",
                                width: "140%",
                                height: "180%",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                                    stdDeviation: "7"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        pointerEvents: "none",
                        opacity: 0.12,
                        filter: `url(#${idPrefix}archShadowBlur)`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                                cx: cx,
                                cy: upperBase - ry * 0.45,
                                rx: rx,
                                ry: ry * 0.75,
                                fill: (0, $789c06d5db9cfc3f$export$46572491bf07a861).archShadow
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                                cx: cx,
                                cy: lowerBase + ry * 0.45,
                                rx: rx,
                                ry: ry * 0.75,
                                fill: (0, $789c06d5db9cfc3f$export$46572491bf07a861).archShadow
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                        x1: cx,
                        y1: $45122e9f240c7236$var$PAD - 14,
                        x2: cx,
                        y2: H - $45122e9f240c7236$var$PAD + 6,
                        stroke: "#e8edf3",
                        strokeWidth: 1,
                        strokeDasharray: "4 4"
                    }),
                    bridgeBars.map((b)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                            points: b.points,
                            fill: "none",
                            ...(0, $789c06d5db9cfc3f$export$49e77edbb85c0c46),
                            pointerEvents: "none"
                        }, b.key)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        x: $45122e9f240c7236$var$PAD - 12,
                        y: $45122e9f240c7236$var$PAD - 12,
                        fontSize: 10.5,
                        fontWeight: 700,
                        fill: "#94a3b8",
                        children: t('chart.patientRight')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        x: W - $45122e9f240c7236$var$PAD + 12,
                        y: $45122e9f240c7236$var$PAD - 12,
                        textAnchor: "end",
                        fontSize: 10.5,
                        fontWeight: 700,
                        fill: "#94a3b8",
                        children: t('chart.patientLeft')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($45122e9f240c7236$var$Arch, {
                        ...common,
                        teeth: (0, $789c06d5db9cfc3f$export$7841f2f53987dfb9).upper,
                        cx: cx,
                        cy: upperBase,
                        rx: rx,
                        ry: ry,
                        upper: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($45122e9f240c7236$var$Arch, {
                        ...common,
                        teeth: (0, $789c06d5db9cfc3f$export$7841f2f53987dfb9).lower,
                        cx: cx,
                        cy: lowerBase,
                        rx: rx,
                        ry: ry,
                        upper: false
                    }),
                    withPrimary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($45122e9f240c7236$var$Arch, {
                                ...common,
                                teeth: (0, $789c06d5db9cfc3f$export$fc5732f3d203b9d).upper,
                                cx: cx,
                                cy: upperBase + 14,
                                rx: P.rx,
                                ry: P.ry,
                                upper: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($45122e9f240c7236$var$Arch, {
                                ...common,
                                teeth: (0, $789c06d5db9cfc3f$export$fc5732f3d203b9d).lower,
                                cx: cx,
                                cy: lowerBase - 14,
                                rx: P.rx,
                                ry: P.ry,
                                upper: false
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "aria-live": "polite",
                role: "status",
                style: $45122e9f240c7236$var$SR_ONLY,
                children: cursor ? `${t('chart.tooth')} ${cursor} \u{2014} ${t((0, $789c06d5db9cfc3f$export$569cf66ddb61c0fe)(cursor))}` : ''
            }),
            hover && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88fa21a6af013ee1$export$2e2bcd8739ae039), {
                fdi: hover.fdi,
                state: states[hover.fdi],
                x: hover.x,
                y: hover.y,
                containerWidth: wrapRef.current?.clientWidth,
                treated: treated?.get(hover.fdi) || null,
                planned: planned?.get(hover.fdi) || null,
                t: t,
                formatDate: formatDate
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");




// The tooth-editor DRAFT → the batch that goes on the wire.
//
// THE DRAFT MODEL: nothing is sent until «ثبت». A dentist charting a molar
// touches several surfaces in a row, and a request per tap would produce a
// burst of writes the server has to reconcile — and would make «انصراف»
// meaningless. Edits accumulate as a draft and go out as ONE batch, which is
// also exactly what the server's all-or-nothing RPC expects: one clinical act,
// one transaction.
//
// This lives in lib/ rather than inside the drawer because BOTH surfaces edit a
// tooth — the desktop `ToothDrawer` and the mobile `MobileToothSheet` — and
// they look nothing alike. What must NOT differ is the batch: the two forms
// emitting subtly different events for the same taps is precisely the class of
// bug §1.1 exists to prevent ("the two surfaces may look nothing alike but must
// never disagree"). Markup forks; this does not.
//
// It is a pure function of (draft, fdi, state) so it is testable without a DOM.
/**
 * @param draft { presence, condition:{value,material}, surfaces:{[code]:{value,material}}, note, isHistorical }
 * @param fdi   the tooth being edited
 * @param state the tooth's CURRENT server state (used only to drop a no-op presence)
 * @returns the ToothEventInput batch — empty when there is nothing to save
 */ function $c6530d73ef205691$export$42d1dcf756bfbad5(draft, fdi, state) {
    if (!fdi) return [];
    const d = draft || {};
    const out = [];
    // A presence identical to what is already recorded is not an edit. Sending it
    // would append a second, redundant event to an append-only log.
    if (d.presence && d.presence !== state?.presence) out.push({
        toothFdi: fdi,
        aspect: 'presence',
        value: d.presence
    });
    if (d.condition?.value) out.push({
        toothFdi: fdi,
        aspect: 'condition',
        value: d.condition.value,
        material: d.condition.material || null
    });
    for (const [code, v] of Object.entries(d.surfaces || {})){
        if (!v?.value) continue;
        out.push({
            toothFdi: fdi,
            aspect: 'surface',
            surface: code,
            value: v.value,
            material: v.material || null
        });
    }
    if (d.note?.trim()) out.push({
        toothFdi: fdi,
        aspect: 'note',
        value: 'note',
        note: d.note.trim()
    });
    // «کار قبلی» stamps the WHOLE batch: one visit to the editor is one clinical
    // statement, and half of it being "done today" while the other half is
    // historical is not a state a dentist can express or would mean.
    return out.map((e)=>({
            ...e,
            isHistorical: !!d.isHistorical
        }));
}
function $c6530d73ef205691$export$d16336e5a7ea5761(finding) {
    const f = finding || {};
    const seed = {
        surfaces: {},
        isHistorical: !!f.isHistorical
    };
    if (!f.toothFdi || !f.aspect || !f.value) return seed;
    if (f.aspect === 'presence') seed.presence = f.value;
    else if (f.aspect === 'condition') seed.condition = {
        value: f.value,
        material: null
    };
    else if (f.aspect === 'surface' && f.surface) seed.surfaces[f.surface] = {
        value: f.value,
        material: null
    };
    return seed;
}
var $c6530d73ef205691$export$2e2bcd8739ae039 = $c6530d73ef205691$export$42d1dcf756bfbad5;


// Editing one tooth.
//
// THE DRAFT MODEL: nothing is sent until «ثبت». A dentist charting a molar
// touches several surfaces in a row, and a request per tap would produce a
// burst of writes the server has to reconcile — and would make «انصراف»
// meaningless. Edits accumulate as a draft and go out as ONE batch, which is
// also exactly what the server's all-or-nothing RPC expects: one clinical act,
// one transaction.
//
// A pill row is used rather than a <select> because charting is repetitive and
// one tap beats open-scroll-pick every time.
const $b0d6ec014fedfc25$var$Section = ({ title: title, hint: hint, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            marginBottom: 20
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 8,
                    marginBottom: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        style: {
                            margin: 0,
                            fontSize: 13,
                            fontWeight: 700,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: title
                    }),
                    hint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: hint
                    })
                ]
            }),
            children
        ]
    });
/**
 * Read-only mode, as context rather than a prop threaded through six call
 * sites.
 *
 * Every editable control in this drawer is a `Pill`, so making Pill itself
 * consult the mode means a control added later is read-only by DEFAULT — the
 * failure mode is "a new pill does nothing on a closed visit", not "a new pill
 * silently writes to one".
 */ const $b0d6ec014fedfc25$var$ReadOnlyContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
const $b0d6ec014fedfc25$var$Pill = ({ active: active, onClick: onClick, children: children, tone: tone })=>{
    const readOnly = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($b0d6ec014fedfc25$var$ReadOnlyContext);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        onClick: readOnly ? undefined : onClick,
        disabled: readOnly,
        "aria-pressed": active,
        style: {
            border: `1.5px solid ${active ? tone || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            background: active ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)(tone || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.08) : '#fff',
            color: active ? tone || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
            borderRadius: 999,
            padding: '6px 12px',
            fontSize: 12.5,
            fontWeight: active ? 700 : 500,
            fontFamily: 'inherit',
            cursor: readOnly ? 'default' : 'pointer',
            opacity: readOnly && !active ? 0.6 : 1
        },
        children: children
    });
};
const $b0d6ec014fedfc25$var$PillRow = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6
        },
        children: children
    });
function $b0d6ec014fedfc25$export$2e2bcd8739ae039({ open: open, fdi: fdi, state: state, onClose: onClose, onSave: onSave, saving: saving, focusSurface: focusSurface, t: t, seed: /**
   * A draft to open WITH, rather than the empty one.
   *
   * The one caller is a confirmed AI image finding: ticking «تأیید» on a
   * hotspot opens this drawer with the tooth, the aspect and the value already
   * chosen, and the dentist presses ثبت — or changes it first, which is the
   * entire point of routing a model proposal through the editor instead of
   * writing it to the chart directly.
   *
   * It is a SEED and not a value: the drawer owns the draft from the moment it
   * opens, so anything typed afterwards wins and a re-render cannot reset it.
   */ seed = null, readOnly: /**
   * Open the tooth for READING only — the drawer still shows everything that
   * has been recorded, and offers no way to add to it.
   *
   * The visit workspace passes this once the appointment is completed or
   * cancelled (dent-visit.md's read-only state): the dentist app cannot reopen
   * a finished visit, so charting into one would file a finding under a day
   * that is over, with nothing on screen afterwards to say it arrived late.
   *
   * It hides the COMMIT, not the record. A closed visit's chart is still the
   * patient's chart and must stay readable.
   */ readOnly = false, history: /**
   * What has already happened to this tooth, rendered above the editor.
   *
   * A NODE rather than data, because the two callers of this drawer disagree
   * about what the trail costs: the patient record has the treatments in hand
   * and reads the events lazily behind a toggle, and the visit shows its own
   * trail outside the drawer entirely. The drawer stays ignorant of both and
   * only decides WHERE it goes — first, because «what was done here» is the
   * context for what is about to be recorded.
   */ history = null }) {
    // draft: { presence, condition:{value,material}, surfaces:{ [code]:{value,material} }, note }
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        surfaces: {}
    });
    const [activeSurface, setActiveSurface] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [err, setErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Reset whenever the drawer opens on a different tooth — a draft carried
    // between teeth would record a filling on whichever one was opened next.
    //
    // `seed` is spread over the empty draft rather than replacing it, so a seed
    // that names only a condition still arrives with the `surfaces: {}` every
    // handler below indexes into.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setDraft({
                surfaces: {},
                ...seed || {}
            });
            setErr(null);
            setActiveSurface(focusSurface || null);
        }
    }, [
        open,
        fdi,
        focusSurface,
        seed
    ]);
    // These run even while the drawer is CLOSED — see the hook-order note at
    // the early return below — so every one of them tolerates a null tooth.
    const surfaces = state?.surfacesAvailable?.length ? state.surfacesAvailable : fdi ? (0, $789c06d5db9cfc3f$export$e8e69ffa6db2b2c2)(fdi) : [];
    const missing = (0, $789c06d5db9cfc3f$export$5c3943b5a89fa884)(draft.presence ?? state?.presence);
    const currentOf = (code)=>(state?.surfaces || []).find((s)=>s.surface === code)?.value || null;
    const setSurface = (code, value)=>setDraft((d)=>({
                ...d,
                surfaces: {
                    ...d.surfaces,
                    // Tapping the chosen value again clears the pending edit rather than
                    // recording the same thing twice.
                    [code]: d.surfaces[code]?.value === value ? undefined : {
                        value: value,
                        material: null
                    }
                }
            }));
    const setSurfaceMaterial = (code, material)=>setDraft((d)=>({
                ...d,
                surfaces: {
                    ...d.surfaces,
                    [code]: {
                        ...d.surfaces[code],
                        material: material
                    }
                }
            }));
    // The batch actually sent. Built here so the footer can show a count and
    // disable «ثبت» when there is nothing to save.
    //
    // `buildToothEvents` is in lib/toothDraft.js because the MOBILE tooth sheet
    // emits the same batch from a completely different form. The markup forks;
    // what goes on the wire does not (§1.1).
    const events = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $c6530d73ef205691$export$42d1dcf756bfbad5)(draft, fdi, state), [
        draft,
        fdi,
        state
    ]);
    // EVERY HOOK IS ABOVE THIS LINE, and must stay there.
    //
    // This return used to sit before the useMemo below, which changed the hook
    // COUNT between a closed and an open render — React error #310, thrown the
    // first time a tooth was clicked. React identifies hooks by call order, so a
    // return between two of them is never safe, however obvious the condition
    // looks.
    if (!open || !fdi) return null;
    const submit = async ()=>{
        setErr(null);
        const failure = await onSave(events);
        if (failure) setErr(failure);
        else onClose();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$ReadOnlyContext.Provider, {
        value: readOnly,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$2e2bcd8739ae039), {
            open: open,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "tooth-drawer",
                "data-tooth": fdi,
                style: {
                    display: 'contents'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49383ac93d397699$export$bb68d554ded258ea), {
                        onClose: onClose,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        fontSize: 17,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                                    },
                                    children: [
                                        t('chart.tooth'),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            ...(0, $a278322405d51c25$export$3433559efc22d110),
                                            children: fdi
                                        })
                                    ]
                                }),
                                state?.universal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                    },
                                    children: [
                                        t('chart.universalShort'),
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            ...(0, $a278322405d51c25$export$3433559efc22d110),
                                            children: state.universal
                                        })
                                    ]
                                }),
                                state?.isCharted === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    children: t('chart.notCharted')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49383ac93d397699$export$4ed8420cdfcb2b8f), {
                        children: [
                            history,
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$Section, {
                                title: t('chart.presence.title'),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$PillRow, {
                                    children: (0, $789c06d5db9cfc3f$export$82384a94f00cdd46).map((p)=>{
                                        const active = (draft.presence ?? state?.presence) === p;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$Pill, {
                                            active: active,
                                            tone: p === (0, $789c06d5db9cfc3f$export$52e39c9e8fc17728).PRESENT ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : '#64748b',
                                            onClick: ()=>setDraft((d)=>({
                                                        ...d,
                                                        presence: p
                                                    })),
                                            children: t(`chart.presence.${p}`)
                                        }, p);
                                    })
                                })
                            }),
                            !missing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b0d6ec014fedfc25$var$Section, {
                                        title: t('chart.surfaces.title'),
                                        hint: t('chart.surfaces.hint'),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$PillRow, {
                                                children: surfaces.map((code)=>{
                                                    const pending = draft.surfaces[code]?.value;
                                                    const current = currentOf(code);
                                                    const shown = pending || current;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b0d6ec014fedfc25$var$Pill, {
                                                        active: activeSurface === code,
                                                        tone: shown ? (0, $789c06d5db9cfc3f$export$332b24b8d2f6799)(shown).stroke : undefined,
                                                        onClick: ()=>setActiveSurface(activeSurface === code ? null : code),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                                children: code
                                                            }),
                                                            " \xb7 ",
                                                            t(`chart.surface.${code}`),
                                                            shown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                style: {
                                                                    marginInlineStart: 6,
                                                                    fontSize: 11,
                                                                    opacity: 0.85
                                                                },
                                                                children: [
                                                                    t(`chart.surfaceState.${shown}`),
                                                                    pending && ' *'
                                                                ]
                                                            })
                                                        ]
                                                    }, code);
                                                })
                                            }),
                                            activeSurface && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    marginTop: 10,
                                                    padding: 12,
                                                    borderRadius: 10,
                                                    background: '#f8fafc',
                                                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                            marginBottom: 8
                                                        },
                                                        children: [
                                                            t('chart.surfaces.setFor'),
                                                            " ",
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                                children: t(`chart.surface.${activeSurface}`)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$PillRow, {
                                                        children: (0, $789c06d5db9cfc3f$export$1d0d1c0dec314fe8).map((v)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$Pill, {
                                                                active: draft.surfaces[activeSurface]?.value === v,
                                                                tone: (0, $789c06d5db9cfc3f$export$332b24b8d2f6799)(v).stroke,
                                                                onClick: ()=>setSurface(activeSurface, v),
                                                                children: t(`chart.surfaceState.${v}`)
                                                            }, v))
                                                    }),
                                                    (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('surface', draft.surfaces[activeSurface]?.value).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        style: {
                                                            marginTop: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                style: {
                                                                    fontSize: 12,
                                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                                    marginBottom: 6
                                                                },
                                                                children: t('chart.material')
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$PillRow, {
                                                                children: (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('surface', draft.surfaces[activeSurface]?.value).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$Pill, {
                                                                        active: draft.surfaces[activeSurface]?.material === m,
                                                                        onClick: ()=>setSurfaceMaterial(activeSurface, m),
                                                                        children: t(`chart.materialName.${m}`)
                                                                    }, m))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($b0d6ec014fedfc25$var$Section, {
                                        title: t('chart.condition.title'),
                                        hint: t('chart.condition.hint'),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$PillRow, {
                                                children: (0, $789c06d5db9cfc3f$export$58954b0b7e983b1b).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$Pill, {
                                                        active: draft.condition?.value === c,
                                                        onClick: ()=>setDraft((d)=>({
                                                                    ...d,
                                                                    condition: d.condition?.value === c ? null : {
                                                                        value: c,
                                                                        material: null
                                                                    }
                                                                })),
                                                        children: t(`chart.conditionName.${c}`)
                                                    }, c))
                                            }),
                                            (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('condition', draft.condition?.value).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    marginTop: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                            marginBottom: 6
                                                        },
                                                        children: t('chart.material')
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$PillRow, {
                                                        children: (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('condition', draft.condition?.value).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$Pill, {
                                                                active: draft.condition?.material === m,
                                                                onClick: ()=>setDraft((d)=>({
                                                                            ...d,
                                                                            condition: {
                                                                                ...d.condition,
                                                                                material: m
                                                                            }
                                                                        })),
                                                                children: t(`chart.materialName.${m}`)
                                                            }, m))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b0d6ec014fedfc25$var$Section, {
                                title: t('chart.note.title'),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                    value: draft.note || '',
                                    onChange: (e)=>setDraft((d)=>({
                                                ...d,
                                                note: e.target.value
                                            })),
                                    rows: 2,
                                    placeholder: t('chart.note.placeholder'),
                                    style: {
                                        width: '100%',
                                        padding: 10,
                                        borderRadius: 8,
                                        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                        fontFamily: 'inherit',
                                        fontSize: 13,
                                        resize: 'vertical',
                                        boxSizing: 'border-box'
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    fontSize: 12.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                    cursor: 'pointer'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: !!draft.isHistorical,
                                        onChange: (e)=>setDraft((d)=>({
                                                    ...d,
                                                    isHistorical: e.target.checked
                                                }))
                                    }),
                                    t('chart.isHistorical')
                                ]
                            }),
                            err && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "alert",
                                style: {
                                    marginTop: 14,
                                    padding: 10,
                                    borderRadius: 8,
                                    background: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    color: '#b91c1c',
                                    fontSize: 12.5,
                                    lineHeight: 1.8
                                },
                                children: err.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49383ac93d397699$export$d05a7d25ec5abf06), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                onClick: onClose,
                                disabled: saving,
                                children: readOnly ? t('common.actions.close') : t('common.actions.cancel')
                            }),
                            !readOnly && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                onClick: submit,
                                disabled: saving || events.length === 0,
                                children: saving ? t('common.actions.saving') : `${t('common.actions.save')}${events.length ? ` (${events.length})` : ''}`
                            })
                        ]
                    })
                ]
            })
        })
    });
}


// PNG export — the chart as a document (a referral, a printout).
//
// Serializes a CLONE of the live chart <svg>, injects a patient-context
// header, rasterizes it onto a canvas at 2× and downloads the PNG. The live
// DOM node is NEVER mutated — everything happens on the clone.
//
// Every DOM API on this path (canvas 2D, Image, Blob, URL, XMLSerializer) is
// guarded so the module is inert under jsdom/node: when any of them is
// missing, `exportChartPng` returns early with a clear error instead of
// half-downloading. No test renders the PNG itself — the guards are the
// testable surface.
//
// FONTS: the SVG is rasterized as a STANDALONE document, so the app's webfont
// is not guaranteed inside it. The Persian glyphs of the two permanent
// «راست بیمار» / «چپ بیمار» side markers may therefore fall back to the system
// font in the PNG. Accepted deliberately: embedding the font would add ~50 KB
// to every export for two small labels.

const $3fc1a6f2dc9b6a88$var$SVG_NS = 'http://www.w3.org/2000/svg';
const $3fc1a6f2dc9b6a88$var$HEADER_H = 26; // viewBox units added above the chart for the header
const $3fc1a6f2dc9b6a88$var$SCALE = 2; // rasterization factor — crisp enough to print
function $3fc1a6f2dc9b6a88$export$547f20e16aca96d1(patientId, date = new Date()) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `odontogram-${patientId}-${y}${m}${d}.png`;
}
async function $3fc1a6f2dc9b6a88$export$bb74a4b3702605c({ svgEl: svgEl, patientId: patientId, header: header }) {
    if (typeof document === 'undefined' || typeof Image === 'undefined' || typeof Blob === 'undefined' || typeof URL === 'undefined' || !URL.createObjectURL || typeof XMLSerializer === 'undefined') return {
        ok: false,
        error: 'unsupported'
    };
    if (!svgEl) return {
        ok: false,
        error: 'no-svg'
    };
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext && canvas.getContext('2d');
    // jsdom lands here: it has document/Image/Blob but no canvas backend.
    if (!ctx || !canvas.toBlob) return {
        ok: false,
        error: 'unsupported'
    };
    const box = (svgEl.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number);
    if (box.length !== 4 || box.some((n)=>!Number.isFinite(n))) return {
        ok: false,
        error: 'no-svg'
    };
    const [minX, minY, w, h] = box;
    // Clone, then make the clone a self-contained document: explicit pixel
    // dimensions (the live node's width:100% / max-width CSS would clamp a
    // standalone rasterization), an explicit xmlns for the serializer, and the
    // same direction:ltr the live chart pins — the anatomical frame must hold
    // in the export exactly as on screen (CORE.md §9).
    const clone = svgEl.cloneNode(true);
    clone.removeAttribute('style');
    clone.setAttribute('xmlns', $3fc1a6f2dc9b6a88$var$SVG_NS);
    clone.setAttribute('direction', 'ltr');
    clone.setAttribute('font-family', 'sans-serif'); // see FONTS note above
    clone.setAttribute('viewBox', `${minX} ${minY - $3fc1a6f2dc9b6a88$var$HEADER_H} ${w} ${h + $3fc1a6f2dc9b6a88$var$HEADER_H}`);
    clone.setAttribute('width', String(w * $3fc1a6f2dc9b6a88$var$SCALE));
    clone.setAttribute('height', String((h + $3fc1a6f2dc9b6a88$var$HEADER_H) * $3fc1a6f2dc9b6a88$var$SCALE));
    // The patient-context header, injected into the CLONE only. World
    // coordinates, unrotated (text stays upright), LTR — it is an id + a date.
    const text = document.createElementNS($3fc1a6f2dc9b6a88$var$SVG_NS, 'text');
    text.setAttribute('x', String(minX + 10));
    text.setAttribute('y', String(minY - $3fc1a6f2dc9b6a88$var$HEADER_H + 17));
    text.setAttribute('font-size', '12');
    text.setAttribute('font-weight', '700');
    text.setAttribute('fill', (0, $789c06d5db9cfc3f$export$46572491bf07a861).exportHeader);
    text.setAttribute('direction', 'ltr');
    text.textContent = header || String(patientId ?? '');
    clone.insertBefore(text, clone.firstChild);
    const svgUrl = URL.createObjectURL(new Blob([
        new XMLSerializer().serializeToString(clone)
    ], {
        type: 'image/svg+xml;charset=utf-8'
    }));
    try {
        const img = await new Promise((resolve, reject)=>{
            const i = new Image();
            i.onload = ()=>resolve(i);
            i.onerror = ()=>reject(new Error('svg-load'));
            i.src = svgUrl;
        });
        canvas.width = w * $3fc1a6f2dc9b6a88$var$SCALE;
        canvas.height = (h + $3fc1a6f2dc9b6a88$var$HEADER_H) * $3fc1a6f2dc9b6a88$var$SCALE;
        ctx.fillStyle = (0, $789c06d5db9cfc3f$export$46572491bf07a861).exportBackground;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const pngBlob = await new Promise((resolve)=>canvas.toBlob(resolve, 'image/png'));
        if (!pngBlob) return {
            ok: false,
            error: 'raster'
        };
        const fileName = $3fc1a6f2dc9b6a88$export$547f20e16aca96d1(patientId);
        const a = document.createElement('a');
        const pngUrl = URL.createObjectURL(pngBlob);
        a.href = pngUrl;
        a.download = fileName;
        a.rel = 'noopener';
        a.click();
        // Revoke on the next macrotask turn — the click's navigation has started
        // by then, and holding the URL longer only leaks the blob.
        setTimeout(()=>URL.revokeObjectURL(pngUrl), 0);
        return {
            ok: true,
            fileName: fileName
        };
    } catch  {
        return {
            ok: false,
            error: 'raster'
        };
    } finally{
        URL.revokeObjectURL(svgUrl);
    }
}


// The odontogram's data layer.
//
// One read (the whole mouth) and one write (a batch of facts). The chart is
// small — 52 teeth — so it is refetched whole after a write rather than
// patched locally: a client-side patch is a second implementation of the
// server's fold, and the two disagreeing is how a dentist ends up looking at a
// tooth state that was never saved.

var $acw62 = parcelRequire("acw62");

const $b11e9ffe8c3f2849$var$TOOTH_STATE_FIELDS = `
  toothFdi
  isPermanent
  isAnterior
  universal
  surfacesAvailable
  presence
  isCharted
  lastRecordedAtMs
  conditions { value material eventId isHistorical atMs note }
  surfaces { surface value material eventId isHistorical atMs }
  notes { eventId text atMs actorId }
`;
const $b11e9ffe8c3f2849$export$d183f8fe2ed7e9bb = `
  query DentalChart($patientId: ID!, $clinicId: ID) {
    dentalChart(patientId: $patientId, clinicId: $clinicId) {
      patientId
      summary { chartedTeeth present missing decayed restored dmft }
      teeth { ${$b11e9ffe8c3f2849$var$TOOTH_STATE_FIELDS} }
    }
  }
`;
const $b11e9ffe8c3f2849$export$beda99f18aa6ed02 = `
  mutation RecordToothEvents($patientId: ID!, $clinicId: ID, $events: [ToothEventInput!]!) {
    recordToothEvents(patientId: $patientId, clinicId: $clinicId, events: $events) {
      id toothFdi aspect surface value material recordedAtMs
    }
  }
`;
const $b11e9ffe8c3f2849$export$cffc0315620ec7f2 = `
  query ToothHistory($patientId: ID!, $toothFdi: String!) {
    toothHistory(patientId: $patientId, toothFdi: $toothFdi) {
      id aspect surface value material note isHistorical
      actorId actorType recordedAtMs occurredAtMs voidedAtMs voidReason
      sourceRecordId
    }
  }
`;
const $b11e9ffe8c3f2849$export$2bf317c5c703ca27 = `
  mutation VoidToothEvent($eventId: ID!, $reason: String) {
    voidToothEvent(eventId: $eventId, reason: $reason)
  }
`;
function $b11e9ffe8c3f2849$export$e3f31f0e2006ba13({ patientId: patientId, toothFdi: toothFdi, enabled: enabled }) {
    const [events, setEvents] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wanted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(toothFdi);
    wanted.current = toothFdi;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!enabled || !patientId || !toothFdi) {
            setEvents([]);
            return undefined;
        }
        let alive = true;
        const asked = toothFdi;
        setLoading(true);
        setError(null);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($b11e9ffe8c3f2849$export$cffc0315620ec7f2, {
            patientId: patientId,
            toothFdi: asked
        }).then((data)=>{
            if (!alive || wanted.current !== asked) return;
            setEvents(data?.toothHistory || []);
        }).catch((err)=>{
            if (!alive || wanted.current !== asked) return;
            console.error('[useToothHistory] failed:', err?.message);
            setError(err);
        }).finally(()=>{
            if (alive && wanted.current === asked) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        patientId,
        toothFdi,
        enabled
    ]);
    return {
        events: events,
        loading: loading,
        error: error
    };
}
function $b11e9ffe8c3f2849$export$26586bb2073aa39c({ patientId: patientId, clinicId: clinicId }) {
    const [chart, setChart] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Guards a slow response for a patient the dentist has already navigated
    // away from — it must never paint over the chart now on screen.
    const wantedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(patientId);
    wantedRef.current = patientId;
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        if (!patientId) return;
        const asked = patientId;
        if (initial) setLoading(true);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)($b11e9ffe8c3f2849$export$d183f8fe2ed7e9bb, {
                patientId: asked,
                clinicId: clinicId || null
            });
            if (wantedRef.current !== asked) return;
            setChart(data?.dentalChart || null);
            setError(null);
        } catch (err) {
            if (wantedRef.current !== asked) return;
            console.error('[useDentalChart] load failed:', err?.message);
            // A failed BACKGROUND refresh keeps the chart on screen: stale teeth are
            // more use to a dentist mid-treatment than an error card replacing them.
            if (initial) setError(err);
        } finally{
            if (initial && wantedRef.current === asked) setLoading(false);
        }
    }, [
        patientId,
        clinicId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            initial: true
        });
    }, [
        load
    ]);
    /** Record a batch. Resolves to null on success, or the Error on failure, so
   *  the caller can keep the drawer open and show why. */ const record = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (events)=>{
        if (!events?.length) return null;
        setSaving(true);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($b11e9ffe8c3f2849$export$beda99f18aa6ed02, {
                patientId: patientId,
                clinicId: clinicId || null,
                events: events
            });
            await load(); // refetch: the server owns the fold
            return null;
        } catch (err) {
            console.error('[useDentalChart] record failed:', err?.message);
            return err;
        } finally{
            setSaving(false);
        }
    }, [
        patientId,
        clinicId,
        load
    ]);
    const teeth = chart?.teeth || [];
    const byFdi = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const map = {};
        for (const s of teeth)map[s.toothFdi] = s;
        return map;
    }, [
        teeth
    ]);
    return {
        chart: chart,
        teeth: teeth,
        byFdi: byFdi,
        summary: chart?.summary || null,
        loading: loading,
        error: error,
        saving: saving,
        record: record,
        reload: ()=>load({
                initial: true
            })
    };
}
var $b11e9ffe8c3f2849$export$2e2bcd8739ae039 = $b11e9ffe8c3f2849$export$26586bb2073aa39c;


// جلسهٔ درمان — the visit workspace's data layer.
//
// One hook per concern, all in this file because they share one rule: EVERY ONE
// OF THEM IS SCOPED TO THE VISIT the header resolved, never to the id in the
// URL. `useVisit` reads the appointment and hands back the patient id the
// SERVER says it belongs to; every other hook takes that id. A screen that
// reads the patient from the path and the visit from the id can be made to
// paint one patient's chart under another's name by editing the address bar,
// and the BFF's double scope check would not stop it — both ids would be the
// caller's own.
//
// Nothing here polls. امروز polls because the desk changes it underneath the
// dentist; a visit is changed by the person looking at it, so a refetch happens
// after a write and not on a timer.

var $acw62 = parcelRequire("acw62");


/**
 * A load that cannot be overtaken by a slower one for a different subject.
 *
 * Every hook here can be re-pointed while a request is in flight — the dentist
 * moves from one visit to the next — and a stale response painting over the
 * current one is the failure this exists to prevent. The pattern is the same
 * one useDentalChart uses; it is repeated rather than abstracted because the
 * "asked" key differs per hook and an abstraction over it hid the bug once.
 */ function $cfeee402cf40bab0$var$useGuardedLoad(key) {
    const wanted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(key);
    wanted.current = key;
    return wanted;
}
/**
 * The state every «پیشنهاد هوش مصنوعی» button on this screen shares.
 *
 * Four of them now (تشخیص, پرسش‌ها, دستورات, دارو) and they all obey the same
 * three rules, so the rules live here once rather than four times:
 *
 *  1. NOTHING LOADS BY ITSELF. Every one of these calls bills a credit, so the
 *     pane opens with a button, never with a bill.
 *  2. The CREDIT case gets its own branch. «شارژ کنید» is actionable and
 *     «در دسترس نیست» is not — the same split نسخه makes for its sweep.
 *  3. `data === null` means NOT ASKED YET, which is a different thing from an
 *     empty answer. Rendering «پیشنهادی نیست» for a button nobody pressed is
 *     the bug this distinction prevents.
 */ function $cfeee402cf40bab0$var$useAiSuggestions(label, run) {
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const ask = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (...args)=>{
        setLoading(true);
        setError(null);
        try {
            setData(await run(...args));
            return null;
        } catch (err) {
            console.error(`[${label}] failed:`, err?.message);
            setError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable');
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        label,
        run
    ]);
    // Dismissed or acted on, a suggestion set leaves the screen the same way.
    const clear = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setData(null);
        setError(null);
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        ask: ask,
        clear: clear
    };
}
function $cfeee402cf40bab0$export$8ad4ab361a8a3764(appointmentId) {
    const [visit, setVisit] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [completing, setCompleting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(appointmentId);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!appointmentId) {
            setLoading(false);
            return undefined;
        }
        let alive = true;
        const asked = appointmentId;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$512faac54c275f2e), {
            appointmentId: asked
        }).then((data)=>{
            if (!alive || wanted.current !== asked) return;
            // null is NOT_FOUND — or a walk-in with no patient record. The screen
            // renders that as its own state; it is not an error and offers no retry.
            setVisit(data?.visit || null);
            setError(null);
        }).catch((err)=>{
            if (!alive || wanted.current !== asked) return;
            console.error('[useVisit] failed:', err?.message);
            setError(err);
        }).finally(()=>{
            if (alive && wanted.current === asked) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        appointmentId,
        nonce,
        wanted
    ]);
    /**
   * What the last close did about «نوبت بعدی» — raised | refreshed |
   * nothing_outstanding | declined | already_booked | unavailable.
   *
   * A REF, not state, and deliberately: the screen reads it in the same tick it
   * awaits `complete`, and a state update would not have flushed by then. It is
   * also not part of `visit` — it is what one close DID, not a property of the
   * appointment, and a copy stored on the row would age the moment the plan moved.
   */ const followUpOutcome = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    /**
   * «پایان جلسه» — close the visit.
   *
   * Resolves to null on success or the Error on failure, the shape every write
   * on this screen uses. The caller flushes unsaved work first and skips this
   * entirely when that flush failed: `completed` is terminal for this BFF, so a
   * close that lands before the note does loses the note for good.
   *
   * `followUp` is what the dentist answered about the patient's next visit, and
   * the outcome lands on `followUpOutcome.current`.
   */ const complete = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (patientId, followUp = null)=>{
        setCompleting(true);
        try {
            // `followUp` is what the dentist answered about «نوبت بعدی». Omitted
            // entirely when null — saying nothing is NOT «لازم نیست», and the service
            // still tells the desk, with its default interval.
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$a415b6f5d9b3134c), {
                patientId: patientId,
                appointmentId: appointmentId,
                ...followUp ? {
                    followUp: followUp
                } : {}
            });
            // Patch rather than refetch: the mutation already answered with the row
            // it wrote, and a reload here would race the desk touching the same
            // appointment. `reload` stays available for the ordinary path.
            setVisit((v)=>v ? {
                    ...v,
                    ...data?.completeVisit || {}
                } : v);
            followUpOutcome.current = data?.completeVisit?.followUpOutcome || null;
            return null;
        } catch (err) {
            console.error('[useVisit] complete failed:', err?.message);
            return err;
        } finally{
            setCompleting(false);
        }
    }, [
        appointmentId
    ]);
    return {
        visit: visit,
        loading: loading,
        error: error,
        completing: completing,
        complete: complete,
        followUpOutcome: followUpOutcome,
        reload: ()=>setNonce((n)=>n + 1)
    };
}
function $cfeee402cf40bab0$export$2f317b9dd5652683({ patientId: patientId, appointmentId: appointmentId }) {
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    /**
   * Bumped on every successful save.
   *
   * The note's `id` does NOT change when it is revised — the row is updated in
   * place — so a form that re-syncs on `note.id` never notices a write made
   * somewhere else. That is a real loop on this screen: answering a question in
   * پرسش‌ها appends a finding to the same note the subjective form is bound to.
   * Without this the dentist never saw the appended finding, and their next
   * «ذخیره» wrote the stale text back over it.
   */ const [revision, setRevision] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(appointmentId);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        if (!patientId || !appointmentId) {
            setLoading(false);
            return;
        }
        const asked = appointmentId;
        if (initial) setLoading(true);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$4cf273fa9ac8cacd), {
                patientId: patientId,
                appointmentId: asked
            });
            if (wanted.current !== asked) return;
            setNote(data?.visitNote || null);
            setError(null);
        } catch (err) {
            if (wanted.current !== asked) return;
            console.error('[useVisitNote] failed:', err?.message);
            if (initial) setError(err);
        } finally{
            if (initial && wanted.current === asked) setLoading(false);
        }
    }, [
        patientId,
        appointmentId,
        wanted
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            initial: true
        });
    }, [
        load
    ]);
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (patch)=>{
        setSaving(true);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$6ae6c77977d8a05b), {
                patientId: patientId,
                appointmentId: appointmentId,
                ...patch
            });
            setNote(data?.saveVisitNote || null);
            setRevision((n)=>n + 1);
            return null;
        } catch (err) {
            console.error('[useVisitNote] save failed:', err?.message);
            return err;
        } finally{
            setSaving(false);
        }
    }, [
        patientId,
        appointmentId
    ]);
    return {
        note: note,
        revision: revision,
        loading: loading,
        error: error,
        saving: saving,
        save: save,
        reload: ()=>load({
                initial: true
            })
    };
}
function $cfeee402cf40bab0$export$1769a418b08dd895({ patientId: patientId, appointmentId: appointmentId }) {
    const [visits, setVisits] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(appointmentId);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!patientId || !appointmentId) {
            setLoading(false);
            return undefined;
        }
        let alive = true;
        const asked = appointmentId;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$6aafaa5b4bb80bb4), {
            patientId: patientId,
            appointmentId: asked,
            limit: 10
        }).then((data)=>{
            if (!alive || wanted.current !== asked) return;
            setVisits(data?.priorVisits || []);
        }).catch((err)=>{
            // Swallowed on purpose: a missing history strip must not take the
            // subjective down with it.
            if (alive) console.error('[usePriorVisits] failed:', err?.message);
        }).finally(()=>{
            if (alive && wanted.current === asked) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        patientId,
        appointmentId,
        wanted
    ]);
    return {
        visits: visits,
        loading: loading
    };
}
function $cfeee402cf40bab0$export$29b2b9621f2e7a20({ patientId: patientId, clinicId: clinicId, appointmentId: appointmentId }) {
    const [plans, setPlans] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // WHAT WAS ACTUALLY DONE — the other half of this screen, and the half the
    // plan cannot answer. A quote says what was agreed; only a record says it
    // happened, who did it, on which surfaces and with what. They load together
    // because «جلسهٔ ۲ از ۳» on a plan line is a fact about the records, so a
    // screen holding one without the other would draw a session count it cannot
    // justify.
    const [records, setRecords] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // What a plan LINE may name — procedures, surgeries and follow-ups. NOT the
    // order catalogue: an order is work sent elsewhere, a treatment is work the
    // dentist does, and quoting a radiograph as a treatment is a quote for the
    // wrong thing on a document the patient signs.
    const [catalog, setCatalog] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // A catalogue that could not be READ is not a clinic with no services, and
    // the plan section says two different things about them: one sends the
    // dentist to «کالا و خدمات» to define twenty services, and doing that during
    // an accounting outage sends them to redefine twenty they already have.
    const [catalogError, setCatalogError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(patientId);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        if (!patientId) {
            setLoading(false);
            return;
        }
        const asked = patientId;
        if (initial) setLoading(true);
        // The plans are the record and the catalogue is reference data. Settled
        // separately: a catalogue that fails to load still leaves the dentist able
        // to READ the plan and move its lines along.
        const [plansRes, catalogRes, recordsRes] = await Promise.allSettled([
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$17160a4cc503e72e), {
                patientId: patientId,
                clinicId: clinicId || null
            }),
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$225549b931c14bb0), {
                clinicId: clinicId || null
            }),
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$80e65e29894beb41), {
                patientId: patientId,
                clinicId: clinicId || null
            })
        ]);
        if (wanted.current !== asked) return;
        if (plansRes.status === 'fulfilled') {
            setPlans(plansRes.value?.treatmentPlans || []);
            setError(null);
        } else {
            console.error('[useTreatmentPlans] failed:', plansRes.reason?.message);
            if (initial) setError(plansRes.reason);
        }
        if (catalogRes.status === 'fulfilled') {
            setCatalog(catalogRes.value?.dentalTreatmentCatalog || []);
            setCatalogError(null);
        } else {
            console.error('[useTreatmentPlans] catalogue failed:', catalogRes.reason?.message);
            setCatalog([]);
            // THREE different things, and the screen says three different things.
            // CLINIC_REQUIRED means this visit names no clinic (or the dentist works
            // at several and none was chosen) — retrying will never fix it, and
            // telling them to «try again» is worse than telling them nothing.
            setCatalogError({
                error: catalogRes.reason,
                kind: (0, $206625c7d33bd390$export$dbfe74f291058e97)(catalogRes.reason) === 'CLINIC_REQUIRED' ? 'noClinic' : 'unavailable'
            });
        }
        if (recordsRes.status === 'fulfilled') setRecords(recordsRes.value?.treatmentRecords || []);
        else // Settled apart from the plans on purpose. A records read that fails must
        // not blank the plan: the dentist can still see and move the quote, and
        // the session counts fall back to the line's own status — which is
        // exactly what they were before records existed.
        console.error('[useTreatmentPlans] records failed:', recordsRes.reason?.message);
        if (initial) setLoading(false);
    }, [
        patientId,
        clinicId,
        wanted
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            initial: true
        });
    }, [
        load
    ]);
    const run = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (doc, variables)=>{
        setSaving(true);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)(doc, variables);
            await load();
            return null;
        } catch (err) {
            console.error('[useTreatmentPlans] write failed:', err?.message);
            return err;
        } finally{
            setSaving(false);
        }
    }, [
        load
    ]);
    const plan = (0, $0cd549c1a257ae26$export$9e890aca5c4be77f)(plans);
    /**
   * Add one line.
   *
   * The service has no per-item RPC — items are REPLACED as a set — so adding
   * means sending the list we want. The existing items are re-sent by value and
   * not by id for exactly the reason typeDefs/plan.js gives: ids are reissued on
   * replace, so a patch keyed on a stale read removes the wrong line.
   */ const addItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((item)=>{
        const asInput = (i)=>({
                // Sent back for every EXISTING line, which is what keeps its id across
                // the replace. A treatment recorded against a line would otherwise be
                // orphaned by adding a second line to the plan.
                id: i.id || null,
                phase: i.phase || 'phase1',
                catalogId: i.catalogId,
                toothFdi: i.toothFdi || null,
                surfaces: i.surfaces || null,
                description: i.description || null,
                status: i.status || 'proposed',
                sortOrder: i.sortOrder ?? 0,
                quantity: i.quantity || 1
            });
        // No open plan, or the open one is SIGNED — either way the line starts a
        // new course. A signed plan is what the patient agreed to and its lines
        // cannot change (the price lock), so appending to it would be refused by
        // the service; the dentist needs somewhere for the new treatment to go, and
        // a second course is what actually happens in a clinic.
        if (!plan || plan.approvedAtMs) return run((0, $0cd549c1a257ae26$export$849b53aa3ba97fa1), {
            patientId: patientId,
            clinicId: clinicId || null,
            title: null,
            items: [
                asInput({
                    ...item,
                    sortOrder: 0
                })
            ]
        });
        const items = [
            ...(plan.items || []).map(asInput),
            asInput({
                ...item,
                sortOrder: (plan.items || []).length
            })
        ];
        return run((0, $0cd549c1a257ae26$export$653ed1769de23b83), {
            planId: plan.id,
            items: items
        });
    }, [
        plan,
        patientId,
        clinicId,
        run
    ]);
    const removeItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((itemId)=>{
        if (!plan) return Promise.resolve(null);
        const items = (plan.items || []).filter((i)=>i.id !== itemId).map((i, index)=>({
                id: i.id,
                phase: i.phase,
                catalogId: i.catalogId,
                toothFdi: i.toothFdi || null,
                surfaces: i.surfaces || null,
                description: i.description || null,
                status: i.status,
                sortOrder: index,
                quantity: i.quantity || 1
            }));
        return run((0, $0cd549c1a257ae26$export$653ed1769de23b83), {
            planId: plan.id,
            items: items
        });
    }, [
        plan,
        run
    ]);
    const setItemStatus = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((itemId, status)=>plan ? run((0, $0cd549c1a257ae26$export$66c7a31c01734817), {
            planId: plan.id,
            itemId: itemId,
            status: status
        }) : Promise.resolve(null), [
        plan,
        run
    ]);
    /**
   * THE LOCK — «تأیید پلن».
   *
   * Irreversible, and the one call on this screen that is. The amounts are NOT
   * sent: the BFF reads them from the clinic's own declarations at the moment
   * of signing, so a browser cannot name the number that goes onto a document
   * a patient signs.
   */ const approve = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(({ approvedByPatient: approvedByPatient = true } = {})=>plan ? run((0, $0cd549c1a257ae26$export$62e5bc55ca1f47a0), {
            planId: plan.id,
            approvedByPatient: approvedByPatient
        }) : Promise.resolve(null), [
        plan,
        run
    ]);
    /**
   * «خدمت جدید» — define a service for the CLINIC, from the chair (D3).
   *
   * The new entry is pushed onto the local catalogue immediately rather than
   * waited for on a refetch: the dentist pressed this because the list did not
   * have what they wanted, and making them hunt for it again afterwards is the
   * same problem twice. `load()` still runs, so the authoritative list replaces
   * this one a moment later.
   *
   * Returns { entry } on success and { error } on failure, rather than the bare
   * error the other writes return, because the caller needs the new service's
   * id to select it.
   */ const createService = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        setSaving(true);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$9dc71384dbf426d1), {
                clinicId: clinicId || null,
                input: input
            });
            const entry = data?.createClinicService;
            if (entry) setCatalog((prev)=>[
                    ...prev,
                    entry
                ]);
            load();
            return {
                entry: entry
            };
        } catch (err) {
            console.error('[useTreatmentPlans] createClinicService failed:', err?.message);
            return {
                error: err
            };
        } finally{
            setSaving(false);
        }
    }, [
        clinicId,
        load
    ]);
    /**
   * «ثبت انجام» — the work, not the quote.
   *
   * ONE clinical act: the record, the chart change it caused and the plan line
   * it finished land together or not at all, in the service. Billing and stock
   * are separate writes made after it, so a failure of either cannot lose the
   * clinical fact — `billingState` / `stockState` say how far they got.
   *
   * `load()` afterwards rather than pushing the row in locally: recording may
   * also have moved the plan line to «انجام‌شده» and written to the chart, and
   * a local insert would show the record beside a line that still says
   * پذیرفته‌شده until something else happened to refetch.
   */ const recordTreatment = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        setSaving(true);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$5b85ae2a03d3fc5a), {
                patientId: patientId,
                clinicId: clinicId || null,
                input: {
                    ...input,
                    appointmentId: input.appointmentId || appointmentId
                }
            });
            await load();
            return {
                record: data?.recordTreatment
            };
        } catch (err) {
            console.error('[useTreatmentPlans] recordTreatment failed:', err?.message);
            return {
                error: err
            };
        } finally{
            setSaving(false);
        }
    }, [
        patientId,
        clinicId,
        appointmentId,
        load
    ]);
    /**
   * «ابطال» — strike it out. The row stays, with its reason.
   *
   * Resolves `{ error, chargeReversed }`. A billed treatment's charge is taken
   * back by the BFF through the order's session
   * (docs/TREATMENT_PROCESS_AND_SERVICE_BUNDLES_PLAN.md §5.4); `chargeReversed`
   * false means it could NOT be and still stands, null that there was none.
   */ const voidRecord = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(// `voidChartEvents` strikes out the chart change this treatment made, in the
    // same transaction. The dialog asks; it is never assumed here, because a
    // void of a BILLING duplicate leaves a tooth that really is crowned.
    async (recordId, reason, voidChartEvents = false)=>{
        setSaving(true);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$3c9c0cef7c22edda), {
                patientId: patientId,
                recordId: recordId,
                reason: reason,
                voidChartEvents: voidChartEvents
            });
            await load();
            return {
                error: null,
                chargeReversed: data?.voidTreatmentRecord?.chargeReversed ?? null
            };
        } catch (err) {
            console.error('[useTreatmentPlans] void failed:', err?.message);
            return {
                error: err,
                chargeReversed: null
            };
        } finally{
            setSaving(false);
        }
    }, [
        patientId,
        load
    ]);
    return {
        plans: plans,
        plan: plan,
        catalog: catalog,
        catalogError: catalogError,
        loading: loading,
        error: error,
        saving: saving,
        records: records,
        addItem: addItem,
        removeItem: removeItem,
        setItemStatus: setItemStatus,
        approve: approve,
        createService: createService,
        recordTreatment: recordTreatment,
        voidRecord: voidRecord,
        reload: ()=>load({
                initial: true
            })
    };
}
function $cfeee402cf40bab0$export$8aa70abf9bd71082({ patientId: patientId, appointmentId: appointmentId }) {
    const [medications, setMedications] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(appointmentId);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        if (!patientId || !appointmentId) {
            setLoading(false);
            return;
        }
        const asked = appointmentId;
        if (initial) setLoading(true);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$aac7d3d2f39b3cb), {
                patientId: patientId,
                appointmentId: asked
            });
            if (wanted.current !== asked) return;
            setMedications(data?.listMedications || []);
        } catch (err) {
            // Supplementary: the prescribing form still works without the list of
            // what was already written.
            console.error('[useVisitMedications] failed:', err?.message);
        } finally{
            if (initial && wanted.current === asked) setLoading(false);
        }
    }, [
        patientId,
        appointmentId,
        wanted
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            initial: true
        });
    }, [
        load
    ]);
    // COSTS PARSINA CREDITS. The button on the دارو tab, and nothing else — the
    // interaction sweep beside it is a separate billed call on its own debounce,
    // and this must never ride along with it.
    const suggestions = $cfeee402cf40bab0$var$useAiSuggestions('useVisitMedications.suggest', (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$69475176a670f48d), {
            patientId: patientId,
            appointmentId: appointmentId
        });
        return data?.medicationSuggestions || {
            items: [],
            followUpTimeline: null
        };
    }, [
        patientId,
        appointmentId
    ]));
    return {
        medications: medications,
        loading: loading,
        reload: ()=>load(),
        suggestions: suggestions.data,
        suggesting: suggestions.loading,
        suggestError: suggestions.error,
        suggest: suggestions.ask,
        clearSuggestions: suggestions.clear
    };
}
function $cfeee402cf40bab0$export$cb19eb17ebbbed5({ patientId: patientId, appointmentId: appointmentId, clinicId: clinicId }) {
    const [orders, setOrders] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [catalog, setCatalog] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(appointmentId);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        // `patientId` is the gate even though this read does not use it: it is null
        // until the VISIT HEADER resolves, and so is `clinicId`. Without it this
        // hook fires once with no clinic and again with one — two wasted requests
        // per visit open, and a catalogue briefly missing the clinic's own rows.
        // Every other hook here waits for the same signal; this one did not.
        if (!appointmentId || !patientId) {
            setLoading(false);
            return;
        }
        const asked = appointmentId;
        if (initial) setLoading(true);
        // The catalogue is reference data and the orders are the record. Fired
        // together, settled separately: a catalogue that fails to load leaves the
        // dentist able to READ their orders, which is more than half the tab.
        const [ordersRes, catalogRes] = await Promise.allSettled([
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$9df8d3fcfc0d6821), {
                appointmentId: asked
            }),
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$e8f901dd17836000), {
                orderType: null,
                clinicId: clinicId || null
            })
        ]);
        if (wanted.current !== asked) return;
        if (ordersRes.status === 'fulfilled') {
            setOrders(ordersRes.value?.visitOrders || []);
            setError(null);
        } else if (initial) {
            console.error('[useVisitOrders] failed:', ordersRes.reason?.message);
            setError(ordersRes.reason);
        }
        if (catalogRes.status === 'fulfilled') setCatalog(catalogRes.value?.dentalOrderCatalog || []);
        if (initial) setLoading(false);
    }, [
        appointmentId,
        patientId,
        clinicId,
        wanted
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            initial: true
        });
    }, [
        load
    ]);
    const create = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        setSaving(true);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$11d6279dbbc74916), {
                patientId: patientId,
                appointmentId: appointmentId,
                ...input
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitOrders] create failed:', err?.message);
            return err;
        } finally{
            setSaving(false);
        }
    }, [
        patientId,
        appointmentId,
        load
    ]);
    const setStatus = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (orderId, transition)=>{
        setSaving(true);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$5318d282c9f591fb), {
                appointmentId: appointmentId,
                orderId: orderId,
                transition: transition
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitOrders] transition failed:', err?.message);
            return err;
        } finally{
            setSaving(false);
        }
    }, [
        appointmentId,
        load
    ]);
    // COSTS PARSINA CREDITS. Only ever called from the button.
    const suggestions = $cfeee402cf40bab0$var$useAiSuggestions('useVisitOrders.suggest', (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$b96ec224ac32a5ad), {
            patientId: patientId,
            appointmentId: appointmentId
        });
        return data?.visitOrderSuggestions || {
            items: [],
            rationale: null,
            droppedCount: 0
        };
    }, [
        patientId,
        appointmentId
    ]));
    return {
        orders: orders,
        catalog: catalog,
        loading: loading,
        error: error,
        saving: saving,
        create: create,
        setStatus: setStatus,
        reload: ()=>load({
                initial: true
            }),
        suggestions: suggestions.data,
        suggesting: suggestions.loading,
        suggestError: suggestions.error,
        suggest: suggestions.ask,
        clearSuggestions: suggestions.clear
    };
}
function $cfeee402cf40bab0$export$a7f91475e840e5fe({ patientId: patientId, appointmentId: appointmentId }) {
    const [diagnoses, setDiagnoses] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [differential, setDifferential] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [suggesting, setSuggesting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [suggestError, setSuggestError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(appointmentId);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        if (!patientId || !appointmentId) {
            setLoading(false);
            return;
        }
        const asked = appointmentId;
        if (initial) setLoading(true);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$11ffaf5d5da7263c), {
                patientId: patientId,
                appointmentId: asked
            });
            if (wanted.current !== asked) return;
            setDiagnoses(data?.visitDiagnoses || []);
            setError(null);
        } catch (err) {
            if (wanted.current !== asked) return;
            console.error('[useVisitDiagnoses] failed:', err?.message);
            if (initial) setError(err);
        } finally{
            if (initial && wanted.current === asked) setLoading(false);
        }
    }, [
        patientId,
        appointmentId,
        wanted
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            initial: true
        });
    }, [
        load
    ]);
    /** COSTS PARSINA CREDITS. Only ever called from a button. */ const suggest = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        setSuggesting(true);
        setSuggestError(null);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$28f15e67f10e46f2), {
                patientId: patientId,
                appointmentId: appointmentId
            });
            setDifferential(data?.visitDifferential || []);
            return null;
        } catch (err) {
            console.error('[useVisitDiagnoses] differential failed:', err?.message);
            // The credit case gets its own branch because "top up" is actionable and
            // "unavailable" is not — the same split نسخه makes for its sweep.
            setSuggestError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable');
            return err;
        } finally{
            setSuggesting(false);
        }
    }, [
        patientId,
        appointmentId
    ]);
    const record = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        setSaving(true);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$e4dfe19fcbbce380), {
                patientId: patientId,
                appointmentId: appointmentId,
                ...input
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitDiagnoses] record failed:', err?.message);
            return err;
        } finally{
            setSaving(false);
        }
    }, [
        patientId,
        appointmentId,
        load
    ]);
    const remove = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (diagnosisId)=>{
        setSaving(true);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$c31d57401ee1a145), {
                patientId: patientId,
                diagnosisId: diagnosisId
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitDiagnoses] delete failed:', err?.message);
            return err;
        } finally{
            setSaving(false);
        }
    }, [
        patientId,
        load
    ]);
    return {
        diagnoses: diagnoses,
        loading: loading,
        error: error,
        saving: saving,
        record: record,
        remove: remove,
        differential: differential,
        suggesting: suggesting,
        suggestError: suggestError,
        suggest: suggest,
        reload: ()=>load({
                initial: true
            })
    };
}
function $cfeee402cf40bab0$export$ab4de818ea42408e({ patientId: patientId, appointmentId: appointmentId }) {
    const [questions, setQuestions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loadingQuestions, setLoadingQuestions] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [questionsError, setQuestionsError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [answers, setAnswers] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [asking, setAsking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [askError, setAskError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    /** COSTS PARSINA CREDITS. */ const generate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ diagnoses: diagnoses = [] } = {})=>{
        setLoadingQuestions(true);
        setQuestionsError(null);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$28edc0ee0a4c0a1), {
                patientId: patientId,
                appointmentId: appointmentId,
                diagnosisCodes: diagnoses.map((d)=>d.code).filter(Boolean),
                diagnosisNames: diagnoses.map((d)=>d.display).filter(Boolean)
            });
            setQuestions(data?.visitQuestions || {
                items: [],
                fallback: false
            });
            return null;
        } catch (err) {
            console.error('[useClinicalAssistant] questions failed:', err?.message);
            setQuestionsError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable');
            return err;
        } finally{
            setLoadingQuestions(false);
        }
    }, [
        patientId,
        appointmentId
    ]);
    /** COSTS PARSINA CREDITS. */ const ask = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (question)=>{
        setAsking(true);
        setAskError(null);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$39fc140801b04626), {
                patientId: patientId,
                appointmentId: appointmentId,
                question: question
            });
            const answer = data?.askVisitQuestion;
            if (answer) setAnswers((prev)=>[
                    ...prev,
                    {
                        question: question,
                        ...answer
                    }
                ]);
            return null;
        } catch (err) {
            console.error('[useClinicalAssistant] ask failed:', err?.message);
            setAskError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable');
            return err;
        } finally{
            setAsking(false);
        }
    }, [
        patientId,
        appointmentId
    ]);
    return {
        questions: questions,
        loadingQuestions: loadingQuestions,
        questionsError: questionsError,
        generate: generate,
        answers: answers,
        asking: asking,
        askError: askError,
        ask: ask
    };
}
function $cfeee402cf40bab0$export$b7e4201174b0194d({ patientId: patientId, appointmentId: appointmentId }) {
    const [analyzing, setAnalyzing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [advice, setAdvice] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [findings, setFindings] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [refineError, setRefineError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [adviceError, setAdviceError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [findingsError, setFindingsError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    /** COSTS PARSINA CREDITS (both calls). Only ever fired from the button. */ const analyze = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (transcript)=>{
        setAnalyzing(true);
        setRefineError(null);
        setAdviceError(null);
        setFindingsError(null);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$ab0c29477139cdb6), {
                patientId: patientId,
                appointmentId: appointmentId,
                transcript: transcript
            });
            setDraft(data?.refineVisitNote || null);
        } catch (err) {
            console.error('[useSoapAssistant] refine failed:', err?.message);
            const kind = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable';
            setRefineError(kind);
            if (kind === 'credits') {
                // The other two calls bill too; running them now buys more refusals.
                setAdviceError('credits');
                setFindingsError('credits');
                setAnalyzing(false);
                return err;
            }
        }
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$2e29d4a4d81f7aa1), {
                patientId: patientId,
                appointmentId: appointmentId,
                transcript: transcript
            });
            setAdvice(data?.generateVisitAdvice || null);
        } catch (err) {
            console.error('[useSoapAssistant] advice failed:', err?.message);
            setAdviceError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable');
        }
        // The tooth read is LAST and its own try: it is the youngest of the three
        // and the one most likely to be unavailable, and the dentist should still
        // get the note draft and the advice when it is.
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$1893e1ce8127ba54), {
                patientId: patientId,
                appointmentId: appointmentId,
                transcript: transcript
            });
            setFindings(data?.extractToothFindings || null);
        } catch (err) {
            console.error('[useSoapAssistant] tooth findings failed:', err?.message);
            setFindingsError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable');
        } finally{
            setAnalyzing(false);
        }
        return null;
    }, [
        patientId,
        appointmentId
    ]);
    // Applied or dismissed, a draft leaves the screen the same way.
    const clearDraft = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setDraft(null), []);
    const clearAdvice = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setAdvice(null), []);
    const clearFindings = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setFindings(null), []);
    return {
        analyzing: analyzing,
        draft: draft,
        advice: advice,
        findings: findings,
        refineError: refineError,
        adviceError: adviceError,
        findingsError: findingsError,
        analyze: analyze,
        clearDraft: clearDraft,
        clearAdvice: clearAdvice,
        clearFindings: clearFindings
    };
}
function $cfeee402cf40bab0$export$c28b254de367c08c({ patientId: patientId, appointmentId: appointmentId }) {
    const [files, setFiles] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [uploading, setUploading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [busyFileId, setBusyFileId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wanted = $cfeee402cf40bab0$var$useGuardedLoad(appointmentId);
    const load = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initial: initial } = {})=>{
        if (!patientId || !appointmentId) {
            setLoading(false);
            return;
        }
        const asked = appointmentId;
        if (initial) setLoading(true);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$175f5ece51a71be1), {
                patientId: patientId,
                appointmentId: asked
            });
            if (wanted.current !== asked) return;
            setFiles(data?.visitFiles || []);
            setError(null);
        } catch (err) {
            if (wanted.current !== asked) return;
            console.error('[useVisitFiles] failed:', err?.message);
            if (initial) setError(err);
        } finally{
            if (initial && wanted.current === asked) setLoading(false);
        }
    }, [
        patientId,
        appointmentId,
        wanted
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        load({
            initial: true
        });
    }, [
        load
    ]);
    const upload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (input)=>{
        setUploading(true);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$d4c482abf80efea8), {
                patientId: patientId,
                appointmentId: appointmentId,
                ...input
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitFiles] upload failed:', err?.message);
            return err;
        } finally{
            setUploading(false);
        }
    }, [
        patientId,
        appointmentId,
        load
    ]);
    const remove = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (fileId)=>{
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$7d2c6204ee78cd8c), {
                patientId: patientId,
                fileId: fileId
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitFiles] delete failed:', err?.message);
            return err;
        }
    }, [
        patientId,
        load
    ]);
    // ── The three per-file actions ────────────────────────────────────────────
    //
    // `busyFileId` and not a boolean: the list shows every file at once, and a
    // single flag would spin every row's button while one of them works. It holds
    // the id so exactly the pressed control reports for duty.
    //
    // All three refetch the list rather than patching the row in place. A patch
    // would be one more place that has to know how a file row is assembled from
    // three services, and the list is small.
    const runOcr = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (fileId, documentType)=>{
        setBusyFileId(fileId);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$f12482f856b497dd), {
                patientId: patientId,
                appointmentId: appointmentId,
                fileId: fileId,
                documentType: documentType || null
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitFiles] ocr failed:', err?.message);
            return err;
        } finally{
            setBusyFileId(null);
        }
    }, [
        patientId,
        appointmentId,
        load
    ]);
    /**
   * Label an already-stored file AS a dental image.
   *
   * Every file uploaded before the image workspace existed has no link, so it
   * can be viewed and nothing else — annotating and reading both need a view
   * type. This is the repair, and it is why the workspace opens on such a file
   * at all rather than refusing it.
   */ const register = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (fileId, viewType, teethFdi)=>{
        setBusyFileId(fileId);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$cbdf065b0d2b950b), {
                patientId: patientId,
                appointmentId: appointmentId,
                fileId: fileId,
                viewType: viewType,
                teethFdi: teethFdi || []
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitFiles] register failed:', err?.message);
            return err;
        } finally{
            setBusyFileId(null);
        }
    }, [
        patientId,
        appointmentId,
        load
    ]);
    const analyze = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (fileId)=>{
        setBusyFileId(fileId);
        try {
            const data = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$84a314bc9e339af4), {
                patientId: patientId,
                appointmentId: appointmentId,
                fileId: fileId
            });
            await load();
            // Returned as well as reloaded: the caller wants to know whether the read
            // found anything and whether it was charged, and «هیچ یافته‌ای پیدا نشد»
            // is a different message from an error.
            return {
                result: data?.analyzeVisitImage || null,
                error: null
            };
        } catch (err) {
            console.error('[useVisitFiles] image read failed:', err?.message);
            return {
                result: null,
                error: err
            };
        } finally{
            setBusyFileId(null);
        }
    }, [
        patientId,
        appointmentId,
        load
    ]);
    const saveAnnotations = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (fileId, annotations)=>{
        setBusyFileId(fileId);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $0cd549c1a257ae26$export$5bae2d275c2f44e2), {
                patientId: patientId,
                appointmentId: appointmentId,
                fileId: fileId,
                // Only the fields the input type declares. Spreading the whole mark
                // would send `authorId` — which the server stamps and the schema does
                // not accept — and GraphQL refuses the entire operation for it.
                annotations: annotations.map((a)=>({
                        id: a.id,
                        kind: a.kind,
                        x: a.x,
                        y: a.y,
                        w: a.w ?? null,
                        h: a.h ?? null,
                        x2: a.x2 ?? null,
                        y2: a.y2 ?? null,
                        points: a.points || [],
                        toothFdi: a.toothFdi || null,
                        comment: a.comment || '',
                        color: a.color || null,
                        createdAtMs: a.createdAtMs || null
                    }))
            });
            await load();
            return null;
        } catch (err) {
            console.error('[useVisitFiles] annotation save failed:', err?.message);
            return err;
        } finally{
            setBusyFileId(null);
        }
    }, [
        patientId,
        appointmentId,
        load
    ]);
    return {
        files: files,
        loading: loading,
        error: error,
        uploading: uploading,
        busyFileId: busyFileId,
        upload: upload,
        remove: remove,
        runOcr: runOcr,
        analyze: analyze,
        saveAnnotations: saveAnnotations,
        register: register,
        reload: ()=>load({
                initial: true
            })
    };
}
var $cfeee402cf40bab0$export$2e2bcd8739ae039 = $cfeee402cf40bab0$export$8ad4ab361a8a3764;




var $acw62 = parcelRequire("acw62");



function $e04b6779df83121e$export$ef4509123843d92e(events = [], records = [], catalog = []) {
    const rows = [];
    for (const e of events || [])rows.push({
        kind: 'event',
        id: `e-${e.id}`,
        at: Number(e.occurredAtMs || e.recordedAtMs) || 0,
        voidedAtMs: e.voidedAtMs || null,
        voidReason: e.voidReason || null,
        // Set when this event was written BY a treatment. Phase 3 stamps it
        // server-side; until then it is always absent and every event renders as
        // its own row, which is what happened before this existed.
        sourceRecordId: e.sourceRecordId || null,
        event: e
    });
    for (const r of records || [])rows.push({
        kind: 'treatment',
        id: `r-${r.id}`,
        recordId: r.id,
        at: Number(r.performedAtMs || r.recordedAtMs) || 0,
        voidedAtMs: r.voidedAtMs || null,
        voidReason: r.voidReason || null,
        title: (0, $0cd549c1a257ae26$export$279093cb86d9c700)(r, catalog),
        record: r
    });
    rows.sort((a, b)=>b.at - a.at);
    // A chart event a treatment caused is NESTED under it rather than listed
    // beside it: on the same day, at the same second, «عصب‌کشی مولر» and
    // «وضعیت: عصب‌کشی‌شده» are one act described twice, and two sibling rows read
    // as two separate findings.
    // The parent is found in the WHOLE list, not in what has been emitted so far.
    // They are written in one transaction and routinely carry the same timestamp
    // to the second, so which of the two sorts first is a coin toss — and looking
    // only backwards meant the common case (identical stamps, event first) nested
    // nothing at all.
    const byRecord = new Map(rows.filter((r)=>r.kind === 'treatment').map((r)=>[
            r.recordId,
            r
        ]));
    const out = [];
    for (const row of rows){
        if (row.kind === 'event' && row.sourceRecordId) {
            const parent = byRecord.get(row.sourceRecordId);
            if (parent) {
                (parent.caused ||= []).push(row);
                continue;
            }
        }
        // An event whose treatment is not in THIS list still shows, on its own: the
        // records may be narrowed to one visit while the events are not, and
        // dropping it would hide a chart change entirely.
        out.push(row);
    }
    return out;
}
const $e04b6779df83121e$var$Line = ({ children: children, muted: muted, struck: struck, indented: indented })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            gap: 8,
            alignItems: 'baseline',
            fontSize: 12,
            lineHeight: 1.9,
            paddingInlineStart: indented ? 18 : 0,
            color: muted ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
            textDecoration: struck ? 'line-through' : 'none'
        },
        children: children
    });
function $e04b6779df83121e$export$2e2bcd8739ae039({ fdi: fdi, events: events = [], records: records = [], catalog: catalog = [], loading: loading = false, error: error = false, t: t, formatDate: formatDate, onOpenVisit: // «مشاهدهٔ ویزیت» — absent on a surface with nowhere to go (the patient
// record's read-only chart), so no button is drawn that leads nowhere.
onOpenVisit = null }) {
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$e04b6779df83121e$export$ef4509123843d92e(events, records, catalog), [
        events,
        records,
        catalog
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        },
        children: t('common.loading')
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        },
        children: t('chart.history.unavailable')
    });
    if (!rows.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        style: {
            fontSize: 12,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
        },
        children: t('chart.history.empty')
    });
    const when = (at)=>at && formatDate ? formatDate(Number(at), 'numeric') : "\u2014";
    // `labelFor` rather than a bare `t()`: the chart's vocabularies grow, and a
    // value with no string yet must render as itself rather than as the raw key
    // path — which is what the dentist would otherwise read in their own history.
    const eventLine = (e)=>[
            e.aspect === 'surface' && e.surface ? `${t('chart.surfaces.title')} ${e.surface}` : null,
            (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'tooth.value', e.value) || null,
            (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'tooth.material', e.material) || null,
            e.note || null
        ].filter(Boolean).join(" \xb7 ");
    const treatmentLine = (r)=>[
            r.surfaces || null,
            (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'tooth.material', r.material) || null,
            Number(r.sessionNo) > 1 ? t('chart.history.session', {
                n: r.sessionNo
            }) : null,
            r.note || null
        ].filter(Boolean).join(" \xb7 ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": `tooth-history-${fdi}`,
        children: rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e04b6779df83121e$var$Line, {
                        muted: !!row.voidedAtMs,
                        struck: !!row.voidedAtMs,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    flexShrink: 0
                                },
                                ...(0, $a278322405d51c25$export$3433559efc22d110),
                                children: when(row.at)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    flexShrink: 0,
                                    fontSize: 10.5,
                                    fontWeight: 700,
                                    color: row.kind === 'treatment' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: row.kind === 'treatment' ? `\u{25CF} ${t('chart.history.treatment')}` : `\u{25CB} ${t('chart.history.event')}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: [
                                    row.kind === 'treatment' ? [
                                        row.title,
                                        treatmentLine(row.record)
                                    ].filter(Boolean).join(" \xb7 ") : eventLine(row.event),
                                    row.voidedAtMs && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        style: {
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: [
                                            ' ',
                                            t('chart.history.voided', {
                                                reason: row.voidReason || "\u2014"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            row.kind === 'treatment' && onOpenVisit && row.record?.appointmentId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>onOpenVisit(row.record.appointmentId),
                                style: {
                                    flexShrink: 0,
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    font: 'inherit',
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk,
                                    cursor: 'pointer'
                                },
                                children: t('visit.record.openVisit')
                            })
                        ]
                    }),
                    (row.caused || []).map((child)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e04b6779df83121e$var$Line, {
                            indented: true,
                            muted: true,
                            struck: !!child.voidedAtMs,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        flexShrink: 0,
                                        fontSize: 10.5
                                    },
                                    children: "\u21B3"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0
                                    },
                                    children: [
                                        eventLine(child.event),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: [
                                                " \u2014 ",
                                                t('chart.history.causedBy')
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, child.id))
                ]
            }, row.id))
    });
}





parcelRequire("acw62");





const $f0b706c85b9518d1$export$7212c5b454172171 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 120,
                    height: 14
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                        gap: 18
                    },
                    children: Array.from({
                        length: 9
                    }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f102dad4aafe4ad4), {
                            valueWidth: `${50 + i * 17 % 40}%`
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 90,
                    height: 14
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$543533cea58d4261), {
                    count: 2,
                    gap: 10
                })
            })
        ]
    });
const $f0b706c85b9518d1$export$f6ff0e8ea850bfdc = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 110,
                    height: 14
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$543533cea58d4261), {
                    count: 3
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 90,
                    height: 14
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$543533cea58d4261), {
                    count: 3
                })
            })
        ]
    });
/** ChartTab's stat tile: 84px min, 11px label over an 18px number. */ const $f0b706c85b9518d1$var$ChartStatSkeleton = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '10px 14px',
            minWidth: 84,
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 48,
                height: 11
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 28,
                height: 18
            })
        ]
    });
const $f0b706c85b9518d1$export$db995d396ec5795d = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "chart-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    marginBottom: 16
                },
                children: [
                    Array.from({
                        length: 5
                    }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f0b706c85b9518d1$var$ChartStatSkeleton, {}, i)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginInlineStart: 'auto',
                            display: 'flex',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                                width: 132
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                                width: 132
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                                width: 96
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$67864df0c74efa69), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 14,
                    flexWrap: 'wrap',
                    marginTop: 12,
                    padding: '10px 12px',
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                    borderRadius: 10
                },
                children: Array.from({
                    length: 8
                }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 12,
                                height: 12,
                                radius: 3
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: [
                                    52,
                                    72,
                                    60,
                                    84
                                ][i % 4],
                                height: 11
                            })
                        ]
                    }, i))
            })
        ]
    });
const $f0b706c85b9518d1$export$fd8935e770d919da = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "chart-tooth-history-skeleton",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            0,
            1,
            2
        ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 64,
                        height: 11
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${40 + i * 17 % 30}%`,
                        height: 12
                    })
                ]
            }, i))
    });
const $f0b706c85b9518d1$var$TAB_BODY = {
    summary: $f0b706c85b9518d1$export$7212c5b454172171,
    history: $f0b706c85b9518d1$export$f6ff0e8ea850bfdc,
    chart: $f0b706c85b9518d1$export$db995d396ec5795d
};
const $f0b706c85b9518d1$export$29e17e48ba44b68d = ({ label: label, tab: tab = 'summary' })=>{
    const Body = $f0b706c85b9518d1$var$TAB_BODY[tab] || $f0b706c85b9518d1$export$7212c5b454172171;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "patient-content",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$a5bf34efdb86126b), {
                avatar: true,
                meta: true,
                stats: 3,
                actions: 1
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '14px 28px 0',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f51fccaec5c96c2a), {
                    count: 3
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    padding: '18px 28px 40px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Body, {})
            })
        ]
    });
};
const $f0b706c85b9518d1$export$a3311dcb3f9040c2 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 96,
                    height: 12
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    padding: '0.25rem 0.875rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$1d36da46ad5622dc), {
                    count: 7
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                style: {
                    marginTop: '0.875rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 72,
                    height: 12
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    padding: '0.875rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                    lines: 2,
                    height: 12
                })
            })
        ]
    });
const $f0b706c85b9518d1$export$70a17900f1020cd = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        children: [
            0,
            1
        ].map((k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginBottom: k === 0 ? '0.875rem' : 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                            width: 90,
                            height: 12
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: '0.25rem 0.875rem'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$1d36da46ad5622dc), {
                            count: 3
                        })
                    })
                ]
            }, k))
    });
/** MobileToothPicker: four quadrants in a 2-up grid, each a wrap of 44px chips. */ const $f0b706c85b9518d1$var$ToothPickerSkeleton = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem'
        },
        children: [
            0,
            1,
            2,
            3
        ].map((q)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.375rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 64,
                        height: 11
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(2.75rem, 1fr))',
                            gap: '0.375rem'
                        },
                        children: Array.from({
                            length: 8
                        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: "100%",
                                height: 44,
                                radius: 10
                            }, i))
                    })
                ]
            }, q))
    });
const $f0b706c85b9518d1$export$5fb13581ab29a88b = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "chart-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$6237acc7cd007357), {
                count: 4
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                style: {
                    marginTop: '0.875rem'
                },
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                    width: 104
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 110,
                    height: 12
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$67864df0c74efa69), {
                radius: "0.75rem"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: '0.875rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                            width: 96,
                            height: 12
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: "80%",
                        height: 11,
                        style: {
                            marginBottom: '0.625rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f0b706c85b9518d1$var$ToothPickerSkeleton, {})
                ]
            })
        ]
    });
const $f0b706c85b9518d1$var$MOBILE_SECTION = {
    summary: $f0b706c85b9518d1$export$a3311dcb3f9040c2,
    history: $f0b706c85b9518d1$export$70a17900f1020cd,
    chart: $f0b706c85b9518d1$export$5fb13581ab29a88b
};
const $f0b706c85b9518d1$export$49545925d670ceeb = ({ label: label, tab: tab = 'summary' })=>{
    const Body = $f0b706c85b9518d1$var$MOBILE_SECTION[tab] || $f0b706c85b9518d1$export$a3311dcb3f9040c2;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "patient-content",
        style: {
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$4c127c4db7b36f7f), {
                back: true,
                subtitle: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '0 0.75rem',
                    marginTop: '-1rem',
                    position: 'relative'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$6237acc7cd007357), {
                    count: 4
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: '0.75rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$52fa1d077274aab0), {
                    count: 3
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Body, {})
            })
        ]
    });
};




// چارت دندان — the odontogram tab of the patient workspace.
//
// Layout: summary strip, the arch, a legend. The legend is not decoration —
// the chart encodes clinical meaning in colour, and a colour-coded record with
// no key is unreadable to anyone but its author.
const $63bdfcbf9030ccf8$var$Stat = ({ label: label, value: value, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            background: '#fff',
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '10px 14px',
            minWidth: 84
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    marginBottom: 4
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 18,
                    fontWeight: 800,
                    color: tone || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                },
                ...(0, $a278322405d51c25$export$3433559efc22d110),
                children: value
            })
        ]
    });
const $63bdfcbf9030ccf8$var$LegendItem = ({ swatch: swatch, label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    width: 12,
                    height: 12,
                    borderRadius: 3,
                    display: 'inline-block',
                    background: swatch.fill,
                    border: `1.5px solid ${swatch.stroke}`
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: label
            })
        ]
    });
// The condition-glyph legend. Each swatch is drawn by the SAME generator the
// chart uses (on a representative molar, scaled up only for legibility) —
// never redrawn by hand — so the legend cannot drift from the chart.
const $63bdfcbf9030ccf8$var$LEGEND_FDI = '16';
const $63bdfcbf9030ccf8$var$LEGEND_POST_CORE = (0, $1e2d81a721530153$export$28ba678519100449)($63bdfcbf9030ccf8$var$LEGEND_FDI);
const $63bdfcbf9030ccf8$var$GlyphLegendItem = ({ label: label, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                width: 15,
                height: 15,
                viewBox: "-19 -19 38 38",
                "aria-hidden": "true",
                style: {
                    display: 'block',
                    flex: 'none'
                },
                children: children
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: label
            })
        ]
    });
const $63bdfcbf9030ccf8$var$LegendSilhouette = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
        d: (0, $1e2d81a721530153$export$fdbe61f566b424c8)($63bdfcbf9030ccf8$var$LEGEND_FDI),
        fill: "none",
        stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).untouched.stroke,
        strokeWidth: 1.5
    });
function $63bdfcbf9030ccf8$export$2e2bcd8739ae039({ patientId: patientId, clinicId: clinicId, t: t, formatDate: formatDate }) {
    const { teeth: teeth, byFdi: byFdi, summary: summary, loading: loading, error: error, saving: saving, record: record, reload: reload } = (0, $b11e9ffe8c3f2849$export$26586bb2073aa39c)({
        patientId: patientId,
        clinicId: clinicId
    });
    // ── The plan and the treatments, on the RECORD's chart ──────────────────
    //
    // This is the chart a dentist opens between visits, and it was the one that
    // showed the LEAST: no planned ring, no sign of any treatment, and no tooth
    // history at all. The visit's chart had the ring; this had nothing, so «چه
    // کاری روی این دندان انجام شده؟» could not be answered from the patient's own
    // record.
    //
    // The SAME hook the visit uses, so the two charts cannot disagree about what
    // is planned or what was done.
    const { plans: plans, records: records, catalog: catalog } = (0, $cfeee402cf40bab0$export$29b2b9621f2e7a20)({
        patientId: patientId,
        clinicId: clinicId
    });
    const planTeeth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$c825b1cc6eb6552a)(plans), [
        plans
    ]);
    const plannedFdis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$49c0abb5f6c435a2)(planTeeth), [
        planTeeth
    ]);
    const treatedFdis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$774cea0d439b4aad)(records, catalog), [
        records,
        catalog
    ]);
    const wholeMouth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$cc03fdd5f9432e88)(records), [
        records
    ]);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [focusSurface, setFocusSurface] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showPrimary, setShowPrimary] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('auto');
    const [labelMode, setLabelMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('fdi');
    const [exporting, setExporting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [exportFailed, setExportFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showHistory, setShowHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const historyId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const chartBoxRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // One read per tooth, and only once its trail is asked for — the drawer
    // opens to CHART, and paying for a history fetch on every tooth a dentist
    // clicks through would make the common act the expensive one.
    const history = (0, $b11e9ffe8c3f2849$export$e3f31f0e2006ba13)({
        patientId: patientId,
        toothFdi: selected,
        enabled: showHistory && !!selected
    });
    // Moving to another tooth folds the trail away: left open, it would show one
    // tooth's history under another tooth's heading for the frame before the new
    // read lands.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowHistory(false);
    }, [
        selected
    ]);
    const toothRecords = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>selected ? (records || []).filter((r)=>r?.toothFdi === selected) : [], [
        records,
        selected
    ]);
    const openTooth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi, surface = null)=>{
        setSelected(fdi);
        setFocusSurface(surface);
    }, []);
    // «خروجی تصویر» — the chart as a referral/print artifact. The svg is found
    // by ref rather than threading one through Odontogram's API; exportChartPng
    // clones it, so the live chart is never touched.
    const doExport = async ()=>{
        setExportFailed(false);
        setExporting(true);
        try {
            const res = await (0, $3fc1a6f2dc9b6a88$export$bb74a4b3702605c)({
                svgEl: chartBoxRef.current?.querySelector('svg'),
                patientId: patientId,
                // Patient id + date — an LTR run. The filename date is Gregorian
                // (sortable ASCII); THIS one is what a human reads, so it follows
                // the active locale (Jalaali under fa).
                header: `${patientId} \u{2014} ${formatDate(Date.now(), 'numeric')}`
            });
            if (!res.ok) setExportFailed(true);
        } finally{
            setExporting(false);
        }
    };
    // Only THIS tab fetches after the record is up, so only this tab body
    // shimmers — in its own shape: the stat strip, the arch at its aspect, the
    // legend band. A centred spinner is banned (DESIGN.md §"Loading & skeleton").
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0b706c85b9518d1$export$db995d396ec5795d), {
        label: t('common.loading')
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
        title: t('chart.error.title'),
        description: t('chart.error.body'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            onClick: reload,
            children: t('common.actions.retry')
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 10,
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    marginBottom: 16
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$Stat, {
                        label: t('chart.summary.charted'),
                        value: summary?.chartedTeeth ?? 0
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$Stat, {
                        label: t('chart.summary.decayed'),
                        value: summary?.decayed ?? 0,
                        tone: summary?.decayed ? '#dc2626' : undefined
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$Stat, {
                        label: t('chart.summary.restored'),
                        value: summary?.restored ?? 0,
                        tone: summary?.restored ? '#2563eb' : undefined
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$Stat, {
                        label: t('chart.summary.missing'),
                        value: summary?.missing ?? 0
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$Stat, {
                        label: t('chart.summary.dmft'),
                        value: summary?.dmft ?? 0
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginInlineStart: 'auto',
                            display: 'flex',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                onClick: ()=>setShowPrimary((v)=>v === true ? 'auto' : true),
                                children: showPrimary === true ? t('chart.hidePrimary') : t('chart.showPrimary')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                onClick: ()=>setLabelMode((m)=>m === 'fdi' ? 'both' : 'fdi'),
                                children: labelMode === 'both' ? t('chart.hideUniversal') : t('chart.showUniversal')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                onClick: doExport,
                                disabled: exporting,
                                children: t('chart.export.button')
                            })
                        ]
                    })
                ]
            }),
            exportFailed && // Same tone as the drawer's save error — an actionable failure, not a
            // crash: the browser simply cannot rasterize (exportChart.js guards).
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "alert",
                style: {
                    marginBottom: 12,
                    padding: '8px 12px',
                    borderRadius: 8,
                    background: '#fef2f2',
                    border: '1px solid #fecaca',
                    color: '#b91c1c',
                    fontSize: 12.5
                },
                children: t('chart.export.error')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: chartBoxRef,
                style: {
                    background: '#fff',
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 12,
                    padding: '8px 4px 4px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45122e9f240c7236$export$2e2bcd8739ae039), {
                    teeth: teeth,
                    selected: selected,
                    highlight: plannedFdis,
                    treated: treatedFdis,
                    planned: planTeeth,
                    onSelect: (fdi)=>openTooth(fdi),
                    onSurfaceSelect: (fdi, surface)=>openTooth(fdi, surface),
                    showPrimary: showPrimary,
                    labelMode: labelMode,
                    t: t,
                    formatDate: formatDate
                })
            }),
            wholeMouth.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "chart-whole-mouth",
                style: {
                    marginTop: 8,
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    display: 'flex',
                    gap: 6,
                    flexWrap: 'wrap',
                    alignItems: 'baseline'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: [
                            t('chart.wholeMouth.title'),
                            t('common.punct.colon')
                        ]
                    }),
                    wholeMouth.slice(0, 3).map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                i > 0 ? "\xb7 " : '',
                                (0, $0cd549c1a257ae26$export$279093cb86d9c700)(r, catalog) || t('visit.plan.untitledItem')
                            ]
                        }, r.id)),
                    wholeMouth.length > 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('chart.tooltip.andMore', {
                            count: wholeMouth.length - 3
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 14,
                    flexWrap: 'wrap',
                    marginTop: 12,
                    padding: '10px 12px',
                    background: '#f8fafc',
                    borderRadius: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).caries,
                        label: t('chart.surfaceState.caries')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).caries_tooth,
                        label: t('chart.legend.wholeToothCaries')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).restoration,
                        label: t('chart.surfaceState.restoration')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).recurrent_caries,
                        label: t('chart.surfaceState.recurrent_caries')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).temporary,
                        label: t('chart.surfaceState.temporary')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).sealant,
                        label: t('chart.surfaceState.sealant')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).missing,
                        label: t('chart.presence.extracted')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendItem, {
                        swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).untouched,
                        label: t('chart.notCharted')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.conditionName.crown'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: (0, $1e2d81a721530153$export$ecea09364f6d7e85)($63bdfcbf9030ccf8$var$LEGEND_FDI),
                                fill: "none",
                                stroke: (0, $789c06d5db9cfc3f$export$e5b4b6e3feb01a67)(null),
                                strokeWidth: 2.6
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.conditionName.root_canal'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                                points: (0, $1e2d81a721530153$export$93f6716ad9cd507a)($63bdfcbf9030ccf8$var$LEGEND_FDI),
                                fill: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).root_canal.stroke,
                                transform: "scale(2)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.conditionName.implant'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                transform: "scale(1.8)",
                                children: (0, $1e2d81a721530153$export$de80878fd40fdd08)($63bdfcbf9030ccf8$var$LEGEND_FDI).map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                        x1: s.x1,
                                        y1: s.y1,
                                        x2: s.x2,
                                        y2: s.y2,
                                        stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).implant.stroke,
                                        strokeWidth: 2,
                                        strokeLinecap: "round"
                                    }, i))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.conditionName.post_core'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                                transform: "scale(1.8)",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                        x1: $63bdfcbf9030ccf8$var$LEGEND_POST_CORE.bar.x1,
                                        y1: $63bdfcbf9030ccf8$var$LEGEND_POST_CORE.bar.y1,
                                        x2: $63bdfcbf9030ccf8$var$LEGEND_POST_CORE.bar.x2,
                                        y2: $63bdfcbf9030ccf8$var$LEGEND_POST_CORE.bar.y2,
                                        stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).post_core.stroke,
                                        strokeWidth: 2,
                                        strokeLinecap: "round"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                        cx: $63bdfcbf9030ccf8$var$LEGEND_POST_CORE.dot.cx,
                                        cy: $63bdfcbf9030ccf8$var$LEGEND_POST_CORE.dot.cy,
                                        r: $63bdfcbf9030ccf8$var$LEGEND_POST_CORE.dot.r,
                                        fill: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).post_core.stroke
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.conditionName.veneer'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: (0, $1e2d81a721530153$export$8dd5375953039c36)($63bdfcbf9030ccf8$var$LEGEND_FDI),
                                fill: "none",
                                stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).restoration.stroke,
                                strokeWidth: 3.5,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.conditionName.fracture'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                                points: (0, $1e2d81a721530153$export$43af588fb1be7790)($63bdfcbf9030ccf8$var$LEGEND_FDI),
                                fill: "none",
                                stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).fractured.stroke,
                                strokeWidth: 2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.legend.planned'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: (0, $1e2d81a721530153$export$fdbe61f566b424c8)($63bdfcbf9030ccf8$var$LEGEND_FDI),
                                fill: "none",
                                ...(0, $789c06d5db9cfc3f$export$268f349e84521056)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.legend.treated'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$LegendSilhouette, {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                transform: "scale(2.4)",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $849f2169098c9170$export$2e2bcd8739ae039), {
                                    count: 1
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($63bdfcbf9030ccf8$var$GlyphLegendItem, {
                        label: t('chart.legend.bridge'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                            x1: -15,
                            y1: 0,
                            x2: 15,
                            y2: 0,
                            ...(0, $789c06d5db9cfc3f$export$49e77edbb85c0c46)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            marginInlineStart: 'auto',
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: t('chart.hint')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0d6ec014fedfc25$export$2e2bcd8739ae039), {
                open: !!selected,
                fdi: selected,
                state: selected ? byFdi[selected] : null,
                focusSurface: focusSurface,
                saving: saving,
                onSave: record,
                onClose: ()=>{
                    setSelected(null);
                    setFocusSurface(null);
                },
                history: /* «تاریخچه دندان» — the half of the record the chart cannot draw.
             The folded state says a tooth is crowned; it does not say when, by
             whom, or what was there before, and on THIS screen — the one
             opened between visits, with no encounter around it — that is the
             whole question. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        marginBottom: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "subtle",
                            "aria-expanded": showHistory,
                            "aria-controls": historyId,
                            onClick: ()=>setShowHistory((v)=>!v),
                            children: t('visit.chart.history')
                        }),
                        showHistory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            id: historyId,
                            style: {
                                marginTop: 8
                            },
                            children: history.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0b706c85b9518d1$export$fd8935e770d919da), {
                                label: t('common.loading')
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04b6779df83121e$export$2e2bcd8739ae039), {
                                fdi: selected,
                                events: history.events,
                                records: toothRecords,
                                catalog: catalog,
                                error: !!history.error,
                                t: t,
                                formatDate: formatDate
                            })
                        })
                    ]
                }),
                t: t
            })
        ]
    });
}



parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5389c2c2de1c7f38$export$a2387ed3b5d536eb = {
    name: "lock",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "11",
                x: "3",
                y: "11",
                rx: "2",
                ry: "2",
                key: "1w4ew1"
            }
        ],
        [
            "path",
            {
                d: "M7 11V7a5 5 0 0 1 10 0v4",
                key: "fwvmzm"
            }
        ]
    ]
};
$5389c2c2de1c7f38$export$a2387ed3b5d536eb.node;
const $5389c2c2de1c7f38$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5389c2c2de1c7f38$export$a2387ed3b5d536eb);









// طرح درمان in the PATIENT's record, not only inside a visit.
//
// The plan was reachable from one place: the open visit. A dentist asking «what
// did we agree with this patient, and what is left?» between appointments — at
// reception, on the phone, before a recall — had nowhere to look, and a patient
// asking the same question got an answer nobody could see.
//
// ── Read-only, deliberately ─────────────────────────────────────────────────
// Adding a line, signing a plan and recording a treatment all happen IN a visit,
// because each of them is a clinical act that belongs to one: a line is quoted
// while the patient is in the chair, and a signature is taken there. This screen
// answers what was agreed and what is outstanding. It does not become a second
// place to quote from, which would be a second, unsigned quote disagreeing with
// the one the patient put their name to.
//
// ── Every course, newest first ──────────────────────────────────────────────
// Unlike the visit section — which shows the one OPEN plan — this shows them
// all. A finished course is what the patient's history is made of, and an
// abandoned one is part of the answer to «why did we not do that?».
//
// ── Each course in its own currency ─────────────────────────────────────────
// With no clinic chosen, the list spans every clinic this dentist works at, and
// two clinics may keep their books in different currencies. Every figure is
// therefore read in ITS plan's currency, and «مانده» is one total PER currency
// (outstandingByCurrency) — never a toman figure and a dirham figure added into
// a number that means nothing. There is no exchange rate anywhere in Parsina.
const $e9071f9b2135b847$var$STATUS_TONE = {
    proposed: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    accepted: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    },
    done: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    rejected: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    },
    deferred: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    }
};
const $e9071f9b2135b847$var$PlanTab = ({ patientId: patientId, clinicId: clinicId, t: t, formatNumber: formatNumber, formatDate: formatDate })=>{
    // The same hook the visit uses, so the two surfaces cannot disagree about
    // what a plan IS, what its lines come to, or how many sessions are done.
    const { plans: plans, catalog: catalog, records: records, loading: loading, error: error, reload: reload } = (0, $cfeee402cf40bab0$export$29b2b9621f2e7a20)({
        patientId: patientId,
        clinicId: clinicId
    });
    const { locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const money = (amount, currency)=>(0, $ee13d5f9dccabef6$export$a17b3c2052469c69)(amount, currency, {
            t: t,
            locale: locale
        });
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('patient.tabs.plan'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                fontSize: 13,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            },
            children: t('common.loading')
        })
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('patient.tabs.plan'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "alert",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('visit.plan.error.title'),
                description: (0, $0cd549c1a257ae26$export$1ebde7358daead69)(t, error) || t('visit.plan.error.body'),
                onRetry: reload,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    // Work, newest first — including what nobody ever quoted. A patient's
    // treatment history is not a subset of their plans: an emergency extraction
    // has a record and no plan line at all, so a screen built only from plans
    // would say it never happened.
    const done = (records || []).slice().sort((a, b)=>(Number(b?.recordedAtMs) || 0) - (Number(a?.recordedAtMs) || 0));
    if (!plans.length && !done.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('patient.tabs.plan'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fb6c94f3b917ca1$export$2e2bcd8739ae039), {
                size: 40,
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            }),
            title: t('patient.plan.empty.title'),
            description: t('patient.plan.empty.description')
        })
    });
    // Lines still waiting to happen, across every course — one total per currency.
    const outstanding = (0, $0cd549c1a257ae26$export$4e15388b46f420b8)(plans, catalog);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 14
        },
        "data-testid": "patient-plan",
        children: [
            outstanding.count > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                "data-testid": "patient-plan-outstanding",
                children: t('patient.plan.outstanding', {
                    count: formatNumber(outstanding.count),
                    amount: outstanding.totals.map(({ amount: amount, currency: currency })=>money(amount, currency)).join((0, $c53f9539af19d960$export$3004b7ed4244ef95)())
                })
            }),
            done.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                title: t('patient.plan.doneTitle'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    },
                    "data-testid": "patient-records",
                    children: done.map((r)=>{
                        const struck = !!r.voidedAtMs;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            "data-state": struck ? 'voided' : 'live',
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                borderRadius: 10,
                                padding: '8px 11px',
                                background: struck ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2 : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                                opacity: struck ? 0.75 : 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 12,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        minWidth: 34,
                                        textAlign: 'center',
                                        flexShrink: 0
                                    },
                                    children: r.toothFdi ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                                        children: formatNumber(r.toothFdi)
                                    }) : t('visit.plan.wholeMouthShort')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                fontWeight: 700,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                textDecoration: struck ? 'line-through' : 'none',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: (0, $0cd549c1a257ae26$export$279093cb86d9c700)(r, catalog) || t('visit.plan.untitledItem')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 11,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: [
                                                r.recordedAtMs && formatDate ? formatDate(new Date(Number(r.recordedAtMs))) : null,
                                                r.surfaces || null,
                                                r.material ? t(`tooth.material.${r.material}`) : null,
                                                struck ? t('visit.record.voidedFor', {
                                                    reason: r.voidReason || "\u2014"
                                                }) : null
                                            ].filter(Boolean).join(" \xb7 ")
                                        })
                                    ]
                                })
                            ]
                        }, r.id);
                    })
                })
            }),
            plans.map((plan)=>{
                const locked = (0, $0cd549c1a257ae26$export$2fc3923f5055ac01)(plan);
                const currency = (0, $0cd549c1a257ae26$export$2971a96bcdab4d0f)(plan);
                const items = plan.items || [];
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                    title: plan.title || t('visit.plan.title'),
                    action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            locked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                                        size: 13,
                                        "aria-hidden": true
                                    }),
                                    t('visit.plan.locked')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                variant: "outline",
                                children: (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.plan.planStatus', plan.status)
                            })
                        ]
                    }),
                    children: items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 13,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('patient.plan.noLines')
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8
                        },
                        children: items.map((item)=>{
                            const tone = $e9071f9b2135b847$var$STATUS_TONE[item.status] || $e9071f9b2135b847$var$STATUS_TONE.proposed;
                            // In THIS plan's currency. A tariff in another currency — the
                            // catalogue is one clinic's, the plans may be several — is
                            // said in words, never shown as this plan's figure.
                            const price = (0, $0cd549c1a257ae26$export$56006d7957c8727b)(item, catalog, {
                                locked: locked,
                                currency: currency
                            });
                            const sessions = (0, $0cd549c1a257ae26$export$5d9a996a03bb93f5)(item, records);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 10,
                                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                    borderRadius: 10,
                                    padding: '9px 11px',
                                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                            minWidth: 38,
                                            textAlign: 'center',
                                            flexShrink: 0
                                        },
                                        children: item.toothFdi ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            ...(0, $a278322405d51c25$export$3433559efc22d110),
                                            children: formatNumber(item.toothFdi)
                                        }) : t('visit.plan.wholeMouthShort')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 13,
                                                    fontWeight: 700,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: item.description || t('visit.plan.untitledItem')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: [
                                                    (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.plan.phases', item.phase),
                                                    item.surfaces ? ` \xb7 ${item.surfaces}` : '',
                                                    sessions.multi ? ` \xb7 ${t('visit.plan.sessionsOf', {
                                                        done: formatNumber(sessions.done),
                                                        total: formatNumber(sessions.quoted)
                                                    })}` : ''
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                                        "data-testid": `patient-plan-amount-${item.id}`,
                                        style: {
                                            fontSize: 12,
                                            fontWeight: price.amount ? 700 : 400,
                                            flexShrink: 0,
                                            color: price.amount ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
                                        },
                                        children: price.amount ? money(price.amount, price.currency) : price.mismatch ? t('visit.plan.otherCurrency', {
                                            currency: price.entryCurrency
                                        }) : t('visit.plan.noTariff')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            background: tone.bg,
                                            color: tone.ink,
                                            borderRadius: 8,
                                            padding: '3px 9px',
                                            fontSize: 11.5,
                                            fontWeight: 700,
                                            flexShrink: 0
                                        },
                                        children: (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.plan.status', item.status)
                                    })
                                ]
                            }, item.id);
                        })
                    })
                }, plan.id);
            })
        ]
    });
};
var $e9071f9b2135b847$export$2e2bcd8739ae039 = $e9071f9b2135b847$var$PlanTab;


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $411fdacea3d25f13$export$a2387ed3b5d536eb = {
    name: "grid-3x3",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "M3 15h18",
                key: "5xshup"
            }
        ],
        [
            "path",
            {
                d: "M9 3v18",
                key: "fh3hqa"
            }
        ],
        [
            "path",
            {
                d: "M15 3v18",
                key: "14nvp0"
            }
        ]
    ],
    aliases: [
        "grid",
        "grid-3-x-3"
    ]
};
$411fdacea3d25f13$export$a2387ed3b5d536eb.node;
const $411fdacea3d25f13$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($411fdacea3d25f13$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $53cde9011dd49799$export$a2387ed3b5d536eb = {
    name: "rotate-ccw-clock",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                key: "1357e3"
            }
        ],
        [
            "path",
            {
                d: "M3 3v5h5",
                key: "1xhq8a"
            }
        ],
        [
            "path",
            {
                d: "M12 7v5l4 2",
                key: "1fdv2h"
            }
        ]
    ],
    aliases: [
        "history"
    ]
};
$53cde9011dd49799$export$a2387ed3b5d536eb.node;
const $53cde9011dd49799$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($53cde9011dd49799$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7cb92f499384d208$export$a2387ed3b5d536eb = {
    name: "id-card",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 19a4 4 0 00-8 0",
                key: "cugzd5"
            }
        ],
        [
            "path",
            {
                d: "M16 10h2",
                key: "8sgtl7"
            }
        ],
        [
            "path",
            {
                d: "M16 14h2",
                key: "epxaof"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "12",
                r: "3",
                key: "u3jwor"
            }
        ],
        [
            "rect",
            {
                x: "2",
                y: "5",
                width: "20",
                height: "14",
                rx: "2",
                key: "qneu4z"
            }
        ]
    ]
};
$7cb92f499384d208$export$a2387ed3b5d536eb.node;
const $7cb92f499384d208$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($7cb92f499384d208$export$a2387ed3b5d536eb);


const $491c0bd874346dfe$export$d6b7a0e86411dcc0 = (t)=>[
        {
            value: 'summary',
            label: t('patient.tabs.summary'),
            Icon: (0, $7cb92f499384d208$export$2e2bcd8739ae039)
        },
        {
            value: 'chart',
            label: t('patient.tabs.chart'),
            Icon: (0, $411fdacea3d25f13$export$2e2bcd8739ae039)
        },
        // طرح درمان outside a visit: what was agreed with this patient and what is
        // left of it. Between appointments — at reception, on the phone, before a
        // recall — the plan was reachable from nowhere.
        {
            value: 'plan',
            label: t('patient.tabs.plan'),
            Icon: (0, $6fb6c94f3b917ca1$export$2e2bcd8739ae039)
        },
        {
            value: 'history',
            label: t('patient.tabs.history'),
            Icon: (0, $53cde9011dd49799$export$2e2bcd8739ae039)
        }
    ];
const $491c0bd874346dfe$export$de4efade1edd2a63 = [
    'summary',
    'chart',
    'plan',
    'history'
];
const $491c0bd874346dfe$export$df83de65e8171a04 = 'summary';
var $491c0bd874346dfe$export$2e2bcd8739ae039 = $491c0bd874346dfe$export$d6b7a0e86411dcc0;




// The patient workspace.
//
// THREE TABS: خلاصه (who this patient is, and what they are allergic to),
// چارت دندان (the odontogram) and سوابق (what has been recorded).
//
// چارت دندان arrived once the tooth key was frozen — FDI/ISO 3950, decided
// 2026-08-02, clearing the phase-0 gate (CORE.md §6). Drawing a chart commits
// to a tooth model, which is exactly why it could not exist before that
// decision was made deliberately.
//
// Still absent, still behind their own decisions: طرح درمان (a priced,
// patient-signed commitment), پریو, and لابراتوار.
// The section set is PatientDetail.shared.js — the mobile strip and the route
// whitelist read the SAME list, which is what stops a tab existing that no URL
// can reach.
const $bbbe6e3a499cfdb9$var$TABS = (0, $491c0bd874346dfe$export$d6b7a0e86411dcc0);
const $bbbe6e3a499cfdb9$var$PatientDetailWeb = ({ id: id, tab: tab, setTab: setTab, goBack: goBack })=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { activeId: activeId } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const { patient: patient, loading: loading, error: error, reload: reload } = (0, $781cda2ad75d5a69$export$9b570c45914f833c)(id, activeId);
    // The record's OWN shape while it loads — header band, tab strip and the
    // body of the tab the URL names — so a reload on /patients/:id/chart draws
    // the chart's shape and nothing shifts when the data lands (DESIGN.md
    // §"Loading & skeleton").
    if (loading && !patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0b706c85b9518d1$export$29e17e48ba44b68d), {
        tab: tab,
        label: t('common.loading')
    });
    // A failed read and a record that does not exist are different facts: only one
    // of them is worth a retry button.
    if (error && !patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "patient-detail-error",
        "data-state": "error",
        role: "alert",
        style: {
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            padding: 32
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('patient.error.title'),
                description: t('errors.load.patient'),
                onRetry: reload,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    if (!patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            padding: 32
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed00022cb253e04b$export$2e2bcd8739ae039), {
                    size: 48,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('patient.notFound.title'),
                description: t('patient.notFound.description'),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    onClick: goBack,
                    children: t('common.actions.back')
                })
            })
        })
    });
    const gKey = (0, $2e1381078ec7f76f$export$c58a664d6aae39f0)(patient.gender);
    const meta = [
        gKey ? t(gKey) : patient.gender || null,
        patient.phone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            dir: "ltr",
            style: {
                unicodeBidi: 'isolate'
            },
            children: (0, $412e1a8a99c19c1a$exports).forDisplay(patient.phone)
        }, "phone") : null,
        patient.fileNumber ? `${t('common.labels.fileNumber')}${t('common.punct.colon')} ${patient.fileNumber}` : null
    ].filter(Boolean);
    const stats = [
        patient.age != null ? {
            label: t('patient.stats.age'),
            value: formatNumber(patient.age)
        } : null,
        {
            label: t('patient.stats.allergies'),
            value: formatNumber((patient.allergies || []).length),
            accent: (patient.allergies || []).length > 0
        },
        {
            label: t('patient.stats.medications'),
            value: formatNumber((patient.medications || []).length)
        }
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c79ee8367a72d83$export$2e2bcd8739ae039), {
                onBack: goBack,
                backLabel: t('common.actions.back'),
                title: patient.name,
                avatar: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                    name: patient.name,
                    src: patient.avatarUrl,
                    size: 44,
                    bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                }),
                meta: meta,
                stats: stats,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: ()=>navigate('prescription', {
                            patientId: patient.id
                        }),
                    children: t('patient.actions.prescribe')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '14px 28px 0',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                    options: $bbbe6e3a499cfdb9$var$TABS(t),
                    value: tab,
                    onChange: setTab
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "tabpanel",
                "aria-label": $bbbe6e3a499cfdb9$var$TABS(t).find((s)=>s.value === tab)?.label,
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '18px 28px 40px'
                },
                children: tab === 'chart' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63bdfcbf9030ccf8$export$2e2bcd8739ae039), {
                    patientId: id,
                    clinicId: activeId,
                    t: t,
                    formatDate: formatDate
                }) : tab === 'plan' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9071f9b2135b847$export$2e2bcd8739ae039), {
                    patientId: id,
                    clinicId: activeId,
                    t: t,
                    formatNumber: formatNumber,
                    formatDate: formatDate
                }) : tab === 'history' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a55d7d850b9289c2$export$2e2bcd8739ae039), {
                    patient: patient
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $353d784267d31267$export$2e2bcd8739ae039), {
                    patient: patient
                })
            })
        ]
    });
};
var $bbbe6e3a499cfdb9$export$2e2bcd8739ae039 = $bbbe6e3a499cfdb9$var$PatientDetailWeb;




var $acw62 = parcelRequire("acw62");









parcelRequire("acw62");




// The persistent allergy safety strip (§4C ③).
//
// «The safety strip and the navigator are the only sticky chrome. The header and
// the identity glance scroll away — the record wins the viewport — but a
// critical allergy stays visible at every scroll position.»
//
// The BANNER is the kit's `Alert variant="warning"`; what is app-local is the
// decision that it belongs in the record's sticky block at all, which is a
// record-screen decision and not a property of an alert. The screen owns the
// `position: sticky` — the strip and the section navigator stick TOGETHER as one
// block, because sticking them separately means guessing the strip's height,
// which depends on how many allergens wrap.
//
// It renders nothing when there is nothing to warn about — a permanent empty
// band would train the dentist to ignore the position.
const $ae4443ff62155701$var$MobileAllergyStrip = ({ allergies: allergies })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const list = (allergies || []).map((a)=>a.allergen).filter(Boolean);
    if (list.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "patient-allergy-strip",
        style: {
            padding: '0.5rem 0.75rem 0',
            // Opaque, not transparent: this sits in a sticky block, and the cards
            // scrolling underneath would otherwise show through the Alert's soft
            // tint and make the allergen text unreadable exactly while it matters.
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
            variant: "warning",
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                size: 16
            }),
            title: t('patient.summary.allergyWarning'),
            children: list.join(" \xb7 ")
        })
    });
};
var $ae4443ff62155701$export$2e2bcd8739ae039 = $ae4443ff62155701$var$MobileAllergyStrip;



parcelRequire("acw62");





// خلاصه — who this patient is, and what they are allergic to.
//
// The desktop lays the twelve demographic fields out on a
// `repeat(auto-fill, minmax(180px, 1fr))` grid. On a phone that collapses to one
// column anyway, but with the label ABOVE the value — two lines per fact and
// twenty-four lines of scroll. One full-width row per fact, label at the
// inline-start and value at the inline-end, halves it and keeps a long value
// from ever forcing a horizontal scroll (§4B, §6).
//
// The allergy banner is NOT repeated here: on this surface it is the sticky
// strip above the section navigator (§4C ③), which is strictly better than a
// banner that scrolls away.
const $601f0593eab6ae42$var$MobilePatientSummary = ({ patient: patient })=>{
    const { t: t, formatNumber: formatNumber, formatDigits: formatDigits, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const allergies = patient.allergies || [];
    const gKey = (0, $2e1381078ec7f76f$export$c58a664d6aae39f0)(patient.gender);
    const mKey = (0, $2e1381078ec7f76f$export$c50166745a33f7cd)(patient.maritalStatus);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "patient-summary",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                children: t('patient.summary.demographics')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    padding: '0.25rem 0.875rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('common.labels.phone'),
                        value: patient.phone ? formatDigits((0, $412e1a8a99c19c1a$exports).forDisplay(patient.phone)) : null,
                        ltr: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('common.labels.nationalId'),
                        value: patient.nationalId ? formatDigits(patient.nationalId) : null,
                        ltr: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('common.labels.fileNumber'),
                        value: patient.fileNumber ? formatDigits(patient.fileNumber) : null
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.birthDate'),
                        value: patient.birthDate ? formatDigits(patient.birthDate) : null
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.stats.age'),
                        value: patient.age != null ? t('common.units.years', {
                            count: patient.age
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.gender'),
                        value: gKey ? t(gKey) : patient.gender
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.maritalStatus'),
                        value: mKey ? t(mKey) : patient.maritalStatus
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.bloodType'),
                        value: patient.bloodType,
                        ltr: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.job'),
                        value: patient.job
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.insurance'),
                        value: patient.insurance
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.height'),
                        value: patient.height ? formatNumber(patient.height) : null
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                        label: t('patient.fields.createdAt'),
                        value: patient.createdAt ? formatDate(patient.createdAt, 'numeric') : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                style: {
                    marginTop: '0.875rem'
                },
                children: t('patient.summary.allergies')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                style: {
                    padding: '0.875rem'
                },
                children: allergies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        fontSize: '0.8125rem',
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    },
                    children: t('patient.summary.noAllergies')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.625rem'
                    },
                    children: allergies.map((a)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                flexWrap: 'wrap'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: '0.8125rem',
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: a.allergen
                                }),
                                a.severity && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: (0, $2e1381078ec7f76f$export$43b5c849fabfd025)(a.severity) ? t((0, $2e1381078ec7f76f$export$43b5c849fabfd025)(a.severity)) : a.severity
                                }),
                                a.reaction && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: '0.75rem',
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                    },
                                    children: a.reaction
                                })
                            ]
                        }, a.id))
                })
            })
        ]
    });
};
var $601f0593eab6ae42$export$2e2bcd8739ae039 = $601f0593eab6ae42$var$MobilePatientSummary;



parcelRequire("acw62");





// سوابق — what has been recorded about this patient, read-only.
//
// The desktop row is one flex line whose date is pushed to the far end with
// `marginInlineStart: auto`; at 320px that collides with a long condition name.
// Here every entry is its own card: the name on the first line, the code, the
// status and the date beneath it, so nothing has to fight for the same line.
//
// Conditions and medications come from clinicalencounter and are keyed on
// `appointment_id`: there is no encounters table on this platform, encounters
// ARE appointments. Nothing here groups by "visit" for that reason — inventing
// a visit grouping the data does not carry would be inventing a fact.
const $f08bb5a488c2f257$var$dosageLine = (medication)=>{
    const d = medication?.dosageInstruction;
    if (!d) return '';
    if (typeof d === 'string') return d;
    if (d.text) return d.text;
    return [
        d.dose,
        d.frequency,
        d.duration
    ].filter(Boolean).join(" \xb7 ");
};
const $f08bb5a488c2f257$var$Empty = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        style: {
            padding: '0.875rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: {
                fontSize: '0.8125rem',
                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
            },
            children: children
        })
    });
const $f08bb5a488c2f257$var$MobilePatientHistory = ({ patient: patient })=>{
    const { t: t, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const conditions = patient.conditions || [];
    const medications = patient.medications || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "patient-history",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                children: t('patient.history.conditions')
            }),
            conditions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f08bb5a488c2f257$var$Empty, {
                children: t('patient.history.noConditions')
            }) : conditions.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.75rem',
                        marginBottom: '0.5rem',
                        borderRadius: '0.875rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            style: {
                                fontSize: '0.8125rem',
                                fontWeight: 700,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                            },
                            children: c.display
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                flexWrap: 'wrap',
                                marginTop: '0.375rem'
                            },
                            children: [
                                c.code && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    dir: "ltr",
                                    style: {
                                        unicodeBidi: 'isolate',
                                        fontSize: '0.6875rem',
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: c.code
                                }),
                                c.clinicalStatus && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: (0, $2e1381078ec7f76f$export$d96129a410768e32)(c.clinicalStatus) ? t((0, $2e1381078ec7f76f$export$d96129a410768e32)(c.clinicalStatus)) : c.clinicalStatus
                                }),
                                c.onsetDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        marginInlineStart: 'auto'
                                    },
                                    children: formatDate(c.onsetDate, 'numeric')
                                })
                            ]
                        })
                    ]
                }, c.id)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                style: {
                    marginTop: '0.875rem'
                },
                children: t('patient.history.medications')
            }),
            medications.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f08bb5a488c2f257$var$Empty, {
                children: t('patient.history.noMedications')
            }) : medications.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.75rem',
                        marginBottom: '0.5rem',
                        borderRadius: '0.875rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            style: {
                                fontSize: '0.8125rem',
                                fontWeight: 700,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                            },
                            children: m.display
                        }),
                        $f08bb5a488c2f257$var$dosageLine(m) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            dir: "auto",
                            style: {
                                fontSize: '0.75rem',
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                marginTop: '0.25rem'
                            },
                            children: $f08bb5a488c2f257$var$dosageLine(m)
                        }),
                        m.authoredOn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: '0.6875rem',
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                marginTop: '0.25rem'
                            },
                            children: t('patient.history.prescribedOn', {
                                date: formatDate(m.authoredOn, 'numeric')
                            })
                        })
                    ]
                }, m.id))
        ]
    });
};
var $f08bb5a488c2f257$export$2e2bcd8739ae039 = $f08bb5a488c2f257$var$MobilePatientHistory;




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2cf9022b4ea6e252$export$a2387ed3b5d536eb = {
    name: "sliders-horizontal",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 5H3",
                key: "1qgfaw"
            }
        ],
        [
            "path",
            {
                d: "M12 19H3",
                key: "yhmn1j"
            }
        ],
        [
            "path",
            {
                d: "M14 3v4",
                key: "1sua03"
            }
        ],
        [
            "path",
            {
                d: "M16 17v4",
                key: "1q0r14"
            }
        ],
        [
            "path",
            {
                d: "M21 12h-9",
                key: "1o4lsq"
            }
        ],
        [
            "path",
            {
                d: "M21 19h-5",
                key: "1rlt1p"
            }
        ],
        [
            "path",
            {
                d: "M21 5h-7",
                key: "1oszz2"
            }
        ],
        [
            "path",
            {
                d: "M8 10v4",
                key: "tgpxqk"
            }
        ],
        [
            "path",
            {
                d: "M8 12H3",
                key: "a7s4jb"
            }
        ]
    ]
};
$2cf9022b4ea6e252$export$a2387ed3b5d536eb.node;
const $2cf9022b4ea6e252$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($2cf9022b4ea6e252$export$a2387ed3b5d536eb);












var $acw62 = parcelRequire("acw62");




// THE TOUCH PATH INTO A TOOTH.
//
// ── why this component exists ───────────────────────────────────────────────
//
// The odontogram is 620 viewBox units carrying 32 crowns. Scaled to a 360px
// phone that is ~0.58×, which puts a crown near 10px and one of its five
// surfaces far below that. §6's floor is 2.75rem (44px). Those two numbers
// cannot both be satisfied inside the arch, and the arch is the part that
// cannot move: CORE.md §9 makes the anatomical frame a patient-safety
// invariant, so pan/zoom (a nested scroll region, §6) , a per-quadrant redraw
// (which destroys the whole-mouth glance that makes an odontogram an
// odontogram) and mirroring are all off the table.
//
// So the CHART stays the overview — read at a glance, tappable as a
// convenience — and the compliant target lives outside the <svg>: quadrant
// chips over a grid of ≥2.75rem tooth chips. Both paths call the SAME
// `onPick(fdi)` the chart calls, and surface-level editing (the genuinely
// sub-10px part) happens in the tooth sheet, where every surface is its own
// 44px chip.
//
// ── why the quadrants are in this order ─────────────────────────────────────
//
// SCREEN order, from `QUADRANTS` in lib/teeth.js: Q1 · Q2 on top, Q4 · Q3
// beneath — the patient's right first, in BOTH locales, exactly as the chart
// draws them. Numeric order (1,2,3,4) would zig-zag across the mouth and break
// the dentist's map of the arch between the two controls.
const $9002703f785118c4$var$MobileToothPicker = ({ teeth: teeth, byFdi: byFdi, showPrimary: showPrimary, selected: selected, onPick: onPick, t: t })=>{
    const [quadrant, setQuadrant] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $789c06d5db9cfc3f$export$89717d998154e6e4)[0].id);
    const withPrimary = (0, $789c06d5db9cfc3f$export$7995d2693cfacea3)(showPrimary, teeth);
    const active = (0, $789c06d5db9cfc3f$export$89717d998154e6e4).find((q)=>q.id === quadrant) || (0, $789c06d5db9cfc3f$export$89717d998154e6e4)[0];
    const fdis = withPrimary ? [
        ...active.teeth,
        ...active.primary
    ] : active.teeth;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "chart-picker",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "group",
                "aria-label": t('chart.mobile.pickTooth'),
                style: {
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '0.5rem'
                },
                children: (0, $789c06d5db9cfc3f$export$89717d998154e6e4).map((q)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                        label: t(q.key),
                        active: q.id === active.id,
                        onClick: ()=>setQuadrant(q.id),
                        "data-testid": `chart-picker-quadrant-${q.id}`,
                        className: "w-full justify-center text-[0.6875rem]"
                    }, q.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    // 2.75rem minimum per column, as many as fit — the §6 floor expressed
                    // as the layout rule rather than checked after the fact.
                    gridTemplateColumns: 'repeat(auto-fit, minmax(2.75rem, 1fr))',
                    gap: '0.375rem',
                    marginTop: '0.625rem'
                },
                children: fdis.map((fdi)=>{
                    const state = byFdi?.[fdi];
                    const tint = (0, $789c06d5db9cfc3f$export$47f15c26a9378317)(state);
                    const on = selected === fdi;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        onClick: ()=>onPick?.(fdi),
                        "aria-pressed": on,
                        "aria-label": `${t('chart.tooth')} ${fdi}`,
                        "data-testid": `chart-picker-tooth-${fdi}`,
                        className: "min-h-11 min-w-11 px-0",
                        style: {
                            // The chip carries the chart's OWN colour vocabulary, from the
                            // same `toothOutline` the crown outline uses — so a red tooth on
                            // the chart is a red chip here and the two cannot drift.
                            background: on ? tint.stroke : tint.fill,
                            borderColor: tint.stroke,
                            color: on ? '#fff' : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            fontWeight: 700
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            ...(0, $a278322405d51c25$export$3433559efc22d110),
                            children: fdi
                        })
                    }, fdi);
                })
            })
        ]
    });
};
var $9002703f785118c4$export$2e2bcd8739ae039 = $9002703f785118c4$var$MobileToothPicker;




var $acw62 = parcelRequire("acw62");





// Editing one tooth, on a phone.
//
// The desktop editor is the kit `Drawer` at a fixed `width: 400; left: 0` — on a
// 320–390px phone it exceeds the viewport, and DentistLayout's `overflow:hidden`
// clips whatever spills. Its pill row is a hand-rolled raw <button> at ~30px,
// beside a raw <textarea> and a raw <input type=checkbox>. None of that is
// copied here: §6's floor is 2.75rem and DESIGN.md rule 1 forbids a raw
// <button>, so every control below is a kit primitive — `FilterChip` (min-h-11,
// aria-pressed, data-state), `Textarea`, `Checkbox`, `Button`.
//
// THE SURFACE PROBLEM IS SOLVED HERE. A surface region inside the arch is well
// under 10px on a phone and cannot be enlarged without breaking the anatomical
// frame (CORE.md §9). Every surface is therefore its own 44px chip in this
// sheet, and the chart's own surface taps stay a convenience for a stylus or a
// tablet.
//
// The DRAFT and the batch come from `buildToothEvents` — the same function the
// desktop drawer builds its batch with. The markup forks; the wire format does
// not (§1.1).
const $89af2117a1eab8fa$var$Section = ({ title: title, hint: hint, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            marginBottom: '1.125rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '0.5rem',
                    marginBottom: '0.5rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        style: {
                            margin: 0,
                            fontSize: '0.8125rem',
                            fontWeight: 700,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: title
                    }),
                    hint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: hint
                    })
                ]
            }),
            children
        ]
    });
// §6: "adjacent targets keep ≥ 0.5rem gap".
const $89af2117a1eab8fa$var$ChipRow = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0.5rem'
        },
        children: children
    });
function $89af2117a1eab8fa$export$2e2bcd8739ae039({ open: open, fdi: fdi, state: state, onClose: onClose, onSave: onSave, saving: saving, focusSurface: focusSurface, t: t, history: /**
   * What has already happened to this tooth, rendered above the editor.
   *
   * A NODE, for the same reason the desktop drawer takes one: the screen knows
   * what the trail costs and when to read it; the sheet only decides WHERE it
   * goes — first, because «what was done here» is the context for what is about
   * to be recorded.
   */ history = null }) {
    // draft: { presence, condition:{value,material}, surfaces:{ [code]:{value,material} }, note }
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        surfaces: {}
    });
    const [activeSurface, setActiveSurface] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [err, setErr] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Reset whenever the sheet opens on a different tooth — a draft carried
    // between teeth would record a filling on whichever one was opened next.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setDraft({
                surfaces: {}
            });
            setErr(null);
            setActiveSurface(focusSurface || null);
        }
    }, [
        open,
        fdi,
        focusSurface
    ]);
    const surfaces = state?.surfacesAvailable?.length ? state.surfacesAvailable : fdi ? (0, $789c06d5db9cfc3f$export$e8e69ffa6db2b2c2)(fdi) : [];
    const missing = (0, $789c06d5db9cfc3f$export$5c3943b5a89fa884)(draft.presence ?? state?.presence);
    const currentOf = (code)=>(state?.surfaces || []).find((s)=>s.surface === code)?.value || null;
    const setSurface = (code, value)=>setDraft((d)=>({
                ...d,
                surfaces: {
                    ...d.surfaces,
                    // Tapping the chosen value again clears the pending edit rather than
                    // recording the same thing twice.
                    [code]: d.surfaces[code]?.value === value ? undefined : {
                        value: value,
                        material: null
                    }
                }
            }));
    const setSurfaceMaterial = (code, material)=>setDraft((d)=>({
                ...d,
                surfaces: {
                    ...d.surfaces,
                    [code]: {
                        ...d.surfaces[code],
                        material: material
                    }
                }
            }));
    // EVERY HOOK IS ABOVE THIS LINE — the same rule the desktop drawer carries.
    // React identifies hooks by call order, so an early return between two of
    // them is never safe however obvious the condition looks (React #310).
    const events = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $c6530d73ef205691$export$42d1dcf756bfbad5)(draft, fdi, state), [
        draft,
        fdi,
        state
    ]);
    if (!open || !fdi) return null;
    const submit = async ()=>{
        setErr(null);
        const failure = await onSave(events);
        // Losing a half-charted tooth to a closed sheet is worse than the error.
        if (failure) setErr(failure);
        else onClose();
    };
    const title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            flexWrap: 'wrap'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                    fontWeight: 800
                },
                children: [
                    t('chart.tooth'),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                        children: fdi
                    })
                ]
            }),
            state?.universal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    fontSize: '0.6875rem',
                    fontWeight: 500,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: [
                    t('chart.universalShort'),
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                        children: state.universal
                    })
                ]
            }),
            state?.isCharted === false && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                children: t('chart.notCharted')
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        title: title,
        closeLabel: t('mobile.close'),
        "data-testid": "tooth-sheet",
        footer: // §6: "submit docks bottom". The sheet's body is an 85vh scroll region,
        // so a commit row inside it would scroll away exactly when it is needed.
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                gap: '0.5rem'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: submit,
                    disabled: saving || events.length === 0,
                    "data-testid": "tooth-sheet-save",
                    className: "flex-1 min-h-11",
                    children: saving ? t('common.actions.saving') : `${t('common.actions.save')}${events.length ? ` (${events.length})` : ''}`
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    onClick: onClose,
                    disabled: saving,
                    "data-testid": "tooth-sheet-cancel",
                    className: "min-h-11",
                    children: t('common.actions.cancel')
                })
            ]
        }),
        children: [
            history,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$Section, {
                title: t('chart.presence.title'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$ChipRow, {
                    children: (0, $789c06d5db9cfc3f$export$82384a94f00cdd46).map((p)=>{
                        const on = (draft.presence ?? state?.presence) === p;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                            label: t(`chart.presence.${p}`),
                            active: on,
                            onClick: ()=>setDraft((d)=>({
                                        ...d,
                                        presence: p
                                    })),
                            "data-testid": `tooth-sheet-presence-${p}`,
                            style: on && p === (0, $789c06d5db9cfc3f$export$52e39c9e8fc17728).PRESENT ? {
                                borderColor: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                            } : undefined
                        }, p);
                    })
                })
            }),
            !missing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($89af2117a1eab8fa$var$Section, {
                        title: t('chart.surfaces.title'),
                        hint: t('chart.surfaces.hint'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$ChipRow, {
                                children: surfaces.map((code)=>{
                                    const pending = draft.surfaces[code]?.value;
                                    const current = currentOf(code);
                                    const shown = pending || current;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                        active: activeSurface === code,
                                        onClick: ()=>setActiveSurface(activeSurface === code ? null : code),
                                        "data-testid": `tooth-sheet-surface-${code}`,
                                        style: shown ? {
                                            borderColor: (0, $789c06d5db9cfc3f$export$332b24b8d2f6799)(shown).stroke
                                        } : undefined,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                children: code
                                            }),
                                            " \xb7 ",
                                            t(`chart.surface.${code}`),
                                            shown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                style: {
                                                    marginInlineStart: '0.375rem',
                                                    fontSize: '0.6875rem',
                                                    opacity: 0.85
                                                },
                                                children: [
                                                    t(`chart.surfaceState.${shown}`),
                                                    pending && ' *'
                                                ]
                                            })
                                        ]
                                    }, code);
                                })
                            }),
                            activeSurface && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: '0.625rem',
                                    padding: '0.75rem',
                                    borderRadius: '0.625rem',
                                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                            marginBottom: '0.5rem'
                                        },
                                        children: [
                                            t('chart.surfaces.setFor'),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                children: t(`chart.surface.${activeSurface}`)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$ChipRow, {
                                        children: (0, $789c06d5db9cfc3f$export$1d0d1c0dec314fe8).map((v)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                                label: t(`chart.surfaceState.${v}`),
                                                active: draft.surfaces[activeSurface]?.value === v,
                                                onClick: ()=>setSurface(activeSurface, v),
                                                "data-testid": `tooth-sheet-state-${v}`,
                                                style: {
                                                    borderColor: (0, $789c06d5db9cfc3f$export$332b24b8d2f6799)(v).stroke
                                                }
                                            }, v))
                                    }),
                                    (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('surface', draft.surfaces[activeSurface]?.value).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            marginTop: '0.625rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: '0.75rem',
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                    marginBottom: '0.375rem'
                                                },
                                                children: t('chart.material')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$ChipRow, {
                                                children: (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('surface', draft.surfaces[activeSurface]?.value).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                                        label: t(`chart.materialName.${m}`),
                                                        active: draft.surfaces[activeSurface]?.material === m,
                                                        onClick: ()=>setSurfaceMaterial(activeSurface, m),
                                                        "data-testid": `tooth-sheet-surface-material-${m}`
                                                    }, m))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($89af2117a1eab8fa$var$Section, {
                        title: t('chart.condition.title'),
                        hint: t('chart.condition.hint'),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$ChipRow, {
                                children: (0, $789c06d5db9cfc3f$export$58954b0b7e983b1b).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                        label: t(`chart.conditionName.${c}`),
                                        active: draft.condition?.value === c,
                                        onClick: ()=>setDraft((d)=>({
                                                    ...d,
                                                    condition: d.condition?.value === c ? null : {
                                                        value: c,
                                                        material: null
                                                    }
                                                })),
                                        "data-testid": `tooth-sheet-condition-${c}`
                                    }, c))
                            }),
                            (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('condition', draft.condition?.value).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: '0.625rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                            marginBottom: '0.375rem'
                                        },
                                        children: t('chart.material')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$ChipRow, {
                                        children: (0, $789c06d5db9cfc3f$export$13f248a297f9c8b4)('condition', draft.condition?.value).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                                label: t(`chart.materialName.${m}`),
                                                active: draft.condition?.material === m,
                                                onClick: ()=>setDraft((d)=>({
                                                            ...d,
                                                            condition: {
                                                                ...d.condition,
                                                                material: m
                                                            }
                                                        })),
                                                "data-testid": `tooth-sheet-condition-material-${m}`
                                            }, m))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($89af2117a1eab8fa$var$Section, {
                title: t('chart.note.title'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                    value: draft.note || '',
                    onChange: (e)=>setDraft((d)=>({
                                ...d,
                                note: e.target.value
                            })),
                    rows: 2,
                    dir: "auto",
                    placeholder: t('chart.note.placeholder'),
                    "aria-label": t('chart.note.title'),
                    "data-testid": "tooth-sheet-note",
                    // ≥1rem or iOS zooms the whole page on focus (§6). `inputStyle`
                    // reaches the control; the kit's `style` dresses the field.
                    inputStyle: {
                        fontSize: '1rem'
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                checked: !!draft.isHistorical,
                onChange: (next)=>setDraft((d)=>({
                            ...d,
                            isHistorical: !!next
                        })),
                label: t('chart.isHistorical'),
                "data-testid": "tooth-sheet-historical",
                className: "min-h-11"
            }),
            err && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                role: "alert",
                style: {
                    marginTop: '0.875rem'
                },
                children: err.message
            })
        ]
    });
}



parcelRequire("acw62");




// The chart's key, for the phone.
//
// The legend is not decoration: the chart encodes clinical meaning in colour
// and glyph, and a colour-coded record with no key is unreadable to anyone but
// its author. But thirteen swatches ahead of the arch would push the chart off
// the fold on a 360px screen, so on mobile it lives inside a collapsed
// `CollapsibleSection` (the screen owns the disclosure; this is only the body).
//
// Every swatch is drawn by the SAME generator the chart uses — never redrawn by
// hand — so the key cannot drift from the chart. That is the desktop legend's
// rule, kept.
const $3724d79ebbbd8cf3$var$LEGEND_FDI = '16';
const $3724d79ebbbd8cf3$var$LEGEND_POST_CORE = (0, $1e2d81a721530153$export$28ba678519100449)($3724d79ebbbd8cf3$var$LEGEND_FDI);
const $3724d79ebbbd8cf3$var$Item = ({ children: children, label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.375rem',
            minWidth: 0
        },
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    fontSize: '0.6875rem',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                children: label
            })
        ]
    });
const $3724d79ebbbd8cf3$var$Swatch = ({ swatch: swatch })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        "aria-hidden": true,
        style: {
            width: '0.75rem',
            height: '0.75rem',
            borderRadius: '0.1875rem',
            display: 'inline-block',
            flex: 'none',
            background: swatch.fill,
            border: `1.5px solid ${swatch.stroke}`
        }
    });
const $3724d79ebbbd8cf3$var$Glyph = ({ children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 15,
        height: 15,
        viewBox: "-19 -19 38 38",
        "aria-hidden": "true",
        style: {
            display: 'block',
            flex: 'none'
        },
        children: children
    });
const $3724d79ebbbd8cf3$var$Silhouette = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
        d: (0, $1e2d81a721530153$export$fdbe61f566b424c8)($3724d79ebbbd8cf3$var$LEGEND_FDI),
        fill: "none",
        stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).untouched.stroke,
        strokeWidth: 1.5
    });
const $3724d79ebbbd8cf3$var$MobileChartLegend = ({ t: t })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "chart-legend",
        style: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(8rem, 1fr))',
            gap: '0.5rem 0.75rem',
            padding: '0.25rem 0 0.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.surfaceState.caries'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).caries
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.legend.wholeToothCaries'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).caries_tooth
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.surfaceState.restoration'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).restoration
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.surfaceState.recurrent_caries'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).recurrent_caries
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.surfaceState.temporary'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).temporary
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.surfaceState.sealant'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).sealant
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.presence.extracted'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).missing
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.notCharted'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Swatch, {
                    swatch: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).untouched
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.conditionName.crown'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: (0, $1e2d81a721530153$export$ecea09364f6d7e85)($3724d79ebbbd8cf3$var$LEGEND_FDI),
                            fill: "none",
                            stroke: (0, $789c06d5db9cfc3f$export$e5b4b6e3feb01a67)(null),
                            strokeWidth: 2.6
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.conditionName.root_canal'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                            points: (0, $1e2d81a721530153$export$93f6716ad9cd507a)($3724d79ebbbd8cf3$var$LEGEND_FDI),
                            fill: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).root_canal.stroke,
                            transform: "scale(2)"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.conditionName.implant'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                            transform: "scale(1.8)",
                            children: (0, $1e2d81a721530153$export$de80878fd40fdd08)($3724d79ebbbd8cf3$var$LEGEND_FDI).map((s, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                    x1: s.x1,
                                    y1: s.y1,
                                    x2: s.x2,
                                    y2: s.y2,
                                    stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).implant.stroke,
                                    strokeWidth: 2,
                                    strokeLinecap: "round"
                                }, i))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.conditionName.post_core'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            transform: "scale(1.8)",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                                    x1: $3724d79ebbbd8cf3$var$LEGEND_POST_CORE.bar.x1,
                                    y1: $3724d79ebbbd8cf3$var$LEGEND_POST_CORE.bar.y1,
                                    x2: $3724d79ebbbd8cf3$var$LEGEND_POST_CORE.bar.x2,
                                    y2: $3724d79ebbbd8cf3$var$LEGEND_POST_CORE.bar.y2,
                                    stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).post_core.stroke,
                                    strokeWidth: 2,
                                    strokeLinecap: "round"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: $3724d79ebbbd8cf3$var$LEGEND_POST_CORE.dot.cx,
                                    cy: $3724d79ebbbd8cf3$var$LEGEND_POST_CORE.dot.cy,
                                    r: $3724d79ebbbd8cf3$var$LEGEND_POST_CORE.dot.r,
                                    fill: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).post_core.stroke
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.conditionName.veneer'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: (0, $1e2d81a721530153$export$8dd5375953039c36)($3724d79ebbbd8cf3$var$LEGEND_FDI),
                            fill: "none",
                            stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).restoration.stroke,
                            strokeWidth: 3.5,
                            strokeLinecap: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.conditionName.fracture'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                            points: (0, $1e2d81a721530153$export$43af588fb1be7790)($3724d79ebbbd8cf3$var$LEGEND_FDI),
                            fill: "none",
                            stroke: (0, $789c06d5db9cfc3f$export$c080d5661a747fd2).fractured.stroke,
                            strokeWidth: 2
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.legend.planned'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: (0, $1e2d81a721530153$export$fdbe61f566b424c8)($3724d79ebbbd8cf3$var$LEGEND_FDI),
                            fill: "none",
                            ...(0, $789c06d5db9cfc3f$export$268f349e84521056)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.legend.treated'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($3724d79ebbbd8cf3$var$Glyph, {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Silhouette, {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                            transform: "scale(2.4)",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $849f2169098c9170$export$2e2bcd8739ae039), {
                                count: 1
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Item, {
                label: t('chart.legend.bridge'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3724d79ebbbd8cf3$var$Glyph, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                        x1: -15,
                        y1: 0,
                        x2: 15,
                        y2: 0,
                        ...(0, $789c06d5db9cfc3f$export$49e77edbb85c0c46)
                    })
                })
            })
        ]
    });
var $3724d79ebbbd8cf3$export$2e2bcd8739ae039 = $3724d79ebbbd8cf3$var$MobileChartLegend;




// چارت دندان — the mobile section (§4C ⑤).
//
// ┌──────────────────────────────────────┐
// │ StatTiles 4-up   پوسیده · ترمیم · … │
// │ [⚙ تنظیمات نمودار] → BottomSheet     │
// │ <Odontogram/>  ← UNCHANGED, ltr      │
// │ MobileToothPicker  ← the ≥44px path  │
// │ CollapsibleSection «راهنما»           │
// │ MobileToothSheet (BottomSheet)        │
// └──────────────────────────────────────┘
//
// THE ODONTOGRAM IS RENDERED VERBATIM. Not forked, not wrapped in a transform,
// not given a `direction` or a logical property on its container, not
// pan/zoomed, not split per quadrant. It is viewBox-scaled at width:100% and
// already carries `style={{direction:'ltr'}}`, which is what keeps the patient's
// right on the screen's left in BOTH locales (CORE.md §9 — a patient-safety
// invariant, not styling). The chart is the OVERVIEW; MobileToothPicker is the
// touch-compliant way in. See that file for the full reasoning.
//
// The three chart CONTROLS move into a BottomSheet — §6 makes the sheet the
// default overlay for a task or a setting set, and three outline buttons in a
// row would eat the fold above the chart.
const $6515ff49ba056ba8$var$MobilePatientChart = ({ patientId: patientId, clinicId: clinicId })=>{
    const { t: t, formatDate: formatDate, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { teeth: teeth, byFdi: byFdi, summary: summary, loading: loading, error: error, saving: saving, record: record, reload: reload } = (0, $b11e9ffe8c3f2849$export$26586bb2073aa39c)({
        patientId: patientId,
        clinicId: clinicId
    });
    // The plan and the treatments, on the phone's chart too — the same hook the
    // visit and the desktop record use, so no two charts can disagree about what
    // is planned on a tooth or what was done to it.
    const { plans: plans, records: records, catalog: catalog } = (0, $cfeee402cf40bab0$export$29b2b9621f2e7a20)({
        patientId: patientId,
        clinicId: clinicId
    });
    const planTeeth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$c825b1cc6eb6552a)(plans), [
        plans
    ]);
    const plannedFdis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$49c0abb5f6c435a2)(planTeeth), [
        planTeeth
    ]);
    const treatedFdis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$774cea0d439b4aad)(records, catalog), [
        records,
        catalog
    ]);
    const wholeMouth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$cc03fdd5f9432e88)(records), [
        records
    ]);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [focusSurface, setFocusSurface] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showHistory, setShowHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const historyId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    // One read per tooth, fired only when the trail is asked for.
    const history = (0, $b11e9ffe8c3f2849$export$e3f31f0e2006ba13)({
        patientId: patientId,
        toothFdi: selected,
        enabled: showHistory && !!selected
    });
    // Folded away when the sheet moves to another tooth — otherwise one tooth's
    // history shows under another tooth's heading until the new read lands.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowHistory(false);
    }, [
        selected
    ]);
    const toothRecords = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>selected ? (records || []).filter((r)=>r?.toothFdi === selected) : [], [
        records,
        selected
    ]);
    const [showPrimary, setShowPrimary] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('auto');
    const [labelMode, setLabelMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('fdi');
    const [settingsOpen, setSettingsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [exporting, setExporting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const chartBoxRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The ONE way a tooth is opened — from the chart, or from the picker.
    const openTooth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi, surface = null)=>{
        setSelected(fdi);
        setFocusSurface(surface);
    }, []);
    const doExport = async ()=>{
        setExporting(true);
        try {
            const res = await (0, $3fc1a6f2dc9b6a88$export$bb74a4b3702605c)({
                svgEl: chartBoxRef.current?.querySelector('svg'),
                patientId: patientId,
                header: `${patientId} \u{2014} ${formatDate(Date.now(), 'numeric')}`
            });
            // §7: a failure REPORTS. The desktop paints a hand-rolled red div; on
            // mobile the sheet is already closing, so the toast is the right channel.
            if (!res.ok) toast.error(t('chart.export.error'));
        } finally{
            setExporting(false);
            setSettingsOpen(false);
        }
    };
    // §7: the chart's OWN shape — tiles, the arch at its aspect, the tooth
    // picker — not a generic card stack (DESIGN.md §"Loading & skeleton").
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0b706c85b9518d1$export$5fb13581ab29a88b), {
        label: t('common.loading')
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "alert",
        "data-state": "error",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('chart.error.title'),
            description: t('chart.error.body'),
            onRetry: reload,
            retryLabel: t('common.actions.retry')
        })
    });
    // Values are PRE-FORMATTED — §8: "Persian digits via the shared utils
    // everywhere a number renders". The kit renders `value` verbatim on purpose;
    // the digit seam belongs to the app.
    const tiles = [
        {
            key: 'decayed',
            label: t('chart.summary.decayed'),
            value: formatNumber(summary?.decayed ?? 0),
            solid: true
        },
        {
            key: 'restored',
            label: t('chart.summary.restored'),
            value: formatNumber(summary?.restored ?? 0),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        },
        {
            key: 'missing',
            label: t('chart.summary.missing'),
            value: formatNumber(summary?.missing ?? 0)
        },
        {
            key: 'dmft',
            label: t('chart.summary.dmft'),
            value: formatNumber(summary?.dmft ?? 0),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "chart-content",
        "data-state": "content",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea4bc4a14affb445$export$2e2bcd8739ae039), {
                tiles: tiles,
                "data-testid": "chart-stats"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                style: {
                    marginTop: '0.875rem'
                },
                count: formatNumber(summary?.chartedTeeth ?? 0),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    onClick: ()=>setSettingsOpen(true),
                    "data-testid": "chart-settings-open",
                    className: "min-h-11 gap-1.5",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2cf9022b4ea6e252$export$2e2bcd8739ae039), {
                            size: 15,
                            "aria-hidden": true
                        }),
                        t('chart.mobile.settings')
                    ]
                }),
                children: t('chart.summary.charted')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: chartBoxRef,
                style: {
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: '0.75rem',
                    padding: '0.5rem 0.25rem 0.25rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45122e9f240c7236$export$2e2bcd8739ae039), {
                    teeth: teeth,
                    selected: selected,
                    highlight: plannedFdis,
                    treated: treatedFdis,
                    planned: planTeeth,
                    onSelect: (fdi)=>openTooth(fdi),
                    onSurfaceSelect: (fdi, surface)=>openTooth(fdi, surface),
                    showPrimary: showPrimary,
                    labelMode: labelMode,
                    t: t,
                    formatDate: formatDate
                })
            }),
            wholeMouth.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "chart-whole-mouth",
                style: {
                    marginTop: '0.5rem',
                    fontSize: '0.6875rem',
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    display: 'flex',
                    gap: '0.375rem',
                    flexWrap: 'wrap',
                    alignItems: 'baseline',
                    lineHeight: 1.8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: [
                            t('chart.wholeMouth.title'),
                            t('common.punct.colon')
                        ]
                    }),
                    wholeMouth.slice(0, 3).map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                i > 0 ? "\xb7 " : '',
                                (0, $0cd549c1a257ae26$export$279093cb86d9c700)(r, catalog) || t('visit.plan.untitledItem')
                            ]
                        }, r.id)),
                    wholeMouth.length > 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('chart.tooltip.andMore', {
                            count: formatNumber(wholeMouth.length - 3)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: '0.875rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                        children: t('chart.mobile.pickTooth')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: '0.6875rem',
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginBottom: '0.625rem',
                            lineHeight: 1.8
                        },
                        children: t('chart.mobile.tapHint')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9002703f785118c4$export$2e2bcd8739ae039), {
                        teeth: teeth,
                        byFdi: byFdi,
                        showPrimary: showPrimary,
                        selected: selected,
                        onPick: (fdi)=>openTooth(fdi),
                        t: t
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: '0.875rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2358e3acbc4a7e55$export$2e2bcd8739ae039), {
                    title: t('chart.mobile.legend'),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3724d79ebbbd8cf3$export$2e2bcd8739ae039), {
                        t: t
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
                open: settingsOpen,
                onClose: ()=>setSettingsOpen(false),
                title: t('chart.mobile.settings'),
                closeLabel: t('mobile.close'),
                "data-testid": "chart-settings-sheet",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.875rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                            checked: showPrimary === true,
                            onChange: (next)=>setShowPrimary(next ? true : 'auto'),
                            label: t('chart.showPrimary'),
                            "data-testid": "chart-settings-primary",
                            className: "min-h-11"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                            checked: labelMode === 'both',
                            onChange: (next)=>setLabelMode(next ? 'both' : 'fdi'),
                            label: t('chart.showUniversal'),
                            "data-testid": "chart-settings-universal",
                            className: "min-h-11"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: doExport,
                            disabled: exporting,
                            "data-testid": "chart-settings-export",
                            className: "w-full min-h-11",
                            children: t('chart.export.button')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89af2117a1eab8fa$export$2e2bcd8739ae039), {
                open: !!selected,
                fdi: selected,
                state: selected ? byFdi[selected] : null,
                focusSurface: focusSurface,
                saving: saving,
                onSave: record,
                onClose: ()=>{
                    setSelected(null);
                    setFocusSurface(null);
                },
                history: /* «تاریخچه دندان» — the half of the record the chart cannot draw. The
             folded state says a tooth is crowned; it does not say when, by whom,
             or what was there before. Collapsed by default: the sheet is opened
             to CHART, and an 85vh scroll region that starts with a trail buries
             the editor. */ /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        marginBottom: '0.875rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            "aria-expanded": showHistory,
                            "aria-controls": historyId,
                            onClick: ()=>setShowHistory((v)=>!v),
                            "data-testid": "tooth-sheet-history-toggle",
                            className: "w-full min-h-11",
                            children: t('visit.chart.history')
                        }),
                        showHistory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            id: historyId,
                            style: {
                                marginTop: '0.5rem'
                            },
                            children: history.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0b706c85b9518d1$export$fd8935e770d919da), {
                                label: t('common.loading')
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04b6779df83121e$export$2e2bcd8739ae039), {
                                fdi: selected,
                                events: history.events,
                                records: toothRecords,
                                catalog: catalog,
                                error: !!history.error,
                                t: t,
                                formatDate: formatDate
                            })
                        })
                    ]
                }),
                t: t
            })
        ]
    });
};
var $6515ff49ba056ba8$export$2e2bcd8739ae039 = $6515ff49ba056ba8$var$MobilePatientChart;




// پرونده — THE SECTIONED MOBILE RECORD (DESIGN-CONCEPT-MOBILE §4C).
//
// ┌──────────────────────────────────────┐
// │ ① MobileHeader — CONTENT mode         │  ← back · name · کد ملی · file no.
// │    action: «نسخه» (the route exists)  │  scrolls away
// │ ② StatTiles 4-up — riding the edge    │  سن · گروه خونی · حساسیت · دارو
// │ ③ MobileAllergyStrip — STICKY         │  an allergy must never scroll off
// │ ④ SectionNav — STICKY                 │  خلاصه · چارت دندان · سوابق
// │ ⑤ the active section                  │  ONE page scroll under the sticky block
// └──────────────────────────────────────┘
//
// NO BOTTOM NAV (§4C): this is a drilled-into full-screen surface, so the
// header's content mode carries the way back. A bar offering «بیماران» here
// would be an escape hatch out of a record the dentist is halfway through
// charting.
//
// ③ AND ④ ARE THE ONLY STICKY CHROME. The header and the identity glance scroll
// away — the record wins the viewport — but a critical allergy stays visible at
// every scroll position and a section is always one tap away.
//
// Sections are CONTENT, not screens: each is one `Mobile*` component rendering
// into the same body, driven by the `?tab=` route segment through
// `PATIENT_SECTIONS`. An unknown segment falls back to خلاصه — the container
// (index.jsx) owns that rule for both surfaces.
const $0de4d1e3dbe902ac$var$PatientDetailMobile = ({ id: id, tab: tab, setTab: setTab, goBack: goBack })=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { activeId: activeId } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const { patient: patient, loading: loading, error: error, reload: reload } = (0, $781cda2ad75d5a69$export$9b570c45914f833c)(id, activeId);
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $491c0bd874346dfe$export$d6b7a0e86411dcc0)(t), [
        t
    ]);
    const navItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>sections.map(({ value: value, label: label, Icon: Icon })=>({
                key: value,
                label: label,
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 16,
                    "aria-hidden": true
                })
            })), [
        sections
    ]);
    // The record's OWN mobile shape — the gradient band, the 4-up tiles riding
    // its edge, the section navigator and the body of the section the URL
    // names — never a generic card stack (DESIGN.md §"Loading & skeleton").
    if (loading && !patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0b706c85b9518d1$export$49545925d670ceeb), {
        tab: tab,
        label: t('common.loading')
    });
    // A failed read and a record that does not exist are different facts: only one
    // of them is worth a retry button.
    if (error && !patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "patient-content",
        "data-state": "error",
        role: "alert",
        style: {
            padding: '0.875rem 0.75rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('patient.error.title'),
            description: t('errors.load.patient'),
            onRetry: reload,
            retryLabel: t('common.actions.retry')
        })
    });
    if (!patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "patient-content",
        "data-state": "empty",
        style: {
            padding: '0.875rem 0.75rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed00022cb253e04b$export$2e2bcd8739ae039), {
                    size: 44,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('patient.notFound.title'),
                description: t('patient.notFound.description'),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    className: "min-h-11",
                    onClick: goBack,
                    children: t('common.actions.back')
                })
            })
        })
    });
    const allergies = patient.allergies || [];
    const identity = [
        patient.nationalId || null,
        patient.fileNumber ? `${t('common.labels.fileNumber')} ${patient.fileNumber}` : null
    ].filter(Boolean).join(" \xb7 ");
    // Values PRE-FORMATTED (§8). A missing datum renders «—» inside the kit rather
    // than dropping its tile, so the row is always 4-up (§4).
    const tiles = [
        {
            key: 'age',
            label: t('patient.stats.age'),
            value: patient.age != null ? formatNumber(patient.age) : null,
            solid: true
        },
        {
            key: 'blood',
            label: t('patient.fields.bloodType'),
            value: patient.bloodType || null
        },
        {
            key: 'allergies',
            label: t('patient.stats.allergies'),
            value: formatNumber(allergies.length),
            // The one number on this row that changes what may be prescribed on the
            // next screen, so it is the one that is allowed to be red.
            color: allergies.length > 0 ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red : undefined
        },
        {
            key: 'meds',
            label: t('patient.stats.medications'),
            value: formatNumber((patient.medications || []).length)
        }
    ];
    return(// ONE scroll region, and the header and the identity glance are INSIDE it:
    // §4C — "The header and the identity glance scroll away — the record wins
    // the viewport — but a critical allergy stays visible at every scroll
    // position, and section switching is always one tap away."
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "patient-content",
        "data-state": "content",
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                onBack: goBack,
                backLabel: t('common.actions.back'),
                title: patient.name,
                subtitle: identity || undefined,
                "data-testid": "patient-header",
                actions: [
                    // §3.2: an action appears only when its destination exists. نسخه does
                    // (`/prescription/:patientId`), so this one resolves.
                    {
                        key: 'prescribe',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": true
                        }),
                        label: t('patient.actions.prescribe'),
                        onClick: ()=>navigate('prescription', {
                                patientId: patient.id
                            })
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '0 0.75rem',
                    marginTop: '-1rem',
                    position: 'relative'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea4bc4a14affb445$export$2e2bcd8739ae039), {
                    tiles: tiles,
                    "data-testid": "patient-stats"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 3,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                    marginTop: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae4443ff62155701$export$2e2bcd8739ae039), {
                        allergies: allergies
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd795e2724b3b1d0$export$2e2bcd8739ae039), {
                        items: navItems,
                        active: tab,
                        onSelect: setTab,
                        ariaLabel: t('patient.tabs.sectionsLabel'),
                        "data-testid": "patient-nav"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "tabpanel",
                "aria-label": sections.find((s)=>s.value === tab)?.label,
                style: {
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: tab === 'chart' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6515ff49ba056ba8$export$2e2bcd8739ae039), {
                    patientId: id,
                    clinicId: activeId
                }) : tab === 'plan' ? // Shared with the desktop rather than reduced: the plan is a list of
                // short rows, which is the one shape that needs no second layout.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9071f9b2135b847$export$2e2bcd8739ae039), {
                    patientId: id,
                    clinicId: activeId,
                    t: t,
                    formatNumber: formatNumber,
                    formatDate: formatDate
                }) : tab === 'history' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f08bb5a488c2f257$export$2e2bcd8739ae039), {
                    patient: patient
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $601f0593eab6ae42$export$2e2bcd8739ae039), {
                    patient: patient
                })
            })
        ]
    }));
};
var $0de4d1e3dbe902ac$export$2e2bcd8739ae039 = $0de4d1e3dbe902ac$var$PatientDetailMobile;




const $0de383faf6571668$export$5ff47a1a5df62032 = (0, $491c0bd874346dfe$export$de4efade1edd2a63);
const $0de383faf6571668$export$b22bf82651bf4640 = (0, $491c0bd874346dfe$export$df83de65e8171a04);
const $0de383faf6571668$var$PatientDetailScreen = ()=>{
    const { id: id, tab: tab } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const rrNavigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const section = $0de383faf6571668$export$5ff47a1a5df62032.includes(tab) ? tab : $0de383faf6571668$export$b22bf82651bf4640;
    const setTab = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        const suffix = next && next !== $0de383faf6571668$export$b22bf82651bf4640 ? `/${next}` : '';
        rrNavigate(`/patients/${id}${suffix}${location.search}`, {
            replace: true,
            state: location.state
        });
    }, [
        id,
        location.search,
        location.state,
        rrNavigate
    ]);
    const goBack = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (location.key && location.key !== 'default') rrNavigate(-1);
        else navigate('patients');
    }, [
        location.key,
        rrNavigate,
        navigate
    ]);
    const props = {
        id: id,
        tab: section,
        setTab: setTab,
        goBack: goBack
    };
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0de4d1e3dbe902ac$export$2e2bcd8739ae039), {
        ...props
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bbbe6e3a499cfdb9$export$2e2bcd8739ae039), {
        ...props
    });
};
var $0de383faf6571668$export$2e2bcd8739ae039 = $0de383faf6571668$var$PatientDetailScreen;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1882f1d059ea7fa7$export$a2387ed3b5d536eb = {
    name: "trash",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 11v6",
                key: "nco0om"
            }
        ],
        [
            "path",
            {
                d: "M14 11v6",
                key: "outv1u"
            }
        ],
        [
            "path",
            {
                d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
                key: "miytrc"
            }
        ],
        [
            "path",
            {
                d: "M3 6h18",
                key: "d0wm0j"
            }
        ],
        [
            "path",
            {
                d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                key: "e791ji"
            }
        ]
    ],
    aliases: [
        "trash-2"
    ]
};
$1882f1d059ea7fa7$export$a2387ed3b5d536eb.node;
const $1882f1d059ea7fa7$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($1882f1d059ea7fa7$export$a2387ed3b5d536eb);








// نسخه — the pure half. No React, no text, no network.
//
// It exists separately from the screen because three different things have to
// agree about what a prescription row IS: what the interaction sweep is asked
// about, what gets written to clinicalencounter, and what the dentist reads back on
// the patient's سوابق tab. One shape, defined here, tested directly.
//
// The one rule that is easy to get wrong and impossible to see in review:
// the interaction sweep is keyed on `Drug.id` — a stable slug like
// 'acetaminophen' — and NEVER on the Persian display name. The rule engine
// keys its static pairs on those slugs, so a name reaches it as an unknown drug
// and comes back clean.

/** A stable client-side row id. The medication has no server id until it is saved. */ let $d9b1b3bcd01f93df$var$seq = 0;
const $d9b1b3bcd01f93df$var$nextKey = ()=>`rx-${++$d9b1b3bcd01f93df$var$seq}`;
function $d9b1b3bcd01f93df$export$12d3280041d352a5(drug) {
    return {
        key: $d9b1b3bcd01f93df$var$nextKey(),
        drug: drug,
        dose: drug?.commonDosages?.[0] || '',
        frequency: drug?.commonFrequencies?.[0] || '',
        duration: '',
        note: ''
    };
}
function $d9b1b3bcd01f93df$export$3add0e9734e66842(item) {
    return [
        item?.dose,
        item?.frequency,
        item?.duration,
        item?.note
    ].map((part)=>String(part || '').trim()).filter(Boolean).join(" \xb7 ");
}
function $d9b1b3bcd01f93df$export$7baebe32bddaafc7(item, { appointmentId: appointmentId = null, authoredOn: authoredOn } = {}) {
    const text = $d9b1b3bcd01f93df$export$3add0e9734e66842(item);
    return {
        code: item?.drug?.id || '',
        display: item?.drug?.name || item?.drug?.genericName || '',
        status: 'active',
        authoredOn: authoredOn || (0, $6e94fc1378f3a785$export$ceda478235320bf2)(),
        dosageInstruction: {
            text: text,
            dose: item?.dose || '',
            frequency: item?.frequency || '',
            duration: item?.duration || '',
            note: item?.note || ''
        },
        ...appointmentId ? {
            appointmentId: appointmentId
        } : {}
    };
}
function $d9b1b3bcd01f93df$export$4fb019cf760083c0(items) {
    const seen = new Set();
    for (const item of items || []){
        const id = item?.drug?.id;
        if (id) seen.add(id);
    }
    return [
        ...seen
    ];
}
function $d9b1b3bcd01f93df$export$f285ed9dd1e8dd93(items) {
    return $d9b1b3bcd01f93df$export$4fb019cf760083c0(items).length >= 2;
}
function $d9b1b3bcd01f93df$export$6eaaad838274d902(raw) {
    const s = String(raw || '').toLowerCase().trim();
    if ([
        'high',
        'severe',
        'major',
        'critical',
        'contraindicated'
    ].includes(s)) return 'high';
    if ([
        'moderate',
        'medium',
        'significant'
    ].includes(s)) return 'moderate';
    return 'low';
}
const $d9b1b3bcd01f93df$var$SEVERITY_RANK = {
    high: 0,
    moderate: 1,
    low: 2
};
const $d9b1b3bcd01f93df$export$9f518ea5abf3eda7 = [
    'interaction',
    'contraindication',
    'allergy',
    'black_box'
];
function $d9b1b3bcd01f93df$export$b10d321a5bcb675d(raw) {
    const s = String(raw || '').toLowerCase().trim();
    return $d9b1b3bcd01f93df$export$9f518ea5abf3eda7.includes(s) ? s : null;
}
function $d9b1b3bcd01f93df$export$888cb547d3ca3da3(warnings) {
    return [
        ...warnings || []
    ].map((w, i)=>({
            w: w,
            i: i,
            rank: $d9b1b3bcd01f93df$var$SEVERITY_RANK[$d9b1b3bcd01f93df$export$6eaaad838274d902(w?.severity)] ?? 2
        })).sort((a, b)=>a.rank - b.rank || a.i - b.i).map((x)=>x.w);
}
const $d9b1b3bcd01f93df$export$d6bd0f6236de0844 = (patient)=>(patient?.allergies || []).map((a)=>a?.allergen).filter(Boolean);
const $d9b1b3bcd01f93df$export$c44664437aa64527 = (patient)=>(patient?.conditions || []).map((c)=>c?.display).filter(Boolean);


// نسخه — the screen's whole GraphQL contract, in one module.
//
// Three services do three jobs, and the split matters:
//
//   listDrugs             clinicalencounter — the seeded Iranian formulary. FREE.
//   checkDrugInteraction  aiassistant   — COSTS PARSINA CREDITS on every call.
//   createMedication      clinicalencounter — the persistence. FREE.
//
// `assistPrescription` is deliberately absent: it bills credits per call and
// phase 1 caps the AI surface at the interaction sweep.

const $784c74a96a5b5460$export$e94eea18383a4188 = `
  query ListDrugs($query: String, $limit: Int) {
    listDrugs(query: $query, limit: $limit) {
      id
      name
      genericName
      category
      commonDosages
      commonFrequencies
    }
  }
`;
const $784c74a96a5b5460$export$9812972017b718e1 = `
  query CheckDrugInteraction(
    $medicationIds: [String!]!
    $patientId: ID!
    $patientConditions: [String!]
    $patientAllergies: [String!]
  ) {
    checkDrugInteraction(
      medicationIds: $medicationIds
      patientId: $patientId
      patientConditions: $patientConditions
      patientAllergies: $patientAllergies
    ) {
      hasInteractions
      warnings { severity description drugPair source warningType drug condition }
    }
  }
`;
const $784c74a96a5b5460$export$5fcaf1729c987f4d = `
  mutation CreateMedication($patientId: ID!, $input: MedicationInput!) {
    createMedication(patientId: $patientId, input: $input) { id display }
  }
`;
const $784c74a96a5b5460$export$13552a2fc8f27ee4 = 800;
const $784c74a96a5b5460$export$e907fe684aa8ce6c = 300;
const $784c74a96a5b5460$export$e3df798668950d68 = 30;
const $784c74a96a5b5460$export$3c798937e9154a7c = {
    high: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
    },
    moderate: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    low: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    }
};
function $784c74a96a5b5460$export$b104048e15014e11(phase) {
    if (phase === 'saving') return 'prescription.saving';
    if (phase === 'confirm') return 'prescription.saveConfirm';
    return 'prescription.save';
}




var $acw62 = parcelRequire("acw62");






// The formulary picker.
//
// It searches the REAL formulary through `listDrugs`. The doctor app's
// standalone نسخه screen ships a hardcoded twenty-drug array instead; that is
// the thing this must not copy.
//
// What comes back carries `id` — a stable slug like 'acetaminophen' — and that
// slug is the interaction key. The display name never leaves this component.
const $90ca997a9e629c7f$var$DrugCombobox = ({ onAdd: onAdd })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [results, setResults] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [searching, setSearching] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failed, setFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const boxRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // The popup has to be REFERABLE for the input to declare what it controls.
    const listId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const term = query.trim();
        if (term.length < (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86)) {
            setResults([]);
            setSearching(false);
            setFailed(false);
            return undefined;
        }
        let alive = true;
        setSearching(true);
        const timer = setTimeout(()=>{
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $784c74a96a5b5460$export$e94eea18383a4188), {
                query: term,
                limit: (0, $784c74a96a5b5460$export$e3df798668950d68)
            }).then((data)=>{
                if (!alive) return;
                setResults(data?.listDrugs || []);
                setFailed(false);
            }).catch((err)=>{
                if (!alive) return;
                console.error('[drugs] search failed:', err?.message);
                setResults([]);
                setFailed(true);
            }).finally(()=>{
                if (alive) setSearching(false);
            });
        }, (0, $784c74a96a5b5460$export$e907fe684aa8ce6c));
        return ()=>{
            alive = false;
            clearTimeout(timer);
        };
    }, [
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onDown = (e)=>{
            if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onDown);
        return ()=>document.removeEventListener('mousedown', onDown);
    }, []);
    const select = (drug)=>{
        onAdd(drug);
        setQuery('');
        setResults([]);
        setOpen(false);
    };
    const term = query.trim();
    const showPanel = open && term.length > 0;
    // What the live region below says. The popup itself is conditionally mounted,
    // so its own text can never be announced reliably — a live region has to be in
    // the DOM before its content changes. This one always is.
    const searchable = term.length >= (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86);
    let announcement = '';
    if (showPanel && searchable) {
        if (searching) announcement = t('prescription.search.searching');
        else if (failed) announcement = t('errors.load.drugs');
        else if (results.length === 0) announcement = t('prescription.search.empty');
        else announcement = t('prescription.search.results', {
            count: results.length
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: boxRef,
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                "aria-live": "polite",
                style: {
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    overflow: 'hidden',
                    clipPath: 'inset(50%)',
                    whiteSpace: 'nowrap'
                },
                children: announcement
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                value: query,
                onChange: (e)=>{
                    setQuery(e.target.value);
                    setOpen(true);
                },
                onFocus: ()=>setOpen(true),
                // Escape closes the popup and keeps focus in the field. Without it the
                // only ways out were a mouse click elsewhere or picking a drug — a panel
                // that covers the prescription below it and cannot be dismissed from the
                // keyboard.
                onKeyDown: (e)=>{
                    if (e.key === 'Escape' && open) {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpen(false);
                    }
                },
                placeholder: t('prescription.search.placeholder'),
                "aria-label": t('prescription.search.label'),
                clearLabel: t('common.actions.clearFilters'),
                // The popup already declared role="listbox"/role="option", but nothing
                // tied it to the field — so its appearance, its result count and its
                // "no medicine matches" were all invisible to a screen reader. These go
                // through `inputProps` because that is the prop the kit forwards to the
                // real <input> (its own `...rest` lands on the wrapper).
                inputProps: {
                    // The kit hardcodes dir="rtl" on its <input>; a formulary is searched
                    // by Persian brand name AND by Latin generic name. `dir="auto"`
                    // follows what was typed.
                    dir: 'auto',
                    role: 'combobox',
                    'aria-expanded': showPanel,
                    // Only while it exists — a dangling reference is worse than none.
                    'aria-controls': showPanel ? listId : undefined,
                    'aria-autocomplete': 'list'
                }
            }),
            showPanel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: listId,
                role: "listbox",
                "aria-label": t('prescription.search.label'),
                style: {
                    position: 'absolute',
                    insetInlineStart: 0,
                    insetInlineEnd: 0,
                    top: 'calc(100% + 6px)',
                    zIndex: 30,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 12,
                    boxShadow: (0, $e7c165fb515b04ea$export$98b6069deb71e13e).floating,
                    maxHeight: 300,
                    overflowY: 'auto',
                    padding: 6
                },
                children: [
                    term.length < (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            padding: 12,
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('prescription.search.hint')
                    }),
                    term.length >= (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86) && searching && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            padding: 12,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                size: 16
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 12.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('prescription.search.searching')
                            })
                        ]
                    }),
                    term.length >= (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86) && !searching && failed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            padding: 12,
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk
                        },
                        children: t('errors.load.drugs')
                    }),
                    term.length >= (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86) && !searching && !failed && results.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            padding: 12,
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('prescription.search.empty')
                    }),
                    results.map((drug)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            role: "option",
                            "aria-selected": "false",
                            onClick: ()=>select(drug),
                            style: {
                                display: 'block',
                                width: '100%',
                                textAlign: 'start',
                                background: 'none',
                                border: 'none',
                                borderRadius: 9,
                                padding: '9px 12px',
                                cursor: 'pointer',
                                fontFamily: 'inherit'
                            },
                            onMouseEnter: (e)=>{
                                e.currentTarget.style.background = (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2;
                            },
                            onMouseLeave: (e)=>{
                                e.currentTarget.style.background = 'none';
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 13.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: drug.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: [
                                        drug.genericName,
                                        drug.category
                                    ].filter(Boolean).join(" \xb7 ")
                                })
                            ]
                        }, drug.id))
                ]
            })
        ]
    });
};
var $90ca997a9e629c7f$export$2e2bcd8739ae039 = $90ca997a9e629c7f$var$DrugCombobox;




parcelRequire("acw62");




const $ec3f29ac0997c977$export$5e588c6d536a4419 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "rx-content",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$a5bf34efdb86126b), {
                avatar: false,
                meta: true,
                actions: 1
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    padding: '20px 28px 40px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'minmax(0, 1fr) 320px',
                        gap: 18,
                        alignItems: 'start'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    style: {
                                        marginBottom: 14
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: 110,
                                            height: 12,
                                            style: {
                                                marginBottom: 8
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                                            label: false
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    style: {
                                        minHeight: 220,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: 44,
                                            height: 44,
                                            radius: 12
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: 160,
                                            height: 14
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: 220,
                                            height: 12
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 96,
                                        height: 14
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                        lines: 2,
                                        height: 12,
                                        lastWidth: "70%"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 110,
                                        height: 14
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 10
                                        },
                                        children: [
                                            0,
                                            1,
                                            2
                                        ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: 5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                                        width: `${45 + i * 17 % 35}%`,
                                                        height: 13
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                                        width: "40%",
                                                        height: 11
                                                    })
                                                ]
                                            }, i))
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
const $ec3f29ac0997c977$export$4bcd20a64d5b8ac3 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "rx-content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$4c127c4db7b36f7f), {
                        back: true,
                        subtitle: true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            padding: '0.875rem 0.75rem 0'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                                label: false
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: '0.875rem',
                                    minHeight: 180,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 44,
                                        height: 44,
                                        radius: 12
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 140,
                                        height: 14
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 200,
                                        height: 12
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: '0.875rem',
                                    padding: '0.875rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 96,
                                        height: 13,
                                        style: {
                                            marginBottom: 8
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                                        lines: 2,
                                        height: 12,
                                        lastWidth: "60%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: '0.875rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    minHeight: 44
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 110,
                                        height: 13
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: 16,
                                        height: 16,
                                        radius: 4
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flexShrink: 0,
                    padding: '0.75rem 0.75rem calc(0.75rem + env(safe-area-inset-bottom, 0px))',
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                    width: "100%"
                })
            })
        ]
    });


// نسخه — inherited unchanged from general medicine (CORE.md §10). Dental
// reshapes the visit CLOSURE, not prescribing.
//
// Two rules this screen exists to honour:
//
//  1. The interaction sweep NEVER blocks prescribing. It costs credits, it can
//     be exhausted, and the service fails open when the wallet is unreachable —
//     so a failed sweep is reported next to the prescription and the ثبت button
//     stays live. A dentist who cannot prescribe because a check timed out is a
//     worse outcome than one who prescribes without it.
//  2. The sweep is keyed on Drug.id SLUGS. Passing the Persian display name
//     reaches the rule engine as an unknown drug and returns a clean bill.
// SEVERITY_TINT and the save-phase label live in Prescription.shared.js: the
// mobile surface paints the same three tones and asks twice in the same order.
const $9c873f1f66168078$var$RxRow = ({ item: item, onChange: onChange, onRemove: onRemove })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            padding: '12px 14px',
            marginBottom: 10,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    marginBottom: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                        size: 16,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13.5,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: item.drug.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: [
                                    item.drug.genericName,
                                    item.drug.category
                                ].filter(Boolean).join(" \xb7 ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 36,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        label: t('prescription.item.remove', {
                            name: item.drug.name
                        }),
                        onClick: onRemove
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('prescription.item.dose'),
                        "aria-label": `${item.drug.name} \u{2014} ${t('prescription.item.dose')}`,
                        dir: "auto",
                        value: item.dose,
                        onChange: (e)=>onChange({
                                ...item,
                                dose: e.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('prescription.item.frequency'),
                        "aria-label": `${item.drug.name} \u{2014} ${t('prescription.item.frequency')}`,
                        dir: "auto",
                        value: item.frequency,
                        onChange: (e)=>onChange({
                                ...item,
                                frequency: e.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('prescription.item.duration'),
                        "aria-label": `${item.drug.name} \u{2014} ${t('prescription.item.duration')}`,
                        dir: "auto",
                        value: item.duration,
                        onChange: (e)=>onChange({
                                ...item,
                                duration: e.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t('prescription.item.note'),
                        "aria-label": `${item.drug.name} \u{2014} ${t('prescription.item.note')}`,
                        dir: "auto",
                        value: item.note,
                        onChange: (e)=>onChange({
                                ...item,
                                note: e.target.value
                            })
                    })
                ]
            })
        ]
    });
};
const $9c873f1f66168078$var$PrescriptionScreen = ()=>{
    const { patientId: patientId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const appointmentId = searchParams.get('appointmentId') || null;
    const { t: t, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { activeId: activeId } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const { patient: patient, loading: loading, error: error, reload: reload } = (0, $781cda2ad75d5a69$export$9b570c45914f833c)(patientId, activeId);
    const [items, setItems] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    // 'idle' → 'confirm' → 'saving'. A prescription is a clinical write; it takes
    // two deliberate clicks, not one stray one.
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('idle');
    const [sweep, setSweep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        loading: false,
        result: null,
        failure: null
    });
    // A STRING, not an array: what the sweep depends on is *which drugs* are on
    // the prescription, and a string compares by value across renders.
    const idsKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $d9b1b3bcd01f93df$export$4fb019cf760083c0)(items).join('|'), [
        items
    ]);
    const sweepable = (0, $d9b1b3bcd01f93df$export$f285ed9dd1e8dd93)(items);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!patient || !sweepable) {
            setSweep({
                loading: false,
                result: null,
                failure: null
            });
            return undefined;
        }
        let alive = true;
        setSweep((s)=>({
                ...s,
                loading: true
            }));
        const timer = setTimeout(()=>{
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $784c74a96a5b5460$export$9812972017b718e1), {
                // Rebuilt from the key rather than closed over `ids`: the memoised array
                // gets a new identity on every keystroke in a dose field, which would
                // re-fire this effect — and re-bill the sweep — for an edit that is not
                // even an input to it.
                medicationIds: idsKey.split('|').filter(Boolean),
                patientId: patient.id,
                patientConditions: (0, $d9b1b3bcd01f93df$export$c44664437aa64527)(patient),
                patientAllergies: (0, $d9b1b3bcd01f93df$export$d6bd0f6236de0844)(patient)
            }).then((data)=>{
                if (!alive) return;
                setSweep({
                    loading: false,
                    result: data?.checkDrugInteraction || null,
                    failure: null
                });
            }).catch((err)=>{
                if (!alive) return;
                // Swallowed on purpose — see the rule at the top of this file. The
                // credit case gets its own copy because "top up" is actionable and
                // "unavailable" is not.
                const code = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
                setSweep({
                    loading: false,
                    result: null,
                    failure: code === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable'
                });
            });
        }, (0, $784c74a96a5b5460$export$13552a2fc8f27ee4));
        return ()=>{
            alive = false;
            clearTimeout(timer);
        };
    // idsKey rather than `items`: editing a dose must not re-bill the sweep,
    // because the dose is not an input to it.
    }, [
        idsKey,
        patient,
        sweepable
    ]);
    const addDrug = (drug)=>{
        setItems((prev)=>prev.some((i)=>i.drug.id === drug.id) ? prev : [
                ...prev,
                (0, $d9b1b3bcd01f93df$export$12d3280041d352a5)(drug)
            ]);
        setPhase('idle');
    };
    const updateItem = (next)=>{
        setItems((prev)=>prev.map((i)=>i.key === next.key ? next : i));
        setPhase('idle');
    };
    const removeItem = (key)=>{
        setItems((prev)=>prev.filter((i)=>i.key !== key));
        setPhase('idle');
    };
    const save = async ()=>{
        if (phase === 'idle') {
            setPhase('confirm');
            return;
        }
        if (phase !== 'confirm') return;
        setPhase('saving');
        // One mutation per row. allSettled rather than a chain: a formulary row the
        // service rejects must not silently discard the rows after it, and the
        // dentist has to be told exactly how many landed.
        const results = await Promise.allSettled(items.map((item)=>(0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $784c74a96a5b5460$export$5fcaf1729c987f4d), {
                patientId: patient.id,
                input: (0, $d9b1b3bcd01f93df$export$7baebe32bddaafc7)(item, {
                    appointmentId: appointmentId
                })
            })));
        const saved = results.filter((r)=>r.status === 'fulfilled').length;
        if (saved === items.length) {
            toast.success(t('prescription.saved'));
            navigate('patient', {
                id: patient.id,
                tab: 'history'
            });
            return;
        }
        if (saved === 0) toast.error(t('prescription.saveFailed'));
        else toast.warn(t('prescription.savePartial', {
            saved: saved,
            total: items.length
        }));
        setPhase('idle');
    };
    // The screen's OWN shape while the record loads — header band, the search
    // card and the two rail panels at their real size — so the search field the
    // dentist is about to type into does not move (DESIGN.md §"Loading &
    // skeleton").
    if (loading && !patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec3f29ac0997c977$export$5e588c6d536a4419), {
        label: t('common.loading')
    });
    if (!patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            padding: 32
        },
        role: "alert",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('patient.error.title'),
                description: error ? t('errors.load.patient') : t('patient.notFound.description'),
                onRetry: error ? reload : undefined,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    const allergies = patient.allergies || [];
    const warnings = (0, $d9b1b3bcd01f93df$export$888cb547d3ca3da3)(sweep.result?.warnings);
    const saveLabel = t((0, $784c74a96a5b5460$export$b104048e15014e11)(phase));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c79ee8367a72d83$export$2e2bcd8739ae039), {
                onBack: ()=>navigate('patient', {
                        id: patient.id
                    }),
                backLabel: t('common.actions.back'),
                title: t('prescription.title'),
                sub: t('prescription.subtitle', {
                    name: patient.name
                }),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: save,
                    disabled: items.length === 0 || phase === 'saving',
                    children: saveLabel
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '20px 28px 40px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gridTemplateColumns: 'minmax(0, 1fr) 320px',
                        gap: 18,
                        alignItems: 'start'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    style: {
                                        marginBottom: 14,
                                        overflow: 'visible'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                fontWeight: 700,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                marginBottom: 8
                                            },
                                            children: t('prescription.search.label')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90ca997a9e629c7f$export$2e2bcd8739ae039), {
                                            onAdd: addDrug
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    "data-testid": "rx-items",
                                    "data-state": items.length ? 'content' : 'empty',
                                    children: items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                                                size: 44,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            }),
                                            title: t('prescription.empty.title'),
                                            description: t('prescription.empty.description')
                                        })
                                    }) : items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c873f1f66168078$var$RxRow, {
                                            item: item,
                                            onChange: updateItem,
                                            onRemove: ()=>removeItem(item.key)
                                        }, item.key))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14
                            },
                            children: [
                                allergies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                    variant: "warning",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    title: t('prescription.allergies.title'),
                                    children: allergies.map((a)=>a.allergen).filter(Boolean).join(" \xb7 ")
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                    title: t('prescription.interactions.title'),
                                    "aria-live": "polite",
                                    "aria-busy": sweep.loading || undefined,
                                    children: [
                                        !sweepable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('prescription.interactions.needsTwo')
                                        }),
                                        sweepable && sweep.loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                                    size: 16
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 12.5,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                    },
                                                    children: t('prescription.interactions.checking')
                                                })
                                            ]
                                        }),
                                        sweepable && !sweep.loading && sweep.failure === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                            variant: "info",
                                            title: t('errors.credits.title'),
                                            children: t('errors.credits.body')
                                        }),
                                        sweepable && !sweep.loading && sweep.failure === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('prescription.interactions.unavailable')
                                        }),
                                        sweepable && !sweep.loading && !sweep.failure && warnings.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                                            },
                                            children: t('prescription.interactions.none')
                                        }),
                                        warnings.map((w, i)=>{
                                            const sev = (0, $d9b1b3bcd01f93df$export$6eaaad838274d902)(w.severity);
                                            const tint = (0, $784c74a96a5b5460$export$3c798937e9154a7c)[sev];
                                            const typeKey = (0, $d9b1b3bcd01f93df$export$b10d321a5bcb675d)(w.warningType);
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    background: tint.bg,
                                                    color: tint.ink,
                                                    borderRadius: 10,
                                                    padding: '10px 12px',
                                                    marginBottom: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        style: {
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 6,
                                                            marginBottom: 4
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                style: {
                                                                    fontSize: 11.5,
                                                                    fontWeight: 800
                                                                },
                                                                children: t(`prescription.interactions.severity.${sev}`)
                                                            }),
                                                            typeKey && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                style: {
                                                                    fontSize: 11
                                                                },
                                                                children: [
                                                                    "\xb7 ",
                                                                    t(`prescription.interactions.type.${typeKey}`)
                                                                ]
                                                            }),
                                                            w.drugPair && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                dir: "ltr",
                                                                style: {
                                                                    unicodeBidi: 'isolate',
                                                                    fontSize: 11,
                                                                    marginInlineStart: 'auto'
                                                                },
                                                                children: w.drugPair
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            fontSize: 12.5,
                                                            lineHeight: 1.8
                                                        },
                                                        children: w.description
                                                    })
                                                ]
                                            }, `${w.drugPair || w.drug || 'w'}-${i}`);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                    title: t('prescription.history.title'),
                                    children: (patient.medications || []).length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12.5,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('prescription.history.empty')
                                    }) : (patient.medications || []).slice(0, 8).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                marginBottom: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    children: m.display
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 11.5,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                    },
                                                    children: m.authoredOn ? t('patient.history.prescribedOn', {
                                                        date: formatDate(m.authoredOn, 'numeric')
                                                    }) : ''
                                                })
                                            ]
                                        }, m.id))
                                }),
                                items.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 12,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                            lineHeight: 1.9
                                        },
                                        children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    marginBottom: 4
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                        variant: "outline",
                                                        children: item.drug.name
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: (0, $d9b1b3bcd01f93df$export$3add0e9734e66842)(item)
                                                    })
                                                ]
                                            }, item.key))
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $9c873f1f66168078$export$2e2bcd8739ae039 = $9c873f1f66168078$var$PrescriptionScreen;




var $acw62 = parcelRequire("acw62");













var $acw62 = parcelRequire("acw62");







// The formulary picker, for a phone.
//
// The desktop `DrugCombobox` is an absolutely-positioned popover hanging under
// a field — a desktop pattern that, on a phone, is drawn over the page by the
// software keyboard and reaches the bottom of the viewport after two results.
// §6 makes `BottomSheet` the default overlay for a task, so the search IS the
// sheet: the field sits at the top of it, the results fill the space directly
// above the keyboard, and nothing the dentist is typing into can be covered.
//
// The CONTRACT is the desktop's, unchanged: the same `listDrugs` query, the
// same 300 ms debounce, the same 30-result limit, the same two-character floor.
// And the same rule that matters most — what leaves this component is the
// `Drug` object carrying `id`, the stable slug the interaction sweep is keyed
// on. The Persian display name never becomes a search key.
// Visually hidden but still announced — the standard clip pattern.
const $3adb0369e9474c71$var$SR_ONLY = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap'
};
const $3adb0369e9474c71$var$MobileDrugSearch = ({ onAdd: onAdd })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [query, setQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [results, setResults] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [searching, setSearching] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failed, setFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const term = query.trim();
        if (term.length < (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86)) {
            setResults([]);
            setSearching(false);
            setFailed(false);
            return undefined;
        }
        let alive = true;
        setSearching(true);
        const timer = setTimeout(()=>{
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $784c74a96a5b5460$export$e94eea18383a4188), {
                query: term,
                limit: (0, $784c74a96a5b5460$export$e3df798668950d68)
            }).then((data)=>{
                if (!alive) return;
                setResults(data?.listDrugs || []);
                setFailed(false);
            }).catch((err)=>{
                if (!alive) return;
                console.error('[drugs] search failed:', err?.message);
                setResults([]);
                setFailed(true);
            }).finally(()=>{
                if (alive) setSearching(false);
            });
        }, (0, $784c74a96a5b5460$export$e907fe684aa8ce6c));
        return ()=>{
            alive = false;
            clearTimeout(timer);
        };
    }, [
        query
    ]);
    const select = (drug)=>{
        onAdd(drug);
        setQuery('');
        setResults([]);
        setOpen(false);
    };
    const term = query.trim();
    const searchable = term.length >= (0, $2e1381078ec7f76f$export$f56c1bb712b9ef86);
    // What the live region says. The list is conditionally rendered, so its own
    // text can never be announced reliably — a live region has to be in the DOM
    // before its content changes. This one always is while the sheet is open.
    let announcement = '';
    if (searchable) {
        if (searching) announcement = t('prescription.search.searching');
        else if (failed) announcement = t('errors.load.drugs');
        else if (results.length === 0) announcement = t('prescription.search.empty');
        else announcement = t('prescription.search.results', {
            count: results.length
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                onClick: ()=>setOpen(true),
                "data-testid": "rx-search-open",
                className: "w-full min-h-11 gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                        size: 16,
                        "aria-hidden": true
                    }),
                    t('prescription.search.label')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
                open: open,
                onClose: ()=>setOpen(false),
                title: t('prescription.search.label'),
                closeLabel: t('mobile.close'),
                "data-testid": "rx-search-sheet",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $318ef1f4a903d866$export$2e2bcd8739ae039), {
                        value: query,
                        onChange: (e)=>setQuery(e.target.value),
                        placeholder: t('prescription.search.placeholder'),
                        "aria-label": t('prescription.search.placeholder'),
                        clearLabel: t('common.actions.clearFilters'),
                        autoFocus: true,
                        // dir="auto": the formulary is searched in either script. ≥1rem or
                        // iOS zooms the page on focus (§6).
                        inputProps: {
                            dir: 'auto',
                            style: {
                                fontSize: '1rem'
                            },
                            'data-testid': 'rx-search-input'
                        },
                        style: {
                            width: '100%'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        "aria-live": "polite",
                        role: "status",
                        style: $3adb0369e9474c71$var$SR_ONLY,
                        children: announcement
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "data-testid": "rx-search-results",
                        "data-state": !searchable ? 'idle' : searching ? 'loading' : failed ? 'error' : results.length ? 'content' : 'empty',
                        style: {
                            marginTop: '0.75rem'
                        },
                        children: [
                            !searchable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    padding: '0.5rem 0'
                                },
                                children: t('prescription.search.hint')
                            }),
                            searchable && searching && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: '0.5rem 0'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('prescription.search.searching')
                                    })
                                ]
                            }),
                            searchable && !searching && failed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    padding: '0.5rem 0'
                                },
                                children: t('errors.load.drugs')
                            }),
                            searchable && !searching && !failed && results.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: '0.75rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    padding: '0.5rem 0'
                                },
                                children: t('prescription.search.empty')
                            }),
                            searchable && !searching && results.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "listbox",
                                "aria-label": t('prescription.search.label'),
                                children: results.map((drug)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        onClick: ()=>select(drug),
                                        role: "option",
                                        "aria-selected": false,
                                        "data-testid": `rx-search-result-${drug.id}`,
                                        style: {
                                            padding: '0.625rem 0.75rem',
                                            marginBottom: '0.375rem',
                                            borderRadius: '0.75rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                dir: "auto",
                                                style: {
                                                    fontSize: '0.8125rem',
                                                    fontWeight: 700,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                },
                                                children: drug.name
                                            }),
                                            (drug.genericName || drug.category) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                dir: "auto",
                                                style: {
                                                    fontSize: '0.6875rem',
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: [
                                                    drug.genericName,
                                                    drug.category
                                                ].filter(Boolean).join(" \xb7 ")
                                            })
                                        ]
                                    }, drug.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3adb0369e9474c71$export$2e2bcd8739ae039 = $3adb0369e9474c71$var$MobileDrugSearch;



parcelRequire("acw62");




// One prescribed medicine, on a phone.
//
// The desktop row lays its four fields on a
// `repeat(auto-fit, minmax(140px, 1fr))` grid — two-up at best on a phone, with
// «مدت مصرف» truncated to «مدت». §6 is explicit: "full-width inputs, one per
// row". Four rows of one field each is more scroll and less guessing.
//
// EVERY FIELD CARRIES AN ARIA-LABEL THAT NAMES THE DRUG. The kit's `FormField`
// renders its `label` as a <span> with no htmlFor and no id, so the visible
// label is not attached to the control: without this each of these is an
// unnamed text box, and on a four-drug prescription that is sixteen of them —
// «دوز» alone would not say which drug's dose is being typed.
const $8f5e248cd39c6fd8$var$FIELDS = [
    {
        key: 'dose',
        labelKey: 'prescription.item.dose'
    },
    {
        key: 'frequency',
        labelKey: 'prescription.item.frequency'
    },
    {
        key: 'duration',
        labelKey: 'prescription.item.duration'
    },
    {
        key: 'note',
        labelKey: 'prescription.item.note'
    }
];
const $8f5e248cd39c6fd8$var$MobileRxCard = ({ item: item, onChange: onChange, onRemove: onRemove, testId: testId })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
        "data-testid": testId,
        style: {
            padding: '0.875rem',
            marginBottom: '0.625rem',
            borderRadius: '0.875rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                        size: 16,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.8125rem',
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: item.drug.name
                            }),
                            (item.drug.genericName || item.drug.category) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                dir: "auto",
                                style: {
                                    fontSize: '0.6875rem',
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: [
                                    item.drug.genericName,
                                    item.drug.category
                                ].filter(Boolean).join(" \xb7 ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 44,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                            size: 16
                        }),
                        label: t('prescription.item.remove', {
                            name: item.drug.name
                        }),
                        onClick: onRemove,
                        "data-testid": `${testId}-remove`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.625rem'
                },
                children: $8f5e248cd39c6fd8$var$FIELDS.map(({ key: key, labelKey: labelKey })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t(labelKey),
                        "aria-label": `${item.drug.name} \u{2014} ${t(labelKey)}`,
                        dir: "auto",
                        value: item[key],
                        onChange: (e)=>onChange({
                                ...item,
                                [key]: e.target.value
                            }),
                        "data-testid": `${testId}-${key}`,
                        // ≥1rem or iOS zooms the whole page the moment the field is
                        // focused, and the dentist has to pinch back out (§6).
                        inputStyle: {
                            fontSize: '1rem'
                        }
                    }, key))
            })
        ]
    });
};
var $8f5e248cd39c6fd8$export$2e2bcd8739ae039 = $8f5e248cd39c6fd8$var$MobileRxCard;




// نسخه — the mobile task flow (a full-screen surface, no bottom nav).
//
// ┌──────────────────────────────────────┐
// │ ① MobileHeader — CONTENT mode         │  ← back to the record · «نسخه»
// │ ② Alert — allergies FIRST             │  above the fold, always
// │ ③ MobileDrugSearch                    │  a sheet, not a popover
// │ ④ MobileRxCard × N                    │  4 full-width fields, one per row
// │ ⑤ interaction panel (aria-live)       │
// │ ⑥ CollapsibleSection «داروهای قبلی»   │  collapsed
// │ [ SaveBar sticky — ثبت نسخه ]         │  docked, keyboard-aware
// └──────────────────────────────────────┘
//
// THE TWO RULES FROM THE DESKTOP SCREEN ARE UNCHANGED AND NON-NEGOTIABLE:
//
//  1. The interaction sweep NEVER blocks prescribing. It costs credits, it can
//     be exhausted, and the service fails open when the wallet is unreachable —
//     so a failed sweep is reported next to the prescription and ثبت stays live.
//     A dentist who cannot prescribe because a check timed out is a worse
//     outcome than one who prescribes without it.
//  2. The sweep is keyed on Drug.id SLUGS. Passing the Persian display name
//     reaches the rule engine as an unknown drug and returns a clean bill.
//
// Everything behavioural below — the debounce, `idsKey`, `canSweep`, the
// credits/unavailable split, `toMedicationInput`, the allSettled partial-save
// report and the idle→confirm→saving phase machine — is the desktop's, reused
// rather than re-typed (§1.1, §9).
const $717f5b0fa57d582c$var$PrescriptionMobile = ()=>{
    const { patientId: patientId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const appointmentId = searchParams.get('appointmentId') || null;
    const { t: t, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const keyboardInset = (0, $da50fe1f8f323572$export$2e2bcd8739ae039)();
    const { activeId: activeId } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const { patient: patient, loading: loading, error: error, reload: reload } = (0, $781cda2ad75d5a69$export$9b570c45914f833c)(patientId, activeId);
    const [items, setItems] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('idle');
    const [sweep, setSweep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        loading: false,
        result: null,
        failure: null
    });
    // A STRING, not an array: what the sweep depends on is *which drugs* are on
    // the prescription, and a string compares by value across renders.
    const idsKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $d9b1b3bcd01f93df$export$4fb019cf760083c0)(items).join('|'), [
        items
    ]);
    const sweepable = (0, $d9b1b3bcd01f93df$export$f285ed9dd1e8dd93)(items);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!patient || !sweepable) {
            setSweep({
                loading: false,
                result: null,
                failure: null
            });
            return undefined;
        }
        let alive = true;
        setSweep((s)=>({
                ...s,
                loading: true
            }));
        const timer = setTimeout(()=>{
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $784c74a96a5b5460$export$9812972017b718e1), {
                // Rebuilt from the key rather than closed over `ids`: the memoised array
                // gets a new identity on every keystroke in a dose field, which would
                // re-fire this effect — and re-bill the sweep — for an edit that is not
                // even an input to it.
                medicationIds: idsKey.split('|').filter(Boolean),
                patientId: patient.id,
                patientConditions: (0, $d9b1b3bcd01f93df$export$c44664437aa64527)(patient),
                patientAllergies: (0, $d9b1b3bcd01f93df$export$d6bd0f6236de0844)(patient)
            }).then((data)=>{
                if (!alive) return;
                setSweep({
                    loading: false,
                    result: data?.checkDrugInteraction || null,
                    failure: null
                });
            }).catch((err)=>{
                if (!alive) return;
                const code = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
                setSweep({
                    loading: false,
                    result: null,
                    failure: code === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable'
                });
            });
        }, (0, $784c74a96a5b5460$export$13552a2fc8f27ee4));
        return ()=>{
            alive = false;
            clearTimeout(timer);
        };
    }, [
        idsKey,
        patient,
        sweepable
    ]);
    const addDrug = (drug)=>{
        setItems((prev)=>prev.some((i)=>i.drug.id === drug.id) ? prev : [
                ...prev,
                (0, $d9b1b3bcd01f93df$export$12d3280041d352a5)(drug)
            ]);
        setPhase('idle');
    };
    const updateItem = (next)=>{
        setItems((prev)=>prev.map((i)=>i.key === next.key ? next : i));
        setPhase('idle');
    };
    const removeItem = (key)=>{
        setItems((prev)=>prev.filter((i)=>i.key !== key));
        setPhase('idle');
    };
    const save = async ()=>{
        // 'idle' → 'confirm' → 'saving'. A prescription is a clinical write; it
        // takes two deliberate taps, not one stray one — and a phone is where a
        // stray tap is most likely.
        if (phase === 'idle') {
            setPhase('confirm');
            return;
        }
        if (phase !== 'confirm') return;
        setPhase('saving');
        // One mutation per row. allSettled rather than a chain: a formulary row the
        // service rejects must not silently discard the rows after it, and the
        // dentist has to be told exactly how many landed.
        const results = await Promise.allSettled(items.map((item)=>(0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $784c74a96a5b5460$export$5fcaf1729c987f4d), {
                patientId: patient.id,
                input: (0, $d9b1b3bcd01f93df$export$7baebe32bddaafc7)(item, {
                    appointmentId: appointmentId
                })
            })));
        const saved = results.filter((r)=>r.status === 'fulfilled').length;
        if (saved === items.length) {
            toast.success(t('prescription.saved'));
            navigate('patient', {
                id: patient.id,
                tab: 'history'
            });
            return;
        }
        if (saved === 0) toast.error(t('prescription.saveFailed'));
        else toast.warn(t('prescription.savePartial', {
            saved: saved,
            total: items.length
        }));
        setPhase('idle');
    };
    // The task's OWN mobile shape — the gradient band, the search field, the
    // empty prescription, the interactions card and the docked commit row —
    // never a generic card stack (DESIGN.md §"Loading & skeleton").
    if (loading && !patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec3f29ac0997c977$export$4bcd20a64d5b8ac3), {
        label: t('common.loading')
    });
    if (!patient) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "rx-content",
        "data-state": "error",
        role: "alert",
        style: {
            padding: '0.875rem 0.75rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('patient.error.title'),
            description: error ? t('errors.load.patient') : t('patient.notFound.description'),
            onRetry: error ? reload : undefined,
            retryLabel: t('common.actions.retry')
        })
    });
    const allergies = patient.allergies || [];
    const warnings = (0, $d9b1b3bcd01f93df$export$888cb547d3ca3da3)(sweep.result?.warnings);
    const history = patient.medications || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "rx-content",
        "data-state": items.length ? 'content' : 'empty',
        style: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                        onBack: ()=>navigate('patient', {
                                id: patient.id
                            }),
                        backLabel: t('common.actions.back'),
                        title: t('prescription.title'),
                        subtitle: t('prescription.subtitle', {
                            name: patient.name
                        }),
                        "data-testid": "rx-header"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            padding: '0.875rem 0.75rem 0'
                        },
                        children: [
                            allergies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                variant: "warning",
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                                    size: 16
                                }),
                                title: t('prescription.allergies.title'),
                                style: {
                                    marginBottom: '0.875rem'
                                },
                                children: allergies.map((a)=>a.allergen).filter(Boolean).join(" \xb7 ")
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3adb0369e9474c71$export$2e2bcd8739ae039), {
                                onAdd: addDrug
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                "data-testid": "rx-items",
                                "data-state": items.length ? 'content' : 'empty',
                                style: {
                                    marginTop: '0.875rem'
                                },
                                children: items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                                            size: 44,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        }),
                                        title: t('prescription.empty.title'),
                                        description: t('prescription.empty.description')
                                    })
                                }) : items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f5e248cd39c6fd8$export$2e2bcd8739ae039), {
                                        item: item,
                                        onChange: updateItem,
                                        onRemove: ()=>removeItem(item.key),
                                        testId: `rx-item-${item.key}`
                                    }, item.key))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                                "data-testid": "rx-interactions",
                                "data-state": !sweepable ? 'idle' : sweep.loading ? 'loading' : sweep.failure ? 'error' : warnings.length ? 'content' : 'empty',
                                "aria-live": "polite",
                                "aria-busy": sweep.loading || undefined,
                                style: {
                                    marginTop: '0.875rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                        children: t('prescription.interactions.title')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem'
                                        },
                                        children: [
                                            !sweepable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: '0.75rem',
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: t('prescription.interactions.needsTwo')
                                            }),
                                            sweepable && sweep.loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '0.5rem'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                                        size: 16
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: '0.75rem',
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                        },
                                                        children: t('prescription.interactions.checking')
                                                    })
                                                ]
                                            }),
                                            sweepable && !sweep.loading && sweep.failure === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                                variant: "info",
                                                title: t('errors.credits.title'),
                                                children: t('errors.credits.body')
                                            }),
                                            sweepable && !sweep.loading && sweep.failure === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: '0.75rem',
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: t('prescription.interactions.unavailable')
                                            }),
                                            sweepable && !sweep.loading && !sweep.failure && warnings.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: '0.75rem',
                                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                                                },
                                                children: t('prescription.interactions.none')
                                            }),
                                            warnings.map((w, i)=>{
                                                const sev = (0, $d9b1b3bcd01f93df$export$6eaaad838274d902)(w.severity);
                                                const tint = (0, $784c74a96a5b5460$export$3c798937e9154a7c)[sev];
                                                const typeKey = (0, $d9b1b3bcd01f93df$export$b10d321a5bcb675d)(w.warningType);
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        background: tint.bg,
                                                        color: tint.ink,
                                                        borderRadius: '0.625rem',
                                                        padding: '0.625rem 0.75rem',
                                                        marginBottom: '0.5rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '0.375rem',
                                                                flexWrap: 'wrap'
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                                    style: {
                                                                        fontSize: '0.6875rem',
                                                                        fontWeight: 800
                                                                    },
                                                                    children: t(`prescription.interactions.severity.${sev}`)
                                                                }),
                                                                typeKey && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    style: {
                                                                        fontSize: '0.6875rem'
                                                                    },
                                                                    children: [
                                                                        "\xb7 ",
                                                                        t(`prescription.interactions.type.${typeKey}`)
                                                                    ]
                                                                }),
                                                                w.drugPair && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    dir: "ltr",
                                                                    style: {
                                                                        unicodeBidi: 'isolate',
                                                                        fontSize: '0.6875rem',
                                                                        marginInlineStart: 'auto'
                                                                    },
                                                                    children: w.drugPair
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                fontSize: '0.75rem',
                                                                lineHeight: 1.8,
                                                                marginTop: '0.25rem'
                                                            },
                                                            children: w.description
                                                        })
                                                    ]
                                                }, `${w.drugPair || w.drug || 'w'}-${i}`);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    marginTop: '0.875rem'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2358e3acbc4a7e55$export$2e2bcd8739ae039), {
                                    title: t('prescription.history.title'),
                                    children: history.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: '0.75rem',
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                            padding: '0.25rem 0 0.5rem'
                                        },
                                        children: t('prescription.history.empty')
                                    }) : history.slice(0, 8).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                padding: '0.375rem 0'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    dir: "auto",
                                                    style: {
                                                        fontSize: '0.8125rem',
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    children: m.display
                                                }),
                                                m.authoredOn && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: '0.6875rem',
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                    },
                                                    children: t('patient.history.prescribedOn', {
                                                        date: formatDate(m.authoredOn, 'numeric')
                                                    })
                                                })
                                            ]
                                        }, m.id))
                                })
                            }),
                            items.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                style: {
                                    marginTop: '0.875rem',
                                    padding: '0.75rem'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: '0.6875rem',
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        lineHeight: 1.9
                                    },
                                    children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                marginBottom: '0.25rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: "outline",
                                                    children: item.drug.name
                                                }),
                                                ' ',
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    dir: "auto",
                                                    children: (0, $d9b1b3bcd01f93df$export$3add0e9734e66842)(item)
                                                })
                                            ]
                                        }, item.key))
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    height: '1rem'
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1c3a031457b1019$export$2e2bcd8739ae039), {
                sticky: true,
                onSave: save,
                saving: phase === 'saving',
                disabled: items.length === 0,
                saveLabel: t((0, $784c74a96a5b5460$export$b104048e15014e11)(phase)),
                "data-testid": "rx-savebar",
                style: {
                    marginTop: 0,
                    flexShrink: 0,
                    paddingInline: '0.75rem',
                    paddingBottom: `calc(0.75rem + env(safe-area-inset-bottom, 0px) + ${keyboardInset}px)`
                }
            })
        ]
    });
};
var $717f5b0fa57d582c$export$2e2bcd8739ae039 = $717f5b0fa57d582c$var$PrescriptionMobile;


// نسخه — two surfaces, one prescription.
//
// The desktop is a `minmax(0,1fr) 320px` two-column workspace with the drug
// list on the left and allergies/interactions in a right rail. A phone has no
// rail, so the order changes: allergies lead, the drug search is a
// `BottomSheet` rather than a popover, each medicine's four fields go one per
// row, and ثبت docks at the bottom.
//
// The BEHAVIOUR is identical and shared: `Prescription.shared.js` +
// `lib/prescription.js` own the sweep contract, the severity tints and the
// two-tap save phase, so the two surfaces cannot disagree about what is
// dangerous or about what reaches clinicalencounter.
const $1dfa506f0b1b21c4$var$PrescriptionScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $717f5b0fa57d582c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c873f1f66168078$export$2e2bcd8739ae039), {});
};
var $1dfa506f0b1b21c4$export$2e2bcd8739ae039 = $1dfa506f0b1b21c4$var$PrescriptionScreen;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8139bc0e06cf9ce5$export$a2387ed3b5d536eb = {
    name: "calendar-x",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M8 2v3",
                key: "1ioesn"
            }
        ],
        [
            "path",
            {
                d: "M16 2v3",
                key: "otl347"
            }
        ],
        [
            "rect",
            {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2",
                key: "h1oib"
            }
        ],
        [
            "path",
            {
                d: "M3 9h18",
                key: "1pudct"
            }
        ],
        [
            "path",
            {
                d: "m14 13-4 4",
                key: "1gib57"
            }
        ],
        [
            "path",
            {
                d: "m10 13 4 4",
                key: "153uiq"
            }
        ]
    ]
};
$8139bc0e06cf9ce5$export$a2387ed3b5d536eb.node;
const $8139bc0e06cf9ce5$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($8139bc0e06cf9ce5$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d97ad00fbef0d0b$export$a2387ed3b5d536eb = {
    name: "video",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
                key: "ftymec"
            }
        ],
        [
            "rect",
            {
                x: "2",
                y: "6",
                width: "14",
                height: "12",
                rx: "2",
                key: "158x01"
            }
        ]
    ]
};
$0d97ad00fbef0d0b$export$a2387ed3b5d536eb.node;
const $0d97ad00fbef0d0b$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($0d97ad00fbef0d0b$export$a2387ed3b5d536eb);









var $acw62 = parcelRequire("acw62");

// ویزیت تصویری — loading and driving the Jitsi IFrame API.
//
// React-free on purpose, like the rest of src/lib: this module knows about a
// script tag and an external API object, and nothing about the screen it is
// drawn on. The hook (src/hooks/useVideoVisit.js) owns the React side.
//
// ── Why the script is loaded at RUN TIME from the server's answer ────────────
// `external_api.js` must come from the SAME host that serves the conference,
// and which host that is arrives in `videoVisitSession.domain` — from the BFF,
// per environment. Bundling it, or configuring the URL in the client, would put
// a second copy of "which environment am I in" in the client, and a staging
// client pointed at a production media server is exactly the kind of mismatch
// runtimeEnv.js's BFF_WS_BASE derivation exists to prevent.
/** Resolved script loads, keyed by domain — the tag is added at most once. */ const $7baa51c3cff49fc5$var$loaded = new Map();
function $7baa51c3cff49fc5$export$e5f23e1a6d5d1e7b(domain) {
    if (!domain) return Promise.reject(new Error('jitsi: no domain'));
    const existing = $7baa51c3cff49fc5$var$loaded.get(domain);
    if (existing) return existing;
    const promise = new Promise((resolve, reject)=>{
        // Already there — a previous load in this session, or a remount after the
        // map was cleared. The global is what matters, not our bookkeeping.
        if (typeof window !== 'undefined' && window.JitsiMeetExternalAPI) {
            resolve(window.JitsiMeetExternalAPI);
            return;
        }
        const script = document.createElement('script');
        script.src = `https://${domain}/external_api.js`;
        script.async = true;
        script.onload = ()=>{
            if (window.JitsiMeetExternalAPI) resolve(window.JitsiMeetExternalAPI);
            else reject(new Error('jitsi: script loaded but API is missing'));
        };
        script.onerror = ()=>{
            // The tag is dropped so a later attempt can retry: a failed load that
            // leaves its tag behind makes every retry a no-op.
            $7baa51c3cff49fc5$var$loaded.delete(domain);
            script.remove();
            reject(new Error('jitsi: script failed to load'));
        };
        document.head.appendChild(script);
    });
    $7baa51c3cff49fc5$var$loaded.set(domain, promise);
    return promise;
}
function $7baa51c3cff49fc5$export$dcaa598e6bc560df({ roomName: roomName, token: token, displayName: displayName, parentNode: parentNode, prejoin: prejoin = false, lang: lang = 'fa', providerName: // The brand as the CALL shows it — window title, join/leave notifications.
// An argument rather than a literal because it is user-facing and therefore
// translatable; this module is React-free by design and has no i18n of its
// own. The Latin default is the brand name, safe in any locale — until a
// caller passes the translated one, the way the doctor app does from its
// visit screen.
providerName = 'Parsina' }) {
    return {
        roomName: roomName,
        jwt: token,
        parentNode: parentNode,
        width: '100%',
        height: '100%',
        userInfo: {
            displayName: displayName
        },
        configOverwrite: {
            // The dentist joins from inside the visit workspace and the patient from
            // a card they already tapped; a prejoin screen is a second confirmation
            // of a decision already made. The patient app turns it back on, where
            // checking your own camera before a doctor sees you is worth the tap.
            //
            // `prejoinConfig` and nothing else: the older `prejoinPageEnabled` is not
            // on the config whitelist — see «Branding» below — so it was doing
            // nothing, and this is the key the device-check screen actually obeys.
            prejoinConfig: {
                enabled: prejoin
            },
            startWithAudioMuted: false,
            startWithVideoMuted: false,
            disableDeepLinking: true,
            // 1:1. Nobody is invited, so nothing offers to invite.
            disableInviteFunctions: true,
            doNotStoreRoom: true,
            // ── Branding: the ONE key that reaches the conference ────────────────
            // An empty logo URL means the watermark renders nothing at all. It is not
            // a preference — it is the only lever the client has:
            //
            //   • Jitsi filters EVERY override we send. `configOverwrite` and
            //     `interfaceConfigOverwrite` both travel as URL-hash params that
            //     external_api.js appends, and the app picks them through a whitelist
            //     before merging. Whatever is not on the list is dropped in silence;
            //     the console logs only the survivors, as «Extending config with: …».
            //   • The interfaceConfig whitelist — 44 keys in jitsi/web:stable-11031 —
            //     contains NO logo or watermark key. SHOW_JITSI_WATERMARK,
            //     DEFAULT_LOGO_URL and their neighbours were set here for months and
            //     never once took effect: that is how the Jitsi logo outlived the
            //     commit that "removed" it.
            //   • The logo url moved to config.defaultLogoUrl. Left unset, a legacy
            //     shim in the bundle falls back to the hardcoded images/watermark.svg
            //     — the Jitsi logo — because the server's interface_config.js has
            //     DEFAULT_LOGO_URL commented out. Setting it is the whole fix.
            //   • This key is whitelisted only while the app runs in an IFRAME
            //     (`window.self !== window.top`), which every Parsina client does. If
            //     a future jitsi/web image drops that gate the logo comes back, and
            //     this line is the first place to look; the escape hatch is then
            //     server-side — see parsina.k8s.deployments/jitsi/README.md.
            //
            // To show پارسینا in the call rather than nothing, this is the one line
            // to change: 'images/parsina-logo.png' is already served by the media
            // server (parsina.k8s.deployments/jitsi/branding.yaml). Relative on
            // purpose — it resolves against the conference host, so the image is
            // same-origin, carries no build hash and names no environment.
            defaultLogoUrl: '',
            // Jitsi's OWN transcriber, refused. It is NOT «پایش بالینی», which is
            // Parsina's own AI reading the conversation live to draft the note and
            // writing nothing to disk. Do not turn this on to enable that — they are
            // unrelated systems. See docs/online-visit-audio-capture.md.
            transcribingEnabled: false,
            liveStreamingEnabled: false,
            hideConferenceSubject: true,
            hideConferenceTimer: false,
            disableThirdPartyRequests: true
        },
        interfaceConfigOverwrite: {
            // Only whitelisted keys reach the conference (see «Branding» above), and
            // these are the ones the list actually honours. Anything about the
            // watermark or the logo belongs in configOverwrite.defaultLogoUrl —
            // adding a SHOW_*_WATERMARK key back here changes nothing at all.
            TOOLBAR_BUTTONS: [
                'microphone',
                'camera',
                'desktop',
                'fullscreen',
                'settings',
                'videoquality',
                'tileview',
                'hangup'
            ],
            // Nothing is KEPT. Recording is not offered because it is absent from
            // TOOLBAR_BUTTONS, the minted token refuses it, and there is no jibri
            // container that could honour it — those three facts are the guarantee.
            // The fileRecordingsEnabled flag that used to sit in configOverwrite read
            // like a fourth one and was discarded by the whitelist unread.
            PROVIDER_NAME: providerName,
            NATIVE_APP_NAME: providerName,
            SHOW_POWERED_BY: false,
            // No DEFAULT_BACKGROUND. It would have to be a literal colour — the
            // design tokens are CSS `var()` references and mean nothing inside
            // Jitsi's iframe — and a raw hex is exactly what the conformance tests
            // in both clients refuse. The branding is on OUR chrome around the frame;
            // the video area is the video.
            DISABLE_JOIN_LEAVE_NOTIFICATIONS: false
        },
        lang: lang
    };
}
async function $7baa51c3cff49fc5$export$323cdae55ed0200(options) {
    const JitsiMeetExternalAPI = await $7baa51c3cff49fc5$export$e5f23e1a6d5d1e7b(options.domain);
    const { domain: domain, ...rest } = options;
    return new JitsiMeetExternalAPI(domain, $7baa51c3cff49fc5$export$dcaa598e6bc560df(rest));
}




const $17cb599564a95c49$export$985b4499d05c66a6 = 'idle';
const $17cb599564a95c49$export$3c482fb33388beb2 = 'starting';
const $17cb599564a95c49$export$1617cb1ce4943d48 = 'live';
const $17cb599564a95c49$export$93578a4f81d1df7e = 'error';
function $17cb599564a95c49$export$fd58d87a1fa8fc0d({ patientId: patientId, appointmentId: appointmentId, editable: editable }) {
    // The call's own chrome follows the panel language. Without it Jitsi stayed
    // on jitsiEmbed's 'fa' default, so the English (and French, German) UI
    // opened a Persian call. Jitsi ships fa, en, fr and de.
    const { locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($17cb599564a95c49$export$985b4499d05c66a6);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [available, setAvailable] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const apiRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const openingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    /**
   * Take the conference down.
   *
   * Handlers are removed BEFORE `dispose()`: disposing fires
   * `readyToClose`/`videoConferenceLeft`, and a handler still attached would
   * run against state a later session may already own.
   */ const teardown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const api = apiRef.current;
        apiRef.current = null;
        openingRef.current = false;
        if (!api) return;
        try {
            api.removeAllListeners?.();
            api.dispose?.();
        } catch  {
        // A conference that is already gone is the state we wanted.
        }
    }, []);
    /**
   * Does this deployment offer video visits, for this visit?
   *
   * Cheap, mints nothing, and safe to call on mount — the query returns null
   * rather than an error when the feature is off.
   */ const probe = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (!patientId || !appointmentId || !editable) {
            setAvailable(false);
            return;
        }
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$8f8b87906e9e5f4e), {
                patientId: patientId,
                appointmentId: appointmentId
            });
            setAvailable(Boolean(data?.videoVisitSession));
        } catch  {
            // A probe that failed is not a feature that is off, but for the purpose
            // of drawing a button the two are the same: do not offer what we could
            // not confirm.
            setAvailable(false);
        }
    }, [
        patientId,
        appointmentId,
        editable
    ]);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (openingRef.current || apiRef.current) return;
        openingRef.current = true;
        setError(null);
        setState($17cb599564a95c49$export$3c482fb33388beb2);
        try {
            // A fresh session BEFORE anything else. The token is short-lived by
            // design, so the query is re-run rather than its answer cached — and
            // re-running it is also what re-checks that this visit is still open.
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$8f8b87906e9e5f4e), {
                patientId: patientId,
                appointmentId: appointmentId
            });
            const session = data?.videoVisitSession;
            if (!session) {
                setAvailable(false);
                throw new Error('unavailable');
            }
            // The panel mounts its container in the same render that flips state to
            // STARTING, so the node exists by the time the await above resolves. If
            // it does not, the panel was closed mid-open — stop rather than attach a
            // conference to nothing.
            const parentNode = containerRef.current;
            if (!parentNode) {
                openingRef.current = false;
                setState($17cb599564a95c49$export$985b4499d05c66a6);
                return;
            }
            const api = await (0, $7baa51c3cff49fc5$export$323cdae55ed0200)({
                domain: session.domain,
                roomName: session.roomName,
                token: session.token,
                displayName: session.displayName,
                parentNode: parentNode,
                // The dentist is already inside the visit; a device-check screen here
                // is a second confirmation of a decision already made.
                prejoin: false,
                lang: locale
            });
            // Closed while the script was loading.
            if (!containerRef.current) {
                try {
                    api.dispose?.();
                } catch  {}
                openingRef.current = false;
                setState($17cb599564a95c49$export$985b4499d05c66a6);
                return;
            }
            apiRef.current = api;
            openingRef.current = false;
            setState($17cb599564a95c49$export$1617cb1ce4943d48);
            // «قطع تماس» inside the Jitsi UI, and any other end the iframe decides
            // on. Without this the panel would keep showing a dead conference.
            api.addListener('readyToClose', ()=>{
                teardown();
                setState($17cb599564a95c49$export$985b4499d05c66a6);
            });
            api.addListener('errorOccurred', (event)=>{
                // Only a fatal error takes the call down; Jitsi reports recoverable
                // ones (a brief reconnect) through the same channel.
                if (event?.error?.isFatal) {
                    teardown();
                    setError('connection');
                    setState($17cb599564a95c49$export$93578a4f81d1df7e);
                }
            });
        } catch (err) {
            teardown();
            const code = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
            setError(code === 'VISIT_NOT_EDITABLE' ? 'visitOver' : err?.message === 'unavailable' ? 'unavailable' : 'connection');
            setState($17cb599564a95c49$export$93578a4f81d1df7e);
        }
    }, [
        patientId,
        appointmentId,
        locale,
        teardown
    ]);
    /** «پایان تماس» from OUR chrome, as opposed to Jitsi's own hangup. */ const stop = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const api = apiRef.current;
        // Ask the conference to leave properly first so the other side sees a
        // departure rather than a silence; teardown then disposes regardless.
        try {
            api?.executeCommand?.('hangup');
        } catch  {}
        teardown();
        setState($17cb599564a95c49$export$985b4499d05c66a6);
        setError(null);
    }, [
        teardown
    ]);
    // A conference outlives the screen unless something ends it. This is the
    // camera indicator staying lit after the dentist navigated away.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>teardown, [
        teardown
    ]);
    // Moving to another visit must not leave the previous visit's call running in
    // a container that now belongs to a different patient.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        teardown();
        setState($17cb599564a95c49$export$985b4499d05c66a6);
        setError(null);
    }, [
        appointmentId,
        teardown
    ]);
    return {
        state: state,
        error: error,
        available: available,
        containerRef: containerRef,
        live: state === $17cb599564a95c49$export$1617cb1ce4943d48,
        busy: state === $17cb599564a95c49$export$3c482fb33388beb2,
        probe: probe,
        start: start,
        stop: stop
    };
}



parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b37c0a1f82541767$export$a2387ed3b5d536eb = {
    name: "phone-off",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10.1 13.9a14 14 0 0 0 3.732 2.668 1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2 18 18 0 0 1-12.728-5.272",
                key: "1wngk7"
            }
        ],
        [
            "path",
            {
                d: "M22 2 2 22",
                key: "y4kqgn"
            }
        ],
        [
            "path",
            {
                d: "M4.76 13.582A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 .244.473",
                key: "10hv5p"
            }
        ]
    ]
};
$b37c0a1f82541767$export$a2387ed3b5d536eb.node;
const $b37c0a1f82541767$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($b37c0a1f82541767$export$a2387ed3b5d536eb);





// ویزیت تصویری — the call, drawn OVER the visit workspace.
//
// ── Why an overlay and not a tab or a route ─────────────────────────────────
// A dentist on a video visit is still working: charting the tooth the patient
// is describing, writing the subjective, reading the plan. A tab would put the
// call and the chart in the same space and force a choice between them, and a
// route would take the workspace off screen entirely (and would need a nav
// entry that CORE.md §8 refuses for an unbuilt screen — this one has no screen
// of its own by design).
//
// So it floats: a panel anchored to the corner, over the left column, with the
// odontogram and the subjective still visible and still usable beneath it.
//
// ── The container node is never unmounted mid-call ──────────────────────────
// `containerRef` is where Jitsi attaches its iframe. React must not own that
// subtree's children — hence an empty div and no children of our own inside it.
// The panel's chrome sits AROUND it, never within.
/** The floating panel's footprint. Deliberately small: it is not the screen. */ const $4695d97a8b3ee9d3$var$PANEL_WIDTH = 380;
const $4695d97a8b3ee9d3$var$VIDEO_HEIGHT = 260;
function $4695d97a8b3ee9d3$export$2e2bcd8739ae039({ call: call, patientName: patientName }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { state: state, error: error, live: live, containerRef: containerRef, stop: stop } = call;
    // Nothing to draw until the dentist has asked for a call. `idle` with no
    // error means the button in the header has not been pressed.
    if (state === 'idle') return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
        "aria-label": t('visit.call.panelLabel'),
        style: {
            position: 'fixed',
            insetInlineStart: 24,
            bottom: 24,
            width: $4695d97a8b3ee9d3$var$PANEL_WIDTH,
            maxWidth: 'calc(100vw - 48px)',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            boxShadow: (0, $e7c165fb515b04ea$export$98b6069deb71e13e).floating,
            overflow: 'hidden',
            // Above the workspace, below a modal: a ConfirmDialog for «پایان جلسه»
            // must still be able to cover this.
            zIndex: 40
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8,
                    padding: '10px 12px',
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d97ad00fbef0d0b$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 600,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: patientName || t('visit.call.title')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "danger",
                        size: "sm",
                        onClick: stop,
                        className: "min-h-11",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b37c0a1f82541767$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('visit.call.hangUp')
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: 12
                },
                role: "alert",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    title: t(`visit.call.error.${error}`)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: containerRef,
                style: {
                    height: error ? 0 : $4695d97a8b3ee9d3$var$VIDEO_HEIGHT,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).ink,
                    position: 'relative'
                },
                children: state === (0, $17cb599564a95c49$export$3c482fb33388beb2) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                fontSize: 12
                            },
                            children: t('visit.call.connecting')
                        })
                    ]
                })
            }),
            live && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    margin: 0,
                    padding: '8px 12px',
                    fontSize: 11,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).ink2,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
                },
                children: t('visit.call.notRecorded')
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c8d58349d145e6a3$export$a2387ed3b5d536eb = {
    name: "arrow-down",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 5v14",
                key: "s699le"
            }
        ],
        [
            "path",
            {
                d: "m19 12-7 7-7-7",
                key: "1idqje"
            }
        ]
    ]
};
$c8d58349d145e6a3$export$a2387ed3b5d536eb.node;
const $c8d58349d145e6a3$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($c8d58349d145e6a3$export$a2387ed3b5d536eb);








parcelRequire("acw62");




// جلسهٔ درمان — the loading shapes of the visit workspace.
//
// The workspace is EIGHT independent fetches on one screen (the visit itself,
// the chart, the note, prior visits, the plan, medications, orders, diagnoses,
// files), and DESIGN.md §"Loading & skeleton" says each region skeletons ALONE:
// the odontogram panel shimmers while شرح حال is already typed into. So this
// file exports one skeleton per region — the three rail panels and the five
// panes — and the page skeleton (drawn only until the visit ITSELF resolves,
// before any region can start) is composed from the same pieces, so the shape
// the page loads into is the shape its regions load into.
//
// Every region skeleton keeps the REAL Panel chrome with its real title: the
// title is known before the data is, and «چارت دندان» over a shimmering arch
// says what is coming in a way a bare rectangle cannot.
// ── shared bits ─────────────────────────────────────────────────────────────
/** The pane's add-form box: bordered `surface2` panel, `fields` inputs, a button row. */ const $a1d8c09d19ce3644$var$FormBoxSkeleton = ({ fields: fields = 3, columns: columns = 'repeat(auto-fit, minmax(150px, 1fr))', chips: chips = 0 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: 12,
            marginBottom: 14,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
        },
        children: [
            chips > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 6,
                    marginBottom: 10
                },
                children: Array.from({
                    length: chips
                }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: [
                            104,
                            96,
                            88
                        ][i % 3],
                        height: 36,
                        radius: 999
                    }, i))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: columns,
                    gap: 10
                },
                children: Array.from({
                    length: fields
                }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                        labelWidth: 64
                    }, i))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    marginTop: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        width: 104
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        width: 96
                    })
                ]
            })
        ]
    });
/** A pane's list row: bordered card, 13px title + 11px meta, status pill. */ const $a1d8c09d19ce3644$var$ListRowSkeleton = ({ i: i, lead: lead = false, actions: actions = 0 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '10px 12px',
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                children: [
                    lead && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 38,
                        height: 22,
                        radius: 999
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: `${38 + i * 13 % 30}%`,
                                height: 13
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: `${24 + i * 7 % 20}%`,
                                height: 11
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 64,
                        height: 22,
                        radius: 8
                    })
                ]
            }),
            actions > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    gap: 6,
                    marginTop: 8
                },
                children: Array.from({
                    length: actions
                }, (_, k)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        width: 84
                    }, k))
            })
        ]
    });
const $a1d8c09d19ce3644$var$ListSkeleton = ({ count: count = 3, lead: lead, actions: actions })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 8
        },
        children: Array.from({
            length: count
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$ListRowSkeleton, {
                i: i,
                lead: lead,
                actions: actions
            }, i))
    });
// ── the rail: three persistent panels ───────────────────────────────────────
/** VisitOdontogram's Stat: 74px min, 10.5px label over a 16px number. */ const $a1d8c09d19ce3644$var$RailStatSkeleton = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '8px 12px',
            minWidth: 74,
            display: 'flex',
            flexDirection: 'column',
            gap: 5
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 40,
                height: 10
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 22,
                height: 16
            })
        ]
    });
const $a1d8c09d19ce3644$export$ff271914d2c02324 = ({ t: t, label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.chart.title'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                gap: 6
            },
            children: [
                0,
                1,
                2
            ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$RailStatSkeleton, {}, i))
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
            label: label,
            "data-testid": "visit-chart-skeleton",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$67864df0c74efa69), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        marginTop: 10,
                        padding: '10px 12px',
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                        borderRadius: 10,
                        minHeight: 44
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: "60%",
                        height: 12,
                        style: {
                            marginTop: 6
                        }
                    })
                })
            ]
        })
    });
const $a1d8c09d19ce3644$export$2add9e6c6aef44a6 = ({ t: t, label: label, collapsible: collapsible, defaultOpen: defaultOpen })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.subjective.title'),
        collapsible: collapsible,
        defaultOpen: defaultOpen,
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
            width: 88
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
            label: label,
            "data-testid": "visit-subjective-skeleton",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                        borderRadius: 10,
                        padding: '10px 12px',
                        marginBottom: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                            width: 96,
                            height: 11,
                            style: {
                                marginBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$cb6ddd830302c2a8), {
                            lines: 3,
                            height: 12,
                            lastWidth: "55%"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gap: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                            labelWidth: 96
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 6
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    width: 72,
                                    height: 12
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: 48,
                                            height: 36,
                                            radius: 999
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: 48,
                                            height: 36,
                                            radius: 999
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                                            width: 132
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                                    labelWidth: 64
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                                    labelWidth: 64
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                            labelWidth: 80,
                            multiline: true
                        })
                    ]
                })
            ]
        })
    });
const $a1d8c09d19ce3644$export$2e18e55558453f28 = ({ t: t, label: label, collapsible: collapsible, defaultOpen: defaultOpen })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.plan.title'),
        collapsible: collapsible,
        defaultOpen: defaultOpen,
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "aria-hidden": true,
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                    width: 64,
                    height: 22,
                    radius: 999
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                    width: 96
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
            label: label,
            "data-testid": "visit-plan-skeleton",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$ListSkeleton, {
                count: 3,
                lead: true
            })
        })
    });
const $a1d8c09d19ce3644$export$fd8935e770d919da = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-tooth-history-skeleton",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            0,
            1,
            2
        ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 64,
                        height: 11
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${40 + i * 17 % 30}%`,
                        height: 12
                    })
                ]
            }, i))
    });
const $a1d8c09d19ce3644$export$5a3d463a4d06f3eb = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-prior-skeleton",
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 6
        },
        children: [
            0,
            1
        ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: "100%",
                height: 44,
                radius: 10
            }, i))
    });
const $a1d8c09d19ce3644$export$43c0e6c4c4a58968 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-diagnosis-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$FormBoxSkeleton, {
                fields: 3,
                columns: "minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$ListSkeleton, {
                count: 3
            })
        ]
    });
const $a1d8c09d19ce3644$export$aea4c0e3e752a659 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-orders-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$FormBoxSkeleton, {
                fields: 3,
                chips: 2,
                columns: "repeat(auto-fit, minmax(160px, 1fr))"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$ListSkeleton, {
                count: 3,
                actions: 1
            })
        ]
    });
const $a1d8c09d19ce3644$export$2d1fa618f1153557 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-files-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$FormBoxSkeleton, {
                fields: 2
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: [
                    0,
                    1
                ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "aria-hidden": true,
                        style: {
                            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            borderRadius: 10,
                            padding: 12,
                            display: 'flex',
                            gap: 12,
                            alignItems: 'center',
                            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                width: 72,
                                height: 72,
                                radius: 8
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 140,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: "45%",
                                        height: 13
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                        width: "30%",
                                        height: 11
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 6,
                                            marginTop: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                                                size: "sm",
                                                width: 72
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                                                size: "sm",
                                                width: 72
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, i))
            })
        ]
    });
const $a1d8c09d19ce3644$export$9310c9553a5a900a = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-meds-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    marginBottom: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 12,
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                        label: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$var$ListSkeleton, {
                count: 2,
                actions: 1
            })
        ]
    });
const $a1d8c09d19ce3644$export$4941eb87ab512a34 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-questions-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    marginBottom: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                        width: 160
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 140,
                        height: 11,
                        style: {
                            marginTop: 6
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "aria-hidden": true,
                style: {
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    paddingTop: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 110,
                        height: 11,
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                        label: false
                    })
                ]
            })
        ]
    });
const $a1d8c09d19ce3644$export$14af0a2edf18435 = ({ label: label })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-questionset-skeleton",
        style: {
            marginBottom: 16
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    marginBottom: 7
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 120,
                        height: 12
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 56,
                        height: 22,
                        radius: 999
                    })
                ]
            }),
            [
                0,
                1,
                2
            ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                        borderRadius: 10,
                        padding: '10px 12px',
                        marginBottom: 8,
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                            width: `${55 + i * 17 % 35}%`,
                            height: 13,
                            style: {
                                marginBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: 6
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    width: 64,
                                    height: 36,
                                    radius: 999
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    width: 64,
                                    height: 36,
                                    radius: 999
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    width: 64,
                                    height: 36,
                                    radius: 999
                                })
                            ]
                        })
                    ]
                }, i))
        ]
    });
const $a1d8c09d19ce3644$var$PANE = {
    diagnosis: $a1d8c09d19ce3644$export$43c0e6c4c4a58968,
    meds: $a1d8c09d19ce3644$export$9310c9553a5a900a,
    orders: $a1d8c09d19ce3644$export$aea4c0e3e752a659,
    questions: $a1d8c09d19ce3644$export$4941eb87ab512a34,
    files: $a1d8c09d19ce3644$export$2d1fa618f1153557
};
const $a1d8c09d19ce3644$export$ba9edad9ecba4e47 = ({ t: t, tab: tab = 'diagnosis', label: label })=>{
    const Pane = $a1d8c09d19ce3644$var$PANE[tab] || $a1d8c09d19ce3644$export$43c0e6c4c4a58968;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-content",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$a5bf34efdb86126b), {
                avatar: true,
                meta: true,
                actions: 2
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    display: 'grid',
                    gridTemplateColumns: 'minmax(0, 1.15fr) minmax(0, 1fr)',
                    gap: 16,
                    padding: '16px 24px 24px',
                    overflow: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "visit-rail",
                        style: {
                            minHeight: 0,
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 14,
                            paddingInlineEnd: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$export$ff271914d2c02324, {
                                t: t
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$export$2add9e6c6aef44a6, {
                                t: t
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$export$2e18e55558453f28, {
                                t: t
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    flexShrink: 0,
                                    marginBottom: 12
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f51fccaec5c96c2a), {
                                    count: 5
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                style: {
                                    flex: 1,
                                    minHeight: 0,
                                    overflow: 'hidden',
                                    padding: 16
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Pane, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $a1d8c09d19ce3644$export$301e0800f4263bf6 = ({ t: t, tab: tab = 'diagnosis', label: label })=>{
    const Pane = $a1d8c09d19ce3644$var$PANE[tab] || $a1d8c09d19ce3644$export$43c0e6c4c4a58968;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "visit-content",
        style: {
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$4c127c4db7b36f7f), {
                back: true,
                subtitle: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '0.75rem 0.75rem 0'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$export$ff271914d2c02324, {
                        t: t
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            height: '0.75rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$export$2add9e6c6aef44a6, {
                        t: t,
                        collapsible: true,
                        defaultOpen: false
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            height: '0.5rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a1d8c09d19ce3644$export$2e18e55558453f28, {
                        t: t,
                        collapsible: true,
                        defaultOpen: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: '0.75rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$52fa1d077274aab0), {
                    count: 5
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.875rem',
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Pane, {})
                })
            })
        ]
    });
};






// §3.1.1 — the odontogram, at the TOP of the persistent column.
//
// "Visual representation of the patient's persistent dental status", with
// clickable teeth, colour-coded conditions, and "real-time status updates when
// treatments are planned or completed".
//
// ── The chart itself is not reimplemented, and that is deliberate ───────────
// `Odontogram` and `ToothDrawer` are the SAME components چارت دندان renders, at
// the same size, in the same anatomical frame. CORE.md §9 makes the arch a
// safety invariant: it is drawn in the PATIENT's frame in both locales and is
// never forked, zoomed, mirrored or wrapped in a transform. A visit-specific
// copy would be a second chart that could disagree with the record's.
//
// ── What this section ADDS ─────────────────────────────────────────────────
// The plan overlay. §3.1.3 requires treatments "linked directly to specific
// teeth on the Odontogram", and §3.1.1 requires the chart to move when one is
// planned or completed. So a tooth carrying plan items is marked, selecting a
// tooth shows what is planned on it beside its recorded state, and the plan's
// own writes reload the chart — the two halves of the right column stay in step
// because they read the same tooth key, not because they message each other.
const $fca799f36321e610$var$PLAN_TONE = {
    proposed: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    accepted: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    },
    done: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    rejected: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    },
    deferred: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    }
};
const $fca799f36321e610$var$Stat = ({ label: label, value: value, tone: tone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '8px 12px',
            minWidth: 74
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 10.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    marginBottom: 3
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 16,
                    fontWeight: 800,
                    color: tone || (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                },
                ...(0, $a278322405d51c25$export$3433559efc22d110),
                children: value
            })
        ]
    });
function $fca799f36321e610$export$2e2bcd8739ae039({ patientId: patientId, clinicId: clinicId, t: t, formatNumber: formatNumber, formatDate: formatDate, chart: chart, planTeeth: planTeeth, selectedTooth: selectedTooth, onSelectTooth: onSelectTooth, onPlanTooth: onPlanTooth, editable: editable, records: // What has been RECORDED on this patient's teeth, and the catalogue that
// names each one. The chart drew the PLAN and nothing else, so a treatment
// the dentist had just recorded left no mark on the arch at all.
records = [], catalog: catalog = [], appointmentId: appointmentId = null, onToothPick: /**
   * Every tooth the dentist CLICKS on the arch, as an event rather than as
   * state — «دندان‌های درگیر» toggles on it, and a toggle needs to hear the
   * second click on a tooth that is already selected, which a `selectedTooth`
   * that did not change cannot report.
   *
   * Fired only from a real click on the chart, never from the programmatic
   * selection a confirmed image finding makes: reviewing an AI finding is not
   * the dentist saying the complaint is about that tooth.
   */ onToothPick, pendingFinding: /**
   * A finding the dentist ticked on an image, waiting to be confirmed.
   *
   * It arrives from فایل‌ها — a different pane, two columns away — because the
   * decision made 2026-08-31 is that an AI finding PRE-FILLS this editor rather
   * than writing to the chart: a model that misread a tooth number would
   * otherwise put a filling on the wrong tooth, and the correction is a void
   * entry an append-only chart carries forever.
   *
   * Consumed once and cleared, so re-rendering this section does not reopen a
   * drawer the dentist just dismissed.
   */ pendingFinding, onFindingConsumed: onFindingConsumed }) {
    const { teeth: teeth, byFdi: byFdi, summary: summary, loading: loading, error: error, saving: saving, record: record, reload: reload } = chart;
    const [focusSurface, setFocusSurface] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [drawerOpen, setDrawerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [seed, setSeed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Which tooth «افزودن به طرح درمان» was last pressed for. The form it opens
    // lives two sections down the same scrolling column, so without a word here
    // the press reads as having done nothing at all. Named for what it IS — the
    // form opened — because the treatment itself is not chosen yet and claiming
    // "added" would be a confirmation of something that has not happened.
    const [planFormFor, setPlanFormFor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showHistory, setShowHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const historyId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    // One read per tooth, and only once its trail is asked for.
    const history = (0, $b11e9ffe8c3f2849$export$e3f31f0e2006ba13)({
        patientId: patientId,
        toothFdi: selectedTooth,
        enabled: showHistory && !!selectedTooth
    });
    // Moving to another tooth closes the trail: leaving it open would show one
    // tooth's history under another tooth's heading for the frame before the new
    // read lands.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowHistory(false);
    }, [
        selectedTooth
    ]);
    // Same reasoning for the plan notice: it names a tooth, so it must not
    // survive onto a different one.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setPlanFormFor(null);
    }, [
        selectedTooth
    ]);
    // A finding ticked in فایل‌ها opens the editor here, pre-filled.
    //
    // The finding is consumed IMMEDIATELY — before the drawer has been closed or
    // saved — so that dismissing it does not leave a pending proposal that
    // reopens on the next unrelated re-render. The seed lives in this component's
    // own state from that point on, which is where a draft belongs.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!pendingFinding) return;
        onSelectTooth?.(pendingFinding.toothFdi);
        setSeed((0, $c6530d73ef205691$export$d16336e5a7ea5761)(pendingFinding));
        setFocusSurface(pendingFinding.aspect === 'surface' ? pendingFinding.surface : null);
        setDrawerOpen(true);
        onFindingConsumed?.();
    }, [
        pendingFinding,
        onSelectTooth,
        onFindingConsumed
    ]);
    const openTooth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi, surface = null)=>{
        onSelectTooth(fdi);
        onToothPick?.(fdi);
        setFocusSurface(surface);
        setDrawerOpen(true);
    }, [
        onSelectTooth,
        onToothPick
    ]);
    // The teeth with OUTSTANDING work, marked on the arch. `Odontogram` takes a
    // `highlight` set rather than being taught about plans: it draws teeth, and
    // what a highlight MEANS is this screen's business.
    //
    // Outstanding, not "has any item": completing the last treatment on a tooth
    // must clear its mark, which is §3.1.1's "real-time status updates when
    // treatments are planned or COMPLETED". Keying on mere membership left a
    // permanent ring on every tooth ever planned, including declined lines.
    const plannedFdis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$49c0abb5f6c435a2)(planTeeth), [
        planTeeth
    ]);
    // «امروز» / «همه» — in the chair the question is «what have I done today»,
    // and between visits it is «what has ever been done». Defaults to ALL,
    // because a chart that hid last month's crown would be lying about the tooth.
    const [scope, setScope] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const scopedRecords = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>scope === 'visit' && appointmentId ? records.filter((r)=>r?.appointmentId === appointmentId) : records, [
        records,
        scope,
        appointmentId
    ]);
    const treatedFdis = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$774cea0d439b4aad)(scopedRecords, catalog), [
        scopedRecords,
        catalog
    ]);
    const wholeMouth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$cc03fdd5f9432e88)(scopedRecords), [
        scopedRecords
    ]);
    // The selected tooth's own treatments, for the merged history below.
    const toothRecords = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>selectedTooth ? records.filter((r)=>r?.toothFdi === selectedTooth) : [], [
        records,
        selectedTooth
    ]);
    const selectedPlanItems = selectedTooth ? planTeeth.get(selectedTooth) || [] : [];
    // This panel alone, in its own shape — the stat strip, the arch at its
    // aspect, the hint strip — inside the real Panel, while شرح حال beside it is
    // already being typed into (DESIGN.md §"Loading & skeleton", region load).
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$ff271914d2c02324), {
        t: t,
        label: t('common.loading')
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.chart.title'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "alert",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('chart.error.title'),
                description: t('chart.error.body'),
                onRetry: reload,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.chart.title'),
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                gap: 6,
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fca799f36321e610$var$Stat, {
                    label: t('chart.summary.decayed'),
                    value: formatNumber(summary?.decayed ?? 0),
                    tone: summary?.decayed ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk : undefined
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fca799f36321e610$var$Stat, {
                    label: t('chart.summary.missing'),
                    value: formatNumber(summary?.missing ?? 0)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fca799f36321e610$var$Stat, {
                    label: t('chart.summary.dmft'),
                    value: formatNumber(summary?.dmft ?? 0)
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "visit-chart",
                "data-state": teeth.length ? 'content' : 'empty',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45122e9f240c7236$export$2e2bcd8739ae039), {
                        teeth: teeth,
                        selected: selectedTooth,
                        highlight: plannedFdis,
                        treated: treatedFdis,
                        planned: planTeeth,
                        onSelect: (fdi)=>openTooth(fdi),
                        onSurfaceSelect: (fdi, surface)=>openTooth(fdi, surface),
                        showPrimary: "auto",
                        labelMode: "fdi",
                        t: t,
                        formatDate: formatDate
                    }),
                    wholeMouth.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "data-testid": "chart-whole-mouth",
                        style: {
                            marginTop: 8,
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            display: 'flex',
                            gap: 6,
                            flexWrap: 'wrap',
                            alignItems: 'baseline'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: [
                                    t('chart.wholeMouth.title'),
                                    t('common.punct.colon')
                                ]
                            }),
                            wholeMouth.slice(0, 3).map((r, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        i > 0 ? "\xb7 " : '',
                                        (0, $0cd549c1a257ae26$export$279093cb86d9c700)(r, catalog) || t('visit.plan.untitledItem')
                                    ]
                                }, r.id)),
                            wholeMouth.length > 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('chart.tooltip.andMore', {
                                    count: formatNumber(wholeMouth.length - 3)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 10,
                            padding: '10px 12px',
                            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                            borderRadius: 10,
                            minHeight: 44
                        },
                        children: !selectedTooth ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                fontSize: 12,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                            },
                            children: t('visit.chart.hint')
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        marginBottom: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            style: {
                                                fontSize: 13,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                            },
                                            children: t('visit.chart.tooth', {
                                                fdi: formatNumber(selectedTooth)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            children: (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'chart.presence', byFdi[selectedTooth]?.presence || 'present')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                marginInlineStart: 'auto',
                                                display: 'flex',
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                    variant: "subtle",
                                                    className: "min-h-11",
                                                    onClick: ()=>setDrawerOpen(true),
                                                    children: t('visit.chart.openTooth')
                                                }),
                                                editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                    variant: "outline",
                                                    className: "min-h-11",
                                                    onClick: ()=>{
                                                        onPlanTooth(selectedTooth);
                                                        setPlanFormFor(selectedTooth);
                                                    },
                                                    children: t('visit.chart.planForTooth')
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                planFormFor === selectedTooth && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    role: "status",
                                    "data-testid": "chart-plan-form-opened",
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
                                        borderRadius: 8,
                                        padding: '6px 9px',
                                        marginBottom: 6,
                                        fontSize: 11.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c8d58349d145e6a3$export$2e2bcd8739ae039), {
                                            size: 13,
                                            "aria-hidden": true,
                                            style: {
                                                flexShrink: 0
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: t('visit.chart.planFormOpened', {
                                                fdi: formatNumber(selectedTooth)
                                            })
                                        })
                                    ]
                                }),
                                selectedPlanItems.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: t('visit.chart.noPlanForTooth')
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 6
                                    },
                                    children: selectedPlanItems.map((item)=>{
                                        const tone = $fca799f36321e610$var$PLAN_TONE[item.status] || $fca799f36321e610$var$PLAN_TONE.proposed;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                background: tone.bg,
                                                color: tone.ink,
                                                borderRadius: 8,
                                                padding: '3px 9px',
                                                fontSize: 11.5,
                                                fontWeight: 700
                                            },
                                            children: [
                                                item.description || t('visit.plan.untitledItem'),
                                                " \xb7 ",
                                                (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.plan.status', item.status)
                                            ]
                                        }, item.itemId);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        marginTop: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "subtle",
                                            className: "min-h-11",
                                            "aria-expanded": showHistory,
                                            "aria-controls": historyId,
                                            onClick: ()=>setShowHistory((v)=>!v),
                                            children: t('visit.chart.history')
                                        }),
                                        showHistory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            id: historyId,
                                            style: {
                                                marginTop: 8
                                            },
                                            children: history.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$fd8935e770d919da), {
                                                label: t('common.loading')
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e04b6779df83121e$export$2e2bcd8739ae039), {
                                                fdi: selectedTooth,
                                                events: history.events,
                                                records: toothRecords,
                                                catalog: catalog,
                                                error: !!history.error,
                                                t: t,
                                                formatDate: formatDate
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0d6ec014fedfc25$export$2e2bcd8739ae039), {
                open: drawerOpen && !!selectedTooth,
                fdi: selectedTooth,
                state: selectedTooth ? byFdi[selectedTooth] : null,
                focusSurface: focusSurface,
                seed: seed,
                saving: saving,
                // A finished visit is read-only everywhere, and the chart is not an
                // exception: charting into yesterday's appointment is the same mistake
                // as writing a diagnosis into it.
                onSave: editable ? record : undefined,
                readOnly: !editable,
                onClose: ()=>{
                    setDrawerOpen(false);
                    setFocusSurface(null);
                    setSeed(null);
                },
                t: t
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3365fede8cd1121a$export$a2387ed3b5d536eb = {
    name: "loader-circle",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M21 12a9 9 0 1 1-6.219-8.56",
                key: "13zald"
            }
        ]
    ],
    aliases: [
        "loader-2"
    ]
};
$3365fede8cd1121a$export$a2387ed3b5d536eb.node;
const $3365fede8cd1121a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3365fede8cd1121a$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9f4b1e9a7f47143$export$a2387ed3b5d536eb = {
    name: "mic",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 19v3",
                key: "npa21l"
            }
        ],
        [
            "path",
            {
                d: "M19 10v2a7 7 0 0 1-14 0v-2",
                key: "1vc78b"
            }
        ],
        [
            "rect",
            {
                x: "9",
                y: "2",
                width: "6",
                height: "13",
                rx: "3",
                key: "s6n7sd"
            }
        ]
    ]
};
$f9f4b1e9a7f47143$export$a2387ed3b5d536eb.node;
const $f9f4b1e9a7f47143$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($f9f4b1e9a7f47143$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5340d072e86ce769$export$a2387ed3b5d536eb = {
    name: "square",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                key: "afitv7"
            }
        ]
    ]
};
$5340d072e86ce769$export$a2387ed3b5d536eb.node;
const $5340d072e86ce769$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5340d072e86ce769$export$a2387ed3b5d536eb);




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



// Voice → text through the BFF, for dictating a field the dentist would
// otherwise type.
//
// MediaRecorder captures the microphone and each chunk goes as a binary frame to
// parsina.bff.dentist's `/ws/transcribe`, which relays it into the AI service's
// TranscribeAudio stream. The words come back as JSON on the same socket.
//
// ── WHY THIS EXISTS AND useSpeechToText's ENGINE DOES NOT SUFFICE ───────────
// `webkitSpeechRecognition` is absent on Safari and in EVERY browser on iOS
// (they are all WebKit), so the sibling hook could only report `supported:
// false` there and the microphone was hidden on the one device a dentist
// actually holds chairside. MediaRecorder is present in every one of them.
//
// ── IT DOES NOT BEHAVE LIKE THE BROWSER ENGINE, AND THE UI MUST NOT PRETEND ──
// Three differences, all of them visible to a dentist:
//
//   1. NO AUTO-STOP. SpeechRecognition detects the end of an utterance and
//      closes itself; a recorder has no idea whether a silence is a full stop or
//      a breath. Every session here ends when the dentist says it does, which is
//      why `continuous` is accepted and ignored — see below.
//   2. THE WORDS ARRIVE LATE. The service transcribes the accumulated buffer on
//      a timer (HINT_INITIAL_DELAY, then HINT_INTERVAL), so anything under about
//      ten seconds — which is most of شکایت اصلی — produces NO interim text at
//      all. The whole transcript arrives in one piece after `stop()`.
//   3. STOPPING IS NOT INSTANT. The final transcription runs after the audio
//      stops, so there is a wait. `transcribing` is that wait, and a caller that
//      does not render it looks frozen.
//
// ── THE FINAL MESSAGE REPLACES, IT DOES NOT APPEND ──────────────────────────
// The service re-transcribes the WHOLE buffer each time and `is_final` carries
// the entire session, so appending it to anything already shown would say
// everything twice.
//
// ── AND THE INTERIM FRAMES ARE NOT SHOWN AT ALL ────────────────────────────
// They were, until dentists reported their dictation coming back with whole
// phrases repeated:
//
//   «… هنگام خوردن غذاهای سرد یا شیرین درد می‌گیرد غذاهای سرد یا شیرین درد
//    می‌گیرد. همچنین موقع جویدن … دارم همچنین موقع جویدن … دارم»
//
// An interim frame is SUPPOSED to carry only the new words, and this hook
// accumulated them on that promise. But the service computes that delta by
// string comparison against its previous transcription of a SHORTER buffer
// (transcription.py, transcribe_audio: `current_text[len(hint_text_so_far):] if
// current_text.startswith(hint_text_so_far) else current_text`) — and an ASR
// pass over more audio revises what it already heard, so punctuation and
// spelling shift a few characters back and the prefix test fails. The frame
// then carries the WHOLE transcript again, and the accumulator dutifully
// appends it to the copy it already had.
//
// It cannot be repaired from this side: the client cannot tell a genuine new
// phrase from a re-transcription of an old one, because on the wire they are
// the same frame. The words the dentist keeps come from ONE clean pass over the
// whole recording — the final frame — so that is now the only thing surfaced.
// `interim` stays in the return shape, always '', because the browser engine
// (useSpeechToText.js) does produce a sound preview and callers must not have
// to ask which engine they got.
//
// What is lost is the field filling as they speak; what is gained is that it
// fills with what they said. If the live preview is wanted back, the fix is on
// the service: send the cumulative text and let this hook REPLACE rather than
// append — but that frame is shared with the doctor app's live-visit panel.
/**
 * The recording container, in the order we would prefer it.
 *
 * Opus in WebM first because it is the smallest thing that goes over the wire
 * for the same audio, and Chrome/Edge/Firefox all take it. `audio/mp4` last and
 * NOT optional: it is the only entry Safari and iOS accept, and dropping it is
 * exactly how the microphone stops working on an iPad.
 *
 * An empty string means "no candidate matched" — MediaRecorder is then
 * constructed with no options and picks its own, which is the correct fallback
 * rather than a failure.
 */ const $a176d3ff9f6d4624$var$MIME_CANDIDATES = [
    'audio/webm;codecs=opus',
    'audio/webm',
    'audio/ogg;codecs=opus',
    'audio/mp4'
];
function $a176d3ff9f6d4624$var$pickMime() {
    try {
        return $a176d3ff9f6d4624$var$MIME_CANDIDATES.find((t)=>window.MediaRecorder?.isTypeSupported?.(t)) || '';
    } catch  {
        return '';
    }
}
function $a176d3ff9f6d4624$export$9534545a69517f6b() {
    return typeof window !== 'undefined' && !!window.MediaRecorder && !!navigator.mediaDevices?.getUserMedia;
}
/** Why a session could not start, in the vocabulary VoiceDictateButton renders. */ function $a176d3ff9f6d4624$var$startFailure(err) {
    const name = err?.name || '';
    if (name === 'NotAllowedError' || name === 'PermissionDeniedError') return 'denied';
    if (name === 'NotFoundError' || name === 'DevicesNotFoundError') return 'no-mic';
    return 'generic';
}
// The BFF refuses in TWO places at once (src/websocket/transcribeHandler.js): a
// JSON frame carrying a `code`, and then a close code. Both are read, because
// neither alone is reliable — some engines give `onclose` no usable code for a
// close they did not initiate, and a frame can lose the race with the close.
// Whichever arrives first wins; `setError(prev => prev || …)` keeps the second
// from overwriting it with something vaguer.
/** `extensions.code`-style names from the JSON frame. */ const $a176d3ff9f6d4624$var$FRAME_REASON = {
    INSUFFICIENT_CREDITS: 'credits',
    UNAUTHENTICATED: 'auth',
    ONBOARDING_REQUIRED: 'onboarding',
    FORBIDDEN: 'onboarding',
    GATE_UNAVAILABLE: 'unavailable',
    AI_UNAVAILABLE: 'unavailable'
};
/** Private-use close codes, mirroring the HTTP statuses the GraphQL side uses. */ const $a176d3ff9f6d4624$var$CLOSE_REASON = {
    4401: 'auth',
    4402: 'credits',
    4403: 'onboarding',
    4503: 'unavailable',
    4504: 'unavailable'
};
function $a176d3ff9f6d4624$export$2e2bcd8739ae039({ onResult: onResult } = {}) {
    const [listening, setListening] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [transcribing, setTranscribing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const wsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const recorderRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const streamRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // What the interim frames have said so far. SALVAGE ONLY — it is never shown
    // as a preview (see the header note: the frames overlap, so this text repeats
    // itself). It is what the dentist gets instead of nothing in the two cases
    // where the clean final transcript never arrives: an empty final frame, and
    // the 30-second timeout. A ref and not state because both of those read it
    // from inside a callback.
    const heardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef('');
    // Guards a second socket while the first is still connecting: `listening` is
    // not yet true during the handshake, so a double-tap would open two.
    const openingRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const finalTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Chunk sends that have been handed to `arrayBuffer()` but have not reached
    // `ws.send` yet. `{done:true}` must not overtake them — see sendDone.
    const inFlightRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    const doneSentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const cb = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onResult);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        cb.current = onResult;
    }, [
        onResult
    ]);
    /** Drop the microphone tracks — what turns the browser's recording indicator
   *  off. Called AFTER the recorder has finished producing its last chunk. */ const releaseTracks = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        try {
            streamRef.current?.getTracks().forEach((t)=>t.stop());
        } catch  {}
        streamRef.current = null;
    }, []);
    /** Release the microphone entirely. Separate from teardown: stop() keeps the
   *  socket, because the transcript has not arrived yet. */ const releaseMic = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        try {
            const rec = recorderRef.current;
            if (rec && rec.state !== 'inactive') rec.stop();
        } catch  {}
        releaseTracks();
        recorderRef.current = null;
    }, [
        releaseTracks
    ]);
    /**
   * Half-close the stream — but only once every chunk already produced is on
   * the wire.
   *
   * THIS ORDERING IS THE WHOLE POINT. `recorder.stop()` emits one last
   * `dataavailable` ASYNCHRONOUSLY, and this hook turns each chunk into an
   * ArrayBuffer asynchronously on top of that. Sending `{done:true}` straight
   * after `stop()` therefore overtakes the final chunk, and the BFF drops
   * anything that arrives after the gRPC stream is half-closed (`!call.writable`)
   * — so the last half-second of every dictation went missing, silently, with a
   * plausible-looking transcript to cover for it.
   *
   * It is worse than half a second on a browser that ignores the timeslice and
   * emits ONLY at stop, which some WebKit builds do: there, that final chunk is
   * the entire recording.
   */ const sendDone = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (doneSentRef.current) return;
        doneSentRef.current = true;
        try {
            await Promise.all(inFlightRef.current);
        } catch  {}
        const ws = wsRef.current;
        if (ws && ws.readyState === WebSocket.OPEN) try {
            ws.send(JSON.stringify({
                done: true
            }));
        } catch  {}
    }, []);
    /** Hard stop: microphone released, socket closed, every flag cleared. */ const teardown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        openingRef.current = false;
        if (finalTimerRef.current) {
            clearTimeout(finalTimerRef.current);
            finalTimerRef.current = null;
        }
        releaseMic();
        const ws = wsRef.current;
        wsRef.current = null;
        if (ws) {
            // Detached first: the close below would otherwise re-enter through
            // onclose and clear flags a next session has already set.
            try {
                ws.onopen = ws.onmessage = ws.onerror = ws.onclose = null;
            } catch  {}
            try {
                ws.close(1000, 'client done');
            } catch  {}
        }
        setListening(false);
        setTranscribing(false);
    }, [
        releaseMic
    ]);
    /**
   * The dentist pressed «پایان».
   *
   * The microphone stops here, but the SOCKET STAYS OPEN: `{done:true}` asks the
   * service to transcribe what it has, and the answer is the only complete
   * transcript there will be. Closing now would throw away the whole session.
   *
   * The timer is the promise that this state ends. Without it a service that
   * never answers leaves «در حال تبدیل…» on screen forever, with no way back to
   * the form except a reload.
   */ const stop = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const ws = wsRef.current;
        setListening(false);
        if (ws && ws.readyState === WebSocket.OPEN) {
            setTranscribing(true);
            const recorder = recorderRef.current;
            recorderRef.current = null;
            if (recorder && recorder.state !== 'inactive') {
                // The flush is deferred to `onstop`, which fires AFTER the recorder's
                // last `dataavailable`. The tracks are dropped there too, not here: a
                // microphone cut before the recorder has finished writing its final
                // chunk is a truncated chunk.
                recorder.onstop = ()=>{
                    releaseTracks();
                    sendDone();
                };
                try {
                    recorder.stop();
                } catch  {
                    releaseTracks();
                    sendDone();
                }
            } else {
                releaseTracks();
                sendDone();
            }
            if (finalTimerRef.current) clearTimeout(finalTimerRef.current);
            finalTimerRef.current = setTimeout(()=>{
                // Whatever the interims managed to say is better than nothing, and the
                // dentist can see it was cut short.
                const partial = heardRef.current.trim();
                if (partial) cb.current?.(partial);
                else setError('timeout');
                teardown();
            }, 30000);
        } else {
            releaseMic();
            teardown();
        }
    }, [
        releaseMic,
        releaseTracks,
        sendDone,
        teardown
    ]);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        if (openingRef.current || wsRef.current) return;
        openingRef.current = true;
        setError(null);
        heardRef.current = '';
        inFlightRef.current = [];
        doneSentRef.current = false;
        if (!$a176d3ff9f6d4624$export$9534545a69517f6b()) {
            // Almost always the insecure-origin case in practice: `mediaDevices` is
            // undefined over plain http, which is how an iPad pointed at a laptop's
            // dev server behaves.
            setError(window.isSecureContext === false ? 'insecure' : 'unsupported');
            openingRef.current = false;
            return;
        }
        // Asked for BEFORE the socket, so a dentist who declines the permission
        // prompt never opens one — and, more to the point, never starts a gRPC
        // stream that bills them for silence.
        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
        } catch (err) {
            setError($a176d3ff9f6d4624$var$startFailure(err));
            openingRef.current = false;
            return;
        }
        streamRef.current = stream;
        // A WebSocket cannot carry an Authorization header, so the token rides in
        // the query string. Refreshed first: the BFF closes an expired one with
        // 4401 and the dentist would read "log in again" mid-visit for a session
        // that was one refresh away from working.
        let token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
        if (!token || (0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) {
            const ok = await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)();
            token = ok ? (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)() : null;
        }
        if (!token) {
            // The session is over, not merely this feature. Say so once, centrally:
            // the shell raises the expired dialog, so the dentist is told what
            // happened instead of being left with a microphone that silently refuses
            // — and the visit on screen behind it is not destroyed. The local `auth`
            // error still renders, for the case where the shell is not mounted.
            (0, $d4d7a25942cf3f48$export$c21f8c101d467dce)((0, $d4d7a25942cf3f48$export$3b6ed64b5b4e542d).EXPIRED);
            setError('auth');
            teardown();
            return;
        }
        let ws;
        try {
            ws = new WebSocket(`${(0, $d87bd335296b449f$export$d8ff6422767fc83a)}/ws/transcribe?token=${encodeURIComponent(token)}`);
        } catch  {
            setError('unavailable');
            teardown();
            return;
        }
        wsRef.current = ws;
        ws.onopen = ()=>{
            // The recorder starts only once the socket is up. Started earlier, its
            // first chunks — which for MPEG-4 carry the header the rest of the file is
            // undecodable without — would be produced with nowhere to go.
            const mimeType = $a176d3ff9f6d4624$var$pickMime();
            let recorder;
            try {
                recorder = new window.MediaRecorder(stream, mimeType ? {
                    mimeType: mimeType
                } : {});
            } catch  {
                setError('unsupported');
                teardown();
                return;
            }
            recorderRef.current = recorder;
            recorder.ondataavailable = (e)=>{
                if (!e.data?.size || ws.readyState !== WebSocket.OPEN) return;
                // Blob → ArrayBuffer explicitly. Sending the Blob works in Chrome but
                // Safari's WebSocket is unreliable with one, and the failure is a socket
                // that stays open sending nothing.
                //
                // The promise is REGISTERED, not just fired: `{done:true}` waits on
                // these, or it overtakes the chunk it is meant to follow. See sendDone.
                const sent = e.data.arrayBuffer().then((buf)=>{
                    try {
                        ws.send(buf);
                    } catch  {}
                }, ()=>{});
                inFlightRef.current.push(sent);
            };
            recorder.start(500);
            openingRef.current = false;
            setListening(true);
        };
        ws.onmessage = (event)=>{
            let msg;
            try {
                msg = JSON.parse(typeof event.data === 'string' ? event.data : '');
            } catch  {
                return;
            }
            if (!msg) return;
            if (msg.error) {
                setError($a176d3ff9f6d4624$var$FRAME_REASON[msg.code] || 'generic');
                teardown();
                return;
            }
            if (typeof msg.text !== 'string') return;
            if (msg.is_final) {
                // The whole session in one clean pass, not a last fragment — and the
                // ONLY thing the dentist is shown. The fallback behind it is the
                // accumulated interims, which repeat themselves; that is a salvage of a
                // session that would otherwise be lost, not a second display path.
                const full = msg.text.trim() || heardRef.current.trim();
                if (full) cb.current?.(full);
                teardown();
                return;
            }
            // Kept, not shown. See heardRef's declaration and the header note.
            heardRef.current = `${heardRef.current}${msg.text} `;
        };
        ws.onerror = ()=>{
            // A socket error with a transcript already in hand is not worth an error
            // message — the dentist has their words. This fires alongside onclose, so
            // teardown is left to that one handler.
            setError((prev)=>prev || 'unavailable');
        };
        ws.onclose = (event)=>{
            const reason = $a176d3ff9f6d4624$var$CLOSE_REASON[event?.code];
            if (reason) setError((prev)=>prev || reason);
            teardown();
        };
    }, [
        teardown
    ]);
    const toggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (wsRef.current) stop();
        else start();
    }, [
        start,
        stop
    ]);
    // A recorder left running past unmount holds the tab's microphone indicator.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>teardown, [
        teardown
    ]);
    return {
        listening: listening,
        transcribing: transcribing,
        // ALWAYS EMPTY on this engine, and kept in the shape rather than dropped so
        // callers stay engine-agnostic — the browser engine's preview is sound and
        // still streams. See the header note for why this one cannot be.
        interim: '',
        error: error,
        supported: $a176d3ff9f6d4624$export$9534545a69517f6b(),
        start: start,
        stop: stop,
        toggle: toggle
    };
}



// Voice → text for dictating a field the dentist would otherwise type
// (شکایت اصلی, یادداشت, and the visit narrative in تشخیص).
//
// TWO ENGINES LIVE HERE. The default export is the dispatcher; which one it
// returns is decided once, below, and no caller has to know which it got.
//
// ── 2026-08-25: THE DEFAULT MOVED TO THE SERVER, BECAUSE OF SAFARI ─────────
// This file used to be the browser engine and nothing else, and its own comment
// said the replacement, if the position ever changed, would be "a BFF mutation
// behind this same hook and no caller has to change". That is what happened,
// and the reason was not privacy in the end — it was that the engine DOES NOT
// EXIST on the device dentists use.
//
// `webkitSpeechRecognition` is Chrome and Edge. Safari does not implement it,
// Firefox does not implement it, and neither does any browser on iOS — they are
// all WebKit underneath, so an iPad has no recogniser no matter what is
// installed on it. `supported` was therefore false on the iPad a dentist holds
// chairside, and VoiceDictateButton correctly rendered nothing at all: the
// feature simply did not exist on half the devices it was written for.
//
// The server path records with MediaRecorder — present in every one of those
// browsers — and streams the audio to parsina.bff.dentist's /ws/transcribe.
// See useServerSpeechToText.js.
//
// Two things changed with it, and they pull in opposite directions:
//   * PRIVACY IMPROVED. The browser engine was never local recognition: Chrome
//     and Edge stream the microphone to GOOGLE'S servers, so a patient's spoken
//     complaint was leaving this deployment. It now reaches Parsina's own AI
//     service over the BFF's authenticated socket.
//   * IT COSTS پارسه, where the browser engine was free. `USE_BROWSER_STT=true`
//     buys the old behaviour back, at the price of no microphone on iPads.
// ── The browser engine ──────────────────────────────────────────────────────
const $34c7ebd088df533e$var$Engine = typeof window !== 'undefined' && (window.SpeechRecognition || window.webkitSpeechRecognition) || null;
const $34c7ebd088df533e$export$8f9e01df4470b7ac = !!$34c7ebd088df533e$var$Engine;
// Recognition wants a BCP-47 tag; the app's locale is the bare 'fa' | 'en' | 'fr' | 'de'.
// Every SUPPORTED locale needs a row: a missing one listens for PERSIAN.
const $34c7ebd088df533e$var$TAGS = {
    fa: 'fa-IR',
    en: 'en-US',
    fr: 'fr-FR',
    de: 'de-DE'
};
function $34c7ebd088df533e$export$682646ec4ac33209({ locale: locale = 'fa', onResult: onResult, continuous: continuous = false } = {}) {
    const [listening, setListening] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [interim, setInterim] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const recRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // onResult is read at event time, so a caller may pass a fresh closure every
    // render without tearing down the recogniser mid-sentence.
    const cb = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onResult);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        cb.current = onResult;
    }, [
        onResult
    ]);
    const stop = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const rec = recRef.current;
        recRef.current = null;
        setListening(false);
        setInterim('');
        if (rec) {
            // Detach first: `stop()` fires onend, which would otherwise re-enter this
            // and null a recogniser the next start() has already installed.
            rec.onresult = null;
            rec.onerror = null;
            rec.onend = null;
            try {
                rec.stop();
            } catch  {}
        }
    }, []);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (!$34c7ebd088df533e$var$Engine || recRef.current) return;
        setError(null);
        setInterim('');
        const rec = new $34c7ebd088df533e$var$Engine();
        rec.lang = $34c7ebd088df533e$var$TAGS[locale] || $34c7ebd088df533e$var$TAGS.fa;
        rec.continuous = continuous;
        // interimResults gives the dentist live feedback that the microphone is
        // actually hearing them, rather than a dead button until the first pause.
        rec.interimResults = true;
        rec.maxAlternatives = 1;
        rec.onresult = (event)=>{
            let pending = '';
            for(let i = event.resultIndex; i < event.results.length; i += 1){
                const r = event.results[i];
                const text = r[0]?.transcript || '';
                if (r.isFinal) cb.current?.(text.trim());
                else pending += text;
            }
            setInterim(pending);
        };
        rec.onerror = (event)=>{
            // `aborted` is what stop() itself raises, and `no-speech` is a silent
            // room — neither is a failure worth showing a dentist mid-visit.
            if (event.error !== 'aborted' && event.error !== 'no-speech') // Normalised to the SAME vocabulary the server engine reports, so
            // VoiceDictateButton renders one set of messages and never has to ask
            // which engine produced the failure.
            setError(event.error === 'not-allowed' ? 'denied' : 'generic');
            stop();
        };
        // Chrome ends a `continuous` session on its own after a long silence. That
        // is left to stand rather than auto-restarted: a recogniser that respawns
        // itself is a microphone that never closes, which is not a thing to leave
        // running in a room where patients are talking.
        rec.onend = ()=>stop();
        recRef.current = rec;
        setListening(true);
        try {
            rec.start();
        } catch  {
            setError('generic');
            stop();
        }
    }, [
        locale,
        continuous,
        stop
    ]);
    const toggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (recRef.current) stop();
        else start();
    }, [
        start,
        stop
    ]);
    // A recogniser left running past unmount keeps the tab's mic indicator lit.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>stop, [
        stop
    ]);
    return {
        listening: listening,
        // The browser engine transcribes as it hears; there is no post-recording
        // wait to render. Present so both engines return the same shape.
        transcribing: false,
        interim: interim,
        error: error,
        supported: $34c7ebd088df533e$export$8f9e01df4470b7ac,
        start: start,
        stop: stop,
        toggle: toggle
    };
}
function $34c7ebd088df533e$export$e772b07b28ae7108() {
    return (0, $d87bd335296b449f$export$348460d0a768e5a6) ? $34c7ebd088df533e$export$8f9e01df4470b7ac : (0, $a176d3ff9f6d4624$export$9534545a69517f6b)();
}
function $34c7ebd088df533e$export$2e2bcd8739ae039(opts = {}) {
    const browser = $34c7ebd088df533e$export$682646ec4ac33209(opts);
    const server = (0, $a176d3ff9f6d4624$export$2e2bcd8739ae039)(opts);
    const useBrowser = (0, $d87bd335296b449f$export$348460d0a768e5a6) && $34c7ebd088df533e$export$8f9e01df4470b7ac;
    return {
        ...useBrowser ? browser : server,
        engine: useBrowser ? 'browser' : 'server'
    };
}




parcelRequire("acw62");




function $c0054f6b4676327d$export$11c467f1ec2afb25({ size: size = 12 }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: "none",
        "aria-hidden": "true",
        style: {
            flexShrink: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "6.4",
                stroke: "currentColor",
                strokeWidth: "1.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "2.1",
                fill: "currentColor"
            })
        ]
    });
}
function $c0054f6b4676327d$export$2e2bcd8739ae039({ cost: cost, per: per, prefix: prefix, tone: tone = 'accent', size: size = 'sm', title: title, style: style, testid: testid = 'coin-chip' }) {
    const { formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    if (cost == null) return null;
    const tones = {
        accent: {
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.14),
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
        },
        onDark: {
            bg: 'rgba(255,255,255,0.18)',
            fg: '#fff'
        },
        warn: {
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight,
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber
        },
        danger: {
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).redLight,
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
        },
        mute: {
            bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted, 0.12),
            fg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
        }
    };
    const palette = tones[tone] || tones.accent;
    const isSm = size === 'sm';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        title: title,
        "data-testid": testid,
        style: {
            ...isSm ? (0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption : (0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            background: palette.bg,
            color: palette.fg,
            borderRadius: 999,
            padding: isSm ? '1px 8px' : '3px 10px',
            fontWeight: 800,
            lineHeight: 1.6,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c0054f6b4676327d$export$11c467f1ec2afb25, {
                size: isSm ? 11 : 12
            }),
            prefix ? `${prefix} ` : '',
            (0, $75f061374f24c25d$export$b634cc5d06849b0a)(cost, formatNumber),
            per ? ` / ${per}` : ''
        ]
    });
}



function $67a78e1c740445b3$export$2e2bcd8739ae039({ onText: onText, onInterim: // Live, not-yet-final words for the current session, or '' when there is no
// session. OPTIONAL: a caller that omits it simply gets the words at the end,
// which is how this component behaved before.
onInterim, disabled: disabled = false, label: label, appearance: // 'icon' | 'wide' — see the appearance note above.
appearance = 'icon', stopLabel: // Wide appearance only: what the live button says instead of the generic
// «پایان ضبط», for a caller whose stop has a consequence worth naming.
stopLabel, size: size = 44, continuous: // Pass for a multi-line field, where a pause between sentences is thinking
// rather than the end of the answer. Honoured by the browser engine; the
// server engine records until stopped either way. See useSpeechToText.
continuous = false }) {
    const { t: t, locale: locale, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // The policy's per-minute price once the list has arrived; the constant until then.
    const { costOf: costOf } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    // Appends rather than replaces: dictation is a second way to fill the field,
    // not a reset of what the dentist already typed.
    const handleResult = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((text)=>{
        if (text) onText(text);
    }, [
        onText
    ]);
    const { listening: listening, transcribing: transcribing, interim: interim, error: error, engine: engine, start: start, stop: stop } = (0, $34c7ebd088df533e$export$2e2bcd8739ae039)({
        locale: locale,
        continuous: continuous,
        onResult: handleResult
    });
    // ── The interim stream, forwarded to the field ────────────────────────────
    // Read through a ref so a caller may pass a fresh closure every render — which
    // it will, since the handler closes over the field's value — without this
    // effect re-firing and re-sending the same preview.
    //
    // `listening || transcribing`, not `listening` alone: the hook keeps the
    // interim text through the post-recording wait, and dropping the preview at
    // «پایان» would blank the field for the seconds before the final transcript
    // lands. Teardown clears both flags AND the interim in the same batch as the
    // final result, so the preview disappears exactly as the real words arrive —
    // never a frame showing both.
    //
    // A LAYOUT effect, not a passive one, and only for the last render of a
    // session: the final transcript reaches the caller through `onText` during the
    // socket's message handler, while the preview is cleared from here. A passive
    // effect runs AFTER the paint, so for one frame the field would show the
    // committed words followed by the preview of the same words — the duplication
    // this whole contract exists to avoid, visible just long enough to be noticed.
    const liveRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(onInterim);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        liveRef.current = onInterim;
    }, [
        onInterim
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        liveRef.current?.(listening || transcribing ? interim : '');
    }, [
        interim,
        listening,
        transcribing
    ]);
    // ── The clock ─────────────────────────────────────────────────────────────
    // Restarted from zero by `listening` going true, and left frozen at its last
    // value when it goes false — the interval stops, the state does not reset,
    // because the chip unmounts with it and a reset would be a visible flicker to
    // «۰۰:۰۰» on the way out.
    const [elapsed, setElapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!listening) return undefined;
        setElapsed(0);
        const id = setInterval(()=>setElapsed((s)=>s + 1), 1000);
        return ()=>clearInterval(id);
    }, [
        listening
    ]);
    const begin = ()=>start();
    // Hidden only where NEITHER engine can work — a browser with no recogniser
    // and no MediaRecorder, or an insecure origin where getUserMedia does not
    // exist. A disabled-but-visible mic reads as "broken today, retry later",
    // which is the wrong promise for something that will never work here.
    if (!(0, $34c7ebd088df533e$export$e772b07b28ae7108)()) return null;
    // The label IS the affordance now that the modal's «پایان» is gone: while a
    // session is live this button is the stop control, and its tooltip and
    // accessible name have to say so.
    const title = listening ? t('common.voice.stop') : label || t('common.voice.start');
    // Only the server engine reaches the AI service, and only the AI service
    // charges. Advertising a price on the free path would be a straight untruth.
    const priced = engine === 'server';
    const mm = String(Math.floor(elapsed / 60)).padStart(2, '0');
    const ss = String(elapsed % 60).padStart(2, '0');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 2,
                    flexShrink: 0
                },
                children: [
                    appearance === 'wide' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        // Destructive red while live — the same colour as the dot beside
                        // it, so the two read as one state rather than a button and a
                        // warning. The kit's destructive variant IS the recording red.
                        variant: listening ? 'destructive' : 'default',
                        className: "min-h-11",
                        // Inert while the words are being worked out: there is nothing to
                        // stop and nothing to start, and a second press would only re-ask
                        // the server for a transcript it is already producing.
                        disabled: disabled || transcribing,
                        "aria-pressed": listening,
                        "data-testid": "voice-mic",
                        onClick: listening ? stop : begin,
                        children: [
                            listening ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5340d072e86ce769$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true,
                                fill: "currentColor"
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9f4b1e9a7f47143$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true
                            }),
                            listening ? stopLabel || t('common.voice.stop') : title
                        ]
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        // Red and filled while live — the same colour as the dot beside it,
                        // so the two read as one state rather than a button and a warning.
                        variant: listening ? 'default' : 'ghost',
                        size: size,
                        // Inert while the words are being worked out: there is nothing to stop
                        // and nothing to start, and a second press would only re-ask the server
                        // for a transcript it is already producing.
                        disabled: disabled || transcribing,
                        label: title,
                        "aria-pressed": listening,
                        "data-testid": "voice-mic",
                        onClick: listening ? stop : begin,
                        style: listening ? {
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                            color: '#fff'
                        } : undefined,
                        icon: listening ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5340d072e86ce769$export$2e2bcd8739ae039), {
                            size: 14,
                            "aria-hidden": true,
                            fill: "currentColor"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9f4b1e9a7f47143$export$2e2bcd8739ae039), {
                            size: 16,
                            "aria-hidden": true
                        })
                    }),
                    priced && !disabled && !listening && !transcribing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$2e2bcd8739ae039), {
                        cost: costOf('TRANSCRIPTION_PER_MIN'),
                        per: t('common.units.minute'),
                        tone: "mute",
                        title: t('common.voice.priceTitle'),
                        testid: "voice-cost"
                    })
                ]
            }),
            listening && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                role: "status",
                "aria-live": "polite",
                "data-testid": "voice-live",
                "data-phase": "listening",
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                    whiteSpace: 'nowrap',
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "aria-hidden": true,
                        style: {
                            position: 'relative',
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red,
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "animate-ping",
                            style: {
                                position: 'absolute',
                                inset: -2,
                                borderRadius: '50%',
                                background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).red, 0.5)
                            }
                        })
                    }),
                    t('common.voice.listening'),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "data-testid": "voice-timer",
                        style: {
                            fontVariantNumeric: 'tabular-nums',
                            fontWeight: 700
                        },
                        children: formatDigits(`${mm}:${ss}`)
                    })
                ]
            }),
            transcribing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                role: "status",
                "aria-live": "polite",
                "data-testid": "voice-inline-status",
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    whiteSpace: 'nowrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3365fede8cd1121a$export$2e2bcd8739ae039), {
                        size: 13,
                        "aria-hidden": true,
                        className: "animate-spin"
                    }),
                    t('common.voice.inlineTranscribing')
                ]
            }),
            !!error && !listening && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                role: "alert",
                "data-testid": "voice-inline-error",
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).red
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                        size: 13,
                        "aria-hidden": true,
                        style: {
                            flexShrink: 0
                        }
                    }),
                    t(`common.voice.error.${error}`)
                ]
            })
        ]
    });
}



// §3.1.2 — Subjective (SOAP note), the MIDDLE of the persistent column.
//
// Three requirements, three regions:
//
//   "Structured input fields for current complaints"   → the form
//   "Integrated display of «شرح حال بیمار»"             → the history strip
//   "Contextual linking to previous visits"            → the prior-visit list
//
// ── Why the fields are structured AND composed into prose ──────────────────
// What is STORED is a SOAP note with the structured dental fields inside its
// content object (the service allows extra keys), and the readable `subjective`
// string is derived from them server-side on every save. So the dentist fills
// in fields, and a reader that knows nothing about dentistry — the doctor app,
// a FHIR export — still finds a real note rather than an empty S.
//
// ── Saving ─────────────────────────────────────────────────────────────────
// Explicit, not on blur and not on a timer. A note is a clinical record; a
// dentist mid-sentence must not be committing drafts, and an autosave racing a
// half-typed complaint is how «درد» ends up in the record as «د».
const $9eb3b027aeb752d3$var$PAIN_CHARACTERS = [
    'sharp',
    'dull',
    'throbbing',
    'sensitivity',
    'none'
];
/** The empty form. Every field a string so the inputs are always controlled. */ const $9eb3b027aeb752d3$var$EMPTY = {
    chiefComplaint: '',
    painScore: '',
    painCharacter: '',
    onset: '',
    duration: '',
    aggravatingFactors: '',
    relievingFactors: '',
    dentalHistory: '',
    notes: ''
};
/** A saved note → the form's shape. */ function $9eb3b027aeb752d3$var$toForm(note) {
    const d = note?.dental || {};
    return {
        chiefComplaint: d.chiefComplaint || '',
        // 0 is a real score and must survive the || fallback that would blank it.
        painScore: d.painScore == null ? '' : String(d.painScore),
        painCharacter: d.painCharacter || '',
        onset: d.onset || '',
        duration: d.duration || '',
        aggravatingFactors: d.aggravatingFactors || '',
        relievingFactors: d.relievingFactors || '',
        dentalHistory: d.dentalHistory || '',
        notes: d.notes || ''
    };
}
const $9eb3b027aeb752d3$var$Field = ({ label: label, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
        style: {
            display: 'block'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    display: 'block',
                    fontSize: 11.5,
                    fontWeight: 700,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    marginBottom: 4
                },
                children: label
            }),
            children
        ]
    });
// The kit's FilterChip, not a hand-rolled pill: it is already `aria-pressed`
// and already `min-h-11`, which is the touch floor this section renders at on a
// phone (this file is shared by both surfaces).
const $9eb3b027aeb752d3$var$Chip = ({ active: active, onClick: onClick, disabled: disabled, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
        active: active,
        disabled: disabled,
        onClick: onClick,
        label: children
    });
function $9eb3b027aeb752d3$export$2e2bcd8739ae039({ t: t, formatNumber: formatNumber, formatDate: formatDate, note: note, editable: editable, selectedTooth: selectedTooth, toothPick: /**
   * The last tooth CLICKED on the arch, as `{ fdi, seq }`.
   *
   * §3.1.3's link runs both ways, and the way a dentist names the teeth a
   * complaint is about is by pointing at them — several of them. `seq` is what
   * makes that possible: the chart holds ONE `selectedTooth`, so clicking a
   * tooth that is already selected changes nothing observable, and a toggle
   * driven off the value alone could never take a tooth back OUT of the list.
   * The counter turns each click into a distinct event.
   */ toothPick, priorVisits: priorVisits, onOpenPriorVisit: onOpenPriorVisit, patient: patient, pendingRef: /**
   * A ref the visit screen owns, kept pointing at { dirty, submit }.
   *
   * «پایان جلسه» closes the visit for good, and this form is the ONLY thing on
   * the screen holding text that is not already persisted — every other section
   * writes on its own action. So the screen has to be able to ask this one
   * whether it has anything pending and to flush it, without lifting the whole
   * form's state out of here.
   */ pendingRef, collapsible: // The phone stacks all three persistent sections in one scroll, so the two
// text-heavy ones fold. Forwarded to Panel rather than wrapped in a
// CollapsibleSection, which would render the title twice.
collapsible = false, defaultOpen: defaultOpen = true }) {
    const { note: saved, revision: revision, loading: loading, error: error, saving: saving, save: save, reload: reload } = note;
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($9eb3b027aeb752d3$var$EMPTY);
    const [dirty, setDirty] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [teeth, setTeeth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [justSaved, setJustSaved] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // ── Words a dictation session has produced but not finished ──────────────
    // Kept OUT of `form` and shown only by concatenation: the server engine's
    // final message carries the whole session rather than its tail, so anything
    // folded into the form here would be written a second time when it lands —
    // and, worse, would be `dirty` and saveable while still provisional.
    // `VoiceDictateButton` clears it back to '' in the same render as the final
    // text reaches `onText`.
    //
    // یادداشت ONLY, and not شکایت اصلی, which is a single-line input: a growing
    // preview scrolls out of the left of one of those as it arrives, so the
    // dentist would watch the FIRST words of a sentence whose newest words are
    // the ones they want to check. A textarea grows downward and can be pinned to
    // its bottom (below), so there the preview is readable. The complaint still
    // gets the whole transcript the moment the session ends, as it always did.
    const [liveNotes, setLiveNotes] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Keeps the newest streamed words in view in a box that is two rows tall.
    // React 19 passes `ref` as an ordinary prop, and the kit's Textarea spreads
    // its rest props onto the real control, so this reaches the <textarea>.
    const notesRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (liveNotes && notesRef.current) notesRef.current.scrollTop = notesRef.current.scrollHeight;
    }, [
        liveNotes
    ]);
    // Load the saved note into the form once per REVISION, and never over unsaved
    // edits: a background reload that overwrote what the dentist is typing would
    // lose the complaint mid-sentence.
    //
    // Keyed on `revision` and not on `saved.id`, because the id does NOT change
    // when the note is revised in place — and this note is written from two
    // places. Answering a question in پرسش‌ها appends a finding to it; on the id
    // alone this form never re-synced, the dentist never saw the finding, and
    // their next «ذخیره» wrote the stale text back over it.
    const loadedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const key = `${saved?.id || 'none'}:${revision ?? 0}`;
        if (loadedRef.current === key) return;
        // Unsaved edits still win: the dentist's half-typed complaint is not
        // discarded by somebody else's write. `justSaved` keeps the confirmation
        // visible for the save that produced this revision.
        if (dirty) return;
        loadedRef.current = key;
        setForm($9eb3b027aeb752d3$var$toForm(saved));
        setTeeth(saved?.dental?.teethFdi || []);
    }, [
        saved,
        revision,
        dirty
    ]);
    const set = (key)=>(value)=>{
            setForm((f)=>({
                    ...f,
                    [key]: value
                }));
            setDirty(true);
            setJustSaved(false);
        };
    // §3.1.3's link runs both ways: a tooth selected on the odontogram can be
    // attached to the complaint, so «کدام دندان» is answered by pointing rather
    // than by typing a number. Clicking the arch now does this on its own (see
    // the pick effect below); the button remains for the tooth that is selected
    // but NOT listed — the one whose chip was just removed by ×.
    const attachTooth = ()=>{
        if (!selectedTooth || teeth.includes(selectedTooth)) return;
        setTeeth((prev)=>[
                ...prev,
                selectedTooth
            ]);
        setDirty(true);
        setJustSaved(false);
    };
    const detachTooth = (fdi)=>{
        setTeeth((prev)=>prev.filter((x)=>x !== fdi));
        setDirty(true);
        setJustSaved(false);
    };
    // ── Clicking teeth on the arch fills this list ────────────────────────────
    // The chart is single-select — it has to be, because the drawer, the tooth
    // history and «افزودن به طرح درمان» all speak about ONE tooth — so before
    // this a dentist who picked three teeth on the arch could only ever get the
    // last of them into «دندان‌های درگیر», and only by pressing a button two
    // sections further down. Now each click toggles its tooth here, and the
    // chip's × still removes one.
    //
    // Keyed on `seq`, not on the tooth: a second click on the SAME tooth must be
    // heard, and re-running on a re-render must not silently re-add a tooth the
    // dentist just removed.
    const lastPickRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const seq = toothPick?.seq || 0;
        const fdi = toothPick?.fdi;
        if (!seq || !fdi || seq === lastPickRef.current) return;
        // Not before the saved note has landed: marking the form dirty first would
        // block the load above FOREVER (`if (dirty) return`) and the next «ذخیره»
        // would overwrite a real subjective with this blank one. The pick is HELD
        // rather than dropped — `loading` is a dependency, so it lands the moment
        // the note does, and a dentist who tapped a tooth while the panel was still
        // spinning does not have to notice that it did nothing.
        if (loading || loadedRef.current === null) return;
        // A closed visit is read-only; the arch is still browsable there.
        if (!editable) return;
        lastPickRef.current = seq;
        setTeeth((prev)=>prev.includes(fdi) ? prev.filter((x)=>x !== fdi) : [
                ...prev,
                fdi
            ]);
        setDirty(true);
        setJustSaved(false);
    }, [
        toothPick,
        editable,
        loading
    ]);
    const submit = async ()=>{
        setFailure(null);
        const score = form.painScore === '' ? null : Number(form.painScore);
        const err = await save({
            subjective: {
                chiefComplaint: form.chiefComplaint || null,
                painScore: Number.isFinite(score) ? score : null,
                painCharacter: form.painCharacter || null,
                teethFdi: teeth,
                onset: form.onset || null,
                duration: form.duration || null,
                aggravatingFactors: form.aggravatingFactors || null,
                relievingFactors: form.relievingFactors || null,
                dentalHistory: form.dentalHistory || null,
                notes: form.notes || null
            }
        });
        if (err) {
            setFailure(err);
            return err;
        }
        setDirty(false);
        setJustSaved(true);
        // Returns the error, or null — «پایان جلسه» flushes through this and must
        // NOT close the visit when the flush failed. Closing is one-way, so a note
        // that did not land before it would be lost with no way back in.
        return null;
    };
    // No dependency list: `submit` closes over the current form and teeth, so a
    // stale entry here would flush yesterday's text on «پایان جلسه».
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!pendingRef) return undefined;
        pendingRef.current = {
            dirty: dirty,
            submit: submit
        };
        return ()=>{
            pendingRef.current = null;
        };
    });
    // This panel alone, in its own shape — the history strip, the complaint
    // field, the tooth chips, the score fields — inside the real Panel
    // (DESIGN.md §"Loading & skeleton", region load).
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$2add9e6c6aef44a6), {
        t: t,
        label: t('common.loading'),
        collapsible: collapsible,
        defaultOpen: defaultOpen
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.subjective.title'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "alert",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('visit.subjective.error.title'),
                description: t('visit.subjective.error.body'),
                onRetry: reload,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    const allergies = patient?.allergies || [];
    const conditions = patient?.conditions || [];
    const medications = patient?.medications || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.subjective.title'),
        collapsible: collapsible,
        defaultOpen: defaultOpen,
        action: editable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8
            },
            children: [
                justSaved && !dirty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 4,
                        fontSize: 11.5,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                            size: 13,
                            "aria-hidden": true
                        }),
                        t('visit.subjective.saved')
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    className: "min-h-11",
                    onClick: submit,
                    disabled: saving || !dirty,
                    children: saving ? t('common.actions.saving') : t('common.actions.save')
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
            variant: "outline",
            children: t('visit.readOnly.badge')
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "visit-subjective",
            "data-state": saved ? 'content' : 'empty',
            children: [
                failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    style: {
                        marginBottom: 12
                    },
                    children: t('visit.subjective.saveFailed')
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                        borderRadius: 10,
                        padding: '10px 12px',
                        marginBottom: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 11.5,
                                fontWeight: 800,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                marginBottom: 6
                            },
                            children: t('visit.subjective.history')
                        }),
                        allergies.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                                marginBottom: 6,
                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
                                fontSize: 12.5,
                                fontWeight: 700
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: allergies.map((a)=>a.allergen).filter(Boolean).join(" \xb7 ")
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 12,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                marginBottom: 6
                            },
                            children: t('visit.subjective.noAllergies')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                fontSize: 12,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                lineHeight: 1.9
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                t('visit.subjective.conditions'),
                                                t('common.punct.colon'),
                                                " "
                                            ]
                                        }),
                                        conditions.length ? conditions.map((c)=>c.display).filter(Boolean).join((0, $c53f9539af19d960$export$3004b7ed4244ef95)()) : t('common.labels.none')
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            children: [
                                                t('visit.subjective.medications'),
                                                t('common.punct.colon'),
                                                " "
                                            ]
                                        }),
                                        medications.length ? medications.map((m)=>m.display).filter(Boolean).join((0, $c53f9539af19d960$export$3004b7ed4244ef95)()) : t('common.labels.none')
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'grid',
                        gap: 10
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                            label: t('visit.subjective.chiefComplaint'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                            dir: "auto",
                                            value: form.chiefComplaint,
                                            disabled: !editable,
                                            "aria-label": t('visit.subjective.chiefComplaint'),
                                            onChange: (e)=>set('chiefComplaint')(e.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67a78e1c740445b3$export$2e2bcd8739ae039), {
                                        disabled: !editable,
                                        label: t('visit.subjective.dictateComplaint'),
                                        onText: (text)=>set('chiefComplaint')(// Append: dictation adds to what is already there rather
                                            // than discarding a complaint the dentist half-typed.
                                            form.chiefComplaint ? `${form.chiefComplaint} ${text}` : text)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                            label: t('visit.subjective.teeth'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 6,
                                    alignItems: 'center'
                                },
                                children: [
                                    teeth.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('visit.subjective.noTeeth')
                                    }),
                                    teeth.map((fdi)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9eb3b027aeb752d3$var$Chip, {
                                            active: true,
                                            disabled: !editable,
                                            onClick: ()=>detachTooth(fdi),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                    children: formatNumber(fdi)
                                                }),
                                                editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        marginInlineStart: 5
                                                    },
                                                    children: "\xd7"
                                                })
                                            ]
                                        }, fdi)),
                                    editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: "subtle",
                                        className: "min-h-11",
                                        onClick: attachTooth,
                                        disabled: !selectedTooth || teeth.includes(selectedTooth),
                                        children: selectedTooth ? t('visit.subjective.addTooth', {
                                            fdi: formatNumber(selectedTooth)
                                        }) : t('visit.subjective.selectToothFirst')
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                                    label: t('visit.subjective.painScore'),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        type: "number",
                                        min: 0,
                                        max: 10,
                                        dir: "auto",
                                        value: form.painScore,
                                        disabled: !editable,
                                        "aria-label": t('visit.subjective.painScore'),
                                        onChange: (e)=>set('painScore')(e.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                                    label: t('visit.subjective.onset'),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        type: "time",
                                        dir: "ltr",
                                        value: form.onset,
                                        disabled: !editable,
                                        "aria-label": t('visit.subjective.onset'),
                                        onChange: (e)=>set('onset')(e.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                                    label: t('visit.subjective.duration'),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        dir: "auto",
                                        value: form.duration,
                                        disabled: !editable,
                                        "aria-label": t('visit.subjective.duration'),
                                        onChange: (e)=>set('duration')(e.target.value)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                            label: t('visit.subjective.painCharacter'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 6
                                },
                                children: $9eb3b027aeb752d3$var$PAIN_CHARACTERS.map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Chip, {
                                        active: form.painCharacter === p,
                                        disabled: !editable,
                                        onClick: ()=>set('painCharacter')(form.painCharacter === p ? '' : p),
                                        children: t(`visit.subjective.pain.${p}`)
                                    }, p))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                                    label: t('visit.subjective.aggravating'),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        dir: "auto",
                                        value: form.aggravatingFactors,
                                        disabled: !editable,
                                        "aria-label": t('visit.subjective.aggravating'),
                                        onChange: (e)=>set('aggravatingFactors')(e.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                                    label: t('visit.subjective.relieving'),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        dir: "auto",
                                        value: form.relievingFactors,
                                        disabled: !editable,
                                        "aria-label": t('visit.subjective.relieving'),
                                        onChange: (e)=>set('relievingFactors')(e.target.value)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                            label: t('visit.subjective.dentalHistory'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                rows: 2,
                                dir: "auto",
                                value: form.dentalHistory,
                                disabled: !editable,
                                "aria-label": t('visit.subjective.dentalHistory'),
                                onChange: (e)=>set('dentalHistory')(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9eb3b027aeb752d3$var$Field, {
                            label: t('visit.subjective.notes'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                            ref: notesRef,
                                            rows: 2,
                                            dir: "auto",
                                            value: liveNotes ? form.notes ? `${form.notes} ${liveNotes}` : liveNotes : form.notes,
                                            disabled: !editable,
                                            readOnly: !!liveNotes,
                                            "aria-label": t('visit.subjective.notes'),
                                            onChange: (e)=>set('notes')(e.target.value)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67a78e1c740445b3$export$2e2bcd8739ae039), {
                                        continuous: true,
                                        disabled: !editable,
                                        label: t('visit.subjective.dictateNotes'),
                                        onInterim: setLiveNotes,
                                        onText: (text)=>set('notes')(form.notes ? `${form.notes} ${text}` : text)
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        marginTop: 16,
                        borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                        paddingTop: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                                marginBottom: 8,
                                fontSize: 11.5,
                                fontWeight: 800,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53cde9011dd49799$export$2e2bcd8739ae039), {
                                    size: 13,
                                    "aria-hidden": true
                                }),
                                t('visit.subjective.priorVisits')
                            ]
                        }),
                        priorVisits.loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$5a3d463a4d06f3eb), {
                            label: t('common.loading')
                        }) : priorVisits.visits.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                fontSize: 12,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                            },
                            children: t('visit.subjective.noPriorVisits')
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 6
                            },
                            children: priorVisits.visits.map((v)=>// A kit Button rather than a styled <button>: this is a row-
                                // sized tap target on a phone, and the kit is what guarantees
                                // the 2.75rem floor. `justify-start` because a Button centres
                                // by default and this is a line of text, not a label.
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    className: "min-h-11 w-full justify-start",
                                    onClick: ()=>onOpenPriorVisit(v.appointmentId),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            width: '100%',
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 12,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                    flexShrink: 0
                                                },
                                                children: v.dateTime ? formatDate(v.dateTime, 'numeric') : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 12.5,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                    flex: 1,
                                                    minWidth: 0,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    textAlign: 'start'
                                                },
                                                children: v.summary || t('visit.subjective.priorNoSummary')
                                            }),
                                            v.diagnosisCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                children: t('visit.subjective.priorDiagnoses', {
                                                    count: formatNumber(v.diagnosisCount)
                                                })
                                            })
                                        ]
                                    })
                                }, v.appointmentId))
                        })
                    ]
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fc88d8cf02c9ed12$export$a2387ed3b5d536eb = {
    name: "external-link",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 3h6v6",
                key: "1q9fwt"
            }
        ],
        [
            "path",
            {
                d: "M10 14 21 3",
                key: "gplh6r"
            }
        ],
        [
            "path",
            {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
                key: "a6xqqp"
            }
        ]
    ]
};
$fc88d8cf02c9ed12$export$a2387ed3b5d536eb.node;
const $fc88d8cf02c9ed12$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($fc88d8cf02c9ed12$export$a2387ed3b5d536eb);










var $acw62 = parcelRequire("acw62");







function $87e150cf6e48c386$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, onCreate: onCreate, saving: saving, t: t, clinicId: clinicId, initialName: // Prefilled from what the dentist was already doing: they pressed «خدمت
// جدید» because the list did not have what they were looking for.
initialName = '', currency: // The clinic's currency (an ISO code), or null when it is not known. Omitted
// is IRR — what this dialog was before currencies, byte for byte.
currency = (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e) }) {
    const { locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const known = currency != null;
    const isIrr = known && (0, $fcda591c8cd139a4$export$272b829bb65f9e96)(currency).code === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e);
    const unit = known ? (0, $ee13d5f9dccabef6$export$dc766bb5b31bee30)(currency, {
        t: t,
        locale: locale
    }) : null;
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        name: '',
        category: '',
        applicability: '',
        chartEffect: '',
        priceToman: '',
        durationMinutes: 30
    });
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Only after the dentist has left the field: an error on a form they have not
    // filled in yet is a telling-off, not help.
    const [touched, setTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Reset on every open, not on mount: the dialog is kept mounted by its
    // parent, so a stale draft would otherwise greet the next service.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        setForm({
            name: initialName,
            category: '',
            applicability: '',
            chartEffect: '',
            priceToman: '',
            durationMinutes: 30
        });
        setFailure(null);
        setTouched(false);
    }, [
        open,
        initialName
    ]);
    const set = (patch)=>setForm((f)=>({
                ...f,
                ...patch
            }));
    const submit = async ()=>{
        setFailure(null);
        const name = form.name.trim();
        if (!name) {
            setTouched(true);
            return;
        }
        // An empty field is «بدون تعرفه», not zero-because-unparseable: the dentist
        // saves the service now and the clinic prices it later. Anything typed that
        // is NOT a number is a mistake worth stopping on, because the alternative
        // is silently saving a service as free.
        // `parseAmount`, not a bare Number(): the app renders Persian numerals
        // everywhere and a dentist types «۵۰۰٬۰۰۰». For IRR it is exactly
        // `parseTomanToRial` (toman in, whole rials out); for any other currency it
        // is strict — at most the currency's own decimals, grouping in threes — so
        // «12.505» dirhams is refused rather than rounded into a price nobody typed.
        // The panel language says which mark is the decimal: a French or German
        // dentist types «12,50», which without it was refused for a dirham clinic.
        // For toman, which has no fraction a dentist types, `parseTariff` reads a
        // French «500,000» or German «500.000» as the half million typed and
        // refuses the ambiguous «12,5» rather than saving a price ten or a thousand
        // times off. fa and en parse exactly as before.
        const typed = known ? String(form.priceToman).trim() : '';
        const tariffRial = typed ? (0, $ee13d5f9dccabef6$export$164219e1848ce85d)(typed, currency, locale) : 0;
        if (!Number.isFinite(tariffRial) || tariffRial < 0) {
            setFailure({
                message: t('visit.plan.newService.badTariff', {
                    unit: unit
                })
            });
            return;
        }
        const err = await onCreate({
            name: name,
            category: form.category.trim() || null,
            applicability: form.applicability || null,
            chartEffect: form.chartEffect || null,
            // Whole minor units (whole rials for IRR). A half-toman entry rounds here
            // rather than being refused by the BFF with a message naming a unit
            // («ریال») the dentist never saw; any other currency is already whole.
            tariffRial: Math.round(tariffRial),
            durationMinutes: Math.max(1, Number(form.durationMinutes) || 30)
        });
        if (err) {
            setFailure(err);
            return;
        }
        onOpenChange(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            "data-testid": "new-service-dialog",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                            children: t('visit.plan.newService.title')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$94e94c2ec2c954d5), {
                            children: t('visit.plan.newService.subtitle')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12
                        },
                        children: [
                            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                variant: "error",
                                children: failure.message || t('visit.plan.newService.failed')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.plan.newService.name'),
                                "aria-label": t('visit.plan.newService.name'),
                                required: true,
                                dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(form.name),
                                value: form.name,
                                onChange: (e)=>set({
                                        name: e.target.value
                                    }),
                                // Said at the field rather than only by a disabled button: a save
                                // that does nothing and explains nothing is the worst of the three
                                // possible answers.
                                error: touched && !form.name.trim() ? t('visit.plan.newService.nameRequired') : '',
                                onBlur: ()=>setTouched(true)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        label: `${t('visit.plan.newService.category')} ${t('common.form.optional')}`,
                                        "aria-label": t('visit.plan.newService.category'),
                                        dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(form.category),
                                        value: form.category,
                                        onChange: (e)=>set({
                                                category: e.target.value
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                        label: `${t('visit.plan.newService.applicability')} ${t('common.form.optional')}`,
                                        "aria-label": t('visit.plan.newService.applicability'),
                                        placeholder: null,
                                        value: form.applicability,
                                        onChange: (e)=>set({
                                                applicability: e.target.value
                                            }),
                                        options: (0, $0cd549c1a257ae26$export$5c9d23f753d827d0)(t)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                        label: `${t('visit.plan.newService.chartEffect')} ${t('common.form.optional')}`,
                                        "aria-label": t('visit.plan.newService.chartEffect'),
                                        placeholder: null,
                                        value: form.chartEffect,
                                        onChange: (e)=>set({
                                                chartEffect: e.target.value
                                            }),
                                        options: (0, $0cd549c1a257ae26$export$a5a2a58e8e5d8a26)(t)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                    gap: 10
                                },
                                children: [
                                    known && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        label: `${t('visit.plan.newService.tariff', {
                                            unit: unit
                                        })} ${t('common.form.optional')}`,
                                        "aria-label": t('visit.plan.newService.tariff', {
                                            unit: unit
                                        }),
                                        dir: "ltr",
                                        inputMode: isIrr ? 'numeric' : 'decimal',
                                        value: form.priceToman,
                                        placeholder: t('visit.plan.noTariff'),
                                        onChange: (e)=>set({
                                                priceToman: e.target.value
                                            }),
                                        "data-testid": "new-service-tariff",
                                        "data-currency": currency
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                                        label: t('visit.plan.newService.duration'),
                                        "aria-label": t('visit.plan.newService.duration'),
                                        min: 1,
                                        value: form.durationMinutes,
                                        onChange: (e)=>set({
                                                durationMinutes: e.target.value
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    lineHeight: 1.8
                                },
                                children: known ? t('visit.plan.newService.tariffHint') : t('visit.plan.newService.currencyUnknown')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                                    borderRadius: 10,
                                    padding: '10px 12px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        children: t('visit.plan.newService.clinicOnly.title')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                            lineHeight: 1.8
                                        },
                                        children: t('visit.plan.newService.clinicOnly.body')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: (0, $d87bd335296b449f$export$656ea0803b1a2433)(clinicId),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        style: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 5,
                                            minHeight: 44,
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
                                        },
                                        children: [
                                            t('visit.plan.noServices.action'),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
                                                size: 13,
                                                "aria-hidden": true
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            className: "min-h-11",
                            onClick: submit,
                            disabled: saving || !form.name.trim(),
                            "data-testid": "new-service-save",
                            children: saving ? t('common.actions.saving') : t('visit.plan.newService.save')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            className: "min-h-11",
                            variant: "outline",
                            onClick: ()=>onOpenChange(false),
                            disabled: saving,
                            children: t('common.actions.cancel')
                        })
                    ]
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");






// «ثبت انجام» — the work, written down.
//
// ── The thing this app could not do ─────────────────────────────────────────
// A dentist could record what is WRONG with a tooth and what they PLAN to do
// about it, and had nowhere at all to say what they actually did. «انجام‌شده»
// on a plan line was the closest thing, and it is a status: no who, no when, no
// visit, no surfaces, no material, no note, and reversible without a trace.
// This form is the missing half, and it is why `done` left that menu.
//
// ── What it is NOT ──────────────────────────────────────────────────────────
// It is not the tooth editor. `ToothDrawer` states what IS TRUE of a tooth;
// this states what WAS DONE to it in this visit. They meet in exactly one
// place — «وضعیت دندان پس از درمان» below, which offers the chart change the
// treatment caused — and that offer is a proposal the dentist confirms, never
// something derived behind them. A screen that silently charted «MOD composite
// ⇒ three restored surfaces» would have the chart asserting what nobody looked
// at, and a dentist would find it there months later with no idea who said so.
//
// That block used to appear only when SURFACES were ticked, which is why a
// عصب‌کشی, a روکش and a کشیدن left the odontogram untouched: the work was
// recorded, billed and invisible on the one picture of the mouth. It now always
// appears for a treatment on a tooth, prefilled from what the catalogue says
// the service does.
//
// ── No money, anywhere ──────────────────────────────────────────────────────
// There is no amount on this form and none on the row it writes. The billable
// act is an order in clinicalencounter, and the record's `billingState` reports
// how far that separate write got. A field here would be a second, disagreeing
// opinion about what the patient owes, typed by whoever happened to be holding
// the mouse.
//
// ── One session, not a course ───────────────────────────────────────────────
// A three-session root canal is ONE plan line quoted at three (D6) and THREE
// records. «نتیجه» is what says which one finished it: تکمیل شد closes the
// line, ادامه در جلسهٔ بعد leaves it open for the next appointment. That is
// the whole of the session model, and why «جلسهٔ ۲ از ۳» is derived rather
// than stored.
/** The surfaces a tooth actually has — an incisor has I, a molar has O. */ const $d4cebdf56aea0eb3$var$surfaceCodes = (toothFdi)=>toothFdi ? (0, $789c06d5db9cfc3f$export$e8e69ffa6db2b2c2)(toothFdi) : [];
function $d4cebdf56aea0eb3$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, onRecord: onRecord, saving: saving, t: t, formatNumber: formatNumber, item: // The plan line being carried out. Never null: «ثبت انجام» is offered ON a
// line, and «ثبت درمانِ خارج از برنامه» — the one entry point that opened this
// without one — was removed as a control nobody used. Work that was not
// planned is recorded by adding the line and then recording it, which is one
// more press and one fewer way to end up with a treatment nothing quoted.
item, planId: // The COURSE that line belongs to. Separate from `item` because a plan item
// does not carry its own plan's id — the service returns them nested — and
// reading `item.planId` silently recorded every session against no plan at
// all, which is the one field that ties a record back to what was agreed.
planId, entry: // The catalogue entry behind that line — its name, and the performers the
// clinic named for it (D7).
entry, records: records = [] }) {
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        catalogId: '',
        serviceName: '',
        toothFdi: '',
        surfaces: '',
        material: '',
        note: '',
        outcome: 'completed',
        chartEffect: (0, $0cd549c1a257ae26$export$8604b736a60e0cc5)
    });
    // Whether the dentist has touched «وضعیت دندان پس از درمان» themselves. Once
    // they have, changing «نتیجه» must not overwrite their answer: the C4 rule
    // (a session that does not finish the work proposes nothing) is a DEFAULT,
    // and a default that keeps reasserting itself over a person is a control
    // that fights back.
    const [effectTouched, setEffectTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Reset on every OPEN — the dialog is kept mounted by its parent, so without
    // this the surfaces of the last tooth greet the next one.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!open) return;
        const sessions = item ? (0, $0cd549c1a257ae26$export$5d9a996a03bb93f5)(item, records) : null;
        setForm({
            catalogId: item?.catalogId || '',
            serviceName: '',
            toothFdi: item?.toothFdi || '',
            // What was QUOTED for this line, as the starting point. A dentist who
            // treated two of the three surfaces corrects it; one who treated all
            // three does not have to type them again.
            surfaces: item?.surfaces || '',
            material: '',
            note: '',
            // The last session of a course defaults to «تکمیل شد» and the ones before
            // it to «ادامه در جلسهٔ بعد» — which is what actually happens, and means
            // the common case needs no thought.
            outcome: sessions && sessions.done + 1 < sessions.quoted ? 'in_progress' : 'completed',
            // What the catalogue says this service does to the tooth — «عصب‌کشی مولر»
            // ⇒ عصب‌کشی‌شده. The form cannot work that out, and before the catalogue
            // carried it the only thing it could propose was a surface.
            chartEffect: (0, $0cd549c1a257ae26$export$26076c91f3335ba5)(entry, sessions && sessions.done + 1 < sessions.quoted ? 'in_progress' : 'completed')
        });
        setEffectTouched(false);
        setFailure(null);
    }, [
        open,
        item,
        entry,
        records
    ]);
    const set = (patch)=>setForm((f)=>({
                ...f,
                ...patch
            }));
    // «نتیجه» moves the proposal with it, until the dentist has answered it
    // themselves: a session that does not finish the work proposes nothing (C4),
    // and going back to «تکمیل شد» must bring the proposal back rather than
    // leaving a finished root canal unrecorded on the chart.
    const setOutcome = (outcome)=>setForm((f)=>({
                ...f,
                outcome: outcome,
                chartEffect: effectTouched ? f.chartEffect : (0, $0cd549c1a257ae26$export$26076c91f3335ba5)(entry, outcome)
            }));
    // The catalogue row behind the line, for its «کاربرد» snapshot.
    const chosen = entry || null;
    const codes = $d4cebdf56aea0eb3$var$surfaceCodes(form.toothFdi);
    const chosenSurfaces = new Set(String(form.surfaces || '').toUpperCase().split(''));
    const toggleSurface = (code)=>{
        const next = new Set(chosenSurfaces);
        if (next.has(code)) next.delete(code);
        else next.add(code);
        // Canonical ORDER, not tap order: the service normalises it anyway, and a
        // «DOM» on the screen that becomes «MDO» in the record reads as a bug.
        set({
            surfaces: codes.filter((c)=>next.has(c)).join('')
        });
    };
    // What the block would write, in the dentist's own words. Shown rather than
    // merely offered: «نمودار دندان هم به‌روز شود» told nobody WHAT it would say.
    const chartEvents = (0, $0cd549c1a257ae26$export$eb8ea8a7dc42e176)({
        toothFdi: form.toothFdi,
        surfaces: form.surfaces,
        material: form.material,
        effect: form.chartEffect
    });
    const effect = (0, $0cd549c1a257ae26$export$5bdb384b22eb31f0)(form.chartEffect);
    // A surface effect with nothing ticked writes nothing. Saying so is the
    // point: silence here is exactly what made this feature necessary.
    const effectWritesNothing = !!effect && chartEvents.length === 0;
    const effectLabel = (option)=>{
        const word = t(`tooth.value.${option.word}`);
        return option.layer === 'surface' ? t('visit.record.chartEffect.surfaceOption', {
            state: word
        }) : word;
    };
    const submit = async ()=>{
        setFailure(null);
        const { error: error } = await onRecord({
            planId: planId || null,
            planItemId: item?.id || null,
            catalogId: form.catalogId || item?.catalogId || null,
            // The SNAPSHOT of what was done, taken here because here is the only
            // place that has it: the service defaults nothing — it stores the name it
            // is given and accepts a catalog_id alone — so sending nothing wrote a
            // record that reads «اقدام بدون عنوان» for ever. The dentist's own
            // wording wins, then the plan line's, then the catalogue's.
            serviceName: form.serviceName.trim() || item?.description || entry?.name || null,
            applicability: chosen?.applicability || null,
            toothFdi: form.toothFdi || null,
            surfaces: form.surfaces || null,
            material: form.material || null,
            note: form.note.trim() || null,
            outcome: form.outcome,
            chartEvents: chartEvents
        });
        if (error) {
            setFailure(error);
            return;
        }
        onOpenChange(false);
    };
    const title = item?.description || t('visit.plan.untitledItem');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
            "data-testid": "treatment-record-dialog",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                            children: t('visit.record.title', {
                                treatment: title
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$94e94c2ec2c954d5), {
                            children: t('visit.record.subtitle')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$5d20f2c38fcde41f), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12
                        },
                        children: [
                            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                variant: "error",
                                children: failure.message || t('visit.record.failed')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                        label: t('visit.record.tooth'),
                                        "aria-label": t('visit.record.tooth'),
                                        dir: "ltr",
                                        inputMode: "numeric",
                                        value: form.toothFdi,
                                        placeholder: t('visit.plan.wholeMouthShort'),
                                        onChange: (e)=>set({
                                                toothFdi: e.target.value.replace(/\D/g, '').slice(0, 2)
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                        label: t('visit.record.outcome'),
                                        "aria-label": t('visit.record.outcome'),
                                        "data-testid": "record-outcome",
                                        value: form.outcome,
                                        placeholder: null,
                                        onChange: (e)=>setOutcome(e.target.value),
                                        options: [
                                            {
                                                value: 'completed',
                                                label: t('visit.record.outcome.completed')
                                            },
                                            {
                                                value: 'in_progress',
                                                label: t('visit.record.outcome.inProgress')
                                            }
                                        ]
                                    })
                                ]
                            }),
                            codes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            fontSize: 12.5,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                            marginBottom: 6
                                        },
                                        children: [
                                            t('visit.record.surfaces'),
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: t('common.form.optional')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 6,
                                            flexWrap: 'wrap'
                                        },
                                        "data-testid": "record-surfaces",
                                        children: codes.map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                                active: chosenSurfaces.has(code),
                                                onClick: ()=>toggleSurface(code),
                                                // M D F L O I is the notation itself, not a word to
                                                // translate — the tooth editor shows the same letters.
                                                "aria-label": code,
                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                    children: code
                                                })
                                            }, code))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: `${t('visit.record.material')} ${t('common.form.optional')}`,
                                "aria-label": t('visit.record.material'),
                                value: form.material,
                                placeholder: t('visit.record.noMaterial'),
                                onChange: (e)=>set({
                                        material: e.target.value
                                    }),
                                options: (0, $789c06d5db9cfc3f$export$b7815f33793b967).map((m)=>({
                                        value: m,
                                        label: t(`tooth.material.${m}`)
                                    }))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                label: `${t('visit.record.note')} ${t('common.form.optional')}`,
                                "aria-label": t('visit.record.note'),
                                rows: 2,
                                dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(form.note),
                                value: form.note,
                                placeholder: t('visit.record.notePlaceholder'),
                                onChange: (e)=>set({
                                        note: e.target.value
                                    })
                            }),
                            form.toothFdi && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                "data-testid": "record-chart-effect",
                                style: {
                                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                    borderRadius: 10,
                                    padding: '10px 12px',
                                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                        label: t('visit.record.chartEffect'),
                                        "aria-label": t('visit.record.chartEffect'),
                                        value: form.chartEffect,
                                        placeholder: null,
                                        onChange: (e)=>{
                                            setEffectTouched(true);
                                            set({
                                                chartEffect: e.target.value
                                            });
                                        },
                                        options: (0, $0cd549c1a257ae26$export$7e825e47d2291c85)(form.toothFdi).map((o)=>({
                                                value: o.value,
                                                label: o.layer === 'none' ? t('visit.record.chartEffect.none') : effectLabel(o)
                                            }))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 11.5,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                            marginTop: 6
                                        },
                                        children: !effect ? t('visit.record.chartEffect.noneDetail') : effectWritesNothing ? t('visit.record.chartEffect.needsSurfaces') : t(effect.layer === 'surface' ? 'visit.record.chartEffect.detailSurfaces' : 'visit.record.chartEffect.detail', {
                                            tooth: formatNumber(form.toothFdi),
                                            state: t(`tooth.value.${effect.value}`),
                                            surfaces: chartEvents.map((e)=>e.surface).filter(Boolean).join((0, $c53f9539af19d960$export$3004b7ed4244ef95)())
                                        })
                                    }),
                                    form.outcome === 'in_progress' && !effect && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 11.5,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                            marginTop: 4
                                        },
                                        children: t('visit.record.chartEffect.inProgress')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('visit.record.billingNote')
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$7bbfb2d443473050), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            className: "min-h-11",
                            variant: "outline",
                            onClick: ()=>onOpenChange(false),
                            disabled: saving,
                            children: t('common.actions.cancel')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            className: "min-h-11",
                            onClick: submit,
                            disabled: saving,
                            "data-testid": "record-save",
                            children: saving ? t('common.actions.saving') : t('visit.record.save')
                        })
                    ]
                })
            ]
        })
    });
}



// «پلن درمان» — the BOTTOM of the persistent column (§3.1.3).
//
//   "Integration: link treatments directly to specific teeth on the Odontogram"
//   "Workflow: supports adding planned procedures, surgeries, or follow-ups"
//   "Tracking: status tracking (Pending, Scheduled, Completed)"
//
// ── This is the DENTAL SERVICE's plan, not a second model of one ────────────
// طرح درمان already exists in this app's BFF: price-locked at approval,
// patient-signed, append-only. This section is a view onto it, and everything
// it does is one of the mutations that service already validates. A visit-local
// plan would be a second, unsigned quote that disagrees with the one the
// patient put their name to.
//
// ── No «تأیید و قفل مبلغ» ──────────────────────────────────────────────────
// The BFF still HAS `approveTreatmentPlan`, which locks a plan's amounts and
// freezes its document. This screen deliberately does not call it: the product
// owner's answer was that a dentist neither needs nor uses a signing step, and
// a button that is pressed by nobody is a button that teaches people to ignore
// buttons. `isPlanLocked` stays because a plan approved elsewhere must still
// render as read-only — what went is the way to CREATE that state from here.
//
// ── The status vocabulary ──────────────────────────────────────────────────
// §3.1.3 says "Pending, Scheduled, Completed". The service stores five states
// and they are the ones that get written; the mapping is documented in
// Visit.shared.js. Offering the document's three words verbatim would mean
// writing a status the service rejects.
const $bec031a053f3da13$var$STATUS_TONE = {
    proposed: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    accepted: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    },
    done: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    rejected: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    },
    deferred: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    }
};
const $bec031a053f3da13$var$PHASES = [
    'emergency',
    'phase1',
    'phase2',
    'maintenance'
];
function $bec031a053f3da13$export$2e2bcd8739ae039({ t: t, formatNumber: formatNumber, plans: plans, catalog: catalog, editable: editable, selectedTooth: selectedTooth, onSelectTooth: onSelectTooth, addRequestTooth: addRequestTooth, onAddRequestHandled: onAddRequestHandled, onChartChanged: /**
   * A recorded treatment wrote to the chart. The odontogram is a SEPARATE read
   * owned by the screen, so it has to be told — nothing else here can reach it.
   */ onChartChanged, clinicId: // Where «تعریف خدمات در پنل کلینیک» goes when this clinic has declared none.
clinicId, appointmentId: // THE VISIT a record is written against. Without it nothing here can record:
// a treatment belongs to the appointment it was done in, and the service
// requires one.
appointmentId, collapsible: // See VisitSubjective: the phone folds this section rather than wrapping it.
collapsible = false, defaultOpen: defaultOpen = true }) {
    const { plan: plan, loading: loading, error: error, saving: saving, addItem: addItem, removeItem: removeItem, setItemStatus: setItemStatus, createService: createService, catalogError: catalogError, reload: reload, records: records = [], recordTreatment: recordTreatment, voidRecord: voidRecord } = plans;
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const [adding, setAdding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        catalogId: '',
        toothFdi: '',
        phase: 'phase1',
        description: '',
        quantity: 1,
        surfaces: ''
    });
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // «خدمت جدید» — open when the list does not have what the dentist wants.
    const [definingService, setDefiningService] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // «ثبت انجام» — the plan line being recorded, or `{}` for «خارج از برنامه».
    // One piece of state rather than two: open-ness and which line are the same
    // question, and holding them apart is how a dialog opens on the last line.
    const [recording, setRecording] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // «ابطال» takes a reason the service requires, so it asks for one.
    const [voiding, setVoiding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [voidReason, setVoidReason] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // «وضعیت چارت هم باطل شود» — ticked, because a mistaken treatment usually
    // means a mistaken chart change. Not assumed, because it does not always: a
    // dentist voiding a BILLING duplicate has a tooth that really is crowned.
    const [voidChart, setVoidChart] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    // WHAT the last add put in the plan — its wording and tooth, never its id.
    // The service REPLACES items as a set and reissues ids on every write (see
    // addItem), so an id held across a save names a different line or none.
    const [justAdded, setJustAdded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // The odontogram's «افزودن به طرح درمان» opens this form with the tooth
    // already filled in — §3.1.3's "linked directly to specific teeth on the
    // Odontogram", driven from the chart rather than from a number field.
    //
    // AND BRINGS THE DENTIST TO IT. The chart, شرح حال and this section share one
    // scrolling column, so the form this opens is normally two sections below the
    // button that opened it — off-screen. Pressing «افزودن به طرح درمان» then
    // looked like it did nothing, and the tooth it prefilled was never seen.
    // Scrolling the form into view and focusing the one field the dentist must
    // still fill (the treatment — the button cannot know which) is what makes the
    // press legible as "this opened something".
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!addRequestTooth) return;
        setAdding(true);
        setDraft((d)=>({
                ...d,
                toothFdi: addRequestTooth
            }));
        setJustAdded(null);
        onAddRequestHandled();
    }, [
        addRequestTooth,
        onAddRequestHandled
    ]);
    const addFormRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const requested = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    requested.current = requested.current || !!addRequestTooth;
    // After the form has actually rendered, not in the same tick that asks for it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!adding || !requested.current || !addFormRef.current) return;
        requested.current = false;
        // Optional: scrollIntoView is absent in jsdom, and calling it unguarded
        // throws INSIDE the effect — which takes the focus below down with it and
        // leaves the dentist on a form that is neither scrolled to nor focused.
        // The scroll is the nicety here; the focus is the part that must not fail.
        addFormRef.current.scrollIntoView?.({
            behavior: 'smooth',
            block: 'center'
        });
        addFormRef.current.querySelector('select, input')?.focus();
    }, [
        adding
    ]);
    const locked = (0, $0cd549c1a257ae26$export$2fc3923f5055ac01)(plan);
    // A signed plan's LINES are frozen, but the dentist is not stuck: adding a
    // treatment starts a NEW course (useVisit's addItem). So «افزودن اقدام» stays
    // available on a locked plan — what it does changes, not whether it exists.
    // Removing a line and reordering remain refused, because those would edit the
    // signed document itself.
    const canEdit = editable && !locked;
    const canAdd = editable;
    // ── Money, in the currency it is counted in ────────────────────────────────
    // Every amount on the wire is minor units of a currency (whole rials for IRR),
    // and lib/money.js turns it into text: «۴٬۵۰۰٬۰۰۰ تومان» for IRR, exactly as
    // this screen always said it, «۱۲٫۵۰ AED» for a clinic whose books are in
    // dirhams. The PLAN's currency for its lines and total; an ENTRY's own for a
    // tariff in the picker. Never a conversion, and never two currencies summed.
    const { locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const money = (amount, currency)=>(0, $ee13d5f9dccabef6$export$a17b3c2052469c69)(amount, currency, {
            t: t,
            locale: locale
        });
    const { clinics: clinics } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const planCurrency = plan ? (0, $0cd549c1a257ae26$export$2971a96bcdab4d0f)(plan) : null;
    // What the clinic keeps its books in NOW — what a new line, a new course or
    // a new service is quoted in. Null when this screen cannot tell (see
    // clinicCurrencyFor): no guess, because an IRR guess on an AED clinic reads
    // dirhams as toman.
    const clinicCurrency = (0, $0cd549c1a257ae26$export$a2f1b1864a88d0bc)({
        clinicId: plan?.clinicId || clinicId,
        plan: plan,
        clinics: clinics,
        catalog: catalog
    });
    // The currency a picked service must be priced in to join the plan. An open,
    // unsigned plan's own; otherwise the line starts a new course (see addItem),
    // which is quoted in the clinic's current currency.
    const quoteCurrency = plan && !(0, $0cd549c1a257ae26$export$2fc3923f5055ac01)(plan) ? planCurrency : clinicCurrency;
    const clinicAppUrl = (0, $d87bd335296b449f$export$656ea0803b1a2433)(plan?.clinicId || clinicId);
    // A service whose dictionary row was RETIRED stays on the plans that already
    // quote it — a clinic mid-course cannot have its quotes stop working because
    // the dictionary was tidied — but it is not offered for a NEW line (D10).
    const offerable = catalog.filter((c)=>!c.archived);
    // The service being added, and therefore which fields the form should ask
    // for. «کاربرد» is a HINT: a service that says nothing keeps the old
    // behaviour exactly — ask for a tooth, let it be left blank.
    const chosen = catalog.find((c)=>c.id === draft.catalogId) || null;
    const asks = (0, $0cd549c1a257ae26$export$9cba27725f1ac46d)(chosen);
    const outstanding = (0, $0cd549c1a257ae26$export$2078a79d5d359959)(plan, catalog);
    const submit = async ()=>{
        setFailure(null);
        if (!draft.catalogId) return;
        const entry = catalog.find((c)=>c.id === draft.catalogId);
        // A service priced in another currency than the plan it would join is not
        // added: it could never be priced into it (approval refuses the whole plan),
        // and a line that silently reads «بدون تعرفه» would hide why.
        const fit = quoteCurrency ? (0, $0cd549c1a257ae26$export$11c05300a3da9053)(entry, quoteCurrency) : null;
        if (fit?.mismatch) {
            // Both named by ISO code: the entry's may be IRR, and «تومان» must not
            // appear on a plan counted in anything else.
            setFailure({
                message: t('visit.plan.otherCurrencyRefused', {
                    name: entry?.name || t('visit.plan.untitledItem'),
                    currency: fit.currency,
                    planCurrency: quoteCurrency
                })
            });
            return;
        }
        const err = await addItem({
            catalogId: draft.catalogId,
            // A whole-mouth service never carries a tooth, whatever is left in the
            // field from a previous pick: an invented tooth on a جرم‌گیری line ends
            // up on a document a patient signs.
            toothFdi: asks.tooth && draft.toothFdi || null,
            surfaces: asks.surfaces && draft.surfaces || null,
            phase: draft.phase,
            description: draft.description || entry?.name || null,
            // A three-session root canal is ONE line with quantity 3, not three
            // lines: the clinic's tariff is per session (D6).
            quantity: Math.max(1, Number(draft.quantity) || 1)
        });
        if (err) {
            setFailure(err);
            return;
        }
        // Say it landed, in BOTH registers: a toast for the dentist who is looking
        // somewhere else on the page (this form is often reached from the chart two
        // sections up), and a line that STAYS in the section for the one who is
        // looking right at it. A toast alone disappears; an inline line alone is
        // missed by whoever scrolled back to the odontogram.
        const what = draft.description || entry?.name || t('visit.plan.untitledItem');
        setJustAdded({
            description: what,
            toothFdi: draft.toothFdi || null
        });
        toast.success(draft.toothFdi ? t('visit.plan.addedForTooth', {
            what: what,
            fdi: formatNumber(draft.toothFdi)
        }) : t('visit.plan.added', {
            what: what
        }));
        setDraft({
            catalogId: '',
            toothFdi: '',
            phase: 'phase1',
            description: '',
            quantity: 1,
            surfaces: ''
        });
        setAdding(false);
    };
    const changeStatus = async (itemId, status)=>{
        setFailure(null);
        const err = await setItemStatus(itemId, status);
        if (err) setFailure(err);
    };
    const drop = async (itemId)=>{
        setFailure(null);
        const err = await removeItem(itemId);
        if (err) setFailure(err);
    };
    // What was done IN THIS VISIT — the audit view, voided rows included, because
    // a struck-out treatment is the row a dispute turns on.
    const visitRecords = (0, $0cd549c1a257ae26$export$37d161d3e5b5ff8b)(records, appointmentId);
    // Recording needs a visit to write against. Without one the buttons are not
    // rendered at all rather than rendered and refused: an action that cannot
    // work is not an action.
    const canRecord = editable && !!appointmentId && !!recordTreatment;
    const record = async (input)=>{
        setFailure(null);
        const result = await recordTreatment(input);
        if (!result?.error) {
            // A treatment may now write TOOTH EVENTS — «وضعیت دندان پس از درمان» —
            // and the chart above is a separate read that knows nothing about this
            // one. Without this, a dentist charts an extraction, sees the tooth still
            // standing, and charts it again by hand.
            //
            // Only when something was actually written: a جرم‌گیری changes no tooth,
            // and refetching the whole chart to learn that is a read for nothing.
            if (input.chartEvents?.length) onChartChanged?.();
            const what = input.serviceName || recording?.description || catalog.find((c)=>c.id === input.catalogId)?.name || t('visit.plan.untitledItem');
            // Two facts, and the second is the one a dentist cannot see from here:
            // recording a treatment is what puts its price on this visit's invoice
            // (D17). Saying so once, at the moment it happens, is how «why did the
            // patient's bill change?» stops being a question for the desk.
            const billed = result?.record?.billingState === 'billed';
            toast.success(billed ? `${t('visit.record.saved', {
                what: what
            })} ${t('visit.record.billed')}` : t('visit.record.saved', {
                what: what
            }));
        }
        return result;
    };
    const confirmVoid = async ()=>{
        const reason = voidReason.trim();
        if (!reason || !voiding) return;
        setFailure(null);
        // Only a treatment on a tooth can have changed one. Sending true for a
        // جرم‌گیری would be asking the service to undo something that never was.
        const alsoChart = !!voiding.toothFdi && voidChart;
        const { error: err, chargeReversed: chargeReversed } = await voidRecord(voiding.id, reason, alsoChart);
        if (err) setFailure(err);
        // The charge comes back on its own now; the one case worth a word is the
        // one where it did not, because then the desk still has to act.
        if (!err && chargeReversed === false) toast.warn(t('visit.record.voidCharge.notReversed'));
        // The arch is a separate read and has just been made wrong by this write —
        // the same reason a recorded treatment refetches it.
        if (!err && alsoChart) onChartChanged?.();
        setVoiding(null);
        setVoidReason('');
        setVoidChart(true);
    };
    /**
   * Define a service and select it, in one gesture.
   *
   * Selecting it is the point: the dentist opened this because the picker did
   * not have what they were looking for, and leaving them to find it in the
   * list afterwards is that same problem a second time.
   */ const defineService = async (input)=>{
        const { entry: entry, error: err } = await createService(input);
        if (err) return err;
        // A resolved call that answered nothing is not success. Without this the
        // next line throws inside the dialog's await, which leaves it open with no
        // message and an unhandled rejection in the console.
        if (!entry?.id) return new Error(t('visit.plan.newService.failed'));
        setDraft((d)=>({
                ...d,
                catalogId: entry.id
            }));
        toast.success(t('visit.plan.newService.created', {
            name: entry.name
        }));
        return null;
    };
    // This panel alone, in its own shape — plan-line rows with their tooth
    // chip and status pill — inside the real Panel (DESIGN.md §"Loading &
    // skeleton", region load).
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$2e18e55558453f28), {
        t: t,
        label: t('common.loading'),
        collapsible: collapsible,
        defaultOpen: defaultOpen
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.plan.title'),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            role: "alert",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('visit.plan.error.title'),
                description: (0, $0cd549c1a257ae26$export$1ebde7358daead69)(t, error) || t('visit.plan.error.body'),
                onRetry: reload,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    const items = plan?.items || [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
        title: t('visit.plan.title'),
        collapsible: collapsible,
        defaultOpen: defaultOpen,
        action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: 8
            },
            children: [
                locked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                    style: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 4,
                        fontSize: 11.5,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                            size: 13,
                            "aria-hidden": true
                        }),
                        t('visit.plan.locked')
                    ]
                }),
                outstanding.amount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: 11.5,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                    },
                    "data-testid": "plan-outstanding",
                    children: t('visit.plan.outstanding', {
                        amount: money(outstanding.amount, outstanding.currency)
                    })
                }),
                plan && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "outline",
                    children: (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.plan.planStatus', plan.status)
                }),
                canAdd && !adding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    className: "min-h-11",
                    variant: "outline",
                    onClick: ()=>setAdding(true),
                    children: locked ? t('visit.plan.startNew') : t('visit.plan.add')
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            "data-testid": "visit-plan",
            "data-state": items.length ? 'content' : 'empty',
            children: [
                failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    style: {
                        marginBottom: 12
                    },
                    children: (0, $0cd549c1a257ae26$export$1ebde7358daead69)(t, failure) || failure.message || t('visit.plan.saveFailed')
                }),
                locked && // Said out loud rather than left as missing buttons: the plan being
                // uneditable is a PROPERTY of a signed document, not a fault.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "info",
                    style: {
                        marginBottom: 12
                    },
                    children: [
                        t('visit.plan.lockedNote'),
                        " ",
                        t('visit.plan.lockedNextStep')
                    ]
                }),
                catalogError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    style: {
                        marginBottom: 12
                    },
                    "data-testid": "plan-catalog-error",
                    children: catalogError.kind === 'noClinic' ? t('visit.plan.noClinic') : t('visit.plan.catalogUnavailable')
                }) : catalog.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "warning",
                    style: {
                        marginBottom: 12
                    },
                    "data-testid": "plan-no-services",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontWeight: 700
                                },
                                children: t('visit.plan.noServices.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t('visit.plan.noServices.body')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                    flexWrap: 'wrap'
                                },
                                children: [
                                    clinicAppUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                        href: clinicAppUrl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        style: {
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 5,
                                            minHeight: 44,
                                            fontSize: 12.5,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
                                        },
                                        children: [
                                            t('visit.plan.noServices.action'),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
                                                size: 13,
                                                "aria-hidden": true
                                            })
                                        ]
                                    }),
                                    canAdd && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        className: "min-h-11",
                                        variant: "outline",
                                        onClick: ()=>setDefiningService(true),
                                        "data-testid": "plan-new-service-empty",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": true,
                                                style: {
                                                    marginInlineEnd: 4
                                                }
                                            }),
                                            t('visit.plan.newService.title')
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                justAdded && !adding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    role: "status",
                    "data-testid": "plan-just-added",
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 7,
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
                        border: `1px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good}`,
                        borderRadius: 8,
                        padding: '8px 10px',
                        marginBottom: 12,
                        fontSize: 12.5,
                        fontWeight: 700,
                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                            size: 15,
                            "aria-hidden": true,
                            style: {
                                flexShrink: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: justAdded.toothFdi ? t('visit.plan.addedForTooth', {
                                what: justAdded.description,
                                fdi: formatNumber(justAdded.toothFdi)
                            }) : t('visit.plan.added', {
                                what: justAdded.description
                            })
                        })
                    ]
                }),
                adding && canAdd && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    ref: addFormRef,
                    "data-testid": "plan-add-form",
                    style: {
                        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                        borderRadius: 10,
                        padding: 12,
                        marginBottom: 12,
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: 6,
                                        alignItems: 'flex-end'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                                label: t('visit.plan.service'),
                                                "aria-label": t('visit.plan.service'),
                                                placeholder: t('visit.plan.choose'),
                                                value: draft.catalogId,
                                                onChange: (e)=>setDraft((d)=>({
                                                            ...d,
                                                            catalogId: e.target.value
                                                        })),
                                                options: offerable.map((c)=>{
                                                    // The tariff is in the option itself. A dentist choosing
                                                    // between «کامپوزیت دو سطحی» and «سه سطحی» is choosing a
                                                    // price as much as a treatment, and making them add the line
                                                    // to find out is a quote written blind. «بدون تعرفه» is said
                                                    // out loud rather than shown as «۰ تومان», which would read
                                                    // as "this work is free".
                                                    //
                                                    // In the ENTRY's own currency — and a service priced in
                                                    // another currency than the plan it would join says so
                                                    // instead of showing a figure that cannot be added to it.
                                                    const price = (0, $0cd549c1a257ae26$export$11c05300a3da9053)(c, quoteCurrency ?? undefined);
                                                    let tail;
                                                    if (price.mismatch) tail = t('visit.plan.otherCurrency', {
                                                        currency: price.currency
                                                    });
                                                    else if (price.amount) tail = money(price.amount, price.currency);
                                                    else tail = t('visit.plan.noTariff');
                                                    return {
                                                        value: c.id,
                                                        label: `${c.name} \u{2014} ${tail}`
                                                    };
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            size: 44,
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83905746e46531b9$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            label: t('visit.plan.newService.title'),
                                            onClick: ()=>setDefiningService(true),
                                            "data-testid": "plan-new-service"
                                        })
                                    ]
                                }),
                                asks.tooth && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            gap: 6,
                                            alignItems: 'flex-end'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    flex: 1,
                                                    minWidth: 0
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                    label: t('visit.plan.tooth'),
                                                    dir: "ltr",
                                                    value: draft.toothFdi,
                                                    "aria-label": t('visit.plan.tooth'),
                                                    placeholder: t('visit.plan.wholeMouth'),
                                                    onChange: (e)=>setDraft((d)=>({
                                                                ...d,
                                                                toothFdi: e.target.value
                                                            }))
                                                })
                                            }),
                                            selectedTooth && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                variant: "subtle",
                                                className: "min-h-11",
                                                onClick: ()=>setDraft((d)=>({
                                                            ...d,
                                                            toothFdi: selectedTooth
                                                        })),
                                                children: formatNumber(selectedTooth)
                                            })
                                        ]
                                    })
                                }),
                                asks.surfaces && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('visit.plan.surfaces'),
                                    dir: "ltr",
                                    value: draft.surfaces,
                                    "aria-label": t('visit.plan.surfaces'),
                                    placeholder: "MOD",
                                    onChange: (e)=>setDraft((d)=>({
                                                ...d,
                                                surfaces: e.target.value.toUpperCase().replace(/[^MDFLOI]/g, '')
                                            }))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                                    label: t('visit.plan.sessions'),
                                    "aria-label": t('visit.plan.sessions'),
                                    min: 1,
                                    value: draft.quantity,
                                    onChange: (e)=>setDraft((d)=>({
                                                ...d,
                                                quantity: e.target.value
                                            }))
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                    label: t('visit.plan.phase'),
                                    "aria-label": t('visit.plan.phase'),
                                    placeholder: "",
                                    value: draft.phase,
                                    onChange: (e)=>setDraft((d)=>({
                                                ...d,
                                                phase: e.target.value
                                            })),
                                    options: $bec031a053f3da13$var$PHASES.map((p)=>({
                                            value: p,
                                            label: t(`visit.plan.phases.${p}`)
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                marginTop: 10
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(draft.description),
                                value: draft.description,
                                "aria-label": t('visit.plan.description'),
                                placeholder: t('visit.plan.description'),
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            description: e.target.value
                                        }))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: 8,
                                marginTop: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    className: "min-h-11",
                                    onClick: submit,
                                    disabled: saving || !draft.catalogId,
                                    children: saving ? t('common.actions.saving') : locked ? t('visit.plan.startNew') : t('visit.plan.addItem')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    className: "min-h-11",
                                    variant: "outline",
                                    onClick: ()=>setAdding(false),
                                    disabled: saving,
                                    children: t('common.actions.cancel')
                                })
                            ]
                        })
                    ]
                }),
                items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6fb6c94f3b917ca1$export$2e2bcd8739ae039), {
                        size: 40,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    }),
                    title: t('visit.plan.empty.title'),
                    description: t('visit.plan.empty.description')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8
                    },
                    children: items.map((item)=>{
                        const tone = $bec031a053f3da13$var$STATUS_TONE[item.status] || $bec031a053f3da13$var$STATUS_TONE.proposed;
                        // The locked amount once signed; the clinic's current tariff
                        // before that. Null is «بدون تعرفه» — a service the clinic has
                        // not priced, which is a state and not a gap — or a tariff in
                        // another currency than the plan's, which is never priced in.
                        const price = (0, $0cd549c1a257ae26$export$56006d7957c8727b)(item, catalog, {
                            locked: locked,
                            currency: planCurrency
                        });
                        const sessions = (0, $0cd549c1a257ae26$export$5d9a996a03bb93f5)(item, records);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            "data-testid": `plan-item-${item.id}`,
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 6,
                                border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                borderRadius: 10,
                                padding: '9px 11px',
                                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10
                                    },
                                    children: [
                                        item.toothFdi ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                            active: selectedTooth === item.toothFdi,
                                            onClick: ()=>onSelectTooth(item.toothFdi),
                                            title: t('visit.plan.showOnChart'),
                                            "aria-label": t('visit.plan.showOnChart'),
                                            className: "flex-none",
                                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                children: formatNumber(item.toothFdi)
                                            })
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontSize: 11,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                minWidth: 38,
                                                textAlign: 'center',
                                                flexShrink: 0
                                            },
                                            children: t('visit.plan.wholeMouthShort')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            "data-testid": `plan-item-name-${item.id}`,
                                            style: {
                                                flex: 1,
                                                minWidth: 0,
                                                fontSize: 13,
                                                fontWeight: 700,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: item.description || t('visit.plan.untitledItem')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            ...(0, $a278322405d51c25$export$3433559efc22d110),
                                            "data-testid": `plan-item-amount-${item.id}`,
                                            style: {
                                                fontSize: 12,
                                                fontWeight: price.amount ? 700 : 400,
                                                flexShrink: 0,
                                                color: price.amount ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
                                            },
                                            children: price.amount ? money(price.amount, price.currency) : price.mismatch ? t('visit.plan.otherCurrency', {
                                                currency: price.entryCurrency
                                            }) : t('visit.plan.noTariff')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0,
                                                fontSize: 11,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            },
                                            children: [
                                                (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.plan.phases', item.phase),
                                                item.surfaces ? ` \xb7 ${item.surfaces}` : '',
                                                sessions.multi ? ` \xb7 ${t('visit.plan.sessionsOf', {
                                                    done: formatNumber(sessions.done),
                                                    total: formatNumber(sessions.quoted)
                                                })}` : ''
                                            ]
                                        }),
                                        editable && !(0, $0cd549c1a257ae26$export$41d850810a86099c)(item.status) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                width: 138,
                                                flexShrink: 0
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                                value: item.status,
                                                placeholder: null,
                                                "aria-label": t('visit.plan.changeStatus', {
                                                    item: item.description || t('visit.plan.untitledItem')
                                                }),
                                                "data-testid": `plan-status-${item.id}`,
                                                onChange: (e)=>{
                                                    const next = e.target.value;
                                                    if (next && next !== item.status) changeStatus(item.id, next);
                                                },
                                                options: [
                                                    item.status,
                                                    ...(0, $0cd549c1a257ae26$export$8d9172732906836e)(item.status)
                                                ].map((v)=>({
                                                        value: v,
                                                        label: t(`visit.plan.status.${v}`)
                                                    }))
                                            })
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "data-testid": `plan-status-${item.id}`,
                                            style: {
                                                background: tone.bg,
                                                color: tone.ink,
                                                borderRadius: 8,
                                                padding: '3px 9px',
                                                fontSize: 11.5,
                                                fontWeight: 700,
                                                flexShrink: 0
                                            },
                                            children: (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.plan.status', item.status)
                                        }),
                                        canRecord && (0, $0cd549c1a257ae26$export$236c7cfabf06d283)(item, records) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            variant: "outline",
                                            className: "flex-none min-h-11",
                                            "data-testid": `plan-record-${item.id}`,
                                            onClick: ()=>setRecording(item),
                                            children: sessions.multi ? t('visit.record.openSession') : t('visit.record.open')
                                        }),
                                        canEdit && item.status !== 'done' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                            variant: "ghost",
                                            size: 44,
                                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            label: t('visit.plan.remove', {
                                                item: item.description || t('visit.plan.untitledItem')
                                            }),
                                            onClick: ()=>drop(item.id)
                                        })
                                    ]
                                })
                            ]
                        }, item.id);
                    })
                }),
                visitRecords.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        marginTop: 14
                    },
                    "data-testid": "visit-records",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 12,
                                fontWeight: 700,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                marginBottom: 8
                            },
                            children: t('visit.record.doneHere', {
                                count: formatNumber(visitRecords.length)
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 6
                            },
                            children: visitRecords.map((r)=>{
                                const struck = !!r.voidedAtMs;
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    "data-testid": `visit-record-${r.id}`,
                                    "data-state": struck ? 'voided' : 'live',
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 10,
                                        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                        borderRadius: 10,
                                        padding: '8px 11px',
                                        background: struck ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2 : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
                                        opacity: struck ? 0.75 : 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                                            size: 15,
                                            color: struck ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk,
                                            "aria-hidden": true,
                                            style: {
                                                flexShrink: 0
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontSize: 12,
                                                fontWeight: 700,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                minWidth: 34,
                                                textAlign: 'center',
                                                flexShrink: 0
                                            },
                                            children: r.toothFdi ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                children: formatNumber(r.toothFdi)
                                            }) : t('visit.plan.wholeMouthShort')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 12.5,
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                        textDecoration: struck ? 'line-through' : 'none',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap'
                                                    },
                                                    children: (0, $0cd549c1a257ae26$export$279093cb86d9c700)(r, catalog) || t('visit.plan.untitledItem')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                    },
                                                    children: [
                                                        r.surfaces || null,
                                                        r.material ? t(`tooth.material.${r.material}`) : null,
                                                        r.outcome === 'in_progress' ? t('visit.record.outcome.inProgress') : null,
                                                        // The reason a struck row was struck. Without it the
                                                        // strike-through says «this did not happen», which is
                                                        // exactly the claim a void does NOT make.
                                                        struck ? t('visit.record.voidedFor', {
                                                            reason: r.voidReason || "\u2014"
                                                        }) : null
                                                    ].filter(Boolean).join(" \xb7 ")
                                                })
                                            ]
                                        }),
                                        !struck && r.billingState === 'failed' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            "data-testid": `record-unbilled-${r.id}`,
                                            style: {
                                                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk,
                                                borderRadius: 8,
                                                padding: '3px 9px',
                                                fontSize: 11,
                                                fontWeight: 700,
                                                flexShrink: 0
                                            },
                                            children: t('visit.record.notBilled')
                                        }),
                                        canRecord && !struck && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            size: "sm",
                                            variant: "ghost",
                                            className: "flex-none min-h-11",
                                            "data-testid": `record-void-${r.id}`,
                                            onClick: ()=>{
                                                setVoiding(r);
                                                setVoidReason('');
                                            },
                                            children: t('visit.record.void')
                                        })
                                    ]
                                }, r.id);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4cebdf56aea0eb3$export$2e2bcd8739ae039), {
                    open: !!recording,
                    onOpenChange: (next)=>{
                        if (!next) setRecording(null);
                    },
                    onRecord: record,
                    saving: saving,
                    t: t,
                    formatNumber: formatNumber,
                    item: recording,
                    planId: plan?.id || null,
                    entry: catalog.find((c)=>c.id === recording?.catalogId) || null,
                    records: records
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                    open: !!voiding,
                    onOpenChange: (next)=>{
                        if (!next) {
                            setVoiding(null);
                            setVoidReason('');
                            setVoidChart(true);
                        }
                    },
                    title: t('visit.record.voidConfirm.title'),
                    description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                style: {
                                    margin: 0,
                                    fontSize: 13,
                                    lineHeight: 1.8,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                },
                                children: t('visit.record.voidConfirm.body', {
                                    what: (0, $0cd549c1a257ae26$export$279093cb86d9c700)(voiding, catalog) || t('visit.plan.untitledItem')
                                })
                            }),
                            voiding?.billingState === 'billed' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                variant: "warning",
                                "data-testid": "record-void-billing",
                                children: t('visit.record.voidConfirm.stillBilled')
                            }),
                            !!voiding?.toothFdi && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                                checked: voidChart,
                                onChange: (v)=>setVoidChart(!!v),
                                "data-testid": "record-void-chart",
                                label: t('visit.record.voidConfirm.alsoChart', {
                                    tooth: formatNumber(voiding.toothFdi)
                                })
                            })
                        ]
                    }),
                    confirmLabel: t('visit.record.void'),
                    cancelLabel: t('common.actions.cancel'),
                    confirmDisabled: !voidReason.trim(),
                    onConfirm: confirmVoid,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        "aria-label": t('visit.record.voidReason'),
                        placeholder: t('visit.record.voidReason'),
                        dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(voidReason),
                        value: voidReason,
                        "data-testid": "record-void-reason",
                        onChange: (e)=>setVoidReason(e.target.value)
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87e150cf6e48c386$export$2e2bcd8739ae039), {
                    open: definingService,
                    onOpenChange: setDefiningService,
                    onCreate: defineService,
                    saving: saving,
                    t: t,
                    clinicId: plan?.clinicId || clinicId,
                    // What the typed tariff is parsed in: the clinic's books' currency,
                    // which is what the BFF stores it as. Null (unknown) takes no tariff.
                    currency: clinicCurrency,
                    // What the dentist already typed as the line's شرح: they pressed
                    // «خدمت جدید» because the list did not have it, so the name they were
                    // reaching for is usually the one already in their hands.
                    initialName: draft.description
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");




function $8b9d79adaff552ef$export$2e2bcd8739ae039({ open: open, onOpenChange: onOpenChange, onConfirm: onConfirm, loading: loading, t: t, formatNumber: formatNumber, testId: // §15.1's selector contract is `{page}-{region}-{element}`, and only the
// CALLER knows which page it is on — so the two buttons' testids are props,
// exactly as the kit's ConfirmDialog takes them. The phone's suite selects on
// them; a confirm that can only be found by matching Persian copy is a test
// that breaks the next time the copy is rewritten.
testId, confirmTestId: confirmTestId, cancelTestId: cancelTestId, outstanding: // The lines this visit is about to leave undone. Empty ⇒ no question.
outstanding = [], interval: // The chosen interval key, owned by the caller so it survives a re-render
// while the mutation is in flight.
interval, onIntervalChange: onIntervalChange }) {
    const asks = outstanding.length > 0;
    // Reset to the default on every open: the dialog is kept mounted by the
    // screen, so last visit's «لازم نیست» would otherwise greet the next patient.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) onIntervalChange((0, $0cd549c1a257ae26$export$f61ae47d7ba2b859));
    }, [
        open,
        onIntervalChange
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        title: t('visit.finish.confirm.title'),
        description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 12
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    style: {
                        margin: 0,
                        fontSize: 13,
                        lineHeight: 1.8,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                    },
                    children: t('visit.finish.confirm.body')
                }),
                asks && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    "data-testid": "finish-follow-up",
                    style: {
                        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                        borderRadius: 10,
                        padding: '10px 12px',
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 6,
                                fontSize: 12.5,
                                fontWeight: 700,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87513a585d30c268$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true
                                }),
                                t('visit.finish.followUp.title', {
                                    count: formatNumber(outstanding.length)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                fontSize: 11.5,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                marginTop: 4
                            },
                            children: [
                                outstanding.slice(0, 3).map((item)=>item.toothFdi ? `${item.description || t('visit.plan.untitledItem')} \u{2014} ${t('visit.record.tooth')} ${formatNumber(item.toothFdi)}` : item.description || t('visit.plan.untitledItem')).join(" \xb7 "),
                                outstanding.length > 3 ? ` ${t('visit.finish.followUp.andMore', {
                                    count: formatNumber(outstanding.length - 3)
                                })}` : ''
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 12,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                margin: '10px 0 6px'
                            },
                            children: t('visit.finish.followUp.when')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            role: "group",
                            "aria-label": t('visit.finish.followUp.when'),
                            "data-testid": "finish-follow-up-intervals",
                            style: {
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 6
                            },
                            children: (0, $0cd549c1a257ae26$export$4b6ff696946acc8d).map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                    active: interval === i.key,
                                    onClick: ()=>onIntervalChange(i.key),
                                    "data-testid": `finish-follow-up-${i.key}`,
                                    label: t(`visit.finish.followUp.${i.key}`)
                                }, i.key))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                fontSize: 11,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                marginTop: 8
                            },
                            children: interval === 'none' ? t('visit.finish.followUp.noneNote') : t('visit.finish.followUp.deskNote')
                        })
                    ]
                })
            ]
        }),
        confirmLabel: t('visit.finish.action'),
        cancelLabel: t('common.actions.cancel'),
        loading: loading,
        onConfirm: onConfirm,
        "data-testid": testId || 'finish-visit-dialog',
        confirmTestId: confirmTestId,
        cancelTestId: cancelTestId
    });
}
function $8b9d79adaff552ef$export$f3c16bd6689f1c86(t, outcome) {
    switch(outcome){
        case 'raised':
        case 'refreshed':
            return t('visit.finish.done.followUpRaised');
        case 'already_booked':
            return t('visit.finish.done.alreadyBooked');
        // «unavailable» is NOT «nothing to do»: the prompt could not be raised and a
        // patient may have been dropped, so it says so rather than staying quiet.
        case 'unavailable':
            return t('visit.finish.done.followUpFailed');
        default:
            return t('visit.finish.done.plain');
    }
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $53b0597d7da6e50a$export$a2387ed3b5d536eb = {
    name: "sparkles",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
                key: "1s2grr"
            }
        ],
        [
            "path",
            {
                d: "M20 2v4",
                key: "1rf3ol"
            }
        ],
        [
            "path",
            {
                d: "M22 4h-4",
                key: "gwowj6"
            }
        ],
        [
            "circle",
            {
                cx: "4",
                cy: "20",
                r: "2",
                key: "6kqj1y"
            }
        ]
    ],
    aliases: [
        "stars"
    ]
};
$53b0597d7da6e50a$export$a2387ed3b5d536eb.node;
const $53b0597d7da6e50a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($53b0597d7da6e50a$export$a2387ed3b5d536eb);











async function $2ba9d4aa464da3d6$export$ca2e0df0499e4739(suggestion) {
    const name = String(suggestion?.name || '').trim();
    if (!name) return null;
    const key = name.toLowerCase();
    let match = null;
    try {
        const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $784c74a96a5b5460$export$e94eea18383a4188), {
            query: name,
            limit: 10
        });
        match = (data?.listDrugs || []).find((d)=>String(d.name || '').trim().toLowerCase() === key || String(d.genericName || '').trim().toLowerCase() === key) || null;
    } catch (err) {
        // A formulary outage is a suggestion the dentist keeps, not one they lose.
        console.warn('[meds] suggestion lookup failed:', err?.message);
    }
    const drug = match || {
        id: `sugg-med-${name}`,
        name: name,
        genericName: '',
        category: '',
        commonDosages: [],
        commonFrequencies: []
    };
    const item = (0, $d9b1b3bcd01f93df$export$12d3280041d352a5)(drug);
    return {
        ...item,
        dose: suggestion.dosage || item.dose,
        frequency: suggestion.frequency || item.frequency,
        duration: suggestion.duration || '',
        // The free-text note IS the dosing instruction the four fields cannot hold.
        // Dropping it would make «افزودن» quietly lose the only part of the advice
        // that is specific to this patient.
        note: suggestion.notes || ''
    };
}
const $2ba9d4aa464da3d6$var$RxRow = ({ item: item, onChange: onChange, onRemove: onRemove, t: t })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '10px 12px',
            marginBottom: 8,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    marginBottom: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                        size: 15,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: item.drug.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: [
                                    item.drug.genericName,
                                    item.drug.category
                                ].filter(Boolean).join(" \xb7 ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 44,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        label: t('prescription.item.remove', {
                            name: item.drug.name
                        }),
                        onClick: onRemove
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
                    gap: 8
                },
                children: [
                    'dose',
                    'frequency',
                    'duration',
                    'note'
                ].map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        label: t(`prescription.item.${field}`),
                        "aria-label": `${item.drug.name} \u{2014} ${t(`prescription.item.${field}`)}`,
                        dir: "auto",
                        value: item[field],
                        onChange: (e)=>onChange({
                                ...item,
                                [field]: e.target.value
                            })
                    }, field))
            })
        ]
    });
function $2ba9d4aa464da3d6$export$2e2bcd8739ae039({ visit: visit, patient: patient, editable: editable, medications: medications }) {
    const { t: t, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    // THE ONE PANE THAT FORKS ITS PRIMITIVES. نسخه already ships a phone-designed
    // picker and row (`MobileDrugSearch` opens a BottomSheet; `DrugCombobox` is an
    // absolutely-positioned popover that the mobile concept names as the wrong
    // pattern), and prescribing is the pane most likely to be used one-handed at
    // the chair. The BEHAVIOUR is identical — same `newRxItem`, same sweep, same
    // two-tap commit — only the controls differ, which is §1.1's rule exactly.
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const [items, setItems] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('idle');
    // Which suggestion is being looked up in the formulary. Per-name, so a
    // dentist pressing two in a row sees which one is working.
    const [addingSuggestion, setAddingSuggestion] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [sweep, setSweep] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        loading: false,
        result: null,
        failure: null
    });
    const patientId = visit?.patientId;
    const appointmentId = visit?.appointmentId;
    // A STRING, not an array: what the sweep depends on is WHICH drugs are on the
    // prescription, and a string compares by value across renders. Editing a dose
    // must not re-bill it.
    const idsKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $d9b1b3bcd01f93df$export$4fb019cf760083c0)(items).join('|'), [
        items
    ]);
    const sweepable = (0, $d9b1b3bcd01f93df$export$f285ed9dd1e8dd93)(items);
    // The sweep's OTHER inputs, as strings for the same reason. `patient` is a
    // fresh object on every `useVisit` reload, so depending on it directly
    // re-fires — and re-BILLS — a credit-costing call for a re-render that
    // changed nothing the rule engine reads.
    const conditionsKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $d9b1b3bcd01f93df$export$c44664437aa64527)(patient).join('|'), [
        patient
    ]);
    const allergiesKey = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $d9b1b3bcd01f93df$export$d6bd0f6236de0844)(patient).join('|'), [
        patient
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!patientId || !sweepable) {
            setSweep({
                loading: false,
                result: null,
                failure: null
            });
            return undefined;
        }
        let alive = true;
        setSweep((s)=>({
                ...s,
                loading: true
            }));
        const timer = setTimeout(()=>{
            (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $784c74a96a5b5460$export$9812972017b718e1), {
                medicationIds: idsKey.split('|').filter(Boolean),
                patientId: patientId,
                patientConditions: conditionsKey.split('|').filter(Boolean),
                patientAllergies: allergiesKey.split('|').filter(Boolean)
            }).then((data)=>{
                if (!alive) return;
                setSweep({
                    loading: false,
                    result: data?.checkDrugInteraction || null,
                    failure: null
                });
            }).catch((err)=>{
                if (!alive) return;
                setSweep({
                    loading: false,
                    result: null,
                    failure: (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'INSUFFICIENT_CREDITS' ? 'credits' : 'unavailable'
                });
            });
        }, (0, $784c74a96a5b5460$export$13552a2fc8f27ee4));
        return ()=>{
            alive = false;
            clearTimeout(timer);
        };
    }, [
        idsKey,
        patientId,
        conditionsKey,
        allergiesKey,
        sweepable
    ]);
    const { suggestions: suggestions, suggesting: suggesting, suggestError: suggestError, suggest: suggest, clearSuggestions: clearSuggestions } = medications || {};
    // A suggestion enters the نسخه as an ORDINARY ROW — same shape, same fields,
    // same ثبت. It is not a second kind of prescription, and once it is in the
    // list the dentist edits it like any other; the only difference is that its
    // drug had to be looked up first so the interaction sweep can see it.
    const addSuggested = async (suggestion)=>{
        if (addingSuggestion) return;
        setAddingSuggestion(suggestion.name);
        try {
            const item = await $2ba9d4aa464da3d6$export$ca2e0df0499e4739(suggestion);
            if (!item) return;
            setItems((prev)=>prev.some((i)=>i.drug.name === item.drug.name) ? prev : [
                    ...prev,
                    item
                ]);
            setPhase('idle');
        } finally{
            setAddingSuggestion(null);
        }
    };
    const addDrug = (drug)=>{
        setItems((prev)=>prev.some((i)=>i.drug.id === drug.id) ? prev : [
                ...prev,
                (0, $d9b1b3bcd01f93df$export$12d3280041d352a5)(drug)
            ]);
        setPhase('idle');
    };
    const updateItem = (next)=>{
        setItems((prev)=>prev.map((i)=>i.key === next.key ? next : i));
        setPhase('idle');
    };
    const removeItem = (key)=>{
        setItems((prev)=>prev.filter((i)=>i.key !== key));
        setPhase('idle');
    };
    const save = async ()=>{
        if (phase === 'idle') {
            // A prescription is a clinical write: two deliberate clicks, not one
            // stray one. The same two-step نسخه uses.
            setPhase('confirm');
            return;
        }
        if (phase !== 'confirm') return;
        setPhase('saving');
        // allSettled, not a chain: a row the service rejects must not silently
        // discard the rows after it, and the dentist has to be told how many landed.
        const results = await Promise.allSettled(items.map((item)=>(0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $784c74a96a5b5460$export$5fcaf1729c987f4d), {
                patientId: patientId,
                input: (0, $d9b1b3bcd01f93df$export$7baebe32bddaafc7)(item, {
                    appointmentId: appointmentId
                })
            })));
        const ok = results.filter((r)=>r.status === 'fulfilled').length;
        if (ok === items.length) {
            toast.success(t('prescription.saved'));
            setItems([]);
            setPhase('idle');
            // Re-read rather than appending locally: the panes are conditionally
            // mounted, so a locally-kept list is blanked by switching tabs and back
            // while the rows exist server-side — and a fabricated id cannot later
            // address the row it stands for.
            medications?.reload?.();
            return;
        }
        if (ok === 0) toast.error(t('prescription.saveFailed'));
        else toast.warn(t('prescription.savePartial', {
            saved: ok,
            total: items.length
        }));
        setPhase('idle');
    };
    // Server-backed, so switching to دستورات and back does not blank it — and so
    // each row carries the id the platform actually stored.
    const thisVisit = medications?.medications || [];
    const warnings = (0, $d9b1b3bcd01f93df$export$888cb547d3ca3da3)(sweep.result?.warnings);
    const allergies = patient?.allergies || [];
    // نسخه's own phase→label map, imported rather than re-typed as a ternary: the
    // two surfaces must ask twice in the same words, and `tests/i18n.test.js`
    // pins every phase this function can return.
    const saveLabel = t((0, $784c74a96a5b5460$export$b104048e15014e11)(phase));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "visit-meds",
        "data-state": items.length ? 'content' : 'empty',
        children: [
            allergies.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                    size: 15
                }),
                title: t('prescription.allergies.title'),
                style: {
                    marginBottom: 12
                },
                children: allergies.map((a)=>a.allergen).filter(Boolean).join(" \xb7 ")
            }),
            editable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginBottom: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12,
                            fontWeight: 700,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            marginBottom: 6
                        },
                        children: t('prescription.search.label')
                    }),
                    isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3adb0369e9474c71$export$2e2bcd8739ae039), {
                        onAdd: addDrug
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90ca997a9e629c7f$export$2e2bcd8739ae039), {
                        onAdd: addDrug
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            marginTop: 10,
                            flexWrap: 'wrap'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            className: "min-h-11",
                            variant: "outline",
                            onClick: suggest,
                            disabled: suggesting || !suggest,
                            "data-testid": "visit-meds-suggest",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": true,
                                    style: {
                                        marginInlineEnd: 5
                                    }
                                }),
                                suggesting ? t('visit.meds.suggesting') : t('visit.meds.suggest')
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 6
                        },
                        children: t('visit.ai.costsCredits')
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                style: {
                    marginBottom: 12
                },
                children: t('visit.readOnly.note')
            }),
            suggestError === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                title: t('errors.credits.title'),
                style: {
                    marginBottom: 12
                },
                children: t('errors.credits.body')
            }),
            suggestError === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                style: {
                    marginBottom: 12
                },
                children: t('visit.meds.suggestUnavailable')
            }),
            suggestions && !suggestError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginBottom: 14
                },
                "data-testid": "visit-meds-suggestions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            marginBottom: 8,
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true
                            }),
                            t('visit.meds.suggestions'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: 44,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
                                    size: 13
                                }),
                                label: t('visit.meds.suggestClose'),
                                onClick: clearSuggestions,
                                style: {
                                    marginInlineStart: 'auto'
                                }
                            })
                        ]
                    }),
                    suggestions.items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('visit.meds.noSuggestions')
                    }) : suggestions.items.map((m)=>{
                        const taken = items.some((i)=>i.drug.name === m.name) || thisVisit.some((row)=>(row.display || '').trim() === m.name.trim());
                        const dosing = [
                            m.dosage,
                            m.frequency,
                            m.duration
                        ].filter(Boolean).join(" \xb7 ");
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                border: `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                borderRadius: 10,
                                padding: '9px 11px',
                                marginBottom: 8,
                                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                                            size: 15,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    dir: "auto",
                                                    children: m.name
                                                }),
                                                dosing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                    },
                                                    dir: "auto",
                                                    children: dosing
                                                })
                                            ]
                                        }),
                                        editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            className: "min-h-11",
                                            variant: "subtle",
                                            onClick: ()=>addSuggested(m),
                                            disabled: taken || !!addingSuggestion,
                                            "data-testid": `visit-meds-suggest-add-${m.name}`,
                                            children: taken ? t('visit.meds.suggestAdded') : addingSuggestion === m.name ? t('common.actions.saving') : t('visit.meds.suggestAdd')
                                        })
                                    ]
                                }),
                                m.notes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        marginTop: 6,
                                        lineHeight: 1.8
                                    },
                                    dir: "auto",
                                    children: m.notes
                                })
                            ]
                        }, m.name);
                    }),
                    suggestions.followUpTimeline && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            marginTop: 4
                        },
                        dir: "auto",
                        children: [
                            t('visit.meds.followUp'),
                            " ",
                            suggestions.followUpTimeline
                        ]
                    })
                ]
            }),
            items.map((item)=>isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8f5e248cd39c6fd8$export$2e2bcd8739ae039), {
                    item: item,
                    onChange: updateItem,
                    onRemove: ()=>removeItem(item.key),
                    testId: `visit-rx-${item.key}`
                }, item.key) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2ba9d4aa464da3d6$var$RxRow, {
                    item: item,
                    t: t,
                    onChange: updateItem,
                    onRemove: ()=>removeItem(item.key)
                }, item.key)),
            items.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "aria-live": "polite",
                        "aria-busy": sweep.loading || undefined,
                        style: {
                            marginBottom: 12
                        },
                        children: [
                            sweep.loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31e8de2f297417a1$export$7f7cbe89f1eacd2), {
                                        size: 15
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 12,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('prescription.interactions.checking')
                                    })
                                ]
                            }),
                            !sweep.loading && sweep.failure === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                variant: "info",
                                title: t('errors.credits.title'),
                                children: t('errors.credits.body')
                            }),
                            !sweep.loading && sweep.failure === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('prescription.interactions.unavailable')
                            }),
                            !sweepable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: t('prescription.interactions.needsTwo')
                            }),
                            !sweep.loading && !sweep.failure && sweepable && warnings.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                                },
                                children: t('prescription.interactions.none')
                            }),
                            warnings.map((w, i)=>{
                                const sev = (0, $d9b1b3bcd01f93df$export$6eaaad838274d902)(w.severity);
                                const tint = (0, $784c74a96a5b5460$export$3c798937e9154a7c)[sev];
                                const typeKey = (0, $d9b1b3bcd01f93df$export$b10d321a5bcb675d)(w.warningType);
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        background: tint.bg,
                                        color: tint.ink,
                                        borderRadius: 9,
                                        padding: '9px 11px',
                                        marginBottom: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 11.5,
                                                fontWeight: 800,
                                                marginBottom: 3
                                            },
                                            children: [
                                                t(`prescription.interactions.severity.${sev}`),
                                                typeKey && ` \xb7 ${t(`prescription.interactions.type.${typeKey}`)}`
                                            ]
                                        }),
                                        w.drugPair && // The PAIR is the actionable half of an interaction
                                        // warning: "moderate" without naming which two drugs is
                                        // not something a dentist can act on. LTR — these are Latin
                                        // slugs inside an RTL line.
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            dir: "ltr",
                                            style: {
                                                unicodeBidi: 'isolate',
                                                fontSize: 11,
                                                marginBottom: 3
                                            },
                                            children: w.drugPair
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 12.5,
                                                lineHeight: 1.8
                                            },
                                            children: w.description
                                        })
                                    ]
                                }, `${w.drugPair || w.drug || 'w'}-${i}`);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        className: "min-h-11",
                        onClick: save,
                        disabled: phase === 'saving',
                        children: saveLabel
                    })
                ]
            }),
            items.length === 0 && thisVisit.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ffe798f65d504e7$export$2e2bcd8739ae039), {
                    size: 40,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('visit.meds.empty.title'),
                description: t('visit.meds.empty.description')
            }),
            thisVisit.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            marginBottom: 6
                        },
                        children: t('visit.meds.thisVisit')
                    }),
                    thisVisit.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                fontSize: 12.5,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                marginBottom: 4
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    children: m.display
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: (0, $0cd549c1a257ae26$export$a446afe38fa74cae)(m)
                                })
                            ]
                        }, m.id))
                ]
            }),
            (patient?.medications || []).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 14,
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    paddingTop: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            marginBottom: 6
                        },
                        children: t('visit.meds.current')
                    }),
                    (patient.medications || []).slice(0, 10).map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                marginBottom: 6
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: m.display
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 11,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    children: m.authoredOn ? t('patient.history.prescribedOn', {
                                        date: formatDate(m.authoredOn, 'numeric')
                                    }) : ''
                                })
                            ]
                        }, m.id))
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5935de03d6f5e9ca$export$a2387ed3b5d536eb = {
    name: "microscope",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M6 18h8",
                key: "1borvv"
            }
        ],
        [
            "path",
            {
                d: "M3 22h18",
                key: "8prr45"
            }
        ],
        [
            "path",
            {
                d: "M14 22a7 7 0 1 0 0-14h-1",
                key: "1jwaiy"
            }
        ],
        [
            "path",
            {
                d: "M9 14h2",
                key: "197e7h"
            }
        ],
        [
            "path",
            {
                d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z",
                key: "1bmzmy"
            }
        ],
        [
            "path",
            {
                d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3",
                key: "1drr47"
            }
        ]
    ]
};
$5935de03d6f5e9ca$export$a2387ed3b5d536eb.node;
const $5935de03d6f5e9ca$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5935de03d6f5e9ca$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6828da86e4d4e8df$export$a2387ed3b5d536eb = {
    name: "scan",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 7V5a2 2 0 0 1 2-2h2",
                key: "aa7l1z"
            }
        ],
        [
            "path",
            {
                d: "M17 3h2a2 2 0 0 1 2 2v2",
                key: "4qcy5o"
            }
        ],
        [
            "path",
            {
                d: "M21 17v2a2 2 0 0 1-2 2h-2",
                key: "6vwrx8"
            }
        ],
        [
            "path",
            {
                d: "M7 21H5a2 2 0 0 1-2-2v-2",
                key: "ioqczr"
            }
        ]
    ]
};
$6828da86e4d4e8df$export$a2387ed3b5d536eb.node;
const $6828da86e4d4e8df$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6828da86e4d4e8df$export$a2387ed3b5d536eb);





// §3.2.2 — دستورات.
//
//   "Constraint: Scope restricted to Dental workflows."
//   "Laboratory Orders: Dental-specific lab requests."
//   "Dental Imaging Orders: X-rays, OPG, CBCT, etc."
//   "Note: Exclude general medical orders unless specific clinical exceptions
//    are defined."
//
// The exclusion is enforced in the BFF, not here: `dentalOrderCatalog` serves a
// curated dental list plus the clinic's OWN declared rows, and `createVisitOrder`
// refuses any order type but lab and imaging. This pane could not offer a CBC
// even if it tried, which is the right place for that rule — a client-side
// filter is a suggestion.
//
// ── The shape of the form is نسخه's, deliberately ──────────────────────────
// §4: "Do not reinvent interaction patterns. If the Doctor App uses a specific
// pattern for Adding a Medication, use that exact pattern for Adding a Dental
// Order." So: pick from a catalogue, fill in the qualifiers beside it, commit
// explicitly. Type tabs first because a dentist knows whether they are sending
// a lab case or asking for a film before they know which one.
const $3c0611acc345baf3$var$TYPE_ICON = {
    imaging: (0, $6828da86e4d4e8df$export$2e2bcd8739ae039),
    dental_lab: (0, $5935de03d6f5e9ca$export$2e2bcd8739ae039),
    lab: (0, $5935de03d6f5e9ca$export$2e2bcd8739ae039)
};
const $3c0611acc345baf3$var$STATUS_TONE = {
    pending: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    in_progress: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
    },
    completed: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    cancelled: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    }
};
/** Which transitions the service will accept from a given status. */ const $3c0611acc345baf3$var$TRANSITIONS = {
    pending: [
        'start',
        'cancel'
    ],
    in_progress: [
        'complete'
    ],
    completed: [],
    cancelled: []
};
function $3c0611acc345baf3$export$2e2bcd8739ae039({ orders: orders, editable: editable }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { orders: rows, catalog: catalog, loading: loading, error: error, saving: saving, create: create, setStatus: setStatus, reload: reload, suggestions: suggestions, suggesting: suggesting, suggestError: suggestError, suggest: suggest, clearSuggestions: clearSuggestions } = orders;
    const [type, setType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('imaging');
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        catalogId: '',
        description: '',
        urgency: 'routine',
        notes: '',
        sessionCount: ''
    });
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Which suggestion is mid-write. Per-key rather than a boolean: a dentist who
    // presses two in a row must see which one is being filed.
    const [addingKey, setAddingKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const forType = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>catalog.filter((c)=>c.orderType === type), [
        catalog,
        type
    ]);
    const chosen = forType.find((c)=>c.id === draft.catalogId) || null;
    const submit = async ()=>{
        setFailure(null);
        // The catalogue entry's name IS the description unless the dentist wrote
        // one: an order that reads «رادیوگرافی پانورامیک (OPG)» is what a radiology
        // unit needs, and making them retype it is how it ends up blank.
        const description = draft.description.trim() || chosen?.name || '';
        if (!description) return;
        const sessions = Number(draft.sessionCount);
        const err = await create({
            orderType: type,
            description: description,
            catalogId: draft.catalogId || null,
            urgency: draft.urgency,
            notes: draft.notes || null,
            code: chosen?.code || null,
            sessionCount: Number.isFinite(sessions) && sessions > 0 ? sessions : null
        });
        if (err) {
            setFailure(err);
            return;
        }
        setDraft({
            catalogId: '',
            description: '',
            urgency: 'routine',
            notes: '',
            sessionCount: ''
        });
    };
    // A suggestion becomes an order through the SAME mutation the form calls,
    // with the catalogue row's own values — the BFF matched the name to this
    // clinic's dental catalogue, so `catalogId` is real and accounting can settle
    // against it. The AI's Persian reason rides along as the order's note: it is
    // what tells the radiology unit which tooth, and dropping it would leave the
    // lab a bare «روکش».
    const addSuggested = async (item)=>{
        if (addingKey) return;
        setFailure(null);
        setAddingKey(item.key);
        const err = await create({
            orderType: item.orderType,
            description: item.name,
            catalogId: item.catalogId,
            urgency: item.urgency,
            notes: item.reason || null,
            code: item.code || null,
            sessionCount: null
        });
        if (err) setFailure(err);
        setAddingKey(null);
    };
    const move = async (orderId, transition)=>{
        setFailure(null);
        const err = await setStatus(orderId, transition);
        if (err) setFailure(err);
    };
    // The pane's own shape — the type chips, the add form, the order rows —
    // never a centred spinner (DESIGN.md §"Loading & skeleton").
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$aea4c0e3e752a659), {
        label: t('common.loading')
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "alert",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('visit.orders.error.title'),
            description: t('visit.orders.error.body'),
            onRetry: reload,
            retryLabel: t('common.actions.retry')
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "visit-orders",
        "data-state": rows.length ? 'content' : 'empty',
        children: [
            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                style: {
                    marginBottom: 12
                },
                children: failure.message || t('visit.orders.saveFailed')
            }),
            editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    padding: 12,
                    marginBottom: 14,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        id: "visit-orders-type-label",
                        className: "select-none",
                        style: {
                            display: 'block',
                            marginBottom: 6,
                            fontSize: 11.5,
                            fontWeight: 600,
                            letterSpacing: '0.01em',
                            lineHeight: 1,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: t('visit.orders.type')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "group",
                        "aria-labelledby": "visit-orders-type-label",
                        style: {
                            display: 'flex',
                            gap: 6,
                            marginBottom: 10
                        },
                        children: (0, $0cd549c1a257ae26$export$7fe249ad93dcc233).map((ty)=>{
                            const Icon = $3c0611acc345baf3$var$TYPE_ICON[ty];
                            const active = type === ty;
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                active: active,
                                onClick: ()=>{
                                    setType(ty);
                                    setDraft((d)=>({
                                            ...d,
                                            catalogId: ''
                                        }));
                                },
                                className: active ? 'bg-navy text-white border-navy hover:bg-navy-dark shadow-sm' : 'text-foreground',
                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 6
                                    },
                                    children: [
                                        active ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                                            size: 14,
                                            "aria-hidden": true,
                                            strokeWidth: 3
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 14,
                                            "aria-hidden": true
                                        }),
                                        t(`visit.orders.types.${ty}`)
                                    ]
                                })
                            }, ty);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.orders.service'),
                                "aria-label": t('visit.orders.service'),
                                helperText: t('visit.orders.serviceScope', {
                                    type: (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.orders.types', type)
                                }),
                                placeholder: t('visit.orders.choose'),
                                value: draft.catalogId,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            catalogId: e.target.value
                                        })),
                                options: forType.map((c)=>({
                                        // A clinic's own row is marked, because only one of the two
                                        // lists is theirs to get corrected.
                                        label: c.source === 'clinic' ? `${c.name} \u{2605}` : c.name,
                                        value: c.id
                                    }))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.orders.urgency'),
                                "aria-label": t('visit.orders.urgency'),
                                placeholder: "",
                                value: draft.urgency,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            urgency: e.target.value
                                        })),
                                options: (0, $0cd549c1a257ae26$export$c9b31a4acc93d37d).map((u)=>({
                                        value: u,
                                        label: t(`visit.orders.urgencies.${u}`)
                                    }))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.orders.sessions'),
                                "aria-label": t('visit.orders.sessions'),
                                type: "number",
                                min: 1,
                                dir: "auto",
                                value: draft.sessionCount,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            sessionCount: e.target.value
                                        }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                            label: t('visit.orders.description'),
                            "aria-label": t('visit.orders.description'),
                            dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(draft.description),
                            value: draft.description,
                            placeholder: chosen?.name || t('visit.orders.descriptionHint'),
                            onChange: (e)=>setDraft((d)=>({
                                        ...d,
                                        description: e.target.value
                                    }))
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                            label: t('visit.orders.notes'),
                            "aria-label": t('visit.orders.notes'),
                            rows: 2,
                            dir: "auto",
                            value: draft.notes,
                            onChange: (e)=>setDraft((d)=>({
                                        ...d,
                                        notes: e.target.value
                                    }))
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            marginTop: 10,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                onClick: submit,
                                disabled: saving || !draft.catalogId && !draft.description.trim(),
                                children: saving ? t('common.actions.saving') : t('visit.orders.add')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                variant: "outline",
                                onClick: suggest,
                                disabled: suggesting,
                                "data-testid": "visit-orders-suggest",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true,
                                        style: {
                                            marginInlineEnd: 5
                                        }
                                    }),
                                    suggesting ? t('visit.orders.suggesting') : t('visit.orders.suggest')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 6
                        },
                        children: t('visit.ai.costsCredits')
                    })
                ]
            }),
            !editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                style: {
                    marginBottom: 12
                },
                children: t('visit.readOnly.note')
            }),
            suggestError === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                title: t('errors.credits.title'),
                style: {
                    marginBottom: 12
                },
                children: t('errors.credits.body')
            }),
            suggestError === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                style: {
                    marginBottom: 12
                },
                children: t('visit.orders.suggestUnavailable')
            }),
            suggestions && !suggestError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginBottom: 14
                },
                "data-testid": "visit-orders-suggestions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            marginBottom: 8,
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true
                            }),
                            t('visit.orders.suggestions'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                variant: "ghost",
                                size: 44,
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
                                    size: 13
                                }),
                                label: t('visit.orders.suggestClose'),
                                onClick: clearSuggestions,
                                style: {
                                    marginInlineStart: 'auto'
                                }
                            })
                        ]
                    }),
                    suggestions.rationale && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            lineHeight: 1.9,
                            marginBottom: 8
                        },
                        dir: "auto",
                        children: suggestions.rationale
                    }),
                    suggestions.items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('visit.orders.noSuggestions')
                    }) : suggestions.items.map((item)=>{
                        const Icon = $3c0611acc345baf3$var$TYPE_ICON[item.orderType] || (0, $3f35c50d66e81764$export$2e2bcd8739ae039);
                        // Already on this visit — computed from the ORDERS THEMSELVES rather
                        // than from a local "added" set, so it survives the reload after a
                        // write and is still right when the same order was filed by hand.
                        const taken = rows.some((o)=>(o.description || '').trim() === item.name.trim());
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                border: `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                borderRadius: 10,
                                padding: '9px 11px',
                                marginBottom: 8,
                                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 15,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    children: item.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                    },
                                                    children: [
                                                        (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.orders.types', item.orderType),
                                                        item.category ? ` \xb7 ${item.category}` : '',
                                                        ` \xb7 ${(0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.orders.urgencies', item.urgency)}`
                                                    ]
                                                })
                                            ]
                                        }),
                                        editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            className: "min-h-11",
                                            variant: "subtle",
                                            onClick: ()=>addSuggested(item),
                                            disabled: taken || !!addingKey,
                                            "data-testid": `visit-order-suggest-add-${item.key}`,
                                            children: taken ? t('visit.orders.suggestAdded') : addingKey === item.key ? t('common.actions.saving') : t('visit.orders.suggestAdd')
                                        })
                                    ]
                                }),
                                item.reason && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        marginTop: 6,
                                        lineHeight: 1.8
                                    },
                                    dir: "auto",
                                    children: item.reason
                                })
                            ]
                        }, item.key);
                    }),
                    suggestions.droppedCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 4
                        },
                        children: t('visit.orders.suggestDropped', {
                            count: formatNumber(suggestions.droppedCount)
                        })
                    })
                ]
            }),
            rows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f35c50d66e81764$export$2e2bcd8739ae039), {
                    size: 40,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('visit.orders.empty.title'),
                description: t('visit.orders.empty.description')
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: rows.map((o)=>{
                    const Icon = $3c0611acc345baf3$var$TYPE_ICON[o.orderType] || (0, $3f35c50d66e81764$export$2e2bcd8739ae039);
                    const tone = $3c0611acc345baf3$var$STATUS_TONE[o.status] || $3c0611acc345baf3$var$STATUS_TONE.pending;
                    const moves = $3c0611acc345baf3$var$TRANSITIONS[o.status] || [];
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            borderRadius: 10,
                            padding: '10px 12px',
                            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                        size: 15,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            flex: 1,
                                            minWidth: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 13,
                                                    fontWeight: 700,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                },
                                                children: o.description
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    fontSize: 11,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: [
                                                    (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.orders.types', o.orderType),
                                                    o.urgency ? ` \xb7 ${(0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.orders.urgencies', o.urgency)}` : '',
                                                    o.sessionCount > 0 ? ` \xb7 ${t('visit.orders.sessionCount', {
                                                        count: formatNumber(o.sessionCount)
                                                    })}` : '',
                                                    o.createdAt ? ` \xb7 ${formatDate(o.createdAt, 'numeric')}` : ''
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            background: tone.bg,
                                            color: tone.ink,
                                            borderRadius: 8,
                                            padding: '3px 9px',
                                            fontSize: 11.5,
                                            fontWeight: 700,
                                            flexShrink: 0
                                        },
                                        children: (0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.orders.statuses', o.status)
                                    })
                                ]
                            }),
                            o.notes && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                    marginTop: 6,
                                    lineHeight: 1.8
                                },
                                children: o.notes
                            }),
                            editable && moves.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 6,
                                    marginTop: 8
                                },
                                children: moves.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        className: "min-h-11",
                                        variant: m === 'cancel' ? 'outline' : 'subtle',
                                        disabled: saving,
                                        onClick: ()=>move(o.id, m),
                                        children: t(`visit.orders.transitions.${m}`)
                                    }, m))
                            })
                        ]
                    }, o.id);
                })
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ffa913da585dd100$export$a2387ed3b5d536eb = {
    name: "message-square",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
                key: "18887p"
            }
        ]
    ]
};
$ffa913da585dd100$export$a2387ed3b5d536eb.node;
const $ffa913da585dd100$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($ffa913da585dd100$export$a2387ed3b5d536eb);








// §3.2.3 — تشخیص.
//
//   "Data Derivation: subjective feedback · patient history · uploaded
//    medical/dental imaging (AI-assisted analysis)."
//   "Traceability: Every diagnosis entry must support click-to-reveal
//    functionality to show the supporting clinical data used to derive it."
//
// ── Traceability is the whole point of this pane ───────────────────────────
// A diagnosis is stored WITH its evidence: `VisitDiagnosis.evidence` is a list
// of {kind, detail, ref} written in the same row, in the same call, as the
// diagnosis itself (the BFF puts it in the condition's `meta`, because there is
// no evidence column and inventing one downstream is a migration this repo does
// not own). So the reveal shows what was actually recorded — not a
// reconstruction assembled at read time from whatever happens to be nearby now.
//
// The distinction matters because a reconstruction changes: a note edited next
// week would silently rewrite the basis of a diagnosis made today.
//
// ── AI is a SUGGESTION and never a record ──────────────────────────────────
// `differential` and `diagnoses` are separate lists and are drawn separately.
// Nothing is written until the dentist accepts a suggestion, at which point its
// `supportingEvidence` becomes the recorded evidence and `aiAssisted` is set —
// so the record says where it came from.
//
// The differential COSTS PARSINA CREDITS and is fired only from the button.
const $28a017da747dbd19$var$EVIDENCE_ICON = {
    subjective: (0, $ffa913da585dd100$export$2e2bcd8739ae039),
    history: (0, $df9771111904a5d5$export$2e2bcd8739ae039),
    chart: (0, $411fdacea3d25f13$export$2e2bcd8739ae039),
    file: (0, $df9771111904a5d5$export$2e2bcd8739ae039),
    order: (0, $3f35c50d66e81764$export$2e2bcd8739ae039),
    ai: (0, $53b0597d7da6e50a$export$2e2bcd8739ae039)
};
const $28a017da747dbd19$var$CONFIDENCE_TONE = {
    high: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
    },
    medium: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnSoft,
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
    },
    low: {
        bg: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
        ink: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
    }
};
// The closed set clinicalencounter enforces (ALLOWED_VERIFICATION_STATUSES + a DB
// CHECK). There is deliberately no third value: an accepted AI suggestion is a
// working diagnosis (`provisional`) and `aiAssisted` carries where it came from.
const $28a017da747dbd19$var$VERIFICATION = [
    'provisional',
    'confirmed'
];
/** One recorded diagnosis, with its evidence behind a disclosure. */ function $28a017da747dbd19$var$DiagnosisRow({ d: d, t: t, formatDate: formatDate, editable: editable, onRemove: onRemove, onRevealRef: onRevealRef }) {
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const bodyId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            marginBottom: 8,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '9px 11px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 13,
                                            fontWeight: 700,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        children: d.display
                                    }),
                                    d.code && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            fontSize: 11,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                                        children: d.code
                                    }),
                                    d.aiAssisted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                                size: 10,
                                                "aria-hidden": true,
                                                style: {
                                                    marginInlineEnd: 3
                                                }
                                            }),
                                            t('visit.diagnosis.aiAssisted')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: [
                                    d.verificationStatus ? t(`visit.diagnosis.verification.${d.verificationStatus}`) : '',
                                    d.createdAt ? ` \xb7 ${formatDate(d.createdAt, 'numeric')}` : ''
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        className: "min-h-11 flex-none",
                        "aria-expanded": open,
                        "aria-controls": bodyId,
                        onClick: ()=>setOpen((o)=>!o),
                        children: [
                            t('visit.diagnosis.evidence', {
                                count: d.evidence.length
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true,
                                style: {
                                    marginInlineStart: 4,
                                    transform: open ? 'rotate(180deg)' : 'none',
                                    transition: 'transform .15s'
                                }
                            })
                        ]
                    }),
                    editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 44,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        label: t('visit.diagnosis.remove', {
                            name: d.display
                        }),
                        onClick: ()=>onRemove(d.id)
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                id: bodyId,
                style: {
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                    padding: '9px 11px'
                },
                children: d.evidence.length === 0 ? // Honest rather than fabricated. A diagnosis recorded before the
                // trail existed, or typed by someone who did not itemise their
                // reasoning, has no evidence — and saying so is the truthful answer.
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontSize: 12,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                    },
                    children: t('visit.diagnosis.noEvidence')
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    style: {
                        margin: 0,
                        padding: 0,
                        listStyle: 'none'
                    },
                    children: d.evidence.map((e, i)=>{
                        const Icon = $28a017da747dbd19$var$EVIDENCE_ICON[e.kind] || (0, $df9771111904a5d5$export$2e2bcd8739ae039);
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            style: {
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: 7,
                                fontSize: 12.5,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                lineHeight: 1.8,
                                marginBottom: 5
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                    size: 13,
                                    "aria-hidden": true,
                                    style: {
                                        marginTop: 3,
                                        flexShrink: 0
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        flex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                            style: {
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                            },
                                            children: [
                                                t(`visit.diagnosis.evidenceKind.${e.kind}`),
                                                t('common.punct.colon')
                                            ]
                                        }),
                                        ' ',
                                        e.detail
                                    ]
                                }),
                                e.kind === 'chart' && e.ref && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    className: "min-h-11",
                                    variant: "subtle",
                                    onClick: ()=>onRevealRef(e),
                                    children: t('visit.diagnosis.showTooth')
                                })
                            ]
                        }, `${e.kind}-${i}`);
                    })
                })
            })
        ]
    });
}
/** The panel's own order for drawing the sections a draft proposes. */ const $28a017da747dbd19$var$SOAP_SECTION_ORDER = [
    's',
    'o',
    'a',
    'p'
];
/**
 * The chart vocabulary in the dentist's language, falling back to the raw
 * value. The dental service's vocabulary is open at the edges (a clinic may
 * stock a material nobody else does), so an unknown key must still render as
 * something readable rather than as a blank row.
 */ const $28a017da747dbd19$var$label = (t, kind, value)=>{
    if (!value) return '';
    const key = `tooth.${kind}.${value}`;
    const out = t(key);
    return out === key ? value : out;
};
/**
 * یافته‌های دندان‌ها — the per-tooth facts the assistant read out of the
 * narrative, each one a proposal for چارت دندان.
 *
 * This is the third thing one «تکمیل…» produces, and the only one that writes
 * somewhere other than the note. It follows the same suggestion-vs-record line
 * the rest of this pane draws: NOTHING is charted until the dentist ticks it
 * and presses «ثبت در چارت دندان».
 *
 * LOW CONFIDENCE STARTS UNTICKED. The model's hard problem is Persian anatomy
 * → FDI («آسیای اول پایین راست» → 46), and the failure that matters is a
 * finding filed against the WRONG TOOTH — invisible in the chart afterwards,
 * because a charted tooth looks the same whoever put it there. So a row the
 * model inferred rather than heard cannot be recorded by pressing the default
 * action; the dentist has to tick it deliberately.
 */ function $28a017da747dbd19$var$ToothFindings({ findings: findings, error: error, chart: chart, onDismiss: onDismiss }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const rows = findings?.findings || [];
    // Keyed by index: the same tooth can legitimately carry two findings from one
    // narrative (a crown AND a fracture on 23), so nothing here is unique by FDI.
    const [ticked, setTicked] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>new Set());
    const [recording, setRecording] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [recorded, setRecorded] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Re-arm for each new read: a fresh set of findings must not inherit the
    // previous run's ticks, and must not still be showing the old confirmation.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setTicked(new Set(rows.map((f, i)=>f.confidence === 'high' ? i : -1).filter((i)=>i >= 0)));
        setRecorded(false);
        setFailure(false);
    }, [
        findings
    ]);
    if (error === 'unavailable') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
        variant: "warning",
        style: {
            marginTop: 10
        },
        children: t('visit.soap.teeth.unavailable')
    });
    if (!findings || error) return null;
    if (!rows.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            fontSize: 11.5,
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
            marginTop: 10
        },
        children: t('visit.soap.teeth.none')
    });
    const toggle = (i)=>setTicked((prev)=>{
            const next = new Set(prev);
            if (next.has(i)) next.delete(i);
            else next.add(i);
            return next;
        });
    const commit = async ()=>{
        const events = [
            ...ticked
        ].sort((a, b)=>a - b).map((i)=>(0, $0cd549c1a257ae26$export$20ae66bdf902993)(rows[i])).filter(Boolean);
        if (!events.length) return;
        setFailure(false);
        setRecording(true);
        try {
            // ONE batch, because recordToothEvents is all-or-nothing: three findings
            // confirmed together are one clinical act, and committing the valid half
            // would leave a chart the dentist never saw.
            const err = await chart.record(events);
            if (err) {
                setFailure(true);
                return;
            }
            setRecorded(true);
        } finally{
            setRecording(false);
        }
    };
    const anyLow = rows.some((f)=>f.confidence !== 'high');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "soap-tooth-findings",
        style: {
            border: `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '10px 12px',
            marginTop: 10,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    marginBottom: 4,
                    fontSize: 11.5,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $411fdacea3d25f13$export$2e2bcd8739ae039), {
                        size: 13,
                        "aria-hidden": true
                    }),
                    t('visit.soap.teeth.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    lineHeight: 1.8,
                    marginBottom: 8
                },
                children: t('visit.soap.teeth.description')
            }),
            recorded ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "status",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 7,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good}`,
                    borderRadius: 8,
                    padding: '7px 10px',
                    marginBottom: 9,
                    fontSize: 12.5,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                        size: 15,
                        "aria-hidden": true,
                        style: {
                            flexShrink: 0
                        }
                    }),
                    t('visit.soap.teeth.recorded')
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "error",
                        style: {
                            marginBottom: 8
                        },
                        children: t('visit.soap.teeth.recordFailed')
                    }),
                    anyLow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk,
                            marginBottom: 8,
                            lineHeight: 1.7
                        },
                        children: t('visit.soap.teeth.lowConfidenceHint')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                },
                children: rows.map((f, i)=>{
                    const on = ticked.has(i);
                    return(// The kit's Checkbox, whose `label` takes a NODE and wraps the
                    // whole row in its own <label> — so the row is the tap target
                    // (2.75rem on a phone) without a hand-rolled control.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                        checked: on,
                        disabled: recorded || recording,
                        onChange: ()=>toggle(i),
                        className: "min-h-11 items-start",
                        "data-testid": "tooth-finding-row",
                        "data-state": on ? 'checked' : 'unchecked',
                        style: {
                            border: `1px solid ${on ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            background: on ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                            borderRadius: 8,
                            padding: '8px 10px'
                        },
                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            style: {
                                display: 'block',
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        flexWrap: 'wrap',
                                        fontSize: 12.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            ...(0, $a278322405d51c25$export$3433559efc22d110),
                                            style: {
                                                fontWeight: 800
                                            },
                                            children: t('visit.soap.teeth.tooth', {
                                                fdi: formatNumber(f.toothFdi)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: $28a017da747dbd19$var$label(t, 'value', f.value)
                                        }),
                                        f.aspect === 'surface' && f.surface && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            children: t('visit.soap.teeth.surface', {
                                                surface: f.surface
                                            })
                                        }),
                                        f.material && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            children: $28a017da747dbd19$var$label(t, 'material', f.material)
                                        }),
                                        f.isHistorical && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            children: t('visit.soap.teeth.historical')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontSize: 11,
                                                color: f.confidence === 'high' ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk
                                            },
                                            children: t(`visit.soap.teeth.confidence.${f.confidence}`)
                                        })
                                    ]
                                }),
                                f.evidence && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        display: 'block',
                                        fontSize: 11.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        lineHeight: 1.7,
                                        marginTop: 3
                                    },
                                    children: [
                                        "\xab",
                                        f.evidence,
                                        "\xbb"
                                    ]
                                })
                            ]
                        })
                    }, `${f.toothFdi}-${f.aspect}-${f.surface || ''}-${i}`));
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: 8,
                    marginTop: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    !recorded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        className: "min-h-11",
                        onClick: commit,
                        disabled: recording || chart?.saving || ticked.size === 0,
                        children: recording ? t('visit.soap.teeth.recording') : t('visit.soap.teeth.record', {
                            count: formatNumber(ticked.size)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        className: "min-h-11",
                        variant: "outline",
                        onClick: onDismiss,
                        disabled: recording,
                        children: t('visit.soap.dismiss')
                    })
                ]
            })
        ]
    });
}
/**
 * دستیار شرح حال — the doctor app's SOAP flow, on dental terms.
 *
 * The dentist TALKS. There is no typed narrative any more — 2026-08-26 removed
 * the textarea and the «تکمیل شرح حال و دریافت توصیه» button both, because the
 * flow they described was three presses for one intention: dictate, watch the
 * box fill, then press a second button to send what was just said. Now one
 * labelled voice button is the whole input: while it records the words stream
 * in as a read-only preview, and the moment the final transcript arrives the
 * analysis fires BY ITSELF — pressing stop IS pressing تکمیل, and the stop
 * button's own label says so («پایان و دریافت توصیه»).
 *
 * Two things follow from auto-firing, and both are guarded here:
 *   * AN EMPTY TRANSCRIPT MUST NOT ANALYSE. All three analysis calls bill
 *     credits; a silent recording already cost its transcription minute, and
 *     auto-sending its empty result would buy three refusals on top.
 *   * A FAILURE MUST NOT COST THE SPEECH. With no box holding the narrative, a
 *     transient refine failure would otherwise mean dictating the whole visit
 *     again — so the heard transcript is kept and «ارسال دوباره» resends it
 *     without a second recording (or a second transcription charge).
 *
 * Two things come back — a draft of the note's sections, and the assistant's
 * advice. Neither writes anything: the draft lands in شرح حال بیمار only
 * through «اعمال», and a suggested diagnosis becomes a record only through
 * «ثبت» — the same suggestion-vs-record line the differential below draws.
 *
 * S IS NEVER REPLACED. The dental subjective is structured (شکایت اصلی، شدت
 * درد، دندان‌ها…) and a prose merge cannot round-trip it, so the S section
 * contributes only its additions, appended under یادداشت — exactly how پرسش‌ها
 * records a confirmed finding. O/A/P are replaced wholesale: nothing else in
 * this app writes those three fields.
 */ function $28a017da747dbd19$var$SoapAssistant({ soap: soap, note: note, chart: chart, alreadyRecorded: alreadyRecorded, saving: saving, onRecord: onRecord }) {
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { analyzing: analyzing, draft: draft, advice: advice, findings: findings, refineError: refineError, adviceError: adviceError, findingsError: findingsError, analyze: analyze, clearDraft: clearDraft, clearAdvice: clearAdvice, clearFindings: clearFindings } = soap;
    // `live` is the words the transcription stream has produced for a session
    // that is still running — a read-only preview, since there is nothing
    // editable for them to land in any more. `heard` is the final transcript of
    // the last session: what the analysis was fired with, kept so a failed
    // analysis can be resent without making the dentist dictate the visit again.
    const [live, setLive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [heard, setHeard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [applying, setApplying] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [applied, setApplied] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const changedSections = (draft?.sections || []).filter((s)=>s.changed).sort((a, b)=>$28a017da747dbd19$var$SOAP_SECTION_ORDER.indexOf(a.section) - $28a017da747dbd19$var$SOAP_SECTION_ORDER.indexOf(b.section));
    /** The stop press, one step later: the final transcript IS the submission. */ const run = (text)=>{
        const clean = (text || '').trim();
        // A silent recording produces no final text and VoiceDictateButton never
        // calls onText — this guard is for `run(heard)` from «ارسال دوباره» and
        // for defence in depth: analysis bills three times, silence must not.
        if (!clean) return;
        setHeard(clean);
        setApplied(false);
        setFailure(null);
        analyze(clean);
    };
    const apply = async ()=>{
        setFailure(null);
        setApplying(true);
        try {
            const patch = (0, $0cd549c1a257ae26$export$5eaa45fb4b6fc44b)(draft, note?.note?.dental?.notes || '');
            const err = await note.save(patch);
            if (err) {
                setFailure(err);
                return;
            }
            setApplied(true);
            clearDraft();
        } finally{
            setApplying(false);
        }
    };
    const recordSuggested = async ()=>{
        setFailure(null);
        const err = await onRecord({
            code: advice.icdCodes?.[0]?.code || '',
            display: advice.suggestedDiagnosis,
            verificationStatus: 'provisional',
            evidence: [
                // The assistant's own account of what it reasoned from — the summary
                // is the trail, the same way a differential's supportingEvidence is.
                {
                    kind: 'ai',
                    detail: t('visit.soap.aiEvidence'),
                    ref: null
                },
                ...advice.summary ? [
                    {
                        kind: 'ai',
                        detail: advice.summary.split('\n')[0],
                        ref: null
                    }
                ] : []
            ],
            aiAssisted: true
        });
        if (err) setFailure(err);
    };
    const dxTaken = advice?.suggestedDiagnosis && alreadyRecorded.has(advice.suggestedDiagnosis.trim());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "soap-assistant",
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: 12,
            marginBottom: 14,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    marginBottom: 4,
                    fontSize: 12,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                        size: 13,
                        "aria-hidden": true
                    }),
                    t('visit.soap.title')
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    lineHeight: 1.8,
                    marginBottom: 8
                },
                children: t('visit.soap.description')
            }),
            (0, $34c7ebd088df533e$export$e772b07b28ae7108)() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $67a78e1c740445b3$export$2e2bcd8739ae039), {
                        continuous: true,
                        appearance: "wide",
                        disabled: analyzing,
                        label: t('visit.soap.speak'),
                        stopLabel: t('visit.soap.speakStop'),
                        onInterim: setLive,
                        onText: run
                    }),
                    analyzing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        role: "status",
                        "aria-live": "polite",
                        "data-testid": "soap-analyzing",
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3365fede8cd1121a$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true,
                                className: "animate-spin"
                            }),
                            t('visit.soap.analyzing')
                        ]
                    })
                ]
            }) : // The mic beside شکایت اصلی hides itself where dictation cannot work,
            // because typing carries that field either way. Here dictation IS the
            // feature, so its absence has to be said rather than shown as an
            // inexplicably empty panel.
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: t('visit.soap.voiceUnavailable')
            }),
            !!live && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                "data-testid": "soap-live-transcript",
                dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(live),
                style: {
                    marginTop: 8,
                    padding: '8px 10px',
                    borderRadius: 8,
                    border: `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface1,
                    fontSize: 12.5,
                    lineHeight: 1.9,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: live
            }),
            !!heard && !live && (analyzing || refineError || adviceError) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "soap-heard",
                dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(heard),
                style: {
                    marginTop: 8,
                    padding: '8px 10px',
                    borderRadius: 8,
                    border: `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface1,
                    fontSize: 12.5,
                    lineHeight: 1.9,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontWeight: 700,
                            marginInlineEnd: 6
                        },
                        children: t('visit.soap.heard')
                    }),
                    heard,
                    !analyzing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginTop: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            className: "min-h-11",
                            variant: "outline",
                            onClick: ()=>run(heard),
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                    size: 13,
                                    "aria-hidden": true,
                                    style: {
                                        marginInlineEnd: 5
                                    }
                                }),
                                t('visit.soap.retry')
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    marginTop: 6
                },
                children: t('visit.ai.costsCredits')
            }),
            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                style: {
                    marginTop: 10
                },
                children: failure.message || t('visit.soap.applyFailed')
            }),
            (refineError === 'credits' || adviceError === 'credits') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                title: t('errors.credits.title'),
                style: {
                    marginTop: 10
                },
                children: t('errors.credits.body')
            }),
            refineError === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                style: {
                    marginTop: 10
                },
                children: t('visit.soap.refineUnavailable')
            }),
            applied && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "success",
                style: {
                    marginTop: 10
                },
                children: t('visit.soap.applied')
            }),
            draft && !refineError && (changedSections.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    marginTop: 10
                },
                children: t('visit.soap.noNews')
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "soap-draft",
                style: {
                    border: `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    padding: '10px 12px',
                    marginTop: 10,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            marginBottom: 6
                        },
                        children: t('visit.soap.draftTitle')
                    }),
                    changedSections.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                marginBottom: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                        marginBottom: 2
                                    },
                                    children: t(`visit.soap.sections.${s.section}`)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        lineHeight: 1.9,
                                        whiteSpace: 'pre-wrap'
                                    },
                                    children: s.text
                                }),
                                s.additions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        marginTop: 3,
                                        fontSize: 12,
                                        lineHeight: 1.8
                                    },
                                    children: s.additions.map((a, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                                            },
                                            children: [
                                                "+ ",
                                                a
                                            ]
                                        }, i))
                                })
                            ]
                        }, s.section)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                onClick: apply,
                                disabled: applying,
                                children: applying ? t('common.actions.saving') : t('visit.soap.apply')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                variant: "outline",
                                onClick: clearDraft,
                                disabled: applying,
                                children: t('visit.soap.dismiss')
                            })
                        ]
                    })
                ]
            })),
            adviceError === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                style: {
                    marginTop: 10
                },
                children: t('visit.soap.adviceUnavailable')
            }),
            advice && !adviceError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "soap-advice",
                "data-accepted": dxTaken ? 'true' : 'false',
                style: {
                    // ACCEPTED LOOKS DIFFERENT AT A GLANCE. A dashed border is this
                    // pane's mark for "a proposal"; once the dentist has taken the
                    // diagnosis into the record it is no longer one, so the card goes
                    // solid and green rather than merely disabling its button — the
                    // same distinction the record below draws against the suggestions.
                    border: dxTaken ? `1.5px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good}` : `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    padding: '10px 12px',
                    marginTop: 10,
                    background: dxTaken ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            marginBottom: 6,
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true
                            }),
                            t('visit.soap.adviceTitle')
                        ]
                    }),
                    dxTaken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "status",
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 7,
                            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                            border: `1px solid ${(0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good}`,
                            borderRadius: 8,
                            padding: '7px 10px',
                            marginBottom: 9,
                            fontSize: 12.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                                size: 15,
                                "aria-hidden": true,
                                style: {
                                    flexShrink: 0
                                }
                            }),
                            t('visit.soap.accepted')
                        ]
                    }),
                    advice.summary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            lineHeight: 1.9,
                            whiteSpace: 'pre-wrap',
                            marginBottom: 8
                        },
                        children: advice.summary
                    }),
                    advice.suggestedDiagnosis && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            flexWrap: 'wrap',
                            marginBottom: 8
                        },
                        children: [
                            dxTaken && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: {
                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good,
                                    flexShrink: 0
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: dxTaken ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: [
                                    t('visit.soap.suggestedDiagnosis'),
                                    t('common.punct.colon'),
                                    " ",
                                    advice.suggestedDiagnosis
                                ]
                            }),
                            advice.icdCodes.map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        fontSize: 11,
                                        color: dxTaken ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                    },
                                    ...(0, $a278322405d51c25$export$3433559efc22d110),
                                    title: c.description,
                                    children: c.code
                                }, c.code)),
                            dxTaken ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good,
                                    color: '#fff',
                                    borderRadius: 8,
                                    padding: '3px 9px',
                                    fontSize: 11,
                                    fontWeight: 800
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                                        size: 11,
                                        "aria-hidden": true
                                    }),
                                    t('visit.diagnosis.alreadyRecorded')
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                variant: "subtle",
                                onClick: recordSuggested,
                                disabled: saving,
                                children: t('visit.soap.recordDiagnosis')
                            })
                        ]
                    }),
                    advice.suggestedActions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginBottom: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    marginBottom: 2
                                },
                                children: t('visit.soap.actions')
                            }),
                            advice.suggestedActions.map((a, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        lineHeight: 1.8
                                    },
                                    children: [
                                        "\u2022 ",
                                        a
                                    ]
                                }, i))
                        ]
                    }),
                    advice.suggestedMedications.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginBottom: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    marginBottom: 2
                                },
                                children: t('visit.soap.medications')
                            }),
                            advice.suggestedMedications.map((m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        lineHeight: 1.8
                                    },
                                    children: [
                                        "\u2022 ",
                                        m
                                    ]
                                }, i))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        className: "min-h-11",
                        variant: "outline",
                        onClick: clearAdvice,
                        children: t('visit.soap.dismiss')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($28a017da747dbd19$var$ToothFindings, {
                findings: findings,
                error: findingsError,
                chart: chart,
                onDismiss: clearFindings
            })
        ]
    });
}
function $28a017da747dbd19$export$2e2bcd8739ae039({ diagnoses: diagnoses, editable: editable, note: note, selectedTooth: selectedTooth, onSelectTooth: onSelectTooth, files: files, soap: soap, chart: chart }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { diagnoses: rows, loading: loading, error: error, saving: saving, record: record, remove: remove, differential: differential, suggesting: suggesting, suggestError: suggestError, suggest: suggest, reload: reload } = diagnoses;
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        code: '',
        display: '',
        verificationStatus: 'provisional'
    });
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    /**
   * The evidence a MANUALLY typed diagnosis rests on.
   *
   * Assembled from what is actually on screen at the moment of recording — the
   * subjective the dentist wrote, the tooth they have selected, the reports
   * extracted from this visit's files. That is §3.2.3's three derivation
   * sources, captured at the time rather than re-derived later.
   */ const currentEvidence = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const out = [];
        const subjective = note?.note?.subjective;
        if (subjective) out.push({
            kind: 'subjective',
            detail: subjective.split('\n')[0],
            ref: null
        });
        if (selectedTooth) out.push({
            kind: 'chart',
            detail: t('visit.diagnosis.toothEvidence', {
                fdi: formatNumber(selectedTooth)
            }),
            ref: selectedTooth
        });
        for (const f of (files || []).filter((x)=>x.fromThisVisit && x.reportText))out.push({
            kind: 'file',
            detail: `${f.fileName}: ${f.reportText.split('\n')[0]}`,
            ref: f.id
        });
        return out;
    }, [
        note,
        selectedTooth,
        files,
        t,
        formatNumber
    ]);
    const submit = async ()=>{
        setFailure(null);
        if (!draft.display.trim()) return;
        const err = await record({
            code: draft.code.trim(),
            display: draft.display.trim(),
            verificationStatus: draft.verificationStatus,
            evidence: currentEvidence(),
            aiAssisted: false
        });
        if (err) {
            setFailure(err);
            return;
        }
        setDraft({
            code: '',
            display: '',
            verificationStatus: 'provisional'
        });
    };
    /** Accept a suggestion: its own evidence becomes the recorded evidence. */ const accept = async (item)=>{
        setFailure(null);
        const err = await record({
            code: item.diagnosisCode || '',
            display: item.diagnosisName,
            // `provisional`, not `differential`: the service accepts only the closed
            // provisional/confirmed set, and an accepted suggestion the dentist has
            // not yet established is exactly a working diagnosis.
            verificationStatus: 'provisional',
            evidence: [
                // The service's own account of what it reasoned from — this is what
                // makes an accepted suggestion auditable a month later.
                ...item.supportingEvidence.map((detail)=>({
                        kind: 'ai',
                        detail: detail,
                        ref: null
                    })),
                ...currentEvidence()
            ],
            aiAssisted: true
        });
        if (err) setFailure(err);
    };
    const drop = async (id)=>{
        setFailure(null);
        const err = await remove(id);
        if (err) setFailure(err);
    };
    // The pane's own shape — the add form and the diagnosis rows — never a
    // centred spinner (DESIGN.md §"Loading & skeleton").
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$43c0e6c4c4a58968), {
        label: t('common.loading')
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "alert",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('visit.diagnosis.error.title'),
            description: t('visit.diagnosis.error.body'),
            onRetry: reload,
            retryLabel: t('common.actions.retry')
        })
    });
    const alreadyRecorded = new Set(rows.map((r)=>(r.display || '').trim()));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "visit-diagnosis",
        "data-state": rows.length ? 'content' : 'empty',
        children: [
            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                style: {
                    marginBottom: 12
                },
                children: failure.message || t('visit.diagnosis.saveFailed')
            }),
            editable && soap && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($28a017da747dbd19$var$SoapAssistant, {
                soap: soap,
                note: note,
                chart: chart,
                alreadyRecorded: alreadyRecorded,
                saving: saving,
                onRecord: record
            }),
            editable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    padding: 12,
                    marginBottom: 14,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr)',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.diagnosis.name'),
                                "aria-label": t('visit.diagnosis.name'),
                                dir: "auto",
                                value: draft.display,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            display: e.target.value
                                        }))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                label: t('visit.diagnosis.code'),
                                "aria-label": t('visit.diagnosis.code'),
                                dir: "ltr",
                                value: draft.code,
                                placeholder: "K02.1",
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            code: e.target.value
                                        }))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.diagnosis.certainty'),
                                "aria-label": t('visit.diagnosis.certainty'),
                                placeholder: "",
                                value: draft.verificationStatus,
                                onChange: (e)=>setDraft((d)=>({
                                            ...d,
                                            verificationStatus: e.target.value
                                        })),
                                options: $28a017da747dbd19$var$VERIFICATION.map((v)=>({
                                        value: v,
                                        label: t(`visit.diagnosis.verification.${v}`)
                                    }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 8,
                            lineHeight: 1.8
                        },
                        children: t('visit.diagnosis.willAttach', {
                            count: formatNumber(currentEvidence().length)
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            marginTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                onClick: submit,
                                disabled: saving || !draft.display.trim(),
                                children: saving ? t('common.actions.saving') : t('visit.diagnosis.add')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                variant: "outline",
                                onClick: suggest,
                                disabled: suggesting,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true,
                                        style: {
                                            marginInlineEnd: 5
                                        }
                                    }),
                                    suggesting ? t('visit.diagnosis.suggesting') : t('visit.diagnosis.suggest')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 6
                        },
                        children: t('visit.ai.costsCredits')
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                style: {
                    marginBottom: 12
                },
                children: t('visit.readOnly.note')
            }),
            suggestError === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                title: t('errors.credits.title'),
                style: {
                    marginBottom: 12
                },
                children: t('errors.credits.body')
            }),
            suggestError === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                style: {
                    marginBottom: 12
                },
                children: t('visit.diagnosis.suggestUnavailable')
            }),
            differential !== null && !suggestError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginBottom: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            marginBottom: 8,
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true
                            }),
                            t('visit.diagnosis.suggestions')
                        ]
                    }),
                    differential.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('visit.diagnosis.noSuggestions')
                    }) : differential.map((item)=>{
                        const tone = $28a017da747dbd19$var$CONFIDENCE_TONE[item.confidence] || $28a017da747dbd19$var$CONFIDENCE_TONE.low;
                        const taken = alreadyRecorded.has((item.diagnosisName || '').trim());
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                border: `1px dashed ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                borderRadius: 10,
                                padding: '9px 11px',
                                marginBottom: 8,
                                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    children: item.diagnosisName
                                                }),
                                                item.diagnosisCode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                        marginInlineStart: 6
                                                    },
                                                    ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                    children: item.diagnosisCode
                                                })
                                            ]
                                        }),
                                        item.confidence && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                background: tone.bg,
                                                color: tone.ink,
                                                borderRadius: 8,
                                                padding: '2px 8px',
                                                fontSize: 11,
                                                fontWeight: 700
                                            },
                                            children: t(`visit.diagnosis.confidence.${item.confidence}`)
                                        }),
                                        editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            className: "min-h-11",
                                            variant: "subtle",
                                            onClick: ()=>accept(item),
                                            disabled: saving || taken,
                                            children: taken ? t('visit.diagnosis.alreadyRecorded') : t('visit.diagnosis.accept')
                                        })
                                    ]
                                }),
                                (item.supportingEvidence.length > 0 || item.contradictingEvidence.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        marginTop: 6,
                                        fontSize: 12,
                                        lineHeight: 1.8
                                    },
                                    children: [
                                        item.supportingEvidence.map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk
                                                },
                                                children: [
                                                    "+ ",
                                                    e
                                                ]
                                            }, `s${i}`)),
                                        item.contradictingEvidence.map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: [
                                                    "\u2212 ",
                                                    e
                                                ]
                                            }, `c${i}`))
                                    ]
                                })
                            ]
                        }, `${item.diagnosisCode}-${item.diagnosisName}`);
                    })
                ]
            }),
            rows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $02839c5704f38745$export$2e2bcd8739ae039), {
                    size: 40,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('visit.diagnosis.empty.title'),
                description: t('visit.diagnosis.empty.description')
            }) : rows.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($28a017da747dbd19$var$DiagnosisRow, {
                    d: d,
                    t: t,
                    formatDate: formatDate,
                    editable: editable,
                    onRemove: drop,
                    onRevealRef: (e)=>onSelectTooth(e.ref)
                }, d.id))
        ]
    });
}




var $acw62 = parcelRequire("acw62");






// §3.2.4 — پرسش‌ها, the «دستیار بالینی» pattern.
//
//   "Identify clinical information gaps."
//   "Provide automated prompts to clarify symptoms or findings."
//   "Support diagnostic and treatment decision pathways."
//
// ── The loop this pane closes ──────────────────────────────────────────────
// The assistant is given the diagnoses under consideration and returns, per
// diagnosis, the questions that would confirm or exclude it — each carrying the
// SENTENCE to record for a yes and for a no. Answering one appends that
// sentence to the visit's subjective, which is the same text the differential
// reads from. So:
//
//   subjective → questions → an answer → a richer subjective → a better
//   differential
//
// That is what makes this a workflow rather than a list of prompts. A question
// that only asks leaves the dentist retyping the finding themselves, and the
// finding is the part that matters.
//
// ── Nothing here loads by itself ───────────────────────────────────────────
// Both calls COST PARSINA CREDITS, so the tab opens with an explanation and a
// button. An automatic generate on tab-open would bill a credit every time a
// dentist glanced at this pane.
// «بله» and «خیر» are not a primary action and its escape hatch — they are two
// equal, opposite commitments, each writing a DIFFERENT sentence into the visit
// note. They were `subtle` (navy at 5%) beside `outline` (white): two pale pills
// that looked the same, on a card where picking the wrong one puts a wrong
// finding in a clinical record. Affirm and deny get the two opposite semantic
// tones, at equal weight so neither is nudged.
const $48071389e5f2f37a$var$ANSWER_TONE = {
    yes: {
        bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good, 0.13),
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk,
        line: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good, 0.4)
    },
    no: {
        bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger, 0.13),
        ink: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).dangerInk,
        line: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).danger, 0.4)
    }
};
function $48071389e5f2f37a$var$QuestionCard({ q: q, t: t, busyKey: busyKey, disabled: disabled, onAnswer: onAnswer, answered: answered }) {
    // Each answer, with the sentence it will write. Built as data so the two
    // branches cannot drift apart — the previous pair was two hand-copied blocks.
    const choices = [
        {
            key: 'yes',
            Icon: (0, $3fbaf9031554177f$export$2e2bcd8739ae039),
            label: t('visit.questions.yes'),
            statement: q.positiveStatement
        },
        {
            key: 'no',
            Icon: (0, $4b6a18bc128c0629$export$2e2bcd8739ae039),
            label: t('visit.questions.no'),
            statement: q.negativeStatement
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            padding: '10px 12px',
            marginBottom: 8,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 13,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    lineHeight: 1.9
                },
                children: q.question
            }),
            q.hint && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    marginTop: 3
                },
                children: q.hint
            }),
            answered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginTop: 9,
                    borderRadius: 9,
                    padding: '7px 10px',
                    background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).good, 0.13),
                    color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk,
                    fontSize: 12,
                    lineHeight: 1.8,
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 6
                },
                dir: "auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                        size: 14,
                        strokeWidth: 3,
                        "aria-hidden": true,
                        style: {
                            flexShrink: 0,
                            marginTop: 3
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: t('visit.questions.recorded', {
                            statement: answered
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
                    gap: 8,
                    marginTop: 9
                },
                children: choices.map(({ key: key, Icon: Icon, label: label, statement: statement })=>{
                    const tone = $48071389e5f2f37a$var$ANSWER_TONE[key];
                    const busy = busyKey === `${q.id}:${key}`;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        className: "h-auto min-h-11 flex-col items-stretch justify-center gap-1 py-2 text-start hover:brightness-95",
                        style: {
                            background: tone.bg,
                            color: tone.ink,
                            borderColor: tone.line
                        },
                        // Busy is per-answer, not per-pane: a dentist who presses «بله»
                        // must see WHICH answer is being written, not eight cards that
                        // all went grey at once.
                        disabled: disabled || !!busyKey,
                        "aria-busy": busy,
                        onClick: ()=>onAnswer(q, key, statement),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 5,
                                    fontWeight: 800
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                        size: 14,
                                        strokeWidth: 3,
                                        "aria-hidden": true
                                    }),
                                    busy ? t('common.actions.saving') : label
                                ]
                            }),
                            statement && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                dir: "auto",
                                style: {
                                    fontSize: 11.5,
                                    fontWeight: 500,
                                    lineHeight: 1.7,
                                    opacity: 0.85
                                },
                                children: statement
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
}
function $48071389e5f2f37a$export$2e2bcd8739ae039({ assistant: assistant, diagnoses: diagnoses, note: note, editable: editable }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { questions: questions, loadingQuestions: loadingQuestions, questionsError: questionsError, generate: generate, answers: answers, asking: asking, askError: askError, ask: ask } = assistant;
    const [question, setQuestion] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // questionId → the statement that was recorded, so an answered card shows
    // what it wrote rather than resetting to two buttons.
    const [answered, setAnswered] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    // `questionId:yes|no` — WHICH answer is mid-write, not merely that one is.
    const [answeringKey, setAnsweringKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const recorded = diagnoses?.diagnoses || [];
    const onGenerate = ()=>generate({
            diagnoses: recorded
        });
    /**
   * Record an answer INTO the subjective.
   *
   * The statement is appended to the note's free-text notes field rather than
   * replacing anything: the dentist's own words stay first, and the assistant's
   * findings accumulate under them in the order they were confirmed.
   */ const onAnswer = async (q, choice, statement)=>{
        if (!statement || answeringKey) return;
        setFailure(null);
        setAnsweringKey(`${q.id}:${choice}`);
        try {
            const existing = note?.note?.dental?.notes || '';
            const err = await note.save({
                subjective: {
                    notes: existing ? `${existing}\n${statement}` : statement
                }
            });
            if (err) {
                setFailure(err);
                return;
            }
            setAnswered((prev)=>({
                    ...prev,
                    [q.id]: statement
                }));
        } finally{
            setAnsweringKey(null);
        }
    };
    const onAsk = async ()=>{
        const text = question.trim();
        if (!text) return;
        const err = await ask(text);
        if (!err) setQuestion('');
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "visit-questions",
        "data-state": questions ? 'content' : 'empty',
        children: [
            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                style: {
                    marginBottom: 12
                },
                children: t('visit.questions.recordFailed')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    padding: 12,
                    marginBottom: 14,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            marginBottom: 6,
                            fontSize: 12.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true
                            }),
                            t('visit.questions.title')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            lineHeight: 1.9,
                            marginBottom: 9
                        },
                        children: recorded.length > 0 ? t('visit.questions.forDiagnoses', {
                            list: recorded.map((d)=>d.display).join((0, $c53f9539af19d960$export$3004b7ed4244ef95)())
                        }) : t('visit.questions.noDiagnosesYet')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        className: "min-h-11",
                        onClick: onGenerate,
                        disabled: loadingQuestions,
                        children: loadingQuestions ? t('visit.questions.generating') : t('visit.questions.generate')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 6
                        },
                        children: t('visit.ai.costsCredits')
                    })
                ]
            }),
            !editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                style: {
                    marginBottom: 12
                },
                children: t('visit.readOnly.note')
            }),
            questionsError === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                title: t('errors.credits.title'),
                style: {
                    marginBottom: 12
                },
                children: t('errors.credits.body')
            }),
            questionsError === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "warning",
                style: {
                    marginBottom: 12
                },
                children: t('visit.questions.unavailable')
            }),
            loadingQuestions && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$14af0a2edf18435), {
                label: t('common.loading')
            }),
            questions && !loadingQuestions && !questionsError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    marginBottom: 16
                },
                children: [
                    questions.fallback && // Surfaced, not hidden: generic questions should read as generic,
                    // or a dentist will take a template for a considered opinion.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "info",
                        style: {
                            marginBottom: 10
                        },
                        children: t('visit.questions.fallbackNote')
                    }),
                    questions.items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3703118ab2b2b83a$export$2e2bcd8739ae039), {
                            size: 40,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        }),
                        title: t('visit.questions.empty.title'),
                        description: t('visit.questions.empty.description')
                    }) : questions.items.map((set)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                marginBottom: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        marginBottom: 7
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontSize: 12.5,
                                                fontWeight: 800,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                            },
                                            children: set.diagnosisName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            children: t('visit.questions.count', {
                                                count: formatNumber(set.questions.length)
                                            })
                                        })
                                    ]
                                }),
                                set.questions.map((q)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($48071389e5f2f37a$var$QuestionCard, {
                                        q: q,
                                        t: t,
                                        busyKey: answeringKey,
                                        disabled: !editable,
                                        answered: answered[q.id],
                                        onAnswer: onAnswer
                                    }, q.id))
                            ]
                        }, `${set.diagnosisCode}-${set.diagnosisName}`))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    paddingTop: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            marginBottom: 7
                        },
                        children: t('visit.questions.askTitle')
                    }),
                    answers.map((a, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                marginBottom: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12.5,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                        marginBottom: 4
                                    },
                                    children: a.question
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                                        borderRadius: 9,
                                        padding: '9px 11px',
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        lineHeight: 1.9
                                    },
                                    children: [
                                        a.answer,
                                        a.followUps?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                marginTop: 7,
                                                fontSize: 12
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                                    style: {
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    children: [
                                                        t('visit.questions.followUps'),
                                                        t('common.punct.colon')
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    style: {
                                                        margin: '4px 0 0',
                                                        paddingInlineStart: 18
                                                    },
                                                    children: a.followUps.map((f, j)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            children: f
                                                        }, j))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i)),
                    askError === 'credits' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "info",
                        title: t('errors.credits.title'),
                        style: {
                            marginBottom: 10
                        },
                        children: t('errors.credits.body')
                    }),
                    askError === 'unavailable' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                        variant: "warning",
                        style: {
                            marginBottom: 10
                        },
                        children: t('visit.questions.unavailable')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 8,
                            alignItems: 'flex-end'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    flex: 1,
                                    minWidth: 0
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    dir: (0, $a278322405d51c25$export$7fc2fdc74bdf206)(question),
                                    value: question,
                                    "aria-label": t('visit.questions.askPlaceholder'),
                                    placeholder: t('visit.questions.askPlaceholder'),
                                    onChange: (e)=>setQuestion(e.target.value),
                                    onKeyDown: (e)=>{
                                        // Enter submits — a single-line field where the only action is
                                        // "ask" should not require reaching for the mouse.
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            onAsk();
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                onClick: onAsk,
                                disabled: asking || !question.trim(),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c49d7be4abd1b80$export$2e2bcd8739ae039), {
                                        size: 13,
                                        "aria-hidden": true,
                                        style: {
                                            marginInlineEnd: 4
                                        }
                                    }),
                                    asking ? t('visit.questions.asking') : t('visit.questions.ask')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 6
                        },
                        children: t('visit.ai.costsCredits')
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839cd39f53db0480$export$a2387ed3b5d536eb = {
    name: "eye",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
                key: "1nclc0"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "3",
                key: "1v7zrd"
            }
        ]
    ]
};
$839cd39f53db0480$export$a2387ed3b5d536eb.node;
const $839cd39f53db0480$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($839cd39f53db0480$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $272fea46916dddb1$export$a2387ed3b5d536eb = {
    name: "image",
    size: 24,
    node: [
        [
            "rect",
            {
                width: "18",
                height: "18",
                x: "3",
                y: "3",
                rx: "2",
                ry: "2",
                key: "1m3agn"
            }
        ],
        [
            "circle",
            {
                cx: "9",
                cy: "9",
                r: "2",
                key: "af1f0g"
            }
        ],
        [
            "path",
            {
                d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
                key: "1xmnt7"
            }
        ]
    ]
};
$272fea46916dddb1$export$a2387ed3b5d536eb.node;
const $272fea46916dddb1$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($272fea46916dddb1$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $88a05a649e245666$export$a2387ed3b5d536eb = {
    name: "pencil-ruler",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13",
                key: "orapub"
            }
        ],
        [
            "path",
            {
                d: "m8 6 2-2",
                key: "115y1s"
            }
        ],
        [
            "path",
            {
                d: "m18 16 2-2",
                key: "ee94s4"
            }
        ],
        [
            "path",
            {
                d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
                key: "cfq27r"
            }
        ],
        [
            "path",
            {
                d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                key: "1a8usu"
            }
        ],
        [
            "path",
            {
                d: "m15 5 4 4",
                key: "1mk7zo"
            }
        ]
    ]
};
$88a05a649e245666$export$a2387ed3b5d536eb.node;
const $88a05a649e245666$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($88a05a649e245666$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a021fd56cbbf78f9$export$a2387ed3b5d536eb = {
    name: "scan-text",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 7V5a2 2 0 0 1 2-2h2",
                key: "aa7l1z"
            }
        ],
        [
            "path",
            {
                d: "M17 3h2a2 2 0 0 1 2 2v2",
                key: "4qcy5o"
            }
        ],
        [
            "path",
            {
                d: "M21 17v2a2 2 0 0 1-2 2h-2",
                key: "6vwrx8"
            }
        ],
        [
            "path",
            {
                d: "M7 21H5a2 2 0 0 1-2-2v-2",
                key: "ioqczr"
            }
        ],
        [
            "path",
            {
                d: "M7 8h8",
                key: "1jbsf9"
            }
        ],
        [
            "path",
            {
                d: "M7 12h10",
                key: "b7w52i"
            }
        ],
        [
            "path",
            {
                d: "M7 16h6",
                key: "1vyc9m"
            }
        ]
    ]
};
$a021fd56cbbf78f9$export$a2387ed3b5d536eb.node;
const $a021fd56cbbf78f9$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($a021fd56cbbf78f9$export$a2387ed3b5d536eb);







var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4e081ec70e23b03f$export$a2387ed3b5d536eb = {
    name: "circle",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ]
    ]
};
$4e081ec70e23b03f$export$a2387ed3b5d536eb.node;
const $4e081ec70e23b03f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($4e081ec70e23b03f$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a92bbd74876a0a00$export$a2387ed3b5d536eb = {
    name: "contrast",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10",
                key: "1mglay"
            }
        ],
        [
            "path",
            {
                d: "M12 18a6 6 0 0 0 0-12v12z",
                key: "j4l70d"
            }
        ]
    ]
};
$a92bbd74876a0a00$export$a2387ed3b5d536eb.node;
const $a92bbd74876a0a00$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($a92bbd74876a0a00$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cc37683d2791ff01$export$a2387ed3b5d536eb = {
    name: "map-pin",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
                key: "1r0f0z"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "10",
                r: "3",
                key: "ilqhr7"
            }
        ]
    ]
};
$cc37683d2791ff01$export$a2387ed3b5d536eb.node;
const $cc37683d2791ff01$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($cc37683d2791ff01$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $98b0bab9c13bb75b$export$a2387ed3b5d536eb = {
    name: "maximize-2",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M15 3h6v6",
                key: "1q9fwt"
            }
        ],
        [
            "path",
            {
                d: "m21 3-7 7",
                key: "1l2asr"
            }
        ],
        [
            "path",
            {
                d: "m3 21 7-7",
                key: "tjx5ai"
            }
        ],
        [
            "path",
            {
                d: "M9 21H3v-6",
                key: "wtvkvv"
            }
        ]
    ]
};
$98b0bab9c13bb75b$export$a2387ed3b5d536eb.node;
const $98b0bab9c13bb75b$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($98b0bab9c13bb75b$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4c9f0c6f3071e7c6$export$a2387ed3b5d536eb = {
    name: "mouse-pointer-2",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
                key: "edeuup"
            }
        ]
    ]
};
$4c9f0c6f3071e7c6$export$a2387ed3b5d536eb.node;
const $4c9f0c6f3071e7c6$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($4c9f0c6f3071e7c6$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3cd5b3c3b97fd41a$export$a2387ed3b5d536eb = {
    name: "move-up-right",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 5H19V11",
                key: "1n1gyv"
            }
        ],
        [
            "path",
            {
                d: "M19 5L5 19",
                key: "72u4yj"
            }
        ]
    ]
};
$3cd5b3c3b97fd41a$export$a2387ed3b5d536eb.node;
const $3cd5b3c3b97fd41a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($3cd5b3c3b97fd41a$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d1c7722460de3260$export$a2387ed3b5d536eb = {
    name: "pen-line",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M13 21h8",
                key: "1jsn5i"
            }
        ],
        [
            "path",
            {
                d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                key: "1a8usu"
            }
        ]
    ],
    aliases: [
        "edit-3"
    ]
};
$d1c7722460de3260$export$a2387ed3b5d536eb.node;
const $d1c7722460de3260$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($d1c7722460de3260$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6c970ba75b9f5ae$export$a2387ed3b5d536eb = {
    name: "rotate-ccw",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
                key: "1357e3"
            }
        ],
        [
            "path",
            {
                d: "M3 3v5h5",
                key: "1xhq8a"
            }
        ]
    ]
};
$c6c970ba75b9f5ae$export$a2387ed3b5d536eb.node;
const $c6c970ba75b9f5ae$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($c6c970ba75b9f5ae$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $51c8194506532e3d$export$a2387ed3b5d536eb = {
    name: "sun",
    size: 24,
    node: [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "4",
                key: "4exip2"
            }
        ],
        [
            "path",
            {
                d: "M12 2v2",
                key: "tus03m"
            }
        ],
        [
            "path",
            {
                d: "M12 20v2",
                key: "1lh1kg"
            }
        ],
        [
            "path",
            {
                d: "m4.93 4.93 1.41 1.41",
                key: "149t6j"
            }
        ],
        [
            "path",
            {
                d: "m17.66 17.66 1.41 1.41",
                key: "ptbguv"
            }
        ],
        [
            "path",
            {
                d: "M2 12h2",
                key: "1t8f8n"
            }
        ],
        [
            "path",
            {
                d: "M20 12h2",
                key: "1q8mjw"
            }
        ],
        [
            "path",
            {
                d: "m6.34 17.66-1.41 1.41",
                key: "1m8zz5"
            }
        ],
        [
            "path",
            {
                d: "m19.07 4.93-1.41 1.41",
                key: "1shlcs"
            }
        ]
    ]
};
$51c8194506532e3d$export$a2387ed3b5d536eb.node;
const $51c8194506532e3d$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($51c8194506532e3d$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5e5d2d1db089da95$export$a2387ed3b5d536eb = {
    name: "tag",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
                key: "vktsd0"
            }
        ],
        [
            "circle",
            {
                cx: "7.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor",
                key: "kqv944"
            }
        ]
    ]
};
$5e5d2d1db089da95$export$a2387ed3b5d536eb.node;
const $5e5d2d1db089da95$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($5e5d2d1db089da95$export$a2387ed3b5d536eb);





// جلسهٔ درمان → فایل‌ها → one image, opened.
//
// ────────────────────────────────────────────────────────────────────────────
// WHAT THIS SCREEN IS FOR
// ────────────────────────────────────────────────────────────────────────────
// A dentist looking at a periapical does three things, in this order: they LOOK
// (zoom, and push the contrast, because that is how a film is read), they MARK
// what they found so the next person sees it, and they read what the assistant
// thinks it saw. The layout follows that order — the image is the whole screen,
// the pen is a toolbar above it, and the findings are a list beside it that
// points INTO the image.
//
// ── Three layers, one frame ────────────────────────────────────────────────
// The image, the dentist's marks, and the model's findings are three stacked
// absolutely-positioned layers inside ONE element whose size the image decides.
// They are stacked rather than drawn into a canvas because a mark has to be
// clickable, focusable and describable to a screen reader — a bitmap is none of
// those — and because a canvas would have to be re-rastered on every zoom.
//
// ── Everything is a PERCENTAGE ─────────────────────────────────────────────
// Not one pixel coordinate is stored or drawn. The SVG layers use a fixed
// `viewBox="0 0 100 100"` with `preserveAspectRatio="none"`, so the unit square
// the server stores maps onto whatever box the image currently occupies —
// zoomed, resized, on a phone — with no arithmetic at draw time and no
// listener on the element's size. See lib/imageMarks.js.
//
// ── Zoom is CSS, not layout ────────────────────────────────────────────────
// `transform: scale()` on the frame, with the layers inside it. That keeps the
// three layers in exact register at every zoom level for free: they are one
// subtree, so they scale together and cannot drift by a rounding error.
//
// ── Contrast is a filter, and it is not an edit ────────────────────────────
// `filter: brightness() contrast()` on the <img> ALONE, never on the frame:
// pushing the contrast on a dark periapical is how it gets read, and if the
// filter applied to the whole subtree it would wash out the marks and the
// hotspots too. Nothing here writes a modified image anywhere — the bytes in
// storage are the bytes the sensor produced, and a "brightened" radiograph
// saved over the original is a diagnostic record nobody can re-read.
const $410d71b87c2b8a75$var$TOOL_CURSOR = 'cursor';
const $410d71b87c2b8a75$var$TOOLS = [
    {
        id: $410d71b87c2b8a75$var$TOOL_CURSOR,
        icon: (0, $4c9f0c6f3071e7c6$export$2e2bcd8739ae039)
    },
    {
        id: (0, $2c51377d39509d2c$export$68d935f6a7eab51c),
        icon: (0, $cc37683d2791ff01$export$2e2bcd8739ae039)
    },
    {
        id: (0, $2c51377d39509d2c$export$17a0078031eb7d1d),
        icon: (0, $5340d072e86ce769$export$2e2bcd8739ae039)
    },
    {
        id: (0, $2c51377d39509d2c$export$d82ee3d579db8f16),
        icon: (0, $4e081ec70e23b03f$export$2e2bcd8739ae039)
    },
    {
        id: (0, $2c51377d39509d2c$export$8a0b11bdd5ff0385),
        icon: (0, $3cd5b3c3b97fd41a$export$2e2bcd8739ae039)
    },
    {
        id: (0, $2c51377d39509d2c$export$c785f1ba800069c4),
        icon: (0, $d1c7722460de3260$export$2e2bcd8739ae039)
    }
];
const $410d71b87c2b8a75$var$ZOOM_STEPS = [
    1,
    1.5,
    2,
    3,
    4
];
// ── The dentist's marks ─────────────────────────────────────────────────────
function $410d71b87c2b8a75$var$MarkShape({ mark: mark, selected: selected, onSelect: onSelect, interactive: interactive, label: label }) {
    const stroke = mark.color || (0, $2c51377d39509d2c$export$a868e3b957eaade4);
    // Stroke width is in the 0-100 viewBox, so it thins as the image is zoomed —
    // which is what a magnifying glass does and what a dentist expects. A
    // `vector-effect` that kept it constant would fatten every mark on a phone.
    const width = selected ? 1.4 : 0.9;
    const common = {
        stroke: stroke,
        strokeWidth: width,
        fill: 'none',
        vectorEffect: 'non-scaling-stroke',
        style: {
            cursor: interactive ? 'pointer' : 'default'
        },
        onPointerDown: interactive ? (e)=>{
            e.stopPropagation();
            onSelect(mark.id);
        } : undefined,
        role: interactive ? 'button' : undefined,
        tabIndex: interactive ? 0 : undefined,
        'aria-label': label,
        onKeyDown: interactive ? (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(mark.id);
            }
        } : undefined
    };
    if (mark.kind === (0, $2c51377d39509d2c$export$17a0078031eb7d1d)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
        x: mark.x * 100,
        y: mark.y * 100,
        width: (mark.w || 0) * 100,
        height: (mark.h || 0) * 100,
        ...common
    });
    if (mark.kind === (0, $2c51377d39509d2c$export$d82ee3d579db8f16)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
        cx: (mark.x + (mark.w || 0) / 2) * 100,
        cy: (mark.y + (mark.h || 0) / 2) * 100,
        rx: (mark.w || 0) / 2 * 100,
        ry: (mark.h || 0) / 2 * 100,
        ...common
    });
    if (mark.kind === (0, $2c51377d39509d2c$export$8a0b11bdd5ff0385)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        ...common,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                x1: mark.x * 100,
                y1: mark.y * 100,
                x2: (mark.x2 ?? mark.x) * 100,
                y2: (mark.y2 ?? mark.y) * 100,
                stroke: stroke,
                strokeWidth: width,
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: (mark.x2 ?? mark.x) * 100,
                cy: (mark.y2 ?? mark.y) * 100,
                r: 1.1,
                fill: stroke,
                stroke: "none"
            })
        ]
    });
    if (mark.kind === (0, $2c51377d39509d2c$export$c785f1ba800069c4)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polyline", {
        points: (0, $2c51377d39509d2c$export$822ebe4c89939c31)(mark.points),
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ...common
    });
    // A pin. Two circles rather than a map-pin glyph, because a glyph has a tip
    // and a body and the dentist means the tip — an outline ring centred on the
    // point says exactly where it is.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        ...common,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: mark.x * 100,
                cy: mark.y * 100,
                r: selected ? 2.2 : 1.7,
                stroke: stroke,
                strokeWidth: width,
                fill: "none",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: mark.x * 100,
                cy: mark.y * 100,
                r: 0.5,
                fill: stroke,
                stroke: "none"
            })
        ]
    });
}
// ── The model's findings ────────────────────────────────────────────────────
function $410d71b87c2b8a75$var$FindingHotspot({ finding: finding, active: active, onHover: onHover, onLeave: onLeave, onSelect: onSelect, label: label }) {
    const tone = (0, $2c51377d39509d2c$export$aae4999338ff8157)(finding.confidence);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        onPointerEnter: ()=>onHover(finding.id),
        onPointerLeave: onLeave,
        onFocus: ()=>onHover(finding.id),
        onBlur: onLeave,
        onPointerDown: (e)=>{
            e.stopPropagation();
            onSelect(finding.id);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(finding.id);
            }
        },
        // Focusable, so the findings are reachable without a mouse. A hover-only
        // hotspot is a finding a keyboard user cannot discover exists.
        tabIndex: 0,
        role: "button",
        "aria-label": label,
        style: {
            cursor: 'pointer',
            outline: 'none'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
            x: finding.x * 100,
            y: finding.y * 100,
            width: finding.w * 100,
            height: finding.h * 100,
            fill: active ? (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.14) : 'transparent',
            stroke: tone.line,
            strokeWidth: active ? 1.4 : 0.9,
            // Dashed, always: it is what tells a proposal apart from a mark a human
            // drew, at a glance and without a legend.
            strokeDasharray: "2 1.6",
            vectorEffect: "non-scaling-stroke",
            rx: 0.8
        })
    });
}
/** The card that appears under the cursor on a hovered finding. */ function $410d71b87c2b8a75$var$FindingTip({ finding: finding, x: x, y: y, containerWidth: containerWidth, t: t }) {
    if (!finding) return null;
    const WIDTH = 230;
    const OFFSET = 14;
    const flip = x + OFFSET + WIDTH > (containerWidth || Infinity);
    const left = flip ? Math.max(4, x - OFFSET - WIDTH) : x + OFFSET;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "tooltip",
        style: {
            position: 'absolute',
            left: left,
            top: y + OFFSET,
            width: WIDTH,
            background: '#0f172a',
            color: '#e2e8f0',
            borderRadius: 8,
            padding: '9px 11px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
            // Load-bearing: the card follows the cursor and would otherwise sit
            // under it, stealing the hover from the hotspot and flickering.
            pointerEvents: 'none',
            zIndex: 30,
            textAlign: 'start'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: 6,
                    marginBottom: 4
                },
                children: [
                    finding.toothFdi && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 14,
                            fontWeight: 800,
                            color: '#fff'
                        },
                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                        children: finding.toothFdi
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 10.5,
                            color: '#94a3b8'
                        },
                        children: t(`visit.image.confidence.${finding.confidence}`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 12.5,
                    lineHeight: 1.7
                },
                children: finding.label
            }),
            finding.evidence && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 11,
                    color: '#94a3b8',
                    marginTop: 5,
                    lineHeight: 1.7
                },
                children: finding.evidence
            })
        ]
    });
}
function $410d71b87c2b8a75$export$2e2bcd8739ae039({ file: file, url: url, loadingUrl: loadingUrl, urlFailed: urlFailed, editable: editable, busy: busy, compact: compact = false, onBack: onBack, onSave: onSave, onAnalyze: onAnalyze, onConfirmFinding: onConfirmFinding, onRegister: onRegister, view: /**
   * How the film is currently being looked at, owned by the CALLER.
   *
   * Zoom and the brightness/contrast pair live outside this component because
   * the modal that holds it unmounts — confirming a finding closes it and sends
   * the dentist to the tooth editor, and they come back to the same film for the
   * next finding. Re-zooming and re-pushing the contrast every time would make
   * the second finding cost more than the first.
   */ view, onViewChange: onViewChange, onDirtyChange: /** Told when there are unsaved marks, so the caller can guard the close. */ onDirtyChange, t: t, formatDate: formatDate, formatNumber: formatNumber }) {
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const wrapRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [tool, setTool] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($410d71b87c2b8a75$var$TOOL_CURSOR);
    const [color, setColor] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $2c51377d39509d2c$export$a868e3b957eaade4));
    const zoom = view?.zoom ?? 1;
    const brightness = view?.brightness ?? 100;
    const contrast = view?.contrast ?? 100;
    const setView = (patch)=>onViewChange?.({
            zoom: zoom,
            brightness: brightness,
            contrast: contrast,
            ...patch
        });
    const setZoom = (next)=>setView({
            zoom: typeof next === 'function' ? next(zoom) : next
        });
    const setBrightness = (v)=>setView({
            brightness: v
        });
    const setContrast = (v)=>setView({
            contrast: v
        });
    // The marks being edited. Seeded from the file and NOT kept in sync with it
    // afterwards: this is a draft, and a refetch landing mid-edit must not
    // silently discard what the dentist has drawn since.
    const [marks, setMarks] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>file.annotations || []);
    const [dirty, setDirty] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Reported upward so the modal can refuse to close on a stray Esc or backdrop
    // click. The marks themselves stay here — this is one boolean, not the canvas.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        onDirtyChange?.(dirty);
    }, [
        dirty,
        onDirtyChange
    ]);
    const [selectedId, setSelectedId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [drawing, setDrawing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [hovered, setHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [tipAt, setTipAt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [readNote, setReadNote] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [registerAs, setRegisterAs] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(file.viewType || 'periapical');
    /**
   * Is this file registered as a dental image?
   *
   * Every file uploaded before this screen existed answers NO, and so does one
   * whose link write soft-failed at upload. Such a file can be LOOKED at — that
   * is the whole point of opening it — but not drawn on and not read: marks
   * have nowhere to live without the link row, and a reading has no view type,
   * which is the field that decides what the model may report at all.
   *
   * The tools are HIDDEN rather than disabled, with one line saying why and the
   * control that fixes it. A row of greyed-out pens explains nothing.
   */ const registered = !!file.imageLinkId;
    // Re-seed when the FILE changes — opening a different image — but never on a
    // refetch of the same one, which is what the id comparison buys.
    const fileId = file.id;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMarks(file.annotations || []);
        setDirty(false);
        setSelectedId(null);
        setRegisterAs(file.viewType || 'periapical');
    }, [
        fileId
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const selected = marks.find((m)=>m.id === selectedId) || null;
    const findings = file.aiFindings || [];
    const localized = findings.filter((0, $2c51377d39509d2c$export$7849a1990b6ddf9f));
    const unlocalized = findings.filter((f)=>!(0, $2c51377d39509d2c$export$7849a1990b6ddf9f)(f));
    const hoveredFinding = findings.find((f)=>f.id === hovered) || null;
    const patch = (id, changes)=>{
        setMarks((list)=>list.map((m)=>m.id === id ? {
                    ...m,
                    ...changes
                } : m));
        setDirty(true);
    };
    const drop = (id)=>{
        setMarks((list)=>list.filter((m)=>m.id !== id));
        setSelectedId(null);
        setDirty(true);
    };
    // ── Drawing ──────────────────────────────────────────────────────────────
    //
    // Pointer events, not mouse events: an iPad chairside is the device this is
    // used on, and `pointerdown` covers the pen, the finger and the mouse with
    // one path. `setPointerCapture` keeps a stroke that leaves the image alive
    // until it is released, instead of ending it at the edge.
    const beginDraw = (event)=>{
        if (!editable || tool === $410d71b87c2b8a75$var$TOOL_CURSOR) return;
        if (marks.length >= (0, $2c51377d39509d2c$export$e4cedbb8a08ffd7a)) {
            setFailure(new Error(t('visit.image.tooManyMarks', {
                max: formatNumber((0, $2c51377d39509d2c$export$e4cedbb8a08ffd7a))
            })));
            return;
        }
        event.currentTarget.setPointerCapture?.(event.pointerId);
        const at = (0, $2c51377d39509d2c$export$d48be2db27a3a8d3)(event, frameRef.current);
        setFailure(null);
        setSelectedId(null);
        setDrawing({
            kind: tool,
            from: at,
            to: at,
            points: [
                at.x,
                at.y
            ]
        });
    };
    const moveDraw = (event)=>{
        if (!drawing) return;
        const at = (0, $2c51377d39509d2c$export$d48be2db27a3a8d3)(event, frameRef.current);
        setDrawing((d)=>{
            if (!d) return d;
            if (d.kind !== (0, $2c51377d39509d2c$export$c785f1ba800069c4)) return {
                ...d,
                to: at
            };
            // A stroke that hits the ceiling STOPS GROWING rather than being refused:
            // the server caps the point list, and losing an entire long stroke at
            // save time is a worse answer than a stroke that stopped following.
            if (d.points.length >= (0, $2c51377d39509d2c$export$9d6fea047341202) * 2) return {
                ...d,
                to: at
            };
            return {
                ...d,
                to: at,
                points: [
                    ...d.points,
                    at.x,
                    at.y
                ]
            };
        });
    };
    const endDraw = ()=>{
        if (!drawing) return;
        const { kind: kind, from: from, to: to, points: points } = drawing;
        setDrawing(null);
        if (!(0, $2c51377d39509d2c$export$275dc60b90a08333)(kind, from, to)) return;
        const geometry = kind === (0, $2c51377d39509d2c$export$c785f1ba800069c4) ? {
            x: points[0],
            y: points[1],
            points: points
        } : (0, $2c51377d39509d2c$export$19efb8ccf6e13914)(kind, from, to);
        const mark = (0, $2c51377d39509d2c$export$d39c435a0adaeeff)({
            kind: kind,
            geometry: geometry,
            color: color,
            // The tooth the image is of, when it is of exactly one. A bitewing is of
            // several and a panoramic of none, and guessing which one a mark is about
            // from a coordinate is precisely the inference this app must not make.
            toothFdi: (file.teethFdi || []).length === 1 ? file.teethFdi[0] : null
        });
        setMarks((list)=>[
                ...list,
                mark
            ]);
        setSelectedId(mark.id);
        setDirty(true);
        // Back to the cursor after one mark. A pen that stays armed turns the next
        // click — usually meant to select what was just drawn — into another mark.
        setTool($410d71b87c2b8a75$var$TOOL_CURSOR);
    };
    const save = async ()=>{
        setFailure(null);
        const err = await onSave(marks);
        if (err) setFailure(err);
        else setDirty(false);
    };
    const analyze = async ()=>{
        setFailure(null);
        setReadNote(null);
        const { result: result, error: error } = await onAnalyze();
        if (error) {
            setFailure(error);
            return;
        }
        // "The model read it and saw nothing" is not a failure and must not be
        // rendered as one — but it must be rendered, or the button looks broken.
        if (result && result.status !== 'ok') setReadNote(result.status);
    };
    const filter = `brightness(${brightness}%) contrast(${contrast}%)`;
    const wrapWidth = wrapRef.current?.clientWidth || 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "image-workspace",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    marginBottom: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 44,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a140ead2dcbdb51$export$2e2bcd8739ae039), {
                            size: 16,
                            style: (0, $a278322405d51c25$export$ddb338179359cccc)
                        }),
                        label: t('visit.image.back'),
                        onClick: onBack
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13.5,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: file.fileName
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: [
                                    file.viewType ? t(`visit.files.viewTypes.${file.viewType}`) : '',
                                    file.createdAt ? ` \xb7 ${formatDate(file.createdAt, 'numeric')}` : ''
                                ]
                            })
                        ]
                    }),
                    (file.teethFdi || []).length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                        children: file.teethFdi.join(', ')
                    })
                ]
            }),
            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                style: {
                    marginBottom: 10
                },
                children: failure.message || t('visit.image.saveFailed')
            }),
            readNote && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                style: {
                    marginBottom: 10
                },
                children: t(`visit.image.readStatus.${readNote}`)
            }),
            editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 10,
                    flexWrap: 'wrap',
                    padding: '10px 12px',
                    marginBottom: 10,
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 200
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    fontSize: 12.5,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    marginBottom: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e5d2d1db089da95$export$2e2bcd8739ae039), {
                                        size: 13,
                                        "aria-hidden": true
                                    }),
                                    registered ? t('visit.image.viewType.title') : t('visit.image.notRegistered.title')
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 11.5,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    lineHeight: 1.7
                                },
                                children: registered ? t('visit.image.viewType.body') : t('visit.image.notRegistered.body')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                        label: t('visit.files.viewType'),
                        "aria-label": t('visit.files.viewType'),
                        placeholder: "",
                        value: registerAs,
                        onChange: (e)=>setRegisterAs(e.target.value),
                        options: (0, $2c51377d39509d2c$export$4ed55f6519d0435b).map((v)=>({
                                value: v,
                                label: t(`visit.files.viewTypes.${v}`)
                            }))
                    }),
                    (!registered || registerAs !== file.viewType) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        className: "min-h-11 flex-none",
                        disabled: busy,
                        onClick: async ()=>{
                            setFailure(null);
                            const err = await onRegister(registerAs);
                            if (err) setFailure(err);
                        },
                        children: busy ? t('visit.image.registering') : registered ? t('visit.image.changeView') : t('visit.image.register')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap',
                    padding: '8px 10px',
                    marginBottom: 8,
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                },
                children: [
                    editable && registered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43f8655df02249d5$export$2e2bcd8739ae039), {
                                value: tool,
                                onChange: setTool,
                                "aria-label": t('visit.image.tools'),
                                options: $410d71b87c2b8a75$var$TOOLS.map(({ id: id, icon: Icon })=>({
                                        value: id,
                                        label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                                            size: 15,
                                            "aria-hidden": true
                                        }),
                                        'aria-label': t(`visit.image.tool.${id}`),
                                        title: t(`visit.image.tool.${id}`)
                                    }))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    gap: 4
                                },
                                role: "group",
                                "aria-label": t('visit.image.color'),
                                children: (0, $2c51377d39509d2c$export$96cdd4336b8baa5d).map((c)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setColor(c),
                                        "aria-label": t(`visit.image.colorName.${c.replace('#', '')}`),
                                        "aria-pressed": color === c,
                                        style: {
                                            width: 22,
                                            height: 22,
                                            borderRadius: 6,
                                            background: c,
                                            border: color === c ? `2px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary}` : `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                            cursor: 'pointer',
                                            padding: 0
                                        }
                                    }, c))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    width: 1,
                                    height: 22,
                                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
                                },
                                "aria-hidden": true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 38,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a481aded68921702$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        label: t('visit.image.zoomOut'),
                        onClick: ()=>setZoom((z)=>$410d71b87c2b8a75$var$ZOOM_STEPS[Math.max(0, $410d71b87c2b8a75$var$ZOOM_STEPS.indexOf(z) - 1)] || 1)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            fontSize: 11.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            minWidth: 34,
                            textAlign: 'center'
                        },
                        children: [
                            formatNumber(Math.round(zoom * 100)),
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 38,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $191016e022d4d457$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        label: t('visit.image.zoomIn'),
                        onClick: ()=>setZoom((z)=>$410d71b87c2b8a75$var$ZOOM_STEPS[Math.min($410d71b87c2b8a75$var$ZOOM_STEPS.length - 1, $410d71b87c2b8a75$var$ZOOM_STEPS.indexOf(z) + 1)] || 1)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 38,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98b0bab9c13bb75b$export$2e2bcd8739ae039), {
                            size: 15
                        }),
                        label: t('visit.image.fit'),
                        // ONE patch, not three: each setter derives from the CURRENT view, so
                        // three calls in a row would each overwrite the last from stale values.
                        onClick: ()=>onViewChange?.({
                                zoom: 1,
                                brightness: 100,
                                contrast: 100
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            width: 1,
                            height: 22,
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border
                        },
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51c8194506532e3d$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: t('visit.image.brightness')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "range",
                                min: 40,
                                max: 200,
                                value: brightness,
                                "aria-label": t('visit.image.brightness'),
                                onChange: (e)=>setBrightness(Number(e.target.value)),
                                style: {
                                    width: compact ? 66 : 84
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a92bbd74876a0a00$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "sr-only",
                                children: t('visit.image.contrast')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "range",
                                min: 40,
                                max: 260,
                                value: contrast,
                                "aria-label": t('visit.image.contrast'),
                                onChange: (e)=>setContrast(Number(e.target.value)),
                                style: {
                                    width: compact ? 66 : 84
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            flex: 1
                        }
                    }),
                    editable && registered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        className: "min-h-11",
                        onClick: analyze,
                        disabled: busy,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 5
                                }
                            }),
                            busy ? t('visit.image.reading') : t('visit.image.read')
                        ]
                    }),
                    editable && registered && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        className: "min-h-11",
                        onClick: save,
                        disabled: !dirty || busy,
                        children: t('common.actions.save')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: compact ? 'column' : 'row',
                    alignItems: 'stretch',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: '1 1 auto',
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                ref: wrapRef,
                                style: {
                                    position: 'relative',
                                    overflow: 'auto',
                                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                    borderRadius: 10,
                                    background: '#0b1220',
                                    minHeight: compact ? 220 : 320,
                                    maxHeight: compact ? 'none' : '70vh'
                                },
                                onPointerMove: (e)=>{
                                    const rect = wrapRef.current?.getBoundingClientRect();
                                    if (rect) setTipAt({
                                        x: e.clientX - rect.left,
                                        y: e.clientY - rect.top
                                    });
                                },
                                children: [
                                    loadingUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$8b3e24dbbac64362), {
                                        label: t('common.loading'),
                                        style: {
                                            padding: 12
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: "100%",
                                            height: compact ? 196 : 296,
                                            radius: 8,
                                            tone: "onDark"
                                        })
                                    }),
                                    !loadingUrl && urlFailed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            padding: 40,
                                            fontSize: 12.5,
                                            color: '#94a3b8'
                                        },
                                        children: file.storageFileId ? t('visit.files.previewFailed') : t('visit.files.bytesGone')
                                    }),
                                    !loadingUrl && url && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        ref: frameRef,
                                        style: {
                                            position: 'relative',
                                            // ── ZOOM IS LAYOUT, NOT A TRANSFORM ──────────────────────────
                                            // This was `transform: scale(zoom)`, and a transform does not
                                            // change layout size: the scroll area of the box above stayed at
                                            // 1× however far the film was zoomed, so past ~2× the edges could
                                            // not be reached at all. Widening the FRAME makes the overflow
                                            // real, and the scrollbars mean it.
                                            //
                                            // The three layers stay in exact register for free either way —
                                            // the image and both SVGs are children of this element and are
                                            // sized from it (`maxWidth:100%` and `inset:0`), so they all
                                            // follow one number. That was the property the transform was
                                            // chosen for, and it survives the change.
                                            width: `${zoom * 100}%`,
                                            margin: 'auto',
                                            lineHeight: 0,
                                            touchAction: drawing ? 'none' : 'auto',
                                            cursor: editable && registered && tool !== $410d71b87c2b8a75$var$TOOL_CURSOR ? 'crosshair' : 'default'
                                        },
                                        onPointerDown: beginDraw,
                                        onPointerMove: moveDraw,
                                        onPointerUp: endDraw,
                                        onPointerCancel: endDraw,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: url,
                                                alt: file.fileName,
                                                draggable: false,
                                                style: {
                                                    // `width:100%` and not `maxWidth`: the frame is what the zoom
                                                    // widens, and the image has to follow it. `maxWidth` would cap
                                                    // the film at its natural pixel size and the zoom would stop
                                                    // having any effect once it passed that.
                                                    display: 'block',
                                                    width: '100%',
                                                    height: 'auto',
                                                    filter: // ONLY the image. Applied to the frame it would wash out the
                                                    // marks and the hotspots along with the film.
                                                    filter,
                                                    userSelect: 'none'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                                                viewBox: "0 0 100 100",
                                                preserveAspectRatio: "none",
                                                style: {
                                                    position: 'absolute',
                                                    inset: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    // Marks are clickable; the empty space between them is not, so
                                                    // a drag that starts on background still reaches the frame.
                                                    pointerEvents: editable && registered ? 'auto' : 'none'
                                                },
                                                "aria-hidden": marks.length === 0,
                                                children: [
                                                    marks.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($410d71b87c2b8a75$var$MarkShape, {
                                                            mark: m,
                                                            selected: m.id === selectedId,
                                                            interactive: editable && tool === $410d71b87c2b8a75$var$TOOL_CURSOR,
                                                            onSelect: setSelectedId,
                                                            label: m.comment || t(`visit.image.tool.${m.kind}`)
                                                        }, m.id)),
                                                    drawing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($410d71b87c2b8a75$var$MarkShape, {
                                                        mark: {
                                                            kind: drawing.kind,
                                                            color: color,
                                                            points: drawing.points,
                                                            ...drawing.kind === (0, $2c51377d39509d2c$export$c785f1ba800069c4) ? {
                                                                x: drawing.points[0],
                                                                y: drawing.points[1]
                                                            } : (0, $2c51377d39509d2c$export$19efb8ccf6e13914)(drawing.kind, drawing.from, drawing.to)
                                                        },
                                                        selected: true,
                                                        interactive: false,
                                                        onSelect: ()=>{},
                                                        label: ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                                viewBox: "0 0 100 100",
                                                preserveAspectRatio: "none",
                                                style: {
                                                    position: 'absolute',
                                                    inset: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    pointerEvents: localized.length ? 'auto' : 'none'
                                                },
                                                children: localized.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($410d71b87c2b8a75$var$FindingHotspot, {
                                                        finding: f,
                                                        active: hovered === f.id,
                                                        onHover: setHovered,
                                                        onLeave: ()=>setHovered(null),
                                                        onSelect: setHovered,
                                                        label: f.label
                                                    }, f.id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($410d71b87c2b8a75$var$FindingTip, {
                                        finding: hoveredFinding,
                                        x: tipAt.x,
                                        y: tipAt.y,
                                        containerWidth: wrapWidth,
                                        t: t
                                    })
                                ]
                            }),
                            editable && registered && selected && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    marginTop: 10,
                                    padding: 10,
                                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                    borderRadius: 10,
                                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            marginBottom: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: 3,
                                                    background: selected.color || (0, $2c51377d39509d2c$export$a868e3b957eaade4)
                                                },
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 12.5,
                                                    fontWeight: 700,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                },
                                                children: t(`visit.image.tool.${selected.kind}`)
                                            }),
                                            selected.toothFdi && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                    children: selected.toothFdi
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    flex: 1
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                                                variant: "ghost",
                                                size: 38,
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                label: t('visit.image.removeMark'),
                                                onClick: ()=>drop(selected.id)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                        value: selected.comment || '',
                                        onChange: (e)=>patch(selected.id, {
                                                comment: e.target.value.slice(0, (0, $2c51377d39509d2c$export$217e8b917497ff48))
                                            }),
                                        placeholder: t('visit.image.commentPlaceholder'),
                                        "aria-label": t('visit.image.comment'),
                                        rows: 2
                                    })
                                ]
                            })
                        ]
                    }),
                    findings.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            flex: compact ? '1 1 auto' : '0 0 300px',
                            minWidth: 0,
                            maxHeight: compact ? 'none' : '70vh',
                            overflowY: compact ? 'visible' : 'auto'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'baseline',
                                        gap: 8,
                                        marginBottom: 6
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontSize: 12.5,
                                                fontWeight: 800,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                            },
                                            children: t('visit.image.findings')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                fontSize: 11,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('visit.image.findingsNote')
                                        })
                                    ]
                                }),
                                findings.map((f)=>{
                                    const tone = (0, $2c51377d39509d2c$export$aae4999338ff8157)(f.confidence);
                                    const active = hovered === f.id;
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        onPointerEnter: ()=>setHovered(f.id),
                                        onPointerLeave: ()=>setHovered(null),
                                        style: {
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 9,
                                            padding: '8px 10px',
                                            marginBottom: 6,
                                            border: `1px solid ${active ? tone.line : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                            borderRadius: 9,
                                            background: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2 : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: 2,
                                                    marginTop: 5,
                                                    background: tone.line,
                                                    flex: 'none'
                                                },
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    flex: 1,
                                                    minWidth: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        style: {
                                                            fontSize: 12.5,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                            lineHeight: 1.7
                                                        },
                                                        children: [
                                                            f.toothFdi && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                style: {
                                                                    fontWeight: 800,
                                                                    marginInlineEnd: 5
                                                                },
                                                                ...(0, $a278322405d51c25$export$3433559efc22d110),
                                                                children: f.toothFdi
                                                            }),
                                                            f.label
                                                        ]
                                                    }),
                                                    f.evidence && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        style: {
                                                            fontSize: 11,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                            marginTop: 2
                                                        },
                                                        children: f.evidence
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        style: {
                                                            fontSize: 10.5,
                                                            color: tone.ink,
                                                            marginTop: 3
                                                        },
                                                        children: [
                                                            t(`visit.image.confidence.${f.confidence}`),
                                                            !(0, $2c51377d39509d2c$export$7849a1990b6ddf9f)(f) && ` \xb7 ${t('visit.image.notLocalized')}`
                                                        ]
                                                    })
                                                ]
                                            }),
                                            editable && (0, $2c51377d39509d2c$export$824fa60a66980aaf)(f) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                className: "min-h-11 flex-none",
                                                onClick: ()=>onConfirmFinding(f),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3fbaf9031554177f$export$2e2bcd8739ae039), {
                                                        size: 13,
                                                        "aria-hidden": true,
                                                        style: {
                                                            marginInlineEnd: 4
                                                        }
                                                    }),
                                                    t('visit.image.confirm')
                                                ]
                                            })
                                        ]
                                    }, f.id);
                                }),
                                unlocalized.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 11,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                        marginTop: 2
                                    },
                                    children: t('visit.image.unlocalizedNote', {
                                        count: formatNumber(unlocalized.length)
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            editable && registered && dirty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    marginTop: 10,
                    fontSize: 11.5,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6c970ba75b9f5ae$export$2e2bcd8739ae039), {
                        size: 13,
                        "aria-hidden": true
                    }),
                    t('visit.image.unsaved')
                ]
            })
        ]
    });
}





// §3.2.5 — فایل‌ها.
//
//   "Display uploaded documents (lab results, images)."
//   "Report Association: Clearly indicate which extracted report belongs to
//    which uploaded file."
//   "Prioritize clinically relevant and recent files."
//
// ── UPLOAD IS PLAIN, AND THAT IS THE CHANGE (2026-08-31) ───────────────────
// This tab used to carry a pre-ticked «استخراج گزارش» checkbox, and the
// predicate behind it counted every image/jpeg as extractable — so uploading a
// periapical sent it to a model asked to transcribe text a radiograph does not
// contain. It came back empty every time, the card said «گزارشی استخراج نشده»,
// and the dentist had waited for that answer while a credit warning was on
// screen for a call that (see the BFF) was never actually billed.
//
// Upload now stores bytes. Afterwards, per file, on a control the dentist
// presses while looking at the thing:
//
//   «استخراج متن»  — a document has TEXT in it. PDFs, photographed lab sheets.
//   «خواندن تصویر» — a radiograph has FINDINGS in it, and they have a place.
//
// Those are two different questions, and the old tab asked the first one about
// everything.
//
// ── The association is a STORED FACT, not a layout ─────────────────────────
// A file, its extracted report and its marks arrive on ONE row from the BFF,
// because three services wrote three rows keyed by the same
// `storage:labfile:<id>` reference. Nothing here pairs anything by timestamp —
// a tab that guessed would eventually pair the wrong two, and would look right
// while doing it.
//
// ── The bytes are fetched ONE AT A TIME ────────────────────────────────────
// A data: URI costs the file's size × 1.33 in the response, so `visitFileUrl`
// is a separate query fired when a file is opened. A files list must not
// download every attachment to draw a list of names.
// What the picker will admit.
//
// ENUMERATED, never the image wildcard. The wildcard admits HEIC — which an
// iPhone produces by default and which no browser but Safari draws — so such a
// file uploads perfectly and then shows a blank frame with no error anywhere.
// The document list includes the photo types too, because a lab sheet snapped
// with a phone is the common case in an Iranian clinic.
//
// They are constants rather than inline strings for a second reason that is not
// style: tests/mobileComposition.test.js scans this SOURCE and strips block
// comments before looking, so a slash and a star written adjacently anywhere in
// this file — which is what the wildcard form is — reads to it as a comment
// opener and silently swallows the rest of the element. Keeping that sequence
// out of the file is what keeps the guard able to see it.
const $23347f4af3778820$var$IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp,image/bmp,image/tiff';
const $23347f4af3778820$var$DOCUMENT_ACCEPT = `application/pdf,${$23347f4af3778820$var$IMAGE_ACCEPT}`;
/** One file's bytes, fetched once and remembered for as long as it is open. */ function $23347f4af3778820$var$useFileUrl(patientId, file) {
    const [url, setUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [failed, setFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const fileId = file?.id;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!fileId || !patientId) return undefined;
        let alive = true;
        setUrl(null);
        setFailed(false);
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$d141e074b4d84050), {
            patientId: patientId,
            fileId: fileId
        }).then((data)=>{
            if (!alive) return;
            if (data?.visitFileUrl) setUrl(data.visitFileUrl);
            else setFailed(true);
        }).catch(()=>{
            if (alive) setFailed(true);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        patientId,
        fileId
    ]);
    return {
        url: url,
        loading: loading,
        failed: failed
    };
}
function $23347f4af3778820$var$FileCard({ f: f, t: t, formatNumber: formatNumber, formatDate: formatDate, editable: editable, busy: busy, onDelete: onDelete, onOpen: onOpen, onOpenExternal: onOpenExternal, onRunOcr: onRunOcr }) {
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const bodyId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    const size = (0, $0cd549c1a257ae26$export$671351640b9eccaf)(f.fileSize);
    const isImage = (0, $2c51377d39509d2c$export$125b59614f576538)(f.fileType);
    /**
   * Can this file be OPENED at all?
   *
   * Only two things matter: the bytes still exist, and this app can draw them.
   * NOT whether it is a registered dental image — that gate was here until it
   * turned out to hide the preview on every file uploaded before the workspace
   * existed, which is most of them, and on any file whose link write failed.
   * Looking at a radiograph is the least a files tab owes its reader; the view
   * type only decides whether it can also be drawn on and read.
   */ const viewable = isImage && !!f.storageFileId && (0, $2c51377d39509d2c$export$7dc169c276dbe757)(f.fileType);
    const extractable = (0, $0cd549c1a257ae26$export$cf0d6a5afe211dd5)(f.fileType, f.viewType);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 10,
            background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
            marginBottom: 8,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 9,
                    padding: '10px 12px',
                    flexWrap: 'wrap'
                },
                children: [
                    isImage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $272fea46916dddb1$export$2e2bcd8739ae039), {
                        size: 16,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                        "aria-hidden": true
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df9771111904a5d5$export$2e2bcd8739ae039), {
                        size: 16,
                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            flex: 1,
                            minWidth: 140
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: f.fileName
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    fontSize: 11,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                },
                                children: [
                                    f.createdAt ? formatDate(f.createdAt, 'numeric') : '',
                                    size ? ` \xb7 ${formatNumber(size.value)} ${t(`visit.files.units.${size.unit}`)}` : '',
                                    f.viewType ? ` \xb7 ${(0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.files.viewTypes', f.viewType)}` : f.documentType ? ` \xb7 ${(0, $0cd549c1a257ae26$export$7cc0b9b3fa44a60f)(t, 'visit.files.docTypes', f.documentType)}` : ''
                                ]
                            })
                        ]
                    }),
                    f.fromThisVisit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                        variant: "outline",
                        children: t('visit.files.thisVisit')
                    }),
                    f.annotations?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 3,
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88a05a649e245666$export$2e2bcd8739ae039), {
                                size: 12,
                                "aria-hidden": true
                            }),
                            formatNumber(f.annotations.length)
                        ]
                    }),
                    f.aiFindings?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 3,
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentInk
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53b0597d7da6e50a$export$2e2bcd8739ae039), {
                                size: 12,
                                "aria-hidden": true
                            }),
                            formatNumber(f.aiFindings.length)
                        ]
                    }),
                    f.teethFdi.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        ...(0, $a278322405d51c25$export$3433559efc22d110),
                        children: f.teethFdi.join(', ')
                    }),
                    viewable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        className: "min-h-11 flex-none",
                        onClick: ()=>onOpen(f),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839cd39f53db0480$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 4
                                }
                            }),
                            t('visit.files.openImage')
                        ]
                    }),
                    !viewable && f.storageFileId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        className: "min-h-11 flex-none",
                        onClick: ()=>onOpenExternal(f),
                        disabled: busy,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 4
                                }
                            }),
                            t('visit.files.openFile')
                        ]
                    }),
                    editable && extractable && !f.reportText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        className: "min-h-11 flex-none",
                        onClick: ()=>onRunOcr(f),
                        disabled: busy,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a021fd56cbbf78f9$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true,
                                style: {
                                    marginInlineEnd: 4
                                }
                            }),
                            busy ? t('visit.files.extracting') : t('visit.files.extract')
                        ]
                    }),
                    (f.reportText || f.abnormalFlags.length > 0) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        variant: "outline",
                        className: "min-h-11 flex-none",
                        "aria-expanded": open,
                        "aria-controls": bodyId,
                        onClick: ()=>setOpen((o)=>!o),
                        children: [
                            t('visit.files.hasReport'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc4be5d9d5a360aa$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true,
                                style: {
                                    marginInlineStart: 4,
                                    transform: open ? 'rotate(180deg)' : 'none',
                                    transition: 'transform .15s'
                                }
                            })
                        ]
                    }),
                    editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26386601b5f40a7d$export$2e2bcd8739ae039), {
                        variant: "ghost",
                        size: 44,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1882f1d059ea7fa7$export$2e2bcd8739ae039), {
                            size: 14
                        }),
                        label: t('visit.files.remove', {
                            name: f.fileName
                        }),
                        onClick: ()=>onDelete(f.id)
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: bodyId,
                style: {
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2,
                    padding: '10px 12px'
                },
                children: [
                    f.abnormalFlags.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            marginBottom: 8,
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).warnInk,
                            fontWeight: 700
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                                size: 13,
                                "aria-hidden": true
                            }),
                            f.abnormalFlags.join(" \xb7 ")
                        ]
                    }),
                    f.reportText ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12.5,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            lineHeight: 1.9,
                            whiteSpace: 'pre-wrap'
                        },
                        children: f.reportText
                    }) : // "No report" and "an empty report" are different facts, and only
                    // one of them means the extraction was never run.
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 12,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: t('visit.files.noReport')
                    })
                ]
            })
        ]
    });
}
function $23347f4af3778820$export$2e2bcd8739ae039({ files: files, visit: visit, editable: editable, selectedTooth: selectedTooth, compact: compact = false, onConfirmFinding: onConfirmFinding }) {
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { files: rows, loading: loading, error: error, uploading: uploading, busyFileId: busyFileId, upload: upload, remove: remove, runOcr: runOcr, analyze: analyze, saveAnnotations: saveAnnotations, register: register, reload: reload } = files;
    const [kind, setKind] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('image');
    const [viewType, setViewType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('periapical');
    const [documentType, setDocumentType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('lab_report');
    const [attachTooth, setAttachTooth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [failure, setFailure] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [openId, setOpenId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [fetchingId, setFetchingId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [dirty, setDirty] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [confirmDiscard, setConfirmDiscard] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // How each film is being looked at, KEYED BY FILE and held here rather than
    // in the workspace: the modal unmounts every time it closes — confirming a
    // finding closes it and sends the dentist to the tooth editor — and they come
    // back to the same image for the next finding. Re-zooming and re-pushing the
    // contrast each time would make the second finding cost more than the first.
    const [views, setViews] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const patientId = visit?.patientId;
    // The open file is looked up FRESH from the list on every render rather than
    // held in state: the list refetches after a save or a read, and a held copy
    // would keep showing the marks and findings from before it.
    const openFile = rows.find((r)=>r.id === openId) || null;
    const fileUrl = $23347f4af3778820$var$useFileUrl(patientId, openFile);
    const onPick = async (event)=>{
        const file = event.target.files?.[0];
        // Reset immediately, so picking the SAME file twice still fires a change.
        event.target.value = '';
        if (!file) return;
        setFailure(null);
        if (file.size > (0, $0cd549c1a257ae26$export$ad100638cfc43086)) {
            // Refused here as well as server-side: sending 20 MB to be told no is a
            // slow way to learn it, especially on a clinic's uplink.
            setFailure(new Error(t('visit.files.tooLarge')));
            return;
        }
        // HEIC is admitted by `accept="image/*"`, is what an iPhone produces by
        // default, and is drawn by no browser but Safari — so it uploads fine and
        // then shows a blank frame with no error anywhere. Refusing at the picker
        // is the only place this is legible.
        const asImage = kind === 'image';
        if (asImage && !(0, $2c51377d39509d2c$export$7dc169c276dbe757)(file.type)) {
            setFailure(new Error(t('visit.files.unsupportedImage')));
            return;
        }
        let base64;
        try {
            base64 = await (0, $0cd549c1a257ae26$export$25df2e315be8e003)(file);
        } catch  {
            setFailure(new Error(t('visit.files.readFailed')));
            return;
        }
        const err = await upload({
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            fileData: base64,
            // A view type is what REGISTERS the upload as a dental image. A document
            // gets a documentType instead, and neither gets both: a PDF referral with
            // a view type would be handed to the image reader as if it were a film.
            viewType: asImage ? viewType : null,
            documentType: asImage ? null : documentType,
            teethFdi: asImage && attachTooth && selectedTooth ? [
                selectedTooth
            ] : []
        });
        if (err) setFailure(err);
    };
    const viewOf = (id)=>views[id] || {
            zoom: 1,
            brightness: 100,
            contrast: 100
        };
    const closeNow = ()=>{
        setOpenId(null);
        setDirty(false);
    };
    /** Close, unless there are marks that exist nowhere else yet. */ const requestClose = ()=>{
        if (dirty) setConfirmDiscard(true);
        else closeNow();
    };
    /**
   * A finding was ticked. Close the modal and hand it up.
   *
   * CLOSING IS THE POINT, not a limitation. `ToothDrawer` is built on the kit's
   * `Drawer`, which is `position: absolute` at z-index 11; `Dialog` is `fixed`
   * at 1100 (the scale is written at the top of the kit's Dialog.jsx). So a
   * drawer opened while this modal is up would render UNDERNEATH it — the
   * dentist would tick a finding and watch nothing happen.
   *
   * The alternatives were worse: raising the drawer means editing a kit
   * component three apps share, and rendering a second tooth editor inside the
   * modal means two editors that must agree about a clinical write.
   *
   * And it reads correctly anyway — confirming a finding IS the move from
   * reading the film to charting the tooth. The zoom and contrast survive in
   * `views`, so coming back for the next finding costs one click.
   */ const confirmFinding = (finding)=>{
        closeNow();
        onConfirmFinding?.(finding);
    };
    const drop = async (fileId)=>{
        setFailure(null);
        if (fileId === openId) setOpenId(null);
        const err = await remove(fileId);
        if (err) setFailure(err);
    };
    /**
   * Open a file this app cannot draw — a PDF, a scan in a format no browser
   * renders inline — in a new tab.
   *
   * The bytes arrive as a `data:` URI, so this fetches them on demand rather
   * than holding one per row: a files list must not download every attachment
   * to draw a list of names. A blob URL and not the data URI itself, because
   * Chrome refuses top-level navigation to `data:` — the tab would open blank
   * with nothing anywhere saying why.
   */ const openExternal = async (file)=>{
        setFailure(null);
        setFetchingId(file.id);
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)((0, $0cd549c1a257ae26$export$d141e074b4d84050), {
                patientId: patientId,
                fileId: file.id
            });
            if (!data?.visitFileUrl) {
                setFailure(new Error(t('visit.files.previewFailed')));
                return;
            }
            const res = await fetch(data.visitFileUrl);
            const url = URL.createObjectURL(await res.blob());
            window.open(url, '_blank', 'noopener');
            // Released on the next tick rather than immediately: revoking before the
            // new tab has read it leaves that tab blank.
            setTimeout(()=>URL.revokeObjectURL(url), 60000);
        } catch  {
            setFailure(new Error(t('visit.files.previewFailed')));
        } finally{
            setFetchingId(null);
        }
    };
    // The pane's own shape — the upload form and the file cards — never a
    // centred spinner (DESIGN.md §"Loading & skeleton").
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$2d1fa618f1153557), {
        label: t('common.loading')
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "alert",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('visit.files.error.title'),
            description: t('visit.files.error.body'),
            onRetry: reload,
            retryLabel: t('common.actions.retry')
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "visit-files",
        "data-state": rows.length ? 'content' : 'empty',
        children: [
            failure && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                style: {
                    marginBottom: 12
                },
                children: failure.message || t('visit.files.uploadFailed')
            }),
            editable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    borderRadius: 10,
                    padding: 12,
                    marginBottom: 14,
                    background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface2
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.files.kind'),
                                "aria-label": t('visit.files.kind'),
                                placeholder: "",
                                value: kind,
                                onChange: (e)=>setKind(e.target.value),
                                options: [
                                    {
                                        value: 'image',
                                        label: t('visit.files.kinds.image')
                                    },
                                    {
                                        value: 'document',
                                        label: t('visit.files.kinds.document')
                                    }
                                ]
                            }),
                            kind === 'image' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.files.viewType'),
                                "aria-label": t('visit.files.viewType'),
                                placeholder: "",
                                value: viewType,
                                onChange: (e)=>setViewType(e.target.value),
                                options: (0, $2c51377d39509d2c$export$4ed55f6519d0435b).map((v)=>({
                                        value: v,
                                        label: t(`visit.files.viewTypes.${v}`)
                                    }))
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                label: t('visit.files.docType'),
                                "aria-label": t('visit.files.docType'),
                                placeholder: "",
                                value: documentType,
                                onChange: (e)=>setDocumentType(e.target.value),
                                options: (0, $0cd549c1a257ae26$export$ca410b253ced059c).map((d)=>({
                                        value: d,
                                        label: t(`visit.files.docTypes.${d}`)
                                    }))
                            })
                        ]
                    }),
                    kind === 'image' && selectedTooth && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 14,
                            marginTop: 10
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a6c6e1277da35de$export$2e2bcd8739ae039), {
                            checked: attachTooth,
                            onChange: setAttachTooth,
                            label: t('visit.files.attachTooth', {
                                fdi: formatNumber(selectedTooth)
                            }),
                            className: "min-h-11"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            marginTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                ref: inputRef,
                                type: "file",
                                onChange: onPick,
                                accept: kind === 'image' ? $23347f4af3778820$var$IMAGE_ACCEPT : $23347f4af3778820$var$DOCUMENT_ACCEPT,
                                style: {
                                    display: 'none'
                                },
                                "aria-hidden": "true",
                                tabIndex: -1
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                className: "min-h-11",
                                onClick: ()=>inputRef.current?.click(),
                                disabled: uploading,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $557120626e51c22d$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": true,
                                        style: {
                                            marginInlineEnd: 5
                                        }
                                    }),
                                    uploading ? t('visit.files.uploading') : t('visit.files.upload')
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 6
                        },
                        children: t('visit.files.plainUploadNote')
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "info",
                style: {
                    marginBottom: 12
                },
                children: t('visit.readOnly.note')
            }),
            rows.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8745eaf007923a88$export$2e2bcd8739ae039), {
                    size: 40,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('visit.files.empty.title'),
                description: t('visit.files.empty.description')
            }) : rows.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($23347f4af3778820$var$FileCard, {
                    f: f,
                    t: t,
                    formatNumber: formatNumber,
                    formatDate: formatDate,
                    editable: editable,
                    busy: busyFileId === f.id || fetchingId === f.id,
                    onDelete: drop,
                    onOpen: (file)=>setOpenId(file.id),
                    onOpenExternal: openExternal,
                    onRunOcr: async (file)=>{
                        setFailure(null);
                        const err = await runOcr(file.id, file.documentType);
                        if (err) setFailure(err);
                    }
                }, f.id)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
                open: !!openFile,
                onOpenChange: (next)=>{
                    if (!next) requestClose();
                },
                children: openFile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
                    className: "max-w-[min(1180px,96vw)]",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                                children: openFile.fileName
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $410d71b87c2b8a75$export$2e2bcd8739ae039), {
                            file: openFile,
                            url: fileUrl.url,
                            loadingUrl: fileUrl.loading,
                            urlFailed: fileUrl.failed,
                            editable: editable,
                            busy: busyFileId === openFile.id,
                            compact: compact,
                            view: viewOf(openFile.id),
                            onViewChange: (v)=>setViews((all)=>({
                                        ...all,
                                        [openFile.id]: v
                                    })),
                            onDirtyChange: setDirty,
                            onBack: requestClose,
                            onSave: (marks)=>saveAnnotations(openFile.id, marks),
                            onAnalyze: ()=>analyze(openFile.id),
                            onRegister: (viewType)=>register(openFile.id, viewType, openFile.teethFdi),
                            onConfirmFinding: confirmFinding,
                            t: t,
                            formatDate: formatDate,
                            formatNumber: formatNumber
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3d370aebf1b917$export$2e2bcd8739ae039), {
                open: confirmDiscard,
                onOpenChange: setConfirmDiscard,
                title: t('visit.image.discard.title'),
                description: t('visit.image.discard.body'),
                confirmLabel: t('visit.image.discard.confirm'),
                cancelLabel: t('common.actions.cancel'),
                destructive: true,
                onConfirm: ()=>{
                    setConfirmDiscard(false);
                    closeNow();
                }
            })
        ]
    });
}





// جلسهٔ درمان — the desktop visit workspace (dentist-app/docs/dent-visit.md §2).
//
// ┌───────────────────────────────┬──────────────────────────────┐
// │ LEFT — dynamic workspace      │ RIGHT — persistent clinical  │
// │  دارو · دستورات · تشخیص       │  ① odontogram                │
// │  پرسش · فایل‌ها               │  ② subjective (SOAP)         │
// │  ┌─────────────────────────┐  │  ③ اقدام درمانی و پلن درمان  │
// │  │ the active pane         │  │                              │
// │  └─────────────────────────┘  │  vertically stacked, static  │
// └───────────────────────────────┴──────────────────────────────┘
//
// The RIGHT column is first in the DOM and second on screen, and that is
// deliberate on an RTL surface: `direction: rtl` lays grid columns right-to-
// left, so the first child IS the right-hand one. §2 puts the persistent
// clinical view on the right — in the reading-start position for Persian — and
// the dynamic workspace on the left.
//
// EACH COLUMN SCROLLS INDEPENDENTLY. §2's whole claim for the right column is
// that "the clinician always has the patient's dental context in view"; one
// page scroll would carry the odontogram off the top the moment the dentist
// worked down a long orders list.
//
// ── One state, shared by both columns ──────────────────────────────────────
// `selectedTooth` lives HERE rather than inside the odontogram, because it is
// what ties the two halves together: selecting a tooth on the arch fills the
// subjective's tooth chips and pre-fills a plan line, and clicking a plan line
// or a diagnosis's chart evidence selects it back. §3.1.3's "link treatments
// directly to specific teeth on the Odontogram" runs in both directions, and a
// selection owned by one section could only run in one.
const $9ef55795e996d715$var$VisitWeb = ({ appointmentId: appointmentId, tab: tab, setTab: setTab, goBack: goBack })=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { visit: visit, loading: loading, error: error, reload: reload, completing: completing, complete: complete, followUpOutcome: followUpOutcome } = (0, $cfeee402cf40bab0$export$8ad4ab361a8a3764)(appointmentId);
    // The ids EVERY section scopes on come from the server's answer about this
    // appointment, never from the URL.
    const patientId = visit?.patientId || null;
    const clinicId = visit?.clinicId || null;
    const editable = (0, $0cd549c1a257ae26$export$d8fa188a7f68dae7)(visit);
    // ویزیت تصویری. `probe` only asks whether this deployment offers a call and
    // whether this visit could host one — it mints nothing and starts nothing.
    // The camera is never touched until «تماس تصویری» is pressed.
    const call = (0, $17cb599564a95c49$export$fd58d87a1fa8fc0d)({
        patientId: patientId,
        appointmentId: appointmentId,
        editable: editable
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        call.probe();
    }, [
        call.probe
    ]);
    const [selectedTooth, setSelectedTooth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Each CLICK on the arch, as an event: `{ fdi, seq }` with a counter that
    // rises on every click, including a repeat click on the tooth already
    // selected. «دندان‌های درگیر» toggles on it, which is how a complaint comes
    // to name several teeth without the chart having to hold a selection SET.
    const [toothPick, setToothPick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const pickTooth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi)=>setToothPick((prev)=>({
                fdi: fdi,
                seq: (prev?.seq || 0) + 1
            })), []);
    // A finding ticked on an image in فایل‌ها, on its way to the tooth editor
    // in the odontogram section. Lifted here for the same reason `selectedTooth`
    // is: the two panes that need it are siblings, and neither owns the other.
    const [pendingFinding, setPendingFinding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // A one-shot request from the chart to the plan section: "open your add form
    // for this tooth". Cleared by the plan once it has acted, so it cannot re-fire
    // on an unrelated re-render.
    const [planToothRequest, setPlanToothRequest] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // «پایان جلسه». The subjective form is the only section holding text that is
    // not already persisted, so the screen keeps a handle on it and flushes it
    // before closing — see finishVisit.
    const subjectivePending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [confirmFinish, setConfirmFinish] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // «نوبت بعدی» — held HERE rather than inside the dialog so it survives the
    // re-render while `completeVisit` is in flight, and so `finishVisit` can read
    // what the dentist chose without the dialog handing it back.
    const [followUpInterval, setFollowUpInterval] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $0cd549c1a257ae26$export$f61ae47d7ba2b859));
    const [finishError, setFinishError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const chart = (0, $b11e9ffe8c3f2849$export$26586bb2073aa39c)({
        patientId: patientId,
        clinicId: clinicId
    });
    const note = (0, $cfeee402cf40bab0$export$2f317b9dd5652683)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const priorVisits = (0, $cfeee402cf40bab0$export$1769a418b08dd895)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const plans = (0, $cfeee402cf40bab0$export$29b2b9621f2e7a20)({
        patientId: patientId,
        clinicId: clinicId,
        appointmentId: appointmentId
    });
    const medications = (0, $cfeee402cf40bab0$export$8aa70abf9bd71082)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const orders = (0, $cfeee402cf40bab0$export$cb19eb17ebbbed5)({
        patientId: patientId,
        appointmentId: appointmentId,
        clinicId: clinicId
    });
    const diagnoses = (0, $cfeee402cf40bab0$export$a7f91475e840e5fe)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const assistant = (0, $cfeee402cf40bab0$export$ab4de818ea42408e)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const soap = (0, $cfeee402cf40bab0$export$b7e4201174b0194d)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const files = (0, $cfeee402cf40bab0$export$c28b254de367c08c)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const planTeeth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$c825b1cc6eb6552a)(plans.plans), [
        plans.plans
    ]);
    const tabs = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$bc2c85ac4003b25)(t), [
        t
    ]);
    // Until the visit ITSELF resolves nothing else can start, so the whole
    // workspace draws its own shape — header band, the three rail panels, the
    // tab strip and the pane the URL names (DESIGN.md §"Loading & skeleton").
    // Afterwards each region skeletons alone, inside its real Panel.
    if (loading && !visit) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$ba9edad9ecba4e47), {
        t: t,
        tab: tab,
        label: t('common.loading')
    });
    // A failed read and a visit that does not exist are different facts: only one
    // of them is worth a retry button.
    if (error && !visit) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "visit-error",
        "data-state": "error",
        role: "alert",
        style: {
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            padding: 28
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('visit.error.title'),
                description: t('visit.error.body'),
                onRetry: reload,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    if (!visit) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "visit-content",
        "data-state": "empty",
        style: {
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            padding: 28
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8139bc0e06cf9ce5$export$2e2bcd8739ae039), {
                    size: 44,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('visit.notFound.title'),
                description: t('visit.notFound.description'),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    onClick: goBack,
                    children: t('common.actions.back')
                })
            })
        })
    });
    const patient = visit.patient;
    const meta = [
        visit.dateTime ? formatDate(Number(visit.dateTime), 'full') : null,
        patient?.fileNumber ? `${t('common.labels.fileNumber')}${t('common.punct.colon')} ${patient.fileNumber}` : null,
        patient?.age != null ? t('common.units.years', {
            count: patient.age
        }) : null
    ].filter(Boolean);
    /**
   * Save what is unsaved, then close the visit.
   *
   * ORDER MATTERS AND IS NOT REVERSIBLE. `completed` makes every write on this
   * screen refuse, and this app has no way to reopen an appointment — so the
   * flush goes first and a failed flush ABORTS the close. Closing first and
   * saving after would lose the note with no way back in.
   *
   * Only the subjective is flushed because only it holds unsaved state: an
   * order is written by «ثبت دستور», a plan line by its own save, a tooth event
   * as it is charted. There is nothing else pending to collect.
   */ const finishVisit = async ()=>{
        setFinishError(null);
        const pending = subjectivePending.current;
        if (pending?.dirty) {
            const saveErr = await pending.submit();
            if (saveErr) {
                setFinishError({
                    kind: 'subjective'
                });
                setConfirmFinish(false);
                return;
            }
        }
        // The outstanding lines are what the dialog just showed, so the duration the
        // desk is asked to book is the longest of THOSE — not the doctor's standard
        // slot, which is a consultation and not a restoration.
        const leftUndone = (0, $0cd549c1a257ae26$export$f5a44d3156f7523c)(plans.plans, plans.records);
        const err = await complete(patientId, (0, $0cd549c1a257ae26$export$c9843a8a10355e58)(followUpInterval, Date.now(), (0, $0cd549c1a257ae26$export$c4397ce7b585cc7c)(leftUndone, plans.catalog)));
        if (err) {
            // Prefer the SERVICE's own sentence over the generic one. Scheduling
            // refuses transitions for reasons the dentist can act on — a cancelled
            // appointment, a desk that moved it — and «بستن جلسه ممکن نشد» hides
            // every one of them behind the same six words.
            setFinishError({
                kind: 'complete',
                message: err?.message || null
            });
            setConfirmFinish(false);
            return;
        }
        setConfirmFinish(false);
        // The visit is closed and the screen goes read-only, so the ONLY way the
        // dentist learns whether the desk was told is this line. `unavailable` gets
        // its own sentence rather than silence — a prompt that failed to raise is a
        // patient who may never be called back.
        toast.success((0, $8b9d79adaff552ef$export$f3c16bd6689f1c86)(t, followUpOutcome.current));
    };
    const paneProps = {
        visit: visit,
        patient: patient,
        editable: editable,
        selectedTooth: selectedTooth,
        onSelectTooth: setSelectedTooth
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c79ee8367a72d83$export$2e2bcd8739ae039), {
                onBack: goBack,
                backLabel: t('common.actions.back'),
                title: patient?.name || t('visit.unknownPatient'),
                avatar: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4d30a9c02b68374$export$2e2bcd8739ae039), {
                    name: patient?.name || (0, $c53f9539af19d960$export$69b8321e9fbf06df)(),
                    src: patient?.avatarUrl,
                    size: 44,
                    bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                }),
                meta: meta,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8
                    },
                    children: [
                        visit.status && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            children: t(`today.status.${visit.status}`)
                        }),
                        !editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                            variant: "outline",
                            children: t('visit.readOnly.badge')
                        }),
                        call.available && !call.live && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: call.start,
                            disabled: call.busy,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d97ad00fbef0d0b$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                call.busy ? t('visit.call.connecting') : t('visit.call.start')
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            variant: "outline",
                            onClick: ()=>navigate('patient', {
                                    id: patientId
                                }),
                            children: t('visit.openRecord')
                        }),
                        editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                            onClick: ()=>setConfirmFinish(true),
                            disabled: completing,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                                    size: 16,
                                    "aria-hidden": true
                                }),
                                completing ? t('visit.finish.working') : t('visit.finish.action')
                            ]
                        })
                    ]
                })
            }),
            finishError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "alert",
                style: {
                    padding: '0 24px 12px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                    variant: "error",
                    title: t(`visit.finish.error.${finishError.kind}`),
                    children: finishError.message || null
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b9d79adaff552ef$export$2e2bcd8739ae039), {
                open: confirmFinish,
                onOpenChange: setConfirmFinish,
                onConfirm: finishVisit,
                loading: completing,
                t: t,
                formatNumber: formatNumber,
                outstanding: (0, $0cd549c1a257ae26$export$f5a44d3156f7523c)(plans.plans, plans.records),
                interval: followUpInterval,
                onIntervalChange: setFollowUpInterval
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "visit-content",
                "data-state": "content",
                style: {
                    flex: 1,
                    minHeight: 0,
                    display: 'grid',
                    // The RIGHT column is wider: it carries the odontogram, which has a
                    // fixed aspect ratio and stops being readable when squeezed.
                    //
                    // The first track is the RIGHT one under dir=rtl, and it holds the
                    // first child — the rail. It used to be the 1fr of `1fr 1.05fr`,
                    // which gave the extra width to the workspace instead and made the
                    // comment above describe the opposite of what shipped.
                    gridTemplateColumns: 'minmax(0, 1.15fr) minmax(0, 1fr)',
                    gap: 16,
                    padding: '16px 24px 24px',
                    overflow: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "visit-rail",
                        style: {
                            minHeight: 0,
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 14,
                            paddingInlineEnd: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fca799f36321e610$export$2e2bcd8739ae039), {
                                pendingFinding: pendingFinding,
                                onFindingConsumed: ()=>setPendingFinding(null),
                                patientId: patientId,
                                clinicId: clinicId,
                                t: t,
                                formatNumber: formatNumber,
                                formatDate: formatDate,
                                chart: chart,
                                planTeeth: planTeeth,
                                records: plans.records || [],
                                catalog: plans.catalog || [],
                                appointmentId: appointmentId,
                                selectedTooth: selectedTooth,
                                onSelectTooth: setSelectedTooth,
                                onToothPick: pickTooth,
                                onPlanTooth: setPlanToothRequest,
                                editable: editable
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb3b027aeb752d3$export$2e2bcd8739ae039), {
                                pendingRef: subjectivePending,
                                t: t,
                                formatNumber: formatNumber,
                                formatDate: formatDate,
                                note: note,
                                editable: editable,
                                selectedTooth: selectedTooth,
                                toothPick: toothPick,
                                priorVisits: priorVisits,
                                patient: patient,
                                onOpenPriorVisit: (id)=>navigate('visit', {
                                        appointmentId: id
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bec031a053f3da13$export$2e2bcd8739ae039), {
                                t: t,
                                formatNumber: formatNumber,
                                plans: plans,
                                catalog: plans.catalog,
                                clinicId: clinicId,
                                appointmentId: appointmentId,
                                editable: editable,
                                selectedTooth: selectedTooth,
                                onSelectTooth: setSelectedTooth,
                                addRequestTooth: planToothRequest,
                                onAddRequestHandled: ()=>setPlanToothRequest(null),
                                onChartChanged: chart.reload
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    flexShrink: 0,
                                    marginBottom: 12
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                    options: tabs,
                                    value: tab,
                                    onChange: setTab
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "tabpanel",
                                "aria-label": tabs.find((s)=>s.value === tab)?.label,
                                style: {
                                    flex: 1,
                                    minHeight: 0,
                                    display: 'flex'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                    style: {
                                        flex: 1,
                                        minHeight: 0,
                                        overflowY: 'auto',
                                        padding: 16
                                    },
                                    children: tab === 'orders' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c0611acc345baf3$export$2e2bcd8739ae039), {
                                        orders: orders,
                                        editable: editable
                                    }) : tab === 'diagnosis' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28a017da747dbd19$export$2e2bcd8739ae039), {
                                        diagnoses: diagnoses,
                                        note: note,
                                        files: files.files,
                                        soap: soap,
                                        chart: chart,
                                        ...paneProps
                                    }) : tab === 'questions' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48071389e5f2f37a$export$2e2bcd8739ae039), {
                                        assistant: assistant,
                                        diagnoses: diagnoses,
                                        note: note,
                                        editable: editable
                                    }) : tab === 'files' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23347f4af3778820$export$2e2bcd8739ae039), {
                                        files: files,
                                        visit: visit,
                                        editable: editable,
                                        selectedTooth: selectedTooth,
                                        onConfirmFinding: setPendingFinding
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ba9d4aa464da3d6$export$2e2bcd8739ae039), {
                                        visit: visit,
                                        patient: patient,
                                        editable: editable,
                                        medications: medications
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4695d97a8b3ee9d3$export$2e2bcd8739ae039), {
                call: call,
                patientName: patient?.name
            })
        ]
    });
};
var $9ef55795e996d715$export$2e2bcd8739ae039 = $9ef55795e996d715$var$VisitWeb;




var $acw62 = parcelRequire("acw62");





















// جلسهٔ درمان on a phone (DESIGN-CONCEPT-MOBILE §4C, applied to a workspace).
//
// ┌──────────────────────────────────────┐
// │ ① MobileHeader — CONTENT mode        │  ← back · patient · date
// │ ② MobileAllergyStrip — STICKY        │  never scrolls off
// │ ③ the persistent clinical view       │  odontogram, then subjective and
// │    (odontogram always open; the two  │  طرح درمان as collapsibles
// │     others collapsible)              │
// │ ④ SectionNav — STICKY                │  دارو · دستورات · تشخیص · …
// │ ⑤ the active pane                    │
// └──────────────────────────────────────┘
//
// ── Why this is not the desktop layout reflowed ────────────────────────────
// §2's two columns cannot both be columns at 390px — halving the viewport
// would leave the odontogram at roughly 180px wide, and a crown is ~10px on a
// phone already. So the two columns become two REGIONS of one scroll, in the
// order the document gives them: the persistent clinical view first, the
// dynamic workspace under it.
//
// What §2 actually asks for is that the dental context is never more than a
// glance away, and on a phone that is answered by keeping the ARCH at the top
// with the allergy strip pinned above it and the pane navigator pinned below —
// not by splitting a phone in half.
//
// ── The odontogram is rendered VERBATIM ────────────────────────────────────
// Not forked, not zoomed, not wrapped in a transform. CORE.md §9 makes the
// patient's anatomical frame a safety invariant, and it holds on this surface
// exactly as it does on چارت دندان's.
//
// ── No bottom nav ──────────────────────────────────────────────────────────
// §4C: a drilled-into full-screen surface carries its own way back in the
// header. A bar offering «بیماران» here is an escape hatch out of a visit the
// dentist is halfway through documenting.
const $733b563b5e3db94b$var$VisitMobile = ({ appointmentId: appointmentId, tab: tab, setTab: setTab, goBack: goBack })=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { visit: visit, loading: loading, error: error, reload: reload, completing: completing, complete: complete, followUpOutcome: followUpOutcome } = (0, $cfeee402cf40bab0$export$8ad4ab361a8a3764)(appointmentId);
    const patientId = visit?.patientId || null;
    const clinicId = visit?.clinicId || null;
    const editable = (0, $0cd549c1a257ae26$export$d8fa188a7f68dae7)(visit);
    // ویزیت تصویری — the SAME hook the desktop surface uses. Two surfaces, one
    // behaviour: the panel and every rule about when a call may start live in
    // shared code, and only the chrome around them differs.
    const call = (0, $17cb599564a95c49$export$fd58d87a1fa8fc0d)({
        patientId: patientId,
        appointmentId: appointmentId,
        editable: editable
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        call.probe();
    }, [
        call.probe
    ]);
    const [selectedTooth, setSelectedTooth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Each CLICK on the arch, as an event: `{ fdi, seq }` with a counter that
    // rises on every click, including a repeat click on the tooth already
    // selected. «دندان‌های درگیر» toggles on it, which is how a complaint comes
    // to name several teeth without the chart having to hold a selection SET.
    const [toothPick, setToothPick] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const pickTooth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fdi)=>setToothPick((prev)=>({
                fdi: fdi,
                seq: (prev?.seq || 0) + 1
            })), []);
    // A finding ticked on an image in فایل‌ها, on its way to the tooth editor
    // in the odontogram section. Lifted here for the same reason `selectedTooth`
    // is: the two panes that need it are siblings, and neither owns the other.
    const [pendingFinding, setPendingFinding] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [planToothRequest, setPlanToothRequest] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // «پایان جلسه», the desktop surface's contract verbatim. The subjective form
    // is the only section holding text that is not already persisted, so the
    // screen keeps a handle on it and flushes it before closing.
    const subjectivePending = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [confirmFinish, setConfirmFinish] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // «نوبت بعدی» — held HERE rather than inside the dialog so it survives the
    // re-render while `completeVisit` is in flight, and so `finishVisit` can read
    // what the dentist chose without the dialog handing it back.
    const [followUpInterval, setFollowUpInterval] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $0cd549c1a257ae26$export$f61ae47d7ba2b859));
    const [finishError, setFinishError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const chart = (0, $b11e9ffe8c3f2849$export$26586bb2073aa39c)({
        patientId: patientId,
        clinicId: clinicId
    });
    const note = (0, $cfeee402cf40bab0$export$2f317b9dd5652683)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const priorVisits = (0, $cfeee402cf40bab0$export$1769a418b08dd895)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const plans = (0, $cfeee402cf40bab0$export$29b2b9621f2e7a20)({
        patientId: patientId,
        clinicId: clinicId,
        appointmentId: appointmentId
    });
    const medications = (0, $cfeee402cf40bab0$export$8aa70abf9bd71082)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const orders = (0, $cfeee402cf40bab0$export$cb19eb17ebbbed5)({
        patientId: patientId,
        appointmentId: appointmentId,
        clinicId: clinicId
    });
    const diagnoses = (0, $cfeee402cf40bab0$export$a7f91475e840e5fe)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const assistant = (0, $cfeee402cf40bab0$export$ab4de818ea42408e)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const soap = (0, $cfeee402cf40bab0$export$b7e4201174b0194d)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const files = (0, $cfeee402cf40bab0$export$c28b254de367c08c)({
        patientId: patientId,
        appointmentId: appointmentId
    });
    const planTeeth = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$c825b1cc6eb6552a)(plans.plans), [
        plans.plans
    ]);
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $0cd549c1a257ae26$export$bc2c85ac4003b25)(t), [
        t
    ]);
    const navItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>sections.map(({ value: value, label: label, Icon: Icon })=>({
                key: value,
                label: label,
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 16,
                    "aria-hidden": true
                })
            })), [
        sections
    ]);
    // The workspace's OWN mobile shape — the gradient band, the arch panel, the
    // two folded panels, the pane navigator and the pane the URL names — never a
    // generic card stack (DESIGN.md §"Loading & skeleton").
    if (loading && !visit) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1d8c09d19ce3644$export$301e0800f4263bf6), {
        t: t,
        tab: tab,
        label: t('common.loading')
    });
    if (error && !visit) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "visit-content",
        "data-state": "error",
        role: "alert",
        style: {
            padding: '0.875rem 0.75rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('visit.error.title'),
            description: t('visit.error.body'),
            onRetry: reload,
            retryLabel: t('common.actions.retry')
        })
    });
    if (!visit) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "visit-content",
        "data-state": "empty",
        style: {
            padding: '0.875rem 0.75rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8139bc0e06cf9ce5$export$2e2bcd8739ae039), {
                    size: 40,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                }),
                title: t('visit.notFound.title'),
                description: t('visit.notFound.description'),
                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    variant: "outline",
                    className: "min-h-11",
                    onClick: goBack,
                    children: t('common.actions.back')
                })
            })
        })
    });
    const patient = visit.patient;
    /**
   * Save what is unsaved, then close the visit — the desktop's `finishVisit`,
   * same order and same irreversibility.
   *
   * `completed` makes every write on this screen refuse and this app cannot
   * reopen an appointment, so the flush goes FIRST and a failed flush aborts
   * the close. Only the subjective is flushed because only it holds unsaved
   * state: an order is written by «ثبت دستور», a plan line by its own save, a
   * tooth event as it is charted.
   */ const finishVisit = async ()=>{
        setFinishError(null);
        const pending = subjectivePending.current;
        if (pending?.dirty) {
            const saveErr = await pending.submit();
            if (saveErr) {
                setFinishError({
                    kind: 'subjective'
                });
                setConfirmFinish(false);
                return;
            }
        }
        // The outstanding lines are what the dialog just showed, so the duration the
        // desk is asked to book is the longest of THOSE — not the doctor's standard
        // slot, which is a consultation and not a restoration.
        const leftUndone = (0, $0cd549c1a257ae26$export$f5a44d3156f7523c)(plans.plans, plans.records);
        const err = await complete(patientId, (0, $0cd549c1a257ae26$export$c9843a8a10355e58)(followUpInterval, Date.now(), (0, $0cd549c1a257ae26$export$c4397ce7b585cc7c)(leftUndone, plans.catalog)));
        if (err) {
            // The SERVICE's own sentence over the generic one: scheduling refuses a
            // transition for reasons the dentist can act on.
            setFinishError({
                kind: 'complete',
                message: err?.message || null
            });
            setConfirmFinish(false);
            return;
        }
        setConfirmFinish(false);
        // The visit is closed and the screen goes read-only, so the ONLY way the
        // dentist learns whether the desk was told is this line. `unavailable` gets
        // its own sentence rather than silence — a prompt that failed to raise is a
        // patient who may never be called back.
        toast.success((0, $8b9d79adaff552ef$export$f3c16bd6689f1c86)(t, followUpOutcome.current));
    };
    const subtitle = [
        visit.dateTime ? formatDate(Number(visit.dateTime), 'numeric') : null,
        visit.status ? t(`today.status.${visit.status}`) : null
    ].filter(Boolean).join(" \xb7 ");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "visit-content",
        "data-state": "content",
        style: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                onBack: goBack,
                backLabel: t('common.actions.back'),
                title: patient?.name || t('visit.unknownPatient'),
                subtitle: subtitle || undefined,
                "data-testid": "visit-header",
                actions: [
                    // Offered only when the deployment has a media server and this visit
                    // is still open — the same condition the desktop header uses.
                    ...call.available && !call.live ? [
                        {
                            key: 'call',
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d97ad00fbef0d0b$export$2e2bcd8739ae039), {
                                size: 18,
                                "aria-hidden": true
                            }),
                            label: t('visit.call.start'),
                            onClick: call.start
                        }
                    ] : [],
                    {
                        key: 'record',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df9771111904a5d5$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": true
                        }),
                        label: t('visit.openRecord'),
                        onClick: ()=>navigate('patient', {
                                id: patientId
                            })
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 3,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae4443ff62155701$export$2e2bcd8739ae039), {
                    allergies: patient?.allergies || []
                })
            }),
            !editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '0.5rem 0.75rem 0'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                    variant: "outline",
                    children: t('visit.readOnly.badge')
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '0.75rem 0.75rem 0'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fca799f36321e610$export$2e2bcd8739ae039), {
                        pendingFinding: pendingFinding,
                        onFindingConsumed: ()=>setPendingFinding(null),
                        patientId: patientId,
                        clinicId: clinicId,
                        t: t,
                        formatNumber: formatNumber,
                        formatDate: formatDate,
                        chart: chart,
                        planTeeth: planTeeth,
                        records: plans.records || [],
                        catalog: plans.catalog || [],
                        appointmentId: appointmentId,
                        selectedTooth: selectedTooth,
                        onSelectTooth: setSelectedTooth,
                        onToothPick: pickTooth,
                        onPlanTooth: setPlanToothRequest,
                        editable: editable
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            height: '0.75rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9eb3b027aeb752d3$export$2e2bcd8739ae039), {
                        collapsible: true,
                        defaultOpen: false,
                        pendingRef: subjectivePending,
                        t: t,
                        formatNumber: formatNumber,
                        formatDate: formatDate,
                        note: note,
                        editable: editable,
                        selectedTooth: selectedTooth,
                        toothPick: toothPick,
                        priorVisits: priorVisits,
                        patient: patient,
                        onOpenPriorVisit: (id)=>navigate('visit', {
                                appointmentId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            height: '0.5rem'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bec031a053f3da13$export$2e2bcd8739ae039), {
                        collapsible: true,
                        defaultOpen: false,
                        t: t,
                        formatNumber: formatNumber,
                        plans: plans,
                        catalog: plans.catalog,
                        clinicId: clinicId,
                        appointmentId: appointmentId,
                        editable: editable,
                        selectedTooth: selectedTooth,
                        onSelectTooth: setSelectedTooth,
                        addRequestTooth: planToothRequest,
                        onAddRequestHandled: ()=>setPlanToothRequest(null),
                        onChartChanged: chart.reload
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                    marginTop: '0.75rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd795e2724b3b1d0$export$2e2bcd8739ae039), {
                    items: navItems,
                    active: tab,
                    onSelect: setTab,
                    ariaLabel: t('visit.tabs.sectionsLabel'),
                    "data-testid": "visit-nav"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "tabpanel",
                "aria-label": sections.find((s)=>s.value === tab)?.label,
                style: {
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.875rem',
                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface
                    },
                    children: tab === 'orders' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c0611acc345baf3$export$2e2bcd8739ae039), {
                        orders: orders,
                        editable: editable
                    }) : tab === 'diagnosis' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28a017da747dbd19$export$2e2bcd8739ae039), {
                        diagnoses: diagnoses,
                        note: note,
                        files: files.files,
                        soap: soap,
                        chart: chart,
                        visit: visit,
                        patient: patient,
                        editable: editable,
                        selectedTooth: selectedTooth,
                        onSelectTooth: setSelectedTooth
                    }) : tab === 'questions' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48071389e5f2f37a$export$2e2bcd8739ae039), {
                        assistant: assistant,
                        diagnoses: diagnoses,
                        note: note,
                        editable: editable
                    }) : tab === 'files' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23347f4af3778820$export$2e2bcd8739ae039), {
                        files: files,
                        visit: visit,
                        editable: editable,
                        selectedTooth: selectedTooth,
                        compact: true,
                        onConfirmFinding: setPendingFinding
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ba9d4aa464da3d6$export$2e2bcd8739ae039), {
                        visit: visit,
                        patient: patient,
                        editable: editable,
                        medications: medications
                    })
                })
            }),
            editable && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 4,
                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    padding: '0.75rem 0.75rem calc(0.75rem + env(safe-area-inset-bottom, 0px))'
                },
                children: [
                    finishError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        role: "alert",
                        style: {
                            marginBottom: '0.625rem'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "error",
                            title: t(`visit.finish.error.${finishError.kind}`),
                            children: finishError.message || null
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: ()=>setConfirmFinish(true),
                        disabled: completing,
                        className: "w-full min-h-11",
                        "data-testid": "visit-finish",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8cb58a0e56c12463$export$2e2bcd8739ae039), {
                                size: 16,
                                "aria-hidden": true
                            }),
                            completing ? t('visit.finish.working') : t('visit.finish.action')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b9d79adaff552ef$export$2e2bcd8739ae039), {
                open: confirmFinish,
                onOpenChange: setConfirmFinish,
                onConfirm: finishVisit,
                loading: completing,
                t: t,
                formatNumber: formatNumber,
                outstanding: (0, $0cd549c1a257ae26$export$f5a44d3156f7523c)(plans.plans, plans.records),
                interval: followUpInterval,
                onIntervalChange: setFollowUpInterval,
                testId: "visit-finish-confirm",
                confirmTestId: "visit-finish-confirm-yes",
                cancelTestId: "visit-finish-confirm-no"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4695d97a8b3ee9d3$export$2e2bcd8739ae039), {
                call: call,
                patientName: patient?.name
            })
        ]
    });
};
var $733b563b5e3db94b$export$2e2bcd8739ae039 = $733b563b5e3db94b$var$VisitMobile;




const $35a05642ffb904d6$export$73b877b58963a4f = (0, $0cd549c1a257ae26$export$a6d374bb1b39867a);
const $35a05642ffb904d6$export$f3adfdcbb472d8e4 = (0, $0cd549c1a257ae26$export$a988734073442de8);
const $35a05642ffb904d6$var$VisitScreen = ()=>{
    const { appointmentId: appointmentId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const rrNavigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const navigate = (0, $53b14620f65a31c3$export$5b61ff3425c1c197)();
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const raw = searchParams.get('tab');
    const tab = $35a05642ffb904d6$export$73b877b58963a4f.includes(raw) ? raw : $35a05642ffb904d6$export$f3adfdcbb472d8e4;
    const setTab = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((next)=>{
        const params = new URLSearchParams(searchParams);
        if (!next || next === $35a05642ffb904d6$export$f3adfdcbb472d8e4) params.delete('tab');
        else params.set('tab', next);
        setSearchParams(params, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    const goBack = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (location.key && location.key !== 'default') rrNavigate(-1);
        else navigate('today');
    }, [
        location.key,
        rrNavigate,
        navigate
    ]);
    const props = {
        appointmentId: appointmentId,
        tab: tab,
        setTab: setTab,
        goBack: goBack
    };
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $733b563b5e3db94b$export$2e2bcd8739ae039), {
        ...props
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ef55795e996d715$export$2e2bcd8739ae039), {
        ...props
    });
};
var $35a05642ffb904d6$export$2e2bcd8739ae039 = $35a05642ffb904d6$var$VisitScreen;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");







// The profile screen's data layer.
//
// ONE query for the whole screen, deliberately: identity, saved appearance and
// shifts arrive together so the screen has a single loading state instead of
// three panels resolving at different moments.
//
// Clinic membership is NOT re-fetched here — it comes from the app-wide clinic
// scope, which every screen already depends on. Asking twice for the same list
// is how two parts of one screen end up disagreeing about which clinics exist.

var $acw62 = parcelRequire("acw62");

const $8db22074202537d3$export$288e9ba00d03b754 = `
  query ProfilePage {
    me { id fullName medicalCode specialty bio isDentist isOnboarded }
    myAppearanceSettings { theme fontSize language }
    myPresences {
      id
      clinicId
      dayOfWeek
      specificDate
      startTimeMinutes
      endTimeMinutes
      isActive
    }
  }
`;
const $8db22074202537d3$export$2bd6bf9cd3be4686 = `
  mutation UpdateDoctorProfile($input: UpdateDoctorProfileInput!) {
    updateDoctorProfile(input: $input) {
      id fullName medicalCode specialty bio isDentist isOnboarded
    }
  }
`;
const $8db22074202537d3$export$4ee51816e42030af = `
  mutation UpdateAppearanceSettings($input: AppearanceSettingsInput!) {
    updateAppearanceSettings(input: $input) { theme fontSize language }
  }
`;
const $8db22074202537d3$export$97fc5255fc3d3b7a = `
  mutation JoinClinicByCode($invitationCode: String!) {
    joinClinicByCode(invitationCode: $invitationCode) {
      id
      clinicId
      status
      clinic { id name city }
    }
  }
`;
function $8db22074202537d3$export$73fc7af4ef9455f4() {
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [nonce, setNonce] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let alive = true;
        setLoading(true);
        (0, $206625c7d33bd390$export$7fb4864174f056c)($8db22074202537d3$export$288e9ba00d03b754).then((res)=>{
            if (!alive) return;
            setData(res);
            setError(null);
        }).catch((err)=>{
            if (!alive) return;
            console.error('[useProfile] failed:', err?.message);
            setError(err);
        }).finally(()=>{
            if (alive) setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, [
        nonce
    ]);
    const reload = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>setNonce((n)=>n + 1), []);
    /**
   * Presence-based partial update: ONLY the keys that actually changed go on
   * the wire, because the service treats an absent field as "leave alone" and a
   * present empty one as "blank it". Sending the whole form would erase a bio
   * the dentist never touched.
   */ const saveProfile = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (changes)=>{
        const result = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($8db22074202537d3$export$2bd6bf9cd3be4686, {
            input: changes
        });
        setData((prev)=>prev ? {
                ...prev,
                me: result?.updateDoctorProfile || prev.me
            } : prev);
        return result?.updateDoctorProfile;
    }, []);
    const saveAppearance = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async (patch)=>{
        const result = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($8db22074202537d3$export$4ee51816e42030af, {
            input: patch
        });
        setData((prev)=>prev ? {
                ...prev,
                myAppearanceSettings: result?.updateAppearanceSettings || prev.myAppearanceSettings
            } : prev);
        return result?.updateAppearanceSettings;
    }, []);
    return {
        me: data?.me || null,
        appearance: data?.myAppearanceSettings || null,
        presences: data?.myPresences || [],
        loading: loading,
        error: error,
        reload: reload,
        saveProfile: saveProfile,
        saveAppearance: saveAppearance
    };
}
var $8db22074202537d3$export$2e2bcd8739ae039 = $8db22074202537d3$export$73fc7af4ef9455f4;



// شیفت‌ها — reading the clinic's presence rows.
//
// Two facts from the scheduling contract that a screen must not re-guess:
//
//   dayOfWeek is 0 = MONDAY … 6 = SUNDAY. It is NOT JS's getDay() (0 = Sunday)
//   and it is NOT the Iranian week (which starts on شنبه). A wrong base here
//   puts a dentist's Saturday shift on a Monday and nothing else breaks, so
//   nothing else catches it.
//
//   startTimeMinutes / endTimeMinutes are Iran wall-clock minutes from midnight,
//   already local. They are NOT epochs and must not go through iranTime.js.
//
// Presence is READ-ONLY in this app: the clinic owns the shift, and the BFF
// exposes no write. Nothing here builds an editable model.
/** The catalogue key for a weekly day. null for a one-off (dayOfWeek -1). */ function $4059084aac03ad2b$export$e21d9c2954945d75(dayOfWeek) {
    const n = Number(dayOfWeek);
    return Number.isInteger(n) && n >= 0 && n <= 6 ? `profile.presence.days.${n}` : null;
}
function $4059084aac03ad2b$export$ba3e9e7b0e0e7e68(minutes) {
    if (minutes == null || minutes === '') return '';
    const n = Number(minutes);
    if (!Number.isFinite(n) || n < 0 || n > 1440) return '';
    const h = Math.floor(n / 60);
    const m = Math.round(n % 60);
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
function $4059084aac03ad2b$export$9c11ed3c9f459806(presence) {
    const start = Number(presence?.startTimeMinutes);
    const end = Number(presence?.endTimeMinutes);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;
    return end - start;
}
function $4059084aac03ad2b$export$b5af444615f1273e(list) {
    return [
        ...list || []
    ].sort((a, b)=>{
        const da = Number(a?.dayOfWeek);
        const db = Number(b?.dayOfWeek);
        const wa = da >= 0 ? 0 : 1;
        const wb = db >= 0 ? 0 : 1;
        if (wa !== wb) return wa - wb;
        if (wa === 0 && da !== db) return da - db;
        if (wa === 1) {
            const sa = Number(a?.specificDate) || 0;
            const sb = Number(b?.specificDate) || 0;
            if (sa !== sb) return sa - sb;
        }
        return (Number(a?.startTimeMinutes) || 0) - (Number(b?.startTimeMinutes) || 0);
    });
}




parcelRequire("acw62");





/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6219358252a45071$export$a2387ed3b5d536eb = {
    name: "building-complex",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M10 12h4",
                key: "a56b0p"
            }
        ],
        [
            "path",
            {
                d: "M10 8h4",
                key: "1sr2af"
            }
        ],
        [
            "path",
            {
                d: "M14 21v-3a2 2 0 0 0-4 0v3",
                key: "1rgiei"
            }
        ],
        [
            "path",
            {
                d: "M6 10H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2",
                key: "secmi2"
            }
        ],
        [
            "path",
            {
                d: "M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16",
                key: "16ra0t"
            }
        ]
    ],
    aliases: [
        "building-2"
    ]
};
$6219358252a45071$export$a2387ed3b5d536eb.node;
const $6219358252a45071$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($6219358252a45071$export$a2387ed3b5d536eb);

/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f4f73b3410e8104a$export$a2387ed3b5d536eb = {
    name: "palette",
    size: 24,
    node: [
        [
            "path",
            {
                d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
                key: "e79jfc"
            }
        ],
        [
            "circle",
            {
                cx: "13.5",
                cy: "6.5",
                r: ".5",
                fill: "currentColor",
                key: "1okk4w"
            }
        ],
        [
            "circle",
            {
                cx: "17.5",
                cy: "10.5",
                r: ".5",
                fill: "currentColor",
                key: "f64h9f"
            }
        ],
        [
            "circle",
            {
                cx: "6.5",
                cy: "12.5",
                r: ".5",
                fill: "currentColor",
                key: "qy21gx"
            }
        ],
        [
            "circle",
            {
                cx: "8.5",
                cy: "7.5",
                r: ".5",
                fill: "currentColor",
                key: "fotxhn"
            }
        ]
    ]
};
$f4f73b3410e8104a$export$a2387ed3b5d536eb.node;
const $f4f73b3410e8104a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($f4f73b3410e8104a$export$a2387ed3b5d536eb);



const $19bde4c4267c7fe2$export$10b2fbb63cdee6f3 = (t)=>[
        {
            value: 'identity',
            label: t('profile.sections.identity'),
            Icon: (0, $7cb92f499384d208$export$2e2bcd8739ae039)
        },
        {
            value: 'clinics',
            label: t('profile.sections.clinics'),
            Icon: (0, $6219358252a45071$export$2e2bcd8739ae039)
        },
        {
            value: 'presence',
            label: t('profile.sections.presence'),
            Icon: (0, $87513a585d30c268$export$2e2bcd8739ae039)
        },
        {
            value: 'appearance',
            label: t('profile.sections.appearance'),
            Icon: (0, $f4f73b3410e8104a$export$2e2bcd8739ae039)
        }
    ];
const $19bde4c4267c7fe2$export$aece9465b5528b4c = (t)=>Object.keys((0, $94f36eaf2deb686d$export$4c4b683c586ca56e)).map((id)=>({
            value: id,
            label: t(`profile.language.${id}`)
        }));
const $19bde4c4267c7fe2$export$c1614f8d1bd73615 = [
    'identity',
    'clinics',
    'presence',
    'appearance'
];
const $19bde4c4267c7fe2$export$f47a0b5412f0d5de = 'identity';
const $19bde4c4267c7fe2$export$e6909ad44e61103d = [
    'fullName',
    'medicalCode',
    'bio'
];
const $19bde4c4267c7fe2$export$9f0a6e17ab0cd0a6 = (saved)=>Boolean((saved?.medicalCode || '').trim());
const $19bde4c4267c7fe2$export$b8801ea43165ed7d = (me)=>Object.fromEntries($19bde4c4267c7fe2$export$e6909ad44e61103d.map((k)=>[
            k,
            me?.[k] ?? ''
        ]));
const $19bde4c4267c7fe2$export$a32373c71666f903 = (form, saved)=>Object.fromEntries($19bde4c4267c7fe2$export$e6909ad44e61103d.filter((k)=>!(k === 'medicalCode' && $19bde4c4267c7fe2$export$9f0a6e17ab0cd0a6(saved))).filter((k)=>(form[k] || '').trim() !== (saved[k] || '').trim()).map((k)=>[
            k,
            (form[k] || '').trim()
        ]));
const $19bde4c4267c7fe2$export$910b6cdd390341b3 = (form, saved)=>Object.keys($19bde4c4267c7fe2$export$a32373c71666f903(form, saved)).length > 0;
var $19bde4c4267c7fe2$export$2e2bcd8739ae039 = $19bde4c4267c7fe2$export$10b2fbb63cdee6f3;


// پروفایل — the loading shape of the profile screen, per section.
//
// The page title is REAL (it is a translated string, known before the data),
// and so is nothing else: the section strip and the section body shimmer in
// the shape of whichever `?tab=` the URL names, so a reload on the presence
// section draws shift rows, not identity fields.
//   identity    the three-field form + bio textarea (web: in a Panel with a
//               ذخیره button; mobile: in a Card)
//   clinics     membership rows + the «پیوستن با کد» form
//   presence    weekly shift rows
//   appearance  the theme preset grid + two segmented controls
// ── section bodies ──────────────────────────────────────────────────────────
const $65b88bee8cd184fd$var$IdentityFields = ({ mobile: mobile })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: mobile ? {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.75rem'
                } : {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                    gap: 14
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                        labelWidth: 72
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                        labelWidth: 88
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                        labelWidth: 64
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    marginTop: mobile ? '0.75rem' : 14
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                    labelWidth: 56,
                    multiline: true
                })
            })
        ]
    });
const $65b88bee8cd184fd$var$PresetGrid = ({ mobile: mobile })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: mobile ? '0.5rem' : 10
        },
        children: Array.from({
            length: 5
        }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: mobile ? 96 : 120,
                height: mobile ? 44 : 64,
                radius: 12
            }, i))
    });
const $65b88bee8cd184fd$var$WEB_SECTION = {
    identity: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 96,
                height: 14
            }),
            action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                width: 96
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($65b88bee8cd184fd$var$IdentityFields, {})
        }),
    clinics: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 14
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 110,
                        height: 14
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$543533cea58d4261), {
                        count: 2,
                        gap: 20
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 120,
                        height: 14
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            gap: 10,
                            alignItems: 'flex-end'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                                labelWidth: 96,
                                style: {
                                    flex: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                                width: 112
                            })
                        ]
                    })
                })
            ]
        }),
    presence: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
            title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 110,
                height: 14
            }),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$543533cea58d4261), {
                count: 4,
                gap: 16
            })
        }),
    appearance: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: 14
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 72,
                        height: 14
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($65b88bee8cd184fd$var$PresetGrid, {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 14
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f51fccaec5c96c2a), {
                        count: 3
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 64,
                        height: 14
                    }),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f51fccaec5c96c2a), {
                        count: 2
                    })
                })
            ]
        })
};
const $65b88bee8cd184fd$var$MOBILE_SECTION = {
    identity: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            style: {
                padding: '0.875rem'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($65b88bee8cd184fd$var$IdentityFields, {
                mobile: true
            })
        }),
    clinics: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 12
                    })
                }),
                [
                    0,
                    1
                ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        style: {
                            padding: '0.875rem',
                            marginBottom: '0.5rem'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: "50%",
                                            height: 14
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                            width: "30%",
                                            height: 11
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                                    width: 56,
                                    height: 22,
                                    radius: 999
                                })
                            ]
                        })
                    }, i)),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                    style: {
                        marginTop: '0.875rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 120,
                        height: 12
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.875rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.75rem'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$5ce4f4d8e50e2948), {
                            labelWidth: 96
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$7387c3f2666b9f16), {
                            width: "100%"
                        })
                    ]
                })
            ]
        }),
    presence: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 12
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.25rem 0.875rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$1d36da46ad5622dc), {
                        count: 4
                    })
                })
            ]
        }),
    appearance: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 72,
                        height: 12
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.875rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($65b88bee8cd184fd$var$PresetGrid, {
                        mobile: true
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                    style: {
                        marginTop: '0.875rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 96,
                        height: 12
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.875rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f51fccaec5c96c2a), {
                        count: 3
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                    style: {
                        marginTop: '0.875rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: 64,
                        height: 12
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                    style: {
                        padding: '0.875rem'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f51fccaec5c96c2a), {
                        count: 2
                    })
                })
            ]
        })
};
const $65b88bee8cd184fd$export$a74d55cc79ab1d0f = ({ section: section = 'identity', label: label, title: title, sub: sub })=>{
    const Body = $65b88bee8cd184fd$var$WEB_SECTION[section] || $65b88bee8cd184fd$var$WEB_SECTION.identity;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "profile-content",
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: title,
                sub: sub
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    padding: '20px 32px 40px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginBottom: 16
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$f51fccaec5c96c2a), {
                            count: (0, $19bde4c4267c7fe2$export$c1614f8d1bd73615).length
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Body, {})
                ]
            })
        ]
    });
};
const $65b88bee8cd184fd$export$62620c16ce51c0dc = ({ section: section = 'identity', label: label })=>{
    const Body = $65b88bee8cd184fd$var$MOBILE_SECTION[section] || $65b88bee8cd184fd$var$MOBILE_SECTION.identity;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "profile-content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$4c127c4db7b36f7f), {
                greeting: true,
                subtitle: false
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ce57f089cb4321$export$52fa1d077274aab0), {
                count: (0, $19bde4c4267c7fe2$export$c1614f8d1bd73615).length
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Body, {})
            })
        ]
    });
};



// پروفایل — identity, clinics, shifts, appearance.
//
// Two save models, on purpose:
//   the identity FORM commits on a button, because typing a half-finished
//     medical code is not intent;
//   the appearance PICKERS commit immediately and paint locally first, because
//     the whole point of an accent picker is seeing the accent.
//
// The specialty field is READ-ONLY and shows the dental string. This panel IS
// the dental module; changing the specialty elsewhere closes it to the account,
// and offering an editor for that here would be offering a door out of the
// building labelled "settings".
// The section set and the identity edit model live in Profile.shared.js — the
// mobile surface renders the same four sections and commits the same changed
// keys, and "what counts as dirty" existing twice is how two forms come to
// disagree about whether there is anything to save.
const $2b7093a0ae606eaa$var$SECTIONS = (0, $19bde4c4267c7fe2$export$10b2fbb63cdee6f3);
const $2b7093a0ae606eaa$var$ProfileScreen = ()=>{
    const { t: t, locale: locale, setLocale: setLocale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { setAppearance: setAppearance } = (0, $54fc473ae52026aa$export$93d4e7f90805808f)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { clinics: clinics, reload: reloadClinics } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const { me: me, appearance: appearance, presences: presences, loading: loading, error: error, reload: reload, saveProfile: saveProfile, saveAppearance: saveAppearance } = (0, $8db22074202537d3$export$73fc7af4ef9455f4)();
    const section = $2b7093a0ae606eaa$var$SECTIONS(t).some((s)=>s.value === searchParams.get('tab')) ? searchParams.get('tab') : 'identity';
    const setSection = (next)=>{
        const params = new URLSearchParams(searchParams);
        if (next === 'identity') params.delete('tab');
        else params.set('tab', next);
        setSearchParams(params, {
            replace: true
        });
    };
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $19bde4c4267c7fe2$export$b8801ea43165ed7d)(null));
    const [saved, setSaved] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $19bde4c4267c7fe2$export$b8801ea43165ed7d)(null));
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [formError, setFormError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!me) return;
        const snap = (0, $19bde4c4267c7fe2$export$b8801ea43165ed7d)(me);
        setForm(snap);
        setSaved(snap);
    }, [
        me
    ]);
    const dirty = (0, $19bde4c4267c7fe2$export$910b6cdd390341b3)(form, saved);
    const codeLocked = (0, $19bde4c4267c7fe2$export$9f0a6e17ab0cd0a6)(saved);
    const submit = async ()=>{
        if (!form.fullName?.trim()) {
            setFormError(t('validation.fullName'));
            return;
        }
        // Unreachable while the field is locked (which is whenever `saved` holds a
        // number) — it guards the account that has none and starts typing one.
        if (saved.medicalCode && !form.medicalCode?.trim()) {
            setFormError(t('validation.medicalCode'));
            return;
        }
        const changes = (0, $19bde4c4267c7fe2$export$a32373c71666f903)(form, saved);
        if (Object.keys(changes).length === 0) {
            toast.info(t('profile.noChanges'));
            return;
        }
        setSaving(true);
        setFormError(null);
        try {
            await saveProfile(changes);
            toast.success(t('profile.saved'));
        } catch (err) {
            const msg = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'DUPLICATE_MEDICAL_CODE' ? t('profile.duplicateCode') : t('profile.saveFailed');
            setFormError(msg);
            toast.error(msg);
        } finally{
            setSaving(false);
        }
    };
    // ── Appearance: paint first, persist second, revert the paint on failure. ──
    const commitAppearance = async (patch)=>{
        const before = {
            theme: appearance?.theme,
            fontSize: appearance?.fontSize
        };
        if (patch.theme || patch.fontSize) setAppearance(patch);
        try {
            await saveAppearance(patch);
            toast.success(t('profile.appearance.saved'));
        } catch  {
            if (patch.theme || patch.fontSize) setAppearance(before);
            toast.error(t('profile.appearance.failed'));
        }
    };
    // Language switches the UI FIRST — nothing unmounts, so the next frame is
    // already in the new language and the confirmation toast arrives in it too.
    const commitLanguage = async (next)=>{
        const previous = locale;
        setLocale(next);
        try {
            await saveAppearance({
                language: next
            });
        } catch  {
            setLocale(previous);
            toast.error(t('profile.appearance.failed'));
        }
    };
    // ── Join a clinic ────────────────────────────────────────────────────────
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [joining, setJoining] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [joinError, setJoinError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const join = async ()=>{
        const value = code.trim();
        if (!value) {
            setJoinError(t('validation.invitationCode'));
            return;
        }
        setJoining(true);
        setJoinError(null);
        try {
            const res = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $8db22074202537d3$export$97fc5255fc3d3b7a), {
                invitationCode: value
            });
            const name = res?.joinClinicByCode?.clinic?.name || value;
            toast.success(t('profile.clinics.joined', {
                name: name
            }));
            setCode('');
            reloadClinics();
        } catch (err) {
            const msg = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'CLINIC_NOT_FOUND' ? t('profile.clinics.notFound') : t('profile.clinics.joinFailed');
            setJoinError(msg);
        } finally{
            setJoining(false);
        }
    };
    // The page's OWN shape while the profile loads — the real title, the
    // section strip and the body of the section the URL names — so a reload on
    // ?tab=presence draws shift rows, not identity fields (DESIGN.md §"Loading &
    // skeleton").
    if (loading && !me) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65b88bee8cd184fd$export$a74d55cc79ab1d0f), {
        section: section,
        label: t('common.loading'),
        title: t('profile.title'),
        sub: t('profile.subtitle')
    });
    if (error && !me) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            height: '100%',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            padding: 32
        },
        role: "alert",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                title: t('errors.load.profile'),
                onRetry: reload,
                retryLabel: t('common.actions.retry')
            })
        })
    });
    const sortedPresences = (0, $4059084aac03ad2b$export$b5af444615f1273e)(presences);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('profile.title'),
                sub: t('profile.subtitle')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '20px 32px 40px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            marginBottom: 16
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                            options: $2b7093a0ae606eaa$var$SECTIONS(t),
                            value: section,
                            onChange: setSection
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "tabpanel",
                        "aria-label": $2b7093a0ae606eaa$var$SECTIONS(t).find((s)=>s.value === section)?.label,
                        children: [
                            section === 'identity' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                title: t('profile.sections.identity'),
                                action: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    onClick: submit,
                                    disabled: !dirty || saving,
                                    children: saving ? t('common.actions.saving') : t('common.actions.save')
                                }),
                                children: [
                                    formError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "error",
                                        role: "alert",
                                        style: {
                                            marginBottom: 14
                                        },
                                        children: formError
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
                                            gap: 14
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('profile.fields.fullName'),
                                                "aria-label": t('profile.fields.fullName'),
                                                dir: "auto",
                                                required: true,
                                                "aria-required": "true",
                                                value: form.fullName,
                                                onChange: (e)=>setForm((f)=>({
                                                            ...f,
                                                            fullName: e.target.value
                                                        }))
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('profile.fields.medicalCode'),
                                                "aria-label": t('profile.fields.medicalCode'),
                                                dir: "ltr",
                                                value: form.medicalCode,
                                                onChange: codeLocked ? ()=>{} : (e)=>setForm((f)=>({
                                                            ...f,
                                                            medicalCode: e.target.value
                                                        })),
                                                disabled: codeLocked,
                                                helperText: codeLocked ? t('profile.medicalCodeLocked') : undefined,
                                                "data-testid": "profile-medicalcode"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('profile.fields.specialty'),
                                                "aria-label": t('profile.fields.specialty'),
                                                dir: "auto",
                                                value: me?.specialty || t('profile.specialtyValue'),
                                                onChange: ()=>{},
                                                disabled: true,
                                                helperText: t('profile.specialtyLocked')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginTop: 14
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                            label: t('profile.fields.bio'),
                                            "aria-label": t('profile.fields.bio'),
                                            dir: "auto",
                                            rows: 3,
                                            value: form.bio,
                                            onChange: (e)=>setForm((f)=>({
                                                        ...f,
                                                        bio: e.target.value
                                                    }))
                                        })
                                    })
                                ]
                            }),
                            section === 'clinics' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 14
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                        title: t('profile.sections.clinics'),
                                        children: clinics.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: 13,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('profile.clinics.empty')
                                        }) : clinics.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 10,
                                                    padding: '10px 0',
                                                    borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                                    flexWrap: 'wrap'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: 13.5,
                                                            fontWeight: 700,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                        },
                                                        children: m.clinic?.name || m.clinicId
                                                    }),
                                                    m.clinic?.city && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                        },
                                                        children: m.clinic.city
                                                    }),
                                                    m.visitDurationMinutes ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                        },
                                                        children: t('profile.clinics.visitDuration', {
                                                            count: m.visitDurationMinutes
                                                        })
                                                    }) : null,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                        variant: m.status === 'pending' ? 'warning' : 'success',
                                                        className: "ms-auto",
                                                        children: m.status === 'pending' ? t('profile.clinics.status.pending') : t('profile.clinics.status.active')
                                                    })
                                                ]
                                            }, m.id))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                        title: t('profile.clinics.joinTitle'),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 12.5,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                    marginBottom: 12
                                                },
                                                children: t('profile.clinics.joinHint')
                                            }),
                                            joinError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                                variant: "error",
                                                role: "alert",
                                                style: {
                                                    marginBottom: 12
                                                },
                                                children: joinError
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    gap: 10,
                                                    flexWrap: 'wrap'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                        label: t('profile.clinics.joinPlaceholder'),
                                                        "aria-label": t('profile.clinics.joinPlaceholder'),
                                                        dir: "ltr",
                                                        value: code,
                                                        // A one-field form: Enter submits it. Without this the only way
                                                        // to join was to leave the keyboard for the button.
                                                        onKeyDown: (e)=>{
                                                            if (e.key === 'Enter' && !joining) {
                                                                e.preventDefault();
                                                                join();
                                                            }
                                                        },
                                                        onChange: (e)=>setCode(e.target.value),
                                                        style: {
                                                            flex: 1,
                                                            minWidth: 220
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                        onClick: join,
                                                        disabled: joining,
                                                        children: joining ? t('common.actions.saving') : t('common.actions.join')
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            section === 'presence' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                title: t('profile.sections.presence'),
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            marginBottom: 12,
                                            fontSize: 12,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba16dd414953e5a4$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: t('profile.presence.readOnly')
                                            })
                                        ]
                                    }),
                                    sortedPresences.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            fontSize: 13,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('profile.presence.empty')
                                    }) : sortedPresences.map((p)=>{
                                        const dayKey = (0, $4059084aac03ad2b$export$e21d9c2954945d75)(p.dayOfWeek);
                                        const clinic = clinics.find((c)=>c.clinicId === p.clinicId);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 12,
                                                padding: '9px 0',
                                                borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                                opacity: p.isActive ? 1 : 0.55
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 13.5,
                                                        fontWeight: 700,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                        minWidth: 90
                                                    },
                                                    children: dayKey ? t(dayKey) : t('profile.presence.oneOff')
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    dir: "ltr",
                                                    style: {
                                                        unicodeBidi: 'isolate',
                                                        fontSize: 13,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                                    },
                                                    children: [
                                                        (0, $4059084aac03ad2b$export$ba3e9e7b0e0e7e68)(p.startTimeMinutes),
                                                        " \u2013 ",
                                                        (0, $4059084aac03ad2b$export$ba3e9e7b0e0e7e68)(p.endTimeMinutes)
                                                    ]
                                                }),
                                                !p.isActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                    variant: "outline",
                                                    children: t('profile.presence.inactive')
                                                }),
                                                clinic && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                        marginInlineStart: 'auto'
                                                    },
                                                    children: clinic.clinic?.name || clinic.clinicId
                                                })
                                            ]
                                        }, p.id);
                                    })
                                ]
                            }),
                            section === 'appearance' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 14
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                        title: t('profile.appearance.theme'),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                gap: 10,
                                                flexWrap: 'wrap'
                                            },
                                            children: (0, $e7c165fb515b04ea$export$a1d018c6ed60ae4c).map((preset)=>{
                                                const active = (appearance?.theme || 'default') === preset.id;
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    onClick: ()=>commitAppearance({
                                                            theme: preset.id
                                                        }),
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8,
                                                        padding: '8px 14px',
                                                        borderRadius: 10,
                                                        border: `1.5px solid ${active ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                                                        background: active ? (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).accentSoft : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                                                        cursor: 'pointer',
                                                        fontFamily: 'inherit',
                                                        fontSize: 13,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                width: 16,
                                                                height: 16,
                                                                borderRadius: '50%',
                                                                background: `linear-gradient(135deg, ${preset.swatch}, ${preset.swatch2})`
                                                            }
                                                        }),
                                                        t(`profile.theme.${preset.id}`)
                                                    ]
                                                }, preset.id);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                        title: t('profile.appearance.fontSize'),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                            options: (0, $e7c165fb515b04ea$export$58c32c962db85532).map((f)=>({
                                                    value: f.id,
                                                    label: t(`profile.fontSize.${f.id}`)
                                                })),
                                            value: appearance?.fontSize || 'medium',
                                            onChange: (v)=>commitAppearance({
                                                    fontSize: v
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca14abae17ea5b4d$export$2e2bcd8739ae039), {
                                        title: t('profile.appearance.language'),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                            options: (0, $19bde4c4267c7fe2$export$aece9465b5528b4c)(t),
                                            value: locale,
                                            onChange: commitLanguage
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $2b7093a0ae606eaa$export$2e2bcd8739ae039 = $2b7093a0ae606eaa$var$ProfileScreen;




var $acw62 = parcelRequire("acw62");



/**
 * @license lucide-react v1.57.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fe506e7c2094458f$export$a2387ed3b5d536eb = {
    name: "log-out",
    size: 24,
    node: [
        [
            "path",
            {
                d: "m16 17 5-5-5-5",
                key: "1bji2h"
            }
        ],
        [
            "path",
            {
                d: "M21 12H9",
                key: "dn1m92"
            }
        ],
        [
            "path",
            {
                d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
                key: "1uf3rs"
            }
        ]
    ]
};
$fe506e7c2094458f$export$a2387ed3b5d536eb.node;
const $fe506e7c2094458f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)($fe506e7c2094458f$export$a2387ed3b5d536eb);












// پروفایل — a top-level mobile destination, sectioned.
//
// ┌──────────────────────────────────────┐
// │ ① MobileHeader — cockpit              │  avatar · greeting · name
// │ ② SectionNav — STICKY                 │  هویت · کلینیک‌ها · شیفت‌ها · ظاهر
// │ ③ the active section                  │
// │ [ SaveBar — only while dirty ]         │  identity section only
// │ [ BottomNav ]                          │
// └──────────────────────────────────────┘
//
// ── THIS SCREEN CLOSES THE TWO HOLES THE MOBILE FORK CREATES ────────────────
//
// The desktop SIDEBAR owns the clinic switcher and sign-out, and there is no
// sidebar on a phone. Without them:
//
//   • a multi-clinic dentist would be locked to one scope forever, with امروز
//     and بیماران silently showing one clinic and no way to say which;
//   • there would be no way to sign out at all.
//
// Both live in this screen now. The switcher lists `scopeClinics`, NOT
// `clinics`: a pending membership cannot scope anything (the BFF answers
// CLINIC_FORBIDDEN), so offering it would break every screen and then snap back.
// That reasoning is the sidebar's and it survives the port.
//
// The desktop's four sections overflow a `SegmentedControl` at 320px, which is
// why this uses the kit's scrolling `SectionNav` instead (§4C).
const $f808a251142b44f3$var$ProfileMobile = ()=>{
    const { t: t, locale: locale, setLocale: setLocale, formatDigits: formatDigits } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { setAppearance: setAppearance } = (0, $54fc473ae52026aa$export$93d4e7f90805808f)();
    const [searchParams, setSearchParams] = (0, $040dbb9c344a508d$export$f1a78c17382fe22a)();
    const { clinics: clinics, scopeClinics: scopeClinics, activeId: activeId, setActiveId: setActiveId, reload: reloadClinics } = (0, $862d9bf17e1d4526$export$26433d199b47941f)();
    const { me: me, appearance: appearance, presences: presences, loading: loading, error: error, reload: reload, saveProfile: saveProfile, saveAppearance: saveAppearance } = (0, $8db22074202537d3$export$73fc7af4ef9455f4)();
    const section = (0, $19bde4c4267c7fe2$export$c1614f8d1bd73615).includes(searchParams.get('tab')) ? searchParams.get('tab') : (0, $19bde4c4267c7fe2$export$f47a0b5412f0d5de);
    const setSection = (next)=>{
        const params = new URLSearchParams(searchParams);
        if (next === (0, $19bde4c4267c7fe2$export$f47a0b5412f0d5de)) params.delete('tab');
        else params.set('tab', next);
        setSearchParams(params, {
            replace: true
        });
    };
    const [form, setForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $19bde4c4267c7fe2$export$b8801ea43165ed7d)(null));
    const [saved, setSaved] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $19bde4c4267c7fe2$export$b8801ea43165ed7d)(null));
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [formError, setFormError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!me) return;
        const snap = (0, $19bde4c4267c7fe2$export$b8801ea43165ed7d)(me);
        setForm(snap);
        setSaved(snap);
    }, [
        me
    ]);
    const dirty = (0, $19bde4c4267c7fe2$export$910b6cdd390341b3)(form, saved);
    const codeLocked = (0, $19bde4c4267c7fe2$export$9f0a6e17ab0cd0a6)(saved);
    const submit = async ()=>{
        if (!form.fullName?.trim()) {
            setFormError(t('validation.fullName'));
            return;
        }
        // Unreachable while the field is locked (which is whenever `saved` holds a
        // number) — it guards the account that has none and starts typing one.
        if (saved.medicalCode && !form.medicalCode?.trim()) {
            setFormError(t('validation.medicalCode'));
            return;
        }
        const changes = (0, $19bde4c4267c7fe2$export$a32373c71666f903)(form, saved);
        if (Object.keys(changes).length === 0) {
            toast.info(t('profile.noChanges'));
            return;
        }
        setSaving(true);
        setFormError(null);
        try {
            await saveProfile(changes);
            toast.success(t('profile.saved'));
        } catch (err) {
            const msg = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'DUPLICATE_MEDICAL_CODE' ? t('profile.duplicateCode') : t('profile.saveFailed');
            setFormError(msg);
            toast.error(msg);
        } finally{
            setSaving(false);
        }
    };
    // Paint first, persist second, revert the paint on failure — the whole point
    // of an accent picker is seeing the accent.
    const commitAppearance = async (patch)=>{
        const before = {
            theme: appearance?.theme,
            fontSize: appearance?.fontSize
        };
        if (patch.theme || patch.fontSize) setAppearance(patch);
        try {
            await saveAppearance(patch);
            toast.success(t('profile.appearance.saved'));
        } catch  {
            if (patch.theme || patch.fontSize) setAppearance(before);
            toast.error(t('profile.appearance.failed'));
        }
    };
    // Language switches the UI FIRST — nothing unmounts, so the next frame is
    // already in the new language and the confirmation toast arrives in it too.
    const commitLanguage = async (next)=>{
        const previous = locale;
        setLocale(next);
        try {
            await saveAppearance({
                language: next
            });
        } catch  {
            setLocale(previous);
            toast.error(t('profile.appearance.failed'));
        }
    };
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [joining, setJoining] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [joinError, setJoinError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const join = async ()=>{
        const value = code.trim();
        if (!value) {
            setJoinError(t('validation.invitationCode'));
            return;
        }
        setJoining(true);
        setJoinError(null);
        try {
            const res = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $8db22074202537d3$export$97fc5255fc3d3b7a), {
                invitationCode: value
            });
            const name = res?.joinClinicByCode?.clinic?.name || value;
            toast.success(t('profile.clinics.joined', {
                name: name
            }));
            setCode('');
            reloadClinics();
        } catch (err) {
            const msg = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'CLINIC_NOT_FOUND' ? t('profile.clinics.notFound') : t('profile.clinics.joinFailed');
            setJoinError(msg);
        } finally{
            setJoining(false);
        }
    };
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $19bde4c4267c7fe2$export$10b2fbb63cdee6f3)(t), [
        t
    ]);
    const navItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>sections.map(({ value: value, label: label, Icon: Icon })=>({
                key: value,
                label: label,
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 16,
                    "aria-hidden": true
                })
            })), [
        sections
    ]);
    // The page's OWN mobile shape — the greeting band, the section navigator
    // and the body of the section the URL names — never a generic card stack
    // (DESIGN.md §"Loading & skeleton").
    if (loading && !me) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $65b88bee8cd184fd$export$62620c16ce51c0dc), {
        section: section,
        label: t('common.loading')
    });
    if (error && !me) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-testid": "profile-content",
        "data-state": "error",
        role: "alert",
        style: {
            padding: '0.875rem 0.75rem'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
            title: t('errors.load.profile'),
            onRetry: reload,
            retryLabel: t('common.actions.retry')
        })
    });
    const sortedPresences = (0, $4059084aac03ad2b$export$b5af444615f1273e)(presences);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "profile-content",
        "data-state": "content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                        user: {
                            name: me?.fullName || ''
                        },
                        greeting: t('mobile.greeting'),
                        subtitle: me?.specialty || undefined,
                        "data-testid": "profile-header"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd795e2724b3b1d0$export$2e2bcd8739ae039), {
                            items: navItems,
                            active: section,
                            onSelect: setSection,
                            ariaLabel: t('profile.sections.label'),
                            "data-testid": "profile-nav"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        role: "tabpanel",
                        "aria-label": sections.find((s)=>s.value === section)?.label,
                        style: {
                            padding: '0.875rem 0.75rem 1.5rem'
                        },
                        children: [
                            section === 'identity' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    formError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                        variant: "error",
                                        role: "alert",
                                        style: {
                                            marginBottom: '0.875rem'
                                        },
                                        children: formError
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '0.75rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('profile.fields.fullName'),
                                                "aria-label": t('profile.fields.fullName'),
                                                dir: "auto",
                                                required: true,
                                                "aria-required": "true",
                                                value: form.fullName,
                                                onChange: (e)=>setForm((f)=>({
                                                            ...f,
                                                            fullName: e.target.value
                                                        })),
                                                "data-testid": "profile-fullname",
                                                inputStyle: {
                                                    fontSize: '1rem'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('profile.fields.medicalCode'),
                                                "aria-label": t('profile.fields.medicalCode'),
                                                dir: "ltr",
                                                inputMode: "numeric",
                                                value: form.medicalCode,
                                                onChange: codeLocked ? ()=>{} : (e)=>setForm((f)=>({
                                                            ...f,
                                                            medicalCode: e.target.value
                                                        })),
                                                disabled: codeLocked,
                                                helperText: codeLocked ? t('profile.medicalCodeLocked') : undefined,
                                                "data-testid": "profile-medicalcode",
                                                inputStyle: {
                                                    fontSize: '1rem'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('profile.fields.specialty'),
                                                "aria-label": t('profile.fields.specialty'),
                                                dir: "auto",
                                                value: me?.specialty || t('profile.specialtyValue'),
                                                onChange: ()=>{},
                                                disabled: true,
                                                helperText: t('profile.specialtyLocked'),
                                                inputStyle: {
                                                    fontSize: '1rem'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                                label: t('profile.fields.bio'),
                                                "aria-label": t('profile.fields.bio'),
                                                dir: "auto",
                                                rows: 3,
                                                value: form.bio,
                                                onChange: (e)=>setForm((f)=>({
                                                            ...f,
                                                            bio: e.target.value
                                                        })),
                                                "data-testid": "profile-bio",
                                                inputStyle: {
                                                    fontSize: '1rem'
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            marginTop: '1.5rem',
                                            paddingTop: '1rem',
                                            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            onClick: ()=>(0, $3bdb28763df76ec7$export$a0973bcfe11b05c9)(),
                                            "data-testid": "profile-signout",
                                            className: "w-full min-h-11 gap-1.5",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe506e7c2094458f$export$2e2bcd8739ae039), {
                                                    size: 16,
                                                    "aria-hidden": true
                                                }),
                                                t('nav.sidebar.logout')
                                            ]
                                        })
                                    })
                                ]
                            }),
                            section === 'clinics' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    scopeClinics.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem',
                                            marginBottom: '0.875rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                                label: t('profile.clinics.activeScope'),
                                                "aria-label": t('profile.clinics.activeScope'),
                                                value: activeId || '',
                                                // The kit's Select hands its handler the DOM EVENT, not the
                                                // value — it is a native <select> underneath.
                                                onChange: (e)=>setActiveId(e.target.value),
                                                options: scopeClinics.map((m)=>({
                                                        value: m.clinicId,
                                                        label: m.clinic?.name || m.clinicId
                                                    })),
                                                // The kit's default placeholder is a Persian literal, and
                                                // `activeId` always resolves to one of these clinics
                                                // (clinicScopeState falls back to the first usable one), so
                                                // an empty option would be an unreachable state in `en`.
                                                placeholder: "",
                                                "data-testid": "profile-clinic-scope"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: '0.6875rem',
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                    marginTop: '0.5rem'
                                                },
                                                children: t('profile.clinics.activeScopeHint')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                        children: t('profile.sections.clinics')
                                    }),
                                    clinics.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: '0.8125rem',
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('profile.clinics.empty')
                                        })
                                    }) : clinics.map((m)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                            style: {
                                                padding: '0.75rem',
                                                marginBottom: '0.5rem',
                                                borderRadius: '0.875rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '0.5rem',
                                                        flexWrap: 'wrap'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            dir: "auto",
                                                            style: {
                                                                fontSize: '0.8125rem',
                                                                fontWeight: 700,
                                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                            },
                                                            children: m.clinic?.name || m.clinicId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                            variant: m.status === 'pending' ? 'warning' : 'success',
                                                            className: "ms-auto",
                                                            children: m.status === 'pending' ? t('profile.clinics.status.pending') : t('profile.clinics.status.active')
                                                        })
                                                    ]
                                                }),
                                                (m.clinic?.city || m.visitDurationMinutes) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        fontSize: '0.6875rem',
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                        marginTop: '0.25rem'
                                                    },
                                                    children: [
                                                        m.clinic?.city || '',
                                                        m.visitDurationMinutes ? t('profile.clinics.visitDuration', {
                                                            count: m.visitDurationMinutes
                                                        }) : ''
                                                    ].filter(Boolean).join(" \xb7 ")
                                                })
                                            ]
                                        }, m.id)),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                        style: {
                                            marginTop: '0.875rem'
                                        },
                                        children: t('profile.clinics.joinTitle')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    fontSize: '0.75rem',
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                    marginBottom: '0.75rem'
                                                },
                                                children: t('profile.clinics.joinHint')
                                            }),
                                            joinError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                                                variant: "error",
                                                role: "alert",
                                                style: {
                                                    marginBottom: '0.75rem'
                                                },
                                                children: joinError
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                                label: t('profile.clinics.joinPlaceholder'),
                                                "aria-label": t('profile.clinics.joinPlaceholder'),
                                                dir: "ltr",
                                                value: code,
                                                // A one-field form: Enter submits it.
                                                onKeyDown: (e)=>{
                                                    if (e.key === 'Enter' && !joining) {
                                                        e.preventDefault();
                                                        join();
                                                    }
                                                },
                                                onChange: (e)=>setCode(e.target.value),
                                                "data-testid": "profile-join-code",
                                                inputStyle: {
                                                    fontSize: '1rem'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                onClick: join,
                                                disabled: joining,
                                                "data-testid": "profile-join",
                                                className: "mt-3 w-full min-h-11",
                                                children: joining ? t('common.actions.saving') : t('common.actions.join')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            section === 'presence' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '0.5rem',
                                            marginBottom: '0.75rem',
                                            fontSize: '0.6875rem',
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                            lineHeight: 1.8
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba16dd414953e5a4$export$2e2bcd8739ae039), {
                                                size: 14,
                                                style: {
                                                    flexShrink: 0,
                                                    marginTop: '0.125rem'
                                                },
                                                "aria-hidden": true
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: t('profile.presence.readOnly')
                                            })
                                        ]
                                    }),
                                    sortedPresences.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                fontSize: '0.8125rem',
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('profile.presence.empty')
                                        })
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.25rem 0.875rem'
                                        },
                                        children: sortedPresences.map((p)=>{
                                            const dayKey = (0, $4059084aac03ad2b$export$e21d9c2954945d75)(p.dayOfWeek);
                                            const clinic = clinics.find((c)=>c.clinicId === p.clinicId);
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$4f0e1e0c5eb41359), {
                                                label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        dayKey ? t(dayKey) : t('profile.presence.oneOff'),
                                                        !p.isActive && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ddd0c49a5377bd48$export$2e2bcd8739ae039), {
                                                            variant: "outline",
                                                            className: "ms-1.5",
                                                            children: t('profile.presence.inactive')
                                                        })
                                                    ]
                                                }),
                                                value: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            dir: "ltr",
                                                            style: {
                                                                unicodeBidi: 'isolate'
                                                            },
                                                            children: formatDigits(`${(0, $4059084aac03ad2b$export$ba3e9e7b0e0e7e68)(p.startTimeMinutes)} \u{2013} ${(0, $4059084aac03ad2b$export$ba3e9e7b0e0e7e68)(p.endTimeMinutes)}`)
                                                        }),
                                                        clinic && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            style: {
                                                                fontSize: '0.6875rem',
                                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                            },
                                                            children: clinic.clinic?.name || clinic.clinicId
                                                        })
                                                    ]
                                                })
                                            }, p.id);
                                        })
                                    })
                                ]
                            }),
                            section === 'appearance' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                        children: t('profile.appearance.theme')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            role: "group",
                                            "aria-label": t('profile.appearance.theme'),
                                            style: {
                                                display: 'flex',
                                                gap: '0.5rem',
                                                flexWrap: 'wrap'
                                            },
                                            children: (0, $e7c165fb515b04ea$export$a1d018c6ed60ae4c).map((preset)=>// The kit FilterChip, not the desktop's hand-rolled raw
                                                // <button> swatches: min-h-11, aria-pressed, data-state.
                                                // The swatch rides in as `children`; the LABEL is the
                                                // catalogue's, because the kit's preset labels are
                                                // Persian-only literals.
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                                    active: (appearance?.theme || 'default') === preset.id,
                                                    onClick: ()=>commitAppearance({
                                                            theme: preset.id
                                                        }),
                                                    "data-testid": `profile-theme-${preset.id}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            "aria-hidden": true,
                                                            style: {
                                                                width: '0.875rem',
                                                                height: '0.875rem',
                                                                borderRadius: '50%',
                                                                display: 'inline-block',
                                                                background: `linear-gradient(135deg, ${preset.swatch}, ${preset.swatch2})`
                                                            }
                                                        }),
                                                        t(`profile.theme.${preset.id}`)
                                                    ]
                                                }, preset.id))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                        style: {
                                            marginTop: '0.875rem'
                                        },
                                        children: t('profile.appearance.fontSize')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                            size: "lg",
                                            options: (0, $e7c165fb515b04ea$export$58c32c962db85532).map((f)=>({
                                                    value: f.id,
                                                    label: t(`profile.fontSize.${f.id}`)
                                                })),
                                            value: appearance?.fontSize || 'medium',
                                            onChange: (v)=>commitAppearance({
                                                    fontSize: v
                                                })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                        style: {
                                            marginTop: '0.875rem'
                                        },
                                        children: t('profile.appearance.language')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                        style: {
                                            padding: '0.875rem'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                maxWidth: '100%',
                                                overflowX: 'auto'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                                size: "lg",
                                                options: (0, $19bde4c4267c7fe2$export$aece9465b5528b4c)(t),
                                                value: locale,
                                                onChange: commitLanguage
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            section === 'identity' && dirty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1c3a031457b1019$export$2e2bcd8739ae039), {
                sticky: true,
                onSave: submit,
                onCancel: ()=>{
                    setForm(saved);
                    setFormError(null);
                },
                saving: saving,
                saveLabel: t('common.actions.save'),
                cancelLabel: t('common.actions.cancel'),
                "data-testid": "profile-savebar",
                style: {
                    marginTop: 0,
                    flexShrink: 0,
                    paddingInline: '0.75rem'
                }
            })
        ]
    });
};
var $f808a251142b44f3$export$2e2bcd8739ae039 = $f808a251142b44f3$var$ProfileMobile;


// پروفایل — two surfaces, one profile.
//
// The mobile surface is not just the desktop page in a narrow column: its four
// sections live in a scrolling `SectionNav` (a `SegmentedControl` overflows at
// 320px and takes the page into horizontal scroll), its theme picker is the kit
// `FilterChip` rather than the desktop's hand-rolled swatch buttons, and it
// carries the CLINIC SWITCHER and SIGN-OUT that the desktop keeps in the
// sidebar — which does not exist below 768px.
//
// The edit model is shared (`Profile.shared.js`), so both agree about which
// fields the form owns, what "dirty" means and which keys reach the wire.
const $618a45575ddb4226$var$ProfileScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f808a251142b44f3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b7093a0ae606eaa$export$2e2bcd8739ae039), {});
};
var $618a45575ddb4226$export$2e2bcd8739ae039 = $618a45575ddb4226$var$ProfileScreen;



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");



// اعتبار — the loading shape of the LEDGER only.
//
// Everything above the ledger is real chrome while it loads: the balance hero
// draws its cached balance, `KpiCard` / `StatTiles` carry their own loading
// dash, the type filter and the group/date controls are operable. What the
// query fills is the list of transactions, so that is what skeletons — in the
// shape of `TransactionRow` (desktop: 34px icon tile, body + micro line,
// amount; 10px 16px padding) and `MobileTxnRow` (30px tile, 9px 12px
// padding), under a day-group caption strip, so the first row lands exactly
// where its placeholder was.
const $9b3c8cc4f20b7966$var$Row = ({ i: i, mobile: mobile })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "aria-hidden": true,
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: mobile ? '0.625rem' : 12,
            padding: mobile ? '0.5625rem 0.75rem' : '10px 16px',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: mobile ? 30 : 34,
                height: mobile ? 30 : 34,
                radius: 9
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 5
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${34 + i * 17 % 30}%`,
                        height: 13
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                        width: `${22 + i * 11 % 24}%`,
                        height: 10
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
                width: 64,
                height: 14
            })
        ]
    });
const $9b3c8cc4f20b7966$var$GroupCaption = ({ mobile: mobile })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "aria-hidden": true,
        style: {
            padding: mobile ? '0.3125rem 0.75rem' : '6px 16px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c90190398471f24a$export$2e2bcd8739ae039), {
            width: 96,
            height: 11
        })
    });
const $9b3c8cc4f20b7966$export$c12b8848658bae76 = ({ label: label, mobile: mobile = false, rows: rows = 5 })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e0ce57f089cb4321$export$45686ee14bc4c7f3), {
        label: label,
        "data-testid": "credits-ledger-skeleton",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9b3c8cc4f20b7966$var$GroupCaption, {
                mobile: mobile
            }),
            Array.from({
                length: rows
            }, (_, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9b3c8cc4f20b7966$var$Row, {
                    i: i,
                    mobile: mobile
                }, i))
        ]
    });












var $acw62 = parcelRequire("acw62");








// خرید پارسه — the body of the top-up flow.
//
// ONE component for both surfaces: it is rendered inside a `Dialog` on the
// desktop and a `BottomSheet` on the phone, and neither owns any of the choice
// logic. A second mobile copy would be a second place for the price of a
// package to live.
//
// PACKAGES ARE EXPLAINED IN WORK DONE, not in money — «≈ ۲۰ جلسه با دستیار».
// Toman appears twice and only where the number really is a price: on each
// row's trailing edge, and on the pay button.
//
// ── WHY A RADIOGROUP AND NOT FOUR onClick DIVS ─────────────────────────────
// This is one choice among four, which is what a radio group IS: arrow keys
// move between the options, the selection is announced, and `aria-checked`
// says which one is live. The doctor panel's version nests its amount field
// INSIDE the custom row's <button>, which is invalid (interactive content in a
// button) and leaves the field unreachable by keyboard — so here the field sits
// below the row instead, where it is also a full-width target on a phone.
const $260a6170605807fd$var$PACKAGES = [
    200,
    500,
    1000
];
// The floor is ONE پارسه (`minToman` below). It exists to stop trivially small
// gateway transactions, not to force a package: a dentist who wants a single
// پارسه's worth should be able to buy it, and every Iranian gateway settles
// amounts this size happily.
// What one session costs when there is no history to average — roughly the
// differential plus a note refine plus an interaction check, i.e. "used the
// assistant properly, once".
const $260a6170605807fd$var$FALLBACK_COST_PER_VISIT = 23;
function $260a6170605807fd$export$2e2bcd8739ae039({ avgPerVisit: avgPerVisit, onPay: onPay, busy: busy = false, error: error = null }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // What one پارسه costs in Toman: the active policy's figure, else the constant.
    const { coinPriceToman: COIN_PRICE_TOMAN } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const minToman = COIN_PRICE_TOMAN;
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(500); // پارسه, or 'custom'
    const [customToman, setCustomToman] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const perVisit = avgPerVisit && avgPerVisit > 0 ? avgPerVisit : $260a6170605807fd$var$FALLBACK_COST_PER_VISIT;
    const isCustom = selected === 'custom';
    const customCoins = Math.floor((Number(customToman) || 0) / COIN_PRICE_TOMAN);
    const coins = isCustom ? customCoins : selected;
    const toman = coins * COIN_PRICE_TOMAN;
    const belowMin = toman < minToman;
    const options = [
        ...$260a6170605807fd$var$PACKAGES,
        'custom'
    ];
    // Arrow keys move the selection, which is what makes this a radio group
    // rather than four buttons that happen to look like one.
    const onKeyDown = (event)=>{
        const forward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
        const back = event.key === 'ArrowUp' || event.key === 'ArrowLeft';
        if (!forward && !back) return;
        event.preventDefault();
        const at = options.indexOf(selected);
        const next = forward ? options[(at + 1) % options.length] : options[(at - 1 + options.length) % options.length];
        setSelected(next);
    };
    const Row = ({ value: value, children: children })=>{
        const active = selected === value;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
            type: "button",
            role: "radio",
            "aria-checked": active,
            tabIndex: active ? 0 : -1,
            variant: active ? 'subtle' : 'outline',
            onClick: ()=>setSelected(value),
            "data-testid": `topup-${value === 'custom' ? 'custom' : `pkg-${value}`}`,
            className: "min-h-11 w-full justify-start gap-3 rounded-xl px-4 py-3 h-auto",
            children: children
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                role: "radiogroup",
                "aria-label": t('credits.topUp.chooseAmount'),
                onKeyDown: onKeyDown,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    $260a6170605807fd$var$PACKAGES.map((pkg)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Row, {
                            value: pkg,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                        display: 'flex'
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                        size: 16
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        flex: 1,
                                        textAlign: 'start',
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 8
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).amount,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                    },
                                                    children: [
                                                        (0, $75f061374f24c25d$export$b634cc5d06849b0a)(pkg, formatNumber),
                                                        " ",
                                                        t('credits.unit')
                                                    ]
                                                }),
                                                pkg === 500 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                                                        fontWeight: 800,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
                                                        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight,
                                                        borderRadius: 999,
                                                        padding: '1px 8px'
                                                    },
                                                    children: t('credits.topUp.recommended')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                display: 'block',
                                                marginTop: 2
                                            },
                                            children: t('credits.topUp.approxVisits', {
                                                count: formatNumber(Math.round(pkg / perVisit))
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    style: {
                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                        fontWeight: 700,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        whiteSpace: 'nowrap'
                                    },
                                    children: [
                                        formatNumber(pkg * COIN_PRICE_TOMAN),
                                        " ",
                                        t('credits.tomanShort')
                                    ]
                                })
                            ]
                        }, pkg)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Row, {
                        value: "custom",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    color: isCustom ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    display: 'flex'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                    size: 16
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    flex: 1,
                                    textAlign: 'start',
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: t('credits.topUp.custom')
                            }),
                            isCustom && coins > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    "= ",
                                    (0, $75f061374f24c25d$export$b634cc5d06849b0a)(coins, formatNumber),
                                    " ",
                                    t('credits.unit')
                                ]
                            })
                        ]
                    })
                ]
            }),
            isCustom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                            whiteSpace: 'nowrap'
                        },
                        children: t('credits.topUp.customAria')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b90d527c31e5b4da$export$2e2bcd8739ae039), {
                        value: customToman,
                        onChange: setCustomToman,
                        autoFocus: true,
                        "data-testid": "topup-custom-input",
                        unitLabel: t('credits.toman'),
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        inputStyle: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                            width: '100%',
                            boxSizing: 'border-box',
                            minHeight: '2.75rem',
                            padding: '0 12px',
                            paddingInlineStart: 52,
                            textAlign: 'end',
                            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                            borderRadius: 10,
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            outline: 'none'
                        }
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                variant: "error",
                "data-testid": "topup-error",
                children: error.message && error.message !== 'NO_URL' ? t('credits.topUp.failedWithReason', {
                    reason: error.message
                }) : t('credits.topUp.failed')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                onClick: ()=>!belowMin && !busy && onPay(coins, toman),
                disabled: belowMin || busy,
                "data-testid": "topup-pay",
                className: "w-full min-h-11",
                style: {
                    marginTop: 4
                },
                children: busy ? t('credits.topUp.redirecting') : toman > 0 ? t('credits.topUp.payVia', {
                    amount: formatNumber(toman),
                    gateway: (0, $84433f335a456b60$export$18053a58f12c6137)(t)
                }) : t('credits.topUp.enterAmount')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    textAlign: 'center',
                    lineHeight: 1.8
                },
                children: belowMin ? t('credits.topUp.minimum', {
                    amount: formatNumber(minToman)
                }) : t('credits.topUp.redirectNote')
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");
function $dbc5cc1d1bbccab9$export$b19a1b350a269434({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"
        })
    });
}
function $dbc5cc1d1bbccab9$export$2d8598c0b89a07db({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 13l-3-3 1.41-1.41L11 11.17l4.59-4.58L17 8l-6 6z"
        })
    });
}
function $dbc5cc1d1bbccab9$export$592efa5f07538585({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
        })
    });
}
function $dbc5cc1d1bbccab9$export$f21ab0717a89c77f({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
        })
    });
}
function $dbc5cc1d1bbccab9$export$89472f18b6de8cda({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        width: size,
        height: size,
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M20 12v8H4v-8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M22 7H2v5h20z"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 7v13"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 7c-1.5 0-4-.6-4-3a2 2 0 0 1 4 0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 7c1.5 0 4-.6 4-3a2 2 0 0 0-4 0"
            })
        ]
    });
}
function $dbc5cc1d1bbccab9$export$52cd484a7ef4f2b9({ size: size = 16, color: color = 'currentColor' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: color,
        width: size,
        height: size,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
        })
    });
}
function $dbc5cc1d1bbccab9$export$7dd004358974b05d({ size: size = 20 }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6L9 17l-5-5"
        })
    });
}


/**
 * کد هدیه — redeem a campaign code, and see the ones already spent.
 *
 * THE CODE FIELD IS FORCED LTR even under a Persian layout. The code is a Latin
 * token whose left-to-right order carries meaning, and in an RTL input a
 * leading '-' or a mixed digit run REORDERS ON SCREEN while the value stays
 * correct — so the dentist proofreads a string that is not the one being sent.
 *
 * Persian digits are deliberately NOT converted here. The marketing service
 * normalises them (app/domain/gift_codes.py:normalize_code), so a dentist typing
 * on a Persian keyboard is already handled, and a second normaliser in the
 * browser would be a second place for that rule to drift.
 */ const $63da91af56ebc85e$var$STATUS_TONE = {
    issued: {
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
        bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.12)
    },
    redeemed: {
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1)
    },
    revoked: {
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
    },
    expired: {
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
        bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
    }
};
function $63da91af56ebc85e$export$2e2bcd8739ae039({ onRedeemed: onRedeemed, compact: compact = false }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { codes: codes, redeem: redeem } = (0, $3c762e0fe7df1045$export$67e83c350c566786)();
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [done, setDone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const submit = async (event)=>{
        event.preventDefault();
        if (busy) return;
        setError('');
        setBusy(true);
        const result = await redeem(value);
        setBusy(false);
        if (result.ok) {
            setDone(result);
            setValue('');
            // The balance in the hero and in the KPI strip is now stale. They both
            // read one number, so every mounted reader refetches rather than this
            // card holding a second copy of it.
            (0, $3c762e0fe7df1045$export$9cce968afbb01012)();
            if (onRedeemed) onRedeemed(result);
            return;
        }
        setError(result.code === 'EMPTY' ? t('credits.gift.empty') : result.message || t('credits.gift.notFound'));
    };
    const SHELL = {
        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
        border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
        borderRadius: 12,
        padding: 18,
        display: 'flex',
        flexDirection: 'column',
        gap: 12
    };
    if (done) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "gift-success",
        style: {
            ...SHELL,
            border: `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).green}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            width: 38,
                            height: 38,
                            borderRadius: '50%',
                            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
                            color: '#fff',
                            display: 'grid',
                            placeItems: 'center',
                            flexShrink: 0
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbc5cc1d1bbccab9$export$7dd004358974b05d), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                                    fontWeight: 800,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                },
                                children: t('credits.gift.success', {
                                    parseh: formatNumber(done.granted)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                    marginTop: 3
                                },
                                children: t('credits.gift.successSub', {
                                    visits: formatNumber(done.smartVisits)
                                })
                            })
                        ]
                    })
                ]
            }),
            done.balance != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: t('credits.gift.newBalance')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                            fontWeight: 800,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                        },
                        children: [
                            formatNumber(done.balance),
                            " ",
                            t('credits.unit')
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: SHELL,
        "data-testid": "gift-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            width: 34,
                            height: 34,
                            borderRadius: 10,
                            background: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1),
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                            display: 'grid',
                            placeItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbc5cc1d1bbccab9$export$89472f18b6de8cda), {
                            size: 18
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).title,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: t('credits.gift.title')
                    })
                ]
            }),
            !compact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    lineHeight: 1.9
                },
                children: t('credits.gift.hint')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: submit,
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                        dir: "ltr",
                        value: value,
                        // The kit hands the EVENT through to the real <input>, so this is
                        // `e.target.value` and not a bare string — unlike MoneyInput, which
                        // reports the stripped value directly.
                        onChange: (e)=>{
                            setValue(e.target.value);
                            if (error) setError('');
                        },
                        placeholder: t('credits.gift.placeholder'),
                        "aria-label": t('credits.gift.title'),
                        "aria-invalid": !!error || undefined,
                        // `error` on the kit input paints the red border AND announces the
                        // message; the block below it is what a screen reader reaches through
                        // role="alert".
                        error: error || undefined,
                        "data-testid": "gift-code-input",
                        inputStyle: {
                            fontWeight: 700,
                            letterSpacing: 1.5,
                            textAlign: 'center'
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        type: "submit",
                        disabled: busy,
                        "data-testid": "gift-code-submit",
                        className: "w-full min-h-11",
                        children: busy ? t('credits.gift.submitting') : t('credits.gift.submit')
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "alert",
                "aria-live": "polite",
                "data-testid": "gift-code-error",
                className: "sr-only",
                children: error
            }),
            !error && !compact && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: t('credits.gift.oneUse')
            }),
            codes.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
                    paddingTop: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                            fontWeight: 700,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                        },
                        children: t('credits.gift.myCodes')
                    }),
                    codes.map((code)=>{
                        const tone = $63da91af56ebc85e$var$STATUS_TONE[code.status] || $63da91af56ebc85e$var$STATUS_TONE.revoked;
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2,
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            dir: "ltr",
                                            style: {
                                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                fontWeight: 800,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                                                letterSpacing: 1,
                                                unicodeBidi: 'isolate'
                                            },
                                            children: code.code
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                            },
                                            children: t('credits.gift.worth', {
                                                parseh: formatNumber(code.parseh),
                                                visits: formatNumber(code.smartVisits)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                        fontWeight: 700,
                                        color: tone.color,
                                        background: tone.bg,
                                        borderRadius: 999,
                                        padding: '3px 10px',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: t(`credits.gift.status.${code.status}`)
                                })
                            ]
                        }, code.id);
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");





function $29f1cbe2be0a8e40$export$2e2bcd8739ae039() {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { config: config, loading: loading, saving: saving, save: save } = (0, $3c762e0fe7df1045$export$2177e3f0da1cd259)();
    const [threshold, setThreshold] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [enabled, setEnabled] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!config) return;
        setThreshold(String(Math.round(config.threshold)));
        setEnabled(config.enableAlerts);
    }, [
        config
    ]);
    const dirty = !!config && (Number(threshold) !== Math.round(config.threshold) || enabled !== config.enableAlerts);
    const commit = async ()=>{
        const value = Number(threshold);
        if (!Number.isFinite(value) || value < 0) {
            toast.error(t('credits.lowBalance.invalid'));
            return;
        }
        const ok = await save({
            threshold: value,
            enableAlerts: enabled
        });
        if (ok) toast.success(t('credits.lowBalance.saved'));
        else toast.error(t('credits.lowBalance.failed'));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "credits-lowbalance",
        style: {
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
            border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 16,
            boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
            padding: '14px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).title,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            flex: 1
                        },
                        children: t('credits.lowBalance.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d47a2201c3cd6a9$export$2e2bcd8739ae039), {
                        checked: enabled,
                        onChange: setEnabled,
                        disabled: loading,
                        label: t('credits.lowBalance.toggleAria')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    lineHeight: 1.9
                },
                children: t('credits.lowBalance.hint')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe0519cb1ec239e$export$2e2bcd8739ae039), {
                value: threshold,
                // The kit's NumberInput reports `{ target: { value } }`, having already
                // folded Persian digits to Latin — so a threshold typed as «۱۵۰» arrives
                // as '150' rather than as NaN.
                onChange: (e)=>setThreshold(e.target.value),
                unit: t('credits.unit'),
                min: 0,
                disabled: loading || !enabled,
                "aria-label": t('credits.lowBalance.thresholdAria'),
                "data-testid": "credits-lowbalance-threshold"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                onClick: commit,
                disabled: !dirty || saving || loading,
                variant: "outline",
                size: "sm",
                "data-testid": "credits-lowbalance-save",
                children: saving ? t('common.actions.saving') : t('common.actions.save')
            }),
            config && !dirty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: enabled ? t('credits.lowBalance.active', {
                    coins: formatNumber(Math.round(config.threshold))
                }) : t('credits.lowBalance.off')
            })
        ]
    });
}


// اعتبار — everything the two surfaces must agree about.
//
// The service→label/colour vocabulary, the ledger-description parsing, the KPI
// arithmetic and the grouping. Both `Credits.web.jsx` and `Credits.mobile.jsx`
// import from here, so the phone and the workstation can never disagree about
// what a row says or what «این ماه» adds up to. (Profile.shared.js and
// Visit.shared.js exist for the same reason.)


const $884b9b27c085fa62$export$dd3a6ec182d7f57a = (t)=>({
        AI_LLM_SUMMARY: {
            label: t('credits.service.assistant'),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
            bg: 'color-mix(in srgb, var(--p-navy) 10%, transparent)',
            icon: (0, $dbc5cc1d1bbccab9$export$b19a1b350a269434)
        },
        AI_INTERACTION_CHECK: {
            label: t('credits.service.interaction'),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amber,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).amberLight,
            icon: (0, $dbc5cc1d1bbccab9$export$2d8598c0b89a07db)
        },
        AI_TRANSCRIPTION: {
            label: t('credits.service.transcription'),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight,
            icon: (0, $dbc5cc1d1bbccab9$export$592efa5f07538585)
        },
        TOP_UP: {
            label: t('credits.service.topUp'),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight,
            icon: (0, $dbc5cc1d1bbccab9$export$f21ab0717a89c77f)
        },
        GIFT_CODE: {
            label: t('credits.service.gift'),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).greenLight,
            icon: (0, $dbc5cc1d1bbccab9$export$89472f18b6de8cda)
        },
        SMS: {
            label: t('credits.service.sms'),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
            bg: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).tealLight,
            icon: (0, $dbc5cc1d1bbccab9$export$52cd484a7ef4f2b9)
        }
    });
const $884b9b27c085fa62$export$64f6ffea5049f9d4 = (t)=>({
        label: t('credits.service.ai'),
        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
        bg: 'color-mix(in srgb, var(--p-navy) 10%, transparent)',
        icon: (0, $dbc5cc1d1bbccab9$export$b19a1b350a269434)
    });
// Rows written before the wallet stored the enum NAME carry the proto INTEGER
// as a string. They are still in the ledger and still have to render.
const $884b9b27c085fa62$var$SERVICE_TYPE_INT_MAP = {
    1: 'SMS',
    2: 'AI_TRANSCRIPTION',
    3: 'AI_LLM_SUMMARY',
    4: 'AI_INTERACTION_CHECK'
};
function $884b9b27c085fa62$export$856ef076f8da864a(rawType) {
    const resolved = $884b9b27c085fa62$var$SERVICE_TYPE_INT_MAP[rawType] || rawType;
    return String(resolved || '').replace(/^SERVICE_TYPE_/, '');
}
function $884b9b27c085fa62$export$e0b738a571245f61(rawType, t) {
    return $884b9b27c085fa62$export$dd3a6ec182d7f57a(t)[$884b9b27c085fa62$export$856ef076f8da864a(rawType)] || $884b9b27c085fa62$export$64f6ffea5049f9d4(t);
}
function $884b9b27c085fa62$export$170e57b1ee989654(raw) {
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch  {
        return raw;
    }
}
function $884b9b27c085fa62$export$b89a369743013e7(raw, t) {
    const parsed = $884b9b27c085fa62$export$170e57b1ee989654(raw);
    if (!parsed || typeof parsed === 'string') return {
        title: parsed || '',
        sub: '',
        visitId: null
    };
    const sub = [];
    if (parsed.duration_seconds) sub.push(t('credits.minutesUsed', {
        count: Math.ceil(parsed.duration_seconds / 60)
    }));
    return {
        title: parsed.action || '',
        sub: sub.join(" \xb7 "),
        // The visit id IS the appointment id in this platform (there is no
        // encounters table), which is what makes «۲۳ پارسه در این جلسه» computable.
        visitId: parsed.visit_id || parsed.appointment_id || parsed.patient_id || null
    };
}
// ── Grouping ────────────────────────────────────────────────────────────────
//
// `formatDate` is passed IN rather than imported: it comes from
// `useTranslation()` and it is what pins every date to Asia/Tehran and to the
// active calendar. A `toLocaleDateString('fa-IR')` here would render a Persian
// date in the BROWSER'S timezone — which puts a 23:30 debit on the wrong day
// for a dentist who is travelling, and on the right one at home.
const $884b9b27c085fa62$var$dayKeyOf = (iso)=>{
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? 'unknown' : `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
};
function $884b9b27c085fa62$var$dayLabel(iso, t, formatDate) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const startOf = (x)=>new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
    const days = Math.round((startOf(new Date()) - startOf(d)) / 86400000);
    if (days === 0) return t('credits.time.today');
    if (days === 1) return t('credits.time.yesterday');
    return formatDate(d.getTime(), 'full');
}
function $884b9b27c085fa62$export$3be14461f103972e(transactions, t, formatDate) {
    const groups = [];
    const index = {};
    transactions.forEach((item)=>{
        const key = $884b9b27c085fa62$var$dayKeyOf(item.createdAt);
        if (index[key] == null) {
            index[key] = groups.length;
            groups.push({
                key: key,
                label: $884b9b27c085fa62$var$dayLabel(item.createdAt, t, formatDate),
                items: []
            });
        }
        groups[index[key]].items.push(item);
    });
    return groups;
}
function $884b9b27c085fa62$export$c4f843207ab6bf8c(transactions, t) {
    const map = {};
    transactions.forEach((item)=>{
        const key = $884b9b27c085fa62$export$856ef076f8da864a(item.serviceType);
        if (!map[key]) map[key] = {
            key: key,
            meta: $884b9b27c085fa62$export$e0b738a571245f61(key, t),
            total: 0,
            items: []
        };
        map[key].total += item.type === 'debit' ? item.amount : -item.amount;
        map[key].items.push(item);
    });
    return Object.values(map).sort((a, b)=>Math.abs(b.total) - Math.abs(a.total));
}
const $884b9b27c085fa62$export$925c8ee11af609ba = (t)=>[
        {
            value: 'all',
            label: t('credits.range.all')
        },
        {
            value: 'today',
            label: t('credits.time.today')
        },
        {
            value: '7d',
            label: t('credits.range.days7')
        },
        {
            value: '30d',
            label: t('credits.range.days30')
        },
        {
            value: 'month',
            label: t('credits.range.thisMonth')
        }
    ];
const $884b9b27c085fa62$var$pad = (n)=>String(n).padStart(2, '0');
const $884b9b27c085fa62$var$startISO = (d)=>`${d.getFullYear()}-${$884b9b27c085fa62$var$pad(d.getMonth() + 1)}-${$884b9b27c085fa62$var$pad(d.getDate())}T00:00:00`;
const $884b9b27c085fa62$var$endISO = (d)=>`${d.getFullYear()}-${$884b9b27c085fa62$var$pad(d.getMonth() + 1)}-${$884b9b27c085fa62$var$pad(d.getDate())}T23:59:59`;
function $884b9b27c085fa62$export$439018c7c0970868(preset) {
    const now = new Date();
    switch(preset){
        case 'today':
            return {
                startDate: $884b9b27c085fa62$var$startISO(now),
                endDate: $884b9b27c085fa62$var$endISO(now)
            };
        case '7d':
            {
                const from = new Date(now);
                from.setDate(now.getDate() - 6);
                return {
                    startDate: $884b9b27c085fa62$var$startISO(from),
                    endDate: $884b9b27c085fa62$var$endISO(now)
                };
            }
        case '30d':
            {
                const from = new Date(now);
                from.setDate(now.getDate() - 29);
                return {
                    startDate: $884b9b27c085fa62$var$startISO(from),
                    endDate: $884b9b27c085fa62$var$endISO(now)
                };
            }
        case 'month':
            return {
                startDate: $884b9b27c085fa62$var$startISO(new Date(now.getFullYear(), now.getMonth(), 1)),
                endDate: $884b9b27c085fa62$var$endISO(now)
            };
        default:
            return {
                startDate: '',
                endDate: ''
            };
    }
}
function $884b9b27c085fa62$export$52e8b78f2372daa5(transactions) {
    const now = new Date();
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    let usedThisMonth = 0;
    let totalCredited = 0;
    let monthDebitTotal = 0;
    const byService = {};
    const visitSpend = {};
    transactions.forEach((item)=>{
        const at = new Date(item.createdAt).getTime();
        if (item.type === 'debit') {
            const key = $884b9b27c085fa62$export$856ef076f8da864a(item.serviceType);
            if (at >= monthStart) {
                usedThisMonth += item.amount;
                monthDebitTotal += item.amount;
                byService[key] = (byService[key] || 0) + item.amount;
            }
            const { visitId: visitId } = $884b9b27c085fa62$export$b89a369743013e7(item.description, ()=>'');
            if (visitId) visitSpend[visitId] = (visitSpend[visitId] || 0) + item.amount;
        } else totalCredited += item.amount;
    });
    const visitIds = Object.keys(visitSpend);
    const avgPerVisit = visitIds.length ? visitIds.reduce((sum, k)=>sum + visitSpend[k], 0) / visitIds.length : null;
    let topService = null;
    let topAmount = 0;
    Object.entries(byService).forEach(([k, v])=>{
        if (v > topAmount) {
            topAmount = v;
            topService = k;
        }
    });
    const topPct = monthDebitTotal ? Math.round(topAmount / monthDebitTotal * 100) : 0;
    return {
        usedThisMonth: usedThisMonth,
        totalCredited: totalCredited,
        avgPerVisit: avgPerVisit,
        topService: topService,
        topPct: topPct,
        byService: byService,
        monthDebitTotal: monthDebitTotal
    };
}
function $884b9b27c085fa62$export$d8999ed724c19ec6(transactions, t) {
    const map = {};
    transactions.forEach((item)=>{
        if (item.type !== 'debit') return;
        const key = $884b9b27c085fa62$export$856ef076f8da864a(item.serviceType);
        if (!map[key]) map[key] = {
            amount: 0,
            count: 0,
            meta: $884b9b27c085fa62$export$e0b738a571245f61(key, t)
        };
        map[key].amount += item.amount;
        map[key].count += 1;
    });
    return Object.entries(map).map(([key, v])=>({
            key: key,
            ...v
        })).sort((a, b)=>b.amount - a.amount);
}
const $884b9b27c085fa62$export$1616e9e969dfdcee = (t)=>[
        {
            value: 'all',
            label: t('credits.filter.all')
        },
        {
            value: 'debit',
            label: t('credits.filter.spend')
        },
        {
            value: 'credit',
            label: t('credits.filter.topUp')
        }
    ];
const $884b9b27c085fa62$export$d4320a5464386596 = (t)=>[
        {
            value: 'day',
            label: t('credits.group.day')
        },
        {
            value: 'type',
            label: t('credits.group.type')
        }
    ];
const $884b9b27c085fa62$export$8ec3d08588d2eeda = 30;


// اعتبار — the desktop surface.
//
// ┌────────────────────────────────────────────────────────────────┐
// │ PageHeader «اعتبار پارسینا»                      [ خرید پارسه ] │
// ├────────────────────────────────────────────────────────────────┤
// │ ⚠ low/mid banner — only when the balance is actually low        │
// │ ┌──────────┬─────────────────────────────────────────────────┐ │
// │ │ hero     │ this month · per session · biggest consumer      │ │
// │ ├──────────┴──────────────────────────────┬──────────────────┤ │
// │ │ the ledger (filter · grouping · range)  │ gift code        │ │
// │ │                                          │ price list       │ │
// │ │                                          │ where it went    │ │
// │ │                                          │ low-balance      │ │
// └────────────────────────────────────────────────────────────────┘
//
// The body is FULL-BLEED, not a centred column. A `maxWidth` here leaves a band
// of empty background down one side of every wide screen — and in RTL a capped
// block sits against the right, so the cap reads as a layout bug rather than as
// a centred page. What gets capped is content INSIDE a card, never the body.
const $48ab62c8c643bc72$var$CARD = {
    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).card,
    borderRadius: 16,
    border: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
    boxShadow: '0 1px 6px rgba(0,0,0,0.05)'
};
// ── Balance hero ────────────────────────────────────────────────────────────
function $48ab62c8c643bc72$var$BalanceHero({ balance: balance, onTopUp: onTopUp }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const { coinPriceToman: coinPriceToman } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const level = (0, $e7c165fb515b04ea$export$2e1a2382662bd4ea)(balance);
    const color = (0, $e7c165fb515b04ea$export$3b48083d65d829ca)(balance);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "credits-hero",
        style: {
            background: (0, $e7c165fb515b04ea$export$4c2e201e0b6dbaa3),
            borderRadius: 20,
            padding: '22px 24px',
            color: '#fff',
            position: 'relative',
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    position: 'absolute',
                    top: -40,
                    insetInlineStart: -40,
                    width: 150,
                    height: 150,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.05)'
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    position: 'absolute',
                    bottom: -60,
                    insetInlineEnd: -30,
                    width: 190,
                    height: 190,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.04)'
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                            color: 'rgba(255,255,255,0.6)'
                        },
                        children: t('credits.currentBalance')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'flex-end',
                            gap: 8,
                            marginTop: 6,
                            flexWrap: 'wrap'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).hero
                                },
                                "data-testid": "credits-balance",
                                children: balance === null ? "\u2014" : (0, $75f061374f24c25d$export$b634cc5d06849b0a)(balance, formatNumber)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).unit,
                                    color: 'rgba(255,255,255,0.7)',
                                    marginBottom: 6
                                },
                                children: t('credits.unit')
                            }),
                            level && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    background: 'rgba(255,255,255,0.12)',
                                    borderRadius: 20,
                                    padding: '3px 10px',
                                    marginBottom: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            background: color
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                            color: 'rgba(255,255,255,0.85)'
                                        },
                                        children: t((0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].labelKey)
                                    })
                                ]
                            })
                        ]
                    }),
                    balance !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                            color: 'rgba(255,255,255,0.55)',
                            marginTop: 8
                        },
                        children: (0, $75f061374f24c25d$export$3c73313758e13369)(balance, {
                            formatNumber: formatNumber,
                            tomanLabel: t('credits.toman'),
                            tomanPerCoin: coinPriceToman
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                        onClick: onTopUp,
                        "data-testid": "credits-topup",
                        variant: "outline",
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                            marginTop: 16,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            background: 'rgba(255,255,255,0.16)',
                            border: '1px solid rgba(255,255,255,0.2)',
                            color: '#fff'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                size: 14
                            }),
                            t('credits.buy')
                        ]
                    })
                ]
            })
        ]
    });
}
// ── Rail: the price list ────────────────────────────────────────────────────
function $48ab62c8c643bc72$var$PriceListCard() {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // The policy's figures once the list has arrived; the shipped constants until
    // then — a price row never spins and never goes blank.
    const { priceList: priceList } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const rows = open ? priceList : priceList.slice(0, 5);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            ...$48ab62c8c643bc72$var$CARD,
            padding: '14px 16px'
        },
        "data-testid": "credits-pricelist",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).title,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    marginBottom: 4
                },
                children: t('credits.priceList.title')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                    marginBottom: 10,
                    lineHeight: 1.8
                },
                children: t('credits.priceList.hint')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column'
                },
                children: rows.map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '6px 0',
                            borderBottom: i < rows.length - 1 ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                    flex: 1,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                },
                                children: t(row.labelKey)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                    fontWeight: 800,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                    whiteSpace: 'nowrap'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                        size: 11
                                    }),
                                    (0, $75f061374f24c25d$export$b634cc5d06849b0a)(row.cost, formatNumber),
                                    row.perKey ? ` / ${t(row.perKey)}` : ''
                                ]
                            })
                        ]
                    }, row.id))
            }),
            priceList.length > 5 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                variant: "ghost",
                size: "sm",
                onClick: ()=>setOpen((o)=>!o),
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                    fontWeight: 700,
                    marginTop: 8,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                    paddingInline: 0
                },
                children: open ? t('common.actions.close') : t('credits.priceList.viewAll')
            })
        ]
    });
}
// ── Rail: where the credit went ─────────────────────────────────────────────
function $48ab62c8c643bc72$var$ServiceBreakdownCard({ transactions: transactions }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$d8999ed724c19ec6)(transactions, t), [
        transactions,
        t
    ]);
    if (!rows.length) return null;
    const max = rows[0].amount || 1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            ...$48ab62c8c643bc72$var$CARD,
            padding: '14px 16px'
        },
        "data-testid": "credits-breakdown",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).title,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    marginBottom: 12
                },
                children: t('credits.byService')
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12
                },
                children: rows.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    marginBottom: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                            fontWeight: 700,
                                            flex: 1,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                        },
                                        children: row.meta.label
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('credits.timesUsed', {
                                            count: formatNumber(row.count)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                            fontWeight: 800,
                                            color: row.meta.color
                                        },
                                        children: (0, $75f061374f24c25d$export$b634cc5d06849b0a)(row.amount, formatNumber)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                style: {
                                    height: 5,
                                    background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                                    borderRadius: 4,
                                    overflow: 'hidden'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        height: '100%',
                                        width: `${row.amount / max * 100}%`,
                                        background: row.meta.color,
                                        borderRadius: 4,
                                        transition: 'width 0.6s cubic-bezier(.4,0,.2,1)'
                                    }
                                })
                            })
                        ]
                    }, row.key))
            })
        ]
    });
}
// ── Ledger rows ─────────────────────────────────────────────────────────────
function $48ab62c8c643bc72$var$TransactionRow({ txn: txn }) {
    const { t: t, formatNumber: formatNumber, formatTime: formatTime } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const meta = (0, $884b9b27c085fa62$export$e0b738a571245f61)(txn.serviceType, t);
    const Icon = meta.icon;
    const isDebit = txn.type === 'debit';
    const { title: title, sub: sub } = (0, $884b9b27c085fa62$export$b89a369743013e7)(txn.description, t);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "credits-row",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '10px 16px',
            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    width: 34,
                    height: 34,
                    borderRadius: 9,
                    background: meta.bg,
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 16,
                    color: meta.color
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                        },
                        children: title || meta.label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            marginTop: 2,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            formatTime(txn.createdAt),
                            sub ? ` \xb7 ${sub}` : ''
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).amount,
                    color: isDebit ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
                    flexShrink: 0
                },
                children: [
                    isDebit ? "\u2212" : '+',
                    (0, $75f061374f24c25d$export$b634cc5d06849b0a)(txn.amount, formatNumber)
                ]
            })
        ]
    });
}
function $48ab62c8c643bc72$var$TypeGroupHeader({ group: group }) {
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const Icon = group.meta.icon;
    const spent = group.total >= 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 16px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    width: 22,
                    height: 22,
                    borderRadius: 6,
                    background: group.meta.bg,
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 13,
                    color: group.meta.color
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                    fontWeight: 800,
                    flex: 1,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: group.meta.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: t('credits.timesUsed', {
                    count: formatNumber(group.items.length)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).amount,
                    color: spent ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green,
                    minWidth: 52,
                    textAlign: 'end'
                },
                children: [
                    spent ? "\u2212" : '+',
                    (0, $75f061374f24c25d$export$b634cc5d06849b0a)(Math.abs(group.total), formatNumber)
                ]
            })
        ]
    });
}
// ── Main ────────────────────────────────────────────────────────────────────
const $48ab62c8c643bc72$var$CreditsWeb = ()=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { balance: balance, reload: reloadBalance } = (0, $3c762e0fe7df1045$export$6f7596e662cfa902)();
    const { startTopUp: startTopUp, busy: payBusy, error: payError } = (0, $3c762e0fe7df1045$export$64e212e524010641)();
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [typeFilter, setTypeFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [groupMode, setGroupMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('day');
    const [datePreset, setDatePreset] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [topUpOpen, setTopUpOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { startDate: startDate, endDate: endDate } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$439018c7c0970868)(datePreset), [
        datePreset
    ]);
    const { transactions: transactions, totalCount: totalCount, loading: loading, error: error, reload: reload } = (0, $3c762e0fe7df1045$export$5735140d6962cb0e)({
        limit: (0, $884b9b27c085fa62$export$8ec3d08588d2eeda),
        offset: page * (0, $884b9b27c085fa62$export$8ec3d08588d2eeda),
        startDate: startDate,
        endDate: endDate,
        // Server-side. The ledger runs to thousands of rows, so filtering the
        // fetched page would show only the matches that happened to land on it,
        // under a count describing the whole set.
        type: typeFilter === 'all' ? '' : typeFilter
    });
    // ── The gateway return leg ──
    //
    // By the time the browser lands here the payment BFF has ALREADY verified and
    // settled with the bank — it is the only party that can, because the gateway
    // reports server-to-server and Sepehr's settle step needs a receipt the
    // browser never sees. So this screen reports the outcome and refreshes; it
    // must not try to confirm anything itself.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        const settled = params.get('payment');
        if (!settled) return;
        // Stripped immediately, so a refresh cannot replay the message.
        window.history.replaceState({}, '', window.location.pathname);
        if (settled === 'success') toast.success(t('credits.payment.done'));
        else toast.error(t('credits.payment.failed'));
        reloadBalance();
        reload();
    // `t` is stable per locale and the toast/reload identities are stable; this
    // must run once per landing, not on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const stats = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$52e8b78f2372daa5)(transactions), [
        transactions
    ]);
    const dayGroups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$3be14461f103972e)(transactions, t, formatDate), [
        transactions,
        t,
        formatDate
    ]);
    const typeGroups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$c4f843207ab6bf8c)(transactions, t), [
        transactions,
        t
    ]);
    const totalPages = Math.max(1, Math.ceil(totalCount / (0, $884b9b27c085fa62$export$8ec3d08588d2eeda)));
    // Changing the server-side window must reset paging, or the offset points
    // past the end of the new set and the ledger renders empty.
    const applyDatePreset = (value)=>{
        setDatePreset(value);
        setPage(0);
    };
    const level = (0, $e7c165fb515b04ea$export$2e1a2382662bd4ea)(balance);
    const topMeta = stats.topService ? (0, $884b9b27c085fa62$export$e0b738a571245f61)(stats.topService, t) : null;
    const filtered = typeFilter !== 'all' || datePreset !== 'all';
    // A NON-BREAKING SPACE, and it is load-bearing. The kit's KpiCard separates
    // its value from its unit with `marginRight: 4` — which is the LEADING edge in
    // RTL and the trailing one in LTR, so under `en` the tiles rendered
    // «46Parseh» and «Clinical assistant87%» with no gap at all. The kit is a
    // pinned git dependency shared with two other apps, so the gap is supplied
    // here rather than by forking it; remove this when KpiCard uses a logical
    // margin.
    const unit = (label)=>`\u00A0${label}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
            overflowY: 'auto'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed420e5a4f8c639f$export$2e2bcd8739ae039), {
                title: t('credits.title'),
                sub: t('credits.subtitle'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                    onClick: ()=>setTopUpOpen(true),
                    "data-testid": "credits-topup-header",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                            size: 14
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                marginInlineStart: 6
                            },
                            children: t('credits.buy')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    padding: '20px 28px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 18,
                    width: '100%',
                    boxSizing: 'border-box'
                },
                children: [
                    (level === 'low' || level === 'mid') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        "data-testid": "credits-low-banner",
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            padding: '10px 16px',
                            borderRadius: 10,
                            background: (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].tint,
                            border: `1px solid ${(0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].color, 0.35)}`
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: {
                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                                    color: (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].color,
                                    flex: 1
                                },
                                children: t(level === 'low' ? 'credits.banner.low' : 'credits.banner.mid', {
                                    coins: (0, $75f061374f24c25d$export$b634cc5d06849b0a)(balance, formatNumber)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                variant: "outline",
                                size: "sm",
                                onClick: ()=>setTopUpOpen(true),
                                style: {
                                    borderColor: (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].color,
                                    color: (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].color
                                },
                                children: t('credits.topUp')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'minmax(260px, 300px) 1fr',
                            gap: 14,
                            alignItems: 'stretch'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($48ab62c8c643bc72$var$BalanceHero, {
                                balance: balance,
                                onTopUp: ()=>setTopUpOpen(true)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                    gap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $178f36e6e586ad89$export$2e2bcd8739ae039), {
                                        label: t('credits.kpi.month'),
                                        value: (0, $75f061374f24c25d$export$b634cc5d06849b0a)(stats.usedThisMonth, formatNumber),
                                        unit: unit(t('credits.unit')),
                                        loading: loading && !transactions.length,
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal,
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                                size: 18
                                            })
                                        }),
                                        bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal, 0.12),
                                        accent: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $178f36e6e586ad89$export$2e2bcd8739ae039), {
                                        label: t('credits.kpi.perVisit'),
                                        value: stats.avgPerVisit == null ? "\u2014" : (0, $75f061374f24c25d$export$b634cc5d06849b0a)(stats.avgPerVisit, formatNumber),
                                        unit: unit(t('credits.unit')),
                                        loading: loading && !transactions.length,
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                                size: 18
                                            })
                                        }),
                                        bg: (0, $e7c165fb515b04ea$export$7bce9182245b1545)((0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy, 0.1),
                                        accent: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $178f36e6e586ad89$export$2e2bcd8739ae039), {
                                        label: t('credits.kpi.topService'),
                                        value: topMeta ? topMeta.label : "\u2014",
                                        unit: topMeta ? unit(t('credits.percent', {
                                            value: formatNumber(stats.topPct)
                                        })) : '',
                                        loading: loading && !transactions.length,
                                        icon: topMeta ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(topMeta.icon, {
                                            size: 18,
                                            color: topMeta.color
                                        }) : undefined,
                                        bg: topMeta ? topMeta.bg : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg,
                                        accent: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gridTemplateColumns: 'minmax(0, 1fr) 280px',
                            gap: 14,
                            alignItems: 'start'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    ...$48ab62c8c643bc72$var$CARD,
                                    overflow: 'hidden'
                                },
                                "data-testid": "credits-ledger",
                                "data-state": transactions.length ? 'content' : error && !loading ? 'error' : loading ? 'loading' : 'empty',
                                "aria-busy": loading && !transactions.length ? true : undefined,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 10,
                                            padding: '14px 16px',
                                            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                style: {
                                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).title,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                                },
                                                children: [
                                                    t('credits.transactions'),
                                                    totalCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                        style: {
                                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                            marginInlineStart: 8
                                                        },
                                                        children: [
                                                            "(",
                                                            t('credits.itemCount', {
                                                                count: formatNumber(totalCount)
                                                            }),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                                options: (0, $884b9b27c085fa62$export$1616e9e969dfdcee)(t),
                                                value: typeFilter,
                                                onChange: (v)=>{
                                                    setTypeFilter(v);
                                                    setPage(0);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10,
                                            flexWrap: 'wrap',
                                            padding: '10px 16px',
                                            borderBottom: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: t('credits.group.label')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                                options: (0, $884b9b27c085fa62$export$d4320a5464386596)(t),
                                                value: groupMode,
                                                onChange: setGroupMode
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                "data-testid": "credits-daterange",
                                                role: "group",
                                                "aria-label": t('credits.range.label'),
                                                style: {
                                                    marginInlineStart: 'auto',
                                                    display: 'flex',
                                                    gap: 6,
                                                    flexWrap: 'wrap'
                                                },
                                                children: (0, $884b9b27c085fa62$export$925c8ee11af609ba)(t).map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                                        label: p.label,
                                                        active: datePreset === p.value,
                                                        onClick: ()=>applyDatePreset(p.value),
                                                        className: "min-h-9"
                                                    }, p.value))
                                            })
                                        ]
                                    }),
                                    error && !loading && transactions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        role: "alert",
                                        style: {
                                            padding: 16
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                            title: t('credits.error.title'),
                                            description: t('credits.error.body'),
                                            onRetry: reload,
                                            retryLabel: t('common.actions.retry')
                                        })
                                    }),
                                    loading && transactions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b3c8cc4f20b7966$export$c12b8848658bae76), {
                                        label: t('common.loading')
                                    }),
                                    !loading && !error && transactions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            padding: '44px 20px',
                                            textAlign: 'center'
                                        },
                                        "data-testid": "credits-empty",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                    display: 'inline-flex'
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                                    size: 34
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                                                    margin: '10px 0 4px'
                                                },
                                                children: filtered ? t('credits.empty.filtered') : t('credits.empty.title')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                style: {
                                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                                },
                                                children: filtered ? t('credits.empty.filteredHint') : t('credits.empty.hint')
                                            })
                                        ]
                                    }),
                                    !loading && groupMode === 'day' && dayGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                        fontWeight: 700,
                                                        padding: '6px 16px',
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
                                                    },
                                                    children: group.label
                                                }),
                                                group.items.map((txn)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($48ab62c8c643bc72$var$TransactionRow, {
                                                        txn: txn
                                                    }, txn.id))
                                            ]
                                        }, group.key)),
                                    !loading && groupMode === 'type' && typeGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($48ab62c8c643bc72$var$TypeGroupHeader, {
                                                    group: group
                                                }),
                                                group.items.map((txn)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($48ab62c8c643bc72$var$TransactionRow, {
                                                        txn: txn
                                                    }, txn.id))
                                            ]
                                        }, group.key)),
                                    totalCount > 0 && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        "data-testid": "credits-range",
                                        style: {
                                            padding: '10px 16px 0',
                                            textAlign: 'center',
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('credits.showingRange', {
                                            from: formatNumber(page * (0, $884b9b27c085fa62$export$8ec3d08588d2eeda) + 1),
                                            to: formatNumber(Math.min((page + 1) * (0, $884b9b27c085fa62$export$8ec3d08588d2eeda), totalCount)),
                                            total: formatNumber(totalCount)
                                        })
                                    }),
                                    totalPages > 1 && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            gap: 12,
                                            padding: '12px 16px',
                                            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                size: "sm",
                                                onClick: ()=>setPage((p)=>Math.max(0, p - 1)),
                                                disabled: page === 0,
                                                "data-testid": "credits-prev",
                                                children: t('credits.pager.previous')
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                style: {
                                                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                                    whiteSpace: 'nowrap'
                                                },
                                                "data-testid": "credits-page-label",
                                                children: t('credits.pager.page', {
                                                    page: formatNumber(page + 1),
                                                    total: formatNumber(totalPages)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                                variant: "outline",
                                                size: "sm",
                                                onClick: ()=>setPage((p)=>p + 1 < totalPages ? p + 1 : p),
                                                disabled: page + 1 >= totalPages,
                                                "data-testid": "credits-next",
                                                children: t('credits.pager.next')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 12
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63da91af56ebc85e$export$2e2bcd8739ae039), {
                                        onRedeemed: ()=>{
                                            reloadBalance();
                                            reload();
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($48ab62c8c643bc72$var$PriceListCard, {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($48ab62c8c643bc72$var$ServiceBreakdownCard, {
                                        transactions: transactions
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29f1cbe2be0a8e40$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$3ddf2d174ce01153), {
                open: topUpOpen,
                onOpenChange: setTopUpOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ace11be13f1c53cf$export$b6d9565de1e068cf), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$742513523b177e3b), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ace11be13f1c53cf$export$16f7638e4a34b909), {
                                children: t('credits.buy')
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $260a6170605807fd$export$2e2bcd8739ae039), {
                            avgPerVisit: stats.avgPerVisit,
                            onPay: startTopUp,
                            busy: payBusy,
                            error: payError
                        })
                    ]
                })
            })
        ]
    });
};
var $48ab62c8c643bc72$export$2e2bcd8739ae039 = $48ab62c8c643bc72$var$CreditsWeb;




var $acw62 = parcelRequire("acw62");















// اعتبار — the ≤768px surface (DESIGN-CONCEPT-MOBILE).
//
// ┌──────────────────────────────────────┐
// │ ① MobileHeader (gradient) — PINNED    │
// │    └ the balance, inside the header   │  ۴۲۰ پارسه · «اعتبار خوب»
// │ ② StatTiles — 3-up, riding the edge   │  این ماه · هر جلسه · بیشترین
// ├──────────────────────────────────────┤  ── the scroll starts here ──
// │ ③ low/mid banner, when it applies     │
// │ ④ کد هدیه (compact)                    │
// │ ⑤ the ledger: chips + grouped rows    │
// │ ⑥ price list + هشدار, both collapsed   │
// │ [ BottomNav ]                          │
// └──────────────────────────────────────┘
//
// The BALANCE LIVES IN THE HEADER rather than in a hero card below it. §3.2's
// rule for a glanceable screen is that "the numbers never leave the screen", and
// on اعتبار the number that must never leave is the balance — the whole reason
// a dentist opens this page is to find out whether they can afford the next
// assistant call.
//
// The price list and the alert setting are COLLAPSED by default: they are
// reference material, and expanded they would push the ledger — the thing the
// dentist scrolled here to read — below two screens of static content.
const $506153099b614331$var$MobileTxnRow = ({ txn: txn })=>{
    const { t: t, formatNumber: formatNumber, formatTime: formatTime } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const meta = (0, $884b9b27c085fa62$export$e0b738a571245f61)(txn.serviceType, t);
    const Icon = meta.icon;
    const isDebit = txn.type === 'debit';
    const { title: title, sub: sub } = (0, $884b9b27c085fa62$export$b89a369743013e7)(txn.description, t);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        "data-testid": "credits-row",
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.625rem',
            padding: '0.5625rem 0.75rem',
            borderTop: `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    width: '1.875rem',
                    height: '1.875rem',
                    borderRadius: '0.5rem',
                    background: meta.bg,
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 15,
                    color: meta.color
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    flex: 1,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                            fontWeight: 700,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                            display: 'block'
                        },
                        children: title || meta.label
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                            display: 'block',
                            marginTop: '0.0625rem',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        },
                        children: [
                            formatTime(txn.createdAt),
                            sub ? ` \xb7 ${sub}` : ''
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).body,
                    fontWeight: 800,
                    color: isDebit ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
                },
                children: [
                    isDebit ? "\u2212" : '+',
                    (0, $75f061374f24c25d$export$b634cc5d06849b0a)(txn.amount, formatNumber)
                ]
            })
        ]
    });
};
const $506153099b614331$var$MobileTypeGroupHeader = ({ group: group })=>{
    const { t: t, formatNumber: formatNumber } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const Icon = group.meta.icon;
    const spent = group.total >= 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.4375rem',
            padding: '0.375rem 0.75rem',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    width: '1.25rem',
                    height: '1.25rem',
                    borderRadius: '0.375rem',
                    background: group.meta.bg,
                    display: 'grid',
                    placeItems: 'center',
                    flexShrink: 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, {
                    size: 12,
                    color: group.meta.color
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                    fontWeight: 800,
                    flex: 1,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                },
                children: group.meta.label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                },
                children: t('credits.timesUsed', {
                    count: formatNumber(group.items.length)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                style: {
                    ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                    fontWeight: 800,
                    color: spent ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).green
                },
                children: [
                    spent ? "\u2212" : '+',
                    (0, $75f061374f24c25d$export$b634cc5d06849b0a)(Math.abs(group.total), formatNumber)
                ]
            })
        ]
    });
};
const $506153099b614331$var$CreditsMobile = ()=>{
    const { t: t, formatNumber: formatNumber, formatDate: formatDate } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // The policy's figures once the list has arrived; the shipped constants until then.
    const { priceList: priceList, coinPriceToman: coinPriceToman } = (0, $9449204a10cf7050$export$204bd72286fdb787)();
    const toast = (0, $352ffee698fbd002$export$a407b657d3044108)();
    const { balance: balance, reload: reloadBalance } = (0, $3c762e0fe7df1045$export$6f7596e662cfa902)();
    const { startTopUp: startTopUp, busy: payBusy, error: payError } = (0, $3c762e0fe7df1045$export$64e212e524010641)();
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [typeFilter, setTypeFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [groupMode, setGroupMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('day');
    const [datePreset, setDatePreset] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('all');
    const [topUpOpen, setTopUpOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { startDate: startDate, endDate: endDate } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$439018c7c0970868)(datePreset), [
        datePreset
    ]);
    const { transactions: transactions, totalCount: totalCount, loading: loading, error: error, reload: reload } = (0, $3c762e0fe7df1045$export$5735140d6962cb0e)({
        limit: (0, $884b9b27c085fa62$export$8ec3d08588d2eeda),
        offset: page * (0, $884b9b27c085fa62$export$8ec3d08588d2eeda),
        startDate: startDate,
        endDate: endDate,
        type: typeFilter === 'all' ? '' : typeFilter
    });
    // The gateway return leg. This surface needs its own copy and not a shared
    // one: a ≤768px viewport renders THIS component and never Credits.web, so
    // without it a dentist who paid on a phone lands back here with no
    // confirmation and a stale balance.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        const settled = params.get('payment');
        if (!settled) return;
        window.history.replaceState({}, '', window.location.pathname);
        if (settled === 'success') toast.success(t('credits.payment.done'));
        else toast.error(t('credits.payment.failed'));
        reloadBalance();
        reload();
    // Once per landing, never on re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const stats = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$52e8b78f2372daa5)(transactions), [
        transactions
    ]);
    const dayGroups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$3be14461f103972e)(transactions, t, formatDate), [
        transactions,
        t,
        formatDate
    ]);
    const typeGroups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(0, $884b9b27c085fa62$export$c4f843207ab6bf8c)(transactions, t), [
        transactions,
        t
    ]);
    const totalPages = Math.max(1, Math.ceil(totalCount / (0, $884b9b27c085fa62$export$8ec3d08588d2eeda)));
    const level = (0, $e7c165fb515b04ea$export$2e1a2382662bd4ea)(balance);
    const topMeta = stats.topService ? (0, $884b9b27c085fa62$export$e0b738a571245f61)(stats.topService, t) : null;
    const filtered = typeFilter !== 'all' || datePreset !== 'all';
    // EXACTLY THREE TILES, always — and `columns={3}` below, which the kit
    // supports precisely "so a screen with three facts does not have to invent a
    // filler tile". Without it StatTiles lays out its default four columns and
    // the row renders with a hole in it.
    const tiles = [
        {
            key: 'month',
            label: t('credits.kpi.month'),
            value: (0, $75f061374f24c25d$export$b634cc5d06849b0a)(stats.usedThisMonth, formatNumber),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                size: 16
            }),
            solid: true
        },
        {
            key: 'perVisit',
            label: t('credits.kpi.perVisit'),
            value: stats.avgPerVisit == null ? "\u2014" : (0, $75f061374f24c25d$export$b634cc5d06849b0a)(stats.avgPerVisit, formatNumber),
            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                size: 16
            }),
            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
        },
        {
            key: 'top',
            label: topMeta ? topMeta.label : t('credits.kpi.topService'),
            value: topMeta ? t('credits.percent', {
                value: formatNumber(stats.topPct)
            }) : "\u2014",
            icon: topMeta ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(topMeta.icon, {
                size: 16
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                size: 16
            }),
            color: topMeta ? topMeta.color : (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).mute
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flexShrink: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62f4a9fc87ba90f8$export$2e2bcd8739ae039), {
                        title: t('credits.title'),
                        "data-testid": "credits-header",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                background: 'rgba(255,255,255,0.12)',
                                borderRadius: '0.875rem',
                                padding: '0.75rem 0.875rem',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        flex: 1,
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                                                color: 'rgba(255,255,255,0.6)'
                                            },
                                            children: t('credits.currentBalance')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'baseline',
                                                gap: '0.375rem',
                                                marginTop: '0.125rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).display,
                                                        color: '#fff'
                                                    },
                                                    "data-testid": "credits-balance",
                                                    children: balance === null ? "\u2014" : (0, $75f061374f24c25d$export$b634cc5d06849b0a)(balance, formatNumber)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).unit,
                                                        color: 'rgba(255,255,255,0.7)'
                                                    },
                                                    children: t('credits.unit')
                                                }),
                                                level && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    style: {
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '0.3125rem',
                                                        background: 'rgba(255,255,255,0.14)',
                                                        borderRadius: '1.25rem',
                                                        padding: '0.125rem 0.5rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                width: '0.4375rem',
                                                                height: '0.4375rem',
                                                                borderRadius: '50%',
                                                                background: (0, $e7c165fb515b04ea$export$3b48083d65d829ca)(balance)
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            style: {
                                                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                                                                color: '#fff'
                                                            },
                                                            children: t((0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].shortLabelKey)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        balance !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            style: {
                                                ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                                                color: 'rgba(255,255,255,0.55)',
                                                marginTop: '0.25rem'
                                            },
                                            children: (0, $75f061374f24c25d$export$3c73313758e13369)(balance, {
                                                formatNumber: formatNumber,
                                                tomanLabel: t('credits.toman'),
                                                tomanPerCoin: coinPriceToman
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    onClick: ()=>setTopUpOpen(true),
                                    "data-testid": "credits-topup",
                                    className: "min-h-11 shrink-0",
                                    style: {
                                        background: '#fff',
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                            size: 14
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            style: {
                                                marginInlineStart: '0.375rem'
                                            },
                                            children: t('credits.buy')
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            padding: '0 0.75rem',
                            marginTop: '-1rem',
                            position: 'relative'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ea4bc4a14affb445$export$2e2bcd8739ae039), {
                            tiles: tiles,
                            columns: 3,
                            loading: loading && !transactions.length,
                            "data-testid": "credits-stats"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                "data-testid": "credits-content",
                "data-state": error ? 'error' : loading ? 'loading' : transactions.length ? 'content' : 'empty',
                "aria-busy": loading || undefined,
                style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    // Clear of the bottom bar, so the last row is never covered.
                    padding: '0.875rem 0.75rem 1.5rem'
                },
                children: [
                    (level === 'low' || level === 'mid') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                        "data-testid": "credits-low-banner",
                        style: {
                            background: (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].tint,
                            borderColor: (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].color,
                            marginBottom: '0.875rem'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: {
                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                        color: (0, $e7c165fb515b04ea$export$83bdaf7cc3f6b0e7)[level].color,
                                        flex: 1,
                                        lineHeight: 1.8
                                    },
                                    children: t(level === 'low' ? 'credits.banner.low' : 'credits.banner.mid', {
                                        coins: (0, $75f061374f24c25d$export$b634cc5d06849b0a)(balance, formatNumber)
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: ()=>setTopUpOpen(true),
                                    className: "min-h-11 shrink-0",
                                    children: t('credits.topUp')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63da91af56ebc85e$export$2e2bcd8739ae039), {
                        compact: true,
                        onRedeemed: ()=>{
                            reloadBalance();
                            reload();
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        style: {
                            marginTop: '0.875rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45e53d65b3e0238c$export$156186cd9d0794), {
                                count: totalCount ? formatNumber(totalCount) : undefined,
                                children: t('credits.transactions')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "group",
                                "aria-label": t('credits.filter.label'),
                                style: {
                                    display: 'flex',
                                    gap: '0.375rem',
                                    overflowX: 'auto',
                                    paddingBottom: '0.25rem'
                                },
                                children: (0, $884b9b27c085fa62$export$1616e9e969dfdcee)(t).map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                        label: f.label,
                                        active: typeFilter === f.value,
                                        onClick: ()=>{
                                            setTypeFilter(f.value);
                                            setPage(0);
                                        }
                                    }, f.value))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "group",
                                "aria-label": t('credits.range.label'),
                                style: {
                                    display: 'flex',
                                    gap: '0.375rem',
                                    overflowX: 'auto',
                                    padding: '0.375rem 0 0.5rem'
                                },
                                "data-testid": "credits-daterange",
                                children: (0, $884b9b27c085fa62$export$925c8ee11af609ba)(t).map((p)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f5f0e3d96e18162$export$2e2bcd8739ae039), {
                                        label: p.label,
                                        active: datePreset === p.value,
                                        onClick: ()=>{
                                            setDatePreset(p.value);
                                            setPage(0);
                                        }
                                    }, p.value))
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    marginBottom: '0.5rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                                        },
                                        children: t('credits.group.label')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $24dfcaee8d76ee07$export$2e2bcd8739ae039), {
                                        options: (0, $884b9b27c085fa62$export$d4320a5464386596)(t),
                                        value: groupMode,
                                        onChange: setGroupMode,
                                        size: "lg"
                                    })
                                ]
                            }),
                            error && !loading && transactions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                role: "alert",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3cbee9b1abdcb86a$export$2e2bcd8739ae039), {
                                    title: t('credits.error.title'),
                                    description: t('credits.error.body'),
                                    onRetry: reload,
                                    retryLabel: t('common.actions.retry')
                                })
                            }),
                            loading && transactions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                style: {
                                    padding: 0,
                                    overflow: 'hidden'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b3c8cc4f20b7966$export$c12b8848658bae76), {
                                    mobile: true,
                                    label: t('common.loading')
                                })
                            }),
                            !loading && !error && transactions.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $838915ee2bfb8ab1$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                            display: 'inline-flex'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                            size: 44
                                        })
                                    }),
                                    title: filtered ? t('credits.empty.filtered') : t('credits.empty.title'),
                                    description: filtered ? t('credits.empty.filteredHint') : t('credits.empty.hint')
                                })
                            }),
                            !loading && !error && transactions.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $9169df7fa2fdff01$export$2e2bcd8739ae039), {
                                style: {
                                    padding: 0,
                                    overflow: 'hidden'
                                },
                                children: [
                                    groupMode === 'day' && dayGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).micro,
                                                        fontWeight: 700,
                                                        padding: '0.3125rem 0.75rem',
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                                        background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).bg
                                                    },
                                                    children: group.label
                                                }),
                                                group.items.map((txn)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($506153099b614331$var$MobileTxnRow, {
                                                        txn: txn
                                                    }, txn.id))
                                            ]
                                        }, group.key)),
                                    groupMode === 'type' && typeGroups.map((group)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($506153099b614331$var$MobileTypeGroupHeader, {
                                                    group: group
                                                }),
                                                group.items.map((txn)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($506153099b614331$var$MobileTxnRow, {
                                                        txn: txn
                                                    }, txn.id))
                                            ]
                                        }, group.key))
                                ]
                            }),
                            totalPages > 1 && !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: '0.5rem',
                                    marginTop: '0.625rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        onClick: ()=>setPage((p)=>Math.max(0, p - 1)),
                                        disabled: page === 0,
                                        className: "min-h-11",
                                        "data-testid": "credits-prev",
                                        children: t('credits.pager.previous')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        style: {
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).label,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                            whiteSpace: 'nowrap'
                                        },
                                        "data-testid": "credits-page-label",
                                        children: t('credits.pager.page', {
                                            page: formatNumber(page + 1),
                                            total: formatNumber(totalPages)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                        variant: "outline",
                                        onClick: ()=>setPage((p)=>p + 1 < totalPages ? p + 1 : p),
                                        disabled: page + 1 >= totalPages,
                                        className: "min-h-11",
                                        "data-testid": "credits-next",
                                        children: t('credits.pager.next')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        style: {
                            marginTop: '0.875rem',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.625rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2358e3acbc4a7e55$export$2e2bcd8739ae039), {
                                title: t('credits.priceList.title'),
                                defaultOpen: false,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                            color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted,
                                            lineHeight: 1.9,
                                            marginBottom: '0.5rem'
                                        },
                                        children: t('credits.priceList.hint')
                                    }),
                                    priceList.map((row, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '0.5rem',
                                                padding: '0.3125rem 0',
                                                borderTop: i ? `1px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}` : 'none'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                        flex: 1,
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary
                                                    },
                                                    children: t(row.labelKey)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                    style: {
                                                        ...(0, $9ab4d64d86b95e22$export$bf9fb029d174d554).caption,
                                                        fontWeight: 800,
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '0.25rem',
                                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c0054f6b4676327d$export$11c467f1ec2afb25), {
                                                            size: 10
                                                        }),
                                                        (0, $75f061374f24c25d$export$b634cc5d06849b0a)(row.cost, formatNumber),
                                                        row.perKey ? ` / ${t(row.perKey)}` : ''
                                                    ]
                                                })
                                            ]
                                        }, row.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29f1cbe2be0a8e40$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfba7d02b5e7069f$export$2e2bcd8739ae039), {
                open: topUpOpen,
                onClose: ()=>setTopUpOpen(false),
                title: t('credits.buy'),
                closeLabel: t('mobile.close'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $260a6170605807fd$export$2e2bcd8739ae039), {
                    avgPerVisit: stats.avgPerVisit,
                    onPay: startTopUp,
                    busy: payBusy,
                    error: payError
                })
            })
        ]
    });
};
var $506153099b614331$export$2e2bcd8739ae039 = $506153099b614331$var$CreditsMobile;


// اعتبار — two surfaces, one balance.
//
// The mobile surface is not the desktop page in a narrow column. The balance
// moves INTO the gradient header (§3.2 — on this screen the number that must
// never scroll away is the balance itself), the three-column rail becomes two
// collapsed sections at the foot, the date window is chosen from chips rather
// than from a dropdown, and the desktop's `PageHeader`/`KpiCard` are replaced by
// `MobileHeader`/`StatTiles` — §1.1's rule that layout, page anatomy and chrome
// are NOT shared.
//
// What IS shared is `Credits.shared.js`: the service vocabulary, the ledger
// parsing, the grouping and the KPI arithmetic. So the two surfaces can differ
// in shape and can never differ about what a row says or what «این ماه» adds
// up to. `TopUpSheet`, `GiftCodeCard` and `LowBalanceCard` are shared for the
// same reason — they are content, not chrome.
const $3a41492e814d4035$var$CreditsScreen = ()=>{
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    return isMobile ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $506153099b614331$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48ab62c8c643bc72$export$2e2bcd8739ae039), {});
};
var $3a41492e814d4035$export$2e2bcd8739ae039 = $3a41492e814d4035$var$CreditsScreen;




var $acw62 = parcelRequire("acw62");


// The dental specialty string.
//
// READ dentist-app/docs/CORE.md §4 BEFORE TOUCHING THIS. There are TWO dental
// strings in the platform and they render identically:
//
//   'دندانپزشکی'   10 codepoints, NO ZWNJ  — SPECIALTIES[18] in the doctor
//                                            client, i.e. what doctor.specialty
//                                            actually holds. THIS ONE.
//   'دندان‌پزشکی'  11 codepoints, WITH U+200C — a CLINIC_TYPES value, forty
//                                            lines away in the same file.
//
// Copying the wrong one produces a value the server-side gate does not accept,
// and it looks perfectly correct in review.
//
// This constant exists to be WRITTEN (onboarding sends it, the profile screen
// shows it locked). It is deliberately NOT a comparison helper: whether a stored
// specialty counts as dental is decided server-side by the normalized predicate
// in parsina.bff.dentist/src/auth/specialty.js, and `me { isDentist }` is how
// this client learns the answer. Never write `=== DENTAL_SPECIALTY` to gate a
// screen — a real row may hold 'متخصص دندانپزشکی'.
//
// i18n-exempt: a stored identifier, not UI copy — and it is rendered verbatim,
// never translated. Both the profile field and the onboarding step show the
// STORED string (falling back to this constant when the profile has none), so
// what the dentist reads is exactly what doctorpreference holds. Translating it
// would show a Persian label for a value the server never received.
const $b0b690e819784781$export$9a55ef74abff1564 = "\u062F\u0646\u062F\u0627\u0646\u067E\u0632\u0634\u06A9\u06CC";





// «مطب خودم را ثبت می‌کنم» — what the screen SENDS and what it SAYS back, kept
// pure so it can be pinned without mounting a screen whose logo is a Parcel
// `url:` import (vite cannot resolve that scheme, which is why no test mounts
// index.jsx).

function $8a4b34f14ef2811c$export$4a9de3cba578f249(code, { t: t, locale: locale }) {
    if (code === (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e)) return t('onboarding.clinic.currencyIrr');
    return `${(0, $fcda591c8cd139a4$export$846d8329e0c3da65)(code, locale, 'long')} (${code})`;
}
function $8a4b34f14ef2811c$export$b97a6cd60d226dd5({ t: t, locale: locale }) {
    return (0, $fcda591c8cd139a4$export$729c9ac211f2ddda).map((code)=>({
            value: code,
            label: $8a4b34f14ef2811c$export$4a9de3cba578f249(code, {
                t: t,
                locale: locale
            })
        }));
}
function $8a4b34f14ef2811c$export$392df74af1fb2dde({ name: name, city: city, address: address, officePhone: officePhone, currency: currency }) {
    return {
        name: String(name || '').trim(),
        clinicType: 'OFFICE',
        city: String(city || '').trim() || undefined,
        address: String(address || '').trim() || undefined,
        officePhone: officePhone || undefined,
        currency: currency || (0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e)
    };
}
function $8a4b34f14ef2811c$export$fade08dc47046ed6(err, { t: t, locale: locale }) {
    const code = err?.extensions?.code || null;
    if (code === 'CLINIC_EXISTS') return {
        message: t('onboarding.clinic.alreadyExists'),
        blocked: false
    };
    if (code === 'CURRENCY_MISMATCH') {
        const theirs = err?.extensions?.currency;
        return {
            message: t('onboarding.clinic.currencyMismatch', {
                currency: (0, $fcda591c8cd139a4$export$68d15a182c6bcbf0)(theirs) ? $8a4b34f14ef2811c$export$4a9de3cba578f249(theirs, {
                    t: t,
                    locale: locale
                }) : String(theirs || "\u2014")
            }),
            blocked: false
        };
    }
    if (code === 'CLINIC_SETUP_INCOMPLETE') return {
        message: t('onboarding.clinic.setupIncomplete'),
        blocked: true
    };
    return {
        message: t('errors.generic'),
        blocked: false
    };
}





// Onboarding — mounted OUTSIDE the router, over the whole viewport.
//
// It exists because of one server behaviour: doctorpreference's
// GetDoctorProfile never returns NOT_FOUND — it CREATES a blank row on first
// read. So a brand-new account has an empty specialty, and "is onboarded" is
// `!!medicalCode`, not "the row exists". The BFF's gate leaves onboarding
// reachable for exactly that reason, and this is the screen that uses the gap.
//
// The specialty is SENT, not chosen. This panel is the dental module: a picker
// here would let a dentist select their way out of the app they just opened.
// The string is the 10-codepoint 'دندانپزشکی' from constants/specialties.js —
// NOT the ZWNJ-bearing clinic-type spelling, which renders identically and is
// rejected by the server-side predicate.
/**
 * The dentist's name as the token knows it, or '' for an account created by the
 * phone + SMS-code flow — which knows only a verified phone number.
 *
 * Read from the access token rather than fetched: this runs on the first screen
 * after sign-in, the claims are already in hand, and a round trip to learn
 * something the token may not contain would delay the form either way.
 */ function $62b061fca587e5c8$var$nameFromToken() {
    const claims = (0, $3bdb28763df76ec7$export$83cd1f1503eb19c0)((0, $3bdb28763df76ec7$export$257b2d10b709d8ef)()) || {};
    return ([
        claims.given_name,
        claims.family_name
    ].filter(Boolean).join(' ') || claims.name || '').trim();
}
/**
 * An ASCII number quoted inside a Persian sentence, isolated so it reads
 * left-to-right with no CSS: U+2068 FSI … U+2069 PDI. The same wrap the kit puts
 * around the example in its own default phone copy — replacing that copy must
 * not lose it.
 */ const $62b061fca587e5c8$var$isolate = (value)=>`\u2068${value}\u2069`;
const $62b061fca587e5c8$var$COMPLETE_STEP1 = `
  mutation CompleteOnboardingStep1($input: OnboardingStep1Input!) {
    completeOnboardingStep1(input: $input) {
      id fullName medicalCode specialty isDentist isOnboarded
    }
  }
`;
// JOIN_CLINIC is IMPORTED, not re-declared: the profile screen joins a clinic
// with the same mutation and the same selection set, and two copies of one
// document is how a field added for one screen goes missing on the other.
const $62b061fca587e5c8$var$CREATE_MY_CLINIC = `
  mutation CreateMyClinic($input: CreateOwnClinicInput!) {
    createMyClinic(input: $input) {
      id status clinic { id name }
    }
  }
`;
const $62b061fca587e5c8$var$STAGES = [
    'step1',
    'clinic',
    'done'
];
/** One of the two answers to "own practice or existing clinic?".
 *
 *  A <button>, not a clickable <div>: this is the primary control of its screen,
 *  and it has to be reachable by keyboard and announced as an action. The whole
 *  card is the target rather than a link inside it — on a phone the card IS the
 *  tap area. */ const $62b061fca587e5c8$var$ChoiceCard = ({ title: title, body: body, onClick: onClick })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        onClick: onClick,
        style: {
            display: 'block',
            width: '100%',
            textAlign: 'start',
            border: `1.5px solid ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).border}`,
            borderRadius: 12,
            padding: '14px 16px',
            background: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).surface || '#fff',
            cursor: 'pointer',
            font: 'inherit'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 13.5,
                    fontWeight: 800,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary,
                    marginBottom: 4
                },
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    fontSize: 12,
                    color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                    lineHeight: 1.8
                },
                children: body
            })
        ]
    });
const $62b061fca587e5c8$var$Progress = ({ stage: stage })=>{
    const { t: t } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const index = $62b061fca587e5c8$var$STAGES.indexOf(stage);
    const labels = [
        t('onboarding.progress.step1'),
        t('onboarding.progress.clinic'),
        t('onboarding.progress.done')
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: 'flex',
            gap: 8,
            marginBottom: 22
        },
        children: labels.map((label, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            height: 4,
                            borderRadius: 3,
                            background: i <= index ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).teal : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).border,
                            marginBottom: 6
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            fontSize: 11,
                            fontWeight: i === index ? 800 : 500,
                            color: i <= index ? (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary : (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textMuted
                        },
                        children: label
                    })
                ]
            }, label))
    });
};
const $62b061fca587e5c8$var$OnboardingScreen = ({ onComplete: onComplete })=>{
    const { t: t, locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    const [stage, setStage] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('step1');
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Sign-in no longer knows the dentist's name.
    //
    // A phone + SMS-code account carries a verified phone number and no name
    // claims at all, and the name is printed on every prescription. So it is asked
    // for HERE, at the first moment it is needed, rather than by a signup form
    // nobody has a reason to fill in yet. An account registered before the change
    // still has the claims, so the field arrives pre-filled and reads as a
    // confirmation rather than a question.
    const [fullName, setFullName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>$62b061fca587e5c8$var$nameFromToken());
    const [medicalCode, setMedicalCode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [bio, setBio] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [code, setCode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // Which branch of the clinic step is showing: the question, or one of its two
    // answers. Kept separate from `stage` so «بازگشت» returns to the question
    // without re-running step 1.
    const [clinicMode, setClinicMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('choose'); // choose | own | join
    const [clinicName, setClinicName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [clinicCity, setClinicCity] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [clinicAddress, setClinicAddress] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // The practice line, in the two forms the field deals in: `clinicPhone` is
    // what gets SENT — E.164 and nothing else, or '' while the number is not yet a
    // number — and `clinicPhoneDraft` is what is in the box. Both are needed
    // because the canonical value is '' both when the dentist typed nothing and
    // when they typed something that is not a phone number, and those two must not
    // submit the same way: the second is a half-entered number we would otherwise
    // drop on the floor without ever saying so.
    const [clinicPhone, setClinicPhone] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [clinicPhoneDraft, setClinicPhoneDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    // The currency the مطب keeps its books in — every tariff and طرح درمان is
    // counted in it. IRR unless the dentist says otherwise, which is what every
    // practice registered before this field was.
    const [clinicCurrency, setClinicCurrency] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $fcda591c8cd139a4$export$c19ece7ea27dcd9e));
    // The practice row exists but its currency never reached accounting. The BFF
    // cannot always find that row again on a retry (a clinic id is no longer the
    // account's own id), so pressing «ثبت مطب» again would register a SECOND
    // practice. Once this happens the button stays off and the message says why.
    const [setupIncomplete, setSetupIncomplete] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [joinedName, setJoinedName] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const submitStep1 = async ()=>{
        if (!fullName.trim()) {
            setError(t('validation.fullName'));
            return;
        }
        if (!medicalCode.trim()) {
            setError(t('validation.medicalCode'));
            return;
        }
        setBusy(true);
        setError(null);
        try {
            await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($62b061fca587e5c8$var$COMPLETE_STEP1, {
                input: {
                    fullName: fullName.trim(),
                    medicalCode: medicalCode.trim(),
                    specialty: (0, $b0b690e819784781$export$9a55ef74abff1564),
                    bio: bio.trim() || undefined
                }
            });
            setStage('clinic');
        } catch (err) {
            setError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'DUPLICATE_MEDICAL_CODE' ? t('profile.duplicateCode') : t('errors.generic'));
        } finally{
            setBusy(false);
        }
    };
    const submitOwnClinic = async ()=>{
        // Enter in the name field reaches here too, not only the disabled button.
        if (setupIncomplete) return;
        if (!clinicName.trim()) {
            setError(t('validation.clinicName'));
            return;
        }
        // Optional, but not "optional to get right": something in the box that never
        // resolved would be silently discarded, and the dentist would find the field
        // empty later with no idea why.
        if (clinicPhoneDraft && !clinicPhone) {
            setError(t('validation.officePhone'));
            return;
        }
        setBusy(true);
        setError(null);
        try {
            const res = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)($62b061fca587e5c8$var$CREATE_MY_CLINIC, {
                // OFFICE, the practice's currency, and the rest as typed — see
                // ownClinicInput for what each field is and why.
                input: (0, $8a4b34f14ef2811c$export$392df74af1fb2dde)({
                    name: clinicName,
                    city: clinicCity,
                    address: clinicAddress,
                    officePhone: clinicPhone,
                    currency: clinicCurrency
                })
            });
            setJoinedName(res?.createMyClinic?.clinic?.name || clinicName.trim());
            setStage('done');
        } catch (err) {
            // Say something true rather than "try again" — and, for a practice
            // created without its currency, stop a retry from making a second one.
            const failure = (0, $8a4b34f14ef2811c$export$fade08dc47046ed6)(err, {
                t: t,
                locale: locale
            });
            if (failure.blocked) setSetupIncomplete(true);
            setError(failure.message);
        } finally{
            setBusy(false);
        }
    };
    const submitJoin = async ()=>{
        if (!code.trim()) {
            setError(t('validation.invitationCode'));
            return;
        }
        setBusy(true);
        setError(null);
        try {
            const res = await (0, $206625c7d33bd390$export$8395d0fc0d822a81)((0, $8db22074202537d3$export$97fc5255fc3d3b7a), {
                invitationCode: code.trim()
            });
            setJoinedName(res?.joinClinicByCode?.clinic?.name || null);
            setStage('done');
        } catch (err) {
            setError((0, $206625c7d33bd390$export$dbfe74f291058e97)(err) === 'CLINIC_NOT_FOUND' ? t('profile.clinics.notFound') : t('profile.clinics.joinFailed'));
        } finally{
            setBusy(false);
        }
    };
    const subtitle = {
        step1: t('onboarding.subtitle.step1'),
        clinic: t('onboarding.subtitle.clinic'),
        done: t('onboarding.subtitle.done')
    }[stage];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            position: 'fixed',
            inset: 0,
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            overflowY: 'auto',
            background: `linear-gradient(145deg, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyDark} 0%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy} 55%, ${(0, $e7c165fb515b04ea$export$e7094788287c5e9b).navyLight} 100%)`,
            fontFamily: 'Meshkat, sans-serif'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).surface,
                borderRadius: 18,
                width: 520,
                maxWidth: '100%',
                boxShadow: '0 32px 80px rgba(0,0,0,0.3)',
                overflow: 'hidden'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        padding: '24px 28px 0',
                        textAlign: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($23a4fb8df39836e9$exports))),
                            alt: "",
                            style: {
                                width: 56,
                                height: 56,
                                objectFit: 'contain',
                                marginBottom: 10
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            style: {
                                fontSize: 19,
                                fontWeight: 800,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).navy,
                                margin: '0 0 6px'
                            },
                            children: t('onboarding.title')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                fontSize: 13,
                                color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                margin: '0 0 20px'
                            },
                            children: subtitle
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        padding: '0 28px 26px'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($62b061fca587e5c8$var$Progress, {
                            stage: stage
                        }),
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35331361c3270146$export$2e2bcd8739ae039), {
                            variant: "error",
                            role: "alert",
                            style: {
                                marginBottom: 14
                            },
                            children: error
                        }),
                        stage === 'step1' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('onboarding.step1.fullName'),
                                    "aria-label": t('onboarding.step1.fullName'),
                                    required: true,
                                    "aria-required": "true",
                                    placeholder: t('onboarding.step1.fullNamePlaceholder'),
                                    value: fullName,
                                    onChange: (e)=>setFullName(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('onboarding.step1.medicalCode'),
                                    "aria-label": t('onboarding.step1.medicalCode'),
                                    required: true,
                                    "aria-required": "true",
                                    dir: "ltr",
                                    placeholder: t('onboarding.step1.medicalCodePlaceholder'),
                                    value: medicalCode,
                                    // A one-field step: Enter continues it.
                                    onKeyDown: (e)=>{
                                        if (e.key === 'Enter' && !busy) {
                                            e.preventDefault();
                                            submitStep1();
                                        }
                                    },
                                    onChange: (e)=>setMedicalCode(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('onboarding.step1.specialty'),
                                    "aria-label": t('onboarding.step1.specialty'),
                                    value: t('profile.specialtyValue'),
                                    onChange: ()=>{},
                                    disabled: true,
                                    helperText: t('onboarding.step1.specialtyNote')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26a45cd6e1b19edd$export$2e2bcd8739ae039), {
                                    label: t('onboarding.step1.bio'),
                                    "aria-label": t('onboarding.step1.bio'),
                                    dir: "auto",
                                    rows: 3,
                                    value: bio,
                                    onChange: (e)=>setBio(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    onClick: submitStep1,
                                    disabled: busy,
                                    className: "w-full",
                                    children: busy ? t('common.actions.saving') : t('onboarding.step1.submit')
                                })
                            ]
                        }),
                        stage === 'clinic' && clinicMode === 'choose' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    style: {
                                        margin: 0,
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: t('onboarding.clinic.choiceTitle')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        lineHeight: 1.9
                                    },
                                    children: t('onboarding.clinic.choiceDescription')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($62b061fca587e5c8$var$ChoiceCard, {
                                    title: t('onboarding.clinic.ownTitle'),
                                    body: t('onboarding.clinic.ownBody'),
                                    onClick: ()=>{
                                        setError(null);
                                        setClinicMode('own');
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($62b061fca587e5c8$var$ChoiceCard, {
                                    title: t('onboarding.clinic.joinTitle'),
                                    body: t('onboarding.clinic.joinBody'),
                                    onClick: ()=>{
                                        setError(null);
                                        setClinicMode('join');
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    variant: "outline",
                                    onClick: ()=>setStage('done'),
                                    disabled: busy,
                                    children: t('onboarding.clinic.skip')
                                })
                            ]
                        }),
                        stage === 'clinic' && clinicMode === 'own' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    style: {
                                        margin: 0,
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: t('onboarding.clinic.ownTitle')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('onboarding.clinic.ownName'),
                                    "aria-label": t('onboarding.clinic.ownName'),
                                    required: true,
                                    "aria-required": "true",
                                    placeholder: t('onboarding.clinic.ownNamePlaceholder'),
                                    value: clinicName,
                                    onKeyDown: (e)=>{
                                        if (e.key === 'Enter' && !busy) {
                                            e.preventDefault();
                                            submitOwnClinic();
                                        }
                                    },
                                    onChange: (e)=>setClinicName(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('onboarding.clinic.ownCity'),
                                    "aria-label": t('onboarding.clinic.ownCity'),
                                    value: clinicCity,
                                    onChange: (e)=>setClinicCity(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('onboarding.clinic.ownAddress'),
                                    "aria-label": t('onboarding.clinic.ownAddress'),
                                    value: clinicAddress,
                                    onChange: (e)=>setClinicAddress(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2f997edd3d0e9220$export$2e2bcd8739ae039), {
                                    label: t('onboarding.clinic.currency'),
                                    "aria-label": t('onboarding.clinic.currency'),
                                    helperText: t('onboarding.clinic.currencyHint'),
                                    placeholder: null,
                                    value: clinicCurrency,
                                    onChange: (e)=>setClinicCurrency(e.target.value),
                                    options: (0, $8a4b34f14ef2811c$export$b97a6cd60d226dd5)({
                                        t: t,
                                        locale: locale
                                    }),
                                    "data-testid": "onboarding-clinic-currency"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f69d84dab43bb31$export$2e2bcd8739ae039), {
                                    label: t('onboarding.clinic.ownPhone'),
                                    "aria-label": t('onboarding.clinic.ownPhone'),
                                    countryLabel: t('common.labels.country'),
                                    // A practice's number is an OFFICE LINE: «۰۲۱۸۸…» is the
                                    // ordinary answer here, and the mobile rule would refuse it.
                                    allowLandline: true,
                                    // The kit's copy is Persian by default (DESIGN.md rule 7) and
                                    // this app ships `en` too. Only these three are reachable: the
                                    // field is optional, so `required` never fires, and `notMobile`
                                    // cannot fire with `allowLandline` on.
                                    messages: {
                                        tooShort: (ctx)=>t('validation.phone.tooShort', {
                                                country: ctx.countryName,
                                                example: $62b061fca587e5c8$var$isolate(ctx.example)
                                            }),
                                        tooLong: (ctx)=>t('validation.phone.tooLong', {
                                                country: ctx.countryName,
                                                example: $62b061fca587e5c8$var$isolate(ctx.example)
                                            }),
                                        invalid: t('validation.phone.invalid')
                                    },
                                    value: clinicPhone,
                                    // A VALUE, not an event: the canonical number first, the rest of
                                    // the parse second.
                                    onChange: (e164, meta)=>{
                                        setClinicPhone(e164);
                                        setClinicPhoneDraft(meta?.draft ?? '');
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            onClick: submitOwnClinic,
                                            disabled: busy || setupIncomplete,
                                            className: "flex-1",
                                            children: busy ? t('common.actions.saving') : t('onboarding.clinic.create')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            onClick: ()=>{
                                                setError(null);
                                                setClinicMode('choose');
                                            },
                                            disabled: busy,
                                            children: t('onboarding.clinic.back')
                                        })
                                    ]
                                })
                            ]
                        }),
                        stage === 'clinic' && clinicMode === 'join' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    style: {
                                        margin: 0,
                                        fontSize: 14,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: t('onboarding.clinic.title')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 12.5,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        lineHeight: 1.9
                                    },
                                    children: t('onboarding.clinic.description')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e2f2bccd0e2a9fb$export$2e2bcd8739ae039), {
                                    label: t('onboarding.clinic.placeholder'),
                                    "aria-label": t('onboarding.clinic.placeholder'),
                                    dir: "ltr",
                                    value: code,
                                    onKeyDown: (e)=>{
                                        if (e.key === 'Enter' && !busy) {
                                            e.preventDefault();
                                            submitJoin();
                                        }
                                    },
                                    onChange: (e)=>setCode(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            onClick: submitJoin,
                                            disabled: busy,
                                            className: "flex-1",
                                            children: busy ? t('common.actions.saving') : t('onboarding.clinic.join')
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                            variant: "outline",
                                            onClick: ()=>{
                                                setError(null);
                                                setClinicMode('choose');
                                            },
                                            disabled: busy,
                                            children: t('onboarding.clinic.back')
                                        })
                                    ]
                                })
                            ]
                        }),
                        stage === 'done' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 14,
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    style: {
                                        margin: 0,
                                        fontSize: 16,
                                        fontWeight: 800,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textPrimary
                                    },
                                    children: t('onboarding.done.title')
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        fontSize: 13,
                                        color: (0, $e7c165fb515b04ea$export$e7094788287c5e9b).textSecondary,
                                        lineHeight: 1.9
                                    },
                                    children: t('onboarding.done.body')
                                }),
                                joinedName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    style: {
                                        background: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodSoft,
                                        color: (0, $e7c165fb515b04ea$export$4b57bfb4dade55bd).goodInk,
                                        borderRadius: 10,
                                        padding: '10px 12px',
                                        fontSize: 13
                                    },
                                    children: t('profile.clinics.joined', {
                                        name: joinedName
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39b6a9e95398564b$export$2e2bcd8739ae039), {
                                    onClick: onComplete,
                                    className: "w-full",
                                    children: t('onboarding.done.enter')
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $62b061fca587e5c8$export$2e2bcd8739ae039 = $62b061fca587e5c8$var$OnboardingScreen;


// PWA wiring: the manifest link and the service worker.
//
// WHY THIS IS ALL AT RUNTIME rather than in index.html.
//
// Parcel RESOLVES `<link rel="manifest">` and `navigator.serviceWorker
// .register('/sw.js')`, pulling both into the bundle graph. The manifest makes
// it auto-install @parcel/transformer-webmanifest DURING THE BUILD — a network
// fetch, in a repo whose CI has three separate proxy layers and a documented
// history of DNS-flaky builds — and it rewrites asset filenames, which the
// service worker's fixed root scope cannot use.
//
// So the PWA assets are copied verbatim from public/ to the dist root by the
// build script and referenced here at runtime. Nothing about the PWA can break
// a build.
//
// Everything below is best-effort and never awaited: an app that cannot install
// must still be an app that works.
const $a60b4e1e50f19438$var$MANIFEST_URL = '/manifest.webmanifest';
const $a60b4e1e50f19438$var$APPLE_ICON_URL = '/apple-touch-icon.png';
// Assembled rather than written inline: a string literal here is exactly what
// makes Parcel try to bundle the worker. The file is emitted by the build's
// copy step and must stay at the ROOT — a worker's default scope is its own
// directory, so a hashed or nested one could not control the whole app.
const $a60b4e1e50f19438$var$SW_URL = [
    '',
    'sw.js'
].join('/');
function $a60b4e1e50f19438$var$addLink(rel, href) {
    if (document.querySelector(`link[rel="${rel}"]`)) return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    document.head.appendChild(link);
}
function $a60b4e1e50f19438$export$f9288095a2aa0847() {
    if (typeof document === 'undefined') return;
    $a60b4e1e50f19438$var$addLink('manifest', $a60b4e1e50f19438$var$MANIFEST_URL);
    // iOS ignores the manifest entirely and reads this instead.
    $a60b4e1e50f19438$var$addLink('apple-touch-icon', $a60b4e1e50f19438$var$APPLE_ICON_URL);
}
function $a60b4e1e50f19438$export$c6245babf0c60892() {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
    // HTTPS or localhost only. The ingress serves this app over plain HTTP too
    // (`ssl-redirect: "false"` in both overlays), and registering there throws
    // rather than quietly no-oping.
    const secure = window.isSecureContext || [
        'localhost',
        '127.0.0.1'
    ].includes(window.location.hostname);
    if (!secure) return;
    // After load: registration otherwise competes with the boot query, and the
    // boot query is what puts a dentist in front of their day.
    window.addEventListener('load', ()=>{
        navigator.serviceWorker.register($a60b4e1e50f19438$var$SW_URL).catch((err)=>{
            console.warn('[pwa] service worker registration failed:', err?.message);
        });
    });
}
function $a60b4e1e50f19438$export$65fd8dd5bba2ae0d() {
    try {
        $a60b4e1e50f19438$export$f9288095a2aa0847();
        $a60b4e1e50f19438$export$c6245babf0c60892();
    } catch (err) {
        console.warn('[pwa] setup skipped:', err?.message);
    }
}
var $a60b4e1e50f19438$export$2e2bcd8739ae039 = $a60b4e1e50f19438$export$65fd8dd5bba2ae0d;



// One boot query carrying the two facts the app cannot start without: whether
// this account has finished registering, and which accent/language to paint in.
//
// Both fields are UNGATED on the BFF — they have to be, because an account with
// no specialty yet is exactly the one that needs to reach onboarding.
const $3712292999d2a2f0$var$BOOT_QUERY = `
  query Boot {
    checkOnboardingStatus { isOnboarded isDentist }
    myAppearanceSettings { theme fontSize language }
  }
`;
const $3712292999d2a2f0$var$AppShell = ()=>{
    // ≤768px gets the mobile shell — bottom navigation and per-screen gradient
    // headers (DESIGN-CONCEPT-MOBILE §3) — and not the sidebar at a smaller
    // width. The ROUTES are identical: the same five, in the same order. Only the
    // chrome around them forks, which is the §1.1 rule ("layout system, page
    // anatomy, chrome: NOT shared") applied to the shell.
    const { isMobile: isMobile } = (0, $e959a5a9c1f6e19d$export$2e2bcd8739ae039)();
    const Shell = isMobile ? (0, $3dffe7472d2e8d91$export$2e2bcd8739ae039) : (0, $64212f0be7bb84ee$export$2e2bcd8739ae039);
    // A session ending is app chrome, not a screen's concern — it can arrive
    // while any of the seven routes is open, and every one of them has unsaved
    // state worth not destroying. Mounted here, once, above the router's outlet.
    const session = (0, $be7f94ce6db606a5$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Shell, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d82b9c575211bc6$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/patients",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87056e061dab16ec$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/patients/:id/:tab?",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0de383faf6571668$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/prescription/:patientId",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1dfa506f0b1b21c4$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/visit/:appointmentId",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $35a05642ffb904d6$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/credits",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a41492e814d4035$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "/profile",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $618a45575ddb4226$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                to: "/",
                                replace: true
                            })
                        })
                    ]
                })
            }),
            session.isExpiring && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e88acdb961d2fa90$export$c05fa71599f06855), {
                secondsLeft: session.secondsLeft,
                onExtend: session.extend,
                onDismiss: session.dismissWarning,
                busy: session.busy
            }),
            session.isExpired && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e88acdb961d2fa90$export$88240b05a63eec38), {
                onSignIn: session.signInAgain,
                busy: session.busy
            })
        ]
    });
};
const $3712292999d2a2f0$var$AuthGate = ()=>{
    const { t: t, setLocale: setLocale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    // 'checking'  resolving tokens / the OIDC callback
    // 'booting'   authenticated, asking the BFF who this is
    // 'ready'     the app
    // 'onboarding' authenticated but no medical code yet
    // 'bootError' the boot query failed for a reason that is NOT auth
    // 'loop'      auth.js detected a redirect loop and bailed
    const [phase, setPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('checking');
    const [attempt, setAttempt] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const { setAppearance: setAppearance } = (0, $54fc473ae52026aa$export$93d4e7f90805808f)();
    // Held in a ref, NOT used as a dependency. @parsina/framework's ThemeProvider
    // memoises its context value on its own appearance state and rebuilds
    // `setAppearance` whenever that state changes — and its updater returns a new
    // object every call, even when the resolved values are identical. So naming
    // `setAppearance` in boot's dependency list is an infinite boot loop:
    //   boot() → applies the server's appearance → new local state →
    //   new setAppearance → new boot → the effect below (deps [boot]) refires →
    //   boot() → …
    // It fired ~141 GraphQL requests before the page painted once. `boot` needs to
    // CALL this, never to react to it, which is exactly what a ref expresses.
    const setAppearanceRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(setAppearance);
    setAppearanceRef.current = setAppearance;
    // Same ref discipline, same reason: I18nProvider rebuilds its context value
    // whenever the locale changes, so naming anything off it in boot's dependency
    // list re-arms the effect that calls boot.
    const setLocaleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(setLocale);
    setLocaleRef.current = setLocale;
    const boot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        try {
            const data = await (0, $206625c7d33bd390$export$7fb4864174f056c)($3712292999d2a2f0$var$BOOT_QUERY);
            const saved = data?.myAppearanceSettings;
            // The server copy is the real record and wins over the local cache — it
            // is how the preference follows the dentist to another machine. Nulls
            // mean "not set", not "reset to default", so they are filtered out.
            if (saved?.theme || saved?.fontSize) setAppearanceRef.current({
                ...saved.theme ? {
                    theme: saved.theme
                } : {},
                ...saved.fontSize ? {
                    fontSize: saved.fontSize
                } : {}
            });
            // The server copy of the language preference wins over the device's, so
            // the choice follows the dentist to another machine.
            //
            // It has to be APPLIED, not merely written to storage. I18nProvider
            // resolves the locale ONCE, in a lazy state initialiser, and it mounts
            // ABOVE this component — so by the time boot() runs that resolution has
            // already happened, and a bare localStorage write changes nothing until
            // the next full page load. `setLocale` persists it too, so storage stays
            // in step with what is on screen.
            //
            // `narrow` first: the stored value is a free-text BCP-47-ish tag, so
            // 'fa-IR' has to become 'fa' or setLocale rejects it as unsupported and
            // the preference is silently dropped.
            const language = (0, $94f36eaf2deb686d$export$ec67f55c222e1546)(saved?.language);
            if (language) setLocaleRef.current(language);
            const status = data?.checkOnboardingStatus;
            if (!status?.isOnboarded) {
                setPhase('onboarding');
                return;
            }
            // 2026-08-08: a specialty check used to sit here and send a
            // general-medicine doctor to a dead-end screen. The app is open to every
            // onboarded doctor now, so being onboarded IS the whole test. The
            // specialty flag is still queried — the profile screen shows it — but it
            // no longer decides anything. See tests/openToAllDoctors.test.js.
            setPhase('ready');
        } catch (err) {
            const code = (0, $206625c7d33bd390$export$dbfe74f291058e97)(err);
            if (code === 'UNAUTHENTICATED' || err?.status === 401) {
                (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
                return;
            }
            // Anything else is an OUTAGE, not a verdict about this account. It must
            // not be read as "this dentist has not onboarded" — showing the
            // registration wizard to someone already registered is how a stale token
            // turned into a second, duplicate account in the doctor app.
            console.error('[boot] failed:', code || err?.message);
            setPhase('bootError');
        }
    // Intentionally NO dependencies: everything boot touches is either a stable
    // setState, a module import, or the ref above. A dependency here re-arms the
    // effect that calls it.
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        if (params.get('auth_error') === 'loop') {
            setPhase('loop');
            return;
        }
        (async ()=>{
            // Returning from Keycloak: exchange the code first.
            if (params.has('code') || params.has('state') || params.has('error')) {
                if (await (0, $3bdb28763df76ec7$export$f8ec4f1dc49ac9b7)()) {
                    (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                    // Put the dentist back where they were interrupted. Keycloak's
                    // redirect_uri is the origin, so a re-login has always landed on
                    // امروز — a shrug on a list screen and a real cost on
                    // /visit/:appointmentId, where the dentist has to find the
                    // appointment and re-open the session they were mid-way through.
                    //
                    // `replaceState`, not a navigation: BrowserRouter has not mounted
                    // yet, so rewriting the address here is what its FIRST render reads.
                    // Doing it afterwards would paint امروز and then jump, and would
                    // leave the OIDC callback in the history stack for the back button.
                    const returnTo = (0, $d4d7a25942cf3f48$export$e5c839e26770d4ca)();
                    if (returnTo && returnTo !== '/') window.history.replaceState({}, '', returnTo);
                    setPhase('booting');
                    boot();
                    return;
                }
            }
            const token = (0, $3bdb28763df76ec7$export$257b2d10b709d8ef)();
            if (token && !(0, $3bdb28763df76ec7$export$b007d77a962aa175)(token)) {
                (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                setPhase('booting');
                boot();
                return;
            }
            if ((0, $3bdb28763df76ec7$export$c8736e6c4fef498e)() && await (0, $3bdb28763df76ec7$export$f8f36faf9a051362)()) {
                (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
                setPhase('booting');
                boot();
                return;
            }
            (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)(); // navigates away; no state update needed
        })();
    }, [
        boot,
        attempt
    ]);
    // The session screens are the kit's (packages/DESIGN.md §"Session check") —
    // the same card, motion and manual sign-in link as every other Parsina
    // panel. Only the words and the logo are this panel's.
    if (phase === 'loop') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4ca280922aa4ea$export$d422f67d76bf24e4), {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($23a4fb8df39836e9$exports))),
        brandName: t('nav.brand.name'),
        title: t('auth.loopTitle'),
        body: t('auth.loopError'),
        actionLabel: t('auth.retry'),
        onAction: ()=>{
            (0, $3bdb28763df76ec7$export$67488bf92fa15f1e)();
            (0, $3bdb28763df76ec7$export$639ddbdf19445d0c)();
            window.location.href = '/';
        },
        host: (0, $d87bd335296b449f$export$91dbb4a8660769db).replace(/^https?:\/\//, '')
    });
    if (phase === 'bootError') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4ca280922aa4ea$export$d422f67d76bf24e4), {
        tone: "warning",
        testId: "boot-error",
        stateTestId: "boot-error-state",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($23a4fb8df39836e9$exports))),
        brandName: t('nav.brand.name'),
        title: t('auth.bootFailed.title'),
        body: t('auth.bootFailed.body'),
        actionLabel: t('common.actions.retry'),
        onAction: ()=>{
            setPhase('checking');
            setAttempt((n)=>n + 1);
        },
        host: (0, $d87bd335296b449f$export$91dbb4a8660769db).replace(/^https?:\/\//, '')
    });
    if (phase === 'checking' || phase === 'booting') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4ca280922aa4ea$export$cd72095868f03c30), {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f0b50123bb07e4c7$exports))),
        brandName: t('nav.brand.name'),
        panelName: t('nav.brand.panel'),
        title: phase === 'checking' ? t('auth.checking') : t('auth.loading'),
        subtitle: t('auth.checkingHint'),
        stuckLabel: t('auth.stuck'),
        manualLabel: t('auth.manualSignIn'),
        onManualSignIn: ()=>{
            (0, $3bdb28763df76ec7$export$2fb87bbf5418dbe1)();
        }
    });
    if (phase === 'onboarding') // Outside the router on purpose: there is no app to navigate around yet.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62b061fca587e5c8$export$2e2bcd8739ae039), {
        onComplete: ()=>{
            setPhase('booting');
            boot();
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $862d9bf17e1d4526$export$ac4d1181bb6a7e7d), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$AppShell, {})
        })
    });
};
const $3712292999d2a2f0$var$DocumentTitle = ()=>{
    const { t: t, locale: locale } = (0, $a278322405d51c25$export$9fc83ad70ead8663)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        document.title = t('app.title');
    }, [
        t,
        locale
    ]);
    return null;
};
// Provider order is load-bearing:
//   ThemeProvider outermost — it applies the cached accent in a lazy
//     initialiser, i.e. BEFORE first paint, so a reload does not flash the
//     default accent while the boot query is still in flight.
//   I18nProvider above ToastProvider — the auth-error and onboarding screens
//     read t(), and so do the toasts.
const $3712292999d2a2f0$var$App = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54fc473ae52026aa$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a278322405d51c25$export$a54013f0d02a8f82), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $352ffee698fbd002$export$f5d03d415824e0e), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$DocumentTitle, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$AuthGate, {})
                ]
            })
        })
    });
(0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root')).render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3712292999d2a2f0$var$App, {}));
// After render, never awaited: an app that cannot install must still run.
(0, $a60b4e1e50f19438$export$65fd8dd5bba2ae0d)();


//# sourceMappingURL=app.564f3e17.js.map
